import React__default, { Fragment, useState, useEffect, useContext, useRef, useMemo, useLayoutEffect, Component, useReducer, useCallback, createContext, memo } from 'react';
import styled, { css } from 'styled-components';
import axios from 'axios';
import { postHttpClientRequest, getHttpClientRequest } from '@vz/react-util';
import { isMobile as isMobile$1, isTablet, osName, osVersion, deviceType } from 'react-device-detect';
import Cookies from 'universal-cookie';
import $$1 from 'jquery';
import 'simple-jsonp-promise';
import { useHistory, withRouter, useLocation, useParams, HashRouter, Switch, Route } from 'react-router-dom';
import { Line as Line$1 } from '@vds/lines';
import { Loader as Loader$2 } from '@vds/loaders';
import { Title, Body, Micro } from '@vds/typography';
import PropTypes from 'prop-types';
import { Button as Button$1, TextLink, TextLinkCaret, ButtonGroup as ButtonGroup$1 } from '@vds/buttons';
import Icon$2, { Icon as Icon$1 } from '@vds/icons';
import { DropdownSelect } from '@vds/selects';
import { Modal as Modal$1, ModalBody as ModalBody$1, ModalFooter as ModalFooter$1, ModalTitle } from '@vds/modals';
import { Table, TableHeader as TableHeader$1, Cell as Cell$1, TableHead, TableBody, TableRow as TableRow$1 } from '@vds/tables';
import { Checkbox, CheckboxGroup } from '@vds/checkboxes';
import { DropdownItem } from '@vzrf/react-dropdown';
import useSWRMutation from 'swr/mutation';
import useSWR, { useSWRConfig, mutate } from 'swr';
import { Notification } from '@vds/notifications';
import { Breadcrumbs as Breadcrumbs$1, BreadcrumbItem } from '@vds/breadcrumbs';
import { Grid as Grid$1, Row as Row$1, Col } from '@vds/grids';
import { ButtonIcon } from '@vds/button-icons';
import { TextArea as TextArea$1, Input as Input$1 } from '@vds/inputs';
import useSWRImmutable from 'swr/immutable';
import Select$1, { components } from 'react-select';
import _, { isEmpty as isEmpty$1 } from 'lodash';
import { Accordion as Accordion$1, AccordionItem, AccordionHeader, AccordionTitle, AccordionDetail } from '@vds/accordions';
import { PieChart, Pie, Label } from 'rechartsUpdated';
import { Tooltip } from '@vds/tooltips';
import { ListItem as ListItem$2, UnorderedList } from '@vds/lists';
import { Tabs as Tabs$1, Tab } from '@vds/tabs';
import { motion, AnimatePresence } from 'framer-motion';
import { TitleLockup } from '@vds/type-lockups';
import { Badge } from '@vds/badges';
import { TileContainer as TileContainer$1, Tilelet, TileletCarousel } from '@vds/tiles';
import moment from 'moment-timezone';
import { RadioButtonGroup, RadioButton } from '@vds/radio-buttons';
import { convertStringToElements } from '@vds/html-parsers';
import { Carousel } from '@vds/carousels';
import IdeasSolutions from '@vds/icons/ideas-solutions';
import 'lodash/find';
import Md5 from 'crypto-js/md5';
import { useFormContext, Controller, useForm, FormProvider } from 'react-hook-form';
import CarryoverData from '@vds/icons/carryover-data';
import AsyncSelect from 'react-select/async';
import moment$1 from 'moment';
import { create } from 'zustand';
import { UTPTickets } from 'utp-ticket-list';
import { RadioBoxGroup } from '@vds/radio-boxes';
import { Pagination as Pagination$2 } from '@vds/pagination';
import ReactDOM, { createPortal } from 'react-dom';
import Draggable from 'react-draggable';
import Row$2 from 'react-bootstrap/Row';
import 'react-bootstrap/Col';
import 'lodash/get';
import DownArrow from '@vds/icons/down-arrow';
import Plus from '@vds/icons/plus';
import Minus from '@vds/icons/minus';
import { ResponsiveContainer, ComposedChart, XAxis, YAxis, Tooltip as Tooltip$1, Area, Line as Line$2 } from 'recharts';
import AlternateCheckmark from '@vds/icons/alternate-checkmark';
import CloseAlternate from '@vds/icons/close-alternate';
import Info from '@vds/icons/info';
import Search from '@vds/icons/search';
import { DatePicker } from '@vds/date-pickers';
import Location from '@vds/icons/location';

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _createForOfIteratorHelperLoose(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
    t && (r = t);
    var o = 0;
    return function () {
      return o >= r.length ? {
        done: !0
      } : {
        done: !1,
        value: r[o++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _taggedTemplateLiteralLoose(e, t) {
  return t || (t = e.slice(0)), e.raw = t, e;
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

// A type of promise-like that resolves synchronously and supports only one observer
const _Pact = /*#__PURE__*/(function() {
	function _Pact() {}
	_Pact.prototype.then = function(onFulfilled, onRejected) {
		const result = new _Pact();
		const state = this.s;
		if (state) {
			const callback = state & 1 ? onFulfilled : onRejected;
			if (callback) {
				try {
					_settle(result, 1, callback(this.v));
				} catch (e) {
					_settle(result, 2, e);
				}
				return result;
			} else {
				return this;
			}
		}
		this.o = function(_this) {
			try {
				const value = _this.v;
				if (_this.s & 1) {
					_settle(result, 1, onFulfilled ? onFulfilled(value) : value);
				} else if (onRejected) {
					_settle(result, 1, onRejected(value));
				} else {
					_settle(result, 2, value);
				}
			} catch (e) {
				_settle(result, 2, e);
			}
		};
		return result;
	};
	return _Pact;
})();

// Settles a pact synchronously
function _settle(pact, state, value) {
	if (!pact.s) {
		if (value instanceof _Pact) {
			if (value.s) {
				if (state & 1) {
					state = value.s;
				}
				value = value.v;
			} else {
				value.o = _settle.bind(null, pact, state);
				return;
			}
		}
		if (value && value.then) {
			value.then(_settle.bind(null, pact, state), _settle.bind(null, pact, 2));
			return;
		}
		pact.s = state;
		pact.v = value;
		const observer = pact.o;
		if (observer) {
			observer(pact);
		}
	}
}

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously implement a switch statement
function _switch(discriminant, cases) {
	var dispatchIndex = -1;
	var awaitBody;
	outer: {
		for (var i = 0; i < cases.length; i++) {
			var test = cases[i][0];
			if (test) {
				var testValue = test();
				if (testValue && testValue.then) {
					break outer;
				}
				if (testValue === discriminant) {
					dispatchIndex = i;
					break;
				}
			} else {
				// Found the default case, set it as the pending dispatch case
				dispatchIndex = i;
			}
		}
		if (dispatchIndex !== -1) {
			do {
				var body = cases[dispatchIndex][1];
				while (!body) {
					dispatchIndex++;
					body = cases[dispatchIndex][1];
				}
				var result = body();
				if (result && result.then) {
					awaitBody = true;
					break outer;
				}
				var fallthroughCheck = cases[dispatchIndex][2];
				dispatchIndex++;
			} while (fallthroughCheck && !fallthroughCheck());
			return result;
		}
	}
	const pact = new _Pact();
	const reject = _settle.bind(null, pact, 2);
	(awaitBody ? result.then(_resumeAfterBody) : testValue.then(_resumeAfterTest)).then(void 0, reject);
	return pact;
	function _resumeAfterTest(value) {
		for (;;) {
			if (value === discriminant) {
				dispatchIndex = i;
				break;
			}
			if (++i === cases.length) {
				if (dispatchIndex !== -1) {
					break;
				} else {
					_settle(pact, 1, result);
					return;
				}
			}
			test = cases[i][0];
			if (test) {
				value = test();
				if (value && value.then) {
					value.then(_resumeAfterTest).then(void 0, reject);
					return;
				}
			} else {
				dispatchIndex = i;
			}
		}
		do {
			var body = cases[dispatchIndex][1];
			while (!body) {
				dispatchIndex++;
				body = cases[dispatchIndex][1];
			}
			var result = body();
			if (result && result.then) {
				result.then(_resumeAfterBody).then(void 0, reject);
				return;
			}
			var fallthroughCheck = cases[dispatchIndex][2];
			dispatchIndex++;
		} while (fallthroughCheck && !fallthroughCheck());
		_settle(pact, 1, result);
	}
	function _resumeAfterBody(result) {
		for (;;) {
			var fallthroughCheck = cases[dispatchIndex][2];
			if (!fallthroughCheck || fallthroughCheck()) {
				break;
			}
			dispatchIndex++;
			var body = cases[dispatchIndex][1];
			while (!body) {
				dispatchIndex++;
				body = cases[dispatchIndex][1];
			}
			result = body();
			if (result && result.then) {
				result.then(_resumeAfterBody).then(void 0, reject);
				return;
			}
		}
		_settle(pact, 1, result);
	}
}

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

var tsaEnvConfig = function tsaEnvConfig(env) {
  var API_BASE_URL = '/ApiData';
  var ACSS_BASE_URL = '/acss/service';
  var acssApiUrls = {
    apiBaseUrl: ACSS_BASE_URL,
    issueSelector: ACSS_BASE_URL + "/troubleshooting/get-device-symptoms",
    getnsasymptoms: ACSS_BASE_URL + "/troubleshooting/get-nsa-symptoms",
    additionalInfo: ACSS_BASE_URL + "/troubleshooting/other-content",
    offerFeedbackInfo: ACSS_BASE_URL + "/troubleshooting/offerFeedback",
    issueHistory: ACSS_BASE_URL + "/troubleshooting/get-all-embedded-cases",
    deviceSelectorURI: ACSS_BASE_URL + "/troubleshooting/device-selector-vira",
    getCasesURI: ACSS_BASE_URL + "/troubleshooting/get-all-vira-cases",
    getOrderCaseId: ACSS_BASE_URL + "/troubleshooting/get-clnr-case-details",
    getTroubleshootingDeviceDetails: ACSS_BASE_URL + "/troubleshooting/fetchTroubleshootingDeviceDetails",
    getNetworkTroubleshootingData: ACSS_BASE_URL + "/troubleshooting/getNetworkTroubleshootingData",
    getProfileData: ACSS_BASE_URL + "/profile/api/v1/profile",
    getLoadLinks: ACSS_BASE_URL + "/landing/api/v1/esb/loadLinks",
    getModelService: ACSS_BASE_URL + "/troubleshooting/getEmulatorData",
    getDeviceDiagnostics: ACSS_BASE_URL + "/troubleshooting/fetchTroubleshootingDeviceDiagnostics",
    getLoadLTESimStatus: ACSS_BASE_URL + "/device-payoff/api/getLoadLTESimStatus",
    getGuardedLinkPinPukService: ACSS_BASE_URL + "/device-payoff/api/guardedLinkPinPukService",
    getQuerySimService: ACSS_BASE_URL + "/device-payoff/api/querySimService",
    getValidateEmail: ACSS_BASE_URL + "/nbs/billing/validateEmail",
    getOneMessageEmailService: ACSS_BASE_URL + "/landing/api/v1/OneMessageEmailService",
    getViraCaseIdForLvURI: ACSS_BASE_URL + "/get-lv-vira-case-id",
    getCustomerInquirySearchandDomain: ACSS_BASE_URL + "/landing/api/v1/customerInquirySearch",
    getSpeedTestHistory: ACSS_BASE_URL + "/troubleshooting/speedTestHistoryTroubleshooting",
    getSpeedTest: ACSS_BASE_URL + "/troubleshooting/speedTestTroubleshooting",
    getWifiAnalyzerData: ACSS_BASE_URL + "/troubleshooting/fetchWifiAnalyzerTroubleshooting",
    getWifiAnalyzerRawData: ACSS_BASE_URL + "/troubleshooting/fetchWifiAnalyzerTroubleshooting",
    getRebootAndReset: ACSS_BASE_URL + "/troubleshooting/rebootAndResetTroubleshooting",
    getMvaFreeTrial: ACSS_BASE_URL + "/device-payoff/api/v1/esb/mvaFreeTrial",
    getNetworkOutage: ACSS_BASE_URL + "/troubleshooting/getOutageDetails",
    getDeviceHealth: ACSS_BASE_URL + "/troubleshooting/get-device-hlth",
    pollDeviceHealth: ACSS_BASE_URL + "/troubleshooting/poll-device-hlth",
    getNsaSymptoms: ACSS_BASE_URL + "/troubleshooting/get-nsa-symptoms"
  };
  var devApiUrls = {
    apiBaseUrl: API_BASE_URL,
    issueSelector: API_BASE_URL + "/get-device-symptoms.json",
    getnsasymptoms: API_BASE_URL + "/get-nsa-symptoms.json",
    additionalInfo: API_BASE_URL + "/configdata.json",
    offerFeedbackInfo: ACSS_BASE_URL + "/troubleshooting/offerFeedback",
    issueHistory: API_BASE_URL + "/get-all-embedded-cases.json",
    deviceSelectorURI: API_BASE_URL + "/device-selector-vira.json",
    getCasesURI: ACSS_BASE_URL + "/get-all-vira-cases",
    getViraCaseIdForLvURI: API_BASE_URL + "/get-lv-vira-case-id",
    getOrderCaseId: ACSS_BASE_URL + "/get-clnr-case-details",
    getTroubleshootingDeviceDetails: API_BASE_URL + "/troubleshooting_device_data.json",
    getNetworkTroubleshootingData: API_BASE_URL + "/networkProvisioning.json",
    getProfileData: API_BASE_URL + "/profile.json",
    getLoadLinks: API_BASE_URL + "/loadLinks.json",
    getModelService: API_BASE_URL + "/modelService.json",
    getDeviceDiagnostics: API_BASE_URL + "/fetchTroubleshootingDeviceDiagnostics.json",
    getLoadLTESimStatus: API_BASE_URL + "/simStatus.json",
    getGuardedLinkPinPukService: API_BASE_URL + "/guardedLinkPinPukService.json",
    getQuerySimService: API_BASE_URL + "/QuerySimService.json",
    getValidateEmail: API_BASE_URL + "/validateEmail.json",
    getOneMessageEmailService: API_BASE_URL + "/OneMessageEmailService.json",
    getSpeedTestHistory: API_BASE_URL + "/SpeedTestHistory.json",
    getSpeedTest: API_BASE_URL + "/speedTest.json",
    getWifiAnalyzerData: API_BASE_URL + "/WifiAnalyzer.json",
    getWifiAnalyzerRawData: API_BASE_URL + "/wifiAnalyzerRaw.json",
    getRebootAndReset: API_BASE_URL + "/rebootAndResetTroubleshooting.json",
    getMvaFreeTrial: API_BASE_URL + "/MvaFreeTrial.json",
    getNetworkOutage: API_BASE_URL + "/troubleshooting/getOutageDetails",
    getDeviceHealth: ACSS_BASE_URL + "/troubleshooting/get-device-hlth",
    pollDeviceHealth: ACSS_BASE_URL + "/troubleshooting/poll-device-hlth"
  };
  if (env === 'development') {
    return {
      apiUrls: devApiUrls
    };
  }
  return {
    apiUrls: acssApiUrls
  };
};

var sessionUtility = {
  getRunMode: function getRunMode() {
    return sessionStorage.getItem("mvoenv") || "prod";
  },
  setRunMode: function setRunMode(value) {
    sessionStorage.setItem("mvoenv", value);
  },
  getMvoConfig: function getMvoConfig() {
    return JSON.parse(sessionStorage.getItem("mvoConfig")) || {};
  },
  setMvoConfig: function setMvoConfig(value) {
    sessionStorage.setItem("mvoConfig", JSON.stringify(value));
  },
  setExternalTarget: function setExternalTarget(value) {
    sessionStorage.setItem("mvoExternalTarget", value);
  },
  getExternalTarget: function getExternalTarget() {
    var mvoExternalTarget = sessionStorage.getItem("mvoExternalTarget");
    return mvoExternalTarget;
  },
  getTroubleShootingJson: function getTroubleShootingJson() {
    var _this$getMvoConfig$tr, _this$getMvoConfig;
    return (_this$getMvoConfig$tr = (_this$getMvoConfig = this.getMvoConfig()) === null || _this$getMvoConfig === void 0 ? void 0 : _this$getMvoConfig.troubleShootingJson) != null ? _this$getMvoConfig$tr : {};
  },
  getCaseDetails: function getCaseDetails() {
    var _this$getMvoConfig$ca, _this$getMvoConfig2;
    return (_this$getMvoConfig$ca = (_this$getMvoConfig2 = this.getMvoConfig()) === null || _this$getMvoConfig2 === void 0 ? void 0 : _this$getMvoConfig2.caseDetails) != null ? _this$getMvoConfig$ca : {};
  },
  setCaseDetails: function setCaseDetails(value) {
    var config = JSON.parse(sessionStorage.getItem("mvoConfig"));
    config.caseDetails = value;
    sessionStorage.setItem("mvoConfig", JSON.stringify(config));
  },
  setCaseDetailsProps: function setCaseDetailsProps(props) {
    var config = JSON.parse(sessionStorage.getItem("mvoConfig"));
    config.caseDetails = _extends({}, config.caseDetails, props);
    sessionStorage.setItem("mvoConfig", JSON.stringify(config));
  },
  getUserId: function getUserId() {
    return sessionStorage.getItem("mvoId");
  },
  setUserId: function setUserId(value) {
    sessionStorage.setItem("mvoId", value);
  },
  getTroubleShootingDetails: function getTroubleShootingDetails() {
    if (sessionStorage.getItem("troubleshootingDetails")) {
      return JSON.parse(sessionStorage.getItem("troubleshootingDetails")) || {};
    } else {
      return {};
    }
  },
  setTroubleShootingDetails: function setTroubleShootingDetails(value) {
    sessionStorage.setItem("troubleshootingDetails", JSON.stringify(value));
  }
};

var tsaEnvConfig$1 = function tsaEnvConfig(envConfig) {
  var _mvoTroubleShootingJs, _mvoTroubleShootingJs2, _mvoTroubleShootingJs3;
  console.log(envConfig);
  var mvoConfig = sessionUtility.getMvoConfig();
  var mvoTroubleShootingJson = sessionUtility.getTroubleShootingJson();
  var runMode = envConfig === null || envConfig === void 0 ? void 0 : envConfig.mvoenv;
  var externalTarget = envConfig === null || envConfig === void 0 ? void 0 : envConfig.externalTarget;
  var API_BASE_URL = runMode === 'development' ? '/ApiData' : window.isLoggedOut ? '/digital/nsa/nos/gw/troubleshooting' : '/digital/nsa/secure/gw/troubleshooting';
  var ACSS_BASE_URL = mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isLoggedOut ? externalTarget + "/acss/nos/service/troubleshooting" : externalTarget + "/acss/service/troubleshooting";
  var routesArr = window.location.hash.split('/');
  console.log('routes array in apiconfig-->', routesArr);
  var is5GFlow = (_mvoTroubleShootingJs = mvoTroubleShootingJson === null || mvoTroubleShootingJson === void 0 ? void 0 : (_mvoTroubleShootingJs2 = mvoTroubleShootingJson.ddata) === null || _mvoTroubleShootingJs2 === void 0 ? void 0 : (_mvoTroubleShootingJs3 = _mvoTroubleShootingJs2.device) === null || _mvoTroubleShootingJs3 === void 0 ? void 0 : _mvoTroubleShootingJs3.is5GDevice) != null ? _mvoTroubleShootingJs : false;
  if (routesArr.includes('eotsecure')) {
    is5GFlow = false;
  }
  if (window.isMVODigital && routesArr.includes('midflowsecure')) {
    is5GFlow = false;
  }
  var acssApiUrls = {
    apiBaseUrl: ACSS_BASE_URL,
    configUrl: ACSS_BASE_URL + "/config-troubleshooting",
    analyticsUrl: ACSS_BASE_URL + "/tagging-troubleshooting",
    checkOutageUrl: ACSS_BASE_URL + "/support/1d/data/secure/getNBX4GOutageInfo?outageBanner=4G",
    check5GOutageUrl: ACSS_BASE_URL + "/support/1d/data/secure/getOutageInfo?outageBanner=5G",
    externalNavLandingUrl: ACSS_BASE_URL + "/navigate-to-ts",
    startTroubleShootingUrl: ACSS_BASE_URL + "/start-troubleshooting",
    closeTroubleShootingUrl: ACSS_BASE_URL + "/close-troubleshooting",
    submitTroubleShootingActionUrl: ACSS_BASE_URL + "/submit-action-for-troubleshooting",
    startTroubleShootingNewUrl: ACSS_BASE_URL + "/start-4g-troubleshooting",
    submitTroubleShootingNewUrl: ACSS_BASE_URL + "/submit-vira-action-for-troubleshooting",
    submitNrbTicket: ACSS_BASE_URL + "/submit-nrb-ticket",
    getVegasGenAISummary: ACSS_BASE_URL + "/getVegasGenAISummary",
    getMenuValues: ACSS_BASE_URL + "/get-menu-values",
    genAIFeedback: ACSS_BASE_URL + "/genAIFeedback",
    testTroubleShootingNewUrl: ACSS_BASE_URL + "/test-vira-troubleshooting",
    startViraUrl: ACSS_BASE_URL + "/start-vira-troubleshooting",
    resumeTroubleShootingUrl: ACSS_BASE_URL + "/start-4g-troubleshooting",
    replayTroubleShootingActionUrl: ACSS_BASE_URL + "/replay-troubleshooting",
    replayTroubleShootingNewUrl: ACSS_BASE_URL + "/replay-vira-troubleshooting",
    pollTroubleShootingActionUrl: is5GFlow ? ACSS_BASE_URL + "/poll-troubleshooting" : ACSS_BASE_URL + "/poll-vira-troubleshooting",
    defaultTemplateUrl: ACSS_BASE_URL + "/error-content-troubleshooting",
    addressValidationUrl: ACSS_BASE_URL + "/validate-address",
    typeAheadUrl: ACSS_BASE_URL + "/search",
    searchUrl: ACSS_BASE_URL + "/search",
    deviceSelectorUrl: ACSS_BASE_URL + "/device-selector",
    supportTicketUrl: '/digital/nsa/secure/ui/sdr/createsupportticket',
    createCaseUrl: '/digital/nsa/secure/gw/sdr/createmrticket',
    submitCaseUrl: '/digital/nsa/secure/gw/sdr/submit-ticket',
    initCaseUrl: '/digital/nsa/secure/gw/sdr/submit-supticket',
    timeSlotURI: '/digital/nsa/secure/gw/sdr/get-call-details',
    deviceRepairUrl: ACSS_BASE_URL + "/support/1d/secure/schedule-device-repair",
    feedbackDropdownUrl: API_BASE_URL + "/feedbackDropdownUrl",
    additionalInfo: ACSS_BASE_URL + "/other-content",
    uilogging: externalTarget + "/acss/nos/service/troubleshooting/uilogging",
    dynamicCtaURI: ACSS_BASE_URL + "/retrieveContentJson",
    getAllIntentsUrl: ACSS_BASE_URL + "/get-nsa-symptoms",
    getDeviceDataUrl: '/support/1d/secure/tsa',
    getDeviceSymptoms: ACSS_BASE_URL + "/get-device-symptoms",
    getRecentPendingCasesUrl: API_BASE_URL + "/get-recent-pending-case",
    getCasesURI: ACSS_BASE_URL + "/get-all-vira-cases",
    getViraCaseIdForLvURI: ACSS_BASE_URL + "/get-lv-vira-case-id",
    getNrbURL: API_BASE_URL + "/get-nrb-content",
    getOfferEligibilityURL: API_BASE_URL + "/get-neoffer-eligibility",
    getNBXOfferEligibiltyURL: API_BASE_URL + "/check-nbx-nwe-eligibility",
    getAddOfferEligibilityURL: API_BASE_URL + "/add-neoffer",
    offerFeedbackInfo: ACSS_BASE_URL + "/offerFeedback"
  };
  var digitalApiUrls = {
    apiBaseUrl: API_BASE_URL,
    analyticsUrl: API_BASE_URL + "/tagging-troubleshooting",
    checkOutageUrl: '/support/1d/data/secure/getNBX4GOutageInfo?outageBanner=4G',
    check5GOutageUrl: '/support/1d/data/secure/getOutageInfo?outageBanner=5G',
    externalNavLandingUrl: API_BASE_URL + "/navigate-to-ts",
    startTroubleShootingUrl: API_BASE_URL + "/start-troubleshooting",
    closeTroubleShootingUrl: API_BASE_URL + "/close-troubleshooting",
    submitTroubleShootingActionUrl: API_BASE_URL + "/submit-action-for-troubleshooting",
    startTroubleShootingNewUrl: API_BASE_URL + "/start-4g-troubleshooting",
    submitTroubleShootingNewUrl: API_BASE_URL + "/submit-vira-action-for-troubleshooting",
    smartSolutionURL: API_BASE_URL + "/get-vegas-response",
    smartSolutionDiagnosticURL: API_BASE_URL + "/get-mvd-diagnostics",
    submitNrbTicket: API_BASE_URL + "/submit-nrb-ticket",
    testTroubleShootingNewUrl: API_BASE_URL + "/test-vira-troubleshooting",
    startViraUrl: API_BASE_URL + "/start-vira-troubleshooting",
    getVegasGenAISummary: API_BASE_URL + "/getVegasGenAISummary",
    getMenuValues: API_BASE_URL + "/get-menu-values",
    genAIFeedback: API_BASE_URL + "/genAIFeedback",
    resumeTroubleShootingUrl: API_BASE_URL + "/start-4g-troubleshooting",
    replayTroubleShootingActionUrl: API_BASE_URL + "/replay-troubleshooting",
    replayTroubleShootingNewUrl: is5GFlow ? API_BASE_URL + "/replay-troubleshooting" : API_BASE_URL + "/replay-vira-troubleshooting",
    pollTroubleShootingActionUrl: is5GFlow ? API_BASE_URL + "/poll-troubleshooting" : API_BASE_URL + "/poll-vira-troubleshooting",
    defaultTemplateUrl: is5GFlow ? API_BASE_URL + "/error-content-troubleshooting" : API_BASE_URL + "/error-content-vira-troubleshooting",
    addressValidationUrl: API_BASE_URL + "/validate-address",
    typeAheadUrl: API_BASE_URL + "/search",
    searchUrl: API_BASE_URL + "/search",
    deviceSelectorUrl: API_BASE_URL + "/device-selector",
    supportTicketUrl: '/digital/nsa/secure/ui/sdr/createsupportticket',
    createCaseUrl: '/digital/nsa/secure/gw/sdr/createmrticket',
    submitCaseUrl: '/digital/nsa/secure/gw/sdr/submit-ticket',
    initCaseUrl: '/digital/nsa/secure/gw/sdr/submit-supticket',
    timeSlotURI: '/digital/nsa/secure/gw/sdr/get-call-details',
    deviceRepairUrl: API_BASE_URL + "/support/1d/secure/schedule-device-repair/",
    callbackTime: '/digital/nsa/nos/gw/contactus/get-ewt',
    additionalInfo: API_BASE_URL + "/other-content",
    issueSelector: API_BASE_URL + "/other-content",
    searchIssueSelector: API_BASE_URL + "/getSearchTrgIssues",
    dynamicCtaURI: API_BASE_URL + "/retrieveContentJson",
    uilogging: '/digital/nsa/nos/gw/troubleshooting/uilogging',
    managefiveGNetworks: '/mobile/nsa/psecure/gw/5groutermgmt/managefiveGNetworks',
    moreTab5gHomeSupport: '/mobile/nsa/psecure/gw/5groutermgmt/moreTab5gHomeSupport',
    fiveGHomeLanding: '/mobile/nsa/psecure/gw/5groutermgmt/fiveGHomeLanding',
    getAllIntentsUrl: API_BASE_URL + "/get-nsa-symptoms",
    getDeviceDataUrl: '/support/1d/secure/tsa',
    getDeviceSymptoms: API_BASE_URL + "/get-device-symptoms",
    getRecentPendingCasesUrl: API_BASE_URL + "/get-recent-pending-case",
    checkAlertBanner: '/digital/nsa/nos/gw/support/readsitealert/sitealertlogin',
    getCasesURI: API_BASE_URL + "/get-all-vira-cases",
    getViraCaseIdForLvURI: API_BASE_URL + "/get-lv-vira-case-id",
    getNrbURL: API_BASE_URL + "/get-nrb-content",
    getOfferEligibilityURL: API_BASE_URL + "/get-neoffer-eligibility",
    getNBXOfferEligibiltyURL: API_BASE_URL + "/check-nbx-nwe-eligibility",
    getAddOfferEligibilityURL: API_BASE_URL + "/add-neoffer",
    troubleShootingNBXUrl: API_BASE_URL + "/get-recommended-tiles",
    recommendFeedBackURL: API_BASE_URL + "/nbx-feedback",
    feedbackNsaUrl: API_BASE_URL + "/feedback",
    checkOutageDiagnosticUrl: "/digital/nsa/secure/gw/udb/new_network_outage"
  };
  var devApiUrls = {
    apiBaseUrl: API_BASE_URL,
    configUrl: API_BASE_URL + "/configdata.json",
    analyticsUrl: API_BASE_URL + "/analytics.json",
    accountIssueInfoUrl: API_BASE_URL + "/accountIssuePage.json",
    checkOutageUrl: API_BASE_URL + "/outage4g.json",
    check5GOutageUrl: API_BASE_URL + "/outageInfo_true.json",
    closeTroubleShootingUrl: API_BASE_URL + "/closeTroubleShooting.json",
    networkOutagePageUrl: API_BASE_URL + "/networkOutage.json",
    contactsUrl: API_BASE_URL + "/contactsPage.json",
    questionsIssueInfoUrl: API_BASE_URL + "/questionsPage.json",
    troubleShootingUrl: API_BASE_URL + "/troubleShooting_WifiCall.json",
    resumeTroubleShootingUrl: API_BASE_URL + "/troubleShootingNew.json",
    startTroubleShootingUrl: "/ts/" + API_BASE_URL + "/diagnostic.json",
    deviceSelectorUrl: API_BASE_URL + "/deviceSelector.json",
    externalNavLandingUrl: API_BASE_URL + "/externalNav.json",
    submitTroubleShootingNewUrl: window.callQAAPI ? ACSS_BASE_URL + "/submit-vira-action-for-troubleshooting" : API_BASE_URL + "/devrepeot.json",
    smartSolutionURL: API_BASE_URL + "/smartAISampleResponse.json",
    smartSolutionDiagnosticURL: API_BASE_URL + "/smartDiagnostic.json",
    submitNrbTicket: "/digital/nsa/secure/gw/troubleshooting/submit-nrb-ticket",
    submitTroubleShootingRadioUrl: API_BASE_URL + "/02.json",
    submitTroubleShootingOptionsUrl: API_BASE_URL + "/03.json",
    getVegasGenAISummary: "/digital/nsa/secure/gw/troubleshooting/getVegasGenAISummary",
    getMenuValues: "/digital/nsa/secure/gw/troubleshooting/get-menu-values",
    genAIFeedback: "/digital/nsa/secure/gw/troubleshooting/genAIFeedback",
    submitTroubleShootingDropdownUrl: API_BASE_URL + "/troubleShootingNewDropdown.json",
    submitTroubleShootingMultiUrl: API_BASE_URL + "/troubleShootingNewMultiArticle.json",
    completionUrl: API_BASE_URL + "/completionPage.json",
    testTroubleShootingNewUrl: API_BASE_URL + "/troubleShootingNew.json",
    startViraUrl: window.callQAAPI ? ACSS_BASE_URL + "/start-vira-troubleshooting" : API_BASE_URL + "/startvira.json",
    submitTroubleShootingActionUrl: API_BASE_URL + "/troubleShootingNew.json",
    replayTroubleShootingActionUrl: API_BASE_URL + "/replayTroubleShooting.json",
    replayTroubleShootingNewUrl: window.callQAAPI ? ACSS_BASE_URL + "/reply-vira-troubleshooting" : API_BASE_URL + "/replayTroubleShooting.json",
    pollTroubleShootingActionUrl: API_BASE_URL + "/dynamicpollend.json",
    defaultTemplateUrl: API_BASE_URL + "/errorContentTroubleShooting.json",
    addressValidationUrl: API_BASE_URL + "/addressValidation.json",
    typeAheadUrl: API_BASE_URL + "/searchResult.json",
    searchUrl: API_BASE_URL + "/searchResult.json",
    supportTicketUrl: 'https://onevzsoe-eks-gz-sit2e.ebiz.verizon.com/ui/sdr/createticket',
    createCaseUrl: 'digital/nsa/secure/gw/sdr/create-mr-ticket',
    submitCaseUrl: API_BASE_URL + "/submitTicket.json",
    initCaseUrl: API_BASE_URL + "/callbackData.json",
    timeSlotURI: API_BASE_URL + "/callDetails.json",
    deviceRepairUrl: API_BASE_URL + "/troubleShootingNew.json",
    reviewTechBulletInUrl: API_BASE_URL + "/reviewTechBulletInSearch.json",
    feedbackDropdownUrl: API_BASE_URL + "/feedbackDropdownInfo.json",
    additionalInfo: API_BASE_URL + "/additionalInfo.json",
    uilogging: API_BASE_URL + "/uilogging.json",
    dynamicCtaURI: window.callQAAPI ? ACSS_BASE_URL + "/retrieveContentJson" : API_BASE_URL + "/dynamicRespNew.json",
    getAllIntentsUrl: API_BASE_URL + "/search-intents.json",
    getDeviceDataUrl: 'https://vzwqa1.verizonwireless.com/support/1d/secure/tsa',
    getDeviceSymptoms: API_BASE_URL + "/get-device-symptoms.json",
    getRecentPendingCasesUrl: API_BASE_URL + "/getrecentpendingcase.json",
    checkAlertBanner: API_BASE_URL + "/siteAlert.json",
    getCasesURI: API_BASE_URL + "/getAllCases.json",
    getViraCaseIdForLvURI: API_BASE_URL + "/getLvViraCaseId.json",
    getNrbURL: API_BASE_URL + "/getNrbContent_1.json",
    getOfferEligibilityURL: API_BASE_URL + "/getNeofferEligibility.json",
    getAddOfferEligibilityURL: API_BASE_URL + "/getNeAddofferEligibility.json",
    getNBXOfferEligibiltyURL: API_BASE_URL + "/getNBXOfferEligibility.json",
    troubleShootingNBXUrl: API_BASE_URL + "/troubleShootingNBX.json",
    recommendFeedBackURL: API_BASE_URL + "/recommendFeedBack.json",
    feedbackNsaUrl: API_BASE_URL + "/feedback.json",
    checkOutageDiagnosticUrl: API_BASE_URL + "/checkOutage.json"
  };
  if (runMode === 'development') {
    return {
      apiUrls: devApiUrls
    };
  }
  if (window.isMVODigital) {
    return {
      apiUrls: digitalApiUrls
    };
  }
  return {
    apiUrls: acssApiUrls
  };
};

var mvoConfig = sessionUtility.getMvoConfig();
var mvoTroubleShootingJson = sessionUtility.getTroubleShootingJson();
var mvoCaseDetails = sessionUtility.getCaseDetails();
var common = {
  getChannelId: function getChannelId(sURL) {
    var channelID = "";
    if (mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.channelId) {
      channelID = mvoConfig === null || mvoConfig === void 0 ? void 0 : mvoConfig.channelId;
      if (channelID == "VZW-DOTCOM" && isMobile$1) {
        channelID = "VZW-DOTCOM-MOB";
      }
    } else if (window.location.pathname.toLowerCase().indexOf("/mva") > -1) {
      channelID = "VZW-MFA";
    } else {
      if (isMobile$1) {
        channelID = "VZW-DOTCOM-MOB";
      } else {
        channelID = "VZW-DOTCOM";
      }
    }
    return channelID;
  },
  getCaseChannelDetails: function getCaseChannelDetails(sURL) {
    var _mvoCaseDetails$inten, _mvoTroubleShootingJs, _mvoTroubleShootingJs2, _mvoTroubleShootingJs3;
    var channelID = "";
    if (typeof (mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.channel) !== "undefined" && (mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.channel) !== null) {
      if (((mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.channel) == "My Verizon" || (mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.channel) == "Verizon website") && isMobile$1) {
        channelID = "VZW-DOTCOM-MOB";
      } else if (((mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.channel) == "My Verizon" || (mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.channel) == "Verizon website") && isTablet) {
        channelID = "VZW-DOTCOM-TAB";
      } else {
        channelID = "VZW-DOTCOM";
      }
    } else {
      channelID = "";
    }
    return {
      channelID: channelID,
      flowName: JSON.stringify({
        intentType: (_mvoCaseDetails$inten = mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.intent) != null ? _mvoCaseDetails$inten : "",
        devicename: (_mvoTroubleShootingJs = mvoTroubleShootingJson === null || mvoTroubleShootingJson === void 0 ? void 0 : (_mvoTroubleShootingJs2 = mvoTroubleShootingJson.ddata) === null || _mvoTroubleShootingJs2 === void 0 ? void 0 : (_mvoTroubleShootingJs3 = _mvoTroubleShootingJs2.device) === null || _mvoTroubleShootingJs3 === void 0 ? void 0 : _mvoTroubleShootingJs3.soeUrl) != null ? _mvoTroubleShootingJs : ""
      })
    };
  },
  getAction: function getAction(interfaceName, clickstream, templateId, currentPageId) {
    var action = "TRG_SIGNIN_4G_PAGELOAD";
    if (mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isLoggedOut) {
      action = "TRG_NONSIGNIN_4G_PAGELOAD";
    }
    if (interfaceName == "PAGE-LOADED" && clickstream == "PAGE-LOADED" && templateId && currentPageId) {
      if (templateId != "CONGRATULATIONS_PAGE" && templateId != "4G-CONTACT-OPTIONS-WITHOUT-REPAIR" && templateId != "4G-CONTACT-OPTIONS-WITH-REPAIR" && currentPageId > 1) {
        action = "TRG_SIGNIN_4G_PROGRESS";
        if (mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isLoggedOut) {
          action = "TRG_NONSIGNIN_4G_PROGRESS";
        }
      } else if ((templateId == "4G-CONTACT-OPTIONS-WITH-REPAIR" || templateId == "4G-CONTACT-OPTIONS-WITHOUT-REPAIR") && currentPageId > 1) {
        action = "TRG_SIGNIN_4G_CONTACT_US";
        if (mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isLoggedOut) {
          action = "TRG_NONSIGNIN_4G_CONTACT_US";
        }
      } else if (templateId == "CONGRATULATIONS_PAGE" && currentPageId > 1) {
        action = "TRG_SIGNIN_4G_COMPLETED";
        if (mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isLoggedOut) {
          action = "TRG_NONSIGNIN_4G_COMPLETED";
        }
      }
    } else if (clickstream != "PAGE-LOADED" && interfaceName != "PAGE-LOADED") {
      action = (clickstream === null || clickstream === void 0 ? void 0 : clickstream.replace(/{|}/g, '')) + " click";
    }
    return action;
  },
  getErrorMessage: function getErrorMessage(error) {
    var errorMsg = "";
    try {
      if (error !== null && error.error !== null) {
        if (error.status === 200 && error.error.error !== null) errorMsg = error.error.error.message !== null ? error.error.error.message : JSON.stringify(error.error.error);else errorMsg = JSON.stringify(error.error);
      } else {
        error = {
          status: 500,
          message: 'Error is null'
        };
        if (error.status !== null) errorMsg += "STATUS=" + error.status + ",";
        if (error.message !== null) errorMsg += "MSG=" + error.message;
        errorMsg = JSON.stringify(error);
      }
      if (errorMsg === "") errorMsg = JSON.stringify(error);
    } catch (ex) {
      errorMsg = JSON.stringify(error);
    }
    return errorMsg;
  },
  loadUtagScript: function loadUtagScript(callback) {
    var existingScript = document.getElementById('vzta');
    var tagUrl = mvoConfig === null || mvoConfig === void 0 ? void 0 : mvoConfig._vzwTagUrl;
    if (!existingScript && tagUrl) {
      var script = document.createElement('script');
      script.src = tagUrl;
      script.id = 'vzta';
      document.body.appendChild(script);
      script.onload = function () {
        if (callback) callback();
      };
    }
    if (existingScript && callback) callback();
  },
  stringifyJSON: function stringifyJSON(obj) {
    try {
      if (obj && obj !== null && obj !== "") {
        if (typeof obj === "string") {
          return obj;
        } else {
          return JSON.stringify(obj);
        }
      }
    } catch (e) {}
    return obj;
  }
};
function getCookie(name) {
  var cookieArr = document.cookie.split(';');
  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split('=');
    if (name == cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}
function getNBXParams(params) {
  var _params, _params$intentId;
  if (params === void 0) {
    params = {};
  }
  if (window.isMVODigital && (_params = params) !== null && _params !== void 0 && (_params$intentId = _params.intentId) !== null && _params$intentId !== void 0 && _params$intentId.startsWith('IN') && !window.isLoggedOut && sessionStorage.getItem('propositionNBX')) {
    var propositionNBX = JSON.parse(sessionStorage.getItem('propositionNBX'));
    params.recommendedTile = propositionNBX ? propositionNBX.propositionName : "";
  }
}
function windowScrollTop() {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
}

var mvoConfig$1 = sessionUtility.getMvoConfig();
var mvoTroubleShootingJson$1 = sessionUtility.getTroubleShootingJson();
var mvoCaseDetails$1 = sessionUtility.getCaseDetails();
var method = sessionUtility.getRunMode() == "development" ? "get" : "post";
var ostype = "WEB";
var axiosConfig = {
  url: '',
  timeout: 300000,
  responseType: "json",
  method: method,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    channelId: common.getChannelId()
  }
};
if (mvoConfig$1 !== null && mvoConfig$1 !== void 0 && mvoConfig$1.isAcss) {
  axiosConfig.withCredentials = true;
}
var newrelic = window.newrelic ? window.newrelic : "";
var _dg_sessionId = window._dg_sessionId ? window._dg_sessionId : "";
var _dg_eReqId = window._dg_eReqId ? window._dg_eReqId : "";
function startNewrelicInteraction(pageName) {
  try {
    var newRelicObj = newrelic.interaction();
    newRelicObj.setName(pageName);
    newRelicObj.save();
  } catch (ex) {}
}
function getAMId() {
  var amID = "";
  if (typeof _dg_sessionId !== "undefined" && _dg_sessionId) {
    amID = _dg_sessionId;
  }
  console.log("NSA Session ID / AMID " + amID);
  return amID;
}
function is5GDevice() {
  var _mvoTroubleShootingJs, _mvoTroubleShootingJs2, _mvoTroubleShootingJs3;
  return (_mvoTroubleShootingJs = mvoTroubleShootingJson$1 === null || mvoTroubleShootingJson$1 === void 0 ? void 0 : (_mvoTroubleShootingJs2 = mvoTroubleShootingJson$1.ddata) === null || _mvoTroubleShootingJs2 === void 0 ? void 0 : (_mvoTroubleShootingJs3 = _mvoTroubleShootingJs2.device) === null || _mvoTroubleShootingJs3 === void 0 ? void 0 : _mvoTroubleShootingJs3.is5GDevice) != null ? _mvoTroubleShootingJs : false;
}
function getViraPageName(apiResponse) {
  if (apiResponse && apiResponse !== "") {
    var _JSON$parse$ddata$out, _JSON$parse, _JSON$parse$ddata, _JSON$parse2, _outputResponse$pageC, _outputResponse$pageC2, _outputResponse$pageC3, _outputResponse$curre;
    var outputResponse = (_JSON$parse$ddata$out = (_JSON$parse = JSON.parse((_JSON$parse2 = JSON.parse(apiResponse)) === null || _JSON$parse2 === void 0 ? void 0 : _JSON$parse2.responseInfo)) === null || _JSON$parse === void 0 ? void 0 : (_JSON$parse$ddata = _JSON$parse.ddata) === null || _JSON$parse$ddata === void 0 ? void 0 : _JSON$parse$ddata.output) != null ? _JSON$parse$ddata$out : null;
    return {
      templateId: (_outputResponse$pageC = outputResponse === null || outputResponse === void 0 ? void 0 : (_outputResponse$pageC2 = outputResponse.pageContent) === null || _outputResponse$pageC2 === void 0 ? void 0 : (_outputResponse$pageC3 = _outputResponse$pageC2.steps[0]) === null || _outputResponse$pageC3 === void 0 ? void 0 : _outputResponse$pageC3.templateId) != null ? _outputResponse$pageC : "",
      stepId: (_outputResponse$curre = outputResponse === null || outputResponse === void 0 ? void 0 : outputResponse.currentPageId) != null ? _outputResponse$curre : ""
    };
  } else {
    return "";
  }
}
function getPageName(pathVal) {
  console.log("test pathVal", pathVal);
  var path = "";
  pathVal !== undefined ? path = pathVal : path = "";
  if (!path) {
    var pathArray = window.location.hash.split("/");
    try {
      path = pathArray.length > 1 ? pathArray[1].toLowerCase() : "";
    } catch (ex) {}
  }
  var pageName = "";
  console.log("test path", path);
  switch (path) {
    case "":
      pageName = "LANDING_SYMPTOMS";
      break;
    case "issue_information":
      pageName = "ISSUE_INFORMATION";
      break;
    case "issue_steps":
      pageName = "ISSUE_STEPS";
      break;
    case "tsa_completion":
      pageName = "TSA_COMPLETION";
      break;
    default:
      pageName = "TSA";
  }
  return pageName;
}
function logApiInfo(pageName, apiRequest, apiResponse, responseTime, flowName, interfaceName, configUrl, data, responseCode, responseStatus, mydata, envUrl) {
  if (mvoConfig$1 !== null && mvoConfig$1 !== void 0 && mvoConfig$1.enableUILogging) {
    var _axiosConfig$method;
    var dateTime = new Date().toLocaleString("en-US", {
      timeZone: "UTC"
    });
    var logPayload = {
      dateTime: dateTime,
      logType: "api",
      channelName: common.getChannelId(),
      osType: osName,
      osVerison: osVersion,
      deviceType: ostype,
      agentId: navigator.userAgent,
      pageName: pageName,
      apiRequest: apiRequest,
      apiResponse: apiResponse,
      responseTime: responseTime,
      responseData: data,
      responseCode: responseCode,
      responseStatus: responseStatus,
      apiName: configUrl,
      flowName: flowName,
      interfaceName: interfaceName,
      serviceName: "digital",
      data: mydata,
      mtn: (mvoCaseDetails$1 === null || mvoCaseDetails$1 === void 0 ? void 0 : mvoCaseDetails$1.mtn) || "",
      is5GDevice: is5GDevice()
    };
    if (mvoConfig$1 !== null && mvoConfig$1 !== void 0 && mvoConfig$1.isAcss) {
      var _mvoCaseDetails$accou;
      logPayload.accountNumber = (_mvoCaseDetails$accou = mvoCaseDetails$1 === null || mvoCaseDetails$1 === void 0 ? void 0 : mvoCaseDetails$1.accountNumber) != null ? _mvoCaseDetails$accou : "";
    }
    if (!is5GDevice()) {
      logPayload.channelName = common.getCaseChannelDetails().channelID;
      logPayload.flowName = common.getCaseChannelDetails().flowName;
      logPayload.pageName = JSON.stringify(getViraPageName(apiResponse));
    }
    console.log("test logApiInfo", axiosConfig);
    axiosConfig.url = tsaEnvConfig$1(envUrl).apiUrls.uilogging;
    axiosConfig.data = logPayload ? JSON.stringify(logPayload) : "";
    var apiMethod = ((_axiosConfig$method = axiosConfig.method) === null || _axiosConfig$method === void 0 ? void 0 : _axiosConfig$method.toLowerCase()) === "post" ? postHttpClientRequest(axiosConfig.url, axiosConfig.data, axiosConfig) : getHttpClientRequest(axiosConfig.url, axiosConfig);
    return apiMethod.then(function (res) {
      console.log("clickstream response=> " + res);
      return "success";
    })["catch"](function (err) {
      console.log("clickstream error=> " + err);
      logNewrelicNoticeError(err, "APIError");
      return "failure";
    });
  }
}
function logJSError(errorStack, errorMsg, errorType, filename) {
  if (mvoConfig$1 !== null && mvoConfig$1 !== void 0 && mvoConfig$1.enableUILogging) {
    try {
      var _axiosConfig$method2;
      var currentPage = getPageName();
      var flowName = currentPage;
      var errStackData = errorStack.toString();
      var jsError = {
        errorMessage: errorMsg,
        errorStack: errStackData,
        fileName: filename
      };
      var dateTime = new Date().toLocaleString("en-US", {
        timeZone: "UTC"
      });
      var logPayload = {
        dateTime: dateTime,
        logType: "CLICKSTREAM",
        osType: osName,
        osVerision: osVersion,
        deviceType: ostype,
        agentId: navigator.userAgent,
        pageName: currentPage,
        action: "JS-ERROR",
        flowName: errorType,
        mtn: (mvoCaseDetails$1 === null || mvoCaseDetails$1 === void 0 ? void 0 : mvoCaseDetails$1.mtn) || "",
        data: JSON.stringify(jsError),
        is5GDevice: is5GDevice()
      };
      axiosConfig.headers.OsType = ostype;
      if (mvoConfig$1 !== null && mvoConfig$1 !== void 0 && mvoConfig$1.isAcss) {
        var _mvoCaseDetails$accou2;
        logPayload.accountNumber = (_mvoCaseDetails$accou2 = mvoCaseDetails$1 === null || mvoCaseDetails$1 === void 0 ? void 0 : mvoCaseDetails$1.accountNumber) != null ? _mvoCaseDetails$accou2 : "";
      }
      if (!is5GDevice()) {
        logPayload.flowName = common.getCaseChannelDetails().flowName;
        logPayload.action = common.getAction();
      }
      console.log("test logJSError", axiosConfig);
      axiosConfig.data = logPayload ? JSON.stringify(logPayload) : "";
      var apiMethod = ((_axiosConfig$method2 = axiosConfig.method) === null || _axiosConfig$method2 === void 0 ? void 0 : _axiosConfig$method2.toLowerCase()) === "post" ? postHttpClientRequest(axiosConfig.url, axiosConfig.data, axiosConfig) : getHttpClientRequest(axiosConfig.url, axiosConfig);
      return apiMethod.then(function (res) {
        console.log("clickstream response=> " + res);
        return "success";
      })["catch"](function (err) {
        console.log("clickstream error=> " + err);
        logNewrelicNoticeError(err, "APIError");
        return "failure";
      });
    } catch (ex) {}
  }
}
function logClickStream(interfaceName, activityName, clickstream, setTitle, templateId, currentPageId) {
  if (mvoConfig$1 !== null && mvoConfig$1 !== void 0 && mvoConfig$1.enableUILogging) {
    try {
      var currentPage = getPageName(setTitle);
      var flowName = currentPage;
      var dateTime = new Date().toLocaleString("en-US", {
        timeZone: "UTC"
      });
      var logPayload = {
        dateTime: dateTime,
        logType: "CLICKSTREAM",
        channelName: common.getChannelId(),
        osVerison: osVersion,
        deviceType: ostype,
        pageName: currentPage,
        eventId: activityName,
        interfaceName: interfaceName,
        action: clickstream,
        flowName: flowName,
        mtn: (mvoCaseDetails$1 === null || mvoCaseDetails$1 === void 0 ? void 0 : mvoCaseDetails$1.mtn) || "",
        is5GDevice: is5GDevice()
      };
      if (mvoConfig$1 !== null && mvoConfig$1 !== void 0 && mvoConfig$1.isAcss) {
        var _mvoCaseDetails$accou3;
        logPayload.accountNumber = (_mvoCaseDetails$accou3 = mvoCaseDetails$1 === null || mvoCaseDetails$1 === void 0 ? void 0 : mvoCaseDetails$1.accountNumber) != null ? _mvoCaseDetails$accou3 : "";
      }
      if (!is5GDevice()) {
        console.log("test logger" + "templateId" + templateId + "currentPageId" + currentPageId);
        logPayload.channelName = common.getCaseChannelDetails().channelID;
        logPayload.flowName = common.getCaseChannelDetails().flowName;
        logPayload.action = common.getAction(interfaceName, clickstream, templateId, currentPageId);
        if (templateId && currentPageId) {
          logPayload.pageName = JSON.stringify({
            templateId: templateId,
            stepId: currentPageId
          });
        }
        if (clickstream !== "PAGE-LOADED" && clickstream.endsWith("-link")) {
          logPayload.pageName = clickstream.replace(/-link/g, '');
        }
      }
      startNewrelicInteraction(currentPage);
      if (clickstream) {
        var _axiosConfig$method3;
        console.log("test logClickStream", axiosConfig);
        axiosConfig.data = logPayload ? JSON.stringify(logPayload) : "";
        var apiMethod = ((_axiosConfig$method3 = axiosConfig.method) === null || _axiosConfig$method3 === void 0 ? void 0 : _axiosConfig$method3.toLowerCase()) === "post" ? postHttpClientRequest(axiosConfig.url, axiosConfig.data, axiosConfig) : getHttpClientRequest(axiosConfig.url, axiosConfig);
        return apiMethod.then(function (res) {
          console.log("clickstream response=> " + res);
          return "success";
        })["catch"](function (err) {
          console.log("clickstream error=> " + err);
          logNewrelicNoticeError(err, "APIError");
          return "failure";
        });
      }
    } catch (ex) {}
  }
}
function logNewrelicNoticeError(errorObject, logType) {
  try {
    var dateTime = new Date().toLocaleString("en-US", {
      timeZone: "UTC"
    });
    var cookies = new Cookies();
    var sessionId = cookies.get("digital_ig_session");
    sessionId = sessionId ? sessionId : "trgnsa";
    var channelId = common.getChannelId();
    var logPayload = {
      dateTime: dateTime,
      logType: logType,
      channelId: channelId,
      e2eRequestId: _dg_eReqId,
      url: window.location.href,
      sessionId: sessionId
    };
    if (mvoConfig$1 !== null && mvoConfig$1 !== void 0 && mvoConfig$1.isAcss) {
      var _mvoCaseDetails$accou4;
      logPayload.accountNumber = (_mvoCaseDetails$accou4 = mvoCaseDetails$1 === null || mvoCaseDetails$1 === void 0 ? void 0 : mvoCaseDetails$1.accountNumber) != null ? _mvoCaseDetails$accou4 : "";
    }
    if (typeof newrelic != "undefined" && typeof newrelic.noticeError != "undefined") {
      newrelic.noticeError(errorObject, logPayload);
    }
  } catch (ex) {
    console.log("ex:" + ex);
  }
}

var callAxios = function callAxios(url, method, data, headers) {
  try {
    var response = false;
    var axiosConfig = {
      timeout: 300000,
      responseType: "json",
      withCredentials: true,
      headers: _extends({}, headers, {
        Accept: "application/json",
        "Content-Type": "application/json",
        credentials: true
      })
    };
    var payload = data ? JSON.stringify(data) : '';
    var apiMethod = (method === null || method === void 0 ? void 0 : method.toLowerCase()) === "post" ? postHttpClientRequest(url, payload, axiosConfig) : getHttpClientRequest(url, axiosConfig);
    return Promise.resolve(apiMethod.then(function (resp, headers) {
      response = {
        success: true,
        response: resp,
        headers: headers
      };
    })["catch"](function (err, headers) {
      logNewrelicNoticeError(err, 'APIError');
      response = {
        success: false,
        error: err,
        headers: headers
      };
    })).then(function () {
      return response;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var additionalInfo = function additionalInfo(params) {
  try {
    var URL = tsaEnvConfig("development").apiUrls.additionalInfo;
    console.log("external target inside additional info: " + (params === null || params === void 0 ? void 0 : params.externalTarget));
    if ((params === null || params === void 0 ? void 0 : params.mvoenv) !== "development" && params !== null && params !== void 0 && params.externalTarget) {
      URL = (params === null || params === void 0 ? void 0 : params.externalTarget) + tsaEnvConfig().apiUrls.additionalInfo;
      console.log("api url inside additional info: " + URL);
    }
    var addtionalParamAcss = "";
    if (!window.isMVODigital && !window.isBAUACSS) {
      var _params$channel, _params$tier;
      console.log("Not digital and bau acss");
      var _params$equipmentId = params.equipmentId,
        equipmentId = _params$equipmentId === void 0 ? '' : _params$equipmentId,
        _params$sku = params.sku,
        sku = _params$sku === void 0 ? '' : _params$sku,
        _params$mdn = params.mdn,
        mdn = _params$mdn === void 0 ? '' : _params$mdn,
        _params$accountNumber = params.accountNumber,
        accountNumber = _params$accountNumber === void 0 ? '' : _params$accountNumber;
      addtionalParamAcss = {
        "channelId": (_params$channel = params === null || params === void 0 ? void 0 : params.channel) != null ? _params$channel : "Care",
        "tierId": (_params$tier = params === null || params === void 0 ? void 0 : params.tier) != null ? _params$tier : "",
        "equipmentId": equipmentId,
        "deviceSku": sku,
        "mtn": mdn,
        "accountNumber": accountNumber
      };
    }
    if (params !== null && params !== void 0 && params.newPopoutFlow) {
      var _params$channel2, _params$tier2, _params$mdn2, _params$accountNumber2;
      console.log("newPopoutFlow flag inside additional info: " + (params === null || params === void 0 ? void 0 : params.newPopoutFlow));
      addtionalParamAcss = {
        "channelId": (_params$channel2 = params === null || params === void 0 ? void 0 : params.channel) != null ? _params$channel2 : "CARE",
        "tierId": (_params$tier2 = params === null || params === void 0 ? void 0 : params.tier) != null ? _params$tier2 : "",
        "mtn": (_params$mdn2 = params === null || params === void 0 ? void 0 : params.mdn) != null ? _params$mdn2 : "",
        "accountNumber": (_params$accountNumber2 = params === null || params === void 0 ? void 0 : params.accountNumber) != null ? _params$accountNumber2 : ""
      };
    }
    return Promise.resolve(_catch(function () {
      var payload = JSON.stringify(_extends({
        "loggedInUser": params.loggedInUser
      }, addtionalParamAcss));
      var axiosConfig = {
        credentials: 'include',
        headers: {
          "Content-Type": "application/json",
          "channelId": "VZW-ACSS"
        }
      };
      var apiMethod = postHttpClientRequest(URL, payload, axiosConfig);
      var response = false;
      return Promise.resolve(apiMethod.then(function (resp, headers) {
        response = {
          success: true,
          body: resp.data.body,
          responseInfo: resp.data.responseInfo,
          headers: headers
        };
      })["catch"](function (err, headers) {
        logNewrelicNoticeError(err, 'APIError');
        var responseInfo = {
          responseCode: "99",
          responseMessage: "Failed"
        };
        response = {
          success: false,
          error: err,
          headers: headers,
          responseInfo: responseInfo
        };
      })).then(function () {
        console.log("additional info response: " + response);
        return response;
      });
    }, function () {
      console.log("additionalInfo call failed");
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};
var issueSelectorPageLoad = function issueSelectorPageLoad(externalTarget, mvoenv, channelId, payload) {
  try {
    var resp = null;
    var _temp = _catch(function () {
      var url = tsaEnvConfig("development").apiUrls.issueSelector;
      if (mvoenv !== "development" && externalTarget) {
        url = externalTarget + tsaEnvConfig().apiUrls.issueSelector;
      }
      return Promise.resolve(callAxios(url, mvoenv === "development" ? "get" : "post", payload, {
        "channelId": channelId != null ? channelId : "VZW-ACSS"
      })).then(function (_callAxios) {
        resp = _callAxios;
      });
    }, function () {
      console.log("Issue Selector Page Load failed");
    });
    return Promise.resolve(_temp && _temp.then ? _temp.then(function () {
      return resp;
    }) : resp);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getNsaSymptomsPageLoad = function getNsaSymptomsPageLoad(externalTarget, mvoenv, channelId, payload) {
  try {
    var resp = null;
    var _temp2 = _catch(function () {
      var url = tsaEnvConfig("development").apiUrls.getnsasymptoms;
      if (mvoenv !== "development" && externalTarget) {
        url = externalTarget + tsaEnvConfig().apiUrls.getnsasymptoms;
      }
      return Promise.resolve(callAxios(url, mvoenv === "development" ? "get" : "post", payload, {
        "channelId": channelId != null ? channelId : "VZW-ACSS"
      })).then(function (_callAxios2) {
        resp = _callAxios2;
      });
    }, function () {
      console.log("NSA symptom Page Load failed");
    });
    return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {
      return resp;
    }) : resp);
  } catch (e) {
    return Promise.reject(e);
  }
};
var redirectFormPostToTRGUrl = function redirectFormPostToTRGUrl(selectedItem, parentSymptomid, paramsDetails, sessionCacheId, tsrAction) {
  var _paramsDetails$appId, _paramsDetails$channe, _paramsDetails$tier, _paramsDetails$tier2, _paramsDetails$mdn, _paramsDetails$custom;
  console.log(selectedItem);
  var tsrId = "";
  if (selectedItem && selectedItem.symptomId && parentSymptomid) {
    tsrId = selectedItem.symptomId + "~" + parentSymptomid;
  }
  if (selectedItem && selectedItem.symptomId && (typeof parentSymptomid === "undefined" || parentSymptomid === "")) {
    tsrId = "" + selectedItem.symptomId;
  }
  if (selectedItem && selectedItem.stepId !== "0") {
    tsrId += "~" + selectedItem.stepId;
  }
  if (selectedItem && selectedItem.guideId !== "0") {
    tsrId += "~" + selectedItem.guideId;
  }
  var params = {
    appId: (_paramsDetails$appId = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.appId) != null ? _paramsDetails$appId : "ACSS",
    channel: (_paramsDetails$channe = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.channel) != null ? _paramsDetails$channe : "Care",
    tierId: (_paramsDetails$tier = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.tier) != null ? _paramsDetails$tier : "",
    tier: (_paramsDetails$tier2 = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.tier) != null ? _paramsDetails$tier2 : "",
    mdn: (_paramsDetails$mdn = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.mdn) != null ? _paramsDetails$mdn : "",
    custVerified: (_paramsDetails$custom = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.customerVerified) != null ? _paramsDetails$custom : "Y",
    userId: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.loggedInUser,
    token: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.token
  };
  if (tsrAction) {
    params["tsrAction"] = tsrAction;
  }
  if (paramsDetails && paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.equipmentId) {
    params["equipId"] = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.equipmentId;
  }
  if (sessionCacheId) {
    params["frontEndSessionID"] = sessionCacheId;
  }
  if (tsrId) {
    params['tsrID'] = tsrId;
  }
  var url = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.mvoSolPortal;
  try {
    var submitToPopup = function submitToPopup(f) {
      var w = window.open('', 'form-target', 'width=1200,height=1000');
      f.target = 'form-target';
      f.submit();
    };
    var form = document.createElement("form");
    form.setAttribute("method", "post");
    form.setAttribute("action", url);
    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }
    }
    ;
    document.body.appendChild(form);
    console.log("form bau", form);
    submitToPopup(form);
  } catch (error) {
    console.log("Form Post URL Info Failed");
  }
};
var redirectResumeFormPostToTRGUrl = function redirectResumeFormPostToTRGUrl(url, params) {
  try {
    var submitToPopup = function submitToPopup(f) {
      var w = window.open('', 'form-target', 'width=1200,height=1000');
      f.target = 'form-target';
      f.submit();
    };
    var form = document.createElement("form");
    form.setAttribute("method", "post");
    form.setAttribute("action", url);
    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }
    }
    ;
    document.body.appendChild(form);
    console.log("form bau", form);
    submitToPopup(form);
  } catch (error) {
    console.log("Form Post URL Info Failed");
  }
};
var redirectFormPostToNSAUrl = function redirectFormPostToNSAUrl(selectedItem, intentId, paramsDetails, caseId) {
  var _paramsDetails$appId2, _paramsDetails$channe2, _paramsDetails$tier3, _paramsDetails$tier4, _paramsDetails$mdn2, _paramsDetails$equipm, _paramsDetails$custom2;
  console.log(selectedItem);
  var params = {
    appId: (_paramsDetails$appId2 = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.appId) != null ? _paramsDetails$appId2 : "ACSS",
    channel: (_paramsDetails$channe2 = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.channel) != null ? _paramsDetails$channe2 : "Care",
    tierId: (_paramsDetails$tier3 = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.tier) != null ? _paramsDetails$tier3 : "",
    tier: (_paramsDetails$tier4 = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.tier) != null ? _paramsDetails$tier4 : "",
    mdn: (_paramsDetails$mdn2 = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.mdn) != null ? _paramsDetails$mdn2 : "",
    equipId: (_paramsDetails$equipm = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.equipmentId) != null ? _paramsDetails$equipm : "",
    custVerified: (_paramsDetails$custom2 = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.customerVerified) != null ? _paramsDetails$custom2 : "Y",
    userId: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.loggedInUser,
    token: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.token,
    tsrAction: 'showNsaStep',
    frontEndSessionID: caseId,
    tsrID: intentId + "~" + selectedItem.title
  };
  var url = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.mvoSolPortal;
  try {
    var submitToPopup = function submitToPopup(f) {
      var w = window.open('', 'form-target', 'width=1200,height=1000');
      f.target = 'form-target';
      f.submit();
    };
    var form = document.createElement("form");
    form.setAttribute("method", "post");
    form.setAttribute("action", url);
    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }
    }
    ;
    document.body.appendChild(form);
    console.log("form nsa", form);
    submitToPopup(form);
  } catch (error) {
    console.log("Form Post URL Info Failed");
  }
};
var ChangeTabIssueHistory = function ChangeTabIssueHistory(data) {
  try {
    var resp = null;
    var externalTarget = data === null || data === void 0 ? void 0 : data.externalTarget;
    var mvoenv = data.mvoenv;
    var channelId = data === null || data === void 0 ? void 0 : data.channelId;
    var payload = {
      "mtn": data.mdn,
      "accountNumber": data.accountNumber,
      "frontEndClientID": "ACSS",
      "channelId": data === null || data === void 0 ? void 0 : data.channel,
      "trainingAccount": data === null || data === void 0 ? void 0 : data.isTrainingMode
    };
    var _temp4 = _catch(function () {
      var url = tsaEnvConfig("development").apiUrls.issueHistory;
      if (mvoenv !== "development" && externalTarget) {
        url = externalTarget + tsaEnvConfig().apiUrls.issueHistory;
      }
      return Promise.resolve(callAxios(url, mvoenv === "development" ? "get" : "post", payload, {
        "channelId": channelId != null ? channelId : "VZW-ACSS"
      })).then(function (_callAxios3) {
        resp = _callAxios3;
      });
    }, function () {
      console.log("Issue History Page Load failed");
    });
    return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(function () {
      return resp;
    }) : resp);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getDeviceSelectorJson = function getDeviceSelectorJson(requestObj) {
  if (requestObj === void 0) {
    requestObj = {};
  }
  try {
    var _requestObj = requestObj,
      externalTarget = _requestObj.externalTarget,
      mvoenv = _requestObj.mvoenv,
      channelId = _requestObj.channelId;
    var resp;
    var _temp5 = _catch(function () {
      var reqURI = tsaEnvConfig("development").apiUrls.deviceSelectorURI;
      if (mvoenv !== "development" && externalTarget) {
        reqURI = externalTarget + tsaEnvConfig().apiUrls.deviceSelectorURI;
      }
      return Promise.resolve(callAxios(reqURI, mvoenv === "development" ? "get" : "post", {}, {
        "channelId": channelId != null ? channelId : "VZW-ACSS"
      })).then(function (_ref) {
        var _ref$response = _ref.response,
          response = _ref$response === void 0 ? {} : _ref$response;
        resp = response.data;
      });
    }, function () {
      console.log("Device Selector Json Call Failed");
    });
    return Promise.resolve(_temp5 && _temp5.then ? _temp5.then(function () {
      return resp;
    }) : resp);
  } catch (e) {
    return Promise.reject(e);
  }
};
var GetOrderCaseId = function GetOrderCaseId(data, paramsDetails) {
  try {
    var resp = null;
    var externalTarget = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.externalTarget;
    var mvoenv = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.mvoenv;
    var channelId = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.channelId;
    var payload = {
      "locationCode": data.locationCode,
      "orderNumber": data.orderNumber
    };
    var _temp6 = _catch(function () {
      var url = tsaEnvConfig("development").apiUrls.getOrderCaseId;
      if (mvoenv !== "development" && externalTarget) {
        url = externalTarget + tsaEnvConfig().apiUrls.getOrderCaseId;
      }
      return Promise.resolve(callAxios(url, mvoenv === "development" ? "get" : "post", payload, {
        "channelId": channelId != null ? channelId : "VZW-ACSS"
      })).then(function (_callAxios4) {
        resp = _callAxios4;
      });
    }, function () {
      console.log("Get Order Case API failed");
    });
    return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function () {
      return resp;
    }) : resp);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getNsaSymptomsData = function getNsaSymptomsData(payload) {
  try {
    var externalTarget = payload.externalTarget,
      mvoenv = payload.mvoenv,
      channelId = payload.channelId;
    return Promise.resolve(_catch(function () {
      var reqURI = tsaEnvConfig("development").apiUrls.getNsaSymptoms;
      if (mvoenv !== "development" && externalTarget) {
        reqURI = externalTarget + tsaEnvConfig().apiUrls.getNsaSymptoms;
      }
      return Promise.resolve(callAxios(reqURI, mvoenv === "development" ? "get" : "post", payload, {
        "channelId": channelId != null ? channelId : "VZW-ACSS"
      })).then(function (response) {
        return response === null || response === void 0 ? void 0 : response.response;
      });
    }, function () {
      console.log("nsa symptom call failed");
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

var isEmpty = function isEmpty(value) {
  if (typeof value === "undefined" || value === undefined || value === 'undefined') {
    return true;
  }
  if (value === null) {
    return true;
  }
  if (typeof value === "string" && value.length === 0) {
    return true;
  }
  if (typeof value === "number" && value === 0) {
    return true;
  }
  if (typeof value === "boolean" && value === false) {
    return true;
  }
  if (Array.isArray(value) && value.length === 0) {
    return true;
  }
  if (typeof value === "object" && !(value instanceof HTMLElement) && Object.keys(value).length === 0) {
    return true;
  }
  if (typeof value === "symbol" && value.length === 0) {
    return true;
  }
  return false;
};
var getObjectPropertyByPath = function getObjectPropertyByPath(propertyPath, object, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = undefined;
  }
  var segments = propertyPath.split(".");
  var length = segments.length;
  var property = object;
  if (typeof property !== "object" || isEmpty(property)) {
    return defaultValue;
  }
  for (var ii = 0; ii < length; ii++) {
    if (typeof property[segments[ii]] === "undefined") {
      return defaultValue;
    }
    property = property[segments[ii]];
  }
  return property;
};
var isValidEmail = function isValidEmail(email, required, returnReason) {
  if (required === void 0) {
    required = true;
  }
  if (returnReason === void 0) {
    returnReason = false;
  }
  var valid = true;
  var errorText = "";
  if (isEmpty(email) || typeof email !== "string" || email.trim() === "") {
    if (required) {
      errorText = "Email Address is required";
      valid = false;
    }
  } else if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
    errorText = "Invalid Email Address";
    valid = false;
  }
  return returnReason ? errorText : valid;
};
var getPhoneDigits = function getPhoneDigits(str) {
  var newStr = str.replace(/[^0-9]/g, "");
  return str ? newStr : str;
};
var isValidPhoneNumber = function isValidPhoneNumber(phoneNumber, required, returnReason) {
  if (required === void 0) {
    required = true;
  }
  if (returnReason === void 0) {
    returnReason = false;
  }
  var valid = true;
  var errorText = "";
  var phoneDigits = getPhoneDigits(phoneNumber);
  var firstDigit = phoneDigits.substring(0, 1);
  var firstThreeDigits = phoneDigits.substring(0, 3);
  var emergencyDigits = firstThreeDigits.substring(1, 3);
  console.log("phone number::", firstDigit, phoneDigits.length, emergencyDigits);
  if (isEmpty(phoneNumber) || typeof phoneNumber !== "string" || phoneNumber.trim() === "") {
    if (required) {
      errorText = "Phone Number is required";
      valid = false;
    }
  } else if (firstThreeDigits === "011" || firstDigit === "1" || emergencyDigits === "11") {
    if (firstThreeDigits === "011" && phoneDigits.length < 13) {
      errorText = "Invalid Phone Number, must be 13 digits or more";
      valid = false;
    } else if (firstDigit === "1" && phoneDigits.length !== 11) {
      errorText = "Invalid Phone Number, must be 11 digits";
      valid = false;
    } else if (emergencyDigits === "11" && phoneDigits.length > 3 && phoneDigits.length !== 10 && firstThreeDigits !== "011") {
      errorText = "Invalid Phone Number";
      valid = false;
    }
  } else if (phoneDigits.length !== 10) {
    errorText = "Invalid Phone Number, must be 10 digits";
    valid = false;
  }
  return returnReason ? errorText : valid;
};
var isValidZipCode = function isValidZipCode(zipCode, required, returnReason) {
  if (required === void 0) {
    required = true;
  }
  if (returnReason === void 0) {
    returnReason = false;
  }
  var valid = true;
  var errorText = "";
  if (isEmpty(zipCode) || typeof zipCode !== "string" || zipCode.trim() === "") {
    if (required) {
      errorText = "Zip Code is required";
      valid = false;
    }
  } else if (zipCode.length !== 5 || !/^\d+$/.test(zipCode)) {
    errorText = "Zip Code, must be 5 digits";
    valid = false;
  }
  return returnReason ? errorText : valid;
};
var isValidAddress = function isValidAddress(address, required, returnReason, streetTypeRequired) {
  if (required === void 0) {
    required = true;
  }
  if (returnReason === void 0) {
    returnReason = false;
  }
  if (streetTypeRequired === void 0) {
    streetTypeRequired = false;
  }
  var valid = true;
  var errorText = "";
  var addressParts = address.trim().replace(/\s+/g, " ").split(" ");
  if (isEmpty(address) || typeof address !== "string" || address.trim() === "") {
    if (required) {
      errorText = "Address is required";
      valid = false;
    }
  } else if (addressParts.length < 2) {
    errorText = "Address requires Number and Street Name";
    valid = false;
  } else if (streetTypeRequired && addressParts.length < 3) {
    errorText = "Address requires Number, Street Name, and Type: ie: St, Dr, Ave, ...";
    valid = false;
  } else if (!parseInt(addressParts[0], 10)) {
    errorText = "Address must start with a number";
    valid = false;
  }
  return returnReason ? errorText : valid;
};
var ellipsis = function ellipsis(text, length) {
  if (text) {
    if (text.length < length) {
      return text;
    }
    return text.substr(0, length) + "\u2026";
  }
};
var isMobile = function isMobile() {
  if (navigator.userAgent.match(/Android|BlackBerry|iPhone|iPod|Opera Mini|IEMobile/i)) {
    return true;
  }
  return false;
};
var foramtMDN = function foramtMDN(str) {
  var match = str === null || str === void 0 ? void 0 : str.trim().match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "XXX" + '-' + "XXX" + '-' + match[3];
  }
  return str ? str.trim() : str;
};
var monthMap = {
  "0": "January",
  "1": "February",
  "2": "March",
  "3": "April",
  "4": "May",
  "5": "June",
  "6": "July",
  "7": "August",
  "8": "September",
  "9": "October",
  "10": "November",
  "11": "December"
};
var localeDateConverter = function localeDateConverter(date) {
  if (!date) {
    return null;
  }
  var localDate = new Date(date);
  return monthMap[localDate.getMonth().toString()] + " " + localDate.getDate() + ", " + localDate.getFullYear();
};
var localeTimeConverter = function localeTimeConverter(date) {
  if (!date) {
    return null;
  }
  var startTime = new Date(date.startTime).toLocaleTimeString();
  var endTime = new Date(date.endTime).toLocaleTimeString();
  var startTimeArr = startTime.split(" ");
  var startTimeSub = startTimeArr[0].split(":");
  var endTimeArr = endTime.split(" ");
  var endTimeSub = endTimeArr[0].split(":");
  var timeZone = new Date(date.startTime).toLocaleTimeString('en-us', {
    timeZoneName: 'short'
  }).split(' ')[2];
  return startTimeSub[0] + ":" + startTimeSub[1] + "-" + endTimeSub[0] + ":" + endTimeSub[1] + " " + endTimeArr[1] + " " + timeZone;
};
var getCookie$1 = function getCookie(name) {
  var start = document.cookie.indexOf(name + "=");
  if (start < 0) return null;
  start = start + name.length + 1;
  var end = document.cookie.indexOf(";", start);
  if (end < 0) end = document.cookie.length;
  while (document.cookie.charAt(start) == " ") {
    start++;
  }
  return decodeURIComponent(document.cookie.substring(start, end));
};
var invokeNative = function invokeNative(msg) {
  console.log('invokeNative called.');
  console.log(msg);
  if (window.webkit !== undefined) {
    if (window.webkit.messageHandlers.mfAppInterface !== undefined) {
      window.webkit.messageHandlers.mfAppInterface.postMessage(msg);
    }
  }
  if (window.mfAppInterface !== undefined) {
    window.mfAppInterface.postMessage(msg);
  }
};
var removeHtmlCharacters = function removeHtmlCharacters(text) {
  var regex = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/ig;
  return text === null || text === void 0 ? void 0 : text.replace(regex, "");
};
var nativeSetTitle = function nativeSetTitle(title) {
  console.log('headerTitle', title);
  var tMsg = {
    "actionType": "updateNavigation",
    "navigationBar": {
      "moleculeName": "navigationBar",
      "title": removeHtmlCharacters(title),
      "alwaysShowBackButton": true
    }
  };
  invokeNative(JSON.stringify(tMsg));
};
var hideMvaChatBot = function hideMvaChatBot() {
  var actionInfo = {
    actionType: 'updateChatFab',
    chatFab: {
      hideFabOverlay: true
    }
  };
  invokeNative(JSON.stringify(actionInfo));
};
var openMvaChatbot = function openMvaChatbot(searchTerm, intentName) {
  if (searchTerm === void 0) {
    searchTerm = "";
  }
  if (intentName === void 0) {
    intentName = "";
  }
  var searchKey = isEmpty(searchTerm) ? "live agent" : searchTerm;
  var selectedIntent = !isEmpty(intentName) && intentName !== "undefined" ? intentName : "";
  if (isEmpty(intentName)) {
    var _sessionUtility$getTr = sessionUtility.getTroubleShootingDetails(),
      _sessionUtility$getTr2 = _sessionUtility$getTr.intent,
      intent = _sessionUtility$getTr2 === void 0 ? '' : _sessionUtility$getTr2;
    if (!isEmpty(intent) && intent !== "undefined") {
      selectedIntent = intent;
    } else {
      if (!isEmpty(window.vzdl) && !isEmpty(window.vzdl.support) && !isEmpty(window.vzdl.support.tsaIssueName)) {
        selectedIntent = window.vzdl.support.tsaIssueName;
      } else {
        selectedIntent = "Troubleshooting";
      }
    }
  }
  var actionInfo = {
    "actionType": "openPanel",
    "extraParameters": {
      "extraSearchTextParameters": "1",
      "getSupportConfig": "yes",
      "pageType": "networktroubleshooting",
      "navigationTopPageType": "networktroubleshooting",
      "channelName": "MVA",
      "supportIntent": selectedIntent
    },
    "panel": "support"
  };
  if (searchTerm.includes("tech coach")) {
    actionInfo['extraParameters']['searchTerm'] = searchKey;
  }
  invokeNative(JSON.stringify(actionInfo));
};
var removeTextFromString = function removeTextFromString(str, textToRemove) {
  if (typeof str !== 'string' || typeof textToRemove !== 'string') {
    return str;
  }
  var regex = new RegExp(textToRemove, 'g');
  var result = str.replace(regex, '');
  return result;
};
var resizeImage = function resizeImage(imgurl) {
  var _window$tsFeatureFlag;
  if (!imgurl) return imgurl;
  if ((_window$tsFeatureFlag = window.tsFeatureFlags) !== null && _window$tsFeatureFlag !== void 0 && _window$tsFeatureFlag.enableDeviceImageResizeFFlag) {
    if (imgurl.includes("//ss7.vzw.com") && !imgurl.includes("webp-alpha")) {
      imgurl += imgurl.includes("?") ? "&fmt=webp-alpha" : "?fmt=webp-alpha";
    }
    if (imgurl.includes("$device%2Dlg$")) {
      imgurl = imgurl.replace("$device%2Dlg$/", "");
      imgurl = imgurl.replace("$device%2Dlg$", "");
    }
  }
  return imgurl;
};

var getStepByName = function getStepByName(name, steps) {
  var step = {};
  steps.forEach(function (tmpStep) {
    if (tmpStep.templateType === name) {
      step = tmpStep;
    }
  });
  return step;
};
var focusScreenTitle = function focusScreenTitle() {
  var screenTitle = document.getElementById('screenTitle');
  if (screenTitle) {
    screenTitle.setAttribute('tabindex', '-1');
    screenTitle.focus();
    screenTitle.addEventListener('blur', function () {
      screenTitle.removeAttribute('tabindex');
    });
  }
};
var setVzdlTargetobj = function setVzdlTargetobj(engagementObj) {
  var _window, _window$vzdl;
  var targetObj = ((_window = window) === null || _window === void 0 ? void 0 : (_window$vzdl = _window.vzdl) === null || _window$vzdl === void 0 ? void 0 : _window$vzdl.target) || {};
  if (window.isMVODigital) {
    targetObj = {
      engagement: _extends({}, engagementObj),
      sandBox: ""
    };
  } else {
    targetObj = {
      engagement: _extends({}, engagementObj)
    };
  }
  return targetObj;
};
var getListOfDevices = function getListOfDevices(json) {
  try {
    var devices = json.pageContent.steps[0].devices;
    var deviceObj = devices.map(function (item) {
      var obj = {};
      item.device.forEach(function (info) {
        obj[info.key] = info.value;
      });
      return obj;
    });
    return deviceObj;
  } catch (e) {
    return [];
  }
};
var getListOfDevicesStepObj = function getListOfDevicesStepObj(json) {
  try {
    var devices = json.devices;
    var deviceObj = devices.map(function (item) {
      var obj = {};
      item.device.forEach(function (info) {
        obj[info.key] = info.value;
      });
      return obj;
    });
    return deviceObj;
  } catch (e) {
    return [];
  }
};
var getTemplateId = function getTemplateId(steps) {
  if (steps === void 0) {
    steps = [];
  }
  var perContentData = [];
  steps.forEach(function (tmpStep) {
    tmpStep.templateId && perContentData.push(tmpStep.templateId);
    return null;
  });
  return perContentData.toString();
};
var getTemplateType = function getTemplateType(data, fromResponse) {
  if (fromResponse === void 0) {
    fromResponse = false;
  }
  var templateType = '';
  var steps = false;
  if (fromResponse) {
    steps = getObjectPropertyByPath('response.data.body.ddata.output.pageContent.steps', data, false);
  } else {
    steps = getObjectPropertyByPath('ddata.output.pageContent.steps', data, false);
  }
  if (!steps) {
    return templateType;
  }
  if (Array.isArray(steps) && !steps.length) {
    return templateType;
  }
  templateType = steps[0].templateType || '';
  if (steps[0].templateId === "BATTERYCHARGINGISSUES") {
    templateType = "reviewtechbulletin";
  }
  if (steps[0].templateId === "DEVICE_FORUMS") {
    templateType = "deviceforums";
  }
  if (steps[0].templateId === "searchsupportcontent") {
    templateType = "searchsupportcontent";
  }
  return templateType;
};
var getParameterByName = function getParameterByName(name) {
  var url = window.location.href;
  var urlname = name.replace(/[[\]]/g, '\\$&');
  var regex = new RegExp("[?&]" + urlname + "(=([^&#]*)|&|#|$)");
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  var result = '';
  if (urlname === 'navState') {
    result = results[2].replace('/', '');
  } else {
    result = results[2].replace(/\+/g, ' ');
  }
  return decodeURIComponent(result);
};
var chkAddOfferEligibility = function chkAddOfferEligibility(mtn, accountNumber, nwPayloadOptions, getEnvData) {
  if (mtn === void 0) {
    mtn = '';
  }
  if (nwPayloadOptions === void 0) {
    nwPayloadOptions = {};
  }
  try {
    var _window$accountNumber, _nwPayloadOptions$pro, _nwPayloadOptions, _nwPayloadOptions$acc, _nwPayloadOptions2, _nwPayloadOptions$acc2, _nwPayloadOptions3, _nwPayloadOptions$pro2, _nwPayloadOptions4, _tsaEnvConfig, _tsaEnvConfig$apiUrls;
    var offerAddEligibilityPayload = {
      mtn: mtn,
      accountNumber: (_window$accountNumber = window.accountNumber) != null ? _window$accountNumber : '',
      productId: (_nwPayloadOptions$pro = (_nwPayloadOptions = nwPayloadOptions) === null || _nwPayloadOptions === void 0 ? void 0 : _nwPayloadOptions.productId) != null ? _nwPayloadOptions$pro : '',
      accessoryCategory: (_nwPayloadOptions$acc = (_nwPayloadOptions2 = nwPayloadOptions) === null || _nwPayloadOptions2 === void 0 ? void 0 : _nwPayloadOptions2.accessoryCategory) != null ? _nwPayloadOptions$acc : '',
      accessoryId: (_nwPayloadOptions$acc2 = (_nwPayloadOptions3 = nwPayloadOptions) === null || _nwPayloadOptions3 === void 0 ? void 0 : _nwPayloadOptions3.accessoryId) != null ? _nwPayloadOptions$acc2 : '',
      processAction: (_nwPayloadOptions$pro2 = (_nwPayloadOptions4 = nwPayloadOptions) === null || _nwPayloadOptions4 === void 0 ? void 0 : _nwPayloadOptions4.processAction) != null ? _nwPayloadOptions$pro2 : ''
    };
    var getApiUrl = (_tsaEnvConfig = tsaEnvConfig$1(getEnvData)) === null || _tsaEnvConfig === void 0 ? void 0 : (_tsaEnvConfig$apiUrls = _tsaEnvConfig.apiUrls) === null || _tsaEnvConfig$apiUrls === void 0 ? void 0 : _tsaEnvConfig$apiUrls.getAddOfferEligibilityURL;
    var envData = {
      externalTarget: getApiUrl,
      mvoenv: process.env.NODE_ENV
    };
    console.log("offerAddEligibilityPayload==", offerAddEligibilityPayload);
    return Promise.resolve(getNrbReq(offerAddEligibilityPayload, envData)).then(function (offerAddedEligibilityData) {
      console.log(offerAddedEligibilityData === null || offerAddedEligibilityData === void 0 ? void 0 : offerAddedEligibilityData.success, "offerAddedEligibilityData==", offerAddedEligibilityData);
      if (offerAddedEligibilityData !== null && offerAddedEligibilityData !== void 0 && offerAddedEligibilityData.success) {
        var _offerAddedEligibilit = offerAddedEligibilityData.response,
          _offerAddedEligibilit2 = _offerAddedEligibilit === void 0 ? {} : _offerAddedEligibilit,
          _offerAddedEligibilit3 = _offerAddedEligibilit2.data,
          _offerAddedEligibilit4 = _offerAddedEligibilit3 === void 0 ? {} : _offerAddedEligibilit3,
          _offerAddedEligibilit5 = _offerAddedEligibilit4.body,
          body = _offerAddedEligibilit5 === void 0 ? {} : _offerAddedEligibilit5;
        return body.offerAdded ? "yes" : body !== null && body !== void 0 && body.neinCart ? "isNEinCart" : "no";
      } else {
        return "error";
      }
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var getPlatform = function getPlatform() {
  if (navigator.userAgent.match(/android/i)) {
    return "ANDROID";
  } else if (navigator.userAgent.match(/iPad|iPhone|iPod/)) {
    return "IOS";
  } else {
    return "";
  }
};
var chkNBXEligibility = function chkNBXEligibility(getEnvData) {
  try {
    var _tsaEnvConfig2, _tsaEnvConfig2$apiUrl;
    var nbxPayload = {
      platform: getPlatform()
    };
    var getApiUrl = (_tsaEnvConfig2 = tsaEnvConfig$1(getEnvData)) === null || _tsaEnvConfig2 === void 0 ? void 0 : (_tsaEnvConfig2$apiUrl = _tsaEnvConfig2.apiUrls) === null || _tsaEnvConfig2$apiUrl === void 0 ? void 0 : _tsaEnvConfig2$apiUrl.getNBXOfferEligibiltyURL;
    var envData = {
      externalTarget: getApiUrl,
      mvoenv: process.env.NODE_ENV
    };
    return Promise.resolve(getNBXEligibileReq(nbxPayload, envData)).then(function (chkNBXEligibility) {
      if (chkNBXEligibility !== null && chkNBXEligibility !== void 0 && chkNBXEligibility.success) {
        var _chkNBXEligibility$re = chkNBXEligibility.response,
          _chkNBXEligibility$re2 = _chkNBXEligibility$re === void 0 ? {} : _chkNBXEligibility$re,
          _chkNBXEligibility$re3 = _chkNBXEligibility$re2.data,
          _chkNBXEligibility$re4 = _chkNBXEligibility$re3 === void 0 ? {} : _chkNBXEligibility$re3,
          _chkNBXEligibility$re5 = _chkNBXEligibility$re4.body,
          body = _chkNBXEligibility$re5 === void 0 ? {} : _chkNBXEligibility$re5;
        return body;
      } else {
        return 'error';
      }
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var chkOfferEligibility = function chkOfferEligibility(mtn, accountNumber, accessoryId, getEnvData) {
  if (mtn === void 0) {
    mtn = '';
  }
  if (accessoryId === void 0) {
    accessoryId = '';
  }
  try {
    var _window$accountNumber2, _tsaEnvConfig3, _tsaEnvConfig3$apiUrl;
    var offerEligibilityPayload = {
      mtn: mtn,
      accountNumber: (_window$accountNumber2 = window.accountNumber) != null ? _window$accountNumber2 : '',
      accessoryId: accessoryId
    };
    var getApiUrl = (_tsaEnvConfig3 = tsaEnvConfig$1(getEnvData)) === null || _tsaEnvConfig3 === void 0 ? void 0 : (_tsaEnvConfig3$apiUrl = _tsaEnvConfig3.apiUrls) === null || _tsaEnvConfig3$apiUrl === void 0 ? void 0 : _tsaEnvConfig3$apiUrl.getOfferEligibilityURL;
    var envData = {
      externalTarget: getApiUrl,
      mvoenv: process.env.NODE_ENV
    };
    console.log("offerEligibilityPayload==", offerEligibilityPayload);
    return Promise.resolve(getNrbReq(offerEligibilityPayload, envData)).then(function (offerEligibilityData) {
      console.log(offerEligibilityData === null || offerEligibilityData === void 0 ? void 0 : offerEligibilityData.success, "offerEligibilityData==", offerEligibilityData);
      if (offerEligibilityData !== null && offerEligibilityData !== void 0 && offerEligibilityData.success) {
        var _offerEligibilityData = offerEligibilityData.response,
          _offerEligibilityData2 = _offerEligibilityData === void 0 ? {} : _offerEligibilityData,
          _offerEligibilityData3 = _offerEligibilityData2.data,
          _offerEligibilityData4 = _offerEligibilityData3 === void 0 ? {} : _offerEligibilityData3,
          _offerEligibilityData5 = _offerEligibilityData4.body,
          body = _offerEligibilityData5 === void 0 ? {} : _offerEligibilityData5;
        return body.offerEligible ? "yes" : "no";
      } else {
        return "error";
      }
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var chkNeAddOffer = function chkNeAddOffer(offerData) {
  if (offerData === void 0) {
    offerData = {};
  }
  try {
    var _temp4 = function _temp4() {
      var _troubleshootingDetai, _troubleshootingDetai2, _window$accountNumber3;
      var mdn = !isEmpty((_troubleshootingDetai = troubleshootingDetails) === null || _troubleshootingDetai === void 0 ? void 0 : _troubleshootingDetai.mtn) ? (_troubleshootingDetai2 = troubleshootingDetails) === null || _troubleshootingDetai2 === void 0 ? void 0 : _troubleshootingDetai2.mtn : !isEmpty(caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.mtn) ? caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.mtn : paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.mdn;
      console.log(troubleshootingDetails, "mdn=====", mdn);
      console.log(caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.mtn, "++++++++++++++", paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.mdn);
      console.log("paramPageId^^^^^^^^^^foundMtn", mdn, configDetails);
      var getEnvData = {
        externalTarget: window.externalTarget,
        mvoenv: mvoenv
      };
      console.log("getEnvData-1-------", getEnvData);
      actionButton.nrbOeNeChkEligibilityLoader = "yes";
      handleNrbChkEligibilityLoader(actionButton);
      return Promise.resolve(chkOfferEligibility(mdn, (_window$accountNumber3 = window.accountNumber) != null ? _window$accountNumber3 : '', networkExtenderOptions === null || networkExtenderOptions === void 0 ? void 0 : networkExtenderOptions.accessoryId, getEnvData)).then(function (offerEligibility) {
        function _temp2() {
          actionButton.nrbOeNeChkEligibilityLoader = "no";
          handleNrbChkEligibilityLoader(actionButton);
        }
        console.log("offerEligibility----", offerEligibility);
        var _temp = function () {
          if (offerEligibility === "yes") {
            var _window$accountNumber4;
            console.log("getEnvData--2------", getEnvData);
            return Promise.resolve(chkAddOfferEligibility(mdn, (_window$accountNumber4 = window.accountNumber) != null ? _window$accountNumber4 : '', networkExtenderOptions, getEnvData)).then(function (getAddOfferData) {
              actionButton.nrbOeNeChkEligibilityLoader = "no";
              handleNrbChkEligibilityLoader(actionButton);
              console.log("getAddOfferData===", getAddOfferData);
              if (getAddOfferData === "yes") {
                window.open(url, '_self');
              } else {
                console.log("getAddOfferData=err==", getAddOfferData);
                actionButton.nrbOeNethrowError = true;
              }
            });
          } else if (offerEligibility === "no") {
            actionButton.nrbNeNotEligibleforOffer = true;
            console.log("offerEligibility----", offerEligibility);
          } else {
            actionButton.nrbOeNethrowError = true;
          }
        }();
        return _temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp);
      });
    };
    console.log("!!!!!!!!!!!!!!!!!!!!!");
    var _offerData = offerData,
      handleNrbChkEligibilityLoader = _offerData.handleNrbChkEligibilityLoader,
      _offerData$actionButt = _offerData.actionButton,
      actionButton = _offerData$actionButt === void 0 ? {} : _offerData$actionButt,
      _offerData$configDeta = _offerData.configDetails,
      configDetails = _offerData$configDeta === void 0 ? {} : _offerData$configDeta;
    var _actionButton$url = actionButton.url,
      url = _actionButton$url === void 0 ? '' : _actionButton$url;
    var _configDetails$params = configDetails.paramsDetails,
      paramsDetails = _configDetails$params === void 0 ? {} : _configDetails$params,
      _configDetails$config = configDetails.config,
      config = _configDetails$config === void 0 ? {} : _configDetails$config;
    var _paramsDetails$mvoenv = paramsDetails.mvoenv,
      mvoenv = _paramsDetails$mvoenv === void 0 ? '' : _paramsDetails$mvoenv;
    var _config$networkExtend = config.networkExtenderOptions,
      networkExtenderOptions = _config$networkExtend === void 0 ? {} : _config$networkExtend,
      _config$caseDetails = config.caseDetails,
      caseDetails = _config$caseDetails === void 0 ? {} : _config$caseDetails;
    var troubleshootingDetails;
    var _temp3 = function () {
      if (sessionStorage.getItem('troubleshootingDetails')) {
        return Promise.resolve(JSON.parse(sessionStorage.getItem('troubleshootingDetails'))).then(function (_JSON$parse) {
          troubleshootingDetails = _JSON$parse;
        });
      }
    }();
    return Promise.resolve(_temp3 && _temp3.then ? _temp3.then(_temp4) : _temp4(_temp3));
  } catch (e) {
    return Promise.reject(e);
  }
};
var redirectToNrbFlow = function redirectToNrbFlow(configDetails) {
  try {
    var _temp6 = function _temp6() {
      var _troubleshootingDetai3, _troubleshootingDetai4;
      var mdn = !isEmpty((_troubleshootingDetai3 = troubleshootingDetails) === null || _troubleshootingDetai3 === void 0 ? void 0 : _troubleshootingDetai3.mtn) ? (_troubleshootingDetai4 = troubleshootingDetails) === null || _troubleshootingDetai4 === void 0 ? void 0 : _troubleshootingDetai4.mtn : !isEmpty(caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.mtn) ? caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.mtn : paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.mdn;
      var foundMtn = additionalMtns.filter(function (mtn) {
        return mtn.mtn == mdn;
      });
      if ((foundMtn === null || foundMtn === void 0 ? void 0 : foundMtn.length) > 0) {
        var mtnHash = foundMtn[0].mtnHash;
        window.open("/digital/nsa/secure/ui/troubleshooting/nrbflow/" + mtnHash + "/uad", '_self');
      }
    };
    var _ref = configDetails || {},
      _ref$paramsDetails = _ref.paramsDetails,
      paramsDetails = _ref$paramsDetails === void 0 ? {} : _ref$paramsDetails,
      _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config,
      _ref$additionalMtns = _ref.additionalMtns,
      additionalMtns = _ref$additionalMtns === void 0 ? [] : _ref$additionalMtns;
    var _config$caseDetails2 = config.caseDetails,
      caseDetails = _config$caseDetails2 === void 0 ? {} : _config$caseDetails2;
    var troubleshootingDetails;
    var _temp5 = function () {
      if (sessionStorage.getItem('troubleshootingDetails')) {
        return Promise.resolve(JSON.parse(sessionStorage.getItem('troubleshootingDetails'))).then(function (_JSON$parse2) {
          troubleshootingDetails = _JSON$parse2;
        });
      }
    }();
    return Promise.resolve(_temp5 && _temp5.then ? _temp5.then(_temp6) : _temp6(_temp5));
  } catch (e) {
    return Promise.reject(e);
  }
};
var session = function session(name) {
  return {
    get: function get() {
      try {
        var data = sessionStorage.getItem(name);
        return JSON.parse(data);
      } catch (e) {
        console.error('Error getting session from sessionStorage', e);
        return null;
      }
    },
    set: function set(data) {
      try {
        sessionStorage.setItem(name, JSON.stringify(data));
      } catch (e) {
        console.error('Error setting session to sessionStorage', e);
      }
    },
    reset: function reset() {
      try {
        sessionStorage.removeItem(name);
      } catch (e) {
        console.error('Error removing session from sessionStorage', e);
      }
    }
  };
};

var Z2SESSION = "heDAX4SqOCwSo1khzfPYeb5TGenjar8GT6ifPlWWei2Yxbj8G+GJBAWFhCjDel1BsxLghklwl9hZq5mTSxiIo/8JU5MZnBWS0S++qBz2RMWwIu++ThY6U0JrkI7bK7GdcHoKmFJPrrT23Bvq7cRkhr2bxPigTbigkwebshf6eozDZ2m65DVIusJGZ9mrUVJS9bfqiwrx34JH0DpUbOVf2WXlyuLf/rqu6w6us/X7swnfcn87t+lWLIviW8Se8owRbK8fPoX3LpyFbhwc3VOHWpz1F4G19pW2Tm+yVynoEDyoZ7NDGIO09GW4Jebdw/ZJkIHxZzlnXDGri2kQbWL9sOG1ZUVKIutsyS8YK98ntO5D0lDKO7SPY7XfGecrbPLIjHfnAWri86okFGBN9ZtsVmikcuQ2ryPFTtIK67kWdpFeUGdh5v9EOXOdDEC6UZNmNiFhqjzH6VkBy0TxvCEb5TdfDy2QBqqoHLqlqgqCtYeTVLg6S2HCLZoIw1zMEfsFqu536PENIN3/qqm8WDPUo7aJbAgWyU1dbg7phqvfaAHgBh1Dkz3ayfnJCLL2Pxy29/tFbyBCVEOndOe+xlXdNNkSsLDJg6leGgXNYxA8tO5Ol947AVJ5etol77xS1xH/5BN3bQj6VAUEAiZCIVdrao0f7cxJvIeAIn0HqBTxZHojpIJOg99B7kayhgtMn8rlu4CxWUlFprW0hCprgvsp4aSDR/CJ6QPChdA80N8M88UrUvM38mfrRQlSpyK6cfyTv+fBGn7hnOoK1r4Kxu8UqcyGCZs3MIbopHTk+qm0pf7Eu2PXmb5P2cULTJvU33HHdjRCXuF4fLgpimRaCvkg8RU4XE139+B8QSCWefV7JUD8LWQlyERtvQCO8+hlMFhkcXWQPIdLKdrUYJkW/+v912Mb1P9x14lSEpX3HsTbCMnTiJ32+egTFYF5KRmOKNz+hra1a8kwmkcZv5/KvU/4ROTYxyZbe/vlUUyyaGmsozRfttzoyHiSjU0ifBtVpw+uG19V+EQQSiJ5lFU4FP6jdMKgwZSxdlsHKAygEUtKwHrjdd/TT+iPZWyPgc11viavH8UjEQUYubZIU36XufUDpx2fEmplgMLrVhN3H2c/6WulQdHDCDYCtBG0aSZ6RfNCiYNR5l9YvLEdp93pEFHvqpksJDpZlmYCr4mNXiIkPQlZmBEOUW7or5+gVCIGS9qMNkPaTkx/md3QjCeyxAR1DIU0e8YY8ZYvRZquQnQw6d4TR1F0qCSsXggQDO7wjOp+TFQOm4KvTijgIxebjdU5B6jOuMoPRTRh";
var ASSISTED_IG_SESSION = "1feeb8fd-5d9a-4488-98e0-e3ff8edc7daf";
var JWT = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJ2endSb2xlcyI6ImFjY291bnRNYW5hZ2VyIiwiZ2l2ZW5OYW1lIjoiTGVib3dza2kiLCJpc3MiOiJodHRwczpcL1wvc3NvLW5wLmViaXoudmVyaXpvbi5jb20iLCJtb2JpbGUiOiI4NjQ0NzM3MzE5IiwidnppZCI6IiIsImZlZGVyYXRpb25LZXkiOiIiLCJhbUlEIjoiNDVjZGU0MjQtZWY5Mi00YzM3LTg3NzQtMjQ4NWE0YjA5NDI5IiwiZWNwZElEIjoiIiwiYW1GZWRlcmF0ZWQiOiIiLCJhY2NvdW50SG9sZGVyRXhpc3RzIjoiZmFsc2UiLCJhdWQiOiJNQ0YiLCJ1aWQiOiI4NjQ0NzM3MzE5cmVnVG9vbCIsImFtQ3NyUm9sZSI6IiIsInVuaXZlcnNhbElkIjoiIiwiZ3VpZCI6IjU4M2NlNWUzLWI1NmEtNDEzZS1iMjgyLWE1YjMyNGRiOTEzMSIsImV4cCI6MTY3NTkwNDA0OCwidnp3QWNjb3VudE51bWJlciI6IjAzMTMzNjY0NDIwMDAwMSIsImFjY291bnRIb2xkZXJNb2JpbGVOdW1iZXIiOiIiLCJpYXQiOjE2NzU4OTY4NDgsImxvYiI6InZ6dyIsImlzVW5pdmVyc2FsUHJvZmlsZSI6IiJ9.S_RzpZWD0kzQtj-wKz0bYaQ4aBz1zIZzxBQLIEXziB7spUOixugX5s2cLPzznqfK6EqUEJyf5ngRnIKJgNqdFo27fOBiBBo_E_WXvKnXYcQC0nWroG-lvJvMNf1yi03JMJp7WrZ-2woeKjXx--SX5jURwTVlriSZGhdw_D6FRplMrObisWbFtbr8A0nDpV_D51KWzCTLM2kL5XuweA1jbuo5Z16dV8DL6_jD0jiFfq-11X0v2TyTyLCNKZnKiyKOln7bsljHs1cg_x1ld5mJ5KTA-Clv3LjUicn0OoaMjSJfSygvaVT2y0ZHVYohaeIUCj1Ie_6IVvuM9ia4AP8-Hg";
var INTENT = "Battery is slow to charge, will not charge, or no charging indicator";
var INTENT_ID = "IN0119";

var runMode = sessionUtility.getRunMode();
var mvoConfig$2 = sessionUtility.getMvoConfig();
var callMethod = "post";
callMethod = runMode == "development" ? window.callQAAPI ? "post" : "get" : "post";
var logHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
  channelId: mvoConfig$2 === null || mvoConfig$2 === void 0 ? void 0 : mvoConfig$2._dg_channelId
};
var logApiInfoSuccess = function logApiInfoSuccess(resp, troubleShootingData, url, pagename, envData) {
  var apiResponseTime = Date.now();
  var methodName = pagename;
  var pageName = pagename;
  var flowName = pagename;
  var responsecode = resp && resp.data && resp.data.responseInfo && resp.data.responseInfo.responseCode;
  var _dg_eReqId = resp && resp.data && resp.data.responseInfo && resp.data.responseInfo.correlationId;
  var apiResponse = {
    responseInfo: troubleShootingData ? JSON.stringify(troubleShootingData) : "",
    eReqId: _dg_eReqId,
    amID: "1234"
  };
  logApiInfo(pageName, JSON.stringify(logHeaders), common.stringifyJSON(apiResponse), apiResponseTime, flowName, methodName, url, JSON.stringify(logHeaders), resp && resp.data && resp.data.body && resp.data.body.ddata, responsecode === "000" || responsecode === "00" ? "success" : "failure", {}, envData);
};
var logApiInfoError = function logApiInfoError(pagename, error) {
  var apiResponseTime = Date.now();
  var methodName = pagename;
  var pageName = pagename;
  var flowName = pagename;
  var statuscode = "";
  var response = "";
  try {
    if (error && (error.request || error.response)) {
      statuscode = error.request && error.request.status !== undefined && error.request.status != null ? error.request.status : error.response && error.response.status ? error.response.status : "";
      response = error.request && error.request.response ? error.request.response : error.response && error.response.request && error.response.request.response ? error.response.request.response : "";
    }
  } catch (e) {}
  logApiInfo(pageName, JSON.stringify(logHeaders), common.getErrorMessage(error), apiResponseTime, flowName, methodName, error && error.config ? error.config.url : "", JSON.stringify(logHeaders), error && error.status || statuscode, "failure");
};
var callAxios$1 = function callAxios(url, method, data, headers) {
  try {
    var response = false;
    return Promise.resolve(sessionUtility.getMvoConfig()).then(function (mvoConfig) {
      var _mvoConfig$_dg_channe;
      var channelId = (_mvoConfig$_dg_channe = mvoConfig === null || mvoConfig === void 0 ? void 0 : mvoConfig._dg_channelId) != null ? _mvoConfig$_dg_channe : "VZW-ACSS";
      if (window.isMVODigital) {
        channelId = window._dg_channelId;
      }
      var axiosConfig = {
        timeout: 300000,
        responseType: "json",
        withCredentials: true,
        headers: _extends({}, headers, {
          Accept: "application/json",
          "Content-Type": "application/json",
          channelId: channelId
        })
      };
      console.log("axiosConfigs", axiosConfig, url);
      var payload = data ? JSON.stringify(data) : '';
      var apiMethod = (method === null || method === void 0 ? void 0 : method.toLowerCase()) === "post" ? postHttpClientRequest(url, payload, axiosConfig) : getHttpClientRequest(url, axiosConfig);
      return Promise.resolve(apiMethod.then(function (resp, headers) {
        response = {
          success: true,
          response: resp,
          headers: headers
        };
      })["catch"](function (err, headers) {
        console.log("headers", headers);
        var loggerEl = document.getElementById("pageDetails");
        var pageDetails = "";
        if (loggerEl) {
          pageDetails = loggerEl.getAttribute("value");
        }
        if (window && window.vzLogger && window.vzLogger.apiError) {
          window.vzLogger.apiError({
            error: err,
            loggerObject: pageDetails ? JSON.parse(pageDetails) : {}
          });
        }
        logNewrelicNoticeError(err, "APIError");
        response = {
          success: false,
          error: err,
          headers: headers
        };
      })).then(function () {
        return response;
      });
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var getAnalyticsData = function getAnalyticsData(data, envData) {
  try {
    var analyticsData = {};
    console.log("analyticsData params", data);
    var _temp = _catch(function () {
      return Promise.resolve(callAxios$1(tsaEnvConfig$1(envData).apiUrls.analyticsUrl, callMethod, data)).then(function (resp) {
        analyticsData = getObjectPropertyByPath("response.data.body", resp, {});
      });
    }, function (error) {
      console.error(error);
    });
    return Promise.resolve(_temp && _temp.then ? _temp.then(function () {
      return analyticsData;
    }) : analyticsData);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getTroubleShootingInfo = function getTroubleShootingInfo(envData) {
  try {
    var troubleShootingInfo = {};
    var _temp4 = _catch(function () {
      return Promise.resolve(callAxios$1(tsaEnvConfig$1(envData).apiUrls.troubleShootingUrl, "get")).then(function (resp) {
        function _temp3() {
          troubleShootingInfo = getObjectPropertyByPath("response.data.body", resp, {});
        }
        var templateType = getTemplateType(resp, true);
        var _temp2 = function () {
          if (!templateType) {
            return Promise.resolve(callAxios$1(envConfig.apiUrls.defaultTemplateUrl, "get")).then(function (_callAxios) {
              resp = _callAxios;
            });
          }
        }();
        return _temp2 && _temp2.then ? _temp2.then(_temp3) : _temp3(_temp2);
      });
    }, function () {
      console.log("Get Outage Info call failed");
    });
    return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(function () {
      return troubleShootingInfo;
    }) : troubleShootingInfo);
  } catch (e) {
    return Promise.reject(e);
  }
};
var createSupportRequest = function createSupportRequest(payload, envData) {
  try {
    var ticketDetails = {};
    var _temp5 = _catch(function () {
      return Promise.resolve(callAxios$1(tsaEnvConfig$1(envData).apiUrls.supportTicketUrl, "post", payload)).then(function (resp) {
        ticketDetails = getObjectPropertyByPath("response.data.body", resp, {});
      });
    }, function () {
      console.log("Ticket creation call failed");
    });
    return Promise.resolve(_temp5 && _temp5.then ? _temp5.then(function () {
      return ticketDetails;
    }) : ticketDetails);
  } catch (e) {
    return Promise.reject(e);
  }
};
var initSupportRequest = function initSupportRequest(payload, envData) {
  try {
    var initCaseResponse = {};
    var _temp6 = _catch(function () {
      return Promise.resolve(callAxios$1(tsaEnvConfig$1(envData).apiUrls.initCaseUrl, "post", payload)).then(function (resp) {
        initCaseResponse = getObjectPropertyByPath("response.data.body", resp, {});
      });
    }, function () {
      console.log("Ticket creation call failed");
    });
    return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function () {
      return initCaseResponse;
    }) : initCaseResponse);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getDynamicCtaResponse = function getDynamicCtaResponse(payload, envData) {
  try {
    var response = {};
    var _temp7 = _catch(function () {
      var callMethod = (envData === null || envData === void 0 ? void 0 : envData.mvoenv) == "development" ? "get" : "post";
      return Promise.resolve(callAxios$1(tsaEnvConfig$1(envData).apiUrls.dynamicCtaURI, callMethod, payload)).then(function (getResp) {
        response = getObjectPropertyByPath("response.data.body", getResp, {});
      });
    }, function () {
      console.log("fetching dynamic cta failed");
    });
    return Promise.resolve(_temp7 && _temp7.then ? _temp7.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var submitSupportRequest = function submitSupportRequest(payload) {
  try {
    var submitResponse = {};
    var _temp8 = _catch(function () {
      return Promise.resolve(callAxios$1(envConfig.apiUrls.submitCaseUrl, "post", payload)).then(function (resp) {
        submitResponse = getObjectPropertyByPath("response.data.body", resp, {});
      });
    }, function () {
      console.log("Ticket creation call failed");
    });
    return Promise.resolve(_temp8 && _temp8.then ? _temp8.then(function () {
      return submitResponse;
    }) : submitResponse);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getCallDetails = function getCallDetails(callDetailsPayload) {
  try {
    var callResponse = {};
    var _temp9 = _catch(function () {
      return Promise.resolve(callAxios$1(envConfig.apiUrls.timeSlotURI, "post", callDetailsPayload)).then(function (resp) {
        callResponse = getObjectPropertyByPath("response.data.body", resp, {});
      });
    }, function () {
      console.log("Ticket creation call failed");
    });
    return Promise.resolve(_temp9 && _temp9.then ? _temp9.then(function () {
      return callResponse;
    }) : callResponse);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getAccountIssueInfo = function getAccountIssueInfo(envData) {
  try {
    var accountIssueInfo = {};
    var _temp10 = _catch(function () {
      return Promise.resolve(callAxios$1(tsaEnvConfig$1(envData).apiUrls.accountIssueInfoUrl, "get")).then(function (resp) {
        function _temp1() {
          accountIssueInfo = getObjectPropertyByPath("response.data.body", resp, {});
        }
        var templateType = getTemplateType(resp, true);
        var _temp0 = function () {
          if (!templateType) {
            return Promise.resolve(callAxios$1(envConfig.apiUrls.defaultTemplateUrl, "get")).then(function (_callAxios2) {
              resp = _callAxios2;
            });
          }
        }();
        return _temp0 && _temp0.then ? _temp0.then(_temp1) : _temp1(_temp0);
      });
    }, function () {
      console.log("Account Issue Info call failed");
    });
    return Promise.resolve(_temp10 && _temp10.then ? _temp10.then(function () {
      return accountIssueInfo;
    }) : accountIssueInfo);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getLandingInfo = function getLandingInfo() {
  try {
    var landingInfo = {};
    return Promise.resolve(sessionUtility.getTroubleShootingJson()).then(function (mvoTroubleShootingJson) {
      var _ref = mvoTroubleShootingJson || {},
        _ref$ddata = _ref.ddata,
        ddata = _ref$ddata === void 0 ? {} : _ref$ddata;
      landingInfo = ddata;
      return landingInfo;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var getContactsInfo = function getContactsInfo(envData) {
  try {
    var contactsInfo = {};
    var _temp13 = _catch(function () {
      return Promise.resolve(callAxios$1(tsaEnvConfig$1(envData).apiUrls.contactsUrl, "get")).then(function (resp) {
        function _temp12() {
          contactsInfo = getObjectPropertyByPath("response.data.body", resp, {});
        }
        var templateType = getTemplateType(resp, true);
        var _temp11 = function () {
          if (!templateType) {
            return Promise.resolve(callAxios$1(envConfig.apiUrls.defaultTemplateUrl, "get")).then(function (_callAxios3) {
              resp = _callAxios3;
            });
          }
        }();
        return _temp11 && _temp11.then ? _temp11.then(_temp12) : _temp12(_temp11);
      });
    }, function () {
      console.log("Contacts Info call failed");
    });
    return Promise.resolve(_temp13 && _temp13.then ? _temp13.then(function () {
      return contactsInfo;
    }) : contactsInfo);
  } catch (e) {
    return Promise.reject(e);
  }
};
var externalNavRedirect = function externalNavRedirect() {
  try {
    return Promise.resolve(sessionUtility.getCaseDetails()).then(function (mvoCaseDetails) {
      var postData = _extends({}, mvoCaseDetails);
      var navUrl = "";
      var _temp14 = _catch(function () {
        return Promise.resolve(callAxios$1(envConfig.apiUrls.externalNavLandingUrl, callMethod, postData)).then(function (resp) {
          navUrl = getObjectPropertyByPath("response.data.body.ddata.output", resp, {});
          console.log(resp + "ExternalApi Info call success");
        });
      }, function (error) {
        console.log(error + "ExternalApi Info call failed");
      });
      return _temp14 && _temp14.then ? _temp14.then(function () {
        return navUrl;
      }) : navUrl;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var getQuestionsInfo = function getQuestionsInfo(envData) {
  try {
    var questionsInfo = {};
    var _temp17 = _catch(function () {
      return Promise.resolve(callAxios$1(tsaEnvConfig$1(envData).apiUrls.questionsIssueInfoUrl, "get", {})).then(function (resp) {
        function _temp16() {
          questionsInfo = getObjectPropertyByPath("response.data.body", resp, {});
        }
        var templateType = getTemplateType(resp, true);
        var _temp15 = function () {
          if (!templateType) {
            return Promise.resolve(callAxios$1(envConfig.apiUrls.defaultTemplateUrl, "get")).then(function (_callAxios4) {
              resp = _callAxios4;
            });
          }
        }();
        return _temp15 && _temp15.then ? _temp15.then(_temp16) : _temp16(_temp15);
      });
    }, function () {
      console.log("Questions Info call failed");
    });
    return Promise.resolve(_temp17 && _temp17.then ? _temp17.then(function () {
      return questionsInfo;
    }) : questionsInfo);
  } catch (e) {
    return Promise.reject(e);
  }
};
var startTroubleShooting = function startTroubleShooting(params, envData) {
  if (params === void 0) {
    params = {};
  }
  try {
    var _runMode = sessionUtility.getRunMode();
    var _callMethod = _runMode == "development" ? window.callQAAPI ? "post" : "get" : "post";
    var _postData = _extends({}, params);
    return Promise.resolve(sessionUtility.getTroubleShootingJson()).then(function (mvoTroubleShootingJson) {
      var _mvoTroubleShootingJs, _mvoTroubleShootingJs2;
      var troubleShootingData = {};
      var startTroubleShootingApi = mvoTroubleShootingJson !== null && mvoTroubleShootingJson !== void 0 && (_mvoTroubleShootingJs = mvoTroubleShootingJson.ddata) !== null && _mvoTroubleShootingJs !== void 0 && (_mvoTroubleShootingJs2 = _mvoTroubleShootingJs.device) !== null && _mvoTroubleShootingJs2 !== void 0 && _mvoTroubleShootingJs2.is5GDevice ? tsaEnvConfig$1(envData).apiUrls.startTroubleShootingUrl : tsaEnvConfig$1(envData).apiUrls.startTroubleShootingNewUrl;
      console.log("info api params: ", _postData);
      var _temp20 = _catch(function () {
        return Promise.resolve(callAxios$1(startTroubleShootingApi, _callMethod, _postData)).then(function (resp) {
          function _temp19() {
            troubleShootingData = getObjectPropertyByPath("response.data.body", resp, {});
            logApiInfoSuccess(resp, troubleShootingData, startTroubleShootingApi, "ISSUE_INFORMATION");
          }
          var templateType = getTemplateType(resp, true);
          var _temp18 = function () {
            if (!templateType) {
              return Promise.resolve(callAxios$1(envConfig.apiUrls.defaultTemplateUrl, _callMethod, _postData)).then(function (_callAxios5) {
                resp = _callAxios5;
              });
            }
          }();
          return _temp18 && _temp18.then ? _temp18.then(_temp19) : _temp19(_temp18);
        });
      }, function (error) {
        console.log("Start Trouble Shooting call failed");
        logApiInfoError("ISSUE_INFORMATION", error);
      });
      return _temp20 && _temp20.then ? _temp20.then(function () {
        return troubleShootingData;
      }) : troubleShootingData;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var startActionForTroubleShootingNew = function startActionForTroubleShootingNew(params, envData) {
  if (params === void 0) {
    params = {};
  }
  try {
    console.log(params);
    var _postData2 = _extends({}, params);
    var troubleShootingData = {};
    var url;
    var headers = {};
    if (params.mvoenv == "development" || window.callQAAPI) {
      _postData2.intent = INTENT;
      _postData2.intentId = INTENT_ID;
      headers = {
        sso_jwt: JWT,
        Z2SESSION: Z2SESSION,
        assisted_ig_session: ASSISTED_IG_SESSION,
        bypass_jwt: true,
        ACSS_ROUTER_ID_NSA: "wakchpa"
      };
    }
    switch (params.ctaClicked) {
      case "ts_new":
        url = tsaEnvConfig$1(envData).apiUrls.submitTroubleShootingNewUrl;
        break;
      case "ts_multi":
        url = tsaEnvConfig$1(envData).apiUrls.submitTroubleShootingMultiUrl;
        break;
      case "ts_radio":
        url = tsaEnvConfig$1(envData).apiUrls.submitTroubleShootingRadioUrl;
        break;
      case "ts_options":
        url = tsaEnvConfig$1(envData).apiUrls.submitTroubleShootingOptionsUrl;
        break;
      case "ts_dropdown":
        url = tsaEnvConfig$1(envData).apiUrls.submitTroubleShootingDropdownUrl;
        break;
      case "ts_complete":
        url = tsaEnvConfig$1(envData).apiUrls.completionUrl;
        break;
      default:
        break;
    }
    var _temp23 = _catch(function () {
      return Promise.resolve(callAxios$1(url, callMethod, _postData2, headers)).then(function (resp) {
        function _temp22() {
          troubleShootingData = getObjectPropertyByPath("response.data.body", resp, {});
          logApiInfoSuccess(resp, troubleShootingData, url, "ISSUE_INFORMATION");
        }
        var templateType = getTemplateType(resp, true);
        var _temp21 = function () {
          if (!templateType) {
            return Promise.resolve(callAxios$1(envConfig.apiUrls.defaultTemplateUrl, callMethod, _postData2)).then(function (_callAxios6) {
              resp = _callAxios6;
            });
          }
        }();
        return _temp21 && _temp21.then ? _temp21.then(_temp22) : _temp22(_temp21);
      });
    }, function (error) {
      console.log("Start Trouble Shooting call failed");
      logApiInfoError("ISSUE_INFORMATION", error);
    });
    return Promise.resolve(_temp23 && _temp23.then ? _temp23.then(function () {
      return troubleShootingData;
    }) : troubleShootingData);
  } catch (e) {
    return Promise.reject(e);
  }
};
var testActionForTroubleShooting = function testActionForTroubleShooting(params, envData) {
  if (params === void 0) {
    params = {};
  }
  try {
    var _postData3 = _extends({}, params);
    console.log("test testActionForTroubleShooting", params);
    var troubleShootingData = {};
    var testTroubleShootingApi = tsaEnvConfig$1(envData).apiUrls.testTroubleShootingNewUrl;
    var headers = {};
    if (params.mvoenv == "development" || window.callQAAPI) {
      _postData3.intent = INTENT;
      _postData3.intentId = INTENT_ID;
      headers = {
        sso_jwt: JWT,
        Z2SESSION: Z2SESSION,
        assisted_ig_session: ASSISTED_IG_SESSION,
        bypass_jwt: true,
        ACSS_ROUTER_ID_NSA: "wakchpa"
      };
    }
    var _temp26 = _catch(function () {
      return Promise.resolve(callAxios$1(testTroubleShootingApi, callMethod, _postData3)).then(function (resp) {
        function _temp25() {
          troubleShootingData = getObjectPropertyByPath("response.data.body", resp, {});
          logApiInfoSuccess(resp, troubleShootingData, testTroubleShootingApi, "ISSUE_STEPS");
        }
        var templateType = getTemplateType(resp, true);
        var _temp24 = function () {
          if (!templateType) {
            return Promise.resolve(callAxios$1(tsaEnvConfig$1(envData).apiUrls.defaultTemplateUrl, callMethod, _postData3, headers)).then(function (_callAxios7) {
              resp = _callAxios7;
            });
          }
        }();
        return _temp24 && _temp24.then ? _temp24.then(_temp25) : _temp25(_temp24);
      });
    }, function (error) {
      console.log("Trouble Shooting Data call failed");
      logApiInfoError("ISSUE_STEPS", error);
    });
    return Promise.resolve(_temp26 && _temp26.then ? _temp26.then(function () {
      return troubleShootingData;
    }) : troubleShootingData);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getAllCases = function getAllCases(requestObj, envData) {
  try {
    console.log("getAllCases request", requestObj);
    var finalResp;
    var _temp27 = _catch(function () {
      var callMethod = (envData === null || envData === void 0 ? void 0 : envData.mvoenv) == "development" ? "get" : "post";
      var serviceURI = tsaEnvConfig$1(envData).apiUrls.getCasesURI;
      return Promise.resolve(callAxios$1(serviceURI, callMethod, requestObj, {})).then(function (casesResp) {
        console.log("getAllCases resp-->", casesResp);
        finalResp = casesResp;
      });
    }, function (err) {
      finalResp = {
        error: true,
        data: {}
      };
      console.log("Error in getAllCases-->");
      console.log(err);
    });
    return Promise.resolve(_temp27 && _temp27.then ? _temp27.then(function () {
      return finalResp;
    }) : finalResp);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getViraCaseIdForLv = function getViraCaseIdForLv(requestObj, envData) {
  try {
    var finalResp;
    var _temp28 = _catch(function () {
      var callMethod = (envData === null || envData === void 0 ? void 0 : envData.mvoenv) == "development" ? "get" : "post";
      var serviceURI = tsaEnvConfig$1(envData).apiUrls.getViraCaseIdForLvURI;
      return Promise.resolve(callAxios$1(serviceURI, callMethod, requestObj, {})).then(function (casesResp) {
        console.log("getViraCaseIdForLv resp-->", casesResp);
        finalResp = casesResp;
      });
    }, function (err) {
      finalResp = {
        error: true,
        data: {}
      };
      console.log("Error in getViraCaseIdForLv-->");
      console.log(err);
    });
    return Promise.resolve(_temp28 && _temp28.then ? _temp28.then(function () {
      return finalResp;
    }) : finalResp);
  } catch (e) {
    return Promise.reject(e);
  }
};
var submitActionForTroubleShooting = function submitActionForTroubleShooting(params, envData) {
  if (params === void 0) {
    params = {};
  }
  try {
    var _JSON$parse, _JSON$parse2, _JSON$parse4, _window, _window$config;
    if (!params.caseId) {
      params.caseId = window.caseId;
    }
    if (window.isMVODigital) {
      var _window$tsFeatureFlag;
      params.featureFlagList = {
        "enableEOTRemoveHashFFlag": ((_window$tsFeatureFlag = window.tsFeatureFlags) === null || _window$tsFeatureFlag === void 0 ? void 0 : _window$tsFeatureFlag.enableEOTRemoveHashFFlag) || false
      };
    }
    var _postData4 = _extends({}, params);
    console.log("@@@@@@@@nBSFlow@@@@@@@@@@");
    console.log(JSON.parse(sessionStorage.getItem('nBSFlow')));
    if (JSON.parse(sessionStorage.getItem('nBSFlow'))) {
      _postData4.nBSFlow = true;
    } else {
      _postData4.nBSFlow = false;
    }
    _postData4.loggedInUser = params.loggedInUser || "";
    if ((_JSON$parse = JSON.parse(sessionStorage.getItem("troubleshootingDevice"))) !== null && _JSON$parse !== void 0 && _JSON$parse.changeDevice) {
      _postData4.changeDevice = true;
    }
    console.log("troubleshootingDevice$$$$$$$$$$$$$$$$$$");
    console.log(window.isBAUACSS);
    console.log(JSON.parse(sessionStorage.getItem("troubleshootingDevice")));
    if (window.isBAUACSS && typeof ((_JSON$parse2 = JSON.parse(sessionStorage.getItem("troubleshootingDevice"))) === null || _JSON$parse2 === void 0 ? void 0 : _JSON$parse2.callerId) !== "undefined") {
      var _JSON$parse3;
      _postData4.callerId = (_JSON$parse3 = JSON.parse(sessionStorage.getItem("troubleshootingDevice"))) === null || _JSON$parse3 === void 0 ? void 0 : _JSON$parse3.callerId;
    }
    if (window.isBAUACSS && typeof ((_JSON$parse4 = JSON.parse(sessionStorage.getItem("troubleshootingDevice"))) === null || _JSON$parse4 === void 0 ? void 0 : _JSON$parse4.displayMode) !== "undefined" || ((_window = window) === null || _window === void 0 ? void 0 : (_window$config = _window.config) === null || _window$config === void 0 ? void 0 : _window$config.displayMode) === "admin") {
      var _JSON$parse$displayMo, _JSON$parse5, _window2, _window2$config, _window3, _window3$config;
      _postData4.displayMode = ((_JSON$parse$displayMo = (_JSON$parse5 = JSON.parse(sessionStorage.getItem("troubleshootingDevice"))) === null || _JSON$parse5 === void 0 ? void 0 : _JSON$parse5.displayMode) != null ? _JSON$parse$displayMo : !!((_window2 = window) !== null && _window2 !== void 0 && (_window2$config = _window2.config) !== null && _window2$config !== void 0 && _window2$config.displayMode)) ? (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$config = _window3.config) === null || _window3$config === void 0 ? void 0 : _window3$config.displayMode : "view";
    }
    var troubleShootingData = {};
    var submitTroubleShootingApi = tsaEnvConfig$1(envData).apiUrls.submitTroubleShootingNewUrl;
    var headers = {};
    if (params.mvoenv == "development" || window.callQAAPI) {
      _postData4.intent = INTENT;
      _postData4.intentId = INTENT_ID;
      headers = {
        sso_jwt: JWT,
        Z2SESSION: Z2SESSION,
        assisted_ig_session: ASSISTED_IG_SESSION,
        bypass_jwt: true,
        ACSS_ROUTER_ID_NSA: "wakchpa"
      };
    }
    console.log("submitActionForTroubleShooting post params:", _postData4, JSON.parse(sessionStorage.getItem("troubleshootingDevice")));
    sessionStorage.setItem("solutionId", _postData4 === null || _postData4 === void 0 ? void 0 : _postData4.processAction);
    localStorage.setItem("troubleshootParams", JSON.stringify(_postData4));
    if (sessionStorage.getItem("troubleshootingDetails")) {
      localStorage.setItem("troubleshootingDetails", sessionStorage.getItem("troubleshootingDetails"));
    }
    if (_postData4["processStep"] === "resume") {
      _postData4["processAction"] = "";
    }
    var _temp31 = _catch(function () {
      var callMethod = (envData === null || envData === void 0 ? void 0 : envData.mvoenv) == "development" ? "get" : "post";
      return Promise.resolve(callAxios$1(submitTroubleShootingApi, callMethod, _postData4, headers)).then(function (resp) {
        function _temp30() {
          troubleShootingData = getObjectPropertyByPath("response.data.body", resp, {});
          console.log("troubleShootingData------", troubleShootingData);
          logApiInfoSuccess(resp, troubleShootingData, submitTroubleShootingApi, "ISSUE_STEPS", envData);
        }
        var templateType = getTemplateType(resp, true);
        var _temp29 = function () {
          if (!templateType) {
            return Promise.resolve(callAxios$1(envConfig.apiUrls.defaultTemplateUrl, callMethod, _postData4)).then(function (_callAxios8) {
              resp = _callAxios8;
            });
          }
        }();
        return _temp29 && _temp29.then ? _temp29.then(_temp30) : _temp30(_temp29);
      });
    }, function (error) {
      console.log("Trouble Shooting Data call failed");
      logApiInfoError("ISSUE_STEPS", error);
    });
    return Promise.resolve(_temp31 && _temp31.then ? _temp31.then(function () {
      return troubleShootingData;
    }) : troubleShootingData);
  } catch (e) {
    return Promise.reject(e);
  }
};
var troubleShootingNBXCall = function troubleShootingNBXCall(params, envData) {
  if (params === void 0) {
    params = {};
  }
  try {
    var _postData5 = _extends({}, params);
    var troubleShootingNBXData = {};
    var _temp32 = _catch(function () {
      var callMethod = (envData === null || envData === void 0 ? void 0 : envData.mvoenv) == "development" ? "get" : "post";
      console.log(tsaEnvConfig$1(envData).apiUrls.troubleShootingNBXUrl);
      return Promise.resolve(callAxios$1(tsaEnvConfig$1(envData).apiUrls.troubleShootingNBXUrl, callMethod, _postData5)).then(function (resp) {
        troubleShootingNBXData = getObjectPropertyByPath("response.data.body", resp, {});
        logApiInfoSuccess(resp, troubleShootingNBXData, tsaEnvConfig$1(envData).apiUrls.troubleShootingNBXUrl, "TSA_NBX");
      });
    }, function (error) {
      console.log("Trouble Shooting NBX call failed");
      logApiInfoError("NBX API", error);
    });
    return Promise.resolve(_temp32 && _temp32.then ? _temp32.then(function () {
      return troubleShootingNBXData;
    }) : troubleShootingNBXData);
  } catch (e) {
    return Promise.reject(e);
  }
};
var recommendFeedBackAPI = function recommendFeedBackAPI(payload, envData) {
  try {
    var response = {};
    var _temp33 = _catch(function () {
      var callMethod = (envData === null || envData === void 0 ? void 0 : envData.mvoenv) == "development" ? "get" : "post";
      return Promise.resolve(callAxios$1(tsaEnvConfig$1(envData).apiUrls.recommendFeedBackURL, callMethod, payload)).then(function (getResp) {
        response = getObjectPropertyByPath("response.data.body", getResp, {});
      });
    }, function () {
      console.log("fetching recommended Feedback API");
    });
    return Promise.resolve(_temp33 && _temp33.then ? _temp33.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var closeTroubleShooting = function closeTroubleShooting(params, envData) {
  if (params === void 0) {
    params = {};
  }
  try {
    var _postData6 = _extends({}, params);
    var troubleShootingData = {};
    var _temp34 = _catch(function () {
      return Promise.resolve(callAxios$1(tsaEnvConfig$1(envData).apiUrls.closeTroubleShootingUrl, callMethod, _postData6)).then(function (resp) {
        troubleShootingData = getObjectPropertyByPath("response.data.body", resp, {});
        logApiInfoSuccess(resp, troubleShootingData, tsaEnvConfig$1(envData).apiUrls.closeTroubleShootingUrl, "TSA_COMPLETION");
      });
    }, function (error) {
      console.log("Close Trouble Shooting call failed");
      logApiInfoError("TSA_COMPLETION", error);
    });
    return Promise.resolve(_temp34 && _temp34.then ? _temp34.then(function () {
      return troubleShootingData;
    }) : troubleShootingData);
  } catch (e) {
    return Promise.reject(e);
  }
};
var replayActionForTroubleShooting = function replayActionForTroubleShooting(params, envData) {
  if (params === void 0) {
    params = {};
  }
  try {
    var _JSON$parse6;
    if (!params.caseId) {
      params.caseId = window.caseId;
    }
    if (window.isMVODigital) {
      var _window$tsFeatureFlag2;
      params.featureFlagList = {
        "enableEOTRemoveHashFFlag": ((_window$tsFeatureFlag2 = window.tsFeatureFlags) === null || _window$tsFeatureFlag2 === void 0 ? void 0 : _window$tsFeatureFlag2.enableEOTRemoveHashFFlag) || false
      };
    }
    var _postData7 = _extends({}, params);
    if (JSON.parse(sessionStorage.getItem('nBSFlow'))) {
      _postData7.nBSFlow = true;
    } else {
      _postData7.nBSFlow = false;
    }
    if ((_JSON$parse6 = JSON.parse(sessionStorage.getItem("troubleshootingDevice"))) !== null && _JSON$parse6 !== void 0 && _JSON$parse6.changeDevice) {
      _postData7.changeDevice = true;
    }
    var troubleShootingData = {};
    var replayTroubleShootingApi = tsaEnvConfig$1(envData).apiUrls.replayTroubleShootingNewUrl;
    var headers = {};
    if (params.mvoenv == "development" || window.callQAAPI) {
      _postData7.intent = INTENT;
      _postData7.intentId = INTENT_ID;
      headers = {
        sso_jwt: JWT,
        Z2SESSION: Z2SESSION,
        assisted_ig_session: ASSISTED_IG_SESSION,
        bypass_jwt: true,
        ACSS_ROUTER_ID_NSA: "wakchpa"
      };
    }
    console.log("replayActionForTroubleShooting post params:", _postData7, JSON.parse(sessionStorage.getItem("troubleshootingDevice")));
    var _temp37 = _catch(function () {
      var callMethod = (envData === null || envData === void 0 ? void 0 : envData.mvoenv) == "development" ? "get" : "post";
      return Promise.resolve(callAxios$1(replayTroubleShootingApi, callMethod, _postData7, headers)).then(function (resp) {
        function _temp36() {
          console.log("inside replayyy::", resp);
          troubleShootingData = getObjectPropertyByPath("response.data.body", resp, {});
          logApiInfoSuccess(resp, troubleShootingData, replayTroubleShootingApi, "ISSUE_STEPS", envData);
        }
        var templateType = getTemplateType(resp, true);
        var _temp35 = function () {
          if (!templateType) {
            return Promise.resolve(callAxios$1(envConfig.apiUrls.defaultTemplateUrl, callMethod, _postData7)).then(function (_callAxios9) {
              resp = _callAxios9;
            });
          }
        }();
        return _temp35 && _temp35.then ? _temp35.then(_temp36) : _temp36(_temp35);
      });
    }, function (error) {
      console.log("Replay Trouble Shooting Data call failed");
      logApiInfoError("ISSUE_STEPS", error);
    });
    return Promise.resolve(_temp37 && _temp37.then ? _temp37.then(function () {
      return troubleShootingData;
    }) : troubleShootingData);
  } catch (e) {
    return Promise.reject(e);
  }
};
var checkOutageAPI = function checkOutageAPI(envData) {
  try {
    var response = {};
    var _temp38 = _catch(function () {
      var callMethod = "get";
      return Promise.resolve(callAxios$1(tsaEnvConfig$1(envData).apiUrls.checkOutageDiagnosticUrl, callMethod)).then(function (getResp) {
        response = getObjectPropertyByPath("response.data.body", getResp, {});
      });
    }, function () {
      console.log("fetching checkOutageAPI API");
    });
    return Promise.resolve(_temp38 && _temp38.then ? _temp38.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getOutagePageInfo = function getOutagePageInfo(envData) {
  try {
    var _temp41 = function _temp41(_result) {
      if (_exit) return _result;
      var _temp39 = _catch(function () {
        return Promise.resolve(callAxios$1(envConfig.apiUrls.networkOutagePageUrl, "get", postData)).then(function (resp) {
          outagePageInfo = getObjectPropertyByPath("response.data.body", resp, {});
        });
      }, function () {
        console.log("Network Outage Info call failed");
      });
      return _temp39 && _temp39.then ? _temp39.then(function () {
        return outagePageInfo;
      }) : outagePageInfo;
    };
    var _exit = false;
    var outagePageInfo = {};
    var URL = tsaEnvConfig$1(envData).apiUrls.networkOutagePageUrl;
    var _temp40 = _catch(function () {
      return Promise.resolve(fetch(URL, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          channelId: "VZW-ACSS"
        }
      })).then(function (response) {
        return Promise.resolve(response.json()).then(function (resp) {
          outagePageInfo = getObjectPropertyByPath("response.data.body", resp, {});
          _exit = true;
          return info;
        });
      });
    }, function () {
      console.log("outageInfo call failed");
    });
    return Promise.resolve(_temp40 && _temp40.then ? _temp40.then(_temp41) : _temp41(_temp40));
  } catch (e) {
    return Promise.reject(e);
  }
};
var addressValidation = function addressValidation(params) {
  if (params === void 0) {
    params = {};
  }
  try {
    var _exit2 = false;
    var _postData8 = _extends({}, params);
    var validateAddress = {};
    var _temp42 = _catch(function () {
      return Promise.resolve(callAxios$1(envConfig.apiUrls.addressValidationUrl, callMethod, _postData8)).then(function (resp) {
        if (resp.error) {
          throw new Error("Non success response");
        }
        validateAddress = getObjectPropertyByPath("response.data.body", resp, {});
      });
    }, function () {
      console.log("Validate Address call failed");
    });
    return Promise.resolve(_temp42 && _temp42.then ? _temp42.then(function (_result2) {
      return _exit2 ? _result2 : validateAddress;
    }) : _exit2 ? _temp42 : validateAddress);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getSearchSymptoms = function getSearchSymptoms(params, envData) {
  if (params === void 0) {
    params = {};
  }
  try {
    var _exit3 = false;
    var _postData9 = _extends({}, params);
    var typeAheadOptions = {};
    var _temp43 = _catch(function () {
      return Promise.resolve(callAxios$1(tsaEnvConfig$1(envData).apiUrls.typeAheadUrl, callMethod, _postData9)).then(function (resp) {
        if (resp.error) {
          throw new Error("Non success response");
        }
        typeAheadOptions = getObjectPropertyByPath("response.data.body", resp, {});
      });
    }, function () {
      console.log("Validate Address call failed");
    });
    return Promise.resolve(_temp43 && _temp43.then ? _temp43.then(function (_result3) {
      return _exit3 ? _result3 : typeAheadOptions;
    }) : _exit3 ? _temp43 : typeAheadOptions);
  } catch (e) {
    return Promise.reject(e);
  }
};
var redirectWithPostData = function redirectWithPostData(url, payload) {
  var form = document.createElement("form");
  form.style.visibility = "hidden";
  form.method = "POST";
  form.action = url;
  var input = document.createElement("input");
  input.type = "hidden";
  input.name = "payload";
  input.value = JSON.stringify(payload);
  form.appendChild(input);
  document.body.appendChild(form);
  form.submit();
};
var pollActionForTroubleShooting = function pollActionForTroubleShooting(params, envData) {
  if (params === void 0) {
    params = {};
  }
  try {
    var _JSON$parse7, _JSON$parse8, _JSON$parse0, _window4, _window4$config;
    if (!params.caseId) {
      params.caseId = window.caseId;
    }
    var _postData0 = _extends({}, params);
    if (JSON.parse(sessionStorage.getItem('nBSFlow'))) {
      _postData0.nBSFlow = true;
    } else {
      _postData0.nBSFlow = false;
    }
    if ((_JSON$parse7 = JSON.parse(sessionStorage.getItem("troubleshootingDevice"))) !== null && _JSON$parse7 !== void 0 && _JSON$parse7.changeDevice) {
      _postData0.changeDevice = true;
    }
    console.log("troubleshootingDevice$$$$$$$$$$$$$$$$$$");
    console.log(window.isBAUACSS);
    console.log(JSON.parse(sessionStorage.getItem("troubleshootingDevice")));
    if (window.isBAUACSS && typeof ((_JSON$parse8 = JSON.parse(sessionStorage.getItem("troubleshootingDevice"))) === null || _JSON$parse8 === void 0 ? void 0 : _JSON$parse8.callerId) !== "undefined") {
      var _JSON$parse9;
      _postData0.callerId = (_JSON$parse9 = JSON.parse(sessionStorage.getItem("troubleshootingDevice"))) === null || _JSON$parse9 === void 0 ? void 0 : _JSON$parse9.callerId;
    }
    if (window.isBAUACSS && typeof ((_JSON$parse0 = JSON.parse(sessionStorage.getItem("troubleshootingDevice"))) === null || _JSON$parse0 === void 0 ? void 0 : _JSON$parse0.displayMode) !== "undefined" || ((_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$config = _window4.config) === null || _window4$config === void 0 ? void 0 : _window4$config.displayMode) === "admin") {
      var _JSON$parse$displayMo2, _JSON$parse1, _window5, _window5$config, _window6, _window6$config;
      _postData0.displayMode = ((_JSON$parse$displayMo2 = (_JSON$parse1 = JSON.parse(sessionStorage.getItem("troubleshootingDevice"))) === null || _JSON$parse1 === void 0 ? void 0 : _JSON$parse1.displayMode) != null ? _JSON$parse$displayMo2 : !!((_window5 = window) !== null && _window5 !== void 0 && (_window5$config = _window5.config) !== null && _window5$config !== void 0 && _window5$config.displayMode)) ? (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$config = _window6.config) === null || _window6$config === void 0 ? void 0 : _window6$config.displayMode : "view";
    }
    var troubleShootingData = {};
    var headers = {};
    if (params.mvoenv == "development" || window.callQAAPI) {
      _postData0.intent = INTENT;
      _postData0.intentId = INTENT_ID;
      headers = {
        sso_jwt: JWT,
        Z2SESSION: Z2SESSION,
        assisted_ig_session: ASSISTED_IG_SESSION,
        bypass_jwt: true,
        ACSS_ROUTER_ID_NSA: "wakchpa"
      };
    }
    console.log("pollActionForTroubleShooting post params:", _postData0, JSON.parse(sessionStorage.getItem("troubleshootingDevice")));
    var pollTroubleShootingApi = tsaEnvConfig$1(envData).apiUrls.pollTroubleShootingActionUrl;
    var _temp44 = _catch(function () {
      var callMethod = (envData === null || envData === void 0 ? void 0 : envData.mvoenv) == "development" ? "get" : "post";
      return Promise.resolve(callAxios$1(pollTroubleShootingApi, callMethod, _postData0)).then(function (resp) {
        var templateType = getTemplateType(resp, true);
        console.log("inside Poll::", resp);
        troubleShootingData = getObjectPropertyByPath("response.data.body", resp, {});
        logApiInfoSuccess(resp, troubleShootingData, envConfig.apiUrls.pollTroubleShootingUrl, "ISSUE_STEPS");
      });
    }, function (error) {
      console.log("Poll Trouble Shooting Data call failed");
      logApiInfoError("ISSUE_STEPS", error);
    });
    return Promise.resolve(_temp44 && _temp44.then ? _temp44.then(function () {
      return troubleShootingData;
    }) : troubleShootingData);
  } catch (e) {
    return Promise.reject(e);
  }
};
var offerFeedBackResponse = function offerFeedBackResponse(data, envData) {
  try {
    var URL = tsaEnvConfig$1(envData).apiUrls.offerFeedbackInfo;
    return Promise.resolve(_catch(function () {
      return Promise.resolve(fetch(URL, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          channelId: "VZW-ACSS"
        },
        body: JSON.stringify(data)
      })).then(function (response) {
        return Promise.resolve(response.json());
      });
    }, function () {
      console.log("offer feedback call failed");
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};
var redirectFormPostToUrl = function redirectFormPostToUrl(url, equipmentId, purpose) {
  try {
    return Promise.resolve(sessionUtility.getMvoConfig()).then(function (mvoConfig) {
      return Promise.resolve(sessionUtility.getCaseDetails()).then(function (mvoCaseDetails) {
        if (isEmpty(url)) {
          return false;
        }
        try {
          var _mvoCaseDetails$appId, _mvoCaseDetails$chann, _mvoCaseDetails$userI, _mvoCaseDetails$mtn, _mvoCaseDetails$custV, _mvoConfig$token, _window7, _window7$token;
          var form = document.createElement("form");
          form.setAttribute("method", "post");
          form.setAttribute("action", url);
          var params = {
            appId: (_mvoCaseDetails$appId = mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.appId) != null ? _mvoCaseDetails$appId : "",
            channel: (_mvoCaseDetails$chann = mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.channel) != null ? _mvoCaseDetails$chann : "",
            tierId: (mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.tier) || (mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.tierId) || "",
            tier: (mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.tier) || (mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.tierId) || "",
            userId: (_mvoCaseDetails$userI = mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.userId) != null ? _mvoCaseDetails$userI : "",
            mdn: (_mvoCaseDetails$mtn = mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.mtn) != null ? _mvoCaseDetails$mtn : "",
            equipId: equipmentId,
            custVerified: (_mvoCaseDetails$custV = mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.custVerified) != null ? _mvoCaseDetails$custV : "",
            token: (mvoConfig === null || mvoConfig === void 0 ? void 0 : (_mvoConfig$token = mvoConfig.token) === null || _mvoConfig$token === void 0 ? void 0 : _mvoConfig$token.token) || ((_window7 = window) === null || _window7 === void 0 ? void 0 : (_window7$token = _window7.token) === null || _window7$token === void 0 ? void 0 : _window7$token.token) || ""
          };
          if (purpose == "issue-history") {
            var _mvoCaseDetails$caseI;
            params.tsrID = (_mvoCaseDetails$caseI = mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.caseId) != null ? _mvoCaseDetails$caseI : "";
            params.tsrAction = "DETAIL";
            try {
              var newURL = mvoCaseDetails.changeIssueUrl.replace(/symptom_selector\/&/, "history");
              form.setAttribute("action", newURL);
            } catch (error) {
              console.error("redirectFormPostToUrl error", error);
            }
          }
          for (var key in params) {
            if (params.hasOwnProperty(key)) {
              var hiddenField = document.createElement("input");
              hiddenField.setAttribute("type", "hidden");
              hiddenField.setAttribute("name", key);
              hiddenField.setAttribute("value", params[key]);
              form.appendChild(hiddenField);
            }
          }
          document.body.appendChild(form);
          form.submit();
        } catch (error) {
          console.log("Form Post URL Info Failed");
        }
      });
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var reviewTechBulletInSearch = function reviewTechBulletInSearch(url) {
  try {
    return Promise.resolve(sessionUtility.getRunMode()).then(function (runMode) {
      var resp = {};
      var _temp45 = _catch(function () {
        if (runMode === "development") {
          url = envConfig.apiUrls.reviewTechBulletInUrl;
        }
        return Promise.resolve(callAxios$1(url, callMethod)).then(function (_callAxios0) {
          resp = _callAxios0;
        });
      }, function () {
        console.log("review tech bullet in search failed");
      });
      return _temp45 && _temp45.then ? _temp45.then(function () {
        return resp;
      }) : resp;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var getRecentPendingCase = function getRecentPendingCase(params, envData) {
  try {
    var _temp48 = function _temp48() {
      var _temp46 = function () {
        if (process.env.NODE_ENV == 'development') {
          var sleep = function sleep(ms) {
            return new Promise(function (resolve) {
              return setTimeout(resolve, ms);
            });
          };
          return Promise.resolve(sleep(5000)).then(function () {
            return Promise.resolve(callAxios$1(URL, _callMethod2)).then(function (_callAxios10) {
              resp = _callAxios10;
            });
          });
        }
      }();
      return _temp46 && _temp46.then ? _temp46.then(function () {
        return resp;
      }) : resp;
    };
    var resp = null;
    var URL = tsaEnvConfig$1(envData).apiUrls.getRecentPendingCasesUrl;
    var _callMethod2 = process.env.NODE_ENV == 'development' ? 'get' : 'post';
    var _temp47 = _catch(function () {
      return Promise.resolve(callAxios$1(URL, _callMethod2, params)).then(function (_callAxios1) {
        resp = _callAxios1;
      });
    }, function (error) {
      console.log('getRecentPendingCase API failed: ' + error);
    });
    return Promise.resolve(_temp47 && _temp47.then ? _temp47.then(_temp48) : _temp48(_temp47));
  } catch (e) {
    return Promise.reject(e);
  }
};
var checkAlertBanner = function checkAlertBanner(envData) {
  try {
    var resp = null;
    var URL = tsaEnvConfig$1(envData).apiUrls.checkAlertBanner;
    var _callMethod3 = 'get';
    var _temp49 = _catch(function () {
      return Promise.resolve(callAxios$1(URL, _callMethod3)).then(function (_callAxios11) {
        resp = _callAxios11;
      });
    }, function (error) {
      console.log('checkAlertBanner API failed: ' + error);
    });
    return Promise.resolve(_temp49 && _temp49.then ? _temp49.then(function () {
      return resp;
    }) : resp);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getAllIntents = function getAllIntents(params, envData) {
  if (params === void 0) {
    params = {};
  }
  try {
    var _postData1 = _extends({}, params);
    var intentsData = {};
    var submitTroubleShootingApi = tsaEnvConfig$1(envData).apiUrls.getAllIntentsUrl;
    var headers = {};
    if (params.mvoenv == "development" || window.callQAAPI) {
      headers = {
        sso_jwt: JWT,
        Z2SESSION: Z2SESSION,
        assisted_ig_session: ASSISTED_IG_SESSION,
        bypass_jwt: true,
        ACSS_ROUTER_ID_NSA: "wakchpa"
      };
    }
    var _temp50 = _catch(function () {
      var callMethod = (envData === null || envData === void 0 ? void 0 : envData.mvoenv) == "development" ? "get" : "post";
      return Promise.resolve(callAxios$1(submitTroubleShootingApi, callMethod, _postData1, headers)).then(function (resp) {
        intentsData = getObjectPropertyByPath("response.data.body", resp, {});
      });
    }, function () {
      console.log("Trouble Shooting Data call failed");
    });
    return Promise.resolve(_temp50 && _temp50.then ? _temp50.then(function () {
      return intentsData;
    }) : intentsData);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getDeviceSymptoms = function getDeviceSymptoms(params, envData) {
  if (params === void 0) {
    params = {};
  }
  try {
    var _postData10 = _extends({}, params);
    var symptomsData = {};
    var URL = tsaEnvConfig$1(envData).apiUrls.getDeviceSymptoms;
    var headers = {};
    if (params.mvoenv == "development" || window.callQAAPI) {
      headers = {
        sso_jwt: JWT,
        Z2SESSION: Z2SESSION,
        assisted_ig_session: ASSISTED_IG_SESSION,
        bypass_jwt: true,
        ACSS_ROUTER_ID_NSA: "wakchpa"
      };
    }
    var _temp51 = _catch(function () {
      var callMethod = (envData === null || envData === void 0 ? void 0 : envData.mvoenv) == "development" ? "get" : "post";
      return Promise.resolve(callAxios$1(URL, callMethod, _postData10, headers)).then(function (resp) {
        symptomsData = getObjectPropertyByPath("response.data.body.getSymptomsResult.primarySymptoms", resp, {});
      });
    }, function () {
      console.error("catch getDeviceSymptoms call failed");
    });
    return Promise.resolve(_temp51 && _temp51.then ? _temp51.then(function () {
      return symptomsData;
    }) : symptomsData);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getNrbReq = function getNrbReq(requestObj, envData) {
  try {
    console.log("getNrbReq request", requestObj);
    var finalResp;
    var _temp52 = _catch(function () {
      var callMethod = (envData === null || envData === void 0 ? void 0 : envData.mvoenv) == 'development' ? 'get' : 'post';
      var serviceURI = envData === null || envData === void 0 ? void 0 : envData.externalTarget;
      return Promise.resolve(callAxios$1(serviceURI, callMethod, requestObj, {})).then(function (nrbResp) {
        console.log("nrbResp resp-->", nrbResp);
        finalResp = nrbResp;
      });
    }, function (err) {
      finalResp = {
        error: true,
        data: {}
      };
      console.log("Error in nrbResp-->");
      console.log(err);
    });
    return Promise.resolve(_temp52 && _temp52.then ? _temp52.then(function () {
      return finalResp;
    }) : finalResp);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getNBXEligibileReq = function getNBXEligibileReq(nbxPayload, envData) {
  try {
    var finalResp;
    var _temp53 = _catch(function () {
      var callMethod = (envData === null || envData === void 0 ? void 0 : envData.mvoenv) == 'development' ? 'get' : 'post';
      var serviceURI = envData === null || envData === void 0 ? void 0 : envData.externalTarget;
      return Promise.resolve(callAxios$1(serviceURI, callMethod, nbxPayload, {})).then(function (nbxResp) {
        console.log("nbxResp resp-->", nbxResp);
        finalResp = nbxResp;
      });
    }, function (err) {
      finalResp = {
        error: true,
        data: {}
      };
      console.log("Error in nbxResp-->");
      console.log(err);
    });
    return Promise.resolve(_temp53 && _temp53.then ? _temp53.then(function () {
      return finalResp;
    }) : finalResp);
  } catch (e) {
    return Promise.reject(e);
  }
};
var smartSolutionDiagnosticAPI = function smartSolutionDiagnosticAPI(smartApiUrl, payload, envData) {
  try {
    var _temp55 = function _temp55() {
      response = getObjectPropertyByPath("response.data.data.data.data", getResp, {});
      return response;
    };
    var response = {};
    var getResp = "";
    var _callMethod4 = (envData === null || envData === void 0 ? void 0 : envData.mvoenv) == "development" ? "get" : "post";
    var _temp54 = _catch(function () {
      return Promise.resolve(callAxios$1(smartApiUrl, _callMethod4, payload)).then(function (_callAxios12) {
        getResp = _callAxios12;
      });
    }, function (error) {
      console.log('API failed: ' + error);
    });
    return Promise.resolve(_temp54 && _temp54.then ? _temp54.then(_temp55) : _temp55(_temp54));
  } catch (e) {
    return Promise.reject(e);
  }
};
var smartSolutionAPI = function smartSolutionAPI(smartApiUrl, payload, envData) {
  try {
    var _temp57 = function _temp57() {
      response = getObjectPropertyByPath("response.data.body", getResp, {});
      return response;
    };
    var response = {};
    var getResp = "";
    var _callMethod5 = (envData === null || envData === void 0 ? void 0 : envData.mvoenv) == "development" ? "get" : "post";
    var _temp56 = _catch(function () {
      return Promise.resolve(callAxios$1(smartApiUrl, _callMethod5, payload)).then(function (_callAxios13) {
        getResp = _callAxios13;
      });
    }, function (error) {
      console.log('API failed: ' + error);
    });
    return Promise.resolve(_temp56 && _temp56.then ? _temp56.then(_temp57) : _temp57(_temp56));
  } catch (e) {
    return Promise.reject(e);
  }
};

var _templateObject;
var ChildrenWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\nz-index: 3;\nposition: absolute;\ntop: 32%;\nwidth: 100%;\ndisplay: flex;\nalign-items: center;\njustify-content: center;\ntext-align: center;\n"])));
var Loader = function Loader(props) {
  return /*#__PURE__*/React__default.createElement("div", null, props.children && /*#__PURE__*/React__default.createElement(ChildrenWrapper, {
    style: _extends({}, props.childrenStyles)
  }, props.children));
};
Loader.propTypes = {
  childrenStyles: PropTypes.object,
  className: PropTypes.string
};
Loader.defaultProps = {
  childrenStyles: {},
  className: ''
};

var _templateObject$1;
var StyledButton = styled(Button$1)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n  min-width: ", ";\n  width: ", ";\n  padding: 0 20px;\n\n  @media (min-width: 601px) {\n    :not(:last-child) {\n     // margin-right: 14px;\n    }\n  }\n\n  [class^='StyledChildWrapper-'] {\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  @media (max-width: 600px) {\n    margin-top: 10px;\n    align-items: center;\n    :not(:first-child) {\n    }\n\n    padding: 0;\n    //margin-bottom: 20px!important;\n  }\n  &.btn-solved * {\n    ", "\n  }\n"])), function (props) {
  return props.minWidth ? props.minWidth : '55%';
}, function (props) {
  return props.width ? props.width : 'auto';
}, function (props) {
  return props.isDark ? "\n        background-color: #fff;\n        color: #000;\n        border-radius: 6.25rem;\n        &:active{\n          border-color: #e4e6e6;\n          box-shadow: 0 0 0 0.0625rem #e4e6e6;\n          background-color: #e4e6e6;\n         }\n      " : "\n        background-color: #000;\n        color: #fff;\n        border-radius: 6.25rem;\n        &:active{\n          border-color: #747676;\n          box-shadow: 0 0 0 0.0625rem #747676;\n          background-color: #747676;\n         }\n      ";
});
var ActionButton = function ActionButton(props) {
  var childProps = _extends({}, props);
  if (parseInt(props.size, 10) > 0) {
    childProps.minWidth = childProps.size;
    delete childProps.size;
  }
  if (childProps.children.length >= 10) {
    childProps.minWidth = '55%';
  }
  if (childProps.children.length > 20) {
    childProps.minWidth = '70%';
  }
  return /*#__PURE__*/React__default.createElement(StyledButton, childProps);
};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(_typeof_1);

var toPrimitive_1 = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(toPrimitive_1);

var toPropertyKey_1 = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];

function toPropertyKey(t) {
  var i = toPrimitive_1(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(toPropertyKey_1);

var defineProperty = createCommonjsModule(function (module) {
function _defineProperty(e, r, t) {
  return (r = toPropertyKey_1(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _defineProperty = unwrapExports(defineProperty);

var UtilityConfig={remBase:16},splitUnits=function(t){return {number:parseFloat(t),units:String(t).replace(/^[\d.-]+/,"")}},calculateRem=function(){for(var t="",e=0;e<arguments.length;++e){var r=e<0||arguments.length<=e?void 0:arguments[e];""!==t&&(t+=" ");var n=splitUnits(r);"rem"!==n.units?t+=n.number/UtilityConfig.remBase:t+=n.number,0!=n.number&&(t+="rem");}return t};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var baseColors = {
  // Color Definitions
  black: '#000000',
  white: '#ffffff',
  red: '#d52b1e',
  charcoal: '#454545',
  green: '#00ac3e',
  blue: '#0088ce',
  yellow: '#ffbc3d',
  orange: '#ed7000',
  coolGray1: '#f6f6f6',
  coolGray3: '#d8dada',
  coolGray6: '#747676',
  coolGray10: '#333333',
  grayLight: '#d8dada'
};
var textColors = {
  textColor: baseColors.charcoal,
  textColorSuccess: baseColors.white,
  textColorInfo: baseColors.white,
  textColorWarning: baseColors.charcoal,
  textColorError: baseColors.white
};
var colors = _objectSpread(_objectSpread({}, baseColors), textColors);

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var fontFamilies = {
  fontFamily: '"BrandFont-Text", Helvetica, Arial, sans-serif',
  monospace: '"SFMono-Regular", "RobotoMono-Regular", monospace',
  sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  serif: 'serif',
  iconFontUrl: 'https://respframework.verizon.com/fonts/verizon-icons/fonts.css',
  iconFont: 'verizon-icons'
};
var fontStyles = {
  fontColor: colors.black,
  fontColorAlt: colors.white,
  fontSize: calculateRem(16)
};
var fontWeights = {
  light: 300,
  normal: 400,
  medium: 500,
  bold: 700
};
var font = _objectSpread$1(_objectSpread$1(_objectSpread$1({}, fontFamilies), fontStyles), {}, {
  fontWeights: fontWeights,
  fontHeader: fontFamilies.fontFamily,
  fontBody: fontFamilies.sans,
  fontWeight: fontWeights
});

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var general = {
  // General
  primary: colors.black,
  secondary: colors.white,
  accent: colors.red,
  background: colors.white,
  backgroundColorDisabled: colors.coolGray3,
  // Messaging Types
  success: colors.green,
  info: colors.blue,
  warning: colors.yellow,
  error: colors.orange,
  disabled: colors.coolGray3,
  textColorSuccess: colors.white,
  textColorInfo: colors.white,
  textColorWarning: colors.black,
  textColorError: colors.black,
  textColorDisabled: colors.white,
  // Borders
  borderWidth: calculateRem(1),
  borderStyle: 'solid',
  borderColor: colors.coolGray3,
  border: "".concat(calculateRem(1), " solid ").concat(colors.coolGray3),
  borderColorDisabled: colors.coolGray3,
  // Links
  linkColor: colors.black,
  linkColorHover: colors.blue,
  linkColorActive: colors.blue,
  linkDecoration: 'underline',
  // Transitions
  transitionDuration: '0.2s',
  // Horizontal Rule
  hrPrimary: "".concat(calculateRem(4), " solid ").concat(colors.charcoal),
  hrSecondary: "".concat(calculateRem(1), " solid ").concat(colors.charcoal),
  hrTertiary: "".concat(calculateRem(1), " solid ").concat(colors.coolGray3)
};
var oldTheme = _objectSpread$2(_objectSpread$2(_objectSpread$2({
  name: 'Verizon Theme'
}, colors), font), general);

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var newColors = {
  blueInverted: '#0088CE',
  blue: '#0077B4',
  green: '#008330'
};

var colors$1 = _objectSpread$3(_objectSpread$3({}, oldTheme), newColors);

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var verizonTheme = _objectSpread$4(_objectSpread$4({}, oldTheme), colors$1);

var _templateObject$2, _templateObject2, _templateObject3, _templateObject4;
var ButtonsWrapper = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n\n  @media (min-width:601px){\n    display: flex;\n    justify-content: left;\n    margin-top: 40px;\n  }\n\n  @media (max-width:600px){\n    display:block;\n    margin-top: 20px;\n  }\n"])));
var ContentWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: start;\n  max-width: 1232px;\n\n  @media (min-width:601px){\n    width: 100%;\n  }\n"])));
var SpacerDiv = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  height: ", ";\n  width: ", ";\n"])), function (props) {
  return props.height || '20px';
}, function (props) {
  return props.width || '100%';
});
var HeightDiv = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  margin: ", ";\n"])), function (props) {
  return props.margin || '10px 0';
});
var TextWithHtml = function TextWithHtml(props) {
  var children = props.children || '';
  var newProps = _extends({}, props);
  delete newProps.children;
  return /*#__PURE__*/React__default.createElement(Fragment, null, typeof children === 'object' && {
    children: children
  }, typeof children !== 'object' && /*#__PURE__*/React__default.createElement("div", _extends({}, newProps, {
    dangerouslySetInnerHTML: {
      __html: children
    }
  })));
};

var _templateObject$3, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66, _templateObject67, _templateObject68, _templateObject69, _templateObject70, _templateObject71, _templateObject72, _templateObject73, _templateObject74, _templateObject75, _templateObject76, _templateObject77, _templateObject78, _templateObject79, _templateObject80, _templateObject81, _templateObject82, _templateObject83, _templateObject84, _templateObject85, _templateObject86, _templateObject87, _templateObject88, _templateObject89, _templateObject90, _templateObject91, _templateObject92, _templateObject93, _templateObject94, _templateObject95, _templateObject96, _templateObject97, _templateObject98, _templateObject99, _templateObject100, _templateObject101, _templateObject102, _templateObject103, _templateObject104, _templateObject105, _templateObject106, _templateObject107, _templateObject108, _templateObject109, _templateObject110, _templateObject111, _templateObject112, _templateObject113, _templateObject114, _templateObject115, _templateObject116, _templateObject117, _templateObject118, _templateObject119, _templateObject120, _templateObject121, _templateObject122, _templateObject123, _templateObject124, _templateObject125;
var FootnoteBlock = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\nmargin-bottom:10px;\nmargin-top: 10px;\na {\n  color: black;\n  text-decoration: underline;\n  cursor: pointer;\n}\n"])));
var NavInnerSteps = styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n    button{\n      ", "\n      span{\n        height: auto;\n      }\n    }\n"])), function (props) {
  return props.isDark ? "\n        border-color: #D8DADA\n        " : "\n        border-color: #000\n      ";
});
var StyledCheckbox = styled(Checkbox)(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\nfont-weight: bolder;\n\n", "\n"])), function (props) {
  return props.isDark && "\nsvg {\n  stroke: #fff;\n  fill: #fff;\n}\nspan {\n  border-color: #fff ;\n  color:#fff\n}\n  ";
});
var StyledTextLink = styled(TextLink)(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteralLoose(["\n  :hover, :focus{\n    text-decoration: none;\n  }\n"])));
var ContentWrapper$1 = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  margin: 0px -15px -5px -15px\n"])));
var BoldText = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  font-weight: 800;\n  font-size: 1rem;\n"])));
var TitleWrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  padding-top: 15px;\n  width: 100%;\n\n  div:last-child {\n    margin-left: auto;\n  }\n  @media screen and (max-width: 600px) {\n    padding-top: 0px;\n  }\n"])));
var ButtonWrapper = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width: 601px) {\n    height: 60px;\n  }\n  @media screen and (max-width: 600px) {\n    display:none\n  }\n   svg path{\n    ", "\n   }\n"])), function (props) {
  return props.isDark ? "\n      stroke: #D8DADA;\n    " : "\n      stroke: #000;\n    ";
});
var ButtonWrapperMobile = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n  width: 50%;\n  margin:0px auto;\n  @media screen and (min-width: 600px) {\n    display:none\n  }\n"])));
var TextWrapper = styled('Body')(_templateObject0 || (_templateObject0 = _taggedTemplateLiteralLoose(["\n  font-size: 25px;\n  text-align: center;\n  margin-bottom: 10px;\n  overflow: hidden;\n  height: unset;\n  a :active {\n    color:gray !important;\n    border-bottom: 1px solid gray;\n  }\n  a :hover {\n    color:gray  !important;\n    border-bottom: 1px solid gray;\n  }\n\n  @media screen and (max-width: 600px) {\n    margin-left: 5px;\n  }\n"])));
var TroubleShootingTitle = styled.div(_templateObject1 || (_templateObject1 = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width: 601px) {\n    padding: 24px 0 0 0;\n    margin-left: ", ";\n    margin-right: 20px;\n    text-align: ", ";\n  }\n"])), function (props) {
  return props.firstPage ? '300px' : '0px';
}, function (props) {
  return props.firstPage ? 'left' : 'center';
});
var TitleTextWrapper = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n  // text-align: left;\n  // margin-left: 53px;\n  // @media screen and (max-width: 600px) {\n  //   padding: 0px 10px 0px 10px;\n  // }\n  padding-top: 15px;\n  display: flex;\n  align-items: end;\n  justify-content: space-between;\n"])));
var HeadingWrapper = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  position: relative;\n  width: 100%;\n  a {\n    color: black;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n  @media(max-width: 768px) {\n    font-size:1.0rem;\n  }\n  @media screen and (max-width: 600px) {\n    margin-left: 0px;\n    width: 330px;\n    // margin-top: 20px\n  }\n  div.checklist-wrapper {\n    @media screen and (max-width: 600px) {\n      position: absolute;\n    }\n  }\n"])));
var PageTitle = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width:601px) {\n    position: absolute;\n    margin-left: 70px;\n  }\n  @media screen and (max-width: 600px) {\n    margin: 0 0 15px 65px;\n    z-index: 1;\n  }\n"])));
var Cancel = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n  margin-right: 10px;\n"])));
var TabsContainer = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  @media(min-width: 601px) {\n    justify-content: space-between;\n  }\n  @media(max-width: 600px) {\n    flex-direction: column;\n    padding: 0px 15px 0px 15px;\n  }\n"])));
var StepContainer = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  position: relative;\n  justify-content: space-between;\n  @media(min-width: 601px) {\n    padding: 0px 20px;\n    width: 100%;\n  }\n  @media(max-width: 600px) {\n    flex-direction: column;\n    padding: 0px 15px 0px 15px;\n  }\n"])));
var StepInfoContainer = styled.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  @media(min-width: 601px) {\n    // padding-right: ", ";\n    // width: ", ";\n    width: 100%;\n  }\n  .DarkLineBorder{\n    background-color: #D8DADA;\n  }\n\n  .midflowContentWrapper {\n    button {\n      border-color: #a7a7a7;\n    }\n    button:hover {\n      border-color: #ffffff;\n    }   \n    span {\n      background: unset;\n    }\n  }\n\n  .rerun-billing-check {\n    border-color: ", ";\n    overflow: hidden;\n    [class^=\"HitArea\"] {\n      background: ", ";\n    }\n  }\n\n  .nav-steps-history {\n    button {\n      [class^=\"HitArea\"] {\n        background: ", ";\n      }\n    }\n  }\n"])), function (props) {
  return props.hideRightPadding ? '' : '60px';
}, function (props) {
  return props.isNewDesign ? function (props) {
    return props.hideRightNav ? '100%' : '80%';
  } : '100%';
}, function (props) {
  return props.isDark && '#fff';
}, function (props) {
  return props.isDark && 'unset';
}, function (props) {
  return props.isDark && 'unset';
});
var ImageContainer = styled.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteralLoose(["\n  @media(min-width: 601px) {\n    float:left;\n  }\n"])));
var ChangeIssueContainer = styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteralLoose(["\n@media(min-width: 601px) {\n  text-align: left;\n  position: absolute;\n  left : 300px;\n}\n"])));
var DeviceImageContainer = styled.div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  // height: 290px;\n  margin-top: 25px;\n  @media(min-width: 601px) {\n    // width: 40%;\n    margin-top:40px;\n  }\n"])));
var DeviceImage = styled.img(_templateObject20 || (_templateObject20 = _taggedTemplateLiteralLoose(["\n  @media(min-width: 601px) {\n    width: 7%;\n    position: absolute;\n    top: -40px;\n    left: 57px;\n  }\n  @media(max-width: 600px) {\n    width: 12%;\n  }\n"])));
var IssuesContainer = styled.div(_templateObject21 || (_templateObject21 = _taggedTemplateLiteralLoose(["\n  div.question {\n    font-size: 1rem;\n    font-family: 'Verizon-NHG-eDS';\n    font-weight: 400;\n    line-height: 1.25rem;\n    letter-spacing: 0.03125rem;\n    text-decoration: none;\n    margin-bottom: 15px;\n    a{ color: #428bca;  text-decoration : underline;}\n  }\n  @media(min-width:601px) {\n    column-fill: auto;\n    column-count: 1;\n    //margin-top: 30px;\n    margin-bottom: 30px;\n    max-width: ", ";\n  }\n  @media(max-width: 600px) {\n    margin-top: 1rem;\n    margin-bottom: 15px;\n  }\n"])), function (props) {
  return props.isSetFlexColumn ? props.isMvoDigi ? '85%' : '90%' : '600px';
});
var QuesDropdownSelect = styled.div(_templateObject22 || (_templateObject22 = _taggedTemplateLiteralLoose(["\n &.questionDropdown *{\n  ", "\n }\n"])), function (props) {
  return props.isDark ? "\n    background-color: white;\n    color:#000;\n    " : "\n    background: none;\n  ";
});
var ImageTitle = styled.div(_templateObject23 || (_templateObject23 = _taggedTemplateLiteralLoose(["\n  @media(min-width: 601px) {\n    position: absolute;\n    display: inline-block;\n    top: 20px;\n    left: 130px;\n    text-align:start;\n    margin-right: 10px;\n    max-width: 155px;\n  }\n"])));
var MapWrapper = styled.div(_templateObject24 || (_templateObject24 = _taggedTemplateLiteralLoose(["\n  @media(max-width: 600px) {\n    position: relative;\n    padding-bottom: 56.25%; /* 16:9 */\n    padding-top: 25px;\n    height: 0;\n\n    iframe {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n  }\n"])));
var CloseButton = styled.span(_templateObject25 || (_templateObject25 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 25px;\n  top: 25px;\n  cursor: pointer;\n  z-index: 9999;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  @media screen and (max-width: 600px) { }\n"])));
var FeedbackCloseButton = styled.span(_templateObject26 || (_templateObject26 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 20px;\n  top: 12px;\n  cursor: pointer;\n  z-index: 9999;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  @media screen and (max-width: 600px) {\n    right: 25px;\n  }\n"])));
var StyledModal = styled(Modal$1)(_templateObject27 || (_templateObject27 = _taggedTemplateLiteralLoose(["\n", "\n  &[class^=\"ModalDialog-\"] {\n    height: ", ";\n    width: ", ";\n    padding-top: ", ";\n  }\n"])), function (props) {
  return props.theme.isDark && "\n  background-color: " + props.theme.themeObject.background + ";\n  color: " + props.theme.themeObject.textColor + "\n\n  p, h2 {\n  color: " + props.theme.themeObject.textColor + "\n  }\n  path {\n   stroke: " + props.theme.themeObject.textColor + "\n  }\n  #bgColor {\n    color: #FFF !important\n  }\n";
}, isMobile() ? '100%' : '72%', function (props) {
  return props.modalName != "feedback" && (isMobile() ? '100%' : '40%');
}, function (props) {
  return props.modalName != "feedback" ? props.expandModal ? '20px' : '40px' : !isMobile() ? '30px' : '10px';
});
var StyledModalPopup = styled(Modal$1)(_templateObject28 || (_templateObject28 = _taggedTemplateLiteralLoose(["\n   {\n    height: 300px !important;\n    width: 450px !important;\n  }\n  ", "\n"])), function (props) {
  return props.theme.isDark && "\n    #dark-theme-color {\n      color: #FFF !important\n    }\n  ";
});
var StyledEmailModalPopup = styled(Modal$1)(_templateObject29 || (_templateObject29 = _taggedTemplateLiteralLoose(["\n    height: 100% !important;\n    width: 450px !important;\n    @media screen and (max-width: 600px)   {\n      &[class^=\"ModalDialog-\"] {\n        width: 100vw !important};\n        position:fixed  !important;\n        left:0px !important\n      }\n    }\n"])));
var StyledModalBody = styled(ModalBody$1)(_templateObject30 || (_templateObject30 = _taggedTemplateLiteralLoose(["\n  &[class^=\"StyledModalBody-\"] {\n    padding: 0px;\n  }\n"])));
var DescWrapper = styled.div(_templateObject31 || (_templateObject31 = _taggedTemplateLiteralLoose(["\n  p {\n    margin: 0px 0px 10px 0;\n  }\n  h1 div{\n    font-size: initial;\n  }\n  h2 div{\n    font-size: initial;\n    font-weight: bold;\n  }\n  h3 div{\n    font-size: initial;\n  }\n  a {\n    text-decoration: underline\n  };\n  a.btn-link {\n    display: block;\n    margin: 10px 0;\n    padding: 10px;\n    text-decoration: none;\n    text-align: center;\n    min-width: 160px;\n    width: 200px;\n    border-radius: 2.5rem;\n    background-color: black;\n    color: #fff;\n    font-size: 1rem;\n    font-weight: 600;\n    letter-spacing: 0.03125rem;\n    // height: 2.45rem;\n    align-items: center;\n  }\n  a.btn-link:hover{\n    border: none;\n    outline: none;\n  }\n  a.btn-link:hover:not(:active) {\n    outline: none;\n    box-shadow: 0 0 0 0.0925rem #000000;\n    -webkit-transition: ease-out 0.1s;\n    transition: ease-out 0.1s;\n  }\n"])));
var Probing = styled.div(_templateObject32 || (_templateObject32 = _taggedTemplateLiteralLoose(["\nmargin-bottom: ", ";\ndiv[class^=\"StyledInnerCircle-VDS\"] {\n  background:  ", ";\n}\n.radioLabel {\n line-height: 1.25rem;\n  font-family: Verizon-NHG-eDS;\n  padding-right: ", ";\n  font-weight:bold;\n}\n.container  {\n\n  display:inline-block;\n  position:relative;\n  padding-left:35px;\n  margin-bottom:12px;\n  cursor:pointer;\n  line-height: 1.25rem;\n  font-size: 1rem;\n  font-family: \"Verizon-NHG-eDS\";\n  -webkit-user-select:none;\n  -moz-user-select:none;\n  -ms-user-select:none;\n  user-select:none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.container input {\n\n  position:absolute;\n  opacity:0;\n  cursor:pointer\n}\n\n.checkmark{\n\n  position:absolute;\n  top:0;\n  left:0;\n  height:18px;\n  width:18px;\n  border-radius:50%\n}\n\n.container input:focus ~ span.checkmark {\n  ", "\n}\n\n.container:hover input ~ .checkmark {\n  ", "\n}\n\n\n.container input ~ .checkmark {\n  ", "\n}\n\n\n.checkmark:after {\n\n  content: \"\";\n  position:absolute;\n  display:none\n}\n\n\n.container .checkmark:after {\n  ", "\n}\n\n\n\n.container input:checked ~ .checkmark:after {display:block}\n\n"])), function (props) {
  return props.search && '40px';
}, function (props) {
  return props.isDark && 'rgb(255, 255, 255) !important';
}, function (props) {
  return props.search && '50px';
}, function (props) {
  return props.isDark ? "\n  border: 1px dashed #fff;\n  " : "\n  border: 1px dashed gray;\n";
}, function (props) {
  return props.isDark ? "\n    border: 1px solid #fff;\n    " : "\n    border: 1px solid black;\n  ";
}, function (props) {
  return props.isDark ? "\n    border: 1px solid #fff;\n    " : "\n    border: 1px solid black\n  ";
}, function (props) {
  return props.isDark ? "\n    top: 3px;\n    left: 3px;\n    width:10px;\n    height:10px;\n    border-radius:50px;\n    background:#fff;\n    " : "\n    top: 3px;\n    left: 3px;\n    width:10px;\n    height:10px;\n    border-radius:50px;\n    background:black;\n  ";
});
var SearchBar = styled.div(_templateObject33 || (_templateObject33 = _taggedTemplateLiteralLoose(["\n\n  ", "\n\n  margin-bottom:85px\n"])), function (props) {
  return props.isDark ? "\n    @media(min-width:601px){\n      display:flex;\n      border-bottom: 2.5px solid #D8DADA;\n      width:50%;\n      margin-bottom: " + function (props) {
    return props.search && '20px';
  } + ";\n    }\n    @media(max-width:600px){\n      display:flex;\n      border: 1.2px solid black;\n      width:90.5%;\n      margin-bottom:10px\n      height:50px;\n      margin-bottom:20px\n    }\n    svg path{\n      stroke: #D8DADA;\n      fill: #D8DADA;\n    }\n    " : "\n    @media(min-width:601px){\n      display:flex;\n      border-bottom: 2.5px solid black;\n      width:50%;\n      margin-bottom: " + function (props) {
    return props.search && '20px';
  } + ";\n    }\n    @media(max-width:600px){\n      display:flex;\n      border: 1.2px solid black;\n      width:90.5%;\n      margin-bottom:10px\n      height:50px;\n      margin-bottom:20px\n    }\n    svg path{\n      stroke: #000;\n      fill: #000;\n    }\n  ";
});
var SearchResults = styled.div(_templateObject34 || (_templateObject34 = _taggedTemplateLiteralLoose(["\nmargin-bottom: 30px;\n"])));
var SearchTitle = styled.p(_templateObject35 || (_templateObject35 = _taggedTemplateLiteralLoose(["\ncolor: #0082b7;\nfont-size: 18px;\ntext-decoration: underline;\nmargin-bottom: 10px;\ntext-underline-offset: 3px;\ncursor: pointer;\n"])));
var SearchDesc = styled.p(_templateObject36 || (_templateObject36 = _taggedTemplateLiteralLoose(["\np{\n  font-size: 17px;\n}\n"])));
var SearchResultsContainer = styled.div(_templateObject37 || (_templateObject37 = _taggedTemplateLiteralLoose(["\nmargin-bottom: 30px;\n"])));
var IframeContainer = styled.div(_templateObject38 || (_templateObject38 = _taggedTemplateLiteralLoose(["\n@media(min-width:601px){\n    display:flex;\n    width:100%;\n  }\n  @media(max-width:600px){\n    display:flex;\n    border: 1.2px solid black;\n    width:90.5%;\n    margin-bottom:10px\n    height:50px;\n    margin-bottom:20px\n  }\nmargin-bottom:50px\n"])));
var StyledTable = styled(Table)(_templateObject39 || (_templateObject39 = _taggedTemplateLiteralLoose(["\nmargin-bottom: 0;\n"])));
var StyledTableHeader = styled(TableHeader$1)(_templateObject40 || (_templateObject40 = _taggedTemplateLiteralLoose(["\nfont-size: 14px\n"])));
var StyledCell = styled(Cell$1)(_templateObject41 || (_templateObject41 = _taggedTemplateLiteralLoose(["\nfont-size: 14px\n"])));
var StepOption = styled.div(_templateObject42 || (_templateObject42 = _taggedTemplateLiteralLoose(["\n  border: 1px solid lightGray;\n  border-radius: 7px;\n  display: inline-block;\n  float:left;\n  margin-right: 3%;\n  cursor: pointer;\n  flex-direction: column;\n  height: 55px;\n  justify-content: center;\n  padding-left: 14px;\n  padding-top: 13px;\n  padding-bottom: 13px;\n  padding-right: 14px;\n  width: 335px;\n\n  :not(:first-child) {\n    margin-top: 15px;\n  }\n"])));
var IssueBoxWrapper = styled.div(_templateObject43 || (_templateObject43 = _taggedTemplateLiteralLoose(["\n  display: flex;\n"])));
var IssueContentbox = styled.div(_templateObject44 || (_templateObject44 = _taggedTemplateLiteralLoose(["\n  @media (min-width: 601px) {\n    width: 344px;\n  }\n\n  @media (max-width: 600px) {\n    width: 304px;\n  }\n  cursor: pointer;\n  justify-content: left;\n"])));
var IssueContentArrow = styled.div(_templateObject45 || (_templateObject45 = _taggedTemplateLiteralLoose(["\n  @media (min-width: 601px) {\n    width: 40px;\n  }\n\n  @media (max-width: 600px) {\n    width: 30px;\n  }\n  position: absolute;\n  cursor: pointer;\n  justify-content: right;\n  display: inline-flex;\n  align-items:flex-end;\n  right:10px;\n  bottom:5px;\n  /*padding-top: 32px;*/\n"])));
var ButtonContainer = styled.div(_templateObject46 || (_templateObject46 = _taggedTemplateLiteralLoose(["\n  div.question {\n    font-size: 1rem;\n    font-family: 'Verizon-NHG-eDS';\n    font-weight: 400;\n    line-height: 1.25rem;\n    letter-spacing: 0.03125rem;\n    text-decoration: none;\n    margin-bottom: 15px;\n    a{ color: #428bca;  text-decoration : underline;}\n  }\n  @media(min-width:601px) {\n    column-fill: auto;\n    column-count: 1;\n    //margin-top: 30px;\n    margin-bottom: 30px;\n  }\n  @media(max-width: 600px) {\n    margin-top: 1rem;\n    margin-bottom: 15px;\n  }\n  \n\n"])));
var ContentBody = styled.div(_templateObject47 || (_templateObject47 = _taggedTemplateLiteralLoose(["\n#bannerSuccessThemeDark * {\n  ", "\n}\n#bannerErrorThemeDark * {\n  ", "\n}\nborder-top:2px solid hsl(180deg 3% 85%);\nwidth: calc(100% - 3px);\n  margin-bottom: 4rem;\n   height: 610px;\n  overflow-y: auto;\n  ", "\n"])), function (props) {
  return (props === null || props === void 0 ? void 0 : props.isDark) && "background-color: rgb(0, 53, 20) !important;";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.isDark) && "background-color: rgb(86, 23, 1) !important;";
}, function (props) {
  return props.theme.themeId === 'theme_dark' ? "\n  background-color: " + props.theme.themeObject.background + " !important;\n  &::-webkit-scrollbar {\n    display: block !important;\n    width: 6px !important;\n    background: " + props.theme.themeObject.background + " !important;\n    border-radius: 4px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: #acacac;\n    border-radius: 4px;\n  }\n  " : "\n  background-color: #fff;\n  &::-webkit-scrollbar {\n    display: block !important;\n    width: 6px !important;\n    background: #dedcdc;\n    border-radius: 4px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: #acacac;\n    border-radius: 4px;\n}\n ";
});
var CopyIconDiv = styled.div.attrs({
  'data-track': 'copy external URL of TS article'
})(_templateObject48 || (_templateObject48 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  margin-right: 5px;\n  svg{\n    pointer-events: none;\n  }\n"])));
var EmailIconDiv = styled.div.attrs({
  'data-track': 'send email of TS article'
})(_templateObject49 || (_templateObject49 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  svg{\n    pointer-events: none;\n  }\n"])));
var SmsIconDiv = styled.div.attrs({
  'data-track': 'send SMS of TS article'
})(_templateObject50 || (_templateObject50 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  padding-right: 2px;\n  svg{\n    pointer-events: none;\n  }\n"])));
var ResumeEmailIconDiv = styled.div.attrs({
  'data-track': 'send resume TS email'
})(_templateObject51 || (_templateObject51 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  svg{\n    pointer-events: none;\n  }\n"])));
var Footer = styled.div(_templateObject52 || (_templateObject52 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (props) {
  return props.isDark ? "\n      background-color: #000 !important;\n     \n      width:100%;\n      position: fixed;\n      bottom:0;\n      z-index:0;\n      padding: 0px 20px 10px 20px;\n\n      div{\n        background-color: #000;\n        span{\n          background-color: #000;\n        }\n        button{\n          // border: 1px solid #fff;\n          color: #000;\n          background-color: #fff;\n        }\n        img{\n          background-color: #000;\n        }\n      }\n\n      .ebAwXT {\n        padding: 0 70px;\n      }\n\n      .etCvPo{\n        margin-left:0;\n      }\n\n     \n\n      .eoptfu span {\n        font-family: Verizon-NHG-eDS !important;\n      }\n      .QTMEZ{\n        font-family: Verizon-NHG-eDS;\n      }\n\n      .footer-line {\n        width: 100%;\n        height: 2px;\n        background-color: '#fff';\n      }\n      \n      }\n\n\n    " : "\n      \n      width:100%;\n      position: fixed;\n      bottom:0;\n      z-index:0;\n      padding: 0px 20px 10px 20px;\n      background-color: #fff;\n\n\n      .footer-line {\n        width: 100%;\n        height: 2px;\n        background-color: gray;\n      }\n\n      .ebAwXT {\n        padding: 0 70px;\n      }\n\n      .etCvPo{\n        margin-left:0;\n      }\n\n      .eoptfu span {\n        font-family: Verizon-NHG-eDS !important;\n      }\n      .QTMEZ{\n        font-family: Verizon-NHG-eDS;\n      }\n      @media screen and (max-width:601px){\n        width:100vw;\n        height:70px;\n      }\n\n    ";
});
var HeaderTabContainer = styled.div(_templateObject53 || (_templateObject53 = _taggedTemplateLiteralLoose(["\n\n  height:50px;\n  position: sticky;\n  position: -webkit-sticky;\n  background-color:#ffffff;\n  top:0;\n  z-index:100;\n  font-family: 'Verizon-NHG-eDS';\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: 0px;\n  padding: 0px 70px;\n\n  .mcTmv{\n    width:100%;\n    padding:0;\n    margin-left:20px;\n\n    button{\n      letter-spacing: 0.5px;\n    }\n    .kwonIF{\n      color: #6F7171;\n    }\n  }\n"])));
var NavStepsContainer = styled.div(_templateObject54 || (_templateObject54 = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width:601px){\n    display:flex;\n    position: relative;\n    width: auto;\n    justify-content: space-between;\n    align-items: center;\n  }\n  font-family: 'Verizon-NHG-eDS';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: 0px;\n  div.articalId {\n    text-align: right;\n    font-weight: normal;\n    @media screen and (max-width: 600px)   {\n      text-align: left;\n      width: 100%;\n      margin-bottom:10px;\n    }\n  }\n\n\n  ", "\n"])), function (props) {
  return props.isDark && "\n  #nav-step-dark {\n    background-color : #202229 !important;\n  }\n  path {\n    fill: #fff;\n    stroke: #fff;\n  }\n  button{\n    border-bottom: 1px solid #fff;\n  }\n  div {\n    background-color : #202229;\n  }\n  ";
});
var NavStepsWrapper = styled.div(_templateObject55 || (_templateObject55 = _taggedTemplateLiteralLoose(["\ndisplay: flex;\nalign-items: center;\npadding-bottom:15px;\n@media screen and (max-width:600px){\n  align-items: normal;\n  flex-direction: column;\n  gap: 10px;\n}\n\n", "\n"])), function (props) {
  return props.isDark && "\n  div div {\n  background-color : #202229;\n  }\n  ";
});
var TroubleShootingTitleNew = styled.div(_templateObject56 || (_templateObject56 = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    margin-bottom: 15px;\n    flex: 1;\n    padding-left: 20px;\n    padding-top: 28px;\n    @media screen and (max-width: 601px) {\n      padding-left:   15px;\n    }\n  // @media screen and (min-width: 601px) {\n  //   padding: 0 15px 0 ;\n  //   margin-left: '0px';\n  //   margin-right: 20px;\n  //   width: 84%;\n  //   display: inline-block;\n  //   margin-bottom: 15px;\n  // }\n  // @media screen and (max-width: 601px) {\n  //   padding: 24px 15px 0 ;\n  //   margin-left: '0px';\n  //   text-align: left;\n  //   width: 70%;\n  //   display: inline-block;\n  // }\n"])));
var NewPageTitle = styled.div(_templateObject57 || (_templateObject57 = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width:601px) {\n    position: relative !important;\n    margin-left: 23px !important;\n    display: flex;\n    align-items: center;\n  }\n  @media screen and (max-width:600px) {\n    position: relative;\n    margin-top:15px;\n    margin-bottom:15px\n  }\n"])));
var RightMenuContainer = styled.nav.attrs({
  className: 'RightMenuContainer'
})(_templateObject58 || (_templateObject58 = _taggedTemplateLiteralLoose(["\n  @media(min-width: 601px) {\n    a.right-menu-item{\n      display: block;\n      padding: 10px 15px;\n      cursor: pointer;\n      border-left: 1px solid silver;\n      font-family: 'Verizon-NHG-eDS';\n      font-weight: 700;\n      font-size: 16px;\n      line-height: 20px;\n      letter-spacing: 0.5px;\n      color:#6F7171;\n      position:relative;\n    }\n    /* a.rmi-selected{\n      color: #000000;\n    }\n    a.rmi-selected:before{\n      content:\"\";\n      border-left: 3px solid red;\n      position: absolute;\n      left: 0;\n      height: 100%;\n      top: 0;\n    } */\n  }\n"])));
var DescWrapperNew = styled.div(_templateObject59 || (_templateObject59 = _taggedTemplateLiteralLoose(["\n\n  table {\n    border-spacing: 0\n  }\n\n  table th, table td {\n    border: 1px solid grey;\n    padding: 5px;\n  }\n\n  table thead tr.row, table tbody tr.row {\n    display: table-row;\n  }\n\n  [data-outputclass=\"video\"] {\n    background-repeat: no-repeat;\n    background-position: 0 4px;\n    background-size: 16px 12px;\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAAvCAYAAACrKzemAAAACXBIWXMAAC4jAAAuIwF4pT92AAAB80lEQVRoge2b0VHCQBCG/3V8hw6kA+lArEA6gBKwArACxwrEDrQD7QA70A60gnXOOZhk3buLRxgddr+ZPHBJLuSf3MdeEggA47i5ZObnfc+QiNYnRx5ULxDRHMDMwypARGMA92ErDysDEQ0B7IbwqbLpJ4DNf/iyFYwAnPXYXwhqsP2ghbVh5skhzuTQENEKwLKPwwShAzhvtvkwVNgKXa7xsARNoUs8rAZS6BIPq01L6BIPK6IJXeJhZYQuMR9WTugS02GVhC6xfmWlhP4E4EU2mg0rI/RXAHNtH5NhZYQe5sVzZv7Q9jMXVkHoIajkTQRTYRWEfsPMj7n9rV1ZSaEz86q0s5mwaoQuMRFWrdAlFsKqFrrEQli3ifaHktAlFsK6jsNNMiOi6W86shBWGGaLxLp1rLs6YULwzBx+Ce+UVYMY2LBLP2ZKB2ZeaJPjWE6su/RhrSgNjnpX2q/iY7QspsKK9dQ0IfxlSfjmJtKxrqoSvslbNLXCN3vzr0b42rsOlpjGOky+THKlZWD6HnxB+D+w/sCiJPwW5sNCXvgtPKxIRvg7PKw2qQr/Gw+rQUn4HpYgJ3wPSyElfK0oHRPR3v9I+CNGfR02CD/OEy9a7Ue+TJgZNQuAMEd82+bjwzCDFL6HVaApfOsT6U4E4RPR+AvHogDkc3GOcQAAAABJRU5ErkJggg==);\n    div {\n      margin-left: 25px;\n    }\n  }\n  section.section h2 {\n    cursor: pointer;\n    font-family: 'Verizon-NHG-eDS';\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 20px;\n  }\n\n  .arrow-down span {\n    ", "\n  }\n\n  .step {\n    margin-bottom:32px\n  }\n\n  .arrow-up span {\n    ", "\n  }\n\n  ol.steps {\n    counter-reset: li;\n  }  \n\n  ol.steps li.step {\n    position: relative;\n    list-style-type: none;\n  }\n\n  ol.steps li.step:before {\n    position: absolute;\n    left: -56px;\n    top: 5px;\n    content: counter(li);\n    counter-increment: li;\n    color: ", ";\n    font-weight:700;\n    font-size: 36px;\n  }\n\n  div.Troubleshooting-Steps div.accordion h2 {\n    cursor: pointer;\n    display: flex !important;\n    align-items: center;\n    font-weight: bold;\n  }\n  p {\n    margin: 0px 0px 10px 0;\n  }\n  h1 div {\n    font-size: initial;\n  }\n  h2 div {\n    font-size: initial;\n    font-weight: bold;\n  }\n  h3 div {\n    font-size: initial;\n  }\n  a {\n    text-decoration: underline;\n    font-family: 'Verizon-NHG-eDS';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    letter-spacing: 0px;\n    color: blue\n  };\n\n  .accordion {\n    margin-top: ", ";\n    border-top: ", ";\n  }\n\n  .accordion .title{\n    margin-top: 10px;\n  }\n\n  .note {\n    margin-top: ", ";\n    border-top: ", ";\n  }\n\n  .note .ul, .accordion .ul{\n    padding-left:25px;\n    margin-left:0;\n  }\n\n  .note .ul .li, .accordion .ul .li{\n    margin-bottom:16px;\n  }\n  .note .ul .li:last-child{\n    margin-bottom:0;\n  }\n\n  .note h2.title {\n    position: relative;\n    margin-top: 10px;\n  }\n\n  .arrow{\n    position: relative;\n    display: block !important;\n  }\n  .arrow span{\n    right: .25rem !important;\n    top: 0px;\n  }\n\n  .ol.steps {\n    padding-left: 56px;\n    border-top:  ", ";\n    padding-top: 12px;\n    margin-top: 2rem;\n  }\n\n  .note, .steps  {\n    font-family: 'Verizon-NHG-eDS';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    letter-spacing: 0px;\n  }\n\n  div[data-outputclass=\"line-note\"]::before, span[data-outputclass=\"line-note\"]::before,\nli[data-outputclass=\"line-note\"]::before,\n.ph[data-outputclass=\"line-note\"],\na[data-outputclass=\"line-note\"]::before {\n    content: '';\n    background: ", ";\n    display: inline-block;\n    background-size: 14px 11px;\n    width: 17px;\n    height: 12px;\n}\n\n.menucascade div > *::after {\n    content: '';\n    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAA7CAYAAAAXdfjrAAAACXBIWXMAAC4jAAAuIwF4pT92AAABZ0lEQVRo3s3a240CMQwF0GsqoJNtgVKmtNlOKIFStgPzAxJi5xEn19dBytcEcWTytMfcHTN+LkcPzew6HczMVgD3Mpy7/2sAVgD+ag8A161+me0MVYZrQZXgWlFyXAQlxb1n5T0wX34ks/Xjr1wCUUuP3Pfgnwa3tVxMgdtbYMtx+w+KcccPC3HnHYpwbZ0KcO0dxbhYZyEu/gURri/MAlz/4EzGjU3pRNz4QpiE42wfCTjepkvGcY8qRBz/gEfC5RyLCbi869cg7pJ4z7kF+z/c/e8wd0GI1hqM1qoY/MOojOWCgmIvsDQUc0uiolibOB3FOPakoEYPimmokaN1Kqr3MpKO6rm+SVDRC68MFUkRSFGtSRU5qiUNVYI6S9yVoY5SnaWoSC1JiorWkmSonlqSBNVbS0pH9daSft19kVV4G++B6ZHqqSXJUJFakhTVWkuSo9wdtvdCiJktAG6Sgb71+7O+qfIE2AZ/1PVQRysAAAAASUVORK5CYII) no-repeat;\n    display: inline-block;\n    background-size: 5px 8px;\n    width: 8px;\n    height: 9px;\n    position: relative;\n    margin-left: 2px;\n}\n\n.menucascade div > :last-child::after {\n    content: none;\n}\n\n.uicontrol {\n    font-weight: bold;\n}\n\n.scroll.troubleshoottabarea {\n  overflow: scroll;\n  height: 660px;\n}\n"])), function (props) {
  return props.isDark ? "\n\n      caret-color:transparent;\n      position:absolute;\n      right:25%;\n      transform: rotate(315deg);\n      border:none;\n      width:10px;\n      height:10px;\n      border-left: 1px solid #D8DADA;\n      border-bottom: 1px solid #D8DADA;\n      cursor: pointer;\n      " : "\n      caret-color:transparent;\n      position:absolute;\n      right:25%;\n      transform: rotate(315deg);\n      border:none;\n      width:10px;\n      height:10px;\n      border-left: 1px solid black;\n      border-bottom: 1px solid black;\n      cursor: pointer;\n    ";
}, function (props) {
  return props.isDark ? "\n\n      caret-color:transparent;\n      position:absolute;\n      transform: rotate(135deg);\n      right:25%;\n      width:10px;\n      height:10px;\n      border:none;\n      border-left: 1px solid #D8DADA;\n      border-bottom: 1px solid #D8DADA;\n      cursor: pointer;\n    " : "\n      caret-color:transparent;\n      position:absolute;\n      transform: rotate(135deg);\n      right:25%;\n      width:10px;\n      height:10px;\n      border:none;\n      border-left: 1px solid black;\n      border-bottom: 1px solid black;\n      cursor: pointer;\n    ";
}, function (props) {
  return props.isDark ? "#fff" : "#000";
}, function (props) {
  return props.segments ? 0 : '2rem';
}, function (props) {
  return props.isDark ? '1px solid #D8DADA' : '1px solid #000000';
}, function (props) {
  return props.segments ? 0 : '2rem';
}, function (props) {
  return props.isDark ? '1px solid #D8DADA' : '1px solid #000000';
}, function (props) {
  return props.isDark ? '1px solid #fff' : '1px solid black';
}, function (props) {
  return props.isDark ? 'url(data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAFsAAABbCAYAAAAcNvmZAAAACXBIWXMAAC4jAAAuIwF4pT92AAACWklEQVR4nO3d703DMBQE8APxvWxCRmAENqBMBmzABrAB7SZ0gqKoqaBq/lVNLu/87r5UqqU2+slynfjZvdnv93A4ubUzL8YmxtjEGJsYYxNjbGKMTYwi9huADYD7ANdyUdSwa+hnAA8AvtTAlbCP0MfIgavcrlcAvjvatgAeAfyQr+niqPTseox+6WiT6eFqw4g0uOIPpCy46tRPElz1pkYSXPkOcgx4Rb6m3pSwUrMG8NrRtmumhRvyNbWmhGcjfT18FamHl/IgSgK8pKd+4cFLe8QaGrzE59lhwUtdPAgJXnqRTtXArlra6NPC0pfFNg3orqWN3sMzrEGGAc+y4BsCPNPq+uLg2UoZFgXPWDeyGHjWIp1FwDNXRNHBs5efUcGzY4MJbuxDKODG/svs4MY+zazgxj7PbODGbs8s4MbuzuTgxu7PpOBDKzX1F31Oe/3FZfSKj3v29Rndw409TWrwj6FPMvY0qYeSp6FPMvb1GT1m+7yR4UxWDuGe3Z9J606M3Z3JC3yM3Z5ZKqmMfZ7ZStaMfZpZawON/ZfZizCNfQil2tXYxLLi7NjU+u3M2PRC+azYi+xIyIi92NaPbNiL7rHJhL34ZqYs2CF2jWXADrM9r3Rs74MkZR0Jus4d88uICXngS4k9O+zJOqVhhz7CqCTs8GdFlYItcShXCdg+/YyUPuhtJGiIT/3GQIc65lm1Z8tBQxRbEhqC2LLQEMOWhob/84Abpf88eG95XwYagsPIf3ApaAjOs9fNa6UGDW/z4CZ7+Rk1xibG2MQYmxhjE2NsYozNCoBfpbTirVEjrqcAAAAASUVORK5CYII) no-repeat' : 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAYAAAA4TnrqAAAACXBIWXMAAC4jAAAuIwF4pT92AAAB3UlEQVR4nO3c203EQAyF4X+oYDuBEuiEpQNKoQOWTrYDoBM6GBQE0YKIyGUux3aOlKdRlNEnO0+WU84ZpaSUTsANcJtzfle625XAHcZ8Qd0B18A5pXQQudpnZLAuoL4jBybRhimloe1eJo7fVFpSorJyzq/A/cSxTIXJtGHO+aQOJvWDVweTwkIcTA4LYTBJLETBZLEQBJPGQgxMHgshMBNYiICZwUIAzBQWncHMYdERzCQWncDMYtEBzDQWjcHMY9EQzAUWjcDcYNEAzBUWlcHcYVERzCUWlcDcYlEBzDUWhcHcY1EQLAQWhcDCYFEALBQWG8HCYbEBLCQWK8HCYrES7Dy8tz+TzzAOdRjm2EJX1syMFbZjzcsA9rhjzcswqvmwY/2fcaZVbg6+dVJKR+Bp4rM/hn9DV9YSKCJjLYUiKtYaKCJirYUiGtYWKCJhbYUiClYJKCJglYLCO1ZJKDxjlYbCK1YNKDxi1YLCG1ZNKDxh1YbCC1YLKDxgtYLCOlZLKCxjtYbCKlYPKCxi9YLCGlZPKCxh9YbCCpYCFBawVKBQx1KCQhlLDQpVLEUoFLFUoRDc+ScLhdjOP2ko9p1/y6K08+/5jyMZKMR2/h1/gUlBodKGl5HdgAt8AN7+5IYhtq+7AAAAAElFTkSuQmCC) no-repeat';
});
var DescInnerWrapper = styled.div(_templateObject60 || (_templateObject60 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  @media (max-width: 768px) {\n    flex-direction: column-reverse;\n  }\n"])));
var DescBodyWrapper = styled.div(_templateObject61 || (_templateObject61 = _taggedTemplateLiteralLoose(["\n  flex:1;\n  .table{\n  color:", "\n  }\n"])), function (props) {
  return (props === null || props === void 0 ? void 0 : props.isDark) && '#fff';
});
var IconImage = styled.img(_templateObject62 || (_templateObject62 = _taggedTemplateLiteralLoose(["\n  padding: 20px 0 0 10px;\n  cursor: pointer;\n  width: 30px;\n  height: 30px;\n"])));
var IconDownloadEmail = styled.div(_templateObject63 || (_templateObject63 = _taggedTemplateLiteralLoose(["\n    display: inline-block;   \n    margin-bottom: 8px;\n    @media screen and (max-width: 601px) {\n      padding-right: 15px;\n    }\n  // @media screen and (min-width: 601px) {\n  //   width: 10%;\n  //   display: inline-block;\n  // }\n  // @media screen and (max-width: 601px) {\n  //   width: 20%;\n  //   display: inline-block;\n  // }\n"])));
var DownloadImage = styled.img(_templateObject64 || (_templateObject64 = _taggedTemplateLiteralLoose(["\n  padding: 5px 0 0 10px;\n  cursor: pointer;\n  width: 25px;\n  height: 25px;\n"])));
var EmailImage = styled.img(_templateObject65 || (_templateObject65 = _taggedTemplateLiteralLoose(["\n  padding: 5px 0 0 10px;\n  cursor: pointer;\n  width: 18px;\n  height: 13px;\n"])));
var BillingSteps = styled.div(_templateObject66 || (_templateObject66 = _taggedTemplateLiteralLoose(["\n  display: flex;\n"])));
var DropdownWrapper = styled.div(_templateObject67 || (_templateObject67 = _taggedTemplateLiteralLoose(["\nwidth: 350px;\n ", "\n"])), function (props) {
  return props.isDark && "\n path {\n  fill: #fff;\n  stroke: #fff;\n }\n select {\n  border-bottom: 1px solid #fff;\n    border-top: 1px solid #fff;\n }\n ";
});
var getActionsWrapperStyles = function getActionsWrapperStyles(props) {
  var styles = 'justify-content: center;\n';
  if (props.showNext || props.showPrevious) {
    styles = 'justify-content: space-between;\n';
  } else if (props.alignButtons !== 'center') {
    if (props.alignButtons === 'left') {
      styles = 'justify-content: flex-start;\n';
    } else if (props.alignButtons === 'right') {
      styles = 'justify-content: flex-end;\n';
    }
  }
  if (props.disableMargin) {
    styles = 'margin-left: -50px;\n';
  }
  return styles;
};
var getButtonsWrapperStyles = function getButtonsWrapperStyles(props) {
  var styles = '';
  if (props.stackButtons) {
    styles += 'align-items: center;\n';
    styles += 'flex-direction: column;\n';
    styles += 'justify-content: center;\n';
  }
  return styles;
};
var ActionsWrapper = styled.div(_templateObject68 || (_templateObject68 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: flex-end;\n  justify-content: ", ";\n  ", "\n  width: 100%;\n  height:100%;\n  a.nextBtnAnchorSilver { color: silver !important; }\n  a.nextBtnAnchorWhite { color: #000 !important; }\n  a.NextBtn{\n    display: flex;\n    padding-left:25px;\n    margin-top: 10px;\n    margin-left:15px;\n    cursor: pointer;\n    border-left:1px solid #000;\n    border-bottom: none;\n  }\n  a.PrevBtn{\n    padding-right:10px;\n    display: flex;\n    margin-top: 10px;\n    margin-left: 0px;\n    cursor: pointer;\n    border-bottom: none;\n  }\n  a.NextBtn:hover, a.PrevBtn:hover{\n    border-bottom: none;\n    text-decoration: none;\n  }\n  a.NextBtn:hover svg,a.PrevBtn:hover svg{\n    transition: none;\n    -webkit-transition: none;\n    left:0;\n  }\n  a.NextBtn svg path, a.PrevBtn svg path{\n   stroke-width: 2px;\n  }\n  a.NextBtn:active svg g path, a.PrevBtn:active svg g path{\n    stroke: #ffffff;\n  }\n  button.Actionbtn{\n    border:none;\n    padding-right: 20px;\n    padding-left: 20px;\n    min-width:100px;\n    height:33px;\n    margin-top:0px;\n    margin-left:10px;\n    font-weight: normal;\n    background-color:#ffffff;\n    color:#000;\n    margin-right: 24px;\n    font-weight: 700;\n  }\n  button.Actionbtn:active{\n    background-color:#ffffff;\n    color: #000;\n  }\n  button.Actionbtn:hover:not(:active){\n    box-shadow: none;\n    transition: none;\n    -webkit-transition: none;\n  }\n\n  @media (max-width: 600px){\n    .NextBtn{\n    margin-top: 30px;\n    margin-right: 30px;\n    }\n    .PrevBtn{\n        margin-top: 30px;\n        margin-left: 30px;\n    }\n  }\n"])), function (props) {
  return props.showNext || props.showPrevious ? 'space-between' : 'center';
}, function (props) {
  return getActionsWrapperStyles(props);
});
var NewPreviousButtonWrapper = styled.div(_templateObject69 || (_templateObject69 = _taggedTemplateLiteralLoose(["\n  display:flex;\n  align-items: center;\n"])));
var ButtonsWrapper$1 = styled.div(_templateObject70 || (_templateObject70 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  column-gap: 15px;\n  ", "\n\n   .footerThumbsCover {\n    background-color: lightgrey;\n    border-radius: 17px;\n    width: 30px;\n    display: flex;\n  }\n    \n  .footerThumbsCover svg {\n   margin: auto\n  }\n\n  .footer-thumbs-up {\n    cursor: ", ";\n    opacity: ", "\n  }\n  .footer-thumbs-down {\n    cursor: ", ";\n    opacity: ", "\n  }\n     \n"])), function (props) {
  return getButtonsWrapperStyles(props);
}, function (props) {
  return props.thumbsUpClicked || props.submitClicked ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.submitClicked ? '50%' : 'none';
}, function (props) {
  return props.submitClicked || props.thumbsUpClicked ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.thumbsUpClicked ? '50%' : 'none';
});
var Next = styled.div(_templateObject71 || (_templateObject71 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 10px;\n  margin-right: 56px;\n  @media (max-width: 600px){\n    margin-top: 30px;\n    margin-right: 30px;\n  }\n  cursor: pointer;\n"])));
var Previous = styled.div(_templateObject72 || (_templateObject72 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 10px;\n  margin-left: 50px;\n  @media (max-width: 600px){\n    margin-top: 30px;\n    margin-left: 30px;\n  }\n  cursor: pointer;\n  ", "\n"])), function (props) {
  return props.isDark ? "\n    svg path{\n      stroke: #D8DADA;\n    }\n    " : "\n    svg path{\n      stroke: #000;\n    }\n  ";
});
var StyledButton$1 = styled(Button$1)(_templateObject73 || (_templateObject73 = _taggedTemplateLiteralLoose(["\n  min-width: ", ";\n\n  span {\n    overflow: visible !important;\n    width: fit-content !important;\n  }\n\n  @media (min-width: 601px) {\n    :not(:last-child) {\n      margin-right: 14px;\n    }\n  }\n\n  [class^=\"StyledChildWrapper-\"] {\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  @media (max-width: 600px){\n    margin-top: 10px;\n    align-items: center;\n    :not(:first-child) {\n    }\n\n    font-size: 14px;\n    padding: 0;\n    margin-bottom: 20px!important;\n  }\n"])), function (props) {
  return props.minWidth ? props.minWidth : '50%';
});
var StyledTextLinkCaret = styled(TextLinkCaret)(_templateObject74 || (_templateObject74 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (props) {
  return props.isDiabled && "\n  * {\n      cursor: not-allowed !important;\n    }";
});
var NextNew = styled(TextLinkCaret)(_templateObject75 || (_templateObject75 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  border-left:1px solid #ffffff;\n  padding-left:25px;\n  margin-top: 10px;\n  margin-left:15px;\n\n  @media (max-width: 600px){\n    margin-top: 30px;\n    margin-right: 30px;\n  }\n  cursor: pointer;\n\n  ", "\n"])), function (props) {
  return props.isDiabled && "\n    *{\n      cursor: not-allowed !important;\n    }";
});
var PreviousNew = styled(TextLinkCaret)(_templateObject76 || (_templateObject76 = _taggedTemplateLiteralLoose(["\n  padding-right:10px;\n  display: flex;\n  margin-top: 10px;\n  margin-left: 50px;\n  @media (max-width: 600px){\n    margin-top: 30px;\n    margin-left: 30px;\n  }\n  cursor: pointer;\n\n  ", "\n"])), function (props) {
  return props.isDiabled && "\n    *{\n      cursor: not-allowed !important;\n    }\n  ";
});
var NewBtnWrapper = styled.div(_templateObject77 || (_templateObject77 = _taggedTemplateLiteralLoose(["\n  display:flex;\n  width:100%;\n  justify-content:space-between;\n  align-self: center;\n  #acss-footer-next-previous a:hover {\n    text-decoration: unset;\n    color: unset !important;\n  }\n  #acss-footer-next-previous a.darkTextLinkCaret span {\n    color: #333333 !important;\n  }\n"])));
var NewActionButton = styled.button(_templateObject78 || (_templateObject78 = _taggedTemplateLiteralLoose(["\n  background-color:", " !important;\n  border-radius:50px;\n  border:none;\n  min-width:100px;\n  height:25px;\n  margin-top:5px;\n  margin-left:10px;\n  font-size: 13px;\n  padding: 2px;\n  font-weight: bold;\n  cursor: ", ";\n"])), function (props) {
  return props.disabled ? 'lightgrey' : '#fff';
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
});
var NewActionButtonWrapper = styled.div(_templateObject79 || (_templateObject79 = _taggedTemplateLiteralLoose(["\n  display:flex;\n  align-items: center;\n  column-gap: 15px;\n"])));
var IconImageUp = styled.img(_templateObject80 || (_templateObject80 = _taggedTemplateLiteralLoose(["\n  margin-left: 20px;\n  padding-top: 6px;\n  cursor: ", ";\n  opacity: ", "\n"])), function (props) {
  return props.thumbsUpClicked || props.submitClicked ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.submitClicked ? '50%' : 'none';
});
var IconImageDown = styled.img(_templateObject81 || (_templateObject81 = _taggedTemplateLiteralLoose(["\n  margin-left: 20px;\n  padding-top: 6px;\n  cursor: ", ";\n  opacity: ", "\n"])), function (props) {
  return props.submitClicked || props.thumbsUpClicked ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.thumbsUpClicked ? '50%' : 'none';
});
var LeftIcon = styled.span(_templateObject82 || (_templateObject82 = _taggedTemplateLiteralLoose(["\n  caret-color:transparent;\n  transform: rotate(225deg);\n  margin-top:3px;\n  width:8px;\n  height:8px;\n  border:none;\n  border-left: 2px solid #ffffff;\n  border-bottom: 2px solid #ffffff;\n  cursor: pointer;\n"])));
var Divider = styled.span(_templateObject83 || (_templateObject83 = _taggedTemplateLiteralLoose(["\n  border-left:1px solid #BFBFBF;\n  padding:17px 0;\n"])));
var LeftIconDisabled = styled.span(_templateObject84 || (_templateObject84 = _taggedTemplateLiteralLoose(["\n  caret-color:transparent;\n  transform: rotate(225deg);\n  margin-top:3px;\n  width:8px;\n  height:8px;\n  border:none;\n  border-left: 2px solid silver;\n  border-bottom: 2px solid silver;\n  cursor:not-allowed;\n"])));
var RightIcon = styled.span(_templateObject85 || (_templateObject85 = _taggedTemplateLiteralLoose(["\n  caret-color:transparent;\n  transform: rotate(45deg);\n  margin-top:3px;\n  width:8px;\n  height:8px;\n  border:none;\n  border-left: 2px solid #ffffff;\n  border-bottom: 2px solid #ffffff;\n  cursor: pointer;\n"])));
var RightIconDisabled = styled.span(_templateObject86 || (_templateObject86 = _taggedTemplateLiteralLoose(["\n  caret-color:transparent;\n  transform: rotate(45deg);\n  margin-top:3px;\n  width:8px;\n  height:8px;\n  border:none;\n  border-left: 2px solid silver;\n  border-bottom: 2px solid silver;\n  cursor: not-allowed;\n"])));
var StyledDropdownItem = styled(DropdownItem)(_templateObject87 || (_templateObject87 = _taggedTemplateLiteralLoose(["\n  &&& {\n    background: ", ";\n    color: ", ";\n    padding: 10px !important;\n    border-bottom: 1px solid #D8DADA;\n    border-top: 1px solid #D8DADA;\n    margin: 0;\n    min-height: 20px !important;\n    font-size: 14px !important;\n    font: normal 14px tahoma,arial,verdana,sans-serif;\n    line-height: 20px;\n    font-weight: normal!important;\n    border-left: ", ";\n  }\n"])), function (props) {
  return props.isDark ? 'black' : '#ffffff';
}, function (props) {
  return props.isDark ? '#ffffff' : 'black';
}, function (props) {
  return props.isDark ? '4px solid black' : '4px solid #FFF';
});
var DividerWrapper = styled.span(_templateObject88 || (_templateObject88 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-left: 20px;\n  align-self: center;\n"])));
var DropdownSelectWrapper = styled.div(_templateObject89 || (_templateObject89 = _taggedTemplateLiteralLoose(["\n  * {\n    background-color:  ", " !important;\n    font-weight: normal;\n    color: #fff;\n  }\n  button{\n    margin:5px !important\n  }\n  button span{\n    border-bottom: none !important;\n  }\n  svg g polygon{\n    fill: #fff !important;\n  }\n  height: 33px;\n  font-weight: normal;\n  margin:3px !important;\n  border: 1px solid #fff !important;\n  border-radius: 20px !important;\n  color: #fff !important;\n\n  .editable-dropdown-input {\n    font-weight:normal;\n    font-size:14px !important;\n    color: #fff !important;\n    margin :3px !important;\n  }\n\n  :focus-visible {\n    outline: 0.0625rem dashed #fff !important;\n    height: 33px;\n    font-weight: normal;\n    margin:3px !important;\n    border: 1px dashed #fff !important;\n    border-radius: 20px !important;\n    color: #fff !important;\n  }\n\n  select, select:focus-visible {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    box-sizing: content-box !important;\n    border: 1px solid #fff !important;\n    border-radius: 20px;\n    -webkit-appearance: none !important;\n    -moz-appearance: none !important;\n    appearance: none !important;\n    text-indent: 5px;\n  }\n\n  option {\n    background-color: #fff !important;\n    color: #000;\n    box-sizing: content-box;\n    padding-top : 20px !important;\n    padding-bottom : 20px !important;\n    margin-top : 20px !important;\n    margin-bottom : 20px !important;\n  }\n  select option {\n    box-sizing: content-box;\n    padding: 20px 0;\n  }\n  div span{\n    background-color: transparent !important;\n  }\n\n  div span span span {\n    margin-top: -4px;\n  }\n\n  path {\n    stroke: #fff;\n    fill: #fff;\n  }\n\n  margin-right: 20px\n"])), function (props) {
  return props.isDark ? '#000' : 'gray';
});
var StyledDropdownItemNetwork = styled(StyledDropdownItem)(_templateObject90 || (_templateObject90 = _taggedTemplateLiteralLoose(["\n  border-radius: 20px !important;\n  color: #ffffff !important;\n"])));
var ContainerWrapper = styled.div(_templateObject91 || (_templateObject91 = _taggedTemplateLiteralLoose(["\n  padding: 25px 40px 15px 40px;\n"])));
var DividerContainer = styled.div(_templateObject92 || (_templateObject92 = _taggedTemplateLiteralLoose(["\ndisplay: flex;\n    justify-content: center;\n    margin: 7px;\n    div {\n      width: 93%\n    }\n"])));
var ContactsContainer = styled.div(_templateObject93 || (_templateObject93 = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  @media (min-width: 601px) {\n    height: 290px;\n    padding: 0px 30px 0px 30px;\n    width: 40%;\n  }\n\n  @media (max-width: 600px) {\n    width: 100%;\n  }\n"])));
var StyledTextWithHtml = styled(TextWithHtml)(_templateObject94 || (_templateObject94 = _taggedTemplateLiteralLoose(["\n  .congratsDesc{\n    font-weight: bold;\n    font-size: 22px;\n  }\n  @media (max-width: 600px) {\n    width: 300px;\n  }\n"])));
var FeedbackSaveExitContainer = styled.div(_templateObject95 || (_templateObject95 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n"])));
var SaveExitCloseButton = styled.div(_templateObject96 || (_templateObject96 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 20px;\n  top: 13px;\n  cursor: pointer;\n  z-index: 9999;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  @media screen and (max-width: 600px) {\n    right: 25px;\n  }\n"])));
var TitleTextWrapperCompletion = styled.div(_templateObject97 || (_templateObject97 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  width: 95%;\n"])));
var StepContainerCompletion = styled.div(_templateObject98 || (_templateObject98 = _taggedTemplateLiteralLoose(["\n  display: flex;\n\n  @media (min-width: 601px) {\n    height: 290px;\n    justify-content: space-between;\n    padding: 25px 40px 15px 40px;\n  }\n\n  @media (max-width: 600px) {\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n  }\n"])));
var StepInfoContainerCompletion = styled.div(_templateObject99 || (_templateObject99 = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n\n  @media (min-width: 601px) {\n    align-items: flex-start;\n    height: 275px;\n    //justify-content: center;\n    width: 50%;\n  }\n\n  @media (max-width: 600px) {\n    width: 100%;\n  }\n"])));
var DeviceImageCompletion = styled.img(_templateObject100 || (_templateObject100 = _taggedTemplateLiteralLoose(["\n  @media(min-width: 601px) {\n    width: 50%;\n  }\n  @media(max-width: 600px) {\n    width: 12%;\n  }\n"])));
var DesktopHeadingWrapper = styled.div(_templateObject101 || (_templateObject101 = _taggedTemplateLiteralLoose(["\n  @media (max-width: 600px) {\n    display: none;\n  }\n"])));
var MobileHeadingWrapper = styled.div(_templateObject102 || (_templateObject102 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  position: relative;\n  width: 100%;\n  @media (min-width: 601px) {\n     display: none;\n    }\n  a {\n    color: black;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n  @media(max-width: 768px) {\n    font-size:1.0rem;\n  }\n  @media screen and (max-width: 600px) {\n    margin-left: 0px;\n    width: 330px;\n    // margin-top: 20px\n  }\n  div.checklist-wrapper {\n    @media screen and (max-width: 600px) {\n      position: absolute;\n    }\n  }\n"])));
var StyledGrid = styled.div(_templateObject103 || (_templateObject103 = _taggedTemplateLiteralLoose([""])));
var StyledRow = styled.div(_templateObject104 || (_templateObject104 = _taggedTemplateLiteralLoose(["\n  display:flex;\n  /*justify-content: space-between;*/\n  margin-top: 1rem\n"])));
var StyledTile = styled.div(_templateObject105 || (_templateObject105 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  /*flex:1;*/\n  border: 1px solid lightGray;\n  border-radius: 7px;\n  display: inline-block;\n  /*padding: 1rem;*/\n  /*margin-right: 1.5rem;*/\n  margin: 12px 16px 0 0;\n  cursor: pointer;\n\n  justify-content: center;\n  padding-left: 20px;\n  padding-top: 13px;\n  padding-bottom: 12px;\n  padding-right: 12px;\n  /*width: 335px;*/\n\n  @media (min-width: 601px) {\n    width: 340px;\n  }\n\n  @media (max-width: 600px) {\n    width: 315px;\n  }\n"])));
var TilesContainer = styled.div(_templateObject106 || (_templateObject106 = _taggedTemplateLiteralLoose(["\n  div.question {\n    font-size: 1rem;\n    font-family: 'Verizon-NHG-eDS';\n    font-weight: 400;\n    line-height: 1.25rem;\n    letter-spacing: 0.03125rem;\n    text-decoration: none;\n    margin-bottom: 15px;\n    a{ color: #428bca;  text-decoration : underline;}\n  }\n  @media(min-width:601px) {\n    column-fill: auto;\n    column-count: 1;\n    //margin-top: 30px;\n    margin-bottom: 30px;\n  }\n  @media(max-width: 600px) {\n    margin-top: 1rem;\n    margin-bottom: 15px;\n  }\n"])));
var TileFooterContainer = styled.div(_templateObject107 || (_templateObject107 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n  "])));
var ButtonDiv = styled.div(_templateObject108 || (_templateObject108 = _taggedTemplateLiteralLoose(["\n    padding-top: 6px;\n    padding-left:15px;\n  "])));
var HeadingSpan = styled.span(_templateObject109 || (_templateObject109 = _taggedTemplateLiteralLoose([""])));
var NetworkCongestion = styled.div(_templateObject110 || (_templateObject110 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  font-weight: bold;\n  text-align: center;\n  div.row {\n    div.column:nth-child(1){\n      border-bottom: none;\n    }\n    div.column:nth-child(2){\n      border-top: none;\n    }\n    div.column0{\n      color: #FFF;\n    }\n  }\n  div.column {\n    border: 1px solid #808080;\n    width: 120px;\n    // padding-left: 5px;\n  }\n  div.redbg {\n    background-color: red;\n    color: red;\n  }\n  div.white {\n    color: #FFF;\n  }\n"])));
var CustomContentDiv = styled.div(_templateObject111 || (_templateObject111 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n    flex-direction: ", ";\n    @media (max-width: 768px) {\n      flex-direction: column-reverse;\n    }\n"])), function (props) {
  return props.isSetFlexColumn ? 'column' : '';
});
var ProvisioningChecksInfo = styled.div(_templateObject112 || (_templateObject112 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n"])));
var ProvisioningChecksTable = styled.div(_templateObject113 || (_templateObject113 = _taggedTemplateLiteralLoose(["\n  table {\n    border: 1px solid #d8dada;\n  }\n  thead {\n    background-color: ", ";\n    tr {\n      border-bottom: 1px solid #d8dada !important;\n    }\n    td {\n       color:#000;\n      }\n  }\n  td {\n    padding: 0.2rem 0 0.2rem 0.5rem\n    font-size: 0.8rem;\n  }\n"])), function (props) {
  return props.color;
});
var LeftNavWrapperAll = styled.div(_templateObject114 || (_templateObject114 = _taggedTemplateLiteralLoose(["\n height: 232px;\n border: 10px;\n margin-left: 22px;\n padding: 0px 33px 35px 50px;\n width: 215px;\n"])));
var LeftNavSidebar = styled.div(_templateObject115 || (_templateObject115 = _taggedTemplateLiteralLoose(["\n display: inline-flex;\n @media (max-width: 414px) {\n  flex-wrap: ", ";\n}\n"])), function (props) {
  return props.isACSS ? 'unset' : 'wrap';
});
var StyledNumberInput = styled.input(_templateObject116 || (_templateObject116 = _taggedTemplateLiteralLoose(["\nwidth: 100px;\nheight: 30px;\nmargin-right: 10px;\n"])));
var RightArrowDiv = styled.div(_templateObject117 || (_templateObject117 = _taggedTemplateLiteralLoose(["\n   display:flex;\n   justify-content:flex-end;\n   padding-right:10px;\n   padding-bottom:10px;\n\n "])));
var TiletContainer = styled.div(_templateObject118 || (_templateObject118 = _taggedTemplateLiteralLoose(["\n display : grid;\n grid-template-columns: 1fr 1fr;\n gap:20px;\n width:740px;\n\n  \n"])));
var TechCoachBody = styled.p(_templateObject119 || (_templateObject119 = _taggedTemplateLiteralLoose(["\nmargin-top: 1rem;\n"])));
var CloseIconWrapper = styled.div(_templateObject120 || (_templateObject120 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  width: 3rem;\n  height: 3rem;\n  display: flex;\n  -webkit-box-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  align-items: center;\n  z-index: 1;\n"])));
var CloseButtonIconContainer = styled.div(_templateObject121 || (_templateObject121 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 2rem;\n  height: 2rem;\n"])));
var PopupCloseButton = styled.button(_templateObject122 || (_templateObject122 = _taggedTemplateLiteralLoose(["\ndisplay: flex;\n-webkit-box-pack: center;\njustify-content: center;\n-webkit-box-align: center;\nalign-items: center;\npadding: 0px;\nmargin: 0px;\ncursor: pointer;\nbox-sizing: border-box;\ntext-align: center;\ntext-decoration: none;\nposition: relative;\ntouch-action: manipulation;\npointer-events: auto;\nvertical-align: middle;\noutline: none;\nwidth: 100%;\nheight: 100%;\nbackground-color: transparent;\nborder-radius: 50%;\nborder: none;\nbackground-clip: padding-box;\ntransition: all 0.1s ease-out 0s;\n"])));
var CloseButtonHitArea = styled.span(_templateObject123 || (_templateObject123 = _taggedTemplateLiteralLoose(["\n    height: 2.75rem;\n    width: 2.75rem;\n    display: inline-block;\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    text-align: center;\n    transform: translate(-50%, -50%);\n"])));
var IconContainer = styled.span(_templateObject124 || (_templateObject124 = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    left: 0px;\n    bottom: 0px;\n    pointer-events: none;\n"])));
var CloseIconSVG = styled.svg(_templateObject125 || (_templateObject125 = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    height: 1.25rem;\n    width: 1.25rem;\n    min-height: 1.25rem;\n    min-width: 1.25rem;\n"])));
var styledComps = {
  ProvisioningChecksTable: ProvisioningChecksTable,
  ProvisioningChecksInfo: ProvisioningChecksInfo,
  EmailIconDiv: EmailIconDiv,
  SmsIconDiv: SmsIconDiv,
  ContentWrapper: ContentWrapper$1,
  StyledTextLink: StyledTextLink,
  TitleWrapper: TitleWrapper,
  ButtonWrapper: ButtonWrapper,
  ButtonWrapperMobile: ButtonWrapperMobile,
  TextWrapper: TextWrapper,
  TroubleShootingTitle: TroubleShootingTitle,
  TitleTextWrapper: TitleTextWrapper,
  HeadingWrapper: HeadingWrapper,
  PageTitle: PageTitle,
  Cancel: Cancel,
  TabsContainer: TabsContainer,
  StepContainer: StepContainer,
  StepInfoContainer: StepInfoContainer,
  ImageContainer: ImageContainer,
  DeviceImageContainer: DeviceImageContainer,
  DeviceImage: DeviceImage,
  IssuesContainer: IssuesContainer,
  ImageTitle: ImageTitle,
  MapWrapper: MapWrapper,
  FeedbackCloseButton: FeedbackCloseButton,
  CloseButton: CloseButton,
  StyledModal: StyledModal,
  StyledModalBody: StyledModalBody,
  DescWrapper: DescWrapper,
  Probing: Probing,
  SearchBar: SearchBar,
  SearchResults: SearchResults,
  SearchTitle: SearchTitle,
  SearchDesc: SearchDesc,
  SearchResultsContainer: SearchResultsContainer,
  IframeContainer: IframeContainer,
  StyledTableHeader: StyledTableHeader,
  StyledCell: StyledCell,
  StyledTable: StyledTable,
  ChangeIssueContainer: ChangeIssueContainer,
  BoldText: BoldText,
  StepOption: StepOption,
  ButtonContainer: ButtonContainer,
  StyledModalPopup: StyledModalPopup,
  StyledCheckbox: StyledCheckbox,
  NavInnerSteps: NavInnerSteps,
  QuesDropdownSelect: QuesDropdownSelect,
  ContentBody: ContentBody,
  FootnoteBlock: FootnoteBlock,
  StyledEmailModalPopup: StyledEmailModalPopup,
  CopyIconDiv: CopyIconDiv,
  ResumeEmailIconDiv: ResumeEmailIconDiv,
  FeedbackSaveExitContainer: FeedbackSaveExitContainer,
  SaveExitCloseButton: SaveExitCloseButton,
  Footer: Footer,
  HeaderTabContainer: HeaderTabContainer,
  NavStepsContainer: NavStepsContainer,
  NavStepsWrapper: NavStepsWrapper,
  TroubleShootingTitleNew: TroubleShootingTitleNew,
  NewPageTitle: NewPageTitle,
  RightMenuContainer: RightMenuContainer,
  DescWrapperNew: DescWrapperNew,
  IconImage: IconImage,
  DropdownWrapper: DropdownWrapper,
  BillingSteps: BillingSteps,
  DownloadImage: DownloadImage,
  EmailImage: EmailImage,
  IconDownloadEmail: IconDownloadEmail,
  ActionsWrapper: ActionsWrapper,
  NewPreviousButtonWrapper: NewPreviousButtonWrapper,
  ButtonsWrapper: ButtonsWrapper$1,
  Next: Next,
  Previous: Previous,
  StyledTextLinkCaret: StyledTextLinkCaret,
  NextNew: NextNew,
  PreviousNew: PreviousNew,
  NewBtnWrapper: NewBtnWrapper,
  NewActionButton: NewActionButton,
  NewActionButtonWrapper: NewActionButtonWrapper,
  IconImageUp: IconImageUp,
  IconImageDown: IconImageDown,
  LeftIcon: LeftIcon,
  Divider: Divider,
  LeftIconDisabled: LeftIconDisabled,
  RightIcon: RightIcon,
  RightIconDisabled: RightIconDisabled,
  StyledDropdownItem: StyledDropdownItem,
  DividerWrapper: DividerWrapper,
  DropdownSelectWrapper: DropdownSelectWrapper,
  StyledDropdownItemNetwork: StyledDropdownItemNetwork,
  StyledButton: StyledButton$1,
  ContainerWrapper: ContainerWrapper,
  DividerContainer: DividerContainer,
  ContactsContainer: ContactsContainer,
  StyledTextWithHtml: StyledTextWithHtml,
  TitleTextWrapperCompletion: TitleTextWrapperCompletion,
  StepContainerCompletion: StepContainerCompletion,
  DeviceImageCompletion: DeviceImageCompletion,
  StepInfoContainerCompletion: StepInfoContainerCompletion,
  DesktopHeadingWrapper: DesktopHeadingWrapper,
  MobileHeadingWrapper: MobileHeadingWrapper,
  StyledGrid: StyledGrid,
  StyledRow: StyledRow,
  StyledTile: StyledTile,
  TilesContainer: TilesContainer,
  IssueBoxWrapper: IssueBoxWrapper,
  IssueContentbox: IssueContentbox,
  IssueContentArrow: IssueContentArrow,
  TileFooterContainer: TileFooterContainer,
  ButtonDiv: ButtonDiv,
  HeadingSpan: HeadingSpan,
  CustomContentDiv: CustomContentDiv,
  DescBodyWrapper: DescBodyWrapper,
  DescInnerWrapper: DescInnerWrapper,
  NetworkCongestion: NetworkCongestion,
  LeftNavWrapperAll: LeftNavWrapperAll,
  LeftNavSidebar: LeftNavSidebar,
  StyledNumberInput: StyledNumberInput,
  RightArrowDiv: RightArrowDiv,
  TiletContainer: TiletContainer,
  TechCoachBody: TechCoachBody,
  CloseIconWrapper: CloseIconWrapper,
  CloseButtonIconContainer: CloseButtonIconContainer,
  PopupCloseButton: PopupCloseButton,
  CloseButtonHitArea: CloseButtonHitArea,
  IconContainer: IconContainer,
  CloseIconSVG: CloseIconSVG
};

var _templateObject$4, _templateObject2$2, _templateObject3$2, _templateObject4$2, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject0$1, _templateObject1$1, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13$1, _templateObject14$1, _templateObject15$1, _templateObject16$1, _templateObject17$1, _templateObject18$1, _templateObject19$1, _templateObject20$1, _templateObject21$1, _templateObject22$1, _templateObject23$1, _templateObject24$1, _templateObject25$1, _templateObject26$1, _templateObject27$1, _templateObject28$1, _templateObject29$1, _templateObject30$1, _templateObject31$1, _templateObject32$1, _templateObject33$1, _templateObject34$1, _templateObject35$1, _templateObject36$1, _templateObject37$1, _templateObject38$1, _templateObject39$1, _templateObject40$1, _templateObject41$1, _templateObject42$1, _templateObject43$1, _templateObject44$1, _templateObject45$1, _templateObject46$1, _templateObject47$1, _templateObject48$1, _templateObject49$1, _templateObject50$1, _templateObject51$1, _templateObject52$1, _templateObject53$1, _templateObject54$1, _templateObject55$1, _templateObject56$1, _templateObject57$1, _templateObject58$1, _templateObject59$1, _templateObject60$1, _templateObject61$1, _templateObject62$1, _templateObject63$1, _templateObject64$1, _templateObject65$1, _templateObject66$1, _templateObject67$1, _templateObject68$1, _templateObject69$1, _templateObject70$1, _templateObject71$1, _templateObject72$1, _templateObject73$1, _templateObject74$1, _templateObject75$1, _templateObject76$1, _templateObject77$1, _templateObject78$1, _templateObject79$1, _templateObject80$1, _templateObject81$1, _templateObject82$1, _templateObject83$1, _templateObject84$1, _templateObject85$1, _templateObject86$1, _templateObject87$1, _templateObject88$1, _templateObject89$1, _templateObject90$1, _templateObject91$1, _templateObject92$1, _templateObject93$1, _templateObject94$1, _templateObject95$1, _templateObject96$1, _templateObject97$1, _templateObject98$1, _templateObject99$1, _templateObject100$1, _templateObject101$1, _templateObject102$1, _templateObject103$1, _templateObject104$1, _templateObject105$1, _templateObject106$1, _templateObject107$1, _templateObject108$1, _templateObject109$1, _templateObject110$1, _templateObject111$1, _templateObject112$1, _templateObject113$1, _templateObject114$1, _templateObject115$1, _templateObject116$1, _templateObject117$1, _templateObject118$1, _templateObject119$1, _templateObject120$1, _templateObject121$1, _templateObject122$1, _templateObject123$1, _templateObject124$1, _templateObject125$1, _styledBauComps;
var StyledTextLink$1 = styled(TextLink)(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["\n  :hover, :focus{\n    text-decoration: none;\n  }\n"])));
var FootnoteBlock$1 = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\nmargin-bottom:10px;\nmargin-top: 10px;\na {\n  color: black;\n  text-decoration: underline;\n  cursor: pointer;\n}\n"])));
var ContentWrapper$2 = styled.div(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteralLoose(["\n  @media(max-width: 600px) {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 2.0rem;\n  }\n\n  @media(min-width:601px) {\n    box-shadow: 0px 0px 10px #aaa;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n    width: 990px;\n  }\n\n  div.right-menu-container {\n    display: ", "\n    width: 25%;\n  }\n\n  nav.fixedRightNav {\n    position:fixed;\n    height: calc(100vh - 180px);\n    overflow-y: auto;\n    top: 52px;\n    width: 18.2rem;\n  }\n"])), function (props) {
  return props.isNewDesign ? props.hideRightNav ? 'none' : 'block' : 'none';
});
var BoldText$1 = styled.div(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteralLoose(["\n  font-weight: 800;\n  font-size: 1rem;\n"])));
var TitleWrapper$1 = styled.div(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  padding-top: 15px;\n  width: 100%;\n\n  div:last-child {\n    margin-left: auto;\n  }\n  @media screen and (max-width: 600px) {\n    padding-top: 0px;\n  }\n"])));
var ButtonWrapper$1 = styled.div(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width: 601px) {\n    height: 60px;\n  }\n  @media screen and (max-width: 600px) {\n    display:none\n  }\n"])));
var ButtonWrapperMobile$1 = styled.div(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteralLoose(["\n  width: 50%;\n  margin:0px auto;\n  @media screen and (min-width: 600px) {\n    display:none\n  }\n"])));
var TextWrapper$1 = styled('Body')(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteralLoose(["\n  font-size: 25px;\n  text-align: center;\n  margin-bottom: 10px;\n  overflow: hidden;\n  height: unset;\n  a :active {\n    color:gray !important;\n    border-bottom: 1px solid gray;\n  }\n  a :hover {\n    color:gray  !important;\n    border-bottom: 1px solid gray;\n  }\n\n  @media screen and (max-width: 600px) {\n    margin-left: 5px;\n  }\n"])));
var TroubleShootingTitle$1 = styled.div(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width: 601px) {\n    padding: 24px 0 0 0;\n    margin-left: '0px';\n    margin-right: 20px;\n    text-align: 'center';\n  }\n"])));
var TitleTextWrapper$1 = styled.div(_templateObject0$1 || (_templateObject0$1 = _taggedTemplateLiteralLoose(["\n  // text-align: left;\n  // margin-left: 53px;\n  // @media screen and (max-width: 600px) {\n  //   padding: 0px 10px 0px 10px;\n  // }\n  display: flex;\n  align-items: end;\n  justify-content: space-between;\n"])));
var HeadingWrapper$1 = styled.div(_templateObject1$1 || (_templateObject1$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  position: relative;\n  width: 100%;\n  a {\n    color: black;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n  @media(max-width: 768px) {\n    font-size:1.0rem;\n  }\n  @media screen and (max-width: 600px) {\n    margin-left: 0px;\n    width: 330px;\n    // margin-top: 20px\n  }\n  div.checklist-wrapper {\n    @media screen and (max-width: 600px) {\n      position: absolute;\n    }\n  }\n"])));
var PageTitle$1 = styled.div(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width:601px) {\n    position: absolute;\n    margin-left: 70px;\n  }\n  @media screen and (max-width: 600px) {\n    margin: 0 0 15px 65px;\n    z-index: 1;\n  }\n"])));
var Cancel$1 = styled.div(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteralLoose(["\n  margin-right: 10px;\n"])));
var TabsContainer$1 = styled.div(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  @media(min-width: 601px) {\n    justify-content: space-between;\n  }\n  @media(max-width: 600px) {\n    flex-direction: column;\n    padding: 0px 15px 0px 15px;\n  }\n"])));
var StepContainer$1 = styled.div(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  position: relative;\n  justify-content: space-between;\n  ", "\n  @media(min-width: 601px) {\n    /* padding: 0px 70px; */\n    width : 100%;\n  }\n  @media(max-width: 600px) {\n    flex-direction: column;\n    padding: 0px 15px 0px 15px;\n  }\n"])), function (props) {
  return (props === null || props === void 0 ? void 0 : props.isPopOutFlow) && 'padding-right: 25px;';
});
var StepInfoContainer$1 = styled.div(_templateObject14$1 || (_templateObject14$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  @media(min-width: 601px) {\n    // width: ", ";\n    width : 100%;\n  }\n"])), function (isNewDesign) {
  if (isNewDesign === void 0) {
    isNewDesign = false;
  }
  return isNewDesign ? function (_ref) {
    var _ref$hideRightNav = _ref.hideRightNav,
      hideRightNav = _ref$hideRightNav === void 0 ? true : _ref$hideRightNav;
    return hideRightNav ? '100%' : '70%';
  } : '100%';
});
var ImageContainer$1 = styled.div(_templateObject15$1 || (_templateObject15$1 = _taggedTemplateLiteralLoose(["\n  @media(min-width: 601px) {\n    float:left;\n  }\n"])));
var ChangeIssueContainer$1 = styled.div(_templateObject16$1 || (_templateObject16$1 = _taggedTemplateLiteralLoose(["\n@media(min-width: 601px) {\n  text-align: left;\n  position: absolute;\n  left : 300px;\n}\n"])));
var DeviceImageContainer$1 = styled.div(_templateObject17$1 || (_templateObject17$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  // height: 290px;\n  margin-top: 25px;\n  @media(min-width: 601px) {\n    // width: 40%;\n    margin-top:40px;\n  }\n"])));
var DeviceImage$1 = styled.img(_templateObject18$1 || (_templateObject18$1 = _taggedTemplateLiteralLoose(["\n  @media(min-width: 601px) {\n    width: 7%;\n    position: absolute;\n    top: -40px;\n    left: 57px;\n  }\n  @media(max-width: 600px) {\n    width: 12%;\n  }\n"])));
var IssuesContainer$1 = styled.div(_templateObject19$1 || (_templateObject19$1 = _taggedTemplateLiteralLoose(["\n  div.question {\n    font-size: 1rem;\n    font-family: 'Verizon-NHG-eDS';\n    font-weight: 400;\n    line-height: 1.25rem;\n    letter-spacing: 0.03125rem;\n    text-decoration: none;\n    margin-bottom: 15px;\n    a{ color: #428bca;  text-decoration : underline;}\n  }\n  @media(min-width:601px) {\n    column-fill: auto;\n    column-count: 1;\n    //margin-top: 30px;\n    margin-bottom: 30px;\n    max-width: ", ";\n  }\n  @media(max-width: 600px) {\n    margin-top: 1rem;\n    margin-bottom: 15px;\n  }\n"])), function (props) {
  return props.isSetFlexColumn ? props.isMvoDigi ? '85%' : '90%' : '600px';
});
var ImageTitle$1 = styled.div(_templateObject20$1 || (_templateObject20$1 = _taggedTemplateLiteralLoose(["\n  @media(min-width: 601px) {\n    position: absolute;\n    display: inline-block;\n    top: 20px;\n    left: 130px;\n    text-align:start;\n    margin-right: 10px;\n    max-width: 155px;\n  }\n"])));
var MapWrapper$1 = styled.div(_templateObject21$1 || (_templateObject21$1 = _taggedTemplateLiteralLoose(["\n  @media(max-width: 600px) {\n    position: relative;\n    padding-bottom: 56.25%; /* 16:9 */\n    padding-top: 25px;\n    height: 0;\n\n    iframe {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n  }\n"])));
var CloseButton$1 = styled.span(_templateObject22$1 || (_templateObject22$1 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 25px;\n  top: 25px;\n  cursor: pointer;\n  z-index: 9999;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  @media screen and (max-width: 600px) { }\n"])));
var FeedbackCloseButton$1 = styled.span(_templateObject23$1 || (_templateObject23$1 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 10px;\n  top: 12px;\n  cursor: pointer;\n  z-index: 9999;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  @media screen and (max-width: 600px) {\n    right: 25px;\n  }\n"])));
var StyledModal$1 = styled(Modal$1)(_templateObject24$1 || (_templateObject24$1 = _taggedTemplateLiteralLoose(["\n  &[class^=\"ModalDialog-\"] {\n    height: ", ";\n    width: ", ";\n    padding-top: ", ";\n  }\n"])), isMobile() ? '100%' : '70%', function (props) {
  return props.modalName != "feedback" && (isMobile() ? '100%' : '40%');
}, function (props) {
  return props.modalName != "feedback" ? props.expandModal ? '20px' : '40px' : !isMobile() ? '30px' : '10px';
});
var StyledModalPopup$1 = styled(Modal$1)(_templateObject25$1 || (_templateObject25$1 = _taggedTemplateLiteralLoose(["\n   {\n    height: 300px !important};\n    width: 450px !important};\n  }\n"])));
var StyledEmailModalPopup$1 = styled(Modal$1)(_templateObject26$1 || (_templateObject26$1 = _taggedTemplateLiteralLoose(["\n    height: 100% !important;\n    width: 450px !important;\n    @media screen and (max-width: 600px)   {\n      &[class^=\"ModalDialog-\"] {\n        width: 100vw !important};\n        position:fixed  !important;\n        left:0px !important\n      }\n    }\n"])));
var StyledModalBody$1 = styled(ModalBody$1)(_templateObject27$1 || (_templateObject27$1 = _taggedTemplateLiteralLoose(["\n  &[class^=\"StyledModalBody-\"] {\n    padding: 0px;\n  }\n"])));
var DescWrapper$1 = styled.div(_templateObject28$1 || (_templateObject28$1 = _taggedTemplateLiteralLoose(["\n  p {\n    margin: 0px 0px 10px 0;\n  }\n  h1 div{\n    font-size: initial;\n  }\n  h2 div{\n    font-size: initial;\n    font-weight: bold;\n  }\n  h3 div{\n    font-size: initial;\n  }\n  a {\n    text-decoration: underline\n  };\n  a.btn-link {\n    display: block;\n    margin: 10px 0;\n    padding: 10px;\n    text-decoration: none;\n    text-align: center;\n    min-width: 160px;\n    width: 200px;\n    border-radius: 2.5rem;\n    background-color: black;\n    color: #fff;\n    font-size: 1rem;\n    font-weight: 600;\n    letter-spacing: 0.03125rem;\n    // height: 2.45rem;\n    align-items: center;\n  }\n  a.btn-link:hover{\n    border: none;\n    outline: none;\n  }\n  a.btn-link:hover:not(:active) {\n    outline: none;\n    box-shadow: 0 0 0 0.0925rem #000000;\n    -webkit-transition: ease-out 0.1s;\n    transition: ease-out 0.1s;\n  }\n"])));
var Probing$1 = styled.div(_templateObject29$1 || (_templateObject29$1 = _taggedTemplateLiteralLoose(["\nmargin-bottom: ", "; \ndiv[class^=\"StyledInnerCircle-VDS\"] {\n  background:  ", ";\n}\n.radioLabel {\n line-height: 1.25rem;\n  font-family: Verizon-NHG-eDS;\n  padding-right: ", ";\n  font-weight:bold;\n}\n.container  {\n\n  display:inline-block;\n  position:relative;\n  padding-left:35px;\n  margin-bottom:12px;\n  cursor:pointer;\n  line-height: 1.25rem;\n  font-size: 1rem;\n  font-family: \"Verizon-NHG-eDS\";\n  -webkit-user-select:none;\n  -moz-user-select:none;\n  -ms-user-select:none;\n  user-select:none;\n  -webkit-tap-highlight-color: transparent;\n\n}\n\n.container input {\n\n  position:absolute;\n  opacity:0;\n  cursor:pointer\n}\n\n.checkmark{\n\n  position:absolute;\n  top:0;\n  left:0;\n  height:18px;\n  width:18px;\n  border-radius:50%\n}\n\n.container:hover input ~ .checkmark {\n\n  border: 1px solid black\n}\n\n\n.container input ~ .checkmark {\n\n  border: 1px solid black\n}\n\n.container input:focus ~ span.checkmark {\n  border: 1px dashed gray;\n}\n\n.checkmark:after {\n\n  content: \"\";\n  position:absolute;\n  display:none\n}\n\n\n.container .checkmark:after {\n\n  top:4px;\n  left:4px;\n  width:10px;\n  height:10px;\n  border-radius:50px;\n  background:black\n}\n\n\n\n.container input:checked ~ .checkmark:after {display:block}\n\n"])), function (props) {
  return props.search && '40px';
}, function (props) {
  return props.isDark && 'rgb(255, 255, 255) !important';
}, function (props) {
  return props.search && '50px';
});
var SearchBar$1 = styled.div(_templateObject30$1 || (_templateObject30$1 = _taggedTemplateLiteralLoose(["\n\n\n@media(min-width:601px){\n    display:flex;\n    border-bottom: 2.5px solid black;\n    width:50%;\n    margin-bottom: ", ";\n\n\n  }\n  @media(max-width:600px){\n    display:flex;\n    border: 1.2px solid black;\n    width:90.5%;\n    margin-bottom:10px\n    height:50px;\n    margin-bottom:20px\n\n\n  }\n\nmargin-bottom:85px\n"])), function (props) {
  return props.search && '20px';
});
var SearchResults$1 = styled.div(_templateObject31$1 || (_templateObject31$1 = _taggedTemplateLiteralLoose(["\nmargin-bottom: 30px;\n"])));
var SearchTitle$1 = styled.p(_templateObject32$1 || (_templateObject32$1 = _taggedTemplateLiteralLoose(["\ncolor: #0082b7;\nfont-size: 18px;\ntext-decoration: underline;\nmargin-bottom: 10px;\ntext-underline-offset: 3px;\ncursor: pointer;\n"])));
var SearchDesc$1 = styled.p(_templateObject33$1 || (_templateObject33$1 = _taggedTemplateLiteralLoose(["\np{\n  font-size: 17px;\n}\n"])));
var SearchResultsContainer$1 = styled.div(_templateObject34$1 || (_templateObject34$1 = _taggedTemplateLiteralLoose(["\nmargin-bottom: 30px;\n"])));
var IframeContainer$1 = styled.div(_templateObject35$1 || (_templateObject35$1 = _taggedTemplateLiteralLoose(["\n@media(min-width:601px){\n    display:flex;\n    width:100%;\n  }\n  @media(max-width:600px){\n    display:flex;\n    border: 1.2px solid black;\n    width:90.5%;\n    margin-bottom:10px\n    height:50px;\n    margin-bottom:20px\n  }\nmargin-bottom:50px\n"])));
var StyledTable$1 = styled(Table)(_templateObject36$1 || (_templateObject36$1 = _taggedTemplateLiteralLoose(["\nmargin-bottom: 0;\n"])));
var StyledTableHeader$1 = styled(TableHeader$1)(_templateObject37$1 || (_templateObject37$1 = _taggedTemplateLiteralLoose(["\nfont-size: 14px\n"])));
var StyledCell$1 = styled(Cell$1)(_templateObject38$1 || (_templateObject38$1 = _taggedTemplateLiteralLoose(["\nfont-size: 14px\n"])));
var StepOption$1 = styled.div(_templateObject39$1 || (_templateObject39$1 = _taggedTemplateLiteralLoose(["\n  border: 1px solid lightGray;\n  border-radius: 7px;\n  display: inline-block;\n  float:left;\n  margin-right: 3%;\n  cursor: pointer;\n  flex-direction: column;\n  height: 48px;\n  justify-content: center;\n  padding-left: 14px;\n  padding-top: 13px;\n  padding-bottom: 13px;\n  padding-right: 14px;\n  width: 315px;\n\n  :not(:first-child) {\n    margin-top: 15px;\n  }\n"])));
var IssueBoxWrapper$1 = styled.div(_templateObject40$1 || (_templateObject40$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  min-height: 38px;\n"])));
var IssueContentbox$1 = styled.div(_templateObject41$1 || (_templateObject41$1 = _taggedTemplateLiteralLoose(["\n  @media (min-width: 601px) {\n    width: 344px;\n  }\n\n  @media (max-width: 600px) {\n    width: 304px;\n  }\n  cursor: pointer;\n  justify-content: left;\n"])));
var IssueContentArrow$1 = styled.div(_templateObject42$1 || (_templateObject42$1 = _taggedTemplateLiteralLoose(["\n  @media (min-width: 601px) {\n    width: 40px;\n  }\n\n  @media (max-width: 600px) {\n    width: 30px;\n  }\n  position: absolute;\n  cursor: pointer;\n  justify-content: right;\n  display: inline-flex;\n  align-items:flex-end;\n  right:10px;\n  bottom:5px;\n  /*padding-top: 32px;*/\n"])));
var ButtonContainer$1 = styled.div(_templateObject43$1 || (_templateObject43$1 = _taggedTemplateLiteralLoose(["\n  div.question {\n    font-size: 1rem;\n    font-family: 'Verizon-NHG-eDS';\n    font-weight: 400;\n    line-height: 1.25rem;\n    letter-spacing: 0.03125rem;\n    text-decoration: none;\n    margin-bottom: 15px;\n    a{ color: #428bca;  text-decoration : underline;}\n  }\n  @media(min-width:601px) {\n    column-fill: auto;\n    column-count: 1;\n    //margin-top: 30px;\n    margin-bottom: 30px;\n  }\n  @media(max-width: 600px) {\n    margin-top: 1rem;\n    margin-bottom: 15px;\n  }\n"])));
var StyledCheckbox$1 = styled(Checkbox)(_templateObject44$1 || (_templateObject44$1 = _taggedTemplateLiteralLoose(["\nfont-weight: bolder;\n\n", "\n"])), function (props) {
  return props.isDark && "\nsvg {\n  stroke: #fff;\n  fill: #fff;\n}\n  ";
});
var NavInnerSteps$1 = styled.div(_templateObject45$1 || (_templateObject45$1 = _taggedTemplateLiteralLoose(["\n    button{\n      ", "\n      span{\n        height: auto;\n      }\n    }\n"])), function (props) {
  return props.isDark ? "\n        border-color: #D8DADA\n        " : "\n        border-color: #000\n      ";
});
var QuesDropdownSelect$1 = styled.div(_templateObject46$1 || (_templateObject46$1 = _taggedTemplateLiteralLoose(["\n &.questionDropdown *{\n  ", "\n }\n"])), function (props) {
  return props.isDark ? "\n    background-color: white;\n    color:#000;\n    " : "\n    background: none;\n  ";
});
var ContentBody$1 = styled.div(_templateObject47$1 || (_templateObject47$1 = _taggedTemplateLiteralLoose(["\n     overflow: auto;\n// border-top:2px solid hsl(180deg 3% 85%);\n// width: calc(100% - 3px);\n//   height: 580px;\n//   overflow-y: auto;\n//   ", "\n"])), function (props) {
  return props.theme.themeId === 'theme_dark' ? "\n//   background-color: " + props.theme.themeObject.background + " !important;\n//   &::-webkit-scrollbar {\n//     display: block !important;\n//     width: 6px !important;\n//     background: " + props.theme.themeObject.background + " !important;\n//     border-radius: 4px;\n//   }\n//   &::-webkit-scrollbar-thumb {\n//     background-color: #acacac;\n//     border-radius: 4px;\n//   }\n//   " : "\n//   background-color: #fff;\n//   &::-webkit-scrollbar {\n//     display: block !important;\n//     width: 6px !important;\n//     background: #dedcdc !important;\n//     border-radius: 4px;\n//   }\n//   &::-webkit-scrollbar-thumb {\n//     background-color: #acacac;\n//     border-radius: 4px;\n// }\n// ";
});
var CopyIconDiv$1 = styled.div.attrs({
  'data-track': 'copy external URL of TS article'
})(_templateObject48$1 || (_templateObject48$1 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  margin-right: 5px;\n  svg{\n    pointer-events: none;\n  }\n"])));
var EmailIconDiv$1 = styled.div.attrs({
  'data-track': 'send email of TS article'
})(_templateObject49$1 || (_templateObject49$1 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  svg{\n    pointer-events: none;\n  }\n"])));
var SmsIconDiv$1 = styled.div.attrs({
  'data-track': 'send SMS of TS article'
})(_templateObject50$1 || (_templateObject50$1 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  padding-right: 2px;\n  svg{\n    pointer-events: none;\n  }\n"])));
var ResumeEmailIconDiv$1 = styled.div.attrs({
  'data-track': 'send resume TS email'
})(_templateObject51$1 || (_templateObject51$1 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  svg{\n    pointer-events: none;\n  }\n"])));
var Footer$1 = styled.div(_templateObject52$1 || (_templateObject52$1 = _taggedTemplateLiteralLoose(["\n  height:50px;\n  width:990px;\n  background-color: gray;\n  position:sticky;\n  bottom:0;\n  z-index:0;\n\n  .ebAwXT {\n    padding: 0 70px;\n  }\n\n  .etCvPo{\n    margin-left:0;\n  }\n\n  .eoptfu span {\n    font-family: Verizon-NHG-eDS !important;\n  }\n  .QTMEZ{\n    font-family: Verizon-NHG-eDS;\n  }\n  @media screen and (max-width:601px){\n    width:100vw;\n    height:70px;\n  }\n"])));
var HeaderTabContainer$1 = styled.div(_templateObject53$1 || (_templateObject53$1 = _taggedTemplateLiteralLoose(["\n\n  height:50px;\n  position: sticky;\n  position: -webkit-sticky;\n  background-color:#ffffff;\n  top:0;\n  z-index:100;\n  font-family: 'Verizon-NHG-eDS';\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: 0px;\n  padding: 0px 70px;\n\n  .mcTmv{\n    width:100%;\n    padding:0;\n    margin-left:20px;\n\n    button{\n      letter-spacing: 0.5px;\n    }\n    .kwonIF{\n      color: #6F7171;\n    }\n  }\n"])));
var NavStepsContainer$1 = styled.div(_templateObject54$1 || (_templateObject54$1 = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width:601px){\n    display:flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  font-family: 'Verizon-NHG-eDS';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: 0px;\n  div.articalId {\n    text-align: right;\n    width: 19%;\n    font-weight: normal;\n    @media screen and (max-width: 600px)   {\n      text-align: left;\n      width: 100%;\n      margin-bottom:10px;\n    }\n  }\n"])));
var NavStepsWrapper$1 = styled.div(_templateObject55$1 || (_templateObject55$1 = _taggedTemplateLiteralLoose(["\ndisplay: flex;\nalign-items: center;\n@media screen and (max-width:600px){\n  align-items: normal\n  flex-direction: column;\n  gap: 10px;\n}\n"])));
var TroubleShootingTitleNew$1 = styled.div(_templateObject56$1 || (_templateObject56$1 = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    margin-bottom: 15px;\n    flex: 1;\n    padding-left: 66px;\n    padding-top: 28px;\n    @media screen and (max-width: 601px) {\n      padding-left:   15px;\n    }\n  // @media screen and (min-width: 601px) {\n  //   padding: 0 15px 0 ;\n  //   margin-left: '0px';\n  //   margin-right: 20px;\n  //   width: 84%;\n  //   display: inline-block;\n  //   margin-bottom: 15px;\n  // }\n  // @media screen and (max-width: 601px) {\n  //   padding: 24px 15px 0 ;\n  //   margin-left: '0px';\n  //   text-align: left;\n  //   width: 70%;\n  //   display: inline-block;\n  // }\n"])));
var NewPageTitle$1 = styled.div(_templateObject57$1 || (_templateObject57$1 = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width:601px) {\n    position: relative !important;\n    margin-left: 23px !important;\n    width:73%;\n    display: flex;\n    align-items: center;\n  }\n  @media screen and (max-width:600px) {\n    position: relative;\n    margin-top:15px;\n    margin-bottom:15px\n  }\n"])));
var RightMenuContainer$1 = styled.nav.attrs({
  className: 'RightMenuContainer'
})(_templateObject58$1 || (_templateObject58$1 = _taggedTemplateLiteralLoose(["\n\n  @media(min-width: 601px) {\n    a.right-menu-item{\n      display: block;\n      padding: 10px 15px;\n      cursor: pointer;\n      border-left: 1px solid silver;\n      font-family: 'Verizon-NHG-eDS';\n      font-weight: 700;\n      font-size: 16px;\n      line-height: 20px;\n      letter-spacing: 0.5px;\n      color:#6F7171;\n      position:relative;\n    }\n   /* a.rmi-selected{\n      color: #000000;\n    }\n    a.rmi-selected:before{\n      content:\"\";\n      border-left: 3px solid red;\n      position: absolute;\n      left: 0;\n      height: 100%;\n      top: 0;\n    } */\n  }\n"])));
var DescWrapperNew$1 = styled.div(_templateObject59$1 || (_templateObject59$1 = _taggedTemplateLiteralLoose(["\n\n  table {\n    border: 1px solid grey;\n    border-spacing: 0\n  }\n\n  table th, table td {\n    border: 1px solid grey;\n    padding: 5px;\n  }\n\n  [data-outputclass=\"video\"] {\n    background-repeat: no-repeat;\n    background-position: 0 4px;\n    background-size: 16px 12px;\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAAvCAYAAACrKzemAAAACXBIWXMAAC4jAAAuIwF4pT92AAAB80lEQVRoge2b0VHCQBCG/3V8hw6kA+lArEA6gBKwArACxwrEDrQD7QA70A60gnXOOZhk3buLRxgddr+ZPHBJLuSf3MdeEggA47i5ZObnfc+QiNYnRx5ULxDRHMDMwypARGMA92ErDysDEQ0B7IbwqbLpJ4DNf/iyFYwAnPXYXwhqsP2ghbVh5skhzuTQENEKwLKPwwShAzhvtvkwVNgKXa7xsARNoUs8rAZS6BIPq01L6BIPK6IJXeJhZYQuMR9WTugS02GVhC6xfmWlhP4E4EU2mg0rI/RXAHNtH5NhZYQe5sVzZv7Q9jMXVkHoIajkTQRTYRWEfsPMj7n9rV1ZSaEz86q0s5mwaoQuMRFWrdAlFsKqFrrEQli3ifaHktAlFsK6jsNNMiOi6W86shBWGGaLxLp1rLs6YULwzBx+Ce+UVYMY2LBLP2ZKB2ZeaJPjWE6su/RhrSgNjnpX2q/iY7QspsKK9dQ0IfxlSfjmJtKxrqoSvslbNLXCN3vzr0b42rsOlpjGOky+THKlZWD6HnxB+D+w/sCiJPwW5sNCXvgtPKxIRvg7PKw2qQr/Gw+rQUn4HpYgJ3wPSyElfK0oHRPR3v9I+CNGfR02CD/OEy9a7Ue+TJgZNQuAMEd82+bjwzCDFL6HVaApfOsT6U4E4RPR+AvHogDkc3GOcQAAAABJRU5ErkJggg==);\n    div {\n      margin-left: 25px;\n    }\n  }\n\n  section.section h2 {\n    cursor: pointer;\n    font-family: 'Verizon-NHG-eDS';\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 20px;\n  }\n\n  .arrow-down span {\n    caret-color:transparent;\n    position:absolute;\n    right:25%;\n    transform: rotate(315deg);\n    border:none;\n    width:10px;\n    height:10px;\n    border-left: 1px solid black;\n    border-bottom: 1px solid black;\n    cursor: pointer;\n  }\n\n  .step {\n    margin-bottom:32px\n  }\n\n  .arrow-up span {\n    caret-color:transparent;\n    position:absolute;\n    transform: rotate(135deg);\n    right:25%;\n    width:10px;\n    height:10px;\n    border:none;\n    border-left: 1px solid black;\n    border-bottom: 1px solid black;\n    cursor: pointer;\n  }\n\n  ol.steps {\n    counter-reset: li;\n  }\n\n  ol.steps li.step {\n    position: relative;\n    list-style-type: none;\n  }\n\n  ol.steps li.step:before {\n    position: absolute;\n    left: -50px;\n    top: 5px;\n    content: counter(li);\n    counter-increment: li;\n    color: #fff;\n    background: #EE0000;\n    line-height: 32px;\n    width: 32px;\n    height: 32px;\n    text-align: center;\n    font-weight:700;\n  }\n\n  div.Troubleshooting-Steps div.accordion h2 {\n    cursor: pointer;\n    font-weight: bold;\n\n  }\n  p {\n    margin: 0px 0px 10px 0;\n  }\n  h1 div {\n    font-size: initial;\n  }\n  h2 div {\n    font-size: initial;\n    font-weight: bold;\n  }\n  h3 div {\n    font-size: initial;\n  }\n  a {\n    text-decoration: underline;\n    font-family: 'Verizon-NHG-eDS';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    letter-spacing: 0px;\n  };\n\n  .accordion {\n    margin-top: ", ";\n    border-top: 4px solid #000000;\n  }\n\n  .accordion .title{\n    margin-top: 10px;\n  }\n\n  .note {\n    margin-top: ", ";\n    border-top: 1px solid #000000;\n  }\n\n  .note .ul, .accordion .ul{\n    padding-left:25px;\n    margin-left:0;\n  }\n\n  .note .ul .li, .accordion .ul .li{\n    margin-bottom:16px;\n  }\n  .note .ul .li:last-child{\n    margin-bottom:0;\n  }\n\n  .note h2.title {\n    position: relative;\n  }\n\n  .arrow{\n    position: relative;\n  }\n  .arrow span{\n    right: .25rem !important;\n    top: 0px;\n  }\n\n  .ol.steps {\n    padding-left: 50px;\n    border-top: 1px solid black;\n    padding-top: 12px;\n    margin-top: 2rem;\n  }\n\n  .note, .steps  {\n    font-family: 'Verizon-NHG-eDS';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    letter-spacing: 0px;\n  }\n\n  div[data-outputclass=\"line-note\"]::before, span[data-outputclass=\"line-note\"]::before,\n  li[data-outputclass=\"line-note\"]::before,\n  .ph[data-outputclass=\"line-note\"],\n  a[data-outputclass=\"line-note\"]::before {\n      content: '';\n      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAYAAAA4TnrqAAAACXBIWXMAAC4jAAAuIwF4pT92AAAB3UlEQVR4nO3c203EQAyF4X+oYDuBEuiEpQNKoQOWTrYDoBM6GBQE0YKIyGUux3aOlKdRlNEnO0+WU84ZpaSUTsANcJtzfle625XAHcZ8Qd0B18A5pXQQudpnZLAuoL4jBybRhimloe1eJo7fVFpSorJyzq/A/cSxTIXJtGHO+aQOJvWDVweTwkIcTA4LYTBJLETBZLEQBJPGQgxMHgshMBNYiICZwUIAzBQWncHMYdERzCQWncDMYtEBzDQWjcHMY9EQzAUWjcDcYNEAzBUWlcHcYVERzCUWlcDcYlEBzDUWhcHcY1EQLAQWhcDCYFEALBQWG8HCYbEBLCQWK8HCYrES7Dy8tz+TzzAOdRjm2EJX1syMFbZjzcsA9rhjzcswqvmwY/2fcaZVbg6+dVJKR+Bp4rM/hn9DV9YSKCJjLYUiKtYaKCJirYUiGtYWKCJhbYUiClYJKCJglYLCO1ZJKDxjlYbCK1YNKDxi1YLCG1ZNKDxh1YbCC1YLKDxgtYLCOlZLKCxjtYbCKlYPKCxi9YLCGlZPKCxh9YbCCpYCFBawVKBQx1KCQhlLDQpVLEUoFLFUoRDc+ScLhdjOP2ko9p1/y6K08+/5jyMZKMR2/h1/gUlBodKGl5HdgAt8AN7+5IYhtq+7AAAAAElFTkSuQmCC) no-repeat;\n      display: inline-block;\n      background-size: 14px 11px;\n      width: 17px;\n      height: 12px;\n  }\n\n  .menucascade div > *::after {\n      content: '';\n      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAA7CAYAAAAXdfjrAAAACXBIWXMAAC4jAAAuIwF4pT92AAABZ0lEQVRo3s3a240CMQwF0GsqoJNtgVKmtNlOKIFStgPzAxJi5xEn19dBytcEcWTytMfcHTN+LkcPzew6HczMVgD3Mpy7/2sAVgD+ag8A161+me0MVYZrQZXgWlFyXAQlxb1n5T0wX34ks/Xjr1wCUUuP3Pfgnwa3tVxMgdtbYMtx+w+KcccPC3HnHYpwbZ0KcO0dxbhYZyEu/gURri/MAlz/4EzGjU3pRNz4QpiE42wfCTjepkvGcY8qRBz/gEfC5RyLCbi869cg7pJ4z7kF+z/c/e8wd0GI1hqM1qoY/MOojOWCgmIvsDQUc0uiolibOB3FOPakoEYPimmokaN1Kqr3MpKO6rm+SVDRC68MFUkRSFGtSRU5qiUNVYI6S9yVoY5SnaWoSC1JiorWkmSonlqSBNVbS0pH9daSft19kVV4G++B6ZHqqSXJUJFakhTVWkuSo9wdtvdCiJktAG6Sgb71+7O+qfIE2AZ/1PVQRysAAAAASUVORK5CYII) no-repeat;\n      display: inline-block;\n      background-size: 5px 8px;\n      width: 8px;\n      height: 9px;\n      position: relative;\n      margin-left: 2px;\n  }\n\n  .menucascade div > :last-child::after {\n      content: none;\n  }\n\n  .uicontrol {\n      font-weight: bold;\n  }\n\n  .scroll.troubleshoottabarea {\n    overflow: scroll;\n    height: 660px;\n  }\n"])), function (props) {
  return props.segments ? 0 : '2rem';
}, function (props) {
  return props.segments ? 0 : '2rem';
});
var DescInnerWrapper$1 = styled.div(_templateObject60$1 || (_templateObject60$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  @media (max-width: 768px) {\n    flex-direction: column-reverse;\n  }\n"])));
var DescBodyWrapper$1 = styled.div(_templateObject61$1 || (_templateObject61$1 = _taggedTemplateLiteralLoose(["\n  flex:1;\n"])));
var IconImage$1 = styled.img(_templateObject62$1 || (_templateObject62$1 = _taggedTemplateLiteralLoose(["\n  padding: 20px 0 0 10px;\n  cursor: pointer;\n  width: 30px;\n  height: 30px;\n"])));
var IconDownloadEmail$1 = styled.div(_templateObject63$1 || (_templateObject63$1 = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    padding-right: 25px;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    @media screen and (max-width: 601px) {\n      padding-right: 15px;\n    }\n  // @media screen and (min-width: 601px) {\n  //   width: 10%;\n  //   display: inline-block;\n  // }\n  // @media screen and (max-width: 601px) {\n  //   width: 20%;\n  //   display: inline-block;\n  // }\n"])));
var DownloadImage$1 = styled.img(_templateObject64$1 || (_templateObject64$1 = _taggedTemplateLiteralLoose(["\n  padding: 5px 0 0 10px;\n  cursor: pointer;\n  width: 16px;\n  height: 16px;\n"])));
var EmailImage$1 = styled.img(_templateObject65$1 || (_templateObject65$1 = _taggedTemplateLiteralLoose(["\n  padding: 5px 0 0 10px;\n  cursor: pointer;\n  width: 18px;\n  height: 13px;\n"])));
var BillingSteps$1 = styled.div(_templateObject66$1 || (_templateObject66$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n"])));
var DropdownWrapper$1 = styled.div(_templateObject67$1 || (_templateObject67$1 = _taggedTemplateLiteralLoose(["\n  width: 350px;\n  ", "\n"])), function (props) {
  return props.isDark && "\n  path {\n    fill: #fff;\n    stroke: #fff;\n    }\n  select {\n    border-bottom: 1px solid #fff;\n    border-top: 1px solid #fff;\n }";
});
var getActionsWrapperStyles$1 = function getActionsWrapperStyles(props) {
  var styles = 'justify-content: center;\n';
  if (props.showNext || props.showPrevious) {
    styles = 'justify-content: space-between;\n';
  } else if (props.alignButtons !== 'center') {
    if (props.alignButtons === 'left') {
      styles = 'justify-content: flex-start;\n';
    } else if (props.alignButtons === 'right') {
      styles = 'justify-content: flex-end;\n';
    }
  }
  if (props.disableMargin) {
    styles = 'margin-left: -50px;\n';
  }
  return styles;
};
var getButtonsWrapperStyles$1 = function getButtonsWrapperStyles(props) {
  var styles = '';
  if (props.stackButtons) {
    styles += 'align-items: center;\n';
    styles += 'flex-direction: column;\n';
    styles += 'justify-content: center;\n';
  }
  return styles;
};
var ActionsWrapper$1 = styled.div(_templateObject68$1 || (_templateObject68$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: flex-end;\n  justify-content: ", ";\n  ", "\n  width: 100%;\n  height:100%;\n  a.NextBtn{\n    display: flex;\n    padding-left:25px;\n    margin-top: 10px;\n    margin-left:15px;\n    cursor: pointer;\n    border-left:1px solid #ffffff;\n    border-bottom: none;\n  }\n  a.PrevBtn{\n    padding-right:10px;\n    display: flex;\n    margin-top: 10px;\n    margin-left: 50px;\n    cursor: pointer;\n    border-bottom: none;\n  }\n  a.NextBtn:hover, a.PrevBtn:hover{\n    border-bottom: none;\n    text-decoration: none;\n  }\n  a.NextBtn:hover svg,a.PrevBtn:hover svg{\n    transition: none;\n    -webkit-transition: none;\n    left:0;\n  }\n  a.NextBtn svg path, a.PrevBtn svg path{\n   stroke-width: 2px;\n  }\n  a.NextBtn:active svg g path, a.PrevBtn:active svg g path{\n    stroke: #ffffff;\n  }\n  button.Actionbtn{\n    border:none;\n    padding-right: 20px;\n    padding-left: 20px;\n    min-width:100px;\n    height:33px;\n    margin-top:0px;\n    margin-left:10px;\n    font-weight: normal;\n    background-color:#ffffff;\n    color:#000;\n    margin-right: 24px;\n    font-weight: 700;\n  }\n  button.Actionbtn:active{\n    background-color:#ffffff;\n    color: #000;\n  }\n  button.Actionbtn:hover:not(:active){\n    box-shadow: none;\n    transition: none;\n    -webkit-transition: none;\n  }\n\n  @media (max-width: 600px){\n    .NextBtn{\n    margin-top: 30px;\n    margin-right: 30px;\n    }\n    .PrevBtn{\n        margin-top: 30px;\n        margin-left: 30px;\n    }\n  }\n"])), function (props) {
  return props.showNext || props.showPrevious ? 'space-between' : 'center';
}, function (props) {
  return getActionsWrapperStyles$1(props);
});
var NewPreviousButtonWrapper$1 = styled.div(_templateObject69$1 || (_templateObject69$1 = _taggedTemplateLiteralLoose(["\n  display:flex;\n  align-items: center;\n"])));
var ButtonsWrapper$2 = styled.div(_templateObject70$1 || (_templateObject70$1 = _taggedTemplateLiteralLoose(["\n  display: ", "\n  ", "\n  ", "\n"])), window.isBAUACSS ? 'flex' : 'inline-block', window.isBAUACSS && 'column-gap: 15px', function (props) {
  return getButtonsWrapperStyles$1(props);
});
var Next$1 = styled.div(_templateObject71$1 || (_templateObject71$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 10px;\n  margin-right: 56px;\n  @media (max-width: 600px){\n    margin-top: 30px;\n    margin-right: 30px;\n  }\n  cursor: pointer;\n"])));
var Previous$1 = styled.div(_templateObject72$1 || (_templateObject72$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 10px;\n  margin-left: 50px;\n  @media (max-width: 600px){\n    margin-top: 30px;\n    margin-left: 30px;\n  }\n  cursor: pointer;\n  ", "\n"])), function (props) {
  return props.isDark ? "\n    svg path{\n      stroke: #D8DADA;\n    }\n    " : "\n    svg path{\n      stroke: #000;\n    }\n  ";
});
var StyledButton$2 = styled(Button$1)(_templateObject73$1 || (_templateObject73$1 = _taggedTemplateLiteralLoose(["\n  min-width: ", ";\n\n  span {\n    overflow: visible !important;\n    width: fit-content !important;\n  }\n\n  @media (min-width: 601px) {\n    :not(:last-child) {\n      margin-right: 14px;\n    }\n  }\n\n  [class^=\"StyledChildWrapper-\"] {\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  @media (max-width: 600px){\n    margin-top: 10px;\n    align-items: center;\n    :not(:first-child) {\n    }\n\n    font-size: 14px;\n    padding: 0;\n    margin-bottom: 20px!important;\n  }\n"])), function (props) {
  return props.minWidth ? props.minWidth : '50%';
});
var StyledTextLinkCaret$1 = styled(TextLinkCaret)(_templateObject74$1 || (_templateObject74$1 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (props) {
  return props.isDiabled && "\n  * {\n      cursor: not-allowed !important;\n    }";
});
var NextNew$1 = styled(TextLinkCaret)(_templateObject75$1 || (_templateObject75$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  border-left:1px solid #ffffff;\n  padding-left:25px;\n  margin-top: 10px;\n  margin-left:15px;\n\n  @media (max-width: 600px){\n    margin-top: 30px;\n    margin-right: 30px;\n  }\n  cursor: pointer;\n\n  ", "\n"])), function (props) {
  return props.isDiabled && "\n    *{\n      cursor: not-allowed !important;\n    }";
});
var PreviousNew$1 = styled(TextLinkCaret)(_templateObject76$1 || (_templateObject76$1 = _taggedTemplateLiteralLoose(["\n  padding-right:10px;\n  display: flex;\n  margin-top: 10px;\n  margin-left: 50px;\n  @media (max-width: 600px){\n    margin-top: 30px;\n    margin-left: 30px;\n  }\n  cursor: pointer;\n\n  ", "\n"])), function (props) {
  return props.isDiabled && "\n    *{\n      cursor: not-allowed !important;\n    }\n  ";
});
var NewBtnWrapper$1 = styled.div(_templateObject77$1 || (_templateObject77$1 = _taggedTemplateLiteralLoose(["\n  display:flex;\n  width:100%;\n  justify-content:space-between;\n  align-self: center;\n"])));
var NewActionButton$1 = styled.button(_templateObject78$1 || (_templateObject78$1 = _taggedTemplateLiteralLoose(["\n  background-color:", " !important;\n  border-radius:50px;\n  border:none;\n  min-width:100px;\n  height:25px;\n  margin-top:5px;\n  margin-left:10px;\n  font-size: 13px;\n  padding: 2px;\n  font-weight: bold;\n  cursor: ", ";\n"])), function (props) {
  return props.disabled ? 'lightgrey' : '#fff';
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
});
var NewActionButtonWrapper$1 = styled.div(_templateObject79$1 || (_templateObject79$1 = _taggedTemplateLiteralLoose(["\n  display:flex;\n  align-items: center;\n  margin-right:15px;\n"])));
var IconImageUp$1 = styled.img(_templateObject80$1 || (_templateObject80$1 = _taggedTemplateLiteralLoose(["\n  margin-left: 20px;\n  padding-top: 6px;\n  cursor: ", ";\n  opacity: ", "\n"])), function (props) {
  return props.thumbsUpClicked || props.submitClicked ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.submitClicked ? '50%' : 'none';
});
var IconImageDown$1 = styled.img(_templateObject81$1 || (_templateObject81$1 = _taggedTemplateLiteralLoose(["\n  margin-left: 20px;\n  padding-top: 6px;\n  cursor: ", ";\n  opacity: ", "\n"])), function (props) {
  return props.submitClicked || props.thumbsUpClicked ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.thumbsUpClicked ? '50%' : 'none';
});
var LeftIcon$1 = styled.span(_templateObject82$1 || (_templateObject82$1 = _taggedTemplateLiteralLoose(["\n  caret-color:transparent;\n  transform: rotate(225deg);\n  margin-top:3px;\n  width:8px;\n  height:8px;\n  border:none;\n  border-left: 2px solid #ffffff;\n  border-bottom: 2px solid #ffffff;\n  cursor: pointer;\n"])));
var Divider$1 = styled.span(_templateObject83$1 || (_templateObject83$1 = _taggedTemplateLiteralLoose(["\n  border-left:1px solid #BFBFBF;\n  padding:17px 0;\n"])));
var LeftIconDisabled$1 = styled.span(_templateObject84$1 || (_templateObject84$1 = _taggedTemplateLiteralLoose(["\n  caret-color:transparent;\n  transform: rotate(225deg);\n  margin-top:3px;\n  width:8px;\n  height:8px;\n  border:none;\n  border-left: 2px solid silver;\n  border-bottom: 2px solid silver;\n  cursor:not-allowed;\n"])));
var RightIcon$1 = styled.span(_templateObject85$1 || (_templateObject85$1 = _taggedTemplateLiteralLoose(["\n  caret-color:transparent;\n  transform: rotate(45deg);\n  margin-top:3px;\n  width:8px;\n  height:8px;\n  border:none;\n  border-left: 2px solid #ffffff;\n  border-bottom: 2px solid #ffffff;\n  cursor: pointer;\n"])));
var RightIconDisabled$1 = styled.span(_templateObject86$1 || (_templateObject86$1 = _taggedTemplateLiteralLoose(["\n  caret-color:transparent;\n  transform: rotate(45deg);\n  margin-top:3px;\n  width:8px;\n  height:8px;\n  border:none;\n  border-left: 2px solid silver;\n  border-bottom: 2px solid silver;\n  cursor: not-allowed;\n"])));
var StyledDropdownItem$1 = styled(DropdownItem)(_templateObject87$1 || (_templateObject87$1 = _taggedTemplateLiteralLoose(["\n  &&& {\n    background: #ffffff;\n    color: black;\n    padding: 10px !important;\n    border-bottom: 1px solid #D8DADA;\n    border-top: 1px solid #D8DADA;\n    margin: 0;\n    min-height: 20px !important;\n    font-size: 14px !important;\n    font: normal 14px tahoma,arial,verdana,sans-serif;\n    line-height: 20px;\n    font-weight: normal!important;\n    border-left: 4px solid #FFF;\n  }\n"])));
var DividerWrapper$1 = styled.span(_templateObject88$1 || (_templateObject88$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-left: 20px;\n  align-self: center;\n"])));
var DropdownSelectWrapper$1 = styled.div(_templateObject89$1 || (_templateObject89$1 = _taggedTemplateLiteralLoose(["\n  * {\n    background-color:  ", " !important;\n    font-weight: normal;\n    color: #fff;\n  }\n  button{\n    margin:5px !important\n  }\n  button span{\n    border-bottom: none !important;\n  }\n  svg g polygon{\n    fill: #fff !important;\n  }\n  height: 33px;\n  font-weight: normal;\n  margin:3px !important;\n  border: 1px solid #fff !important;\n  border-radius: 20px !important;\n  color: #fff !important;\n\n  .editable-dropdown-input {\n    font-weight:normal;\n    font-size:14px !important;\n    color: #fff !important;\n    margin :3px !important;\n  }\n\n  select, select:focus-visible {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    box-sizing: content-box !important;\n    border: 1px solid #fff !important;\n    border-radius: 20px;\n    -webkit-appearance: none !important;\n    -moz-appearance: none !important;\n    appearance: none !important;\n    text-indent: 5px;\n  }\n\n  option {\n    background-color: #fff !important;\n    color: #000;\n    box-sizing: content-box;\n    padding-top : 20px !important;\n    padding-bottom : 20px !important;\n    margin-top : 20px !important;\n    margin-bottom : 20px !important;\n  }\n  select option {\n    box-sizing: content-box;\n    padding: 20px 0;\n  }\n  div span{\n    background-color: transparent !important;\n  }\n\n  div span span span {\n    margin-top: -4px;\n  }\n\n  path {\n    stroke: #fff;\n    fill: #fff;\n  }\n\n  margin-right: 20px\n"])), function (props) {
  return props.isDark ? '#000' : 'gray';
});
var StyledDropdownItemNetwork$1 = styled(StyledDropdownItem$1)(_templateObject90$1 || (_templateObject90$1 = _taggedTemplateLiteralLoose(["\n  border-radius: 20px !important;\n  color: #ffffff !important;\n"])));
var ContainerWrapper$1 = styled.div(_templateObject91$1 || (_templateObject91$1 = _taggedTemplateLiteralLoose(["\n  padding: 25px 40px 15px 40px;\n"])));
var DividerContainer$1 = styled.div(_templateObject92$1 || (_templateObject92$1 = _taggedTemplateLiteralLoose(["\ndisplay: flex;\n    justify-content: center;\n    margin: 7px;\n    div {\n      width: 93%\n    }\n"])));
var ContactsContainer$1 = styled.div(_templateObject93$1 || (_templateObject93$1 = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  @media (min-width: 601px) {\n    height: 290px;\n    padding: 0px 30px 0px 30px;\n    width: 40%;\n  }\n\n  @media (max-width: 600px) {\n    width: 100%;\n  }\n"])));
var StyledTextWithHtml$1 = styled(TextWithHtml)(_templateObject94$1 || (_templateObject94$1 = _taggedTemplateLiteralLoose(["\n  .congratsDesc{\n    font-weight: bold;\n    font-size: 22px;\n  }\n  @media (max-width: 600px) {\n    width: 300px;\n  }\n"])));
var TitleTextWrapperCompletion$1 = styled.div(_templateObject95$1 || (_templateObject95$1 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  width: 95%;\n"])));
var StepContainerCompletion$1 = styled.div(_templateObject96$1 || (_templateObject96$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n\n  @media (min-width: 601px) {\n    height: 290px;\n    justify-content: space-between;\n    padding: 25px 40px 15px 40px;\n  }\n\n  @media (max-width: 600px) {\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n  }\n"])));
var StepInfoContainerCompletion$1 = styled.div(_templateObject97$1 || (_templateObject97$1 = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n\n  @media (min-width: 601px) {\n    align-items: flex-start;\n    height: 275px;\n    //justify-content: center;\n    width: 50%;\n  }\n\n  @media (max-width: 600px) {\n    width: 100%;\n  }\n"])));
var DeviceImageCompletion$1 = styled.img(_templateObject98$1 || (_templateObject98$1 = _taggedTemplateLiteralLoose(["\n  @media(min-width: 601px) {\n    width: 50%;\n  }\n  @media(max-width: 600px) {\n    width: 12%;\n  }\n"])));
var DesktopHeadingWrapper$1 = styled.div(_templateObject99$1 || (_templateObject99$1 = _taggedTemplateLiteralLoose(["\n  @media (max-width: 600px) {\n    display: none;\n  }\n"])));
var MobileHeadingWrapper$1 = styled.div(_templateObject100$1 || (_templateObject100$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  position: relative;\n  width: 100%;\n  @media (min-width: 601px) {\n     display: none;\n    }\n  a {\n    color: black;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n  @media(max-width: 768px) {\n    font-size:1.0rem;\n  }\n  @media screen and (max-width: 600px) {\n    margin-left: 0px;\n    width: 330px;\n    // margin-top: 20px\n  }\n  div.checklist-wrapper {\n    @media screen and (max-width: 600px) {\n      position: absolute;\n    }\n  }\n"])));
var FeedbackSaveExitContainer$1 = styled.div(_templateObject101$1 || (_templateObject101$1 = _taggedTemplateLiteralLoose([""])));
var SaveExitCloseButton$1 = styled.div(_templateObject102$1 || (_templateObject102$1 = _taggedTemplateLiteralLoose([""])));
var StyledGrid$1 = styled.div(_templateObject103$1 || (_templateObject103$1 = _taggedTemplateLiteralLoose([""])));
var StyledRow$1 = styled.div(_templateObject104$1 || (_templateObject104$1 = _taggedTemplateLiteralLoose(["\n  display:flex;\n  /*justify-content: space-between;*/\n  margin-top: 1rem\n  // flex-direction: column\n"])));
var StyledTile$1 = styled.div(_templateObject105$1 || (_templateObject105$1 = _taggedTemplateLiteralLoose(["\n/*flex:1;*/\nposition: relative;\nborder: 1px solid lightGray;\nborder-radius: 7px;\ndisplay: inline-block;\n/*padding: 1rem;*/\n/*margin-right: 1.5rem;*/\nmargin: 12px 16px 0 0;\ncursor: pointer;\n\njustify-content: center;\npadding-left: 20px;\npadding-top: 13px;\npadding-bottom: 12px;\npadding-right: 12px;\n/*width: 335px;*/\n\n@media (min-width: 601px) {\n  width: 275px;\n}\n\n@media (max-width: 600px) {\n  width: 315px;\n}\n"])));
var TilesContainer$1 = styled.div(_templateObject106$1 || (_templateObject106$1 = _taggedTemplateLiteralLoose(["\n  div.question {\n    font-size: 1rem;\n    font-family: 'Verizon-NHG-eDS';\n    font-weight: 400;\n    line-height: 1.25rem;\n    letter-spacing: 0.03125rem;\n    text-decoration: none;\n    margin-bottom: 15px;\n    a{ color: #428bca;  text-decoration : underline;}\n  }\n  @media(min-width:601px) {\n    column-fill: auto;\n    column-count: 1;\n    //margin-top: 30px;\n    margin-bottom: 30px;\n  }\n  @media(max-width: 600px) {\n    margin-top: 1rem;\n    margin-bottom: 15px;\n  }\n"])));
var TileFooterContainer$1 = styled.div(_templateObject107$1 || (_templateObject107$1 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: center;"])));
var ButtonDiv$1 = styled.div(_templateObject108$1 || (_templateObject108$1 = _taggedTemplateLiteralLoose(["\n    padding-top: 6px;\n    padding-left:15px;\n"])));
var HeadingSpan$1 = styled.span(_templateObject109$1 || (_templateObject109$1 = _taggedTemplateLiteralLoose([""])));
var NetworkCongestion$1 = styled.div(_templateObject110$1 || (_templateObject110$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  font-weight: bold;\n  text-align: center;\n  div.row {\n    div.column:nth-child(1){\n      border-bottom: none;\n    }\n    div.column:nth-child(2){\n      border-top: none;\n    }\n    div.column0{\n      color: #FFF;\n    }\n  }\n  div.column {\n    border: 1px solid #808080;\n    width: 120px;\n    // padding-left: 5px;\n  }\n  div.redbg {\n    background-color: red;\n    color: red;\n  }\n  div.white {\n    color: #FFF;\n  }\n"])));
var CustomContentDiv$1 = styled.div(_templateObject111$1 || (_templateObject111$1 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n    flex-direction: ", ";\n    @media (max-width: 768px) {\n      flex-direction: column-reverse;\n    }\n"])), function (props) {
  return props.isSetFlexColumn ? 'column' : '';
});
var ProvisioningChecksInfo$1 = styled.div(_templateObject112$1 || (_templateObject112$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n"])));
var ProvisioningChecksTable$1 = styled.div(_templateObject113$1 || (_templateObject113$1 = _taggedTemplateLiteralLoose(["\n  table {\n    border: 1px solid #d8dada;\n  }\n  thead {\n    background-color: ", ";\n    tr {\n      border-bottom: 1px solid #d8dada !important;\n    }\n  }\n  td {\n    padding: 0.2rem 0 0.2rem 0.5rem\n    font-size: 0.8rem;\n  }\n"])), function (props) {
  return props.color;
});
var LeftNavWrapperAll$1 = styled.div(_templateObject114$1 || (_templateObject114$1 = _taggedTemplateLiteralLoose(["\n height: 232px;\n border: 10px;\n margin-left: 65px;\n padding: 0px 33px 35px 50px;\n width: 212px;\n"])));
var LeftNavSidebar$1 = styled.div(_templateObject115$1 || (_templateObject115$1 = _taggedTemplateLiteralLoose(["\n display: inline-flex;\n @media (max-width: 414px) {\n  flex-wrap: ", ";\n}\n"])), function (props) {
  return props.isACSS ? 'unset' : 'wrap';
});
var StyledNumberInput$1 = styled.input(_templateObject116$1 || (_templateObject116$1 = _taggedTemplateLiteralLoose(["\nwidth: 100px;\nheight: 30px;\nmargin-right: 10px;\n"])));
var RightArrowDiv$1 = styled.div(_templateObject117$1 || (_templateObject117$1 = _taggedTemplateLiteralLoose(["\n   display:flex;\n   justify-content:flex-end;\n   padding-right:10px;\n   padding-bottom:10px;\n\n "])));
var TiletContainer$1 = styled.div(_templateObject118$1 || (_templateObject118$1 = _taggedTemplateLiteralLoose(["\n display : grid;\n grid-template-columns: 1fr 1fr;\n gap:20px;\n width:740px;\n \n \n"])));
var TechCoachBody$1 = styled.p(_templateObject119$1 || (_templateObject119$1 = _taggedTemplateLiteralLoose(["\nmargin-top: 1rem;\n"])));
var CloseIconWrapper$1 = styled.div(_templateObject120$1 || (_templateObject120$1 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  width: 3rem;\n  height: 3rem;\n  display: flex;\n  -webkit-box-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  align-items: center;\n  z-index: 1;\n"])));
var CloseButtonIconContainer$1 = styled.div(_templateObject121$1 || (_templateObject121$1 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 2rem;\n  height: 2rem;\n"])));
var PopupCloseButton$1 = styled.button(_templateObject122$1 || (_templateObject122$1 = _taggedTemplateLiteralLoose(["\ndisplay: flex;\n-webkit-box-pack: center;\njustify-content: center;\n-webkit-box-align: center;\nalign-items: center;\npadding: 0px;\nmargin: 0px;\ncursor: pointer;\nbox-sizing: border-box;\ntext-align: center;\ntext-decoration: none;\nposition: relative;\ntouch-action: manipulation;\npointer-events: auto;\nvertical-align: middle;\noutline: none;\nwidth: 100%;\nheight: 100%;\nbackground-color: transparent;\nborder-radius: 50%;\nborder: none;\nbackground-clip: padding-box;\ntransition: all 0.1s ease-out 0s;\n"])));
var CloseButtonHitArea$1 = styled.span(_templateObject123$1 || (_templateObject123$1 = _taggedTemplateLiteralLoose(["\n    height: 2.75rem;\n    width: 2.75rem;\n    display: inline-block;\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    text-align: center;\n    transform: translate(-50%, -50%);\n"])));
var IconContainer$1 = styled.span(_templateObject124$1 || (_templateObject124$1 = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    left: 0px;\n    bottom: 0px;\n    pointer-events: none;\n"])));
var CloseIconSVG$1 = styled.svg(_templateObject125$1 || (_templateObject125$1 = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    height: 1.25rem;\n    width: 1.25rem;\n    min-height: 1.25rem;\n    min-width: 1.25rem;\n"])));
var styledBauComps = (_styledBauComps = {
  ProvisioningChecksTable: ProvisioningChecksTable$1,
  ProvisioningChecksInfo: ProvisioningChecksInfo$1,
  EmailIconDiv: EmailIconDiv$1,
  SmsIconDiv: SmsIconDiv$1,
  ResumeEmailIconDiv: ResumeEmailIconDiv$1,
  ContentWrapper: ContentWrapper$2,
  StyledTextLink: StyledTextLink$1,
  TitleWrapper: TitleWrapper$1,
  ButtonWrapper: ButtonWrapper$1,
  ButtonWrapperMobile: ButtonWrapperMobile$1,
  TextWrapper: TextWrapper$1,
  TroubleShootingTitle: TroubleShootingTitle$1,
  TitleTextWrapper: TitleTextWrapper$1,
  HeadingWrapper: HeadingWrapper$1,
  PageTitle: PageTitle$1,
  Cancel: Cancel$1,
  TabsContainer: TabsContainer$1,
  StepContainer: StepContainer$1,
  StepInfoContainer: StepInfoContainer$1,
  ImageContainer: ImageContainer$1,
  DeviceImageContainer: DeviceImageContainer$1,
  DeviceImage: DeviceImage$1,
  IssuesContainer: IssuesContainer$1,
  ImageTitle: ImageTitle$1,
  MapWrapper: MapWrapper$1,
  FeedbackCloseButton: FeedbackCloseButton$1,
  CloseButton: CloseButton$1,
  StyledModal: StyledModal$1,
  StyledModalBody: StyledModalBody$1,
  DescWrapper: DescWrapper$1,
  Probing: Probing$1,
  SearchBar: SearchBar$1,
  SearchResults: SearchResults$1,
  SearchTitle: SearchTitle$1,
  SearchDesc: SearchDesc$1,
  SearchResultsContainer: SearchResultsContainer$1,
  IframeContainer: IframeContainer$1,
  StyledTableHeader: StyledTableHeader$1,
  StyledCell: StyledCell$1,
  StyledTable: StyledTable$1,
  ChangeIssueContainer: ChangeIssueContainer$1,
  BoldText: BoldText$1,
  StepOption: StepOption$1,
  ButtonContainer: ButtonContainer$1,
  StyledModalPopup: StyledModalPopup$1,
  StyledCheckbox: StyledCheckbox$1,
  NavInnerSteps: NavInnerSteps$1,
  QuesDropdownSelect: QuesDropdownSelect$1,
  ContentBody: ContentBody$1,
  FootnoteBlock: FootnoteBlock$1,
  StyledEmailModalPopup: StyledEmailModalPopup$1,
  CopyIconDiv: CopyIconDiv$1,
  FeedbackSaveExitContainer: FeedbackSaveExitContainer$1,
  SaveExitCloseButton: SaveExitCloseButton$1,
  Footer: Footer$1,
  HeaderTabContainer: HeaderTabContainer$1,
  NavStepsContainer: NavStepsContainer$1,
  TroubleShootingTitleNew: TroubleShootingTitleNew$1,
  NewPageTitle: NewPageTitle$1,
  NavStepsWrapper: NavStepsWrapper$1,
  RightMenuContainer: RightMenuContainer$1,
  DescWrapperNew: DescWrapperNew$1,
  IconImage: IconImage$1,
  DropdownWrapper: DropdownWrapper$1,
  BillingSteps: BillingSteps$1,
  DownloadImage: DownloadImage$1,
  EmailImage: EmailImage$1,
  IconDownloadEmail: IconDownloadEmail$1,
  ActionsWrapper: ActionsWrapper$1,
  NewPreviousButtonWrapper: NewPreviousButtonWrapper$1,
  ButtonsWrapper: ButtonsWrapper$2,
  Next: Next$1,
  Previous: Previous$1,
  StyledTextLinkCaret: StyledTextLinkCaret$1,
  NextNew: NextNew$1,
  PreviousNew: PreviousNew$1,
  NewBtnWrapper: NewBtnWrapper$1,
  NewActionButton: NewActionButton$1,
  NewActionButtonWrapper: NewActionButtonWrapper$1,
  IconImageUp: IconImageUp$1,
  IconImageDown: IconImageDown$1,
  LeftIcon: LeftIcon$1,
  Divider: Divider$1,
  LeftIconDisabled: LeftIconDisabled$1,
  RightIcon: RightIcon$1,
  RightIconDisabled: RightIconDisabled$1,
  StyledDropdownItem: StyledDropdownItem$1,
  DividerWrapper: DividerWrapper$1,
  DropdownSelectWrapper: DropdownSelectWrapper$1,
  StyledDropdownItemNetwork: StyledDropdownItemNetwork$1,
  StyledButton: StyledButton$2,
  ContainerWrapper: ContainerWrapper$1,
  DividerContainer: DividerContainer$1,
  ContactsContainer: ContactsContainer$1,
  StyledTextWithHtml: StyledTextWithHtml$1,
  TitleTextWrapperCompletion: TitleTextWrapperCompletion$1,
  StepContainerCompletion: StepContainerCompletion$1,
  DeviceImageCompletion: DeviceImageCompletion$1,
  StepInfoContainerCompletion: StepInfoContainerCompletion$1,
  DesktopHeadingWrapper: DesktopHeadingWrapper$1,
  MobileHeadingWrapper: MobileHeadingWrapper$1,
  StyledGrid: StyledGrid$1,
  StyledRow: StyledRow$1,
  StyledTile: StyledTile$1,
  TilesContainer: TilesContainer$1,
  IssueBoxWrapper: IssueBoxWrapper$1,
  IssueContentbox: IssueContentbox$1,
  IssueContentArrow: IssueContentArrow$1,
  TileFooterContainer: TileFooterContainer$1,
  ButtonDiv: ButtonDiv$1,
  HeadingSpan: HeadingSpan$1,
  CustomContentDiv: CustomContentDiv$1,
  DescInnerWrapper: DescInnerWrapper$1,
  DescBodyWrapper: DescBodyWrapper$1,
  NetworkCongestion: NetworkCongestion$1,
  LeftNavWrapperAll: LeftNavWrapperAll$1,
  LeftNavSidebar: LeftNavSidebar$1,
  StyledNumberInput: StyledNumberInput$1,
  RightArrowDiv: RightArrowDiv$1,
  TiletContainer: TiletContainer$1,
  TechCoachBody: TechCoachBody$1,
  CloseIconWrapper: CloseIconWrapper$1,
  CloseButtonIconContainer: CloseButtonIconContainer$1,
  PopupCloseButton: PopupCloseButton$1,
  CloseButtonHitArea: CloseButtonHitArea$1,
  IconContainer: IconContainer$1
}, _styledBauComps["IconContainer"] = IconContainer$1, _styledBauComps.CloseIconSVG = CloseIconSVG$1, _styledBauComps);

var _templateObject$5, _templateObject2$3, _templateObject3$3, _templateObject4$3, _templateObject5$2, _templateObject6$2, _templateObject7$2, _templateObject8$2, _templateObject9$2, _templateObject0$2, _templateObject1$2, _templateObject10$2, _templateObject11$2, _templateObject12$2, _templateObject13$2, _templateObject14$2, _templateObject15$2, _templateObject16$2, _templateObject17$2, _templateObject18$2, _templateObject19$2, _templateObject20$2, _templateObject21$2, _templateObject22$2, _templateObject23$2, _templateObject24$2, _templateObject25$2, _templateObject26$2, _templateObject27$2, _templateObject28$2, _templateObject29$2, _templateObject30$2, _templateObject31$2, _templateObject32$2, _templateObject33$2, _templateObject34$2, _templateObject35$2, _templateObject36$2, _templateObject37$2, _templateObject38$2, _templateObject39$2, _templateObject40$2, _templateObject41$2, _templateObject42$2, _templateObject43$2, _templateObject44$2, _templateObject45$2, _templateObject46$2, _templateObject47$2, _templateObject48$2, _templateObject49$2, _templateObject50$2, _templateObject51$2, _templateObject52$2, _templateObject53$2, _templateObject54$2, _templateObject55$2, _templateObject56$2, _templateObject57$2, _templateObject58$2, _templateObject59$2, _templateObject60$2, _templateObject61$2, _templateObject62$2, _templateObject63$2, _templateObject64$2, _templateObject65$2, _templateObject66$2, _templateObject67$2, _templateObject68$2, _templateObject69$2, _templateObject70$2, _templateObject71$2, _templateObject72$2, _templateObject73$2, _templateObject74$2, _templateObject75$2, _templateObject76$2, _templateObject77$2, _templateObject78$2, _templateObject79$2, _templateObject80$2, _templateObject81$2, _templateObject82$2, _templateObject83$2, _templateObject84$2, _templateObject85$2, _templateObject86$2, _templateObject87$2, _templateObject88$2, _templateObject89$2, _templateObject90$2, _templateObject91$2, _templateObject92$2, _templateObject93$2, _templateObject94$2, _templateObject95$2, _templateObject96$2, _templateObject97$2, _templateObject98$2, _templateObject99$2, _templateObject100$2, _templateObject101$2, _templateObject102$2, _templateObject103$2, _templateObject104$2, _templateObject105$2, _templateObject106$2, _templateObject107$2, _templateObject108$2, _templateObject109$2, _templateObject110$2, _templateObject111$2, _templateObject112$2, _templateObject113$2;
var MainWrapper = styled.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteralLoose(["\n  @media(min-width:601px) {\n    display: ", ";\n  }\n"])), function (props) {
  return props.isNewDesign ? 'flex' : 'block';
});
var SubWrapper = styled.div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteralLoose(["\n  @media(min-width: 601px) {\n    width: ", ";\n  }\n"])), function (props) {
  return props.isNewDesign ? props.rightMenuItems.length > 0 ? '75%' : '100%' : '100%';
});
var ContentWrapper$3 = styled.div(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteralLoose(["\n  @media(max-width: 600px) {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 2.0rem;\n  }\n   @media(min-width: 768px) {\n    padding-bottom:50px;\n    position: relative;\n    /* max-width: 1019px; */\n    /* margin: auto; */\n    box-shadow: ", ";\n    // margin-left: ", ";\n    // margin-right: ", ";\n    /* width: ", "; */\n    /* padding: ", "; */\n  }\n"])), function (props) {
  return props.showBorder ? '0px 0px 10px #aaa' : props.isNewDesign ? 'none' : '0px 0px 10px #aaa';
}, function (props) {
  return props.isNewDesign ? 0 : 'auto';
}, function (props) {
  return props.isNewDesign ? 0 : 'auto';
}, function (props) {
  return props.isNewDesign ? 'auto' : '1019px';
}, function (props) {
  return props.isNewDesign ? '' : '30px';
});
var ButtonWrapper$2 = styled.div(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width: 601px) {\n    width: 100%;\n  }\n  @media screen and (max-width: 600px) {\n    display:none\n  }\n    div.solvedProblemLinkNew{\n   text-align: center;\n    padding:10px 10px 0;\n    .link{\n      font-family: 'Verizon-NHG-eDS';\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 19px;\n      text-decoration-line: underline;\n      color: #747676;\n    }\n  }\n  div.solvedProblemLink{\n    text-align: center;\n    padding:32px 0;\n    .link{\n      font-family: 'Verizon-NHG-eDS';\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 19px;\n      text-decoration-line: underline;\n      color: #747676;\n    }\n  }\n"])));
var ButtonWrapperMobile$2 = styled.div(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteralLoose(["\n  //margin:16px;\n  @media screen and (min-width: 600px) {\n    display:none\n  }\n  div.solvedProblemLink{\n    text-align: center;\n    .link{\n      font-family: 'Verizon-NHG-eDS';\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 19px;\n      text-decoration-line: underline;\n      color: #747676;\n    }\n  }\n"])));
var TextWrapper$2 = styled('Body')(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteralLoose(["\n  font-size: 25px;\n  text-align: center;\n  margin-bottom: 10px;\n  overflow: hidden;\n  height: unset;\n  a :active {\n    color:gray !important;\n    border-bottom: 1px solid gray;\n  }\n  a :hover {\n    color:gray  !important;\n    border-bottom: 1px solid gray;\n  }\n\n  @media screen and (max-width: 600px) {\n    margin-left: 5px;\n  }\n"])));
var TroubleShootingTitle$2 = styled.div(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width: 601px) {\n    padding-top: 18px;\n    margin-left: 10px;\n  }\n"])));
var TroubleShootingNewTitle = styled.div(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width: 601px) {\n    padding: 0px 70px;\n    margin-top:20px;\n    margin-bottom:25px\n  }\n  @media screen and (max-width: 600px) {\n    margin-bottom:15px;\n    padding: 0 15px;\n  }\n"])));
var TitleTextWrapper$2 = styled.div(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteralLoose(["\n  /* text-align: left; */\n  /* padding-bottom: 10px; */\n  padding-bottom: 32px;\n  @media screen and (max-width: 600px) {\n\n  }\n"])));
var HeadingWrapper$2 = styled.div(_templateObject0$2 || (_templateObject0$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  position: relative;\n  width: 100%;\n  a {\n    color: black;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n  @media(max-width: 768px) {\n    font-size:1.0rem;\n  }\n  @media screen and (max-width: 600px) {\n    margin-left: 0px;\n    width: 330px;\n  }\n  div.checklist-wrapper {\n    @media screen and (max-width: 600px) {\n      position: absolute;\n    }\n  }\n"])));
var PageTitle$2 = styled.div(_templateObject1$2 || (_templateObject1$2 = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width:601px) {\n    position: absolute;\n    margin-left: 70px;\n  }\n  @media screen and (max-width: 600px) {\n    margin: 0 0 15px 65px;\n    z-index: 1;\n  }\n"])));
var SelectDeviceBannerDiv = styled.div(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteralLoose(["\n@media(min-width: 601px) {\n  padding: 0px 70px 0px 66px;\n}\n\n@media (max-width: 600px) {\n  padding: 0 15px 0 15px;\n}\n"])));
var StepContainer$2 = styled.div(_templateObject11$2 || (_templateObject11$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  div.right-menu-container{\n    display: ", ";\n    // width:  ", ";\n    width: 100%;\n    // overflow: auto\n  }\n  nav {\n    // height: 280px;\n  }\n  nav.fixedRightNav{\n    position: sticky;\n    overflow-y: auto;\n    top: 300px;\n    margin-bottom: 28px;\n  }\n  @media(min-width: 601px) {\n    justify-content: space-between;\n    padding: 0px 70px 0px 0px;\n    width: 100%;\n  }\n  @media(max-width: 600px) {\n    flex-direction: column;\n  }\n"])), function (props) {
  return props.isNewDesign ? 'block' : 'none';
}, function (props) {
  return props.hideRightNav ? 0 : '20%';
});
var StepInfoContainer$2 = styled.div(_templateObject12$2 || (_templateObject12$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  @media(max-width: 600px) {\n    img {\n      max-width: 300px;\n    }\n  }\n  @media(min-width: 601px) {\n    /* width: ", "; */\n    padding-right: ", ";\n  }\n"])), function (isNewDesign) {
  if (isNewDesign === void 0) {
    isNewDesign = false;
  }
  return isNewDesign ? function (_ref) {
    var _ref$hideRightNav = _ref.hideRightNav,
      hideRightNav = _ref$hideRightNav === void 0 ? true : _ref$hideRightNav;
    return hideRightNav ? '100%' : '80%';
  } : '100%';
}, function (_ref2) {
  var isWaitScreen = _ref2.isWaitScreen;
  return !isWaitScreen ? '20px' : '0';
});
var ImageContainer$2 = styled.div(_templateObject13$2 || (_templateObject13$2 = _taggedTemplateLiteralLoose(["\n  @media(min-width: 601px) {\n    float:left;\n  }\n"])));
var DeviceImageContainer$2 = styled.div(_templateObject14$2 || (_templateObject14$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  margin-top: 25px;\n  margin-bottom: 20px;\n  @media(min-width: 601px) {\n    margin-top:40px;\n  }\n"])));
var DeviceImage$2 = styled.img(_templateObject15$2 || (_templateObject15$2 = _taggedTemplateLiteralLoose(["\n  @media(min-width: 601px) {\n    width: 7%;\n    position: absolute;\n    top: -40px;\n    left: 57px;\n  }\n  @media(max-width: 600px) {\n    width: 12%;\n  }\n"])));
var IssuesContainer$2 = styled.div(_templateObject16$2 || (_templateObject16$2 = _taggedTemplateLiteralLoose(["\n  div.question {\n    font-size: 1rem;\n    font-family: 'Verizon-NHG-eDS';\n    font-weight: 400;\n    line-height: 1.25rem;\n    letter-spacing: 0.03125rem;\n    text-decoration: none;\n    margin-bottom: 15px;\n  }\n  @media(min-width:601px) {\n    column-fill: auto;\n    column-count: 1;\n    margin-bottom: 30px;\n    max-width: ", ";\n  }\n  @media(max-width: 600px) {\n    margin-top: 1rem;\n    margin-bottom: 15px;\n  }\n"])), function (props) {
  return props.isSetFlexColumn ? props.isMvoDigi ? '85%' : '90%' : '600px';
});
var ImageTitle$2 = styled.div(_templateObject17$2 || (_templateObject17$2 = _taggedTemplateLiteralLoose(["\n  @media(min-width: 601px) {\n    position: absolute;\n    display: inline-block;\n    top: 20px;\n    left: 132px;\n    text-align:start;\n    margin-right: 10px;\n    max-width: 160px;\n  }\n"])));
var MapWrapper$2 = styled.div(_templateObject18$2 || (_templateObject18$2 = _taggedTemplateLiteralLoose(["\n  @media(max-width: 600px) {\n    position: relative;\n    padding-bottom: 56.25%; /* 16:9 */\n    padding-top: 25px;\n    height: 0;\n\n    iframe {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n  }\n"])));
var FeedbackCloseButton$2 = styled.span(_templateObject19$2 || (_templateObject19$2 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 12px;\n  top: 14px;\n  cursor: pointer;\n  z-index: 9999;\n  display: inline-block;\n  @media screen and (max-width: 600px) {\n    right: 14px;\n  }\n"])));
var SaveExitCloseButton$2 = styled.div(_templateObject20$2 || (_templateObject20$2 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 20px;\n  top: 13px;\n  cursor: pointer;\n  z-index: 9999;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  @media screen and (max-width: 600px) {\n    right: 25px;\n  }\n"])));
var StyledModal$2 = styled(Modal$1)(_templateObject21$2 || (_templateObject21$2 = _taggedTemplateLiteralLoose(["\n&[class^=\"ModalDialog-\"] {   \n  height: ", ";\n  width: ", ";\n  padding-top: ", ";\n  position: ", ";\n  bottom: ", ";\n  ", "\n}\n[class^=\"StyledModalBody-VDS\"] {\n  padding: ", ";\n}\n[class^=\"ChildWrapper-VDS\"] {\n  @media (max-width: 767px) {\n    height:", "\n  }\n}\n[class^=\"ModalDialogWrapper-VDS\"] {\n  padding: ", ";\n}\n@media (min-width: 767px){\n  max-width: ", ";\n  max-height: ", ";\n  padding: ", ";\n}\n"])), function (props) {
  return props.modalName != "feedback" && (isMobile() ? "100%" : "73%");
}, function (props) {
  return props.modalName != "feedback" && (isMobile() ? "100%" : "40%");
}, function (props) {
  return props.modalName != "feedback" ? props.expandModal ? "20px" : "40px" : isMobile() && "10px";
}, function (props) {
  return props.modalType && !isMobile() && "absolute";
}, function (props) {
  return props.modalType && !isMobile() && "65px";
}, function (props) {
  return props.howToModalType && "\n    height: 100%;\n    min-height: 100%;\n    max-height: 100%;\n  ";
}, function (props) {
  return props.modalName == "feedback" && "0px";
}, function (props) {
  return props.modalName == "feedback" && '100%';
}, function (props) {
  return props.modalName == "feedback" && isMobile() && "16px 16px 16px 4px !important";
}, function (props) {
  return props.modalType && '44vw';
}, function (props) {
  return props.modalType && '46vh !important';
}, function (props) {
  return props.modalType && '40px 0px 0px 35px;';
});
var StyledModalBody$2 = styled(ModalBody$1)(_templateObject22$2 || (_templateObject22$2 = _taggedTemplateLiteralLoose(["\n  &[class^=\"StyledModalBody-\"] {\n    padding: 0px;\n  }\n"])));
var StyledModalPopup$2 = styled(Modal$1)(_templateObject23$2 || (_templateObject23$2 = _taggedTemplateLiteralLoose(["\n{\n  height: 300px !important};\n  width: 450px !important};\n}\n"])));
var DescWrapper$2 = styled.div(_templateObject24$2 || (_templateObject24$2 = _taggedTemplateLiteralLoose(["\n  [data-outputclass=\"video\"] {\n    background-repeat: no-repeat;\n    background-position: 0 4px;\n    background-size: 16px 12px;\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAAvCAYAAACrKzemAAAACXBIWXMAAC4jAAAuIwF4pT92AAAB80lEQVRoge2b0VHCQBCG/3V8hw6kA+lArEA6gBKwArACxwrEDrQD7QA70A60gnXOOZhk3buLRxgddr+ZPHBJLuSf3MdeEggA47i5ZObnfc+QiNYnRx5ULxDRHMDMwypARGMA92ErDysDEQ0B7IbwqbLpJ4DNf/iyFYwAnPXYXwhqsP2ghbVh5skhzuTQENEKwLKPwwShAzhvtvkwVNgKXa7xsARNoUs8rAZS6BIPq01L6BIPK6IJXeJhZYQuMR9WTugS02GVhC6xfmWlhP4E4EU2mg0rI/RXAHNtH5NhZYQe5sVzZv7Q9jMXVkHoIajkTQRTYRWEfsPMj7n9rV1ZSaEz86q0s5mwaoQuMRFWrdAlFsKqFrrEQli3ifaHktAlFsK6jsNNMiOi6W86shBWGGaLxLp1rLs6YULwzBx+Ce+UVYMY2LBLP2ZKB2ZeaJPjWE6su/RhrSgNjnpX2q/iY7QspsKK9dQ0IfxlSfjmJtKxrqoSvslbNLXCN3vzr0b42rsOlpjGOky+THKlZWD6HnxB+D+w/sCiJPwW5sNCXvgtPKxIRvg7PKw2qQr/Gw+rQUn4HpYgJ3wPSyElfK0oHRPR3v9I+CNGfR02CD/OEy9a7Ue+TJgZNQuAMEd82+bjwzCDFL6HVaApfOsT6U4E4RPR+AvHogDkc3GOcQAAAABJRU5ErkJggg==);\n    div {\n      margin-left: 25px;\n    }\n  }\n  p {\n    margin: 0px 0px 10px 0;\n  }\n  h1 div{\n    font-size: initial;\n  }\n  h2 div{\n    font-size: initial;\n  }\n  h3 div{\n    font-size: initial;\n  }\n  a {\n    text-decoration: underline\n  };\n"])));
var Probing$2 = styled.div(_templateObject25$2 || (_templateObject25$2 = _taggedTemplateLiteralLoose(["\n.radioLabel {\n  line-height: 1.25rem;\n  font-family: Verizon-NHG-eDS;\n  font-weight:bold;\n}\n.container  {\n  display:inline-block;\n  position:relative;\n  padding-left:35px;\n  margin-bottom:12px;\n  cursor:pointer;\n  line-height: 1.25rem;\n  font-size: 1rem;\n  font-family: \"Verizon-NHG-eDS\";\n  -webkit-user-select:none;\n  -moz-user-select:none;\n  -ms-user-select:none;\n  user-select:none;\n  -webkit-tap-highlight-color: transparent;\n}\n.container input {\n  position:absolute;\n  opacity:0;\n  cursor:pointer\n}\n.checkmark{\n  position:absolute;\n  top:0;\n  left:0;\n  height:18px;\n  width:18px;\n  border-radius:50%\n}\n.container:hover input ~ .checkmark {\n  border: 1px solid black\n}\n.container input ~ .checkmark {\n  border: 1px solid black\n}\n.checkmark:after {\n  content: \"\";\n  position:absolute;\n  display:none\n}\n.container .checkmark:after {\n  top:4px;\n  left:4px;\n  width:10px;\n  height:10px;\n  border-radius:50px;\n  background:black\n}\n.container input:checked ~ .checkmark:after {display:block}\n"])));
var FeedbackSaveExitContainer$2 = styled.div(_templateObject26$2 || (_templateObject26$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  // padding: ", ";\n  width: ", ";\n  max-width: 1019px;\n  margin: ", ";;\n  @media(max-width: 600px) {\n    display: flex;\n    gap: 12px;\n    flex-direction: column;\n    align-items: flex-start;\n    margin-bottom: 15px;\n    /* padding: ", "; */\n  }\n"])), function (props) {
  return props.isNewDesign ? '30px 120px 0' : '0';
}, function (props) {
  return props.hideRightNav ? '100%' : '80%';
}, function (props) {
  return props.lessMargin ? '2% 0 0 0' : '3% 0 0 0';
}, function (props) {
  return props.isNewDesign ? '30px 20px' : '0';
});
var BoldText$2 = styled.div(_templateObject27$2 || (_templateObject27$2 = _taggedTemplateLiteralLoose(["\n  font-weight: 800;\n  font-size: 1rem;\n"])));
var FootnoteBlock$2 = styled.div(_templateObject28$2 || (_templateObject28$2 = _taggedTemplateLiteralLoose(["\nmargin-bottom:20px;\na {\n  color: black;\n  text-decoration: underline;\n  cursor: pointer;\n}\n"])));
var StepOption$2 = styled.button(_templateObject29$2 || (_templateObject29$2 = _taggedTemplateLiteralLoose(["\n  background: #FFF;\n  position: relative;\n  border: 1px solid lightGray;\n  border-radius: 7px;\n  display: inline-block;\n  margin: 12px 16px 0 0;\n  cursor: pointer;\n  justify-content: center;\n  padding-left: 20px;\n  padding-top: 13px;\n  padding-bottom: 12px;\n  padding-right: 12px;\n  text-align: left;\n  min-height: 65px;\n\n  @media (min-width: 601px) {\n    width: 360px;   \n  }\n\n  @media (max-width: 600px) {\n    width: 315px;\n    margin-top:", ";\n  }\n"])), function (props) {
  return props !== null && props !== void 0 && props.recommended ? '30px' : '22px';
});
var IssueBoxWrapper$2 = styled.div(_templateObject30$2 || (_templateObject30$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-left: 4px;\n  max-width: 316px;\n  :not(.toplink_steps_wrapper)\n  :not(.bottomlink_steps_wrapper)\n  {\n    height: auto !important;\n    width: auto;\n  }\n"])));
var IssueContentbox$2 = styled.div(_templateObject31$2 || (_templateObject31$2 = _taggedTemplateLiteralLoose(["\n  @media (min-width: 601px) {\n    width: 320px;\n  }\n\n  @media (max-width: 600px) {\n    width: 280px;\n  }\n  cursor: pointer;\n  justify-content: left;\n  margin-right: 16px;\n"])));
var IssueContentArrow$2 = styled.div(_templateObject32$2 || (_templateObject32$2 = _taggedTemplateLiteralLoose(["\n  @media (min-width: 601px) {\n    width: 40px;\n  }\n\n  @media (max-width: 600px) {\n    width: 30px;\n  }\n  cursor: pointer;\n  position: absolute;\n  justify-content: right;\n  right:0;\n  bottom:0;\n  text-align: right;\n  vertical-align: baseline;\n  line-height:11px;\n  padding-right:12px;\n  padding-bottom:12px;\n"])));
var TilesContainer$2 = styled.div(_templateObject33$2 || (_templateObject33$2 = _taggedTemplateLiteralLoose(["\n  div.question {\n    margin-bottom: 15px;\n    font-size: 1rem;\n    font-family: 'Verizon-NHG-eDS';\n    font-weight: 400;\n    line-height: 1.25rem;\n    letter-spacing: 0.03125rem;\n    text-decoration: none;\n    a{ color: #428bca;  text-decoration : underline;}\n  }\n  @media(min-width:601px) {\n    column-fill: auto;\n    column-count: 1;\n    //margin-top: 30px;\n    margin-bottom: 30px;\n  }\n  @media(max-width: 600px) {\n    margin-top: 1rem;\n    margin-bottom: 15px;\n  }\n"])));
var Footer$2 = styled.div(_templateObject34$2 || (_templateObject34$2 = _taggedTemplateLiteralLoose(["\n  height:50px;\n  width:1024px;\n  background-color: gray;\n  position:fixed;\n  bottom:0;\n  z-index:0;\n\n  .ebAwXT {\n    padding: 0 70px;\n  }\n\n  .etCvPo{\n    margin-left:0;\n  }\n\n  .eoptfu span {\n    font-family: Verizon-NHG-eDS !important;\n  }\n  .QTMEZ{\n    font-family: Verizon-NHG-eDS;\n  }\n"])));
var HeaderTabContainer$2 = styled.div(_templateObject35$2 || (_templateObject35$2 = _taggedTemplateLiteralLoose(["\n\n  height:50px;\n  position: sticky;\n  position: -webkit-sticky;\n  background-color:#ffffff;\n  top:0;\n  z-index:100;\n  font-family: 'Verizon-NHG-eDS';\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: 0px;\n  padding: 0px 70px;\n\n  .mcTmv{\n    width:100%;\n    padding:0;\n    margin-left:20px;\n\n    button{\n      letter-spacing: 0.5px;\n    }\n    .kwonIF{\n      color: #6F7171;\n    }\n  }\n"])));
var NavStepsContainer$2 = styled.div(_templateObject36$2 || (_templateObject36$2 = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width:601px){\n    display:flex\n    align-items: center;\n  }\n  font-family: 'Verizon-NHG-eDS';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: 0px;\n\n  @media screen and (max-width:600px){\n    display:flex;\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n  }\n"])));
var NavStepsWrapper$2 = styled.div(_templateObject37$2 || (_templateObject37$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  margin-bottom: 32px;\n  @media screen and (max-width:600px){\n    align-items: normal;\n    flex-direction: column;\n    gap: 10px;\n  }\n"])));
var NewPageTitle$2 = styled.div(_templateObject38$2 || (_templateObject38$2 = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width:601px) {\n    position: relative;\n    margin-left: 23px;\n    display: flex;\n    align-items: center;\n  }\n  @media screen and (max-width:600px) {\n    width: 100%;\n  }\n"])));
var RightMenuContainer$2 = styled.nav(_templateObject39$2 || (_templateObject39$2 = _taggedTemplateLiteralLoose(["\n  @media(min-width: 601px) {\n    a.right-menu-item{\n      display: block;\n      padding: 10px 15px;\n      cursor: pointer;\n      border-left: 1px solid silver;\n      font-family: 'Verizon-NHG-eDS';\n      font-weight: 700;\n      font-size: 16px;\n      line-height: 20px;\n      letter-spacing: 0.5px;\n      color:#6F7171;\n      position:relative;\n    }\n\n    a.right-menu-item:hover{\n      color:#000000;\n      text-decoration:underline;\n    }\n  }\n  @media screen and (max-width:600px) {\n    display: none\n  }\n"])));
var DescWrapperNew$2 = styled.div(_templateObject40$2 || (_templateObject40$2 = _taggedTemplateLiteralLoose(["\n  table {\n    border: 1px solid grey;\n    border-spacing: 0\n  }\n\n  table th, table td {\n    border: 1px solid grey;\n    padding: 5px;\n  }\n\n  [data-outputclass=\"video\"] {\n    background-repeat: no-repeat;\n    background-position: 0 4px;\n    background-size: 16px 12px;\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAAvCAYAAACrKzemAAAACXBIWXMAAC4jAAAuIwF4pT92AAAB80lEQVRoge2b0VHCQBCG/3V8hw6kA+lArEA6gBKwArACxwrEDrQD7QA70A60gnXOOZhk3buLRxgddr+ZPHBJLuSf3MdeEggA47i5ZObnfc+QiNYnRx5ULxDRHMDMwypARGMA92ErDysDEQ0B7IbwqbLpJ4DNf/iyFYwAnPXYXwhqsP2ghbVh5skhzuTQENEKwLKPwwShAzhvtvkwVNgKXa7xsARNoUs8rAZS6BIPq01L6BIPK6IJXeJhZYQuMR9WTugS02GVhC6xfmWlhP4E4EU2mg0rI/RXAHNtH5NhZYQe5sVzZv7Q9jMXVkHoIajkTQRTYRWEfsPMj7n9rV1ZSaEz86q0s5mwaoQuMRFWrdAlFsKqFrrEQli3ifaHktAlFsK6jsNNMiOi6W86shBWGGaLxLp1rLs6YULwzBx+Ce+UVYMY2LBLP2ZKB2ZeaJPjWE6su/RhrSgNjnpX2q/iY7QspsKK9dQ0IfxlSfjmJtKxrqoSvslbNLXCN3vzr0b42rsOlpjGOky+THKlZWD6HnxB+D+w/sCiJPwW5sNCXvgtPKxIRvg7PKw2qQr/Gw+rQUn4HpYgJ3wPSyElfK0oHRPR3v9I+CNGfR02CD/OEy9a7Ue+TJgZNQuAMEd82+bjwzCDFL6HVaApfOsT6U4E4RPR+AvHogDkc3GOcQAAAABJRU5ErkJggg==);\n    div {\n      margin-left: 25px;\n    }\n  }\n\n  section.section h2 {\n    cursor: pointer;\n    font-family: 'Verizon-NHG-eDS';\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 20px;\n  }\n\n  .arrow-down span {\n    caret-color:transparent;\n    position:absolute;\n    right:25%;\n    transform: rotate(315deg);\n    border:none;\n    width:10px;\n    height:10px;\n    border-left: 1px solid black;\n    border-bottom: 1px solid black;\n    cursor: pointer;\n  }\n\n  .step {\n    margin-bottom:32px\n  }\n\n  .arrow-up span {\n    caret-color:transparent;\n    position:absolute;\n    transform: rotate(135deg);\n    right:25%;\n    width:10px;\n    height:10px;\n    border:none;\n    border-left: 1px solid black;\n    border-bottom: 1px solid black;\n    cursor: pointer;\n  }\n\n  ol.steps {\n    counter-reset: li;\n  }\n\n  ol.steps li.step {\n    position: relative;\n    list-style-type: none;\n  }\n\n  ol.steps li.step:before {\n    position: absolute;\n    left: -56px;\n    content: counter(li);\n    counter-increment: li;\n    color: #000;\n    text-align: center;\n    font-size: 36px;\n    font-weight: 700;\n    margin-top: 2px;\n  }\n\n  div.Troubleshooting-Steps div.accordion h2 {\n    cursor: pointer;\n    font-weight: bold;\n  }\n  p {\n    margin: 0px 0px 10px 0;\n  }\n  h1 div {\n    font-size: initial;\n  }\n  h2 div {\n    font-size: initial;\n  }\n  h3 div {\n    font-size: initial;\n  }\n  a {\n    text-decoration: underline;\n    font-family: 'Verizon-NHG-eDS';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    letter-spacing: 0px;\n    color: #428bca;\n  };\n\n  .accordion {\n    margin-top: ", ";\n    border-top: 4px solid #000000;\n  }\n\n  .accordion .title{\n    margin-top: 10px;\n  }\n\n  .note {\n    margin-top: ", ";\n    border-top: 1px solid #000000;\n  }\n\n  .note .ul, .accordion .ul{\n    padding-left:25px;\n    margin-left:0;\n  }\n\n  .note .ul .li, .accordion .ul .li{\n    margin-bottom:16px;\n  }\n  .note .ul .li:last-child{\n    margin-bottom:0;\n  }\n\n  .note h2.title {\n    position: relative;\n  }\n\n  .arrow{\n    position: relative;\n  }\n  .arrow span{\n    right: .25rem !important;\n    top: 0px;\n  }\n\n  .ol.steps {\n    padding-left: 56px;\n    margin-block: 32px;\n  }\n\n  .note, .steps  {\n    font-family: 'Verizon-NHG-eDS';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    letter-spacing: 0px;\n  }\n\n  div[data-outputclass=\"line-note\"]::before, span[data-outputclass=\"line-note\"]::before,\n  li[data-outputclass=\"line-note\"]::before, .ph[data-outputclass=\"line-note\"], a[data-outputclass=\"line-note\"]::before {\n    content: '';\n    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAYAAAA4TnrqAAAACXBIWXMAAC4jAAAuIwF4pT92AAAB3UlEQVR4nO3c203EQAyF4X+oYDuBEuiEpQNKoQOWTrYDoBM6GBQE0YKIyGUux3aOlKdRlNEnO0+WU84ZpaSUTsANcJtzfle625XAHcZ8Qd0B18A5pXQQudpnZLAuoL4jBybRhimloe1eJo7fVFpSorJyzq/A/cSxTIXJtGHO+aQOJvWDVweTwkIcTA4LYTBJLETBZLEQBJPGQgxMHgshMBNYiICZwUIAzBQWncHMYdERzCQWncDMYtEBzDQWjcHMY9EQzAUWjcDcYNEAzBUWlcHcYVERzCUWlcDcYlEBzDUWhcHcY1EQLAQWhcDCYFEALBQWG8HCYbEBLCQWK8HCYrES7Dy8tz+TzzAOdRjm2EJX1syMFbZjzcsA9rhjzcswqvmwY/2fcaZVbg6+dVJKR+Bp4rM/hn9DV9YSKCJjLYUiKtYaKCJirYUiGtYWKCJhbYUiClYJKCJglYLCO1ZJKDxjlYbCK1YNKDxi1YLCG1ZNKDxh1YbCC1YLKDxgtYLCOlZLKCxjtYbCKlYPKCxi9YLCGlZPKCxh9YbCCpYCFBawVKBQx1KCQhlLDQpVLEUoFLFUoRDc+ScLhdjOP2ko9p1/y6K08+/5jyMZKMR2/h1/gUlBodKGl5HdgAt8AN7+5IYhtq+7AAAAAElFTkSuQmCC) no-repeat;\n    display: inline-block;\n    background-size: 14px 11px;\n    width: 17px;\n    height: 12px;\n}\n\n.menucascade div > *::after {\n  content: '';\n  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAA7CAYAAAAXdfjrAAAACXBIWXMAAC4jAAAuIwF4pT92AAABZ0lEQVRo3s3a240CMQwF0GsqoJNtgVKmtNlOKIFStgPzAxJi5xEn19dBytcEcWTytMfcHTN+LkcPzew6HczMVgD3Mpy7/2sAVgD+ag8A161+me0MVYZrQZXgWlFyXAQlxb1n5T0wX34ks/Xjr1wCUUuP3Pfgnwa3tVxMgdtbYMtx+w+KcccPC3HnHYpwbZ0KcO0dxbhYZyEu/gURri/MAlz/4EzGjU3pRNz4QpiE42wfCTjepkvGcY8qRBz/gEfC5RyLCbi869cg7pJ4z7kF+z/c/e8wd0GI1hqM1qoY/MOojOWCgmIvsDQUc0uiolibOB3FOPakoEYPimmokaN1Kqr3MpKO6rm+SVDRC68MFUkRSFGtSRU5qiUNVYI6S9yVoY5SnaWoSC1JiorWkmSonlqSBNVbS0pH9daSft19kVV4G++B6ZHqqSXJUJFakhTVWkuSo9wdtvdCiJktAG6Sgb71+7O+qfIE2AZ/1PVQRysAAAAASUVORK5CYII) no-repeat;\n  display: inline-block;\n  background-size: 5px 8px;\n  width: 8px;\n  height: 9px;\n  position: relative;\n  margin-left: 2px;\n}\n\n.menucascade div > :last-child::after {\n  content: none;\n}\n\n.uicontrol {\n  font-weight: bold;\n}\n\ndiv.itemgroup span.ph.uicontrol {\n  font-weight: bold;\n  word-wrap: break-word;\n}\n\n"])), function (props) {
  return props.segments ? 0 : '2rem';
}, function (props) {
  return props.segments ? 0 : '2rem';
});
var DescInnerWrapper$2 = styled.div(_templateObject41$2 || (_templateObject41$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  @media (max-width: 768px) {\n    flex-direction: column-reverse;\n  }\n"])));
var DescBodyWrapper$2 = styled.div(_templateObject42$2 || (_templateObject42$2 = _taggedTemplateLiteralLoose(["\n  flex:1;\n"])));
var IconImage$2 = styled.img(_templateObject43$2 || (_templateObject43$2 = _taggedTemplateLiteralLoose(["\n  padding: 20px 0 0 10px;\n  cursor: pointer;\n  width: 30px;\n  height: 30px;\n"])));
var IconDownloadEmail$2 = styled.div(_templateObject44$2 || (_templateObject44$2 = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width: 601px) {\n    width: 10%;\n    display: inline-block;\n  }\n  @media screen and (max-width: 601px) {\n    width: 20%;\n    display: inline-block;\n  }\n"])));
var DownloadImage$2 = styled.img(_templateObject45$2 || (_templateObject45$2 = _taggedTemplateLiteralLoose(["\n  padding: 5px 0 0 10px;\n  cursor: pointer;\n  width: 16px;\n  height: 16px;\n"])));
var EmailImage$2 = styled.img(_templateObject46$2 || (_templateObject46$2 = _taggedTemplateLiteralLoose(["\n  padding: 5px 0 0 10px;\n  cursor: pointer;\n  width: 18px;\n  height: 13px;\n"])));
var BillingSteps$2 = styled.div(_templateObject47$2 || (_templateObject47$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n"])));
var DropdownWrapper$2 = styled.div(_templateObject48$2 || (_templateObject48$2 = _taggedTemplateLiteralLoose(["\n  width: 350px;\n  ", "\n"])), function (props) {
  return props.isDark && "\n  path {\n    fill: #fff;\n    stroke: #fff;\n    }\n  select {\n    border-bottom: 1px solid #fff;\n    border-top: 1px solid #fff;\n }";
});
var TroubleShootingTitleNew$2 = styled.div(_templateObject49$2 || (_templateObject49$2 = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width: 601px) {\n    /* padding: 0px 67px; */\n    /* margin-top: 1.75rem; */\n    /* margin-bottom: 0.625rem; */\n  }\n  @media screen and (max-width: 601px) {\n    /* padding: 24px 5px 20px ; */\n    /* margin-left: '0px'; */\n    text-align: left;\n    display: inline-block;\n  }\n"])));
var getActionsWrapperStyles$2 = function getActionsWrapperStyles(props) {
  var styles = 'justify-content: center;\n';
  if (props.showNext || props.showPrevious) {
    styles = 'justify-content: space-between;\n';
  } else if (props.alignButtons !== 'center') {
    if (props.alignButtons === 'left') {
      styles = 'justify-content: flex-start;\n';
    } else if (props.alignButtons === 'right') {
      styles = 'justify-content: flex-end;\n';
    }
  }
  if (props.disableMargin) {
    styles = 'margin-left: -50px;\n';
  }
  return styles;
};
var getButtonsWrapperStyles$2 = function getButtonsWrapperStyles(props) {
  var styles = '';
  if (props.stackButtons) {
    styles += 'align-items: center;\n';
    styles += 'flex-direction: column;\n';
    styles += 'justify-content: center;\n';
  }
  return styles;
};
var ActionsWrapper$2 = styled.div(_templateObject50$2 || (_templateObject50$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: flex-end;\n  justify-content: ", ";\n  ", "\n  width: 100%;\n"])), function (props) {
  return props.showNext || props.showPrevious ? 'space-between' : 'center';
}, function (props) {
  return getActionsWrapperStyles$2(props);
});
var ButtonsWrapper$3 = styled.div(_templateObject51$2 || (_templateObject51$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  /* justify-content: center; */\n  ", "\n  gap: 10px ;\n  @media (max-width: 700px){\n    flex-direction: column;\n  }\n\n"])), function (props) {
  return getButtonsWrapperStyles$2(props);
});
var ButtonsWrapperNew = styled.div(_templateObject52$2 || (_templateObject52$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  /* justify-content: center; */\n  ", "\n  gap: 10px ;\n  @media (min-width: 701px){\n    flex-direction: row-reverse;\n    \n  }\n\n"])), function (props) {
  return getButtonsWrapperStyles$2(props);
});
var Next$2 = styled.div(_templateObject53$2 || (_templateObject53$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 10px;\n  margin-right: ", ";\n  @media (max-width: 600px){\n    margin-top: 30px;\n    margin-right: 30px;\n  }\n  cursor: pointer;\n"])), function (props) {
  return props.isNewDesign ? 0 : '56px';
});
var Previous$2 = styled.div(_templateObject54$2 || (_templateObject54$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 10px;\n  margin-left: ", ";\n  @media (max-width: 600px){\n    margin-top: 30px;\n    margin-left: 30px;\n  }\n  cursor: pointer;\n"])), function (props) {
  return props.isNewDesign ? 0 : '50px';
});
var StyledButton$3 = styled(Button$1)(_templateObject55$2 || (_templateObject55$2 = _taggedTemplateLiteralLoose(["\n  min-width: ", ";\n\n  span {\n    overflow: visible !important;\n    width: fit-content !important;\n  }\n\n  @media (min-width: 601px) {\n    :not(:last-child) {\n      margin-right: 14px;\n    }\n  }\n\n  [class^=\"StyledChildWrapper-\"] {\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  @media (max-width: 600px){\n    margin-top: 10px;\n    align-items: center;\n    :not(:first-child) {\n    }\n\n    font-size: 14px;\n    padding: 0;\n    margin-bottom: 20px!important;\n  }\n"])), function (props) {
  return props.minWidth ? props.minWidth : '50%';
});
var ContainerWrapper$2 = styled.div(_templateObject56$2 || (_templateObject56$2 = _taggedTemplateLiteralLoose(["\n  padding: 25px 40px 15px 40px;\n"])));
var DividerContainer$2 = styled.div(_templateObject57$2 || (_templateObject57$2 = _taggedTemplateLiteralLoose(["\ndisplay: flex;\n    justify-content: center;\n    margin: 7px;\n    div {\n      width: 93%\n    }\n"])));
var ContactsContainer$2 = styled.div(_templateObject58$2 || (_templateObject58$2 = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  @media (min-width: 601px) {\n    height: 290px;\n    padding: ", ";\n    width: 40%;\n  }\n\n  @media (max-width: 600px) {\n    width: 100%;\n  }\n"])), function (props) {
  return props.isEotpaddingBtm ? '0px 30px 30px 30px' : '0px 30px 0px 30px;';
});
var StyledTextWithHtml$2 = styled(TextWithHtml)(_templateObject59$2 || (_templateObject59$2 = _taggedTemplateLiteralLoose(["\n  .congratsDesc{\n    font-weight: bold;\n    font-size: 22px;\n  }\n  @media (max-width: 600px) {\n    width: 300px;\n  }\n"])));
var TitleTextWrapperCompletion$2 = styled.div(_templateObject60$2 || (_templateObject60$2 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  width: 95%;\n"])));
var StepContainerCompletion$2 = styled.div(_templateObject61$2 || (_templateObject61$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n\n  @media (min-width: 601px) {\n   // height: 290px;\n    justify-content: space-between;\n    padding: 25px 40px 15px 40px;\n  }\n\n  @media (max-width: 600px) {\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n  }\n"])));
var StepInfoContainerCompletion$2 = styled.div(_templateObject62$2 || (_templateObject62$2 = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n\n  @media (min-width: 601px) {\n    align-items: flex-start;\n    height: 275px;\n    //justify-content: center;\n    width: 50%;\n  }\n\n  @media (max-width: 600px) {\n    width: 100%;\n  }\n"])));
var DeviceImageCompletion$2 = styled.img(_templateObject63$2 || (_templateObject63$2 = _taggedTemplateLiteralLoose(["\n  @media(min-width: 601px) {\n    width: 50%;\n  }\n  @media(max-width: 600px) {\n    width: 12%;\n  }\n"])));
var DesktopHeadingWrapper$2 = styled.div(_templateObject64$2 || (_templateObject64$2 = _taggedTemplateLiteralLoose(["\n  @media (max-width: 600px) {\n    display: none;\n  }\n"])));
var MobileHeadingWrapper$2 = styled.div(_templateObject65$2 || (_templateObject65$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  position: relative;\n  width: 100%;\n  @media (min-width: 601px) {\n     display: none;\n    }\n  a {\n    color: black;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n  @media(max-width: 768px) {\n    font-size:1.0rem;\n  }\n  @media screen and (max-width: 600px) {\n    margin-left: 0px;\n    width: 330px;\n    // margin-top: 20px\n  }\n  div.checklist-wrapper {\n    @media screen and (max-width: 600px) {\n      position: absolute;\n    }\n  }\n"])));
var Cancel$2 = styled.div(_templateObject66$2 || (_templateObject66$2 = _taggedTemplateLiteralLoose(["\n  margin-right: 10px;\n  float: right;\n"])));
var StyledTextLink$2 = styled.div(_templateObject67$2 || (_templateObject67$2 = _taggedTemplateLiteralLoose([""])));
var TitleWrapper$2 = styled.div(_templateObject68$2 || (_templateObject68$2 = _taggedTemplateLiteralLoose([""])));
var TabsContainer$2 = styled.div(_templateObject69$2 || (_templateObject69$2 = _taggedTemplateLiteralLoose([""])));
var CloseButton$2 = styled.div(_templateObject70$2 || (_templateObject70$2 = _taggedTemplateLiteralLoose([""])));
var SearchBar$2 = styled.div(_templateObject71$2 || (_templateObject71$2 = _taggedTemplateLiteralLoose([""])));
var SearchResults$2 = styled.div(_templateObject72$2 || (_templateObject72$2 = _taggedTemplateLiteralLoose([""])));
var SearchTitle$2 = styled.div(_templateObject73$2 || (_templateObject73$2 = _taggedTemplateLiteralLoose([""])));
var SearchDesc$2 = styled.div(_templateObject74$2 || (_templateObject74$2 = _taggedTemplateLiteralLoose([""])));
var SearchResultsContainer$2 = styled.div(_templateObject75$2 || (_templateObject75$2 = _taggedTemplateLiteralLoose([""])));
var IframeContainer$2 = styled.div(_templateObject76$2 || (_templateObject76$2 = _taggedTemplateLiteralLoose([""])));
var StyledTableHeader$2 = styled.div(_templateObject77$2 || (_templateObject77$2 = _taggedTemplateLiteralLoose([""])));
var StyledCell$2 = styled.div(_templateObject78$2 || (_templateObject78$2 = _taggedTemplateLiteralLoose([""])));
var StyledTable$2 = styled.div(_templateObject79$2 || (_templateObject79$2 = _taggedTemplateLiteralLoose([""])));
var ChangeIssueContainer$2 = styled.div(_templateObject80$2 || (_templateObject80$2 = _taggedTemplateLiteralLoose([""])));
var ButtonContainer$2 = styled.div(_templateObject81$2 || (_templateObject81$2 = _taggedTemplateLiteralLoose([""])));
var StyledCheckbox$2 = styled.div(_templateObject82$2 || (_templateObject82$2 = _taggedTemplateLiteralLoose([""])));
var NavInnerSteps$2 = styled.div(_templateObject83$2 || (_templateObject83$2 = _taggedTemplateLiteralLoose([""])));
var QuesDropdownSelect$2 = styled.div(_templateObject84$2 || (_templateObject84$2 = _taggedTemplateLiteralLoose([""])));
var ContentBody$2 = styled.div(_templateObject85$2 || (_templateObject85$2 = _taggedTemplateLiteralLoose([""])));
var StyledEmailModalPopup$2 = styled.div(_templateObject86$2 || (_templateObject86$2 = _taggedTemplateLiteralLoose([""])));
var CopyIconDiv$2 = styled.div.attrs({
  'data-track': 'copy external URL of TS article'
})(_templateObject87$2 || (_templateObject87$2 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  margin-right: 5px;\n  svg{\n    pointer-events: none;\n  }\n"])));
var EmailIconDiv$2 = styled.div.attrs({
  'data-track': 'send email of TS article'
})(_templateObject88$2 || (_templateObject88$2 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  svg{\n    pointer-events: none;\n  }\n"])));
var SmsIconDiv$2 = styled.div.attrs({
  'data-track': 'send SMS of TS article'
})(_templateObject89$2 || (_templateObject89$2 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  padding-right: 2px;\n  svg{\n    pointer-events: none;\n  }\n"])));
var ResumeEmailIconDiv$2 = styled.div.attrs({
  'data-track': 'send resume TS email'
})(_templateObject90$2 || (_templateObject90$2 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  svg{\n    pointer-events: none;\n  }\n"])));
var StyledGrid$2 = styled.div(_templateObject91$2 || (_templateObject91$2 = _taggedTemplateLiteralLoose([""])));
var StyledRow$2 = styled.div(_templateObject92$2 || (_templateObject92$2 = _taggedTemplateLiteralLoose(["\n  display:flex;\n  justify-content: space-between;\n  margin-top: 1rem\n"])));
var StyledTile$2 = styled.div(_templateObject93$2 || (_templateObject93$2 = _taggedTemplateLiteralLoose(["\n  flex:1;\n  border: 1px solid lightGray;\n  border-radius: 7px;\n  display: inline-block;\n  padding: 1rem;\n  margin-right: 1.5rem;\n  cursor: pointer;\n"])));
var HeadingSpan$2 = styled.span(_templateObject94$2 || (_templateObject94$2 = _taggedTemplateLiteralLoose([""])));
var NetworkCongestion$2 = styled.div(_templateObject95$2 || (_templateObject95$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  font-weight: bold;\n  text-align: center;\n  div.row {\n    div.column:nth-child(1){\n      border-bottom: none;\n    }\n    div.column:nth-child(2){\n      border-top: none;\n    }\n    div.column0{\n      color: #FFF;\n    }\n  }\n  div.column {\n    border: 1px solid #808080;\n    width: 120px;\n    // padding-left: 5px;\n  }\n  div.redbg {\n    background-color: red;\n    color: red;\n  }\n  div.white {\n    color: #FFF;\n  }\n"])));
var CustomContentDiv$2 = styled.div(_templateObject96$2 || (_templateObject96$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  flex-direction: ", ";\n  @media (max-width: 768px) {\n    flex-direction: column-reverse;\n  }\n"])), function (props) {
  return props.isSetFlexColumn ? 'column' : '';
});
var ProvisioningChecksInfo$2 = styled.div(_templateObject97$2 || (_templateObject97$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n"])));
var ProvisioningChecksTable$2 = styled.div(_templateObject98$2 || (_templateObject98$2 = _taggedTemplateLiteralLoose(["\n  table {\n    border: 1px solid #d8dada;\n  }\n  thead {\n    background-color: ", ";\n    tr {\n      border-bottom: 1px solid #d8dada !important;\n    }\n  }\n  td {\n    padding: 0.2rem 0 0.2rem 0.5rem\n    font-size: 0.8rem;\n  }\n"])), function (props) {
  return props.color;
});
var LeftNavWrapperAll$2 = styled.div(_templateObject99$2 || (_templateObject99$2 = _taggedTemplateLiteralLoose(["\n height: 232px;\n border: 10px;\n margin-left: 65px;\n padding: 0px 33px 35px 50px;\n width: 212px;\n"])));
var StyledNumberInput$2 = styled.input(_templateObject100$2 || (_templateObject100$2 = _taggedTemplateLiteralLoose(["\nwidth: 100px;\nheight: 30px;\nmargin-right: 10px;\n"])));
var LeftNavSidebar$2 = styled.div(_templateObject101$2 || (_templateObject101$2 = _taggedTemplateLiteralLoose(["\n display: inline-flex;\n @media (max-width: 414px) {\n  flex-wrap: ", ";\n}\n "])), function (props) {
  return props.isACSS ? 'unset' : 'wrap';
});
var SpanTag = styled.span(_templateObject102$2 || (_templateObject102$2 = _taggedTemplateLiteralLoose(["\n  margin-bottom: 2rem;\n"])));
var RecommendedTile = styled.div(_templateObject103$2 || (_templateObject103$2 = _taggedTemplateLiteralLoose(["\n  position:absolute\n  height:15px;\n  padding:5px;\n  padding-left:25px;\n  width:330px;\n  font-size:12px;\n  background-color:#000;\n  margin-top:-38px;\n  margin-left:-20px;\n  color:#fff;\n  font-weight:bold;\n  @media (max-width: 600px){\n    width: 285px;\n  }\n\n "])));
var GuestDescText = styled.div(_templateObject104$2 || (_templateObject104$2 = _taggedTemplateLiteralLoose(["\n  font-size:18px;\n "])));
var RightArrowDiv$2 = styled.div(_templateObject105$2 || (_templateObject105$2 = _taggedTemplateLiteralLoose(["\n   display:flex;\n   justify-content:flex-end;\n   padding-right:10px;\n   padding-bottom:10px;\n\n "])));
var TiletContainer$2 = styled.div(_templateObject106$2 || (_templateObject106$2 = _taggedTemplateLiteralLoose(["\n display : grid;\n gap:20px;\n\n @media(min-width: 1101px){\n  grid-template-columns: 430px 430px;\n }\n @media(min-width: 601px) and (max-width: 1100px){\n  grid-template-columns: 1fr 1fr;\n }\n @media (max-width: 600px) {\n  grid-template-columns: 1fr ;\n }\n"])));
var TechCoachBody$2 = styled.p(_templateObject107$2 || (_templateObject107$2 = _taggedTemplateLiteralLoose(["\nmargin-top: 1rem;\n"])));
var CloseIconWrapper$2 = styled.div(_templateObject108$2 || (_templateObject108$2 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  width: 3rem;\n  height: 3rem;\n  display: flex;\n  -webkit-box-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  align-items: center;\n  z-index: 1;\n"])));
var CloseButtonIconContainer$2 = styled.div(_templateObject109$2 || (_templateObject109$2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 2rem;\n  height: 2rem;\n"])));
var PopupCloseButton$2 = styled.button(_templateObject110$2 || (_templateObject110$2 = _taggedTemplateLiteralLoose(["\ndisplay: flex;\n-webkit-box-pack: center;\njustify-content: center;\n-webkit-box-align: center;\nalign-items: center;\npadding: 0px;\nmargin: 0px;\ncursor: pointer;\nbox-sizing: border-box;\ntext-align: center;\ntext-decoration: none;\nposition: relative;\ntouch-action: manipulation;\npointer-events: auto;\nvertical-align: middle;\noutline: none;\nwidth: 100%;\nheight: 100%;\nbackground-color: transparent;\nborder-radius: 50%;\nborder: none;\nbackground-clip: padding-box;\ntransition: all 0.1s ease-out 0s;\n"])));
var CloseButtonHitArea$2 = styled.span(_templateObject111$2 || (_templateObject111$2 = _taggedTemplateLiteralLoose(["\n    height: 2.75rem;\n    width: 2.75rem;\n    display: inline-block;\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    text-align: center;\n    transform: translate(-50%, -50%);\n"])));
var IconContainer$2 = styled.span(_templateObject112$2 || (_templateObject112$2 = _taggedTemplateLiteralLoose(["\n    position: relative;\n    display: flex;\n    -webkit-box-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    justify-content: center;\n    left: 0px;\n    bottom: 0px;\n    pointer-events: none;\n"])));
var CloseIconSVG$2 = styled.svg(_templateObject113$2 || (_templateObject113$2 = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    height: 1.25rem;\n    width: 1.25rem;\n    min-height: 1.25rem;\n    min-width: 1.25rem;\n"])));
var styledDigital = {
  ProvisioningChecksTable: ProvisioningChecksTable$2,
  ProvisioningChecksInfo: ProvisioningChecksInfo$2,
  MainWrapper: MainWrapper,
  SubWrapper: SubWrapper,
  ContentWrapper: ContentWrapper$3,
  ButtonWrapper: ButtonWrapper$2,
  ButtonWrapperMobile: ButtonWrapperMobile$2,
  TextWrapper: TextWrapper$2,
  TroubleShootingTitle: TroubleShootingTitle$2,
  TroubleShootingNewTitle: TroubleShootingNewTitle,
  TitleTextWrapper: TitleTextWrapper$2,
  HeadingWrapper: HeadingWrapper$2,
  PageTitle: PageTitle$2,
  StepContainer: StepContainer$2,
  StepInfoContainer: StepInfoContainer$2,
  ImageContainer: ImageContainer$2,
  DeviceImageContainer: DeviceImageContainer$2,
  DeviceImage: DeviceImage$2,
  IssuesContainer: IssuesContainer$2,
  ImageTitle: ImageTitle$2,
  MapWrapper: MapWrapper$2,
  FeedbackCloseButton: FeedbackCloseButton$2,
  SaveExitCloseButton: SaveExitCloseButton$2,
  StyledModal: StyledModal$2,
  StyledModalBody: StyledModalBody$2,
  StyledModalPopup: StyledModalPopup$2,
  DescWrapper: DescWrapper$2,
  Probing: Probing$2,
  FeedbackSaveExitContainer: FeedbackSaveExitContainer$2,
  BoldText: BoldText$2,
  IconImage: IconImage$2,
  BillingSteps: BillingSteps$2,
  FootnoteBlock: FootnoteBlock$2,
  StepOption: StepOption$2,
  TilesContainer: TilesContainer$2,
  StyledTextLink: StyledTextLink$2,
  TitleWrapper: TitleWrapper$2,
  Cancel: Cancel$2,
  TabsContainer: TabsContainer$2,
  CloseButton: CloseButton$2,
  SearchBar: SearchBar$2,
  SearchResults: SearchResults$2,
  SearchTitle: SearchTitle$2,
  SearchDesc: SearchDesc$2,
  SearchResultsContainer: SearchResultsContainer$2,
  IframeContainer: IframeContainer$2,
  StyledTableHeader: StyledTableHeader$2,
  StyledCell: StyledCell$2,
  StyledTable: StyledTable$2,
  ChangeIssueContainer: ChangeIssueContainer$2,
  ButtonContainer: ButtonContainer$2,
  StyledCheckbox: StyledCheckbox$2,
  NavInnerSteps: NavInnerSteps$2,
  QuesDropdownSelect: QuesDropdownSelect$2,
  ContentBody: ContentBody$2,
  StyledEmailModalPopup: StyledEmailModalPopup$2,
  CopyIconDiv: CopyIconDiv$2,
  EmailIconDiv: EmailIconDiv$2,
  SmsIconDiv: SmsIconDiv$2,
  ResumeEmailIconDiv: ResumeEmailIconDiv$2,
  Footer: Footer$2,
  HeaderTabContainer: HeaderTabContainer$2,
  NavStepsContainer: NavStepsContainer$2,
  NavStepsWrapper: NavStepsWrapper$2,
  NewPageTitle: NewPageTitle$2,
  RightMenuContainer: RightMenuContainer$2,
  DescWrapperNew: DescWrapperNew$2,
  DropdownWrapper: DropdownWrapper$2,
  DownloadImage: DownloadImage$2,
  EmailImage: EmailImage$2,
  IconDownloadEmail: IconDownloadEmail$2,
  TroubleShootingTitleNew: TroubleShootingTitleNew$2,
  ActionsWrapper: ActionsWrapper$2,
  ButtonsWrapper: ButtonsWrapper$3,
  Next: Next$2,
  Previous: Previous$2,
  StyledButton: StyledButton$3,
  ContainerWrapper: ContainerWrapper$2,
  DividerContainer: DividerContainer$2,
  ContactsContainer: ContactsContainer$2,
  StyledTextWithHtml: StyledTextWithHtml$2,
  TitleTextWrapperCompletion: TitleTextWrapperCompletion$2,
  StepContainerCompletion: StepContainerCompletion$2,
  DeviceImageCompletion: DeviceImageCompletion$2,
  StepInfoContainerCompletion: StepInfoContainerCompletion$2,
  DesktopHeadingWrapper: DesktopHeadingWrapper$2,
  MobileHeadingWrapper: MobileHeadingWrapper$2,
  StyledGrid: StyledGrid$2,
  StyledRow: StyledRow$2,
  StyledTile: StyledTile$2,
  IssueBoxWrapper: IssueBoxWrapper$2,
  IssueContentbox: IssueContentbox$2,
  IssueContentArrow: IssueContentArrow$2,
  HeadingSpan: HeadingSpan$2,
  DescBodyWrapper: DescBodyWrapper$2,
  DescInnerWrapper: DescInnerWrapper$2,
  CustomContentDiv: CustomContentDiv$2,
  NetworkCongestion: NetworkCongestion$2,
  SelectDeviceBannerDiv: SelectDeviceBannerDiv,
  LeftNavWrapperAll: LeftNavWrapperAll$2,
  LeftNavSidebar: LeftNavSidebar$2,
  SpanTag: SpanTag,
  StyledNumberInput: StyledNumberInput$2,
  RecommendedTile: RecommendedTile,
  GuestDescText: GuestDescText,
  RightArrowDiv: RightArrowDiv$2,
  TiletContainer: TiletContainer$2,
  TechCoachBody: TechCoachBody$2,
  CloseIconWrapper: CloseIconWrapper$2,
  CloseButtonIconContainer: CloseButtonIconContainer$2,
  PopupCloseButton: PopupCloseButton$2,
  CloseButtonHitArea: CloseButtonHitArea$2,
  IconContainer: IconContainer$2,
  CloseIconSVG: CloseIconSVG$2,
  ButtonsWrapperNew: ButtonsWrapperNew
};

var MVA = "VZW-MFA";
var channelId = window._dg_channelId;
var isMVA = channelId === MVA;

var getUrl = function getUrl() {
  var mvoenv = sessionStorage.getItem('mvoenv');
  var externalTarget = sessionStorage.getItem('mvoExternalTarget');
  var _tsaEnvConfig = tsaEnvConfig$1({
      mvoenv: mvoenv,
      externalTarget: externalTarget
    }),
    apiUrls = _tsaEnvConfig.apiUrls;
  return apiUrls === null || apiUrls === void 0 ? void 0 : apiUrls.genAIFeedback;
};
var getAxiosConfig = function getAxiosConfig(isACSS) {
  return {
    withCredentials: true,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      credentials: true,
      channelId: isACSS ? 'VZW-ACSS' : channelId
    }
  };
};
var getSessionStorage = function getSessionStorage(key) {
  try {
    var data = sessionStorage.getItem(key);
    return JSON.parse(data);
  } catch (e) {
    console.error('Error getting session from sessionStorage', e);
    return;
  }
};
var buildPayload = function buildPayload(arg) {
  var _getSessionStorage;
  var feedback = arg.feedback,
    vegasTransactionId = arg.vegasTransactionId,
    acssCallId = arg.acssCallId,
    isACSS = arg.isACSS;
  var clientTransactionId = isACSS ? acssCallId || vegasTransactionId : (_getSessionStorage = getSessionStorage('sessionDetails')) === null || _getSessionStorage === void 0 ? void 0 : _getSessionStorage.soesessionId;
  return {
    clientId: 'troubleshooter_ai',
    action: 'reaction',
    referenceTransactionID: vegasTransactionId,
    clientTransactionId: clientTransactionId,
    ratingData: {
      accuracy: feedback,
      usability: feedback,
      reliability: feedback
    }
  };
};
var provideFeedback = function provideFeedback(_ref) {
  var url = _ref.url,
    arg = _ref.arg;
  try {
    if (!url) throw new Error('Missing Feedback url');
    var isACSS = arg.isACSS;
    var axiosConfig = getAxiosConfig(isACSS);
    var payload = buildPayload(arg);
    return Promise.resolve(postHttpClientRequest(url, payload, axiosConfig));
  } catch (e) {
    return Promise.reject(e);
  }
};
var useFeedback = function useFeedback() {
  var url = getUrl();
  return useSWRMutation(url, function (url, _ref2) {
    var arg = _ref2.arg;
    return provideFeedback({
      url: url,
      arg: arg
    });
  });
};

var useSWRCache = function useSWRCache(cacheKey) {
  if (cacheKey === void 0) {
    cacheKey = [];
  }
  var _useSWRConfig = useSWRConfig(),
    cache = _useSWRConfig.cache;
  try {
    var _cacheKey;
    if (!cache || ((_cacheKey = cacheKey) === null || _cacheKey === void 0 ? void 0 : _cacheKey.length) === 0) return {};
    var allCacheKeys = (cache === null || cache === void 0 ? void 0 : cache.keys()) || [];
    var matchingCacheKey = allCacheKeys === null || allCacheKeys === void 0 ? void 0 : allCacheKeys.find(function (key) {
      var _cacheKey2;
      return (_cacheKey2 = cacheKey) === null || _cacheKey2 === void 0 ? void 0 : _cacheKey2.every(function (ck) {
        return key === null || key === void 0 ? void 0 : key.includes(ck);
      });
    });
    if (!matchingCacheKey) return {};
    return (cache === null || cache === void 0 ? void 0 : cache.get(matchingCacheKey)) || {};
  } catch (e) {
    console.error('Error retrieving cache:', e);
    return {};
  }
};

var isGenAIEnabled = function isGenAIEnabled(values) {
  var _values$troubleShooti, _values$troubleShooti2, _values$troubleShooti3, _values$troubleShooti4, _values$troubleShooti5, _values$troubleShooti6;
  return values === null || values === void 0 ? void 0 : (_values$troubleShooti = values.troubleShootingInfo) === null || _values$troubleShooti === void 0 ? void 0 : (_values$troubleShooti2 = _values$troubleShooti.ddata) === null || _values$troubleShooti2 === void 0 ? void 0 : (_values$troubleShooti3 = _values$troubleShooti2.output) === null || _values$troubleShooti3 === void 0 ? void 0 : (_values$troubleShooti4 = _values$troubleShooti3.pageContent) === null || _values$troubleShooti4 === void 0 ? void 0 : (_values$troubleShooti5 = _values$troubleShooti4.steps) === null || _values$troubleShooti5 === void 0 ? void 0 : (_values$troubleShooti6 = _values$troubleShooti5[0]) === null || _values$troubleShooti6 === void 0 ? void 0 : _values$troubleShooti6.aiSummryEnabled;
};

var _templateObject$6;
var dropdownList = ['Network', 'Device'];
var IssueResolvedButton = styled(Button$1)(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteralLoose(["\n& > span{\nbackground-color:", ";\n}\n \n"])), function (props) {
  return props.isDark && "unset !important";
});
var ActionButtons = function ActionButtons(props) {
  var _props$values$thumbsD, _props$values, _props$values$thumbsD2, _props$values2, _window, _window$config, _window2, _window2$config, _configDetails$params39, _configDetails$params40;
  var finalComps = {
    styles: styledComps
  };
  if (window.isBAUACSS) {
    finalComps = {
      styles: styledBauComps
    };
  }
  if (window.isMVODigital) {
    finalComps = {
      styles: styledDigital
    };
  }
  var _finalComps$styles = finalComps.styles,
    ActionsWrapper = _finalComps$styles.ActionsWrapper,
    NewPreviousButtonWrapper = _finalComps$styles.NewPreviousButtonWrapper,
    ButtonsWrapper = _finalComps$styles.ButtonsWrapper,
    Next = _finalComps$styles.Next,
    Previous = _finalComps$styles.Previous,
    NewBtnWrapper = _finalComps$styles.NewBtnWrapper,
    NewActionButtonWrapper = _finalComps$styles.NewActionButtonWrapper;
  console.log('props.values?.thumbsDownClick', props);
  var _useState = useState({
      thumbsClicked: (_props$values$thumbsD = (_props$values = props.values) === null || _props$values === void 0 ? void 0 : _props$values.thumbsDownClick) != null ? _props$values$thumbsD : false,
      thumbsUpClicked: false,
      thumbsDownClicked: (_props$values$thumbsD2 = (_props$values2 = props.values) === null || _props$values2 === void 0 ? void 0 : _props$values2.thumbsDownClick) != null ? _props$values$thumbsD2 : false,
      showThumbsUp: false,
      showThumbsDown: false,
      submitClicked: false,
      rating: ''
    }),
    flags = _useState[0],
    setFlags = _useState[1];
  var _useState2 = useState({
      enableButton: false,
      userInput: ''
    });
  var thumbsClicked = flags.thumbsClicked,
    thumbsUpClicked = flags.thumbsUpClicked,
    thumbsDownClicked = flags.thumbsDownClicked;
  var _props$hideNetworkAnd = props.hideNetworkAndDevice,
    hideNetworkAndDevice = _props$hideNetworkAnd === void 0 ? false : _props$hideNetworkAnd;
  var acssCallId = props.acssCallId,
    values = props.values,
    isACSS = props.isACSS;
  var aiSummryEnabled = isGenAIEnabled(values);
  var _useFeedback = useFeedback(),
    provideGenAIFeedback = _useFeedback.trigger;
  if ((_window = window) !== null && _window !== void 0 && (_window$config = _window.config) !== null && _window$config !== void 0 && _window$config.newPopoutFlow && !((_window2 = window) !== null && _window2 !== void 0 && (_window2$config = _window2.config) !== null && _window2$config !== void 0 && _window2$config.retailIframe)) {
    hideNetworkAndDevice = true;
  }
  var history = useHistory();
  useEffect(function () {
    if (props.thumbsDownSubmittedStep === true) {
      setFlags(_extends({}, flags, {
        submitClicked: true
      }));
    }
  }, [props.thumbsDownSubmittedStep]);
  var configDetails = useContext(ConfigContext);
  var nextBtn = {};
  useEffect(function () {
    var _props$values$thumbsD3, _props$values3, _props$values$thumbsD4, _props$values4;
    setFlags(_extends({}, flags, {
      thumbsClicked: (_props$values$thumbsD3 = (_props$values3 = props.values) === null || _props$values3 === void 0 ? void 0 : _props$values3.thumbsDownClick) != null ? _props$values$thumbsD3 : false,
      thumbsUpClicked: false,
      thumbsDownClicked: (_props$values$thumbsD4 = (_props$values4 = props.values) === null || _props$values4 === void 0 ? void 0 : _props$values4.thumbsDownClick) != null ? _props$values$thumbsD4 : false
    }));
  }, [props.pageId]);
  if (props.buttons && props.buttons.length > 0) {
    props.buttons.forEach(function (btn) {
      if (btn.label.toLowerCase() != 'yes') {
        nextBtn = btn;
      }
    });
  }
  var doActionNew = function doActionNew(e, button, disabled) {
    e.preventDefault();
    if (disabled && !props.isNextBtnEnableNRB) {
      return;
    }
    if (props.handleAction) {
      props.handleAction(button);
    }
  };
  var doAction = function doAction(button, redirectToBackPage) {
    var _window3;
    if (redirectToBackPage === void 0) {
      redirectToBackPage = false;
    }
    if ((_window3 = window) !== null && _window3 !== void 0 && _window3.isMVODigital && props.isHowToContent && redirectToBackPage) {
      history === null || history === void 0 ? void 0 : history.goBack();
      return;
    }
    if (props.handleAction) {
      props.handleAction(button);
    }
  };
  var doNext = function doNext(e, disabled) {
    e.preventDefault();
    if (disabled) {
      return;
    }
    if (props.handleNext) {
      var currentPageId = props.pageId;
      var finalPageID = ++currentPageId;
      props.handleNext(finalPageID);
    }
  };
  var doPrevious = function doPrevious(e, disabled) {
    e.preventDefault();
    if (disabled) {
      return;
    }
    if (props.handlePrevious) {
      var currentPageId = props.pageId;
      var finalPageID = --currentPageId;
      props.handlePrevious(finalPageID);
    }
  };
  var handleThumbsUpClick = function handleThumbsUpClick() {
    var _window4, _window4$troubleShoot, _window4$troubleShoot2, _window4$troubleShoot3, _window5, _window5$troubleShoot, _window5$troubleShoot2, _window5$troubleShoot3;
    var aiSummary = session('aiSummary').get();
    if (aiSummryEnabled && aiSummary !== null && aiSummary !== void 0 && aiSummary.vegasTransactionId) {
      provideGenAIFeedback({
        feedback: 5,
        vegasTransactionId: aiSummary === null || aiSummary === void 0 ? void 0 : aiSummary.vegasTransactionId,
        acssCallId: acssCallId,
        isACSS: isACSS
      });
    }
    try {
      window.scrollTo(0, 0);
    } catch (error) {
      console.log(error);
    }
    setFlags(_extends({}, flags, {
      rating: '5',
      showThumbsUp: true,
      thumbsClicked: true,
      thumbsUpClicked: true,
      thumbsDownClicked: false
    }));
    if (!((_window4 = window) !== null && _window4 !== void 0 && (_window4$troubleShoot = _window4.troubleShootingJson) !== null && _window4$troubleShoot !== void 0 && (_window4$troubleShoot2 = _window4$troubleShoot.ddata) !== null && _window4$troubleShoot2 !== void 0 && (_window4$troubleShoot3 = _window4$troubleShoot2.device) !== null && _window4$troubleShoot3 !== void 0 && _window4$troubleShoot3.is5GDevice)) {
      props.functions.handleTroubleShootingAction({
        'action': 'done'
      }, '', '', 'feedbackThumbsUp');
    }
    if ((_window5 = window) !== null && _window5 !== void 0 && (_window5$troubleShoot = _window5.troubleShootingJson) !== null && _window5$troubleShoot !== void 0 && (_window5$troubleShoot2 = _window5$troubleShoot.ddata) !== null && _window5$troubleShoot2 !== void 0 && (_window5$troubleShoot3 = _window5$troubleShoot2.device) !== null && _window5$troubleShoot3 !== void 0 && _window5$troubleShoot3.is5GDevice) {
      if (props.handleModalState) {
        props.handleModalState(_extends({}, flags, {
          thumbsClicked: true,
          showThumbsUp: true
        }));
      }
    }
  };
  var handleThumbsDownClick = function handleThumbsDownClick() {
    setFlags(_extends({}, flags, {
      rating: '1',
      showThumbsDown: true,
      thumbsUpClicked: false,
      thumbsDownClicked: true
    }));
    if (props.handleModalState) {
      props.handleModalState(_extends({}, flags, {
        thumbsClicked: true,
        justAfterThumbsDownClicked: true,
        showThumbsDown: true
      }));
    }
  };
  var invokeBridgeFunc = function invokeBridgeFunc(callback, funcName) {
    if (callback && typeof callback === 'function') {
      callback();
      console.log(funcName + '--->' + " Invoked");
      return;
    }
    console.log(funcName + '--->' + " is not passed to nodemodules");
  };
  var handleChange = function handleChange(value) {
    console.log(props, "!!!!!!!!!!!!");
    var event = value;
    var _ref = configDetails || {},
      _ref$paramsDetails = _ref.paramsDetails,
      _ref$paramsDetails2 = _ref$paramsDetails === void 0 ? {} : _ref$paramsDetails,
      _ref$paramsDetails2$c = _ref$paramsDetails2.channel,
      channel = _ref$paramsDetails2$c === void 0 ? '' : _ref$paramsDetails2$c,
      openDeviceTile = _ref$paramsDetails2.openDeviceTile,
      openNetworkTile = _ref$paramsDetails2.openNetworkTile,
      viewNetworkDetailsPopup = _ref$paramsDetails2.viewNetworkDetailsPopup,
      viewDeviceDetailsPopup = _ref$paramsDetails2.viewDeviceDetailsPopup;
    if (event === 'Network') {
      channel === 'Retail' ? invokeBridgeFunc(openNetworkTile, 'openNetworkTile') : invokeBridgeFunc(viewNetworkDetailsPopup, 'viewNetworkDetailsPopup');
    } else if (event === 'Device') {
      channel === 'Retail' ? invokeBridgeFunc(openDeviceTile, 'openDeviceTile') : invokeBridgeFunc(viewDeviceDetailsPopup, 'viewDeviceDetailsPopup');
    }
  };
  var buttonCount = 0;
  var disabledBtn = true;
  console.log('ActionButtons buttons, props.showPrevious, props.showNext, props.disablePrevious, props.disableNext', props.showPrevious, props.showNext, props.disablePrevious, props.disableNext);
  var ActionBtnNew = function ActionBtnNew() {
    var _configDetails$params, _configDetails$params2, _configDetails$params3, _configDetails$params4, _configDetails$params5, _configDetails$params6, _configDetails$params7, _configDetails$params8, _configDetails$params9, _configDetails$params0, _configDetails$params1, _configDetails$params10, _configDetails$params11, _configDetails$params12, _configDetails$config, _configDetails$params13, _configDetails$params14, _configDetails$params15, _configDetails$params16, _configDetails$params27, _configDetails$params28, _configDetails$params29, _configDetails$params30, _configDetails$params31, _configDetails$params32, _props$values5, _configDetails$params33, _configDetails$params34, _configDetails$params35, _configDetails$params36, _configDetails$params37, _configDetails$params38;
    return /*#__PURE__*/React__default.createElement(NewBtnWrapper, null, /*#__PURE__*/React__default.createElement(NewPreviousButtonWrapper, {
      id: "acss-footer-next-previous",
      className: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : (_configDetails$params2 = _configDetails$params.theme) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.isDark) && 'dark'
    }, !props.isHowToContent && props.showPrevious ? /*#__PURE__*/React__default.createElement(TextLinkCaret, {
      className: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params3 = configDetails.paramsDetails) === null || _configDetails$params3 === void 0 ? void 0 : (_configDetails$params4 = _configDetails$params3.theme) === null || _configDetails$params4 === void 0 ? void 0 : _configDetails$params4.isDark) && props.disablePrevious && 'darkTextLinkCaret',
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params5 = configDetails.paramsDetails) !== null && _configDetails$params5 !== void 0 && (_configDetails$params6 = _configDetails$params5.theme) !== null && _configDetails$params6 !== void 0 && _configDetails$params6.isDark ? 'dark' : 'light',
      disabled: props.disablePrevious,
      iconPosition: "left",
      onClick: function onClick(e) {
        return doPrevious(e, props.disablePrevious);
      },
      "data-analyticstrack": 'caret-left icon',
      "data-clickstream": 'caret-left icon',
      "data-track": '{"type": "link", "name": "Previous step"}',
      ariaLabel: "Previous step"
    }, "Previous step") : null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        height: "20px",
        margin: "5px 10px 0px 10px"
      }
    }, /*#__PURE__*/React__default.createElement(Line$1, {
      type: "primary",
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params7 = configDetails.paramsDetails) !== null && _configDetails$params7 !== void 0 && (_configDetails$params8 = _configDetails$params7.theme) !== null && _configDetails$params8 !== void 0 && _configDetails$params8.isDark ? 'dark' : 'light',
      className: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params9 = configDetails.paramsDetails) === null || _configDetails$params9 === void 0 ? void 0 : (_configDetails$params0 = _configDetails$params9.theme) === null || _configDetails$params0 === void 0 ? void 0 : _configDetails$params0.isDark) && 'verticalDividentline',
      orientation: "vertical"
    })), !props.isHowToContent && props.showNext && props.templateId !== 'RESOLUTION_OPTIONS_ALL_DIGITAL' && (props === null || props === void 0 ? void 0 : props.templateId) !== "RESOLUTION_OPTIONS_GUEST_DIGITAL" && /*#__PURE__*/React__default.createElement(TextLinkCaret, {
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params1 = configDetails.paramsDetails) !== null && _configDetails$params1 !== void 0 && (_configDetails$params10 = _configDetails$params1.theme) !== null && _configDetails$params10 !== void 0 && _configDetails$params10.isDark ? 'dark' : 'light',
      className: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params11 = configDetails.paramsDetails) === null || _configDetails$params11 === void 0 ? void 0 : (_configDetails$params12 = _configDetails$params11.theme) === null || _configDetails$params12 === void 0 ? void 0 : _configDetails$params12.isDark) && props.disableNext && !props.isNextBtnEnableNRB && props.disabledButtons && 'darkTextLinkCaret',
      disabled: props.disableNext && props.disabledButtons && !props.isNextBtnEnableNRB,
      iconPosition: "right",
      onClick: function onClick(e) {
        return doActionNew(e, nextBtn, props.disableNext && props.disabledButtons);
      },
      "data-analyticstrack": 'caret-right icon',
      "data-clickstream": 'caret-right icon',
      "data-track": '{"type": "link", "name": "Next step"}',
      title: "Next step",
      ariaLabel: "Next step"
    }, "Next step")), /*#__PURE__*/React__default.createElement(NewActionButtonWrapper, null, !(configDetails !== null && configDetails !== void 0 && (_configDetails$config = configDetails.config) !== null && _configDetails$config !== void 0 && _configDetails$config.isBAUACSS) && !hideNetworkAndDevice && /*#__PURE__*/React__default.createElement(DropdownSelect, {
      onChange: function onChange(e) {
        return handleChange(e.target.value);
      },
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params13 = configDetails.paramsDetails) !== null && _configDetails$params13 !== void 0 && (_configDetails$params14 = _configDetails$params13.theme) !== null && _configDetails$params14 !== void 0 && _configDetails$params14.isDark ? 'dark' : 'light',
      width: "230px"
    }, /*#__PURE__*/React__default.createElement("option", null, "Network and device info"), dropdownList.map(function (optionValue, idx) {
      return /*#__PURE__*/React__default.createElement("option", {
        value: optionValue
      }, optionValue);
    })), /*#__PURE__*/React__default.createElement(ButtonsWrapper, {
      align: props.alignButtons,
      stackButtons: props.stackButtons,
      thumbsUpClicked: thumbsUpClicked,
      thumbsDownClicked: thumbsDownClicked,
      submitClicked: props.thumbsDownSubmittedStep,
      isDark: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params15 = configDetails.paramsDetails) === null || _configDetails$params15 === void 0 ? void 0 : (_configDetails$params16 = _configDetails$params15.theme) === null || _configDetails$params16 === void 0 ? void 0 : _configDetails$params16.isDark) == true
    }, props.buttons.map(function (button) {
      console.log('button', button);
      if (button.label.toLowerCase() == 'yes') {
        if (!props.hideIssueResolved) {
          var _configDetails$params19, _configDetails$params20, _configDetails$params21, _configDetails$params22, _configDetails$params23, _configDetails$params24, _configDetails$params25, _configDetails$params26;
          var btnLabel = 'Issue Resolved';
          var btnType = button.type === 'secondary' ? "secondary" : "primary";
          return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
            style: {
              display: "flex",
              height: "20px",
              marginTop: "5px"
            }
          }, /*#__PURE__*/React__default.createElement(Line$1, {
            className: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params19 = configDetails.paramsDetails) === null || _configDetails$params19 === void 0 ? void 0 : (_configDetails$params20 = _configDetails$params19.theme) === null || _configDetails$params20 === void 0 ? void 0 : _configDetails$params20.isDark) && 'verticalDividentline',
            surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params21 = configDetails.paramsDetails) !== null && _configDetails$params21 !== void 0 && (_configDetails$params22 = _configDetails$params21.theme) !== null && _configDetails$params22 !== void 0 && _configDetails$params22.isDark ? 'dark' : 'light',
            type: "primary",
            orientation: "vertical"
          })), /*#__PURE__*/React__default.createElement(IssueResolvedButton, {
            size: "small",
            surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params23 = configDetails.paramsDetails) !== null && _configDetails$params23 !== void 0 && (_configDetails$params24 = _configDetails$params23.theme) !== null && _configDetails$params24 !== void 0 && _configDetails$params24.isDark ? 'dark' : 'light',
            onClick: function onClick() {
              return doAction(button);
            },
            use: btnType,
            isDark: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params25 = configDetails.paramsDetails) === null || _configDetails$params25 === void 0 ? void 0 : (_configDetails$params26 = _configDetails$params25.theme) === null || _configDetails$params26 === void 0 ? void 0 : _configDetails$params26.isDark) == true
          }, btnLabel));
        } else {
          return /*#__PURE__*/React__default.createElement("span", null, " ");
        }
      }
    }), /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        height: "20px",
        marginTop: "5px"
      }
    }, /*#__PURE__*/React__default.createElement(Line$1, {
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params27 = configDetails.paramsDetails) !== null && _configDetails$params27 !== void 0 && (_configDetails$params28 = _configDetails$params27.theme) !== null && _configDetails$params28 !== void 0 && _configDetails$params28.isDark ? 'dark' : 'light',
      className: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params29 = configDetails.paramsDetails) === null || _configDetails$params29 === void 0 ? void 0 : (_configDetails$params30 = _configDetails$params29.theme) === null || _configDetails$params30 === void 0 ? void 0 : _configDetails$params30.isDark) && 'verticalDividentline',
      type: "primary",
      orientation: "vertical"
    })), /*#__PURE__*/React__default.createElement("div", {
      className: !(configDetails !== null && configDetails !== void 0 && (_configDetails$params31 = configDetails.paramsDetails) !== null && _configDetails$params31 !== void 0 && (_configDetails$params32 = _configDetails$params31.theme) !== null && _configDetails$params32 !== void 0 && _configDetails$params32.isDark) && 'footerThumbsCover footer-thumbs-up',
      "data-track": "thumbs-Up",
      onClick: !thumbsClicked && !((_props$values5 = props.values) !== null && _props$values5 !== void 0 && _props$values5.thumbsDownClick) && handleThumbsUpClick
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      alt: "thumbs-up",
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params33 = configDetails.paramsDetails) !== null && _configDetails$params33 !== void 0 && (_configDetails$params34 = _configDetails$params33.theme) !== null && _configDetails$params34 !== void 0 && _configDetails$params34.isDark ? 'dark' : 'light',
      name: !thumbsUpClicked ? 'thumbs-up' : 'thumbs-up-filled',
      size: "medium",
      tabIndex: "0",
      "data-name": "ThumbUp",
      "data-analyticstrack": 'thumbs-Up-Idle',
      "data-track": '{"type": "icon", "name": "thumbs-Up-Idle"}',
      "data-clickstream": 'thumbs-Up-Idle'
    })), /*#__PURE__*/React__default.createElement("div", {
      className: !(configDetails !== null && configDetails !== void 0 && (_configDetails$params35 = configDetails.paramsDetails) !== null && _configDetails$params35 !== void 0 && (_configDetails$params36 = _configDetails$params35.theme) !== null && _configDetails$params36 !== void 0 && _configDetails$params36.isDark) && 'footerThumbsCover footer-thumbs-down',
      "data-track": "thumbs-Down",
      onClick: !props.thumbsDownSubmittedStep && !props.values.thumbsUpClick && handleThumbsDownClick
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      alt: "thumbs-down",
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params37 = configDetails.paramsDetails) !== null && _configDetails$params37 !== void 0 && (_configDetails$params38 = _configDetails$params37.theme) !== null && _configDetails$params38 !== void 0 && _configDetails$params38.isDark ? 'dark' : 'light',
      name: !thumbsDownClicked ? 'thumbs-down' : 'thumbs-down-filled',
      size: "medium",
      tabIndex: "0",
      "data-name": "ThumbDown",
      "data-analyticstrack": 'thumbs-Down-Idle',
      "data-track": '{"type": "icon", "name": "thumbs-Down-Idle"}',
      "data-clickstream": 'thumbs-Down-Idle'
    })))));
  };
  return /*#__PURE__*/React__default.createElement(ActionsWrapper, _extends({
    className: "helpNot"
  }, props), props.newBtnType && /*#__PURE__*/React__default.createElement(ActionBtnNew, null), !props.newBtnType && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, props.showPrevious && /*#__PURE__*/React__default.createElement(Previous, {
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params39 = configDetails.paramsDetails) === null || _configDetails$params39 === void 0 ? void 0 : (_configDetails$params40 = _configDetails$params39.theme) === null || _configDetails$params40 === void 0 ? void 0 : _configDetails$params40.isDark,
    onClick: function onClick(e) {
      return doPrevious(e, props.disablePrevious);
    },
    onKeyPress: function onKeyPress(e) {
      return doPrevious(e, props.disablePrevious);
    },
    "data-analyticstrack": 'caret-left icon',
    "data-track": '{"type": "link", "name": "caret-left icon"}',
    "data-clickstream": 'caret-left icon',
    tabIndex: props !== null && props !== void 0 && props.disablePrevious ? -1 : "0",
    role: "button",
    "aria-label": "Previous",
    "aria-disabled": props !== null && props !== void 0 && props.disablePrevious ? "true" : "false"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    color: props.disablePrevious ? verizonTheme.coolGray3 : verizonTheme.black,
    name: "left-caret",
    ariaLabel: "Previous step",
    size: props.caretSize ? props.caretSize : 'large',
    ariaHidden: "true",
    tabIndex: "-1"
  })), /*#__PURE__*/React__default.createElement(ButtonsWrapper, {
    align: props.alignButtons,
    stackButtons: props.stackButtons
  }, props.buttons.map(function (button) {
    if (props.templateId == 'RESOLUTION_OPTIONS_ALL_DIGITAL' || (props === null || props === void 0 ? void 0 : props.templateId) == 'RESOLUTION_OPTIONS_GUEST_DIGITAL' || (props === null || props === void 0 ? void 0 : props.templateId) == 'RESOLUTION_OPTIONS_RECOMMEND_AUTH_DGTAL' || props.templateId == 'RESOLUTION_OPTIONS_MVO_TIER2' || window.isMVODigital && props.templateId == 'RESOLUTION_OPTIONS_CHANGE_DEVICE_DIGITAL') {
      return null;
    }
    if (props.isNewDesign && !props.isHowToContent) {
      if (button.label.toLowerCase() == 'no' || button.label.toLowerCase() == 'next') {
        var _window6;
        console.log("cont.");
        var btnLabel = props.templateId === 'LV_PERMANENTADDRESS_PILOT' && (_window6 = window) !== null && _window6 !== void 0 && _window6.isMVODigital ? 'Submit' : 'Continue';
        var btnType = button.type === 'secondary' ? "secondary" : "primary";
        var inverted = button.inverted ? true : false;
        var size = props.size ? props.size : button.size;
        size = props.stackButtons ? '320px' : size;
        return /*#__PURE__*/React__default.createElement(ActionButton, {
          "data-analyticstrack": button.label + "-Btn",
          "data-track": "{\"type\": \"link\", \"name\": \"" + button.label + "-Btn\"}",
          "data-clickstream": button.label + "-btn-cta",
          disabled: props.disabled ? disabledBtn : props.disabled,
          surface: inverted ? "dark" : "light",
          key: "action_button_" + ++buttonCount,
          onClick: function onClick() {
            return doAction(button);
          },
          use: btnType,
          size: size,
          style: window.isMVODigital && btnLabel === 'Continue' ? {
            'min-width': size
          } : null,
          "data-testid": "actionBtn"
        }, btnLabel);
      }
    } else {
      var _window7, _window7$troubleShoot, _window7$troubleShoot2, _window7$troubleShoot3;
      var _btnType = button.type === 'secondary' ? "secondary" : "primary";
      var _inverted = button.inverted ? true : false;
      var _size = props.size ? props.size : button.size;
      _size = props.stackButtons ? '320px' : _size;
      if ((_window7 = window) !== null && _window7 !== void 0 && (_window7$troubleShoot = _window7.troubleShootingJson) !== null && _window7$troubleShoot !== void 0 && (_window7$troubleShoot2 = _window7$troubleShoot.ddata) !== null && _window7$troubleShoot2 !== void 0 && (_window7$troubleShoot3 = _window7$troubleShoot2.device) !== null && _window7$troubleShoot3 !== void 0 && _window7$troubleShoot3.is5GDevice) {
        _size = props.stackButtons ? '170px' : _size;
      }
      return /*#__PURE__*/React__default.createElement(ActionButton, {
        className: _btnType == "primary" && "btn-primary-dark",
        "data-analyticstrack": button.label + "-Btn",
        "data-track": "{\"type\": \"link\", \"name\": \"" + button.label + "-Btn\"}",
        "data-clickstream": button.label + "-btn-cta",
        disabled: props.disabled ? disabledBtn : props.disabled,
        surface: _inverted ? "dark" : "light",
        key: "action_button_" + ++buttonCount,
        onClick: function onClick() {
          return doAction(button, true);
        },
        use: _btnType,
        size: _size,
        "data-testid": "howtoActionBtn"
      }, button.label);
    }
  })), props.showNext && props.templateId !== 'RESOLUTION_OPTIONS_ALL_DIGITAL' && (props === null || props === void 0 ? void 0 : props.templateId) !== 'RESOLUTION_OPTIONS_GUEST_DIGITAL' && /*#__PURE__*/React__default.createElement(Next, {
    onClick: function onClick(e) {
      return doNext(e, props.disableNext);
    },
    onKeyPress: function onKeyPress(e) {
      return doNext(e, props.disableNext);
    },
    "data-analyticstrack": 'caret-right icon',
    "data-track": '{"type": "link", "name": "caret-right icon"}',
    "data-clickstream": 'caret-right icon',
    tabIndex: props !== null && props !== void 0 && props.disableNext ? -1 : "0",
    role: "button",
    "aria-label": "Next",
    "aria-disabled": props !== null && props !== void 0 && props.disableNext ? "true" : "false"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    color: props.disableNext ? verizonTheme.coolGray3 : verizonTheme.black,
    name: "right-caret",
    ariaLabel: "Next step",
    size: props.caretSize ? props.caretSize : 'large',
    ariaHidden: "true",
    tabIndex: "-1"
  }))));
};
ActionButtons.propTypes = {
  alignButtons: PropTypes.oneOf(['left', 'center', 'right']),
  buttons: PropTypes.array.isRequired,
  disableNext: PropTypes.bool,
  disablePrevious: PropTypes.bool,
  disabled: PropTypes.bool,
  handleAction: PropTypes.func,
  handleNext: PropTypes.func,
  handlePrevious: PropTypes.func,
  showNext: PropTypes.bool,
  showPrevious: PropTypes.bool,
  stackButtons: PropTypes.bool,
  disableMargin: PropTypes.bool,
  pageId: PropTypes.string
};
ActionButtons.defaultProps = {
  alignButtons: 'center',
  buttons: [],
  disabled: false,
  disableNext: false,
  disablePrevious: false,
  showNext: false,
  showPrevious: false,
  stackButtons: false,
  disableMargin: false
};

var _templateObject$7, _templateObject2$4, _templateObject3$4, _templateObject4$4, _templateObject5$3, _templateObject6$3, _templateObject7$3, _templateObject8$3, _templateObject9$3, _templateObject0$3, _templateObject1$3, _templateObject10$3, _templateObject11$3;
var CheckListContainer = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteralLoose(["\n // border: 1px solid ", ";\n  height: 30px;\n  // width: ", ";\n  margin-bottom: ", ";\n  max-width: ", ";\n  @media screen and (min-width: 600px) {\n    width: 470px;\n  }\n"])), verizonTheme.coolGray3, function (props) {
  return props.width;
}, function (props) {
  return props.marginBottom || "30px";
}, function (props) {
  return props.maxWidth;
});
var BorderContainer = styled.div(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-shadow: 0px 1px 1px ", ";\n"])), verizonTheme.white, verizonTheme.coolGray3, verizonTheme.coolGray6);
var BorderContainerOption = styled.div(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-shadow: 0px 0px 2px ", ";\n  border-left: 4px solid #d52b1e !important;\n"])), verizonTheme.white, verizonTheme.coolGray3, verizonTheme.coolGray6);
var ItemList = styled.div(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteralLoose(["\n  \n  position: relative;\n  background-color: ", ";\n  // border: 1px solid ", ";\n  box-shadow: 0px 1px 4px ", ";\n  /* display: ", "; */\n  visibility: ", ";\n  // margin-top: -3px;\n  // padding-bottom: 10px;\n  //width: 470px;\n  max-width: inherit;\n  z-index: 2;\n  max-height:260px;\n  overflow-y: scroll;\n"])), verizonTheme.white, verizonTheme.coolGray3, verizonTheme.coolGray6, function (_ref) {
  var show = _ref.show;
  return show ? "block" : "none";
}, function (_ref2) {
  var show = _ref2.show;
  return show ? "visible" : "hidden";
});
var ItemWrapper = styled.div(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  height: 30px;\n  align-items: center;\n  // width: 470px;\n  max-width: inherit;\n  align-items: center;\n    svg path{\n      ", "\n    }\n"])), function (props) {
  return props.isDark ? "\n        stroke: #D8DADA;\n      " : "\n        stroke: #000;\n      ";
});
var Accent = styled.div(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteralLoose(["\n  // background-color: ", ";\n  width: 3px;\n"])), function (_ref3) {
  var active = _ref3.active,
    selected = _ref3.selected;
  return active || selected ? verizonTheme.red : "transparent";
});
var CheckMark = styled.div(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 35px;\n  max-width:35px\n"])));
var ItemStepCount = styled.div(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteralLoose(["\n  padding-top: 7px;\n  padding-left: 0px;\n"])));
var ItemText = styled.div(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"])));
var UnderLine = styled.div(_templateObject0$3 || (_templateObject0$3 = _taggedTemplateLiteralLoose(["\n  width: 26px;\n  border-bottom: 1px solid ", ";\n  margin-left: 10px;\n"])), verizonTheme.black);
var PageNumber = styled.div(_templateObject1$3 || (_templateObject1$3 = _taggedTemplateLiteralLoose(["\n  span {\n    border-bottom: 1px solid black;\n    padding-bottom: 10px;\n    width: 25px;\n    display: inline-block;\n    padding-left: 6px;\n    margin-top: 10px;\n  }\n"])));
var CheckListItem = function CheckListItem(props) {
  var _configDetails$params, _configDetails$params2;
  var _useState = useState(false);
  var AnchorLink = styled.a(_templateObject10$3 || (_templateObject10$3 = _taggedTemplateLiteralLoose(["\n    text-decoration: none;\n    color: ", " !important;\n    outline: 0px;\n    cursor: ", "\n    &:hover{\n      cursor: ", "\n    }\n  "])), props.selected ? verizonTheme.black : verizonTheme.coolGray3, props.eotFlag ? "default" : "pointer", props.eotFlag ? "default" : "pointer");
  var ItemStepCount = styled.div(_templateObject11$3 || (_templateObject11$3 = _taggedTemplateLiteralLoose(["\n  display:inline-block;\n  min-width:20px;\n  max-width:20px;\n    // border-bottom: ", ";\n  "])), props.selected ? '1px solid #000' : '0px');
  var renderPageNumber = function renderPageNumber() {
    if (!props.singleItem || props.is5GDevice == undefined) {
      return /*#__PURE__*/React__default.createElement(Title, {
        color: props.selected ? verizonTheme.black : verizonTheme.coolGray3,
        size: props.step === "" ? "large" : "small"
      }, props.step === "" ? /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "12px",
          borderBottom: "2px solid black"
        }
      }) : props.step);
    }
    return /*#__PURE__*/React__default.createElement(Title, {
      color: props.selected ? verizonTheme.black : verizonTheme.coolGray3,
      size: props.step === "" ? "large" : "small"
    }, /*#__PURE__*/React__default.createElement(PageNumber, null, props.step === "" ? /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "12px",
        borderBottom: "2px solid black"
      }
    }) : /*#__PURE__*/React__default.createElement("span", null, props.step)));
  };
  var configDetails = useContext(ConfigContext);
  return /*#__PURE__*/React__default.createElement(ItemWrapper, {
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : (_configDetails$params2 = _configDetails$params.theme) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.isDark,
    className: "ItemCheck",
    onClick: function onClick() {
      return props.onClick(props.value || "");
    },
    "data-testid": "ItemCheck-" + props.value,
    "data-value": props.value
  }, /*#__PURE__*/React__default.createElement(Accent, {
    active: props.active,
    selected: props.selected
  }), /*#__PURE__*/React__default.createElement(ItemStepCount, null, renderPageNumber()), props.selected && !props.text && /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "down-caret",
    color: verizonTheme.black,
    size: props.caretSize ? props.caretSize : "small",
    medium: "1px",
    style: props.step === "" ? {
      paddingLeft: '10px',
      height: '2.5rem'
    } : {
      paddingLeft: '10px'
    }
  }), /*#__PURE__*/React__default.createElement(CheckMark, null, !props.selected && /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "checkmark",
    size: "medium",
    medium: "2px"
  })), /*#__PURE__*/React__default.createElement(ItemText, null, /*#__PURE__*/React__default.createElement(Title, {
    color: props.selected ? verizonTheme.black : verizonTheme.coolGray3,
    size: "small"
  }, /*#__PURE__*/React__default.createElement(AnchorLink, {
    value: props.text
  }, props.text))));
};
var CheckList = function CheckList(props) {
  var _props$steps = props.steps,
    steps = _props$steps === void 0 ? [] : _props$steps,
    value = props.value,
    marginBottom = props.marginBottom,
    is5GDevice = props.is5GDevice,
    eotFlag = props.eotFlag;
  var _useState2 = useState(false),
    showList = _useState2[0],
    setShowList = _useState2[1];
  var dropdownNode = useRef();
  var handleClick = function handleClick(e) {
    var _e$target;
    console.log("Checklist: handleClick");
    var showFlag = false;
    var parentElement = e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.parentElement;
    if (parentElement && parentElement.classList.contains('dropdownHandler')) {
      showFlag = false;
    } else {
      showFlag = true;
    }
    if (isMobile) {
      if (!showList && dropdownNode.current && dropdownNode.current.contains(event.target) && showFlag) {
        setShowList(true);
        return;
      }
      setShowList(false);
      return;
    }
    setShowList(!showList);
  };
  useEffect(function () {
    document.addEventListener('click', handleClick);
    return function () {
      document.removeEventListener('click', handleClick);
    };
  }, [handleClick]);
  var selectedStep = steps[0] || {};
  if (steps.length > 0) {
    steps.forEach(function (step) {
      if (step.pageId === value) {
        selectedStep = step;
      }
    });
  }
  var handleSelect = function handleSelect(pageValue) {
    console.log("Checklist: handleSelect: value: ", pageValue);
    if (!is5GDevice && eotFlag) {
      return false;
    }
    props.onChange(pageValue);
  };
  var renderCheckList = function renderCheckList(step) {
    var text = isMobile() ? ellipsis(step.title, 90) : ellipsis(step.title, 130);
    return /*#__PURE__*/React__default.createElement(CheckListItem, {
      value: step.pageId,
      key: step.pageId,
      checked: step.currentStep,
      "data-analyticstrack": step.title + "-Dropdown",
      "data-track": "{\"type\": \"link\", \"name\": \"" + step.title + "-Dropdown\"}",
      "data-clickstream": step.title + "-Dropdown",
      step: step && step.pageId && step.pageId.toString().padStart(2, 0),
      onClick: function onClick() {
        return handleSelect(step.pageId);
      },
      text: text,
      selected: step.pageId === value ? true : false,
      is5GDevice: is5GDevice,
      eotFlag: eotFlag
    });
  };
  var renderCheckListComponent = function renderCheckListComponent() {
    var border = "0px";
    return /*#__PURE__*/React__default.createElement(CheckListContainer, {
      ref: dropdownNode,
      marginBottom: marginBottom,
      id: "CheckList_1234",
      "data-track": "{\"type\": \"link\", \"name\": \"" + selectedStep.title + "-Dropdown\"}",
      "data-analyticstrack": selectedStep.title + "-Dropdown"
    }, /*#__PURE__*/React__default.createElement(BorderContainer, {
      style: {
        display: showList ? 'none' : 'block',
        border: '0px',
        boxShadow: '0px 0px 0px 0px'
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "dropdownHandler"
    }, /*#__PURE__*/React__default.createElement(CheckListItem, {
      active: true,
      checked: true,
      "data-analyticstrack": selectedStep.title + "-Dropdown",
      "data-track": "{\"type\": \"link\", \"name\": \"" + selectedStep.title + "-Dropdown\"}",
      "data-clickstream": selectedStep.title + "-Dropdown",
      onClick: function onClick(e) {
        return handleClick(e);
      },
      selected: value ? selectedStep.pageId === value : true,
      step: value ? value.toString().padStart(2, 0) : "",
      childrenStyles: {
        border: border
      },
      caretSize: props.caretSize,
      singleItem: true,
      is5GDevice: is5GDevice,
      eotFlag: eotFlag
    }))), /*#__PURE__*/React__default.createElement(ItemList, {
      id: "ItemList_1234",
      "data-testid": "ItemListTestId",
      show: showList,
      onMouseLeave: function onMouseLeave() {
        return setShowList(false);
      }
    }, props.steps.sort(function (a, b) {
      return a.pageId - b.pageId;
    }).reverse().map(function (step) {
      if (step.pageId === value) {
        return /*#__PURE__*/React__default.createElement(BorderContainerOption, null, renderCheckList(step));
      }
      return renderCheckList(step);
    })));
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, !isMobile() && renderCheckListComponent(), isMobile() && renderCheckListComponent());
};
CheckList.propTypes = {
  onChange: PropTypes.func,
  steps: PropTypes.array.isRequired,
  size: PropTypes.string,
  value: PropTypes.string
};
CheckList.defaultProps = {};

var _templateObject$8, _templateObject2$5, _templateObject3$5, _templateObject4$5, _templateObject5$4, _templateObject6$4;
var ContentWrapper$4 = styled.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteralLoose(["\n  height: 180px;\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  width: 795px;\n  @media(max-width: 600px) {\n  width:78%;\n  margin-left: 38px;\n  height: 100%;\n  }\n"])));
var TitleWrapper$3 = styled.div(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteralLoose(["\n  padding: 3px 10px;\n"])));
var ButtonWrapper$3 = styled.div(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteralLoose(["\n  /* justify-content: left !important; */\n  width: 100%;\n  @media(max-width: 600px) {\n    display: block;\n    border:2px solid red;\n  \n  }\n"])));
var TitleContainer = styled.div(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteralLoose(["\n  padding-top: 5px;\n  background-color: ", ";\n  display: inline-flex;\n  vertical-align: middle;\n  padding-top: 13px;\n  padding-bottom: 13px;\n  padding-left: 10px;\n  padding-right: -1rem;\n  width: 786px;\n  @media(max-width: 600px) {\n    padding-left: 10px;\n    padding-right: 6rem;\n    width: 100%;\n    margin-left: -3rem;\n  }\n"])), verizonTheme.yellow);
var TitleDescription = styled.div(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteralLoose(["\n  border: 1px solid #e6e5e3;\n  padding: 1rem 2rem 1rem 2rem;\n  @media(max-width: 600px) {\n    margin-left: -4rem;\n    margin-right: -4rem;\n    border: 1px solid #e6e5e3;\n    padding: 1rem 4rem 1rem 3rem;\n  }\n"])));
var IconWrapper = styled.div(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteralLoose(["\n  margin-top: 4px;\n"])));
var handleAction = function handleAction(button) {
  window.location.href = button.url;
};
var Outage = function Outage(props) {
  var _props$outageInfo = props.outageInfo,
    outageInfo = _props$outageInfo === void 0 ? {} : _props$outageInfo;
  var _outageInfo$data = outageInfo.data,
    data = _outageInfo$data === void 0 ? {} : _outageInfo$data,
    _outageInfo$cta = outageInfo.cta,
    buttons = _outageInfo$cta === void 0 ? [] : _outageInfo$cta;
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ContentWrapper$4, null, /*#__PURE__*/React__default.createElement(TitleContainer, null, /*#__PURE__*/React__default.createElement(IconWrapper, null, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "error",
    size: "medium"
  })), /*#__PURE__*/React__default.createElement(TitleWrapper$3, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "large",
    bold: true,
    primitive: "h4"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, data.statusMessage)), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "3px"
  }), /*#__PURE__*/React__default.createElement(Body, {
    size: "small"
  }, "Last updated ", data.lastUpdated))), /*#__PURE__*/React__default.createElement(TitleDescription, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    primitive: "h4"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, data.detailedMessage)), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "1rem"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$3, null, /*#__PURE__*/React__default.createElement(ActionButtons, {
    alignButtons: "left",
    buttons: buttons,
    handleAction: handleAction,
    size: "small"
  })))));
};
Outage.propTypes = {
  outageInfo: PropTypes.object.isRequired
};

var _templateObject$9, _templateObject2$6, _templateObject3$6, _templateObject4$6, _templateObject5$5, _templateObject6$5, _templateObject7$4, _templateObject8$4;
var ContentWrapper$5 = styled.div(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  text-align: center;\n  color: red;\n"])));
var OutageContainer = styled.div(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteralLoose(["\n  background-color: #ffbc3d;\n  color: #000;\n  position:relative;\n  font:14px \n  @media(max-width:600px){\n      top:0px;\n  }\n"])));
var ContainerItems = styled.div(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (props) {
  return props.isDark ? "\n      border: 1px solid #fff;\n      svg path{\n        fill: #fff;\n        stroke: #D8DADA;\n      }\n      button{\n        border-color: #fff;\n      }\n    " : "\n      border: 1px solid #ffbc3d;\n  ";
});
var Items = styled.div(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteralLoose(["\n  @media(min-width:601px){\n    display:flex;\n    margin-left:100px;\n    margin-top:25px;\n    font-family: 'NeueHaasGroteskDisplayStd';\n    padding-bottom:15px\n  }\n"])));
var OutageMessage = styled.div(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteralLoose(["\n  margin-left:10px;\n  font-family: Verizon-NHG-eDS;\n  @media(min-width:768px) and (max-width:1024px){\n    width:40%;\n  }\n"])));
var DetailButtonContainer = styled.div(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteralLoose(["\n  @media (min-width: 601px) and (max-width: 1366px) {\n    margin-left:8rem;\n  }\n  @media (min-width:1367px){\n    margin-left:200px;\n  }\n\n  @media(max-width:600px){\n    margin-left:10px;\n    margin-top: 10px\n  }\n"])));
var DetailButton = styled.button(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteralLoose(["\n  border-radius:100px;\n  background:transparent;\n  border: 1px solid black;\n  width:100px;\n  padding:3px; \n  font-weight:600;\n  margin-top:6px;\n  font-size:12px;\n  cursor: pointer;\n"])));
var CloseIcon = styled.div(_templateObject8$4 || (_templateObject8$4 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  font-size:15px;\n  @media (min-width:601px) and  (max-width: 1366px) {\n    margin-left:18rem;\n  }\n  @media (min-width:1367px){\n    margin-left:30rem;\n  }\n\n  @media(max-width:600px){\n    position: relative;\n    top: -160px;\n    left: 325px\n  }\n"])));
var Outage4g = function Outage4g(props) {
  var _configDetails$params, _configDetails$params2;
  var configDetails = useContext(ConfigContext);
  var _props$outageInfo = props.outageInfo,
    outageInfo = _props$outageInfo === void 0 ? {} : _props$outageInfo;
  var _outageInfo$data = outageInfo.data,
    data = _outageInfo$data === void 0 ? {} : _outageInfo$data;
  var _useState = useState(true),
    showNotification = _useState[0],
    setNotification = _useState[1];
  var handleNotification = function handleNotification() {
    return setNotification(false);
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, " ", showNotification ? /*#__PURE__*/React__default.createElement(OutageContainer, null, /*#__PURE__*/React__default.createElement(ContainerItems, {
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : (_configDetails$params2 = _configDetails$params.theme) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.isDark
  }, /*#__PURE__*/React__default.createElement(Items, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: '2px',
      marginLeft: '8px'
    }
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "warning",
    size: "medium",
    color: "#000000",
    font: "bold"
  })), /*#__PURE__*/React__default.createElement(OutageMessage, null, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("strong", null, data.detailedMessage)), /*#__PURE__*/React__default.createElement("p", null, "Last updated ", data.lastUpdated)), /*#__PURE__*/React__default.createElement(DetailButtonContainer, null, /*#__PURE__*/React__default.createElement("a", {
    href: "/support/1d/secure/networkdisruption/?outageDetail=4G",
    target: "_blank"
  }, /*#__PURE__*/React__default.createElement(DetailButton, null, "View details"))), /*#__PURE__*/React__default.createElement(CloseIcon, {
    onClick: handleNotification,
    "data-testid": "triggerClick"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "close",
    size: "small",
    color: "#000000",
    font: "bold"
  }))))) : /*#__PURE__*/React__default.createElement(Fragment, null));
};
Outage4g.propTypes = {
  outageInfo: PropTypes.object.isRequired
};
Outage4g.defaultProps = {
  outageInfo: {}
};

const ColorTokens = {
  "palette": {
    "black": {
      "value": "#000000"
    },
    "white": {
      "value": "#ffffff"
    },
    "red": {
      "value": "#ee0000"
    },
    "gray95": {
      "value": "#f6f6f6"
    },
    "gray85": {
      "value": "#d8dada"
    },
    "gray65": {
      "value": "#a7a7a7"
    },
    "gray44": {
      "value": "#6f7171"
    },
    "gray20": {
      "value": "#333333"
    },
    "gray11": {
      "value": "#1b1d1f"
    },
    "orange94": {
      "value": "#ffece0"
    },
    "orange83": {
      "value": "#ffcaaa"
    },
    "orange71": {
      "value": "#ffa46d"
    },
    "orange58": {
      "value": "#ff8027"
    },
    "orange41": {
      "value": "#b95319"
    },
    "orange24": {
      "value": "#732706"
    },
    "orange17": {
      "value": "#561701"
    },
    "yellow94": {
      "value": "#fff9de"
    },
    "yellow87": {
      "value": "#fff4bc"
    },
    "yellow74": {
      "value": "#ffe97a"
    },
    "yellow53": {
      "value": "#fed60e"
    },
    "yellow39": {
      "value": "#bc9f0a"
    },
    "yellow20": {
      "value": "#635305"
    },
    "yellow15": {
      "value": "#4b3f04"
    },
    "blue94": {
      "value": "#e3f2fd"
    },
    "blue82": {
      "value": "#aad8f9"
    },
    "blue62": {
      "value": "#4aabf2"
    },
    "blue46": {
      "value": "#0089ec"
    },
    "blue38": {
      "value": "#006fc1"
    },
    "blue21": {
      "value": "#003e6c"
    },
    "blue15": {
      "value": "#002c4d"
    },
    "green91": {
      "value": "#dcf5e6"
    },
    "green77": {
      "value": "#a4e6bd"
    },
    "green61": {
      "value": "#63d48e"
    },
    "green36": {
      "value": "#00b845"
    },
    "green26": {
      "value": "#008331"
    },
    "green15": {
      "value": "#004b1c"
    },
    "green10": {
      "value": "#003514"
    },
    "pink87": {
      "value": "#febfe8"
    },
    "pink76": {
      "value": "#fc89d5"
    },
    "pink62": {
      "value": "#fb42bc"
    },
    "pink46": {
      "value": "#b9318b"
    },
    "pink25": {
      "value": "#671b4e"
    },
    "purple85": {
      "value": "#edb9fb"
    },
    "purple75": {
      "value": "#e084f9"
    },
    "purple60": {
      "value": "#ce3df5"
    },
    "purple39": {
      "value": "#84279e"
    },
    "purple20": {
      "value": "#461553"
    }
  },
  "background": {
    "primary": {
      "light": {
        "value": "#ffffff"
      },
      "dark": {
        "value": "#000000"
      },
      "inverse": {
        "light": {
          "value": "#000000"
        },
        "dark": {
          "value": "#ffffff"
        }
      }
    },
    "secondary": {
      "light": {
        "value": "#f6f6f6"
      },
      "dark": {
        "value": "#1b1d1f"
      }
    },
    "brandhighlight": {
      "value": "#ee0000"
    }
  },
  "feedback": {
    "error": {
      "onlight": {
        "value": "#b95319"
      },
      "ondark": {
        "value": "#ff8027"
      },
      "background": {
        "onlight": {
          "value": "#ffece0"
        },
        "ondark": {
          "value": "#561701"
        }
      }
    },
    "warning": {
      "onlight": {
        "value": "#fed60e"
      },
      "ondark": {
        "value": "#fed60e"
      },
      "background": {
        "onlight": {
          "value": "#fff9de"
        },
        "ondark": {
          "value": "#4b3f04"
        }
      }
    },
    "information": {
      "onlight": {
        "value": "#006fc1"
      },
      "ondark": {
        "value": "#0089ec"
      },
      "background": {
        "onlight": {
          "value": "#e3f2fd"
        },
        "ondark": {
          "value": "#002c4d"
        }
      }
    },
    "success": {
      "onlight": {
        "value": "#008331"
      },
      "ondark": {
        "value": "#00b845"
      },
      "background": {
        "onlight": {
          "value": "#dcf5e6"
        },
        "ondark": {
          "value": "#003514"
        }
      }
    }
  },
  "interactive": {
    "active": {
      "onlight": {
        "value": "#6f7171"
      },
      "ondark": {
        "value": "#a7a7a7"
      }
    },
    "disabled": {
      "onlight": {
        "value": "#d8dada"
      },
      "ondark": {
        "value": "#333333"
      }
    },
    "scrollthumb": {
      "onlight": {
        "value": "#6f7171"
      },
      "ondark": {
        "value": "#a7a7a7"
      },
      "hover": {
        "onlight": {
          "value": "#333333"
        },
        "ondark": {
          "value": "#d8dada"
        }
      }
    },
    "scrolltrack": {
      "onlight": {
        "value": "#d8dada"
      },
      "ondark": {
        "value": "#333333"
      }
    }
  },
  "elements": {
    "primary": {
      "onlight": {
        "value": "#000000"
      },
      "ondark": {
        "value": "#ffffff"
      },
      "inverse": {
        "onlight": {
          "value": "#ffffff"
        },
        "ondark": {
          "value": "#000000"
        }
      }
    },
    "secondary": {
      "onlight": {
        "value": "#6f7171"
      },
      "ondark": {
        "value": "#a7a7a7"
      }
    },
    "brandhighlight": {
      "value": "#ee0000"
    },
    "lowcontrast": {
      "onlight": {
        "value": "#d8dada"
      },
      "ondark": {
        "value": "#333333"
      }
    }
  },
  "dataviz": {
    "orange200": {
      "value": "#ffcaaa"
    },
    "orange300": {
      "value": "#ffa46d"
    },
    "orange400": {
      "value": "#ff8027"
    },
    "orange600": {
      "value": "#b95319"
    },
    "orange900": {
      "value": "#732706"
    },
    "yellow200": {
      "value": "#fff4bc"
    },
    "yellow300": {
      "value": "#ffe97a"
    },
    "yellow400": {
      "value": "#fed60e"
    },
    "yellow600": {
      "value": "#bc9f0a"
    },
    "yellow900": {
      "value": "#635305"
    },
    "blue200": {
      "value": "#aad8f9"
    },
    "blue300": {
      "value": "#4aabf2"
    },
    "blue400": {
      "value": "#0089ec"
    },
    "blue600": {
      "value": "#006fc1"
    },
    "blue900": {
      "value": "#003e6c"
    },
    "green200": {
      "value": "#a4e6bd"
    },
    "green300": {
      "value": "#63d48e"
    },
    "green400": {
      "value": "#00b845"
    },
    "green600": {
      "value": "#008331"
    },
    "green900": {
      "value": "#004b1c"
    },
    "pink200": {
      "value": "#febfe8"
    },
    "pink300": {
      "value": "#fc89d5"
    },
    "pink400": {
      "value": "#fb42bc"
    },
    "pink600": {
      "value": "#b9318b"
    },
    "pink900": {
      "value": "#671b4e"
    },
    "purple200": {
      "value": "#edb9fb"
    },
    "purple300": {
      "value": "#e084f9"
    },
    "purple400": {
      "value": "#ce3df5"
    },
    "purple600": {
      "value": "#84279e"
    },
    "purple900": {
      "value": "#461553"
    }
  },
  "badges": {
    "background": {
      "red": {
        "onlight": {
          "value": "#ee0000"
        },
        "ondark": {
          "value": "#ee0000"
        }
      },
      "orange": {
        "onlight": {
          "value": "#b95319"
        },
        "ondark": {
          "value": "#ff8027"
        }
      },
      "green": {
        "onlight": {
          "value": "#008331"
        },
        "ondark": {
          "value": "#00b845"
        }
      },
      "blue": {
        "onlight": {
          "value": "#006fc1"
        },
        "ondark": {
          "value": "#0089ec"
        }
      },
      "yellow": {
        "onlight": {
          "value": "#fed60e"
        },
        "ondark": {
          "value": "#fed60e"
        }
      },
      "white": {
        "onlight": {
          "value": "#ffffff"
        },
        "ondark": {
          "value": "#ffffff"
        }
      },
      "black": {
        "onlight": {
          "value": "#000000"
        },
        "ondark": {
          "value": "#000000"
        }
      }
    }
  }
};

var divProps = [
	"accentColor",
	"additiveSymbols",
	"alignContent",
	"alignItems",
	"alignSelf",
	"alignmentBaseline",
	"all",
	"animation",
	"animationComposition",
	"animationDelay",
	"animationDirection",
	"animationDuration",
	"animationFillMode",
	"animationIterationCount",
	"animationName",
	"animationPlayState",
	"animationRange",
	"animationRangeEnd",
	"animationRangeStart",
	"animationTimeline",
	"animationTimingFunction",
	"appRegion",
	"appearance",
	"ascentOverride",
	"aspectRatio",
	"backdropFilter",
	"backfaceVisibility",
	"background",
	"backgroundAttachment",
	"backgroundBlendMode",
	"backgroundClip",
	"backgroundColor",
	"backgroundImage",
	"backgroundOrigin",
	"backgroundPosition",
	"backgroundPositionX",
	"backgroundPositionY",
	"backgroundRepeat",
	"backgroundRepeatX",
	"backgroundRepeatY",
	"backgroundSize",
	"basePalette",
	"baselineShift",
	"baselineSource",
	"blockSize",
	"border",
	"borderBlock",
	"borderBlockColor",
	"borderBlockEnd",
	"borderBlockEndColor",
	"borderBlockEndStyle",
	"borderBlockEndWidth",
	"borderBlockStart",
	"borderBlockStartColor",
	"borderBlockStartStyle",
	"borderBlockStartWidth",
	"borderBlockStyle",
	"borderBlockWidth",
	"borderBottom",
	"borderBottomColor",
	"borderBottomLeftRadius",
	"borderBottomRightRadius",
	"borderBottomStyle",
	"borderBottomWidth",
	"borderCollapse",
	"borderColor",
	"borderEndEndRadius",
	"borderEndStartRadius",
	"borderImage",
	"borderImageOutset",
	"borderImageRepeat",
	"borderImageSlice",
	"borderImageSource",
	"borderImageWidth",
	"borderInline",
	"borderInlineColor",
	"borderInlineEnd",
	"borderInlineEndColor",
	"borderInlineEndStyle",
	"borderInlineEndWidth",
	"borderInlineStart",
	"borderInlineStartColor",
	"borderInlineStartStyle",
	"borderInlineStartWidth",
	"borderInlineStyle",
	"borderInlineWidth",
	"borderLeft",
	"borderLeftColor",
	"borderLeftStyle",
	"borderLeftWidth",
	"borderRadius",
	"borderRight",
	"borderRightColor",
	"borderRightStyle",
	"borderRightWidth",
	"borderSpacing",
	"borderStartEndRadius",
	"borderStartStartRadius",
	"borderStyle",
	"borderTop",
	"borderTopColor",
	"borderTopLeftRadius",
	"borderTopRightRadius",
	"borderTopStyle",
	"borderTopWidth",
	"borderWidth",
	"bottom",
	"boxShadow",
	"boxSizing",
	"breakAfter",
	"breakBefore",
	"breakInside",
	"bufferedRendering",
	"captionSide",
	"caretColor",
	"clear",
	"clip",
	"clipPath",
	"clipRule",
	"color",
	"colorInterpolation",
	"colorInterpolationFilters",
	"colorRendering",
	"colorScheme",
	"columnCount",
	"columnFill",
	"columnGap",
	"columnRule",
	"columnRuleColor",
	"columnRuleStyle",
	"columnRuleWidth",
	"columnSpan",
	"columnWidth",
	"columns",
	"contain",
	"containIntrinsicBlockSize",
	"containIntrinsicHeight",
	"containIntrinsicInlineSize",
	"containIntrinsicSize",
	"containIntrinsicWidth",
	"container",
	"containerName",
	"containerType",
	"content",
	"contentVisibility",
	"counterIncrement",
	"counterReset",
	"counterSet",
	"cursor",
	"cx",
	"cy",
	"d",
	"descentOverride",
	"direction",
	"display",
	"dominantBaseline",
	"emptyCells",
	"fallback",
	"fill",
	"fillOpacity",
	"fillRule",
	"filter",
	"flex",
	"flexBasis",
	"flexDirection",
	"flexFlow",
	"flexGrow",
	"flexShrink",
	"flexWrap",
	"float",
	"floodColor",
	"floodOpacity",
	"font",
	"fontDisplay",
	"fontFamily",
	"fontFeatureSettings",
	"fontKerning",
	"fontOpticalSizing",
	"fontPalette",
	"fontSize",
	"fontStretch",
	"fontStyle",
	"fontSynthesis",
	"fontSynthesisSmallCaps",
	"fontSynthesisStyle",
	"fontSynthesisWeight",
	"fontVariant",
	"fontVariantAlternates",
	"fontVariantCaps",
	"fontVariantEastAsian",
	"fontVariantLigatures",
	"fontVariantNumeric",
	"fontVariantPosition",
	"fontVariationSettings",
	"fontWeight",
	"forcedColorAdjust",
	"gap",
	"grid",
	"gridArea",
	"gridAutoColumns",
	"gridAutoFlow",
	"gridAutoRows",
	"gridColumn",
	"gridColumnEnd",
	"gridColumnGap",
	"gridColumnStart",
	"gridGap",
	"gridRow",
	"gridRowEnd",
	"gridRowGap",
	"gridRowStart",
	"gridTemplate",
	"gridTemplateAreas",
	"gridTemplateColumns",
	"gridTemplateRows",
	"height",
	"hyphenateCharacter",
	"hyphenateLimitChars",
	"hyphens",
	"imageOrientation",
	"imageRendering",
	"inherits",
	"initialLetter",
	"initialValue",
	"inlineSize",
	"inset",
	"insetBlock",
	"insetBlockEnd",
	"insetBlockStart",
	"insetInline",
	"insetInlineEnd",
	"insetInlineStart",
	"isolation",
	"justifyContent",
	"justifyItems",
	"justifySelf",
	"left",
	"letterSpacing",
	"lightingColor",
	"lineBreak",
	"lineGapOverride",
	"lineHeight",
	"listStyle",
	"listStyleImage",
	"listStylePosition",
	"listStyleType",
	"margin",
	"marginBlock",
	"marginBlockEnd",
	"marginBlockStart",
	"marginBottom",
	"marginInline",
	"marginInlineEnd",
	"marginInlineStart",
	"marginLeft",
	"marginRight",
	"marginTop",
	"marker",
	"markerEnd",
	"markerMid",
	"markerStart",
	"mask",
	"maskType",
	"mathDepth",
	"mathShift",
	"mathStyle",
	"maxBlockSize",
	"maxHeight",
	"maxInlineSize",
	"maxWidth",
	"minBlockSize",
	"minHeight",
	"minInlineSize",
	"minWidth",
	"mixBlendMode",
	"negative",
	"objectFit",
	"objectPosition",
	"objectViewBox",
	"offset",
	"offsetAnchor",
	"offsetDistance",
	"offsetPath",
	"offsetPosition",
	"offsetRotate",
	"opacity",
	"order",
	"orphans",
	"outline",
	"outlineColor",
	"outlineOffset",
	"outlineStyle",
	"outlineWidth",
	"overflow",
	"overflowAnchor",
	"overflowClipMargin",
	"overflowWrap",
	"overflowX",
	"overflowY",
	"overlay",
	"overrideColors",
	"overscrollBehavior",
	"overscrollBehaviorBlock",
	"overscrollBehaviorInline",
	"overscrollBehaviorX",
	"overscrollBehaviorY",
	"pad",
	"padding",
	"paddingBlock",
	"paddingBlockEnd",
	"paddingBlockStart",
	"paddingBottom",
	"paddingInline",
	"paddingInlineEnd",
	"paddingInlineStart",
	"paddingLeft",
	"paddingRight",
	"paddingTop",
	"page",
	"pageBreakAfter",
	"pageBreakBefore",
	"pageBreakInside",
	"pageOrientation",
	"paintOrder",
	"perspective",
	"perspectiveOrigin",
	"placeContent",
	"placeItems",
	"placeSelf",
	"pointerEvents",
	"position",
	"prefix",
	"quotes",
	"r",
	"range",
	"resize",
	"right",
	"rotate",
	"rowGap",
	"rubyPosition",
	"rx",
	"ry",
	"scale",
	"scrollBehavior",
	"scrollMargin",
	"scrollMarginBlock",
	"scrollMarginBlockEnd",
	"scrollMarginBlockStart",
	"scrollMarginBottom",
	"scrollMarginInline",
	"scrollMarginInlineEnd",
	"scrollMarginInlineStart",
	"scrollMarginLeft",
	"scrollMarginRight",
	"scrollMarginTop",
	"scrollPadding",
	"scrollPaddingBlock",
	"scrollPaddingBlockEnd",
	"scrollPaddingBlockStart",
	"scrollPaddingBottom",
	"scrollPaddingInline",
	"scrollPaddingInlineEnd",
	"scrollPaddingInlineStart",
	"scrollPaddingLeft",
	"scrollPaddingRight",
	"scrollPaddingTop",
	"scrollSnapAlign",
	"scrollSnapStop",
	"scrollSnapType",
	"scrollTimeline",
	"scrollTimelineAxis",
	"scrollTimelineName",
	"scrollbarGutter",
	"shapeImageThreshold",
	"shapeMargin",
	"shapeOutside",
	"shapeRendering",
	"size",
	"sizeAdjust",
	"speak",
	"speakAs",
	"src",
	"stopColor",
	"stopOpacity",
	"stroke",
	"strokeDasharray",
	"strokeDashoffset",
	"strokeLinecap",
	"strokeLinejoin",
	"strokeMiterlimit",
	"strokeOpacity",
	"strokeWidth",
	"suffix",
	"symbols",
	"syntax",
	"system",
	"tabSize",
	"tableLayout",
	"textAlign",
	"textAlignLast",
	"textAnchor",
	"textCombineUpright",
	"textDecoration",
	"textDecorationColor",
	"textDecorationLine",
	"textDecorationSkipInk",
	"textDecorationStyle",
	"textDecorationThickness",
	"textEmphasis",
	"textEmphasisColor",
	"textEmphasisPosition",
	"textEmphasisStyle",
	"textIndent",
	"textOrientation",
	"textOverflow",
	"textRendering",
	"textShadow",
	"textSizeAdjust",
	"textTransform",
	"textUnderlineOffset",
	"textUnderlinePosition",
	"textWrap",
	"timelineScope",
	"top",
	"touchAction",
	"transform",
	"transformBox",
	"transformOrigin",
	"transformStyle",
	"transition",
	"transitionBehavior",
	"transitionDelay",
	"transitionDuration",
	"transitionProperty",
	"transitionTimingFunction",
	"translate",
	"unicodeBidi",
	"unicodeRange",
	"userSelect",
	"vectorEffect",
	"verticalAlign",
	"viewTimeline",
	"viewTimelineAxis",
	"viewTimelineInset",
	"viewTimelineName",
	"viewTransitionName",
	"visibility",
	"whiteSpace",
	"whiteSpaceCollapse",
	"widows",
	"width",
	"willChange",
	"wordBreak",
	"wordSpacing",
	"wordWrap",
	"writingMode",
	"x",
	"y",
	"zIndex",
	"zoom"
];

var _templateObject$a, _templateObject2$7, _templateObject3$7, _templateObject4$7, _templateObject5$6, _templateObject6$6, _templateObject7$5, _templateObject8$5;
var breakpoint = {
  sm: '480px',
  md: '1024px'
};
var responsiveObject = function responsiveObject(props) {
  var mobile = {};
  var tablet = {};
  var desktop = {};
  for (var _i = 0, _Object$entries = Object.entries(props); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (divProps.includes(key)) {
      if (Array.isArray(value) && value.length === 3) {
        var m = value[0],
          t = value[1],
          d = value[2];
        mobile[key] = m;
        tablet[key] = t;
        desktop[key] = d;
      } else if (Array.isArray(value) && value.length === 2) {
        var _m = value[0],
          _d = value[1];
        mobile[key] = _m;
        tablet[key] = _d;
        desktop[key] = _d;
      } else {
        mobile[key] = value;
        tablet[key] = value;
        desktop[key] = value;
      }
    }
  }
  return {
    mobile: mobile,
    tablet: tablet,
    desktop: desktop
  };
};
var buildStyles = function buildStyles(props) {
  var _extends2;
  var _responsiveObject = responsiveObject(props),
    mobile = _responsiveObject.mobile,
    tablet = _responsiveObject.tablet,
    desktop = _responsiveObject.desktop;
  return _extends({}, desktop, (_extends2 = {}, _extends2["@media (min-width: " + breakpoint.sm + ") and (max-width: " + breakpoint.md + ")"] = tablet, _extends2["@media (max-width: " + breakpoint.sm + ")"] = mobile, _extends2));
};
var Box = styled.div(_templateObject$a || (_templateObject$a = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (props) {
  return buildStyles(props);
});
var Image = styled.img(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (props) {
  return buildStyles(props);
});
var Stack = styled(Box)(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteralLoose(["\n  display: ", ";\n  flex-direction: ", ";\n"])), function (props) {
  return (props === null || props === void 0 ? void 0 : props.display) || 'flex';
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.flexDirection) || 'column';
});
var HStack = styled(Box)(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteralLoose(["\n  display: ", ";\n  flex-direction: ", ";\n  #dark-background {\n    background-color: ", ";\n    p {\n      background-color: ", ";\n    }\n  }\n"])), function (props) {
  return (props === null || props === void 0 ? void 0 : props.display) || 'flex';
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.flexDirection) || 'row';
}, function (props) {
  return props === null || props === void 0 ? void 0 : props.backgroundColor;
}, function (props) {
  return props === null || props === void 0 ? void 0 : props.backgroundColor;
});
var VStack = styled(Box)(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteralLoose(["\n  display: ", ";\n  flex-direction: ", ";\n  align-items: ", ";\n"])), function (props) {
  return (props === null || props === void 0 ? void 0 : props.display) || 'flex';
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.flexDirection) || 'column';
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.alignItems) || 'center';
});
var Grid = styled(Box)(_templateObject6$6 || (_templateObject6$6 = _taggedTemplateLiteralLoose(["\n  display: ", ";\n"])), function (props) {
  return (props === null || props === void 0 ? void 0 : props.display) || 'grid';
});
var Center = styled(Box)(_templateObject7$5 || (_templateObject7$5 = _taggedTemplateLiteralLoose(["\n  display: ", ";\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n"])), function (props) {
  return (props === null || props === void 0 ? void 0 : props.display) || 'flex';
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.flexDirection) || 'column';
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.alignItems) || 'center';
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.justifyContent) || 'center';
});
var Form = styled(Stack).attrs({
  as: 'form'
})(_templateObject8$5 || (_templateObject8$5 = _taggedTemplateLiteralLoose([""])));

var getMatch = function getMatch(screen) {
  var _window$matchMedia, _window$matchMedia2, _window$matchMedia3;
  if (screen === "mobile") return (_window$matchMedia = window.matchMedia("(max-width: " + breakpoint.sm + ")")) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.matches;else if (screen === "tablet") return (_window$matchMedia2 = window.matchMedia("(min-width: " + breakpoint.sm + ") and (max-width: " + breakpoint.md + ")")) === null || _window$matchMedia2 === void 0 ? void 0 : _window$matchMedia2.matches;else if (screen === "desktop") return (_window$matchMedia3 = window.matchMedia("(min-width: " + breakpoint.md + ")")) === null || _window$matchMedia3 === void 0 ? void 0 : _window$matchMedia3.matches;
  return false;
};
var useMediaQuery = function useMediaQuery() {
  var _useState = useState(function () {
      return getMatch("mobile");
    }),
    isMobile = _useState[0],
    setIsMobile = _useState[1];
  var _useState2 = useState(function () {
      return getMatch("tablet");
    }),
    isTablet = _useState2[0],
    setIsTablet = _useState2[1];
  var _useState3 = useState(function () {
      return getMatch("desktop");
    }),
    isDesktop = _useState3[0],
    setIsDesktop = _useState3[1];
  useEffect(function () {
    var updateMedia = function updateMedia() {
      setIsMobile(getMatch("mobile"));
      setIsTablet(getMatch("tablet"));
      setIsDesktop(getMatch("desktop"));
    };
    updateMedia();
    window.addEventListener("resize", updateMedia);
    return function () {
      window.removeEventListener("resize", updateMedia);
    };
  }, []);
  return {
    isMobile: isMobile,
    isTablet: isTablet,
    isDesktop: isDesktop
  };
};

var _templateObject$b, _templateObject2$8, _templateObject3$8, _templateObject4$8, _templateObject5$7, _templateObject6$7, _templateObject7$6, _templateObject8$6, _templateObject9$4, _templateObject0$4, _templateObject1$4, _templateObject10$4;
var palette = ColorTokens.palette;
var mvoCaseDetails$2 = sessionUtility.getCaseDetails();
var SearchWrapper = styled.div(_templateObject$b || (_templateObject$b = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  display: ", ";\n  position: relative;\n  label {\n    margin-left: 5px;\n    font-size: 18px;\n    margin-bottom: 5px;\n    display: block;\n  }\n  @media (max-width: 601px) {\n    width: ", ";\n    margin-bottom: \"24px\";\n  }\n\n  @media (min-width:601px) and (max-width: 1024px) {\n    margin-top:\"8px\";\n  }\n"])), function (props) {
  return props !== null && props !== void 0 && props.isActiveFocus ? '92%' : 'inherit';
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.isActiveFocus) && 'inline-block';
}, function (props) {
  return props !== null && props !== void 0 && props.isActiveFocus ? '90%' : 'inherit';
});
var SearchBox = styled.input(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteralLoose(["\n  border: 1px solid gray;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  font-size: 1rem;\n  line-height: \"20px\";\n  letter-spacing:\"0.5px\";\n  width: 48.6rem;\n  padding: ", ";\n  transition: width 0.3s;\n  //background-color: #e0e3e7;\n  background-color: #ffffff;\n  box-sizing: content-box;\n  font-weight: 400;\n  ::placeholder {\n    font-weight:  400;\n    color: ", ";\n    margin-left: 20px;\n    font-size:16px;\n  }\n  :focus {\n    border: 2px solid black;\n    outline: none;\n  }\n\n  @media (min-width:601px) and (max-width: 1024px) {\n    width: ", ";\n  }\n  @media (max-width: 600px) {\n   width: ", ";\n  }\n"])), function (props) {
  return props !== null && props !== void 0 && props.isActiveFocus ? '0.7rem 0.9rem' : '1rem';
}, function (props) {
  return props.intentCatagoriesFlag ? "#6F7171" : "#000000";
}, function (props) {
  return props !== null && props !== void 0 && props.isActiveFocus ? '81vw' : '96%';
}, function (props) {
  return props !== null && props !== void 0 && props.isActiveFocus ? "78vw" : '92%';
});
var ButtonsWrapper$4 = styled.div(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  width: -6em;\n  margin-top: -1rem;\n  position: absolute;\n  top: 60%;\n  cursor: pointer;\n  right:27rem;\n  background-color: transparent;\n  border: 0;\n  background-repeat: no-repeat;\n  background-size: 100%;\n\n  @media (max-width: 1024px) {\n    right: ", ";\n  }\n  @media (max-width: 600px) {\n    right: ", ";\n  }\n"])), function (props) {
  return props !== null && props !== void 0 && props.isActiveFocus ? '-1rem' : "1.5rem";
}, function (props) {
  return props !== null && props !== void 0 && props.isActiveFocus ? '0.7rem' : '0.5rem';
});
var Button = styled.button(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteralLoose(["\n  background-color: #ffffff;\n  color: inherit;\n  border: none;\n  display:block;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n  :focus {\n    border: 1px dotted black;\n    outline: none;\n  }\n  @media (max-width: 1024px) {\n    cursor: none;\n  }\n"])));
var OptionsWrapper = styled.div(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  z-index: ", ";\n  @media (max-width: 1024px) {\n     width:'98%'\n  }\n"])), function (props) {
  return props.combinedIssueSelector ? 1 : 999;
});
var OptionsList = styled.ul(_templateObject6$7 || (_templateObject6$7 = _taggedTemplateLiteralLoose(["\n  font-size: 1rem;\n  display: block;\n  list-style: none;\n  min-width: 440px;\n  width:47.7rem;\n  transition: width 0.3s;\n  position: relative;\n  margin: 0px;\n  -webkit-box-shadow: 0px 6px 12px #ccc; /* Safari 3-4, iOS 4.0.2 - 4.2, Android 2.3+ */\n  -moz-box-shadow: 0px 6px 12px #ccc; /* Firefox 3.5 - 3.6 */\n  box-shadow: 0px 6px 12px #ccc; /* Opera 10.5, IE 9, Firefox 4+, Chrome 6+, iOS 5 */\n  border-bottom: 2px solid black;\n  background: white;\n  padding-left: 15px;\n  padding-right: 15px;\n  border-right: 1px solid #ccc;\n  max-height: 200px;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  padding-block: 12px;\n   @media (max-width: 1024px) {\nwidth: ", ";\n}\n  @media (max-width: 601px) {\n    font-size: 1rem;\n    max-height: 250px;\n    padding: ", ";\n    min-width: 215px;\n    width: ", ";\n    left: ", ";\n  }\n"])), function (props) {
  return props !== null && props !== void 0 && props.isActiveFocus ? '81vw' : '90vw';
}, function (props) {
  return props !== null && props !== void 0 && props.isActiveFocus ? '0px 10px' : '0px 25px';
}, function (props) {
  return props !== null && props !== void 0 && props.isActiveFocus ? '95%' : '76vw';
}, function (props) {
  return props !== null && props !== void 0 && props.isActiveFocus ? '0px' : '20px';
});
var Option = styled.li(_templateObject7$6 || (_templateObject7$6 = _taggedTemplateLiteralLoose(["\n  display: block;\n  padding: ", ";\n  font-family: 'Verizon-NHG-eDS';\n  cursor: pointer;\n  background-color: ", ";\n  outline: none;\n"])), function (props) {
  return props !== null && props !== void 0 && props.isActiveFocus ? '10px 5px' : '10px';
}, function (props) {
  return props !== null && props !== void 0 && props.selected ? palette.gray85.value : 'unset';
});
var SearchOverlay = styled.div(_templateObject8$6 || (_templateObject8$6 = _taggedTemplateLiteralLoose(["\n", "  \n"])), function (props) {
  return props !== null && props !== void 0 && props.isActiveFocus ? "\n  z-index: 1000;\n  inset: 0px;\n  position: fixed;\n  padding: 25px 15px 0px 15px;\n  background-color: #fff;\n" : "";
});
var BackSearchButton = styled.div(_templateObject9$4 || (_templateObject9$4 = _taggedTemplateLiteralLoose(["\ndisplay: inline-block;\nwidth: 7%;\nvertical-align: middle;\n"])));
var HiddenText = styled.p(_templateObject0$4 || (_templateObject0$4 = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var PopularOptionsList = styled.ul(_templateObject1$4 || (_templateObject1$4 = _taggedTemplateLiteralLoose(["\n  border: 1px solid #000000;\n  margin-top:4px;\n  padding:24px 24px 24px 19px;\n  border-radius:4px;\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  max-height: 280px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  @media(min-width: 1024px) {\n  width:47.8rem;\n  box-sizing: content-box;\n}\n  background: white;\n  gap:8px;\n   @media (min-width:601px) and (max-width: 1024px) {\n   width:45.3rem;\n}\n  @media (max-width: 601px) {\n    font-size: 1rem;\n    max-height: 250px;\n    min-width: 360px;\n    border:none;\n    padding:0px;\n  }\n"])));
var PopularOption = styled.li(_templateObject10$4 || (_templateObject10$4 = _taggedTemplateLiteralLoose(["\n  font-family: 'Verizon-NHG-eDS';\n  cursor: pointer;\n  font-size:16px;\n  padding:6px 0px 6px 5px;\n  letter-spacing:0.5px;\n  line-height:20px;\n  display:flex;\n  align-items:center;\n  background-color: #ffffff;\n  font-weight:normal;\n\n  &:hover {\n  font-weight: \"bold\";\n  background-color: 'unset' ;\n}\n\n  @media (max-width: 600px) {\n    line-height:18px;\n    font-size:14px;\n    width:328px;\n  }\n\n"])));
var SearchBar$3 = function SearchBar(props) {
  var _props$Catagories;
  console.log('comren SearchBar', props);
  var _props$functions = props.functions,
    functions = _props$functions === void 0 ? {} : _props$functions,
    _props$values = props.values,
    values = _props$values === void 0 ? {} : _props$values,
    _props$topSearchData = props.topSearchData,
    topSearchData = _props$topSearchData === void 0 ? [] : _props$topSearchData;
  var _useState = useState({
      userInput: ''
    }),
    typeAhead = _useState[0],
    setTypeAhead = _useState[1];
  var _values$landingInfo = values.landingInfo,
    landingInfo = _values$landingInfo === void 0 ? {} : _values$landingInfo,
    _values$searchResults = values.searchResults,
    searchResults = _values$searchResults === void 0 ? {} : _values$searchResults,
    showTypeAhead = values.showTypeAhead;
  var userInput = typeAhead.userInput;
  var _landingInfo$device = landingInfo.device,
    device = _landingInfo$device === void 0 ? {} : _landingInfo$device;
  var _device$equipmentId = device.equipmentId,
    equipmentId = _device$equipmentId === void 0 ? '' : _device$equipmentId;
  var _device$bauSearchUrl = device.bauSearchUrl,
    bauSearchUrl = _device$bauSearchUrl === void 0 ? '' : _device$bauSearchUrl;
  var _searchResults$subSym = searchResults.subSymptoms,
    subSymptoms = _searchResults$subSym === void 0 ? [] : _searchResults$subSym;
  var _useState2 = useState(false),
    searchFocus = _useState2[0],
    setsearchFocus = _useState2[1];
  var searchRef = useRef(null);
  var _useState3 = useState(-1),
    activeIndex = _useState3[0],
    setActiveIndex = _useState3[1];
  var liRefs = useRef([]);
  var _useState4 = useState(false),
    suggestions = _useState4[0],
    setSuggestions = _useState4[1];
  var wrapperRef = useRef(null);
  var intentCatagoriesFlag = !window.isLoggedOut && window.popularCategoriesFFlag || window.isLoggedOut && window.popularCategoriesUnauthFFlag;
  var categoryLengthCheck = !window.fwaDevice && (props === null || props === void 0 ? void 0 : (_props$Catagories = props.Catagories) === null || _props$Catagories === void 0 ? void 0 : _props$Catagories.length) > 2;
  useEffect(function () {
    var _liRefs$current, _liRefs$current2;
    liRefs.current = topSearchData !== null && topSearchData !== void 0 && topSearchData.length ? (_liRefs$current = liRefs.current) === null || _liRefs$current === void 0 ? void 0 : _liRefs$current.slice(0, topSearchData === null || topSearchData === void 0 ? void 0 : topSearchData.length) : (_liRefs$current2 = liRefs.current) === null || _liRefs$current2 === void 0 ? void 0 : _liRefs$current2.slice(0, subSymptoms.length);
  }, [subSymptoms, topSearchData]);
  document.onclick = function (e) {
    if (!(e.target.id === 'typeAheadBox' || e.target.parentNode.id === 'typeAheadBox' || e.target.id === 'searchbox') && showTypeAhead) {
      if (functions.updateValues) {
        functions.updateValues(values, {
          showTypeAhead: false
        });
      }
      setSuggestions(false);
    }
  };
  var handleClickOutside = function handleClickOutside(event) {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setSuggestions(false);
    }
  };
  useEffect(function () {
    document.addEventListener("click", handleClickOutside);
    return function () {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  var handleSearchText = function handleSearchText(event) {
    var userInput = event.target.value;
    if ((userInput === null || userInput === void 0 ? void 0 : userInput.length) > 2) {
      var params = {
        query: '',
        equipId: '',
        tsaBauUrl: ''
      };
      params.query = userInput;
      params.equipId = equipmentId;
      params.tsaBauUrl = bauSearchUrl;
      if (functions.handleSearch) {
        functions.handleSearch(params, true);
      }
    } else {
      functions.updateValues(values, {
        showTypeAhead: false
      });
    }
    setTypeAhead(_extends({}, typeAhead, {
      userInput: userInput
    }));
  };
  var handleTypeAhead = function handleTypeAhead(event) {
    if (event.keyCode === 13) {
      handleSearchClick();
    }
    handleKeyDown(event);
  };
  var handleTypeAheadClick = function handleTypeAheadClick(event, option) {
    handleBackSearchButton();
    if (props.combinedIssueSelector) {
      props.handleTypeAheadSelect(event, option);
    } else if (option.redirect) {
      functions.processSymptomRedirection(option);
    }
  };
  var handleSearchClick = function handleSearchClick(event) {
    if (userInput.length) {
      var params = {
        query: '',
        equipId: '',
        tsaBauUrl: ''
      };
      params.query = userInput;
      params.equipId = equipmentId;
      params.tsaBauUrl = bauSearchUrl;
      if (functions.handleSearch) {
        functions.handleSearch(params, true, true);
      }
      if (searchRef.current && !subSymptoms.length) {
        var _searchRef$current;
        (_searchRef$current = searchRef.current) === null || _searchRef$current === void 0 ? void 0 : _searchRef$current.select();
      }
    }
  };
  var handleKeyDown = function handleKeyDown(event, option, isListItem, ispopularSearch) {
    if (isListItem === void 0) {
      isListItem = false;
    }
    if (ispopularSearch === void 0) {
      ispopularSearch = false;
    }
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      setActiveIndex(function (prevIndex) {
        var nextIndex = topSearchData !== null && topSearchData !== void 0 && topSearchData.length ? Math.min(prevIndex + 1, topSearchData === null || topSearchData === void 0 ? void 0 : topSearchData.length) : Math.min(prevIndex + 1, subSymptoms.length - 1);
        if (liRefs.current[nextIndex]) {
          liRefs.current[nextIndex].focus();
        }
        return nextIndex;
      });
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      setActiveIndex(function (prevIndex) {
        if (prevIndex === 0) {
          searchRef.current.focus();
          return -1;
        }
        if (prevIndex === -1) {
          return -1;
        }
        var pIndex = Math.max(prevIndex - 1, 0);
        if (liRefs.current[pIndex]) {
          liRefs.current[pIndex].focus();
        }
        return pIndex;
      });
    } else if (event.key === 'Enter' || isListItem && event.code === 'Space') {
      event.preventDefault();
      if (!ispopularSearch && activeIndex >= 0) {
        handleTypeAheadClick(event, option);
      } else {
        handleSuggestionClick(option === null || option === void 0 ? void 0 : option.searchKeyword);
      }
    } else if (event.key === 'Escape') {
      functions.updateValues(values, {
        showTypeAhead: false
      });
    } else if (event.key === 'Tab') {
      functions.updateValues(values, {
        showTypeAhead: false
      });
    }
  };
  var renderOptions = function renderOptions() {
    if (suggestions && !userInput && topSearchData !== null && topSearchData !== void 0 && topSearchData.length) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(PopularOptionsList, {
        className: "options",
        isActiveFocus: searchFocus
      }, /*#__PURE__*/React__default.createElement(Stack, {
        marginBottom: ["8px", "8px", "4px"],
        width: ["328px", "395px"]
      }, /*#__PURE__*/React__default.createElement(Title, {
        bold: true,
        size: "small"
      }, "Popular Searches")), topSearchData === null || topSearchData === void 0 ? void 0 : topSearchData.map(function (option, index) {
        if (index < 5) {
          return /*#__PURE__*/React__default.createElement(PopularOption, {
            ref: function ref(el) {
              liRefs.current[index] = el;
            },
            size: "bodyLarge",
            isActiveFocus: searchFocus,
            tabIndex: "0",
            onKeyDown: function onKeyDown(event) {
              return handleKeyDown(event, option, true, true);
            },
            onClick: function onClick() {
              return handleSuggestionClick(option.searchKeyword);
            },
            "data-testid": "options",
            role: "listitem",
            "data-analyticstrack": "search-" + option.searchKeyword,
            "data-track": "{\"type\": \"link\", \"name\": \"" + ("search-" + option.searchKeyword) + "\"}",
            "data-clickstream": "search-" + option.searchKeyword
          }, option.searchKeyword);
        }
      })));
    }
    if (userInput && showTypeAhead) {
      if (subSymptoms.length) {
        return /*#__PURE__*/React__default.createElement(PopularOptionsList, {
          className: "options",
          id: "typeAheadBox",
          isActiveFocus: searchFocus
        }, subSymptoms.map(function (option, index) {
          if (index < 8) {
            return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(PopularOption, {
              size: "bodyLarge",
              ref: function ref(el) {
                return liRefs.current[index] = el;
              },
              selected: index === activeIndex,
              onFocus: function onFocus() {
                return setActiveIndex(index);
              },
              tabIndex: "0",
              key: option.title || option.name,
              onClick: function onClick(event) {
                return handleTypeAheadClick(event, option);
              },
              "data-analyticstrack": "search-" + option.name,
              "data-track": "{\"type\": \"link\", \"name\": \"" + ("search-" + option.name) + "\"}",
              "data-clickstream": "search-" + option.name,
              isActiveFocus: searchFocus,
              "data-testid": "optionsSection",
              onKeyDown: function onKeyDown(event) {
                return handleKeyDown(event, option, true, false);
              },
              role: "listitem"
            }, /*#__PURE__*/React__default.createElement("span", {
              dangerouslySetInnerHTML: {
                __html: option.title
              }
            }), /*#__PURE__*/React__default.createElement(HiddenText, null, option.name)));
          }
        }));
      }
      return /*#__PURE__*/React__default.createElement(PopularOptionsList, {
        className: "options",
        id: "typeAheadBox",
        isActiveFocus: searchFocus
      }, /*#__PURE__*/React__default.createElement(PopularOption, {
        isActiveFocus: searchFocus
      }, "No Matches to Your Search, Try Different Words."));
    }
  };
  var clearSearch = function clearSearch() {
    setSuggestions(true);
    functions.updateValues(values, {
      showTypeAhead: false
    });
    setTypeAhead({
      userInput: ''
    });
    setTimeout(function () {
      var _searchRef$current2;
      (_searchRef$current2 = searchRef.current) === null || _searchRef$current2 === void 0 ? void 0 : _searchRef$current2.focus();
    }, 100);
    renderOptions();
  };
  var clearOverlay = function clearOverlay() {
    functions.updateValues(values, {
      showTypeAhead: false
    });
    setTypeAhead({
      userInput: ''
    });
    searchRef.current.focus();
  };
  var handleFocusSearch = function handleFocusSearch() {
    setSuggestions(true);
    if (!searchFocus) {
      setsearchFocus(true);
    }
  };
  var handleBackSearchButton = function handleBackSearchButton() {
    if (searchFocus) {
      setsearchFocus(!searchFocus);
      clearOverlay();
    }
  };
  var handleSuggestionClick = function handleSuggestionClick(option) {
    var event = {
      target: {
        value: option
      }
    };
    handleSearchText(event);
    setTimeout(function () {
      var _searchRef$current3;
      (_searchRef$current3 = searchRef.current) === null || _searchRef$current3 === void 0 ? void 0 : _searchRef$current3.focus();
    }, 100);
    setSuggestions(false);
  };
  var onSearchFocus = function onSearchFocus() {
    setSuggestions(true);
    setActiveIndex(-1);
    var params = {
      query: '',
      equipId: '',
      tsaBauUrl: ''
    };
    params.query = userInput;
    params.equipId = equipmentId;
    params.tsaBauUrl = bauSearchUrl;
    functions.handleSearch(params, true, true);
  };
  var renderSearchBox = function renderSearchBox() {
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(SearchWrapper, {
      isActiveFocus: searchFocus,
      ref: wrapperRef
    }, /*#__PURE__*/React__default.createElement(SearchBox, {
      intentCatagoriesFlag: intentCatagoriesFlag && categoryLengthCheck,
      autoComplete: "off",
      ref: searchRef,
      maxLength: "37",
      type: "text",
      "aria-label": intentCatagoriesFlag && categoryLengthCheck ? "" : "Tell us what’s going on",
      placeholder: props.placeholder || 'Search Troubleshooting',
      onKeyDown: handleTypeAhead,
      onChange: handleSearchText,
      onFocus: isMobile() && window.isMVODigital && props !== null && props !== void 0 && props.mvaSearchBox ? handleFocusSearch : onSearchFocus,
      value: userInput,
      id: "searchbox",
      isActiveFocus: searchFocus,
      autoFocus: searchFocus ? 'autofocus' : ''
    }), /*#__PURE__*/React__default.createElement(ButtonsWrapper$4, {
      isActiveFocus: searchFocus
    }, /*#__PURE__*/React__default.createElement(Button, {
      tabIndex: !!userInput ? '0' : '-1',
      "aria-hidden": !!userInput ? 'false' : 'true',
      onClick: !!userInput ? clearSearch : handleSearchClick,
      "data-analyticstrack": !!userInput ? 'clear-search-text-cta' : 'Search-Button',
      "data-clickstream": "Search-Button",
      "data-testid": "searchButton",
      "aria-label": !!userInput ? 'Clear' : 'Search'
    }, !!userInput && /*#__PURE__*/React__default.createElement(Icon$1, {
      tabIndex: "0",
      name: "close-alt",
      size: "large",
      ariaLabel: "Clear",
      role: "img"
    }), !userInput && /*#__PURE__*/React__default.createElement(Icon$1, {
      "aria-hidden": "true",
      tabIndex: "-1",
      name: "search",
      size: "large",
      ariaLabel: "Search",
      role: "img"
    })))), /*#__PURE__*/React__default.createElement(OptionsWrapper, {
      combinedIssueSelector: props.combinedIssueSelector
    }, renderOptions()));
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, !searchFocus ? /*#__PURE__*/React__default.createElement(Fragment, null, " ", renderSearchBox()) : /*#__PURE__*/React__default.createElement(SearchOverlay, {
    isActiveFocus: searchFocus
  }, searchFocus && /*#__PURE__*/React__default.createElement(BackSearchButton, {
    "data-testid": "backButton",
    "data-analyticstrack": "overlay-back-search-cta",
    onClick: function onClick() {
      return handleBackSearchButton();
    }
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "left-arrow",
    size: "large",
    color: "#000000"
  })), renderSearchBox()));
};
SearchBar$3.propTypes = {
  functions: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
};
SearchBar$3.defaultProps = {};

var ModalContext = React__default.createContext();
var UserProvider = ModalContext.Provider;
var UserConsumer = ModalContext.Consumer;

var BannerEmailDownload = function BannerEmailDownload(props) {
  var _configDetails$params, _configDetails$params2;
  var bannerFeedbackRef = useRef(null);
  useEffect(function () {
    if (bannerFeedbackRef.current !== null) {
      bannerFeedbackRef.current.focus();
    }
  }, []);
  var configDetails = useContext(ConfigContext);
  var isDark = configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : (_configDetails$params2 = _configDetails$params.theme) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.isDark;
  useEffect(function () {
    var _window, _window$vzdl;
    console.log("window.vzdl=======", window.vzdl, props);
    if ((_window = window) !== null && _window !== void 0 && (_window$vzdl = _window.vzdl) !== null && _window$vzdl !== void 0 && _window$vzdl.target && props.templateId && (props.templateId === 'SEND_EMAIL_SUCCESS' || props.templateId === 'SEND_EMAIL_FAILURE' || props.templateId === 'SEND_SMS_SUCCESS' || props.templateId === 'SEND_SMS_FAILURE')) {
      var _window2, _window2$vztag, _window2$vztag$api;
      window.vzdl.target.message = props.templateId;
      (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$vztag = _window2.vztag) === null || _window2$vztag === void 0 ? void 0 : (_window2$vztag$api = _window2$vztag.api) === null || _window2$vztag$api === void 0 ? void 0 : _window2$vztag$api.dispatch("notification");
      sendCustomEvent('notification', window.vzdl);
      setTimeout(function () {
        window.vzdl.target.message = '';
        console.log("window.vzdl.target.message=======", window.vzdl, props);
      }, 1000);
    }
  }, [props.templateId, props.bannerName]);
  return /*#__PURE__*/React__default.createElement(UserConsumer, null, function (value) {
    var item = {
      title: "",
      description: ""
    };
    if (value.additionalInfoSteps) {
      value.additionalInfoSteps.map(function (value) {
        if (value.templateId === props.templateId) {
          item = value;
        }
      });
    }
    var description;
    if ((props === null || props === void 0 ? void 0 : props.templateId) == "SEND_EMAIL_SUCCESS" || (props === null || props === void 0 ? void 0 : props.templateId) == "SEND_EMAIL_FAILURE") {
      description = item.description.replace("##MAILID##", props === null || props === void 0 ? void 0 : props.custEmailId);
    } else {
      description = item.description.replace("##SMSID##", props === null || props === void 0 ? void 0 : props.selectedMdn);
    }
    if (item.title == "SEND_SMS_SUCCESS") {
      item.title = "SMS sent";
    } else if (item.title == "SEND_SMS_FAIL") {
      item.title = "SMS not sent";
    }
    console.log("description", description, props === null || props === void 0 ? void 0 : props.custEmailId);
    var success = props.templateId === "SEND_EMAIL_SUCCESS" || props.templateId === "SEND_SMS_SUCCESS" || props.templateId === "COPY_CLIPBOARD_MODAL" ? true : false;
    return /*#__PURE__*/React__default.createElement(Notification, {
      id: success ? isDark && 'bannerSuccessThemeDark' : isDark && 'bannerErrorThemeDark',
      type: success ? 'success' : 'error',
      title: item.title,
      subtitle: /*#__PURE__*/React__default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: description
        }
      }),
      surface: isDark ? 'dark' : 'light',
      disableAnimation: false,
      fullBleed: false,
      hideCloseButton: false,
      disableFocus: false,
      inline: false,
      layout: null,
      onCloseButtonClick: function onCloseButtonClick() {
        return props.closeBannerBar(props.values, props.setValues);
      }
    });
  });
};

var mvoTroubleShootingJson$2 = sessionUtility.getTroubleShootingJson();
var taggingGetPlatform = function taggingGetPlatform(useName) {
  var abbreviations = {
    'browser': 'dspt',
    'tablet': 'tspt',
    'mobile': 'mspt',
    'mfapp': 'mvapt'
  };
  var names = {
    'browser': 'desktop',
    'tablet': 'tablet',
    'mobile': 'mobile',
    'mfapp': 'mfapp'
  };
  var platform = useName ? 'desktop' : 'dspt';
  if (useName) {
    return names[deviceType] || platform;
  }
  platform = abbreviations[deviceType] || platform;
  return platform;
};
var taggingSetIssueDetails_vzwDL = function taggingSetIssueDetails_vzwDL(symptom) {
  if (window && window.vzwDL && window.vzwDL.support) {
    var support = window.vzwDL.support;
    support.issueNumber = symptom.symptomId;
    support.tsaIssueName = symptom.issueName;
    return true;
  }
  return false;
};
var taggingForDeviceNetworkTile = function taggingForDeviceNetworkTile(data) {
  var _window, _window$vzdl, _window2, _window2$vztag, _window2$vztag$api;
  if ((_window = window) !== null && _window !== void 0 && (_window$vzdl = _window.vzdl) !== null && _window$vzdl !== void 0 && _window$vzdl.page && typeof window.vzdl.page === "object") {
    window.vzdl.page.detail = data;
  } else {
    window.vzdl = {
      page: {
        detail: data
      }
    };
  }
  (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$vztag = _window2.vztag) === null || _window2$vztag === void 0 ? void 0 : (_window2$vztag$api = _window2$vztag.api) === null || _window2$vztag$api === void 0 ? void 0 : _window2$vztag$api.dispatch("openView");
  sendCustomEvent$1('openView', window.vzdl);
};
var taggingSetIssueDetails_vzdl = function taggingSetIssueDetails_vzdl(symptom) {
  var _window$vzdl$event$va, _window3, _window3$vzdl, _window3$vzdl$event;
  if ((_window$vzdl$event$va = (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$vzdl = _window3.vzdl) === null || _window3$vzdl === void 0 ? void 0 : (_window3$vzdl$event = _window3$vzdl.event) === null || _window3$vzdl$event === void 0 ? void 0 : _window3$vzdl$event.value) != null ? _window$vzdl$event$va : "") {
    window.vzdl.event.value = "event117";
  }
  if (window && window.vzdl && window.vzdl.support) {
    var support = window.vzdl.support;
    support.issueNumber = symptom.symptomId;
    support.tsaIssueName = symptom.issueName;
    return true;
  }
  return false;
};
var taggingSetStepNameValue = function taggingSetStepNameValue(value) {
  var _window$vzdl$support, _window5, _window5$vzdl;
  if ((_window$vzdl$support = (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$vzdl = _window5.vzdl) === null || _window5$vzdl === void 0 ? void 0 : _window5$vzdl.support) != null ? _window$vzdl$support : "") {
    window.vzdl.support.tsaStepName = value;
    return true;
  }
  return false;
};
var taggingSetPageValue = function taggingSetPageValue(value) {
  var _window$vzdl$page, _window6, _window6$vzdl;
  if ((_window$vzdl$page = (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$vzdl = _window6.vzdl) === null || _window6$vzdl === void 0 ? void 0 : _window6$vzdl.page) != null ? _window$vzdl$page : "") {
    window.vzdl.page.name = value;
    var normalPageName = value.replace(/[_]/g, ' ');
    if (!isEmpty(window.vztag)) {
      window.vztag.api.dispatch("pageView", {
        name: normalPageName
      });
    }
    return true;
  }
  return false;
};
var taggingSet_vzwDL = function taggingSet_vzwDL(pageName) {
  if (window && window.vzwDL && window.vzwDL.page) {
    var page = window.vzwDL.page;
    var platformAbbr = taggingGetPlatform(true);
    var platform = taggingGetPlatform();
    page.channel = platform;
    page.mlsExp = platformAbbr + ":northstar";
    page.pageType = platformAbbr + " support";
    page.platform = platformAbbr;
    page['pageName'] = mvoTroubleShootingJson$2 && mvoTroubleShootingJson$2.ddata && mvoTroubleShootingJson$2.ddata.device && mvoTroubleShootingJson$2.ddata.device.is5GDevice ? "/" + platform + "/5g-ts/" + pageName : "/" + platform + "/ts/" + pageName;
    return true;
  }
  return false;
};
var taggingSet_perContentImpression = function taggingSet_perContentImpression(perContentData) {
  if (window && window.vzwDL && window.vzwDL.page) {
    var page = window.vzwDL.page;
    page.perContentImpression = perContentData;
    if (window.vzwAnalytics) {
      window.vzwAnalytics.events.track('variableUpdater', {
        list2: perContentData
      });
    }
    return true;
  }
  return false;
};
var taggingSet_vzdl = function taggingSet_vzdl(pageName) {
  if (window && window.vzdl && window.vzdl.page) {
    var page = window.vzdl.page;
    var platform = taggingGetPlatform();
    page.name = "/" + platform + "/" + pageName;
    return true;
  }
  return false;
};
var taggingSetPageView = function taggingSetPageView(pageName) {
  var normalPageName = pageName.replace(/[_]/g, ' ');
  try {
    taggingSet_vzwDL(normalPageName);
    taggingSet_vzdl(normalPageName);
    if (!isEmpty(window.vztag)) {
      window.vztag.api.dispatch("pageView", {
        name: normalPageName
      });
    }
    if (!isEmpty(window.vzwAnalytics)) {
      window.vzwAnalytics.events.track('pageChangeEvent');
    }
  } catch (e) {
    console.log("Tagging Exception for Page View: " + e);
  }
};
var taggingSetOpenView = function taggingSetOpenView(name, selector, isError) {
  if (isError === void 0) {
    isError = false;
  }
  try {
    if (!isEmpty(window.vztag)) {
      window.vztag.api.dispatch('openView', {
        name: name,
        selector: selector,
        error: isError
      });
    }
    if (!isEmpty(window.vzwAnalytics)) {
      if (isError) {
        window.vzwAnalytics.events.track('errorEvent', {
          'errorMsg': name,
          'errorName': 'message displayed'
        });
      } else {
        window.vzwAnalytics.events.track('pageChangeEvent', {
          page: name,
          overlay: true
        });
      }
    }
  } catch (e) {
    console.log("Tagging Exception for Open View: " + e);
  }
};
var taggingSetCloseView = function taggingSetCloseView(name, selector) {
  try {
    if (!isEmpty(window.vztag)) {
      window.vztag.api.dispatch('closeView', {
        name: name,
        selector: selector
      });
    }
  } catch (e) {
    console.log("Tagging Exception for Close View: " + e);
  }
};
var sendCustomEvent$1 = function sendCustomEvent(evt, data) {
  console.log('sendCustomEvent', evt, data);
  if (document.createEvent && document.body.dispatchEvent) {
    var event = document.createEvent('Event');
    event === null || event === void 0 ? void 0 : event.initEvent(evt, true, true);
    if (event) {
      event.detail = data;
    }
    document.body.dispatchEvent(event);
  } else if (window.CustomEvent && document.body.dispatchEvent) {
    var _event = new CustomEvent(evt, {
      bubbles: true,
      cancelable: true,
      detail: data
    });
    document.body.dispatchEvent(_event);
  }
};
window.sendCustomEvent = sendCustomEvent$1;
var triggerPageViewUpdateEvent = function triggerPageViewUpdateEvent(eventName, eventId) {
  console.log("triggerPageViewUpdateEvent==start--eventName--", eventName);
  console.log("triggerPageViewUpdateEvent==start--eventId--", eventId);
  window.vzdl = window.vzdl || {};
  window.vzdl.page = window.vzdl.page || {};
  if (typeof window.vzdl.page !== "string") {
    window.vzdl.page.detail = "tsa_steps";
  }
  var newEvent;
  if (eventId !== null && eventId !== undefined && eventId !== "") {
    newEvent = {
      eventInfo: {
        eventName: eventName,
        timeStamp: new Date(),
        processed: {
          adobeAnalytics: false
        }
      },
      page: window.vzdl.page,
      scEvents: eventId
    };
  } else {
    newEvent = {
      eventInfo: {
        eventName: eventName,
        timeStamp: new Date(),
        processed: {
          adobeAnalytics: false
        }
      },
      page: window.vzdl.page
    };
  }
  window.vzdl.events = [];
  if (window.vzdl) {
    window.vzdl.event = window.vzdl.event || {};
    window.vzdl.event.value = eventId;
  }
  window.vzdl.events.push(newEvent);
  sendCustomEvent$1(eventName);
};
var updateVzdl = function updateVzdl(issueName, symptomId, eventNumber, stepName, currentPageId, subFlow, sourceChannel, displayChannel) {
  if (!stepName) return;
  try {
    var _window7, _window7$vzdl, _window8, _window8$vzdl;
    console.log("updateVzdl==start--issueName--", issueName);
    console.log("updateVzdl==start--symptomId--", symptomId);
    console.log("updateVzdl==start--eventNumber--", eventNumber);
    console.log("updateVzdl==start--stepName--", stepName);
    console.log("updateVzdl==start--currentPageId--", currentPageId);
    if ((_window7 = window) !== null && _window7 !== void 0 && (_window7$vzdl = _window7.vzdl) !== null && _window7$vzdl !== void 0 && _window7$vzdl.page && typeof window.vzdl.page !== 'string') {
      window.vzdl.page.url = document.URL;
      window.vzdl.page.sourceChannel = sourceChannel;
      window.vzdl.page.displayChannel = displayChannel;
    }
    if (subFlow) {
      window.vzdl.page.subFlow = subFlow;
    }
    if ((_window8 = window) !== null && _window8 !== void 0 && (_window8$vzdl = _window8.vzdl) !== null && _window8$vzdl !== void 0 && _window8$vzdl.support) {
      window.vzdl.support.issueNumber = symptomId;
      window.vzdl.support.tsaIssueName = issueName;
      if (stepName && currentPageId) {
        window.vzdl.support.tsaStepName = stepName + "_" + currentPageId;
      }
    } else {
      window.vzdl.support = {
        issueNumber: symptomId,
        tsaIssueName: issueName,
        tsaStepName: stepName + "_" + currentPageId
      };
    }
    window.vzdl.event.value = eventNumber;
    if (!!window.vztag) {
      window.vztag.api.dispatch("sendData", {
        name: "update tsa steps: " + stepName + " ",
        data: {
          page: {
            subFlow: subFlow,
            url: document.URL,
            sourceChannel: sourceChannel,
            displayChannel: displayChannel
          },
          support: {
            issueNumber: symptomId,
            tsaIssueName: issueName,
            tsaStepName: stepName + "_" + currentPageId
          },
          event: {
            value: eventNumber
          }
        }
      });
    }
  } catch (error) {
    console.error("updateVzdl error: ", error);
  }
};
var dispatchTaggingAPI = function dispatchTaggingAPI(apiName, obj) {
  if (window.VZTAG_IS_READY) {
    window.vztag.api.dispatch(apiName, obj);
  } else {
    document.addEventListener('vztagReady', function (vApiName, vObj) {
      return function () {
        window.vztag.api.dispatch(vApiName, vObj);
      };
    }(apiName, obj));
  }
};
var setPageView = function setPageView(tagging, isCustomEvent, popOutFlow) {
  var _window9;
  console.log("isCustomEvent+++++++", isCustomEvent);
  console.log("popOutFlow++++++", popOutFlow);
  var _vzdl = _extends({}, (_window9 = window) === null || _window9 === void 0 ? void 0 : _window9.vzdl);
  for (var _i = 0, _Object$entries = Object.entries(tagging); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    console.log({
      vzdlValue: value,
      key: key,
      page: _vzdl[key]
    });
    var vzdlKey = _vzdl[key];
    _vzdl[key] = _extends({}, vzdlKey, value);
  }
  console.log({
    _vzdl: _vzdl
  });
  window.vzdl = _vzdl;
  if (isCustomEvent && popOutFlow) {
    try {
      sendCustomEvent$1("troubleshooting", window.vzdl);
      console.log("customEvent++++", "troubleshooting");
    } catch (error) {
      console.log(error);
    }
  } else if (isCustomEvent && !popOutFlow) {
    try {
      sendCustomEvent$1("pageView", window.vzdl);
      console.log("customEvent++++", "pageView");
    } catch (error) {
      console.log(error);
    }
  } else {
    dispatchTaggingAPI('pageView');
  }
};
var setPage = function setPage(tagging, isCustomEvent) {
  var _window0;
  var _vzdl = _extends({}, (_window0 = window) === null || _window0 === void 0 ? void 0 : _window0.vzdl);
  for (var _i2 = 0, _Object$entries2 = Object.entries(tagging); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _Object$entries2[_i2],
      key = _Object$entries2$_i[0],
      value = _Object$entries2$_i[1];
    console.log({
      vzdlValue: value,
      key: key,
      page: _vzdl[key]
    });
    var vzdlKey = _vzdl[key];
    _vzdl[key] = _extends({}, vzdlKey, value);
  }
  window.vzdl = _vzdl;
  if (isCustomEvent) {
    sendCustomEvent$1("pageView", window.vzdl);
  } else {
    dispatchTaggingAPI('pageView');
  }
};
var sendData = function sendData(tagging) {
  var _window1, _vzdl$page;
  var _vzdl = _extends({}, (_window1 = window) === null || _window1 === void 0 ? void 0 : _window1.vzdl);
  for (var _i3 = 0, _Object$entries3 = Object.entries(tagging); _i3 < _Object$entries3.length; _i3++) {
    var _Object$entries3$_i = _Object$entries3[_i3],
      key = _Object$entries3$_i[0],
      value = _Object$entries3$_i[1];
    var vzdlKey = _vzdl[key];
    _vzdl[key] = _extends({}, vzdlKey, value);
  }
  window.vzdl = _vzdl;
  dispatchTaggingAPI("Update: " + (_vzdl === null || _vzdl === void 0 ? void 0 : (_vzdl$page = _vzdl.page) === null || _vzdl$page === void 0 ? void 0 : _vzdl$page.name), {
    name: 'sendData',
    data: _vzdl
  });
};
var dispatchOverlay = function dispatchOverlay(api, obj) {
  return dispatchTaggingAPI(api, obj);
};
var dispatchNotify = function dispatchNotify(event, isACSS) {
  if (event === void 0) {
    event = {};
  }
  if (isACSS === void 0) {
    isACSS = false;
  }
  if (isACSS) sendCustomEvent$1('pageView', event);else dispatchTaggingAPI('notify', event);
};
var dispatchLinkClick = function dispatchLinkClick(value) {
  return dispatchTaggingAPI('linkClick', {
    value: value
  });
};
var tagging = {
  setPage: setPage,
  setPageView: setPageView,
  sendData: sendData,
  dispatchOverlay: dispatchOverlay,
  dispatchNotify: dispatchNotify,
  dispatchLinkClick: dispatchLinkClick
};

var _templateObject$c, _templateObject2$9, _templateObject3$9, _templateObject4$9, _templateObject5$8;
var StyledModal$3 = styled(Modal$1)(_templateObject$c || (_templateObject$c = _taggedTemplateLiteralLoose(["\n  &.completeModal{\n    ", "\n  }\n"])), function (props) {
  return props.isDark ? "\n      background-color: #202229;\n      button[data-testid=\"modal-close-button\"]{\n        background-color: #202229 !important;\n        svg path{\n          stroke: #D8DADA;\n        }\n      }\n      " : "\n      button[data-testid=\"modal-close-button\"]{\n        background-color: #fff !important;\n        svg path{\n          stroke: #000;\n        }\n      }\n      background-color: #fff;\n    ";
});
var StyledModalBody$3 = styled(ModalBody$1)(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteralLoose(["\n  &[class^=\"StyledModalBody-\"] {\n    padding: 0px;\n  }\n  &.completeModalBody{\n    ", "\n  }\n"])), function (props) {
  return props.isDark ? "\n      h3, #message-modal div{\n        color: #fff;\n      }\n    \n    " : "\n      h3, #message-modal div{\n        color: #000;\n      }\n    ";
});
var getMessageWrapperStyles = function getMessageWrapperStyles(props) {
  var styles = '';
  if (isMobile()) {
    styles += 'margin-top: 65px;\n';
  }
  return styles;
};
var MessageWrapper = styled.div(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (props) {
  return getMessageWrapperStyles();
});
var getMessageTextStyles = function getMessageTextStyles(props) {
  if (props.title) {
    return "\n      margin-top: 20px;\n    ";
  }
  return '';
};
var getMessageActionsWrapperStyles = function getMessageActionsWrapperStyles(props) {
  var styles = '';
  if (props.stackButtons) {
    styles += 'align-items: center;\n';
    styles += 'flex-direction: column;\n';
    styles += 'justify-content: center;\n';
  }
  return styles;
};
var MessageText = styled.div(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteralLoose(["\n  font-size: initial;\n  ", "\n"])), function (props) {
  return getMessageTextStyles(props);
});
var MessageActionsWrapper = styled.div(_templateObject5$8 || (_templateObject5$8 = _taggedTemplateLiteralLoose(["\n\n@media(max-width:600px){\n\n  padding-top: 10px;\n}\n  display: flex;\n  justify-content: ", ";\n  padding-top: 40px;\n  padding-bottom: 30px;\n  width: 90%;\n  ", "\n\n  &.modalFooterMessage{\n    button[data-clickstream=\"Done-btn-cta\"]{\n      background-color: #fff !important;\n      border: 0.0625rem solid #000000;\n      color: #000;\n      &:active{\n        color: #747676;\n        border-color: #747676;\n        box-shadow: 0 0 0 0.0625rem #747676;\n      }\n    }\n  }\n"])), function (props) {
  return props.buttons.length > 1 ? 'start' : 'center';
}, function (props) {
  return getMessageActionsWrapperStyles(props);
});
var MessageModal = function MessageModal(props) {
  var _configDetails$params, _configDetails$params2, _configDetails$params3, _configDetails$params4, _configDetails$params5, _configDetails$params6;
  var _props$body = props.body,
    body = _props$body === void 0 ? '' : _props$body,
    _props$buttons = props.buttons,
    buttons = _props$buttons === void 0 ? [] : _props$buttons,
    _props$title = props.title,
    title = _props$title === void 0 ? '' : _props$title,
    _props$styles = props.styles,
    styles = _props$styles === void 0 ? {} : _props$styles;
  var handleAction = function handleAction(button) {
    if (props.handleAction) {
      props.handleAction(button);
    }
  };
  var modalChanged = function modalChanged(open) {
    var modalSelector = "#" + props.id;
    if (open) {
      taggingSetOpenView(title, modalSelector, props.isError);
    } else {
      taggingSetCloseView(title, modalSelector);
      if (props.handleAction) {
        props.handleAction({
          actionData: 'close'
        });
      }
    }
  };
  var zIndex = isMobile() ? 15000 : 1000;
  zIndex = props.zIndex ? props.zIndex : zIndex;
  var configDetails = useContext(ConfigContext);
  return /*#__PURE__*/React__default.createElement(StyledModal$3, {
    className: "completeModal",
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : (_configDetails$params2 = _configDetails$params.theme) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.isDark,
    ariaLabel: title,
    closeButton: null,
    data: props.deviceDetails,
    id: props.id,
    onOpenedChange: modalChanged,
    opened: props.showModal,
    styles: props.styles,
    zIndex: zIndex
  }, /*#__PURE__*/React__default.createElement(StyledModalBody$3, {
    className: "completeModalBody",
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params3 = configDetails.paramsDetails) === null || _configDetails$params3 === void 0 ? void 0 : (_configDetails$params4 = _configDetails$params3.theme) === null || _configDetails$params4 === void 0 ? void 0 : _configDetails$params4.isDark
  }, /*#__PURE__*/React__default.createElement(MessageWrapper, props, title && /*#__PURE__*/React__default.createElement(Title, {
    size: "large"
  }, title), body && /*#__PURE__*/React__default.createElement(MessageText, props, typeof body === 'object' && body, typeof body !== 'object' && /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: body
    }
  }))), buttons.length > 0 && /*#__PURE__*/React__default.createElement(ModalFooter$1, props, /*#__PURE__*/React__default.createElement(MessageActionsWrapper, {
    className: "modalFooterMessage",
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params5 = configDetails.paramsDetails) === null || _configDetails$params5 === void 0 ? void 0 : (_configDetails$params6 = _configDetails$params5.theme) === null || _configDetails$params6 === void 0 ? void 0 : _configDetails$params6.isDark,
    buttons: buttons,
    stackButtons: props.stackButtons
  }, buttons.map(function (button) {
    var secondary = button.type === 'secondary' ? true : false;
    var inverted = button.inverted ? true : false;
    var size = props.size ? props.size : button.size;
    size = props.stackButtons ? '320px' : size;
    return /*#__PURE__*/React__default.createElement(ActionButton, {
      "data-analyticstrack": button.text + "-Btn",
      "data-track": "{\"type\": \"link\", \"name\": \"" + button.text + "-Btn\"}",
      "data-clickstream": button.text + "-btn-cta",
      inverted: inverted,
      key: button.text,
      onClick: function onClick() {
        return handleAction(button);
      },
      "data-testid": "action",
      secondary: secondary,
      size: size,
      marginBottom: styles.marginBottom
    }, button.text);
  })))));
};
MessageModal.propTypes = {
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  buttons: PropTypes.array,
  handleAction: PropTypes.func,
  id: PropTypes.string,
  isError: PropTypes.bool,
  showClose: PropTypes.bool,
  showModal: PropTypes.bool.isRequired,
  stackButtons: PropTypes.bool,
  styles: PropTypes.object,
  title: PropTypes.string,
  zIndex: PropTypes.number
};
MessageModal.defaultProps = {
  body: '',
  buttons: [],
  id: 'message-modal',
  isError: false,
  showClose: true,
  stackButtons: false,
  title: ''
};

var Breadcrumbs = function Breadcrumbs(_ref) {
  var configDetails = useContext(ConfigContext);
  var breadcrumb = useMemo(function () {
    var breadcrumbData = configDetails.breadcrumbData || [];
    return breadcrumbData;
  }, [configDetails.breadcrumbData]);
  if (isMVA) return null;
  return /*#__PURE__*/React__default.createElement(Box, {
    margin: "auto",
    width: "100%",
    maxWidth: ["100%", "1232px"],
    paddingBottom: ['16px', '32px']
  }, /*#__PURE__*/React__default.createElement(Breadcrumbs$1, {
    surface: "light"
  }, breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.map(function (_ref2) {
    var _window$tsFeatureFlag;
    var name = _ref2.name,
      url = _ref2.url;
    return /*#__PURE__*/React__default.createElement(BreadcrumbItem, {
      key: name + url,
      href: url
    }, window.isMVODigital && (_window$tsFeatureFlag = window.tsFeatureFlags) !== null && _window$tsFeatureFlag !== void 0 && _window$tsFeatureFlag.enableRemovePrepaidStringFFlag ? removeTextFromString(name, 'Prepaid') : name);
  })));
};

var _templateObject$d, _templateObject2$a, _templateObject3$a, _templateObject4$a, _templateObject5$9, _templateObject6$8, _templateObject7$7, _templateObject8$7, _templateObject9$5;
var SpacerDiv$1 = styled.div(_templateObject$d || (_templateObject$d = _taggedTemplateLiteralLoose(["\n  height: ", ";\n  width: ", ";\n"])), function (props) {
  return props.height || "20px";
}, function (props) {
  return props.width || "100%";
});
var TitleDiv = styled.div(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteralLoose(["\n@media (max-width: 600px) {\nwidth: 35%;\n}\n"])));
var ImageContainer$3 = styled.div(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-end;\n  min-height: 250px;\n  width: 100%;\n"])));
var DeviceImage$3 = styled.img(_templateObject4$a || (_templateObject4$a = _taggedTemplateLiteralLoose(["\n  height: 200px;\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n"])));
var IconWrapper$1 = styled.div(_templateObject5$9 || (_templateObject5$9 = _taggedTemplateLiteralLoose(["\n  margin-left: 10px;\n"])));
var IssueContainer = styled.div(_templateObject6$8 || (_templateObject6$8 = _taggedTemplateLiteralLoose(["\n  padding-top: 5px;\n  @media (max-width: 600px) {\n  margin-right: 5rem;\n  }\n"])));
var InfoContainer = styled.div(_templateObject7$7 || (_templateObject7$7 = _taggedTemplateLiteralLoose(["\n  border: 1px solid #e6e5e3;\n  padding: 25px 40px;\n  @media (max-width: 600px) {\n    margin-left: -2.5rem;\n    width: 32%;\n  }\n"])));
var TitleWrapper$4 = styled.div(_templateObject8$7 || (_templateObject8$7 = _taggedTemplateLiteralLoose(["\n  padding: 3px 10px;\n"])));
var TitleContainer$1 = styled.div(_templateObject9$5 || (_templateObject9$5 = _taggedTemplateLiteralLoose(["\n  padding-top: 5px;\n  background-color: #fab916;\n  display: inline-flex;\n  vertical-align: middle;\n  padding-top: 13px;\n  padding-bottom: 13px;\n  /* padding-left: 10px; */\n  width: 100%;\n  @media (max-width: 600px) {\n    margin-left: -1rem;\n    width: 37%;\n  }\n"])));
var AccountIssuePage = function AccountIssuePage(props) {
  var _props$values = props.values,
    values = _props$values === void 0 ? {} : _props$values,
    _props$functions = props.functions,
    functions = _props$functions === void 0 ? {} : _props$functions;
  var _values$troubleShooti = values.troubleShootingInfo,
    accountIssueInfo = _values$troubleShooti === void 0 ? {} : _values$troubleShooti;
  var pageContent = getObjectPropertyByPath("ddata.output.pageContent", accountIssueInfo, {});
  var _pageContent$steps = pageContent.steps,
    steps = _pageContent$steps === void 0 ? [] : _pageContent$steps;
  var accountIssue = steps[0] ? steps[0] : {};
  var _accountIssue$cta = accountIssue.cta,
    cta = _accountIssue$cta === void 0 ? [] : _accountIssue$cta;
  var handleAction = function handleAction(button) {
    if (functions.handleTroubleShootingAction) {
      functions.handleTroubleShootingAction(button);
    }
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Grid$1, {
    "data-testid": "AccountIssuePage"
  }, /*#__PURE__*/React__default.createElement(Row$1, null, /*#__PURE__*/React__default.createElement(Col, {
    colSizes: {
      mobile: 12,
      tablet: 3,
      desktop: 3
    }
  }, !isMobile() && /*#__PURE__*/React__default.createElement(ImageContainer$3, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(DeviceImage$3, {
    alt: "phone",
    src: accountIssue.image
  })))), /*#__PURE__*/React__default.createElement(Col, {
    colSizes: {
      mobile: 12,
      tablet: 9,
      desktop: 9
    }
  }, /*#__PURE__*/React__default.createElement(IssueContainer, null, /*#__PURE__*/React__default.createElement(TitleContainer$1, null, /*#__PURE__*/React__default.createElement(IconWrapper$1, null, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "warning",
    size: "medium"
  })), /*#__PURE__*/React__default.createElement(TitleWrapper$4, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    bold: true
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, accountIssue.title)))), /*#__PURE__*/React__default.createElement(InfoContainer, null, accountIssue.heading && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    bold: true
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, accountIssue.heading)), /*#__PURE__*/React__default.createElement(SpacerDiv$1, {
    height: "5px"
  })), accountIssue.subHeading && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, accountIssue.subHeading)), /*#__PURE__*/React__default.createElement(SpacerDiv$1, {
    height: "20px"
  })), accountIssue.description && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, accountIssue.description)), /*#__PURE__*/React__default.createElement(SpacerDiv$1, {
    height: "20px"
  })), /*#__PURE__*/React__default.createElement(ActionButtons, {
    alignButtons: "left",
    buttons: cta,
    handleAction: handleAction,
    size: "small"
  })))))));
};
AccountIssuePage.propTypes = {
  functions: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
};
AccountIssuePage.defaultProps = {};

var _templateObject$e, _templateObject2$b, _templateObject3$b, _templateObject4$b, _templateObject5$a, _templateObject6$9, _templateObject7$8, _templateObject8$8, _templateObject9$6, _templateObject0$5, _templateObject1$5;
var mvoConfig$3 = sessionUtility.getMvoConfig();
var InputFieldWrapper = styled.div(_templateObject$e || (_templateObject$e = _taggedTemplateLiteralLoose(["\n  padding: 0rem 0rem 0.5rem 0rem;\n"])));
var SelectWrapper = styled.div(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteralLoose(["\n  float: left;\n  padding-right: 10px;\n"])));
var StyledModal$4 = styled(Modal$1)(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteralLoose(["\n  &[class^=\"ModalDialog-\"] {\n    width: 500px;\n    padding: 25px 40px 0px 40px;\n    min-height: 440px;\n  }\n"])));
var StyledModalBody$4 = styled(ModalBody$1)(_templateObject4$b || (_templateObject4$b = _taggedTemplateLiteralLoose(["\n  &[class^=\"StyledModalBody-\"] {\n    padding: 0px;\n  }\n"])));
var ModalSubTitle = styled.div(_templateObject5$a || (_templateObject5$a = _taggedTemplateLiteralLoose(["\n    padding: 10px 0px;\n    font-size: 12px;\n"])));
var ButtonWrapper$4 = styled.div(_templateObject6$9 || (_templateObject6$9 = _taggedTemplateLiteralLoose(["\n  justify-content: left;\n  padding-top: 10px;\n  display: inline-block;\n"])));
var ErrorMessage = styled.div(_templateObject7$8 || (_templateObject7$8 = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    color: red;\n    font-size: 12px;\n"])));
var WarningMessage = styled.div(_templateObject8$8 || (_templateObject8$8 = _taggedTemplateLiteralLoose(["\n  padding: 0 0 0 10px;\n"])));
var WarningIcon = styled.div(_templateObject9$6 || (_templateObject9$6 = _taggedTemplateLiteralLoose(["\n  height: 24px;\n  width: 24px;\n  padding-top: 7px;\n  position: relative;\n\n  span {\n    position: absolute;\n    top: 5px;\n    left: 6.5px;\n  }\n"])));
var Icon = styled.div(_templateObject0$5 || (_templateObject0$5 = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  height: 16.31px;\n  width: 16.31px;\n  padding: 5px;\n  transform: rotate(45deg);\n  border: 1px solid #ED7000;\n  border-radius: 2px;\n\n  span {\n    transform: rotate(-45deg);\n  }\n"])));
var MessageWrap = styled.div(_templateObject1$5 || (_templateObject1$5 = _taggedTemplateLiteralLoose(["\n  color: #ED7000;\n  font-family: \"Verizon NHG DS\";\n  font-size: 12px;\n  letter-spacing: 0.5px;\n  display: flex;\n  padding: 10px 0 0 5px;\n"])));
var ScheduleCallbackContent = function ScheduleCallbackContent(props) {
  var _props$tsData;
  var _useState = useState(false),
    errMDN = _useState[0],
    setErrMDN = _useState[1];
  var _useState2 = useState(false),
    errDate = _useState2[0],
    setErrDate = _useState2[1];
  var _useState3 = useState(false),
    errTime = _useState3[0],
    setErrTime = _useState3[1];
  var functions = props.functions;
  var _ref = (props === null || props === void 0 ? void 0 : (_props$tsData = props.tsData) === null || _props$tsData === void 0 ? void 0 : _props$tsData.createCaseResponse) || {},
    _ref$callMeDetails = _ref.callMeDetails,
    callMeDetails = _ref$callMeDetails === void 0 ? {} : _ref$callMeDetails,
    _ref$callMeContactLis = _ref.callMeContactList,
    callMeContactList = _ref$callMeContactLis === void 0 ? [] : _ref$callMeContactLis,
    ticketNumber = _ref.ticketNumber;
  var _callMeDetails$eligib = callMeDetails.eligibleTimeSlots,
    eligibleTimeSlots = _callMeDetails$eligib === void 0 ? {} : _callMeDetails$eligib,
    loggedInMtn = callMeDetails.loggedInMtn,
    _callMeDetails$existi = callMeDetails.existingCallback,
    existingCallback = _callMeDetails$existi === void 0 ? false : _callMeDetails$existi;
  var _eligibleTimeSlots$ti = eligibleTimeSlots.timeSlot,
    timeSlot = _eligibleTimeSlots$ti === void 0 ? [] : _eligibleTimeSlots$ti;
  var onLoadFlag = timeSlot.length === 0;
  var errMsg1 = "The selected contact number is already scheduled for a call. Please choose a different number or method of contact.";
  var errMsg2 = "We're having trouble setting up a call the call at this moment. Please choose a different method of contact or try again later.";
  var onLoadErr = existingCallback ? errMsg1 : !existingCallback && onLoadFlag ? errMsg2 : '';
  var _ref2 = (props === null || props === void 0 ? void 0 : props.tsData) || {},
    _ref2$context = _ref2.context,
    context = _ref2$context === void 0 ? {} : _ref2$context;
  var _context$lineInfo = context.lineInfo,
    lineInfo = _context$lineInfo === void 0 ? [] : _context$lineInfo;
  var _useState4 = useState(timeSlot),
    timeSlots = _useState4[0],
    setTimeSlots = _useState4[1];
  var _useState5 = useState(''),
    selectedDate = _useState5[0],
    setSelectedDate = _useState5[1];
  var _useState6 = useState(''),
    selectedTime = _useState6[0],
    setSelectedTime = _useState6[1];
  var _useState7 = useState(loggedInMtn),
    selectedMTN = _useState7[0],
    setSelectedMTN = _useState7[1];
  var _useState8 = useState(onLoadFlag),
    showError = _useState8[0],
    setShowError = _useState8[1];
  var _useState9 = useState(onLoadErr),
    errorMessage = _useState9[0],
    setErrorMessage = _useState9[1];
  var handleChange = function handleChange(event) {
    event.preventDefault();
    if (event.target.name === 'Date') {
      setSelectedDate(event.target.value);
      setErrDate(false);
      setSelectedTime('');
    } else if (event.target.name === 'Time') {
      setSelectedTime(event.target.value);
      setErrTime(false);
    } else if (event.target.name === 'ContactNumber') {
      setSelectedMTN(event.target.value);
      resetDateTime();
      setErrMDN(false);
      if (event.target.value !== '') {
        getDateTimeSlot(event.target.value);
      }
    }
  };
  var resetDateTime = function resetDateTime() {
    setSelectedDate('');
    setSelectedTime('');
    setTimeSlots([]);
  };
  var getDateTimeSlot = function getDateTimeSlot(contactNumber) {
    try {
      var reqPaylod = {
        callReason: "Troubleshooting",
        caseId: ticketNumber,
        intent: "Troubleshooting",
        callbackNumber: contactNumber || ""
      };
      if (showError) {
        setShowError(false);
      }
      if (errorMessage) {
        setErrorMessage("");
      }
      return Promise.resolve(getCallDetails(reqPaylod)).then(function (callResp) {
        var _callResp$callSchedul = callResp.callScheduleDetails,
          callScheduleDetails = _callResp$callSchedul === void 0 ? {} : _callResp$callSchedul;
        var _callScheduleDetails$ = callScheduleDetails.eligibleTimeSlots,
          eligibleTimeSlots = _callScheduleDetails$ === void 0 ? {} : _callScheduleDetails$,
          existingCallback = callScheduleDetails.existingCallback;
        var timeSlot = eligibleTimeSlots.timeSlot;
        if (!existingCallback && timeSlot && timeSlot.length > 0) {
          setShowError(false);
          setErrorMessage("");
          setTimeSlots(timeSlot);
        } else if (existingCallback === true) {
          setShowError(true);
          setErrorMessage(errMsg1);
          setTimeSlots([]);
        } else {
          setShowError(true);
          setErrorMessage(errMsg2);
          setTimeSlots([]);
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var handleSubmit = function handleSubmit() {
    try {
      var _temp = function () {
        if (selectedMTN === '' || selectedDate === '' || selectedTime === '') {
          if (selectedMTN === '') {
            setErrMDN(true);
          }
          if (selectedDate === '') {
            setErrDate(true);
          }
          if (selectedTime === '') {
            setErrTime(true);
          }
        } else {
          var selectedSlot = timeSlots.find(function (slots) {
            return slots.slotOrder.toString() === selectedTime.toString();
          });
          var _ref3 = (mvoConfig$3 === null || mvoConfig$3 === void 0 ? void 0 : mvoConfig$3.tokenDetails) || {},
            name = _ref3.name,
            _loggedInMtn = _ref3.loggedInMtn,
            email = _ref3.email;
          var reqPayload = {
            caseId: ticketNumber || "",
            callReason: "Troubleshooting",
            intent: "Troubleshooting",
            processStep: "",
            errorMessages: {
              uiError: "",
              externalSystem: "",
              backendError: "",
              backendErrorCode: "",
              intentProcessStep: ""
            },
            ticketDetails: {
              fullName: name || "",
              contactMTN: selectedMTN,
              email: email || "",
              reason: "Troubleshooting",
              relatingTo: "Phone Calls & Can't make calls",
              additionalInfo: "",
              selectedMTNs: lineInfo.map(function (el) {
                return {
                  selectedMTN: el.mtn
                };
              }),
              preferredContactOption: "Call me",
              callScheduleDetails: {
                callMeNow: false,
                startTime: selectedSlot && selectedSlot.startTime || "",
                endTime: selectedSlot && selectedSlot.endTime || ""
              }
            }
          };
          return Promise.resolve(submitSupportRequest(reqPayload)).then(function (submitApiResp) {
            if (submitApiResp.ticketNumber) {
              var callScheduleDetails = submitApiResp.callScheduleDetails,
                contactMTN = submitApiResp.contactMTN,
                _ticketNumber = submitApiResp.ticketNumber;
              var bookedDate = localeDateConverter(callScheduleDetails.startTime);
              var bookedTime = localeTimeConverter(callScheduleDetails);
              var message = "An agent will reach out to you at " + bookedTime + " on " + bookedDate + " on the number " + contactMTN + ".";
              functions.closeScheduleCallModal();
              functions.openModal("sheduleCallBack", _ticketNumber, message);
            } else {
              functions.closeScheduleCallModal();
              functions.openModal("error");
            }
          });
        }
      }();
      return Promise.resolve(_temp && _temp.then ? _temp.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledModalBody$4, null, /*#__PURE__*/React__default.createElement(Title, null, " Let's schedule a call. "), /*#__PURE__*/React__default.createElement(ModalSubTitle, null, " An agent will reach out to you at time of your choosing. "), /*#__PURE__*/React__default.createElement(SelectWrapper, null, /*#__PURE__*/React__default.createElement(InputFieldWrapper, null, /*#__PURE__*/React__default.createElement(DropdownSelect, {
    label: "Contact Number*",
    name: "ContactNumber",
    onChange: function onChange(event) {
      return handleChange(event);
    },
    required: true,
    value: selectedMTN,
    width: isMobile() ? "150px" : "300px"
  }, /*#__PURE__*/React__default.createElement("option", {
    value: ""
  }, "select"), callMeContactList && callMeContactList.map(function (num, index) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: "callback_" + index,
      value: num
    }, foramtMDN(num));
  })), errMDN && /*#__PURE__*/React__default.createElement(ErrorMessage, null, " Please Select Contact Number "))), /*#__PURE__*/React__default.createElement(SelectWrapper, null, /*#__PURE__*/React__default.createElement(InputFieldWrapper, null, /*#__PURE__*/React__default.createElement(DropdownSelect, {
    label: "Date",
    name: "Date",
    onChange: function onChange(event) {
      return handleChange(event);
    },
    disabled: showError,
    required: true,
    width: isMobile() ? "150px" : "300px"
  }, /*#__PURE__*/React__default.createElement("option", {
    value: ""
  }, "select"), timeSlots.filter(function (dateTime, index) {
    var mapped = timeSlots.map(function (el) {
      return localeDateConverter(el.startTime);
    });
    return mapped.indexOf(localeDateConverter(dateTime.startTime)) === index;
  }).map(function (slot) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: "dateSlot_" + slot.slotOrder,
      value: slot.startTime
    }, localeDateConverter(slot.startTime));
  })), errDate && /*#__PURE__*/React__default.createElement(ErrorMessage, null, " Please Select Date "))), /*#__PURE__*/React__default.createElement(SelectWrapper, null, /*#__PURE__*/React__default.createElement(InputFieldWrapper, null, /*#__PURE__*/React__default.createElement(DropdownSelect, {
    label: "Time",
    name: "Time",
    onChange: function onChange(event) {
      return handleChange(event);
    },
    disabled: showError,
    required: true,
    width: isMobile() ? "150px" : "300px"
  }, /*#__PURE__*/React__default.createElement("option", {
    value: ""
  }, "select"), timeSlots.filter(function (dateTime) {
    return localeDateConverter(dateTime.startTime) === localeDateConverter(selectedDate);
  }).map(function (dateSlot) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: "timeSlot_" + dateSlot.slotOrder,
      value: dateSlot.slotOrder
    }, localeTimeConverter(dateSlot));
  })), errTime && /*#__PURE__*/React__default.createElement(ErrorMessage, null, " Please Select Time "))), /*#__PURE__*/React__default.createElement(ButtonWrapper$4, null, /*#__PURE__*/React__default.createElement(ActionButton, {
    "data-analyticstrack": "Schedule-Btn",
    "data-track": "{\"type\": \"link\", \"name\": \"Schedule-Btn\"}",
    key: "Schedule",
    disabled: showError,
    onClick: function onClick() {
      return handleSubmit();
    },
    size: "240px"
  }, " Schedule ")), showError && /*#__PURE__*/React__default.createElement(MessageWrap, null, /*#__PURE__*/React__default.createElement(WarningIcon, null, " ", /*#__PURE__*/React__default.createElement(Icon, null), " ", /*#__PURE__*/React__default.createElement("span", null, "!"), " "), /*#__PURE__*/React__default.createElement(WarningMessage, null, errorMessage, " ")));
};

var _templateObject$f;
var StyledModal$5 = styled(Modal$1)(_templateObject$f || (_templateObject$f = _taggedTemplateLiteralLoose(["\n  &[class^=\"ModalDialog-\"] {\n    width: 500px;\n    padding: 25px 40px 0px 40px;\n    min-height: 440px;\n  }\n"])));
var ScheduleCallback = function ScheduleCallback(props) {
  var functions = props.functions;
  var handleModalToggle = function handleModalToggle(event) {
    console.log(event);
    if (event === false) {
      functions.closeScheduleCallModal();
    }
  };
  return /*#__PURE__*/React__default.createElement(StyledModal$5, {
    ariaLabel: "ScheduleCallback",
    opened: props.showModal,
    id: "schedule-callback",
    zIndex: 2000,
    onOpenedChange: handleModalToggle
  }, /*#__PURE__*/React__default.createElement(ScheduleCallbackContent, props));
};

var responseInfo = {
	timeStamp: "03-12-2020 08:27:01",
	correlationId: "941a7891-1de9-4184-9045-af9cb07c0dec-4049535",
	responseCode: "00",
	responseMessage: "SUCCESS",
	sectionErrors: [
	]
};
var body = {
	caseId: "TR-1618257-E01",
	ticketNumber: "MR-2249070-E01",
	availableContactPreference: [
		"Mobile text messaging",
		"Manage within account",
		"Call me"
	],
	callMeContactList: [
		"4708652765"
	],
	callMeDetails: {
		ewtDetails: {
			upperEwtInMinutes: 4,
			lowerEwtInMinutes: 3
		},
		eligibleTimeSlots: {
			timeSlot: [
				{
					startTime: "Wed, 21 Oct 2020 06:00:00 GMT",
					endTime: "Wed, 21 Oct 2020 06:30:00 GMT",
					slotOrder: "1"
				},
				{
					startTime: "Wed, 21 Oct 2020 08:00:00 GMT",
					endTime: "Wed, 21 Oct 2020 08:30:00 GMT",
					slotOrder: "5"
				},
				{
					startTime: "Thu, 22 Oct 2020 12:00:00 GMT",
					endTime: "Thu, 22 Oct 2020 12:30:00 GMT",
					slotOrder: "7"
				},
				{
					startTime: "Thu, 22 Oct 2020 15:30:00 GMT",
					endTime: "Thu, 22 Oct 2020 16:00:00 GMT",
					slotOrder: "24"
				},
				{
					startTime: "Fri, 23 Oct 2020 09:30:00 GMT",
					endTime: "Fri, 23 Oct 2020 10:00:00 GMT",
					slotOrder: "35"
				}
			]
		},
		loggedInMtn: "4708652765"
	}
};
var CallbackData = {
	responseInfo: responseInfo,
	body: body
};

var _templateObject$g, _templateObject2$c, _templateObject3$c, _templateObject4$c, _templateObject5$b;
var ThumbsUpContainer = styled.div(_templateObject$g || (_templateObject$g = _taggedTemplateLiteralLoose(["\n    width: ", "\n    margin: ", "\n    display: flex;\n    flex-direction: column;\n    align-items: initial;\n    &.thumbsupTitle *{\n      ", "\n    }\n"])), window.isBAUACSS ? "1024px" : "auto", window.isBAUACSS ? "0 auto" : "", function (props) {
  return props.isDark ? "\n      color: #fff;\n      background-color: transparent;\n    " : "\n      // color: #000000;\n    ";
});
var FeedbackWrapper = styled.div(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteralLoose(["\n  @media screen and (max-width: 600px) {\n    display:none\n  }\n"])));
var FeedbackWrapperMobile = styled.div(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteralLoose(["\n  margin:0px auto;\n  display: flex;\n  @media screen and (min-width: 600px) {\n      display:none\n  }\n"])));
var ThumbIcon = styled.div(_templateObject4$c || (_templateObject4$c = _taggedTemplateLiteralLoose(["\n  padding-top: 3px;\n  cursor: ", ";\n"])), function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? "" : "pointer";
});
var FeedbackBox = styled.textarea(_templateObject5$b || (_templateObject5$b = _taggedTemplateLiteralLoose(["\n  resize: none;\n  width: 100%;\n  height: 80px;\n  padding: 1.2%;\n  border-radius: 0.3rem;\n    \n  ::placeholder {\n    font-family: Verizon-NHG-eDS;\n  }\n"])));
var FeedbackContainer = function FeedbackContainer(props) {
  var _props$values2, _configDetails$params, _configDetails$params2, _props$values3, _props$values4;
  var _props$values = props.values,
    values = _props$values === void 0 ? {} : _props$values;
  var _values$troubleShooti = values.troubleShootingInfo,
    troubleShootingInfo = _values$troubleShooti === void 0 ? {} : _values$troubleShooti,
    _values$landingInfo = values.landingInfo,
    landingInfo = _values$landingInfo === void 0 ? {} : _values$landingInfo,
    _values$symptom = values.symptom,
    symptom = _values$symptom === void 0 ? {} : _values$symptom;
  var context = getObjectPropertyByPath('context', troubleShootingInfo, {});
  var _landingInfo$device = landingInfo.device,
    device = _landingInfo$device === void 0 ? {} : _landingInfo$device;
  var soeUrl = device.soeUrl;
  var issueName = symptom.issueName;
  var caseId = context.caseId;
  var _useState = useState(_extends({}, props.flags)),
    flags = _useState[0],
    setFlags = _useState[1];
  var _useState2 = useState({
      enableButton: false,
      userInput: ''
    }),
    feedbackValues = _useState2[0],
    setFeedbackValues = _useState2[1];
  var showThumbsUp = flags.showThumbsUp,
    showThumbsDown = flags.showThumbsDown,
    thumbsClicked = flags.thumbsClicked,
    submitClicked = flags.submitClicked,
    rating = flags.rating;
  var enableButton = feedbackValues.enableButton,
    userInput = feedbackValues.userInput;
  var aiSummryEnabled = isGenAIEnabled(values);
  var intentId = props.intentId,
    acssCallId = props.acssCallId,
    isACSS = props.isACSS;
  var _useSWRCache = useSWRCache(['aiSummary', intentId]),
    aiSummary = _useSWRCache.data,
    isLoading = _useSWRCache.isLoading;
  var _useFeedback = useFeedback(),
    provideGenAIFeedback = _useFeedback.trigger;
  var disabled = (props === null || props === void 0 ? void 0 : props.disabled) || isLoading;
  var mvoConfig = sessionUtility.getMvoConfig();
  useEffect(function () {
    return setFlags(_extends({}, props.flags));
  }, [props.flags]);
  var handleThumbsUpClick = function handleThumbsUpClick() {
    var _mvoTroubleShootingJs, _mvoTroubleShootingJs2, _$;
    var mvoTroubleShootingJson = sessionUtility.getTroubleShootingJson();
    if (!(mvoTroubleShootingJson !== null && mvoTroubleShootingJson !== void 0 && (_mvoTroubleShootingJs = mvoTroubleShootingJson.ddata) !== null && _mvoTroubleShootingJs !== void 0 && (_mvoTroubleShootingJs2 = _mvoTroubleShootingJs.device) !== null && _mvoTroubleShootingJs2 !== void 0 && _mvoTroubleShootingJs2.is5GDevice)) {
      var options = {
        flags: _extends({}, flags, {
          rating: '5',
          showThumbsUp: true,
          thumbsClicked: true
        })
      };
      props.functions.handleTroubleShootingAction({
        "action": "done"
      }, options, '', "feedbackThumbsUp");
    }
    if (props.page === 'completePage' && props.handleModalState) {
      props.handleModalState(_extends({}, flags, {
        thumbsClicked: true,
        showThumbsUp: true
      }));
    } else {
      setFlags(_extends({}, flags, {
        rating: '5',
        showThumbsUp: true,
        thumbsClicked: true
      }));
    }
    if (aiSummryEnabled && aiSummary !== null && aiSummary !== void 0 && aiSummary.vegasTransactionId) {
      provideGenAIFeedback({
        feedback: 5,
        vegasTransactionId: aiSummary === null || aiSummary === void 0 ? void 0 : aiSummary.vegasTransactionId,
        acssCallId: acssCallId,
        isACSS: isACSS
      });
    }
    (_$ = $('html, #app')) === null || _$ === void 0 ? void 0 : _$.animate({
      scrollTop: 0
    }, 300);
  };
  var handleThumbsDownClick = function handleThumbsDownClick() {
    if (props.handleModalState) {
      props.handleModalState(_extends({}, flags, {
        justAfterThumbsDownClicked: true,
        thumbsClicked: true
      }));
    } else {
      setFlags(_extends({}, flags, {
        rating: '1',
        showThumbsDown: true,
        thumbsClicked: true
      }));
    }
  };
  var handleOnChange = function handleOnChange(event) {
    var userInput = event.target.value;
    userInput && userInput.replace(/\s+/g, '').length > 0 ? setFeedbackValues(_extends({}, feedbackValues, {
      enableButton: true,
      userInput: userInput
    })) : setFeedbackValues(_extends({}, feedbackValues, {
      enableButton: false,
      userInput: userInput
    }));
  };
  var handleSubmit = function handleSubmit() {
    var mvoConfig = sessionUtility.getMvoConfig();
    var APIURL = "/digital/nsa/nos/gw/support/rating-and-reviews";
    var params = {
      rating: rating,
      review: userInput,
      productId: "troubleshooting|" + soeUrl + "|" + (issueName && issueName.replace(/[^\w\s]/g, '')) + "|" + caseId,
      title: issueName
    };
    var axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        "channelId": window._dg_channelId
      }
    };
    postHttpClientRequest(APIURL, params, axiosConfig);
    setFlags(_extends({}, flags, {
      showThumbsUp: showThumbsUp,
      showThumbsDown: showThumbsDown,
      thumbsClicked: thumbsClicked,
      submitClicked: true
    }));
  };
  var renderFeedback = function renderFeedback() {
    return /*#__PURE__*/React__default.createElement("div", {
      id: "feedbackBox"
    }, /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "20px"
    }), /*#__PURE__*/React__default.createElement(Body, {
      size: "large",
      viewport: "desktop",
      primitive: "h2"
    }, "How can we make this step more helpful? (optional)"), /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "5px"
    }), /*#__PURE__*/React__default.createElement(FeedbackBox, {
      "data-testid": "feedbackbox",
      onChange: function onChange(event) {
        return handleOnChange(event);
      },
      placeholder: "Type here..."
    }), /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "5px"
    }), /*#__PURE__*/React__default.createElement(Body, {
      size: "large",
      viewport: "desktop",
      primitive: "h2"
    }, "This information will only be used by Verizon and will not be shared with third parties."), /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "15px"
    }), /*#__PURE__*/React__default.createElement(Button$1, {
      onClick: handleSubmit,
      "data-testid": "submit",
      disabled: !enableButton,
      size: "small",
      style: !enableButton ? {
        background: 'none',
        color: '#ddd'
      } : {}
    }, "Submit"));
  };
  var renderFeedbackMsg2 = function renderFeedbackMsg2() {
    return /*#__PURE__*/React__default.createElement("div", {
      id: "feedbackBox2"
    }, /*#__PURE__*/React__default.createElement("p", null, "Thank you for your feedback."));
  };
  var renderFeedbackMsg3 = function renderFeedbackMsg3() {
    return /*#__PURE__*/React__default.createElement("div", {
      id: "feedbackBox3"
    }, /*#__PURE__*/React__default.createElement("p", null, "Awesome! Glad we could help."));
  };
  var tabIndex_value = "0";
  if ((props === null || props === void 0 ? void 0 : (_props$values2 = props.values) === null || _props$values2 === void 0 ? void 0 : _props$values2.thumbsUpClick) == true) {
    tabIndex_value = "-1";
  }
  var configDetails = useContext(ConfigContext);
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ThumbsUpContainer, {
    id: "ThumbsUPContainer",
    className: "thumbsupTitle",
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : (_configDetails$params2 = _configDetails$params.theme) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.isDark
  }, /*#__PURE__*/React__default.createElement(FeedbackWrapper, null, window.isMVODigital ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      gap: '25px',
      alignItems: 'center'
    },
    tabIndex: -1
  }, /*#__PURE__*/React__default.createElement(Body, {
    size: "large"
  }, "Was this helpful?"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px'
    }
  }, !showThumbsUp ? /*#__PURE__*/React__default.createElement(ThumbIcon, null, /*#__PURE__*/React__default.createElement(ButtonIcon, {
    "data-name": "ThumbUp",
    className: !thumbsClicked ? 'notselected' : '',
    onClick: !thumbsClicked && !disabled && handleThumbsUpClick,
    disabled: disabled || thumbsClicked,
    "data-analyticstrack": "thumbs-Up-Idle",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbsup\"}",
    "data-clickstream": "thumbs-Up-Idle",
    tabIndex: props !== null && props !== void 0 && (_props$values3 = props.values) !== null && _props$values3 !== void 0 && _props$values3.thumbsDownClick ? -1 : 0,
    role: "button",
    ariaLabel: "Thumbs Up",
    kind: "lowContrast",
    size: "large",
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React__default.createElement(Icon$1, {
        name: "thumbs-up",
        size: "medium",
        color: disabled ? '#d8dada' : '#000000'
      });
    }
  })) : /*#__PURE__*/React__default.createElement(ThumbIcon, null, /*#__PURE__*/React__default.createElement(ButtonIcon, {
    "data-name": "ThumbUp",
    className: !thumbsClicked ? 'notselected' : '',
    disabled: disabled || thumbsClicked,
    "data-analyticstrack": "thumbs-Up-On",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbsup\"}",
    "data-clickstream": "thumbs-Up-On",
    kind: "lowContrast",
    size: "large",
    tabIndex: -1,
    ariaLabel: "Thumbs Up",
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React__default.createElement(Icon$1, {
        name: "thumbs-up-filled",
        size: "medium",
        color: disabled ? '#d8dada' : '#000000'
      });
    }
  })), !showThumbsDown ? /*#__PURE__*/React__default.createElement(ThumbIcon, null, /*#__PURE__*/React__default.createElement(ButtonIcon, {
    "data-name": "ThumbDown",
    className: !thumbsClicked ? 'notselected' : '',
    onClick: !thumbsClicked && !disabled && handleThumbsDownClick,
    disabled: disabled || thumbsClicked,
    "data-analyticstrack": "thumbs-Down-Idle",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbsdown\"}",
    "data-clickstream": "thumbs-Down-Idle",
    tabIndex: tabIndex_value,
    role: "button",
    ariaLabel: "Thumbs Down",
    kind: "lowContrast",
    size: "large",
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React__default.createElement(Icon$1, {
        name: "thumbs-down",
        size: "medium",
        color: disabled ? '#d8dada' : '#000000'
      });
    }
  })) : /*#__PURE__*/React__default.createElement(ThumbIcon, null, /*#__PURE__*/React__default.createElement(ButtonIcon, {
    "data-name": "ThumbDown",
    className: !thumbsClicked ? 'notselected' : '',
    disabled: disabled || thumbsClicked,
    "data-analyticstrack": "thumbs-Down-On",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbsdown\"}",
    "data-clickstream": "thumbs-Down-On",
    kind: "lowContrast",
    size: "large",
    ariaLabel: "Thumbs Down",
    tabIndex: -1,
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React__default.createElement(Icon$1, {
        name: "thumbs-down-filled",
        size: "medium",
        color: disabled ? '#d8dada' : '#000000'
      });
    }
  })))) : /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      gap: '5px',
      alignItems: 'center'
    },
    tabIndex: -1
  }, /*#__PURE__*/React__default.createElement(Body, {
    color: disabled ? '#d8dada' : '#000000'
  }, "Was this helpful?"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '5px'
    }
  }, !showThumbsUp ? /*#__PURE__*/React__default.createElement(ThumbIcon, {
    "data-name": "ThumbUp",
    className: !thumbsClicked ? 'notselected' : '',
    onClick: !thumbsClicked && !disabled && handleThumbsUpClick,
    disabled: disabled || thumbsClicked,
    "data-analyticstrack": "thumbs-Up-Idle",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbs-Up-Idle\"}",
    "data-clickstream": "thumbs-Up-Idle",
    tabIndex: 0,
    role: "button",
    "aria-label": "Thumbs Up"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "thumbs-up",
    size: "medium",
    color: disabled ? '#d8dada' : '#000000'
  })) : /*#__PURE__*/React__default.createElement(ThumbIcon, {
    "data-name": "ThumbUp",
    className: !thumbsClicked ? 'notselected' : '',
    disabled: disabled || thumbsClicked,
    "data-analyticstrack": "thumbs-Up-On",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbs-Up-On\"}",
    "data-clickstream": "thumbs-Up-On"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "thumbs-up-filled",
    size: "medium",
    color: disabled ? '#d8dada' : '#000000'
  })), !showThumbsDown ? /*#__PURE__*/React__default.createElement(ThumbIcon, {
    "data-name": "ThumbDown",
    className: !thumbsClicked ? 'notselected' : '',
    onClick: !thumbsClicked && !disabled && handleThumbsDownClick,
    disabled: disabled || thumbsClicked,
    "data-analyticstrack": "thumbs-Down-Idle",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbs-Down-Idle\"}",
    "data-clickstream": "thumbs-Down-Idle",
    tabIndex: tabIndex_value,
    role: "button",
    "aria-label": "Thumbs Down"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "thumbs-down",
    size: "medium",
    color: disabled ? '#d8dada' : '#000000'
  })) : /*#__PURE__*/React__default.createElement(ThumbIcon, {
    "data-name": "ThumbDown",
    className: !thumbsClicked ? 'notselected' : '',
    disabled: disabled || thumbsClicked,
    "data-analyticstrack": "thumbs-Down-On",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbs-Down-On\"}",
    "data-clickstream": "thumbs-Down-On"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "thumbs-down-filled",
    size: "medium",
    color: disabled ? '#d8dada' : '#000000'
  }))))), /*#__PURE__*/React__default.createElement(FeedbackWrapperMobile, null, window.isMVODigital ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '25px'
    }
  }, /*#__PURE__*/React__default.createElement(Body, {
    color: disabled ? '#d8dada' : '#000000',
    size: "large"
  }, "Was this helpful?"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    }
  }, !showThumbsUp ? /*#__PURE__*/React__default.createElement(ThumbIcon, null, /*#__PURE__*/React__default.createElement(ButtonIcon, {
    "data-name": "ThumbUp",
    className: !thumbsClicked ? 'notselected' : '',
    onClick: !thumbsClicked && !disabled && handleThumbsUpClick,
    disabled: disabled || thumbsClicked,
    "data-analyticstrack": "thumbs-Up-Idle",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbsup\"}",
    "data-clickstream": "thumbs-Up-Idle",
    kind: "lowContrast",
    size: "large",
    ariaLabel: "Thumbs Up",
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React__default.createElement(Icon$1, {
        name: "thumbs-up",
        size: "medium",
        color: disabled ? '#d8dada' : '#000000'
      });
    }
  })) : /*#__PURE__*/React__default.createElement(ThumbIcon, null, /*#__PURE__*/React__default.createElement(ButtonIcon, {
    "data-name": "ThumbUp",
    className: !thumbsClicked ? 'notselected' : '',
    disabled: disabled || thumbsClicked,
    "data-analyticstrack": "thumbs-Up-On",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbsup\"}",
    "data-clickstream": "thumbs-Up-On",
    kind: "lowContrast",
    size: "large",
    ariaLabel: "Thumbs Up",
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React__default.createElement(Icon$1, {
        name: "thumbs-up-filled",
        size: "medium",
        color: disabled ? '#d8dada' : '#000000'
      });
    }
  })), !showThumbsDown ? /*#__PURE__*/React__default.createElement(ThumbIcon, null, /*#__PURE__*/React__default.createElement(ButtonIcon, {
    "data-name": "ThumbDown",
    className: !thumbsClicked ? 'notselected' : '',
    onClick: !thumbsClicked && !disabled && handleThumbsDownClick,
    disabled: disabled || thumbsClicked,
    "data-analyticstrack": "thumbs-Down-Idle",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbsdown\"}",
    "data-clickstream": "thumbs-Down-Idle",
    kind: "lowContrast",
    size: "large",
    ariaLabel: "Thumbs Down",
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React__default.createElement(Icon$1, {
        name: "thumbs-down",
        size: "medium",
        color: disabled ? '#d8dada' : '#000000'
      });
    }
  })) : /*#__PURE__*/React__default.createElement(ThumbIcon, null, /*#__PURE__*/React__default.createElement(ButtonIcon, {
    "data-name": "ThumbDown",
    className: !thumbsClicked ? 'notselected' : '',
    disabled: disabled || thumbsClicked,
    "data-analyticstrack": "thumbs-Down-On",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbsdown\"}",
    "data-clickstream": "thumbs-Down-On",
    kind: "lowContrast",
    size: "large",
    ariaLabel: "Thumbs Down",
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React__default.createElement(Icon$1, {
        name: "thumbs-down-filled",
        size: "medium",
        color: disabled ? '#d8dada' : '#000000'
      });
    }
  })))) : /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '5px'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '5px'
    }
  }, !showThumbsUp ? /*#__PURE__*/React__default.createElement(ThumbIcon, {
    "data-name": "ThumbUp",
    className: !thumbsClicked ? 'notselected' : '',
    onClick: !thumbsClicked && !disabled && handleThumbsUpClick,
    disabled: disabled || thumbsClicked,
    "data-analyticstrack": "thumbs-Up-Idle",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbs-Up-Idle\"}",
    "data-clickstream": "thumbs-Up-Idle"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "thumbs-up",
    size: "medium",
    color: disabled ? '#d8dada' : '#000000'
  })) : /*#__PURE__*/React__default.createElement(ThumbIcon, {
    "data-name": "ThumbUp",
    className: !thumbsClicked ? 'notselected' : '',
    disabled: disabled || thumbsClicked,
    "data-analyticstrack": "thumbs-Up-On",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbs-Up-On\"}",
    "data-clickstream": "thumbs-Up-On"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "thumbs-up-filled",
    size: "medium",
    color: disabled ? '#d8dada' : '#000000'
  })), !showThumbsDown ? /*#__PURE__*/React__default.createElement(ThumbIcon, {
    "data-name": "ThumbDown",
    className: !thumbsClicked ? 'notselected' : '',
    onClick: !thumbsClicked && !(props !== null && props !== void 0 && (_props$values4 = props.values) !== null && _props$values4 !== void 0 && _props$values4.thumbsUpClick) && !disabled && handleThumbsDownClick,
    disabled: disabled || thumbsClicked,
    "data-analyticstrack": "thumbs-Down-Idle",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbs-Down-Idle\"}",
    "data-clickstream": "thumbs-Down-Idle"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "thumbs-down",
    size: "medium",
    color: disabled ? '#d8dada' : '#000000'
  })) : /*#__PURE__*/React__default.createElement(ThumbIcon, {
    "data-name": "ThumbDown",
    className: !thumbsClicked ? 'notselected' : '',
    disabled: disabled || thumbsClicked,
    "data-analyticstrack": "thumbs-Down-On",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbs-Down-On\"}",
    "data-clickstream": "thumbs-Down-On"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "thumbs-down-filled",
    size: "medium",
    color: disabled ? '#d8dada' : '#000000'
  }))), /*#__PURE__*/React__default.createElement(Body, {
    color: disabled ? '#d8dada' : '#000000'
  }, "Was this helpful?"))), thumbsClicked && !submitClicked && (mvoConfig === null || mvoConfig === void 0 ? void 0 : mvoConfig.enableRatingsAndReview) === "true" && renderFeedback(), thumbsClicked && !submitClicked && (mvoConfig === null || mvoConfig === void 0 ? void 0 : mvoConfig.enableRatingsAndReview) === "false" && showThumbsDown && renderFeedbackMsg2(), thumbsClicked && !submitClicked && (mvoConfig === null || mvoConfig === void 0 ? void 0 : mvoConfig.enableRatingsAndReview) === "false" && showThumbsUp && renderFeedbackMsg3()));
};
FeedbackContainer.propTypes = {
  functions: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  flags: PropTypes.object.isRequired,
  page: PropTypes.string
};
FeedbackContainer.defaultProps = {};

var _templateObject$h, _templateObject2$d, _templateObject3$d, _templateObject4$d, _templateObject5$c, _templateObject6$a, _templateObject7$9, _templateObject8$9, _templateObject9$7;
var mvoConfig$4 = sessionUtility.getMvoConfig();
var ThumbsUpContainer$1 = styled.div(_templateObject$h || (_templateObject$h = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n\n  :focus-visible { outline:none; }\n \n"])));
var FeedbackTitle = styled.div(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteralLoose(["\n  align-self: start;\n  > h2 {\n    font-size: 24px !important;\n    font-weight: 700;\n  }\n"])));
var FeedbackConfrm = styled.div(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"])));
var ButtonsWrapper$5 = styled.div(_templateObject4$d || (_templateObject4$d = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: ", ";\n  // align-items: center;\n"])), function (props) {
  return props.isNewDesign ? 'left' : 'center';
});
var SubmitButtonWrapper = styled.div(_templateObject5$c || (_templateObject5$c = _taggedTemplateLiteralLoose(["\n  display:flex;\n  flex-direction:", ";\n  justify-content:center;\n  gap:12px;\n  width:100%;\n  @media (max-width: 767px){\n    position:absolute;\n    bottom:0px;\n\n  }\n"])), isMobile() ? 'column' : 'row');
var FeedbackWrapperVDS = styled.div(_templateObject6$a || (_templateObject6$a = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n   gap: 15px;\n"])));
var FeedbackWrapper$1 = styled.div(_templateObject7$9 || (_templateObject7$9 = _taggedTemplateLiteralLoose(["\n   @media screen and (max-width: 600px) {\n  //   display:none\n   }\n"])));
var ThumbsImg = styled.img(_templateObject8$9 || (_templateObject8$9 = _taggedTemplateLiteralLoose(["\n  width: 2.5rem;\n  cursor: ", ";\n"])), function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? "" : "pointer";
});
var FeedbackBoxMessage = styled.div(_templateObject9$7 || (_templateObject9$7 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between\n"])));
var FeedbackContainerModal = function FeedbackContainerModal(props) {
  var _configDetails$params19, _configDetails$params20, _configDetails$params21, _configDetails$params22;
  console.log("comren FeedbackContainerModal", props);
  var isMVA = window._dg_channelId === "VZW-MFA";
  var feedbackInpRef = useRef(null);
  useEffect(function () {
    if (feedbackInpRef.current !== null) {
      feedbackInpRef.current.focus();
    }
  }, []);
  var configDetails = useContext(ConfigContext);
  useEffect(function () {
    try {
      var _props$symptom, _configDetails$caseDe, _configDetails$select, _window, _window$vzdl;
      var page = "troubleshooter | " + ((props === null || props === void 0 ? void 0 : (_props$symptom = props.symptom) === null || _props$symptom === void 0 ? void 0 : _props$symptom.issueName) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$caseDe = configDetails.caseDetails) === null || _configDetails$caseDe === void 0 ? void 0 : _configDetails$caseDe.intent) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select = configDetails.selectedNSAIntent) === null || _configDetails$select === void 0 ? void 0 : _configDetails$select.intent)) + " | Feedback";
      if ((_window = window) !== null && _window !== void 0 && (_window$vzdl = _window.vzdl) !== null && _window$vzdl !== void 0 && _window$vzdl.page && typeof window.vzdl.page === "object") {
        window.vzdl.page.detail = page;
      } else {
        window.vzdl.page = {
          detail: page
        };
      }
      tagging.setPageView(window.vzdl, true);
    } catch (error) {
      console.error(error);
    }
  }, []);
  useEffect(function () {
    var data = document.querySelectorAll('div[id="modalDiv"]');
    var focusData = document.querySelector('span[data-analyticstrack="overlay-generic-cta"]');
    if (data) {
      focusData === null || focusData === void 0 ? void 0 : focusData.focus();
    }
  }, []);
  var _props$values = props.values,
    values = _props$values === void 0 ? {} : _props$values,
    acssCallId = props.acssCallId,
    isACSS = props.isACSS;
  var _values$troubleShooti = values.troubleShootingInfo,
    troubleShootingInfo = _values$troubleShooti === void 0 ? {} : _values$troubleShooti,
    _values$landingInfo = values.landingInfo,
    landingInfo = _values$landingInfo === void 0 ? {} : _values$landingInfo,
    _values$symptom = values.symptom,
    symptom = _values$symptom === void 0 ? {} : _values$symptom;
  var context = getObjectPropertyByPath('context', troubleShootingInfo, {});
  var _landingInfo$device = landingInfo.device,
    device = _landingInfo$device === void 0 ? {} : _landingInfo$device;
  var soeUrl = device.soeUrl;
  var issueName = symptom.issueName;
  var caseId = context.caseId;
  var _useState = useState(_extends({}, props.flags)),
    flags = _useState[0],
    setFlags = _useState[1];
  var aiSummryEnabled = isGenAIEnabled(values);
  var _useFeedback = useFeedback(),
    provideGenAIFeedback = _useFeedback.trigger;
  var _useState2 = useState('Please select'),
    dropDownValue = _useState2[0],
    setDropDownValue = _useState2[1];
  var _useState3 = useState({
      enableButton: false,
      userInput: ''
    }),
    feedbackValues = _useState3[0];
  var _useState4 = useState(''),
    feedbackMessage = _useState4[0],
    setFeedbackMessage = _useState4[1];
  var _useState5 = useState(0),
    feedbackCount = _useState5[0],
    setFeedbackCount = _useState5[1];
  var _useState6 = useState('Not clear enough'),
    subject = _useState6[0],
    setSubject = _useState6[1];
  var _useState7 = useState(true),
    btnShow = _useState7[0],
    setBtnShow = _useState7[1];
  var _useState8 = useState('Type here');
  var showThumbsUp = flags.showThumbsUp,
    showThumbsDown = flags.showThumbsDown,
    thumbsClicked = flags.thumbsClicked,
    submitClicked = flags.submitClicked,
    rating = flags.rating,
    justAfterThumbsDownClicked = flags.justAfterThumbsDownClicked;
  var userInput = feedbackValues.userInput;
  var handleThumbsUpClick = function handleThumbsUpClick() {
    console.log('handleThumbsUpClick flags');
    if (thumbsClicked) {
      return;
    }
    if (props.handleModalClick) {
      props.handleModalClick();
    }
    if (props.handleFeedbackFlags) {
      props.handleFeedbackFlags(_extends({}, flags, {
        rating: '5',
        showThumbsUp: true,
        thumbsClicked: true
      }));
    }
    setFlags(_extends({}, flags, {
      rating: '5',
      showThumbsUp: true,
      thumbsClicked: true
    }));
  };
  var handleThumbsDownClick = function handleThumbsDownClick() {
    console.log('handleThumbsDownClick flags');
    if (thumbsClicked) {
      return;
    }
    setFlags(_extends({}, flags, {
      rating: '1',
      justAfterThumbsDownClicked: true,
      thumbsClicked: true,
      showThumbsDown: true
    }));
  };
  var handleChange = function handleChange(event) {
    if (!props.isNewDesign) {
      setFeedbackMessage(event.target.value);
      if (event.target.value.length < 1 || dropDownValue === 'Please select') {
        setBtnShow(true);
      } else {
        setBtnShow(false);
      }
    } else {
      event.target.value.length <= 500 && setFeedbackMessage(event.target.value);
      event.target.value.length <= 500 && setFeedbackCount(event.target.value.length);
    }
  };
  var handleDropdonChange = function handleDropdonChange(e) {
    setDropDownValue(e.target.value);
    if (e.target.value === 'Please select' || !props.isNewDesign && feedbackMessage.length === 0) {
      setBtnShow(true);
    } else {
      setBtnShow(false);
    }
    console.log("testing handleDropdonChange", e.target.value);
    setSubject(e.target.value);
  };
  var handleSubmit = function handleSubmit() {
    var aiSummary = session('aiSummary').get();
    console.log({
      aiSummary: aiSummary,
      aiSummryEnabled: aiSummryEnabled
    });
    if (aiSummryEnabled && aiSummary !== null && aiSummary !== void 0 && aiSummary.vegasTransactionId) {
      provideGenAIFeedback({
        feedback: 1,
        vegasTransactionId: aiSummary === null || aiSummary === void 0 ? void 0 : aiSummary.vegasTransactionId,
        acssCallId: acssCallId,
        isACSS: isACSS
      });
    }
    console.log("feedback submit props", props, configDetails);
    var APIURL = "/digital/nsa/nos/gw/support/rating-and-reviews";
    var params = {
      rating: rating,
      review: userInput,
      productId: "troubleshooting|" + soeUrl + "|" + (issueName && issueName.replace(/[^\w\s]/g, '')) + "|" + caseId,
      title: issueName
    };
    var axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        "channelId": window._dg_channelId
      }
    };
    postHttpClientRequest(APIURL, params, axiosConfig);
    setFlags(_extends({}, flags, {
      showThumbsDown: true,
      submitClicked: true,
      justAfterThumbsDownClicked: false
    }));
    if (props.handleFeedbackFlags) {
      props.handleFeedbackFlags(_extends({}, flags, {
        showThumbsDown: true,
        thumbsClicked: true,
        submitClicked: true,
        justAfterThumbsDownClicked: false
      }));
    }
    if (props.handleModalClick) {
      props.handleModalClick();
    }
    if (props.functions.handleTroubleShootingAction) {
      var button = {
        "label": "Done",
        "action": "Done",
        "type": "secondary",
        "url": "",
        "callFunction": ""
      };
      var feedbackData = {
        feedbackMessage: feedbackMessage,
        feedbackSubject: subject
      };
      if (aiSummary !== null && aiSummary !== void 0 && aiSummary.vegasTransactionId) {
        feedbackData.aiSummary = true;
      }
      props.functions.handleTroubleShootingAction(button, {
        fromPage: props.fromPage,
        selectedIssueOptionStep: props.selectedIssueOptionStep,
        thumbsDownSubmittedStep: true,
        flags: _extends({}, flags, {
          showThumbsDown: true,
          thumbsClicked: true,
          submitClicked: true,
          justAfterThumbsDownClicked: false
        })
      }, feedbackData);
      window.scrollTo({
        left: 0,
        top: 0
      });
      props.handleCloseButton({
        done: true
      });
    }
  };
  var renderFeedback = function renderFeedback() {
    var _configDetails$params, _configDetails$params2, _configDetails$params3, _configDetails$params4, _configDetails$params5, _configDetails$params6, _configDetails$params7, _configDetails$params8, _configDetails$params9, _configDetails$params0, _configDetails$params1, _configDetails$params10, _configDetails$params11, _configDetails$params12, _configDetails$params13, _configDetails$params14, _configDetails$params15, _configDetails$params16;
    return /*#__PURE__*/React__default.createElement("div", {
      id: "feedbackBox1"
    }, /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "20px"
    }), !props.isNewDesign && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Body, {
      id: "bgColor",
      color: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : (_configDetails$params2 = _configDetails$params.theme) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.isDark) && "#FFF",
      size: "large",
      viewport: "desktop",
      primitive: "h3"
    }, "Please select an option from the drop menu and share your thoughts in the text box."), /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "20px"
    })), props.isNewDesign && /*#__PURE__*/React__default.createElement("h1", null, "Share your thoughts with us"), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(DropdownSelect, {
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params3 = configDetails.paramsDetails) !== null && _configDetails$params3 !== void 0 && (_configDetails$params4 = _configDetails$params3.theme) !== null && _configDetails$params4 !== void 0 && _configDetails$params4.isDark ? "dark" : "light",
      label: "Subject",
      onChange: function onChange(event) {
        return handleDropdonChange(event);
      },
      ariaLabel: "Subject"
    }, /*#__PURE__*/React__default.createElement("option", null, "Please select"), /*#__PURE__*/React__default.createElement("option", null, "Not clear enough"), /*#__PURE__*/React__default.createElement("option", null, "Broken Link"), /*#__PURE__*/React__default.createElement("option", null, "Other"), /*#__PURE__*/React__default.createElement("option", null, "Content Wrong"), /*#__PURE__*/React__default.createElement("option", null, "Content Missing"), /*#__PURE__*/React__default.createElement("option", null, " AI Summary "))), /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "20px"
    }), /*#__PURE__*/React__default.createElement(Body, {
      id: "bgColor",
      color: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params5 = configDetails.paramsDetails) === null || _configDetails$params5 === void 0 ? void 0 : (_configDetails$params6 = _configDetails$params5.theme) === null || _configDetails$params6 === void 0 ? void 0 : _configDetails$params6.isDark) && "#FFF",
      size: "medium",
      viewport: "desktop",
      primitive: "h3"
    }, props.isNewDesign ? "Feedback (optional)" : "Share your thoughts about how we can improve this experience."), /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "5px"
    }), /*#__PURE__*/React__default.createElement(TextArea$1, {
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params7 = configDetails.paramsDetails) !== null && _configDetails$params7 !== void 0 && (_configDetails$params8 = _configDetails$params7.theme) !== null && _configDetails$params8 !== void 0 && _configDetails$params8.isDark ? "dark" : "light",
      required: false,
      maxLength: null,
      "data-testid": "test-input",
      onChange: function onChange(e) {
        handleChange(e);
      }
    }), props.isNewDesign && /*#__PURE__*/React__default.createElement(FeedbackBoxMessage, null, /*#__PURE__*/React__default.createElement(Body, {
      size: "large",
      viewport: "desktop",
      primitive: "h2"
    }, "Please tell us about your experience"), /*#__PURE__*/React__default.createElement(Body, {
      size: "small",
      viewport: "desktop",
      primitive: "h2"
    }, feedbackCount, "/500")), !props.isNewDesign && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "20px"
    }), /*#__PURE__*/React__default.createElement(Body, {
      id: "bgColor",
      color: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params9 = configDetails.paramsDetails) === null || _configDetails$params9 === void 0 ? void 0 : (_configDetails$params0 = _configDetails$params9.theme) === null || _configDetails$params0 === void 0 ? void 0 : _configDetails$params0.isDark) && "#FFF",
      size: "large",
      viewport: "desktop",
      primitive: "h3"
    }, "This information will only be used by Verizon and will not be shared with third parties.")), /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "24px"
    }), props.isNewDesign ? /*#__PURE__*/React__default.createElement(ButtonsWrapper$5, {
      isNewDesign: props.isNewDesign
    }, /*#__PURE__*/React__default.createElement(Button$1, {
      onClick: function onClick() {
        return props.handleCloseButton();
      },
      size: "large",
      use: "secondary",
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params1 = configDetails.paramsDetails) !== null && _configDetails$params1 !== void 0 && (_configDetails$params10 = _configDetails$params1.theme) !== null && _configDetails$params10 !== void 0 && _configDetails$params10.isDark ? "dark" : "light",
      "data-track": "{\"type\": \"link\", \"name\": \"Cancel\"}",
      ariaLabel: "Cancel"
    }, "Cancel"), /*#__PURE__*/React__default.createElement("div", {
      style: {
        "margin": "0 10px"
      }
    }), /*#__PURE__*/React__default.createElement(Button$1, {
      onClick: handleSubmit,
      disabled: btnShow,
      size: "large",
      use: "primary",
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params11 = configDetails.paramsDetails) !== null && _configDetails$params11 !== void 0 && (_configDetails$params12 = _configDetails$params11.theme) !== null && _configDetails$params12 !== void 0 && _configDetails$params12.isDark ? "dark" : "light",
      "data-track": "{\"type\": \"link\", \"name\": \"Submit\"}",
      width: isMobile() || isMVA ? "100%" : "auto"
    }, "Submit")) : /*#__PURE__*/React__default.createElement(SubmitButtonWrapper, null, /*#__PURE__*/React__default.createElement(Button$1, {
      onClick: handleSubmit,
      disabled: btnShow,
      size: "large",
      use: "primary",
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params13 = configDetails.paramsDetails) !== null && _configDetails$params13 !== void 0 && (_configDetails$params14 = _configDetails$params13.theme) !== null && _configDetails$params14 !== void 0 && _configDetails$params14.isDark ? "dark" : "light",
      "data-track": "{\"type\": \"link\", \"name\": \"Submit\"}",
      width: isMobile() || isMVA ? "100%" : "auto"
    }, "Submit"), /*#__PURE__*/React__default.createElement(TextLink, {
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params15 = configDetails.paramsDetails) !== null && _configDetails$params15 !== void 0 && (_configDetails$params16 = _configDetails$params15.theme) !== null && _configDetails$params16 !== void 0 && _configDetails$params16.isDark ? "dark" : "light",
      onClick: function onClick() {
        return props.handleCloseButton();
      },
      "data-track": "{\"type\": \"link\", \"name\": \"Cancel\"}",
      ariaLabel: "Cancel"
    }, "Cancel")));
  };
  var modalClose = function modalClose(e) {
    return props.handleCloseButton({
      done: true
    });
  };
  var renderFeedbackMsg = function renderFeedbackMsg() {
    var _configDetails$params17, _configDetails$params18;
    return /*#__PURE__*/React__default.createElement("div", {
      id: "feedbackBox2",
      style: {
        textAlign: "center"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      style: {
        paddingTop: "10%",
        fontWeight: 700
      }
    }, "Thanks for helping us improve."), /*#__PURE__*/React__default.createElement("div", {
      style: {
        paddingTop: "10%",
        display: "flex",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React__default.createElement(Button$1, {
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params17 = configDetails.paramsDetails) !== null && _configDetails$params17 !== void 0 && (_configDetails$params18 = _configDetails$params17.theme) !== null && _configDetails$params18 !== void 0 && _configDetails$params18.isDark ? "dark" : "light",
      "data-track": "{\"type\": \"link\", \"name\": \"Done\"}",
      use: "primary",
      ariaLabel: "done",
      onClick: function onClick(e) {
        return modalClose();
      }
    }, "Done")));
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, !props.isNewDesign && /*#__PURE__*/React__default.createElement(ThumbsUpContainer$1, {
    ref: feedbackInpRef,
    tabIndex: window.isMVODigital ? "-1" : "0",
    primitive: "h2",
    "aria-label": (thumbsClicked || justAfterThumbsDownClicked) && !submitClicked && showThumbsDown ? 'What was wrong?' : 'Was this helpful?'
  }, showThumbsUp && /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "20px"
  }), window._dg_channelId !== 'VZW-MFA' ? /*#__PURE__*/React__default.createElement("div", {
    id: "modalDiv",
    style: {
      marginLeft: 0
    }
  }, /*#__PURE__*/React__default.createElement(Title, {
    id: "bgColor",
    color: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params19 = configDetails.paramsDetails) === null || _configDetails$params19 === void 0 ? void 0 : (_configDetails$params20 = _configDetails$params19.theme) === null || _configDetails$params20 === void 0 ? void 0 : _configDetails$params20.isDark) && '#FFF',
    primitive: "h2",
    size: "medium",
    bold: true
  }, (thumbsClicked || justAfterThumbsDownClicked) && !submitClicked && showThumbsDown ? 'What was wrong?' : 'Was this helpful?')) : /*#__PURE__*/React__default.createElement(FeedbackTitle, {
    id: "feedbackBox"
  }, /*#__PURE__*/React__default.createElement(Body, {
    id: "bgColor",
    color: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params21 = configDetails.paramsDetails) === null || _configDetails$params21 === void 0 ? void 0 : (_configDetails$params22 = _configDetails$params21.theme) === null || _configDetails$params22 === void 0 ? void 0 : _configDetails$params22.isDark) && '#FFF',
    size: "large",
    viewport: "desktop",
    primitive: "h2",
    bold: true
  }, (thumbsClicked || justAfterThumbsDownClicked) && !submitClicked && showThumbsDown ? 'What was wrong?' : 'Was this helpful?')), !justAfterThumbsDownClicked && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "30px"
  }), window.isMVODigital ? /*#__PURE__*/React__default.createElement(FeedbackWrapperVDS, null, !showThumbsUp ? /*#__PURE__*/React__default.createElement(ButtonIcon, {
    role: "button",
    ariaLabel: "Thumbs Up",
    kind: "lowContrast",
    size: "large",
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React__default.createElement(Icon$1, {
        name: "thumbs-up",
        size: "medium"
      });
    },
    alt: "thumbs_up",
    "data-name": "ThumbUp",
    className: !(thumbsClicked || justAfterThumbsDownClicked) ? 'notselected' : '',
    onClick: handleThumbsUpClick,
    disabled: thumbsClicked || justAfterThumbsDownClicked,
    "data-analyticstrack": "thumbs-Up-Idle",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbsup\"}",
    "data-clickstream": "thumbs-Up-Idle",
    "data-testid": 'thumbsup'
  }) : /*#__PURE__*/React__default.createElement(ButtonIcon, {
    kind: "lowContrast",
    size: "large",
    tabIndex: -1,
    ariaLabel: "Thumbs Up",
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React__default.createElement(Icon$1, {
        name: "thumbs-up-filled",
        size: "medium"
      });
    },
    alt: "thumbs_up",
    "data-name": "ThumbUp",
    className: !(thumbsClicked || justAfterThumbsDownClicked) ? 'notselected' : '',
    disabled: thumbsClicked || justAfterThumbsDownClicked,
    "data-analyticstrack": "thumbs-Up-On",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbup\"}",
    "data-clickstream": "thumbs-Up-On"
  }), !showThumbsDown ? /*#__PURE__*/React__default.createElement(ButtonIcon, {
    role: "button",
    ariaLabel: "Thumbs Down",
    kind: "lowContrast",
    size: "large",
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React__default.createElement(Icon$1, {
        name: "thumbs-down",
        size: "medium"
      });
    },
    alt: "thumbs_down",
    "data-name": "ThumbDown",
    className: !(thumbsClicked || justAfterThumbsDownClicked) ? 'notselected' : '',
    onClick: handleThumbsDownClick,
    disabled: thumbsClicked || justAfterThumbsDownClicked,
    "data-analyticstrack": "thumbs-Down-Idle",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbsdown\"}",
    "data-clickstream": "thumbs-Down-Idle",
    "data-testid": 'thumbsdown'
  }) : /*#__PURE__*/React__default.createElement(ButtonIcon, {
    kind: "lowContrast",
    size: "large",
    ariaLabel: "Thumbs Down",
    tabIndex: -1,
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React__default.createElement(Icon$1, {
        name: "thumbs-down-filled",
        size: "medium",
        color: "#000000"
      });
    },
    alt: "thumbs_up",
    "data-name": "ThumbDown",
    className: !(thumbsClicked || justAfterThumbsDownClicked) ? 'notselected' : '',
    disabled: thumbsClicked || justAfterThumbsDownClicked,
    "data-analyticstrack": "thumbs-Down-On",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbsdown\"}",
    "data-clickstream": "thumbs-Down-On"
  })) : /*#__PURE__*/React__default.createElement(FeedbackWrapper$1, null, !showThumbsUp ? /*#__PURE__*/React__default.createElement(ThumbsImg, {
    alt: "thumbs_up",
    "data-name": "ThumbUp",
    src: "https://scache.vzw.com/content/dam/support/social-share/Up_Idle.png",
    className: !(thumbsClicked || justAfterThumbsDownClicked) ? 'notselected' : '',
    onClick: handleThumbsUpClick,
    disabled: thumbsClicked || justAfterThumbsDownClicked,
    "data-analyticstrack": "thumbs-Up-Idle",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbsup\"}",
    "data-clickstream": "thumbs-Up-Idle",
    "data-testid": 'thumbsup'
  }) : /*#__PURE__*/React__default.createElement(ThumbsImg, {
    alt: "thumbs_up",
    "data-name": "ThumbUp",
    src: "https://scache.vzw.com/content/dam/support/social-share/Up_On.png",
    className: !(thumbsClicked || justAfterThumbsDownClicked) ? 'notselected' : '',
    disabled: thumbsClicked || justAfterThumbsDownClicked,
    "data-analyticstrack": "thumbs-Up-On",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbup\"}",
    "data-clickstream": "thumbs-Up-On"
  }), !showThumbsDown ? /*#__PURE__*/React__default.createElement(ThumbsImg, {
    alt: "thumbs_down",
    "data-name": "ThumbDown",
    src: "https://scache.vzw.com/content/dam/support/social-share/Down_Idle.png",
    className: !(thumbsClicked || justAfterThumbsDownClicked) ? 'notselected' : '',
    onClick: handleThumbsDownClick,
    disabled: thumbsClicked || justAfterThumbsDownClicked,
    "data-analyticstrack": "thumbs-Down-Idle",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbsdown\"}",
    "data-clickstream": "thumbs-Down-Idle",
    "data-testid": 'thumbsdown'
  }) : /*#__PURE__*/React__default.createElement(ThumbsImg, {
    alt: "thumbs_up",
    "data-name": "ThumbDown",
    src: "https://scache.vzw.com/content/dam/support/social-share/Down_On.png",
    className: !(thumbsClicked || justAfterThumbsDownClicked) ? 'notselected' : '',
    disabled: thumbsClicked || justAfterThumbsDownClicked,
    "data-analyticstrack": "thumbs-Down-On",
    "data-track": "{\"type\": \"icon\", \"name\": \"thumbsdown\"}",
    "data-clickstream": "thumbs-Down-On"
  })))), thumbsClicked && !submitClicked && justAfterThumbsDownClicked && renderFeedback(), thumbsClicked && (!submitClicked && showThumbsUp || submitClicked && showThumbsDown) && renderFeedbackMsg(), submitClicked && !(submitClicked && showThumbsDown) && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(FeedbackConfrm, {
    id: "Feedbackconf"
  }, /*#__PURE__*/React__default.createElement(Body, {
    size: "large",
    viewport: "desktop",
    primitive: "h1"
  }, "Thanks for letting us know."))));
};
FeedbackContainerModal.propTypes = {
  functions: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
};
FeedbackContainerModal.defaultProps = {};

var runMode$1 = process.env.NODE_ENV;
var envConfig$1 = tsaEnvConfig(runMode$1);
console.log("process.env.NODE_ENV====", process.env.NODE_ENV);
axios.interceptors.request.use(function (config) {
  var _ref, _window$config$_dg_ch, _window$config;
  console.log("Interceptors--->", config);
  var channelId = (_ref = (_window$config$_dg_ch = (_window$config = window.config) === null || _window$config === void 0 ? void 0 : _window$config._dg_channelId) != null ? _window$config$_dg_ch : localStorage.getItem('channelId')) != null ? _ref : '';
  config.headers.channelId = channelId;
  return config;
}, function (error) {
  Promise.reject(error);
});
var callAxios$2 = function callAxios(url, method, data, headers) {
  try {
    var _ref2, _window$config$_dg_ch2, _window$config2, _window$config3;
    var response = false;
    var axiosConfig = {
      url: url,
      timeout: 300000,
      responseType: "json",
      method: method,
      data: data ? JSON.stringify(data) : "",
      headers: _extends({}, headers, {
        Accept: "application/json",
        "Content-Type": "application/json",
        channelId: (_ref2 = (_window$config$_dg_ch2 = (_window$config2 = window.config) === null || _window$config2 === void 0 ? void 0 : _window$config2._dg_channelId) != null ? _window$config$_dg_ch2 : data === null || data === void 0 ? void 0 : data.channelId) != null ? _ref2 : ""
      })
    };
    ((_window$config3 = window.config) === null || _window$config3 === void 0 ? void 0 : _window$config3.isAcss) && (axiosConfig.withCredentials = true);
    return Promise.resolve(axios(axiosConfig).then(function (resp, headers) {
      response = {
        success: true,
        response: resp,
        headers: headers
      };
    })["catch"](function (err, headers) {
      response = {
        success: false,
        error: err,
        headers: headers
      };
    })).then(function () {
      return response;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var getHealthCheckData = function getHealthCheckData(key, req) {
  try {
    var callMethod = runMode$1 === "development" ? "get" : "post";
    var response = null;
    var URL = key === "poll-device-hlth" ? envConfig$1.apiUrls.pollDeviceHealth : envConfig$1.apiUrls.getDeviceHealth;
    var _temp = _catch(function () {
      return Promise.resolve(callAxios$2(URL, callMethod, req, {})).then(function (_callAxios) {
        response = _callAxios;
      });
    }, function (error) {
      console.log(error, "healthcheck call failed");
    });
    return Promise.resolve(_temp && _temp.then ? _temp.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getNetworkDisruptionData = function getNetworkDisruptionData(req) {
  try {
    var callMethod = runMode$1 === "development" ? "get" : "post";
    var response = null;
    var URL = envConfig$1.apiUrls.getNetworkOutage;
    var _temp2 = _catch(function () {
      return Promise.resolve(callAxios$2(URL, callMethod, req, {})).then(function (_callAxios2) {
        response = _callAxios2;
      });
    }, function (error) {
      console.log(error, "getNetworkDisruption call failed");
    });
    return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getNetworkData = function getNetworkData(req) {
  try {
    var callMethod = runMode$1 === "development" ? "get" : "post";
    var response = null;
    var URL = envConfig$1.apiUrls.getNetworkTroubleshootingData;
    var headers = {
      Cassandraenabled: "Y"
    };
    var _temp3 = _catch(function () {
      return Promise.resolve(callAxios$2(URL, callMethod, req, headers)).then(function (_callAxios3) {
        response = _callAxios3;
      });
    }, function (error) {
      console.log(error, "getNetworkData call failed");
    });
    return Promise.resolve(_temp3 && _temp3.then ? _temp3.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getDeviceData = function getDeviceData(req) {
  try {
    var callMethod = runMode$1 === "development" ? "get" : "post";
    var response = null;
    var URL = envConfig$1.apiUrls.getTroubleshootingDeviceDetails;
    console.log("URL=====", URL);
    var headers = {
      Cassandraenabled: "Y"
    };
    var _temp4 = _catch(function () {
      return Promise.resolve(callAxios$2(URL, callMethod, req, headers)).then(function (_callAxios4) {
        response = _callAxios4;
      });
    }, function (error) {
      console.log(error, "getDeviceData call failed");
    });
    return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getProfileData = function getProfileData(req) {
  try {
    var callMethod = runMode$1 === "development" ? "get" : "post";
    var response = null;
    var URL = envConfig$1.apiUrls.getProfileData;
    var _temp5 = _catch(function () {
      return Promise.resolve(callAxios$2(URL, callMethod, req)).then(function (_callAxios5) {
        response = _callAxios5;
      });
    }, function (error) {
      console.log(error, "getProfileData call failed");
    });
    return Promise.resolve(_temp5 && _temp5.then ? _temp5.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getLoadLinks = function getLoadLinks(req) {
  try {
    var callMethod = runMode$1 === "development" ? "get" : "post";
    var response = null;
    var URL = envConfig$1.apiUrls.getLoadLinks;
    var headers = {
      Cassandraenabled: "Y"
    };
    var _temp6 = _catch(function () {
      return Promise.resolve(callAxios$2(URL, callMethod, req, headers)).then(function (_callAxios6) {
        response = _callAxios6;
      });
    }, function (error) {
      console.log(error, "getLoadLinks call failed");
    });
    return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getDeviceDiagnostics = function getDeviceDiagnostics(req) {
  try {
    var callMethod = runMode$1 === "development" ? "get" : "post";
    var response = null;
    var URL = envConfig$1.apiUrls.getDeviceDiagnostics;
    var headers = {
      Cassandraenabled: "Y"
    };
    var _temp7 = _catch(function () {
      return Promise.resolve(callAxios$2(URL, callMethod, req, headers)).then(function (_callAxios7) {
        response = _callAxios7;
      });
    }, function (error) {
      console.log(error, "getDeviceDiagnostics call failed");
    });
    return Promise.resolve(_temp7 && _temp7.then ? _temp7.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getSpeedTestHistory = function getSpeedTestHistory(req) {
  try {
    var callMethod = runMode$1 === "development" ? "get" : "post";
    var response = null;
    var URL = envConfig$1.apiUrls.getSpeedTestHistory;
    var _temp8 = _catch(function () {
      return Promise.resolve(callAxios$2(URL, callMethod, req)).then(function (_callAxios8) {
        response = _callAxios8;
      });
    }, function (error) {
      console.log(error, "getSpeedTestHistory call failed");
    });
    return Promise.resolve(_temp8 && _temp8.then ? _temp8.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getSpeedTest = function getSpeedTest(req) {
  try {
    var callMethod = runMode$1 === "development" ? "get" : "post";
    var response = null;
    var URL = envConfig$1.apiUrls.getSpeedTest;
    var _temp9 = _catch(function () {
      return Promise.resolve(callAxios$2(URL, callMethod, req)).then(function (_callAxios9) {
        response = _callAxios9;
      });
    }, function (error) {
      console.log(error, "getSpeedTest call failed");
    });
    return Promise.resolve(_temp9 && _temp9.then ? _temp9.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getWifiAnalyzerData = function getWifiAnalyzerData(req) {
  try {
    var callMethod = runMode$1 === "development" ? "get" : "post";
    var response = null;
    var URL = envConfig$1.apiUrls.getWifiAnalyzerData;
    var _temp0 = _catch(function () {
      return Promise.resolve(callAxios$2(URL, callMethod, req)).then(function (_callAxios0) {
        response = _callAxios0;
      });
    }, function (error) {
      console.log(error, "getWifiAnalyzerData call failed");
    });
    return Promise.resolve(_temp0 && _temp0.then ? _temp0.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getWifiAnalyzerRawData = function getWifiAnalyzerRawData(req) {
  try {
    var callMethod = runMode$1 === "development" ? "get" : "post";
    var response = null;
    var URL = envConfig$1.apiUrls.getWifiAnalyzerRawData;
    var _temp1 = _catch(function () {
      return Promise.resolve(callAxios$2(URL, callMethod, req)).then(function (_callAxios1) {
        response = _callAxios1;
      });
    }, function (error) {
      console.log(error, "getWifiAnalyzerRawData call failed");
    });
    return Promise.resolve(_temp1 && _temp1.then ? _temp1.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getRebootAndReset = function getRebootAndReset(req) {
  try {
    var callMethod = runMode$1 === "development" ? "get" : "post";
    var response = null;
    var URL = envConfig$1.apiUrls.getRebootAndReset;
    var _temp10 = _catch(function () {
      return Promise.resolve(callAxios$2(URL, callMethod, req)).then(function (_callAxios10) {
        response = _callAxios10;
      });
    }, function (error) {
      console.log(error, "getRebootAndReset call failed");
    });
    return Promise.resolve(_temp10 && _temp10.then ? _temp10.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getSimStatus = function getSimStatus(req) {
  try {
    var callMethod = runMode$1 === "development" ? "get" : "post";
    var response = null;
    var headers = {
      Cassandraenabled: "Y"
    };
    var URL = envConfig$1.apiUrls.getLoadLTESimStatus;
    var _temp11 = _catch(function () {
      return Promise.resolve(callAxios$2(URL, callMethod, req, headers)).then(function (_callAxios11) {
        response = _callAxios11;
      });
    }, function (error) {
      console.log(error, "getLoadLTESimStatus call failed");
    });
    return Promise.resolve(_temp11 && _temp11.then ? _temp11.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getGuardedLinkPinPukService = function getGuardedLinkPinPukService(req) {
  try {
    var callMethod = runMode$1 === "development" ? "get" : "post";
    var response = null;
    var headers = {
      Cassandraenabled: "Y"
    };
    var URL = envConfig$1.apiUrls.getGuardedLinkPinPukService;
    var _temp12 = _catch(function () {
      return Promise.resolve(callAxios$2(URL, callMethod, req, headers)).then(function (_callAxios12) {
        response = _callAxios12;
      });
    }, function (error) {
      console.log(error, "getGuardedLinkPinPukService call failed");
    });
    return Promise.resolve(_temp12 && _temp12.then ? _temp12.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getQuerySimService = function getQuerySimService(req) {
  try {
    var callMethod = runMode$1 === "development" ? "get" : "post";
    var response = null;
    var headers = {
      Cassandraenabled: "Y"
    };
    var URL = envConfig$1.apiUrls.getQuerySimService;
    var _temp13 = _catch(function () {
      return Promise.resolve(callAxios$2(URL, callMethod, req, headers)).then(function (_callAxios13) {
        response = _callAxios13;
      });
    }, function (error) {
      console.log(error, "getQuerySimService call failed");
    });
    return Promise.resolve(_temp13 && _temp13.then ? _temp13.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getValidateEmail = function getValidateEmail(req) {
  try {
    var callMethod = runMode$1 === "development" ? "get" : "post";
    var response = null;
    var headers = {
      Cassandraenabled: "Y"
    };
    var URL = envConfig$1.apiUrls.getValidateEmail;
    var _temp14 = _catch(function () {
      return Promise.resolve(callAxios$2(URL, callMethod, req, headers)).then(function (_callAxios14) {
        response = _callAxios14;
      });
    }, function (error) {
      console.log(error, "getValidateEmail call failed");
    });
    return Promise.resolve(_temp14 && _temp14.then ? _temp14.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getOneMessageEmailService = function getOneMessageEmailService(req) {
  try {
    var callMethod = runMode$1 === "development" ? "get" : "post";
    var response = null;
    var headers = {
      Cassandraenabled: "Y"
    };
    var URL = envConfig$1.apiUrls.getOneMessageEmailService;
    var _temp15 = _catch(function () {
      return Promise.resolve(callAxios$2(URL, callMethod, req, headers)).then(function (_callAxios15) {
        response = _callAxios15;
      });
    }, function (error) {
      console.log(error, "getOneMessageEmailService call failed");
    });
    return Promise.resolve(_temp15 && _temp15.then ? _temp15.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getMvaFreeTrial = function getMvaFreeTrial(req) {
  try {
    var callMethod = runMode$1 === "development" ? "get" : "post";
    var response = null;
    var headers = {
      Cassandraenabled: "Y"
    };
    var URL = envConfig$1.apiUrls.getMvaFreeTrial;
    var _temp16 = _catch(function () {
      return Promise.resolve(callAxios$2(URL, callMethod, req, headers)).then(function (_callAxios16) {
        response = _callAxios16;
      });
    }, function (error) {
      console.log(error, "getMvaFreeTrial call failed");
    });
    return Promise.resolve(_temp16 && _temp16.then ? _temp16.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getModelService = function getModelService(req) {
  try {
    var callMethod = runMode$1 === "development" ? "get" : "post";
    var response = null;
    var headers = {
      Cassandraenabled: "Y"
    };
    var URL = envConfig$1.apiUrls.getModelService;
    var _temp17 = _catch(function () {
      return Promise.resolve(callAxios$2(URL, callMethod, req, headers)).then(function (_callAxios17) {
        response = _callAxios17;
      });
    }, function (error) {
      console.log(error, "getModelService call failed");
    });
    return Promise.resolve(_temp17 && _temp17.then ? _temp17.then(function () {
      return response;
    }) : response);
  } catch (e) {
    return Promise.reject(e);
  }
};

var DEFAULT_REFETCH_INTERVAL = 4000;
var DEFAULT_POLL_LIMIT = 10;
var useNetworkOutage = function useNetworkOutage(_ref) {
  var _data$response, _data$response$data;
  var mdn = _ref.mdn,
    accountNo = _ref.accountNo,
    outageType = _ref.outageType,
    networkOutageFeatureFlag = _ref.networkOutageFeatureFlag;
  console.log("networkOutageFeatureFlag->", networkOutageFeatureFlag);
  var enableNetworkoutageCall = networkOutageFeatureFlag === null || networkOutageFeatureFlag === void 0 ? void 0 : networkOutageFeatureFlag.status;
  var paylod = {
    mtn: mdn,
    accountNumber: accountNo,
    eventSubType: outageType
  };
  var fetcher = function fetcher() {
    try {
      return Promise.resolve(getNetworkDisruptionData(paylod));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var _useSWRImmutable = useSWRImmutable(function () {
      return enableNetworkoutageCall ? "network_disruption_" + mdn : null;
    }, fetcher),
    data = _useSWRImmutable.data,
    error = _useSWRImmutable.error,
    isLoading = _useSWRImmutable.isLoading;
  return {
    outageData: data === null || data === void 0 ? void 0 : (_data$response = data.response) === null || _data$response === void 0 ? void 0 : (_data$response$data = _data$response.data) === null || _data$response$data === void 0 ? void 0 : _data$response$data.body,
    isLoading: isLoading,
    error: error
  };
};
var useHealthCheck = function useHealthCheck(props) {
  var _healthdata$response, _healthdata$response$, _healthdata$response$2, _pollDataInCache$resp, _pollDataInCache$resp2, _pollDataInCache$resp3, _healthdata$response2, _healthdata$response3, _healthdata$response4;
  var _useState = useState(false),
    shouldPoll = _useState[0],
    setShouldPoll = _useState[1];
  var _useFeatureFlag = useFeatureFlag(),
    _useFeatureFlag$data = _useFeatureFlag.data,
    _useFeatureFlag$data2 = _useFeatureFlag$data === void 0 ? {} : _useFeatureFlag$data,
    _useFeatureFlag$data3 = _useFeatureFlag$data2.healthCheckDiagnosticsFFlag,
    healthCheckDiagnosticsFFlag = _useFeatureFlag$data3 === void 0 ? false : _useFeatureFlag$data3;
  var _useOtherContent = useOtherContent(),
    _useOtherContent$data = _useOtherContent.data,
    _useOtherContent$data2 = _useOtherContent$data === void 0 ? {} : _useOtherContent$data,
    _useOtherContent$data3 = _useOtherContent$data2.configData,
    _useOtherContent$data4 = _useOtherContent$data3 === void 0 ? {} : _useOtherContent$data3,
    _useOtherContent$data5 = _useOtherContent$data4.pollDelay,
    pollDelay = _useOtherContent$data5 === void 0 ? '5000' : _useOtherContent$data5;
  var _props$accountNumber = props.accountNumber,
    accountNumber = _props$accountNumber === void 0 ? '' : _props$accountNumber,
    _props$channel = props.channel,
    channel = _props$channel === void 0 ? '' : _props$channel,
    _props$tier = props.tier,
    tier = _props$tier === void 0 ? '' : _props$tier,
    _props$mdn = props.mdn,
    mdn = _props$mdn === void 0 ? '' : _props$mdn,
    _props$sku = props.sku,
    sku = _props$sku === void 0 ? '' : _props$sku,
    _props$equipmentId = props.equipmentId,
    equipmentId = _props$equipmentId === void 0 ? '' : _props$equipmentId,
    _props$acssCallId = props.acssCallId,
    acssCallId = _props$acssCallId === void 0 ? '' : _props$acssCallId,
    _props$loggedInUser = props.loggedInUser,
    loggedInUser = _props$loggedInUser === void 0 ? '' : _props$loggedInUser;
  console.log("useHealthCheck--->", props);
  var modifiedChannel = (channel === null || channel === void 0 ? void 0 : channel.toLowerCase()) === 'care' ? "Care" : channel;
  var healthCheckPayload = {
    channelId: modifiedChannel,
    tierId: tier,
    loggedInUser: loggedInUser,
    processStep: "",
    callerId: acssCallId,
    accountNumber: accountNumber,
    mtn: mdn,
    deviceSku: sku,
    equipmentId: equipmentId,
    categorizeIntent: true,
    topIntents: false,
    isOptimisedFlow: true,
    healthCheckDiagnostics: true
  };
  var fetcher = function fetcher() {
    try {
      var _ref2 = arguments.length <= 0 ? undefined : arguments[0],
        key = _ref2[0],
        req = _ref2[1];
      return Promise.resolve(getHealthCheckData(key, req)).then(function (resp) {
        mutate(key, resp, false);
        return resp;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var getCacheKey = function getCacheKey() {
    if (healthCheckDiagnosticsFFlag && equipmentId && mdn && sku) {
      return ['get-device-hlth', healthCheckPayload];
    }
    return null;
  };
  var _useSWRImmutable2 = useSWRImmutable(getCacheKey(), fetcher, {
      onSuccess: function onSuccess(data) {
        var _data$response2, _data$response2$data, _data$response2$data$;
        console.log("get-device-hlth", data);
        var resp = (data === null || data === void 0 ? void 0 : (_data$response2 = data.response) === null || _data$response2 === void 0 ? void 0 : (_data$response2$data = _data$response2.data) === null || _data$response2$data === void 0 ? void 0 : (_data$response2$data$ = _data$response2$data.body) === null || _data$response2$data$ === void 0 ? void 0 : _data$response2$data$.context) || {};
        var _ref3 = resp || {},
          processStep = _ref3.processStep;
        setTimeout(function () {
          setShouldPoll(processStep === "DeviceHealthPoll");
        }, pollDelay);
      }
    }),
    healthdata = _useSWRImmutable2.data,
    isLoading = _useSWRImmutable2.isLoading,
    error = _useSWRImmutable2.error;
  var _ref4 = (healthdata === null || healthdata === void 0 ? void 0 : (_healthdata$response = healthdata.response) === null || _healthdata$response === void 0 ? void 0 : (_healthdata$response$ = _healthdata$response.data) === null || _healthdata$response$ === void 0 ? void 0 : (_healthdata$response$2 = _healthdata$response$.body) === null || _healthdata$response$2 === void 0 ? void 0 : _healthdata$response$2.context) || {},
    caseId = _ref4.caseId;
  var devicePollPayload = _extends({}, healthCheckPayload, {
    processStep: "DeviceHealthPoll",
    caseId: caseId
  });
  var getPollKey = function getPollKey() {
    if (healthCheckDiagnosticsFFlag && shouldPoll && mdn && sku && equipmentId && caseId) {
      return ['poll-device-hlth', devicePollPayload];
    }
    return null;
  };
  console.log("useHealthCheck payload--->", healthCheckPayload, devicePollPayload);
  var _useSWRImmutable3 = useSWRImmutable(getPollKey(), fetcher, {
      onSuccess: function onSuccess(data) {
        var _data$response3, _data$response3$data, _data$response3$data$;
        console.log("poll-device-hlth", data);
        var resp = (data === null || data === void 0 ? void 0 : (_data$response3 = data.response) === null || _data$response3 === void 0 ? void 0 : (_data$response3$data = _data$response3.data) === null || _data$response3$data === void 0 ? void 0 : (_data$response3$data$ = _data$response3$data.body) === null || _data$response3$data$ === void 0 ? void 0 : _data$response3$data$.context) || {};
        var _ref5 = resp || {},
          processStep = _ref5.processStep;
        if (processStep !== "DeviceHealthPoll") {
          setShouldPoll(false);
        }
      },
      refreshInterval: function refreshInterval(data) {
        var _data$response4, _data$response4$data, _data$response4$data$;
        var resp = (data === null || data === void 0 ? void 0 : (_data$response4 = data.response) === null || _data$response4 === void 0 ? void 0 : (_data$response4$data = _data$response4.data) === null || _data$response4$data === void 0 ? void 0 : (_data$response4$data$ = _data$response4$data.body) === null || _data$response4$data$ === void 0 ? void 0 : _data$response4$data$.context) || {};
        var processStep = resp === null || resp === void 0 ? void 0 : resp.processStep;
        return processStep === "DeviceHealthPoll" && caseId === (resp === null || resp === void 0 ? void 0 : resp.caseId) ? pollDelay : 0;
      },
      refreshWhenHidden: true,
      keepPreviousData: true
    }),
    pollLoading = _useSWRImmutable3.isLoading,
    pollError = _useSWRImmutable3.error,
    mutate$1 = _useSWRImmutable3.mutate;
  var _useSWR = useSWR(['poll-device-hlth', devicePollPayload], null, {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      revalidateIfStale: false
    }),
    pollDataInCache = _useSWR.data;
  console.log("pollData-->", pollDataInCache);
  var resolvedResp = (pollDataInCache === null || pollDataInCache === void 0 ? void 0 : (_pollDataInCache$resp = pollDataInCache.response) === null || _pollDataInCache$resp === void 0 ? void 0 : (_pollDataInCache$resp2 = _pollDataInCache$resp.data) === null || _pollDataInCache$resp2 === void 0 ? void 0 : (_pollDataInCache$resp3 = _pollDataInCache$resp2.body) === null || _pollDataInCache$resp3 === void 0 ? void 0 : _pollDataInCache$resp3.context) || (healthdata === null || healthdata === void 0 ? void 0 : (_healthdata$response2 = healthdata.response) === null || _healthdata$response2 === void 0 ? void 0 : (_healthdata$response3 = _healthdata$response2.data) === null || _healthdata$response3 === void 0 ? void 0 : (_healthdata$response4 = _healthdata$response3.body) === null || _healthdata$response4 === void 0 ? void 0 : _healthdata$response4.context) || {};
  useEffect(function () {
    if (pollDataInCache) {
      setShouldPoll(true);
      mutate$1(['poll-device-hlth', devicePollPayload]).then(function (data) {
        console.log("In mutate", data);
      });
    }
  }, [equipmentId]);
  return {
    data: resolvedResp,
    isLoading: isLoading || pollLoading,
    error: error || pollError
  };
};
var useDeviceData = function useDeviceData(props) {
  var _window, _window$caseDetails, _window2, _window2$caseDetails, _props$params, _window3, _window3$caseDetails, _window4, _window4$caseDetails, _props$params2, _window5, _window5$config, _window6, _window6$config, _props$params3, _data$response5, _data$response5$data, _data$response5$data$;
  console.log("useDeviceData--->", props);
  var _props$customerInfo = props.customerInfo,
    _props$customerInfo2 = _props$customerInfo === void 0 ? {} : _props$customerInfo,
    _props$customerInfo2$ = _props$customerInfo2.customerAttributes,
    _props$customerInfo2$2 = _props$customerInfo2$ === void 0 ? {} : _props$customerInfo2$,
    _props$customerInfo2$3 = _props$customerInfo2$2.customerType,
    customerType = _props$customerInfo2$3 === void 0 ? '' : _props$customerInfo2$3;
  var dataPayload = {
    customerId: (_window = window) !== null && _window !== void 0 && (_window$caseDetails = _window.caseDetails) !== null && _window$caseDetails !== void 0 && _window$caseDetails.accountNumber ? (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$caseDetails = _window2.caseDetails) === null || _window2$caseDetails === void 0 ? void 0 : _window2$caseDetails.accountNumber : props === null || props === void 0 ? void 0 : (_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.accountNumber,
    mtn: (_window3 = window) !== null && _window3 !== void 0 && (_window3$caseDetails = _window3.caseDetails) !== null && _window3$caseDetails !== void 0 && _window3$caseDetails.mtn ? (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$caseDetails = _window4.caseDetails) === null || _window4$caseDetails === void 0 ? void 0 : _window4$caseDetails.mtn : props === null || props === void 0 ? void 0 : (_props$params2 = props.params) === null || _props$params2 === void 0 ? void 0 : _props$params2.mdn,
    digitalcustomertype: customerType,
    equipmentId: "",
    channelId: (_window5 = window) !== null && _window5 !== void 0 && (_window5$config = _window5.config) !== null && _window5$config !== void 0 && _window5$config.channelId ? (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$config = _window6.config) === null || _window6$config === void 0 ? void 0 : _window6$config.channelId : props === null || props === void 0 ? void 0 : (_props$params3 = props.params) === null || _props$params3 === void 0 ? void 0 : _props$params3.channel
  };
  var fetcher = function fetcher() {
    try {
      return Promise.resolve(getDeviceData(dataPayload));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var _useSWRImmutable4 = useSWRImmutable(["deviceData", dataPayload], fetcher, {}),
    data = _useSWRImmutable4.data,
    error = _useSWRImmutable4.error,
    isLoading = _useSWRImmutable4.isLoading,
    mutate = _useSWRImmutable4.mutate;
  if (data !== null && data !== void 0 && (_data$response5 = data.response) !== null && _data$response5 !== void 0 && (_data$response5$data = _data$response5.data) !== null && _data$response5$data !== void 0 && (_data$response5$data$ = _data$response5$data.body) !== null && _data$response5$data$ !== void 0 && _data$response5$data$.smartPhone) {
    var _data$response6, _data$response6$data, _data$response6$data$;
    sessionStorage.setItem("isSmartPhone", data === null || data === void 0 ? void 0 : (_data$response6 = data.response) === null || _data$response6 === void 0 ? void 0 : (_data$response6$data = _data$response6.data) === null || _data$response6$data === void 0 ? void 0 : (_data$response6$data$ = _data$response6$data.body) === null || _data$response6$data$ === void 0 ? void 0 : _data$response6$data$.smartPhone);
  }
  return {
    data: data,
    isLoading: isLoading,
    error: error,
    refetch: mutate
  };
};
var joinAddressString = function joinAddressString(address) {
  if (address === void 0) {
    address = {};
  }
  var _ref6 = address || {},
    _ref6$addressLine = _ref6.addressLine1,
    addressLine1 = _ref6$addressLine === void 0 ? '' : _ref6$addressLine,
    _ref6$city = _ref6.city,
    city = _ref6$city === void 0 ? '' : _ref6$city,
    _ref6$state = _ref6.state,
    state = _ref6$state === void 0 ? '' : _ref6$state,
    _ref6$zipCode = _ref6.zipCode,
    zipCode = _ref6$zipCode === void 0 ? '' : _ref6$zipCode,
    _ref6$zipCodePlus = _ref6.zipCodePlus4,
    zipCodePlus4 = _ref6$zipCodePlus === void 0 ? '' : _ref6$zipCodePlus;
  var zip = zipCode;
  var getAddr = [];
  if (addressLine1) {
    getAddr.push(addressLine1);
  }
  if (city) {
    getAddr.push(city);
  }
  if (state) {
    getAddr.push(state);
  }
  zipCodePlus4 ? zip += '-' + zipCodePlus4 : zip += '-0000';
  if (zipCode) {
    getAddr.push(zip);
  }
  return getAddr.join(",");
};
var payloadUseNetworkData = function payloadUseNetworkData(props, refreshParam, pollcount) {
  var _props$customerInfo3, _props$customerInfo3$, _props$customerInfo3$2, _sessionStorage$getIt, _window7, _window7$caseDetails, _window8, _window8$caseDetails, _props$params4, _props$params5, _props$params6;
  var _ref7 = props || {},
    _ref7$params = _ref7.params,
    _ref7$params2 = _ref7$params === void 0 ? {} : _ref7$params,
    _ref7$params2$mdn = _ref7$params2.mdn,
    mdn = _ref7$params2$mdn === void 0 ? '' : _ref7$params2$mdn;
  var selectedMTN = mdn;
  var mtns = props === null || props === void 0 ? void 0 : (_props$customerInfo3 = props.customerInfo) === null || _props$customerInfo3 === void 0 ? void 0 : (_props$customerInfo3$ = _props$customerInfo3.billAccounts) === null || _props$customerInfo3$ === void 0 ? void 0 : (_props$customerInfo3$2 = _props$customerInfo3$[0]) === null || _props$customerInfo3$2 === void 0 ? void 0 : _props$customerInfo3$2.mtns;
  var selectedMTNData = mtns ? mtns.find(function (e) {
    return e.mtn === selectedMTN;
  }) : {};
  var addressResponse = selectedMTNData === null || selectedMTNData === void 0 ? void 0 : selectedMTNData.primaryAddress;
  var address = joinAddressString(addressResponse);
  var dataPayload = {
    transactionId: (_sessionStorage$getIt = sessionStorage.getItem("transactionID")) != null ? _sessionStorage$getIt : "",
    initialRequest: sessionStorage.getItem("transactionID") ? false : true,
    refresh: [refreshParam],
    mtn: (_window7 = window) !== null && _window7 !== void 0 && (_window7$caseDetails = _window7.caseDetails) !== null && _window7$caseDetails !== void 0 && _window7$caseDetails.mtn ? (_window8 = window) === null || _window8 === void 0 ? void 0 : (_window8$caseDetails = _window8.caseDetails) === null || _window8$caseDetails === void 0 ? void 0 : _window8$caseDetails.mtn : props === null || props === void 0 ? void 0 : (_props$params4 = props.params) === null || _props$params4 === void 0 ? void 0 : _props$params4.mdn,
    callId: props === null || props === void 0 ? void 0 : (_props$params5 = props.params) === null || _props$params5 === void 0 ? void 0 : _props$params5.acssCallId,
    domain: 'CXP',
    startTime: '',
    endTime: '',
    longitude: '',
    latitude: '',
    address: address,
    channelId: props === null || props === void 0 ? void 0 : (_props$params6 = props.params) === null || _props$params6 === void 0 ? void 0 : _props$params6.channelId,
    pollCount: pollcount
  };
  return dataPayload;
};
var useNetworkData = function useNetworkData(props) {
  var _props$customerInfo4, _props$customerInfo4$, _props$customerInfo4$2, _sessionStorage$getIt2, _window9, _window9$caseDetails, _window0, _window0$caseDetails, _props$params7, _props$params8, _props$params9, _data$response9, _data$response9$data, _data$response9$data$, _data$response9$data$2, _data$response1, _data$response1$data, _data$response1$data$, _data$response10, _data$response10$data, _data$response10$data2, _data$response10$data3;
  console.log('useNetworkData-->', props);
  var _useFeatureFlag2 = useFeatureFlag(),
    _useFeatureFlag2$data = _useFeatureFlag2.data,
    _useFeatureFlag2$data2 = _useFeatureFlag2$data === void 0 ? {} : _useFeatureFlag2$data,
    _useFeatureFlag2$data3 = _useFeatureFlag2$data2.networkTilePollFixFFlag,
    networkTilePollFixFFlag = _useFeatureFlag2$data3 === void 0 ? false : _useFeatureFlag2$data3;
  var REFETCH_INTERVAL = (props === null || props === void 0 ? void 0 : props.delphiPollInterval) || DEFAULT_REFETCH_INTERVAL;
  var MAX_POLL_LIMIT = (props === null || props === void 0 ? void 0 : props.delphiPollLimit) || DEFAULT_POLL_LIMIT;
  var pollfromSession = sessionStorage.getItem('pollCount');
  var initialRequest = pollfromSession ? parseInt(pollfromSession) : 0;
  var _ref8 = props || {},
    _ref8$params = _ref8.params,
    _ref8$params2 = _ref8$params === void 0 ? {} : _ref8$params,
    _ref8$params2$mdn = _ref8$params2.mdn,
    mdn = _ref8$params2$mdn === void 0 ? '' : _ref8$params2$mdn;
  var selectedMTN = mdn;
  var mtns = props === null || props === void 0 ? void 0 : (_props$customerInfo4 = props.customerInfo) === null || _props$customerInfo4 === void 0 ? void 0 : (_props$customerInfo4$ = _props$customerInfo4.billAccounts) === null || _props$customerInfo4$ === void 0 ? void 0 : (_props$customerInfo4$2 = _props$customerInfo4$[0]) === null || _props$customerInfo4$2 === void 0 ? void 0 : _props$customerInfo4$2.mtns;
  var selectedMTNData = mtns ? mtns.find(function (e) {
    return e.mtn === selectedMTN;
  }) : {};
  var addressResponse = selectedMTNData === null || selectedMTNData === void 0 ? void 0 : selectedMTNData.primaryAddress;
  var address = joinAddressString(addressResponse);
  var dataPayload = {
    transactionId: (_sessionStorage$getIt2 = sessionStorage.getItem("transactionID")) != null ? _sessionStorage$getIt2 : "",
    initialRequest: sessionStorage.getItem("transactionID") ? false : true,
    refresh: [],
    mtn: (_window9 = window) !== null && _window9 !== void 0 && (_window9$caseDetails = _window9.caseDetails) !== null && _window9$caseDetails !== void 0 && _window9$caseDetails.mtn ? (_window0 = window) === null || _window0 === void 0 ? void 0 : (_window0$caseDetails = _window0.caseDetails) === null || _window0$caseDetails === void 0 ? void 0 : _window0$caseDetails.mtn : props === null || props === void 0 ? void 0 : (_props$params7 = props.params) === null || _props$params7 === void 0 ? void 0 : _props$params7.mdn,
    callId: props === null || props === void 0 ? void 0 : (_props$params8 = props.params) === null || _props$params8 === void 0 ? void 0 : _props$params8.acssCallId,
    domain: 'CXP',
    startTime: '',
    endTime: '',
    longitude: '',
    latitude: '',
    address: address,
    channelId: props === null || props === void 0 ? void 0 : (_props$params9 = props.params) === null || _props$params9 === void 0 ? void 0 : _props$params9.channelId,
    pollCount: initialRequest
  };
  var dataPayloadForSWR = {
    transactionId: dataPayload === null || dataPayload === void 0 ? void 0 : dataPayload.transactionId,
    initialRequest: dataPayload === null || dataPayload === void 0 ? void 0 : dataPayload.initialRequest,
    refresh: dataPayload === null || dataPayload === void 0 ? void 0 : dataPayload.refresh,
    mtn: dataPayload === null || dataPayload === void 0 ? void 0 : dataPayload.mtn
  };
  var fetcher = function fetcher() {
    try {
      if (dataPayload['pollCount'] == parseInt(MAX_POLL_LIMIT)) {
        dataPayload['pollCount'] = 1;
      }
      return Promise.resolve(getNetworkData(dataPayload));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var _useSWRImmutable5 = useSWRImmutable(['networkData', dataPayloadForSWR], fetcher, {
      refreshInterval: function refreshInterval(data) {
        var _data$response7, _data$response7$data, _data$response7$data$, _data$response7$data$2, _data$response8, _data$response8$data, _data$response8$data$;
        var state = data === null || data === void 0 ? void 0 : (_data$response7 = data.response) === null || _data$response7 === void 0 ? void 0 : (_data$response7$data = _data$response7.data) === null || _data$response7$data === void 0 ? void 0 : (_data$response7$data$ = _data$response7$data.body) === null || _data$response7$data$ === void 0 ? void 0 : (_data$response7$data$2 = _data$response7$data$.data) === null || _data$response7$data$2 === void 0 ? void 0 : _data$response7$data$2.state;
        if (state == 'COMPLETED' || state == 'FAILED' || state == undefined && networkTilePollFixFFlag) {
          sessionStorage.setItem("pollCount", '');
        } else if (state == 'COMPLETED' && !networkTilePollFixFFlag) {
          sessionStorage.setItem("pollCount", '');
        }
        var pollCount = data === null || data === void 0 ? void 0 : (_data$response8 = data.response) === null || _data$response8 === void 0 ? void 0 : (_data$response8$data = _data$response8.data) === null || _data$response8$data === void 0 ? void 0 : (_data$response8$data$ = _data$response8$data.body) === null || _data$response8$data$ === void 0 ? void 0 : _data$response8$data$.pollCount;
        var returnData = state === 'INPROGRESS' && pollCount < parseInt(MAX_POLL_LIMIT) ? REFETCH_INTERVAL : 0;
        return parseInt(returnData);
      }
    }),
    data = _useSWRImmutable5.data,
    error = _useSWRImmutable5.error,
    mutate = _useSWRImmutable5.mutate;
  if (data !== null && data !== void 0 && (_data$response9 = data.response) !== null && _data$response9 !== void 0 && (_data$response9$data = _data$response9.data) !== null && _data$response9$data !== void 0 && (_data$response9$data$ = _data$response9$data.body) !== null && _data$response9$data$ !== void 0 && (_data$response9$data$2 = _data$response9$data$.data) !== null && _data$response9$data$2 !== void 0 && _data$response9$data$2.transactionId) {
    var _data$response0, _data$response0$data, _data$response0$data$, _data$response0$data$2;
    sessionStorage.setItem("transactionID", data === null || data === void 0 ? void 0 : (_data$response0 = data.response) === null || _data$response0 === void 0 ? void 0 : (_data$response0$data = _data$response0.data) === null || _data$response0$data === void 0 ? void 0 : (_data$response0$data$ = _data$response0$data.body) === null || _data$response0$data$ === void 0 ? void 0 : (_data$response0$data$2 = _data$response0$data$.data) === null || _data$response0$data$2 === void 0 ? void 0 : _data$response0$data$2.transactionId);
  }
  var pollFromResponse = data === null || data === void 0 ? void 0 : (_data$response1 = data.response) === null || _data$response1 === void 0 ? void 0 : (_data$response1$data = _data$response1.data) === null || _data$response1$data === void 0 ? void 0 : (_data$response1$data$ = _data$response1$data.body) === null || _data$response1$data$ === void 0 ? void 0 : _data$response1$data$.pollCount;
  var currentState = data === null || data === void 0 ? void 0 : (_data$response10 = data.response) === null || _data$response10 === void 0 ? void 0 : (_data$response10$data = _data$response10.data) === null || _data$response10$data === void 0 ? void 0 : (_data$response10$data2 = _data$response10$data.body) === null || _data$response10$data2 === void 0 ? void 0 : (_data$response10$data3 = _data$response10$data2.data) === null || _data$response10$data3 === void 0 ? void 0 : _data$response10$data3.state;
  if (pollFromResponse && networkTilePollFixFFlag && currentState !== "COMPLETED" && currentState !== "FAILED") {
    sessionStorage.setItem("pollCount", pollFromResponse);
  } else if (!networkTilePollFixFFlag) {
    sessionStorage.setItem("pollCount", pollFromResponse);
  }
  return {
    data: data,
    isLoading: !data && !error,
    error: error,
    refetch: mutate
  };
};
var useProfileData = function useProfileData(props) {
  var _props$params0;
  var dataPayload = {
    isVisionLoginEnabled: "Y",
    callIdRefresh: "Y",
    channelId: props === null || props === void 0 ? void 0 : (_props$params0 = props.params) === null || _props$params0 === void 0 ? void 0 : _props$params0.channelId
  };
  return useSWRImmutable(["profileData", dataPayload], function (_ref9) {
    var dataPayload = _ref9[1];
    try {
      return Promise.resolve(getProfileData(dataPayload)).then(function (response) {
        var _response$response, _response$response$da;
        return response === null || response === void 0 ? void 0 : (_response$response = response.response) === null || _response$response === void 0 ? void 0 : (_response$response$da = _response$response.data) === null || _response$response$da === void 0 ? void 0 : _response$response$da.data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  });
};
var useLoadLinks = function useLoadLinks(props) {
  return useSWRImmutable("loadLinks", function () {
    try {
      var _props$params1;
      var request = {
        channelId: props === null || props === void 0 ? void 0 : (_props$params1 = props.params) === null || _props$params1 === void 0 ? void 0 : _props$params1.channelId
      };
      return Promise.resolve(getLoadLinks(request)).then(function (response) {
        var _response$response2, _response$response2$d;
        return response === null || response === void 0 ? void 0 : (_response$response2 = response.response) === null || _response$response2 === void 0 ? void 0 : (_response$response2$d = _response$response2.data) === null || _response$response2$d === void 0 ? void 0 : _response$response2$d.data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  });
};
var useDeviceDiagnostics = function useDeviceDiagnostics(props) {
  var _useDeviceData, _window1, _window1$caseDetails, _window10, _window10$caseDetails, _props$params10, _useProfileData$data, _useProfileData$data$, _useProfileData$data$2, _selectedMTNData$devi, _selectedMTNData, _selectedMTNData$devi2, _selectedMTNData$devi3, _selectedMTNData$devi4, _selectedMTNData2, _selectedMTNData2$dev, _selectedMTNData2$dev2, _window11, _window11$caseDetails, _window12, _window12$caseDetails, _props$params11, _props$params12;
  var flag = (_useDeviceData = useDeviceData(props)) === null || _useDeviceData === void 0 ? void 0 : _useDeviceData.data;
  var selectedMTN = (_window1 = window) !== null && _window1 !== void 0 && (_window1$caseDetails = _window1.caseDetails) !== null && _window1$caseDetails !== void 0 && _window1$caseDetails.mtn ? (_window10 = window) === null || _window10 === void 0 ? void 0 : (_window10$caseDetails = _window10.caseDetails) === null || _window10$caseDetails === void 0 ? void 0 : _window10$caseDetails.mtn : props === null || props === void 0 ? void 0 : (_props$params10 = props.params) === null || _props$params10 === void 0 ? void 0 : _props$params10.mdn;
  var selectedMTNData;
  if (flag) {
    var _flag$customerInsight, _flag$customerInsight2, _flag$customerInsight3;
    var mtns = flag === null || flag === void 0 ? void 0 : (_flag$customerInsight = flag.customerInsight) === null || _flag$customerInsight === void 0 ? void 0 : (_flag$customerInsight2 = _flag$customerInsight.billAccounts) === null || _flag$customerInsight2 === void 0 ? void 0 : (_flag$customerInsight3 = _flag$customerInsight2[0]) === null || _flag$customerInsight3 === void 0 ? void 0 : _flag$customerInsight3.mtns;
    selectedMTNData = mtns ? mtns.find(function (e) {
      return e.mtn === selectedMTN;
    }) : {};
  }
  var _5gAndUI = useProfileData === null || useProfileData === void 0 ? void 0 : (_useProfileData$data = useProfileData.data) === null || _useProfileData$data === void 0 ? void 0 : (_useProfileData$data$ = _useProfileData$data.permission) === null || _useProfileData$data$ === void 0 ? void 0 : (_useProfileData$data$2 = _useProfileData$data$.sessionPermission) === null || _useProfileData$data$2 === void 0 ? void 0 : _useProfileData$data$2.ACSS_3YEAR_CONTRACT_ENABLED;
  var deviceType = (_selectedMTNData$devi = (_selectedMTNData = selectedMTNData) === null || _selectedMTNData === void 0 ? void 0 : (_selectedMTNData$devi2 = _selectedMTNData.deviceInfo) === null || _selectedMTNData$devi2 === void 0 ? void 0 : (_selectedMTNData$devi3 = _selectedMTNData$devi2[0]) === null || _selectedMTNData$devi3 === void 0 ? void 0 : _selectedMTNData$devi3.deviceType) != null ? _selectedMTNData$devi : "";
  deviceType = deviceType === null || deviceType === undefined || deviceType === "" ? deviceType : deviceType.substring(0, deviceType.length - 1);
  var is5gDevice = deviceType === "5G" ? "true" : "false";
  var _deviceid = (_selectedMTNData$devi4 = (_selectedMTNData2 = selectedMTNData) === null || _selectedMTNData2 === void 0 ? void 0 : (_selectedMTNData2$dev = _selectedMTNData2.deviceInfo) === null || _selectedMTNData2$dev === void 0 ? void 0 : (_selectedMTNData2$dev2 = _selectedMTNData2$dev[0]) === null || _selectedMTNData2$dev2 === void 0 ? void 0 : _selectedMTNData2$dev2.imei) != null ? _selectedMTNData$devi4 : "";
  var dataPayload = {
    mdn: (_window11 = window) !== null && _window11 !== void 0 && (_window11$caseDetails = _window11.caseDetails) !== null && _window11$caseDetails !== void 0 && _window11$caseDetails.mtn ? (_window12 = window) === null || _window12 === void 0 ? void 0 : (_window12$caseDetails = _window12.caseDetails) === null || _window12$caseDetails === void 0 ? void 0 : _window12$caseDetails.mtn : props === null || props === void 0 ? void 0 : (_props$params11 = props.params) === null || _props$params11 === void 0 ? void 0 : _props$params11.mdn,
    refresh: "soft",
    cmd: "standardDiag",
    deviceid: _deviceid,
    meid: "",
    iccid: "",
    accnum: "",
    callid: "",
    uswin: "",
    frontendsessionid: "",
    data: ["./ManagedObjects/DiagMon/Device/Network/5GEARFCN_DL"],
    txId: "anything",
    is5gDevice: _5gAndUI === "Y" ? is5gDevice : "false",
    channelId: props === null || props === void 0 ? void 0 : (_props$params12 = props.params) === null || _props$params12 === void 0 ? void 0 : _props$params12.channelId
  };
  var fetcher = function fetcher() {
    try {
      return Promise.resolve(getDeviceDiagnostics(dataPayload)).then(function (response) {
        var _response$response3, _response$response3$d, _response$response3$d2;
        return response === null || response === void 0 ? void 0 : (_response$response3 = response.response) === null || _response$response3 === void 0 ? void 0 : (_response$response3$d = _response$response3.data) === null || _response$response3$d === void 0 ? void 0 : (_response$response3$d2 = _response$response3$d.body) === null || _response$response3$d2 === void 0 ? void 0 : _response$response3$d2.data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var _useSWRImmutable6 = useSWRImmutable(flag ? "deviceDiagnostics" : null, fetcher, {
      shouldRetryOnError: false
    }),
    data = _useSWRImmutable6.data,
    error = _useSWRImmutable6.error,
    mutate = _useSWRImmutable6.mutate;
  return {
    data: data,
    isLoading: !data && !error,
    error: error,
    refetch: mutate
  };
};
var useSpeedTestHistory = function useSpeedTestHistory(props, command) {
  var _networkData$response, _networkData$response2, _networkData$response3, _networkData$response4, _networkData$response5, _window13, _window13$caseDetails, _window14, _window14$caseDetails, _props$params13, _props$params14;
  var _useNetworkData = useNetworkData(props),
    networkData = _useNetworkData.data;
  var transactionId = (_networkData$response = networkData === null || networkData === void 0 ? void 0 : (_networkData$response2 = networkData.response) === null || _networkData$response2 === void 0 ? void 0 : (_networkData$response3 = _networkData$response2.data) === null || _networkData$response3 === void 0 ? void 0 : (_networkData$response4 = _networkData$response3.body) === null || _networkData$response4 === void 0 ? void 0 : (_networkData$response5 = _networkData$response4.data) === null || _networkData$response5 === void 0 ? void 0 : _networkData$response5.transactionId) != null ? _networkData$response : "";
  var dataPayload = {
    transactionId: transactionId,
    channel: "VZW-ACSS",
    type: command === "start" ? "startCommand" : "pollCommand",
    mdn: (_window13 = window) !== null && _window13 !== void 0 && (_window13$caseDetails = _window13.caseDetails) !== null && _window13$caseDetails !== void 0 && _window13$caseDetails.mtn ? (_window14 = window) === null || _window14 === void 0 ? void 0 : (_window14$caseDetails = _window14.caseDetails) === null || _window14$caseDetails === void 0 ? void 0 : _window14$caseDetails.mtn : props === null || props === void 0 ? void 0 : (_props$params13 = props.params) === null || _props$params13 === void 0 ? void 0 : _props$params13.mdn,
    channelId: props === null || props === void 0 ? void 0 : (_props$params14 = props.params) === null || _props$params14 === void 0 ? void 0 : _props$params14.channelId
  };
  var fetcher = function fetcher() {
    try {
      return Promise.resolve(new Promise(function (resolve, reject) {
        setTimeout(function () {
          try {
            var _temp = _catch(function () {
              return Promise.resolve(getSpeedTestHistory(dataPayload)).then(function (response) {
                var _response$response4, _response$response4$d, _response$response4$d2;
                resolve(response === null || response === void 0 ? void 0 : (_response$response4 = response.response) === null || _response$response4 === void 0 ? void 0 : (_response$response4$d = _response$response4.data) === null || _response$response4$d === void 0 ? void 0 : (_response$response4$d2 = _response$response4$d.body) === null || _response$response4$d2 === void 0 ? void 0 : _response$response4$d2.data);
              });
            }, function (err) {
              reject(err);
            });
            return Promise.resolve(_temp && _temp.then ? _temp.then(function () {}) : void 0);
          } catch (e) {
            return Promise.reject(e);
          }
        }, command === "start" ? 0 : 2000);
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var _useSWRImmutable7 = useSWRImmutable(transactionId ? ["speedTestHistory", dataPayload] : null, fetcher, {
      shouldRetryOnError: false
    }),
    data = _useSWRImmutable7.data,
    error = _useSWRImmutable7.error,
    mutate = _useSWRImmutable7.mutate,
    isLoading = _useSWRImmutable7.isLoading;
  return {
    data: data,
    isLoading: isLoading,
    error: error,
    refetch: mutate
  };
};
var useWifiAnalyzerData = function useWifiAnalyzerData(props) {
  var _window17, _window17$caseDetails, _window18, _window18$caseDetails, _props$params17, _props$params18;
  var dataPayload = {
    serviceHeader: {
      clientId: "vzw_acss_services",
      clientTransactionId: "",
      serviceName: "getInsights"
    },
    serviceRequest: {
      insightName: "wifianlyzer_hist",
      insightId: (_window17 = window) !== null && _window17 !== void 0 && (_window17$caseDetails = _window17.caseDetails) !== null && _window17$caseDetails !== void 0 && _window17$caseDetails.mtn ? (_window18 = window) === null || _window18 === void 0 ? void 0 : (_window18$caseDetails = _window18.caseDetails) === null || _window18$caseDetails === void 0 ? void 0 : _window18$caseDetails.mtn : props === null || props === void 0 ? void 0 : (_props$params17 = props.params) === null || _props$params17 === void 0 ? void 0 : _props$params17.mdn,
      additionalParams: {
        targetChannel: "vzw_mva_services_wifianlyzer_hist",
        targetChannelId: ""
      }
    },
    channelId: props === null || props === void 0 ? void 0 : (_props$params18 = props.params) === null || _props$params18 === void 0 ? void 0 : _props$params18.channelId
  };
  var fetcher = function fetcher() {
    try {
      return Promise.resolve(getWifiAnalyzerData(dataPayload)).then(function (response) {
        var _response$response6;
        return response === null || response === void 0 ? void 0 : (_response$response6 = response.response) === null || _response$response6 === void 0 ? void 0 : _response$response6.data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  return useSWRImmutable("wifiAnalyzerData", fetcher, {
    shouldRetryOnError: false
  });
};
var useWifiAnalyzerRawData = function useWifiAnalyzerRawData(props) {
  var _props$params19;
  var dataPayload = {
    channelId: props === null || props === void 0 ? void 0 : (_props$params19 = props.params) === null || _props$params19 === void 0 ? void 0 : _props$params19.channelId
  };
  var fetcher = function fetcher() {
    try {
      return Promise.resolve(getWifiAnalyzerRawData(dataPayload)).then(function (response) {
        var _response$response7;
        return response === null || response === void 0 ? void 0 : (_response$response7 = response.response) === null || _response$response7 === void 0 ? void 0 : _response$response7.data;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  return useSWRImmutable("wifiAnalyzerRawData", fetcher, {
    shouldRetryOnError: false
  });
};
var useQuerySimService = function useQuerySimService(props) {
  var _window19, _window19$caseDetails, _window20, _window20$caseDetails, _props$params21, _useDeviceData2, _useDeviceData2$data$, _useDeviceData2$data$2, _useDeviceData2$data$3, _selectedMTNData3, _selectedMTNData3$dev, _selectedMTNData3$dev2, _window21, _window21$caseDetails, _window22, _window22$caseDetails, _props$params22;
  var selectedMTN = (_window19 = window) !== null && _window19 !== void 0 && (_window19$caseDetails = _window19.caseDetails) !== null && _window19$caseDetails !== void 0 && _window19$caseDetails.mtn ? (_window20 = window) === null || _window20 === void 0 ? void 0 : (_window20$caseDetails = _window20.caseDetails) === null || _window20$caseDetails === void 0 ? void 0 : _window20$caseDetails.mtn : props === null || props === void 0 ? void 0 : (_props$params21 = props.params) === null || _props$params21 === void 0 ? void 0 : _props$params21.mdn;
  var deviceData = (_useDeviceData2 = useDeviceData(props)) === null || _useDeviceData2 === void 0 ? void 0 : (_useDeviceData2$data$ = _useDeviceData2.data.response) === null || _useDeviceData2$data$ === void 0 ? void 0 : (_useDeviceData2$data$2 = _useDeviceData2$data$.data) === null || _useDeviceData2$data$2 === void 0 ? void 0 : (_useDeviceData2$data$3 = _useDeviceData2$data$2.body) === null || _useDeviceData2$data$3 === void 0 ? void 0 : _useDeviceData2$data$3.data;
  var selectedMTNData;
  if (deviceData) {
    var _deviceData$customerI, _deviceData$customerI2, _deviceData$customerI3;
    var mtns = deviceData === null || deviceData === void 0 ? void 0 : (_deviceData$customerI = deviceData.customerInsight) === null || _deviceData$customerI === void 0 ? void 0 : (_deviceData$customerI2 = _deviceData$customerI.billAccounts) === null || _deviceData$customerI2 === void 0 ? void 0 : (_deviceData$customerI3 = _deviceData$customerI2[0]) === null || _deviceData$customerI3 === void 0 ? void 0 : _deviceData$customerI3.mtns;
    selectedMTNData = mtns ? mtns.find(function (e) {
      return e.mtn === selectedMTN;
    }) : {};
  }
  var eSimId = (_selectedMTNData3 = selectedMTNData) === null || _selectedMTNData3 === void 0 ? void 0 : (_selectedMTNData3$dev = _selectedMTNData3.deviceInfo) === null || _selectedMTNData3$dev === void 0 ? void 0 : (_selectedMTNData3$dev2 = _selectedMTNData3$dev[0]) === null || _selectedMTNData3$dev2 === void 0 ? void 0 : _selectedMTNData3$dev2.simId;
  var customerId;
  function getSecondPart(str) {
    customerId = str.split("-")[0];
    return str.split("-")[1];
  }
  var billAccountNumber = getSecondPart((_window21 = window) !== null && _window21 !== void 0 && (_window21$caseDetails = _window21.caseDetails) !== null && _window21$caseDetails !== void 0 && _window21$caseDetails.accountNumber ? (_window22 = window) === null || _window22 === void 0 ? void 0 : (_window22$caseDetails = _window22.caseDetails) === null || _window22$caseDetails === void 0 ? void 0 : _window22$caseDetails.accountNumber : props === null || props === void 0 ? void 0 : (_props$params22 = props.params) === null || _props$params22 === void 0 ? void 0 : _props$params22.accountNumber);
  var billAccountNumberPadding = "0000000000";
  if (billAccountNumber && billAccountNumber.length < 10) {
    billAccountNumber = billAccountNumberPadding.slice(0, 10 - billAccountNumber.length) + billAccountNumber;
  }
  console.log(customerId, billAccountNumber, "zzzzzzzzzzzzzz");
  var fetcher = function fetcher() {
    try {
      var _props$params23;
      var dataPayload = {
        customerId: customerId,
        billAccountNumber: billAccountNumber,
        customerType: "",
        billTypeCode: "",
        customerStatus: "",
        ecpdId: "",
        iccId: eSimId,
        channelId: props === null || props === void 0 ? void 0 : (_props$params23 = props.params) === null || _props$params23 === void 0 ? void 0 : _props$params23.channelId
      };
      return Promise.resolve(getQuerySimService(dataPayload)).then(function (response) {
        var _response$response9, _response$response9$d, _response$response9$d2;
        return response === null || response === void 0 ? void 0 : (_response$response9 = response.response) === null || _response$response9 === void 0 ? void 0 : (_response$response9$d = _response$response9.data) === null || _response$response9$d === void 0 ? void 0 : (_response$response9$d2 = _response$response9$d.data) === null || _response$response9$d2 === void 0 ? void 0 : _response$response9$d2.Response;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  return useSWRImmutable(["RebootAndResetData"], fetcher, {
    shouldRetryOnError: false
  });
};
var parseFeatureFlag = function parseFeatureFlag(featureFlagList) {
  var _featureFlagList;
  if (featureFlagList === void 0) {
    featureFlagList = [];
  }
  return (_featureFlagList = featureFlagList) === null || _featureFlagList === void 0 ? void 0 : _featureFlagList.flatMap(function (flag) {
    var _ref0;
    return _ref0 = {}, _ref0[flag === null || flag === void 0 ? void 0 : flag.featureFlagName] = (flag === null || flag === void 0 ? void 0 : flag.status) || false, _ref0;
  }).reduce(function (acc, obj) {
    return _extends({}, acc, obj);
  }, {});
};
var useAdditionalInfo = function useAdditionalInfo(params) {
  var _ref1 = params || {},
    _ref1$equipmentId = _ref1.equipmentId,
    equipmentId = _ref1$equipmentId === void 0 ? '' : _ref1$equipmentId,
    _ref1$sku = _ref1.sku,
    sku = _ref1$sku === void 0 ? '' : _ref1$sku,
    _ref1$mdn = _ref1.mdn,
    mdn = _ref1$mdn === void 0 ? '' : _ref1$mdn,
    _ref1$accountNumber = _ref1.accountNumber,
    accountNumber = _ref1$accountNumber === void 0 ? '' : _ref1$accountNumber,
    _ref1$channel = _ref1.channel,
    channel = _ref1$channel === void 0 ? '' : _ref1$channel,
    _ref1$tier = _ref1.tier,
    tier = _ref1$tier === void 0 ? '' : _ref1$tier;
  var addtionalParamAcss = {
    "channelId": channel != null ? channel : "Care",
    "tierId": tier != null ? tier : "",
    "equipmentId": equipmentId,
    "deviceSku": sku,
    "mtn": mdn,
    "accountNumber": accountNumber
  };
  var fetcher = function fetcher() {
    try {
      return Promise.resolve(additionalInfo(params)).then(function (response) {
        var _response$body, _response$body$config;
        var featureFlags = parseFeatureFlag(response === null || response === void 0 ? void 0 : (_response$body = response.body) === null || _response$body === void 0 ? void 0 : (_response$body$config = _response$body.configData) === null || _response$body$config === void 0 ? void 0 : _response$body$config.featureFlagList);
        var otherResponse = (response === null || response === void 0 ? void 0 : response.body) || {};
        mutate(['feature-flags'], featureFlags, false);
        mutate(['other-content'], otherResponse, false);
        return response;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var _useSWRImmutable9 = useSWRImmutable(["additionalInfo-othercontent", addtionalParamAcss], fetcher, {
      revalidateOnMount: true
    }),
    data = _useSWRImmutable9.data,
    error = _useSWRImmutable9.error,
    isLoading = _useSWRImmutable9.isLoading,
    isValidating = _useSWRImmutable9.isValidating,
    mutate$1 = _useSWRImmutable9.mutate;
  return {
    data: data,
    isLoading: isLoading,
    isValidating: isValidating,
    error: error,
    refetch: mutate$1
  };
};
var useFeatureFlag = function useFeatureFlag() {
  var cacheKey = ['feature-flags'];
  return useSWR(cacheKey, null, {
    revalidateOnFocus: false,
    revalidateOnReconnect: true,
    revalidateIfStale: false
  });
};
var useOtherContent = function useOtherContent() {
  var cacheKey = ['other-content'];
  return useSWR(cacheKey, null, {
    revalidateOnFocus: false,
    revalidateOnReconnect: true,
    revalidateIfStale: false
  });
};

var _templateObject$i, _templateObject2$e, _templateObject3$e, _templateObject4$e, _templateObject5$d, _templateObject6$b, _templateObject7$a, _templateObject8$a, _templateObject9$8, _templateObject0$6, _templateObject1$6;
var ThumbsUpContainer$2 = styled.div(_templateObject$i || (_templateObject$i = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n"])));
var ButtonsWrapper$6 = styled.div(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteralLoose(["\n  display: flex;\n"])));
var NextOptionContainer = styled.div(_templateObject3$e || (_templateObject3$e = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n"])));
var StepOption$3 = styled.div(_templateObject4$e || (_templateObject4$e = _taggedTemplateLiteralLoose(["\n  border: 1px solid ", ";\n  border-radius: 7px;\n  display: flex;\n  cursor: pointer;\n  flex-direction: column;\n  height: 64px;\n  justify-content: center;\n  padding-left: 14px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  padding-right: 14px;\n  width: 44%;\n  margin: 10px auto 10px 0px;\n  @media(max-width:601px) {\n    width: 89%;\n  }\n"])), verizonTheme.coolGray);
var SelectContainerWrapper = styled.div(_templateObject5$d || (_templateObject5$d = _taggedTemplateLiteralLoose(["\nwidth: \"50%\"\n@media(max-width:601px) {\n  width: 100%;\n}\n"])));
var LightColor = styled.span(_templateObject6$b || (_templateObject6$b = _taggedTemplateLiteralLoose(["\ncolor: #979a9a\n"])));
var FeedbackWrapper$2 = styled.div(_templateObject7$a || (_templateObject7$a = _taggedTemplateLiteralLoose(["\n  @media screen and (max-width: 600px) {\n    display:none\n  }\n"])));
var FeedbackWrapperMobile$1 = styled.div(_templateObject8$a || (_templateObject8$a = _taggedTemplateLiteralLoose(["\n    margin:0px auto;\n    @media screen and (min-width: 600px) {\n        display:none\n    }\n"])));
var ThumbsImg$1 = styled.img.attrs(function (props) {
  return {
    tabIndex: 0
  };
})(_templateObject9$8 || (_templateObject9$8 = _taggedTemplateLiteralLoose(["\n    width: 2.5rem;\n    cursor: ", ";\n"])), function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? "" : "pointer";
});
var FeedbackBox$1 = styled.textarea(_templateObject0$6 || (_templateObject0$6 = _taggedTemplateLiteralLoose(["\n    resize: none;\n    width: 100%;\n    height: 80px;\n    padding: 1.2%;\n    border-radius: 0.3rem;\n\n  ::placeholder {\n    font-family: Verizon-NHG-eDS;\n  }\n"])));
var FeedbackFooter = styled.div(_templateObject1$6 || (_templateObject1$6 = _taggedTemplateLiteralLoose(["\n  display: flex !important;\n  justify-content: space-between  !important;\n"])));
var HowToFeedbackContainerModal = function HowToFeedbackContainerModal(props) {
  var _props$flags, _props$flags2, _configDetails$params, _configDetails$params2;
  console.log("comren HowToFeedbackContainerModal flags", props);
  var _props$values = props.values,
    values = _props$values === void 0 ? {} : _props$values;
  var _values$troubleShooti = values.troubleShootingInfo,
    troubleShootingInfo = _values$troubleShooti === void 0 ? {} : _values$troubleShooti,
    _values$landingInfo = values.landingInfo,
    landingInfo = _values$landingInfo === void 0 ? {} : _values$landingInfo,
    _values$symptom = values.symptom,
    symptom = _values$symptom === void 0 ? {} : _values$symptom;
  var context = getObjectPropertyByPath('context', troubleShootingInfo, {});
  var _landingInfo$device = landingInfo.device,
    device = _landingInfo$device === void 0 ? {} : _landingInfo$device;
  var soeUrl = device.soeUrl;
  var issueName = symptom.issueName;
  var caseId = context.caseId;
  var _useState = useState(_extends({}, props.flags)),
    flags = _useState[0],
    setFlags = _useState[1];
  var aiSummryEnabled = isGenAIEnabled(values);
  var intentId = props.intentId,
    acssCallId = props.acssCallId,
    isACSS = props.isACSS;
  var _useSWRCache = useSWRCache(['aiSummary', intentId]);
  var _useFeedback = useFeedback(),
    provideGenAIFeedback = _useFeedback.trigger;
  var _useState2 = useState('Please select'),
    setDropDownValue = _useState2[1];
  var _useState3 = useState({
      enableButton: false,
      userInput: ''
    }),
    feedbackValues = _useState3[0];
  var _useState4 = useState(''),
    feedbackMessage = _useState4[0],
    setFeedbackMessage = _useState4[1];
  var _useState5 = useState('Not clear enough'),
    subject = _useState5[0],
    setSubject = _useState5[1];
  var _useState6 = useState(true),
    btnShow = _useState6[0],
    setBtnShow = _useState6[1];
  var showThumbsUp = flags.showThumbsUp,
    showThumbsDown = flags.showThumbsDown,
    thumbsClicked = flags.thumbsClicked,
    submitClicked = flags.submitClicked,
    rating = flags.rating,
    justAfterThumbsDownClicked = flags.justAfterThumbsDownClicked;
  var userInput = feedbackValues.userInput;
  var _ref2 = useFeatureFlag() || {},
    _ref2$data = _ref2.data,
    _ref2$data2 = _ref2$data === void 0 ? {} : _ref2$data,
    _ref2$data2$feedbackT = _ref2$data2.feedbackTextBoxFFlag,
    feedbackTextBoxFFlag = _ref2$data2$feedbackT === void 0 ? false : _ref2$data2$feedbackT;
  if ((props === null || props === void 0 ? void 0 : (_props$flags = props.flags) === null || _props$flags === void 0 ? void 0 : _props$flags.showThumbsUp) != (flags === null || flags === void 0 ? void 0 : flags.showThumbsUp)) {
    console.log("props.flags", props.flags);
    setFlags(_extends({}, props.flags));
  }
  if ((props === null || props === void 0 ? void 0 : (_props$flags2 = props.flags) === null || _props$flags2 === void 0 ? void 0 : _props$flags2.showThumbsDown) != (flags === null || flags === void 0 ? void 0 : flags.showThumbsDown)) {
    console.log("props.flags", props.flags);
    setFlags(_extends({}, props.flags));
  }
  var configDetails = useContext(ConfigContext);
  var isDark = configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : (_configDetails$params2 = _configDetails$params.theme) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.isDark;
  useEffect(function () {
    try {
      var _props$symptom, _configDetails$caseDe, _configDetails$select;
      var page = "troubleshooter | " + ((props === null || props === void 0 ? void 0 : (_props$symptom = props.symptom) === null || _props$symptom === void 0 ? void 0 : _props$symptom.issueName) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$caseDe = configDetails.caseDetails) === null || _configDetails$caseDe === void 0 ? void 0 : _configDetails$caseDe.intent) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select = configDetails.selectedNSAIntent) === null || _configDetails$select === void 0 ? void 0 : _configDetails$select.intent)) + " | How To Feedback";
      window.vzdl.page = page;
      window.sendCustomEvent && window.sendCustomEvent("troubleshooting", window.vzdl);
    } catch (error) {
      console.error(error);
    }
  }, []);
  var handleThumbsUpClick = function handleThumbsUpClick() {
    console.log("handleThumbsUpClick flags");
    if (thumbsClicked) {
      return;
    }
    if (props.handleModalClick) {
      props.handleModalClick();
    }
    if (props.handleFeedbackFlags) {
      props.handleFeedbackFlags(_extends({}, flags, {
        rating: '5',
        showThumbsUp: true,
        thumbsClicked: true
      }));
    }
    setFlags(_extends({}, flags, {
      rating: '5',
      showThumbsUp: true,
      thumbsClicked: true
    }));
  };
  var handleThumbsDownClick = function handleThumbsDownClick() {
    console.log("handleThumbsDownClick flags");
    if (thumbsClicked) {
      return;
    }
    if (props.handleModalClick) {
      props.handleModalClick();
    }
    if (props.handleFeedbackFlags) {
      props.handleFeedbackFlags(_extends({}, flags, {
        rating: '1',
        showThumbsDown: true,
        thumbsClicked: true
      }));
    }
    setFlags(_extends({}, flags, {
      rating: '1',
      justAfterThumbsDownClicked: true,
      thumbsClicked: true,
      showThumbsDown: true
    }));
  };
  var handleChange = function handleChange(event) {
    setFeedbackMessage(event.target.value);
  };
  var handleDropdonChange = function handleDropdonChange(e) {
    console.log(e.target.value);
    setDropDownValue(e.target.value);
    console.log(feedbackMessage.length);
    if (e.target.value === 'Please select') {
      setBtnShow(true);
    } else {
      setBtnShow(false);
    }
    console.log("testing handleDropdonChange", e.target.value);
    setSubject(e.target.value);
  };
  var handleSubmit = function handleSubmit() {
    var aiSummary = session('aiSummary').get();
    if (aiSummryEnabled && aiSummary !== null && aiSummary !== void 0 && aiSummary.vegasTransactionId) {
      provideGenAIFeedback({
        feedback: 1,
        vegasTransactionId: aiSummary === null || aiSummary === void 0 ? void 0 : aiSummary.vegasTransactionId,
        acssCallId: acssCallId,
        isACSS: isACSS
      });
    }
    var APIURL = "/digital/nsa/nos/gw/support/rating-and-reviews";
    var params = {
      rating: rating,
      review: userInput,
      productId: "troubleshooting|" + soeUrl + "|" + (issueName && issueName.replace(/[^\w\s]/g, '')) + "|" + caseId,
      title: issueName
    };
    var axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        "channelId": window._dg_channelId
      }
    };
    postHttpClientRequest(APIURL, params, axiosConfig);
    setFlags(_extends({}, flags, {
      showThumbsUp: showThumbsUp,
      showThumbsDown: showThumbsDown,
      thumbsClicked: thumbsClicked,
      submitClicked: true
    }));
    if (props.handleFeedbackFlags) {
      props.handleFeedbackFlags(_extends({}, flags, {
        showThumbsDown: true,
        thumbsClicked: true,
        submitClicked: true,
        justAfterThumbsDownClicked: false
      }));
    }
    if (props.handleModalClick) {
      props.handleModalClick();
    }
    if (props.functions.handleTroubleShootingAction) {
      var button = {
        "label": "Done",
        "action": "Done",
        "type": "secondary",
        "url": "",
        "callFunction": ""
      };
      var feedbackData = {
        feedbackMessage: feedbackMessage,
        feedbackSubject: subject
      };
      if (aiSummary !== null && aiSummary !== void 0 && aiSummary.vegasTransactionId) {
        feedbackData.aiSummary = true;
      }
      props.functions.handleTroubleShootingAction(button, {
        fromPage: props.fromPage,
        selectedIssueOptionStep: props.selectedIssueOptionStep,
        thumbsDownSubmittedStep: true,
        flags: _extends({}, flags, {
          showThumbsDown: true,
          thumbsClicked: true,
          submitClicked: true,
          justAfterThumbsDownClicked: false
        })
      }, feedbackData);
    }
    props.handleCloseButton();
  };
  var renderFeedback = function renderFeedback() {
    return /*#__PURE__*/React__default.createElement("div", {
      id: "feedbackBox"
    }, /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "20px"
    }), /*#__PURE__*/React__default.createElement(Body, {
      size: "large",
      viewport: "desktop",
      primitive: "h2"
    }, "Share your thoughts with us."), /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "30px"
    }), /*#__PURE__*/React__default.createElement(SelectContainerWrapper, null, /*#__PURE__*/React__default.createElement(UserConsumer, null, function (value) {
      return value.additionalInfoSteps.filter(function (steps) {
        return steps.templateId === "FEEDBACK_THUMPSDOWN_VALUES";
      }) && value.additionalInfoSteps.filter(function (steps) {
        return steps.templateId === "FEEDBACK_THUMPSDOWN_VALUES";
      }).length > 0 && value.additionalInfoSteps.filter(function (steps) {
        return steps.templateId === "FEEDBACK_THUMPSDOWN_VALUES";
      })[0].questions && value.additionalInfoSteps.filter(function (steps) {
        return steps.templateId === "FEEDBACK_THUMPSDOWN_VALUES";
      })[0].questions.length > 0 && value.additionalInfoSteps.filter(function (steps) {
        return steps.templateId === "FEEDBACK_THUMPSDOWN_VALUES";
      })[0].questions[0].choices && value.additionalInfoSteps.filter(function (steps) {
        return steps.templateId === "FEEDBACK_THUMPSDOWN_VALUES";
      })[0].questions[0].choices.length > 0 ? /*#__PURE__*/React__default.createElement(DropdownSelect, {
        label: "Subject",
        onChange: function onChange(event) {
          return handleDropdonChange(event);
        },
        "data-testid": "dropDown",
        style: {
          width: "185px !important"
        },
        surface: isDark ? "dark" : "light"
      }, /*#__PURE__*/React__default.createElement("option", null, "Please select"), value.additionalInfoSteps.filter(function (steps) {
        return steps.templateId === "FEEDBACK_THUMPSDOWN_VALUES";
      })[0].questions[0].choices.map(function (options) {
        return /*#__PURE__*/React__default.createElement("option", {
          value: options.value
        }, options.text);
      })) : /*#__PURE__*/React__default.createElement(DropdownSelect, {
        label: "Subject",
        onChange: function onChange(event) {
          return handleDropdonChange(event);
        },
        style: {
          width: "185px !important"
        },
        surface: isDark ? "dark" : "light",
        "data-testid": "subjectDropDown"
      }, /*#__PURE__*/React__default.createElement("option", null, "Please select"), /*#__PURE__*/React__default.createElement("option", null, "Not clear enough"), /*#__PURE__*/React__default.createElement("option", null, "Broken Link"), /*#__PURE__*/React__default.createElement("option", null, "Other"), /*#__PURE__*/React__default.createElement("option", null, "Content Wrong"), /*#__PURE__*/React__default.createElement("option", null, "Content Missing"), /*#__PURE__*/React__default.createElement("option", null, " AI Summary "));
    })), /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "20px"
    }), /*#__PURE__*/React__default.createElement(Body, {
      size: "medium",
      viewport: "desktop",
      primitive: "h3",
      color: isDark ? "#FFF" : "#000"
    }, "Feedback ", /*#__PURE__*/React__default.createElement(LightColor, null, "Optional")), /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "10px"
    }), feedbackTextBoxFFlag ? /*#__PURE__*/React__default.createElement(TextArea$1, {
      surface: isDark ? "dark" : "light",
      required: false,
      maxLength: null,
      "data-testid": "feedback",
      onChange: function onChange(e) {
        handleChange(e);
      }
    }) : /*#__PURE__*/React__default.createElement(FeedbackBox$1, {
      onChange: function onChange(event) {
        return handleChange(event);
      },
      "data-testId": "feedback",
      maxLength: 500
    }), /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "5px"
    }), /*#__PURE__*/React__default.createElement(FeedbackFooter, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(LightColor, null, " Please tell us about your experience.")), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(LightColor, null, feedbackMessage.length, "/500"))), /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "40px"
    }), /*#__PURE__*/React__default.createElement(ButtonsWrapper$6, null, /*#__PURE__*/React__default.createElement(Button$1, {
      onClick: function onClick() {
        return props.handleCloseButton();
      },
      "data-testId": "cancel",
      size: "large",
      use: "secondary",
      "data-track": "{\"type\": \"link\", \"name\": \"Cancel\"}",
      style: {
        marginRight: "20px"
      },
      surface: isDark ? "dark" : "light"
    }, "Cancel"), /*#__PURE__*/React__default.createElement(Button$1, {
      onClick: handleSubmit,
      "data-testId": "submit",
      disabled: btnShow,
      size: "large",
      "data-track": "{\"type\": \"link\", \"name\": \"Submit\"}",
      surface: isDark ? "dark" : "light"
    }, "Submit")));
  };
  var modalClose = function modalClose(e) {
    return props.handleCloseButton({
      done: true
    });
  };
  var renderNextOptions = function renderNextOptions(contactOptions, handleSelect) {
    var optionCount = 0;
    return contactOptions.map(function (option) {
      return /*#__PURE__*/React__default.createElement(UserConsumer, null, function (value) {
        if (Object.keys(value.callbackData).length > 0 && option.heading == 'Schedule call back') {
          option.subHeading = option.subHeading.slice(0, option.subHeading.indexOf('call in') + 8) + value.callbackData.waitTimeRange;
        }
        return /*#__PURE__*/React__default.createElement(StepOption$3, {
          key: "option_" + optionCount++,
          onClick: function onClick() {
            return handleSelect(option);
          },
          "data-analyticstrack": option.heading,
          "data-track": "{\"type\": \"link\", \"name\": " + option.heading + "}",
          "data-clickstream": option.heading + "-link",
          "data-testid": "stepOptions"
        }, option.heading && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Title, {
          size: "small"
        }, option.heading)), /*#__PURE__*/React__default.createElement("div", {
          style: {
            paddingTop: "6px"
          }
        }, option.subHeading && /*#__PURE__*/React__default.createElement(Body, {
          size: "small"
        }, option.subHeading)));
      });
    });
  };
  var handleSelect = function handleSelect(option) {
    if (option.callFunction === 'anotherSolution' && window.isAcss && window.caseDetails.changeIssueUrl) {
      var _window$caseDetails$e, _window, _window$caseDetails;
      var equipmentId = (_window$caseDetails$e = (_window = window) === null || _window === void 0 ? void 0 : (_window$caseDetails = _window.caseDetails) === null || _window$caseDetails === void 0 ? void 0 : _window$caseDetails.equipmentId) != null ? _window$caseDetails$e : '';
      redirectFormPostToUrl(window.caseDetails.changeIssueUrl, equipmentId);
      return;
    }
    if (props.functions.handleTroubleShootingAction) {
      props.functions.handleTroubleShootingAction(option);
      props.handleCloseButton();
    }
  };
  var renderFeedbackMsg = function renderFeedbackMsg() {
    return /*#__PURE__*/React__default.createElement("div", {
      id: "feedbackBox2",
      style: {
        textAlign: "center"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      style: {
        paddingTop: "10%",
        fontWeight: 700
      }
    }, "Thanks for helping us improve."), /*#__PURE__*/React__default.createElement("div", {
      style: {
        paddingTop: "10%",
        display: "flex",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React__default.createElement(Button$1, {
      "data-track": "{\"type\": \"link\", \"name\": \"Done\"}",
      primary: true,
      onClick: function onClick(e) {
        return modalClose();
      },
      "data-testid": "Done"
    }, "Done")));
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ThumbsUpContainer$2, null, /*#__PURE__*/React__default.createElement(UserConsumer, null, function (value) {
    var _value$additionalInfo;
    var HOW_TO_THUMBS_DOWN_RESPONSE = value === null || value === void 0 ? void 0 : (_value$additionalInfo = value.additionalInfoSteps) === null || _value$additionalInfo === void 0 ? void 0 : _value$additionalInfo.find(function (steps) {
      return steps.templateId === "HOW_TO_THUMBS_DOWN_RESPONSE";
    });
    if (HOW_TO_THUMBS_DOWN_RESPONSE) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Title, {
        size: "small"
      }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, HOW_TO_THUMBS_DOWN_RESPONSE.heading)), /*#__PURE__*/React__default.createElement(SpacerDiv, {
        height: "5px"
      }), /*#__PURE__*/React__default.createElement(Micro, null, /*#__PURE__*/React__default.createElement(TextWithHtml, null, HOW_TO_THUMBS_DOWN_RESPONSE.description)), /*#__PURE__*/React__default.createElement(NextOptionContainer, null, renderNextOptions(HOW_TO_THUMBS_DOWN_RESPONSE.contactOptions, handleSelect)));
    } else {
      return /*#__PURE__*/React__default.createElement(Fragment, null, !justAfterThumbsDownClicked && /*#__PURE__*/React__default.createElement(FeedbackWrapper$2, null, !showThumbsUp ? /*#__PURE__*/React__default.createElement(ThumbsImg$1, {
        alt: "thumbs_up",
        "data-name": "ThumbUp",
        src: "https://scache.vzw.com/content/dam/support/social-share/Up_Idle.png",
        className: !(thumbsClicked || justAfterThumbsDownClicked) ? 'notselected' : '',
        onClick: handleThumbsUpClick,
        "data-testid": "ThumbUp",
        disabled: thumbsClicked || justAfterThumbsDownClicked,
        "data-analyticstrack": "thumbs-Up-Idle",
        "data-track": "{\"type\": \"icon\", \"name\": \"thumbsup\"}",
        "data-clickstream": "thumbs-Up-Idle"
      }) : /*#__PURE__*/React__default.createElement(ThumbsImg$1, {
        alt: "thumbs_up",
        "data-name": "ThumbUp",
        src: "https://scache.vzw.com/content/dam/support/social-share/Up_On.png",
        className: !(thumbsClicked || justAfterThumbsDownClicked) ? 'notselected' : '',
        disabled: thumbsClicked || justAfterThumbsDownClicked,
        "data-analyticstrack": "thumbs-Up-On",
        "data-track": "{\"type\": \"icon\", \"name\": \"thumbsup\"}",
        "data-clickstream": "thumbs-Up-On"
      }), !showThumbsDown ? /*#__PURE__*/React__default.createElement(ThumbsImg$1, {
        alt: "thumbs_down",
        "data-name": "ThumbDown",
        src: "https://scache.vzw.com/content/dam/support/social-share/Down_Idle.png",
        className: !(thumbsClicked || justAfterThumbsDownClicked) ? 'notselected' : '',
        onClick: handleThumbsDownClick,
        "data-testid": "ThumbDown",
        disabled: thumbsClicked || justAfterThumbsDownClicked,
        "data-analyticstrack": "thumbs-Down-Idle",
        "data-track": "{\"type\": \"icon\", \"name\": \"thumbsdown\"}",
        "data-clickstream": "thumbs-Down-Idle"
      }) : /*#__PURE__*/React__default.createElement(ThumbsImg$1, {
        alt: "thumbs_up",
        "data-name": "ThumbDown",
        src: "https://scache.vzw.com/content/dam/support/social-share/Down_On.png",
        className: !(thumbsClicked || justAfterThumbsDownClicked) ? 'notselected' : '',
        disabled: thumbsClicked || justAfterThumbsDownClicked,
        "data-analyticstrack": "thumbs-Down-On",
        "data-track": "{\"type\": \"icon\", \"name\": \"thumbsdown\"}",
        "data-clickstream": "thumbs-Down-On"
      })));
    }
  }), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "10px"
  })), thumbsClicked && !submitClicked && justAfterThumbsDownClicked && renderFeedback(), thumbsClicked && (!submitClicked && showThumbsUp || submitClicked && showThumbsDown) && renderFeedbackMsg(), submitClicked && !(submitClicked && showThumbsDown) && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    id: "Feedbackconf"
  }, /*#__PURE__*/React__default.createElement(Body, {
    size: "large",
    viewport: "desktop",
    primitive: "h1"
  }, "Thanks for letting us know."))));
};
HowToFeedbackContainerModal.propTypes = {
  functions: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
};
HowToFeedbackContainerModal.defaultProps = {};

var _templateObject$j, _templateObject2$f, _templateObject3$f, _templateObject4$f;
var SaveAndExitContainer = styled.div(_templateObject$j || (_templateObject$j = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-bottom: 10px;\n"])));
var TitleContainer$2 = styled.div(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteralLoose(["\nwidth: 100%;\nh3 {\n  font-size: 28px !important\n}\n"])));
var ButtonWrapper$5 = styled.div(_templateObject3$f || (_templateObject3$f = _taggedTemplateLiteralLoose(["\ndisplay: flex;\nwidth: 100%;\njustify-content: space-between;\n  @media screen and (min-width: 601px) {\n    height: 60px;\n  }\n  @media screen and (max-width: 600px) {\n    display:none\n  }\n"])));
var StyledButtons = styled(Button$1)(_templateObject4$f || (_templateObject4$f = _taggedTemplateLiteralLoose(["\nwidth: 35%\n"])));
var SaveAndExitContainerModal = function SaveAndExitContainerModal(props) {
  var configDetails = useContext(ConfigContext);
  useEffect(function () {
    try {
      var _props$symptom, _configDetails$caseDe, _configDetails$select;
      var page = "troubleshooter | " + ((props === null || props === void 0 ? void 0 : (_props$symptom = props.symptom) === null || _props$symptom === void 0 ? void 0 : _props$symptom.issueName) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$caseDe = configDetails.caseDetails) === null || _configDetails$caseDe === void 0 ? void 0 : _configDetails$caseDe.intent) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select = configDetails.selectedNSAIntent) === null || _configDetails$select === void 0 ? void 0 : _configDetails$select.intent)) + " | Save & Exit";
      window.vzdl.page = page;
      window.sendCustomEvent && window.sendCustomEvent("troubleshooting", window.vzdl);
    } catch (error) {
      console.error(error);
    }
  }, []);
  var modalClose = function modalClose(e) {
    if (window._dg_channelId === "VZW-MFA") {
      var mvaParam = {
        "actionType": "openPage",
        "pageType": "myFeed"
      };
      invokeNative(JSON.stringify(mvaParam));
      return;
    }
    window.location.href = "/digital/nsa/secure/ui/support/signinlanding";
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(SaveAndExitContainer, null, /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "30px"
  }), /*#__PURE__*/React__default.createElement(TitleContainer$2, null, /*#__PURE__*/React__default.createElement(Title, {
    size: "large"
  }, /*#__PURE__*/React__default.createElement(UserConsumer, null, function (value) {
    var _value$additionalInfo, _value$additionalInfo2;
    return (_value$additionalInfo = (_value$additionalInfo2 = value.additionalInfoSteps.find(function (steps) {
      return steps.templateId === "SAVE_AND_EXIT_MODAL";
    })) === null || _value$additionalInfo2 === void 0 ? void 0 : _value$additionalInfo2.title) != null ? _value$additionalInfo : "We'll save your progress";
  }))), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "17px"
  }), /*#__PURE__*/React__default.createElement(Body, {
    size: "large",
    viewport: "desktop",
    primitive: "h2"
  }, /*#__PURE__*/React__default.createElement(UserConsumer, null, function (value) {
    var _value$additionalInfo3, _value$additionalInfo4;
    return /*#__PURE__*/React__default.createElement(TextWithHtml, null, (_value$additionalInfo3 = (_value$additionalInfo4 = value.additionalInfoSteps.find(function (steps) {
      return steps.templateId === "SAVE_AND_EXIT_MODAL";
    })) === null || _value$additionalInfo4 === void 0 ? void 0 : _value$additionalInfo4.description) != null ? _value$additionalInfo3 : "<p>Resume this troubleshooting any time within the next 24 hours from the Support Overview Page</p>\n");
  })), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "45px"
  }), /*#__PURE__*/React__default.createElement(StyledButtons, {
    "data-track": "{\"type\": \"link\", \"name\": \"Done\"}",
    primary: true,
    onClick: function onClick(e) {
      return modalClose();
    }
  }, "Done")));
};
SaveAndExitContainerModal.propTypes = {
  functions: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
};
SaveAndExitContainerModal.defaultProps = {};

var _templateObject$k, _templateObject2$g, _templateObject3$g, _templateObject4$g, _templateObject5$e;
var ThumbsUpContainer$3 = styled.div(_templateObject$k || (_templateObject$k = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: initial;\n  padding-right:10px;\n"])));
var SaveAndExitWrapper = styled.div(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteralLoose(["\n  display: flex;\n  gap: 10px;\n  .newDesignIcon{\n    display:flex;\n    justify-content: center;\n    gap: 5px;\n    align-items: center;\n  }\n\n  @media screen and (max-width: 600px) {\n    display:none\n  }\n"])));
var SaveAndExitWrapperMobile = styled.div(_templateObject3$g || (_templateObject3$g = _taggedTemplateLiteralLoose(["\n  margin:0px auto;\n  @media screen and (min-width: 600px) {\n    display:none\n  }\n  @media screen and (max-width: 600px) {\n    margin:0;\n    display: flex;\n    flex-direction: column;\n    grid-gap: 12px;\n    .newDesignIcon{\n      max-width: 110px;\n  }\n"])));
var IconWrapper$2 = styled.div(_templateObject4$g || (_templateObject4$g = _taggedTemplateLiteralLoose(["\n  cursor: ", ";\n  height: 20px;\n"])), function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? '' : 'pointer';
});
var SaveAndExitBox = styled.textarea(_templateObject5$e || (_templateObject5$e = _taggedTemplateLiteralLoose(["\n  resize: none;\n  width: 100%;\n  height: 80px;\n  padding: 1.2%;\n  border-radius: 0.3rem;\n\n  ::placeholder {\n    font-family: Verizon-NHG-eDS;\n  }\n"])));
var SaveAndExitContainer$1 = function SaveAndExitContainer(props) {
  var _window, _window2;
  var _props$functions = props.functions,
    functions = _props$functions === void 0 ? {} : _props$functions;
  var handleThumbsUpClick = function handleThumbsUpClick() {
    if (props.handleModalState) {
      props.handleModalState({
        thumbsClicked: true,
        showThumbsUp: true
      });
    }
  };
  if (props.hide) {
    return null;
  }
  console.log('props---->', props, isMobile());
  var hendleOnEnter = function hendleOnEnter(event, action) {
    if (event.key === 'Enter') {
      action === null || action === void 0 ? void 0 : action();
    }
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ThumbsUpContainer$3, {
    id: "ThumbsUPContainer"
  }, /*#__PURE__*/React__default.createElement(SaveAndExitWrapper, null, props.isNewDesign && !props.isHowToContent && !isMobile() && /*#__PURE__*/React__default.createElement("div", {
    role: "button",
    className: "newDesignIcon",
    onClick: !(props !== null && props !== void 0 && props.disabled) && props.handleLinkClick,
    onKeyDown: function onKeyDown(event) {
      return hendleOnEnter(event, props.handleLinkClick);
    },
    style: {
      cursor: props !== null && props !== void 0 && props.disabled ? 'default' : 'pointer'
    },
    tabIndex: "0",
    "aria-label": "Cannot complete this step",
    "data-track": '{"type": "link", "name": "Cannot complete this step"}'
  }, props.skipSolution && props.templateId != 'RESOLUTION_OPTIONS_ALL_DIGITAL' && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Body, {
    color: props !== null && props !== void 0 && props.disabled ? '#d8dada' : '#000000'
  }, "Cannot complete this step"), /*#__PURE__*/React__default.createElement(IconWrapper$2, null, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "no",
    color: props !== null && props !== void 0 && props.disabled ? '#d8dada' : '#000000'
  })))), props.isNewDesign && !props.isHowToContent && /*#__PURE__*/React__default.createElement("div", {
    role: "link",
    className: "newDesignIcon",
    style: {
      cursor: props !== null && props !== void 0 && props.disabled ? 'default' : 'pointer'
    },
    onClick: !(props !== null && props !== void 0 && props.disabled) && functions.redirectToCombinedIssueSelector,
    onKeyDown: function onKeyDown(event) {
      return hendleOnEnter(event, functions.redirectToCombinedIssueSelector);
    },
    tabIndex: "0",
    "aria-label": "Start over",
    "data-track": '{"type": "link", "name": "Start over"}'
  }, /*#__PURE__*/React__default.createElement(Body, {
    color: props !== null && props !== void 0 && props.disabled ? '#d8dada' : '#000000'
  }, "Start over"), /*#__PURE__*/React__default.createElement(IconWrapper$2, null, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "sync",
    color: props !== null && props !== void 0 && props.disabled ? '#d8dada' : '#000000'
  }))), /*#__PURE__*/React__default.createElement("div", {
    role: "button",
    style: {
      display: 'flex',
      gap: '5px',
      alignItems: 'center',
      cursor: props !== null && props !== void 0 && props.disabled ? 'default' : 'pointer'
    },
    onClick: function onClick() {
      !(props !== null && props !== void 0 && props.disabled) && handleThumbsUpClick();
    },
    onKeyPress: !(props !== null && props !== void 0 && props.disabled) && handleThumbsUpClick,
    tabIndex: "0",
    "aria-label": "Save and exit",
    "data-analyticstrack": "save-And-Exit",
    "data-track": '{"type": "icon", "name": "Save and exit"}',
    "data-clickstream": "save-And-Exit",
    "data-name": "SaveandExit"
  }, window.isMVODigital && ((_window = window) === null || _window === void 0 ? void 0 : _window._dg_channelId) === 'VZW-MFA' ? '' : !window.isLoggedOut && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Body, {
    tabIndex: "-1",
    color: props !== null && props !== void 0 && props.disabled ? '#d8dada' : '#000000'
  }, "Save and exit")), window.isMVODigital && ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2._dg_channelId) === 'VZW-MFA' ? '' : !window.isLoggedOut && /*#__PURE__*/React__default.createElement(IconWrapper$2, {
    disabled: props === null || props === void 0 ? void 0 : props.disabled
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "save",
    color: props !== null && props !== void 0 && props.disabled ? '#d8dada' : '#000000'
  })))), /*#__PURE__*/React__default.createElement(SaveAndExitWrapperMobile, null, props.isNewDesign && !props.isHowToContent && isMobile() && /*#__PURE__*/React__default.createElement(Fragment, null, props.skipSolution && /*#__PURE__*/React__default.createElement("div", {
    role: "button",
    style: {
      display: 'flex',
      cursor: props !== null && props !== void 0 && props.disabled ? 'default' : 'pointer'
    },
    onClick: !(props !== null && props !== void 0 && props.disabled) && props.handleLinkClick,
    tabIndex: "0",
    "data-testid": "SaveAndExitid",
    "aria-label": "Save and exit",
    "data-track": '{"type": "link", "name": "Cannot complete this step"}'
  }, /*#__PURE__*/React__default.createElement(IconWrapper$2, null, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "no",
    color: props !== null && props !== void 0 && props.disabled ? '#d8dada' : '#000000'
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      paddingLeft: '10px'
    }
  }, /*#__PURE__*/React__default.createElement(Body, {
    color: props !== null && props !== void 0 && props.disabled ? '#d8dada' : '#000000'
  }, "Cannot complete this step")))), props.isNewDesign && !props.isHowToContent && /*#__PURE__*/React__default.createElement("div", {
    role: "button",
    style: {
      display: 'flex',
      maxWidth: '200px',
      cursor: props !== null && props !== void 0 && props.disabled ? 'default' : 'pointer'
    },
    onClick: !(props !== null && props !== void 0 && props.disabled) && functions.redirectToCombinedIssueSelector,
    tabIndex: "0",
    "aria-label": "Start over",
    "data-track": '{"type": "link", "name": "Start over"}'
  }, /*#__PURE__*/React__default.createElement(IconWrapper$2, null, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "sync",
    color: props !== null && props !== void 0 && props.disabled ? '#d8dada' : '#000000'
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      paddingLeft: '10px'
    }
  }, /*#__PURE__*/React__default.createElement(Body, {
    color: props !== null && props !== void 0 && props.disabled ? '#d8dada' : '#000000'
  }, "Start over"))), /*#__PURE__*/React__default.createElement("div", null, window.isMVODigital && !window.isLoggedOut ? /*#__PURE__*/React__default.createElement("div", {
    role: "button",
    style: {
      display: 'flex',
      gap: '5px',
      alignItems: 'center',
      cursor: props !== null && props !== void 0 && props.disabled ? 'default' : 'pointer'
    },
    onClick: !(props !== null && props !== void 0 && props.disabled) && handleThumbsUpClick,
    tabIndex: "0",
    "aria-label": "Save and exit",
    "data-track": '{"type": "icon", "name": "Save and exit"}',
    "data-clickstream": "save-And-Exit"
  }, /*#__PURE__*/React__default.createElement(IconWrapper$2, null, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "save",
    color: props !== null && props !== void 0 && props.disabled ? '#d8dada' : '#000000'
  })), /*#__PURE__*/React__default.createElement(Body, {
    color: props !== null && props !== void 0 && props.disabled ? '#d8dada' : '#000000'
  }, "Save and exit")) : null)))));
};
SaveAndExitContainer$1.defaultProps = {};

var defaultOptions = {
  waitForVisaibility: true,
  interval: 100
};
var useQuerySelector = function useQuerySelector(selector, options) {
  if (options === void 0) {
    options = defaultOptions;
  }
  var _useState = useState(null),
    elementRef = _useState[0],
    setElementRef = _useState[1];
  useEffect(function () {
    var intervalId;
    var checkElementVisability = function checkElementVisability() {
      var element = document.querySelector(selector);
      if (element) {
        if (options.waitForVisaibility) {
          var rect = element.getBoundingClientRect();
          if (rect.width > 0 || rect.height > 0) {
            setElementRef(element);
            clearInterval(intervalId);
          }
        } else {
          setElementRef(element);
          clearInterval(intervalId);
        }
      }
    };
    if (!elementRef) {
      intervalId = setInterval(checkElementVisability, options.interval);
    }
    return function () {
      return clearInterval(intervalId);
    };
  }, [selector, options.interval, options.waitForVisaibility, elementRef]);
  return elementRef;
};

var palette$1 = ColorTokens.palette;
var styles = {
  control: function control(provided, state) {
    return _extends({}, provided, {
      padding: 1,
      border: "1px solid " + palette$1.gray44.value,
      borderRadius: 4,
      boxShadow: "none",
      "&:hover": {
        border: "1px solid black"
      },
      "&:after": (state === null || state === void 0 ? void 0 : state.isFocused) && {
        background: "transparent",
        content: "' '",
        position: "absolute",
        height: "100%",
        width: "100%",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        border: "0.0625rem dashed rgb(0, 0, 0)",
        borderRadius: "0.25rem",
        padding: 3
      },
      minWidth: 120,
      pointerEvents: state !== null && state !== void 0 && state.isDisabled ? "auto" : "default",
      cursor: state !== null && state !== void 0 && state.isDisabled ? "not-allowed" : "pointer"
    });
  },
  dropdownIndicator: function dropdownIndicator(provided, state) {
    return _extends({}, provided, {
      transition: "all .2s ease",
      transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null
    });
  },
  option: function option(provided, state) {
    var _palette$gray2;
    var isFocused = state.isFocused,
      isSelected = state.isSelected;
    var getBackgroundColor = function getBackgroundColor() {
      var _palette$blue, _palette$gray;
      if (isSelected) return palette$1 === null || palette$1 === void 0 ? void 0 : (_palette$blue = palette$1.blue94) === null || _palette$blue === void 0 ? void 0 : _palette$blue.value;else if (isFocused) return palette$1 === null || palette$1 === void 0 ? void 0 : (_palette$gray = palette$1.gray85) === null || _palette$gray === void 0 ? void 0 : _palette$gray.value;
      return "transparent";
    };
    var GetBackgroundTheam = function GetBackgroundTheam() {
      var _configDetails$params, _configDetails$params2;
      var configDetails = useContext(ConfigContext);
      return configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : (_configDetails$params2 = _configDetails$params.theme) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.isDark;
    };
    return _extends({}, provided, {
      cursor: "pointer",
      width: "full",
      padding: 12,
      boxShadow: "inset 0 -0.25px 0 0 #B4B4B4",
      "&:first-of-type": {
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3
      },
      "&:last-of-type": {
        borderBottomLeftRadius: 3,
        borderBottomRightRadius: 3,
        borderBottom: "none"
      },
      backgroundColor: GetBackgroundTheam() === true ? '#000' : getBackgroundColor(),
      "&:hover": {
        backgroundColor: GetBackgroundTheam() === true ? '#000' : !(state !== null && state !== void 0 && state.isDisabled) && (palette$1 === null || palette$1 === void 0 ? void 0 : (_palette$gray2 = palette$1.gray85) === null || _palette$gray2 === void 0 ? void 0 : _palette$gray2.value),
        cursor: state !== null && state !== void 0 && state.isDisabled ? "not-allowed" : "pointer",
        border: GetBackgroundTheam() === true && '1px solid #FFF'
      }
    });
  },
  singleValue: function singleValue(provided, state) {
    return _extends({}, provided, {
      color: "#fff",
      cursor: state !== null && state !== void 0 && state.isDisabled ? "not-allowed" : "pointer"
    });
  },
  menu: function menu(provided, state) {
    var _extends2;
    return _extends({}, provided, (_extends2 = {
      marginTop: 8,
      padding: 0,
      backgroundColor: "#fff",
      border: "1px solid " + palette$1.gray44.value,
      width: "max-content",
      minWidth: 350,
      maxWidth: 538,
      borderRadius: 4,
      boxShadow: "none"
    }, _extends2["@media (max-width: 600px)"] = {
      width: "100%",
      minWidth: 'unset'
    }, _extends2.zIndex = "2", _extends2));
  },
  menuList: function menuList(provided, state) {
    return _extends({}, provided, {
      padding: 0,
      maxHeight: 248,
      "&::-webkit-scrollbar": {
        display: "none"
      }
    });
  },
  indicatorSeparator: function indicatorSeparator() {
    return {
      display: "none"
    };
  }
};
var CustomOption = function CustomOption(props) {
  var _props$data;
  var dataTrack = "{\"type\": \"link\", \"name\": \"" + (props === null || props === void 0 ? void 0 : (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.title) + "\"}";
  var isSelected = props.isSelected,
    isFocused = props.isFocused;
  var configDetails = useContext(ConfigContext);
  var getColor = function getColor() {
    var _configDetails$params3, _configDetails$params4, _palette$black, _palette$blue2, _configDetails$params5, _configDetails$params6, _palette$black2;
    if (isFocused) return configDetails !== null && configDetails !== void 0 && (_configDetails$params3 = configDetails.paramsDetails) !== null && _configDetails$params3 !== void 0 && (_configDetails$params4 = _configDetails$params3.theme) !== null && _configDetails$params4 !== void 0 && _configDetails$params4.isDark ? "#fff" : palette$1 === null || palette$1 === void 0 ? void 0 : (_palette$black = palette$1.black) === null || _palette$black === void 0 ? void 0 : _palette$black.value;else if (isSelected) return palette$1 === null || palette$1 === void 0 ? void 0 : (_palette$blue2 = palette$1.blue21) === null || _palette$blue2 === void 0 ? void 0 : _palette$blue2.value;
    return configDetails !== null && configDetails !== void 0 && (_configDetails$params5 = configDetails.paramsDetails) !== null && _configDetails$params5 !== void 0 && (_configDetails$params6 = _configDetails$params5.theme) !== null && _configDetails$params6 !== void 0 && _configDetails$params6.isDark ? "#fff" : palette$1 === null || palette$1 === void 0 ? void 0 : (_palette$black2 = palette$1.black) === null || _palette$black2 === void 0 ? void 0 : _palette$black2.value;
  };
  return /*#__PURE__*/React__default.createElement(components.Option, _extends({}, props, {
    innerProps: _extends({}, props.innerProps, {
      "data-track": dataTrack,
      "data-clickstream": "Steps-Dropdown"
    })
  }), /*#__PURE__*/React__default.createElement(Body, {
    size: "large",
    color: getColor()
  }, props === null || props === void 0 ? void 0 : props.children));
};
var CustomSelectContainer = function CustomSelectContainer(props) {
  var dataTrack = "{\"type\": \"link\", \"name\": \"Steps-Dropdown\"}";
  return /*#__PURE__*/React__default.createElement(components.SelectContainer, _extends({}, props, {
    innerProps: _extends({}, props.innerProps, {
      "data-track": dataTrack
    })
  }), props === null || props === void 0 ? void 0 : props.children);
};
var CustomSelectValue = function CustomSelectValue(props) {
  var _props$data2, _configDetails$params7, _configDetails$params8;
  var value = props === null || props === void 0 ? void 0 : (_props$data2 = props.data) === null || _props$data2 === void 0 ? void 0 : _props$data2.value;
  var configDetails = useContext(ConfigContext);
  return /*#__PURE__*/React__default.createElement(components.SingleValue, props, /*#__PURE__*/React__default.createElement(Body, {
    size: "large",
    color: configDetails !== null && configDetails !== void 0 && (_configDetails$params7 = configDetails.paramsDetails) !== null && _configDetails$params7 !== void 0 && (_configDetails$params8 = _configDetails$params7.theme) !== null && _configDetails$params8 !== void 0 && _configDetails$params8.isDark ? "#ffffff" : "#000000"
  }, value));
};
var CustomDropdownIndicator = function CustomDropdownIndicator(props) {
  var _configDetails$params9, _configDetails$params0;
  var configDetails = useContext(ConfigContext);
  return /*#__PURE__*/React__default.createElement(components.DropdownIndicator, props, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "down-caret",
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params9 = configDetails.paramsDetails) !== null && _configDetails$params9 !== void 0 && (_configDetails$params0 = _configDetails$params9.theme) !== null && _configDetails$params0 !== void 0 && _configDetails$params0.isDark ? "dark" : "light"
  }));
};
var buildOption = function buildOption(step, eotFlag) {
  var _step$pageId;
  var stepNumber = step === null || step === void 0 ? void 0 : (_step$pageId = step.pageId) === null || _step$pageId === void 0 ? void 0 : _step$pageId.padStart(2, "0");
  return _extends({}, step, {
    isDisabled: eotFlag,
    value: "Step " + stepNumber,
    label: "Step " + stepNumber + " - " + (step === null || step === void 0 ? void 0 : step.title)
  });
};
var NavSteps = function NavSteps(_ref) {
  var _ref$steps = _ref.steps,
    steps = _ref$steps === void 0 ? [] : _ref$steps,
    onChange = _ref.onChange,
    eotFlag = _ref.eotFlag,
    stepInputRef = _ref.stepInputRef;
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var options = steps === null || steps === void 0 ? void 0 : steps.map(function (step) {
    return buildOption(step, eotFlag);
  }).reverse();
  var _options$filter = options === null || options === void 0 ? void 0 : options.filter(function (option) {
      return option === null || option === void 0 ? void 0 : option.currentStep;
    }),
    selected = _options$filter[0];
  var dummyInput = useQuerySelector("#ts-nav-dropdown");
  useEffect(function () {
    if (dummyInput) {
      dummyInput.setAttribute("aria-label", "troubleshooting steps");
      dummyInput.removeAttribute("aria-autocomplete");
    }
  }, [dummyInput]);
  var onOptionChange = function onOptionChange(selectedStep) {
    onChange(selectedStep.pageId, selectedStep);
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event && (event.keyCode === 13 || event.keyCode === 32 || event.keyCode === 40 || event.keyCode === 38)) {
      setIsOpen(true);
    }
  };
  return /*#__PURE__*/React__default.createElement(Select$1, {
    ref: stepInputRef,
    inputId: "ts-nav-dropdown",
    "data-testid": "ts-nav-dropdown",
    styles: styles,
    options: options,
    defaultValue: selected,
    isSearchable: false,
    isMulti: false,
    tabSelectsValue: false,
    value: selected,
    onChange: onOptionChange,
    onClick: function onClick() {
      return setIsOpen(true);
    },
    onMenuOpen: function onMenuOpen() {
      return setIsOpen(true);
    },
    onKeyDown: handleKeyDown,
    menuIsOpen: isOpen,
    onMenuClose: function onMenuClose() {
      return setIsOpen(false);
    },
    components: {
      SingleValue: CustomSelectValue,
      Option: CustomOption,
      DropdownIndicator: CustomDropdownIndicator,
      SelectContainer: CustomSelectContainer
    }
  });
};

var FeedbackMessage = function FeedbackMessage(props) {
  var _configDetails$params2, _configDetails$params3;
  var item = {
    title: '',
    description: ''
  };
  var _useState = useState(true),
    showFeedback = _useState[0],
    setShowFeedback = _useState[1];
  var _useContext = useContext(ModalContext),
    _useContext$additiona = _useContext.additionalInfoSteps,
    additionalInfoSteps = _useContext$additiona === void 0 ? [] : _useContext$additiona;
  additionalInfoSteps === null || additionalInfoSteps === void 0 ? void 0 : additionalInfoSteps.map(function (value) {
    if (value.templateId === 'FEEDBACK_SUCCESS') {
      item = value;
    }
  });
  var configDetails = useContext(ConfigContext);
  useEffect(function () {
    if (document.getElementById('contentBody') && document.getElementById('contentBody') !== null) {
      document.getElementById('contentBody').scroll({
        top: 0,
        behavior: 'smooth'
      });
    }
    tagging.setPage({
      target: {
        message: item.title
      }
    }, true);
    if (window.isMVODigital) {
      setTimeout(function () {
        setShowFeedback(false);
      }, 15000);
    }
    return function () {
      window.vzdl.target.message = '';
    };
  }, []);
  if (!item.title && !item.description) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(Fragment, null, showFeedback ? /*#__PURE__*/React__default.createElement(Notification, {
    id: "bgSuccess",
    type: 'success',
    title: item.title,
    subtitle: /*#__PURE__*/React__default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: item.description
      }
    }),
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params2 = configDetails.paramsDetails) !== null && _configDetails$params2 !== void 0 && (_configDetails$params3 = _configDetails$params2.theme) !== null && _configDetails$params3 !== void 0 && _configDetails$params3.isDark ? 'dark' : 'light',
    disableAnimation: false,
    fullBleed: false,
    hideCloseButton: false,
    disableFocus: false,
    inline: false,
    layout: null,
    onCloseButtonClick: function onCloseButtonClick() {
      return props.closeFeedbackBar(props.values);
    }
  }) : /*#__PURE__*/React__default.createElement(Box, {
    marginBottom: ['-24px', '-32px']
  }));
};

var FeedbackBarError = function FeedbackBarError(props) {
  var _configDetails$params2, _configDetails$params3;
  var item = {
    title: '',
    description: ''
  };
  var _useState = useState(true),
    showFeedback = _useState[0],
    setShowFeedback = _useState[1];
  var _useContext = useContext(ModalContext),
    _useContext$additiona = _useContext.additionalInfoSteps,
    additionalInfoSteps = _useContext$additiona === void 0 ? [] : _useContext$additiona;
  additionalInfoSteps === null || additionalInfoSteps === void 0 ? void 0 : additionalInfoSteps.map(function (value) {
    if (value.templateId === 'FEEDBACK_FAILURE') {
      item = value;
    }
  });
  var configDetails = useContext(ConfigContext);
  useEffect(function () {
    if (document.getElementById('contentBody') && document.getElementById('contentBody') !== null) {
      document.getElementById('contentBody').scroll({
        top: 0,
        behavior: 'smooth'
      });
    }
    tagging.setPage({
      target: {
        message: item.title
      }
    }, true);
    if (window.isMVODigital) {
      setTimeout(function () {
        setShowFeedback(false);
      }, 15000);
    }
    return function () {
      window.vzdl.target.message = '';
    };
  }, []);
  if (!item.title && !item.description) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(Fragment, null, showFeedback ? /*#__PURE__*/React__default.createElement(Notification, {
    id: "bgError",
    type: 'error',
    title: item.title,
    subtitle: /*#__PURE__*/React__default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: item.description
      }
    }),
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params2 = configDetails.paramsDetails) !== null && _configDetails$params2 !== void 0 && (_configDetails$params3 = _configDetails$params2.theme) !== null && _configDetails$params3 !== void 0 && _configDetails$params3.isDark ? 'dark' : 'light',
    disableAnimation: false,
    fullBleed: false,
    hideCloseButton: false,
    disableFocus: false,
    inline: false,
    layout: null,
    onCloseButtonClick: function onCloseButtonClick() {
      return props.closeFeedbackBar(props.values);
    }
  }) : /*#__PURE__*/React__default.createElement(Box, {
    marginBottom: ['-24px', '-32px']
  }));
};

var _templateObject$l, _templateObject2$h;
var finalComps = {
  styles: styledComps
};
if (window.isBAUACSS) {
  finalComps = {
    styles: styledBauComps
  };
}
if (window.isMVODigital) {
  finalComps = {
    styles: styledDigital
  };
}
var _finalComps$styles = finalComps.styles,
  FeedbackCloseButton$3 = _finalComps$styles.FeedbackCloseButton,
  NavStepsContainer$3 = _finalComps$styles.NavStepsContainer,
  ContentWrapper$6 = _finalComps$styles.ContentWrapper,
  TitleWrapper$5 = _finalComps$styles.TitleWrapper,
  Cancel$3 = _finalComps$styles.Cancel,
  StepContainer$3 = _finalComps$styles.StepContainer,
  StepInfoContainer$3 = _finalComps$styles.StepInfoContainer,
  ContactsContainer$3 = _finalComps$styles.ContactsContainer,
  DividerContainer$3 = _finalComps$styles.DividerContainer,
  DesktopHeadingWrapper$3 = _finalComps$styles.DesktopHeadingWrapper,
  MobileHeadingWrapper$3 = _finalComps$styles.MobileHeadingWrapper,
  PageTitle$3 = _finalComps$styles.PageTitle,
  StepOption$4 = _finalComps$styles.StepOption,
  StyledTextWithHtml$3 = _finalComps$styles.StyledTextWithHtml,
  SaveExitCloseButton$3 = _finalComps$styles.SaveExitCloseButton,
  StyledModal$6 = _finalComps$styles.StyledModal,
  StyledModalBody$5 = _finalComps$styles.StyledModalBody,
  FeedbackSaveExitContainer$3 = _finalComps$styles.FeedbackSaveExitContainer,
  TroubleShootingTitleNew$3 = _finalComps$styles.TroubleShootingTitleNew,
  IssueBoxWrapper$3 = _finalComps$styles.IssueBoxWrapper,
  IssueContentbox$3 = _finalComps$styles.IssueContentbox,
  IssueContentArrow$3 = _finalComps$styles.IssueContentArrow;
var FlexCol = styled.div(_templateObject$l || (_templateObject$l = _taggedTemplateLiteralLoose(["\n  display: flex;\n  @media (max-width: 1024px){\n    flex-direction : column;\n  }\n  @media (min-width: 359px) and (max-width: 376px){\n    margin-left : 1em;\n  }\n"])));
var ContactWidth = styled.div(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteralLoose(["\n  @media (min-width: 768px) and (max-width: 1024px){\n    width : 50% ;\n  }\n"])));
var renderNextOptions = function renderNextOptions(finalContactOptions, handleSelect) {
  var optionCount = 0;
  return finalContactOptions.map(function (option) {
    return /*#__PURE__*/React__default.createElement(StepOption$4, {
      key: "option_" + optionCount++,
      onClick: function onClick() {
        return handleSelect(option);
      },
      "data-analyticstrack": option.heading,
      "data-track": "{\"type\": \"link\", \"name\": " + option.heading + "}",
      "data-clickstream": option.heading + "-link"
    }, window.isMVODigital ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(IssueBoxWrapper$3, null, /*#__PURE__*/React__default.createElement(IssueContentbox$3, null, option.heading && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Title, {
      bold: true,
      size: "small"
    }, option.heading)), /*#__PURE__*/React__default.createElement("div", {
      style: {
        paddingTop: "6px"
      }
    }, option.subHeading && /*#__PURE__*/React__default.createElement(Body, {
      size: "small"
    }, option.subHeading))), /*#__PURE__*/React__default.createElement(IssueContentArrow$3, null, " ", /*#__PURE__*/React__default.createElement(Icon$1, {
      name: "right-arrow",
      size: "small"
    })))) : /*#__PURE__*/React__default.createElement(Fragment, null, option.heading && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Title, {
      size: "small"
    }, option.heading)), /*#__PURE__*/React__default.createElement("div", {
      style: {
        paddingTop: "6px"
      }
    }, option.subHeading && /*#__PURE__*/React__default.createElement(Body, {
      size: "small"
    }, option.subHeading))));
  });
};
var feedbackStatusObj = {
  feedbackSent: false
};
var ContactsPage = function ContactsPage(props) {
  var _issue$eotFlag, _issue$isHowToContent, _configDetails$config, _steps$, _values$feedbackConta, _mvoTroubleShootingJs, _mvoTroubleShootingJs2, _values$feedbackConta2, _values$feedbackConta3, _configDetails$params, _configDetails$params2, _window, _window$troubleShooti, _window$troubleShooti2, _window$troubleShooti3, _configDetails$params3, _configDetails$params4, _configDetails$params5, _configDetails$params6, _configDetails$params7, _configDetails$params8;
  console.log("comren: ContactsPage", props);
  var _props$values = props.values,
    values = _props$values === void 0 ? {} : _props$values,
    _props$functions = props.functions,
    functions = _props$functions === void 0 ? {} : _props$functions;
  var _useState = useState({
      showModal: false,
      expandModal: false,
      modalType: ''
    }),
    modalValues = _useState[0],
    setModalValues = _useState[1];
  var _useState2 = useState({
      showThumbsUp: false,
      showThumbsDown: false,
      thumbsClicked: false,
      submitClicked: false,
      rating: ''
    }),
    flags = _useState2[0],
    setFlags = _useState2[1];
  var _values$landingInfo = values.landingInfo,
    landingInfo = _values$landingInfo === void 0 ? {} : _values$landingInfo,
    _values$troubleShooti = values.troubleShootingInfo,
    contactsInfo = _values$troubleShooti === void 0 ? {} : _values$troubleShooti,
    _values$symptom = values.symptom,
    symptom = _values$symptom === void 0 ? {} : _values$symptom;
  var output = getObjectPropertyByPath("ddata.output", contactsInfo, {});
  var templateType = getTemplateType(contactsInfo);
  var _output$pageContent = output.pageContent,
    pageContent = _output$pageContent === void 0 ? {} : _output$pageContent,
    _output$navHist = output.navHist,
    navHist = _output$navHist === void 0 ? [] : _output$navHist,
    currentPageId = output.currentPageId;
  var _pageContent$steps = pageContent.steps,
    steps = _pageContent$steps === void 0 ? [] : _pageContent$steps;
  var issue = steps[0] || {};
  var eotFlag = (_issue$eotFlag = issue === null || issue === void 0 ? void 0 : issue.eotFlag) != null ? _issue$eotFlag : false;
  var resolution = getStepByName("resolution", steps);
  var isHowToContent = (_issue$isHowToContent = issue === null || issue === void 0 ? void 0 : issue.isHowToContent) != null ? _issue$isHowToContent : false;
  var _issue$contactOptions = issue.contactOptions,
    contactOptions = _issue$contactOptions === void 0 ? [] : _issue$contactOptions;
  var _landingInfo$device = landingInfo.device,
    device = _landingInfo$device === void 0 ? {} : _landingInfo$device;
  var is5GDevice = device.is5GDevice;
  var templateTypeMain = issue.templateType || '';
  var configDetails = useContext(ConfigContext);
  var isNewDesign = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config = configDetails.config) === null || _configDetails$config === void 0 ? void 0 : _configDetails$config.isNewTemplate) && !is5GDevice;
  var uiLoggerContext = useContext(UiLoggerContext);
  var mvoConfig = sessionUtility.getMvoConfig();
  var mvoCaseDetails = sessionUtility.getCaseDetails();
  var finalContactOptions = contactOptions;
  if (((_steps$ = steps[0]) === null || _steps$ === void 0 ? void 0 : _steps$.templateId) == "4G-CONTACT-OPTIONS-WITHOUT-REPAIR" && window.isLoggedOut) {
    if (contactOptions.length > 0) {
      finalContactOptions = contactOptions.filter(function (option) {
        return option.callFunction != "sdr";
      });
    }
  }
  useEffect(function () {
    if (is5GDevice && symptom.issueName && currentPageId) {
      taggingSetStepNameValue(symptom.issueName + "_" + currentPageId);
      console.log("analytics : step", symptom.issueName + "_" + currentPageId);
      taggingSetPageValue(symptom.issueName + "_" + currentPageId);
      console.log("analytics : page", symptom.issueName + "_" + currentPageId);
    }
  }, [is5GDevice, symptom.issueName, currentPageId]);
  useEffect(function () {
    var errorShown = "0";
    var userViewedMessage = "";
    if (templateTypeMain == "contactoptions-error") {
      errorShown = "1";
      userViewedMessage = steps[0].heading;
    }
    if (uiLoggerContext.setPageDetails) {
      var pageDetails = {
        pageTitle: getTitle(),
        pageName: (is5GDevice ? "5G" : "4G") + " Troubleshooting | " + getTitle(),
        errorShown: errorShown,
        flowName: (is5GDevice ? "5G" : "4G") + " Troubleshooting",
        userViewedMessage: userViewedMessage
      };
      uiLoggerContext.setPageDetails(pageDetails);
    }
  }, [currentPageId]);
  useEffect(function () {
    try {
      var _configDetails$caseDe, _configDetails$select;
      var page = "troubleshooter | " + ((symptom === null || symptom === void 0 ? void 0 : symptom.issueName) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$caseDe = configDetails.caseDetails) === null || _configDetails$caseDe === void 0 ? void 0 : _configDetails$caseDe.intent) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select = configDetails.selectedNSAIntent) === null || _configDetails$select === void 0 ? void 0 : _configDetails$select.intent)) + " | Contact Us";
      window.vzdl.page = page;
      window.sendCustomEvent && window.sendCustomEvent("troubleshooting", window.vzdl);
    } catch (error) {}
  }, []);
  var handleCancel = function handleCancel() {
    console.log("ContactsPage:handleCancel: called...");
    if (functions.handleCancel) {
      functions.handleCancel();
    }
  };
  var handleSelect = function handleSelect(option) {
    if (option.callFunction === "anotherSolution" && mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isAcss && mvoCaseDetails !== null && mvoCaseDetails !== void 0 && mvoCaseDetails.changeIssueUrl) {
      var _mvoCaseDetails$equip;
      var equipmentId = (_mvoCaseDetails$equip = mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.equipmentId) != null ? _mvoCaseDetails$equip : "";
      redirectFormPostToUrl(mvoCaseDetails.changeIssueUrl, equipmentId);
      return;
    }
    if (functions.handleTroubleShootingAction) {
      functions.handleTroubleShootingAction(option);
    }
  };
  var handleChecklistChange = function handleChecklistChange(value, step) {
    console.log("ContactsPage:handleCheckListChange: value:", value);
    if (functions.handleReplayNavigation) {
      functions.handleReplayNavigation(value, step);
    }
  };
  var handleModalState = function handleModalState(flags) {
    setModalValues(_extends({}, modalValues, {
      showModal: true,
      expandModal: true,
      modalType: isHowToContent && isNewDesign && !window.isMVODigital ? 'howToFeedback' : 'feedback'
    }));
    setFlags(_extends({}, flags));
  };
  var handleLinkClick = function handleLinkClick() {
    if (functions.processTroubleShootingPage) {
      functions.processTroubleShootingPage("submit", "skip");
    }
  };
  var handleModalSaveExitState = function handleModalSaveExitState() {
    setModalValues(_extends({}, modalValues, {
      showModal: true,
      expandModal: true,
      modalType: 'saveAndExit'
    }));
  };
  var modalChanged = function modalChanged(open) {
    if (!open) {
      if (props.handleAction) {
        props.handleAction({
          actionData: 'close'
        });
      }
    }
  };
  var handleModalClick = function handleModalClick() {
    setModalValues(_extends({}, modalValues, {
      expandModal: true,
      modalType: isHowToContent && isNewDesign && !window.isMVODigital ? 'howToFeedback' : 'feedback'
    }));
  };
  var handleCloseButton = function handleCloseButton() {
    setModalValues(_extends({}, modalValues, {
      showModal: false,
      expandModal: false,
      modalType: ''
    }));
  };
  var passFeedbackData = function passFeedbackData(data) {
    feedbackStatusObj = _extends({}, data);
  };
  var getTitle = function getTitle() {
    var _configDetails$caseDe2, _configDetails$select2;
    return (symptom.issueName || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$caseDe2 = configDetails.caseDetails) === null || _configDetails$caseDe2 === void 0 ? void 0 : _configDetails$caseDe2.intent) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select2 = configDetails.selectedNSAIntent) === null || _configDetails$select2 === void 0 ? void 0 : _configDetails$select2.intent) || "Title") + "" + (currentPageId && currentPageId !== "1" ? typeof device.deviceName !== "undefined" && device.deviceName !== null && device.deviceName != "" ? " - " + device.deviceName : "" : "");
  };
  var mvoTroubleShootingJson = sessionUtility.getTroubleShootingJson();
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ContentWrapper$6, {
    showBorder: true,
    isNewDesign: isNewDesign,
    "data-testid": "ContactsPage"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      paddingLeft: '20px'
    }
  }, (_values$feedbackConta = values.feedbackContainerDetails) !== null && _values$feedbackConta !== void 0 && _values$feedbackConta.show && !(mvoTroubleShootingJson !== null && mvoTroubleShootingJson !== void 0 && (_mvoTroubleShootingJs = mvoTroubleShootingJson.ddata) !== null && _mvoTroubleShootingJs !== void 0 && (_mvoTroubleShootingJs2 = _mvoTroubleShootingJs.device) !== null && _mvoTroubleShootingJs2 !== void 0 && _mvoTroubleShootingJs2.is5GDevice) ? (_values$feedbackConta2 = values.feedbackContainerDetails) !== null && _values$feedbackConta2 !== void 0 && _values$feedbackConta2.success && (_values$feedbackConta3 = values.feedbackContainerDetails) !== null && _values$feedbackConta3 !== void 0 && _values$feedbackConta3.show ? /*#__PURE__*/React__default.createElement(FeedbackMessage, {
    values: values,
    closeFeedbackBar: props.functions.closeFeedbackBar
  }) : /*#__PURE__*/React__default.createElement(FeedbackBarError, {
    values: values,
    closeFeedbackBar: props.functions.closeFeedbackBar
  }) : null, /*#__PURE__*/React__default.createElement(TitleWrapper$5, {
    style: {
      paddingTop: "12px",
      width: "100%",
      padding: "0px"
    }
  }, /*#__PURE__*/React__default.createElement(TroubleShootingTitleNew$3, {
    style: {
      width: "95%",
      "float": "left",
      padding: "0px"
    }
  }, /*#__PURE__*/React__default.createElement(Title, {
    bold: true,
    size: "2XLarge"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, {
    style: {
      fontSize: "1.1rem",
      textAlign: "left",
      "line-height": "1.25rem",
      padding: !isMobile() && "0px"
    }
  }, getTitle()))), /*#__PURE__*/React__default.createElement(Cancel$3, {
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : (_configDetails$params2 = _configDetails$params.theme) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.isDark,
    "data-analyticstrack": "cancel-Icon",
    "data-track": "{\"type\": \"link\", \"name\": \"cancel-Icon\"}",
    "data-clickstream": "cancel-Icon",
    onClick: handleCancel,
    style: {
      marginTop: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "close",
    size: "large"
  }))), /*#__PURE__*/React__default.createElement(StepContainer$3, null, /*#__PURE__*/React__default.createElement(FlexCol, null, /*#__PURE__*/React__default.createElement(StepInfoContainer$3, null, /*#__PURE__*/React__default.createElement(DesktopHeadingWrapper$3, null, templateType === "contactoptions" && !isNewDesign && /*#__PURE__*/React__default.createElement("div", {
    className: "checklist-wrapper"
  }, /*#__PURE__*/React__default.createElement(CheckList, {
    "data-testid": "checklist12",
    steps: navHist,
    onChange: function onChange(value) {
      return handleChecklistChange(value);
    },
    size: "100%",
    caretSize: "small",
    value: currentPageId
  })), templateType === 'contactoptions' && isNewDesign && /*#__PURE__*/React__default.createElement(NavStepsContainer$3, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(NavSteps, {
    steps: navHist,
    value: currentPageId,
    onChange: function onChange(value, step) {
      return handleChecklistChange(value, step);
    },
    eotFlag: eotFlag
  }))), issue.heading && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Title, {
    bold: true,
    size: "XLarge"
  }, /*#__PURE__*/React__default.createElement(StyledTextWithHtml$3, {
    style: {
      fontSize: !isMobile() ? "1.5rem" : "1.1rem",
      lineHeight: "1.5rem"
    }
  }, issue.heading)), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "20px"
  }))), /*#__PURE__*/React__default.createElement(MobileHeadingWrapper$3, null, /*#__PURE__*/React__default.createElement("div", {
    className: "checklist-wrapper"
  }, templateType === 'contactoptions' && !isNewDesign && /*#__PURE__*/React__default.createElement(CheckList, {
    steps: navHist,
    onChange: function onChange(value) {
      return handleChecklistChange(value);
    },
    size: "100%",
    value: currentPageId,
    caretSize: "small",
    marginBottom: "20px"
  }), templateType === 'contactoptions' && isNewDesign && /*#__PURE__*/React__default.createElement(NavStepsContainer$3, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(NavSteps, {
    steps: navHist,
    value: currentPageId,
    onChange: function onChange(value, step) {
      return handleChecklistChange(value, step);
    }
  })))), issue.heading && /*#__PURE__*/React__default.createElement(PageTitle$3, null, /*#__PURE__*/React__default.createElement(Title, {
    bold: true,
    size: "medium"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, issue.heading)))), issue.subHeading && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Title, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(StyledTextWithHtml$3, null, issue.subHeading)), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "20px"
  })), issue.description && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "large"
  }, /*#__PURE__*/React__default.createElement(StyledTextWithHtml$3, null, issue.description)), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "20px"
  }))), /*#__PURE__*/React__default.createElement(ContactsContainer$3, {
    isEotpaddingBtm: "true"
  }, /*#__PURE__*/React__default.createElement(ContactWidth, null, renderNextOptions(finalContactOptions, handleSelect))))), props.showTextMeModal && /*#__PURE__*/React__default.createElement(ScheduleCallback, {
    showModal: props.showTextMeModal,
    data: CallbackData.body,
    tsData: props.values,
    functions: props.functions
  }), /*#__PURE__*/React__default.createElement(DividerContainer$3, null, /*#__PURE__*/React__default.createElement(Line$1, {
    type: "secondary"
  })), /*#__PURE__*/React__default.createElement(ActionButtons, {
    showPrevious: navHist.length > 0,
    pageId: currentPageId,
    disableNext: true,
    disablePrevious: true,
    handlePrevious: function handlePrevious(value) {
      return handleChecklistChange(value);
    },
    stackButtons: isMobile(),
    functions: functions,
    values: values,
    handleModalState: handleModalState,
    isNewDesign: isNewDesign,
    isHowToContent: isHowToContent
  }), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "20px"
  }), isNewDesign && !isHowToContent && /*#__PURE__*/React__default.createElement(Line$1, {
    type: "secondary"
  }))), window.isMVODigital && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "10px"
  }), /*#__PURE__*/React__default.createElement(FeedbackSaveExitContainer$3, {
    isNewDesign: isNewDesign,
    hideRightNav: true
  }, /*#__PURE__*/React__default.createElement(FeedbackContainer, {
    functions: functions,
    values: values,
    handleModalState: handleModalState,
    flags: flags
  }), !window.isAcss && !((_window = window) !== null && _window !== void 0 && (_window$troubleShooti = _window.troubleShootingJson) !== null && _window$troubleShooti !== void 0 && (_window$troubleShooti2 = _window$troubleShooti.ddata) !== null && _window$troubleShooti2 !== void 0 && (_window$troubleShooti3 = _window$troubleShooti2.device) !== null && _window$troubleShooti3 !== void 0 && _window$troubleShooti3.is5GDevice) && /*#__PURE__*/React__default.createElement(SaveAndExitContainer$1, {
    isNewDesign: isNewDesign,
    isHowToContent: isHowToContent,
    functions: functions,
    values: values,
    skipSolution: issue.skipSolution,
    handleModalState: handleModalSaveExitState,
    handleLinkClick: handleLinkClick
  }))), modalValues.showModal && /*#__PURE__*/React__default.createElement(StyledModal$6, {
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params3 = configDetails.paramsDetails) !== null && _configDetails$params3 !== void 0 && (_configDetails$params4 = _configDetails$params3.theme) !== null && _configDetails$params4 !== void 0 && _configDetails$params4.isDark ? 'dark' : 'light',
    closeButton: modalValues.modalType === 'saveAndExit' ? /*#__PURE__*/React__default.createElement(SaveExitCloseButton$3, {
      "data-analyticstrack": "overlay-generic-cta",
      onClick: function onClick() {
        return handleCloseButton();
      }
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params5 = configDetails.paramsDetails) !== null && _configDetails$params5 !== void 0 && (_configDetails$params6 = _configDetails$params5.theme) !== null && _configDetails$params6 !== void 0 && _configDetails$params6.isDark ? 'dark' : 'light',
      id: "closeModal",
      name: "close",
      size: "large",
      color: "#000000",
      backgroundColor: "transparent"
    }), ' ') : /*#__PURE__*/React__default.createElement(FeedbackCloseButton$3, {
      "data-analyticstrack": "overlay-generic-cta",
      onClick: function onClick() {
        return handleCloseButton();
      }
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params7 = configDetails.paramsDetails) !== null && _configDetails$params7 !== void 0 && (_configDetails$params8 = _configDetails$params7.theme) !== null && _configDetails$params8 !== void 0 && _configDetails$params8.isDark ? 'dark' : 'light',
      id: "closeModal",
      name: "close",
      size: "large",
      color: "#000000",
      backgroundColor: "transparent"
    }), ' '),
    onOpenedChange: modalChanged,
    opened: modalValues.showModal,
    zIndex: "15000",
    expandModal: modalValues.expandModal,
    disableOutsideClick: true,
    modalType: modalValues.modalType === 'saveAndExit',
    howToModalType: modalValues.modalType === 'howToFeedback',
    modalName: modalValues.modalType,
    maxHeight: "95vh"
  }, /*#__PURE__*/React__default.createElement(StyledModalBody$5, null, modalValues.modalType === 'feedback' && /*#__PURE__*/React__default.createElement(FeedbackContainerModal, {
    functions: functions,
    values: values,
    handleModalClick: handleModalClick,
    flags: flags,
    handleCloseButton: handleCloseButton,
    passSubmitData: passFeedbackData
  }), modalValues.modalType === "howToFeedback" && /*#__PURE__*/React__default.createElement(HowToFeedbackContainerModal, {
    functions: functions,
    values: values,
    handleModalClick: handleModalClick,
    flags: flags,
    handleCloseButton: handleCloseButton
  }), modalValues.modalType === 'saveAndExit' && /*#__PURE__*/React__default.createElement(SaveAndExitContainerModal, {
    functions: functions,
    values: values,
    handleModalClick: handleModalClick,
    handleCloseButton: handleCloseButton
  }))));
};
ContactsPage.propTypes = {
  functions: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
};
ContactsPage.defaultProps = {};

var notificationBgColors = {
  success: ColorTokens.feedback.success.background.onlight.value,
  error: ColorTokens.feedback.error.background.onlight.value,
  info: ColorTokens.feedback.information.background.onlight.value,
  warning: ColorTokens.feedback.warning.background.onlight.value
};
var notificationDarkBgColors = {
  success: ColorTokens.feedback.success.background.ondark.value,
  error: ColorTokens.feedback.error.background.ondark.value,
  info: ColorTokens.feedback.information.background.ondark.value,
  warning: ColorTokens.feedback.warning.background.ondark.value
};
var notificationIcon = {
  success: "checkmark-alt",
  error: "close-alt",
  info: "info",
  warning: "warning"
};
var VDSBanner = function VDSBanner(_ref) {
  var type = _ref.type,
    title = _ref.title,
    subtitle = _ref.subtitle,
    children = _ref.children,
    isDark = _ref.isDark;
  return /*#__PURE__*/React__default.createElement(HStack, {
    backgroundColor: isDark ? (notificationDarkBgColors === null || notificationDarkBgColors === void 0 ? void 0 : notificationDarkBgColors[type]) + " !important" : notificationBgColors === null || notificationBgColors === void 0 ? void 0 : notificationBgColors[type],
    borderRadius: "0.25rem",
    padding: "20px",
    gap: "12px",
    tabIndex: "-1"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    id: isDark && "dark-background",
    name: notificationIcon === null || notificationIcon === void 0 ? void 0 : notificationIcon[type],
    size: "large",
    ariaHidden: true,
    tabIndex: "-1",
    surface: isDark ? 'dark' : 'light'
  }), /*#__PURE__*/React__default.createElement(Stack, {
    justifyContent: "center",
    tabIndex: "-1",
    id: isDark && "dark-background"
  }, !!title && /*#__PURE__*/React__default.createElement(Body, {
    bold: true,
    size: "large",
    color: isDark ? '#fff' : '#000'
  }, title), !!subtitle && /*#__PURE__*/React__default.createElement(Body, {
    bold: true,
    size: "large",
    color: isDark ? '#fff' : '#000'
  }, subtitle), children));
};

var BANNER_TEMPLATE = "solutionbanner";
var bannerType = {
  Yes: "success",
  No: "error",
  Info: "info"
};
var getSingleString = function getSingleString(_ref) {
  var label = _ref.label,
    value = _ref.value;
  if (label && !value) return label;else if (!label && value) return value;else if (label && value) return label + ": " + value;else return undefined;
};
var constructTaggingMessage = function constructTaggingMessage(banner) {
  if (banner === void 0) {
    banner = {};
  }
  var _banner = banner,
    type = _banner.type,
    title = _banner.title;
  return type + "_" + (title === null || title === void 0 ? void 0 : title.toLowerCase());
};
var parseBanner = function parseBanner(instepBannerAttrs) {
  if (!instepBannerAttrs) return [];
  var banners = [];
  instepBannerAttrs === null || instepBannerAttrs === void 0 ? void 0 : instepBannerAttrs.forEach(function (instepBannerAttr) {
    var attrNames = instepBannerAttr.attrNames;
    attrNames === null || attrNames === void 0 ? void 0 : attrNames.forEach(function (attrName) {
      var attributeID = attrName.attributeID,
        value = attrName.value,
        bannerHeaderLabel = attrName.bannerHeaderLabel,
        bannerHeaderValue = attrName.bannerHeaderValue,
        _attrName$bannerDetai = attrName.bannerDetails,
        bannerDetails = _attrName$bannerDetai === void 0 ? [] : _attrName$bannerDetai;
      var type = bannerType === null || bannerType === void 0 ? void 0 : bannerType[value];
      if (!type) return;
      var title = getSingleString({
        label: bannerHeaderLabel,
        value: bannerHeaderValue
      });
      if (!type) return;
      banners.push({
        attributeID: attributeID,
        type: type,
        title: title,
        bannerDetails: bannerDetails
      });
    });
  });
  return banners;
};
var InStepBanner = function InStepBanner(_ref2) {
  var _ref2$steps = _ref2.steps,
    steps = _ref2$steps === void 0 ? [] : _ref2$steps,
    isACSS = _ref2.isACSS,
    isDark = _ref2.isDark;
  var _useMemo = useMemo(function () {
      return steps.find(function (step) {
        return step.templateType === BANNER_TEMPLATE;
      }) || {};
    }, [steps]),
    instepBannerAttrs = _useMemo.instepBannerAttrs,
    templateType = _useMemo.templateType;
  var banners = useMemo(function () {
    return parseBanner(instepBannerAttrs);
  }, [instepBannerAttrs]);
  useEffect(function () {
    if (!isACSS) return;
    if (banners !== null && banners !== void 0 && banners.length) {
      var message = banners === null || banners === void 0 ? void 0 : banners.map(constructTaggingMessage).join("|");
      if (window.vzdl) {
        window.vzdl.target.message = message;
      }
      sendCustomEvent$1("notification", window.vzdl);
    }
  }, [banners]);
  if (!banners || banners.length === 0 || templateType !== BANNER_TEMPLATE || !isACSS) return null;
  return /*#__PURE__*/React__default.createElement(Stack, {
    lineHeight: "0.25rem",
    gap: "10px",
    paddingBottom: "10px"
  }, banners.map(function (banner, index) {
    var _banner$bannerDetails;
    return /*#__PURE__*/React__default.createElement(VDSBanner, {
      key: banner.attributeID + index,
      type: banner === null || banner === void 0 ? void 0 : banner.type,
      title: banner === null || banner === void 0 ? void 0 : banner.title,
      isDark: isDark
    }, /*#__PURE__*/React__default.createElement(Stack, null, banner === null || banner === void 0 ? void 0 : (_banner$bannerDetails = banner.bannerDetails) === null || _banner$bannerDetails === void 0 ? void 0 : _banner$bannerDetails.map(function (_ref3) {
      var label = _ref3.label,
        value = _ref3.value;
      return /*#__PURE__*/React__default.createElement(Body, {
        size: "large"
      }, label, ": ", value);
    })));
  }));
};

var _templateObject$m;
var WrapperAccordionDetail = styled.div(_templateObject$m || (_templateObject$m = _taggedTemplateLiteralLoose(["\n  * {\n    background-color: transparent !important;\n  }\n  [class^=\"StyledAnchor-VDS\"] {\n    border-bottom: unset;\n  }\n  [class^=\"StyledAnchor-VDS\"] : hover {\n    background-color : rgba(111,113,113,0.26) !important;\n  }\n  [class^=\"StyledAccordionDetail-VDS\"] {\n    padding-bottom: 8px;\n  }\n"])));
var config = {
  Yes: {
    icon: "checkmark-alt",
    iconColor: ColorTokens.feedback.success.onlight.value,
    ariaLabel: "completed"
  },
  No: {
    icon: "close-alt",
    iconColor: ColorTokens.feedback.error.onlight.value,
    ariaLabel: "Failed"
  },
  NotAvailable: {
    icon: "zoom-out",
    iconColor: ColorTokens.elements.secondary.onlight.value,
    ariaLabel: "NotAvailable"
  }
};
var SymptonItem = function SymptonItem(_ref) {
  var _config$value, _config$value2, _config$value3;
  var value = _ref.value,
    attributeID = _ref.attributeID;
  return /*#__PURE__*/React__default.createElement(HStack, {
    width: "100%",
    gap: "10px",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement("div", {
    "aria-label": config === null || config === void 0 ? void 0 : (_config$value = config[value]) === null || _config$value === void 0 ? void 0 : _config$value.ariaLabel,
    role: "img"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: config === null || config === void 0 ? void 0 : (_config$value2 = config[value]) === null || _config$value2 === void 0 ? void 0 : _config$value2.icon,
    color: config === null || config === void 0 ? void 0 : (_config$value3 = config[value]) === null || _config$value3 === void 0 ? void 0 : _config$value3.iconColor,
    size: "large",
    style: {
      paddingTop: 3
    },
    ariaHidden: true
  })), /*#__PURE__*/React__default.createElement(Body, {
    size: "large",
    color: ColorTokens.elements.primary.onlight.value
  }, attributeID));
};
var SymptomAccordion = function SymptomAccordion(_ref2) {
  var symptom = _ref2.symptom,
    isDark = _ref2.isDark;
  if (!symptom) return null;
  var label = symptom.label,
    _symptom$attrNames = symptom.attrNames,
    attrNames = _symptom$attrNames === void 0 ? [] : _symptom$attrNames;
  return /*#__PURE__*/React__default.createElement(WrapperAccordionDetail, null, /*#__PURE__*/React__default.createElement(Accordion$1, {
    topLine: false,
    bottomLine: false,
    surface: isDark ? "dark" : "light"
  }, /*#__PURE__*/React__default.createElement(AccordionItem, {
    opened: true
  }, /*#__PURE__*/React__default.createElement(AccordionHeader, {
    triggerType: "icon"
  }, /*#__PURE__*/React__default.createElement(AccordionTitle, null, label)), /*#__PURE__*/React__default.createElement(AccordionDetail, null, /*#__PURE__*/React__default.createElement(VStack, {
    width: "100%",
    gap: "16px"
  }, attrNames === null || attrNames === void 0 ? void 0 : attrNames.map(function (item) {
    return /*#__PURE__*/React__default.createElement(SymptonItem, _extends({
      key: item === null || item === void 0 ? void 0 : item.attributeID
    }, item));
  }))))));
};
var LeftNav = function LeftNav(_ref3) {
  var _window;
  var _ref3$symptomList = _ref3.symptomList,
    symptomList = _ref3$symptomList === void 0 ? [] : _ref3$symptomList,
    isDark = _ref3.isDark;
  if (symptomList.length === 0) return null;
  var popOutFlow = (_window = window) !== null && _window !== void 0 && _window.isBAUACSS ? true : false;
  return /*#__PURE__*/React__default.createElement(Stack, {
    backgroundColor: ColorTokens.background.secondary.light.value,
    padding: "0 16px 16px 16px",
    minWidth: ["fit-content", popOutFlow ? "220px" : "250px"],
    height: "fit-content",
    borderRadius: "10px",
    marginBottom: "20px",
    border: isDark ? '1px solid #FFF' : ''
  }, symptomList === null || symptomList === void 0 ? void 0 : symptomList.map(function (symptom) {
    return /*#__PURE__*/React__default.createElement(SymptomAccordion, {
      key: symptom === null || symptom === void 0 ? void 0 : symptom.label,
      symptom: symptom,
      isDark: isDark
    });
  }));
};

var fillColors = {
  yes: ColorTokens.feedback.success.onlight.value,
  no: ColorTokens.feedback.error.onlight.value,
  notavailable: ColorTokens.elements.secondary.onlight.value,
  partialdataavailable: ColorTokens.feedback.warning.onlight.value,
  inprogress: ColorTokens.elements.lowcontrast.onlight.value
};
var WCircle = function WCircle(_ref) {
  var diagnosticsData = _ref.diagnosticsData,
    processStep = _ref.processStep,
    isDark = _ref.isDark,
    isProcessing = _ref.isProcessing;
  var isProgress = processStep === "ViraPoll" || isProcessing;
  useEffect(function () {
    var pieChartRef = document.querySelector(".recharts-layer.recharts-pie");
    if (!!pieChartRef) pieChartRef.tabIndex = -1;
    if (!!pieChartRef) pieChartRef.ariaLabel = "pie chart";
  });
  var pieData = useMemo(function () {
    if (!diagnosticsData || !processStep) return [];
    var combineAttrNames = diagnosticsData.map(function (_ref2) {
      var attrNames = _ref2.attrNames;
      return attrNames;
    }).flat().sort(function (a, b) {
      return isProgress ? b.value.localeCompare(a.value) : 0;
    });
    var pieSliceData = combineAttrNames.map(function (item) {
      var status = item.value.toLowerCase();
      return _extends({}, item, {
        status: status,
        name: item === null || item === void 0 ? void 0 : item.attributeID,
        value: Number((item === null || item === void 0 ? void 0 : item.progressRingAvgWeight) || 1),
        fill: fillColors[status]
      });
    });
    return pieSliceData;
  }, [diagnosticsData, isProgress]);
  return /*#__PURE__*/React__default.createElement(PieChart, {
    width: 200,
    height: 175
  }, /*#__PURE__*/React__default.createElement(Pie, {
    data: pieData,
    innerRadius: 69,
    outerRadius: 85,
    paddingAngle: 0,
    startAngle: 90,
    endAngle: -270,
    animationBegin: 0
  }, /*#__PURE__*/React__default.createElement(Label, {
    value: isProgress ? "Checking for issues" : "Finished Checks",
    fontSize: "20px",
    fontFamily: "Verizon-NHG-eDS,Helvetica,Ariel,Sans-serif",
    fontWeight: 700,
    position: "center",
    width: 70,
    fill: isDark ? 'white' : 'black'
  })));
};

var _templateObject$n, _templateObject2$i;
var CustomTooltip = styled(Tooltip)(_templateObject$n || (_templateObject$n = _taggedTemplateLiteralLoose(["\n\n"])));
var CustomListItem = styled(ListItem$2)(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteralLoose(["\n  padding-top: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n  z-index:9999;\n"])));
var TooltipTitle = function TooltipTitle(_ref) {
  var tooltipHeaderLabel = _ref.tooltipHeaderLabel,
    tooltipHeaderValue = _ref.tooltipHeaderValue;
  if (!!tooltipHeaderLabel && !!tooltipHeaderValue) return tooltipHeaderLabel + ": " + tooltipHeaderValue;else if (!!!tooltipHeaderLabel && !!tooltipHeaderValue) return tooltipHeaderValue;else if (!!!tooltipHeaderValue && !!tooltipHeaderLabel) return tooltipHeaderLabel;else return null;
};
var TooltipComponent = function TooltipComponent(_ref2) {
  var _configDetails$params, _configDetails$params2, _tooltip$tooltip, _configDetails$params3, _configDetails$params4, _tooltip$tooltip2;
  var children = _ref2.children,
    tooltip = _ref2.tooltip,
    isLoading = _ref2.isLoading,
    show = _ref2.show;
  var hide = Object.keys(tooltip).length === 0 && !isLoading;
  var configDetails = useContext(ConfigContext);
  return /*#__PURE__*/React__default.createElement(CustomTooltip, {
    disabled: !show || hide,
    title: isLoading ? 'Loading...' : /*#__PURE__*/React__default.createElement(TooltipTitle, tooltip),
    size: "medium",
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params = configDetails.paramsDetails) !== null && _configDetails$params !== void 0 && (_configDetails$params2 = _configDetails$params.theme) !== null && _configDetails$params2 !== void 0 && _configDetails$params2.isDark ? "dark" : "light",
    renderAnchorElement: function renderAnchorElement() {
      return children;
    },
    containerId: "trg-wrapper"
  }, !isLoading && (tooltip === null || tooltip === void 0 ? void 0 : (_tooltip$tooltip = tooltip.tooltip) === null || _tooltip$tooltip === void 0 ? void 0 : _tooltip$tooltip.length) > 0 && /*#__PURE__*/React__default.createElement(UnorderedList, {
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params3 = configDetails.paramsDetails) !== null && _configDetails$params3 !== void 0 && (_configDetails$params4 = _configDetails$params3.theme) !== null && _configDetails$params4 !== void 0 && _configDetails$params4.isDark ? "dark" : "light"
  }, tooltip === null || tooltip === void 0 ? void 0 : (_tooltip$tooltip2 = tooltip.tooltip) === null || _tooltip$tooltip2 === void 0 ? void 0 : _tooltip$tooltip2.map(function (_ref3) {
    var label = _ref3.label,
      value = _ref3.value;
    return /*#__PURE__*/React__default.createElement(CustomListItem, {
      key: label,
      size: "bodySmall",
      spacing: "compact"
    }, !!label && label + ":", " ", value);
  })));
};

var _templateObject$o, _templateObject2$j, _templateObject3$h, _templateObject4$h, _templateObject5$f, _templateObject6$c;
var ProgressWrapper = styled.div(_templateObject$o || (_templateObject$o = _taggedTemplateLiteralLoose(["\n  @media(min-width:1280px){\n   margin-top:13px;\n   }\n"])));
var ProgressWrapperLoggedOut = styled.div(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteralLoose(["\n@media(min-width:1280px){\n margin-top:13px;\n }\n @media(max-width:1279px){\n margin-top:10px;\n }\n"])));
var RetrieveAndSaveWrapper = styled.div(_templateObject3$h || (_templateObject3$h = _taggedTemplateLiteralLoose(["\n  display:flex;\n  flex-direction:row;\n  gap:", ";\n  \n  @media(max-width:1279px){\n   margin-top:20px;\n   }\n\n   @media(max-width:600px){\n    justify-content:", ";\n   }\n   \n"])), function (props) {
  return props.isLoggedOut && '10px';
}, function (props) {
  return props.isProbing && 'center';
});
var CustomTooltip$1 = styled(Tooltip)(_templateObject4$h || (_templateObject4$h = _taggedTemplateLiteralLoose(["\n   @media(min-width:1280px){\n    [class^='DialogWrapper-VDS'] {\n      bottom: 2.5rem;\n    }\n  }\n"])));
var ButtonWrapper$6 = styled.div(_templateObject5$f || (_templateObject5$f = _taggedTemplateLiteralLoose(["\n  display:flex;\n  flex-direction:", ";\n  justify-content:center;\n  gap:12px;\n  width:100%;\n \n"])), isMobile$1 ? 'column' : 'row');
var CloseButton$3 = styled.div(_templateObject6$c || (_templateObject6$c = _taggedTemplateLiteralLoose(["\n    text-align: right;\n    margin: -25px 25px 0px 0px;  \n  @media screen and (max-width: 568px) {  \n   margin: 20px 20px 0px 0px;  \n  }\n"])));
var SaveAndRetrieveTooltip = function SaveAndRetrieveTooltip(_ref) {
  var _window$config2, _window$config3, _configDetails$params, _configDetails$params2;
  var configDetails = _ref.configDetails,
    isProbing = _ref.isProbing,
    midFlowSigninUrl = _ref.midFlowSigninUrl;
  var _useState = useState(false),
    showModal = _useState[0],
    setShowModal = _useState[1];
  var signInClicked = function signInClicked() {
    var _window$tsFeatureFlag;
    if ((_window$tsFeatureFlag = window.tsFeatureFlags) !== null && _window$tsFeatureFlag !== void 0 && _window$tsFeatureFlag.enableMidflowRedirectionFFlag) {
      var _window, _window$config, _window$config$troubl, _window$config$troubl2, _window$config$troubl3;
      sessionStorage.setItem('authRedirection', 'true');
      sessionStorage.setItem('authRedirectionUrl', midFlowSigninUrl);
      var issueSelectorPage = window.location.origin + "/digital/nsa/secure/ui/troubleshooting/" + ((_window = window) === null || _window === void 0 ? void 0 : (_window$config = _window.config) === null || _window$config === void 0 ? void 0 : (_window$config$troubl = _window$config.troubleShootingJson) === null || _window$config$troubl === void 0 ? void 0 : (_window$config$troubl2 = _window$config$troubl.ddata) === null || _window$config$troubl2 === void 0 ? void 0 : (_window$config$troubl3 = _window$config$troubl2.device) === null || _window$config$troubl3 === void 0 ? void 0 : _window$config$troubl3.soeUrl);
      window.open(issueSelectorPage, '_self');
    } else if (midFlowSigninUrl) {
      window.open(midFlowSigninUrl, '_self');
    }
  };
  var cancelModal = function cancelModal() {
    setShowModal(false);
  };
  return /*#__PURE__*/React__default.createElement(RetrieveAndSaveWrapper, {
    isProbing: isProbing,
    isLoggedOut: window.isLoggedOut || ((_window$config2 = window.config) === null || _window$config2 === void 0 ? void 0 : _window$config2.isLoggedOut)
  }, window.isLoggedOut || (_window$config3 = window.config) !== null && _window$config3 !== void 0 && _window$config3.isLoggedOut ? /*#__PURE__*/React__default.createElement(Fragment, null, window.isMVODigital ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ProgressWrapperLoggedOut, null, /*#__PURE__*/React__default.createElement(Body, {
    color: "#000",
    size: "large"
  }, "Save my progress")), /*#__PURE__*/React__default.createElement(ButtonIcon, {
    kind: "lowContrast",
    role: "button",
    ariaLabel: "Save my progress",
    "data-testid": "saveIcon",
    renderIcon: function renderIcon() {
      return /*#__PURE__*/React__default.createElement(Icon$1, {
        name: "bookmark"
      });
    },
    onClick: function onClick() {
      setShowModal(true);
    }
  })) : null) : /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ProgressWrapper, null, /*#__PURE__*/React__default.createElement(Body, {
    color: "#6F7171",
    size: "large"
  }, "Your progress has been saved")), /*#__PURE__*/React__default.createElement(CustomTooltip$1, {
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params = configDetails.paramsDetails) !== null && _configDetails$params !== void 0 && (_configDetails$params2 = _configDetails$params.theme) !== null && _configDetails$params2 !== void 0 && _configDetails$params2.isDark ? 'dark' : 'light',
    alt: "You can resume troubleshooting at any time within the next 24 hours from the Support page",
    ariaLabel: "More information on your progress has been saved",
    size: "medium",
    iconFillColor: "secondary",
    containerId: "ContentWrapper"
  }, "You can resume troubleshooting at any time within the next 24 hours from the Support page")), /*#__PURE__*/React__default.createElement(Modal$1, {
    opened: showModal,
    closeButton: /*#__PURE__*/React__default.createElement(CloseButton$3, {
      "data-testid": "cancelIconBtn",
      onClick: function onClick(e) {
        return cancelModal();
      }
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      id: "closeModal",
      name: "close",
      size: "large"
    }), " ")
  }, /*#__PURE__*/React__default.createElement(ModalTitle, null, "Would you like to save your progress"), /*#__PURE__*/React__default.createElement(ModalBody$1, null, "Sign in to your account and we'll save your place. Resume troubleshooting at any time within the next 24 hours from the Support page."), /*#__PURE__*/React__default.createElement(ModalFooter$1, null, /*#__PURE__*/React__default.createElement(ButtonWrapper$6, null, /*#__PURE__*/React__default.createElement(ActionButton, {
    "data-analyticstrack": "Signin-Btn",
    "data-track": "{\"type\": \"link\", \"name\": \"Signin-Btn\"}",
    "data-clickstream": "Signin-btn-cta",
    key: "Signin",
    use: "primary",
    style: {
      'min-width': isMobile$1 ? null : "165px",
      padding: 0,
      width: '100%'
    },
    "data-testid": "signinBtn",
    onClick: function onClick() {
      signInClicked();
    }
  }, "Sign in"), /*#__PURE__*/React__default.createElement(ActionButton, {
    "data-analyticstrack": "Cancel-Btn",
    "data-track": "{\"type\": \"link\", \"name\": \"Cancel-Btn\"}",
    "data-clickstream": "Cancel-btn-cta",
    key: "Cancel",
    use: "secondary",
    style: {
      'min-width': isMobile$1 ? null : "165px",
      padding: 0,
      width: '100%'
    },
    "data-testid": "Cancelbtn",
    onClick: function onClick() {
      cancelModal();
    }
  }, "Cancel")))));
};

var _excluded = ["children", "duration", "enabled"];
var FadeIn = function FadeIn(_ref) {
  var children = _ref.children,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 0.5 : _ref$duration,
    enabled = _ref.enabled,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (!enabled) return children;
  return /*#__PURE__*/React__default.createElement(motion.div, _extends({
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    transition: {
      duration: duration
    }
  }, props), children);
};

var useInterval = function useInterval(callback, delay) {
  var savedCallback = useRef(callback);
  useLayoutEffect(function () {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(function () {
    if (delay === null) {
      return;
    }
    var id = setInterval(function () {
      savedCallback.current();
    }, delay);
    return function () {
      clearInterval(id);
    };
  }, [delay]);
};

var INTERVAL_DELAY = 2000;
var getInitialData = function getInitialData(data, isMobile) {
  var _data2;
  if (data === void 0) {
    data = [];
  }
  if (isMobile === void 0) {
    isMobile = false;
  }
  if (isMobile) {
    var _firstItem$attrNames;
    var _data = data,
      firstItem = _data[0];
    var attrNames = [setInProgress(firstItem === null || firstItem === void 0 ? void 0 : (_firstItem$attrNames = firstItem.attrNames) === null || _firstItem$attrNames === void 0 ? void 0 : _firstItem$attrNames[0])];
    return [_extends({}, firstItem, {
      attrNames: attrNames
    })];
  }
  return (_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.map(function (group) {
    return _extends({}, group, {
      attrNames: group.attrNames.map(function (attr) {
        return _extends({}, attr, {
          value: "InProgress"
        });
      })
    });
  });
};
var setInProgress = function setInProgress(attr) {
  return _extends({}, attr, {
    value: "InProgress"
  });
};
var useDiagnostics = function useDiagnostics(_ref) {
  var _window;
  var _ref$data = _ref.data,
    data = _ref$data === void 0 ? [] : _ref$data;
  var _useState = useState([]),
    diagnosticsAI = _useState[0],
    setDiagnosticsAI = _useState[1];
  var _useState2 = useState(false),
    isProcessing = _useState2[0],
    setIsProcessing = _useState2[1];
  var _useMediaQuery = useMediaQuery(),
    isMobile = _useMediaQuery.isMobile;
  var _useState3 = useState(0),
    groupIndex = _useState3[0],
    setGroupIndex = _useState3[1];
  var _useState4 = useState(1),
    attrIndex = _useState4[0],
    setAttrIndex = _useState4[1];
  var diagnosticsAnimation = (_window = window) === null || _window === void 0 ? void 0 : _window.diagnosticsAnimation;
  useEffect(function () {
    if (!(diagnosticsAI !== null && diagnosticsAI !== void 0 && diagnosticsAI.length) && diagnosticsAnimation) {
      var initialData = getInitialData(data, isMobile);
      setDiagnosticsAI(initialData);
      setIsProcessing(true);
    }
  }, [data, diagnosticsAI, isMobile, diagnosticsAnimation]);
  var processData = function processData() {
    var _currentGroup$attrNam, _currentGroup$attrNam2;
    if (groupIndex === (data === null || data === void 0 ? void 0 : data.length)) {
      setDiagnosticsAI(data);
      setIsProcessing(false);
      return;
    }
    var currentGroup = _extends({}, data === null || data === void 0 ? void 0 : data[groupIndex]);
    var currentAttr = currentGroup === null || currentGroup === void 0 ? void 0 : (_currentGroup$attrNam = currentGroup.attrNames) === null || _currentGroup$attrNam === void 0 ? void 0 : _currentGroup$attrNam[attrIndex];
    var praviousAttr = currentGroup === null || currentGroup === void 0 ? void 0 : (_currentGroup$attrNam2 = currentGroup.attrNames) === null || _currentGroup$attrNam2 === void 0 ? void 0 : _currentGroup$attrNam2[attrIndex - 1];
    if ((praviousAttr === null || praviousAttr === void 0 ? void 0 : praviousAttr.value) === "InProgress") return;
    var copyRenderData = [].concat(diagnosticsAI);
    if (isMobile && !(copyRenderData !== null && copyRenderData !== void 0 && copyRenderData[groupIndex])) {
      var _newGroup$attrNames;
      var newGroup = _extends({}, data === null || data === void 0 ? void 0 : data[groupIndex]);
      newGroup.attrNames = [setInProgress(newGroup === null || newGroup === void 0 ? void 0 : (_newGroup$attrNames = newGroup.attrNames) === null || _newGroup$attrNames === void 0 ? void 0 : _newGroup$attrNames[0])];
      setDiagnosticsAI(function (existingData) {
        var _ref2;
        var previousGroupIndex = groupIndex - 1;
        var praviousGroup = _extends({}, data === null || data === void 0 ? void 0 : data[previousGroupIndex]);
        var _reverse = (_ref2 = [].concat(praviousGroup === null || praviousGroup === void 0 ? void 0 : praviousGroup.attrNames)) === null || _ref2 === void 0 ? void 0 : _ref2.reverse(),
          lastAttr = _reverse[0];
        var lastAttrIndex = praviousGroup.attrNames.length - 1;
        existingData[previousGroupIndex].attrNames[lastAttrIndex] = lastAttr;
        return [].concat(existingData, [newGroup]);
      });
      return;
    }
    if (!isMobile && attrIndex === currentGroup.attrNames.length) {
      setDiagnosticsAI(function (existingData) {
        var _ref3;
        var _reverse2 = (_ref3 = [].concat(currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.attrNames)) === null || _ref3 === void 0 ? void 0 : _ref3.reverse(),
          lastAttr = _reverse2[0];
        var lastAttrIndex = currentGroup.attrNames.length - 1;
        existingData[groupIndex].attrNames[lastAttrIndex] = lastAttr;
        return [].concat(existingData);
      });
      setGroupIndex(function (i) {
        return i + 1;
      });
      setAttrIndex(0);
      return;
    }
    if (attrIndex < currentGroup.attrNames.length) {
      copyRenderData[groupIndex].attrNames[attrIndex - 1] = praviousAttr;
      copyRenderData[groupIndex].attrNames[attrIndex] = setInProgress(currentAttr);
      setDiagnosticsAI(copyRenderData);
      setAttrIndex(function (a) {
        return a + 1;
      });
    } else {
      setGroupIndex(function (i) {
        return i + 1;
      });
      setAttrIndex(1);
    }
  };
  var isEnabled = diagnosticsAnimation && isProcessing;
  useInterval(processData, isEnabled ? INTERVAL_DELAY : null);
  return {
    diagnosticsAI: diagnosticsAnimation ? diagnosticsAI : data,
    isProcessing: isProcessing
  };
};

var _excluded$1 = ["attributeID", "value", "systemSource", "showAdditionalInfo"];
var _templateObject$p, _templateObject2$k, _templateObject3$i, _templateObject4$i, _templateObject5$g, _templateObject6$d, _templateObject7$b, _templateObject8$b, _templateObject9$9, _templateObject0$7, _templateObject1$7, _templateObject10$5, _templateObject11$4, _templateObject12$3, _templateObject13$3, _templateObject14$3, _templateObject15$3, _templateObject16$3, _templateObject17$3, _templateObject18$3, _templateObject19$3, _templateObject20$3, _templateObject21$3, _templateObject22$3, _templateObject23$3;
var finalComps$1 = {
  styles: styledComps
};
if (window.isBAUACSS) {
  finalComps$1 = {
    styles: styledBauComps
  };
}
if (window.isMVODigital) {
  finalComps$1 = {
    styles: styledDigital
  };
}
var _finalComps$styles$1 = finalComps$1.styles,
  TabsContainer$3 = _finalComps$styles$1.TabsContainer,
  FeedbackCloseButton$4 = _finalComps$styles$1.FeedbackCloseButton,
  StyledModal$7 = _finalComps$styles$1.StyledModal,
  StyledModalBody$6 = _finalComps$styles$1.StyledModalBody,
  SaveExitCloseButton$4 = _finalComps$styles$1.SaveExitCloseButton,
  Footer$3 = _finalComps$styles$1.Footer,
  HeaderTabContainer$3 = _finalComps$styles$1.HeaderTabContainer,
  NavStepsContainer$4 = _finalComps$styles$1.NavStepsContainer,
  NewPageTitle$3 = _finalComps$styles$1.NewPageTitle;
var ImageContainer$4 = styled.div(_templateObject$p || (_templateObject$p = _taggedTemplateLiteralLoose(["\n  margin: ", ";\n  width: ", ";\n  box-shadow: ", ";\n  @media (max-width: 760px) {\n    margin-top: ", ";\n    margin-right: ", ";\n    margin-bottom: ", ";\n    box-shadow: ", ";\n    margin-left: ", ";\n    position: relative;\n    width: auto;\n    padding-inline: ", ";\n  }\n"])), function (props) {
  return props !== null && props !== void 0 && props.popOutFlow ? "auto" : "";
}, function (props) {
  return props !== null && props !== void 0 && props.popOutFlow ? "990px" : "";
}, function (props) {
  return props !== null && props !== void 0 && props.popOutFlow ? "0px 0px 10px #aaa" : "";
}, function (props) {
  return props !== null && props !== void 0 && props.isACSS ? "0px" : "";
}, function (props) {
  return props !== null && props !== void 0 && props.isACSS ? "-15px" : "auto";
}, function (props) {
  return props !== null && props !== void 0 && props.isACSS ? "-5px" : "";
}, function (props) {
  return props !== null && props !== void 0 && props.popOutFlow ? "0px 0px 10px #aaa" : "";
}, function (props) {
  if (props !== null && props !== void 0 && props.isACSS) {
    return "-15px";
  } else {
    return "0";
  }
}, function (props) {
  return props !== null && props !== void 0 && props.isDigital ? "0" : "15px";
});
var TitleContainer$3 = styled.div(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteralLoose([" \npadding-left: ", "; \nmargin-top: ", "; \nmargin-bottom: ", "; \n/* margin-top : 1rem;  */\n/* margin-left: 0.5rem;  */\n"])), function (props) {
  return props !== null && props !== void 0 && props.popOutFlow ? "62px" : "";
}, function (props) {
  return props !== null && props !== void 0 && props.isACSS ? "1rem" : "0";
}, function (props) {
  return props !== null && props !== void 0 && props.isACSS || props !== null && props !== void 0 && props.popOutFlow ? "0px" : "32px";
});
var StepSubTitle = styled.div(_templateObject3$i || (_templateObject3$i = _taggedTemplateLiteralLoose([" \n    padding-left: ", "; \n    margin-bottom: 1rem; \n    /* margin-left: 0.5rem; */\n    width: auto;\n    @media screen and (max-width:600px){\n      margin-left: 0px;\n    }\n  }\n"])), function (props) {
  return props !== null && props !== void 0 && props.popOutFlow ? "62px" : "";
});
var FeedbackSection = styled.div(_templateObject4$i || (_templateObject4$i = _taggedTemplateLiteralLoose(["\n  margin-bottom: ", "; \n"])), function (props) {
  return props !== null && props !== void 0 && props.isDigital ? "32px" : "";
});
var DiagnosticContainer = styled.div(_templateObject5$g || (_templateObject5$g = _taggedTemplateLiteralLoose(["\n  overflow-y :  ", ";\n  overflow-x : ", ";\n  border-top : ", ";\n  height : ", ";\n  display: flex;\n  flex-direction: column;\n  padding-top: 0px;\n  width: 100%;\n  min-width: 100%;\n  font-family: Verizon-NHG-eDS, Helvetica, Ariel, Sans-serif;\n  min-height: 550px !important;\n  @media (max-width: 760px) {\n    margin-left: 0;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: #acacac;\n    border-radius: 4px;\n  }\n  #bgSuccess * {\n    ", "\n  }\n  #bgError * {\n    ", "\n  }\n"])), function (props) {
  return props.isACSS ? 'auto' : 'unset';
}, function (props) {
  return props.isACSS ? 'auto' : 'unset';
}, function (props) {
  return props.isACSS ? '2px solid hsl(180deg 3% 85%)' : '';
}, function (props) {
  return props.isACSS ? '580px' : '';
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.isDark) && "background-color: rgb(0, 53, 20)";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.isDark) && "background-color: rgb(86, 23, 1)";
});
var HRule = styled.hr(_templateObject6$d || (_templateObject6$d = _taggedTemplateLiteralLoose(["\nmargin:1em 0;\ndisplay: none;\n\n/* @media (min-width: 760px) and (max-width: 821px) {\n  transform: rotate(0deg);\n  display: block;\n  width: 85%;\n  visibility: hidden;\n} */\n@media (max-width: 760px) {\n  transform: rotate(0deg);\n  display: block;\n  width: 100%;\n  margin-top: ", ";\n  ", "\n}\n"])), function (props) {
  return props.marginTopMobile ? '50px' : '1rem';
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.isLast) && "margin-bottom: 32px;";
});
var DescText = styled.div(_templateObject7$b || (_templateObject7$b = _taggedTemplateLiteralLoose(["\n// padding-left: ", ";\n    /* width: 100%; */\n    text-align: left;\n\n    p > span > p:not(:last-child) {\n      margin-bottom: 16px;\n    }\n\n    @media (max-width: 850px) {\n      /* margin: 0.25rem; */\n      // padding-left: 1.2rem;\n      /* margin-top: 16px; */\n      padding-right: 60px;\n}\n"])), function (props) {
  return props.isACSS ? '4.5rem' : '2.1rem';
});
var CircleAlign = styled.div(_templateObject8$b || (_templateObject8$b = _taggedTemplateLiteralLoose(["\n\n/* padding-right: 1.75rem;\npadding-left: ", ";\nmargin-top: 1.25rem;\nmargin-left: 1.75rem; */\nmargin-left: ", ";\nmin-width: ", ";\ndisplay: flex;\njustify-content: center;\npointer-events: none; /* to stop load animation of ring on hover */\n\nsvg g:focus {\n  outline: transparent 0px;\n}\n\n@media (max-width: 760px) {\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n"])), function (props) {
  return props !== null && props !== void 0 && props.popOutFlow ? "3.9rem" : "1.5rem";
}, function (props) {
  return props.popOutFlow ? '50px' : 'unset';
}, function (props) {
  return props.symptomList ? '282px' : 'unset';
});
var LoaderWrapper = styled.div(_templateObject9$9 || (_templateObject9$9 = _taggedTemplateLiteralLoose(["\n  padding-top: 25px;\n  min-width: 24px;\n  position: relative;\n  z-index: 1;\n  & div {\n   background-color:unset;\n    & div {\n      width: 16px;\n       height: 16px;\n    }\n  }\n"])));
var ButtonsWrapper$7 = styled.div(_templateObject0$7 || (_templateObject0$7 = _taggedTemplateLiteralLoose(["\n  /* padding-left: ", "; */\n  width: 100% ;\n  margin: auto;\n\n  & > div > div {\n    & button {\n      min-width: fit-content;\n    }\n  }\n\n  @media (max-width: 760px) {\n    width: 100%;\n    padding-left: 0;\n    margin-top:24px;\n    & > div > div {\n      flex-direction: column-reverse;\n      width: 100%;\n      gap: 12px !important;\n      /* padding-left: 20px; */\n      & button {\n        margin-bottom: 0px !important;\n        margin-top: 0px !important;\n      }\n    }\n  }\n \n"])), function (props) {
  return props.isACSS ? '21rem' : '14rem';
});
var ButtonsWrapperAlign = styled.div(_templateObject1$7 || (_templateObject1$7 = _taggedTemplateLiteralLoose(["\n  display:flex;\n \n   @media (min-width: 760px) {\n    flex: auto;\n   }\n  @media (max-width: 760px) {\n    width: 100%;\n    padding-left: 0;\n    display:block;\n  }\n \n"])));
var FooterSectionAlign = styled.div(_templateObject10$5 || (_templateObject10$5 = _taggedTemplateLiteralLoose(["\n  display:flex;\n   @media (max-width: 820px) {\n      flex-direction:column;\n   }\n"])));
var ActionButtonsFooter = styled.div(_templateObject11$4 || (_templateObject11$4 = _taggedTemplateLiteralLoose(["\n  @media (max-width: 760px) {\n     & > div > div {\n      width: 100%;\n      gap: 12px !important;\n      /* padding-left: 20px; */\n      & button {\n        margin-bottom: 0px !important;\n        margin-top: 0px !important;\n      }\n    }\n  }\n    button {\n      min-width: 165px;\n      padding: 0px;\n    }\n"])));
var SolvedProblemLink = styled.div(_templateObject12$3 || (_templateObject12$3 = _taggedTemplateLiteralLoose(["\n     margin-left:15px;\n    display: flex;\n    @media (max-width: 700px) {\n     margin-top:15px;\n     margin-left:0px;\n     text-align: center;\n     justify-content: center !important;\n"])));
var SaveAndRetriveLink = styled.div(_templateObject13$3 || (_templateObject13$3 = _taggedTemplateLiteralLoose(["\n   display:flex;\n   margin-right:0px;\n    @media (max-width: 768px) {\n     margin-top:15px;\n  }\n"])));
var FooterSectionDignostic = styled.div(_templateObject14$3 || (_templateObject14$3 = _taggedTemplateLiteralLoose(["\n    margin-top:32px;\n"])));
var DescriptionWrapper = styled.div(_templateObject15$3 || (_templateObject15$3 = _taggedTemplateLiteralLoose(["\n  /* margin-right: 1rem; */\n  margin-top: 30px;\n  @media (max-width: 760px) {\n   margin-top: 0;\n  }\n  ", "\n  ", "\n"])), function (props) {
  return props.isDark && ".sendEmailBtnDesc {\n    button {\n      border-color:unset;\n      span {\n        background-color:unset;\n      }\n    }\n  }";
}, function (props) {
  return props.isDark && ".btn-primary-dark {\n    span {\n        color: #000;\n    }\n    background-color: #fff;\n  }";
});
var DiagnosticsDetails = styled.div(_templateObject16$3 || (_templateObject16$3 = _taggedTemplateLiteralLoose(["\n  display: flex ;\n  gap: 40px;\n\n  @media (max-width: 760px) {\n      gap: 16px;\n      /* margin-top: 24px; */\n      flex-direction: column;\n      width: 100%;\n      /* align-items: flex-start; */\n      align: stretch;\n      justify-content: flex-end;\n      & > div {\n        width: 100%;\n      }\n    }\n  @media (min-width: 760px) and (max-width: 820px) {\n    margin-top: 24px;\n   }\n"])));
var Tag = styled.div(_templateObject17$3 || (_templateObject17$3 = _taggedTemplateLiteralLoose(["\n  margin-left: 2px;\n  background-color: ", ";\n  border : ", ";\n  border-radius: 5px;\n  padding: 3px 6px;\n\n"])), function (props) {
  return props.isDark ? "#000000" : "#f6f6f6";
}, function (props) {
  return props.isDark ? "1px solid #000000" : "1px solid #d6d6d6";
});
var AttributeBodyWrapper = styled.div(_templateObject18$3 || (_templateObject18$3 = _taggedTemplateLiteralLoose(["\n   width: max-content;\n"])));
var StepsAndTitle = styled.div(_templateObject19$3 || (_templateObject19$3 = _taggedTemplateLiteralLoose(["\n  display: flex !important;\n  align-items: center !important;\n  margin-bottom: 24px !important;\n  @media screen and (max-width: 601px) {\n    flex-direction: column;\n    gap: 10px;\n  }\n"])));
var StepsAndTitleSection = styled.div(_templateObject20$3 || (_templateObject20$3 = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width:601px) {\n    margin-bottom: 32px !important;\n  }\n \n"])));
var NewPageTitleDigital = styled.div(_templateObject21$3 || (_templateObject21$3 = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  @media screen and (min-width:601px) {\n    position: relative;\n    margin-left: 0px;\n    display: flex;\n    align-items: center;\n  }\n  @media screen and (max-width:600px) {\n    width: 100%;\n  }\n"])));
var CustomListItem$1 = styled(ListItem$2)(_templateObject22$3 || (_templateObject22$3 = _taggedTemplateLiteralLoose(["\n  padding-top: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n"])));
var CustomTooltip$2 = styled(Tooltip)(_templateObject23$3 || (_templateObject23$3 = _taggedTemplateLiteralLoose(["\n  [class^=\"DialogWrapper-VDS__sc-33el4z-0\"] {\n    left: 110px;\n  };\n  [class^=\"DialogWrapper-VDS__sc-33el4z-0\"]::before {\n    left: 12px;\n  }\n"])));
var IconWithTooltip = function IconWithTooltip(_ref) {
  var _configDetails$params, _configDetails$params2, _tooltip$tooltip, _tooltip$tooltip2;
  var children = _ref.children,
    tooltip = _ref.tooltip,
    isLoading = _ref.isLoading,
    show = _ref.show;
  var hide = Object.keys(tooltip).length === 0 && !isLoading;
  var configDetails = useContext(ConfigContext);
  var isDark = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : (_configDetails$params2 = _configDetails$params.theme) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.isDark) == true;
  return /*#__PURE__*/React__default.createElement(CustomTooltip$2, {
    disabled: !show || hide,
    title: isLoading ? 'Loading...' : /*#__PURE__*/React__default.createElement(TooltipTitle, _extends({
      "data-testid": "tooltipTitle"
    }, tooltip)),
    size: "medium",
    surface: isDark ? 'dark' : 'light',
    renderAnchorElement: function renderAnchorElement() {
      return children;
    }
  }, !isLoading && (tooltip === null || tooltip === void 0 ? void 0 : (_tooltip$tooltip = tooltip.tooltip) === null || _tooltip$tooltip === void 0 ? void 0 : _tooltip$tooltip.length) > 0 && /*#__PURE__*/React__default.createElement(UnorderedList, {
    surface: isDark ? 'dark' : 'light'
  }, tooltip === null || tooltip === void 0 ? void 0 : (_tooltip$tooltip2 = tooltip.tooltip) === null || _tooltip$tooltip2 === void 0 ? void 0 : _tooltip$tooltip2.map(function (_ref2) {
    var label = _ref2.label,
      value = _ref2.value;
    return /*#__PURE__*/React__default.createElement(CustomListItem$1, {
      key: label,
      size: "bodySmall",
      spacing: "compact"
    }, !!label && label + ":", " ", value);
  })));
};
var DetailItem = function DetailItem(_ref3) {
  var _configDetails$params3, _configDetails$params4, _tooltip$tooltip3;
  var _ref3$attribute = _ref3.attribute,
    attribute = _ref3$attribute === void 0 ? {} : _ref3$attribute;
  var configDetails = useContext(ConfigContext);
  var isDark = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params3 = configDetails.paramsDetails) === null || _configDetails$params3 === void 0 ? void 0 : (_configDetails$params4 = _configDetails$params3.theme) === null || _configDetails$params4 === void 0 ? void 0 : _configDetails$params4.isDark) == true;
  var value = attribute.value,
    systemSource = attribute.systemSource,
    showAdditionalInfo = attribute.showAdditionalInfo,
    tooltip = _objectWithoutPropertiesLoose(attribute, _excluded$1);
  var hideTooltip = !(tooltip !== null && tooltip !== void 0 && (_tooltip$tooltip3 = tooltip.tooltip) !== null && _tooltip$tooltip3 !== void 0 && _tooltip$tooltip3.length) > 0 && !(tooltip !== null && tooltip !== void 0 && tooltip.tooltipHeaderLabel) && !(tooltip !== null && tooltip !== void 0 && tooltip.tooltipHeaderValue);
  var notAvailableTooltip = {
    tooltipHeaderLabel: "Check unavailable"
  };
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "18px",
      display: 'flex',
      gap: 5,
      alignItems: 'center'
    }
  }, attribute.value == "Yes" && /*#__PURE__*/React__default.createElement(IconWithTooltip, {
    tooltip: tooltip,
    show: showAdditionalInfo && !hideTooltip,
    isLoading: value === 'InProgress'
  }, /*#__PURE__*/React__default.createElement("div", {
    "aria-label": "completed",
    role: "img"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "checkmark-alt",
    color: ColorTokens.feedback.success.onlight.value,
    size: "large",
    style: {
      paddingTop: 3,
      outline: "transparent 0px"
    },
    ariaHidden: true,
    tabIndex: "-1",
    ariaLabel: "completed"
  }))), attribute.value == "No" && /*#__PURE__*/React__default.createElement(IconWithTooltip, {
    tooltip: tooltip,
    show: showAdditionalInfo && !hideTooltip,
    isLoading: value === 'InProgress'
  }, /*#__PURE__*/React__default.createElement("div", {
    "aria-label": "Failed",
    role: "img"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "close-alt",
    color: ColorTokens.feedback.error.onlight.value,
    size: "large",
    style: {
      paddingTop: 3,
      outline: "transparent 0px"
    },
    ariaHidden: true,
    tabIndex: "-1",
    ariaLabel: "Failed"
  }))), attribute.value == "PartialDataAvailable" && /*#__PURE__*/React__default.createElement(IconWithTooltip, {
    tooltip: tooltip,
    show: showAdditionalInfo && !hideTooltip,
    isLoading: value === 'InProgress'
  }, /*#__PURE__*/React__default.createElement("div", {
    "aria-label": "Partial Data Available",
    role: "img"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "checkmark-alt",
    color: ColorTokens.feedback.warning.onlight.value,
    size: "large",
    style: {
      paddingTop: 3,
      outline: "transparent 0px"
    },
    ariaHidden: true,
    tabIndex: "-1",
    ariaLabel: "Partial Data Available"
  }))), attribute.value == "NotAvailable" && /*#__PURE__*/React__default.createElement(IconWithTooltip, {
    tooltip: notAvailableTooltip,
    show: showAdditionalInfo,
    isLoading: value === 'InProgress'
  }, /*#__PURE__*/React__default.createElement("div", {
    "aria-label": "Unavailable",
    role: "img"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "zoom-out",
    color: ColorTokens.elements.secondary.onlight.value,
    size: "large",
    style: {
      paddingTop: 3,
      outline: "transparent 0px"
    },
    ariaHidden: true,
    tabIndex: "-1",
    ariaLabel: "Unavailable"
  }))), attribute.value == "InProgress" && /*#__PURE__*/React__default.createElement(IconWithTooltip, {
    tooltip: tooltip,
    show: showAdditionalInfo,
    isLoading: value === 'InProgress'
  }, /*#__PURE__*/React__default.createElement(LoaderWrapper, null, /*#__PURE__*/React__default.createElement(Loader$2, {
    active: true,
    fullscreen: false,
    surface: isDark ? 'dark' : 'light'
  }))), /*#__PURE__*/React__default.createElement(AttributeBodyWrapper, null, /*#__PURE__*/React__default.createElement(Body, {
    primitive: "span",
    size: "large",
    style: {
      margin: 20,
      width: "100%",
      textAlign: "center"
    },
    color: isDark ? "#FFFFFF" : "#000000"
  }, attribute.attributeID)), !!systemSource && /*#__PURE__*/React__default.createElement(Tag, {
    isDark: isDark
  }, /*#__PURE__*/React__default.createElement(Body, {
    color: "#7c7e7e",
    bold: true
  }, systemSource, " ")));
};
var WaitResultDiagnostics = function WaitResultDiagnostics(props) {
  var _values$troubleShooti4, _values$troubleShooti5, _values$troubleShooti6, _values$troubleShooti7, _values$troubleShooti8, _values$troubleShooti9, _values$troubleShooti0, _configDetails$config, _configDetails$params5, _configDetails$params6, _window, _configDetails$params7, _configDetails$params8, _configDetails$params9, _configDetails$params0, _configDetails$config2, _configDetails$config3, _configDetails$config4, _configDetails$config5, _configDetails$params1, _configDetails$params10, _props$values3, _configDetails$caseDe2, _configDetails$select4;
  console.log("comren WaitResultDiagnostics", props);
  var _useMediaQuery = useMediaQuery(),
    isMobile = _useMediaQuery.isMobile,
    isTablet = _useMediaQuery.isTablet,
    isDesktop = _useMediaQuery.isDesktop;
  var configDetails = useContext(ConfigContext);
  var uiLoggerContext = useContext(UiLoggerContext);
  var _props$functions = props.functions,
    functions = _props$functions === void 0 ? {} : _props$functions,
    _props$values = props.values,
    values = _props$values === void 0 ? {} : _props$values;
  var _ref4 = (values === null || values === void 0 ? void 0 : (_values$troubleShooti4 = values.troubleShootingInfo) === null || _values$troubleShooti4 === void 0 ? void 0 : (_values$troubleShooti5 = _values$troubleShooti4.ddata) === null || _values$troubleShooti5 === void 0 ? void 0 : (_values$troubleShooti6 = _values$troubleShooti5.output) === null || _values$troubleShooti6 === void 0 ? void 0 : (_values$troubleShooti7 = _values$troubleShooti6.pageContent) === null || _values$troubleShooti7 === void 0 ? void 0 : _values$troubleShooti7.steps[0]) || {},
    diagnosticsData = _ref4.diagnosticsData;
  var _ref5 = (values === null || values === void 0 ? void 0 : (_values$troubleShooti8 = values.troubleShootingInfo) === null || _values$troubleShooti8 === void 0 ? void 0 : (_values$troubleShooti9 = _values$troubleShooti8.ddata) === null || _values$troubleShooti9 === void 0 ? void 0 : _values$troubleShooti9.output) || {},
    _ref5$symptomList = _ref5.symptomList,
    symptomList = _ref5$symptomList === void 0 ? [] : _ref5$symptomList;
  var _ref6 = (values === null || values === void 0 ? void 0 : (_values$troubleShooti0 = values.troubleShootingInfo) === null || _values$troubleShooti0 === void 0 ? void 0 : _values$troubleShooti0.context) || {},
    _ref6$processStep = _ref6.processStep,
    processStep = _ref6$processStep === void 0 ? "" : _ref6$processStep;
  var isNewDesign = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config = configDetails.config) === null || _configDetails$config === void 0 ? void 0 : _configDetails$config.isNewTemplate) && !is5GDevice;
  var isDark = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params5 = configDetails.paramsDetails) === null || _configDetails$params5 === void 0 ? void 0 : (_configDetails$params6 = _configDetails$params5.theme) === null || _configDetails$params6 === void 0 ? void 0 : _configDetails$params6.isDark) == true;
  console.log("isDaaaarkkk", isDark);
  var _values$landingInfo = values.landingInfo,
    landingInfo = _values$landingInfo === void 0 ? {} : _values$landingInfo,
    _values$symptom = values.symptom,
    symptom = _values$symptom === void 0 ? {} : _values$symptom,
    _values$troubleShooti1 = values.troubleShootingInfo,
    troubleShootingInfo = _values$troubleShooti1 === void 0 ? {} : _values$troubleShooti1,
    _values$thumbsDownSub = values.thumbsDownSubmittedStep,
    thumbsDownSubmittedStep = _values$thumbsDownSub === void 0 ? false : _values$thumbsDownSub;
  var output = getObjectPropertyByPath("ddata.output", troubleShootingInfo, {});
  var context = getObjectPropertyByPath("context", troubleShootingInfo, {});
  var isHowToContent = false;
  var _output$pageContent = output.pageContent,
    pageContent = _output$pageContent === void 0 ? {} : _output$pageContent,
    _output$navHist = output.navHist,
    navHist = _output$navHist === void 0 ? [] : _output$navHist,
    currentPageId = output.currentPageId,
    prevStepEnabled = output.prevStepEnabled,
    midFlowSigninUrl = output.midFlowSigninUrl;
  var _pageContent$steps = pageContent.steps,
    steps = _pageContent$steps === void 0 ? [] : _pageContent$steps;
  var _landingInfo$device = landingInfo.device,
    device = _landingInfo$device === void 0 ? {} : _landingInfo$device;
  var is5GDevice = device.is5GDevice;
  var analysis = steps[0] || {};
  var resolution = getStepByName("resolution", steps);
  var instructions = getStepByName("instructions", steps);
  var closure = getStepByName("closure", steps);
  var eotFlag = resolution.eotFlag || analysis.eotFlag;
  var buttons = [];
  var popOutFlow = (_window = window) !== null && _window !== void 0 && _window.isBAUACSS ? true : false;
  var isACSS = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params7 = configDetails.paramsDetails) === null || _configDetails$params7 === void 0 ? void 0 : _configDetails$params7.channel) == "CARE" ? true : false;
  var isRetail = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params8 = configDetails.paramsDetails) === null || _configDetails$params8 === void 0 ? void 0 : _configDetails$params8.channel) == "Retail";
  var startTroubleShooting = {
    "label": "Start troubleshooting",
    "action": "Start troubleshooting",
    "type": "primary",
    "url": "",
    "callFunction": "",
    "inverted": configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params9 = configDetails.paramsDetails) === null || _configDetails$params9 === void 0 ? void 0 : (_configDetails$params0 = _configDetails$params9.theme) === null || _configDetails$params0 === void 0 ? void 0 : _configDetails$params0.isDark
  };
  var movSelectDifferentIssue = {
    "label": "Select different issue",
    "action": "Select different issue",
    "type": "secondary",
    "url": configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config2 = configDetails.config) === null || _configDetails$config2 === void 0 ? void 0 : (_configDetails$config3 = _configDetails$config2.caseDetails) === null || _configDetails$config3 === void 0 ? void 0 : _configDetails$config3.changeIssueUrl,
    "callFunction": ""
  };
  var nextStepLabel = {
    "label": "Next step",
    "action": "Start troubleshooting",
    "type": "primary",
    "url": "",
    "callFunction": ""
  };
  var previousStepLabel = {
    "label": "Previous step",
    "action": "Select different issue",
    "type": "secondary",
    "url": configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config4 = configDetails.config) === null || _configDetails$config4 === void 0 ? void 0 : (_configDetails$config5 = _configDetails$config4.caseDetails) === null || _configDetails$config5 === void 0 ? void 0 : _configDetails$config5.changeIssueUrl,
    "callFunction": ""
  };
  var acssSelectDifferentIssue = {
    "label": "Select different issue",
    "action": "Select different issue",
    "type": "secondary",
    "callFunction": "onAcssSelectDifferentIssue",
    "inverted": configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params1 = configDetails.paramsDetails) === null || _configDetails$params1 === void 0 ? void 0 : (_configDetails$params10 = _configDetails$params1.theme) === null || _configDetails$params10 === void 0 ? void 0 : _configDetails$params10.isDark
  };
  if (isACSS || popOutFlow || isRetail) {
    buttons = [acssSelectDifferentIssue, startTroubleShooting];
  } else if (window.isMVODigital) {
    buttons = isDesktop || isTablet ? [previousStepLabel, nextStepLabel] : [nextStepLabel, previousStepLabel];
  } else {
    buttons = [movSelectDifferentIssue, startTroubleShooting];
  }
  var disabledBtnPrev = false;
  var disabledBtn = processStep !== 'undefined' && processStep == "ViraPoll" ? true : false;
  var _useState = useState({
      showModal: false,
      expandModal: false,
      modalType: ''
    }),
    modalValues = _useState[0],
    setModalValues = _useState[1];
  if (!prevStepEnabled) {
    disabledBtnPrev = true;
  }
  var _useState2 = useState({
      showThumbsUp: false,
      showThumbsDown: false,
      thumbsClicked: false,
      submitClicked: false,
      rating: ''
    }),
    flags = _useState2[0],
    setFlags = _useState2[1];
  var mvoTroubleShootingJson = sessionUtility.getTroubleShootingJson();
  var _useState3 = useState('');
  var _useState4 = useState(null),
    waitscreenLoadTime = _useState4[0],
    setWaitscreenLoadTime = _useState4[1];
  var _useState5 = useState({}),
    outageInfoCheck = _useState5[0],
    setOutageInfoCheck = _useState5[1];
  var stepInputRef = useRef(null);
  useEffect(function () {
    var _props$values2;
    setFlags(_extends({}, flags, props === null || props === void 0 ? void 0 : (_props$values2 = props.values) === null || _props$values2 === void 0 ? void 0 : _props$values2.flags));
  }, [props === null || props === void 0 ? void 0 : (_props$values3 = props.values) === null || _props$values3 === void 0 ? void 0 : _props$values3.flags]);
  useEffect(function () {
    var _configDetails$params11, _window2, _window2$troubleShoot, _window2$troubleShoot2, _window2$troubleShoot3, _configDetails$params12, _configDetails$params13, _configDetails$select, _configDetails$select2, _window4, _window5;
    var solutionSource = analysis.solutionSource;
    var deviceSku = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params11 = configDetails.paramsDetails) === null || _configDetails$params11 === void 0 ? void 0 : _configDetails$params11.sku) || ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$troubleShoot = _window2.troubleShootingJson) === null || _window2$troubleShoot === void 0 ? void 0 : (_window2$troubleShoot2 = _window2$troubleShoot.ddata) === null || _window2$troubleShoot2 === void 0 ? void 0 : (_window2$troubleShoot3 = _window2$troubleShoot2.device) === null || _window2$troubleShoot3 === void 0 ? void 0 : _window2$troubleShoot3.deviceSku) || '';
    var deviceName = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params12 = configDetails.paramsDetails) === null || _configDetails$params12 === void 0 ? void 0 : _configDetails$params12.deviceName) || '';
    var tsCaseDetails = sessionUtility.getCaseDetails();
    var categoryTitle = sessionStorage.getItem("categoryTitle") || '';
    var isACSS = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params13 = configDetails.paramsDetails) === null || _configDetails$params13 === void 0 ? void 0 : _configDetails$params13.channel) == "CARE";
    var tsaIssueName = (tsCaseDetails === null || tsCaseDetails === void 0 ? void 0 : tsCaseDetails.intent) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select = configDetails.selectedNSAIntent) === null || _configDetails$select === void 0 ? void 0 : _configDetails$select.intent) || '';
    var issueNumber = (tsCaseDetails === null || tsCaseDetails === void 0 ? void 0 : tsCaseDetails.intentId) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select2 = configDetails.selectedNSAIntent) === null || _configDetails$select2 === void 0 ? void 0 : _configDetails$select2.intentId) || '';
    var tsaStepName = analysis.title || '';
    var isFwaIntentPage = false;
    if (window.isMVODigital) {
      var getTroubleshootParams = JSON.parse(sessionStorage.getItem('troubleshootingDetails'));
      tsaIssueName = getTroubleshootParams !== null && getTroubleshootParams !== void 0 && getTroubleshootParams.intent ? getTroubleshootParams === null || getTroubleshootParams === void 0 ? void 0 : getTroubleshootParams.intent : "";
      issueNumber = getTroubleshootParams !== null && getTroubleshootParams !== void 0 && getTroubleshootParams.intentId ? getTroubleshootParams === null || getTroubleshootParams === void 0 ? void 0 : getTroubleshootParams.intentId : "";
      isFwaIntentPage = getTroubleshootParams !== null && getTroubleshootParams !== void 0 && getTroubleshootParams.isFwaIntentPage ? getTroubleshootParams === null || getTroubleshootParams === void 0 ? void 0 : getTroubleshootParams.isFwaIntentPage : false;
    }
    var support = {
      issueNumber: issueNumber,
      tsaIssueName: tsaIssueName,
      tsaStepName: tsaStepName + "_" + currentPageId
    };
    var subFlow = deviceName + "_" + deviceSku;
    var isFwaIntentPageFlag = isFwaIntentPage == 'true' || isFwaIntentPage === true ? true : false;
    var mvoFlow = (_window4 = window) !== null && _window4 !== void 0 && _window4.isFwa || isFwaIntentPageFlag ? "troubleshooting_asistant_fwa" : "troubleshooting_asistant_mobile";
    var source = !isEmpty(solutionSource) ? solutionSource : window.isMVODigital ? 'Vira' : solutionSource;
    var page = {
      sourceChannel: isACSS ? "ACSS_" + source : "vzw_" + source,
      displayChannel: isACSS ? "ACSS" : "vzw",
      throttle: 'NSA',
      subFlow: subFlow,
      startTime: new Date()
    };
    var target = {
      engagement: {
        intent: "support"
      },
      sandBox: (_window5 = window) !== null && _window5 !== void 0 && _window5.diagnosticsAnimation ? window.isMVODigital ? '' : '200' : ''
    };
    if (processStep === "ViraPoll") {
      var acssFlow = "troubleshooter| ACSS_embedded| run diagnostics";
      var flow = isACSS ? acssFlow : mvoFlow;
      setWaitscreenLoadTime(new Date());
      var name = isACSS ? "ts| " + categoryTitle + "| " + (symptom === null || symptom === void 0 ? void 0 : symptom.issueName) + "| run diagnostics" : "tbs_rundiagnostic";
      tagging.setPage({
        page: _extends({}, page, {
          name: name,
          flow: flow
        }),
        target: target,
        support: support
      }, isACSS);
    }
    if (processStep === "Yes") {
      var _window6, _window6$localStorage;
      var _acssFlow = "troubleshooter| ACSS_embedded| diagnostics results";
      var _flow = isACSS ? _acssFlow : mvoFlow;
      var resultScreen = new Date();
      var timeTaken = resultScreen - waitscreenLoadTime;
      var success = [];
      var fail = [];
      var norun = [];
      var partialSuccess = [];
      diagnosticsData.map(function (_ref7) {
        var attrNames = _ref7.attrNames;
        return attrNames;
      }).flat().forEach(function (item) {
        var _item$attributeID, _item$attributeID2, _item$attributeID3, _item$attributeID4;
        if ((item === null || item === void 0 ? void 0 : item.value) === 'Yes') success.push(item === null || item === void 0 ? void 0 : (_item$attributeID = item.attributeID) === null || _item$attributeID === void 0 ? void 0 : _item$attributeID.toLowerCase());else if ((item === null || item === void 0 ? void 0 : item.value) === 'No') fail.push(item === null || item === void 0 ? void 0 : (_item$attributeID2 = item.attributeID) === null || _item$attributeID2 === void 0 ? void 0 : _item$attributeID2.toLowerCase());else if ((item === null || item === void 0 ? void 0 : item.value) === 'PartialDataAvailable') partialSuccess.push(item === null || item === void 0 ? void 0 : (_item$attributeID3 = item.attributeID) === null || _item$attributeID3 === void 0 ? void 0 : _item$attributeID3.toLowerCase());else if ((item === null || item === void 0 ? void 0 : item.value) === 'NotAvailable') norun.push(item === null || item === void 0 ? void 0 : (_item$attributeID4 = item.attributeID) === null || _item$attributeID4 === void 0 ? void 0 : _item$attributeID4.toLowerCase());
      });
      var tsaIntentResults = [{
        name: 'success',
        data: success
      }, {
        name: 'fail',
        data: fail
      }, {
        name: 'norun',
        data: norun
      }, {
        name: 'partialSuccess',
        data: partialSuccess
      }].filter(function (item) {
        var _item$data;
        return (item === null || item === void 0 ? void 0 : (_item$data = item.data) === null || _item$data === void 0 ? void 0 : _item$data.length) > 0;
      }).map(function (item) {
        var _item$data2;
        return "^" + (item === null || item === void 0 ? void 0 : item.name) + ":" + (item === null || item === void 0 ? void 0 : (_item$data2 = item.data) === null || _item$data2 === void 0 ? void 0 : _item$data2.join('|'));
      }).join('');
      var _name = isACSS ? "ts| " + categoryTitle + "| " + (symptom === null || symptom === void 0 ? void 0 : symptom.issueName) + "| diagnostics results" : "tbs_diagnosticsresult";
      var selectedFromSearch = (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$localStorage = _window6.localStorage) === null || _window6$localStorage === void 0 ? void 0 : _window6$localStorage.getItem('selectedFromSearch');
      var eventValue = selectedFromSearch === "y" ? "event294=" + timeTaken + "," + 'event351,event12' : "event351,event13";
      tagging.setPage({
        page: _extends({}, page, {
          name: _name,
          flow: _flow
        }),
        target: target,
        support: _extends({}, support, {
          tsaIntentResults: tsaIntentResults
        }),
        event: {
          value: eventValue
        }
      }, isACSS);
    }
    return function () {
      window.vzdl.target.message = '';
    };
  }, [processStep]);
  var feedbutton = document.getElementById("disableNetbut");
  useEffect(function () {
    if (feedbutton && window.isBAUACSS) {
      var _feedbutton$style;
      if (feedbutton !== null && feedbutton !== void 0 && feedbutton.style && feedbutton !== null && feedbutton !== void 0 && (_feedbutton$style = feedbutton.style) !== null && _feedbutton$style !== void 0 && _feedbutton$style.display) feedbutton.style.display = "none";
    }
  });
  useEffect(function () {
    var _ddata$output, _ddata$output$navHist, _ddata$output$navHist2;
    var _ref8 = (values === null || values === void 0 ? void 0 : values.troubleShootingInfo) || {},
      _ref8$context = _ref8.context,
      context = _ref8$context === void 0 ? {} : _ref8$context,
      _ref8$ddata = _ref8.ddata,
      ddata = _ref8$ddata === void 0 ? {} : _ref8$ddata;
    var pageId = (ddata === null || ddata === void 0 ? void 0 : (_ddata$output = ddata.output) === null || _ddata$output === void 0 ? void 0 : (_ddata$output$navHist = _ddata$output.navHist) === null || _ddata$output$navHist === void 0 ? void 0 : (_ddata$output$navHist2 = _ddata$output$navHist[0]) === null || _ddata$output$navHist2 === void 0 ? void 0 : _ddata$output$navHist2.pageId) || null;
    if ((context === null || context === void 0 ? void 0 : context.processStep) === "ViraPoll") {
      setTimeout(function () {
        try {
          functions.processTroubleShootingPage("Poll", context === null || context === void 0 ? void 0 : context.processStep, pageId, "diagnostics", context, "", "", "", "", "", "", "", "", {
            newValues: {}
          });
          return Promise.resolve();
        } catch (e) {
          return Promise.reject(e);
        }
      }, 5000);
    }
  }, [values.troubleShootingInfo]);
  var triggerCheckOutageAPI = function triggerCheckOutageAPI() {
    try {
      var _configDetails$params15, _configDetails$params16;
      var envData = {
        externalTarget: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params15 = configDetails.paramsDetails) === null || _configDetails$params15 === void 0 ? void 0 : _configDetails$params15.externalTarget,
        mvoenv: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params16 = configDetails.paramsDetails) === null || _configDetails$params16 === void 0 ? void 0 : _configDetails$params16.mvoenv
      };
      return Promise.resolve(checkOutageAPI(envData)).then(function (responseCheckOutage) {
        var _responseCheckOutage$, _responseCheckOutage$2;
        if (responseCheckOutage !== null && responseCheckOutage !== void 0 && responseCheckOutage.data && responseCheckOutage !== null && responseCheckOutage !== void 0 && (_responseCheckOutage$ = responseCheckOutage.data) !== null && _responseCheckOutage$ !== void 0 && _responseCheckOutage$.pegaCards && responseCheckOutage !== null && responseCheckOutage !== void 0 && (_responseCheckOutage$2 = responseCheckOutage.data) !== null && _responseCheckOutage$2 !== void 0 && _responseCheckOutage$2.pegaCards.length) {
          setOutageInfoCheck(responseCheckOutage);
        }
        console.log(responseCheckOutage);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  useEffect(function () {
    if (isACSS) {
      var _stepInputRef$current;
      stepInputRef === null || stepInputRef === void 0 ? void 0 : (_stepInputRef$current = stepInputRef.current) === null || _stepInputRef$current === void 0 ? void 0 : _stepInputRef$current.focus();
    }
    if (window.isMVODigital) {
      window.scrollTo({
        left: 0,
        top: 0,
        behavior: 'smooth'
      });
      if (!thumbsDownSubmittedStep) {
        triggerCheckOutageAPI();
      }
    }
    if (uiLoggerContext.setPageDetails) {
      var _configDetails$caseDe, _configDetails$select3;
      var _intent = symptom.issueName || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$caseDe = configDetails.caseDetails) === null || _configDetails$caseDe === void 0 ? void 0 : _configDetails$caseDe.intent) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select3 = configDetails.selectedNSAIntent) === null || _configDetails$select3 === void 0 ? void 0 : _configDetails$select3.intent) || "Title";
      var _ref9 = steps[0] || {},
        _ref9$title = _ref9.title,
        title = _ref9$title === void 0 ? '' : _ref9$title;
      var pageDetails = {
        pageTitle: _intent,
        pageName: "Troubleshooting | " + title,
        flowName: (is5GDevice ? "5G" : "4G") + " Troubleshooting"
      };
      uiLoggerContext.setPageDetails(pageDetails);
    }
  }, []);
  var handleModalClick = function handleModalClick() {
    setModalValues(_extends({}, modalValues, {
      expandModal: true,
      modalType: 'feedback'
    }));
  };
  var handleCloseButton = function handleCloseButton(e) {
    setModalValues(_extends({}, modalValues, {
      showModal: false
    }));
    setFlags(_extends({}, flags, {
      justAfterThumbsDownClicked: false,
      thumbsClicked: !!(e !== null && e !== void 0 && e.done)
    }));
  };
  var handleFeedbackFlags = function handleFeedbackFlags(flags) {
    setFlags(_extends({}, flags));
  };
  var handleModalState = function handleModalState(flags) {
    setModalValues(_extends({}, modalValues, {
      showModal: true,
      expandModal: true,
      modalType: 'feedback'
    }));
    setFlags(_extends({}, flags));
  };
  var handleChecklistChange = function handleChecklistChange(value, step) {
    console.log("NextStepPage:handleCheckListChange: value:", value);
    if (functions.handleReplayNavigation) {
      functions.handleReplayNavigation(value, step);
    }
  };
  var history = useHistory();
  var handleAction = function handleAction(button) {
    if (props.combinedIssueSelector && "" + button.action == "Select different issue") {
      console.log("TroubleShooting:handleAction: called with action: " + button.action);
      if (window.isMVODigital && window._dg_channelId === "VZW-MFA") {
        functions.redirectToCombinedIssueSelector();
      } else {
        history.goBack();
      }
    } else if (functions.handleTroubleShootingAction) {
      functions.handleTroubleShootingAction(button);
    }
  };
  var renderDescription = function renderDescription(isDark) {
    return steps.map(function (step, index) {
      if (step.description) {
        return /*#__PURE__*/React__default.createElement(Body, {
          key: index,
          size: "large",
          color: isDark ? "#FFFFFF" : "#000000"
        }, /*#__PURE__*/React__default.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: step.description
          }
        }));
      }
    });
  };
  var handleSolvedClick = function handleSolvedClick(e) {
    try {
      e.preventDefault();
      handleAction({
        label: 'Yes',
        action: 'Yes',
        type: 'primary',
        url: '',
        callFunction: ''
      });
    } catch (error) {
      console.error('FROM onevz-soe-digital-ts-static/app/ts-components/templates/NSATRG/templates/TroubleShooting/WaitResultDiagnostics.js', error);
    }
  };
  var modalChanged = function modalChanged(open) {
    if (!open) {
      if (props.handleAction) {
        props.handleAction({
          actionData: 'close'
        });
      }
      setModalValues(_extends({}, modalValues, {
        showModal: false,
        expandModal: false,
        modalType: ''
      }));
      if (!(flags.showThumbsDown || flags.showThumbsUp)) {
        setFlags(_extends({}, flags, {
          thumbsClicked: false
        }));
      }
    }
  };
  var intenttitle = symptom.issueName || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$caseDe2 = configDetails.caseDetails) === null || _configDetails$caseDe2 === void 0 ? void 0 : _configDetails$caseDe2.intent) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select4 = configDetails.selectedNSAIntent) === null || _configDetails$select4 === void 0 ? void 0 : _configDetails$select4.intent) || "Title";
  var personalizedTitle = context === null || context === void 0 ? void 0 : context.personalizedTitle;
  var intent = {};
  if (personalizedTitle) {
    intent = personalizedTitle;
  } else {
    intent = intenttitle;
  }
  var redirectToOldPortal = function redirectToOldPortal(purpose) {
    if (purpose === void 0) {
      purpose = "issue-selection";
    }
    try {
      return Promise.resolve(sessionUtility.getCaseDetails()).then(function (caseDetails) {
        var _caseDetails$equipmen;
        var equipmentId = (_caseDetails$equipmen = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.equipmentId) != null ? _caseDetails$equipmen : "";
        redirectFormPostToUrl(caseDetails.changeIssueUrl, equipmentId, purpose);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var getTitle = function getTitle() {
    var _troubleshootingDetai;
    var troubleshootingDetails;
    if (sessionStorage.getItem('troubleshootingDetails')) {
      troubleshootingDetails = JSON.parse(sessionStorage.getItem('troubleshootingDetails'));
    }
    var title = props.combinedIssueSelector ? (_troubleshootingDetai = troubleshootingDetails) === null || _troubleshootingDetai === void 0 ? void 0 : _troubleshootingDetai.intent : "";
    if (context.personalizedTitle) {
      title = intent;
    }
    return title || intent || "Title";
  };
  var _useState6 = useState(1),
    activeTab = _useState6[0];
  var onTabChange = function onTabChange(e, i) {
    console.log("onTabChange", e, i);
    if (i == 0) {
      redirectToOldPortal();
    }
    if (i == 2) {
      redirectToOldPortal("issue-history");
    }
  };
  var renderTabs = function renderTabs() {
    return /*#__PURE__*/React__default.createElement(HeaderTabContainer$3, null, /*#__PURE__*/React__default.createElement(TabsContainer$3, null, /*#__PURE__*/React__default.createElement(Tabs$1, {
      orientation: "horizontal",
      indicatorPosition: "top",
      linePosition: "top",
      selectedIndex: activeTab,
      onTabChange: onTabChange
    }, /*#__PURE__*/React__default.createElement(Tab, {
      label: "Issue selector"
    }), /*#__PURE__*/React__default.createElement(Tab, {
      label: "Troubleshooting"
    }), /*#__PURE__*/React__default.createElement(Tab, {
      label: "Issue history"
    }))));
  };
  var diagnosticsAI;
  var isProcessing;
  var resultData = useDiagnostics({
    data: diagnosticsData
  });
  if (window.isMVODigital) {
    var result = !thumbsDownSubmittedStep ? resultData : {
      diagnosticsAI: diagnosticsData,
      isProcessing: false
    };
    diagnosticsAI = result === null || result === void 0 ? void 0 : result.diagnosticsAI;
    isProcessing = result === null || result === void 0 ? void 0 : result.isProcessing;
  } else {
    diagnosticsAI = resultData === null || resultData === void 0 ? void 0 : resultData.diagnosticsAI;
    isProcessing = resultData === null || resultData === void 0 ? void 0 : resultData.isProcessing;
  }
  var newItemRef = useRef(null);
  useEffect(function () {
    if (!isMobile && (processStep !== "ViraPoll" || !isProcessing)) return;
    if (newItemRef.current) newItemRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'end'
    });
  }, [diagnosticsAI]);
  var renderWaitResult = function renderWaitResult() {
    var _window8, _window8$config, _window$caseDetails, _configDetails$params17, _configDetails$params18, _configDetails$config6, _values$feedbackConta, _mvoTroubleShootingJs, _mvoTroubleShootingJs2, _values$feedbackConta2, _values$feedbackConta3, _configDetails$params19, _configDetails$params20, _configDetails$params21, _configDetails$params22, _configDetails$params23, _configDetails$params24, _steps$, _configDetails$params25, _configDetails$params26, _diagnosticsAI, _configDetails$params27, _configDetails$params28, _configDetails$params29, _configDetails$params30, _configDetails$params31, _configDetails$params32, _configDetails$params33, _configDetails$params34, _configDetails$params35, _configDetails$params36, _configDetails$params37, _configDetails$params38;
    var completedCount = diagnosticsData === null || diagnosticsData === void 0 ? void 0 : diagnosticsData.flatMap(function (item) {
      return item.attrNames;
    }).filter(function (attr) {
      return attr.value === "Yes";
    }).length;
    var failedCount = diagnosticsData === null || diagnosticsData === void 0 ? void 0 : diagnosticsData.flatMap(function (item) {
      return item.attrNames;
    }).filter(function (attr) {
      return attr.value === "No";
    }).length;
    var partialDataCount = diagnosticsData === null || diagnosticsData === void 0 ? void 0 : diagnosticsData.flatMap(function (item) {
      return item.attrNames;
    }).filter(function (attr) {
      return attr.value === "PartialDataAvailable";
    }).length;
    var unavailableCount = diagnosticsData === null || diagnosticsData === void 0 ? void 0 : diagnosticsData.flatMap(function (item) {
      return item.attrNames;
    }).filter(function (attr) {
      return attr.value === "NotAvailable";
    }).length;
    var windowRetailIframe = (_window8 = window) === null || _window8 === void 0 ? void 0 : (_window8$config = _window8.config) === null || _window8$config === void 0 ? void 0 : _window8$config.retailIframe;
    var issueNameOutage = "";
    if (sessionStorage.getItem('troubleshootingDetails') && props.combinedIssueSelector) {
      var troubleshootingDetailsObj = JSON.parse(sessionStorage.getItem('troubleshootingDetails'));
      issueNameOutage = troubleshootingDetailsObj === null || troubleshootingDetailsObj === void 0 ? void 0 : troubleshootingDetailsObj.intent;
    } else if (((_window$caseDetails = window.caseDetails) === null || _window$caseDetails === void 0 ? void 0 : _window$caseDetails.intent) !== null && props.combinedIssueSelector) {
      var _window$caseDetails2;
      issueNameOutage = (_window$caseDetails2 = window.caseDetails) === null || _window$caseDetails2 === void 0 ? void 0 : _window$caseDetails2.intent;
    }
    return /*#__PURE__*/React__default.createElement(ImageContainer$4, {
      isACSS: isACSS,
      popOutFlow: popOutFlow,
      isDigital: window.isMVODigital
    }, /*#__PURE__*/React__default.createElement(DiagnosticContainer, {
      isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params17 = configDetails.paramsDetails) === null || _configDetails$params17 === void 0 ? void 0 : (_configDetails$params18 = _configDetails$params17.theme) === null || _configDetails$params18 === void 0 ? void 0 : _configDetails$params18.isDark,
      id: "contentBody",
      isACSS: isACSS,
      popOutFlow: popOutFlow
    }, (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config6 = configDetails.config) === null || _configDetails$config6 === void 0 ? void 0 : _configDetails$config6.isBAUACSS) && !window.isMVODigital && renderTabs(), values !== null && values !== void 0 && (_values$feedbackConta = values.feedbackContainerDetails) !== null && _values$feedbackConta !== void 0 && _values$feedbackConta.show && !(mvoTroubleShootingJson !== null && mvoTroubleShootingJson !== void 0 && (_mvoTroubleShootingJs = mvoTroubleShootingJson.ddata) !== null && _mvoTroubleShootingJs !== void 0 && (_mvoTroubleShootingJs2 = _mvoTroubleShootingJs.device) !== null && _mvoTroubleShootingJs2 !== void 0 && _mvoTroubleShootingJs2.is5GDevice) ? values !== null && values !== void 0 && (_values$feedbackConta2 = values.feedbackContainerDetails) !== null && _values$feedbackConta2 !== void 0 && _values$feedbackConta2.success && values !== null && values !== void 0 && (_values$feedbackConta3 = values.feedbackContainerDetails) !== null && _values$feedbackConta3 !== void 0 && _values$feedbackConta3.show ? /*#__PURE__*/React__default.createElement(FeedbackSection, {
      isDigital: window.isMVODigital
    }, /*#__PURE__*/React__default.createElement(FeedbackMessage, {
      values: values,
      closeFeedbackBar: functions.closeFeedbackBar
    })) : /*#__PURE__*/React__default.createElement(FeedbackSection, {
      isDigital: window.isMVODigital
    }, /*#__PURE__*/React__default.createElement(FeedbackBarError, {
      values: values,
      closeFeedbackBar: functions.closeFeedbackBar
    })) : null, /*#__PURE__*/React__default.createElement(TitleContainer$3, {
      popOutFlow: popOutFlow,
      isACSS: isACSS
    }, window.isMVODigital && /*#__PURE__*/React__default.createElement(Title, {
      size: isACSS || popOutFlow ? 'large' : 'XLarge',
      primitive: "h1"
    }, /*#__PURE__*/React__default.createElement(TextWithHtml, {
      style: {
        textAlign: "left"
      }
    }, getTitle()))), /*#__PURE__*/React__default.createElement(InStepBanner, {
      isLeftNav: symptomList,
      steps: steps,
      isACSS: isACSS || popOutFlow,
      isDark: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params19 = configDetails.paramsDetails) === null || _configDetails$params19 === void 0 ? void 0 : (_configDetails$params20 = _configDetails$params19.theme) === null || _configDetails$params20 === void 0 ? void 0 : _configDetails$params20.isDark) == true
    }), window.isMVODigital ? /*#__PURE__*/React__default.createElement(StepsAndTitleSection, null, /*#__PURE__*/React__default.createElement(NavStepsContainer$4, {
      isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params21 = configDetails.paramsDetails) === null || _configDetails$params21 === void 0 ? void 0 : (_configDetails$params22 = _configDetails$params21.theme) === null || _configDetails$params22 === void 0 ? void 0 : _configDetails$params22.isDark
    }, /*#__PURE__*/React__default.createElement(NavSteps, {
      id: "nav-step-dark",
      steps: navHist,
      value: currentPageId,
      onChange: function onChange(value, step) {
        return handleChecklistChange(value, step);
      },
      stepInputRef: stepInputRef
    })), /*#__PURE__*/React__default.createElement(NewPageTitleDigital, null, /*#__PURE__*/React__default.createElement(Title, {
      size: isMobile ? "large" : "medium",
      primitive: "h2",
      color: "#000000",
      bold: true
    }, /*#__PURE__*/React__default.createElement(TextWithHtml, {
      "aria-live": "polite",
      style: {
        textAlign: "left"
      }
    }, steps[0].title)))) : /*#__PURE__*/React__default.createElement(StepSubTitle, {
      popOutFlow: popOutFlow
    }, /*#__PURE__*/React__default.createElement(StepsAndTitle, null, /*#__PURE__*/React__default.createElement(NavStepsContainer$4, {
      isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params23 = configDetails.paramsDetails) === null || _configDetails$params23 === void 0 ? void 0 : (_configDetails$params24 = _configDetails$params23.theme) === null || _configDetails$params24 === void 0 ? void 0 : _configDetails$params24.isDark
    }, /*#__PURE__*/React__default.createElement(NavSteps, {
      id: "nav-step-dark",
      steps: navHist,
      value: currentPageId,
      onChange: function onChange(value, step) {
        return handleChecklistChange(value, step);
      },
      stepInputRef: stepInputRef
    }), /*#__PURE__*/React__default.createElement(NewPageTitle$3, null, /*#__PURE__*/React__default.createElement(Title, {
      size: isMobile ? "large" : "medium",
      primitive: "h2",
      color: isDark ? "#fff" : "#000000",
      bold: true
    }, /*#__PURE__*/React__default.createElement(TextWithHtml, {
      "aria-live": "polite",
      style: {
        marginLeft: isMobile ? '' : '5px',
        textAlign: "left"
      }
    }, (_steps$ = steps[0]) === null || _steps$ === void 0 ? void 0 : _steps$.title)))))), /*#__PURE__*/React__default.createElement(Stack, {
      flexDirection: ['column', 'row'],
      gap: ["24px", "40px"]
    }, /*#__PURE__*/React__default.createElement(CircleAlign, {
      popOutFlow: popOutFlow,
      symptomList: symptomList.length
    }, /*#__PURE__*/React__default.createElement(WCircle, {
      diagnosticsData: diagnosticsAI,
      processStep: processStep,
      isDark: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params25 = configDetails.paramsDetails) === null || _configDetails$params25 === void 0 ? void 0 : (_configDetails$params26 = _configDetails$params25.theme) === null || _configDetails$params26 === void 0 ? void 0 : _configDetails$params26.isDark) === true,
      isProcessing: isProcessing
    })), /*#__PURE__*/React__default.createElement(DiagnosticsDetails, {
      "aria-live": "polite",
      "aria-atomic": "true"
    }, /*#__PURE__*/React__default.createElement(HRule, null), (_diagnosticsAI = diagnosticsAI) === null || _diagnosticsAI === void 0 ? void 0 : _diagnosticsAI.map(function (item, index) {
      var _diagnosticsAI2;
      return /*#__PURE__*/React__default.createElement(FadeIn, {
        key: (item === null || item === void 0 ? void 0 : item.group) + index,
        enabled: isMobile
      }, /*#__PURE__*/React__default.createElement(Box, {
        bold: false,
        key: item === null || item === void 0 ? void 0 : item.group,
        minWidth: ["100%", "172px"]
      }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Title, {
        size: "small",
        bold: isMobile,
        primitive: "h3",
        color: isDark ? "#FFFFFF" : "#000000"
      }, item.group), item.attrNames.map(function (attribute) {
        return /*#__PURE__*/React__default.createElement(DetailItem, {
          key: attribute === null || attribute === void 0 ? void 0 : attribute.attributeID,
          attribute: attribute
        });
      }))), /*#__PURE__*/React__default.createElement(HRule, {
        isLast: index === ((_diagnosticsAI2 = diagnosticsAI) === null || _diagnosticsAI2 === void 0 ? void 0 : _diagnosticsAI2.length) - 1
      }));
    }))), /*#__PURE__*/React__default.createElement("div", {
      "aria-live": "polite",
      style: {
        overflow: 'hidden',
        width: '0px',
        height: '0px'
      }
    }, completedCount + " completed, " + failedCount + " failed, " + partialDataCount + " partially completed, " + unavailableCount + " not available"), /*#__PURE__*/React__default.createElement(DescriptionWrapper, {
      isDark: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params27 = configDetails.paramsDetails) === null || _configDetails$params27 === void 0 ? void 0 : (_configDetails$params28 = _configDetails$params27.theme) === null || _configDetails$params28 === void 0 ? void 0 : _configDetails$params28.isDark) === true
    }, /*#__PURE__*/React__default.createElement(Stack, {
      flexDirection: ['column', 'row'],
      gap: [isACSS ? '54px' : '32px'],
      marginLeft: ['0', popOutFlow ? '65px' : 0]
    }, /*#__PURE__*/React__default.createElement(LeftNav, {
      symptomList: symptomList,
      isDark: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params29 = configDetails.paramsDetails) === null || _configDetails$params29 === void 0 ? void 0 : (_configDetails$params30 = _configDetails$params29.theme) === null || _configDetails$params30 === void 0 ? void 0 : _configDetails$params30.isDark) == true
    }), /*#__PURE__*/React__default.createElement(Box, {
      marginLeft: [(symptomList === null || symptomList === void 0 ? void 0 : symptomList.length) === 0 && '0', popOutFlow ? (symptomList === null || symptomList === void 0 ? void 0 : symptomList.length) === 0 && '285px' : (symptomList === null || symptomList === void 0 ? void 0 : symptomList.length) === 0 ? '245px' : '0']
    }, !isProcessing && /*#__PURE__*/React__default.createElement(DescText, {
      isACSS: isACSS
    }, renderDescription(isDark)))), window.isMVODigital && /*#__PURE__*/React__default.createElement(FooterSectionDignostic, null, /*#__PURE__*/React__default.createElement(FeedbackContainer, {
      functions: functions,
      values: values,
      handleModalState: handleModalState,
      disabled: disabledBtn,
      flags: flags
    }), modalValues.showModal && /*#__PURE__*/React__default.createElement(StyledModal$7, {
      closeButton: modalValues.modalType === 'saveAndExit' ? /*#__PURE__*/React__default.createElement(SaveExitCloseButton$4, {
        "data-analyticstrack": "overlay-generic-cta"
      }, /*#__PURE__*/React__default.createElement(Icon$1, {
        id: "closeModal",
        name: "close",
        size: "large",
        color: "#000000",
        backgroundColor: "transparent"
      }), ' ') : /*#__PURE__*/React__default.createElement(FeedbackCloseButton$4, {
        "data-analyticstrack": "overlay-generic-cta"
      }, /*#__PURE__*/React__default.createElement(Icon$1, {
        id: "closeModal",
        name: "close",
        size: "large",
        color: "#000000",
        backgroundColor: "transparent"
      }), ' '),
      onOpenedChange: modalChanged,
      opened: modalValues.showModal,
      zIndex: "15000",
      expandModal: modalValues.expandModal,
      disableAnimation: window.isMVODigital && window._dg_channelId === "VZW-MFA" && modalValues.modalType === 'feedback' ? true : false,
      disableOutsideClick: true,
      modalType: modalValues.modalType === 'saveAndExit',
      howToModalType: modalValues.modalType === 'howToFeedback',
      modalName: modalValues.modalType,
      maxHeight: "95vh"
    }, /*#__PURE__*/React__default.createElement(StyledModalBody$6, null, modalValues.modalType === 'feedback' && /*#__PURE__*/React__default.createElement(FeedbackContainerModal, {
      functions: functions,
      values: values,
      flags: flags,
      handleModalClick: handleModalClick,
      handleCloseButton: handleCloseButton,
      handleFeedbackFlags: handleFeedbackFlags
    }), modalValues.modalType === "howToFeedback" && /*#__PURE__*/React__default.createElement(HowToFeedbackContainerModal, {
      functions: functions,
      values: values,
      handleModalClick: handleModalClick,
      flags: flags,
      handleCloseButton: handleCloseButton
    }), modalValues.modalType === 'saveAndExit' && /*#__PURE__*/React__default.createElement(SaveAndExitContainerModal, {
      functions: functions,
      values: values,
      handleModalClick: handleModalClick,
      handleCloseButton: handleCloseButton
    })))), window.isMVODigital ? /*#__PURE__*/React__default.createElement(Line$1, {
      type: "secondary",
      style: {
        margin: "32px 0",
        width: "100%"
      }
    }) : /*#__PURE__*/React__default.createElement(Line$1, {
      type: "secondary",
      style: {
        margin: "20px 0",
        width: "100%"
      },
      id: "topDivisonLine",
      surface: isDark ? "dark" : "light"
    }), window.isMVODigital ? /*#__PURE__*/React__default.createElement(FooterSectionAlign, null, " ", /*#__PURE__*/React__default.createElement(ButtonsWrapperAlign, {
      className: "sendEmailBtnDesc",
      isACSS: isACSS
    }, /*#__PURE__*/React__default.createElement(ActionButtonsFooter, null, /*#__PURE__*/React__default.createElement(ActionButtons, {
      buttons: buttons,
      handleAction: handleAction,
      disabled: disabledBtn || isProcessing
    })), /*#__PURE__*/React__default.createElement(SolvedProblemLink, null, /*#__PURE__*/React__default.createElement(TextLink, {
      type: "standAlone",
      surface: "light",
      onClick: !disabledBtn && handleSolvedClick,
      onKeyPress: handleSolvedClick,
      "aria-label": "This solved my problem",
      className: "solvedProblemCTA"
    }, "This solved my problem"))), "   ", /*#__PURE__*/React__default.createElement(SaveAndRetriveLink, null, /*#__PURE__*/React__default.createElement(SaveAndRetrieveTooltip, {
      configDetails: configDetails,
      isProbing: false,
      midFlowSigninUrl: midFlowSigninUrl
    }))) : /*#__PURE__*/React__default.createElement(ButtonsWrapper$7, {
      className: "sendEmailBtnDesc",
      isACSS: isACSS
    }, /*#__PURE__*/React__default.createElement(ActionButtons, {
      buttons: buttons,
      handleAction: handleAction,
      disabled: disabledBtn || isProcessing
    })), /*#__PURE__*/React__default.createElement("div", {
      ref: newItemRef
    }), window.isMVODigital ? null : /*#__PURE__*/React__default.createElement(Line$1, {
      type: "secondary",
      style: {
        margin: "20px 0",
        width: "100%"
      },
      id: "bottomDivisonLine",
      surface: isDark ? "dark" : "light"
    }))), isNewDesign && !window.isMVODigital && /*#__PURE__*/React__default.createElement(Footer$3, {
      className: !windowRetailIframe ? "footer1 popupFooter" : "footer1",
      style: {
        marginTop: "18px"
      },
      isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params31 = configDetails.paramsDetails) === null || _configDetails$params31 === void 0 ? void 0 : (_configDetails$params32 = _configDetails$params31.theme) === null || _configDetails$params32 === void 0 ? void 0 : _configDetails$params32.isDark
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "footer-line"
    }), modalValues.showModal && /*#__PURE__*/React__default.createElement(StyledModal$7, {
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params33 = configDetails.paramsDetails) !== null && _configDetails$params33 !== void 0 && (_configDetails$params34 = _configDetails$params33.theme) !== null && _configDetails$params34 !== void 0 && _configDetails$params34.isDark ? 'dark' : 'light',
      closeButton: modalValues.modalType === "saveAndExit" ? /*#__PURE__*/React__default.createElement(SaveExitCloseButton$4, {
        "data-analyticstrack": "overlay-generic-cta",
        onClick: function onClick(e) {
          return handleCloseButton(e);
        }
      }, /*#__PURE__*/React__default.createElement(Icon$1, {
        surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params35 = configDetails.paramsDetails) !== null && _configDetails$params35 !== void 0 && (_configDetails$params36 = _configDetails$params35.theme) !== null && _configDetails$params36 !== void 0 && _configDetails$params36.isDark ? 'dark' : 'light',
        id: "closeModal",
        name: "close",
        size: "large",
        color: "#000000",
        backgroundColor: "transparent"
      }), " ") : /*#__PURE__*/React__default.createElement(FeedbackCloseButton$4, {
        "data-analyticstrack": "overlay-generic-cta",
        onClick: function onClick(e) {
          return handleCloseButton(e);
        }
      }, /*#__PURE__*/React__default.createElement(Icon$1, {
        surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params37 = configDetails.paramsDetails) !== null && _configDetails$params37 !== void 0 && (_configDetails$params38 = _configDetails$params37.theme) !== null && _configDetails$params38 !== void 0 && _configDetails$params38.isDark ? 'dark' : 'light',
        id: "closeModal",
        name: "close",
        size: "large",
        color: "#000000",
        backgroundColor: "transparent"
      }), " "),
      onOpenedChange: modalChanged,
      opened: modalValues.showModal,
      zIndex: "15000",
      expandModal: modalValues.expandModal,
      disableOutsideClick: true,
      modalType: modalValues.modalType === "saveAndExit",
      howToModalType: modalValues.modalType === "howToFeedback",
      modalName: modalValues.modalType,
      maxHeight: "95vh"
    }, /*#__PURE__*/React__default.createElement(StyledModalBody$6, null, modalValues.modalType === "feedback" && /*#__PURE__*/React__default.createElement(FeedbackContainerModal, {
      functions: functions,
      values: values,
      handleModalClick: handleModalClick,
      symptom: symptom,
      flags: flags,
      handleCloseButton: handleCloseButton,
      handleFeedbackFlags: handleFeedbackFlags
    }), modalValues.modalType === "howToFeedback" && /*#__PURE__*/React__default.createElement(HowToFeedbackContainerModal, {
      functions: functions,
      values: values,
      handleModalClick: handleModalClick,
      flags: flags,
      symptom: symptom,
      handleCloseButton: handleCloseButton
    }), modalValues.modalType === "saveAndExit" && /*#__PURE__*/React__default.createElement(SaveAndExitContainerModal, {
      functions: functions,
      values: values,
      handleModalClick: handleModalClick,
      symptom: symptom,
      handleCloseButton: handleCloseButton
    }))), /*#__PURE__*/React__default.createElement(ActionButtons, {
      hideNetworkAndDevice: true,
      handleAction: handleAction,
      buttons: buttons,
      showPrevious: true,
      showNext: true,
      disabledButtons: disabledBtn,
      disableNext: disabledBtn,
      disablePrevious: disabledBtnPrev,
      pageId: currentPageId,
      handleNext: handleAction,
      newBtnType: true,
      isNewDesign: isNewDesign,
      isHowToContent: isHowToContent,
      functions: functions,
      values: values,
      eotFlag: eotFlag,
      handleModalState: handleModalState,
      thumbsDownSubmittedStep: thumbsDownSubmittedStep
    })), window.isMVODigital && !disabledBtn && !isProcessing && Object.keys(outageInfoCheck).length > 0 && /*#__PURE__*/React__default.createElement(Modal$1, {
      opened: true,
      surface: "light",
      fullScreenDialog: false,
      disableAnimation: window.isMVODigital && window._dg_channelId === "VZW-MFA" ? true : false,
      disableOutsideClick: true,
      ariaLabel: "Network outage detected Modal",
      className: "networkOutageModal"
    }, /*#__PURE__*/React__default.createElement(ModalTitle, null, outageInfoCheck.data.topMessage), /*#__PURE__*/React__default.createElement(ModalBody$1, null, "It looks like you are experiencing a network outage.", /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "24px"
    }), "Visit our Network Event Page to review status and updates or select Resume troubleshooting to continue to fix ", issueNameOutage !== "" && issueNameOutage !== undefined && issueNameOutage !== null ? issueNameOutage.toLowerCase() : "", "."), /*#__PURE__*/React__default.createElement(ModalFooter$1, {
      buttonData: {
        primary: {
          children: 'View Network Event',
          className: "networkOutageEventBtn",
          "data-analyticstrack": "View Network Event Btn",
          "data-track": "{\"type\": \"link\", \"name\": \"View-Network-Event-Btn\"}",
          "data-clickstream": "View-Network-Event-btn-cta",
          width: isDesktop || isTablet ? '207px' : '100%',
          onClick: function onClick() {
            var target = window._dg_channelId === 'VZW-MFA' ? "_self" : "_blank";
            window.open(outageInfoCheck.data.ctaUrl, target);
          }
        },
        close: {
          children: 'Resume troubleshooting',
          className: "resumeTroubleShootingBtn",
          "data-analyticstrack": "Resume troubleshooting Btn",
          "data-track": "{\"type\": \"link\", \"name\": \"Resume-troubleshooting-Btn\"}",
          "data-clickstream": "Resume-troubleshooting-Btn-cta",
          width: isDesktop || isTablet ? '243px' : '100%'
        }
      }
    })));
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, renderWaitResult());
};
WaitResultDiagnostics.propTypes = {
  functions: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
};
WaitResultDiagnostics.defaultProps = {};

var IntentError = function IntentError(props) {
  var item = {
    title: '',
    description: ''
  };
  var _useContext = useContext(ModalContext),
    _useContext$additiona = _useContext.additionalInfoSteps,
    additionalInfoSteps = _useContext$additiona === void 0 ? [] : _useContext$additiona;
  additionalInfoSteps === null || additionalInfoSteps === void 0 ? void 0 : additionalInfoSteps.map(function (value) {
    if (value.templateId === 'INTENT_NOT_FOUND') {
      item = value;
    }
  });
  useEffect(function () {
    if (document.getElementById('contentBody') && document.getElementById('contentBody') !== null) {
      document.getElementById('contentBody').scroll({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, []);
  if (!item.title && !item.description) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(Notification, {
    type: 'error',
    title: item.title,
    subtitle: /*#__PURE__*/React__default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: item.description
      }
    }),
    surface: "light",
    disableAnimation: false,
    fullBleed: false,
    hideCloseButton: false,
    disableFocus: false,
    inline: false,
    layout: null,
    onCloseButtonClick: function onCloseButtonClick() {
      return props.closeFeedbackBar(props.values);
    }
  });
};

var _templateObject$q, _templateObject2$l;
var TangelwoodCloseButton = styled.span(_templateObject$q || (_templateObject$q = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 20px;\n  top: 12px;\n  cursor: pointer;\n  z-index: 9999;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  @media screen and (max-width: 600px) {\n    right: 25px;\n  }\n"])));
var TitleText = styled.span(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteralLoose(["\ntext-decoration: underline;\ncolor: #0088cc;\n"])));
var TangleWoodModal = function TangleWoodModal(props) {
  var _useState = useState(props === null || props === void 0 ? void 0 : props.tangleWoodFlag),
    openTanglewoodPopup = _useState[0];
  var handleOpenedChange = function handleOpenedChange() {
    console.log("handleChangeBefore1");
    if (window._dg_channelId === "VZW-MFA") {
      var mvaParam = {
        "actionType": "openPage",
        "pageType": "myFeed"
      };
      invokeNative(JSON.stringify(mvaParam));
    } else {
      console.log("handleChangeBefore2");
      window.open("/digital/nsa/secure/ui/udb/", "_self");
      console.log("handleChangeBefore3");
    }
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Modal$1, {
    opened: openTanglewoodPopup,
    surface: "light",
    fullScreenDialog: false,
    id: "tanglewoodOverlay",
    disableAnimation: false,
    expandModal: false,
    disableOutsideClick: true,
    ariaLabel: "Testing Modal",
    closeButton: /*#__PURE__*/React__default.createElement(TangelwoodCloseButton, {
      "data-analyticstrack": "overlay-generic-cta",
      onClick: handleOpenedChange
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      tabIndex: "-1",
      id: "closeModal",
      name: "close",
      size: "large",
      color: "#000000",
      backgroundColor: "transparent"
    }), ' ')
  }, /*#__PURE__*/React__default.createElement(ModalTitle, null, "Alert!"), /*#__PURE__*/React__default.createElement(ModalBody$1, null, /*#__PURE__*/React__default.createElement("div", null, "Troubleshooting is currently disabled for your device type. Please call ", /*#__PURE__*/React__default.createElement(TitleText, null, "1-800-922-0204"), " for further assistance.")), /*#__PURE__*/React__default.createElement(ModalFooter$1, null, /*#__PURE__*/React__default.createElement(ButtonGroup$1, {
    childWidth: '100%',
    viewport: 'desktop',
    rowQuantity: {
      desktop: 2
    },
    data: [{
      children: 'Go Back',
      size: 'large',
      use: 'primary',
      onClick: handleOpenedChange
    }]
  }))));
};

var _templateObject$r, _templateObject2$m, _templateObject3$j, _templateObject4$j, _templateObject5$h, _templateObject6$e;
var GridContainerMain = styled.div(_templateObject$r || (_templateObject$r = _taggedTemplateLiteralLoose(["\n    display: grid;\n    gap: 24px;\n    grid-template-columns: 1fr 1fr 1fr;\n    margin-bottom: 48px;\n    @media (max-width: 1024px) {\n   grid-template-columns: repeat(2, 1fr); }\n    }\n    @media(max-width: 600px){\n        grid-template-columns: 1fr;\n        gap:12px\n        }\n    "])));
var GridContainerCatagories = styled.div(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteralLoose(["\n    display: grid;\n    gap: 24px;\n    grid-template-columns: 1fr 1fr 1fr;\n    @media (max-width: 1024px) {\n   grid-template-columns: repeat(2, 1fr); }\n    }\n    @media(max-width: 600px){\n        grid-template-columns: 1fr;\n        gap:12px\n        }\n    "])));
var FlexContainer = styled.div(_templateObject3$j || (_templateObject3$j = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n"])));
var TopPadder = styled.div(_templateObject4$j || (_templateObject4$j = _taggedTemplateLiteralLoose(["\n  padding-bottom: 8px;\n      @media(max-width: 600px){\n        padding-bottom: 8px;\n        }\n"])));
var AccordionstyleWrapper = styled.article(_templateObject5$h || (_templateObject5$h = _taggedTemplateLiteralLoose(["\n[class*=AccordionWrapper-VDS]{\ndisplay:block !important;\n}\n[class*=AccordionList-VDS]{\nwidth:808px !important;\n@media(min-width: 601px) and (max-width: 1024px) {\n    width:728px !important;\n}\n    @media (max-width: 600px) {\n    display: block !important;\n    width: auto !important;\n    }   \n\n}\n[class*=StyledAccordionItem-VDS] {\n  background-color: #F6F6F6 !important;\n  /* Override with higher specificity */\n  padding: 1.02px 24px !important;\n  border-radius: 12px !important;\n  margin-bottom: 24px !important;\n\n  @media (max-width: 600px) {\n    padding: 3px 24px !important;\n    margin-bottom: 16px !important;\n  }\n\n}\n[class*=StyledLine-VDS] {\n  height: 0px !important;\n\n}\n[class*=TriggerIconWrapper-VDS] {\n  margin-top: 1rem !important;\n\n  @media (max-width: 600px) {\n    margin-top: 0.5rem !important;\n  }\n}\n[class*=InnerElementWrapper-VDS] {\n  padding-top: 21px !important;\n  padding-bottom: 21px !important;\n\n  @media (max-width: 600px) {\n    padding-top: 11px !important;\n    padding-bottom: 11px !important;\n  }\n}\n  \n"])));
var TitleNameWrap = styled.div(_templateObject6$e || (_templateObject6$e = _taggedTemplateLiteralLoose(["\n[class*=Icon-Alignment]{\n@media (max-width: 360px) {\n    margin-left:28vw !important;\n  }\n@media (max-width: 380px) and (min-width: 361px) {\n     margin-left:32vw !important;\n}\n@media (max-width: 400px) and (min-width: 381px) {\n     margin-left:34vw !important;\n}\n@media (max-width: 429px) and (min-width: 401px) {\n    margin-left:38vw !important;\n}\n@media (max-width: 600px) and (min-width: 430px) {\n    margin-left:40vw !important;\n}\n}\n"])));
var TopIntentSectionRedesignDigital = function TopIntentSectionRedesignDigital(_ref) {
  var _window, _window$selectedProdu, _notResumeIntents, _proiritizedIntents, _notResumeIntents2, _TotalIntentsData$cat, _proiritizedIntents2, _proiritizedIntents3, _proiritizedIntents4, _notResumeIntents3;
  var resumeIntent = _ref.resumeIntent,
    suggestIntent = _ref.suggestIntent,
    TotalIntentsData = _ref.TotalIntentsData,
    AIGeneragedIntents = _ref.AIGeneragedIntents,
    notResumeIntents = _ref.notResumeIntents,
    handleSymptomSelect = _ref.handleSymptomSelect,
    detectedIntent = _ref.detectedIntent;
  var _useState = useState(false),
    isExpanded = _useState[0],
    setIsExpanded = _useState[1];
  var _useState2 = useState({}),
    Accordionexpanded = _useState2[0],
    setAccordionExpanded = _useState2[1];
  useEffect(function () {
    var data = document.querySelectorAll('div[id="grid"] div[role="button"]');
    var focusData = document.querySelector('button[aria-label="Show Less"]');
    if (focusData) {
      data[6].focus();
    }
  }, [isExpanded]);
  var _useMediaQuery = useMediaQuery(),
    isMobile = _useMediaQuery.isMobile,
    isDesktop = _useMediaQuery.isDesktop,
    isTablet = _useMediaQuery.isTablet;
  var healthCheckEligibleDevice = (_window = window) === null || _window === void 0 ? void 0 : (_window$selectedProdu = _window.selectedProductType) === null || _window$selectedProdu === void 0 ? void 0 : _window$selectedProdu.toLowerCase().includes('smartphone');
  var proiritizedIntents = [];
  var vzdlObj = window.vzdl;
  proiritizedIntents = [].concat(detectedIntent || [], resumeIntent || [], suggestIntent || []);
  window.resumeIntent = resumeIntent;
  window.suggestIntent = suggestIntent;
  var totalIntents = ((_notResumeIntents = notResumeIntents) === null || _notResumeIntents === void 0 ? void 0 : _notResumeIntents.length) + ((_proiritizedIntents = proiritizedIntents) === null || _proiritizedIntents === void 0 ? void 0 : _proiritizedIntents.length);
  var defaultVisibleIntent = healthCheckEligibleDevice ? 5 : 6;
  var nonProiritizedIntentsLength = defaultVisibleIntent - proiritizedIntents.length;
  notResumeIntents = isExpanded ? notResumeIntents : (_notResumeIntents2 = notResumeIntents) === null || _notResumeIntents2 === void 0 ? void 0 : _notResumeIntents2.slice(0, nonProiritizedIntentsLength);
  useEffect(function () {
    var updateCoreDataTagging = function updateCoreDataTagging(taggingBadge, intentName) {
      window.coreData = window.coreData || [];
      window.coreData.push({
        task: "emit",
        event: "notify",
        params: {
          name: taggingBadge + "-" + intentName,
          message: ""
        }
      });
    };
    var badgearray = [];
    var updateVzdlPageDataTagging = function updateVzdlPageDataTagging(taggingBadge, intentName) {
      var _vzdlObj;
      badgearray.push("'" + taggingBadge + "-" + intentName + "'");
      var msgupdated = "{" + badgearray.join(", ") + "}";
      if ((_vzdlObj = vzdlObj) !== null && _vzdlObj !== void 0 && _vzdlObj.target) {
        vzdlObj.target.message = msgupdated;
      } else {
        vzdlObj = {
          target: {
            message: msgupdated
          }
        };
      }
      tagging.setPageView(vzdlObj, true);
    };
    setTimeout(function () {
      var _window$resumeIntent, _window$resumeIntent$, _window$suggestIntent, _window$suggestIntent2, _detectedIntent$, _window$tsFeatureFlag;
      ((_window$resumeIntent = window.resumeIntent) === null || _window$resumeIntent === void 0 ? void 0 : _window$resumeIntent.length) && updateCoreDataTagging("Resume", (_window$resumeIntent$ = window.resumeIntent[0]) === null || _window$resumeIntent$ === void 0 ? void 0 : _window$resumeIntent$.name);
      ((_window$suggestIntent = window.suggestIntent) === null || _window$suggestIntent === void 0 ? void 0 : _window$suggestIntent.length) && updateCoreDataTagging("Suggested", (_window$suggestIntent2 = window.suggestIntent[0]) === null || _window$suggestIntent2 === void 0 ? void 0 : _window$suggestIntent2.name);
      (detectedIntent === null || detectedIntent === void 0 ? void 0 : detectedIntent.length) && updateCoreDataTagging("Detected", (_detectedIntent$ = detectedIntent[0]) === null || _detectedIntent$ === void 0 ? void 0 : _detectedIntent$.name);
      if ((_window$tsFeatureFlag = window.tsFeatureFlags) !== null && _window$tsFeatureFlag !== void 0 && _window$tsFeatureFlag.newIntentAdditionFFlag) {
        var _window$resumeIntent2, _window$resumeIntent$2, _window$suggestIntent3, _window$suggestIntent4, _detectedIntent$2;
        ((_window$resumeIntent2 = window.resumeIntent) === null || _window$resumeIntent2 === void 0 ? void 0 : _window$resumeIntent2.length) && updateVzdlPageDataTagging("Resume", (_window$resumeIntent$2 = window.resumeIntent[0]) === null || _window$resumeIntent$2 === void 0 ? void 0 : _window$resumeIntent$2.name);
        ((_window$suggestIntent3 = window.suggestIntent) === null || _window$suggestIntent3 === void 0 ? void 0 : _window$suggestIntent3.length) && updateVzdlPageDataTagging("Suggested", (_window$suggestIntent4 = window.suggestIntent[0]) === null || _window$suggestIntent4 === void 0 ? void 0 : _window$suggestIntent4.name);
        (detectedIntent === null || detectedIntent === void 0 ? void 0 : detectedIntent.length) && updateVzdlPageDataTagging("Detected", (_detectedIntent$2 = detectedIntent[0]) === null || _detectedIntent$2 === void 0 ? void 0 : _detectedIntent$2.name);
        (AIGeneragedIntents === null || AIGeneragedIntents === void 0 ? void 0 : AIGeneragedIntents.length) && AIGeneragedIntents.forEach(function (issue) {
          updateCoreDataTagging("AI generated", issue.name);
          updateVzdlPageDataTagging("AI generated", issue.name);
        });
      }
    }, 10000);
  }, []);
  var handlehealthCheckTileClick = function handlehealthCheckTileClick() {
    var healthCheckUrl = TotalIntentsData === null || TotalIntentsData === void 0 ? void 0 : TotalIntentsData.healthCheckUrl;
    window.location.href = healthCheckUrl;
  };
  var accordionHandler = function accordionHandler(accordionId) {
    setAccordionExpanded(function (prevState) {
      return prevState === accordionId ? null : accordionId;
    });
  };
  var capitalizeFirstLetter = function capitalizeFirstLetter(str) {
    if (str === '' || typeof str !== 'string') {
      return str;
    }
    var firstLetter = str.charAt(0).toUpperCase();
    var restOfString = str.slice(1).toLowerCase();
    return firstLetter + restOfString;
  };
  var categoryLengthCheck = !window.fwaDevice && (TotalIntentsData === null || TotalIntentsData === void 0 ? void 0 : (_TotalIntentsData$cat = TotalIntentsData.categoryList) === null || _TotalIntentsData$cat === void 0 ? void 0 : _TotalIntentsData$cat.length) > 2;
  var intentCatagoriesFlag = !window.isLoggedOut && window.popularCategoriesFFlag || window.isLoggedOut && window.popularCategoriesUnauthFFlag;
  return /*#__PURE__*/React__default.createElement(Fragment, null, categoryLengthCheck && intentCatagoriesFlag && /*#__PURE__*/React__default.createElement(Fragment, null, ((_proiritizedIntents2 = proiritizedIntents) === null || _proiritizedIntents2 === void 0 ? void 0 : _proiritizedIntents2.length) > 0 && /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "16px 0 32px 0"
    }
  }, /*#__PURE__*/React__default.createElement(TitleLockup, {
    surface: "light",
    margin: "8px",
    data: {
      title: {
        primitive: 'span',
        bold: false,
        size: 'titleSmall',
        children: 'What we noticed:'
      }
    }
  })), /*#__PURE__*/React__default.createElement(GridContainerCatagories, {
    id: "grid"
  }, (_proiritizedIntents3 = proiritizedIntents) === null || _proiritizedIntents3 === void 0 ? void 0 : _proiritizedIntents3.map(function (intent, index) {
    var _intent$isFwa, _intent$isFwaIntentPa;
    return /*#__PURE__*/React__default.createElement(TileContainer$1, {
      padding: isDesktop ? '24px' : '16px',
      aspectRatio: "none",
      width: "auto",
      value: intent.id + "~" + intent.name + "~" + ((_intent$isFwa = intent === null || intent === void 0 ? void 0 : intent.isFwa) != null ? _intent$isFwa : false) + "~" + ((_intent$isFwaIntentPa = intent === null || intent === void 0 ? void 0 : intent.isFwaIntentPage) != null ? _intent$isFwaIntentPa : false) + "~" + (intent.detected ? "Detected" : intent.suggestedIntent && "Suggested"),
      ariaLabel: (intent.detected ? "Detected" : intent.suggestedIntent ? "Suggested" : "Resume") + " " + intent.name,
      "data-track": "{\"type\": \"link\", \"name\": \"" + (intent.detected ? "Detected-" : intent.suggestedIntent ? "Suggested-" : "Resume-") + intent.name + "\"}",
      "data-analyticstrack": "trbl-issue-radio",
      "data-testid": "tileContainer",
      "data-clickstream": "{" + intent.name + "-trbl-issue-radio}",
      onClick: function onClick() {
        var _intent$isFwa2, _intent$isFwaIntentPa2;
        return handleSymptomSelect(intent.id + "~" + intent.name + "~" + ((_intent$isFwa2 = intent === null || intent === void 0 ? void 0 : intent.isFwa) != null ? _intent$isFwa2 : false) + "~" + ((_intent$isFwaIntentPa2 = intent === null || intent === void 0 ? void 0 : intent.isFwaIntentPage) != null ? _intent$isFwaIntentPa2 : false), intent, "TileClick");
      },
      onKeyPress: function onKeyPress() {
        var _intent$isFwa3, _intent$isFwaIntentPa3;
        return handleSymptomSelect(intent.id + "~" + intent.name + "~" + ((_intent$isFwa3 = intent === null || intent === void 0 ? void 0 : intent.isFwa) != null ? _intent$isFwa3 : false) + "~" + ((_intent$isFwaIntentPa3 = intent === null || intent === void 0 ? void 0 : intent.isFwaIntentPage) != null ? _intent$isFwaIntentPa3 : false), intent, "TileClick");
      }
    }, /*#__PURE__*/React__default.createElement(FlexContainer, {
      style: {
        "min-height": isMobile ? "58px" : "72px"
      }
    }, /*#__PURE__*/React__default.createElement(TopPadder, {
      "data-testid": "badgeValue"
    }, /*#__PURE__*/React__default.createElement(Badge, {
      fillColor: "black",
      maxWidth: "120px"
    }, intent.detected ? "Detected" : intent.suggestedIntent ? "Suggested" : "Resume")), /*#__PURE__*/React__default.createElement(TitleLockup, {
      surface: "light",
      data: {
        title: {
          primitive: 'span',
          size: isMobile ? 'bodyMedium' : 'bodyLarge',
          children: capitalizeFirstLetter(intent.name)
        }
      }
    })));
  }))), categoryLengthCheck && intentCatagoriesFlag ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "24px 0 24px 0"
    }
  }, /*#__PURE__*/React__default.createElement(TitleLockup, {
    surface: "light",
    gap: "8px",
    data: {
      title: {
        primitive: 'span',
        bold: false,
        size: 'titleSmall',
        children: 'Browse for your issue:'
      }
    }
  })), /*#__PURE__*/React__default.createElement(HStack, {
    style: {
      display: "block",
      width: isMobile ? "auto" : isTablet ? "728px" : "808px"
    }
  }, /*#__PURE__*/React__default.createElement(AccordionstyleWrapper, null, /*#__PURE__*/React__default.createElement(Accordion$1, {
    surface: "light",
    topLine: false,
    bottomLine: false,
    type: "single",
    id: "accordion-container1"
  }, TotalIntentsData === null || TotalIntentsData === void 0 ? void 0 : TotalIntentsData.categoryList.map(function (category, index) {
    var _category$intentList;
    return (category === null || category === void 0 ? void 0 : (_category$intentList = category.intentList) === null || _category$intentList === void 0 ? void 0 : _category$intentList.length) > 0 && /*#__PURE__*/React__default.createElement(AccordionItem, {
      key: category.id,
      "data-track": "{\"type\": \"link\", \"name\": \"" + (category.name + "-") + (Accordionexpanded === category.id ? "Collapsed" : "Expanded") + "\"}"
    }, /*#__PURE__*/React__default.createElement(AccordionHeader, {
      id: "accordion-header1",
      "data-testid": "accordion-header1",
      trigger: {
        type: "icon",
        alignment: "top"
      },
      onClick: function onClick() {
        return accordionHandler(category.id);
      },
      bold: true
    }, /*#__PURE__*/React__default.createElement(AccordionTitle, null, /*#__PURE__*/React__default.createElement(TitleLockup, {
      data: {
        title: {
          primitive: 'span',
          size: isMobile ? 'bodyMedium' : 'bodyLarge',
          children: capitalizeFirstLetter(category.name)
        }
      }
    }))), /*#__PURE__*/React__default.createElement(AccordionDetail, {
      id: "accordion-details1"
    }, category.intentList.map(function (intent, index) {
      var _intent$isFwa4, _intent$isFwaIntentPa4;
      return /*#__PURE__*/React__default.createElement(Stack, {
        style: {
          marginTop: isMobile ? "16px" : "24px"
        }
      }, /*#__PURE__*/React__default.createElement(TileContainer$1, {
        id: "Accordion-tileContainer",
        backgroundColor: "white",
        key: "" + index,
        padding: isDesktop ? '24px' : '16px',
        aspectRatio: "none",
        width: "auto",
        value: intent.id + "~" + intent.name + "~" + ((_intent$isFwa4 = intent === null || intent === void 0 ? void 0 : intent.isFwa) != null ? _intent$isFwa4 : false) + "~" + ((_intent$isFwaIntentPa4 = intent === null || intent === void 0 ? void 0 : intent.isFwaIntentPage) != null ? _intent$isFwaIntentPa4 : false),
        height: "68px",
        ariaLabel: "" + intent.name,
        "data-testid": "tileContainer2",
        "data-track": "{\"type\": \"link\", \"name\": \"" + (intent !== null && intent !== void 0 && intent.newAiIntent ? "AI generated-" : '') + (category.name + "-") + intent.name + "\"}",
        "data-analyticstrack": "trbl-issue-radio",
        "data-clickstream": "{" + intent.name + "-trbl-issue-radio}",
        onClick: function onClick() {
          var _intent$isFwa5, _intent$isFwaIntentPa5;
          return handleSymptomSelect(intent.id + "~" + intent.name + "~" + ((_intent$isFwa5 = intent === null || intent === void 0 ? void 0 : intent.isFwa) != null ? _intent$isFwa5 : false) + "~" + ((_intent$isFwaIntentPa5 = intent === null || intent === void 0 ? void 0 : intent.isFwaIntentPage) != null ? _intent$isFwaIntentPa5 : false), intent, "TileClick");
        },
        onKeyPress: function onKeyPress() {
          var _intent$isFwa6, _intent$isFwaIntentPa6;
          return handleSymptomSelect(intent.id + "~" + intent.name + "~" + ((_intent$isFwa6 = intent === null || intent === void 0 ? void 0 : intent.isFwa) != null ? _intent$isFwa6 : false) + "~" + ((_intent$isFwaIntentPa6 = intent === null || intent === void 0 ? void 0 : intent.isFwaIntentPage) != null ? _intent$isFwaIntentPa6 : false), intent, "TileClick");
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        id: "title-lockup1",
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React__default.createElement(TitleLockup, {
        surface: "light",
        gap: "8px",
        data: {
          title: {
            backgroundColor: "white",
            primitive: 'span',
            bold: false,
            size: isMobile ? 'bodyMedium' : 'bodyLarge',
            children: capitalizeFirstLetter(intent.name)
          }
        }
      }))));
    })));
  })))), /*#__PURE__*/React__default.createElement(HStack, {
    style: {
      width: isMobile ? "auto" : isTablet ? "728px" : "808px",
      marginBottom: isMobile ? "16px" : "24px"
    }
  }, healthCheckEligibleDevice && /*#__PURE__*/React__default.createElement(TileContainer$1, {
    padding: isDesktop ? '24px' : '16px',
    aspectRatio: "none",
    id: "tile-healthcheck}",
    height: isMobile ? "50px" : "68px",
    ariaLabel: "Run device health check to identify issue",
    "data-testid": "healthCheckTile",
    "data-track": "{\"type\": \"link\", \"name\": \"Run device health check to identify issue\"}",
    "data-analyticstrack": "trbl-issue-radio",
    "data-clickstream": "{Run device health check to identify issue-trbl-issue-radio}",
    onClick: function onClick() {
      handlehealthCheckTileClick();
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(TitleNameWrap, null, /*#__PURE__*/React__default.createElement(TitleLockup, {
    surface: "light",
    data: {
      title: {
        primitive: 'div',
        size: isMobile ? 'bodyMedium' : 'bodyLarge',
        children: /*#__PURE__*/React__default.createElement(HStack, {
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "nowrap"
        }, isMobile ? "Run device health check" : "Run device health check to identify issue", /*#__PURE__*/React__default.createElement(Stack, {
          className: "Icon-Alignment",
          marginLeft: ["", "349px", "422px"]
        }, /*#__PURE__*/React__default.createElement(Icon$1, {
          name: "right-arrow",
          size: "medium",
          color: "#000000"
        })))
      }
    }
  })))))) : /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(GridContainerMain, {
    id: "grid"
  }, (_proiritizedIntents4 = proiritizedIntents) === null || _proiritizedIntents4 === void 0 ? void 0 : _proiritizedIntents4.map(function (intent, index) {
    var _intent$isFwa7, _intent$isFwaIntentPa7;
    return /*#__PURE__*/React__default.createElement(TileContainer$1, {
      padding: isDesktop ? '24px' : '16px',
      aspectRatio: "none",
      width: "auto",
      value: intent.id + "~" + intent.name + "~" + ((_intent$isFwa7 = intent === null || intent === void 0 ? void 0 : intent.isFwa) != null ? _intent$isFwa7 : false) + "~" + ((_intent$isFwaIntentPa7 = intent === null || intent === void 0 ? void 0 : intent.isFwaIntentPage) != null ? _intent$isFwaIntentPa7 : false) + "~" + (intent.detected ? "Detected" : intent.suggestedIntent && "Suggested"),
      ariaLabel: (intent.detected ? "Detected" : intent.suggestedIntent ? "Suggested" : "Resume") + " " + intent.name,
      "data-track": "{\"type\": \"link\", \"name\": \"" + (intent.detected ? "Detected-" : intent.suggestedIntent ? "Suggested-" : "Resume-") + intent.name + "\"}",
      "data-analyticstrack": "trbl-issue-radio",
      "data-testid": "tileContainer",
      "data-clickstream": "{" + intent.name + "-trbl-issue-radio}",
      onClick: function onClick() {
        var _intent$isFwa8, _intent$isFwaIntentPa8;
        return handleSymptomSelect(intent.id + "~" + intent.name + "~" + ((_intent$isFwa8 = intent === null || intent === void 0 ? void 0 : intent.isFwa) != null ? _intent$isFwa8 : false) + "~" + ((_intent$isFwaIntentPa8 = intent === null || intent === void 0 ? void 0 : intent.isFwaIntentPage) != null ? _intent$isFwaIntentPa8 : false), intent, "TileClick");
      },
      onKeyPress: function onKeyPress() {
        var _intent$isFwa9, _intent$isFwaIntentPa9;
        return handleSymptomSelect(intent.id + "~" + intent.name + "~" + ((_intent$isFwa9 = intent === null || intent === void 0 ? void 0 : intent.isFwa) != null ? _intent$isFwa9 : false) + "~" + ((_intent$isFwaIntentPa9 = intent === null || intent === void 0 ? void 0 : intent.isFwaIntentPage) != null ? _intent$isFwaIntentPa9 : false), intent, "TileClick");
      }
    }, /*#__PURE__*/React__default.createElement(FlexContainer, {
      style: {
        "min-height": isMobile ? "58px" : "72px"
      }
    }, /*#__PURE__*/React__default.createElement(TopPadder, {
      "data-testid": "badgeValue"
    }, /*#__PURE__*/React__default.createElement(Badge, {
      fillColor: "black",
      maxWidth: "120px"
    }, intent.detected ? "Detected" : intent.suggestedIntent ? "Suggested" : "Resume")), /*#__PURE__*/React__default.createElement(TitleLockup, {
      surface: "light",
      data: {
        title: {
          primitive: 'span',
          size: isMobile ? 'bodyMedium' : 'bodyLarge',
          children: capitalizeFirstLetter(intent.name)
        }
      }
    })));
  }), (_notResumeIntents3 = notResumeIntents) === null || _notResumeIntents3 === void 0 ? void 0 : _notResumeIntents3.map(function (intent, index) {
    var _intent$isFwa0, _intent$isFwaIntentPa0;
    return /*#__PURE__*/React__default.createElement(TileContainer$1, {
      key: "" + index,
      padding: isDesktop ? '24px' : '16px',
      aspectRatio: "none",
      width: "auto",
      value: intent.id + "~" + intent.name + "~" + ((_intent$isFwa0 = intent === null || intent === void 0 ? void 0 : intent.isFwa) != null ? _intent$isFwa0 : false) + "~" + ((_intent$isFwaIntentPa0 = intent === null || intent === void 0 ? void 0 : intent.isFwaIntentPage) != null ? _intent$isFwaIntentPa0 : false),
      height: isMobile ? "90px" : isTablet ? "104px" : "120px",
      ariaLabel: "" + intent.name,
      "data-testid": "tileContainer2",
      "data-track": "{\"type\": \"link\", \"name\": \"" + (intent !== null && intent !== void 0 && intent.newAiIntent ? "AI generated-" : '') + intent.name + "\"}",
      "data-analyticstrack": "trbl-issue-radio",
      "data-clickstream": "{" + intent.name + "-trbl-issue-radio}",
      onClick: function onClick() {
        var _intent$isFwa1, _intent$isFwaIntentPa1;
        return handleSymptomSelect(intent.id + "~" + intent.name + "~" + ((_intent$isFwa1 = intent === null || intent === void 0 ? void 0 : intent.isFwa) != null ? _intent$isFwa1 : false) + "~" + ((_intent$isFwaIntentPa1 = intent === null || intent === void 0 ? void 0 : intent.isFwaIntentPage) != null ? _intent$isFwaIntentPa1 : false), intent, "TileClick");
      },
      onKeyPress: function onKeyPress() {
        var _intent$isFwa10, _intent$isFwaIntentPa10;
        return handleSymptomSelect(intent.id + "~" + intent.name + "~" + ((_intent$isFwa10 = intent === null || intent === void 0 ? void 0 : intent.isFwa) != null ? _intent$isFwa10 : false) + "~" + ((_intent$isFwaIntentPa10 = intent === null || intent === void 0 ? void 0 : intent.isFwaIntentPage) != null ? _intent$isFwaIntentPa10 : false), intent, "TileClick");
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React__default.createElement(TitleLockup, {
      surface: "light",
      data: {
        title: {
          primitive: 'span',
          size: isMobile ? 'bodyMedium' : 'bodyLarge',
          children: capitalizeFirstLetter(intent.name)
        }
      }
    })));
  }), !healthCheckEligibleDevice ? "" : /*#__PURE__*/React__default.createElement(TileContainer$1, {
    padding: isDesktop ? '24px' : '16px',
    aspectRatio: "none",
    id: "tile-healthcheck}",
    width: "auto",
    height: isMobile ? "90px" : isTablet ? "104px" : "120px",
    ariaLabel: "Run device health check to identify issue",
    "data-testid": "healthCheckTile",
    "data-track": "{\"type\": \"link\", \"name\": \"Run device health check to identify issue\"}",
    "data-analyticstrack": "trbl-issue-radio",
    "data-clickstream": "{Run device health check to identify issue-trbl-issue-radio}",
    onClick: function onClick() {
      handlehealthCheckTileClick();
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(TitleLockup, {
    surface: "light",
    data: {
      title: {
        primitive: 'span',
        size: isMobile ? 'bodyMedium' : 'bodyLarge',
        children: /*#__PURE__*/React__default.createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            gap: isMobile ? '18vw' : '16px'
          }
        }, "Run device health check to identify issue", /*#__PURE__*/React__default.createElement(Icon$1, {
          name: "right-arrow",
          size: "medium",
          color: "#000000"
        }))
      }
    }
  })))), totalIntents > defaultVisibleIntent && /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "48px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    size: "small",
    "data-testid": "button",
    ariaLabel: isExpanded ? "Show Less" : "Show More",
    style: {
      borderRadius: "24px"
    },
    use: "secondary",
    onClick: function onClick() {
      return setIsExpanded(!isExpanded);
    }
  }, isExpanded ? "Show Less" : "Show More"))));
};

var _templateObject$s, _templateObject2$n, _templateObject3$k, _templateObject4$k, _templateObject5$i, _templateObject6$f, _templateObject7$c, _templateObject8$c, _templateObject9$a, _templateObject0$8, _templateObject1$8;
var DeviceImageContainerMobile = styled.div(_templateObject$s || (_templateObject$s = _taggedTemplateLiteralLoose(["\n  @media (max-width: 600px) {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    a {\n      margin-top: 0.5rem;\n      color: grey;\n    }\n  }\n  @media (min-width: 601px) and (max-width: 1024px) {\n    display: flex;\n    align-items: center;\n  }\n"])));
var DeviceImage$4 = styled.img(_templateObject2$n || (_templateObject2$n = _taggedTemplateLiteralLoose(["\ndisplay:flex !important;\nalign-items:center !important;\nmargin-bottom: 0px;\n"])));
var SearchContainer = styled.div(_templateObject3$k || (_templateObject3$k = _taggedTemplateLiteralLoose(["\n  @media (min-width: 601px) {\n    align-items: flex-start;\n    justify-content: center;\n  }\n\n   @media (max-width: 600px) {\n    align-items: center;\n    flex-direction: column;\n  }\n\n  width: 100%;\n"])));
var TechCoachBody$3 = styled.p(_templateObject4$k || (_templateObject4$k = _taggedTemplateLiteralLoose(["\n  margin-top: 1rem;\n"])));
var Devicedesktop = styled.div(_templateObject5$i || (_templateObject5$i = _taggedTemplateLiteralLoose(["\n display:flex !important;\n align-items:center !important;\n\n"])));
var CloseIconWrapper$3 = styled.div(_templateObject6$f || (_templateObject6$f = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  width: 3rem;\n  height: 3rem;\n  display: flex;\n  -webkit-box-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  align-items: center;\n  z-index: 1;\n"])));
var CloseButtonIconContainer$3 = styled.div(_templateObject7$c || (_templateObject7$c = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 2rem;\n  height: 2rem;\n"])));
var CloseButton$4 = styled.button(_templateObject8$c || (_templateObject8$c = _taggedTemplateLiteralLoose(["\n  display: flex;\n  -webkit-box-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  align-items: center;\n  padding: 0px;\n  margin: 0px;\n  cursor: pointer;\n  box-sizing: border-box;\n  text-align: center;\n  text-decoration: none;\n  position: relative;\n  touch-action: manipulation;\n  pointer-events: auto;\n  vertical-align: middle;\n  outline: none;\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  border-radius: 50%;\n  border: none;\n  background-clip: padding-box;\n  transition: all 0.1s ease-out 0s;\n"])));
var CloseButtonHitArea$3 = styled.span(_templateObject9$a || (_templateObject9$a = _taggedTemplateLiteralLoose(["\n  height: 2.75rem;\n  width: 2.75rem;\n  display: inline-block;\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  text-align: center;\n  transform: translate(-50%, -50%);\n"])));
var IconContainer$3 = styled.span(_templateObject0$8 || (_templateObject0$8 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  -webkit-box-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  justify-content: center;\n  left: 0px;\n  bottom: 0px;\n  pointer-events: none;\n"])));
var CloseIconSVG$3 = styled.svg(_templateObject1$8 || (_templateObject1$8 = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  height: 1.25rem;\n  width: 1.25rem;\n  min-height: 1.25rem;\n  min-width: 1.25rem;\n"])));
var isFwaFlow;
var selectedSymptomId;
var IssueSelectorRedesignDigital = function IssueSelectorRedesignDigital(props) {
  var _configDetails$params, _configDetails$params2, _configDetails$config, _allIntentsData$categ, _outageInfo$data, _allIntentsData$class, _window, _window$selectedProdu, _allIntentsData$topIn, _resumeIntent, _allIntentsData$topIn2, _allIntentsData$topIn3, _window$tsFeatureFlag, _allIntentsData$topIn4, _resumeIntent2, _resumeIntent3, _detectedIntent4, _suggestedIntent2, _notResumeIntents, _window2, _window2$_dg_channelI;
  function getUrlVars(url) {
    var vars = {};
    var parts = url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      vars[key] = value;
    });
    return vars;
  }
  var queryString = getUrlVars(window.location.href);
  var _useMediaQuery = useMediaQuery(),
    isTablet = _useMediaQuery.isTablet,
    isDesktop = _useMediaQuery.isDesktop;
  var _useState = useState(false),
    intentError = _useState[0],
    setIntentError = _useState[1];
  console.log("comren CombinedSymptoms", props);
  var configDetails = useContext(ConfigContext);
  var combinedIssueSelector = configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : _configDetails$params.combinedIssueSelector;
  var channel = configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params2 = configDetails.paramsDetails) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.channel;
  var tangleWoodFlag = configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config = configDetails.config) === null || _configDetails$config === void 0 ? void 0 : _configDetails$config.tangleWoodFlag;
  var _props$functions = props.functions,
    functions = _props$functions === void 0 ? {} : _props$functions,
    _props$values = props.values,
    values = _props$values === void 0 ? {} : _props$values,
    _props$allIntentsData = props.allIntentsData,
    allIntentsData = _props$allIntentsData === void 0 ? {} : _props$allIntentsData,
    _props$pendingCases = props.pendingCases,
    pendingCases = _props$pendingCases === void 0 ? {} : _props$pendingCases;
  var intentCatagoriesFlag = !window.isLoggedOut && window.popularCategoriesFFlag || window.isLoggedOut && window.popularCategoriesUnauthFFlag;
  var categoryLengthCheck = !window.fwaDevice && ((_allIntentsData$categ = allIntentsData.categoryList) === null || _allIntentsData$categ === void 0 ? void 0 : _allIntentsData$categ.length) > 2;
  var fourGLte = JSON.parse(sessionStorage.getItem("fourGLte"));
  console.log(sessionStorage.getItem("fourGLte"));
  sessionStorage.removeItem("fourGLte");
  if (values.landingInfo.fourgLtesymptomSelector && fourGLte) {
    values.landingInfo.symptomSelector = values.landingInfo.fourgLtesymptomSelector;
  }
  var _values$landingInfo = values.landingInfo,
    landingInfo = _values$landingInfo === void 0 ? {} : _values$landingInfo,
    _values$outageInfo = values.outageInfo,
    outageInfo = _values$outageInfo === void 0 ? {} : _values$outageInfo;
  var _landingInfo$device = landingInfo.device,
    device = _landingInfo$device === void 0 ? {} : _landingInfo$device;
  var _values$symptomId = values.symptomId,
    symptomId = _values$symptomId === void 0 ? "" : _values$symptomId,
    _values$symptom = values.symptom,
    symptom = _values$symptom === void 0 ? {} : _values$symptom;
  var _device$imageUrl = device.imageUrl,
    imageUrl = _device$imageUrl === void 0 ? "" : _device$imageUrl,
    is5GDevice = device.is5GDevice;
  var data = (_outageInfo$data = outageInfo === null || outageInfo === void 0 ? void 0 : outageInfo.data) != null ? _outageInfo$data : {};
  var _pendingCases$intentN = pendingCases.intentName,
    intentName = _pendingCases$intentN === void 0 ? "" : _pendingCases$intentN,
    _pendingCases$trouble = pendingCases.troubleshootingUrl,
    troubleshootingUrl = _pendingCases$trouble === void 0 ? "" : _pendingCases$trouble;
  var intentList = allIntentsData === null || allIntentsData === void 0 ? void 0 : (_allIntentsData$class = allIntentsData.classList) === null || _allIntentsData$class === void 0 ? void 0 : _allIntentsData$class.map(function (o) {
    return o.intentList;
  });
  var intentListArray = intentList === null || intentList === void 0 ? void 0 : intentList.flat();
  var healthCheckEligibleDevice = (_window = window) === null || _window === void 0 ? void 0 : (_window$selectedProdu = _window.selectedProductType) === null || _window$selectedProdu === void 0 ? void 0 : _window$selectedProdu.toLowerCase().includes('smartphone');
  var resumeIntent = [];
  var suggestedIntent = [];
  var notResumeIntents = [];
  var detectedIntent = [];
  var AIGeneragedIntents = [];
  var resumeRef = useRef(0);
  var suggestedRef = useRef(0);
  detectedIntent = allIntentsData === null || allIntentsData === void 0 ? void 0 : (_allIntentsData$topIn = allIntentsData.topIntents) === null || _allIntentsData$topIn === void 0 ? void 0 : _allIntentsData$topIn.filter(function (o) {
    return o === null || o === void 0 ? void 0 : o.detected;
  });
  resumeIntent = intentListArray === null || intentListArray === void 0 ? void 0 : intentListArray.filter(function (o) {
    var _o$name, _o$name2, _detectedIntent, _detectedIntent$;
    return (o === null || o === void 0 ? void 0 : (_o$name = o.name) === null || _o$name === void 0 ? void 0 : _o$name.toLowerCase()) === (intentName === null || intentName === void 0 ? void 0 : intentName.toLowerCase()) && (o === null || o === void 0 ? void 0 : (_o$name2 = o.name) === null || _o$name2 === void 0 ? void 0 : _o$name2.toLowerCase()) !== ((_detectedIntent = detectedIntent) === null || _detectedIntent === void 0 ? void 0 : (_detectedIntent$ = _detectedIntent[0]) === null || _detectedIntent$ === void 0 ? void 0 : _detectedIntent$.name.toLowerCase());
  });
  if ((_resumeIntent = resumeIntent) !== null && _resumeIntent !== void 0 && _resumeIntent.length) {
    resumeIntent[0].resumeIntent = true;
  }
  suggestedIntent = allIntentsData === null || allIntentsData === void 0 ? void 0 : (_allIntentsData$topIn2 = allIntentsData.topIntents) === null || _allIntentsData$topIn2 === void 0 ? void 0 : _allIntentsData$topIn2.filter(function (o) {
    var _o$name3, _detectedIntent2, _detectedIntent2$, _detectedIntent2$$nam, _o$name4;
    return (o === null || o === void 0 ? void 0 : o.suggestedIntent) && !(o !== null && o !== void 0 && o.detected) && (o === null || o === void 0 ? void 0 : (_o$name3 = o.name) === null || _o$name3 === void 0 ? void 0 : _o$name3.toLowerCase()) !== ((_detectedIntent2 = detectedIntent) === null || _detectedIntent2 === void 0 ? void 0 : (_detectedIntent2$ = _detectedIntent2[0]) === null || _detectedIntent2$ === void 0 ? void 0 : (_detectedIntent2$$nam = _detectedIntent2$.name) === null || _detectedIntent2$$nam === void 0 ? void 0 : _detectedIntent2$$nam.toLowerCase()) && (o === null || o === void 0 ? void 0 : (_o$name4 = o.name) === null || _o$name4 === void 0 ? void 0 : _o$name4.toLowerCase()) !== (intentName === null || intentName === void 0 ? void 0 : intentName.toLowerCase());
  });
  notResumeIntents = allIntentsData === null || allIntentsData === void 0 ? void 0 : (_allIntentsData$topIn3 = allIntentsData.topIntents) === null || _allIntentsData$topIn3 === void 0 ? void 0 : _allIntentsData$topIn3.filter(function (o) {
    var _o$name5, _o$name6, _detectedIntent3, _detectedIntent3$, _detectedIntent3$$nam, _o$name7, _suggestedIntent, _suggestedIntent$, _suggestedIntent$$nam;
    return (o === null || o === void 0 ? void 0 : (_o$name5 = o.name) === null || _o$name5 === void 0 ? void 0 : _o$name5.toLowerCase()) !== (intentName === null || intentName === void 0 ? void 0 : intentName.toLowerCase()) && (o === null || o === void 0 ? void 0 : (_o$name6 = o.name) === null || _o$name6 === void 0 ? void 0 : _o$name6.toLowerCase()) !== ((_detectedIntent3 = detectedIntent) === null || _detectedIntent3 === void 0 ? void 0 : (_detectedIntent3$ = _detectedIntent3[0]) === null || _detectedIntent3$ === void 0 ? void 0 : (_detectedIntent3$$nam = _detectedIntent3$.name) === null || _detectedIntent3$$nam === void 0 ? void 0 : _detectedIntent3$$nam.toLowerCase()) && (o === null || o === void 0 ? void 0 : (_o$name7 = o.name) === null || _o$name7 === void 0 ? void 0 : _o$name7.toLowerCase()) !== ((_suggestedIntent = suggestedIntent) === null || _suggestedIntent === void 0 ? void 0 : (_suggestedIntent$ = _suggestedIntent[0]) === null || _suggestedIntent$ === void 0 ? void 0 : (_suggestedIntent$$nam = _suggestedIntent$.name) === null || _suggestedIntent$$nam === void 0 ? void 0 : _suggestedIntent$$nam.toLowerCase()) && !o.suggestedIntent && !o.detected;
  });
  AIGeneragedIntents = ((_window$tsFeatureFlag = window.tsFeatureFlags) === null || _window$tsFeatureFlag === void 0 ? void 0 : _window$tsFeatureFlag.newIntentAdditionFFlag) && (allIntentsData === null || allIntentsData === void 0 ? void 0 : (_allIntentsData$topIn4 = allIntentsData.topIntents) === null || _allIntentsData$topIn4 === void 0 ? void 0 : _allIntentsData$topIn4.filter(function (o) {
    return o === null || o === void 0 ? void 0 : o.newAiIntent;
  }));
  var resumeIntentPart = ((_resumeIntent2 = resumeIntent) === null || _resumeIntent2 === void 0 ? void 0 : _resumeIntent2.length) > 0 ? (_resumeIntent3 = resumeIntent) === null || _resumeIntent3 === void 0 ? void 0 : _resumeIntent3.slice(0, 1) : resumeIntent;
  var extraIntentLength = '';
  extraIntentLength = (resumeIntentPart === null || resumeIntentPart === void 0 ? void 0 : resumeIntentPart.length) + ((_detectedIntent4 = detectedIntent) === null || _detectedIntent4 === void 0 ? void 0 : _detectedIntent4.length) + ((_suggestedIntent2 = suggestedIntent) === null || _suggestedIntent2 === void 0 ? void 0 : _suggestedIntent2.length) + ((_notResumeIntents = notResumeIntents) === null || _notResumeIntents === void 0 ? void 0 : _notResumeIntents.length) - 12;
  var nonCategorizedIntent = [];
  if (healthCheckEligibleDevice && extraIntentLength >= 0) {
    var subval = extraIntentLength + 1;
    nonCategorizedIntent = notResumeIntents.slice(0, -subval);
  } else if (extraIntentLength > 0) {
    nonCategorizedIntent = notResumeIntents.slice(0, -extraIntentLength);
  } else {
    nonCategorizedIntent = notResumeIntents;
  }
  var isMVA = ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$_dg_channelI = _window2._dg_channelId) === null || _window2$_dg_channelI === void 0 ? void 0 : _window2$_dg_channelI.toLowerCase()) === "vzw-mfa" ? true : false;
  useEffect(function () {
    if (is5GDevice) {
      taggingSetPageValue("select issue");
      console.log("analytics : page : select issue");
    }
  }, [is5GDevice]);
  useEffect(function () {
    if (window.isMVODigital && isMVA) {
      var _configDetails$params3, _configDetails$params4;
      var title = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params3 = configDetails.paramsDetails) === null || _configDetails$params3 === void 0 ? void 0 : _configDetails$params3.deviceName) !== undefined ? (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params4 = configDetails.paramsDetails) === null || _configDetails$params4 === void 0 ? void 0 : _configDetails$params4.deviceName) + " troubleshooting assistant" : "troubleshooting assistant";
      nativeSetTitle(title);
      hideMvaChatBot();
    }
    if ((queryString === null || queryString === void 0 ? void 0 : queryString.flow) === "matchnotfound") {
      setIntentError(true);
    }
  }, []);
  var closeIntentError = function closeIntentError() {
    setIntentError(false);
  };
  var closeTechCoachPopup = function closeTechCoachPopup(e) {
    functions.updateValues(values, {
      techCoachEligiblity: _extends({}, values.techCoachEligiblity, {
        openPopup: false,
        openChatbotFlowPopup: false
      })
    });
    taggingSetCloseView("Help from tech coach expert", "#tech_coach_popup");
  };
  var handleTypeAheadSelect = function handleTypeAheadSelect(event, option, from) {
    try {
      var _option$isFwaIntentPa, _option$name;
      console.log("handleTypeAheadSelect", event, option, from);
      var element = {
        target: {
          value: option.id + "~" + option.name + "~" + option.isFwa + "~" + ((_option$isFwaIntentPa = option === null || option === void 0 ? void 0 : option.isFwaIntentPage) != null ? _option$isFwaIntentPa : false)
        }
      };
      functions.updateValues(values, {
        showTypeAhead: false
      });
      var isdetectedIntent = false;
      var isSuggestedIntent = false;
      if (option.suggestedIntent !== undefined && option.suggestedIntent !== "") {
        isSuggestedIntent = option.suggestedIntent;
      }
      if (option.detected !== undefined && option.detected !== "") {
        isdetectedIntent = option.detected;
      }
      if (option.suggestedIntent !== undefined && option.suggestedIntent !== "") {
        isSuggestedIntent = false;
      }
      if ((intentName === null || intentName === void 0 ? void 0 : intentName.toLowerCase()) === ((_option$name = option.name) === null || _option$name === void 0 ? void 0 : _option$name.toLowerCase()) && from === "TileClick" && !isdetectedIntent && !isSuggestedIntent) {
        if (functions.handleSymptomSelect) {
          functions.handleSymptomSelect(option.id, option.name);
        }
        window.open(troubleshootingUrl, "_self");
        return Promise.resolve();
      }
      return Promise.resolve(from == "TileClick" ? handleSymptomSelect(event, "TileClick") : handleSymptomSelect(element, "handleTypeAheadSelect")).then(function (_handleSymptomSelect) {
        var _window3, _window3$localStorage, _window4, _window4$vzdl, _configDetails$config2;
        _handleSymptomSelect;
        var isAccountEligibleForTechCoach = !!(allIntentsData !== null && allIntentsData !== void 0 && allIntentsData.techCoachEligible);
        var isSymptomElgibleForTechCoach = !!(option !== null && option !== void 0 && option.isTechCoachEligible);
        var openPopup = !!(allIntentsData !== null && allIntentsData !== void 0 && allIntentsData.techCoachEligible && option !== null && option !== void 0 && option.isTechCoachEligible);
        (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$localStorage = _window3.localStorage) === null || _window3$localStorage === void 0 ? void 0 : _window3$localStorage.setItem("selectedFromSearch", from == "TileClick" ? "n" : "y");
        var searchBox = document.querySelector("#searchbox");
        if ((_window4 = window) !== null && _window4 !== void 0 && (_window4$vzdl = _window4.vzdl) !== null && _window4$vzdl !== void 0 && _window4$vzdl.search) {
          window["vzdl"]["search"]["term"] = searchBox !== null && searchBox !== undefined ? searchBox.value : "";
        }
        if (isAccountEligibleForTechCoach && isSymptomElgibleForTechCoach && configDetails !== null && configDetails !== void 0 && (_configDetails$config2 = configDetails.config) !== null && _configDetails$config2 !== void 0 && _configDetails$config2.enableTechCoachinCIS) {
          functions.updateValues(values, {
            techCoachEligiblity: {
              accountElgible: isAccountEligibleForTechCoach,
              intentEligible: isSymptomElgibleForTechCoach,
              openChatbotFlowPopup: false,
              openPopup: openPopup
            },
            showTypeAhead: false
          });
        } else {
          functions.updateValues(values, {
            techCoachEligiblity: {
              accountElgible: isAccountEligibleForTechCoach,
              intentEligible: isSymptomElgibleForTechCoach,
              openChatbotFlowPopup: false,
              openPopup: openPopup
            },
            showTypeAhead: false
          });
          functions.handleNextPage(option.id, option.name, {
            isDirectFlow: false,
            combinedIssueSelector: true,
            isFwaFlow: option.isFwa,
            selectedSymptomId: selectedSymptomId
          });
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var handleSymptomSelect = function handleSymptomSelect(element, from) {
    try {
      var _window5, _window5$troubleShoot, _window5$troubleShoot2, _window5$troubleShoot3, _configDetails$config3, _configDetails$config4, _configDetails$config5, _configDetails$config6, _configDetails$config7, _configDetails$config8, _configDetails$config9, _configDetails$config0, _props$allIntentsData2, _configDetails$config1, _configDetails$config10, _configDetails$config11, _configDetails$config12, _configDetails$config13, _configDetails$config14, _configDetails$config15, _configDetails$config16, _props$allIntentsData3, _configDetails$config17, _configDetails$config18, _window6;
      var val = from == "handleTypeAheadSelect" ? element.target.value : element;
      var words = val.split("~");
      var _symptomId = words[0];
      var issueName = words[1];
      var isFwaIntentPage = words[3];
      var isFwa = words[2] == "true";
      isFwaFlow = isFwa;
      selectedSymptomId = _symptomId;
      if ((_window5 = window) !== null && _window5 !== void 0 && (_window5$troubleShoot = _window5.troubleShootingJson) !== null && _window5$troubleShoot !== void 0 && (_window5$troubleShoot2 = _window5$troubleShoot.ddata) !== null && _window5$troubleShoot2 !== void 0 && (_window5$troubleShoot3 = _window5$troubleShoot2.device) !== null && _window5$troubleShoot3 !== void 0 && _window5$troubleShoot3.is5GDevice) {
        window.troubleShootingJson.ddata.device.is5GDevice = isFwa;
      }
      var troubleshootingDevice = _extends({}, configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config3 = configDetails.config) === null || _configDetails$config3 === void 0 ? void 0 : (_configDetails$config4 = _configDetails$config3.troubleShootingJson) === null || _configDetails$config4 === void 0 ? void 0 : (_configDetails$config5 = _configDetails$config4.ddata) === null || _configDetails$config5 === void 0 ? void 0 : _configDetails$config5.device, {
        changeDevice: false,
        is5GDevice: isFwa,
        isFwa: isFwa
      });
      sessionStorage.setItem("troubleshootingDevice", JSON.stringify(troubleshootingDevice));
      var config = _extends({}, configDetails === null || configDetails === void 0 ? void 0 : configDetails.config, {
        troubleShootingJson: _extends({}, configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config6 = configDetails.config) === null || _configDetails$config6 === void 0 ? void 0 : _configDetails$config6.troubleShootingJson, {
          ddata: _extends({}, configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config7 = configDetails.config) === null || _configDetails$config7 === void 0 ? void 0 : (_configDetails$config8 = _configDetails$config7.troubleShootingJson) === null || _configDetails$config8 === void 0 ? void 0 : _configDetails$config8.ddata, {
            device: troubleshootingDevice
          })
        })
      });
      sessionStorage.setItem("mvoConfig", JSON.stringify(config));
      var troubleshootingDetails = {
        accountNumber: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config9 = configDetails.config) === null || _configDetails$config9 === void 0 ? void 0 : (_configDetails$config0 = _configDetails$config9.caseDetails) === null || _configDetails$config0 === void 0 ? void 0 : _configDetails$config0.accountNumber,
        caseId: (_props$allIntentsData2 = props.allIntentsData) === null || _props$allIntentsData2 === void 0 ? void 0 : _props$allIntentsData2.caseId,
        changeIssueUrl: "",
        channel: channel,
        custVerified: "N",
        deviceSku: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config1 = configDetails.config) === null || _configDetails$config1 === void 0 ? void 0 : (_configDetails$config10 = _configDetails$config1.troubleShootingJson) === null || _configDetails$config10 === void 0 ? void 0 : (_configDetails$config11 = _configDetails$config10.ddata) === null || _configDetails$config11 === void 0 ? void 0 : (_configDetails$config12 = _configDetails$config11.device) === null || _configDetails$config12 === void 0 ? void 0 : _configDetails$config12.deviceSku,
        equipmentId: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config13 = configDetails.config) === null || _configDetails$config13 === void 0 ? void 0 : (_configDetails$config14 = _configDetails$config13.troubleShootingJson) === null || _configDetails$config14 === void 0 ? void 0 : (_configDetails$config15 = _configDetails$config14.ddata) === null || _configDetails$config15 === void 0 ? void 0 : (_configDetails$config16 = _configDetails$config15.device) === null || _configDetails$config16 === void 0 ? void 0 : _configDetails$config16.equipmentId,
        intent: issueName,
        intentId: _symptomId,
        islogin: !window.isLoggedOut,
        mtn: (_props$allIntentsData3 = props.allIntentsData) === null || _props$allIntentsData3 === void 0 ? void 0 : _props$allIntentsData3.selectedMdn,
        mtnId: window.caseDetails.mtnId || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config17 = configDetails.config) === null || _configDetails$config17 === void 0 ? void 0 : (_configDetails$config18 = _configDetails$config17.caseDetails) === null || _configDetails$config18 === void 0 ? void 0 : _configDetails$config18.mtnId),
        tier: 1,
        tierId: 1,
        userId: "",
        isFwaIntentPage: isFwaIntentPage ? isFwaIntentPage : false
      };
      sessionStorage.setItem("troubleshootingDetails", JSON.stringify(troubleshootingDetails));
      if ((_window6 = window) !== null && _window6 !== void 0 && _window6.hlthFlow) {
        sessionStorage.setItem('deviceHealthData', JSON.stringify(_extends({}, JSON.parse(sessionStorage.getItem('deviceHealthData')), {
          intent: issueName,
          intentId: _symptomId,
          processStep: "resume",
          backButtonTrigger: true,
          isManualSelection: true
        })));
      }
      if (!window.caseDetails) {
        window.caseDetails = {};
      }
      window.caseDetails.intent = issueName;
      window.caseDetails.intentId = _symptomId;
      sessionStorage.setItem("nBSFlow", false);
      if (props.allIntentsData.nbxIntentIds) {
        var nbxIntentIdsArr = props.allIntentsData.nbxIntentIds.split(",");
        if (Array.isArray(nbxIntentIdsArr)) {
          var nBSFlow = nbxIntentIdsArr.includes(_symptomId);
          sessionStorage.setItem("nBSFlow", Boolean(nBSFlow));
        }
      }
      if (functions.handleSymptomSelect) {
        functions.handleSymptomSelect(_symptomId, issueName);
      }
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var handleStartTroubleshooting = function handleStartTroubleshooting() {
    functions.handleNextPage(symptomId, symptom.issueName, {
      isDirectFlow: false,
      combinedIssueSelector: true,
      isFwaFlow: isFwaFlow,
      selectedSymptomId: selectedSymptomId
    });
  };
  var renderSymptoms = function renderSymptoms() {
    var _props$values2, _configDetails$params5, _configDetails$params6, _window$tsFeatureFlag2, _configDetails$params7, _configDetails$params8, _configDetails$params9, _configDetails$params0, _window$tsFeatureFlag3, _configDetails$params1, _configDetails$params10, _configDetails$config19;
    var Mobileview = isMobile();
    var _props$values$techCoa = props === null || props === void 0 ? void 0 : (_props$values2 = props.values) === null || _props$values2 === void 0 ? void 0 : _props$values2.techCoachEligiblity,
      accountElgible = _props$values$techCoa.accountElgible,
      intentEligible = _props$values$techCoa.intentEligible,
      openPopup = _props$values$techCoa.openPopup;
    return /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Stack, {
      gap: ["24px", "32px", "32px"]
    }, is5GDevice && data.statusCode === "10" && /*#__PURE__*/React__default.createElement(Outage, {
      outageInfo: outageInfo
    }), intentError && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(IntentError, {
      values: intentError,
      closeFeedbackBar: closeIntentError
    }), /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "20px"
    })), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(HStack, {
      gap: "20px",
      alignItems: "center",
      justifyContent: "space-between",
      marginTop: ["8px", "16px", "16px"]
    }, Mobileview ? /*#__PURE__*/React__default.createElement(DeviceImageContainerMobile, null, /*#__PURE__*/React__default.createElement(DeviceImage$4, {
      alt: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params5 = configDetails.paramsDetails) === null || _configDetails$params5 === void 0 ? void 0 : _configDetails$params5.deviceName,
      title: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params6 = configDetails.paramsDetails) === null || _configDetails$params6 === void 0 ? void 0 : _configDetails$params6.deviceName,
      src: imageUrl !== "" && imageUrl !== null && imageUrl.indexOf("null") < 0 ? resizeImage(imageUrl) : "https://www.verizon.com/content/dam/support/images_support/troubleshooting_guide/odi/ODI.png",
      id: "DeviceImage",
      width: "48px",
      height: "58px"
    }), /*#__PURE__*/React__default.createElement(Stack, {
      style: {
        marginLeft: "8px"
      }
    }, /*#__PURE__*/React__default.createElement(Body, {
      size: "medium",
      primitive: "span",
      bold: true
    }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, (_window$tsFeatureFlag2 = window.tsFeatureFlags) !== null && _window$tsFeatureFlag2 !== void 0 && _window$tsFeatureFlag2.enableRemovePrepaidStringFFlag ? removeTextFromString(configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params7 = configDetails.paramsDetails) === null || _configDetails$params7 === void 0 ? void 0 : _configDetails$params7.deviceName, 'Prepaid') : "" + (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params8 = configDetails.paramsDetails) === null || _configDetails$params8 === void 0 ? void 0 : _configDetails$params8.deviceName))))) : /*#__PURE__*/React__default.createElement(Devicedesktop, null, /*#__PURE__*/React__default.createElement(DeviceImage$4, {
      alt: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params9 = configDetails.paramsDetails) === null || _configDetails$params9 === void 0 ? void 0 : _configDetails$params9.deviceName,
      title: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params0 = configDetails.paramsDetails) === null || _configDetails$params0 === void 0 ? void 0 : _configDetails$params0.deviceName,
      src: imageUrl !== "" && imageUrl !== null && imageUrl.indexOf("null") < 0 ? resizeImage(imageUrl) : "https://www.verizon.com/content/dam/support/images_support/troubleshooting_guide/odi/ODI.png",
      id: "DeviceImage",
      width: isTablet ? "56px" : "64px",
      height: isTablet ? "68px" : "79px"
    }), /*#__PURE__*/React__default.createElement(Stack, {
      marginLeft: ["0px", "12px", "24px"]
    }, /*#__PURE__*/React__default.createElement(TitleLockup, {
      data: {
        title: {
          primitive: 'span',
          bold: true,
          gap: '8px',
          size: 'titleSmall',
          children: /*#__PURE__*/React__default.createElement(TextWithHtml, null, (_window$tsFeatureFlag3 = window.tsFeatureFlags) !== null && _window$tsFeatureFlag3 !== void 0 && _window$tsFeatureFlag3.enableRemovePrepaidStringFFlag ? removeTextFromString(configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params1 = configDetails.paramsDetails) === null || _configDetails$params1 === void 0 ? void 0 : _configDetails$params1.deviceName, 'Prepaid') : "" + (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params10 = configDetails.paramsDetails) === null || _configDetails$params10 === void 0 ? void 0 : _configDetails$params10.deviceName))
        }
      }
    }))), /*#__PURE__*/React__default.createElement(VStack, {
      gap: "16px"
    }, /*#__PURE__*/React__default.createElement(TextLink, {
      type: "standAlone",
      ariaLabel: "Change device",
      size: isDesktop || isTablet ? "large" : "small",
      href: isMVA ? "/support/devices/?type=app" : "/support/devices"
    }, "Change device"))), /*#__PURE__*/React__default.createElement(Line$1, {
      type: "secondary"
    }), /*#__PURE__*/React__default.createElement(HStack, {
      gap: "20px",
      alignItems: "flex-start"
    }, /*#__PURE__*/React__default.createElement(VStack, {
      style: isDesktop ? {
        marginTop: "16px"
      } : isTablet ? {} : {
        marginTop: "8px"
      },
      gap: "16px",
      alignItems: "flex-start !important"
    }, /*#__PURE__*/React__default.createElement(TitleLockup, {
      data: {
        title: {
          bold: false,
          size: 'titleXLarge',
          children: 'What issue are you experiencing?'
        }
      }
    })))), /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Stack, {
      width: ["100%"]
    }, /*#__PURE__*/React__default.createElement(TopIntentSectionRedesignDigital, {
      resumeIntent: resumeIntentPart,
      suggestIntent: suggestedIntent,
      TotalIntentsData: allIntentsData,
      AIGeneragedIntents: AIGeneragedIntents,
      topIntentsData: allIntentsData.topIntents,
      notResumeIntents: nonCategorizedIntent,
      handleSymptomSelect: handleTypeAheadSelect,
      detectedIntent: detectedIntent
    }), /*#__PURE__*/React__default.createElement(SearchContainer, null, categoryLengthCheck && intentCatagoriesFlag ? "" : /*#__PURE__*/React__default.createElement(Box, {
      marginBottom: "3px"
    }, /*#__PURE__*/React__default.createElement(Body, {
      tabIndex: "-1"
    }, "Tell us what\u2019s going on")), /*#__PURE__*/React__default.createElement(SearchBar$3, {
      functions: functions,
      values: values,
      Catagories: allIntentsData === null || allIntentsData === void 0 ? void 0 : allIntentsData.categoryList,
      combinedIssueSelector: combinedIssueSelector,
      handleTypeAheadSelect: handleTypeAheadSelect,
      topSearchData: allIntentsData.topSearchKeywords,
      placeholder: intentCatagoriesFlag && categoryLengthCheck ? "Search all issues" : "Search for a different issue",
      mvaSearchBox: true
    })), /*#__PURE__*/React__default.createElement(Line$1, {
      type: "secondary",
      style: {
        margin: "48px 0 32px 0"
      },
      color: "#D8DADA"
    }), /*#__PURE__*/React__default.createElement(Title, {
      tabIndex: -1,
      color: "#D8DADA",
      size: "large"
    }, "Troubleshoot issue"), /*#__PURE__*/React__default.createElement(Line$1, {
      type: "secondary",
      style: {
        marginTop: "32px"
      },
      color: "#D8DADA"
    })))), (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config19 = configDetails.config) === null || _configDetails$config19 === void 0 ? void 0 : _configDetails$config19.enableTechCoachinCIS) && /*#__PURE__*/React__default.createElement(Modal$1, {
      surface: "light",
      fullScreenDialog: false,
      disableAnimation: window._dg_channelId === "VZW-MFA" ? true : false,
      disableOutsideClick: false,
      ariaLabel: "Tech coach help",
      onOpenedChange: function onOpenedChange(status) {
        if (status) {
          taggingSetOpenView("Help from tech coach expert", "#tech_coach_popup");
        }
      },
      opened: !!(accountElgible && intentEligible && openPopup),
      id: "tech_coach_popup",
      closeButton: /*#__PURE__*/React__default.createElement(CloseIconWrapper$3, null, /*#__PURE__*/React__default.createElement(CloseButtonIconContainer$3, null, /*#__PURE__*/React__default.createElement(CloseButton$4, {
        onClick: closeTechCoachPopup
      }, /*#__PURE__*/React__default.createElement(CloseButtonHitArea$3, null), /*#__PURE__*/React__default.createElement(IconContainer$3, null, /*#__PURE__*/React__default.createElement(CloseIconSVG$3, {
        role: "img",
        "aria-hidden": "false",
        "aria-label": "close icon",
        viewBox: "0 0 21.6 21.6"
      }, /*#__PURE__*/React__default.createElement("title", null, "close icon"), /*#__PURE__*/React__default.createElement("path", {
        d: "M11.59,10.8l7.11,7.1-.8.8-7.1-7.11L3.7,18.7l-.8-.8L10,10.8,2.9,3.7l.8-.8L10.8,10,17.9,2.9l.8.8Z",
        stroke: "none",
        fill: "#000000"
      }))))))
    }, /*#__PURE__*/React__default.createElement(ModalTitle, null, "Do you want help from a Tech Coach expert?"), /*#__PURE__*/React__default.createElement(ModalBody$1, {
      children: /*#__PURE__*/React__default.createElement("div", {
        className: "tech_coach_popup_body"
      }, /*#__PURE__*/React__default.createElement(TechCoachBody$3, null, "You're enrolled in device protection, with 24/7 access to an expert who can help you resolve your issue."), /*#__PURE__*/React__default.createElement(TechCoachBody$3, null, "You can also continue troubleshooting on your own."))
    }), /*#__PURE__*/React__default.createElement(ModalFooter$1, null, /*#__PURE__*/React__default.createElement(ButtonGroup$1, {
      childWidth: "100%",
      rowQuantity: {
        desktop: 2,
        tablet: 2,
        mobile: 1
      },
      data: [{
        children: 'Chat with Tech Coach',
        size: 'large',
        use: 'primary',
        width: isMobile() ? '100%' : "250px",
        "data-analyticstrack": "chat_with_tech_coach_cta",
        "data-track": "{type: button, name: Chat with Tech Coach}",
        onClick: function onClick() {
          var target = isMVA ? "_self" : "_blank";
          window.open("https://my.asurion.com/device-care/chat?utm=vz_troubleshoot&mxclient=verizon&cid=chat", target, "noopener");
        }
      }, {
        children: "Troubleshoot",
        "data-analyticstrack": "tech_coach_troubleshoot_cta",
        "data-track": "{type: button, name: Troubleshoot - Tech Coach}",
        onClick: function onClick() {
          handleStartTroubleshooting();
        },
        size: 'large',
        use: 'secondary',
        width: isMobile() ? '100%' : "250px"
      }],
      alignment: 'center'
    }))));
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, tangleWoodFlag ? /*#__PURE__*/React__default.createElement(TangleWoodModal, {
    tangleWoodFlag: tangleWoodFlag
  }) : renderSymptoms());
};
IssueSelectorRedesignDigital.propTypes = {
  functions: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
};
IssueSelectorRedesignDigital.defaultProps = {};

var CombinedSymptoms = function CombinedSymptoms(props) {
  return /*#__PURE__*/React__default.createElement(IssueSelectorRedesignDigital, props);
};

var _templateObject$t, _templateObject2$o, _templateObject3$l, _templateObject4$l, _templateObject5$j, _templateObject6$g, _templateObject7$d, _templateObject8$d, _templateObject9$b, _templateObject0$9, _templateObject1$9, _templateObject10$6, _templateObject11$5, _templateObject12$4, _templateObject13$4, _templateObject14$4, _templateObject15$4, _templateObject16$4, _templateObject17$4, _templateObject18$4, _templateObject19$4, _templateObject20$4;
var mvoConfig$5 = sessionUtility.getMvoConfig();
var CloseButton$5 = styled.div(_templateObject$t || (_templateObject$t = _taggedTemplateLiteralLoose(["\nmargin-top: -35px; \nmargin-bottom: 10px;\nposition: relative;\nleft: 475px;\n@media screen and (max-width: 568px) {  \n  margin-top: 20px;\n  z-index: 999;\n  }\n"])));
var Modal = styled.div(_templateObject2$o || (_templateObject2$o = _taggedTemplateLiteralLoose(["\n  background-color:rgba(0,0,0,0.5);\n  display: flex;\n  align-items: flex-start;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  z-index: 1000;\n  @media(max-width:600px){\n    padding: 0;\n  }\n"])));
var ErrorBox = styled.div(_templateObject3$l || (_templateObject3$l = _taggedTemplateLiteralLoose([" \n  position:absolute;\n  left:50%;\n  top:50%;\n  transform: translate(-50%,-50%) \n"])));
var SpinnerM = styled.div(_templateObject4$l || (_templateObject4$l = _taggedTemplateLiteralLoose([" \n  border-top :3.7px solid black;\n  border-left :3.7px solid black; \n  border-right :3.7px solid black;  \n  border-bottom:3.7px solid white;\n  position:absolute;\n  width:35px;\n  height:35px;\n  left:47%;\n  top:50%;\n  border-radius:50%;\n  transform: translate(-50%,-50%);\n  animation: spin 2s linear infinite;\n  @keyframes spin {\n    0% {transform: rotate(0deg);}\n    100% {transform: rotate(360deg)}\n  }\n"])));
var StyledIcon = styled.i(_templateObject5$j || (_templateObject5$j = _taggedTemplateLiteralLoose(["\n  width:48px;\n  height: 48px;\n  background-image: url(data:image/svg+xml;base64,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);\n  display: inline-block;\n  background-size: 48px 48px;\n  margin: 0 auto;\n  position:relative;\n  left:50%;\n  transform: translateX(-50%)\n"])));
var ModalContent = styled.div(_templateObject6$g || (_templateObject6$g = _taggedTemplateLiteralLoose(["\n  position: relative;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #999;\n  border: 1px solid rgba(0,0,0,.2);\n  border-radius: 6px;\n  outline: 0;\n  box-shadow: 0 3px 9px rgb(0 0 0 / 50%);\n  text-align:start;\n    left:50%;\n    transform: translateX(-50%);\n    width:600px;\n    top:10vh;\n    min-height:450px;\n    @media(min-width:768px) and (max-width:1366px){\n      width:550px;  \n      left:50vw;\n      transform: translateX(-50%);\n      top:5%;\n      min-height:400px;\n    }\n  @media(max-width:600px){\n    height:100%;\n    width:100%;\n    background-color:#fff;\n    transform: translateX(0%);\n    top:0;\n    left:0;\n  }\n"])));
var ModalHeader = styled.div(_templateObject7$d || (_templateObject7$d = _taggedTemplateLiteralLoose(["\n  \n@media(min-width:601px){\n    background-color:silver;\n    display:flex\n    padding:8px;\n    padding-bottom:3px;\n  }\n  @media(max-width:600px){\n    background-color:silver;\n    display:flex\n    padding:8px;\n    padding-bottom:3px;\n    justify-content:start\n  }\n"])));
var ModalHeaderHeading = styled.div(_templateObject8$d || (_templateObject8$d = _taggedTemplateLiteralLoose(["\n  @media(min-width:601px){\n    font-weight:bold\n    width:97%;\n  }\n  @media(max-width:600px){\n    font-weight:bold\n    width:97%\n  }\n"])));
var ModalBody = styled.div(_templateObject9$b || (_templateObject9$b = _taggedTemplateLiteralLoose(["\n  background-color:white;\n  max-height:85%;\n  min-height:60%;\n"])));
var ModalBodyHeader = styled.div(_templateObject0$9 || (_templateObject0$9 = _taggedTemplateLiteralLoose(["\n  @media(min-width:601px){\n    display:flex\n  }\n  @media(max-width:600px){\n    display:block\n  }\n"])));
var ModalBodyHeaderContent = styled.ul(_templateObject1$9 || (_templateObject1$9 = _taggedTemplateLiteralLoose(["\n  height:300px;\n  border: 1px solid silver;\n  margin-top:30px;\n  display:flex;\n  padding-inline-start:0;\n  display:flex;\n  overflow-y: scroll;\n  flex-wrap: wrap\n  @media(max-width:600px){\n    height:200px;\n    display:block;\n    margin-top:160px;\n  }\n"])));
var DeviceList = styled.li(_templateObject10$6 || (_templateObject10$6 = _taggedTemplateLiteralLoose([" \n  width:24.5%;\n  border-right: 1px solid silver;\n  border-bottom: 1px solid silver;\n  height: 100%;\n  list-style:none\n  @media(max-width:600px){\n    width:100%;\n  }\n"])));
var LeftSection = styled.div(_templateObject11$5 || (_templateObject11$5 = _taggedTemplateLiteralLoose(["\n  @media(min-width:601px){\n    margin:7px;\n    height:35px;\n    width:55%;\n  }\n  @media(max-width:600px){\n    margin:7px;\n    height:35px;\n    width:100%;\n    display:flex\n  }\n"])));
var SearchBar$4 = styled.div(_templateObject12$4 || (_templateObject12$4 = _taggedTemplateLiteralLoose(["\n  @media(min-width:601px){\n    display:flex; \n    border: 1.5px solid silver;\n  }\n  @media(max-width:600px){\n    display:flex; \n    border: 1.5px solid silver;\n    width:90.5%;\n    margin-bottom:10px\n    height:50px;\n    margin-bottom:20px\n  }\n"])));
var RightSection = styled.div(_templateObject13$4 || (_templateObject13$4 = _taggedTemplateLiteralLoose(["\n@media(min-width:601px){\n    margin:7px;\n    height:35px;\n    width:40%;\n    display: flex\n  }\n  @media(max-width:600px){\n    margin:7px;\n    height:35px;\n    width:93%;\n    display: block\n    margin-top:40px;\n  }\n"])));
var ItemList$1 = styled.ul(_templateObject14$4 || (_templateObject14$4 = _taggedTemplateLiteralLoose(["\n\n    min-width:120px;\n    overflow-y:auto;\n    max-height:320px;\n    border: 1px solid silver;\n    box-shadow: 5px 5px 5px silver;\n    position:fixed;\n    padding-inline-start:0px;\n    margin-block-start:.2rem;\n    background:#fff\n\n@media(max-width:600px){\n\n  max-height:250px;\n  z-index:100;\n  width:90%\n}\n\n"])));
var List = styled.li(_templateObject15$4 || (_templateObject15$4 = _taggedTemplateLiteralLoose(["\n list-style: none;\n padding:2px;\n &:hover{\n     background-color:silver\n }\n\n @media(max-width:600px){\n\n  height:40px;\n  font-size:1.3rem\n }\n\n"])));
var ModalFooter = styled.div(_templateObject16$4 || (_templateObject16$4 = _taggedTemplateLiteralLoose(["\ndisplay:flex;\n\n@media(max-width:600px){\n\n  display:block\n  margin-top:20px\n}\n \n\n"])));
var LeftSide = styled.div(_templateObject17$4 || (_templateObject17$4 = _taggedTemplateLiteralLoose(["\n \ndisplay:flex;\nwidth:55%;\nheight:75px;\n \nalign-items: center;\nmargin-left:20px;\n\n@media(max-width:600px){\n  display:block;\n  margin-left:35px;\n  width:100%;\n  height:25px;\n}\n\n"])));
var RightSide = styled.div(_templateObject18$4 || (_templateObject18$4 = _taggedTemplateLiteralLoose(["\ndisplay:flex;\n \nalign-items: center;\nheight:75px;\n\n@media(max-width:600px){\n  margin-top:20px;\n  height:25px;\n  display:block;\n  margin-left:75px\n}\n \n"])));
var CancelButton = styled.button(_templateObject19$4 || (_templateObject19$4 = _taggedTemplateLiteralLoose(["\n  \n \n\n    border-radius: 18px;\n    display: inline-block;\n    position: relative;\n    font-size: 14px;\n    font-weight: bold;\n    line-height: 1em;\n    padding: 8px 8px;\n    text-align: center;\n    min-width: 10%;\n    border-color: transparent;\n    margin: 0 4px;\n    font-family: NeueHaasGroteskDisplayBold,Arial,Helvetica,sans-serif;\n    width: 100px;\n    background-color: #fff;\n    border: 1px solid #000 !important;\n    color: #000;\n\n\n"])));
var OkButton = styled.button(_templateObject20$4 || (_templateObject20$4 = _taggedTemplateLiteralLoose(["\n  \n    margin-left:10px;\n    border-radius: 18px;\n    display: inline-block;\n    position: relative;\n    font-size: 14px;\n    font-weight: bold;\n    line-height: 1em;\n    padding: 8px 8px;\n    text-align: center;\n    min-width: 10%;\n    border-color: transparent;\n    margin: 0 4px;\n    font-family: NeueHaasGroteskDisplayBold,Arial,Helvetica,sans-serif;\n    width: 100px;\n    background-color: #000;\n    border: 1px solid #000  \n    color: #fff;\n\n    &:disabled{\n      background-color: #ddd;\n      border: none\n    }\n\n\n"])));
var ModalListing = /*#__PURE__*/function (_Component) {
  function ModalListing() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      deviceTypePlaceHolder: 'All',
      brandPlaceHolder: 'All',
      deviceTypeListShow: false,
      brandListShow: false,
      symptomId: '',
      brand: ['All'],
      device: ['All'],
      searchInput: '',
      isOpen: _this.props.isOpen,
      modalError: _this.props.modalError,
      dataAvailable: false,
      selected: [],
      renderList: [],
      selectedDevice: {
        isSelected: false,
        details: {}
      },
      lastActive: ''
    };
    _this.listHandler = function (e) {
      var target;
      if (e.target.classList.contains('brandlist')) {
        _this.setState({
          brandPlaceHolder: e.target.textContent
        });
        target = e.target.textContent;
      }
      if (e.target.classList.contains('devicelist')) {
        _this.setState({
          deviceTypePlaceHolder: e.target.textContent
        });
        target = e.target.textContent;
      }
      window.setTimeout(function () {
        _this.refineSearch(target);
      }, 50);
    };
    _this.refineSearch = function (value) {
      if (_this.state.lastActive.length > 0 && document.querySelector(_this.state.lastActive)) {
        document.querySelector(_this.state.lastActive).style.backgroundColor = "white";
        _this.setState({
          lastActive: ''
        });
      }
      var brand = _this.state.brandPlaceHolder;
      var device = _this.state.deviceTypePlaceHolder;
      var searchBoxValue = _this.state.searchInput.toLowerCase();
      var brandCondition;
      var deviceCondition;
      var searchBoxCondition;
      var newList = [];
      newList = _this.props.deviceResponse.Device.filter(function (item, Index) {
        var _item$DEVICE_BRAND, _item$DEVICE_TYPE, _item$DEVICE_BRAND2, _item$DEVICE_TYPE2, _item$DEVICE_NAME;
        brandCondition = brand.toLowerCase() === 'all' ? 1 : ((_item$DEVICE_BRAND = item.DEVICE_BRAND) === null || _item$DEVICE_BRAND === void 0 ? void 0 : _item$DEVICE_BRAND.toLowerCase()) === brand.toLowerCase();
        deviceCondition = device.toLowerCase() === 'all' ? 1 : ((_item$DEVICE_TYPE = item.DEVICE_TYPE) === null || _item$DEVICE_TYPE === void 0 ? void 0 : _item$DEVICE_TYPE.toLowerCase()) === device.toLowerCase();
        searchBoxCondition = searchBoxValue === '' || searchBoxValue === ' ' ? 1 : ((_item$DEVICE_BRAND2 = item.DEVICE_BRAND) === null || _item$DEVICE_BRAND2 === void 0 ? void 0 : _item$DEVICE_BRAND2.toLowerCase().includes(searchBoxValue)) || ((_item$DEVICE_TYPE2 = item.DEVICE_TYPE) === null || _item$DEVICE_TYPE2 === void 0 ? void 0 : _item$DEVICE_TYPE2.toLowerCase().includes(searchBoxValue)) || ((_item$DEVICE_NAME = item.DEVICE_NAME) === null || _item$DEVICE_NAME === void 0 ? void 0 : _item$DEVICE_NAME.toLowerCase().includes(searchBoxValue));
        if (brandCondition && deviceCondition && searchBoxCondition) {
          return item;
        }
      });
      _this.setState({
        selected: newList
      });
    };
    _this.modalValueReset = function () {
      _this.setState({
        deviceTypePlaceHolder: 'All',
        brandPlaceHolder: 'All',
        deviceTypeListShow: false,
        brandListShow: false,
        renderList: [],
        selected: [],
        dataAvailable: false,
        selectedDevice: {
          isSelected: false,
          details: {}
        },
        brand: ['All'],
        device: ['All'],
        lastActive: ''
      });
      _this.props.modalClose();
    };
    _this.searchBarHandler = function (e) {
      _this.setState({
        searchInput: e.target.value
      });
      if (e.target.value.length > 2 || e.target.value === '') {
        window.setTimeout(function () {
          return _this.refineSearch(_this.state.searchInput);
        }, 50);
      }
      var selectedDevice = {};
      selectedDevice.isSelected = false;
      _this.setState({
        selectedDevice: selectedDevice
      });
    };
    _this.btnClickHandler = function (e) {
      if (e.target.classList.contains('brandtoggleBtn')) {
        _this.setState({
          deviceTypeListShow: false,
          brandListShow: !_this.state.brandListShow
        });
      }
      if (e.target.classList.contains('devicetoggleBtn')) {
        _this.setState({
          deviceTypeListShow: !_this.state.deviceTypeListShow,
          brandListShow: false
        });
      }
      var selectedDevice = {};
      selectedDevice.isSelected = false;
      _this.setState({
        selectedDevice: selectedDevice
      });
    };
    return _this;
  }
  _inheritsLoose(ModalListing, _Component);
  var _proto = ModalListing.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    document.addEventListener('click', function (e) {
      if (!e.target.classList.contains("brandtoggleBtn") && !e.target.classList.contains("devicetoggleBtn")) {
        _this2.setState({
          deviceTypeListShow: false,
          brandListShow: false
        });
      }
    });
  };
  ModalListing.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    try {
      if (props.isOpen) document.body.style.overflow = 'hidden';
      if (state.dataAvailable) {
        return {
          renderList: state.selected
        };
      } else if (Object.keys(state.renderList).length === 0 && Object.keys(state.selected).length === 0 && props.deviceResponse.Device.length > 0) {
        var _props$deviceResponse, _props$deviceResponse2, _props$deviceResponse3, _props$deviceResponse4, _props$deviceResponse5, _props$deviceResponse6, _props$deviceResponse7, _props$deviceResponse8;
        return {
          brand: [state.brand].concat((_props$deviceResponse = (_props$deviceResponse2 = props.deviceResponse) === null || _props$deviceResponse2 === void 0 ? void 0 : _props$deviceResponse2.brand) != null ? _props$deviceResponse : []),
          device: [state.device].concat((_props$deviceResponse3 = (_props$deviceResponse4 = props.deviceResponse) === null || _props$deviceResponse4 === void 0 ? void 0 : _props$deviceResponse4.deviceType) != null ? _props$deviceResponse3 : []),
          renderList: [].concat((_props$deviceResponse5 = (_props$deviceResponse6 = props.deviceResponse) === null || _props$deviceResponse6 === void 0 ? void 0 : _props$deviceResponse6.Device) != null ? _props$deviceResponse5 : []),
          selected: [].concat((_props$deviceResponse7 = (_props$deviceResponse8 = props.deviceResponse) === null || _props$deviceResponse8 === void 0 ? void 0 : _props$deviceResponse8.Device) != null ? _props$deviceResponse7 : []),
          modalError: props.modalError,
          dataAvailable: true,
          symptomId: props.symptomId
        };
      } else {
        return {
          renderList: state.selected
        };
      }
    } catch (e) {
      console.log("error in getDerivedStateFromProps in ModalListing: ", e);
    }
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this3 = this;
    window.setTimeout(function () {
      _this3.props.setSpinner(false);
    }, 1000);
  };
  _proto.deviceSelectionHandler = function deviceSelectionHandler(item, Index, e) {
    var active = "#item-" + Index;
    if (this.state.lastActive.length > 0) {
      if (document.querySelector(this.state.lastActive)) {
        document.querySelector(this.state.lastActive).style.backgroundColor = "white";
      }
    }
    document.querySelector(active).style.backgroundColor = 'rgba(0,0,0,0.2)';
    var selectedDevice = {};
    selectedDevice.isSelected = true;
    selectedDevice.details = item;
    this.setState({
      selectedDevice: selectedDevice,
      lastActive: active
    });
  };
  _proto.deviceChangeHandler = function deviceChangeHandler() {
    var _deviceDetails$troubl, _deviceDetails$DEVICE;
    var deviceDetails = this.state.selectedDevice.details;
    var redirectUrl = (_deviceDetails$troubl = deviceDetails === null || deviceDetails === void 0 ? void 0 : deviceDetails.troubleshootingUrl) != null ? _deviceDetails$troubl : "";
    var DEVICE_ID = (_deviceDetails$DEVICE = deviceDetails === null || deviceDetails === void 0 ? void 0 : deviceDetails.DEVICE_ID) != null ? _deviceDetails$DEVICE : "";
    var isSelected = this.state.selectedDevice.isSelected;
    this.modalValueReset();
    if (mvoConfig$5 !== null && mvoConfig$5 !== void 0 && mvoConfig$5.isAcss) {
      redirectFormPostToUrl("/portal", DEVICE_ID);
      return;
    }
    if (isSelected && deviceDetails) {
      window.location.href = redirectUrl;
    }
  };
  _proto.render = function render() {
    var _this4 = this;
    return this.props.isOpen ? /*#__PURE__*/React__default.createElement(Modal, {
      id: "overlay"
    }, /*#__PURE__*/React__default.createElement(ModalContent, null, /*#__PURE__*/React__default.createElement(ModalHeader, null, /*#__PURE__*/React__default.createElement(ModalHeaderHeading, null, "Select your device"), /*#__PURE__*/React__default.createElement("div", {
      onClick: this.modalValueReset,
      style: {
        "cursor": "pointer"
      }
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      id: "closeModal",
      name: "close",
      size: "small",
      color: "#000000",
      backgroundColor: "transparent",
      onClick: this.modalValueReset
    }))), !this.props.modalError ? /*#__PURE__*/React__default.createElement(ModalBody, null, !this.props.spinner && this.state.dataAvailable ? /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(ModalBodyHeader, null, /*#__PURE__*/React__default.createElement(LeftSection, null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        'height': '20px'
      }
    }), /*#__PURE__*/React__default.createElement(SearchBar$4, null, /*#__PURE__*/React__default.createElement("input", {
      onFocus: function onFocus(e) {
        return e.target.style.outline = 'none';
      },
      onChange: function onChange(e) {
        return _this4.searchBarHandler.bind(_this4, e)();
      },
      placeholder: "select a device",
      style: {
        'width': '100%',
        'border': 'none'
      }
    }), /*#__PURE__*/React__default.createElement("button", {
      style: {
        'border': 'none',
        'backgroundColor': '#fff'
      },
      "data-analyticstrack": "Search-Button",
      "data-track": "{\"type\": \"button\", \"name\": \"Search-Button\"}",
      "data-clickstream": "Search-Button",
      tabIndex: "-1"
    }, /*#__PURE__*/React__default.createElement("svg", {
      focusable: "false",
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 18 18"
    }, /*#__PURE__*/React__default.createElement("path", {
      fill: "#000",
      fillRule: "nonzero",
      d: "M17.896 17.101l-5.995-5.994A6.721 6.721 0 0 0 13.5 6.75a6.75 6.75 0 1 0-6.75 6.75c1.661 0 3.18-.603 4.356-1.598l5.995 5.995.795-.796zM6.75 12.375A5.63 5.63 0 0 1 1.125 6.75 5.63 5.63 0 0 1 6.75 1.125a5.63 5.63 0 0 1 5.625 5.625 5.63 5.63 0 0 1-5.625 5.625z"
    }))))), /*#__PURE__*/React__default.createElement(RightSection, null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        'position': 'relative',
        'marginRight': '10px',
        "width": "50%"
      },
      onClick: function onClick(e) {
        return _this4.btnClickHandler(e);
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        'height': '20px',
        'fontWeight': 'bold'
      }
    }, "Brand/OS"), /*#__PURE__*/React__default.createElement("button", {
      id: "brand",
      className: "brandtoggleBtn",
      style: {
        "cursor": "pointer"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      "data-testid": "brand",
      className: "brandtoggleBtn",
      style: {
        'width': '70%',
        'fontWeight': 'bold',
        'fontFamily': 'Arial,Helvetica,sans-serif',
        'fontSize': '1rem',
        'overflow': 'hidden'
      },
      onClick: function onClick(e) {
        return _this4.btnClickHandler(e);
      }
    }, this.state.brandPlaceHolder), this.state.brandListShow ? /*#__PURE__*/React__default.createElement("img", {
      className: "brandtoggleBtn DeviceSelector_SearchBox_DropDownButton_Img",
      style: {
        'position': 'absolute',
        'right': '10px',
        'top': '35px'
      },
      id: "tl-image2",
      src: "//scache.vzw.com/support/content/dam/support_rd/assets/images/i/support-arrow-up.png",
      alt: ""
    }) : /*#__PURE__*/React__default.createElement("img", {
      className: "brandtoggleBtn DeviceSelector_SearchBox_DropDownButton_Img",
      style: {
        'position': 'absolute',
        'right': '10px',
        'top': '35px'
      },
      id: "tl-image2",
      src: "//scache.vzw.com/support/content/dam/support_rd/assets/images/i/support-arrow-down.png",
      alt: ""
    })), this.state.brandListShow ? /*#__PURE__*/React__default.createElement(ItemList$1, null, Array.isArray(this.state.brand) && this.state.brand.map(function (item, Index) {
      return /*#__PURE__*/React__default.createElement(List, {
        key: Index,
        className: "brandlist",
        onClick: function onClick(e) {
          return _this4.listHandler.bind(_this4, e)();
        }
      }, item);
    })) : null), /*#__PURE__*/React__default.createElement("div", {
      style: {
        'position': 'relative',
        'marginRight': '10px',
        "width": "50%"
      },
      onClick: function onClick(e) {
        return _this4.btnClickHandler(e);
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        'height': '20px',
        'fontWeight': 'bold'
      }
    }, "Device Type"), /*#__PURE__*/React__default.createElement("button", {
      id: "device",
      className: "devicetoggleBtn",
      style: {
        "cursor": "pointer"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      "data-testid": "device",
      className: "devicetoggleBtn",
      style: {
        'width': '70%',
        'fontWeight': 'bold',
        'fontFamily': 'Arial,Helvetica,sans-serif',
        'fontSize': '1rem'
      },
      onClick: function onClick(e) {
        return _this4.btnClickHandler(e);
      }
    }, this.state.deviceTypePlaceHolder), this.state.deviceTypeListShow ? /*#__PURE__*/React__default.createElement("img", {
      className: "devicetoggleBtn DeviceSelector_SearchBox_DropDownButton_Img",
      style: {
        'position': 'absolute',
        'right': '10px',
        'top': '35px'
      },
      id: "tl-image2",
      src: "//scache.vzw.com/support/content/dam/support_rd/assets/images/i/support-arrow-up.png",
      alt: ""
    }) : /*#__PURE__*/React__default.createElement("img", {
      className: "devicetoggleBtn DeviceSelector_SearchBox_DropDownButton_Img",
      style: {
        'position': 'absolute',
        'right': '10px',
        'top': '35px'
      },
      id: "tl-image2",
      src: "//scache.vzw.com/support/content/dam/support_rd/assets/images/i/support-arrow-down.png",
      alt: ""
    })), this.state.deviceTypeListShow ? /*#__PURE__*/React__default.createElement(ItemList$1, null, Array.isArray(this.state.device) && this.state.device.map(function (item, Index) {
      return /*#__PURE__*/React__default.createElement(List, {
        key: Index,
        className: "devicelist",
        onClick: function onClick(e) {
          return _this4.listHandler.bind(_this4, e)();
        }
      }, item);
    })) : null))), /*#__PURE__*/React__default.createElement(ModalBodyHeaderContent, null, Array.isArray(this.state.renderList) && this.state.renderList.map(function (item, Index) {
      var img = decodeURIComponent(item.DEVICE_THUMB_IMG);
      return /*#__PURE__*/React__default.createElement(DeviceList, {
        "data-testid": "deviceList-" + Index,
        id: "item-" + Index,
        style: {
          "cursor": "pointer"
        },
        className: "listDevice",
        key: Index,
        onClick: _this4.deviceSelectionHandler.bind(_this4, item, Index)
      }, /*#__PURE__*/React__default.createElement("div", {
        id: "img-container"
      }, /*#__PURE__*/React__default.createElement("img", {
        src: "" + img,
        style: {
          "marginTop": '20px'
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        style: {
          'display': 'flex',
          'height': '70%',
          'justifyContent': 'center',
          'textAlign': 'center',
          'alignItems': 'flex-start',
          'paddingTop': '5rem'
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          'fontWeight': 'bold'
        },
        dangerouslySetInnerHTML: {
          __html: item.FAMILY_NAME
        }
      })));
    })), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(LeftSide, null, /*#__PURE__*/React__default.createElement("div", null, "All memory capacities and all colors supported")), /*#__PURE__*/React__default.createElement(RightSide, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CancelButton, {
      onClick: this.modalValueReset
    }, "Cancel"), /*#__PURE__*/React__default.createElement(OkButton, {
      onClick: this.deviceChangeHandler.bind(this),
      disabled: !this.state.selectedDevice.isSelected
    }, "Ok"))))) : /*#__PURE__*/React__default.createElement(SpinnerM, null)) : /*#__PURE__*/React__default.createElement(ErrorBox, null, /*#__PURE__*/React__default.createElement(StyledIcon, null), /*#__PURE__*/React__default.createElement("h3", null, "We encountered error while processing your request")))) : null;
  };
  return ModalListing;
}(Component);
var ModalListing$1 = withRouter(ModalListing);

var extractContent = function extractContent(htmlString, tagName) {
  var parser = new DOMParser();
  var doc = parser.parseFromString(htmlString, 'text/html');
  var elements = doc.querySelectorAll(tagName);
  var contentArray = [];
  elements.forEach(function (element) {
    contentArray.push(element.innerHTML);
  });
  return contentArray;
};
var parseBanner$1 = function parseBanner(delphiBannerAttrs) {
  if ((delphiBannerAttrs === null || delphiBannerAttrs === void 0 ? void 0 : delphiBannerAttrs.length) === 0) return [];
  var banners = [];
  delphiBannerAttrs === null || delphiBannerAttrs === void 0 ? void 0 : delphiBannerAttrs.forEach(function (instepBannerAttr) {
    var attrNames = instepBannerAttr.attrNames;
    attrNames === null || attrNames === void 0 ? void 0 : attrNames.forEach(function (attrName) {
      var value = attrName.value,
        bannerContent = attrName.bannerContent,
        _attrName$show = attrName.show,
        show = _attrName$show === void 0 ? '' : _attrName$show;
      if (!value || !bannerContent) return;
      var _extractContent = extractContent(bannerContent, 'p'),
        title = _extractContent[0],
        bannerDetails = _extractContent.slice(1);
      if ((show === null || show === void 0 ? void 0 : show.toLowerCase()) === 'yes') {
        if (!title && (bannerDetails === null || bannerDetails === void 0 ? void 0 : bannerDetails.length) === 0) return;
        banners.push({
          type: value,
          title: title,
          bannerDetails: bannerDetails
        });
      }
    });
  });
  return banners;
};
var DelphiBanner = function DelphiBanner(_ref) {
  var _ref$steps = _ref.steps,
    steps = _ref$steps === void 0 ? [] : _ref$steps,
    isDark = _ref.isDark;
  var _steps$ = steps[0],
    firstStep = _steps$ === void 0 ? {} : _steps$;
  var _firstStep$delphiBann = firstStep.delphiBannerAttrs,
    delphiBannerAttrs = _firstStep$delphiBann === void 0 ? [] : _firstStep$delphiBann;
  var banners = useMemo(function () {
    return parseBanner$1(delphiBannerAttrs);
  }, [delphiBannerAttrs]);
  if ((banners === null || banners === void 0 ? void 0 : banners.length) === 0) return null;
  return /*#__PURE__*/React__default.createElement(Stack, {
    marginBottom: "10px",
    gap: "10px"
  }, banners.map(function (banner, index) {
    var _banner$bannerDetails;
    return /*#__PURE__*/React__default.createElement(VDSBanner, {
      key: 'delphi' + index,
      type: banner === null || banner === void 0 ? void 0 : banner.type,
      title: banner === null || banner === void 0 ? void 0 : banner.title,
      isDark: isDark
    }, /*#__PURE__*/React__default.createElement(Stack, null, banner === null || banner === void 0 ? void 0 : (_banner$bannerDetails = banner.bannerDetails) === null || _banner$bannerDetails === void 0 ? void 0 : _banner$bannerDetails.map(function (item) {
      return /*#__PURE__*/React__default.createElement(Body, {
        size: "large",
        color: isDark ? '#fff' : '#000'
      }, item);
    })));
  }));
};

var IframePage = function IframePage(props) {
  var _props$url = props.url,
    url = _props$url === void 0 ? "" : _props$url,
    _props$styles = props.styles,
    styles = _props$styles === void 0 ? {} : _props$styles,
    _props$frameBorder = props.frameBorder,
    frameBorder = _props$frameBorder === void 0 ? "0" : _props$frameBorder,
    width = props.width,
    height = props.height;
  var finalComps = window.isBAUACSS ? {
    styles: styledBauComps
  } : {
    styles: styledComps
  };
  var IframeContainer = finalComps.styles.IframeContainer;
  return /*#__PURE__*/React__default.createElement(IframeContainer, null, /*#__PURE__*/React__default.createElement("iframe", {
    src: url,
    style: styles,
    frameBorder: frameBorder,
    height: height ? height : "100%",
    width: width ? width : "100%",
    referrerPolicy: "strict-origin-when-cross-origin"
  }));
};

var _templateObject$u, _templateObject2$p;
var BannerContainer = styled.div(_templateObject$u || (_templateObject$u = _taggedTemplateLiteralLoose(["\np{\n\tfont-weight: normal;\n\tmargin:0;\n\tmargin-top: 4px;\n}\nh4{\n    margin-top:0;\n    left: 0 !important;\n    font-size: 1rem;\n    font-weight: 700;\n    line-height: 1.25rem;\n    font-family: Verizon-NHG-eDS, Helvetica, Arial, sans-serif;\n    letter-spacing: 0.03125rem;\n    text-decoration: none;\n}\n"])));
var DynamicValuesDiv = styled.div(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteralLoose(["\nmargin-top:16px;\n"])));
var addDynamicValues = function addDynamicValues(eligibleTemplates, templateId) {
  return eligibleTemplates.split(",").includes(templateId);
};
var notification = function notification(_ref) {
  var _ref$messaage = _ref.messaage,
    messaage = _ref$messaage === void 0 ? '' : _ref$messaage,
    _ref$dynamicTemplates = _ref.dynamicTemplates,
    dynamicTemplates = _ref$dynamicTemplates === void 0 ? '' : _ref$dynamicTemplates,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? {} : _ref$step,
    isDark = _ref.isDark;
  console.log("dynamicTemplates", dynamicTemplates, step);
  var _step$LocationList = step.LocationList,
    LocationList = _step$LocationList === void 0 ? [] : _step$LocationList,
    _step$templateId = step.templateId,
    templateId = _step$templateId === void 0 ? '' : _step$templateId;
  var children = /*#__PURE__*/React__default.createElement(BannerContainer, null, messaage, LocationList.length > 0 && addDynamicValues(dynamicTemplates, templateId) && /*#__PURE__*/React__default.createElement(DynamicValuesDiv, null, LocationList.map(function (locationObj, ind) {
    return /*#__PURE__*/React__default.createElement("p", {
      key: locationObj.location + "_" + ind
    }, locationObj.location, " - ", locationObj.signal);
  })));
  return (
    /*#__PURE__*/
    React__default.createElement("div", null,  /*#__PURE__*/React__default.createElement(Notification, {
      type: "info",
      fullBleed: false,
      inline: false,
      disableFocus: true,
      children: children,
      surface: isDark ? "dark" : "light"
    }))
  );
};

var finalComps$2 = {
  styles: styledComps
};
if (window.isBAUACSS) {
  finalComps$2 = {
    styles: styledBauComps
  };
}
var _finalComps$styles$2 = finalComps$2.styles,
  Probing$3 = _finalComps$styles$2.Probing,
  SearchBar$5 = _finalComps$styles$2.SearchBar,
  SearchDesc$3 = _finalComps$styles$2.SearchDesc,
  SearchResults$3 = _finalComps$styles$2.SearchResults,
  SearchResultsContainer$3 = _finalComps$styles$2.SearchResultsContainer,
  SearchTitle$3 = _finalComps$styles$2.SearchTitle;
var SearchBarComponent = function SearchBarComponent(props) {
  var _configDetails$params, _configDetails$params2;
  var _props$step = props.step,
    step = _props$step === void 0 ? {} : _props$step,
    _props$functions = props.functions,
    functions = _props$functions === void 0 ? {} : _props$functions;
  var _useState = useState({
      previous: "",
      current: ""
    }),
    searchTextInput = _useState[0],
    setSearchTextInput = _useState[1];
  var _useState2 = useState([]),
    reviewTechBulletInResp = _useState2[0],
    setReviewTechBulletInResp = _useState2[1];
  var searchInput = function searchInput(e) {
    if (functions.handleAction) {
      functions.handleAction();
    }
    setSearchTextInput(_extends({}, searchTextInput, {
      current: e.target.value
    }));
  };
  var searchButton = function searchButton(e, searchurl, templateType, templateId) {
    callSearch(e, searchurl, templateType, templateId);
  };
  var callSearch = function callSearch(e, searchurl, templateType, templateId) {
    try {
      var _temp3 = function () {
        if (searchTextInput.current && searchTextInput.previous !== searchTextInput.current) {
          setSearchTextInput(_extends({}, searchTextInput, {
            previous: searchTextInput.current
          }));
          var _temp2 = function () {
            if (templateType === "searchsupportcontent" || templateId === "searchsupportcontent") {
              if (searchurl.includes("query=")) {
                var search = searchurl.replace("query=", "query=" + searchTextInput.current);
                window.open(search, "_blank");
              } else {
                window.open(searchurl + "&query=" + searchTextInput.current, "_blank");
              }
            } else {
              var _temp4 = function () {
                if (templateType === "reviewtechbulletin" || templateId === "BATTERYCHARGINGISSUES") {
                  return Promise.resolve(reviewTechBulletInSearch(searchurl + "&Symptom=" + searchRadioButton + "&query=" + searchTextInput.current)).then(function (apiResponse) {
                    if (apiResponse.response.data.body['LIST OF AEM END POINTS']) {
                      setReviewTechBulletInResp(apiResponse.response.data.body['LIST OF AEM END POINTS']);
                    }
                  });
                }
              }();
              if (_temp4 && _temp4.then) return _temp4.then(function () {});
            }
          }();
          if (_temp2 && _temp2.then) return _temp2.then(function () {});
        }
      }();
      return Promise.resolve(_temp3 && _temp3.then ? _temp3.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var _useState3 = useState(""),
    searchRadioButton = _useState3[0],
    setSearchRadioButton = _useState3[1];
  var handleSearchRadioButton = function handleSearchRadioButton(e) {
    if (functions.handleAction) {
      functions.handleAction();
    }
    setSearchRadioButton(e.target.value);
  };
  var handleSearchTitleClick = function handleSearchTitleClick(url) {
    window.open(url, "_blank");
  };
  var renderSearchRadioButtons = function renderSearchRadioButtons(symptom) {
    var options = [{
      "id": 0,
      "value": "dynamicSearchOption",
      "label": symptom
    }, {
      "id": 1,
      "value": "searchAllTechBulletin",
      "label": "Search all Tech Bulletin"
    }];
    return options.map(function (option, index) {
      return /*#__PURE__*/React__default.createElement("label", {
        className: "container"
      }, /*#__PURE__*/React__default.createElement("input", {
        onChange: function onChange(e) {
          return handleSearchRadioButton(e);
        },
        className: "Radio",
        type: "radio",
        value: option.value,
        name: "categorys",
        role: "radio",
        "data-analyticstrack": "trbl-category-radio",
        "data-track": {
          type: "link",
          name: option.label
        },
        "data-clickstream": option.label + "-trbl-category-radio",
        "aria-label": option.label,
        checked: searchRadioButton === option.value,
        id: "box-" + index
      }), /*#__PURE__*/React__default.createElement("span", {
        className: "checkmark"
      }, " "), /*#__PURE__*/React__default.createElement("label", {
        className: "radioLabel",
        "for": "box-" + index
      }, option.label));
    });
  };
  var configDetails = useContext(ConfigContext);
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(SearchBar$5, {
    search: true,
    isDark: (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : (_configDetails$params2 = _configDetails$params.theme) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.isDark
  }, /*#__PURE__*/React__default.createElement("input", {
    onChange: function onChange(e) {
      return searchInput(e);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter") {
        return searchButton(e, step.contentUrl, step.templateType, step.templateId);
      }
    },
    onFocus: function onFocus(e) {
      return e.target.style.outline = 'none';
    },
    "data-track": "{\"type\": \"link\", \"name\": \"Search\"}",
    placeholder: step.templateType === "searchsupportcontent" || step.templateId === "searchsupportcontent" ? "Search other resources to find solutions" : "Search",
    style: {
      'width': '100%',
      'border': 'none',
      fontSize: "1.25rem",
      fontWeight: "700",
      fontFamily: "Verizon-NHG-eDS"
    }
  }), /*#__PURE__*/React__default.createElement("button", {
    style: {
      'border': 'none',
      'backgroundColor': 'transparent',
      cursor: searchTextInput.current !== "" ? 'pointer' : "not-allowed"
    },
    "data-analyticstrack": "Search-Button",
    "data-track": "{\"type\": \"button\", \"name\": \"Search-Button\"}",
    "data-clickstream": "Search-Button",
    tabIndex: "-1",
    onClick: function onClick(e) {
      return searchButton(e, step.contentUrl, step.templateType, step.templateId);
    }
  }, /*#__PURE__*/React__default.createElement("svg", {
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M17.896 17.101l-5.995-5.994A6.721 6.721 0 0 0 13.5 6.75a6.75 6.75 0 1 0-6.75 6.75c1.661 0 3.18-.603 4.356-1.598l5.995 5.995.795-.796zM6.75 12.375A5.63 5.63 0 0 1 1.125 6.75 5.63 5.63 0 0 1 6.75 1.125a5.63 5.63 0 0 1 5.625 5.625 5.63 5.63 0 0 1-5.625 5.625z"
  })))), step.symptom && /*#__PURE__*/React__default.createElement(Probing$3, {
    search: true
  }, renderSearchRadioButtons(step.symptom)), reviewTechBulletInResp && /*#__PURE__*/React__default.createElement(SearchResults$3, null, reviewTechBulletInResp.map(function (results) {
    return /*#__PURE__*/React__default.createElement(SearchResultsContainer$3, null, /*#__PURE__*/React__default.createElement(SearchTitle$3, {
      "data-testid": "search-title-id",
      onClick: function onClick() {
        return handleSearchTitleClick(results.url);
      },
      "data-track": "{\"type\": \"link\", \"name\": \"" + results.title + "\"}"
    }, results.title), /*#__PURE__*/React__default.createElement(SearchDesc$3, null, /*#__PURE__*/React__default.createElement(TextWithHtml, null, results.synopsis)));
  })));
};

var _templateObject$v, _templateObject2$q, _templateObject3$m, _templateObject4$m;
var WaitScreenContainer = styled.div(_templateObject$v || (_templateObject$v = _taggedTemplateLiteralLoose(["\nmin-height: 40vh;\nposition: relative;\n"])));
var MessageBody = styled.div(_templateObject2$q || (_templateObject2$q = _taggedTemplateLiteralLoose(["\n    text-align: center;\n    font-family: Verizon-NHG-eDS;\n    position: absolute;\n    z-index: 999999;\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n    top: 70%;\n    text-align: center;\n    margin-left: ", "\n"])), window.isBAUACSS ? '0' : '-20px');
var MessageContainer = styled.div(_templateObject3$m || (_templateObject3$m = _taggedTemplateLiteralLoose(["\n    text-align: center;\n    p{\n        margin-bottom: 0;\n    }\n    "])));
var LoaderContainer = styled.div(_templateObject4$m || (_templateObject4$m = _taggedTemplateLiteralLoose(["\ndiv:nth-child(2){\nz-Index: 2 !important;\n}\n"])));
var WaitScreen = function WaitScreen(_ref) {
  var _configDetails$params, _configDetails$params2;
  var _ref$loadingMsg = _ref.loadingMsg,
    loadingMsg = _ref$loadingMsg === void 0 ? '' : _ref$loadingMsg;
  var configDetails = useContext(ConfigContext);
  return /*#__PURE__*/React__default.createElement(WaitScreenContainer, null, /*#__PURE__*/React__default.createElement(Loader$2, {
    active: true,
    fullscreen: false,
    surface: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : (_configDetails$params2 = _configDetails$params.theme) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.themeId) === "theme_dark" ? "dark" : "light"
  }), /*#__PURE__*/React__default.createElement(MessageBody, null, /*#__PURE__*/React__default.createElement(MessageContainer, {
    dangerouslySetInnerHTML: {
      __html: loadingMsg
    }
  })));
};

var _templateObject$w, _templateObject2$r;
var FeedbackCloseButton$5 = styled.span(_templateObject$w || (_templateObject$w = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 40px;\n  top: 25px;\n  cursor: pointer;\n  z-index: 9999;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  @media screen and (max-width: 600px) {\n    right: 25px;\n  }\n"])));
var ResumeMainSection = styled.div(_templateObject2$r || (_templateObject2$r = _taggedTemplateLiteralLoose([""])));
var filterDuplicates = function filterDuplicates(navHist, filterName) {
  if (navHist === void 0) {
    navHist = [];
  }
  if (filterName === void 0) {
    filterName = '';
  }
  return navHist.filter(function (ele, index, array) {
    return array.findIndex(function (item) {
      return item[filterName] === ele[filterName];
    }) === index;
  });
};
var concatStrings = function concatStrings(navHist, selectedBoxes, articleType) {
  if (navHist === void 0) {
    navHist = [];
  }
  if (selectedBoxes === void 0) {
    selectedBoxes = {};
  }
  if (articleType === void 0) {
    articleType = '';
  }
  var filteredList = filterDuplicates(navHist.filter(function (obj) {
    return obj.articleId;
  }), 'articleId');
  return filteredList.filter(function (el) {
    return selectedBoxes[el.title] === true;
  }).map(function (el) {
    return el[articleType];
  }).join("|");
};
var SendResumeEmail = function SendResumeEmail(props) {
  var _configDetails$params, _configDetails$params2, _configDetails$params3, _configDetails$params4, _configDetails$params5, _configDetails$params6, _configDetails$params7, _configDetails$params8, _configDetails$params9, _configDetails$params0, _configDetails$params1, _configDetails$params10;
  var configDetails = useContext(ConfigContext);
  var _useState = useState(true),
    validEmail = _useState[0],
    setValidEmail = _useState[1];
  var handleModalState = props.handleModalState,
    _props$navHistory = props.navHistory,
    navHistory = _props$navHistory === void 0 ? [] : _props$navHistory,
    _props$custEmail = props.custEmail,
    custEmail = _props$custEmail === void 0 ? '' : _props$custEmail,
    _props$onSend = props.onSend,
    onSend = _props$onSend === void 0 ? function () {} : _props$onSend;
  var _useState2 = useState(true),
    showModal = _useState2[0];
  var _useState3 = useState({}),
    checkboxState = _useState3[0],
    setCheckboxState = _useState3[1];
  var _useState4 = useState(custEmail),
    email = _useState4[0],
    setEmail = _useState4[1];
  var _useState5 = useState(0),
    checkedCount = _useState5[0],
    setCheckedCount = _useState5[1];
  var _useState6 = useState(0),
    prevCount = _useState6[0],
    setPrevCount = _useState6[1];
  var _useState7 = useState(function () {
      var filteredList = filterDuplicates(navHistory.filter(function (obj) {
        return obj.articleId;
      }), 'articleId');
      return filteredList.map(function (navOption) {
        return {
          children: navOption.title,
          value: navOption.title,
          id: navOption.pageIdentifier,
          name: navOption.articleName,
          disabled: false
        };
      });
    }),
    checkboxOptions = _useState7[0],
    setCheckboxOptions = _useState7[1];
  useEffect(function () {
    console.log("useRef-->", checkboxState);
  });
  useEffect(function () {
    if (custEmail) {
      setValidEmail(true);
    }
  }, []);
  useEffect(function () {
    var filteredList = filterDuplicates(navHistory.filter(function (obj) {
      return obj.articleId;
    }), 'articleId');
    if (checkedCount === 5) {
      setCheckboxOptions(filteredList.map(function (navOption) {
        return {
          children: navOption.title,
          value: navOption.title,
          id: navOption.pageIdentifier,
          name: navOption.articleName,
          disabled: !(checkboxState[navOption.title] === true),
          selected: checkboxState[navOption.title] === true
        };
      }));
    } else if (checkedCount === 4 && prevCount === 5) {
      setCheckboxOptions(filteredList.map(function (navOption) {
        return {
          children: navOption.title,
          value: navOption.title,
          id: navOption.pageIdentifier,
          name: navOption.articleName,
          disabled: false,
          selected: checkboxState[navOption.title] === true
        };
      }));
    } else {
      setCheckboxOptions(filteredList.map(function (navOption) {
        return {
          children: navOption.title,
          value: navOption.title,
          id: navOption.pageIdentifier,
          name: navOption.articleName,
          disabled: false,
          selected: checkboxState[navOption.title] === true
        };
      }));
    }
  }, [checkedCount]);
  var handleOpenChanged = function handleOpenChanged(modalState) {
    if (!modalState) {
      handleModalState(false);
    }
  };
  var handleCheck = function handleCheck(event) {
    console.log("values", event.target.checked, event.target.value);
    var key = event.target.value;
    var value = event.target.checked;
    var newState = _extends({}, checkboxState);
    newState[key] = value;
    setCheckboxState(newState);
    setPrevCount(checkedCount);
    var count = 0;
    for (var _key in newState) {
      if (newState[_key] === true) count++;
    }
    setCheckedCount(count);
  };
  var handleEmailChange = function handleEmailChange(event) {
    var value = event.target.value;
    setValidEmail(isValidEmail(value));
    setEmail(value);
  };
  var handleSend = function handleSend() {
    var payload = {
      articleId: concatStrings(navHistory, checkboxState, "articleId"),
      articleUrl: concatStrings(navHistory, checkboxState, "articleUrl"),
      articleName: concatStrings(navHistory, checkboxState, "articleName"),
      custEmailId: email
    };
    onSend(payload);
    console.log("paylod", payload);
  };
  return /*#__PURE__*/React__default.createElement(ResumeMainSection, null, /*#__PURE__*/React__default.createElement(Modal$1, {
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params = configDetails.paramsDetails) !== null && _configDetails$params !== void 0 && (_configDetails$params2 = _configDetails$params.theme) !== null && _configDetails$params2 !== void 0 && _configDetails$params2.isDark ? 'dark' : 'light',
    opened: showModal,
    ariaLabel: "email-modal",
    fullScreenDialog: false,
    expandModal: false,
    onOpenedChange: handleOpenChanged,
    closeButton: /*#__PURE__*/React__default.createElement(FeedbackCloseButton$5, {
      "data-testid": "modal-close-button",
      "data-analyticstrack": "overlay-generic-cta",
      onClick: function onClick() {
        return handleOpenChanged(false);
      }
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      tabIndex: "-1",
      id: "closeModal",
      name: "close",
      size: "large",
      color: "#000000",
      backgroundColor: "transparent",
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params3 = configDetails.paramsDetails) !== null && _configDetails$params3 !== void 0 && (_configDetails$params4 = _configDetails$params3.theme) !== null && _configDetails$params4 !== void 0 && _configDetails$params4.isDark ? 'dark' : 'light'
    }), ' ')
  }, /*#__PURE__*/React__default.createElement(ModalTitle, null, /*#__PURE__*/React__default.createElement("span", {
    tabIndex: "0",
    style: {
      outline: "none"
    }
  }, "Send email summary")), /*#__PURE__*/React__default.createElement(ModalBody$1, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Input$1, {
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params5 = configDetails.paramsDetails) !== null && _configDetails$params5 !== void 0 && (_configDetails$params6 = _configDetails$params5.theme) !== null && _configDetails$params6 !== void 0 && _configDetails$params6.isDark ? 'dark' : 'light',
    "data-testid": "email-input",
    type: "text",
    label: "Email",
    readOnly: false,
    required: true,
    disabled: false,
    error: !validEmail,
    value: email,
    errorText: !validEmail ? email.length === 0 ? 'Please enter email' : 'Please enter a valid email' : '',
    onChange: handleEmailChange
  })), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: '10px'
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: configDetails !== null && configDetails !== void 0 && (_configDetails$params7 = configDetails.paramsDetails) !== null && _configDetails$params7 !== void 0 && (_configDetails$params8 = _configDetails$params7.theme) !== null && _configDetails$params8 !== void 0 && _configDetails$params8.isDark ? '#FFFFFF' : '#000000',
    bold: false
  }, "Solution")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      paddingTop: '5px'
    }
  }, /*#__PURE__*/React__default.createElement(CheckboxGroup, {
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params9 = configDetails.paramsDetails) !== null && _configDetails$params9 !== void 0 && (_configDetails$params0 = _configDetails$params9.theme) !== null && _configDetails$params0 !== void 0 && _configDetails$params0.isDark ? 'dark' : 'light',
    data: checkboxOptions,
    onChange: handleCheck
  }))), /*#__PURE__*/React__default.createElement(ModalFooter$1, null, /*#__PURE__*/React__default.createElement(ButtonGroup$1, {
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params1 = configDetails.paramsDetails) !== null && _configDetails$params1 !== void 0 && (_configDetails$params10 = _configDetails$params1.theme) !== null && _configDetails$params10 !== void 0 && _configDetails$params10.isDark ? 'dark' : 'light',
    childWidth: '100%',
    viewport: 'desktop',
    rowQuantity: {
      desktop: 2
    },
    data: [{
      children: 'Cancel',
      size: 'large',
      use: 'secondary',
      'data-clickstream': 'cancel - send email summary',
      'data-track': 'cancel - send email summary',
      'data-testid': "modal-close-button",
      onClick: function onClick() {
        handleOpenChanged(false);
      }
    }, {
      children: 'Send',
      size: 'large',
      use: 'primary',
      'data-clickstream': 'send email summary',
      'data-track': 'send email summary',
      disabled: !validEmail || checkedCount === 0 || email.length === 0,
      onClick: handleSend
    }]
  }))));
};

var _templateObject$x, _templateObject2$s;
var ContentWrapper$7 = styled.div(_templateObject$x || (_templateObject$x = _taggedTemplateLiteralLoose([""])));
var TiletWrapper = styled.div(_templateObject2$s || (_templateObject2$s = _taggedTemplateLiteralLoose(["\n  width:360px;\n  cursor:pointer;\n   [class*=OuterTileContainer-VDS]{\n \n     height:unset !important;\n   }\n"])));
var customFilterByAttrId = function customFilterByAttrId(arr, attr) {
  var _arr$filter, _arr$filter$;
  if (arr === void 0) {
    arr = [];
  }
  return ((_arr$filter = arr.filter(function (e) {
    return e.attrId === attr;
  })) === null || _arr$filter === void 0 ? void 0 : (_arr$filter$ = _arr$filter[0]) === null || _arr$filter$ === void 0 ? void 0 : _arr$filter$.value) || "";
};
var MidFlowButton = function MidFlowButton(_ref) {
  var _configDetails$params, _configDetails$params2;
  var uniquekey = _ref.uniquekey,
    _ref$actionButton = _ref.actionButton,
    actionButton = _ref$actionButton === void 0 ? {} : _ref$actionButton,
    handleOkClick = _ref.handleOkClick,
    isDark = _ref.isDark,
    handleNrbChkEligibilityLoader = _ref.handleNrbChkEligibilityLoader;
  var configDetails = useContext(ConfigContext);
  var paramContextDetails = useContext(ParamsContext);
  var _actionButton$text = actionButton.text,
    text = _actionButton$text === void 0 ? '' : _actionButton$text,
    _actionButton$value = actionButton.value,
    value = _actionButton$value === void 0 ? '' : _actionButton$value,
    _actionButton$popUpHt = actionButton.popUpHtmlContent,
    popUpHtmlContent = _actionButton$popUpHt === void 0 ? '' : _actionButton$popUpHt,
    _actionButton$descrip = actionButton.description,
    description = _actionButton$descrip === void 0 ? '' : _actionButton$descrip,
    _actionButton$macId = actionButton.macId,
    macId = _actionButton$macId === void 0 ? '' : _actionButton$macId,
    _actionButton$skuId = actionButton.skuId,
    skuId = _actionButton$skuId === void 0 ? '' : _actionButton$skuId,
    _actionButton$serialN = actionButton.serialNumber,
    serialNumber = _actionButton$serialN === void 0 ? '' : _actionButton$serialN;
  var _useState = useState(false),
    showModal = _useState[0],
    setShowModal = _useState[1];
  actionButton.nrbOeNethrowError = false;
  actionButton.nrbNeNotEligibleforOffer = false;
  actionButton.nrbOeNeChkEligibilityLoader = "no";
  console.log(configDetails, "-------------midflowbutton-----------", actionButton, handleOkClick, isDark);
  var envData = {
    externalTarget: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : _configDetails$params.externalTarget,
    mvoenv: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params2 = configDetails.paramsDetails) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.mvoenv
  };
  var _ref2 = useFeatureFlag() || {},
    _ref2$data = _ref2.data,
    _ref2$data2 = _ref2$data === void 0 ? {} : _ref2$data,
    _ref2$data2$networkEx = _ref2$data2.networkExtenderOfferFFlag,
    networkExtenderOfferFFlag = _ref2$data2$networkEx === void 0 ? false : _ref2$data2$networkEx;
  useEffect(function () {
    if (value === "Order Network Extender") {
      var _ref3 = configDetails || {},
        _ref3$paramsDetails = _ref3.paramsDetails,
        _ref3$paramsDetails2 = _ref3$paramsDetails === void 0 ? {} : _ref3$paramsDetails,
        openLaunchoutDialog = _ref3$paramsDetails2.openLaunchoutDialog;
      if (openLaunchoutDialog) {
        console.log("invoking openLaunchoutDialog-->");
        openLaunchoutDialog("NetworkExtender-Offer", "NetworkExtender-Offer", 0, 0, "", "MyOffersEquipment", '', '', '', '', 'MyOffersEquipment', true, true);
      }
    }
  }, []);
  var handleOpenChanged = function handleOpenChanged(modalState) {
    if (!modalState) {
      setShowModal(false);
    }
  };
  var openCustomPOSStartOrder = function openCustomPOSStartOrder(transactionTypeVar, JsonObj) {
    var _ref4 = configDetails || {},
      _ref4$paramsDetails = _ref4.paramsDetails,
      _ref4$paramsDetails2 = _ref4$paramsDetails === void 0 ? {} : _ref4$paramsDetails,
      _ref4$paramsDetails2$ = _ref4$paramsDetails2.launchoutConfig,
      launchoutConfig = _ref4$paramsDetails2$ === void 0 ? {} : _ref4$paramsDetails2$,
      messageListener = _ref4$paramsDetails2.messageListener;
    var messageData = {};
    messageData.action = "ACTION_FWD_DATA_FROM_NSA";
    messageData.payload = {
      viewId: "POSACSSView",
      forwardedData: {
        transactionType: transactionTypeVar,
        isStreamline: 'Y',
        rtdJSON: JsonObj
      }
    };
    messageData.src = "" + launchoutConfig['acss.launchout.host'];
    messageData.iframeId = "NetworkExtender-Offer";
    if (messageListener && messageListener.sendMessage) {
      messageListener.sendMessage(messageData);
      console.log("order view invoked-->", messageData);
    }
  };
  var posStartOrderClicked = function posStartOrderClicked(nrbPegaOffer) {
    if (nrbPegaOffer === void 0) {
      nrbPegaOffer = [];
    }
    try {
      var transactionTypeVar = "NAO";
      var _temp = function (_nrbPegaOffer) {
        if (networkExtenderOfferFFlag && ((_nrbPegaOffer = nrbPegaOffer) === null || _nrbPegaOffer === void 0 ? void 0 : _nrbPegaOffer.length) > 0) {
          var _ref5 = (paramContextDetails === null || paramContextDetails === void 0 ? void 0 : paramContextDetails.configDetails) || {},
            productId = _ref5.productId,
            category = _ref5.category,
            _skuId = _ref5.skuId;
          var _ref6 = (configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails) || {},
            loggedInUser = _ref6.loggedInUser,
            mdn = _ref6.mdn,
            accountNumber = _ref6.accountNumber;
          var _nrbPegaOffer$ = nrbPegaOffer[0],
            sessionId = _nrbPegaOffer$.sessionId,
            rank = _nrbPegaOffer$.rank,
            propositionId = _nrbPegaOffer$.propositionId,
            dispositionId = _nrbPegaOffer$.dispositionId,
            externalId = _nrbPegaOffer$.externalId,
            dynamicAttrList = _nrbPegaOffer$.dynamicAttrList,
            propositionMessage = _nrbPegaOffer$.propositionMessage,
            propositionName = _nrbPegaOffer$.propositionName,
            offerSubType = _nrbPegaOffer$.offerSubType,
            isSaveOffer = _nrbPegaOffer$.isSaveOffer;
          var feedbackApiPayload = {
            clientId: "VZW-ACSS",
            clientSessionId: "",
            userId: loggedInUser,
            userType: "",
            mtn: mdn,
            accountNumber: accountNumber,
            athenaSessionId: sessionId,
            rank: rank,
            propositionId: propositionId,
            externalID: externalId,
            dispositionOptionID: dispositionId
          };
          return Promise.resolve(offerFeedBackResponse(feedbackApiPayload, envData)).then(function (feedApiresponse) {
            console.log("feedApiresponse", feedApiresponse);
            var linesValue = [];
            var linesOfferValue = {};
            var offerValues = [];
            linesOfferValue['mtn'] = mdn;
            var offerValuesFirstObj = {};
            var reqComplianceIndicator = customFilterByAttrId(dynamicAttrList, "reqComplianceIndicator");
            var reqCompliance = customFilterByAttrId(dynamicAttrList, "reqCompliance");
            var requires = customFilterByAttrId(dynamicAttrList, "Requires");
            var aal = customFilterByAttrId(dynamicAttrList, "AAL");
            var mmtier = customFilterByAttrId(dynamicAttrList, "MMTIER");
            var offerValidationIndicator = customFilterByAttrId(dynamicAttrList, "offerValidationIndicator");
            var fulFillmentCode = customFilterByAttrId(dynamicAttrList, "fulFillmentCode");
            offerValuesFirstObj['barcodeId'] = "";
            offerValuesFirstObj['tradeInOffer'] = "";
            offerValuesFirstObj['rewardType'] = '';
            offerValuesFirstObj['reasonCode'] = "";
            offerValuesFirstObj['isHomeOffer'] = "";
            offerValuesFirstObj['url'] = [{
              "value": "",
              "urltype": ""
            }];
            offerValuesFirstObj['MtnList'] = '';
            offerValuesFirstObj['sku'] = fulFillmentCode || "";
            offerValuesFirstObj['requiresInd'] = requires;
            offerValuesFirstObj['aal'] = aal;
            offerValuesFirstObj['mmtier'] = mmtier;
            offerValuesFirstObj['propositionMessage'] = propositionMessage || '';
            offerValuesFirstObj['offerCompliance'] = reqComplianceIndicator;
            offerValuesFirstObj['mtn'] = mdn;
            offerValuesFirstObj['complianceType'] = reqCompliance;
            offerValuesFirstObj['description'] = propositionName || '';
            offerValuesFirstObj['compatibleIndicator'] = offerValidationIndicator;
            offerValuesFirstObj['propId'] = propositionId;
            offerValuesFirstObj['offerSubType'] = offerSubType || "";
            offerValuesFirstObj['isSaveOffer'] = isSaveOffer || "";
            offerValuesFirstObj['productId'] = productId || "";
            offerValuesFirstObj['category'] = category || "";
            offerValuesFirstObj['skuId'] = _skuId || "";
            offerValuesFirstObj['isFromTroubleshooting'] = true;
            offerValues.push(offerValuesFirstObj);
            linesOfferValue['offers'] = offerValues;
            linesValue.push(linesOfferValue);
            console.log("linesValue-->", linesValue);
            var JsonObj = {
              nsaVersion: true,
              isvzUpReward: false,
              offerSourceSystem: 'OC_PERSONALIZED',
              cartId: "",
              atenaSessionId: sessionId,
              nsaRequest: {
                lines: linesValue
              }
            };
            console.log("JSONObject-->", JsonObj);
            openCustomPOSStartOrder(transactionTypeVar, JsonObj);
          });
        }
      }();
      return Promise.resolve(_temp && _temp.then ? _temp.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var handleRemedySubmit = function handleRemedySubmit() {
    var _ref7 = configDetails || {},
      _ref7$paramsDetails = _ref7.paramsDetails,
      paramsDetails = _ref7$paramsDetails === void 0 ? {} : _ref7$paramsDetails;
    var viewRemedyPopup = paramsDetails.viewRemedyPopup,
      viewOrderSearchPopup = paramsDetails.viewOrderSearchPopup;
    if (viewRemedyPopup && typeof viewRemedyPopup === "function" && value.toLowerCase() === "view remedy tickets") {
      viewRemedyPopup();
    }
    if (viewOrderSearchPopup && typeof viewOrderSearchPopup === "function" && value.toLowerCase() === "ordersearchcomponent") {
      viewOrderSearchPopup();
    }
  };
  var handleSubmitModal = function handleSubmitModal() {
    if (value !== null && value !== undefined && (value.toLowerCase() === 'view remedy tickets' || value.toLowerCase() === 'ordersearchcomponent')) {
      handleRemedySubmit();
    } else {
      setShowModal(true);
    }
  };
  var handleSubmit = function handleSubmit() {
    try {
      var _temp5 = function _temp5(_result) {
        if (_exit) return _result;
        handleOkClick(actionButton);
      };
      var _exit = false;
      setShowModal(false);
      var _ref8 = configDetails || {},
        _ref8$paramsDetails = _ref8.paramsDetails,
        paramsDetails = _ref8$paramsDetails === void 0 ? {} : _ref8$paramsDetails,
        _ref8$caseId = _ref8.caseId,
        caseId = _ref8$caseId === void 0 ? '' : _ref8$caseId;
      var _paramsDetails$filter = paramsDetails.filteredNrbOffer,
        filteredNrbOffer = _paramsDetails$filter === void 0 ? [] : _paramsDetails$filter;
      var _temp4 = function () {
        if (!actionButton.url) {
          var fixedAssetDeviceReplacementPopup = paramsDetails.fixedAssetDeviceReplacementPopup,
            view5GTruckRollPopup = paramsDetails.view5GTruckRollPopup,
            viewFWAmovingPopup = paramsDetails.viewFWAmovingPopup,
            viewSuspendOrReconnectPopup = paramsDetails.viewSuspendOrReconnectPopup,
            viewCaseDetailsPopup = paramsDetails.viewCaseDetailsPopup,
            viewNetworkOutagePopup = paramsDetails.viewNetworkOutagePopup;
          if (value === "truckrollfwa" && view5GTruckRollPopup) {
            console.log("Truck Roll Invoked");
            view5GTruckRollPopup();
          }
          if (value === "fixedreplacefwa" && fixedAssetDeviceReplacementPopup) {
            console.log("fixedAssetDeviceReplacement Invoked");
            fixedAssetDeviceReplacementPopup();
          }
          if (value === "fixedreplacece1000a" && fixedAssetDeviceReplacementPopup) {
            console.log("fixedAssetDeviceReplacement5GExchangeExt Invoked");
            fixedAssetDeviceReplacementPopup({
              deviceMacId: macId,
              skuId: skuId,
              serialNumber: serialNumber,
              flowType: "5GExchangeExt"
            });
          }
          if (value === "lvmoversflow" && viewFWAmovingPopup) {
            console.log("viewFWAmovingPopup Invoked");
            viewFWAmovingPopup();
          }
          if (value === "lvvacationsuspend" && viewSuspendOrReconnectPopup) {
            console.log("viewSuspendOrReconnectPopup Invoked");
            viewSuspendOrReconnectPopup();
          }
          if (value === "lvfollowup" && viewCaseDetailsPopup) {
            console.log("viewCaseDetailsPopup Invoked");
            viewCaseDetailsPopup();
          }
          if (value === "nwoutage" && viewNetworkOutagePopup) {
            console.log("viewNetworkOutagePopup Invoked");
            viewNetworkOutagePopup(caseId);
            _exit = true;
            return;
          }
          if (value === "Order Network Extender") {
            console.log("start order clicked!!");
            posStartOrderClicked(filteredNrbOffer);
          }
        } else {
          var _temp3 = function () {
            if (value === "neofferaccepted") {
              console.log("------neofferaccepted");
              var _temp2 = function () {
                if (window.isMVODigital) {
                  redirectToNrbFlow(configDetails);
                } else {
                  var offerData = {
                    actionButton: actionButton,
                    handleNrbChkEligibilityLoader: handleNrbChkEligibilityLoader,
                    configDetails: configDetails
                  };
                  return Promise.resolve(chkNeAddOffer(offerData)).then(function () {});
                }
              }();
              if (_temp2 && _temp2.then) return _temp2.then(function () {});
            } else {
              var target = isMVA ? "_self" : "_blank";
              window.open(actionButton.url, target);
            }
          }();
          if (_temp3 && _temp3.then) return _temp3.then(function () {});
        }
      }();
      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp5) : _temp5(_temp4));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(ContentWrapper$7, {
    className: isDark && 'midflowContentWrapper',
    id: "midflowcontainer-" + uniquekey
  }, /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "30px"
  }), /*#__PURE__*/React__default.createElement(TiletWrapper, {
    id: "tilecontainer-" + uniquekey,
    role: "button",
    tabIndex: "0",
    "aria-label": text + " " + description,
    onClick: function onClick() {
      return handleSubmitModal();
    },
    onKeyPress: function onKeyPress() {
      return handleSubmitModal();
    },
    "data-analyticstrack": text,
    "data-track": "{\"type\": \"link\", \"name\": " + text + "}",
    "data-clickstream": text + "-link",
    isDark: isDark,
    "data-testid": "tilecontainer-" + uniquekey
  }, /*#__PURE__*/React__default.createElement(Tilelet, {
    id: "tile-" + uniquekey,
    viewport: "mobile",
    title: {
      bold: true,
      size: 'titleSmall',
      children: "" + text,
      primitive: 'h3'
    },
    subtitle: {
      size: 'bodySmall',
      children: "" + description
    },
    directionalIcon: {
      name: 'right-arrow',
      size: 'medium'
    },
    surface: isDark ? 'dark' : 'light',
    aspectRatio: "none",
    width: "360px",
    backgroundColor: isDark ? "black" : "gray"
  })), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "30px"
  }), /*#__PURE__*/React__default.createElement(Modal$1, {
    opened: showModal,
    ariaLabel: "warning-popup",
    fullScreenDialog: false,
    expandModal: false,
    onOpenedChange: handleOpenChanged,
    surface: isDark ? 'dark' : 'light'
  }, /*#__PURE__*/React__default.createElement(ModalBody$1, null, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: popUpHtmlContent
    }
  })), /*#__PURE__*/React__default.createElement(ModalFooter$1, null, /*#__PURE__*/React__default.createElement(ButtonGroup$1, {
    childWidth: '100%',
    viewport: 'desktop',
    rowQuantity: {
      desktop: 2
    },
    surface: isDark ? 'dark' : 'light',
    data: [{
      children: 'Cancel',
      size: 'large',
      use: 'secondary',
      'data-track': "{\"type\": \"link\", \"name\": \"Cancel\"}",
      onClick: function onClick() {
        return handleOpenChanged(false);
      }
    }, {
      children: 'Ok',
      size: 'large',
      use: 'primary',
      disabled: false,
      'data-track': "{\"type\": \"link\", \"name\": \"Ok\"}",
      onClick: handleSubmit
    }]
  }))));
};

var _templateObject$y, _templateObject2$t, _templateObject3$n;
var CarouselMain = styled.div(_templateObject$y || (_templateObject$y = _taggedTemplateLiteralLoose(["\n   width: 250px;\n   @media (max-width: 768px) {\n    width: 300px;\n    align-self:center;\n  }\n"])));
var TileLetDiv = styled.div(_templateObject2$t || (_templateObject2$t = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: center\n"])));
var ImageDiv = styled.div(_templateObject3$n || (_templateObject3$n = _taggedTemplateLiteralLoose(["\n    padding: 0 10px 10px;\n    img {\n        max-width: 160px;\n    }\n\n"])));
var computeImageSize = function computeImageSize(amount, type) {
  var defaultVal = type === "width" ? "100px" : "200px";
  if (typeof amount !== "string" || !amount) {
    return defaultVal;
  }
  var computed = Number(amount);
  if (isNaN(computed)) return defaultVal;
  if (type === "height" && computed >= 120 || type === "width" && computed >= 200) {
    computed = Math.floor(computed / 2);
  }
  return computed + "px";
};
var ImageCarousel = function ImageCarousel(_ref) {
  var _ref$imageDetails = _ref.imageDetails,
    imageDetails = _ref$imageDetails === void 0 ? [] : _ref$imageDetails;
  console.log("ImageDetails-->", imageDetails);
  var mappedImageData = imageDetails.map(function (obj) {
    var _obj$width = obj.width,
      width = _obj$width === void 0 ? "200" : _obj$width,
      _obj$height = obj.height,
      height = _obj$height === void 0 ? "400" : _obj$height,
      _obj$imageUrl = obj.imageUrl,
      imageUrl = _obj$imageUrl === void 0 ? '' : _obj$imageUrl;
    return {
      backgroundImage: imageUrl,
      showBorder: false,
      width: computeImageSize(width, "width"),
      height: computeImageSize(height, "height")
    };
  });
  return /*#__PURE__*/React__default.createElement(CarouselMain, null, imageDetails.length > 1 ? /*#__PURE__*/React__default.createElement(Carousel, {
    layout: "1UP",
    gutter: "20px",
    peek: "standard",
    surface: "light",
    paginationFill: "light",
    paginationInset: "12px",
    paginationDisplay: "persistent",
    aspectRatio: "2:3",
    slotAlignment: {
      vertical: 'middle',
      horizontal: 'center'
    },
    data: mappedImageData,
    renderItem: function renderItem(props) {
      return isMobile$1 ? /*#__PURE__*/React__default.createElement(Tilelet, _extends({}, props, {
        aspectRatio: "2:3",
        width: "300px",
        height: "350px"
      })) : /*#__PURE__*/React__default.createElement(Tilelet, props);
    }
  }) : imageDetails.length === 1 ? /*#__PURE__*/React__default.createElement(TileLetDiv, null, /*#__PURE__*/React__default.createElement(ImageDiv, null, /*#__PURE__*/React__default.createElement("img", {
    src: mappedImageData[0].backgroundImage,
    alt: "image"
  }))) : null);
};

var _templateObject$z, _templateObject2$u, _templateObject3$o, _templateObject4$n, _templateObject5$k, _templateObject6$h, _templateObject7$e;
var finalComps$3 = {
  styles: styledComps
};
if (window.isBAUACSS) {
  finalComps$3 = {
    styles: styledBauComps
  };
}
if (window.isMVODigital) {
  finalComps$3 = {
    styles: styledDigital
  };
}
var Probing$4 = finalComps$3.styles.Probing;
var DisplayList = styled.div(_templateObject$z || (_templateObject$z = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  background: ", ";\n  @media(min-width: 601px) {\n    padding: 20px 0px 15px 0px;\n  }\n  @media(max-width: 600px) {\n    padding: 15px 0px 15px 0px;\n  }\n\n  .keyBold {\n    font-weight: bold;\n  }\n"])), function (props) {
  return props !== null && props !== void 0 && props.isDark ? '#000' : '#F6F6F6';
});
var SelectDeviceOption = styled.div(_templateObject2$u || (_templateObject2$u = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  width:100%;\n  margin-top:18px;\n  .radioLabel {\n    font-weight:normal !important;\n    font-size:15px;\n    position:relative;\n    bottom:0;\n  }\n"])));
var CantFindDevice = styled.div(_templateObject3$o || (_templateObject3$o = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display:flex;\n  flex-wrap: wrap;\n  justify-content: right;\n  align-items: right;\n  padding: 0px 20px 10px 0px ;\n  text-decoration: underline;\n  cursor: pointer;\n  color: #000;\n\n  &:hover {\n    color: #000;\n    text-decoration: none;\n  }\n\n  .cantFindMydeviceClass {\n    text-decoration: none;\n     color: ", " ;\n  }\n\n  .cantFindMydeviceClass:hover {\n    text-decoration: underline;\n     color: ", " ;\n  }\n"])), function (props) {
  return props.isDark ? '#fff' : '#000';
}, function (props) {
  return props.isDark ? '#fff' : '#000';
});
var DisplayDeviceList = styled.div(_templateObject4$n || (_templateObject4$n = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n"])));
var EachBlock = styled.div(_templateObject5$k || (_templateObject5$k = _taggedTemplateLiteralLoose(["\n  // position: relative;\n  min-height: 240px;\n  margin: 8px;\n  border: 0px solid lightgray;\n  background: #FFFFFF;\n  display: flex;\n  flex-direction: column;\n  padding:10px 15px 10px 10px;\n\n  :first-child {\n    margin-left:10px;\n  }\n\n  .device-info {\n    display: flex;\n    height: inherit;\n    flex-direction: column;\n\n  }\n\n  @media(min-width: 601px) {\n    width: ", ";;\n  }\n  @media(max-width: 600px) {\n    width: 69%;\n    height: auto;\n    padding: 0px 5px 0px 5px;\n    // margin: 0 auto;\n  }\n"])), function (props) {
  return props.isMvoDigi ? "20%" : "23%";
});
var Content = styled.div(_templateObject6$h || (_templateObject6$h = _taggedTemplateLiteralLoose(["\n  padding: 6px 0px 10px 0px;\n\n  .iconSignalClass {\n    flex-direction:column;\n\n  }\n  .iconSignalContent {\n    flex-direction:column;\n    padding-left:5px;\n  }\n  .emptyDiv {\n    line-height:10px;\n  }\n  .contentStyle {\n    font-size:13px;\n  }\n  .contentSize14 {\n    display:flex;\n    font-size:14px;\n  }\n"])));
var ButtonWrapper$7 = styled.div(_templateObject7$e || (_templateObject7$e = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display:flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  padding: 6px 10px 10px 10px;\n  margin-top: auto;\n  // position: absolute;\n  // bottom: 0;\n"])));
var SvgWifi = function SvgWifi(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    style: {
      "margin-left": ""
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M5.2 11.6l.8.8c1.6-1.6 4.3-1.6 5.9 0l.8-.8c-1-1-2.3-1.6-3.7-1.6-1.4.1-2.8.6-3.8 1.6zM2.5 9l.8.8C4.9 8.3 6.8 7.4 9 7.4c2.1 0 4.1.8 5.6 2.3l.8-.7c-1.7-1.7-4-2.7-6.4-2.7-2.5 0-4.7.9-6.5 2.7z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M9 2.6c-3.4 0-6.6 1.3-9 3.7l.8.8C3 5 5.9 3.8 9 3.8s6 1.2 8.2 3.4l.8-.9c-2.4-2.4-5.6-3.7-9-3.7zM7.6 14l1.3 1.3 1.3-1.3c-.7-.7-1.9-.7-2.6 0z"
  }));
};
var SvgNo = function SvgNo(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    style: {
      "margin-left": ""
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.4 18.5",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M9.2.2c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm-7.9 9c0-4.3 3.5-7.9 7.9-7.9 2 0 3.8.7 5.1 1.9l-11 11.2c-1.2-1.4-2-3.2-2-5.2zm7.9 7.9c-2 0-3.8-.7-5.1-1.9L15.2 4.1c1.2 1.4 1.9 3.2 1.9 5.1 0 4.4-3.5 7.9-7.9 7.9z"
  }));
};
var MultiDeviceList = function MultiDeviceList(_ref) {
  var listOfMultiDevices = _ref.listOfMultiDevices,
    handleAction = _ref.handleAction,
    templateId = _ref.templateId,
    handleSelDeviceOptionsChange = _ref.handleSelDeviceOptionsChange,
    selectedTab = _ref.selectedTab,
    selectedOption = _ref.selectedOption,
    searchInput = _ref.searchInput,
    isDark = _ref.isDark;
  console.log("@@@@@@@@@@@@@listOfMultiDevices@@@@@@@@@@@@@");
  var filteredDeviceList = "";
  var _useState = useState([]),
    devicesToRender = _useState[0],
    setDevicesToRender = _useState[1];
  var _useState2 = useState(true),
    showMoreCta = _useState2[0],
    setShowMoreCta = _useState2[1];
  var _useState3 = useState(1),
    poorCount = _useState3[0],
    setPoorCount = _useState3[1];
  var _useState4 = useState(1),
    connectedCount = _useState4[0],
    setConnectedCount = _useState4[1];
  var _useState5 = useState(1),
    inactiveCount = _useState5[0],
    setInactiveCount = _useState5[1];
  var deviceCount = 4;
  useEffect(function () {
    filteredDeviceList = filterDeviceList(searchInput.trim(), selectedTab, listOfMultiDevices);
    console.log("filteredDeviceList-----@@@", filteredDeviceList);
    if (selectedTab === "poor") {
      setDevicesToRender(filteredDeviceList.slice(0, poorCount * deviceCount));
      setShowMoreCta(filteredDeviceList.length > parseInt(poorCount * deviceCount));
    }
    if (selectedTab === "good") {
      setDevicesToRender(filteredDeviceList.slice(0, connectedCount * deviceCount));
      setShowMoreCta(filteredDeviceList.length > parseInt(connectedCount * deviceCount));
    }
    if (selectedTab === "InActive") {
      setDevicesToRender(filteredDeviceList.slice(0, inactiveCount * deviceCount));
      setShowMoreCta(filteredDeviceList.length > parseInt(inactiveCount * deviceCount));
    }
  }, [selectedTab, searchInput]);
  var handleShowMore = function handleShowMore() {
    console.log("!!!!!filteredDeviceList!!!!");
    var filteredDeviceList = filterDeviceList(searchInput.trim(), selectedTab, listOfMultiDevices);
    console.log(filteredDeviceList);
    if (selectedTab === "poor") {
      setDevicesToRender(filteredDeviceList.slice(0, parseInt(poorCount + 1) * deviceCount));
      setShowMoreCta(filteredDeviceList.length > parseInt(parseInt(poorCount + 1) * deviceCount));
      setPoorCount(poorCount + 1);
    }
    if (selectedTab === "good") {
      setDevicesToRender(filteredDeviceList.slice(0, parseInt(connectedCount + 1) * deviceCount));
      setShowMoreCta(filteredDeviceList.length > parseInt(parseInt(connectedCount + 1) * deviceCount));
      setConnectedCount(connectedCount + 1);
    }
    if (selectedTab === "InActive") {
      setDevicesToRender(filteredDeviceList.slice(0, parseInt(inactiveCount + 1) * deviceCount));
      setShowMoreCta(filteredDeviceList.length > parseInt(parseInt(inactiveCount + 1) * deviceCount));
      setInactiveCount(inactiveCount + 1);
    }
    console.log("############");
    console.log(devicesToRender);
    console.log(showMoreCta);
  };
  var filterDeviceList = function filterDeviceList(searchText, selectedTab, listOfMultiDevices) {
    var filteredDeviceListObj = listOfMultiDevices;
    if (selectedTab) {
      filteredDeviceListObj = filteredDeviceListObj.filter(function (device) {
        return device.DeviceType === selectedTab;
      });
    }
    if (searchText) {
      filteredDeviceListObj = filteredDeviceListObj.filter(function (device) {
        return device["Host Name"].toLowerCase().includes(searchText.toLowerCase()) && device.DeviceType === selectedTab;
      });
    }
    console.log("############filteredDeviceListObj#####");
    console.log(filteredDeviceListObj);
    return filteredDeviceListObj;
  };
  var renderDeviceInfo = function renderDeviceInfo(singleDevice, hostName) {
    var stroke = "#d73629";
    if (singleDevice.DeviceType === "good") {
      stroke = "#2B9853";
    }
    var IconSignal = /*#__PURE__*/React__default.createElement(SvgWifi, {
      stroke: stroke
    });
    if (singleDevice.DeviceType === "InActive") {
      IconSignal = /*#__PURE__*/React__default.createElement(SvgNo, null);
    }
    if (hostName) {
      return Object.entries(singleDevice).map(function (info, index) {
        console.log("!!!!!!!!!!!!!!!!info");
        console.log(info[0]);
        if (info[0] === "Host Name") {
          return /*#__PURE__*/React__default.createElement(Content, {
            key: index
          }, info[0] !== "Host Name" ? /*#__PURE__*/React__default.createElement("div", {
            className: "a-bold"
          }, info[0]) : /*#__PURE__*/React__default.createElement("div", {
            className: "emptyDiv"
          }, "\xA0"), /*#__PURE__*/React__default.createElement("div", {
            className: " contentSize14"
          }, info[0] === "Host Name" ? /*#__PURE__*/React__default.createElement("div", {
            className: "iconSignalClass"
          }, IconSignal, " \xA0") : null, " ", /*#__PURE__*/React__default.createElement("div", {
            className: "iconSignalContent"
          }, formatContent(info[1]))));
        }
      });
    } else {
      return Object.entries(singleDevice).map(function (info, index) {
        console.log("!!!!!!!!!!!!!!!!info");
        console.log(info[0]);
        if (info[0] === "MAC Address" || info[0] === "APSSID" || info[0] === "Host Name") {
          return /*#__PURE__*/React__default.createElement(Content, {
            key: index
          }, info[0] !== "Host Name" ? /*#__PURE__*/React__default.createElement("div", {
            className: "a-bold contentStyle"
          }, info[0] === "APSSID" ? "SSID" : info[0]) : null, /*#__PURE__*/React__default.createElement("div", {
            className: (info[0] === "Host Name" ? "keyBold" : "contentStyle") + " "
          }, info[1]));
        }
      });
    }
  };
  var formatContent = function formatContent(content) {
    console.log("@@@@@@@@content");
    console.log(content);
    console.log(content.split(":", 1));
    console.log(content.split(content.split(":", 1)[0]));
    if (content.length > 20) {
      return content.split(":", 1)[0] + " : " + content.split(content.split(":", 1)[0])[1];
    }
    return content;
  };
  var getMACAddress = function getMACAddress(singleDevice) {
    var _Object$entries$filte;
    return (_Object$entries$filte = Object.entries(singleDevice).filter(function (info) {
      return info[0] === "MAC Address";
    })[0]) === null || _Object$entries$filte === void 0 ? void 0 : _Object$entries$filte[1];
  };
  var iCantFindDeviceFunc = function iCantFindDeviceFunc() {
    return /*#__PURE__*/React__default.createElement("a", {
      size: "small",
      width: isMobile() ? '100%' : undefined,
      secondary: true,
      className: "cantFindMydeviceClass",
      onClick: function onClick() {
        return handleAction({
          label: "I can't find device",
          action: "Device not listed",
          type: "primary",
          url: "",
          callFunction: ""
        }, "I can't find device");
      }
    }, "I can't find my device");
  };
  var renderSelectDeviceOptionBtn = function renderSelectDeviceOptionBtn(index, macAddr) {
    return /*#__PURE__*/React__default.createElement(Probing$4, null, /*#__PURE__*/React__default.createElement(SelectDeviceOption, null, /*#__PURE__*/React__default.createElement("label", {
      className: "container"
    }, /*#__PURE__*/React__default.createElement("input", {
      onChange: function onChange(e) {
        return handleSelDeviceOptionsChange(e.target.value);
      },
      className: "Radio",
      type: "radio",
      value: macAddr,
      name: "issues",
      role: "radio",
      id: "box-" + index,
      tabIndex: "0",
      checked: selectedOption === macAddr
    }), /*#__PURE__*/React__default.createElement("span", {
      className: "checkmark"
    }), /*#__PURE__*/React__default.createElement("label", {
      className: "radioLabel",
      htmlFor: "box-" + index
    }, "Select Device"))));
  };
  var renderDeviceList = function renderDeviceList() {
    if (devicesToRender.length > 0) {
      return devicesToRender.map(function (singleDevice, index) {
        console.log("!!!!!!!!!!!!!!listOfMultiDevices.length");
        console.log(singleDevice);
        console.log(templateId);
        console.log(index);
        return /*#__PURE__*/React__default.createElement(EachBlock, {
          key: index,
          isMvoDigi: window.isMVODigital
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "device-info"
        }, renderDeviceInfo(singleDevice, false), renderDeviceInfo(singleDevice, true)), renderSelectDeviceOptionBtn(index, getMACAddress(singleDevice)));
      });
    }
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(DisplayList, {
    "data-testid": "device-list",
    isDark: isDark
  }, /*#__PURE__*/React__default.createElement(CantFindDevice, {
    isDark: isDark
  }, iCantFindDeviceFunc()), /*#__PURE__*/React__default.createElement(DisplayDeviceList, null, renderDeviceList(), showMoreCta && /*#__PURE__*/React__default.createElement(ButtonWrapper$7, {
    className: "trg-multidevice-showmore"
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    size: "small",
    disabled: false,
    use: "secondary",
    onClick: handleShowMore
  }, "Show more")))));
};
MultiDeviceList.propTypes = {};
MultiDeviceList.defaultProps = {};

var _templateObject$A, _templateObject2$v, _templateObject3$p, _templateObject4$o, _templateObject5$l, _templateObject6$i, _templateObject7$f, _templateObject8$e, _templateObject9$c, _templateObject0$a, _templateObject1$a;
var StepInfoContainer$4 = styled.div(_templateObject$A || (_templateObject$A = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  @media(min-width: 601px) {\n    /*padding: 10px 50px 15px 50px;*/\n  }\n  @media(max-width: 600px){\n    /*padding: 5px 15px 5px 15px;*/\n  }\n"])));
var SelectionBox = styled.div(_templateObject2$v || (_templateObject2$v = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  padding: 12px 0 0 0;\n  float: left;\n  .selectedTab {\n    border-bottom: 4px solid #d52b1e;\n    color: ", ";\n\n  }\n"])), function (props) {
  return props.isDark ? '#fff' : "#000";
});
var SelectedItem = styled.div(_templateObject3$p || (_templateObject3$p = _taggedTemplateLiteralLoose(["\n  // padding-right: 20px;\n  z-index: 1;\n  padding-bottom: 12px;\n  cursor: pointer;\n  margin-right: 20px;\n  font-weight: bold;\n  color: gray;\n  &:last-of-type{\n    margin-right: 0;\n  }\n  @media(min-width: 601px) {\n    font-size: 15px;\n  }\n  @media(max-width: 600px) {\n    font-size: 13px;\n  }\n"])));
var ButtonWrapper$8 = styled.div(_templateObject4$o || (_templateObject4$o = _taggedTemplateLiteralLoose(["\n  padding-bottom: 25px;\n  @media screen and (max-width: 600px) {\n    display:none\n  }\n"])));
var ButtonWrapperMobile$3 = styled.div(_templateObject5$l || (_templateObject5$l = _taggedTemplateLiteralLoose(["\n  width: 50%;\n  margin:0px auto;\n  @media screen and (min-width: 600px) {\n    display:none\n  }\n"])));
var SearchContainer$1 = styled.div(_templateObject6$i || (_templateObject6$i = _taggedTemplateLiteralLoose(["\n  margin-top: 15px;\n  margin-bottom: 0px;\n  width:  100%;\n"])));
var SearchWrapper$1 = styled.div(_templateObject7$f || (_templateObject7$f = _taggedTemplateLiteralLoose(["\n  position: relative;\n  @media(min-width:601px) {\n    float: right;\n  }\n"])));
var SearchBox$1 = styled.input(_templateObject8$e || (_templateObject8$e = _taggedTemplateLiteralLoose(["\n  z-index: -1;\n  border: none;\n  -webkit-border-radius: 2rem;\n  -moz-border-radius: 2rem;\n  border-radius: 2rem;\n  font-size: 1rem;\n  height: 5px;\n  padding: 1rem;\n  background-color: #E0E3E7;\n  font-weight: bolder;\n  ::placeholder {\n    font-weight: 30px;\n    margin-left: 20px;\n  }\n  :focus {\n    border: none;\n    outline: none;\n  }\n  @media(min-width:601px) {\n    width: 85%;\n  }\n  @media(max-width:601px) {\n    width: 80%;    \n  }\n"])));
var SearchButtonsWrapper = styled.div(_templateObject9$c || (_templateObject9$c = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  width: -6em;\n  margin-top: -1em;\n  position: absolute;\n  top: 65%;\n  right: 2rem;\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n  background-repeat: no-repeat;\n  background-size: 10;0%;\n  @media(max-width:601px) {\n    right: 3rem;\n  }\n"])));
var SearchButton = styled.button(_templateObject0$a || (_templateObject0$a = _taggedTemplateLiteralLoose(["\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n  @media(max-width:601px) {\n    position: absolute;\n    right: 0px;\n  }\n"])));
var NoDeviceMessage = styled.div(_templateObject1$a || (_templateObject1$a = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  ul {\n    margin: 10px 0 0 0;\n    padding-left: 15px;\n  }\n"])));
var tabsData = [{
  selection: "Poor WiFi",
  DeviceType: "poor",
  count: 0
}, {
  selection: "Connected",
  DeviceType: "good",
  count: 0
}, {
  selection: "In-active",
  DeviceType: "InActive",
  count: 0
}];
var getTabsData = function getTabsData(devices) {
  var countPoorWifi = 0,
    countConnected = 0,
    countInActive = 0;
  devices.forEach(function (device) {
    if (device.DeviceType === "poor") {
      countPoorWifi++;
    }
    if (device.DeviceType === "good") {
      countConnected++;
    }
    if (device.DeviceType === "InActive") {
      countInActive++;
    }
  });
  var tempTabsData = JSON.parse(JSON.stringify(tabsData));
  tempTabsData.forEach(function (tab) {
    if (tab.DeviceType === "poor") {
      tab.count = countPoorWifi;
    }
    if (tab.DeviceType === "good") {
      tab.count = countConnected;
    }
    if (tab.DeviceType === "InActive") {
      tab.count = countInActive;
    }
  });
  console.log("!!!!!!!!!!!!!!tempTabsData");
  console.log(tempTabsData);
  return tempTabsData;
};
var MultiDevices = function MultiDevices(props) {
  var _steps$, _steps$2, _steps$3, _configDetails$params, _configDetails$params2, _configDetails$params3, _configDetails$params4;
  console.log("comren: Devices===", props);
  var _props$values = props.values,
    values = _props$values === void 0 ? {} : _props$values,
    _props$functions = props.functions,
    functions = _props$functions === void 0 ? {} : _props$functions,
    selectedOption = props.selectedOption,
    handleMulSelDeviceOptionsChange = props.handleMulSelDeviceOptionsChange;
  var _values$troubleShooti = values.troubleShootingInfo,
    troubleShootingInfo = _values$troubleShooti === void 0 ? {} : _values$troubleShooti;
  var _useState = useState(false),
    setBtnValue = _useState[1];
  var _useState2 = useState(""),
    searchInput = _useState2[0];
  var _useState3 = useState("poor"),
    selectedTab = _useState3[0],
    setSelectedTab = _useState3[1];
  var _useState4 = useState("");
  var output = getObjectPropertyByPath("ddata.output", troubleShootingInfo, {});
  var _output$pageContent = output.pageContent,
    pageContent = _output$pageContent === void 0 ? {} : _output$pageContent;
  var _pageContent$steps = pageContent.steps,
    steps = _pageContent$steps === void 0 ? [] : _pageContent$steps;
  var analysis = getStepByName("analysis", steps);
  var resolution = getStepByName("resolution", steps);
  var closure = getStepByName("closure", steps);
  console.log("!!!!!!!!!!!!!steps");
  console.log(steps);
  console.log(steps === null || steps === void 0 ? void 0 : (_steps$ = steps[0]) === null || _steps$ === void 0 ? void 0 : _steps$.templateId);
  var stepObject = "";
  if ((steps === null || steps === void 0 ? void 0 : (_steps$2 = steps[0]) === null || _steps$2 === void 0 ? void 0 : _steps$2.templateId) === "SELECT_DEVICE") {
    stepObject = steps[0];
  } else if ((steps === null || steps === void 0 ? void 0 : (_steps$3 = steps[1]) === null || _steps$3 === void 0 ? void 0 : _steps$3.templateId) === "SELECT_DEVICE") {
    stepObject = steps[1];
  }
  var resolutionTemplateId = stepObject.templateId;
  var listOfDevicesData = getListOfDevicesStepObj(stepObject);
  console.log("%%%%%%%%%%listOfDevicesData%%%%%%%%");
  console.log(listOfDevicesData);
  var _useState5 = useState(listOfDevicesData),
    listOfMultiDevices = _useState5[0];
  var _useState6 = useState(getTabsData(listOfDevicesData));
  var _useState7 = useState(getTabsData(listOfDevicesData)),
    tabsHead = _useState7[0];
  var configDetails = useContext(ConfigContext);
  var handleTabSelection = function handleTabSelection(selectedTab) {
    setSelectedTab(selectedTab);
  };
  var handleAction = function handleAction(button, val) {
    console.log("!!!!!!!!!!!!!!!!button");
    console.log(button);
    console.log(val);
    if (val === "I can't find device") {
      var findDevices = "I can't find device";
      console.log("Device:handleAction: called with action====: " + button.action);
      if (functions.handleTroubleShootingAction) {
        functions.handleTroubleShootingAction(button, {
          findDevices: findDevices
        });
        setBtnValue(true);
      }
    }
  };
  var handleSelDeviceOptionsChange = function handleSelDeviceOptionsChange(macAddress) {
    handleMulSelDeviceOptionsChange(macAddress);
  };
  var renderTabs = function renderTabs() {
    var cssClass;
    console.log("$$$$$$$$$$$tabs");
    console.log(tabsHead);
    return tabsHead.map(function (tab) {
      cssClass = "";
      if (selectedTab === tab.DeviceType) {
        cssClass = "selectedTab";
      }
      return /*#__PURE__*/React__default.createElement(SelectedItem, {
        key: tab.DeviceType,
        className: "" + cssClass,
        onClick: function onClick() {
          return handleTabSelection(tab.DeviceType);
        }
      }, /*#__PURE__*/React__default.createElement("span", null, tab.selection), /*#__PURE__*/React__default.createElement("span", null, " (", tab.count, ") "));
    });
  };
  var renderNoDeviceMessage = function renderNoDeviceMessage() {
    if (listOfMultiDevices.length == 0) {
      return /*#__PURE__*/React__default.createElement(NoDeviceMessage, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", null, "Sorry, no results matched your search.")), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", null, "Suggestions"), /*#__PURE__*/React__default.createElement("ul", null, /*#__PURE__*/React__default.createElement("li", null, "Please connect your device to the Wifi network (Joe's-wifi)"), /*#__PURE__*/React__default.createElement("li", null, "If you are having trouble with connecting your device, please click \"Can't find my device\".")));
    }
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(StepInfoContainer$4, null, /*#__PURE__*/React__default.createElement(SearchContainer$1, null, /*#__PURE__*/React__default.createElement(SelectionBox, {
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : (_configDetails$params2 = _configDetails$params.theme) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.isDark
  }, renderTabs())), /*#__PURE__*/React__default.createElement(MultiDeviceList, {
    buttons: stepObject.cta,
    listOfMultiDevices: listOfMultiDevices,
    templateId: stepObject.templateId,
    resolutionTemplateId: resolutionTemplateId,
    handleSelDeviceOptionsChange: handleSelDeviceOptionsChange,
    selectedOption: selectedOption,
    selectedTab: selectedTab,
    searchInput: searchInput.trim(),
    handleAction: handleAction,
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params3 = configDetails.paramsDetails) === null || _configDetails$params3 === void 0 ? void 0 : (_configDetails$params4 = _configDetails$params3.theme) === null || _configDetails$params4 === void 0 ? void 0 : _configDetails$params4.isDark
  }), renderNoDeviceMessage()), window.isMVODigital && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "20px"
  }), /*#__PURE__*/React__default.createElement(FeedbackContainer, {
    functions: functions,
    values: values,
    handleModalState: props.handleModalState,
    flags: props.flags
  })));
};
MultiDevices.propTypes = {
  functions: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
};
MultiDevices.defaultProps = {};

var _templateObject$B;
var FormContainer = styled.div(_templateObject$B || (_templateObject$B = _taggedTemplateLiteralLoose(["\nmargin: 1.5em 0;\nmax-width: ", ";\n"])), window.isMVODigital ? 'unset' : '350px');
var UserInput = function UserInput(props) {
  var _props$isDisabled = props.isDisabled,
    isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
    _props$forwardValue = props.forwardValue,
    forwardValue = _props$forwardValue === void 0 ? function () {} : _props$forwardValue;
  var _useState = useState(''),
    input = _useState[0],
    setInput = _useState[1];
  var _useState2 = useState(false),
    hasError = _useState2[0],
    setHasError = _useState2[1];
  var _useState3 = useState('Enter a valid location'),
    errorText = _useState3[0],
    setErrorText = _useState3[1];
  var hasSpecialChars = function hasSpecialChars(string) {
    if (string === void 0) {
      string = '';
    }
    return /[-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?'"\\]/g.test(string);
  };
  var changeHandler = function changeHandler(e) {
    var value = e.target.value;
    console.log(value);
    setInput(value);
    var hasError = hasSpecialChars(value);
    setHasError(hasError === true);
    setErrorText(hasError ? 'Special characters not allowed' : 'Enter a valid location');
    forwardValue({
      target: {
        value: hasError ? '' : value.trim()
      }
    });
  };
  return /*#__PURE__*/React__default.createElement("form", null, /*#__PURE__*/React__default.createElement(FormContainer, null, /*#__PURE__*/React__default.createElement(Input$1, {
    type: "text",
    label: "Enter a custom location:",
    readOnly: false,
    required: true,
    disabled: isDisabled,
    error: hasError,
    value: input,
    errorText: errorText,
    onChange: changeHandler
  })));
};

var SelectDeviceBanner = function SelectDeviceBanner(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'info' : _ref$type;
  var paramsContext = useContext(ModalContext) || {};
  console.log("context", paramsContext);
  var _paramsContext$additi = paramsContext.additionalInfoSteps,
    additionalInfoSteps = _paramsContext$additi === void 0 ? [] : _paramsContext$additi;
  var bannerObject = additionalInfoSteps.find(function (e) {
    return e.templateId === "EOT_SELECT_DEVICE";
  });
  var _ref2 = bannerObject || {},
    _ref2$description = _ref2.description,
    description = _ref2$description === void 0 ? '' : _ref2$description,
    _ref2$title = _ref2.title,
    title = _ref2$title === void 0 ? '' : _ref2$title;
  console.log("paramsDetails", additionalInfoSteps);
  var handleCtaClick = function handleCtaClick(e) {
    window.location.href = "/support/devices";
  };
  var content = description.replace(/<p[^>]*>|<\/p>|[\n]/g, '');
  return /*#__PURE__*/React__default.createElement(Fragment, null, bannerObject && /*#__PURE__*/React__default.createElement(Notification, {
    type: type,
    title: title,
    subtitle: content,
    surface: "light",
    disableAnimation: false,
    fullBleed: false,
    hideCloseButton: false,
    disableFocus: true,
    inline: false,
    layout: null,
    buttonData: [{
      children: 'Select device',
      onClick: handleCtaClick
    }]
  }));
};

var _templateObject$C, _templateObject2$w, _templateObject3$q, _templateObject4$p;
var DeviceActive = styled.span(_templateObject$C || (_templateObject$C = _taggedTemplateLiteralLoose(["\n  color:green;\n"])));
var DeviceInActive = styled.span(_templateObject2$w || (_templateObject2$w = _taggedTemplateLiteralLoose(["\n  color:red;\n"])));
var NoDeviceAvailable = styled.span(_templateObject3$q || (_templateObject3$q = _taggedTemplateLiteralLoose(["\n  color:red;\n"])));
var TableDeviceConnectWrapper = styled.div(_templateObject4$p || (_templateObject4$p = _taggedTemplateLiteralLoose(["\n    .tableHeadCol {\n      width:32%;\n      @media(max-width: 600px) {\n        padding-left:0.5rem;\n        padding-right:0.5rem;\n      }\n    }\n    .tableTdCol {\n      @media(max-width: 600px) {\n        padding-left:0.5rem;\n        padding-right:0.5rem;\n      }\n    }\n"])));
var DeviceConnected = function DeviceConnected(props) {
  var _stepObject$;
  console.log("Devices: DeviceConnected===", props);
  var _props$values = props.values,
    values = _props$values === void 0 ? {} : _props$values;
  var _values$troubleShooti = values.troubleShootingInfo,
    troubleShootingInfo = _values$troubleShooti === void 0 ? {} : _values$troubleShooti;
  var output = getObjectPropertyByPath("ddata.output", troubleShootingInfo, {});
  var _output$pageContent = output.pageContent,
    pageContent = _output$pageContent === void 0 ? {} : _output$pageContent;
  var _pageContent$steps = pageContent.steps,
    steps = _pageContent$steps === void 0 ? [] : _pageContent$steps;
  var analysis = getStepByName("analysis", steps);
  var resolution = getStepByName("resolution", steps);
  var stepObject = "";
  console.log("!!!!!!!!!deviceList");
  console.log(pageContent);
  console.log(steps);
  console.log(analysis);
  console.log(resolution);
  console.log(steps);
  stepObject = steps.filter(function (obj) {
    console.log(obj.templateId);
    return obj.templateId === 'CONFIRM_DEVICE_SHOW_ACTIVE';
  });
  console.log(stepObject);
  console.log("@@@@@@@@@@@stepObject");
  var deviceList = (_stepObject$ = stepObject[0]) === null || _stepObject$ === void 0 ? void 0 : _stepObject$.devices;
  var handleDeviceSelection = function handleDeviceSelection(devicesList) {
    var deviceListGridRender = [];
    var deviceListGridArray = [];
    var deviceArray = devicesList === null || devicesList === void 0 ? void 0 : devicesList.map(function (devicesObj, index) {
      var deviceOutputArray = [];
      var ddevice = devicesObj.device;
      deviceListGridArray = ddevice === null || ddevice === void 0 ? void 0 : ddevice.map(function (obj, idx) {
        if (obj.key === 'Host Name' || obj.key === 'MAC Address' || obj.key === 'Active') {
          deviceOutputArray[obj.key] = obj.value;
        }
      });
      if (deviceOutputArray) {
        deviceListGridRender.push(deviceOutputArray);
      }
    });
    console.log("#########deviceListGridRender");
    console.log(deviceListGridRender);
    if (deviceListGridRender.length > 0) {
      return deviceListGridRender.map(function (deviceObj) {
        return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(Cell$1, {
          className: "tableTdCol"
        }, deviceObj['Host Name']), /*#__PURE__*/React__default.createElement(Cell$1, {
          className: "tableTdCol"
        }, deviceObj['MAC Address']), /*#__PURE__*/React__default.createElement(Cell$1, {
          className: "tableTdCol"
        }, typeof deviceObj['Active'] !== 'undefined' ? deviceObj['Active'] === 'true' ? /*#__PURE__*/React__default.createElement(DeviceActive, null, "Active") : /*#__PURE__*/React__default.createElement(DeviceInActive, null, "Inactive") : '')));
      });
    } else {
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(NoDeviceAvailable, null, "No devices available"));
    }
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TableDeviceConnectWrapper, null, /*#__PURE__*/React__default.createElement(Table, {
    striped: true
  }, /*#__PURE__*/React__default.createElement(TableHead, null, /*#__PURE__*/React__default.createElement(TableHeader$1, {
    className: "tableHeadCol"
  }, "Device name"), /*#__PURE__*/React__default.createElement(TableHeader$1, {
    className: "tableHeadCol"
  }, "MAC Address"), /*#__PURE__*/React__default.createElement(TableHeader$1, {
    className: "tableHeadCol"
  }, "Status")), /*#__PURE__*/React__default.createElement(TableBody, null, handleDeviceSelection(deviceList)))));
};
DeviceConnected.propTypes = {
  values: PropTypes.object.isRequired
};
DeviceConnected.defaultProps = {};

var useDebounce = function useDebounce(cb, delay) {
  if (delay === void 0) {
    delay = 500;
  }
  var id;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (id) {
      clearTimeout(id);
    }
    id = setTimeout(function () {
      cb.apply(void 0, args);
    }, delay);
  };
};

var _templateObject$D, _templateObject2$x, _templateObject3$r, _templateObject4$q, _templateObject5$m, _templateObject6$j;
var Imgprobequestion = styled.div(_templateObject$D || (_templateObject$D = _taggedTemplateLiteralLoose(["\n    margin-top: 10px;\n    margin-bottom: 16px;\n"])));
var DeviceContainerMain = styled.div(_templateObject2$x || (_templateObject2$x = _taggedTemplateLiteralLoose(["\n    display: grid;\n    gap: 30px;\n    grid-template-columns: 1fr 1fr 1fr;\n    margin-bottom: 30px;\n    ", " \n    @media(max-width: 600px){\n        grid-template-columns: 1fr;\n        }\n    "])), function (_ref) {
  var isMVO = _ref.isMVO;
  return isMVO === true && "\n    grid-template-columns: 1fr 1fr\n        ";
});
var DeviceTileContainer = styled.div(_templateObject3$r || (_templateObject3$r = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    // box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;\n    padding: 20px;\n    border-radius: 8px;\n    background-color: ", ";\n    width:220px;\n    align-self: stretch;\n    #bgTileContainer * {\n        ", "\n    }\n    label{\n        margin-left: 18px;\n    }\n    @media(max-width: 600px){\n        align-self: center;\n        width:300px;\n        padding: 40px 20px;\n    }\n"])), function (props) {
  return props !== null && props !== void 0 && props.isDark ? "#000" : "rgb(246, 246, 246)";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.isDark) && "background-color: unset;";
});
var StyledTileContainer = styled.div(_templateObject4$q || (_templateObject4$q = _taggedTemplateLiteralLoose(["\ndisplay: flex;\njustify-content: center;\n"])));
var RadioContainer = styled.div(_templateObject5$m || (_templateObject5$m = _taggedTemplateLiteralLoose(["\n    padding-top: 1em;\n    input[type='radio']{  \n        ", " \n    }\n    input[type='radio']:after {\n    width: 1.25rem;\n    height: 1.25rem;\n    border-radius: 15px;\n    top: -4px;\n    left: -4px;\n    position: relative;\n    background-color: #ffffff;\n    content: '';\n    display: inline-block;\n    visibility: visible;\n    border: 1px solid rgb(111, 113, 113);\n}\ninput[type='radio']:focus-visible{\n    outline: 1px dashed;\n    outline-offset: 7px;\n}\ninput[type='radio']:hover:after{\n    border-color: rgb(111, 113, 113);\n    box-shadow: rgb(111, 113, 113) 0px 0px 0px 0.0625rem;\n}\n\ninput[type='radio']:checked:after {\n    width: 1.25rem;\n    height: 1.25rem;\n    border-radius: 15px;\n    top: -4px;\n    left: -4px;\n    position: relative;\n    background-color: #000000;\n    content: '';\n    display: inline-block;\n    visibility: visible;\n    border: 6px solid white;\n    outline: 1px solid black;\n    box-sizing: border-box;\n}\n\n"])), function (props) {
  return props.channelDetail === 'Retail' && "\n            width: unset;\n            height: unset;\n            line-height: unset;\n            text-indent: unset;\n        ";
});
var TitleDiv$1 = styled.div(_templateObject6$j || (_templateObject6$j = _taggedTemplateLiteralLoose(["\n    margin: 32px 0 16px 0;\n    @media(max-width: 600px){\n        margin: 48px 0 16px 0;\n    }\n"])));
var ImageProbingQuestions = function ImageProbingQuestions(props) {
  if (props === void 0) {
    props = {};
  }
  var configDetails = useContext(ConfigContext);
  var _props = props,
    _props$stepObj = _props.stepObj,
    stepObj = _props$stepObj === void 0 ? {} : _props$stepObj,
    _props$handler = _props.handler,
    handler = _props$handler === void 0 ? function () {} : _props$handler,
    _props$channelDetail = _props.channelDetail,
    channelDetail = _props$channelDetail === void 0 ? '' : _props$channelDetail,
    _props$isMVO = _props.isMVO,
    isMVO = _props$isMVO === void 0 ? false : _props$isMVO;
  var _stepObj$questions = stepObj.questions,
    _stepObj$questions2 = _stepObj$questions === void 0 ? [] : _stepObj$questions,
    _stepObj$questions2$ = _stepObj$questions2[0],
    _stepObj$questions2$$ = _stepObj$questions2$.choices,
    choices = _stepObj$questions2$$ === void 0 ? [] : _stepObj$questions2$$,
    _stepObj$questions2$$2 = _stepObj$questions2$.question,
    question = _stepObj$questions2$$2 === void 0 ? '' : _stepObj$questions2$$2;
  console.log("StepObj===", stepObj, choices, question, channelDetail);
  var changeHandler = function changeHandler(e) {
    var _e$target = e.target,
      name = _e$target.name,
      value = _e$target.value;
    console.log(name, value, e.target);
    handler(e);
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Imgprobequestion, null, /*#__PURE__*/React__default.createElement(TextWithHtml, null, question)), /*#__PURE__*/React__default.createElement(DeviceContainerMain, {
    isMVO: isMVO
  }, choices.length > 0 && choices.map(function (el) {
    var _configDetails$params, _configDetails$params2, _configDetails$params3, _configDetails$params4, _configDetails$params5, _configDetails$params6;
    return /*#__PURE__*/React__default.createElement(DeviceTileContainer, {
      isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : (_configDetails$params2 = _configDetails$params.theme) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.isDark
    }, /*#__PURE__*/React__default.createElement(StyledTileContainer, {
      id: "bgTileContainer",
      "aria-hidden": "true"
    }, /*#__PURE__*/React__default.createElement(Tilelet, {
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params3 = configDetails.paramsDetails) !== null && _configDetails$params3 !== void 0 && (_configDetails$params4 = _configDetails$params3.theme) !== null && _configDetails$params4 !== void 0 && _configDetails$params4.isDark ? "dark" : "light",
      viewport: "mobile",
      backgroundImage: el.imageUrl,
      width: "200px",
      height: "200px",
      showBorder: false,
      backgroundColor: "gray",
      innerPadding: "32px"
    })), /*#__PURE__*/React__default.createElement(TitleDiv$1, null, /*#__PURE__*/React__default.createElement("p", {
      size: "small",
      bold: true,
      color: "#000000"
    }, el.text)), /*#__PURE__*/React__default.createElement(Line$1, {
      type: "primary",
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params5 = configDetails.paramsDetails) !== null && _configDetails$params5 !== void 0 && (_configDetails$params6 = _configDetails$params5.theme) !== null && _configDetails$params6 !== void 0 && _configDetails$params6.isDark ? "dark" : "light"
    }), /*#__PURE__*/React__default.createElement(RadioContainer, {
      channelDetail: channelDetail
    }, /*#__PURE__*/React__default.createElement("input", {
      type: "radio",
      name: "selectDeviceGroup",
      id: "selectDeviceGroup",
      onChange: changeHandler,
      value: el.value,
      "aria-label": el.text
    }), /*#__PURE__*/React__default.createElement("label", {
      htmlFor: "selectDeviceGroup",
      style: {
        "vertical-align": "top"
      }
    }, el.imageLabel)));
  })));
};

var invokeNative$1 = function invokeNative(jsonMessage) {
  if (window.webkit != undefined) {
    if (window.webkit.messageHandlers.mfAppInterface != undefined) {
      window.webkit.messageHandlers.mfAppInterface.postMessage(jsonMessage);
    }
  }
  if (window.mfAppInterface != undefined) {
    window.mfAppInterface.postMessage(jsonMessage);
  }
};
var navigateToNativePage = function navigateToNativePage(_ref) {
  var pageType = _ref.pageType,
    title = _ref.title,
    _ref$requestURLFlag = _ref.requestURLFlag,
    requestURLFlag = _ref$requestURLFlag === void 0 ? false : _ref$requestURLFlag,
    _ref$requestURL = _ref.requestURL,
    requestURL = _ref$requestURL === void 0 ? '' : _ref$requestURL;
  var jsonMessage = {
    actionType: "openPage",
    title: title,
    presentationStyle: "push",
    tryToReplaceFirst: false,
    disableAction: false,
    pageType: pageType,
    appContext: "mobileFirstSS"
  };
  if (requestURLFlag) {
    jsonMessage.requestURL = requestURL;
  }
  console.log("native bridge invoced with: ", jsonMessage);
  invokeNative$1(JSON.stringify(jsonMessage));
};

var ErrorCollections = {
  type_1: "Please enter a number",
  type_2: "International numbers should begin with 011",
  type_3: "Please enter a 10 digit number",
  type_4: "Please enter a 10 digit domestic or 16 digit international number",
  type_5: "Invalid number entered",
  type_6: "Enter valid 3 digit number (ie 611, 411, 911)",
  type_7: "Digits entered is the same as user number",
  type_8: "International numbers should begin with 011",
  type_9: "Please enter numeric digits only",
  type_10: "Enter a valid international number"
};
var ALLOWED_NUMBERS = ["611", "411", "911"];
var COVERAGE_INTERACTIVE_MAP_ARR = ["confirmcoverageinteractivemapinternal", "confirmcoverageinteractivemapexternal", "confirmcoverageinteractivemapretail"];

var runValidationRules = function runValidationRules(input, selectedMdn) {
  if (input === void 0) {
    input = '';
  }
  if (selectedMdn === void 0) {
    selectedMdn = '';
  }
  var errorObj = {
    hasError: true,
    errorText: '',
    success: false
  };
  if (!input.length) {
    errorObj.errorText = ErrorCollections.type_1;
    return errorObj;
  }
  if (!/^[0-9]*$/.test(input)) {
    errorObj.errorText = ErrorCollections.type_9;
    return errorObj;
  }
  if (input.length < 3) {
    errorObj.errorText = ErrorCollections.type_5;
    return errorObj;
  }
  if (input.length === 3 && input === "011") {
    errorObj.errorText = ErrorCollections.type_10;
    return errorObj;
  }
  if (input.length === 3 && input !== "011" && !ALLOWED_NUMBERS.includes(input)) {
    errorObj.errorText = ErrorCollections.type_6;
    return errorObj;
  }
  if (input.length === 5 && input.at(-1) == '1') {
    errorObj.errorText = '';
    errorObj.hasError = false;
    errorObj.success = true;
    return errorObj;
  }
  if (input.length > 4 && input.length < 7) {
    errorObj.errorText = ErrorCollections.type_5;
    return errorObj;
  }
  if (input.length > 7 && input.length < 10) {
    errorObj.errorText = ErrorCollections.type_3;
    return errorObj;
  }
  if (input.length === 11 && input[0] !== '1') {
    errorObj.errorText = ErrorCollections.type_3;
    return errorObj;
  }
  if (input.length > 11 && input[0] !== '0') {
    errorObj.errorText = ErrorCollections.type_4;
    return errorObj;
  }
  if (input === selectedMdn) {
    errorObj.errorText = ErrorCollections.type_7;
    return errorObj;
  }
  return {
    hasError: false,
    errorText: '',
    success: true
  };
};

var _templateObject$E;
var FormContainer$1 = styled.div(_templateObject$E || (_templateObject$E = _taggedTemplateLiteralLoose(["\nmargin: 1.5em 0;\nmax-width: 328px;\nspan[class^=\"InputContainer-VDS\"]{\n    height: unset !important;\n    border-radius: unset !important;\n}\nsvg {\n    overflow: unset !important;\n    vertical-align: unset !important;\n}\n"])));
var initialState = {
  inputValue: '',
  hasError: false,
  errorText: 'Please enter a number',
  success: false
};
var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'CHANGE_VALUE':
      return _extends({}, state, {
        inputValue: action.payload
      });
    case 'RESET_ERROR':
      return _extends({}, state, {
        hasError: false,
        errorText: '',
        success: false
      });
    case 'RUN_RULES':
      return _extends({}, state, runValidationRules(state.inputValue, action.payload));
    case 'SET_BACKEND_ERROR':
      return _extends({}, state, {
        hasError: true,
        errorText: ErrorCollections.type_5,
        success: false
      });
    default:
      return state;
  }
};
var CapturePhoneNo = function CapturePhoneNo(_ref) {
  var _configDetails$params, _configDetails$params2;
  var _ref$forwardValue = _ref.forwardValue,
    forwardValue = _ref$forwardValue === void 0 ? function () {} : _ref$forwardValue,
    _ref$selectedMdn = _ref.selectedMdn,
    selectedMdn = _ref$selectedMdn === void 0 ? '' : _ref$selectedMdn,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? {} : _ref$step,
    _ref$validate = _ref.validate,
    validate = _ref$validate === void 0 ? true : _ref$validate;
  var _useReducer = useReducer(reducer, initialState),
    state = _useReducer[0],
    dispatch = _useReducer[1];
  var _step$userSelection = step.userSelection,
    userSelection = _step$userSelection === void 0 ? '' : _step$userSelection,
    _step$validationStatu = step.validationStatus,
    validationStatus = _step$validationStatu === void 0 ? '' : _step$validationStatu;
  console.log("selectedMdn-->", selectedMdn);
  console.log("Step-->", step, validate);
  var dispatchAsync = useCallback(useDebounce(dispatch, 1000), []);
  var configDetails = useContext(ConfigContext);
  var isDark = configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : (_configDetails$params2 = _configDetails$params.theme) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.isDark;
  var changeHandler = function changeHandler(e) {
    var value = e.target.value;
    var replacedStr = value.replace(/\s/g, '');
    replacedStr = replacedStr[0] === '+' ? replacedStr.replace('+', '011') : replacedStr;
    if (validate === true) {
      if (replacedStr.length > 16) {
        replacedStr = replacedStr.slice(0, 16);
      }
      if (replacedStr.length > 16 || !/^[0-9]*$/.test(replacedStr)) {
        return;
      }
    }
    console.log(replacedStr);
    dispatch({
      type: 'CHANGE_VALUE',
      payload: replacedStr
    });
    if (validationStatus === "Fail" && state.hasError) {
      dispatch({
        type: 'RESET_ERROR'
      });
    }
    if (validate) {
      dispatchAsync({
        type: 'RUN_RULES',
        payload: selectedMdn
      });
    }
  };
  useEffect(function () {
    forwardValue({
      target: {
        value: state.hasError ? '' : state.inputValue.trim()
      }
    });
  }, [state.inputValue, state.hasError]);
  useEffect(function () {
    if (userSelection) {
      dispatch({
        type: 'CHANGE_VALUE',
        payload: userSelection
      });
      if (validate) {
        dispatch({
          type: 'RUN_RULES',
          payload: selectedMdn
        });
      }
    }
    if (validationStatus === "Fail") {
      dispatch({
        type: 'SET_BACKEND_ERROR'
      });
    }
  }, [userSelection, validationStatus]);
  return /*#__PURE__*/React__default.createElement("form", null, /*#__PURE__*/React__default.createElement(FormContainer$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
    type: "text",
    label: "Phone Number",
    readOnly: false,
    required: validate === true,
    disabled: false,
    error: state.hasError,
    success: state.success,
    value: state.inputValue,
    errorText: state.errorText,
    onChange: changeHandler,
    surface: isDark ? "dark" : "light"
  })));
};

var _templateObject$F, _templateObject2$y, _templateObject3$s, _templateObject4$r, _templateObject5$n, _templateObject6$k, _templateObject7$g, _templateObject8$f, _templateObject9$d, _templateObject0$b, _templateObject1$b;
var ProgressWrapper$1 = styled.div(_templateObject$F || (_templateObject$F = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  row-gap: 55px;\n"])));
var ProgressLine = styled.div(_templateObject2$y || (_templateObject2$y = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  height: 5px;\n  width: 185px;\n  margin-left: -7px;\n  margin-right: -7px;\n  z-index: 2;\n"])), function (props) {
  return props.isDark ? 'white !important' : 'black !important';
});
var LoaderContainer$1 = styled.div(_templateObject3$s || (_templateObject3$s = _taggedTemplateLiteralLoose(["\n  width: 70px;\n  align-content: center;\n  height: 70px;\n  margin-left: 5px;\n  margin-right: -6px;\n"])));
var Loader$1 = styled.div(_templateObject4$r || (_templateObject4$r = _taggedTemplateLiteralLoose(["\n  width: 58px;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  border: 4px solid #d8dada;\n  border-right-color: #a7a7a7;\n  border-top-color: #a7a7a7;\n  border-left-color: #a7a7a7;\n  animation: l2 1s infinite linear;\n  @keyframes l2 {\n    to {\n      transform: rotate(1turn);\n    }\n  }\n"])));
var StepWrapper = styled.div(_templateObject5$n || (_templateObject5$n = _taggedTemplateLiteralLoose(["\n  width: 240px;\n"])));
var ComponentWrapper = styled.div(_templateObject6$k || (_templateObject6$k = _taggedTemplateLiteralLoose(["\n  display: inline-flex;\n  align-items: center;\n"])));
var StepInfoWrapper = styled.div(_templateObject7$g || (_templateObject7$g = _taggedTemplateLiteralLoose(["\n  width: 150px;\n  line-height: 16px;\n  margin-top: 10px;\n  font-size: 14px;\n"])));
var IconTitle = styled.div(_templateObject8$f || (_templateObject8$f = _taggedTemplateLiteralLoose(["\n  font-weight: bold;\n"])));
var IconDescription = styled.div(_templateObject9$d || (_templateObject9$d = _taggedTemplateLiteralLoose([""])));
var LoaderTitle = styled.div(_templateObject0$b || (_templateObject0$b = _taggedTemplateLiteralLoose(["\n  font-weight: bold;\n  opacity: 0.5;\n"])));
var LoaderDescription = styled.div(_templateObject1$b || (_templateObject1$b = _taggedTemplateLiteralLoose(["\n  opacity: 0.5;\n"])));
function IconStepCreator(props) {
  var stepDescription = props.iconStep.description;
  var stepLabel = props.iconStep.label;
  return /*#__PURE__*/React__default.createElement(StepWrapper, null, /*#__PURE__*/React__default.createElement(ComponentWrapper, {
    id: "step-container"
  }, props.isDark ? /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "checkmark-alt",
    size: "70",
    color: "white"
  }) : /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "checkmark-alt",
    size: "70",
    color: "#333333"
  }), props.iconStep.lastStep ? /*#__PURE__*/React__default.createElement("div", null) : /*#__PURE__*/React__default.createElement(ProgressLine, {
    id: "progress-line",
    isDark: props.isDark
  })), /*#__PURE__*/React__default.createElement(StepInfoWrapper, null, /*#__PURE__*/React__default.createElement(IconTitle, null, "Current Status:", /*#__PURE__*/React__default.createElement("br", null), stepLabel), /*#__PURE__*/React__default.createElement(IconDescription, null, stepDescription)));
}
function LoaderStepCreator(props) {
  var stepDescription = props.loaderStep.description;
  var stepLabel = props.loaderStep.label;
  return /*#__PURE__*/React__default.createElement(StepWrapper, null, /*#__PURE__*/React__default.createElement(ComponentWrapper, {
    id: "step-container"
  }, /*#__PURE__*/React__default.createElement(LoaderContainer$1, null, /*#__PURE__*/React__default.createElement(Loader$1, null)), props.loaderStep.lastStep ? /*#__PURE__*/React__default.createElement("div", null) : /*#__PURE__*/React__default.createElement(ProgressLine, {
    id: "progress-line",
    isDark: props.isDark
  })), /*#__PURE__*/React__default.createElement(StepInfoWrapper, null, /*#__PURE__*/React__default.createElement(LoaderTitle, null, "Current Status:", /*#__PURE__*/React__default.createElement("br", null), " ", stepLabel), /*#__PURE__*/React__default.createElement(LoaderDescription, null, stepDescription)));
}
var Stepper = function Stepper(_ref) {
  var _ref$steps = _ref.steps,
    steps = _ref$steps === void 0 ? [] : _ref$steps,
    isDark = _ref.isDark;
  useLayoutEffect(function () {
    progressLineHandler();
    window.addEventListener('resize', progressLineHandler);
    return function () {
      window.removeEventListener('resize', progressLineHandler);
    };
  }, []);
  if (steps[steps.length - 1]) {
    steps[steps.length - 1].lastStep = true;
  }
  function progressLineHandler() {
    var maxRight = 0;
    $$1('[id=step-container]').each(function () {
      maxRight = Math.max(maxRight, $$1(this).offset().left);
    }).each(function () {
      if ($$1(this).offset().left === maxRight) {
        $$1(this).find('[id=progress-line]').css('display', 'none');
      } else {
        $$1(this).find('[id=progress-line]').css('display', 'block');
      }
    });
  }
  return /*#__PURE__*/React__default.createElement(ProgressWrapper$1, null, steps.map(function (step) {
    return /*#__PURE__*/React__default.createElement("div", null, step !== null && step.status !== null && step.status.toLowerCase() === 'inprogress' && /*#__PURE__*/React__default.createElement(LoaderStepCreator, {
      isDark: isDark,
      loaderStep: step
    }), step !== null && step.status !== null && step.status.toLowerCase() !== 'inprogress' && step.status.toLowerCase() !== 'na' && /*#__PURE__*/React__default.createElement(IconStepCreator, {
      isDark: isDark,
      iconStep: step
    }));
  }));
};

var _templateObject$G, _templateObject2$z;
var ButtonsWrapperNew$1 = styled.div(_templateObject$G || (_templateObject$G = _taggedTemplateLiteralLoose(["\n   display: flex;\n   flex-direction: row;\n  gap: 10px ;\n  @media(max-width:600px){\n   display:none;\n  }\n\n "])));
var ButtonsWrapperNewMobile = styled.div(_templateObject2$z || (_templateObject2$z = _taggedTemplateLiteralLoose(["\n   display: flex;\n   flex-direction: column;\n  gap: 10px ;\n    @media(min-width:601px){\n   display:none;\n  }\n "])));
var NavigationButtonDigital = function NavigationButtonDigital(props) {
  var history = useHistory();
  var disbledPrev = props !== null && props !== void 0 && props.isHowToContent ? false : props === null || props === void 0 ? void 0 : props.disablePrevious;
  var doPrevious = function doPrevious(e, disabled) {
    var _window;
    windowScrollTop();
    e.preventDefault();
    if (disabled) {
      return;
    }
    if ((_window = window) !== null && _window !== void 0 && _window.isMVODigital && props.isHowToContent) {
      history === null || history === void 0 ? void 0 : history.goBack();
      return;
    }
    if (props.handlePrevious) {
      var currentPageId = props.pageId;
      var finalPageID = --currentPageId;
      props.handlePrevious(finalPageID);
    }
  };
  var doAction = function doAction(button, redirectToBackPage) {
    windowScrollTop();
    if (props.handleAction) {
      props.handleAction(button);
    }
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ButtonsWrapperNew$1, null, /*#__PURE__*/React__default.createElement(ActionButton, {
    "data-analyticstrack": "Previous-Btn",
    "data-track": "{\"type\": \"link\", \"name\": \"previous-button\"}",
    "data-clickstream": "Previous Step-btn-cta",
    key: "Previous Step",
    onClick: function onClick(e) {
      return doPrevious(e, disbledPrev);
    },
    onKeyPress: function onKeyPress(e) {
      return doPrevious(e, disbledPrev);
    },
    use: "secondary",
    size: props.stackButtons ? '360px' : props.size,
    style: {
      'min-width': props.stackButtons ? null : props.size,
      padding: 0,
      width: '100%'
    },
    "data-testid": "digitalPrevBtn",
    disabled: disbledPrev
  }, "Previous step"), props.buttons.map(function (button) {
    if (props.templateId == 'RESOLUTION_OPTIONS_ALL_DIGITAL' || (props === null || props === void 0 ? void 0 : props.templateId) == 'RESOLUTION_OPTIONS_GUEST_DIGITAL' || (props === null || props === void 0 ? void 0 : props.templateId) == 'RESOLUTION_OPTIONS_RECOMMEND_AUTH_DGTAL' || props.templateId == 'RESOLUTION_OPTIONS_MVO_TIER2' || props.templateId == 'RESOLUTION_OPTIONS_CHANGE_DEVICE_DIGITAL') {
      return null;
    }
    if (props.isNewDesign && !props.isHowToContent) {
      if (button.label.toLowerCase() == 'no' || button.label.toLowerCase() == 'next') {
        var btnLabel = "Next step";
        var btnType = button.type === 'secondary' ? "secondary" : "primary";
        var inverted = button.inverted ? true : false;
        var size = props.size ? props.size : button.size;
        size = props.stackButtons ? '360px' : size;
        return /*#__PURE__*/React__default.createElement(ActionButton, {
          "data-analyticstrack": "next-button",
          "data-track": "{\"type\": \"link\", \"name\": \"next-button\"}",
          "data-clickstream": "next-step-btn-cta",
          disabled: props.disabled,
          surface: inverted ? "dark" : "light",
          key: "action_button_" + button.label,
          onClick: function onClick() {
            return doAction(button);
          },
          use: btnType,
          size: size,
          style: {
            'min-width': size,
            width: '100%',
            padding: 0
          },
          "data-testid": "actionBtn"
        }, btnLabel);
      }
    }
  })), /*#__PURE__*/React__default.createElement(ButtonsWrapperNewMobile, null, props.buttons.map(function (button) {
    if (props.templateId == 'RESOLUTION_OPTIONS_ALL_DIGITAL' || (props === null || props === void 0 ? void 0 : props.templateId) == 'RESOLUTION_OPTIONS_GUEST_DIGITAL' || (props === null || props === void 0 ? void 0 : props.templateId) == 'RESOLUTION_OPTIONS_RECOMMEND_AUTH_DGTAL' || props.templateId == 'RESOLUTION_OPTIONS_MVO_TIER2' || props.templateId == 'RESOLUTION_OPTIONS_CHANGE_DEVICE_DIGITAL') {
      return null;
    }
    if (props.isNewDesign && !props.isHowToContent) {
      if (button.label.toLowerCase() == 'no' || button.label.toLowerCase() == 'next') {
        var btnLabel = "Next step";
        var btnType = button.type === 'secondary' ? "secondary" : "primary";
        var inverted = button.inverted ? true : false;
        return /*#__PURE__*/React__default.createElement(ActionButton, {
          "data-analyticstrack": "next-button",
          "data-track": "{\"type\": \"link\", \"name\": \"next-button\"}",
          "data-clickstream": "next-step-btn-cta",
          disabled: props.disabled,
          surface: inverted ? "dark" : "light",
          key: "action_button_" + button.label,
          onClick: function onClick() {
            return doAction(button);
          },
          use: btnType,
          style: {
            'min-width': 'props.stackButtons ? null : props.size',
            padding: 0,
            width: '100%'
          },
          "data-testid": "actionBtnMobile"
        }, btnLabel);
      }
    }
  }), /*#__PURE__*/React__default.createElement(ActionButton, {
    "data-analyticstrack": "Previous-Btn",
    "data-track": "{\"type\": \"link\", \"name\": \"previous-button\"}",
    "data-clickstream": "previous-step-btn-cta",
    key: "Previous Step",
    onClick: function onClick(e) {
      return doPrevious(e, disbledPrev);
    },
    onKeyPress: function onKeyPress(e) {
      return doPrevious(e, disbledPrev);
    },
    use: "secondary",
    size: props.stackButtons ? '360px' : props.size,
    style: {
      'min-width': props.stackButtons ? null : props.size,
      padding: 0,
      width: '100%'
    },
    "data-testid": "digitalPrevBtnMobile",
    disabled: disbledPrev
  }, "Previous step")));
};

var GenAILoadingIcon = function GenAILoadingIcon(_ref) {
  var surface = _ref.surface;
  var _useState = useState(0),
    key = _useState[0],
    setKey = _useState[1];
  useEffect(function () {
    var interval = setInterval(function () {
      setKey(function (prevKey) {
        return prevKey + 1;
      });
    }, 1500);
    return function () {
      return clearInterval(interval);
    };
  }, []);
  var listVariants = {
    visible: {
      opacity: 1,
      transition: {
        when: 'beforeChildren',
        staggerChildren: 0.3
      }
    },
    hidden: {
      opacity: 0
    }
  };
  var itemVariants = {
    visible: {
      opacity: 1
    },
    hidden: {
      opacity: 0
    }
  };
  var paths = ['M23.303 19.282L23.303 18.032C22.2502 18.0414 21.2364 17.6345 20.4822 16.8999C19.7281 16.1653 19.2948 15.1625 19.2766 14.1098C19.2774 14.0733 19.282 14.0365 19.282 14L18.021 14C18.021 14.0376 18.0261 14.0728 18.0268 14.1101C18.0098 15.1632 17.5768 16.1667 16.8223 16.9016C16.0678 17.6364 15.0531 18.0428 14 18.032L14 19.282C15.0527 19.2725 16.0664 19.6793 16.8206 20.4138C17.5747 21.1483 18.0081 22.151 18.0264 23.2036C18.0255 23.2401 18.021 23.2769 18.021 23.3134L19.282 23.3134C19.282 23.2757 19.2769 23.2405 19.2762 23.2033C19.2932 22.1503 19.7263 21.1468 20.4808 20.412C21.2353 19.6773 22.2499 19.271 23.303 19.282ZM16.4768 18.67C17.3972 18.1719 18.1493 17.4121 18.6382 16.4868C19.1385 17.4062 19.8998 18.1568 20.8263 18.6439C19.9059 19.1419 19.1537 19.9015 18.6648 20.8268C18.1646 19.9075 17.4032 19.157 16.4768 18.67Z', 'M26.5089 17.125L26.5089 18.375C27.3243 18.3676 28.1096 18.6826 28.694 19.2512C29.2783 19.8199 29.6145 20.5964 29.6294 21.4117C29.6287 21.4411 29.625 21.4707 29.625 21.5L30.8839 21.5C30.8839 21.4697 30.8798 21.4414 30.8792 21.4114C30.8931 20.5958 31.2291 19.8188 31.8137 19.2499C32.3984 18.6811 33.1843 18.3666 34 18.375L34 17.125C33.1846 17.1324 32.3993 16.8174 31.8149 16.2487C31.2305 15.6801 30.8944 14.9036 30.8795 14.0883C30.8801 14.0589 30.8839 14.0293 30.8839 14L29.625 14C29.625 14.0303 29.6291 14.0586 29.6297 14.0886C29.6157 14.9042 29.2798 15.6812 28.6951 16.2501C28.1105 16.8189 27.3246 17.1334 26.5089 17.125ZM31.7542 17.7383C31.1423 18.112 30.6312 18.63 30.2657 19.2469C29.8908 18.6359 29.372 18.126 28.7547 17.7617C29.3666 17.3879 29.8776 16.87 30.2431 16.2531C30.6181 16.8641 31.1369 17.374 31.7542 17.7383Z', 'M26.2676 33.8352C26.2924 32.1937 26.9661 30.6288 28.1415 29.4827C29.317 28.3367 30.8984 27.7027 32.54 27.7195L32.54 26.4695C30.898 26.4843 29.3168 25.8488 28.1416 24.7018C26.9665 23.5548 26.2929 21.9895 26.2679 20.3475C26.2692 20.2947 26.2757 20.2416 26.2757 20.189L25.0098 20.189C25.0098 20.2437 25.0166 20.2989 25.0179 20.3537C24.9932 21.9952 24.3195 23.5602 23.144 24.7063C21.9686 25.8524 20.3871 26.4863 18.7455 26.4695L18.7455 27.7195C20.3875 27.7047 21.9688 28.3401 23.1439 29.4871C24.319 30.6341 24.9926 32.1995 25.0176 33.8414C25.0164 33.8942 25.0098 33.9473 25.0098 34L26.2757 34C26.2757 33.9453 26.2689 33.8901 26.2676 33.8352ZM21.777 27.0945C23.5186 26.3128 24.8998 24.9008 25.6428 23.1423C26.3858 24.9008 27.7669 26.3128 29.5085 27.0945C27.7669 27.8762 26.3858 29.2882 25.6428 31.0467C24.8998 29.2882 23.5186 27.8762 21.777 27.0945Z'];
  return /*#__PURE__*/React__default.createElement(motion.svg, {
    key: key,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    initial: "hidden",
    animate: "visible",
    variants: listVariants
  }, paths.map(function (path, index) {
    return /*#__PURE__*/React__default.createElement(motion.path, {
      key: index,
      d: path,
      variants: itemVariants,
      fill: surface === 'dark' ? '#fff' : '#000'
    });
  }));
};

var getUrl$1 = function getUrl() {
  var mvoenv = sessionStorage.getItem('mvoenv');
  var externalTarget = sessionStorage.getItem('mvoExternalTarget');
  var _tsaEnvConfig = tsaEnvConfig$1({
      mvoenv: mvoenv,
      externalTarget: externalTarget
    }),
    apiUrls = _tsaEnvConfig.apiUrls;
  return apiUrls === null || apiUrls === void 0 ? void 0 : apiUrls.getVegasGenAISummary;
};
var getAxiosConfig$1 = function getAxiosConfig(isACSS) {
  return {
    withCredentials: true,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      credentials: true,
      channelId: isACSS ? 'VZW-ACSS' : channelId
    }
  };
};
var swrDefaults = {
  revalidateOnFocus: false,
  revalidateOnReconnect: true,
  revalidateIfStale: false,
  shouldRetryOnError: false
};
var getTextFromHtml = function getTextFromHtml(description) {
  var _doc$body, _doc$body$textContent, _doc$body$textContent2;
  var parser = new DOMParser();
  var doc = parser === null || parser === void 0 ? void 0 : parser.parseFromString(description || '', 'text/html');
  return doc === null || doc === void 0 ? void 0 : (_doc$body = doc.body) === null || _doc$body === void 0 ? void 0 : (_doc$body$textContent = _doc$body.textContent) === null || _doc$body$textContent === void 0 ? void 0 : (_doc$body$textContent2 = _doc$body$textContent.replace(/\n/g, '').replace(/\s+/g, ' ')) === null || _doc$body$textContent2 === void 0 ? void 0 : _doc$body$textContent2.trim();
};
var getNumberOfSteps = function getNumberOfSteps(description) {
  var _doc$body2;
  var parser = new DOMParser();
  var doc = parser === null || parser === void 0 ? void 0 : parser.parseFromString(description || '', 'text/html');
  return doc === null || doc === void 0 ? void 0 : (_doc$body2 = doc.body) === null || _doc$body2 === void 0 ? void 0 : _doc$body2.querySelectorAll('li.step').length;
};
var getAISummary = function getAISummary(_ref) {
  var url = _ref.url,
    description = _ref.description,
    isACSS = _ref.isACSS,
    genAICompositeKey = _ref.genAICompositeKey;
  try {
    if (!url) throw new Error('Missing GenAI url');
    var axiosConfig = getAxiosConfig$1(isACSS);
    var numberOfSteps = getNumberOfSteps(description);
    var content = getTextFromHtml(description);
    var payload = {
      content: content,
      numberOfSteps: numberOfSteps,
      genAICompositeKey: genAICompositeKey
    };
    return Promise.resolve(postHttpClientRequest(url, payload, axiosConfig)).then(function (_ref2) {
      var _data$body, _data$body2;
      var data = _ref2.data;
      if (!(data !== null && data !== void 0 && (_data$body = data.body) !== null && _data$body !== void 0 && _data$body.data)) {
        throw new Error('no ai summary');
      }
      return data === null || data === void 0 ? void 0 : (_data$body2 = data.body) === null || _data$body2 === void 0 ? void 0 : _data$body2.data;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var useAISummary = function useAISummary(_ref3) {
  var isACSS = _ref3.isACSS,
    intentId = _ref3.intentId,
    description = _ref3.description,
    setAISummaryLoaded = _ref3.setAISummaryLoaded,
    genAICompositeKey = _ref3.genAICompositeKey;
  var url = getUrl$1();
  var cacheKey = ['aiSummary', intentId, genAICompositeKey, url];
  return useSWR(cacheKey, function () {
    return getAISummary({
      url: url,
      description: description,
      isACSS: isACSS,
      genAICompositeKey: genAICompositeKey
    });
  }, _extends({}, swrDefaults, {
    onSuccess: function onSuccess(data, key, config) {
      setAISummaryLoaded(data === null || data === void 0 ? void 0 : data.vegasTransactionId);
      session('aiSummary').set(data);
    }
  }));
};

var listVariants = {
  visible: {
    opacity: 1,
    transition: {
      when: 'beforeChildren',
      staggerChildren: 0.3
    }
  },
  hidden: {
    opacity: 0
  }
};
var itemVariants = {
  visible: {
    opacity: 1,
    y: 0,
    display: 'flex'
  },
  hidden: {
    opacity: 0,
    y: 20,
    display: 'none'
  }
};
var LoadingAISummary = function LoadingAISummary(_ref) {
  var surface = _ref.surface;
  return /*#__PURE__*/React__default.createElement(HStack, {
    as: "section",
    gap: "20px",
    alignItems: "center",
    marginBottom: "32px",
    "aria-label": "Loading Gen AI Summary"
  }, /*#__PURE__*/React__default.createElement(GenAILoadingIcon, {
    surface: surface
  }), /*#__PURE__*/React__default.createElement(Title, {
    size: "medium",
    color: surface === 'dark' ? '#fff' : '#000'
  }, "Summarizing this article using Generative AI...."));
};
var contentClean = function contentClean(summary) {
  if (summary === void 0) {
    summary = {};
  }
  var _summary = summary,
    header = _summary.header,
    details = _summary.details;
  if (!!!header && !!!details) return null;else if (!!!header) return details;else if (!!!details) return header;else return "<b>" + header + "</b>: " + details;
};
var Content$1 = function Content(_ref2) {
  var summary = _ref2.summary;
  var content = contentClean(summary);
  if (!content) return null;
  return /*#__PURE__*/React__default.createElement(ListItem$2, {
    key: summary === null || summary === void 0 ? void 0 : summary.header,
    size: "bodyLarge",
    spacing: "compact"
  }, convertStringToElements(content));
};
var Note = function Note(_ref3) {
  var _ref3$modelName = _ref3.modelName,
    modelName = _ref3$modelName === void 0 ? 'Gemini' : _ref3$modelName;
  return /*#__PURE__*/React__default.createElement(Body, {
    color: ColorTokens.palette.gray44.value,
    size: "large"
  }, "This message is based in part on output from Google\u2019s ", modelName, ".");
};
var Paragraph = function Paragraph(_ref4) {
  var summary = _ref4.summary,
    surface = _ref4.surface;
  var content = contentClean(summary);
  if (!content) return null;
  return /*#__PURE__*/React__default.createElement(Body, {
    size: "large",
    color: surface === 'dark' ? '#fff' : '#000'
  }, convertStringToElements(content));
};
var ParagraphTemplate = function ParagraphTemplate(_ref5) {
  var summary = _ref5.summary,
    surface = _ref5.surface;
  return /*#__PURE__*/React__default.createElement(Stack, {
    gap: "8px"
  }, summary === null || summary === void 0 ? void 0 : summary.map(function (summary) {
    return /*#__PURE__*/React__default.createElement(Paragraph, {
      key: (summary === null || summary === void 0 ? void 0 : summary.header) + (summary === null || summary === void 0 ? void 0 : summary.details),
      summary: summary,
      surface: surface
    });
  }));
};
var BulletTemplate = function BulletTemplate(_ref6) {
  var _ref6$summary = _ref6.summary,
    summary = _ref6$summary === void 0 ? [] : _ref6$summary,
    surface = _ref6.surface;
  return /*#__PURE__*/React__default.createElement(UnorderedList, {
    surface: surface
  }, summary === null || summary === void 0 ? void 0 : summary.map(function (summary) {
    return /*#__PURE__*/React__default.createElement(Content$1, {
      key: summary.header + summary.details,
      summary: summary
    });
  }));
};
var getTemplate = function getTemplate(template) {
  var templateMap = {
    paragraph: ParagraphTemplate,
    bullet: BulletTemplate
  };
  return (templateMap === null || templateMap === void 0 ? void 0 : templateMap[template]) || ParagraphTemplate;
};
var AISummary = function AISummary(_ref7) {
  var _data$template;
  var intentId = _ref7.intentId,
    description = _ref7.description,
    isACSS = _ref7.isACSS,
    toggleContent = _ref7.toggleContent,
    showContent = _ref7.showContent,
    setAISummaryLoaded = _ref7.setAISummaryLoaded,
    genAICompositeKey = _ref7.genAICompositeKey,
    surface = _ref7.surface;
  var isDark = surface === 'dark';
  var _useAISummary = useAISummary({
      isACSS: isACSS,
      intentId: intentId,
      description: description,
      setAISummaryLoaded: setAISummaryLoaded,
      genAICompositeKey: genAICompositeKey
    }),
    isLoading = _useAISummary.isLoading,
    data = _useAISummary.data,
    error = _useAISummary.error;
  var getCachedMessage = function getCachedMessage(cachedResponse) {
    if (cachedResponse === undefined) return 'missing cachedResponse';
    return cachedResponse ? 'Adobe Cache' : 'Google LLM';
  };
  useEffect(function () {
    if (error && !showContent) {
      try {
        var cachedMessage = getCachedMessage(data === null || data === void 0 ? void 0 : data.cachedResponse);
        if (window.vzdl) {
          var message = "Failed to generate AI Summary - " + cachedMessage;
          window.vzdl.target.message = message;
          var _event = isACSS ? window.vzdl : {
            type: 'error',
            message: message
          };
          tagging.dispatchNotify(_event, isACSS);
        }
      } catch (e) {
        console.error('Error in AISummary useEffect:', e);
      }
      toggleContent(null, true);
    }
    return function () {
      if (window.vzdl) window.vzdl.target.message = '';
    };
  }, [error, showContent]);
  useEffect(function () {
    if (data !== null && data !== void 0 && data.summary) {
      try {
        var cachedMessage = getCachedMessage(data === null || data === void 0 ? void 0 : data.cachedResponse);
        if (window.vzdl) {
          var message = "AI Summary generated successfully - " + cachedMessage;
          window.vzdl.target.message = message;
          var _event2 = isACSS ? window.vzdl : {
            type: 'success',
            message: message
          };
        }
      } catch (e) {
        console.error('Error in AISummary useEffect:', e);
      }
      tagging.dispatchNotify(event, isACSS);
    }
    return function () {
      if (window.vzdl) window.vzdl.target.message = '';
    };
  }, [data === null || data === void 0 ? void 0 : data.summary]);
  if (!!error) return null;
  if (isLoading) return /*#__PURE__*/React__default.createElement(LoadingAISummary, {
    surface: surface
  });
  var Template = getTemplate(data === null || data === void 0 ? void 0 : (_data$template = data.template) === null || _data$template === void 0 ? void 0 : _data$template.toLowerCase());
  var linkLabel = showContent ? 'Hide detailed instructions' : 'Read detailed instructions';
  return /*#__PURE__*/React__default.createElement(Stack, {
    gap: "48px"
  }, /*#__PURE__*/React__default.createElement(Stack, {
    as: motion.section,
    "aria-label": "Gen AI Summary",
    initial: "hidden",
    animate: "visible",
    variants: listVariants,
    gap: "16px",
    backgroundColor: isDark ? '#000' : '#F6F6F6',
    borderRadius: "4px",
    padding: "20px"
  }, /*#__PURE__*/React__default.createElement(HStack, {
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(IdeasSolutions, {
    surface: surface
  }), /*#__PURE__*/React__default.createElement(Body, {
    size: "medium",
    bold: true,
    color: isDark ? '#fff' : '#000'
  }, "Gemini Summary")), /*#__PURE__*/React__default.createElement(Stack, {
    as: motion.div,
    variants: itemVariants,
    gap: "8px"
  }, /*#__PURE__*/React__default.createElement(Template, {
    summary: data === null || data === void 0 ? void 0 : data.summary,
    surface: surface
  })), /*#__PURE__*/React__default.createElement(Note, {
    modelName: data === null || data === void 0 ? void 0 : data.modelName
  })), /*#__PURE__*/React__default.createElement(Box, {
    className: "a-" + surface
  }, /*#__PURE__*/React__default.createElement(TextLink, {
    surface: surface,
    onClick: toggleContent,
    "data-track": "{\"type\":\"link\",\"name\": \"" + linkLabel + "\"}"
  }, linkLabel)));
};

var _templateObject$H, _templateObject2$A, _templateObject3$t, _templateObject4$s, _templateObject5$o, _templateObject6$l, _templateObject7$h;
function isMdnStatusInEligbleForDelphi(selectedMTNData) {
  var _selectedMTNData$basi, _selectedMTNData$basi2;
  var delphiNonActiveMdnStatusList = ["B", "S", "C", "R", "D"];
  var mtnStatus = selectedMTNData === null || selectedMTNData === void 0 ? void 0 : (_selectedMTNData$basi = selectedMTNData.basicMtnDetails) === null || _selectedMTNData$basi === void 0 ? void 0 : (_selectedMTNData$basi2 = _selectedMTNData$basi[0]) === null || _selectedMTNData$basi2 === void 0 ? void 0 : _selectedMTNData$basi2.mtnStatusCode;
  if (delphiNonActiveMdnStatusList.includes(mtnStatus)) {
    return true;
  } else {
    return false;
  }
}
function getFormatMtn(mtn, status) {
  if (status === void 0) {
    status = null;
  }
  if (mtn) {
    if (mtn === "Please select") {
      return mtn;
    } else {
      if (mtn && mtn !== "" && mtn.indexOf("-") == -1) {
        var formatMtn = mtn.slice(0, 3) + "-" + mtn.slice(3, 6) + "-" + mtn.slice(6);
        if (status) {
          return " " + formatMtn + " -" + status;
        }
        return " " + formatMtn;
      } else return mtn;
    }
  } else {
    return "";
  }
}
function formatBillAccountNo(billAccountNo) {
  if (billAccountNo === void 0) {
    billAccountNo = "";
  }
  var DIGITS = 5;
  var numOfDigits = billAccountNo.toString().length;
  if (numOfDigits === 5) {
    return billAccountNo;
  }
  var numOfPrefixedZeroes = DIGITS - numOfDigits;
  var prefix = "";
  for (var i = 0; i < numOfPrefixedZeroes; i += 1) {
    prefix = "0" + prefix;
  }
  return prefix + billAccountNo;
}
function getCallKeyMetaData(selectedCallKey) {
  if (selectedCallKey === void 0) {
    selectedCallKey = "";
  }
  var _selectedCallKey$spli = selectedCallKey.split("-"),
    customerId = _selectedCallKey$spli[0],
    restParams = _selectedCallKey$spli.slice(1);
  var _ref = restParams && restParams.length > 0 ? restParams[0].split("_") : "",
    selectedBillAccountNo = _ref[0],
    selectedMTN = _ref[1];
  var billAccountNo = stripLeftZeroes(selectedBillAccountNo);
  var mtn = stripLeftZeroes(selectedMTN);
  return {
    customerId: customerId,
    billAccountNo: billAccountNo,
    mtn: mtn
  };
}
function stripLeftZeroes(num) {
  if (num === void 0) {
    num = "";
  }
  return num.replace(/^0+/, "");
}
function isFWADevice(selectedMTNData) {
  var _selectedMTNData$basi3, _selectedMTNData$basi4, _selectedMTNData$basi5, _selectedMTNData$devi, _selectedMTNData$devi2, _selectedMTNData$devi3, _selectedMTNData$devi4, _selectedMTNData$devi5, _selectedMTNData$devi6, _selectedMTNData$devi7, _selectedMTNData$devi8;
  var networkBandIndicatorArray = ["LTE", "CBD", "MMW", "TGW"];
  var fwaDeviceTypeArray = ["5GF", "4GF", "TWM"];
  var fwaDeviceCategoryArray = ["5G Router", "4G Router"];
  var networkBandIndicator = (_selectedMTNData$basi3 = selectedMTNData === null || selectedMTNData === void 0 ? void 0 : (_selectedMTNData$basi4 = selectedMTNData.basicMtnDetails) === null || _selectedMTNData$basi4 === void 0 ? void 0 : (_selectedMTNData$basi5 = _selectedMTNData$basi4[0]) === null || _selectedMTNData$basi5 === void 0 ? void 0 : _selectedMTNData$basi5.networkBandwidthType) != null ? _selectedMTNData$basi3 : "";
  var deviceType = (_selectedMTNData$devi = selectedMTNData === null || selectedMTNData === void 0 ? void 0 : (_selectedMTNData$devi2 = selectedMTNData.deviceInfo) === null || _selectedMTNData$devi2 === void 0 ? void 0 : (_selectedMTNData$devi3 = _selectedMTNData$devi2[0]) === null || _selectedMTNData$devi3 === void 0 ? void 0 : _selectedMTNData$devi3.deviceType) != null ? _selectedMTNData$devi : "";
  var deviceCategory = (_selectedMTNData$devi4 = selectedMTNData === null || selectedMTNData === void 0 ? void 0 : (_selectedMTNData$devi5 = selectedMTNData.deviceInfo) === null || _selectedMTNData$devi5 === void 0 ? void 0 : (_selectedMTNData$devi6 = _selectedMTNData$devi5[0]) === null || _selectedMTNData$devi6 === void 0 ? void 0 : (_selectedMTNData$devi7 = _selectedMTNData$devi6.equipGuideData) === null || _selectedMTNData$devi7 === void 0 ? void 0 : (_selectedMTNData$devi8 = _selectedMTNData$devi7.deviceModel) === null || _selectedMTNData$devi8 === void 0 ? void 0 : _selectedMTNData$devi8.deviceCategory) != null ? _selectedMTNData$devi4 : "";
  if (networkBandIndicatorArray.includes(networkBandIndicator) || fwaDeviceTypeArray.includes(deviceType) || fwaDeviceCategoryArray.includes(deviceCategory)) {
    return true;
  } else {
    return false;
  }
}
var StyledButton$4 = styled(Button$1)(_templateObject$H || (_templateObject$H = _taggedTemplateLiteralLoose(["\n  margin: 0px 0.625rem 0.625rem 0px;\n"])));
var ProvisioningButton = styled(StyledButton$4)(_templateObject2$A || (_templateObject2$A = _taggedTemplateLiteralLoose(["\n  width: 11em;\n  height: 30px;\n"])));
var ThemedNotesBox = styled.div(_templateObject3$t || (_templateObject3$t = _taggedTemplateLiteralLoose(["\n  // background-color: green;\n  margin: 0;\n"])));
var SearchWrapper$2 = styled.div(_templateObject4$s || (_templateObject4$s = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  margin-top: 7px;\n\n  & [class^=\"Input__IconContainer\"] {\n    right: 0;\n    padding-right: 7px;\n    padding-top: 4px;\n  }\n"])));
var Anchor = styled.a(_templateObject5$o || (_templateObject5$o = _taggedTemplateLiteralLoose(["\n  color: ", " !important;\n"])), function (props) {
  return props.theme.linkColor;
});
function getTextBoxColor(isDark) {
  return isDark ? "#ffffff" : "#000000";
}
function getPlaceholderColor(isDark) {
  return "#757575";
}
var SearchBox$2 = styled(Input$1)(_templateObject6$l || (_templateObject6$l = _taggedTemplateLiteralLoose(["\n  ", "\n  /*margin-top:-20px;*/\n  width: 250px;\n  height: 25px;\n  padding: 1px 15px 2px 3px;\n  type: text;\n  background-color: transparent;\n  color: ", ";\n\n  ::-webkit-input-placeholder {\n    color: ", ";\n  }\n  ::-moz-placeholder {\n    color: ", ";\n  }\n  :-ms-input-placeholder {\n    color: ", ";\n  }\n  :-moz-placeholder {\n    color: ", ";\n  }\n\n  &:focus {\n    border-left: 1;\n    border-right: 1;\n    border-top: 1;\n  }\n  & svg {\n    color: ", "!important;\n  }\n"])), function (props) {
  return props.vdsDarkSelectBox && css(_templateObject7$h || (_templateObject7$h = _taggedTemplateLiteralLoose(["\n        span[class*=\"InputContainer-VDS\"] {\n          background: transparent;\n        }\n      "])));
}, function (props) {
  return getTextBoxColor(props.isDark);
}, function (props) {
  return getPlaceholderColor();
}, function (props) {
  return getPlaceholderColor();
}, function (props) {
  return getPlaceholderColor();
}, function (props) {
  return getPlaceholderColor();
}, function (props) {
  return props.isDark ? "#d8dada" : "#ffffff";
});
function getBaseUrlLink(srLinkData, linkID) {
  var _srLinkData$Response$, _srLinkData$Response, _srLinkData$Response$2, _srLinkData$Response$3, _srLinkData$Response$4, _srLinkData$Response$5, _srLinkData$Response2, _srLinkData$Response3, _srLinkData$Response4, _srLinkData$Response5;
  console.log(srLinkData, "ooooooooooooo");
  var linkURLs = (_srLinkData$Response$ = srLinkData === null || srLinkData === void 0 ? void 0 : (_srLinkData$Response = srLinkData.Response) === null || _srLinkData$Response === void 0 ? void 0 : (_srLinkData$Response$2 = _srLinkData$Response.AdminFormsLettersLinksResponse) === null || _srLinkData$Response$2 === void 0 ? void 0 : (_srLinkData$Response$3 = _srLinkData$Response$2.Mapped) === null || _srLinkData$Response$3 === void 0 ? void 0 : (_srLinkData$Response$4 = _srLinkData$Response$3.Links) === null || _srLinkData$Response$4 === void 0 ? void 0 : _srLinkData$Response$4.Link) != null ? _srLinkData$Response$ : [];
  var linkURLsData = (_srLinkData$Response$5 = srLinkData === null || srLinkData === void 0 ? void 0 : (_srLinkData$Response2 = srLinkData.Response) === null || _srLinkData$Response2 === void 0 ? void 0 : (_srLinkData$Response3 = _srLinkData$Response2.AdminFormsLettersLinksResponse) === null || _srLinkData$Response3 === void 0 ? void 0 : (_srLinkData$Response4 = _srLinkData$Response3.ReferenceData) === null || _srLinkData$Response4 === void 0 ? void 0 : (_srLinkData$Response5 = _srLinkData$Response4.LinkURLs) === null || _srLinkData$Response5 === void 0 ? void 0 : _srLinkData$Response5.LinkURL) != null ? _srLinkData$Response$5 : [];
  if (!linkURLs || !linkURLsData) {
    return "";
  }
  var linkIDUrl = "";
  for (var _iterator = _createForOfIteratorHelperLoose(linkURLsData), _step; !(_step = _iterator()).done;) {
    var item = _step.value;
    if (item && item.ID == linkID) {
      linkIDUrl = item.URL;
      break;
    }
  }
  return linkIDUrl;
}
function getMVDBaseUrl(srLinkData) {
  var _srLinkData$Response$6, _srLinkData$Response6, _srLinkData$Response7, _srLinkData$Response8, _srLinkData$Response9, _srLinkData$Response$7, _srLinkData$Response0, _srLinkData$Response1, _srLinkData$Response10, _srLinkData$Response11;
  var linkURLs = (_srLinkData$Response$6 = srLinkData === null || srLinkData === void 0 ? void 0 : (_srLinkData$Response6 = srLinkData.Response) === null || _srLinkData$Response6 === void 0 ? void 0 : (_srLinkData$Response7 = _srLinkData$Response6.AdminFormsLettersLinksResponse) === null || _srLinkData$Response7 === void 0 ? void 0 : (_srLinkData$Response8 = _srLinkData$Response7.Mapped) === null || _srLinkData$Response8 === void 0 ? void 0 : (_srLinkData$Response9 = _srLinkData$Response8.Links) === null || _srLinkData$Response9 === void 0 ? void 0 : _srLinkData$Response9.Link) != null ? _srLinkData$Response$6 : [];
  var linkURLsMvmd = (_srLinkData$Response$7 = srLinkData === null || srLinkData === void 0 ? void 0 : (_srLinkData$Response0 = srLinkData.Response) === null || _srLinkData$Response0 === void 0 ? void 0 : (_srLinkData$Response1 = _srLinkData$Response0.AdminFormsLettersLinksResponse) === null || _srLinkData$Response1 === void 0 ? void 0 : (_srLinkData$Response10 = _srLinkData$Response1.ReferenceData) === null || _srLinkData$Response10 === void 0 ? void 0 : (_srLinkData$Response11 = _srLinkData$Response10.LinkURLs) === null || _srLinkData$Response11 === void 0 ? void 0 : _srLinkData$Response11.LinkURL) != null ? _srLinkData$Response$7 : [];
  if (!linkURLs || !linkURLsMvmd) {
    return "";
  }
  var mvmdUrl = "";
  for (var _iterator2 = _createForOfIteratorHelperLoose(linkURLsMvmd), _step2; !(_step2 = _iterator2()).done;) {
    var item = _step2.value;
    if (item && item.ID == "LINKS_MVMD") {
      mvmdUrl = item.URL;
      break;
    }
  }
  return mvmdUrl;
}
function prepareMVDRemoteViewRequestUrlData(selectedMTNData, callId, MVMD_BASE_URL) {
  var _selectedMTNData$devi9, _selectedMTNData$devi0, _selectedMTNData$devi1, _selectedMTNData$devi10, _selectedMTNData$devi11, _selectedMTNData$devi12, _window, _window$caseDetails, _window2, _window2$caseDetails;
  var serialNo = "";
  var meid = "";
  var imei = (selectedMTNData === null || selectedMTNData === void 0 ? void 0 : (_selectedMTNData$devi9 = selectedMTNData.deviceInfo) === null || _selectedMTNData$devi9 === void 0 ? void 0 : (_selectedMTNData$devi0 = _selectedMTNData$devi9[0]) === null || _selectedMTNData$devi0 === void 0 ? void 0 : _selectedMTNData$devi0.imei) || "";
  var equipManufacturer = (selectedMTNData === null || selectedMTNData === void 0 ? void 0 : (_selectedMTNData$devi1 = selectedMTNData.deviceInfo) === null || _selectedMTNData$devi1 === void 0 ? void 0 : (_selectedMTNData$devi10 = _selectedMTNData$devi1[0]) === null || _selectedMTNData$devi10 === void 0 ? void 0 : _selectedMTNData$devi10.equipmentMfgName) || "";
  var modelName = (selectedMTNData === null || selectedMTNData === void 0 ? void 0 : (_selectedMTNData$devi11 = selectedMTNData.deviceInfo) === null || _selectedMTNData$devi11 === void 0 ? void 0 : (_selectedMTNData$devi12 = _selectedMTNData$devi11[0]) === null || _selectedMTNData$devi12 === void 0 ? void 0 : _selectedMTNData$devi12.modelName) || "";
  var deviceMtnIndicator = (selectedMTNData === null || selectedMTNData === void 0 ? void 0 : selectedMTNData.deviceMtnIndicator) || "";
  var timestamp = "" + new Date().getTime();
  var mtn = ((_window = window) === null || _window === void 0 ? void 0 : (_window$caseDetails = _window.caseDetails) === null || _window$caseDetails === void 0 ? void 0 : _window$caseDetails.mtn) || "";
  var accountNo = ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$caseDetails = _window2.caseDetails) === null || _window2$caseDetails === void 0 ? void 0 : _window2$caseDetails.accountNumber) || "";
  var keyvaluepairs = "";
  keyvaluepairs = keyvaluepairs + MVMD_BASE_URL;
  keyvaluepairs = keyvaluepairs + "?data=" + getMD5EncryptedData(imei, selectedMTNData, deviceMtnIndicator);
  keyvaluepairs = keyvaluepairs + ":" + timestamp;
  keyvaluepairs = keyvaluepairs + ":SNO=" + serialNo;
  keyvaluepairs = keyvaluepairs + ":accessLevel=2";
  keyvaluepairs = keyvaluepairs + ":EntryPoint=SP";
  keyvaluepairs = keyvaluepairs + ":ACCNUM=" + accountNo;
  keyvaluepairs = keyvaluepairs + ":CALLID=" + callId;
  keyvaluepairs = keyvaluepairs + ":IMEI=" + imei;
  keyvaluepairs = keyvaluepairs + ":MDN=" + mtn;
  keyvaluepairs = keyvaluepairs + ":MEID=" + meid;
  keyvaluepairs = keyvaluepairs + ":MFR=" + equipManufacturer;
  keyvaluepairs = keyvaluepairs + ":MODELNAME=" + modelName;
  keyvaluepairs = keyvaluepairs + "&remoteinonly=true#/mvmdremoteinAlone";
  return keyvaluepairs;
}
function getMD5EncryptedData(imei, selectedMTNData, deviceMtnIndicator) {
  if (isFWADevice(selectedMTNData)) {
    var deviceMacId = "";
    var fixedWirelessInfo = getFixedWirelessInfo(selectedMTNData);
    var fwDeviceInfoArr = fixedWirelessInfo && fixedWirelessInfo.deviceInfo;
    if (fwDeviceInfoArr && fwDeviceInfoArr.length > 0) {
      deviceMacId = fetchDeviceMacId(fwDeviceInfoArr, deviceMtnIndicator);
    }
    return Md5(deviceMacId);
  } else {
    return Md5(imei);
  }
}
function fetchDeviceMacId(fwDeviceInfoArr, deviceMtnIndicator) {
  var deviceMacId = "";
  for (var _iterator3 = _createForOfIteratorHelperLoose(fwDeviceInfoArr), _step3; !(_step3 = _iterator3()).done;) {
    var device = _step3.value;
    if (device) {
      if (device.deviceIdType === "MC5" && (device.deviceTyp === "RTR" || device.deviceTyp === "5IR" || device.deviceTyp === "LTE" && device.skuId === "NVG558HX")) {
        deviceMacId = device.deviceId;
      }
      if ((deviceMtnIndicator === "W" || deviceMtnIndicator === "I") && (device.deviceTyp === "RTR" || device.deviceTyp === "4IR")) {
        deviceMacId = device.deviceId;
      }
    }
  }
  return deviceMacId;
}
var getFixedWirelessInfo = function getFixedWirelessInfo(selectedMTNData) {
  var fixedWirelessInfo = [];
  if (selectedMTNData && selectedMTNData.fixedWirelessInfo) {
    fixedWirelessInfo = selectedMTNData.fixedWirelessInfo;
    console.log("5G_Home: Fixed wirelessInfo found");
  }
  return fixedWirelessInfo;
};
var IsNullOrUndefinedObj = function IsNullOrUndefinedObj(obj) {
  return obj === null || obj === undefined || typeof obj === "undefined";
};
var IsNullOrEmpty = function IsNullOrEmpty(obj) {
  isEmpty$1(obj, true);
};
function prepareMVDLaunchOutRequestUrlData(selectedMTNData) {
  var _window3, _window3$caseDetails, _selectedMTNData$devi13, _selectedMTNData$devi14, _selectedMTNData$devi15, _selectedMTNData$devi16, _selectedMTNData$devi17, _selectedMTNData$devi18, _selectedMTNData$devi19, _selectedMTNData$devi20, _selectedMTNData$devi21, _selectedMTNData$devi22, _selectedMTNData$devi23, _selectedMTNData$devi24, _selectedMTNData$devi25, _selectedMTNData$devi26;
  console.log(selectedMTNData);
  var mtn = selectedMTNData === null || selectedMTNData === void 0 ? void 0 : selectedMTNData.mtn;
  var accountNo = ((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$caseDetails = _window3.caseDetails) === null || _window3$caseDetails === void 0 ? void 0 : _window3$caseDetails.accountNumber) || "";
  var meid = "";
  var equipManufacturer = (selectedMTNData === null || selectedMTNData === void 0 ? void 0 : (_selectedMTNData$devi13 = selectedMTNData.deviceInfo) === null || _selectedMTNData$devi13 === void 0 ? void 0 : (_selectedMTNData$devi14 = _selectedMTNData$devi13[0]) === null || _selectedMTNData$devi14 === void 0 ? void 0 : _selectedMTNData$devi14.equipmentMfgName) || "";
  var modelName = (selectedMTNData === null || selectedMTNData === void 0 ? void 0 : (_selectedMTNData$devi15 = selectedMTNData.deviceInfo) === null || _selectedMTNData$devi15 === void 0 ? void 0 : (_selectedMTNData$devi16 = _selectedMTNData$devi15[0]) === null || _selectedMTNData$devi16 === void 0 ? void 0 : _selectedMTNData$devi16.modelName) || "";
  var imei = (selectedMTNData === null || selectedMTNData === void 0 ? void 0 : (_selectedMTNData$devi17 = selectedMTNData.deviceInfo) === null || _selectedMTNData$devi17 === void 0 ? void 0 : (_selectedMTNData$devi18 = _selectedMTNData$devi17[0]) === null || _selectedMTNData$devi18 === void 0 ? void 0 : _selectedMTNData$devi18.imei) || "";
  var deviceType = (selectedMTNData === null || selectedMTNData === void 0 ? void 0 : (_selectedMTNData$devi19 = selectedMTNData.deviceInfo) === null || _selectedMTNData$devi19 === void 0 ? void 0 : (_selectedMTNData$devi20 = _selectedMTNData$devi19[0]) === null || _selectedMTNData$devi20 === void 0 ? void 0 : _selectedMTNData$devi20.deviceType) || "";
  var deviceMacId = "";
  var iccid = (selectedMTNData === null || selectedMTNData === void 0 ? void 0 : (_selectedMTNData$devi21 = selectedMTNData.deviceInfo) === null || _selectedMTNData$devi21 === void 0 ? void 0 : (_selectedMTNData$devi22 = _selectedMTNData$devi21[0]) === null || _selectedMTNData$devi22 === void 0 ? void 0 : _selectedMTNData$devi22.simId) || "";
  var callId = "";
  var serialNo = "";
  var skuId = (selectedMTNData === null || selectedMTNData === void 0 ? void 0 : (_selectedMTNData$devi23 = selectedMTNData.deviceInfo) === null || _selectedMTNData$devi23 === void 0 ? void 0 : (_selectedMTNData$devi24 = _selectedMTNData$devi23[0]) === null || _selectedMTNData$devi24 === void 0 ? void 0 : (_selectedMTNData$devi25 = _selectedMTNData$devi24.equipGuideData) === null || _selectedMTNData$devi25 === void 0 ? void 0 : (_selectedMTNData$devi26 = _selectedMTNData$devi25.deviceModel) === null || _selectedMTNData$devi26 === void 0 ? void 0 : _selectedMTNData$devi26.sku) || "";
  var keyvaluepairs = "";
  if (deviceType === "4GR" || deviceType === "5GL") ; else if (isFWADevice(selectedMTNData)) {
    keyvaluepairs = keyvaluepairs + "ANTENNAMDN=" + mtn + ":ACCNUM=" + accountNo + ":CALLID=" + callId + ":SNO=" + serialNo + ":ACALLID=" + callId;
    keyvaluepairs = keyvaluepairs + ":ANTENNAMFR=" + equipManufacturer;
    keyvaluepairs = keyvaluepairs + ":ANTENNAMODELNAME=" + modelName;
    keyvaluepairs = keyvaluepairs + ":ANTENNAIMEI=" + imei;
    keyvaluepairs = keyvaluepairs + ":ANTENNADEVICETPE=" + deviceType;
    keyvaluepairs = keyvaluepairs + ":ROUTERMAC=" + deviceMacId;
  } else if (skuId === "TR2V1") {
    keyvaluepairs = keyvaluepairs + "EXTENDERMDN=" + mtn + ":ACCNUM=" + accountNo + ":CALLID=" + callId + ":SNO=" + serialNo + ":ACALLID=" + callId;
    keyvaluepairs = keyvaluepairs + ":EXTENDERMFR=" + equipManufacturer;
    keyvaluepairs = keyvaluepairs + ":EXTENDERMODELNAME=" + modelName;
    keyvaluepairs = keyvaluepairs + ":EXTENDERIMEI=" + imei;
    keyvaluepairs = keyvaluepairs + ":EXTENDERDEVICETYPE=" + deviceType;
  } else {
    keyvaluepairs = "MDN=" + mtn + ":ACCNUM=" + accountNo + ":MEID=" + meid + ":IMEI=" + imei + ":ICCID=" + iccid + ":CALLID=" + callId + ":SNO=" + serialNo + ":ACALLID=" + callId + ":MFR=" + equipManufacturer + ":MODELNAME=" + modelName;
    keyValuePairsForSMARTROUTER(deviceType, modelName, keyvaluepairs);
  }
  console.log(keyvaluepairs);
  return keyvaluepairs;
}
function keyValuePairsForSMARTROUTER(deviceType, modelName, keyvaluepairs) {
  if (deviceType && (deviceType === "4GC" || deviceType === "4GE" && modelName && modelName.toUpperCase().indexOf("SMART ROUTER") > -1)) {
    keyvaluepairs += ":DEVICETYPE=" + deviceType;
  }
  return keyvaluepairs;
}
var DisplayDate = function DisplayDate() {
  var currentDate = new Date();
  var month = currentDate.getMonth() + 1;
  var year = currentDate.getFullYear();
  var day = currentDate.getDate();
  day = day < 10 ? "0" + day : day;
  var hour = currentDate.getHours();
  var minutes = currentDate.getMinutes();
  var ampm = hour >= 12 ? "PM" : "AM";
  hour = hour || 12;
  hour = hour > 12 ? hour - 12 : hour;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var disDate = month + "/" + day + "/" + year + ", " + hour + ":" + minutes + " " + ampm;
  return /*#__PURE__*/React__default.createElement("span", {
    style: {
      "float": "inline-end",
      fontSize: ".9rem"
    }
  }, " ", disDate);
};
function popupWindow(url, title, w, h) {
  var left = screen.width / 2 - w / 2;
  var top = screen.height / 2 - h / 2;
  return window.open(url, title, "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left);
}
function isIpad() {
  return !!navigator.userAgent.match(/iPad|iPhone/i);
}
function ipadShell(EurlIpad) {
  var shellParams = {
    name: "Emulator",
    path: "",
    replace: "true",
    params: "rawurl:" + EurlIpad,
    openNewWindow: "true"
  };
  console.log(shellParams, "&&&shellParams");
  executeShellFunction("Shell", "showScreen", "none", shellParams);
}
function executeShellFunction(type, ops, callBack, params) {
  interactWithShell(getCodeURI(type, ops, callBack, params));
}
function interactWithShell(url) {
  console.log(url);
  try {
    var _iFrame = document.getElementById("shellInteractionIframeTrg");
    _iFrame.setAttribute("src", DOMPurify.sanitize(url));
  } catch (e) {
    console.log("ETR: we have issue while interacting with shell URL:- " + url + " Error:-" + e);
  }
}
function getCodeURI(type, ops, callBack, params) {
  var url = "mpos://" + type + "/" + ops;
  var i = 0;
  if (callBack && callBack !== 'none') {
    url += "?callback=" + encodeURIComponent(callBack);
    i++;
  }
  if (params) {
    for (var paramKey in params) {
      var paramValue = params[paramKey];
      if (paramKey) {
        url += (i == 0 ? '?' : '&') + paramKey + "=" + encodeURIComponent(typeof paramValue == 'object' ? JSON.stringify(paramValue) : paramValue);
        ++i;
      }
    }
  }
  return url;
}
function getFeatureFlag(featureFlagArr, featureFlagName) {
  return featureFlagArr === null || featureFlagArr === void 0 ? void 0 : featureFlagArr.find(function (obj) {
    return obj.featureFlagName === featureFlagName;
  });
}

var calledNoEnabledProblemType = ["Call Quality-Audio-Dead Air", "Call Quality-Audio-Dropped Call-All Calls", "Call Quality-Audio-Dropped Call-Isolated Calls", "Call Quality-Audio-One Way", "Call Quality-Audio-Poor Audio", "Caller ID", "Cannot Originate Calls to 411", "Cannot Originate Calls to 800#", "Cannot Originate Calls to Any Number", "Cannot Originate Calls to Specific Number", "Cannot Receive Calls-Cannot Receive Any Calls", "Cannot Receive Calls-From Specific Numbers"];
var newCalledNoEnabledProblemType = ["Call Quality-Audio-Dead Air", "Call Quality-Audio-Dropped Call-All Calls", "Call Quality-Audio-Dropped Call-Isolated Calls", "Call Quality-Audio-One Way", "Call Quality-Audio-Poor Audio", "Caller ID", "Cannot Originate Calls to 800#", "Cannot Originate Calls to Any Number", "Cannot Originate Calls to Specific Number", "Cannot Receive Calls-Cannot Receive Any Calls", "Cannot Receive Calls-From Specific Numbers", "MMS-Cannot Originate: At All", "MMS-Cannot Originate: Specific", "MMS-Cannot Receive: At All", "MMS-Cannot Receive: Specific", "MMS-Unsolicited MMS", "SMS-Cannot Originate: At All", "SMS-Cannot Originate: Specific", "SMS-Cannot Receive: At All", "SMS-Cannot Receive: Specific", "SMS-Unsolicited SMS", "SMS-Delayed", "SMS-Duplicate", "VZWNE-Cannot Originate Calls", "VZWNE-Cannot Receive Calls"];

var NRB_FORM_DATA = 'nrbFormData';
var formSession = {
  get: function get() {
    try {
      var data = sessionStorage.getItem(NRB_FORM_DATA);
      return JSON.parse(data);
    } catch (e) {
      console.error('Error getting session from sessionStorage', e);
      return;
    }
  },
  set: function set(data) {
    try {
      sessionStorage.setItem(NRB_FORM_DATA, JSON.stringify(data));
    } catch (e) {
      console.error('Error setting session to sessionStorage', e);
    }
  },
  reset: function reset() {
    try {
      sessionStorage.removeItem(NRB_FORM_DATA);
    } catch (e) {
      console.error('Error removing session from sessionStorage', e);
    }
  }
};
var NRB_CASE_ID = 'nrbCaseId';
var sessionCaseId = {
  get: function get() {
    try {
      return sessionStorage.getItem(NRB_CASE_ID);
    } catch (e) {
      console.error('Error getting session from sessionStorage', e);
      return;
    }
  },
  set: function set(caseId) {
    try {
      sessionStorage.setItem(NRB_CASE_ID, caseId);
    } catch (e) {
      console.error('Error setting session to sessionStorage', e);
    }
  },
  reset: function reset() {
    try {
      sessionStorage.removeItem(NRB_CASE_ID);
    } catch (e) {
      console.error('Error removing session from sessionStorage', e);
    }
  }
};
var triggerCountSession = {
  get: function get(caseId) {
    try {
      var storedTriggerCounts = JSON.parse(sessionStorage.getItem('nrbFormTriggerCounts')) || {};
      return storedTriggerCounts[caseId] || 1;
    } catch (e) {
      console.error('Failed to get trigger count from session storage', e);
      return 1;
    }
  },
  set: function set(caseId, count) {
    try {
      var storedTriggerCounts = JSON.parse(sessionStorage.getItem('nrbFormTriggerCounts')) || {};
      storedTriggerCounts[caseId] = count;
      sessionStorage.setItem('nrbFormTriggerCounts', JSON.stringify(storedTriggerCounts));
    } catch (e) {
      console.error('Failed to save trigger count to session storage', e);
    }
  },
  reset: function reset(caseId) {
    try {
      var storedTriggerCounts = JSON.parse(sessionStorage.getItem('nrbFormTriggerCounts')) || {};
      delete storedTriggerCounts[caseId];
      sessionStorage.setItem('nrbFormTriggerCounts', JSON.stringify(storedTriggerCounts));
    } catch (e) {
      console.error('Failed to reset trigger count in session storage', e);
    }
  }
};
var apiTypes = {
  problemType: 'ProblemType',
  serviceType: 'ServiceType',
  qualifierQuestions: 'QualifierQuestions',
  state: 'State',
  country: 'Country',
  phoneModel: 'PhoneModel',
  handsetVersion: 'HandsetVersion',
  buildingService: 'BuildingService',
  buildingServiceModel: 'BuildingServiceModel'
};
var getAxiosConfig$2 = function getAxiosConfig(isACSS) {
  return {
    withCredentials: true,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      credentials: true,
      channelId: isACSS ? 'VZW-ACSS' : channelId
    }
  };
};
var getUrl$2 = function getUrl(apiName) {
  var mvoenv = sessionStorage.getItem('mvoenv');
  var externalTarget = sessionStorage.getItem('mvoExternalTarget');
  var _tsaEnvConfig = tsaEnvConfig$1({
      mvoenv: mvoenv,
      externalTarget: externalTarget
    }),
    apiUrls = _tsaEnvConfig.apiUrls;
  return apiUrls === null || apiUrls === void 0 ? void 0 : apiUrls[apiName];
};
var swrDefaults$1 = {
  revalidateOnFocus: false,
  revalidateOnReconnect: true,
  revalidateIfStale: false,
  shouldRetryOnError: false,
  revalidateOnMount: true
};
var checkIsNA = function checkIsNA(qualifiers) {
  return (qualifiers === null || qualifiers === void 0 ? void 0 : qualifiers.length) === 1 && (qualifiers === null || qualifiers === void 0 ? void 0 : qualifiers.includes('NA'));
};
var parseQuestionnaires = function parseQuestionnaires(_ref) {
  var questionnaires = _ref.questionnaires,
    nrbFormData = _ref.nrbFormData;
  return Object.entries((nrbFormData === null || nrbFormData === void 0 ? void 0 : nrbFormData.questionnaires) || {}).map(function (_ref2) {
    var questionId = _ref2[0],
      answer = _ref2[1];
    var questionField = questionnaires === null || questionnaires === void 0 ? void 0 : questionnaires.find(function (q) {
      return (q === null || q === void 0 ? void 0 : q.original['Question ID']) === questionId;
    });
    var question = [{
      name: 'Interface_RequestType',
      value: 'Create Answer'
    }, {
      name: 'AppUser Login',
      value: 'ACSS'
    }, {
      name: 'Qualifier ID',
      value: questionField === null || questionField === void 0 ? void 0 : questionField.original['Qualifier ID']
    }, {
      name: 'Question ID',
      value: questionField === null || questionField === void 0 ? void 0 : questionField.original['Question ID']
    }, {
      name: 'QuestionnaireAnswers',
      value: answer
    }];
    return {
      question: question
    };
  });
};
var getProfile = function getProfile() {
  try {
    var userProfile = JSON.parse(localStorage.getItem('userprofile'));
    var _ref3 = userProfile || {},
      userId = _ref3.userId,
      departmentId = _ref3.departmentId,
      departmentName = _ref3.departmentName,
      firstName = _ref3.firstName,
      lastName = _ref3.lastName;
    var depts = ['ERT', 'ATex'];
    var priorityLevel = depts.includes(departmentName) ? 'P2' : 'P3';
    return {
      appUserLogin: userId,
      deptID: departmentId,
      deptName: departmentName,
      repName: firstName + " " + lastName,
      extendedPriority: priorityLevel,
      priorityLevel: priorityLevel
    };
  } catch (e) {
    console.error('Error parsing userprofile from local storage', e);
    return {};
  }
};
var getAttributeValue = function getAttributeValue(attrNames, key) {
  var _attrNames$find;
  return (attrNames === null || attrNames === void 0 ? void 0 : (_attrNames$find = attrNames.find(function (attr) {
    return (attr === null || attr === void 0 ? void 0 : attr.attributeID) === key;
  })) === null || _attrNames$find === void 0 ? void 0 : _attrNames$find.value) || '';
};
var getInBuilding = function getInBuilding(attrNames) {
  var inBuilding = getAttributeValue(attrNames, 'inBuilding');
  return (inBuilding === null || inBuilding === void 0 ? void 0 : inBuilding.toLowerCase()) === 'yes';
};
var getInBuildingForVZWNE = function getInBuildingForVZWNE(attrNames, problemType) {
  if (problemType !== null && problemType !== void 0 && problemType.includes('VZWNE')) {
    return 'Yes';
  }
  return getAttributeValue(attrNames, 'inBuilding');
};
var getDefaultFormValues = function getDefaultFormValues(attrNames, caseId) {
  var apiDefaultValues = {
    addressLine: getAttributeValue(attrNames, 'addressLine'),
    zipCode: getAttributeValue(attrNames, 'zipCode2'),
    state: getAttributeValue(attrNames, 'state'),
    country: 'USA',
    calledNumber: getAttributeValue(attrNames, 'calledNumber'),
    callBackNumber: getAttributeValue(attrNames, 'callBackNumber'),
    problemStartDateTime: getAttributeValue(attrNames, 'problemStartDateTime'),
    problemDescription: getAttributeValue(attrNames, 'problemDescription')
  };
  if (caseId === sessionCaseId.get()) {
    var _mergedValues$problem;
    var formDataFromSession = formSession.get();
    if (!formDataFromSession) {
      return apiDefaultValues;
    }
    var mergedValues = _extends({}, formDataFromSession);
    Object.keys(apiDefaultValues).forEach(function (field) {
      var apiValue = apiDefaultValues[field];
      var sessionValue = formDataFromSession[field];
      if (apiValue !== '' && apiValue !== sessionValue && field !== "country") {
        mergedValues[field] = apiValue;
      }
    });
    if (!(mergedValues !== null && mergedValues !== void 0 && mergedValues.country)) {
      mergedValues.country = 'USA';
    }
    var isBuilding = getInBuilding(attrNames);
    if (!isBuilding && !(mergedValues !== null && mergedValues !== void 0 && (_mergedValues$problem = mergedValues.problemType) !== null && _mergedValues$problem !== void 0 && _mergedValues$problem.includes('VZWNE'))) {
      mergedValues.inBuildingSolution = undefined;
      mergedValues.model = undefined;
    }
    return mergedValues;
  }
  return apiDefaultValues;
};
var additionalPayloadData = function additionalPayloadData(_ref4) {
  var _configDetails$params, _configDetails$params2, _configDetails$select;
  var steps = _ref4.steps,
    interactionCaseId = _ref4.interactionCaseId,
    configDetails = _ref4.configDetails,
    nrbFormData = _ref4.nrbFormData;
  var _ref5 = steps || [],
    _ref5$ = _ref5[0],
    step = _ref5$ === void 0 ? {} : _ref5$;
  var attrNames = (step === null || step === void 0 ? void 0 : step.attrNames) || [];
  var additionalData = attrNames.reduce(function (acc, _ref6) {
    var attributeID = _ref6.attributeID,
      value = _ref6.value;
    acc[attributeID] = value;
    return acc;
  }, {});
  var userProfileLocalData = getProfile();
  var problemType = (nrbFormData === null || nrbFormData === void 0 ? void 0 : nrbFormData.problemType) || '';
  var nrbDataFields = _extends({}, additionalData, userProfileLocalData, {
    interactionCaseId: interactionCaseId,
    viraCaseId: configDetails === null || configDetails === void 0 ? void 0 : configDetails.caseId,
    accountNumber: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : _configDetails$params.accountNumber,
    mtn: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params2 = configDetails.paramsDetails) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.mdn,
    custInfoEmail: step === null || step === void 0 ? void 0 : step.custEmailId,
    assignedTo: 'Network Repair Bureau',
    surePay: 'No',
    repContact: '8009220204',
    clientId: 'VZW-ACSS',
    serviceName: 'ServiceCase',
    callReason: 'ServiceCase',
    ticketType: 'Network',
    serviceType: 'UTP',
    interfaceReqeustType: 'Ticket Create',
    appTicketId: 'UTP',
    processStep: 'Initiate',
    processAction: 'CreateCase',
    userType: 'Submitter',
    inBuilding: getInBuildingForVZWNE(attrNames, problemType),
    registerNumber: 0,
    ticketSubType: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select = configDetails.selectedNSAIntent) === null || _configDetails$select === void 0 ? void 0 : _configDetails$select.intent,
    startPriority: 'P3',
    group: 'NRB'
  });
  return nrbDataFields;
};
var callSubmitVira = function callSubmitVira(ticketCaseId, handleTroubleShootingAction) {
  if (ticketCaseId === void 0) {
    ticketCaseId = null;
  }
  var button = {
    label: 'SubmitNrbForm',
    action: 'SubmitNrbForm',
    type: 'primary',
    url: '',
    callFunction: ''
  };
  var options = {
    optionSelected: '',
    ticketCaseId: ticketCaseId
  };
  if (handleTroubleShootingAction) {
    handleTroubleShootingAction(button, options);
  }
};
var openRemedyPopup = function openRemedyPopup(launchAutoCreateFollowUp, _ref7) {
  var interactionCaseId = _ref7.interactionCaseId,
    caseId = _ref7.caseId,
    ticketCaseId = _ref7.ticketCaseId;
  try {
    var followUpData = {
      ticketType: 'Network',
      ticketSubType: '',
      ticketDetails: {
        interactionCaseId: interactionCaseId,
        caseId: caseId,
        ticketCaseId: ticketCaseId
      }
    };
    launchAutoCreateFollowUp(followUpData);
  } catch (error) {
    console.error('Error opening Remedy Popup', {
      launchAutoCreateFollowUp: launchAutoCreateFollowUp,
      error: error
    });
  }
};
var getUniqueValues = function getUniqueValues(array) {
  var uniqueValues = [];
  var seen = {};
  array.forEach(function (item) {
    if (item && !seen[item]) {
      seen[item] = true;
      uniqueValues.push(item);
    }
  });
  return uniqueValues;
};
var formDate = function formDate(value) {
  var digits = value === null || value === void 0 ? void 0 : value.replace(/\D/g, '');
  var match = digits.match(/(\d{1,2})(\d{1,2})?(\d{1,4})?/);
  if (!match) return value;
  var month = match[1],
    day = match[2];
  if (Number(month) > 12) return value.slice(0, value.length - 2);
  if (Number(day) > 31) return value.slice(0, value.length - 2);
  return match[1] + (match[2] ? '/' + match[2] : '') + (match[3] ? '/' + match[3] : '');
};
var validateDateRange = function validateDateRange(value) {
  var today = new Date();
  var fourYearsAgo = new Date();
  fourYearsAgo.setFullYear(today.getFullYear() - 4);
  var selectedDate = new Date(value);
  if (selectedDate > today) {
    return 'Date cannot be in the future';
  }
  if (selectedDate < fourYearsAgo) {
    return 'Date must not be older than 4 years';
  }
  return true;
};
var getCalledNumberState = function getCalledNumberState(attrNames, problemType, enableCalledNoForServiceTypeFFlag) {
  var calledNumber = getAttributeValue(attrNames, 'calledNumber');
  if (!calledNumber && (enableCalledNoForServiceTypeFFlag ? newCalledNoEnabledProblemType.includes(problemType) : calledNoEnabledProblemType.includes(problemType))) {
    return {
      readOnly: false
    };
  }
  if (!calledNumber && (enableCalledNoForServiceTypeFFlag ? !newCalledNoEnabledProblemType.includes(problemType) : !calledNoEnabledProblemType.includes(problemType))) {
    return {
      readOnly: true,
      resetCalledNumber: true
    };
  }
  return {
    readOnly: true
  };
};
var scrollToFirstError = function scrollToFirstError(formRef, errors) {
  if (!formRef.current || Object.keys(errors).length === 0) return;
  if (errors.questionnaires) {
    var questionnaireElement = formRef.current.querySelector('[data-field="questionnaires"]');
    if (questionnaireElement) {
      questionnaireElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      return;
    }
  }
  for (var _i = 0, _Object$keys = Object.keys(errors); _i < _Object$keys.length; _i++) {
    var fieldName = _Object$keys[_i];
    if (fieldName === 'questionnaires') continue;
    var element = document.querySelector("[data-field=\"" + fieldName + "\"]");
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      return;
    }
  }
};

var capitalize = function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
var createStore = function createStore(_ref) {
  var name = _ref.name,
    initialState = _ref.initialState;
  var StateContext = createContext(null);
  var DispatchContext = createContext(null);
  var reducer = function reducer(state, action) {
    switch (action.type) {
      case "SET_" + name.toUpperCase():
        return _extends({}, state, action.payload);
      case "RESET_" + name.toUpperCase():
        return initialState;
      default:
        throw new Error("Unknown action type: " + action.type);
    }
  };
  var Provider = function Provider(_ref2) {
    var children = _ref2.children;
    var _useReducer = useReducer(reducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];
    return /*#__PURE__*/React__default.createElement(StateContext.Provider, {
      value: state
    }, /*#__PURE__*/React__default.createElement(DispatchContext.Provider, {
      value: dispatch
    }, children));
  };
  var useStoreState = function useStoreState() {
    var context = useContext(StateContext);
    if (!context) {
      throw new Error(capitalize(name) + "Provider is missing.");
    }
    return context;
  };
  var useStoreDispatch = function useStoreDispatch() {
    var context = useContext(DispatchContext);
    if (!context) {
      throw new Error(capitalize(name) + "Provider is missing.");
    }
    return context;
  };
  return {
    Provider: Provider,
    useStoreState: useStoreState,
    useStoreDispatch: useStoreDispatch
  };
};

var phoneModelData = ["3SI Security Systems 4XGCT", "3SI Security Systems 4XGCT U", "4RF USA Aprisa LTE", "4RF USA Aprisa LTE LT0100000", "4RF USA Aprisa LTE LT0300000", "4RF USA Aprisa LTE LT0301000", "701x Inc xTag", "Accelerated Concepts 1003 CM11", "Accelerated Concepts U110", "Acer Chromebook 511 C741L", "Aclara Technoologies Metrum SM TC1", "Ademco dba Resideo LTEMXV ADT", "Ademco LTEL3V ADT", "Ademco LTEL5V ADT", "Ademco LTEM PV", "Ademco LTEM XV", "Ademco LTEXV ADT", "Ademco PROLTEV", "ADS Environmental Services 8000 FST IM 4WW", "ADS Environmental Services 9000 ECHO 4WW", "ADS Environmental Services 9000 RAIII 4WW", "ADS Environmental Services ADS ECHO", "ADS Environmental Services ADS RainAlert III", "ADS Environmental Services Triton Plus", "Advantech FWA 1012VCR 2CA1OD", "Advantech FWA 1012VCR 4CA1OD", "Advantech FWA 1012VCR 8CA1OD", "Advantech TREK EXT WWAN100", "Aetheros AOS ESR MI", "Agsense AgSense LTE Modem Board", "Agsense Agsense LTE Modem Board NA SS", "Alarm com ADC 470L LTE1", "Alarm com ADC 470L LTE1 NF", "Alarm com ADC 620T LTE1", "Alarm com ADC 620T LTE1 NF", "Alarm com ADC 800U A", "Alarm com ADC NK 100T LTE1", "Alarm com ADC NK 200T A", "Alarm com ADC NK200T A NF", "Alcatel 4051S Go Flip V", "Alcatel 5007S 1V Plus", "Alcatel 5059S Avalon V", "Alcatel 5059SPP Avalon PrePay", "Alchohol Countermeasure Systems Alcolock Data Transfer Module", "Alcohol Analytics Systems AAS 2 0", "Alcohol Monitoring Systems PAM V3", "Alcohol Monitoring Systems RB 210", "Alcohol Monitoring Systems Wireless Base Station LTE", "Aldona Fire Protection SG100", "Allerio AMH100", "Alliance Laundry Systems 204145P CELL", "Allied Universal Electronics Monitoring 14114AVL", "Allstate Processing Corp METRO LTD", "Altair ALT1210", "Altair ALT1210MOD VZ", "Altair ALT1250", "Altair ALT1250 CAT M1", "Altair ALT1250 NB IOT", "Altair FourGee 3800", "Alula BAT CONNECT", "Alula BAT FIRE", "Alula CONNECT XIP", "Alula RE930XP", "Amazon Key for Business KfB LeoLite", "AMC Health H3G 1100", "AMC Health H3G 900", "American Network Solutions ANS F30", "AMIT Wireless IDG400", "AMIT Wireless MDG100", "AMIT Wireless MDG200", "Anaren Microwave WM3", "Anelto Lepton", "Anelto OnTheGo Lite", "Anydata ACT233F", "Appareo 608065 000036", "Appareo 608065 000036 Gorder", "Appareo ACE EG25G", "Appareo ACU 205", "Appareo ACU 230 153010 000140", "Appareo ACU 235 G", "Appareo Appareo Cellular Assembly", "Appareo EppNordic", "Appareo Galeo Pro", "Appareo Marmarth", "Apple iPad 10th Gen", "Apple iPad 4G", "Apple iPad 6th Gen", "Apple iPad 7th Gen", "Apple iPad 8th Gen", "Apple iPad 9th Gen", "Apple iPad Air", "Apple iPad Air 11 inch", "Apple iPad Air 13 inch", "Apple iPad Air 3", "Apple iPad Mini", "Apple iPad Mini 3", "Apple iPad Mini 4", "Apple iPad Mini 5", "Apple iPad Mini 6", "Apple iPad Pro 10 5 Inch", "Apple iPad Pro 11", "Apple iPad Pro 11 Inch", "Apple iPad Pro 11 inch", "Apple iPad Pro 12 9 6th gen", "Apple iPad Pro 12 9 Inch", "Apple iPad Pro 13 inch", "Apple iPad Pro 9 7 Inch", "Apple iPad with Retina Display", "Apple iPhone 11", "Apple iPhone 11 Pro", "Apple iPhone 11 Pro Max", "Apple iPhone 12 5G", "Apple iPhone 12 Mini 5G", "Apple iPhone 12 Pro 5G", "Apple iPhone 12 Pro Max 5G", "Apple iPhone 13", "Apple iPhone 13 Mini", "Apple iPhone 13 Pro", "Apple iPhone 13 Pro Max", "Apple iPhone 14", "Apple iPhone 14 Plus", "Apple iPhone 14 Pro", "Apple iPhone 14 Pro Max", "Apple iPhone 15", "Apple iPhone 15 Plus", "Apple iPhone 15 Pro", "Apple iPhone 15 Pro Max", "Apple iPhone 16", "Apple iPhone 16 Plus", "Apple iPhone 16 Pro", "Apple iPhone 16 Pro Max", "Apple iPhone 6", "Apple iPhone 6 Plus", "Apple iPhone 6S", "Apple iPhone 6S Plus", "Apple iPhone 7", "Apple iPhone 7 Plus", "Apple iPhone 8", "Apple iPhone 8 Plus", "Apple iPhone SE", "Apple iPhone SE 2nd Gen", "Apple iPhone SE 3rd Gen", "Apple iPhone X", "Apple iPhone XR", "Apple iPhone XS", "Apple iPhone XS Max", "Apple Watch SE", "Apple Watch SE 2nd gen", "Apple Watch Series 10", "Apple Watch Series 3", "Apple Watch Series 4", "Apple Watch Series 5", "Apple Watch Series 6", "Apple Watch Series 7", "Apple Watch Series 8", "Apple Watch Series 9", "Apple Watch Ultra", "Apple Watch Ultra 2nd Gen", "Apptricity i Connect Controller", "Apptricity i Connect Controller Scout", "Apptricity i Connect Controller Scout Gn2", "Apptricity iConnect Controller Pathfinder", "Apptricity Ranger Gen2", "Aqua Management Vapor X EC21 V", "Aquana Aquana Smart Valve", "AquaSpy CTLV3", "Arcadyan ARC XCI55AX Titan II Verizon Internet Gateway", "Arcadyan CE1000A", "Arcadyan XC46BE Dragon Verizon Internet Gateway", "Arpa Analytics Arpa1 Board", "Arris NVG558 Router", "Arrow Electronics AIO 3350 V1", "Asiatelco Technologies AS31", "Asiatelco Technologies AT10", "Asiatelco Technologies AT70M", "Asiatelco Technologies FL Flex2", "Asiatelco Technologies IKON AV1", "Asiatelco Technologies LM91 MV", "Asiatelco Technologies W01", "Asiatelco Technologies W02", "Asiatelco Technologies WCM 002", "Asiatelco WCM 001", "Askey ASK RTL 108", "Askey NCM1100E Business Internet Gtwy", "Askey NCQ 1338 Titan I Verizon Internet Gateway", "Askey NCQ 1338E Lannister I Verizon Internet Gateway", "Askey NCQ 1338FA Titan I 5 Verizon Internet Gateway", "Askey SDK NCM1100 Titan 4 Verizon Internet Gateway", "Assured Telematics B1 MIOT GA", "Astute Astute CTR 01", "ASUS A002A ZenFone AR", "ASUS A006 ZenFone V", "ASUS A009 ZenFone V Live", "ASUS P008 Z8 ZenPad", "ASUS P00J Z8 ZenPad", "ASUS TP370QL", "ASUS Z10 ZenPad", "Atlantic Technology IronAntWP", "Atlantic Technology TinSoldierWP", "ATrack Technology", "ATrack Technology AX11", "Attenti US 14024VL", "Attenti US 24014VL", "Attenti US 34204VL", "Autonet Mobile OBD MD", "Autotech Technologies Wireless Cellular IoT Router", "AVIRE AC 4CM10 650 F 20 000", "Axon AX1023 7610", "Ayantra MAT400 CATM1", "Ayyeka Wavelet4", "B and B Electronics Manufacturing SmartFlex SR310", "B B Electronics Manufacturing Company SmartStart", "B B Electronics Manufacturing ICR 3200", "B B Electronics Manufacturing ICR 3211B", "B B Electronics Manufacturing OWL LPWAN", "B B Electronics SmartFlex", "B B Electronics SmartSwarm", "BAE Systems Applied Intelligence Palomino III", "BAK USA Seal8Pro", "Barnett Engineering B1285W4", "Barnett Engineering ProTalk Cv3", "Basic Sunbeam F1", "Bastian Solutions BlueHound Asset Tracker", "BCycle LLC Dash Bicicle", "BCycle V3 Connected Dock BG95", "BEC Technologies BEC MX 100U 4G LTE Modem", "BEC Technologies BEC MX 200A 4G LTE Industrial M2M Router", "BEC Technologies BEC MX 200A ODU", "BEC Technologies MX 210NP R17 AF", "BEC Technologies MX 221P Trio", "BEC Technologies MX 230 M1", "Behold Control Equipment Behold Director", "Beijer Electronics CloudVPN Ethernet PlusWiFi PlusLTE", "Belden DX940e", "BEST BUY HEALTH FIH Limited GW23", "BEST BUY HEALTH TCT Mobile 4053S Jitterbug Flip 2", "BEST BUY HEALTH TCT Mobile 4058P", "BEST BUY HEALTH TCT Mobile 5007S 1V Plus", "BEST BUY HEALTH TCT Mobile LVR5", "BEST BUY HEALTH TCT Mobile T608G", "BEST BUY HEALTH WiBASE Industrial Solutions LVR5", "BI BI HomeGuard 20 20", "BI BI LOC8 LTE", "BI BI SL3", "BLU Products B130DL View 2", "BLU Products B135DL BLU View 2", "BLU Products B160V", "BLU Products B170D View 2", "BLU Products BLU B110DL", "BluAzu Eon", "Blue Siren MODEM BREAKOUT BOARD", "Blue Sparq CATM1 PLUGnPLAY", "Blue Sparq Insight Vending Telemetry", "Blue Sparq QCAT1PLUGnPLAY", "Blue Sparq QCAT1PLUGnPLAY G", "Blue Sparq Vending Control Board", "Blue Sparq Vending Drink Telemetry", "Blue Sparq Vending POS", "Bluebird EF501X", "blueRover BLUEMODEM V", "Bluestone Medical dba OnSite Waste Technologies TE5000", "Bluspectrum Personal GPS", "BMP LOGIC BMPLOGIC YDOC01", "Bosch Security Systems B440", "Bosch Security Systems B441", "Bosch Security Systems B444", "Bosch Security Systems B444 V", "Bosch Thermotechnology IDS V2 1 Gateway", "BrightSky BS6425L AF 11", "BrightSky BS6425L V 11", "Brio Wireless BP4T1 USV UFL", "Bullitt Group Cat S48c VWQ", "Bullitt Group S48c", "Business Marketers Group AC 4CM10 650 F 20 000", "CalAmp ATU1300M", "CalAmp Corp TTU2840XT", "CalAmp HMU3640LV", "CalAmp LMU1300MB", "CalAmp LMU2630M", "CalAmp LMU2630MB", "CalAmp LMU3030LVBL", "CalAmp LMU3040MB", "CalAmp LMU3640LVB", "CalAmp LMU3640MB", "CalAmp LMU3641MB", "CalAmp LMU5541LW", "CalAmp QB300LV", "CalAmp TTU 1230 LTE", "CalAmp TTu 2830 LTE", "CalAmp TTU2830MB", "CalAmp TTU2900MB", "CalAmp Wireless Networks LMU2650MB", "CalAmp Wireless Networks LMU4350LB", "CALE America CALE LTE Modem", "Campbell Scientific CELL210", "Campbell Scientific Internal CELL210", "Cantaloupe ePort Verizon", "Carma Systems CarmaLink LTE", "Carolina Electronics Assemblers TraKid Explorer Band", "Case Emergency Systems LX200", "Case Systems LV100", "Castle Technology UPT1000F", "Castles Technology SATURN 1000 E UPT", "Castles Technology UPT1000B", "Castles Technology UPT1000K", "Castles Technology V3M2", "Cattail Technologies DS600L", "Cattail Technologies MOBILELOCK DS600", "Centrix IP FNG 104", "ChargePoint CPF50", "CHARTER COMMUNICATION Google G020E Pixel 3aXL", "CHARTER COMMUNICATIONS Google G020I Pixel 4", "CHARTER COMMUNICATIONS Google G020J Pixel 4 XL", "CHARTER COMMUNICATIONS Google G025E Pixel 4A 5G", "CHARTER COMMUNICATIONS Google G1MNW W Pixel 8 Pro 5G", "CHARTER COMMUNICATIONS Google G2YBB W Pixel 9 5G", "CHARTER COMMUNICATIONS Google G8V0U W Pixel 6 Pro 5G", "CHARTER COMMUNICATIONS Google G9BQD W Pixel 8 5G", "CHARTER COMMUNICATIONS Google GB7N6 W Pixel 6 5G", "CHARTER COMMUNICATIONS Google GBDU9 W", "CHARTER COMMUNICATIONS Google GD1YQ Pixel 5 5G", "CHARTER COMMUNICATIONS Google GE2AE W Pixel 7 Pro 5G", "CHARTER COMMUNICATIONS Google GGH2X W Pixel 9 Pro Fold 5G", "CHARTER COMMUNICATIONS Google GGX8B W Pixel 9 Pro XL 5G", "CHARTER COMMUNICATIONS Google GKV4X W Google Pixel 8a 5G", "CHARTER COMMUNICATIONS Google GR83Y W Pixel 9 Pro 5G", "CHARTER COMMUNICATIONS Google GRY0E W Pixel Watch 3", "CHARTER COMMUNICATIONS Google GVU6C W Pixel 7 5G", "CHARTER COMMUNICATIONS Google GWKK3 W Pixel 7a 5G", "CHARTER COMMUNICATIONS Google GX7AS W Pixel 6a", "CHARTER COMMUNICATIONS LG GPLMK300QM6", "CHARTER COMMUNICATIONS LG GPLMK500QM5", "CHARTER COMMUNICATIONS LG GPLMK500QM6", "CHARTER COMMUNICATIONS LG GPLMQ620QM6", "CHARTER COMMUNICATIONS LG GPLMQ710ULS", "CHARTER COMMUNICATIONS LG GPLMQ720QM5", "CHARTER COMMUNICATIONS LG GPLMQ720QM6", "CHARTER COMMUNICATIONS LG GPLMQ730QM5", "CHARTER COMMUNICATIONS LG GPLMQ730QM6", "CHARTER COMMUNICATIONS LG GPLMX410ULML", "CHARTER COMMUNICATIONS LG GPLMX420QM6", "CHARTER COMMUNICATIONS Motorola Mobility XT2052 1 WHS Moto E", "CHARTER COMMUNICATIONS Motorola Mobility XT2093 4 WHS Moto G Play", "CHARTER COMMUNICATIONS Motorola Mobility XT2131 1 WHS Moto G Stylus 5G", "CHARTER COMMUNICATIONS Motorola Mobility XT2141 1 WHS Moto Edge", "CHARTER COMMUNICATIONS Motorola Mobility XT2163 4 WHS Moto G Pure", "CHARTER COMMUNICATIONS Motorola Mobility XT2201 3 WHS Edge X30 5G", "CHARTER COMMUNICATIONS Motorola Mobility XT2205 3 WHS Dubai 5G", "CHARTER COMMUNICATIONS Motorola Mobility XT2213 3 WHS Moto G 5G", "CHARTER COMMUNICATIONS Motorola Mobility XT2271 5 WHS Moto G Play", "CHARTER COMMUNICATIONS Motorola Mobility XT2301 1 WHS Moto Edge 40 Pro 5G", "CHARTER COMMUNICATIONS Motorola Mobility XT2311 4 WHS Moto G Power 5G", "CHARTER COMMUNICATIONS Motorola Mobility XT2315 1 WHS Moto G Stylus 5G", "CHARTER COMMUNICATIONS Motorola Mobility XT2321 3 WHS Razr 40 Ultra 5G", "CHARTER COMMUNICATIONS Motorola Mobility XT2405 1 WHS Moto G Stylus 5G", "CHARTER COMMUNICATIONS Motorola Mobility XT2419 1 WHS Moto G Stylus 5G", "CHARTER COMMUNICATIONS Motorola Mobility XT2453 3 WHS Moto RAZR Plus 5G", "CHARTER COMMUNICATIONS Motorola XT2215 1 WHS Moto G Stylus 5G", "CHARTER COMMUNICATIONS Reliance Communications Orbic Fun 4G LTE Smartphone", "CHARTER COMMUNICATIONS Reliance Communications RC2200L CHTR", "CHARTER COMMUNICATIONS Samsung SM A015U W Galaxy A01", "CHARTER COMMUNICATIONS Samsung SM A025V W Galaxy A02s 5G", "CHARTER COMMUNICATIONS Samsung SM A037U W Galaxy A03s", "CHARTER COMMUNICATIONS Samsung SM A102U WC", "CHARTER COMMUNICATIONS Samsung SM A115U W Galaxy A11", "CHARTER COMMUNICATIONS Samsung SM A125U W Galaxy A12 5G", "CHARTER COMMUNICATIONS Samsung SM A136U W Galaxy A13 5G", "CHARTER COMMUNICATIONS Samsung SM A146U W Galaxy A14 5G", "CHARTER COMMUNICATIONS Samsung SM A156U W Galaxy A15 5G", "CHARTER COMMUNICATIONS Samsung SM A166U W Galaxy A16 5G", "CHARTER COMMUNICATIONS Samsung SM A205 WC", "CHARTER COMMUNICATIONS Samsung SM A205U W", "CHARTER COMMUNICATIONS Samsung SM A215U W Galaxy A21", "CHARTER COMMUNICATIONS Samsung SM A326U W Galaxy A32 5G", "CHARTER COMMUNICATIONS Samsung SM A356U W Galaxy A35 5G", "CHARTER COMMUNICATIONS Samsung SM A426U W Galaxy A42 5G", "CHARTER COMMUNICATIONS Samsung SM A505U WC Galaxy A50", "CHARTER COMMUNICATIONS Samsung SM A515U W Galaxy A51", "CHARTER COMMUNICATIONS Samsung SM A516V W Galaxy A51 5G", "CHARTER COMMUNICATIONS Samsung SM A526U W Galaxy A52 5G", "CHARTER COMMUNICATIONS Samsung SM A536U W Samsung Galaxy A53 5G", "CHARTER COMMUNICATIONS Samsung SM A546U W Galaxy A54 5g", "CHARTER COMMUNICATIONS Samsung SM A716V W Galaxy A71 5G", "CHARTER COMMUNICATIONS Samsung SM F711U W Galaxy Z Flip 3", "CHARTER COMMUNICATIONS Samsung SM F721U W Galaxy Z Flip 4", "CHARTER COMMUNICATIONS Samsung SM F721U1 W Galaxy Z Flip 4 512GB", "CHARTER COMMUNICATIONS Samsung SM F731U W Galaxy Z Flip 5 5G", "CHARTER COMMUNICATIONS Samsung SM F741U W Galaxy Z Flip 6 5G", "CHARTER COMMUNICATIONS Samsung SM F926U W Galaxy Z Fold 3 5G", "CHARTER COMMUNICATIONS Samsung SM F936U W Galaxy Z Fold 4", "CHARTER COMMUNICATIONS Samsung SM F946U W Galaxy Z Fold 5 5G", "CHARTER COMMUNICATIONS Samsung SM F956U W Galaxy Z Fold 6 5G", "CHARTER COMMUNICATIONS Samsung SM F956U1 W Galaxy Z Fold 6 5G", "CHARTER COMMUNICATIONS Samsung SM G781V W Galaxy S20 FE 5G", "CHARTER COMMUNICATIONS Samsung SM G950U W", "CHARTER COMMUNICATIONS Samsung SM G950U W2", "CHARTER COMMUNICATIONS Samsung SM G955U W", "CHARTER COMMUNICATIONS Samsung SM G955U W2", "CHARTER COMMUNICATIONS Samsung SM G955U1 W", "CHARTER COMMUNICATIONS Samsung SM G960U W", "CHARTER COMMUNICATIONS Samsung SM G965U W", "CHARTER COMMUNICATIONS Samsung SM G970U W", "CHARTER COMMUNICATIONS Samsung SM G973U W", "CHARTER COMMUNICATIONS Samsung SM G975U W", "CHARTER COMMUNICATIONS Samsung SM G981U W Galaxy S20 5G", "CHARTER COMMUNICATIONS Samsung SM G981V W S20 5G", "CHARTER COMMUNICATIONS Samsung SM G986U W S20 Plus 5G", "CHARTER COMMUNICATIONS Samsung SM G988U W S20 Ultra 5G", "CHARTER COMMUNICATIONS Samsung SM G990U W Galaxy S21 FE 5G", "CHARTER COMMUNICATIONS Samsung SM G990U2 W Galaxy S21 FE 5G UW", "CHARTER COMMUNICATIONS Samsung SM G991U W Galaxy S21 5G", "CHARTER COMMUNICATIONS Samsung SM G996U W Galaxy S21 Plus 5G", "CHARTER COMMUNICATIONS Samsung SM G998U W Galaxy S21 Ultra 5G", "CHARTER COMMUNICATIONS Samsung SM L305U W Galaxy Watch 7", "CHARTER COMMUNICATIONS Samsung SM L315U W Galaxy Watch 7", "CHARTER COMMUNICATIONS Samsung SM L705U W Galaxy Watch Ultra", "CHARTER COMMUNICATIONS Samsung SM N950U W", "CHARTER COMMUNICATIONS Samsung SM N960U W", "CHARTER COMMUNICATIONS Samsung SM N970U W", "CHARTER COMMUNICATIONS Samsung SM N975U W", "CHARTER COMMUNICATIONS Samsung SM N981U W Note 20 5G", "CHARTER COMMUNICATIONS Samsung SM N981U1 W Note 20 5G", "CHARTER COMMUNICATIONS Samsung SM N986U W Note 20 Plus 5G", "CHARTER COMMUNICATIONS Samsung SM R905U W Galaxy Watch 5", "CHARTER COMMUNICATIONS Samsung SM R955U W Galaxy Watch 6", "CHARTER COMMUNICATIONS Samsung SM R965U W Galaxy Watch 6 Classic", "CHARTER COMMUNICATIONS Samsung SM S711U W Galaxy S23 FE", "CHARTER COMMUNICATIONS Samsung SM S721U W Galaxy S24 FE", "CHARTER COMMUNICATIONS Samsung SM S901U W Galaxy S22 5G", "CHARTER COMMUNICATIONS Samsung SM S906U W Galaxy S22 Plus 5G", "CHARTER COMMUNICATIONS Samsung SM S908U W Galaxy S22 Ultra 5G", "CHARTER COMMUNICATIONS Samsung SM S911U W Galaxy S23 5G", "CHARTER COMMUNICATIONS Samsung SM S916U W Galaxy S23 Plus 5G", "CHARTER COMMUNICATIONS Samsung SM S918U W Galaxy S23 Ultra 5G", "CHARTER COMMUNICATIONS Samsung SM S921U W Galaxy S24 5G", "CHARTER COMMUNICATIONS Samsung SM S926U W Galaxy Z Fold 3 5G", "CHARTER COMMUNICATIONS Samsung SM S928U W Galaxy S23 Ultra 5G", "CHARTER COMMUNICATIONS Samsung SM T227U W", "CHARTER COMMUNICATIONS Samsung SM X218U W Galaxy Tab A9", "CHARTER COMMUNICATIONS Samsung SM X518U W Galaxy Tab S9 FE 5G", "CHARTER COMMUNICATIONS Samsung SM X808U W Galaxy Tab S8 Plus 5G", "CHARTER COMMUNICATIONS Samsung SM X818U W Galaxy Tab S8 Plus 5G", "CHARTER COMMUNICATIONS TCT Mobile Encore Spectrum T609V", "CHARTER COMMUNICATIONS TCT Mobile T435WS TCL Flip", "CHARTER COMMUNICATIONS TCT Mobile T614WS", "Check Point SW Technologies 1570", "Check Point SW Technologies 1570R", "Check Point SW Technologies 1590", "ChemStation TelemeTank", "CIMCON Lightning iSLC 3100 7P N", "CIO Technology Inc dba Connected IO CR48NA", "CIO Technology Inc dba Connected IO CXD2800", "Circuit Dojo nRF9160 Feather", "Cisco C1109 PLTEVZ", "Cisco C1111 4PLTEEA", "Cisco C1111 8PLTEEA", "Cisco C1111 8PLTEEAWB", "Cisco C1117 4PLTEEA", "Cisco CG418 E", "CIsco D LTE NA", "Cisco GRWIC 4G LTE EA", "Cisco IR807G LTE VZ K9", "Cisco IR829B LTE EA BK9", "Cisco IR829M 2LTE EA BK9", "Cisco IR829M LTE EA BK9", "Cisco ISR1100 4GLTENA", "Cisco MG21", "Cisco MG21E", "Cisco MG41 HW", "Cisco MG41E HW", "Cisco MG52 HW", "Cisco MG52E HW", "Cisco MX 67C", "Cisco MX 68CW", "Cisco P 5GS6 R16SA GL", "Cisco P LTE MNA", "Cisco P LTE VZ", "Cisco P LTEA EA", "Cisco P LTEAP18 GL", "Citrix Systems NS SDW 210 LTE R1", "Citrix Systems SD WAN 110 LTE WiFi", "CLAAS of America Universal Communication Module", "Clare Controls CLR C1 PNL1", "Clean Start Systems CSS V1 2017 APIID 7000", "ClearTrac Technologies CarePath System", "ClearTrac Technologies CarePath System Male Device", "Cloudleaf GW1 5 I NA", "Clover Clover Flex", "Club Car VDU 2 2", "Club Car VDU 2 3", "CNH Industrial America CM100", "CNH Industrial America CM110", "CNH Industrial CNHI PCM HighBT 4G NAFTA", "Cold Chain Integrity PT500", "COMCAST Google G020E Pixel 3aXL", "COMCAST Google G020I Pixel 4", "COMCAST Google G020J Pixel 4 XL", "COMCAST Google G025E Pixel 4A 5G", "COMCAST Google G1MNW W Pixel 8 Pro 5G", "COMCAST Google G2YBB W Pixel 9 5G", "COMCAST Google G8V0U W Pixel 6 Pro 5G", "COMCAST Google G9BQD W Pixel 8 5G", "COMCAST Google GB7N6 W Pixel 6 5G", "COMCAST Google GBDU9 W", "COMCAST Google GD1YQ Pixel 5 5G", "COMCAST Google GE2AE W Pixel 7 Pro 5G", "COMCAST Google GGH2X W Pixel 9 Pro Fold 5G", "COMCAST Google GGX8B W Pixel 9 Pro XL 5G", "COMCAST Google GK4X W Google Pixel 8a 5G", "COMCAST Google GKV4X W Google Pixel 8a 5G", "COMCAST Google GR83Y W Pixel 9 Pro 5G", "COMCAST Google GRY0E W Pixel Watch 3", "COMCAST Google GVU6C W Pixel 7 5G", "COMCAST Google GWKK3 W Pixel 7a 5G", "COMCAST Google GX7AS W Pixel 6a", "COMCAST LG GPLGK212VL", "COMCAST LG GPLGM322", "COMCAST LG GPLMG820QM5", "COMCAST LG GPLMK500QM5", "COMCAST LG GPLMK500QM6", "COMCAST LG GPLMQ710US", "COMCAST LG GPLMQ720QM5 Stylo 5", "COMCAST LG GPLMQ730QM5", "COMCAST LG GPLMX410ULML Spectrum K30", "COMCAST LG GPLMX410UM", "COMCAST LG GPLMX420QM6 2", "COMCAST Motorola Mobility XT1921 1 WS", "COMCAST Motorola Mobility XT1955 5 WS", "COMCAST Motorola Mobility XT2005 5 WH", "COMCAST Motorola Mobility XT2041 4 G8 Power", "COMCAST Motorola Mobility XT2041 4 WS G8 Power", "COMCAST Motorola Mobility XT2052 1 Moto E LE Unlocked", "COMCAST Motorola Mobility XT2052 1 WS Moto E LE Unlocked", "COMCAST Motorola Mobility XT2093 4 WS Moto G Play 5G", "COMCAST Motorola Mobility XT2113 2 WS Moto G 5G", "COMCAST Motorola Mobility XT2117 4 WS Moto G Power 5G", "COMCAST Motorola Mobility XT2131 1 WS Moto G Stylus 5G", "COMCAST Motorola Mobility XT2163 4 WHS Moto G Pure", "COMCAST Motorola Mobility XT2163 4 WS Moto G Pure", "COMCAST Motorola Mobility XT2165 5 WS Moto G Pure", "COMCAST Motorola Mobility XT2213 3 WS Moto G 5G", "COMCAST Motorola Mobility XT2215 4 WS Motorola G Stylus 5G", "COMCAST Motorola Mobility XT2271 5 WS Moto X4", "COMCAST Motorola Mobility XT2311 4 WS Moto G Power 5G", "COMCAST Motorola Mobility XT2315 1 WS Moto G Stylus 5G", "COMCAST Motorola Mobility XT2323 2 WS Moto RAZR 40 5G", "COMCAST Motorola Mobility XT2413 2 WS Moto G Play", "COMCAST Motorola Mobility XT2417 1 WS Moto Edge 40 Neo 5G", "COMCAST Motorola Mobility XT2419 1 WS", "COMCAST Motorola Mobility XT2419 1WS Moto G Stylus 5G 2024", "COMCAST Motorola Mobility XT2453 3 WS Moto RAZR Plus 5G", "COMCAST Reliance RC608L Orbic Joy", "COMCAST Samsung SM 950U W", "COMCAST Samsung SM A037U W Galaxy A03s", "COMCAST Samsung SM A125U W Galaxy A12 5G", "COMCAST Samsung SM A136U W Galaxy A13 5G", "COMCAST Samsung SM A146U W Galaxy A14 5G", "COMCAST Samsung SM A156U W Galaxy A15 5G", "COMCAST Samsung SM A166U W Galaxy A16 5G", "COMCAST Samsung SM A256U W Galaxy A52 5G", "COMCAST Samsung SM A326U W Galaxy A32 5G", "COMCAST Samsung SM A356U W Galaxy A35 5G", "COMCAST Samsung SM A426U W Galaxy A42 5G", "COMCAST Samsung SM A4705U W", "COMCAST Samsung SM A505U WC Galaxy A50", "COMCAST Samsung SM A515U W Galaxy A51", "COMCAST Samsung SM A526U W Galaxy A52 5G", "COMCAST Samsung SM A536U W Samsung Galaxy A53 5G", "COMCAST Samsung SM A546U W Galaxy A54 5g", "COMCAST Samsung SM A705U W A70", "COMCAST Samsung SM A716V W Galaxy A71 5G", "COMCAST Samsung SM F711U W Galaxy Z Flip 3", "COMCAST Samsung SM F721U W Galaxy Z Flip 4", "COMCAST Samsung SM F721U1 W Galaxy Z Flip 4 512GB", "COMCAST Samsung SM F731U W Galaxy Z Flip 5 5G", "COMCAST Samsung SM F741U W Galaxy Z Flip 6 5G", "COMCAST Samsung SM F926U W Galaxy Z Fold 3 5G", "COMCAST Samsung SM F936U W Galaxy Z Fold 4", "COMCAST Samsung SM F946U W Galaxy Z Fold 5 5G", "COMCAST Samsung SM F956U W Galaxy Z Fold 6 5G", "COMCAST Samsung SM F956U1 W Galaxy Z Fold 6 5G", "COMCAST Samsung SM G781V W Galaxy S20 FE 5G", "COMCAST Samsung SM G930VC", "COMCAST Samsung SM G935VC", "COMCAST Samsung SM G950U W", "COMCAST Samsung SM G955U W", "COMCAST Samsung SM G960U W", "COMCAST Samsung SM G965U W", "COMCAST Samsung SM G970U W", "COMCAST Samsung SM G973U W", "COMCAST Samsung SM G975U W", "COMCAST Samsung SM G981U W Galaxy S20 5G", "COMCAST Samsung SM G981V W S20 5G", "COMCAST Samsung SM G986U W S20 Plus 5G", "COMCAST Samsung SM G988U W S20 Ultra 5G", "COMCAST Samsung SM G990U W Galaxy S21 FE 5G", "COMCAST Samsung SM G990U2 W Galaxy S21 FE 5G UW", "COMCAST Samsung SM G991U W Galaxy S21 5G", "COMCAST Samsung SM G996U W Galaxy S21 Plus 5G", "COMCAST Samsung SM G998U W Galaxy S21 Ultra 5G", "COMCAST Samsung SM L305U W Galaxy Watch 7", "COMCAST Samsung SM L315U W Galaxy W", "COMCAST Samsung SM L705U W Galaxy Watch Ultra", "COMCAST Samsung SM N950U W", "COMCAST Samsung SM N950U1 W Galaxy Note 8 64GB", "COMCAST Samsung SM N970U W", "COMCAST Samsung SM N975U W", "COMCAST Samsung SM N981U W Note 20 5G", "COMCAST Samsung SM N981U1 W Note 20 5G", "COMCAST Samsung SM N986U W Note 20 Plus 5G", "COMCAST Samsung SM R905U W Galaxy Watch 5", "COMCAST Samsung SM R915U W Galaxy Watch 5", "COMCAST Samsung SM R935U W Galaxy Watch 2", "COMCAST Samsung SM R945U W Galaxy Watch 6", "COMCAST Samsung SM R955U W Galaxy Watch 6", "COMCAST Samsung SM R965U W Galaxy Watch 6 Classic", "COMCAST Samsung SM S711U W Galaxy S23 FE", "COMCAST Samsung SM S721U W Galaxy S24 FE 5G", "COMCAST Samsung SM S901U W Galaxy S22 5G", "COMCAST Samsung SM S906U W Galaxy S22 Plus 5G", "COMCAST Samsung SM S908U W Galaxy S22 Ultra 5G", "COMCAST Samsung SM S911U W Galaxy S23 5G", "COMCAST Samsung SM S916U W Galaxy S23 Plus 5G", "COMCAST Samsung SM S918U W Galaxy S23 Ultra 5g", "COMCAST Samsung SM S921U W Galaxy S24 5G", "COMCAST Samsung SM S926U W Galaxy Z Fold 3 5G", "COMCAST Samsung SM S928U W Galaxy S23 Ultra 5G", "COMCAST Samsung SM X218U W Galaxy Tab A9", "COMCAST Samsung SM X518U W Galaxy Tab S9 FE", "COMCAST Samsung SM X808U W Galaxy Tab S8 Plus 5G", "Commsignia ITS RS4", "Communication Devices CDI SW LTE EM7455", "Compology Oscar R12", "Connected Holdings ARROWMV001", "Connected IO EM1000T VZ CAT1", "Connected IO ER2000T VZ CAT1", "Consumer Safety Technology RB C220 910 Cat1", "Contemporary Control Systems BASRTCX B3", "Contemporary Control Systems EICR 3", "Continental Automative Systems CASAN V", "Continental Automotive Systems CASAN VK", "Continental Automotive Systems FE5NA0020", "Continental Automotive Systems HMG DCU 1 0 Module HM28NA 001", "Continental Automotive Systems T DCM", "Control Tec CT 1000 LTE", "Corporate Systems Engineering 3130 0LTE 00A", "Council Rock Enterprises TELiG E1500 8 a", "Council Rock Enterprises TELiG E1500 8 b", "Council Rock Enterprises TELiG E1500 L", "Council Rock Enterprises TELiG E1500 N", "Covert Scouting Cameras AW1 V", "Covert Scouting Cameras Blackhawk LTE", "Covert Scouting Cameras E1", "Covert Scouting Cameras LB V", "Covert Scouting Cameras WC30 V", "CovertTrack Group Stealth V", "CovertTrack Group Stealth V MB", "Cox Communications COX LTEM OBD2", "Cox Communications Cox2M TLM 1 0", "COX WIRELESS Google G1MNW W Pixel 8 Pro 5G", "COX WIRELESS Google G2YBB W Pixel 9 5G", "COX WIRELESS Google G9BQD W Pixel 8 5G", "COX WIRELESS Google GGX8B W Pixel 9 Pro XL 5G", "COX WIRELESS Google GKV4X W Google Pixel 8a 5G", "COX WIRELESS Google GR83Y W Pixel 9 Pro 5G", "COX WIRELESS Motorola Mobility XT2052 1 WS Moto E LE Unlocked", "COX WIRELESS Motorola Mobility XT2417 1 WHSL Moto G 5G", "COX WIRELESS Motorola Mobility XT2417 1 WS Moto Edge 40 Neo 5G", "COX WIRELESS Samsung SM A166U W Galaxy A16 5G", "COX WIRELESS Samsung SM G975U W", "COX WIRELESS Samsung SM G986U W S20 Plus 5G", "COX WIRELESS Samsung SM R955U W Galaxy Watch 6", "COX WIRELESS Samsung SM S916U W Galaxy S23 Plus 5G", "COX WIRELESS TCT Mobile T430WS", "COX WIRELESS TCT Mobile T510WS", "COX WIRELESS TCT Mobile T614WS", "COX WIRELESS XT2413 2 WHSL Moto G Play", "CradlePoint AER1600LP4", "CradlePoint AER1600LPE", "CradlePoint AER1650LP4", "CradlePoint AER1650LPE", "CradlePoint AER2200 1200M", "CradlePoint AER2200 1200M B", "CradlePoint AER2200 600M", "CradlePoint AER2250 600M", "CradlePoint CBA550 150M", "Cradlepoint E100 C4D", "Cradlepoint E110 C4D", "Cradlepoint E300 C18B", "Cradlepoint E300 C4D", "Cradlepoint E3000 C18B", "Cradlepoint E350 C4D", "CradlePoint IBR1100LP6", "CradlePoint IBR1100LPE", "CradlePoint IBR1150LP6", "CradlePoint IBR1150LPE", "CradlePoint IBR1700 1200M", "CradlePoint IBR1700 1200M B", "CradlePoint IBR1700 600M", "CradlePoint IBR200 10M", "Cradlepoint IBR200 10M BuSS", "CradlePoint IBR250 10M", "CradlePoint IBR350LPE", "CradlePoint IBR600B LP4", "Cradlepoint IBR600B LP4 BuSS", "CradlePoint IBR600C 150M", "CradlePoint IBR600LPE", "CradlePoint IBR600LPE PWD", "CradlePoint IBR650B LP4", "CradlePoint IBR650C 150M", "CradlePoint IBR650C LPE", "CradlePoint IBR650LPE", "CradlePoint IBR900 1200M", "CradlePoint IBR900 1200M B", "CradlePoint IBR900 600M", "Cradlepoint IBR900 600M BuSS", "CradlePoint IBR900LP6", "CradlePoint IBR950 600M", "CradlePoint IBR950LP6", "Cradlepoint L950 C7A", "CradlePoint MC400 1200M", "CradlePoint MC400 1200M B", "Cradlepoint MC400 5GB", "CradlePoint MC400LP4", "Cradlepoint MC400LP6 BuSS", "Cradlepoint R1900 5GB", "Cradlepoint W1850 5GB", "Cradlepoint W2000 5GB", "Cradlepoint W2005 5G", "Cradlepoint W4005 5GB", "Crane Payment Innovations Advance 5000", "Crane Payment Innovations AtlasH", "Crane Payment Innovations CORA", "CREDO Google G1MNW W Pixel 8 Pro 5G", "CropX CropX Deep Sensor", "CropX CropX Pro Sensor", "Ctek 4550 SkyRouter MC7455", "CTL NL7CT L Chromebook", "Cube Tracker Cube GPS", "Cubic Transition gate validator", "Cubic Validator 2", "Current Electronics iLocate Auto Tracker EMS", "Cybera Cybera SCA 325 7455", "Cypress Solutions CSM M1", "Cypress Solutions CTM ONE M", "Cypress Solutions CTM ONE PLUS", "Cypress Solutions Oxygen 3Plus", "D Link Systems DWM 311", "D Link Systems DWM 311 B1", "D Link Systems DWR 961", "Danfoss PR Octo", "Danfoss PR SC4", "Datalogic Srl MEMOR 20 WWAN", "DataRemote CDS 9010", "DataRemote CDS 9090", "Datto Network Appliance", "DDS Wireless mSlate 2", "Decklam Technologies Romware One", "Dejero Labs Dejero EnGo 200 Series", "Dejero Labs Dejero Gateway", "Dejero Labs Dejero Pathway", "Dejero Labs Dejero wireless modem board module", "Dejero Labs EnGo 200 Series", "Dejero Labs EnGo 260 Series LWM2M", "Dejero Labs GateWay 100 Series", "Dejero Labs GateWay 100 Series LWM2M", "Dejero Labs GateWay 200 Series LWM2M", "Dejero Labs Modem Board 1", "Dejero Labs PathWay 100 eries", "Dejero Labs Wireless Modem Board", "Dejero Labs Wireless Modem Board 2", "Dell Chromebook 3100 Education", "Dell Edge GW 3000 Series MC7455", "Dell Edge GW 5000", "Dell Edge GW 5100", "Dell Embedded Box PC 3000", "Dell Embedded Box PC 5000", "Dell Inspiron 5390 Fibocom L850 GL module", "Dell Inspiron 5391 Fibocom L850 GL module", "Dell Inspiron 7490 Fibocom L860 GL module", "Dell Latitude 2 in 1 Foxconn T77W968 00 module", "Dell Latitude 3301 Fibocom L850 GL module", "Dell Latitude 3311 Fibocom L850 GL module", "Dell Latitude 3420", "Dell Latitude 3490 EM7455 module", "Dell Latitude 3500 Fibocom L850 GL module", "Dell Latitude 3510 Fibocom L850 GL chipset", "Dell Latitude 3520 Fibocom L850 GL module", "Dell Latitude 3590 EM7455 module", "Dell Latitude 5290 2 in 1 EM7455 module", "Dell Latitude 5290 EM7455 module", "Dell Latitude 5300 2 in 1 Chrome Fibocom L850 GL module", "Dell Latitude 5300 2 in 1 Fibocom L850 GL module", "Dell Latitude 5300 Fibocom L850 GL module", "Dell Latitude 5310 2 in 1 Fibocom L850 GL module", "Dell Latitude 5310 Fibocom L850 GL module", "Dell Latitude 5320 Fibocom L850 GL module", "Dell Latitude 5400 Fibocom L850 GL module", "Dell Latitude 5401 Fibocom L850 GL module", "Dell Latitude 5410 L850 GL chipset", "Dell Latitude 5411 Fibocom L850 GL chipset", "Dell Latitude 5420 Fibocom L850 GL module", "Dell Latitude 5420 Foxconn T77W968 00 module", "Dell Latitude 5421 Fibocom L850 GL module", "Dell Latitude 5424 Foxconn T77W968 00 module", "Dell Latitude 5490 EM7455 module", "Dell Latitude 5491 EM7455 module", "Dell Latitude 5495 EM7455 module", "Dell Latitude 5500 Fibocom L850 GL module", "Dell Latitude 5501 Precision 3541 Fibocom L850 GL module", "Dell Latitude 5510 L850 GL chipset", "Dell Latitude 5511 Fibocom L850 GL chipset", "Dell Latitude 5520 Fibocom L850 GL module", "Dell Latitude 5521 Fibocom 850 GL module", "Dell Latitude 5590 EM7455 module", "Dell Latitude 5591 EM7455 module", "Dell Latitude 7200 2 in 1 Fibocom L850 GL module", "Dell Latitude 7210 2 in 1 T77W968 chipset", "Dell Latitude 7220 Rugged Extreme Foxconn T77W968 00 module", "Dell Latitude 7220EX Rugged Extreme Foxconn T77W968 00 module", "Dell Latitude 7290 EM7455 module", "Dell Latitude 7300 Fibocom L850 GL module", "Dell Latitude 7310 Cat9 Foxconn T77W968C9 module", "Dell Latitude 7310 Foxconn T77W968 module", "Dell Latitude 7320 C9 FoxconnT77W968C9 module", "Dell Latitude 7320 Detachable", "Dell Latitude 7320 Foxconn T77W968 module", "Dell Latitude 7390 2 in 1 EM7455 module", "Dell Latitude 7390 EM7455 module", "Dell Latitude 7400 Fibocom L850 GL module", "Dell Latitude 7410 Cat9 Foxconn T77W968C9 module", "Dell Latitude 7410 Chrome Fibocom L850 GL module", "Dell Latitude 7410 Foxconn T77W968 module", "Dell Latitude 7420 C9 Foxconn T77W968C9 module", "Dell Latitude 7420 Foxconn T77W968 module", "Dell Latitude 7424 Foxconn T77W968 00 module", "Dell Latitude 7490 EM7455 module", "Dell Latitude 7520 C9 Foxconn T77W968C9 module", "Dell Latitude 7520 Foxconn T77W968 module", "Dell Latitude 9410 Foxconn T77W968 chipset", "Dell Latitude 9420", "Dell Latitude 9510", "Dell Latitude 9520", "Dell Latitude Rugged Extreme 7220 Foxconn T77W968", "Dell Latutude 5400 Chrome Fibocom L850 GL module", "Dell Precision 3530 EM7455 module", "Dell Precision 3551 Fibicom L850 GL chipset", "Dell Precision 3560 Fibocom L850 GL module", "Dell Precision 3561 Fibocom 850 GL module", "Dell Precision 7530 EM7455 module", "Dell Precision 7540 Foxconn T77W968 00 module", "Dell Precision 7550 Foxconn T77W968 module", "Dell Precision 7730 EM7455 module", "Dell Precision 7740 Foxconn T77W968 00 module", "Dell Precision 7750 Foxconn T77W968 module", "Denso International America TG1 US", "Denso Ten America MG1 5 US", "Derive Systes Derive Systems VQ", "Device Solutions DS0046", "Device Solutions DS0049", "Device Solutions DS0052V", "Digi International 1002 CMF4", "Digi International 1002 CMG4", "Digi International 1003 CM07 OUS", "Digi International 1003 CM18", "Digi International Connect Sensor LE910 SV1", "Digi International Digi Connect IT Mini", "Digi International Digi IX14 LE910 NA1", "Digi International EX12 Dual Ethernet Router", "Digi International EX50 WXS6 GLB", "Digi International IX10 00G4", "Digi International IX15 00G4 XBP2", "Digi International IX20 00N4 D", "Digi International IX20 0AN4", "Digi International IX20 W0N4 D", "Digi International IX20 WAN4", "Digi International IX30 00P7", "Digi International LR54 AW401 Synnex", "Digi International Transport LR54 MC7455", "Digi International Transport LR54 MC7455 FIPS", "Digi International Transport LR54W MC7455", "Digi International Transport LR54W MC7455 FIPS", "Digi International Transport WR11 LE910 NA", "Digi International Transport WR11 LE910XT", "Digi International Transport WR11XT LE910 NA1", "Digi International Transport WR21 LE910", "Digi International Transport WR21 LE910 NAV2", "Digi International Transport WR31 LE910 NAV2", "Digi International Transport WR31 MC7354", "Digi International TransPort WR31 MC7455", "Digi International Transport WR41 MC7354", "Digi International Transport WR44 LE910SVG", "Digi International Transport WR44 MC7354", "Digi International Transport WR44R MC7354", "Digi International TransPort WR44R MC7455", "Digi International Transport WR44RR MC7455", "Digi International Transport WR54 LM940", "Digi International Transport WR64 LM940", "Digi International TX54 A106", "Digi International TX54 A112", "Digi International TX54 A146", "Digi International TX54 A206", "Digi International TX54 A246", "Digi International TX64 A121", "Digi International TX64 A141", "Digi International TX64 A161", "Digi International TX64 R210", "Digi International WR11 M600 DE1 XB Synnex", "Digi International WR44RR MC7455", "Digi International WR54 A112", "Digi International WR54 LM940", "Digi International XBee 3 Cell LTE M NB GNSS 2G", "Digi International XBee Cellular LE866 SV1", "Digi International XBee Cellular LTE M u blox", "Digi International XBee Industrial Gateway", "Digi International XBee Industrial Gateway LE910 NA1", "Digi International XBee3 Cellular LTE Cat 1", "Digi International XBee3 Cellular LTE M", "Digi Transport WR21 MC7354", "Digital Communications Technologies S4G CAT4 MPCB", "Digital Matter G62 4G LTE M NB IoT", "Digital Matter Oyster2", "Digital Matter Remora2 4G Cat M1 with BLE", "Digital Matter Yabby 4G with GPS", "Digital Monitoring Products 263LTE V", "Digital Monitoring Products 263LTE V2", "Digital Monitoring Products 263LTE V3", "Digital Monitoring Products 263LTE V4", "Digital Products Limited ATM 500 LTE", "Digital Products Limited ATM 510 LTE", "Dover Electronics Well Lync M1", "Drew Technologies CDP4 Q", "Drew Technologies DRIVE", "Drew Technologies DRIVE Q", "Drew Technologies RAP2", "DT Research DT301", "DTECH Labs Vocality RoIP", "DTN DBM CAT1 31V", "Durabook Americas R11AH6", "Durabook Americas S14", "Durabook Americas U11", "EAGL Technology ME910C1 NA", "EBSCO Sign Group EBSCOCELLCAT1", "Echo Smartbox", "EControls 53702501", "EControls 53702504", "El Electronics 4GCD", "Elecsys 02 0019 06", "Elecsys 02 0019 10", "Elecsys 02 0019 11", "Elecsys 02 0019 19", "Elecsys BG96 CAT M MODEM VZ MFF2 GNSS", "Electronic Sensors 7035T", "Electronic Sensors 7035U", "Elsight Elsight Halo", "Elsight HNF2O", "Elsight HNF2W", "Elsight HNF4O", "Elsight HNF4W", "Elster Solution Honeywell A4M1", "Elster Solutions A3WWIC4", "Elster Solutions A4 GM02S", "Elster Solutions AC250 NXCM", "Elster Solutions NXU R100 NBIoT", "Embedded Planet Chronos", "Embedded Planet EPM2M AG CELL", "EmNet LogiCover 7 4", "EmNet logicover 7C1", "Encore Networks Bandit 2 LTE MC7354", "Encore Networks Bandit 3 LTE MC7354", "Encore Networks C2C LTE Quanta", "Encore Networks EN1000 Asia Telco CAT1", "Encore Networks EN2000", "Encore Networks EN2000 Asia Telco Jan 16 0218", "Encore Networks EN4000", "Encore Networks EN4000 Asia Telco CAT4 LP53", "Engineering Solutions Omniguard 5b", "Ericsson Enterprise Solutions R980 5GD", "Ericsson Enterprise Solutions S400 C6 NA", "Ericsson Enterprise Solutions S450 C6 NA", "Eseye Hera604", "Essential Products PH 1", "Eurotech DYGATE 10 12 65", "Eurotech ReliaCELL 10 20 43", "Eurotech RG 10 12 55", "Eurotech RG 10 12 63", "Eurotech RG 10 12 65", "Eurotech RG 10 12 GS02", "Evolve Holdings 3 Holdings Maestro EBook 11 6", "Exodus Outdoor Gear RENDER 4G", "eze System ezeio", "F Robotics MTD Products MTD GSM2", "Farmers Edge Canplug", "Farmers Edge CanPlug 2 NF", "Fibocom Wireless FG360 NA", "Fibocom Wireless FM101 GL 00", "Fibocom Wireless FM101 GL 12", "Fibocom Wireless FM350 GL EMR", "Fibocom Wireless FM350 GL n77", "Fibocom Wireless L850 GL", "Fibocom Wireless L860 GL", "Fibocom Wireless M210 AM 00 module", "Fibocom Wireless M210 AM 10 module", "Fibocom Wireless N510 GL", "Fibocom Wireless NL668 AM", "Fibocom Wireless NL668 AM 00", "Fibocom Wireless SQ808 NA", "FieldWise Smart Radio LTE Cat M1", "FieldWise Smart Radio LTE M1 v2", "FieldWise Smart Radio LTE M1 v3", "FirstCam Outdoor Falcon LTE V", "Firstech X1", "Firstech X1MAX", "FitBark FitBark GPS", "Fleet Metrix LTEpoint", "Fleet Metrix VEUpoint", "Fleet Metrix VEUpoint Plus", "Fleetilla FL950V2", "Fleetilla FL960", "Fluid Conservation Systems COMLog2", "Fluid Conservation Systems COMLog2 WW", "Fluid Conservation Systems COMLog2IS", "Fluid Conservation Systems COMLog2IS WW", "Fluid Conservation Systems COMLogIS WW", "Fluid Conservation Systems Intelligens", "Fluid Conservation Systems Intelligens WW", "Fluid Conservation Systems ISLog", "Fluid Conservation Systems ISLog WW", "Fluid Conservation Systems Multilog 2 M1", "Fluid Conservation Systems Multilog LX2 WW", "Fluid Conservation Systems Multilog2 WW", "Fluid Conservation Systems Multilog2WW WW", "Fluid Conservation Systems MultiPog LX2", "Fluid Conservation Systems Pegasus 2 WW", "Fluid Conservation Systems Pegasus Plus", "Fluid Conservation Systems PermaNet Plus M1", "Fluid Conservation Systems PermaNET Plus WW", "Fluid Conservation Systems PermaNET Spider2", "Fluid Conservation Systems PermaNET SU", "Fluid Conservation Systems PermaNET SU WW", "Fluid Conservation Systems PermaNetF", "Fluid Conservation Systems Sentinel2 WW", "Fluid Conservation Systems StopwatchGSM WW", "Fluid Management Technology Smart Fill Gen2", "Fortinet FEV 211F AM", "Fortinet FEV 212F AM", "Fortinet FEX 201E", "Fortinet FEX 202E", "Fortinet FEX 211E", "Fortinet FEX 40D AMEU", "Fortinet FG 30E 3G4G G", "Fortinet FG 40F 3G4G", "Fortinet FG 41F 3G4G", "Fortinet FGR 60F 3G4G", "Fortinet FWF 40F 3G4G", "Fortinet FWF 41F 3G4G", "Fortress Systems Nova A4D", "Fossil C1NF1 Gen 5 LTE Giant V LTE Watch", "Foxconn FSNO21VA Snow Internet Gtwy", "Foxconn T77W595", "Foxconn T77W676", "Foxconn T77W968", "Foxconn T77W980", "Franklin Wireless LT70B Verizon Smart Locator", "Franklin Wireless MHS 900L Jetpack", "Franklin Wireless MHS900LWS od", "Freeus Belle LTE Voice", "Freeus Belle Plus LTE", "Freeus Belle S VZW", "Freeus Belle W VZW", "Freeus Belle X", "Freezing Point Connected FUB", "Freezing Point Connected FUB v1 1", "Frontier Pursuits Technology Spartan GoCam 4G LTE", "Fujitsu America PQ13A", "Fujitsu America STYLISTIC Q738", "Fujitsu Lifebook T937", "Fujitsu Lifebook T938", "Furrion Furrion Access LTE Router", "Furrion Furrion Access LTE Wi Fi Router Unlocked", "Furrion Furrion Access Point", "Garmin International 010 01986 00", "Garmin International 010 01986 01", "Garmin Vivoactive 3 Music Verizon Watch", "Garrettcom DX940e", "Gate Tel SWH ME910C1 NV", "GateTel SWH ME910C1 NA", "GCT Semi GDM7243i", "GE MDS Orbit ECR 4Gb", "GE MDS Orbit MCR 4Gy", "Gemalto Cinterion ELS31 VA", "Gemalto Cinterion ELS51 V", "Gemalto EMS31 V R3", "Gemalto M2M GmbH ALAS66A US", "Gemalto M2M GmbH Cinterion ELS31 V", "Gemalto M2M GmbH Cinterion ELS31 VA", "Gemalto M2M GmbH ELS31T", "Gemalto M2M GmbH EMS31 V", "Gemalto M2M GmbH EMS31 X", "Gemalto M2M GmbH PLAS9 X", "Gemalto PLPS9 X", "Generac Tether LTE", "Genesis Health Technologies GHT BGM 4123 1 5", "Geometris LP 68X 002", "Geometris LP 79U 002", "Geometris LP 87U 002", "GeoSensorx DG800", "Geotab GO8 LTE", "Geotab GO9 LTE", "Geotab GO9 LTMB", "Geotab GR9 LTE", "Geotab TB1 LTM", "GETAC A140 EM7511", "GETAC B300 EM7455", "Getac B360", "Getac B360 EM7511", "GETAC BWC BC 03", "GETAC F110", "Getac F110", "GETAC F110 EM7511", "GETAC F110 EM7511LWM2M", "GETAC Incorporated K120 EM7511", "GETAC K120", "GETAC RC11", "Getac S400 MC7355", "GETAC S410 EM7455", "GETAC S410 EM7511", "GETAC T800", "GETAC T800 EM7455", "GETAC UX10", "GETAC UX10 EM7511", "GETAC V110 EM7455", "GETAC V110 EM7511", "GETAC VR X20", "GETAC VR X20 EM7511", "GETAC ZX70 EM7355 module", "GETAC ZX70 EM7455", "Gizmo Watch2 ZW20", "Google E14 Wearable", "Google F0DZQ Pixel 7a", "Google G 2PW2100 Pixel", "Google G 2PW2100 Pixel XL", "Google G 2PW4100 Pixel XL", "Google G011A Pixel 2", "Google G011C Pixel 2 XL", "Google G013A Pixel 3", "Google G013C Pixel XL 3", "Google G020A Pixel 3a", "Google G020E Pixel 3aXL", "Google G020I Pixel 4", "Google G020J Pixel 4 XL", "Google G025J Pixel 4a", "Google G0DZQ Pixel 7a", "Google G1MNW Pixel 8 Pro", "Google G2YBB Pixel 9", "Google G6QU3 Pixel 4a5G", "Google G8HHN Pixel 8a", "Google G8V0U Pixel 6 Pro", "Google G9FPL Pixel Fold", "Google G9S9B Pixel 6", "Google GB62Z Pixel 6a", "Google GB7N6 W Pixel 6 5G", "Google GD1YQ Pixel 5", "Google GE2AE Pixel 7 Pro", "Google GGH2X Pixel 9 Pro Fold", "Google GGX8B Pixel 9 Pro XL", "Google GKWS6 Pixel 8", "Google GQML3 Pixel 7", "Google GR83Y Pixel 9 Pro", "Google GWT9R Pixel Watch", "Gordan Howard Associates TRAX 6L", "Gordon Howard Associates PTE 6", "Gordon Howard Associates TRAX 6", "Gordon Howard Associates TRAX 6V", "GPS of Things ST1505", "GPS Technologies GT UBX M1", "Granite Telecommunications G4", "GREAT CALL TCT Mobile T608G", "GREATCALL Alcatel 4043S", "GREATCALL Alcatel 4053S", "GREATCALL Alcatel 5049S GC", "GREATCALL Borqs Technologies R4", "GREATCALL TCT Mobile 4043S OneTouch Go Flip", "GREATCALL TCT Mobile 4058P", "GREATCALL TCT Mobile 5007S 1V Plus", "GSM STC GXVRW", "GSM Stealth Cam BG95 M2 Modem", "GSM Stealth Cam EG91 NAXD Modem", "GSM Stealth Cam EG91 VX Modem", "GSM Stealth Cam Verizon Modem", "Guangzhou Robustel R3000 4L", "HAE Innovations LRSM", "HAE Innovations LRSM0005C", "Hansen Ag Solutions BarnTalk Gateway", "HappyOrNot Americas HON M1 8", "HappyOrNot Americas HON M1 A", "HappyOrNot Americas HON540 V3 8", "HappyOrNot Americas HON540 V3 A", "HappyOrNot Americas HON540 X3 8", "HappyOrNot Americas HON540 X3 A", "Harman International Industries CONBOX HIGH", "Harman International Industries CONBOX HIGH without VTS", "Harman International Industries SA N9001", "Harman International Industries WAVE 11 HIGH R2", "Harris Corp XL 185M", "Harris Corp XL 185M 200M", "Harris Corp XL 185P 7", "Harris Corp XL 185P 7 8 900 NRB", "Harris Corp XL 185P 7 8 900 US", "Harris Corp XL 185P 8", "Harris Corp XL 185P 900", "Harris Corp XL 185P 900 US", "Harris Corp XL 200P NRB US", "Harris Corp XL 200P US", "Harris Corp XL 400P", "Hewlett Packard ARCN9004LTE", "Hewlett Packard HP Pavilion x360 L850 GL chipset", "Hewlett Packard HP Probook 440 G7", "Hewlett Packard HPE EL1000 v3", "Hewlett Packard HPE EL300 v2 Converged Edge System", "HMD Armstrong TA 1221 Nokia 2 V Tella Prepay", "HMD Armstrong TA 1231 Nokia 2 V Tella Postpay", "HMD Global N155DL", "HMD Global N159V", "HMD Global Nokia Crystal", "HMD Global Oy N151DL Drake", "HMD TA 1257 Rise Against Nokia 8 V 5G UW", "HMD TA 1295 Beatles Nokia 2720 Flip", "Hon Lin Technology T77W968", "Hon Lin Technology T77W968C9", "Hon Lin Technology T77W968E", "Hon Lin Technology T99W175", "Honeywell A4M", "Honeywell International CCM VZ HON", "Honeywell International Cloud Link 4G M1 Modem", "Honeywell International CT45 L1N E", "Honeywell International CT45 L1N G", "Honeywell International CT45P L1N 2", "Honeywell International EI8", "Honeywell International HON C QGD", "Honeywell International NC2", "Honeywell Scanning Mobility CN80L1N", "Honeywell Scanning Mobility CN80L1N O", "Honeywell Scanning Mobility CT40 L1N", "Honeywell Scanning Mobility CT40P L1N", "Honeywell Scanning Mobility CT60L1N", "Honeywell Scanning Mobility CT60L1N And P", "Honeywell Scanning Mobility CT60L1N O", "Honeywell Scanning Mobility RT10AL1N", "Honeywell Scanning Mobility RT10W", "Honeywell Scanning Mobility SOM660W", "Honeywell Scanning Mobility SOM660W DO", "Hongdian Cellular iFi Router", "Hongdian Cellular Wi Fi Router", "Hongdian H8951 NA1", "Hongdian H8959 4GVZW", "Hot Pepper Ghost", "Hot Pepper Jalapeno", "HP Elite c1030 Fibocom L850 GL module", "HP Elite Dragonfly Fibocom L860 GL module", "HP Elite Dragonfly G", "HP Elite x2 G4 Fibocom L850 GL module", "HP Elite x2 G4 Fibocom L860 GL module", "HP Elite x2 G8", "HP Elitebook 735 G6 Fibocom L850 GL module", "HP ELitebook 745 G6 Fibocom L850 GL module", "HP Elitebook 830 G6 Fibocom L850 GL module", "HP Elitebook 830 G7 Fibocom L850 GL module", "HP EliteBook 830 G8", "HP Elitebook 835 G7 Fibocom L860 GL module", "HP EliteBook 835 G8", "HP Elitebook 840 G6 Fibocom L850 GL module", "HP Elitebook 840 G7 Fibocom L850 GL module", "HP EliteBook 840 G8 lt4210", "HP Elitebook 840 HC G6 Fibocom L850 GL module", "HP ELitebook 840 HC G6 Fibocom L860 GL module", "HP Elitebook 845 G7 Fibocom 860 L module", "HP EliteBook 845 G8", "HP Elitebook 850 G6 Fibocom L850 GL module", "HP Elitebook 850 G6 Fibocom L860 GL module", "HP Elitebook 850 G7 Fibocom L850 GL module", "HP EliteBook 850 G8", "HP Elitebook 855 G7 Fibocom 860 GL module", "HP EliteBook 855 G8", "HP Elitebook x360 1030 G4 Fibocom L850 GL module", "HP Elitebook x360 1030 G4 Fibocom L860 GL module", "HP Elitebook x360 1030 G7 Fibocom L860 GL module", "HP Elitebook x360 1040 G5 Fibocom L850 GL module", "HP Elitebook x360 1040 G6 Fibocom L850 GL module", "HP Elitebook x360 1040 G6 Fibocom L860 GL module", "HP Elitebook x360 1040 G7 Fibocom L860 GL module", "HP Elitebook x360 830 G5 Fibocom L850 GL module", "HP Elitebook X360 830 G5 Fibocom L860 GL module", "HP eLITEBOOK x360 830 g5 fIBOCOM l860 gl MODULE", "HP Elitebook x360 830 G6 Fibocom L850 GL module", "HP Elitebook X360 830 G6 Fibocom L860 GL module", "HP Elitebook x360 830 G7 Fibocom L850 GL module", "HP EliteBook x360 G8", "HP Probook 430 G5 Fibocom L860 GL module", "HP Probook 440 G8", "HP Probook 640 G5 Fibocom L850 GL module", "HP Probook 650 G5 Fibocom L850 GL module", "HP ZBook 14 G7 Fibocom L850 GL module", "HP ZBook 14 G8", "HP Zbook 14u G6 Fibocom L850 GL module", "HP Zbook 14u G6 FibocomL860 GL module", "HP ZBook 15 G7 Fibocom L850 GL module", "HP ZBook 15u G4 Foxconn TT77W595 module", "HP Zbook 15u G5 lt4210 L 850 GL module", "HP ZBook 15u G6 Fibocom L850 GL module", "HP Zbook 15u G6 Fibocom L860 GL module", "Hp ZBook 17 G6 Fibocom L850 Gl module", "HP Zbook 17 G7", "HTC America HTC U12", "HTC U11", "Huawei H1511", "HUM Verizon Telematics VT 1010", "HUM Verizon Telematics VT 410", "Hydro Electronic Devices CL T16 208", "Hydro Electronic Devices CL T17 208", "Hydropoint Data Systems 4G CAT M1 Cell Module", "Hyster Yale Materials Handling M VAMA G63 40", "Hyundai Mobis AVN Gen 5 Wide", "Hyundai Mobis AVN Gen5 Wide Tri APN", "Hyundai Mobis DCU", "Hyundai Mobis STD AVN Gen4 0 VoLTE", "Hyundai Mobis STD AVN Gen4 5 VoLTE", "Hyundai Mobis Value2 0", "i safe MOBILE M53A01", "IAPARTMENTS TN100 24 BK", "iBeat Inc DBA 100Plus G1", "Icomera R01", "Icomera UK X3", "Icomera US VTC ICR 2", "Icomera US X5 R02", "Icomera X3", "IEE Sensing LiDAS Controller", "IFD Internal Fault Detector Corp SignalPort", "iKeyless ROKSBX 1XX", "In Situ VuLink CI", "Industrial Scientific Ventis Pro 4", "Industrial Scientific Ventis Pro 5", "Infinite Invention Cell Carrier ME910C1 NA", "Infiot iXEdge 101", "Ingenico AXIUM DX8000", "Ingenico AXIUM DX8000 2", "Ingenico AXIUM EX6000", "Ingenico AXIUM EX6000 2", "Ingenico AXIUM EX8000", "Ingenico AXIUM EX8000 2", "InHand Networks FB02", "InHand Networks FS39", "InHand Networks IG502 FQ33 IO W G", "InHand Networks IR301 FQ02 WLAN", "InHand Networks IR302 FQ33 WLAN", "InHand Networks IR302 FQ38 WLAN", "InHand Networks IR615 S FS39 WLAN", "Innova INN1 0", "Innovative World Technologies RT 400", "Inseego BPC100W", "Inseego FG2000 3", "Inseego FG2000e 3", "Inseego FW2000e", "Inseego FW2010e 1", "Inseego FX2000 3", "Inseego FX2000e 3", "Inseego M1000 Jetpack", "Inseego M2100 5G MiFi Hotspot", "Inseego M3100 MiFi X Pro 5G UW", "Inseego MD2000", "Inseego MD2000 FR1", "Inseego MD8800", "Inseego S2000e 3", "Inseego Skyus 140", "Inseego Skyus 160NE", "Inseego Skyus 300V", "Inseego Skyus 500Skyus 500V", "Inseego Skyus SC4", "Inseego USB8", "Inseego Wireless M3000", "Inseego Wireless M3000B NA", "Intelligent Surveillance Corporation SC410", "Intrex Pendant V2B", "Intwine Energy Intwine Connected Gateway ICG 200 NA C 201 VZ", "Inventure Track TK6R", "IPS Group BG95 World Radio Board", "Itron 500S Cellular Gas CAT M1", "Itron 500S Cellular Gas Remote", "Itron 500S Cellular Water CAT M1", "Itron 500S Cellular Water eUICC", "Itron 500S Cellular Water Remote", "Itron 500S SBAP M1 Cellular", "Itron NIC 511 SV1 0312", "Itron NIC 511 SV1 0313", "Itron OW CAT M1", "Itron OW3 5CATM", "IXON B V IXrouter3 4G Global", "Janus Remote Communications LTE310SMT v1 00", "Janus Remote Communications LTE910CF v15 00", "Janus Remote Communications LTE910CF v18 00", "Janus Remote Communications LTE910CF v20 00", "Janus Remote Communications LTE910PS v3 00", "Janus Remote Communications LTE910XF v20 00", "Janus Remote Communications LTE910XF v7 00", "Jio JIO GEN2", "Juniper Networks SRX MP LTE AE", "Juniper Networks SRX320", "Juniper Systems MS3", "Kings III of America SafeCall5000 CP V2 M45", "Kings III of America VoLTE Interface Module VIM", "Klas Telecom TRX R", "Klas Telecom TRX R2", "Klas Telecom TRX R6 5G", "KonnectONE K500HPEL", "KonnectONE K779HSDL", "KonnectONE K779HSDL Moxee Generic", "Koos Technical Services KTS Wireless Agility DFS LTE Cat M1 WW", "Kore Wireless Group DC TBS2 02 OD", "Kore Wireless Group ESDX CEL 3 OD", "Kore Wireless Group KORE TEK 822 OD", "Kore Wireless Group ORION Cellular Cs", "Kore Wireless Group ORION Cellular HLAS OD", "Kore Wireless Group ORION Cellular LTE MS OD", "Kore Wireless Group SpotOn Fence", "Kore Wireless Group VD04 Verizon", "Kyocera C6930 DuraSport 5G UW", "Kyocera E4610 DuraXV LTE", "Kyocera E4610NC DuraXV LTE Non Camera", "Kyocera E4810 Dura XV Extreme", "Kyocera E4810NC Dura XV Extreme Non Camera", "Kyocera E4811 Dura XV Extreme", "Kyocera E4811NC Dura XV Extreme Non Camera", "Kyocera E6910 DuraForce PRO 2", "Kyocera E7110 DuraForce Ultra 5G UW", "Kyocera E7200 DuraForce Pro 3 5G UW", "Kyocera S2720 Cadence Kona GT R", "L3Harris Technologies XL 185P 7 8 900 US", "Laird Connectivity Pinnacle 100 453 00010", "Laird Connectivity Pinnacle 100 453 00011", "Landis Gyr LTE M Focus AXe", "Landis Gyr LTE M S4x", "Landis Gyr N2200", "Landis Gyr N2250", "Landis Gyr N2250 S6", "Landis Gyr N22xx Gen 2", "Landis Gyr N2400", "Landis Gyr N2450", "Landis Gyr Revelo Cellular E360", "Landis Gyr Revelo Cellular E660", "Lanner Electronics FW 7573", "Lanner Electronics L 1515 ADVA Ensemble Connector", "Lanner Electronics NCA 1515", "Lanner Electronics NCA 1515 L 1515 128 Technology", "Lanner Electronics NCA 1515 L 1515 EKINOPS uCPE", "Lanner Electronics NCA 1515 L 1515 ENEA uCPE", "Lanner Electronics NCA 1515 Roqos Core RC150", "Lanner Electronics NCA 1515 Versa FlexVNF", "Lanner Electronics PGN 300", "Lantronix E214G", "Lantronix M113", "Leaf Analytics Leaf Sensor Interface Board", "Leica Geosystems GS18", "Lenovo 82AK Flex 5G SkyNet", "Lenovo Ideapad 3i Duet 3", "Lenovo L14 Gen 2 EM120R GL", "Lenovo L15 Gen 2 EM120R GL", "Lenovo Lenovo 100e Gen 3", "Lenovo Lenovo 300w Gen 3 L 850GL module", "Lenovo Lenovo 500e Gen 3 L850 GL Chipset", "Lenovo Lenovo TB 8505XC", "Lenovo Lenovo TB 8505XC WS", "Lenovo Lenovo TB X6C6L", "Lenovo Lenovo TB X6C6NBL", "Lenovo Lenovo ThinkEdge SE30 EM160", "Lenovo P14s Gen 2 EM120R GL", "Lenovo P14s Gen 2 EM160R GL", "Lenovo P15 Gen 2 EM160", "Lenovo P15s Gen 2 EM120R GL", "Lenovo P15s Gen 2 EM160R GL", "Lenovo P17 Gen 2 EM160R GL", "Lenovo T14 Gen 2 EM120R GL", "Lenovo T14 Gen 2 EM160R GL", "Lenovo T14s Gen 2 EM120R GL", "Lenovo T15 Gen 2 EM120R GL", "Lenovo T15 Gen 2 EM160R GL", "Lenovo T15g Gen 2 EM160", "Lenovo Tab4 8 Plus", "Lenovo TB 8704V Tab4 8 Plus", "Lenovo ThinkCentre M90n 1 Fibocom 850 GL module", "Lenovo ThinkPad L14 AMD L850 GL module", "Lenovo ThinkPad L14 Fibocom L850 GL module", "Lenovo ThinkPad L15 AMD L850 GL module", "Lenovo ThinkPad L15 Fibocom L850 GL module", "Lenovo ThinkPad L490 Fibocom L850 GL module", "Lenovo ThinkPad L590 Fibocom L850 GL module", "Lenovo ThinkPad P1 L860GL modue", "Lenovo ThinkPad P14s Fibocom L850 GL module", "Lenovo ThinkPad P14s Fibocom L860 GL module", "Lenovo ThinkPad P15 Fibocom L860 GL module", "Lenovo THinkPad P15v Fibocom L850 GL module", "Lenovo ThinkPad P17 Fibocom L860 GL module", "Lenovo ThinkPad P53 Fibocom L850 GL module", "Lenovo ThinkPad P53s", "Lenovo ThinkPad T14 AMD L850 GL module", "Lenovo ThinkPad T14 Fibocom L850 GL chipset", "Lenovo ThinkPad T14 Fibocom L860 GL chipset", "Lenovo ThinkPad T14 L860 GL module", "Lenovo ThinkPad T14s AMD L850 GL module", "Lenovo ThinkPad T14s Fibocom L850 GL module", "Lenovo ThinkPad T14s Fibocom L860 GL module", "Lenovo ThinkPad T15 Fibocom L850 GL module", "Lenovo ThinkPad T15 Fibocom L860 GL module", "Lenovo ThinkPad T15g Fibocom L860 GL module", "Lenovo ThinkPad T15p L850 GL module", "Lenovo ThinkPad T15s Fibocom L850 GL module", "Lenovo ThinkPad T15s Fibocom L860 GL module", "Lenovo ThinkPad T490 Fibocom L850 GL module", "Lenovo Thinkpad T490 Fibocom L860 GL module", "Lenovo ThinkPad T490s Fibocom L850 GL module", "Lenovo ThinkPad T495 Fibocom L850 GL module", "Lenovo ThinkPad T495s Fibocom L850 GL module", "Lenovo ThinkPad T590 Fibocom L850 GL module", "Lenovo ThinkPad X1 Carbon 8G L850", "Lenovo ThinkPad X1 Carbon 8G L860", "Lenovo ThinkPad X1 Carbon Fibocom L850 GL module", "Lenovo ThinkPad X1 Carbon G7 Fibocom L860 GL module", "Lenovo ThinkPad X1 EM7455 module", "Lenovo ThinkPad X1 Extreme L860 module", "Lenovo ThinkPad X1 Nano L850 GL module", "Lenovo ThinkPad X1 Titanium Fibocom L850 GL module", "Lenovo ThinkPad X1 Yoga 5G L850", "Lenovo ThinkPad X1 Yoga 5G L860", "Lenovo THinkPad X1 Yoga Fibocom L850 GL module", "Lenovo ThinkPad X1 Yoga G4 Fibocom L860 GL module", "Lenovo ThinkPad X12 Detachable Fibocom L850 GL module", "Lenovo ThinkPad X13 AMD L850 GL module", "Lenovo ThinkPad X13 Fibocom L850 GL module", "Lenovo ThinkPad X13 Yoga Fibocom L850 GL module", "Lenovo ThinkPad X13 Yoga Fibocom L860 GL module", "Lenovo Thinkpad X13s", "Lenovo ThinkPad X390 Fibocom L850 GL module", "Lenovo ThinkPad X390 Yoga Fibocom L850 GL module", "Lenovo ThinkPad X395 Fibocom L850 GL module", "Lenovo ThinkSystem SE350", "Lenovo X1 Carbon Gen 9 EM120 Module", "Lenovo X1 Yoga Gen 6 EM120 Module", "Lenovo X13 Gen 2 EM120R GL", "Lenovo X13 Yoga Gen 2 EM120 Module", "Lenovo Yoga C640 Fibocom L850 GL module", "LG Electronics OCU3 High", "LG Electronics OCU3 High MQB37W Audi", "LG Electronics OCU3 High MQB37W VW", "LG Electronics OCU3 Low High", "LG Electronics OCU3 Low Low", "LG Electronics OCU4", "LG Electronics Premium AVN Gen 5", "LG Electronics Premium AVN Gen 6", "LG Electronics Premium AVN Gen 6 K2", "LG Electronics TCAA19ANANN", "LG Electronics TLVHM3IU N", "LG Electronics TLVUE4IU N", "LG Electronics TLVUM3IU N", "LG Electronics TM03LNNAHK0", "LG Electronics TM13LNNAHK1", "LG Electronics TM13LNNAHK2", "LG Electronics TM16FNNABM0 ICON", "LG GPLGL125DCGB", "LG GPLGL722DCGB Stylo 5", "LG GPLMK300QM6", "LG GPLML713DCGB Stylo 4", "LG GPLMQ620QM6", "LG Innotek LTD VL3000", "LG Innotek LTD VL3001", "LG Innotek LTD VL3010", "LG Innotek LTD VL3020", "LG K4 LTE VS425", "LG LM F100VM WING", "LG LM G710ULM OD", "LG LM G710VM G7 ThinQ", "LG LM G820QM OD", "LG LM G820QMA OD", "LG LM G820UM G8 ThinQ", "LG LM K300QM OD", "LG LM K500QM", "LG LM K500QM OD K51", "LG LM K500UM K51", "LG LM Q620QM OD", "LG LM Q620VA Q70", "LG LM Q710ULM OD", "LG LM Q710ULMA OD", "LG LM Q720QM OD", "LG LM Q720QMA OD", "LG LM Q720VS M7", "LG LM Q720VS Stylo 5", "LG LM Q720VSP M7", "LG LM Q730QM OD Stylo 6", "LG LM Q730VM Stylo 6", "LG LM T600QS OD", "LG LM T600VS TF10", "LG LM V350ULM OD", "LG LM V405QA OD", "LG LM V405UA V40 ThinQ", "LG LM V600VM V60", "LG LM X210VPP Zone 4", "LG LM X320QMG OD", "LG LM X410ULMG OD", "LG LM X410ULMGA OD", "LG LM X420QN OD", "LG LMV450VM V50 ThinQ 5G", "LG LN G900VM Velvet Cayman", "LG OCU3 Low High", "LG PH1M VS835 Stylo 2 V", "LG US996 OD", "LG VK815 G Pad X 8 3", "LG VN220 GF2 Exalt LTE", "LG VS500 K8V", "LG VS500PP K8V Prepay", "LG VS501 K20 V", "LG VS810PP Transpyre", "LG VS880 G Vista", "LG VS880PP G Vista Pre Pay", "LG VS987 G5", "LG VS988 G6", "LG VS995 V20", "LG VS996 V30", "LinOra Corp DBA WiFi Ranger WiFiRanger Teton LTE", "Liteon Technology 1NAC21ACUCM", "Liteon Technology IC 80A", "LITEON Technology LITE ON Level 2 EV Charging Station", "Logic Supply RYR410M", "LooUQ iotQc CTA LTEM1", "M Labs Technologies LP V001", "M Labs Technologies MLTE001", "M2M Circuits M4", "M2M Circuits M5", "Madic Italia ALIO PRO", "Madic Italia BV1000GTV", "Malmoset SwitcheOn Power Control", "Mechanic Advisor CK03", "Mediatek MT2737 M80", "Mediatek MT6813 M60", "Mediatek MT6835T M85", "Mediatek MT6878 M85", "Mediatek MT6878F M85", "Mediatek MT6878TF M85", "Mediatek MT6897 M85", "Mediatek MT6899 M85", "Mediatek MT6985 M80", "Mediatek MT6989 M80", "Mediatek MT8786", "Medicalgorithmics P4TR AA ADS", "MedReady MR357FL XL", "MeiG Smart Technology SLM750", "Mesh Systems mvG LTE M1", "METER Group USA ZENTRA ZL6", "MetOcean Telematics ST 825 LTE", "Metos USA iMetos 3 3", "Metos USA M METOS LTE M", "Metropolitan Industries Ion Connect Gen2", "Metropolitan Industries Ion M1 ESM NA", "Microhard Systems Bullet LTE NA2", "Microhard Systems BulletCAT1 VZ", "Microhard Systems BulletCAT12", "Microhard Systems BulletCAT4 GL", "Microhard Systems Bulletplus NA2", "Microhard Systems BulletplusAC CAT12", "Microhard Systems Dragon LTE 100 GL", "Microhard Systems Dragon LTE 100 GL ALO", "Microhard Systems Dragon LTE 100 NA", "Microhard Systems IPn4Gii CAT12", "Microhard Systems IPn4Gii GL", "Microhard Systems IPn4Gii NA", "Microhard Systems IPn4Gii NA2", "Microhard Systems LTECube CAT4 GL WiFi", "Microhard Systems LTECube CAT4 GL WiFi ALO LTECUBE DONE UE", "Microhard Systems LTECube CAT4 NA2", "Microhard Systems LTECUBE CATM G2", "Microhard Systems LTECUBE CATM WiFi G2", "Microhard Systems LTECube M", "Microhard Systems LTESQ CAT12", "Microhard Systems LTESQ CAT4GL", "Microhard Systems pMLTE 4GL", "Microhard Systems pMLTE 4GL ALO", "Microhard Systems pX2LTE 4GL", "Micron Electronics 911 Responder", "Micron Electronics GT500MA", "Micron Electronics L200V", "Micron Electronics LS100", "Micron Electronics Prime ATC", "Micron Electronics PT200LSV", "Micronet A 317 LTE", "Microsift 1825 Surface", "Microsoft 1657 Surface 3 Tablet", "Microsoft 1876", "Microsoft 1927 Surface Go 2", "Microsoft 1930 Duo", "Microsoft 1961", "Microsoft Galileo", "Microsoft Lumia 735", "Milesight IoT UR32", "Miovision Scout Connected Adapter", "Mission Communications RMDT1", "Mitac Digital Technology N635", "Mitac Digital Technology N693", "Mitac Digital Technology N693C", "Mitac Digital Technology N693D", "Mitac Digital Technology N693E", "Mix Telematics North America LTE CatM1 External Modem", "Mobile Tek L710", "Mobile Tek L710HG", "Mobile Tek LG710", "Mobile Viewpoint Agile Airlink OD", "MobileDemand xTablet T1150", "MobileDemand xTablet T1180", "MobileDemand xTablet T1600", "MobileDemand xTablet T1680", "MobileTek L600", "Mobilogix ATD500X", "Mobilogix ATD700", "Mobilogix BAT", "Mobilogix BrainV2", "Mobilogix BrainV3", "Mobilogix Data Terminal", "Mobilogix LTE Asset Tracker", "Mobilogix MT4000", "Mobilogix MT4201", "Mobilogix Multi Sendor Unit", "Mobilogix VZ Connect Asset Tracker", "Mobilogix VZW Global Asset Tracker", "MOBIS North America D Audio", "MOBIS North America D Audio Kia VoLTE", "MOBIS North America D Audio LTE", "MOBIS North America D Audio VoLTE", "MOBIS North America STD AVN GEN 4 0", "MOBIS North America STD AVN Gen4 0 VoLTE", "MOBIS North America STD AVN GEN4 5", "MOBIS North America STD AVN Gen4 5 VoLTE", "MOBIS STD AVN Gen4 0 LTE", "Mobvoi US WF11026V", "MoFi Networks MOFI4500 4GxLTE V2", "Monnit MNG 9 LTE CCE", "Monnit MNG2 9 ELTE CCE", "Monnit MNG2 9 ELTE CCE POE", "Monnit MNG2 9 ELTE CCE POE GPS", "Monnit MNG2 9 LTE CCE", "Monnit MNG2 9 LTE CCE GPS", "Monnit MonnitLink CGW2", "Montage Systems MGCDMAV1", "Montage Systems MLTE001", "Montblanc S2C19 Summit 2 Plus", "Motium Pty MPP 1020", "Motorola MD1005G Mod", "Motorola Mobility G Play XT1607", "Motorola Mobility Moto G Play XT1607", "Motorola Mobility Motorola Mobility XT2317DL Moto G Stylus", "Motorola Mobility XT1575", "Motorola Mobility XT1625", "Motorola Mobility XT1644", "Motorola Mobility XT1687", "Motorola Mobility XT1710 01 Moto Z2 Play", "Motorola Mobility XT1768", "Motorola Mobility XT1775", "Motorola Mobility XT1806", "Motorola Mobility XT1900 01 Moto X", "Motorola Mobility XT1920 DL WS e5", "Motorola Mobility XT1920DL OD", "Motorola Mobility XT1921 1 ODI", "Motorola Mobility XT1922 9 Moto G6 Play", "Motorola Mobility XT1925 6 Moto G6", "Motorola Mobility XT1925DL WS Moto G6", "Motorola Mobility XT1929 4 Moto Z3 Play", "Motorola Mobility XT1952 4 G7 Play", "Motorola Mobility XT1955 5 ODI", "Motorola Mobility XT1955 5 VS", "Motorola Mobility XT1962 1", "Motorola Mobility XT1980 3", "Motorola Mobility XT1980 3 VS", "Motorola Mobility XT2005 5 Moto E6", "Motorola Mobility XT2005 5 VS Moto E6", "Motorola Mobility XT2013 4", "Motorola Mobility XT2041 4 G8 Power", "Motorola Mobility XT2041 4 VS G8 Power", "Motorola Mobility XT2041 4 WS G8 Power", "Motorola Mobility XT2041DL G8 Optimo Maxx", "Motorola Mobility XT2043 4 Moto G Stylus", "Motorola Mobility XT2043 8 Moto G Stylus", "Motorola Mobility XT2045 3 Moto G8 Unlocked", "Motorola Mobility XT2052 1 Moto E LE Unlocked", "Motorola Mobility XT2052 1 WS Moto E LE Unlocked", "Motorola Mobility XT2063 2 Edge 5G", "Motorola Mobility XT2063DL", "Motorola Mobility XT2071 3 Razr 2020 5G", "Motorola Mobility XT2093 4 Moto G Play 5G", "Motorola Mobility XT2113 2 Moto G 5G", "Motorola Mobility XT2115 1", "Motorola Mobility XT2117 4 Moto G Power 5G", "Motorola Mobility XT2131 1 Moto G Stylus 5G", "Motorola Mobility XT2163DL Moto G Pure", "Motorola Mobility XT2211DL Moto g Stylus", "Motorola Mobility XT2213DL Moto G 5G", "Motorola Mobility XT2215DL Moto G Stylus 5G 3rd Gen", "Motorola Mobility XT2271DL Moto E", "Motorola Mobility XT2419 1", "Motorola Mobility XT2419 NON VZW BYOD Moto G Stylus 5G", "Motorola Mobility XT2453V Moto Razr 5G", "Motorola Solutions APX NEXT", "Motorola Solutions APX NEXT XE", "Motorola Solutions APX NEXT XN", "Motorola Solutions H35XDT9PW8AN", "Motorola Solutions LEX L10g", "Motorola Solutions Lex L11n Mission Critical LTE Device", "Motorola Solutions M 1500L", "Motorola Solutions M1500 8 a", "Motorola Solutions M1500 8 b", "Motorola Solutions M1500 N", "Motorola Solutions MC EDGE", "Motorola Solutions MC EDGE1", "Motorola Solutions MC EDGE10", "Motorola Solutions MC EDGE11", "Motorola Solutions MC EDGE12", "Motorola Solutions MC EDGE13", "Motorola Solutions MC EDGE2", "Motorola Solutions MC EDGE20", "Motorola Solutions MC EDGE21", "Motorola Solutions MC EDGE22", "Motorola Solutions MC EDGE23", "Motorola Solutions MC EDGE24", "Motorola Solutions MC EDGE25", "Motorola Solutions MC EDGE26", "Motorola Solutions MC EDGE27", "Motorola Solutions MC EDGE28", "Motorola Solutions MC EDGE29", "Motorola Solutions MC EDGE3", "Motorola Solutions MC EDGE30", "Motorola Solutions MC EDGE31", "Motorola Solutions MC EDGE32", "Motorola Solutions MC EDGE33", "Motorola Solutions MC EDGE4", "Motorola Solutions MC EDGE5", "Motorola Solutions MC EDGE6", "Motorola Solutions MC EDGE7", "Motorola Solutions MC EDGE8", "Motorola Solutions MC EDGE9", "Motorola Solutions MSLB MKZ900", "Motorola Solutions TLK 100", "Motorola Solutions TLK 150", "Motorola Solutions VLP 5200F", "Motorola Solutions VML750", "Motorola Solutions VML750 R3", "Motorola VU204 Limerick", "Motorola XT1028 Moto G", "Motorola XT1030 Droid Mini", "Motorola XT1060 Moto X", "Motorola XT1080 Droid Ultra", "Motorola XT1080 Droid Ultra Maxx", "Motorola XT1096 New Moto X", "Motorola XT1103 Nexus 6", "Motorola XT1254 Droid Turbo", "Motorola XT1528 Moto E", "Motorola XT1565 Maxx 2", "Motorola XT1585 Droid Turbo 2", "Motorola XT1609 Moto G Play", "Motorola XT1635 01 Z Play", "Motorola XT1650 01 Droid Z", "Motorola XT1650 02 Droid Z Force", "Motorola XT1710 02 Z2 Play", "Motorola XT1765PP Moto E4 Lite 4G Prepay", "Motorola XT1767 Moto E4", "Motorola XT1774 Moto E4 Plus", "Motorola XT1789 01 Moto Z2 Force Edition", "Motorola XT1921 6 E5 Play Prepay", "Motorola XT1921 7 Moto E5 Play", "Motorola XT1921 8 Moto E5 Go Rugby Go 4G Prepay", "Motorola XT1922 6 G6 Play 4G Prepay", "Motorola XT1925 12 Moto G6", "Motorola XT1929 17 Moto Z3", "Motorola XT1952 3 G7 Play", "Motorola XT1955 6 Oslo H Moto G7 Power", "Motorola XT1980 4 Stingray Z4", "Motorola XT2000 1 Voyager RAZR", "Motorola XT2005 1Postpay Surf", "Motorola XT2005 1PP Surf Prepay", "Motorola XT2041 7 Sofia", "Motorola XT2043 5 Sofia Plus", "Motorola XT2052 2PP Gin PrePay", "Motorola XT2061 1 Taycan 5G", "Motorola XT2075 1 Nairobi 5G UW", "Motorola XT2093 2 Guam", "Motorola XT2093 2PP Guam Prepaid", "Motorola XT2113 1 Kiev 5G", "Motorola XT2113 1PP Kiev PrePay", "Motorola XT2117 3 Borneo", "Motorola XT2117 3PP Borneo Prepaid", "Motorola XT2141 1 Berlin 5G", "Motorola XT2163 2 Ellis Plus", "Motorola XT2163 2PP Ellis Plus", "Motorola XT2165 3 Tonga", "Motorola XT2165 3PP Tonga", "Motorola XT2201 4 Rogue Plus Edge Plus 5G UW", "Motorola XT2205 3 Dubai 5G", "Motorola XT2215 1 Moto G Stylus 5G", "Motorola XT2271 1PP Maui", "Motorola XT2413V Fogo", "Motorola XT2415V Cancun 5G", "Motorola XT2417D Fogo 5G", "Motorola XT2419V Boston 5G", "Moultre MV2 MFF2", "Moultrie Field Modem MV1", "Moultrie XV 7000i", "Moxa Americas AIG 502 T US AZU LX", "Moxa Americas MC 1121 E4 T", "Moxa Americas MC 1220", "Moxa Americas OnCell 3120 LTE 1 US", "Moxa Americas UC 3101 T US LX", "Moxa Americas UC 3111 T US LX", "Moxa Americas UC 3121 T US LX", "Moxa Americas UC 8100A", "Moxa Americas UC 8220 T LX US S", "Moxa Americas UC 8580 LX", "Moxa Americas UC 8580 Q LX", "Moxa Americas UC 8580 T CT", "Moxa Americas UC 8580 T CT LX", "Moxa Americas UC 8580 T CT Q", "Moxa Americas UC 8580 T CT Q LX", "Moxa Americas UC 8580 T LX", "Moxa Americas UC 8580 T Q LX", "MRSP Cyclops", "MSA The Safety Company ALTAIR io4", "MTData Development 6050", "Mueller Systems S H Gateway", "Multi Tech Systems MTC LNA4 B01", "Multi Tech Systems MTC LNA4 B03", "Multi Tech Systems MTC LVW2 B01", "Multi Tech Systems MTC LVW2 B02", "Multi Tech Systems MTC MNA1 B01", "Multi Tech Systems MTC MVW1 B01", "Multi Tech Systems MTC MVW1 B03", "Multi Tech Systems MTCAP LNA3 915 001L", "Multi Tech Systems MTCAP2 LNA3 915 042", "Multi Tech Systems MTCDT LVW2", "Multi Tech Systems MTCDTIP2 LNA3 B11UKP L", "Multi Tech Systems MTCM LNA3 B03", "Multi Tech Systems MTCP L4N1 B03", "Multi Tech Systems MTD MVW1", "Multi Tech Systems MTQ L4G1 B02", "Multi Tech Systems MTQ LNA3 B02", "Multi Tech Systems MTQ LNA7 B02", "Multi Tech Systems MTQ LVW3 B01", "Multi Tech Systems MTQ LVW3 B02", "Multi Tech Systems MTQ LVW3 B03", "Multi Tech Systems MTQ MVW1 B01", "Multi Tech Systems MTQ MVW1 B02", "Multi Tech Systems MTQN MNG1 B01", "Multi Tech Systems MTQN MNG1 B01B", "Multi Tech Systems MTQN MNG1 B02", "Multi Tech Systems MTQN MNG1 B02B", "Multi Tech Systems MTR LVW2 B07", "Multi Tech Systems MTR LVW2 B07 IL", "Multi Tech Systems MTR LVW2 B08", "Multi Tech Systems MTR MNG2 B07", "Multi Tech Systems MTR MNG2 B10", "Multi Tech Systems MTR3 L4G2D AC00PA", "Multi Tech Systems MTR3 L4G2D AC00QA", "Multi Tech Systems MTSMC L4G1", "Multi Tech Systems MTSMC L4G1 U", "Multi Tech Systems MTSMC L4N1 U", "Multi Tech Systems MTSMC LVW2 U AG", "Multi Tech Systems MTSMC LVW2 U RS", "Multi Tech Systems MTSMC LVW3", "Multi Tech Systems MTSMC LVW3 U", "Multi Tech Systems MTSMC MNA1 U", "Multi Tech Systems MTSMC MNG2", "Multi Tech Systems MTSMC MNG2 U", "Multi Tech Systems MTSMC MVW1", "Multi Tech Systems MTSMC MVW1 U", "Munters COMMUNICATOR", "Mytrex MXD LTE", "Mytrex myCapsule", "Napco Security Technologies ISEC CONTROL", "Napco Security Technologies SLE CDMA XXXXXX", "Napco Security Technologies SLE CDMAI XXXXXX", "Napco Security Technologies SLE LTEXXXXXXX", "Napco Security Technologies SLE LTEXXXXXXXV1", "Napco Security Technologies SLE LTEXXXXXXXV2", "Napco Security Technologies SLE LTEXXXXXXXV3", "Nautics Group C2 Wallaby", "Nayax AMIT LTE", "Neousys Technology America NSIO LTE 7455", "Neptune Cellular Meter Interface Unit", "Neptune CMUI Pit Verizon", "Neptune Grid Wide MIU", "Neqto neqto Bridge LTE M", "Netafim Irrigation NetBeat MCU by Netafim", "Netcomm Wireless NTC 140 01", "Netcomm Wireless NTC 140W 01", "NetComm Wireless NTC 225 01", "Netcomm Wireless NWL 11", "Netcomm Wireless NWL 15", "Netcomm Wireless NWL 25 02", "Netgear AC791L Jetpack", "Netgear LAX20", "Netgear LBR20", "Netgear LM1200", "Netgear LM1300", "Netgear VML4030 Arlo Go Camera", "Networkfleet 5000CDMA PCS3", "Networkfleet 5000LTE", "Networkfleet 6100", "NetworkFleet 6500", "Networkfleet VT 400Fleet", "Networkfleet VT 400FleetB1", "Nielsen Media Nielsen GCM", "Nielson Media UMG", "Nighthawk Systems CIK980", "Nighthawk Systems RDA890", "Nighthawk Systems RDC980", "Nighthawk Systems RDG980", "Nighthawk Systems WBH980", "NimbeLink NL AT M1 V", "NimbeLink NL AT1VS", "NimbeLink NL AT2VS", "NimbeLink NL AT4", "NimbeLink NL ATG M1 V W", "NimbeLink NL MUR GC1 V", "NimbeLink NL S C1G VR", "NimbeLink NL SW LTE GELS3", "NimbeLink NL SW LTE QBG95", "NimbeLink NL SW LTE QBG96", "NimbeLink NL SW LTE S7588", "NimbeLink NL SW LTE S7618RD", "NimbeLink NL SW LTE SRC7611 1", "NimbeLink NL SW LTE SRC7611 4", "NimbeLink NL SW LTE SVZM20", "NimbeLink NL SW LTE SVZM21", "NimbeLink NL SW LTE TC4NAG", "NimbeLink NL SW LTE TG1WWG", "NimbeLink NL SW LTE TM1G", "NimbeLink NL SW LTE TSVG", "NimbeLink NL SWN LTE NRF9160", "Nimble Wireless N1", "Nimble Wireless N1 503 M", "Nimble Wireless N1 505 Mw", "Nimble Wireless N7 500 M", "Nimble Wireless N7 503 M", "Nimble Wireless N7 504 M", "Nimble Wireless N7 505 M", "Nimble Wireless Toucan N5 500 C", "Nimble Wireless Toucan N5 502 C", "Nimble Wireless Toucan N5 503 C", "Nimble Wireless Toucan N5 504 C", "Nimble Wireless Toucan N5 505 C", "Nimble Wireless Toucan N5 506 C", "Nimble Wireless Toucan N5 551 C", "Nimble Wireless Toucan N5 552 C", "Nimble Wireless Toucan N5 553 C", "Nimble Wireless Toucan N5 554 C", "Nimble Wireless Toucan N5 555 C", "Nimble Wireless W5 500", "Nimble Wireless W5 502", "Nimble WirelessToucan N5 501 C", "NOJA Power REL 15 4GC", "Nokia 2720 V Flip TA 1295", "Nokia HMD TA 1136 2 V Dynamo 2", "Nokia HMD TA 1153 Deadpool Prepay", "Nokia HMD TA 1182 Deadpool Postpay", "Nokia Lumia Icon 929", "Nokia of America 7705 SAR Hm", "Nomad Digital R5001 CCU", "Non Typical NT CELLCAPLE910 1", "Nordic Semiconductor ASA nRF9160", "Nordic Semiconductor ASA nRF9160 DK", "Nordic Semiconductor nRF9151 PC3", "Nordic Semiconductor nRF9161", "Nordic Semiconductor Thingy91", "Noregon Systems ND2", "Nortek 2GIG LTEV A GC2", "Nortek 2GIG LTEV A GC3", "Nortek Security 2GIG LTEV A GC2", "Nortek Security 2GIG LTEV A GC3", "Nortek Security Control 2GIG EDG NA V", "Nortek Security Control 2GIG LTEV A GC2", "Nortek Security Control 2GIG LTEV A GC3", "Nortek Security Control 2GIG LTEV1 A GC2", "Nortek Security Control 2GIG LTEV1 A GC3", "Nortek Security Control 2GIG LTEV4 A GC3", "Nortek Security Control 2GIG LTEVQ1 GC2", "Nortek Security Control 2GIG LTEVV A GC2", "Nortek Security Control Libris 2 0", "Northscaler Celerway GO", "not listed", "NousLogic LTE Adapter board", "NousLogic Smart HomeHealth Hub", "Nova Mobile Systems NMS810CM", "Nova Mobile Systems NMS810CM R1", "Nova Mobile Systems NMS821V", "Nova Mobile Systems NMS825", "Nova Mobile Systems NMS826V", "Nova Mobile Systems NMS840 OBDII", "NovaSom Accusom LTE", "Novatel Home Phone Connect T2000", "Novatel Inseego 8800L MiFi", "Novatel NOVT1114 4G Router with Voice", "Novatel Wireless Jetpack MiFi7730L", "Novatel Wireless MiFi 6620L", "Novatel Wireless MIFI6620D", "Novatel Wireless Rooney MiFi7730", "Novatel Wireless SA1100", "Novatel Wireless SM4401", "Novatel Wireless USB620L MiFi Global Modem", "Novatel Wireless USB730L Franco", "NUU Mobile S2801L", "NUU Mobile S5502L A11L", "NUU Mobile S6003L X6 Plus", "NUU Mobile T100IL NUU", "O2 Concepts Freedom CAT M1", "O2 Concepts Independance CAT M1", "Observables CellCM M1", "Observant Observant C3 M Q", "Observant Observant Solo Q", "OBSM LLC DBA EPIK Epik G3", "OBSM LLC DBA EPIK EPIK G3 1", "ODIC CBRC 1", "Omnilink OM400G", "Omnilink OM410", "Omnilink OM500", "Omnisite OSMR CAT 1", "Omnisite OSMR CAT 1 External Antenna", "Omnisite OSMR CAT M1", "On Track Innovation CONNECT 3000", "On Track Innovation TrioIQ", "OneAccess Networks ONE525 2V 5T 4G app", "OneCare Tiger", "Oneplus 8 IN2019", "OnePlus Technology BE2011 Nord N100", "OnePlus Technology BE2026 N10 Nord 5G", "OnePlus Technology DE2117 Denniz", "OnePlus Technology IN2015", "OnePlus Technology IN2025", "OnePlus Technology KB2005", "OnePlus Technology LE2115 OnePlus 9 5G 128GB Unlocked", "OnePlus Technology LE2125 OnePlus 9 Pro 5G 256GB Unlocked", "OnePlus Technology OnePlus 6T", "OnePlus Technology OnePlus 6T 6 128GB", "OnePlus Technology OnePlus 6T 8 128GB", "OnePlus Technology OnePlus 6T Non VZW", "OnePlus Technology OnePlus 7 Pro", "OnePlus Technology OnePlus 7T", "ONKOL SE1", "Opengear ACM7004 2 L", "Opengear ACM7004 2 LMV", "Opengear ACM7004 5 L", "Opengear ACM7008 2 L", "Opengear B093 004 2E4U V", "Opengear B093 008 2E4U V", "Opengear IM7200 2 DAC LMV", "Opengear LES1604A R R2", "Opengear OCM73V4", "Opengear OM1204 4E L", "Opengear OM1204 L", "Opengear OM1208 8E L", "Opengear OM1208 L", "Opengear OM2216 DDC L", "Opengear OM2216 L", "Opengear OM2224 24E 10G DDC L", "Opengear OM2224 24E 10G L", "Opengear OM2224 24E DDC L", "Opengear OM2224 24E L", "Opengear OM2232 DDC L", "Opengear OM2232 L", "Opengear OM2248 10G DDC L", "Opengear OM2248 10G L", "Opengear OM2248 DDC L", "Opengear OM2248 L", "OptConnect Management EMA L4 1", "Option nv CG0124", "Option NV CloudGate 3G CG0198", "Option nv CloudGate Nano CM0126", "Option nv CM0125", "Orange Traffic ISECT ECO A", "Orbcomm GT1100 LTE", "Orbcomm GT1100 LTE EA", "Orbcomm PT6000 LTE VZ", "Orbcomm ST9101", "Orenco Systems ATRTU", "Oring Networking IMG 4312D Plus D4G", "Orion Labs ROS 001 VZ", "Ositech Communication Titan III Wireless Link 3G", "Ositech Communications Titan III Dual Mode 3G Cell Modem", "Ositech Communications Titan III Dual Mode 4G Cell Modem", "Ositech Communications Titan III Wireless Cellular Gateway 4G", "Ositech Communications Titan III Wireless IoT Gateway 3G", "Ositech Communications Titan III Wireless IoT Gateway 4G", "Ositech Communications Titan III Wireless Link 4G", "Ositech Communications Titan III Wireless Link Hospital 3G", "Ositech Communications Titan III Wireless Router Gateway", "Ositech Communications Titan III Wireless Router Gateway 3G", "Ositech Communications Titan III Wireless SD Gateway 3G", "OTT Hydromet A760 4G Series 6", "OTT Hydromet A764 4G Series 6", "OTT Hydromet A765 4G Series 6", "OTT Hydromet OTT ecoLog 1000", "Outpost Central Corp dba Wildeye WILD M", "Ovation Systems ABIPR", "Ovation Systems FB4G", "Pacific Track PT10", "Pacific Track PT40", "Palm PVG100", "Palm PVG100S Palm Standalone", "Palm Venture Groups PVG100", "Palm Venture Groups PVG100 Gold", "Panasonic FZ A3 Toughpad", "Panasonic FZ E1", "Panasonic FZ L1AA", "Panasonic FZ N1EB", "Panasonic FZ N1KB", "Panasonic FZ N1LB", "Panasonic FZ T1BB", "Panasonic FZ X1", "Panasonic FZ X1V1", "Panasonic North America FZ S1", "Panasonic North America Panasonic FZ G2 EM7511", "Panasonic Toughbook 20 EM7455 module", "Panasonic Toughbook 20 EM7511 Sierra Wireless EM7511 module", "Panasonic Toughbook 31 EM7455 module", "Panasonic Toughbook 33", "Panasonic Toughbook 33 EM7455 module", "Panasonic Toughbook 54", "Panasonic Toughbook 54 EM7455 module", "Panasonic Toughbook 55 EM7511 Sierra Wireless EM7511 module", "Panasonic Toughbook CF 19 MC8355 module", "Panasonic Toughbook CF 31 EM7355 module", "Panasonic Toughbook CF C2 EM7355 module", "Panasonic Toughbook JT B1 MC7750 module", "Panasonic Toughpad CF 19 MC7355 module", "Panasonic Toughpad FZ A2 EM7355 module", "Panasonic Toughpad FZ G1 EM7455 module", "Panasonic Toughpad FZ M1 EM7455 module", "Panasonic Toughpad FZ Q1 EM7355 module", "Panasonic Toughpad FZ Q2 EM7355 module", "Par Tech TDP I", "Par Tech TDP IM", "Parakeet Technologies PK GW01", "Parallel Wireless BHM 205", "Parkeon STRADA PAL", "Parkeon STRADA PAL Cat4", "Parkeon Street Smart", "Parrot Drones SAS Anafi 2", "Patriot Technologies RF 1031 48 XT RS22 ETS CEL2", "Paulson Research SoilVitals", "PAX Technologies S920", "PCD ACT233L Delphi Connect with 4G Mobile Hotspot", "Pegasus Wireless Products PWP GW M96", "Pegasus Wireless Products PWP GW M96 3", "Peloton Technology DVT4", "Pepwave Balance 30 LTE", "Pepwave EXM 3LTEA", "Pepwave EXM T4 LTEA R", "Pepwave Limited BPL 021X LTE US T PRM", "Pepwave Limited BPL 031 LTEA W T", "Pepwave Limited BPL 310 FBR 5GH T PRM", "Pepwave Limited EXM 2GLTE G", "Pepwave Limited EXM 310X GLTE G", "Pepwave Limited EXM 310X LTEA R", "Pepwave Limited EXM 3LTEA R", "Pepwave Limited EXM MBX T2 GLTE G", "Pepwave Limited EXM MBX T4 GLTE G", "Pepwave Limited EXM MINI 15GH", "Pepwave Limited EXM MINI 1LTEA R", "Pepwave Limited EXM MINI 1LTEA W", "Pepwave Limited MAX ADP LTEA K T", "Pepwave Limited MAX ADP LTEA R T", "Pepwave Limited MAX ADP LTEA W T", "Pepwave Limited MAX BR1 ENT LTEA W T", "Pepwave Limited MAX BR1 IP67 LTEA", "Pepwave Limited MAX BR1 LTE US T", "Pepwave Limited MAX BR1 MINI LTE US", "Pepwave Limited MAX BR1 MINI LTE US T", "Pepwave Limited MAX BR1 MINI LTE US T M Core", "Pepwave Limited MAX BR1 MINI LTE US T Rev2", "Pepwave Limited MAX BR1 MINI LTE US T Rev3", "Pepwave Limited MAX BR1 MINI LTEA", "Pepwave Limited MAX BR1 MINI LTEA W T Rev3", "Pepwave Limited MAX BR1 MK2 LTE US T", "Pepwave Limited MAX BR1 MK2 LTEA W T", "Pepwave Limited MAX BR1 PRO 5GH T", "Pepwave Limited MAX BR1 PRO LTEA W T", "Pepwave Limited MAX BR1 PWR LTE US IP67", "Pepwave Limited MAX BR2 PRO 5GH T PRM", "Pepwave Limited MAX HD1 DOM M GLTE G", "Pepwave Limited MAX HD2 DOM M LTEA R", "Pepwave Limited MAX HD2 LTEA W T", "Pepwave Limited MAX HD2 M LTEA R IP67", "Pepwave Limited MAX HD2 M LTEA W IP67", "Pepwave Limited MAX HD4 LTEA W T", "Pepwave Limited MAX HD4 MBX 5GH T", "Pepwave Limited MAX MBX MINI 5GH T", "Pepwave Limited MAX TST GLTE G T PRM", "Pepwave Limited MAX TST LTEA R T", "Pepwave Limited MAX TST MINI LTE F T PRM", "Pepwave Limited PDX LTEA R T", "Pepwave Limited SpeedFusion Engine", "Pepwave Limited UBR GO LTEA R T", "Pepwave Limited UBR LTE US T PRM", "Pepwave MAX BR1 ENT LTEA R", "Pepwave MAX BR1 LTE", "Pepwave MAX BR1 LTE IP55", "Pepwave MAX BR1 LTEA W T", "Pepwave MAX BR1 MINI LTE US T M", "Pepwave MAX BR1 PRO", "Pepwave MAX BR1 Slim", "Pepwave MAX HD DOME LTEA", "Pepwave MAX HD2 LTE IP67", "Pepwave MAX HD2 MINI", "Pepwave MAX HD4", "Pepwave MAX TRANSIT", "Pepwave MAX TST", "Pepwave MAX TST LTEA W T", "Perle Systems C4G M 4P6MWR", "Perle Systems EtherWAN C4G M 3M", "Perle Systems EtherWAN C4G M 6M", "Perle Systems EtherWAN C4G S 1P3M", "Perle Systems EtherWAN C4G S 1P6M", "Perle Systems IRG5140 Plus", "Perle Systems IRG5410", "Perle Systems IRG5410 Plus", "Perle Systems IRG5500", "Perle Systems IRG5500 Plus", "Perle Systems Limited IOLAN SCG LA", "Perle Systems Limited IOLAN SDS1 LA", "Perle Systems Limited IOLAN SDS2 LA", "Perle Systems Limited IOLAN SDS4 LA", "PetSimpl Pip Tracker", "Philips Electronics North America 1141624 R410", "Philips Electronics North America 200603C R410 DFx", "Philips Electronics North America 200604C R410 DFx", "Philips Healthcare 100600C", "Philips Healthcare 100605C", "Philips North America 200603C", "Philips North America 200603C R410", "Philips North America 200604C", "Philips North America 200604C R410", "Phillips Connect Technologies Arrow QA", "Phoenix Contact Electronics GmbH mGuard RS2000", "Phoenix Contact Electronics GmbH TC CLOUD CLIENT 1002 4G VZW", "Phoenix Contact Electronics GmbH TC MGUARD RS4000 4G VZW VPN", "Phoenix Contact Electronics GmbH TC ROUTER 3002T 4G VZW", "Phoenix Contact Electronics GmbH TC ROuter 3002T 4G VZW", "Phytech US Phytech Logger", "PICA Product Development Skyhawk Hub", "PICA Product Development Skyhawk Kiwi", "PICA Product Development Skyhawk KiwiIR", "Pico Digital SMARTBOX LTEu", "Pivotal Commware Echo ES3", "Pivotal Commware Pivot GA1", "Plastic Research and Development Corp Moultrie DELTA", "Plastic Research and Development Corp Moultrie DELTA VZW", "Plastic Research and Development Corp Moultrie JOBSEC V", "Plastic Research and Development Corp Moultrie SECCAM V", "Plastic Research Development Corp MV2", "Plastic Research Development Corp WV 6000", "Podimetrics Podimetrics Mat 2 0", "Point One Navigation P1 SympleConnect CATM1", "Polymer Logistics Smart Box", "POM Parktel 3 0", "Portal 724 MN 724", "Positioning Universal DCD710LA", "Positioning Universal FJ1000L", "Positioning Universal FJ1000LMV", "Positioning Universal FJ150LMV", "Positioning Universal TM90M", "Power Delivery Products Reported", "Power Delivery Products Reporter", "Power Delivery Products Smart Nav 2 0", "Power Monitors BOOMERANG LTE", "Power Monitors Slingshot", "Presidio REX3100 OD", "Procter and Gamble Bounty v1 0", "Procter and Gamble Charmin v1 0", "Promate Solutions TW 004X110", "Prometheus Group Browning Pro Scout", "Prometheus Group Browning Ridgeline", "Prometheus Group Defender Pro Scout Max", "Prometheus Group StrikeForce4G", "ProSoft Technology ICX35 HWC", "ProSoft Technology OWL IPG AMERICAS", "Proximus NXS 9750 4G", "PROXIMUS Radoslaw Janowski NXS 9700 4G", "Pycom FiPy", "Pycom G01", "Pycom GPy", "Q1 PM85 1", "Q1 VML2030", "Q1W Wingtech ASMS01 Airspeed Mobile HotSpot", "Q1W Wingtech ASMSHS01 Airspeed Mobile HotSpot", "QMed Innovations Quest v3", "QoIsys IQPanel 2", "QolSys IQ Hub", "QolSys IQPanel4", "QPCS RSU 4H 14", "QPCS RSU FX2 IoT Gateway", "Quality One Wireless ADR930L Q1W", "Quality One Wireless CMA1000", "Quanta Computer LI170", "Quanta Computer LI172", "Quanta Computer LM171", "Quanta Computer LM171G", "Quanta Computer LM172", "Quanta Computer LM172G", "Quanta Computer LM175", "Quanta Computer LM177", "Quanta QMV7B Verizon Ellipsis 7", "Quanta QTAQZ3 Verizon Ellipsis 8", "Quanta QTASUN1 Verizon Ellipsis 8 HD", "Quanta QTASUN2 Pegasus", "Quanta QTAX53 Gizmo Watch", "Quanta QTAX53DW Disney Gizmo Watch", "Quanta QTAX53SE Gizmo Watch", "Quanta QTAX57 Watch", "Quanta QTAX59 Watch", "Quanta QTAXIA1 Ellipsis 10 HD", "Queclink GB100MG", "Queclink GB100MG Lite", "Queclink GL300MA", "Queclink GL300MA 1713", "Queclink GL300MG 1713", "Queclink GL300V", "Queclink GL300VC", "Queclink GL310B", "Queclink GL310MG 1713", "Queclink GL500MA 1713", "Queclink GL500MG 1713", "Queclink GL501MG 1713", "Queclink GL50MG 1713", "Queclink GV300C", "Queclink GV300VC", "Queclink GV350MA", "Queclink GV350MA 1713", "Queclink GV500MAP", "Queclink GV500MG 1713", "Queclink GV500MGP", "Queclink GV500VC", "QueClink GV50LTA", "Queclink GV50LTA", "Queclink GV50MA", "Queclink GV50MA 1713", "Queclink GV50MG 1713", "Queclink GV50VC", "Queclink GV51MG", "Queclink GV55VC", "Queclink GV600MA 1713A", "Queclink GV600MG 1713", "Queclink GV75MG 1713", "Queclink ZK102", "Quectel Wireless Solutions AG35 NA", "Quectel Wireless Solutions AG35 NA VDd", "Quectel Wireless Solutions BG770A GL", "Quectel Wireless Solutions BG95 M3", "Quectel Wireless Solutions BG95 M3 2 0 M1", "Quectel Wireless Solutions BG95 M3 MINIPCIE", "Quectel Wireless Solutions BG950A GL", "Quectel Wireless Solutions BG951A GL", "Quectel Wireless Solutions BG96 3 0 M1", "Quectel Wireless Solutions BG96 3 0M C2", "Quectel Wireless Solutions BG96 NA", "Quectel Wireless Solutions BG96 NA MBX", "Quectel Wireless Solutions BG96 SST", "Quectel Wireless Solutions EC21 V", "Quectel Wireless Solutions EC21 V C1", "Quectel Wireless Solutions EC21 V C2", "Quectel Wireless Solutions EC21 V MINIPCIE", "Quectel Wireless Solutions EC21 V MINIPCIE C1", "Quectel Wireless Solutions EC21 V MINIPCIE C2", "Quectel Wireless Solutions EC21 VD", "Quectel Wireless Solutions EC25 AF", "Quectel Wireless Solutions EC25 AF Cat 1", "Quectel Wireless Solutions EC25 AF D", "Quectel Wireless Solutions EC25 AF D M", "Quectel Wireless Solutions EC25 AF MINIPCIE", "Quectel Wireless Solutions EC25 AFDL", "Quectel Wireless Solutions EC25 AFDL MINIPCIE", "Quectel Wireless Solutions EC25 AFX", "Quectel Wireless Solutions EC25 AFX MINIPCIE", "Quectel Wireless Solutions EC25 AFXD", "Quectel Wireless Solutions EC25 AFXD MINIPCIE", "Quectel Wireless Solutions EC25 V", "Quectel Wireless Solutions EC25 V ALO", "Quectel Wireless Solutions EC25 V C1", "Quectel Wireless Solutions EC25 V C2", "Quectel Wireless Solutions EC25 V MINIPCIE", "Quectel Wireless Solutions EC25 V MINIPCIE C2", "Quectel Wireless Solutions EC25 VD", "Quectel Wireless Solutions EC25 VD MINIPCIE", "Quectel Wireless Solutions EG06 A", "Quectel Wireless Solutions EG065K NA", "Quectel Wireless Solutions EG21 G", "Quectel Wireless Solutions EG21 G MINIPCIE", "Quectel Wireless Solutions EG25 G", "Quectel Wireless Solutions EG25 G D", "Quectel Wireless Solutions EG25 G MINIPCIE", "Quectel Wireless Solutions EG25 G MINIPCIE C1", "Quectel Wireless Solutions EG25 G MINIPCIE D", "Quectel Wireless Solutions EG25 GL D MINIPCIE", "Quectel Wireless Solutions EG25 GL MINIPCIE", "Quectel Wireless Solutions EG61 NA", "Quectel Wireless Solutions EG800Q NA", "Quectel Wireless Solutions EG91 NA", "Quectel Wireless Solutions EG91 NAX", "Quectel Wireless Solutions EG91 NAXDL", "Quectel Wireless Solutions EG91 NS", "Quectel Wireless Solutions EG91 VX", "Quectel Wireless Solutions EG915Q AF", "Quectel Wireless Solutions EG915Q NA", "Quectel Wireless Solutions EG915Q NA LG", "Quectel Wireless Solutions EG916Q GL", "Quectel Wireless Solutions EG92 NA", "Quectel Wireless Solutions EG95 NA", "Quectel Wireless Solutions EM05 G", "Quectel Wireless Solutions EM06 A", "Quectel Wireless Solutions EM12 G", "Quectel Wireless Solutions EM12 G MSFT", "Quectel Wireless Solutions EM120R GL", "Quectel Wireless Solutions EM120R GL P", "Quectel Wireless Solutions EM121R GL", "Quectel Wireless Solutions EM121R GL P", "Quectel Wireless Solutions EM160R GL", "Quectel Wireless Solutions EM160R GL P", "Quectel Wireless Solutions EM162R GL", "Quectel Wireless Solutions EP06 A", "Quectel Wireless Solutions RG520N NA", "Quectel Wireless Solutions RG520N NA DA", "Quectel Wireless Solutions RM505Q AE", "Quectel Wireless Solutions RM520N GL", "Quectel Wireless Solutions RM520N GL B", "Quectel Wireless Solutions RM520N GL C", "Quectel Wireless Solutions SC20 A", "Quectel Wireless Solutions SC20 AD", "Quectel Wireless Solutions SC20 AL", "Quectel Wireless Solutions SC20 ALD", "Quectel Wireless Solutions SC20 AX", "Quectel Wireless Solutions SC200E NA", "Quectel Wireless Solutions SC200E NA TA", "Quectel Wireless Solutions SC200R NA", "Quectel Wireless Solutions SC206E NA", "Quectel Wireless Solutions SC600T NA", "Quectel Wireless Solutions SC600T NA S", "Quectel Wireless Solutions SC600Y NA", "Quectel Wireless Solutions SC606T NA", "Quectel Wireless Solutions SC606T NAD", "Quectel Wireless Solutions SC66 A", "Quectel Wireless Solutions SC66 A 5 0", "Quectel Wireless Solutions SC668S NA UA", "Quetcel Wireless Solutions BG96", "Quidel Sofia 2", "RAD Data Communications SecFlow1", "Radiflow RF 1031 48 XT RS22 ETS CEL2", "Ranch Systems RS130 M1", "Razer Edge RZ45 0460 Q1W 5G", "Razer USA Razer Phone 2", "React Mobile Peerless LTE Button", "READY IRELESS LG VN250CT", "READY WIRELESS Apple NLKiPhone4s", "READY WIRELESS Casio C771CT", "READY WIRELESS Casio C771SF", "READY WIRELESS HTC 6535 HD RW", "READY WIRELESS HTC D100 HD RW", "READY WIRELESS HTC D100 RW", "READY WIRELESS LG VN251CT", "READY WIRELESS LG VN270CT", "READY WIRELESS LG VS415CT", "READY WIRELESS LG VS415SF", "READY WIRELESS LG VS425 HD RW", "READY WIRELESS LG VS425 RW", "READY WIRELESS LG VS450CT", "READY WIRELESS LG VS450SF", "READY WIRELESS LG VS840 RW", "READY WIRELESS LG VS870 RW", "READY WIRELESS LG VS980 RW", "READY WIRELESS LG VS985 HD RW", "READY WIRELESS LG VS986 HD RW", "READY WIRELESS LG VX8300CT", "READY WIRELESS LG VX8500CT", "READY WIRELESS LG VX9100CT", "READY WIRELESS LG VX9400CT", "READY WIRELESS LG VX9700CT", "READY WIRELESS LG VX990CT", "READY WIRELESS LG WVX9100", "READY WIRELESS LG WVZ8800", "READY WIRELESS Motorola W755", "READY WIRELESS Motorola XT1254 HD RW Droid Turbo", "READY WIRELESS Samsung SCH i500CT", "READY WIRELESS Samsung SCH I535 RW", "READY WIRELESS Samsung SCH I545 RW", "READY WIRELESS Samsung SCH U350CT", "READY WIRELESS Samsung SCH U360CT", "READY WIRELESS Samsung SCH U365CT", "READY WIRELESS Samsung SCH U450CT", "READY WIRELESS Samsung SCH U485CT", "READY WIRELESS Samsung SCH U485SF", "READY WIRELESS Samsung SM 920 HD RW", "READY WIRELESS Samsung SM B311VCT", "READY WIRELESS Samsung SM B311VGG", "READY WIRELESS Samsung SM G360 HD RW", "READY WIRELESS Samsung SM G360 RW", "READY WIRELESS Samsung SM G900 HD RW", "READY WIRELESS Samsung SM G900 RW", "READY WIRELESS ZTE Z233VL HD RW", "READY WIRELESS ZTE Z559DL RW", "READY WIRELESS ZTE Z750C RW", "Reconyx HF2AFD", "Red H1A1000 Hydrogen One", "Red Lion Sixnet DA S00 CL 9C4S", "RED POCKET LG VS415SF", "Regal Beloit America GM 71N", "Reliance 678L5 Orbic Myra", "RELIANCE COMMUNICATION LG VS410PP RC", "RELIANCE COMMUNICATIONS Motorola XT907 RC", "Reliance Communications Orbic Joy 2 RC656V", "Reliance Communications Orbic Speed", "Reliance Communications R100ML5", "Reliance Communications RC2200L W", "Reliance Communications RC555L", "Reliance Communications RC555L Orbic Wonder", "Reliance Communications XT907 RC", "Reliance Orbic R667L5U Trophy", "Reliance R141TL5 Orbic 5G PC", "Reliance R500L5 Orbic Speed 5GT", "Reliance R562L5 Orbic Speed X 5G", "Reliance R8L5T Orbic Tab 8", "Reliance RC2200 L2 Orbic Journey L", "Reliance RC2200L Orbic Journey Flip", "Reliance RC2200L Orbic Journey Flip PrePay", "Reliance RC2210L Orbic Journey V", "Reliance RC400L Orbic Speed Jetpack", "Reliance RC545L Orbic Maui Prepaid", "Reliance RC608L Orbic Joy", "RelianceRC116LCB Chromebook", "Renesas Electronics America RYZ014A", "Rentokil Steritech CP 4GR 915", "Residence Control EOOD dba M2M Services MQ03 LTE M", "Residence Control EOOD M2M Services BAT MiNi", "Resolution Products Alarm Communicator RE929", "Resolution Products M1 Alarm Communicator", "Resolution Products RE930XP", "Response Cloud SN100", "ReviverMx ACKBAR 1", "ReviverMx RMX DLP Beta v1 1", "Rhythmedix RhythmStar", "Rhythmedix RhythmStar W", "Rigado Cascade 500 V", "RIM BlackBerry Classic SQC100 3", "RIM BlackBerry Classic SQC100 5 no camera", "RIM BlackBerry Q10", "RIM BlackBerry STV100 2 PRIV", "RIM Blackberry Z10", "RIM BlackBerry Z30", "Ring Alarm 2 0", "RING BG96 Alarm Security Kit", "Road IQ Road IQ NetHub", "Roqos CA10", "Rosco DV601", "Rosco ND 100", "RuggON PA501B", "RxCap RxCap ESI Cap 38mm", "RxCap RxCap ESI Cap 42mm", "RxCap RxCap Hub", "Samsung 5G CPE", "Samsung Electronics America Galaxy Tab S5e 128GB Unlocked", "Samsung Electronics America Galaxy Tab S5e Unlocked", "Samsung Electronics America SM A025U1 Galaxy A02s Unlocked", "Samsung Electronics America SM A102U1 OD", "Samsung Electronics America SM A115U1 Galaxy A11", "Samsung Electronics America SM A115U1 VS Galaxy A11", "Samsung Electronics America SM A125U1 DS OD Galaxy A12 5G", "Samsung Electronics America SM A205U1 OD", "Samsung Electronics America SM A215U1 OD Galaxy A21", "Samsung Electronics America SM A215U1 OD VS Galaxy A21", "Samsung Electronics America SM A215U1 VS Galaxy A21", "Samsung Electronics America SM A326U1 Galaxy A32 5G", "Samsung Electronics America SM A426U1 Galaxy A42 5G", "Samsung Electronics America SM A505U1 OD", "Samsung Electronics America SM A505U1 OD VS", "Samsung Electronics America SM A515U1 Galaxy A51", "Samsung Electronics America SM A515U1 VS Galaxy A51", "Samsung Electronics America SM A516U1 OD Galaxy A51 5G", "Samsung Electronics America SM A526U1 OD Galaxy A52 5G", "Samsung Electronics America SM A716U1 Galaxy A71 5G", "Samsung Electronics America SM F700U1 OD Galaxy Z Flip", "Samsung Electronics America SM F700U1 OD Galaxy Z Flip TB Edition", "Samsung Electronics America SM F707U1 OD Galaxy Z Flip 5G", "Samsung Electronics America SM F900U1 OD Samsung Fold", "Samsung Electronics America SM F916U1 Galaxy Fold 2 Unlocked", "Samsung Electronics America SM F916U1 TB Galaxy Fold 2 Unlocked", "Samsung Electronics America SM G715U1 Galaxy XCover Pro", "Samsung Electronics America SM G770U1 OD S10 Lite", "Samsung Electronics America SM G781U1 Galaxy S20 FE 5G Unlocked", "Samsung Electronics America SM G781U1 OD 256GB Galaxy S20 FE 5G Unlocked", "Samsung Electronics America SM G781U1 VS Galaxy S20 FE 5G Unlocked", "Samsung Electronics America SM G960U1 OD", "Samsung Electronics America SM G960U1 OD Tactical", "Samsung Electronics America SM G960U1 OD VS", "Samsung Electronics America SM G965U1 OD", "Samsung Electronics America SM G965U1 OD VS", "Samsung Electronics America SM G970U1 OD", "Samsung Electronics America SM G970U1 OD 256", "Samsung Electronics America SM G970U1 OD VS", "Samsung Electronics America SM G973U1 OD", "Samsung Electronics America SM G973U1 OD 512", "Samsung Electronics America SM G975U1 OD", "Samsung Electronics America SM G975U1 OD1TBC", "Samsung Electronics America SM G975U1 OD512C", "Samsung Electronics America SM G981U1 OD Tactical S20 5G", "Samsung Electronics America SM G981U1 S20 5G", "Samsung Electronics America SM G981U1 VS Galaxy S20 5G", "Samsung Electronics America SM G986U1 OD BTS S20 Plus 5G", "Samsung Electronics America SM G986U1 S20 Plus 5G", "Samsung Electronics America SM G986U1 S20 Plus 5G 512GB", "Samsung Electronics America SM G986U1 VS S20 Plus 5G", "Samsung Electronics America SM G988U1 S20 Ultra 5G", "Samsung Electronics America SM G988U1 S20 Ultra 5G 512GB", "Samsung Electronics America SM G988U1 VS S20 Ultra 5G", "Samsung Electronics America SM G991U1 OD 256GB Galaxy S21 5G 256GB", "Samsung Electronics America SM G991U1 OD Galaxy S21 5G", "Samsung Electronics America SM G991U1 VS Galaxy S21 5G", "Samsung Electronics America SM G996U1 OD 256GB Galaxy S21 Plus 5G 256GB", "Samsung Electronics America SM G996U1 OD Galaxy S21 Plus 5G", "Samsung Electronics America SM G996U1 VS Galaxy S21 Plus 5G", "Samsung Electronics America SM G998U1 OD 256GB Galaxy S20 Ultra 5G 256GB", "Samsung Electronics America SM G998U1 OD 512GB Galaxy S20 Ultra 5G 512GB", "Samsung Electronics America SM G998U1 OD Galaxy S20 Ultra 5G 128GB", "Samsung Electronics America SM N970U1 Note 10 Unlocked", "Samsung Electronics America SM N975U1 Note 10 Plus 512GB Unlocked", "Samsung Electronics America SM N975U1 Note 10 Plus Unlocked", "Samsung Electronics America SM N975U1 Note 10 Plus Unlocked Star Wars", "Samsung Electronics America SM N981U1 OD Galaxy Tab S2", "Samsung Electronics America SM N986U1 OD Galaxy Note 20 Ultra", "Samsung Electronics America SM N986U1 OD Galaxy Note 20 Ultra 512GB", "Samsung Electronics America SM T547U Samsung Galaxy Tab Active Pro 10 1 Unlocked", "Samsung Electronics America SM T577U DS 128GB Galaxy Tab Active 3", "Samsung Electronics America SM T577U DS 128GB Galaxy Tab Active 3 128GB", "Samsung Electronics America SM T577U DS OD Galaxy Tab Active 3", "Samsung Electronics America Tab Active2 SM T397U OD", "Samsung Electronics America Tab Active2 SM T397U OD 32GB", "Samsung Electronics Exynos1380", "Samsung Electronics Shannon5400", "Samsung Galaxy A23 SM A236V 5G UW", "Samsung Galaxy SM A546V A54 5G", "Samsung Galaxy SM GA546V A54", "Samsung i435 Galaxy S4 Mini", "Samsung i545 Galaxy S 4", "Samsung NP545XLA Hermes 5G", "Samsung SCH I545PP Galaxy S 4 PrePaid", "Samsung SCH U680N Convoy 3", "Samsung SM 825U Galaxy Watch Active2", "Samsung SM 835U Galaxy Watch Active2", "Samsung SM A015V Galaxy A01", "Samsung SM A025V Galaxy A02s", "Samsung SM A025V Galaxy A02s Prepaid", "Samsung SM A02s Galaxy A02s Postpaid", "Samsung SM A037U A03s", "Samsung SM A102U Galaxy A10e", "Samsung SM A115U Galaxy A11", "Samsung SM A125U Galaxy A12 Postpaid", "Samsung SM A125U Galaxy A12 Prepaid", "Samsung SM A135U Galaxy A13 Postpaid", "Samsung SM A135U Galaxy A13 Prepaid", "Samsung SM A146U Galaxy A14 5G", "Samsung SM A156U Galaxy A15 5G", "Samsung SM A205U Galaxy A20", "Samsung SM A215U Galaxy A21", "Samsung SM A426U Galaxy A42 5G", "Samsung SM A505U Galaxy A50", "Samsung SM A515U Galaxy A51", "Samsung SM A516V Galaxy A51 5G UW", "Samsung SM A536V Garlaxy A53 5G UW", "Samsung SM A716V Galaxy A71 5G UW", "Samsung SM B311V Gusto 3", "Samsung SM B690V Convoy 4", "Samsung SM F711U Galaxy Z Flip 3", "Samsung SM F721U B4 Flip4", "Samsung SM F731U Galaxy Z Flip B5", "Samsung SM F741U Galaxy Z Flip 6 5G", "Samsung SM F916U Galaxy Z Fold2 5G UW", "Samsung SM F926U Galaxy Z Fold3 5G", "Samsung SM F936U Q4 Fold4", "Samsung SM F946U Galaxy Z Fold Q5", "Samsung SM F956U Galaxy Z Fold 6 5G", "Samsung SM G360V Galaxy Core Prime", "Samsung SM G715U Galaxy XCover Pro", "Samsung SM G730V Galaxy S3 Mini", "Samsung SM G781V Galaxy S20 FE 5G", "Samsung SM G900V Galaxy S 5", "Samsung SM G920V Galaxy S 6", "Samsung SM G925V Galaxy S 6 Edge", "Samsung SM G928V Galaxy S6 Edge Plus", "Samsung SM G930U Galaxy S7 Unlocked", "Samsung SM G930V Galaxy S 7", "Samsung SM G935U Galaxy S7 Edge Unlocked", "Samsung SM G935V Galaxy S 7 Edge", "Samsung SM G950U Galaxy S8", "Samsung SM G950U1 Galaxy S8 Unlocked", "Samsung SM G955U Galaxy S8 Plus", "Samsung SM G955U1Galaxy S8 Plus Dream 2 Unlocked", "Samsung SM G960U Galaxy S9", "Samsung SM G960U1 W Galaxy S9 Unlocked", "Samsung SM G965U Galaxy S9 Plus", "Samsung SM G970U Galaxy S10e", "Samsung SM G973U Galaxy S10", "Samsung SM G975U Galaxy S10 Plus", "Samsung SM G977U Galaxy S10 5G", "Samsung SM G981V Galaxy S20 5G", "Samsung SM G986U Galaxy S20 Plus 5G", "Samsung SM G988U Galaxy S20 Ultra 5G", "Samsung SM G990U Galaxy S21 FE 5G", "Samsung SM G990U2 Galaxy S21 FE 5G", "Samsung SM G991U Galaxy S21 5G", "Samsung SM G996U Galaxy S21 Plus 5G", "Samsung SM G998U Galaxy S21 Ultra 5G", "Samsung SM H204V Luna 5G Station", "Samsung SM H303V Outdoor 5G Station", "Samsung SM J100VCT", "Samsung SM J100VPP Galaxy J1 Prepaid", "Samsung SM J320V Galaxy J3", "Samsung SM J320VLPP Galaxy J3PP", "Samsung SM J320VPP Galaxy J3 PrePaid", "Samsung SM J327V Galaxy J3 Eclipse", "Samsung SM J327VPP Galaxy J3 Mission", "Samsung SM J337V Galaxy J3V", "Samsung SM J337VPP Galaxy J3 Prepay", "Samsung SM J727V Galaxy J7", "Samsung SM J727VPP Galaxy J7PP", "Samsung SM J737V Galaxy J7V", "Samsung SM J737VPP Galaxy J7 Prepay", "Samsung SM L305U Galaxy Watch 7", "Samsung SM L315U Galaxy Watch 7", "Samsung SM L705U Galaxy Watch Ultra", "Samsung SM N900V Galaxy Note 3", "Samsung SM N910V Galaxy Note 4", "Samsung SM N915V Galaxy Note Edge", "Samsung SM N920V Note 5", "Samsung SM N930V Note 7", "Samsung SM N950U1 OD", "Samsung SM N960U Galaxy Note 9", "Samsung SM N960U1 OD", "Samsung SM N970U Note 10", "Samsung SM N975U Note 10 Plus", "Samsung SM N976V Note 10 Plus 5G", "Samsung SM N981U Galaxy Note 20 5G", "Samsung SM N981U1 W Note 20 5G", "Samsung SM N986U Galaxy Note 20 Ultra 5G", "Samsung SM P605V Galaxy Note 10 1 2014 Edition", "Samsung SM P905V Galaxy Note Pro", "Samsung SM R730V Gear S 2", "Samsung SM R735V Gear S 2 Classic", "Samsung SM R750V Gear S", "Samsung SM R765V Gear S 3 Frontier", "Samsung SM R775V Gear S 3 Classic", "Samsung SM R805U Galaxy Watch 46mm", "Samsung SM R815U Galaxy Watch 42mm", "Samsung SM R825U Galaxy Watch Active2", "Samsung SM R835U Galaxy Watch Active2", "Samsung SM R845U Galaxy Watch3", "Samsung SM R855U Galaxy Watch3", "Samsung SM R865U Galaxy Watch4", "Samsung SM R875U Galaxy Watch4 Fresh", "Samsung SM R885U Galaxy Watch4 Classic", "Samsung SM R895U Galaxy Watch4 Classic Wise", "Samsung SM R905U Galaxy Watch5 40mm", "Samsung SM R915U Galaxy Watch5 44mm", "Samsung SM R925U Galaxy Watch5 Pro", "Samsung SM R935U Galaxy Watch6", "Samsung SM R945U Galaxy Watch 6", "Samsung SM R955U Galaxy Watch 6", "Samsung SM R965U Galaxy Watch 6", "Samsung SM S124DL Galaxy A02s", "Samsung SM S127DL Galaxy A12", "Samsung SM S134DL Galaxy A03s", "Samsung SM S135DL Galaxy A03s", "Samsung SM S136DL Galaxy A13 5G", "Samsung SM S146VL Galaxy A14 5G", "Samsung SM S156V Galaxy A15 5G", "Samsung SM S236DL Galaxy J2", "Samsung SM S237VL Galaxy J3 Luna Pro 5G", "Samsung SM S256VL Galaxy A25 5G", "Samsung SM S326DL Galaxy A32 5G", "Samsung SM S356V Galaxy A02s 5G", "Samsung SM S426DL Galaxy A42 5G", "Samsung SM S515DL Galaxy A51", "Samsung SM S536DL Galaxy A53 5G", "Samsung SM S546VL Galaxy A54 5G", "Samsung SM S711U Galaxy S23FE", "Samsung SM S901U Galaxy S22", "Samsung SM S906U Galaxy S22 Plus", "Samsung SM S908U Galaxy S22 Ultra", "Samsung SM S911U Galaxy S23", "Samsung SM S916U Galaxy S23 Plus", "Samsung SM S918U Galaxy S23 Ultra", "Samsung SM S921U G S24", "Samsung SM S926U G S24 Plus", "Samsung SM S928U G S24 Ultra", "Samsung SM T227U Galaxy Tab A7 Lite", "Samsung SM T307U Galaxy Tab A 8 4", "Samsung SM T337V Galaxy Tab 4 8", "Samsung SM T377V Galaxy Tab E 8", "Samsung SM T378V Galaxy Tab E 32GB", "Samsung SM T387V Galaxy Tab A 8 inch", "Samsung SM T387VK GizmoTablet", "Samsung SM T537V Galaxy Tab 10 1", "Samsung SM T567V Galaxy Tab E", "Samsung SM T597V Galaxy Tab A 10 5", "Samsung SM T677V Galaxy Tab View", "Samsung SM T727V Galaxy Tab S5e", "Samsung SM T738U Galaxy Tab S7 FE 5G", "Samsung SM T807V Galaxy Tab S 10 5", "Samsung SM T817V Galaxy Tab S 2", "Samsung SM T818V Galaxy Tab S 2 Refresh", "Samsung SM T827V Galaxy Tab S3", "Samsung SM T837V Galaxy Tab S4", "Samsung SM T867V Galaxy Tab S6", "Samsung SM T878U Tab S7", "Samsung SM T978U Tab S7 Plus", "Samsung SM W727V Galaxy Book", "Samsung SM W728VQ OD Galaxy Book 12", "Samsung SM W767V Galaxy Book S", "Samsung SM X218U Galaxy Tab A9 Plus", "Samsung SM X518U Galaxy Tab S9 FE", "Samsung SM X808U Tab S8 Plus", "Samsung SM X818U Galaxy Tab S9 Plus", "Samsung SmartThings Tracker SM V110V", "Samsung SN N950U Galaxy Note 8", "Samsung Tab S 8 4 SM T707V", "Samsung Telecommunications Galaxy S7 Edge SM G935U Unlocked", "Samsung Telecommunications Galaxy S7 SM G930U Unlocked", "Samsung XE345XDA Galaxy Chromebook Go", "Samsung XE525QBB Chromebook", "SATEC 4G LTE Module", "Satellite Tracking of People BLUtag V8", "Schindler Elevator Corporation CB3LTE QU", "Schneider Electric Data Logger SE", "Schneider Electric Mustang MMR 1", "Schneider Electric Mustang MMR M", "Schweitzer Engineering Laboratories SEL 3061", "Seeonic Sightware Gateway", "Semaconnect Cellular Adapter LTE VZW CAT M1", "Semaconnect Cellular Adapter LTE VZW Cat M1", "Semaconnect Cellular LTE VZW Cat M1 WW", "Semaconnect LTE VZW SV Cat 1", "SemiodBio Technologies DNSCD", "SemiosBio Technologies BG96modem", "SemiosBio Technologies DNNODE Y", "SemiosBio Technologies DNTRAPBG96", "Senaya SMV C432G", "Sensera Systems MC26", "Sensity Systems CNEX 277C2NA", "Sensity Systems CNEX 277C2NB", "Sensity Systems CNEX 480C2NA", "Sensity Systems CNEX 480C2NB", "Sensity Systems SCH 277W3C3N", "Sensity Systems SCH 480W3C3N", "Sensonix SENSX001", "Sensonix SENSX002", "Sensonix SXIM1V", "Sensored Life MarCELL LTE M1", "Sensored Life MarCELL LTE M1 410", "Sentek Pty Sentek Modem", "Sentient Energy MM3CLL2", "Sentient Energy UM3CLL5", "Sentient Energy UM3CLL5M", "Sentient Energy ZM1", "Sentient Energy ZM1 Gen1", "Sentient Energy ZM1CLL5", "SEPSAMEDHA S L U M9 Wireless Data Link System", "Septentrio AntaRx", "Septentrio AsteRx U3", "Sequans GM01Q", "Sequans GM02S", "Sequans GM02S NB IoT", "Sequans Monarch Go", "Sequans Monarch Go GPS", "Sequans Monarch Go GPS BLE", "Sequans SQN3330", "Sequans SQN3430", "Sequans SQN66430 SKY66430 11", "Sequans VZ120Q", "Sequans VZ120Q Module", "Sequans VZ20Q", "Sequans VZ22M", "Sequans VZ22Q", "Sequans VZ30L", "Sequans VZM20Q", "Sequans VZW20Q", "Sequans VZW21Q", "Sequentric Energy Systems DLC HV M1", "Sequentric Energy Systems DLC HVAC M11", "Sequentric Energy Systems Sequentric DLC M1", "Sequentric Energy Systems Sequentric MeterBridge M1", "Sequentric Energy Systems Sequentric MPG", "Sequentric Energy Systems SequentricDLC", "Sercomm TPM10", "Sercomm TPM540", "Sharp STTM12VAPP Q1W Rouvo", "Shenzhen Xinguodu Technology N5", "Shoreline IoT iCast Sense", "Shotspotter 200 VE", "Shotspotter Model 200 V", "Shotspotter Model 200 V4", "Shotspotter Model 200V4E", "Siemans Canada RUGGEDCOM RX1500 Telit", "Siemans Canada RX1500 LTE LM", "Siemens Aktiengesellschaft M876 4 NAM", "Siemens Aktiengesellschaft RM1224 NAM", "Siemens Canada RX1400 NA", "Siemens Industry Mobile Division Siemens RSU", "Siera Wireless EM7455D", "Sierra Wireless AC597e", "Sierra Wireless Airlink ES440", "Sierra Wireless Airlink ES450", "Sierra Wireless Airlink GX400", "Sierra Wireless Airlink GX440", "Sierra Wireless Airlink GX450", "Sierra Wireless Airlink LX40", "Sierra Wireless Airlink LX40 LTE M", "Sierra Wireless Airlink LX40 NA", "Sierra Wireless Airlink LX60", "Sierra Wireless Airlink LX60 LTE M", "Sierra Wireless Airlink LX60 NA", "Sierra Wireless Airlink MP70", "Sierra Wireless Airlink MP70E", "Sierra Wireless Airlink RV50", "Sierra Wireless Airlink RV50X", "Sierra Wireless Airlink RV50X AirlinkOS", "Sierra Wireless Airlink RV55 LTE A Pro Global", "Sierra Wireless Airlink RV55 LTE M", "Sierra Wireless Airlink RV55 LTE NA", "Sierra Wireless AR7582", "Sierra Wireless AR7582 1", "Sierra Wireless AR7592 1", "Sierra Wireless EM7345 Module", "Sierra Wireless EM7345 module", "Sierra Wireless EM7355", "Sierra Wireless EM7411", "Sierra Wireless EM7455", "Sierra Wireless EM7455 Module", "Sierra Wireless EM7511", "Sierra Wireless EM7565", "Sierra Wireless EM7690", "SIerra Wireless EM9190", "Sierra Wireless EM9191", "Sierra Wireless FX30 LTE CAT 1", "Sierra Wireless FX30 LTE M", "Sierra Wireless FX30S LTE CAT 1", "Sierra Wireless FX30S LTE M", "Sierra Wireless GL7500", "Sierra Wireless GNX 3 LTE", "Sierra Wireless GNX 5P LTE M", "Sierra Wireless GNX 6 LTE", "Sierra Wireless GNX 6 LTE M", "Sierra Wireless GX400", "Sierra Wireless GX440", "Sierra Wireless HL7518", "Sierra Wireless HL7588", "Sierra Wireless HL7588D", "Sierra Wireless HL7588V", "Sierra Wireless HL7618", "Sierra Wireless HL7618RD", "Sierra Wireless HL7718", "Sierra Wireless HL7800", "Sierra Wireless HL7800 M", "Sierra Wireless HL7800 M1", "Sierra Wireless HL7802", "Sierra Wireless HL7802 M1", "Sierra Wireless LS300", "Sierra Wireless LTE30VZ", "Sierra Wireless MC7350", "Sierra Wireless MC7354", "Sierra Wireless MC7411", "Sierra Wireless MC7455", "Sierra Wireless MC7455D", "Sierra Wireless MG90", "Sierra Wireless MG90 LTE APro", "Sierra Wireless MG90 US", "Sierra Wireless MP70 LTE APro", "Sierra Wireless oMG 2000", "Sierra Wireless oMG 500", "Sierra Wireless RC7110", "Sierra Wireless RC7611", "Sierra Wireless RC7611 1", "Sierra Wireless RV55 LTE A Pro Airlink OS", "Sierra Wireless SL3010T", "Sierra Wireless SL9090", "Sierra Wireless Uplink 5500VZ", "Sierra Wireless WP7601", "Sierra Wireless WP7601 1", "Sierra Wireless WP7610", "Sierra Wireless WP7611", "Sierra Wireless WP7611 1", "Sierra Wireless WP7700", "Sierra Wireless WP7702", "Sierra Wireless XR80 5G 9293", "Sierra Wireless XR90 5G", "Sierra Wireless XR90 5G 9293", "Sierrra Wireless LS300", "SignalFire Telemetry Ranger", "Signalscape ATLD7355", "Signetik SigCell Cellular Modem", "Silicom Connectivity Solutions IA3001", "Silicom Connectivity Solutions VE2 Versa Verizon", "Silicon Connectivity Solutions LTE and Wi Fi enabled CPE", "Silver Sprint Network NIC 511 SV1 0312", "Silver Sprint Network NIC 511 SV1 0313", "SIMcom Wireless Solutions SIM7000A", "SIMcom Wireless Solutions SIM7000A PCIE", "SIMcom Wireless Solutions SIM7070G", "SIMcom Wireless Solutions SIM7080G", "SIMcom Wireless Solutions SIM7090G", "SIMcom Wireless Solutions SIM7600NA H", "SIMcom Wireless Solutions SIM7600V H", "SIMcon Wireless Solutions SIM7500V", "SimpliSafe SS CAT M1", "SimpliSafe SS2 CAT M1 BG95", "SimpliSafe SS3CAT M1 BG95", "Sixfab IOTHAT TX3 0 v1", "Sixnet RAM 9901", "Sixnet RAM 9911", "Sixnet RAM 9931", "Sixnet SN RAM 6900", "Sixnet SN RAM 6901", "Sixnet SN RAM 6901EB", "Sixnet SN RAM 6921", "Siyata Mobile Bluebird VF550", "Siyata Mobile Uniden UV350", "SKU STKAA Auto Reception", "SKU STKHG Hunt Group", "Skykit E400", "Skykit SKPPRO TSMN", "Skyus DS MC7455", "Smart Earth Technologies SET100C", "Smart Grid Solutions FI 5A W", "Smart Tracking Technologies Link 3", "Smart Water Metering SWMGR300", "Smart Witness CP1", "Smart Witness CP2", "Smart Witness CP4S NA", "SMRTGrid SMRTGrid Line Beacon", "SMRxT SMRxT Bottle LTE", "Snap Lock Tech 30 511", "SNPowercom SW100", "Social Mobile T5", "Soiltech Wireless soiltech ag sensor", "Solar Rig Technologies Image Point 4x4", "Solar Technologies MegaWan", "Solar Technology AB MB Controller", "Solar Technology Arrow Board Controller", "Solar Technology Solar Trak", "Solar Technology Solar Trak LTE", "Solar Technology SolarTrak Gen5 v5 2", "Sonim Technologies XP7700", "Sonim XP3900 XP3 Plus", "Sonim XP5700 Feature Phone", "Sonim XP5800 Feature Phone", "Sonim XP8800 Feature Phone", "Sony Electronics XQ AQ62 Xperia Pro 5G", "Sony Electronics XQ BC62 Xperia 1 III 5G", "Sony Electronics XQ BQ62 Xperia 5 III 5G", "Sony Mobile Communications H3123", "Sony Mobile Communications H8314", "Sony Mobile Communications J8170 AMZ Experia 1 6GB", "Sony Mobile Communications J8170 Xperia 1", "Sony Mobile Communications J8270 Xperia 5", "Sony Mobile Communications PDX206 Xperia 1 II", "Sony Mobile Communications Xperia 10", "Sony Mobile Communications Xperia 10 Plus", "Sony Mobile Communications XQ AQ62 Xperia Pro 5G", "Sony Mobile Communications XQ AS62 Xperia 5 II 128GB", "Sony Mobile Communications XQ AT51 Sony XPeria 1 II 256GB", "Sony Xperia Z2 Tablet SGP561", "Sony Xperia Z3v Smartphone D6708", "Sophos XGS 116 firewall", "Sophos XGS 116w firewall", "Sophos XGS 126 firewall", "Sophos XGS 126w firewall", "Sophos XGS 136 firewall", "Sophos XGS 136w firewall", "Spensa Technologies Z Modem", "Spireon ATS100M V", "Spireon ATS100M Y V", "Spireon ATS100M YZ V", "Spireon ATS100M Z V", "Spypoint CELL LINK V", "Spypoint LINK 4GV", "Spypoint LINK DARK V", "Spypoint LINK EVO V", "Spypoint LINK MICRO S V", "Spypoint LINK MICRO V", "Spypoint LINK S DARK V", "Spypoint LINK S V", "Spypoint LINK W V", "Spypoint LINK WM V", "Starcom Systems Kylos Forever", "Starz Analytics Asset Tracker Lite", "Starz Analytics DW3", "STMicroelectronics BG96MAR02A07M1G", "STW Technic TC3G", "STW Technic TCG 4", "STW Technic VD03", "Sunshine Electronic Display Sunshine Gateway CATM1", "Suntech ST4345", "Suntech USA ST4310", "Suntech USA ST4315", "Suntech USA ST4330", "Suntech USA ST4910", "Suntech USA ST494OB", "Suntech USA ST4950", "Suntech USA ST4955", "Super Micro Computer SYS E100 8Q TDAW", "Super Micro Computer SYS E100 8Q TDE3", "Super Micro Computer SYS E100 8QE TDE3", "Sustain Sprinkle S3 Renew", "SUZOHAPP Americas 410260 1", "SUZOHAPP Americas 410260 2", "Synapse Wireless Synapse E20", "Synapse Wireless Synapse SS450", "Systech IPG 8000 CZ4B", "Systech IPG8100 CV1", "Systech IPG8101 CV1", "Systech IPG8110 CV1", "Systech IPG8111 CV1", "Systech SL 1000 CV1 LE866 SV1", "Systech SL 1000 CVE DE910", "Systech SL 1500 CV1 LE866 SV1", "Systech SL 1500 CVE DE910", "Systech SL 2000 CV1 LE866 SV1", "Systech SL 2000 CVE DE910", "Systech SL 3000 CV1 LE866 SV1", "Systech SL 3000 CVE DE910", "Systech SL 4000 CV1 LE866 SV1", "Systech SL 4000 CVE DE910", "Systech SL 500 CV1 LE866 SV1", "Systech SL 500 CV1B", "Systech SL 500 CVE DE910", "Systech SL 500 CZ4B", "Systech SL 500 CZ4BWW", "Systech SL 500 CZMB", "Systech SL 600 CV1 LE866 SV1", "Systech SL 600 CVE DE910", "Systech SL 600 CZ4B", "Systech SL 600 CZ4BWW", "Systech SL 600 CZMB", "Systech SL 800 CV1 LE866 SV1", "Systech SL 800 CVE DE910", "Systech SL 800 CZ4B", "Systech SL 800 CZ4BWW", "Systech SL 800 CZMB", "Systech SL 900 CVE DE910", "Systech SysCONNECT Cellular Modem CV1B", "Systech SysCONNECT CZ4B", "Systech SysCONNECT CZ4BWW", "Systech SysCONNECT CZMB", "Systech SysCONNECT Modem CV1", "Systech SysCONNECTCZ1", "Systech SysCORE 1 CZ4", "Systech SysCORE 1 CZ4B", "Systech SysCORE 1 CZ4BWW", "Systech SysCORE 1 CZMB", "Systech SysCORE 2 CZ4", "Systech SysCORE 2 CZ4B", "Systech SysCORE 2 CZ4BWW", "Systech SysCORE 2 CZMB", "Tactacam Reveal", "Tactacam Reveal X", "Tactical Electronics and Military Supply Boarbuster LTE", "Tait International Tait Unified Vehicle R2", "Takumi KAZ F019 Feature Phone", "Takumi KAZ F119 eTalk Feature Phone", "Takumi KAZ N20 eTalk MyFlix", "Tank Utility AS0034", "Tattletale Consumer Unit M1", "Tattletale Portable Alarm Systems Consumer Unit V2", "Tattletale Portable Alarm Systems Tattletale Commercial Unit V3", "TC26AK 2 DAC code update", "TCL 4056S Flip Pro", "TCL 4056SPP Flip Pro", "TCL 4056V Voice Text", "TCL 4188S 30 LE", "TCL 5004S A1 PrePay", "TCL 9048S Easy Tab 8", "TCL 9049L Family Edition", "TCL 9050S Disney Tab", "TCL 9138S Luna Tab 8", "TCL 9150S Disney Tab", "TCL 9198S 5G Tablet UW", "TCL 9891S Tab Pro 5G", "TCL MW513U 5G UW", "TCL T609SPP Encore 5G", "TCL T781S 5G UW", "TCL T781SPP 5G UW", "TCL T790S T1 5G Smartphone", "TCL T790SPP T10 5G", "TCL T791S 5G UW", "TCT Mobile 5046S", "TCT Mobile 5049S", "TCT Mobile 51020 TCL A30", "TCT Mobile 6060S", "TCT Mobile BBB100 3", "TCT Mobile BBE100 5", "TCT Mobile BBE100 5 BDFILL", "TCT Mobile T434D", "TCT Mobile T510D", "TCT Mobile T510SP Scarab Pro", "TCT Mobile T602DL TCL 30 Z", "TCT Mobile T603DL TCL 30 T", "TCT Mobile T606HPDL", "TCT Mobile T607DL ION V", "TCT Mobile T608DL TCL 40 T", "TCT Mobile T608DL TCL 40T", "TCT Mobile T614D", "TCT Mobile T770B TCL 10L", "TCT Mobile T773O", "TCT Mobile T782P TCL Model G", "TCT Mobile T799B TCL 10 Pro", "TCT Mobile TCL T614SP", "TCT TCL 9199S 5G 10 Tablet", "TCT TCL T435S Go Flip 7", "TCT TCL T435SP Go Flip 7", "TCT TCL T435V Go Flip 7", "Technicolor Picasso VZ SmartHub", "TEKTELIC Communications Kona IoT Gateway", "TEKTELIC Communications Kona Micro IoT Gateway", "Telcare BGM 4", "Telcare Telcare BGM 2", "Teldat H1 Automotive", "Telesense TS000000", "TELIPIRE Casio C771CT", "TELIPSIRE LG VS415CT", "TELIPSIRE LG VS450CT", "TELIPSIRE LG VX9100CT", "TELISPIRE Casio C771SF", "TELISPIRE LG VN250CT", "TELISPIRE LG VN251CT", "TELISPIRE LG VN270CT", "TELISPIRE LG VS415SF", "TELISPIRE LG VS450SF", "TELISPIRE LG VX8300CT", "TELISPIRE LG VX8500CT", "TELISPIRE LG VX9400CT", "TELISPIRE LG VX9700CT", "TELISPIRE LG VX9900CT", "TELISPIRE Samsung SCH i500CT", "TELISPIRE Samsung SCH U350CT", "TELISPIRE Samsung SCH U360CT", "TELISPIRE Samsung SCH U365CT", "TELISPIRE Samsung SCH U450CT", "TELISPIRE Samsung SCH U485CT", "TELISPIRE Samsung SCH U485SF", "TELISPIRE Samsung SM B311VCT", "TELISPIRE Samsung SM B311VGG", "Telit Cinterion PLS63 W", "Telit Cinterion PLS63 X", "Telit Cinterion PLS63 X2", "Telit Cinterion PLS63 X4", "Telit Cinterion PLS83 W", "Telit Cinterion PLS83 X", "Telit Cinterion PLS83 X B", "Telit Cinterion PLS83 X eSIM", "Telit Cinterion PLS83 X2", "Telit Cinterion PLS83 X4", "Telit Cinterion USA MV31 W", "Telit Cinterion USA TX62 W", "Telit Cinterion USA TX62 W B", "Telit Cinterion USA TX62 W eSIM", "Telit Cinterion USA TX82 W", "Telit Cinterion USA X82 W eSIM", "Telit IoT Solutions CMB100A0 WW", "Telit IoT Solutions CMB100C0 WW", "Telit IoT Solutions FN980 HW 2 10", "Telit IoT Solutions FN980m", "Telit IoT Solutions FN990A28", "Telit IoT Solutions FN990A40", "Telit IoT Solutions FN990A40 HW 1 10", "Telit IoT Solutions LE910C1 NF", "Telit IoT Solutions LE910C1 NFX", "Telit IoT Solutions LE910C1 SV", "Telit IoT Solutions LE910C1 WWX", "Telit IoT Solutions LE910C1 WWX HW 1 20", "Telit IoT Solutions LE910C1 WWXD HW 1 20", "Telit IoT Solutions LE910C4 NF", "Telit IoT Solutions LE910C4 NF HW 1 30", "Telit IoT Solutions LE910C4 NFX", "Telit IoT Solutions LE910C4 NFXD", "Telit IoT Solutions LE910C4 SNX", "Telit IoT Solutions LE910C4 SNXD", "Telit IoT Solutions LE910C4 WWX", "Telit IoT Solutions LE910C4 WWX HW 1 20", "Telit IoT Solutions LE910C4 WWXD HW 1 20", "Telit IoT Solutions LN920A13 WW", "Telit IoT Solutions LN920A6 NA", "Telit IoT Solutions ME310M1 W1", "Telit IoT Solutions SE250B4 NA", "Telit Wireless Solutions CE910 DUAL", "Telit Wireless Solutions DE910 DUAL", "Telit Wireless Solutions FN980", "Telit Wireless Solutions FN980 HW 2 10", "Telit Wireless Solutions FN980m", "Telit Wireless Solutions FN980m HW 2 10", "Telit Wireless Solutions HS3001", "Telit Wireless Solutions LE866 SV1", "Telit Wireless Solutions LE910 NA V2", "Telit Wireless Solutions LE910 NA1", "Telit Wireless Solutions LE910 SV V2", "Telit Wireless Solutions LE910 SV V2 HW 1 1", "Telit Wireless Solutions LE910 SV1", "Telit Wireless Solutions LE910 SV1 HW 1 1", "Telit Wireless Solutions LE910 SVG", "Telit Wireless Solutions LE910 SVL", "Telit Wireless Solutions LE910B1 NA", "Telit Wireless Solutions LE910C1 NF", "Telit Wireless Solutions LE910C1 NF HW 1 30", "Telit Wireless Solutions LE910C1 NFD", "Telit Wireless Solutions LE910C1 NFX", "Telit Wireless Solutions LE910C1 SV", "Telit Wireless Solutions LE910C1 SVX", "Telit Wireless Solutions LE910C1 WWX", "Telit Wireless Solutions LE910C1 WWXD", "Telit Wireless Solutions LE910C4 NF", "Telit Wireless Solutions LE910C4 NF HW 1 30", "Telit Wireless Solutions LE910C4 NF HW 1 30 SW x10", "Telit Wireless Solutions LE910C4 NFD", "Telit Wireless Solutions LE910C4 WWX", "Telit Wireless Solutions LE910C4 WWXD", "Telit Wireless Solutions LM940", "Telit Wireless Solutions LM960", "Telit Wireless Solutions LM960A18", "Telit Wireless Solutions LN920A12 WW", "Telit Wireless Solutions LN920A6 WW", "Telit Wireless Solutions LN940A9", "Telit Wireless Solutions LN960A16", "Telit Wireless Solutions ME1910C1 WW", "Telit Wireless Solutions ME310G1 W1", "Telit Wireless Solutions ME310G1 WW", "Telit Wireless Solutions ME310G1 WWV", "Telit Wireless Solutions ME866A1 NV", "Telit Wireless Solutions ME910C1 NA", "Telit Wireless Solutions ME910C1 NV", "Telit Wireless Solutions ME910C1 P1", "Telit Wireless Solutions ME910C1 WW", "Telit Wireless Solutions ME910G1 W1", "Telit Wireless Solutions ME910G1 W3", "Telit Wireless Solutions ME910G1 WW", "Telit Wireless Solutions ME910G1 WWV", "Telit Wireless Solutions ML865C1 NA", "Telit Wireless Solutions NE310L2 W1", "Telit Wireless Solutions NE310L2 WW", "Telit Wireless Solutions Telit 5G HP IoT Eval Kit", "Telit Wireless Solutions Telit 5G LP IoT Eval Kit", "Telit Wireless Solutions Telit 5G Sub 6 IoT Eval Kit", "Telit Wireless Solutions Telit Bravo IoT Evaluation Kit", "Telit Wireless Solutions Telit Charlie IoT Eval Kit", "Telli Health Teliihealh 4G BP Device", "Telog Instruments MW2 M", "Telog Instruments WM2 L", "Telog Instruments WM2 MWW", "Teltonika Networks RUT240", "Teltonika Networks RUT240G", "Teltonika Networks RUT955AF", "Teltonika Networks RUTM50", "Teltonika UAB RUT950", "Teltonika UAB RUT955", "Teltonika UAB RUTX11", "Telular Corp TankLink Series 90", "Telular Corp TG 7FP V", "Telular Corp TG1VX003", "Telular Corp TG4V0004", "Telular Corp TG7V0004", "Telular Corp TG7VA004", "Telular Corp TG7VFS04", "Telular Corp TG7VSF04", "Telular Corp TGKITV04", "Telular Crop TG1VX003", "Telular SMARTank ST90", "Telular SmarTank ST9x LTE", "Telular TG 7FE V", "Telular TG1LX001", "Telular TG1LX002", "Telular TG4LV001", "Telular TG4LV002", "Telular TG7LV001", "Telular TG7LV002", "Telular TG7LVA01", "Telular TG7LVA02", "Telular TG7LVF01", "Telular TG7LVF02", "Telular TGKITLV1", "Telular TGKITLV2", "Temperature lert Commercial BZ Gateway", "Temperature lert ZPoint LTE", "Tempered Networks Airwall 110g", "Tempered Networks HIPswitch 100g", "Teradek Node", "Teradek Node V2", "Terso TS080", "Thales DIS AIS USA ALAS5 AM", "Thales DIS AIS USA ALAS66A US", "Thales DIS AIS USA Cinterion ELS31 V", "Thales DIS AIS USA Cinterion ELS31 VA", "Thales DIS AIS USA Cinterion ELS51 V", "Thales DIS AIS USA Cinterion MLP31 W", "Thales DIS AIS USA EXS62 W", "Thales DIS AIS USA EXS82 W", "Thales DIS AIS USA MV31 W", "Thales DIS AIS USA PLPS9 X", "Thales DIS AIS USA PLS63 W", "Thales DIS AIS USA PLS63 X", "Thales DIS AIS USA PLS63 X2", "Thales DIS AIS USA PLS63 X4", "Thales DIS AIS USA PLS83 W", "Thales DIS AIS USA PLS83 X", "Thales DIS AIS USA PLS83 X B", "Thales DIS AIS USA PLS83 X2", "Thales DIS AIS USA PLS83 X4", "Thales DIS AIS USA TX62 W", "Thales DIS AIS USA TX62 W B", "Thales DIS AIS USA TX82 W", "The Climate Corporation FieldView Drive 2", "The Light Phone TLP201", "The Marine Guardian Softwareboard", "TheHeilCo 3RD EYE CAM", "Tigo Energy Cloud Connect", "Tollgrade Communications Lighthouse LTE MV Sensor", "Tollgrade Lighthouse MV Sensor", "Topcon Positioning Systems AM53", "Topcon Positioning Systems CL20", "Topcon Positioning Systems GR 5", "Topcon Positioning Systems MC i4", "Topcon Positioning Systems OPCL10", "Topcon Positioning Systems OPCL55LTEF01", "Topcon Positioning Systems SL 100", "Tosibox Lock 500iC", "Tosibox TBL670US", "Tosibox TBL675US", "TowerView Health HoriZen v2 5", "Tracer Technology Systems Shot Tracer Verizon LTE", "TRACFONE Alcatel A394C", "TRACFONE Alcatel A405DL", "TRACFONE Alcatel A406DL MyFlip 2", "TRACFONE Alcatel A501DL", "TRACFONE Alcatel A502DL", "TRACFONE Alcatel A503DL", "TRACFONE Alcatel A507DL", "TRACFONE Alcatel A508DL", "TRACFONE Alcatel A509DL A3 X", "TRACFONE Alcatel A520L", "TRACFONE Alcatel A571VL", "TRACFONE Alcatel A573VC", "TRACFONE Alcatel A577V", "TRACFONE Alcatel A577VL", "TRACFONE Alcatel A600DL TCL A3X", "TRACFONE Alcatel A846L", "TRACFONE Arcadyan FWA55V5L Titan TF", "TRACFONE BLU Products B100DL View 1", "TRACFONE BLU Products B130DL View 2", "TRACFONE BLU Products B131DL BLU View 1", "TRACFONE BLU Products B135DL BLU View 2", "TRACFONE BLU Products B140DL View 3", "TRACFONE BLU Products B1550VL BLU View 1 5G", "TRACFONE BLU Products B160V", "TRACFONE BLU Products B170D View 2", "TRACFONE BLU Products B200VL View Flex", "TRACFONE BLU Products B300V", "TRACFONE BLU Products BLU B110DL", "TRACFONE Casio C771CT", "TRACFONE Casio C771SF", "TRACFONE Franklin Wireless F900HSVL", "TRACFONE HMD Global N139DL", "TRACFONE HMD Global N152DL Nokia C100", "TRACFONE HMD Global N155DL", "TRACFONE HMD Global N156DL", "TRACFONE HMD Global N159V", "TRACFONE HMD Global Oy N1374DL", "TRACFONE HMD Global Oy N150DL TA 1500 Dua Lipa", "TRACFONE HMD Global Oy N151DL Drake", "TRACFONE HMD Global Oy N1530DL G400 5G", "TRACFONE Huawei H710VL", "TRACFONE KonnectONE K2000VL", "TRACFONE KonnectONE K500HPEL", "TRACFONE LG GPLG158VL", "TRACFONE LG GPLG505CB", "TRACFONE LG GPLGL125DCGB", "TRACFONE LG GPLGL164VL", "TRACFONE LG GPLGL322DCGB LG Journey", "TRACFONE LG GPLGL355DCGB", "TRACFONE LG GPLGL423DCGB", "TRACFONE LG GPLGL44VL", "TRACFONE LG GPLGL455DCGB", "TRACFONE LG GPLGL52VL", "TRACFONE LG GPLGL555DCGB", "TRACFONE LG GPLGL58VL", "TRACFONE LG GPLGL62VL", "TRACFONE LG GPLGL64VL", "TRACFONE LG GPLGL722DCGB", "TRACFONE LG GPLGL84VL", "TRACFONE LG GPLML212VCB", "TRACFONE LG GPLML413DCGB", "TRACFONE LG GPLML414DCGB", "TRACFONE LG GPLML713DCGB", "TRACFONE LG LG RS988WS", "TRACFONE LG LGGPLGL56VL", "TRACFONE LG VN250CT", "TRACFONE LG VN251CT", "TRACFONE LG VN270CT", "TRACFONE LG VS415CT", "TRACFONE LG VS415SF", "TRACFONE LG VS450CT", "TRACFONE LG VS450SF", "TRACFONE LG VX8300CT", "TRACFONE LG VX8500CT", "TRACFONE LG VX9100CT", "TRACFONE LG VX9400CT", "TRACFONE LG VX9900CT", "TRACFONE LG VZ9700CT", "TRACFONE LG WVX8800", "TRACFONE LG WVX9100", "TRACFONE Motorola Mobility XT1920 DL WS", "TRACFONE Motorola Mobility XT1952DL", "TRACFONE Motorola Mobility XT1955 5 WS", "TRACFONE Motorola Mobility XT1955DL", "TRACFONE Motorola Mobility XT2005DL", "TRACFONE Motorola Mobility XT2041DL G8 Optimo Maxx", "TRACFONE Motorola Mobility XT2052DL", "TRACFONE Motorola Mobility XT2093DL Moto G Play", "TRACFONE Motorola Mobility XT2115DL", "TRACFONE Motorola Mobility XT2131DL Moto G Stylus", "TRACFONE Motorola Mobility XT2163DL Moto G Pure", "TRACFONE Motorola Mobility XT2165DL Moto G Pure", "TRACFONE Motorola Mobility XT2211DL Moto g Stylus", "TRACFONE Motorola Mobility XT2213DL Moto G 5G", "TRACFONE Motorola Mobility XT2215DL Moto G Stylus 5G 3rd Gen", "TRACFONE Motorola Mobility XT2271DL Moto E", "TRACFONE Motorola Mobility XT2311DL Moto G Power 5G", "TRACFONE Motorola Mobility XT2317DL", "TRACFONE Motorola Mobility XT2413V Moto G Play", "TRACFONE Motorola Mobility XT2415V Moto G Power", "TRACFONE Motorola Mobility XT2417D", "TRACFONE Motorola W755", "TRACFONE Motorola XT1925DL WS", "TRACFONE Reliance Communications Orbic Magic WS 5G", "TRACFONE Samsung G930VL", "TRACFONE Samsung S727VL", "TRACFONE Samsung SCH 1535XE", "TRACFONE Samsung SCH i500CT", "TRACFONE Samsung SCH R451C", "TRACFONE Samsung SCH S380C", "TRACFONE Samsung SCH U350CT", "TRACFONE Samsung SCH U360CT", "TRACFONE Samsung SCH U365CT", "TRACFONE Samsung SCH U450CT", "TRACFONE Samsung SCH U485CT", "TRACFONE Samsung SCH U485SF", "TRACFONE Samsung SM B311VCT", "TRACFONE Samsung SM B311VGG", "TRACFONE Samsung SM G930V Galaxy S 7", "TRACFONE Samsung SM G930VL", "TRACFONE Samsung SM G950U W", "TRACFONE Samsung SM G955U W", "TRACFONE Samsung SM S102DL", "TRACFONE Samsung SM S111DL Galaxy A01", "TRACFONE Samsung SM S115DL", "TRACFONE Samsung SM S120VL", "TRACFONE Samsung SM S124DL Galaxy A02s", "TRACFONE Samsung SM S127DL Galaxy A12", "TRACFONE Samsung SM S135DL Galaxy A03s", "TRACFONE Samsung SM S136DL Galaxy A13 5G", "TRACFONE Samsung SM S146VL Galaxy A14 5G", "TRACFONE Samsung SM S156V Galaxy A15 5G", "TRACFONE Samsung SM S205DL", "TRACFONE Samsung SM S215DL Galaxy A21", "TRACFONE Samsung SM S236DL Galaxy J2", "TRACFONE Samsung SM S237VL Galaxy J3 Luna Pro 5G", "TRACFONE Samsung SM S256VL Galaxy A25 5G", "TRACFONE Samsung SM S260DL", "TRACFONE Samsung SM S320VL", "TRACFONE Samsung SM S326DL Galaxy A32 5G", "TRACFONE Samsung SM S327VL", "TRACFONE Samsung SM S356V Galaxy A02s 5G", "TRACFONE Samsung SM S367VL", "TRACFONE Samsung SM S426DL Galaxy A42 5G", "TRACFONE Samsung SM S506DL", "TRACFONE Samsung SM S515DL Galaxy A51", "TRACFONE Samsung SM S536DL Galaxy A53 5G", "TRACFONE Samsung SM S546VL Galaxy A54 5G", "TRACFONE Samsung SM S767VL", "TRACFONE Samsung SM S820L", "TRACFONE Samsung SM S903VL", "TRACFONE Samsung SM S906L", "TRACFONE Samsung SM S907VL", "TRACFONE Samsung SM S920L", "TRACFONE Samsung SM S978L", "TRACFONE TCT Mobile A503DL", "TRACFONE TCT Mobile A509DL A3 X", "TRACFONE TCT Mobile T408DL TCL Flip 2", "TRACFONE TCT Mobile T434D", "TRACFONE TCT Mobile T435D TCL Flip 3", "TRACFONE TCT Mobile T601DL TCL A2", "TRACFONE TCT Mobile T602DL TCL 30 Z", "TRACFONE TCT Mobile T603DL TCL 30 T", "TRACFONE TCT Mobile T607DL", "TRACFONE TCT Mobile T608DL TCL 40T", "TRACFONE TCT Mobile T609DL", "TRACFONE TCT Mobile T614D", "TRACFONE TCT Mobile T701DL TCL 30 XL", "TRACFONE ZTE Z233VL", "TRACFONE ZTE Z291DL", "TRACFONE ZTE Z353VL", "TRACFONE ZTE Z558VL", "TRACFONE ZTE Z559DL", "TRACFONE ZTE Z559DL RW Blade T2", "TRACFONE ZTE Z610DL", "TRACFONE ZTE Z717VL", "TRACFONE ZTE Z719DL", "TRACFONE ZTE Z723EL", "TRACFONE ZTE Z799VL Majesty Pro", "TRACFONE ZTE Z837VL", "TRACFONE ZTE Z862VL", "TRACFONE ZTE Z899VL", "TRACFONE ZTE Z917VL", "TRACFONE ZTE Z963VL", "TRACFONE ZTE Z986DL", "Track Group OTD 4 1", "Transcend IOT TIoT Jackal", "TransData MarkV H", "Transparent Technologies innov8 LTE Gateway", "Transparent Technologies innov8 VNLTE", "Transparent Technologies innov8 VNLTEM1", "Trapeze Software Group Ranger 2", "Trapeze Software Group Ranger 4 4 R44 V100 wo WIFI BT", "Trapeze Software Group Ranger 4 4 R44 V117 w WIFI BT", "Trapeze Software Group Smart Color Touch MDT MC7354", "Trapeze Software Group Smart Color Touch MDT MC7534", "Trimble 121600 Yuma 7", "Trimble Mobile Computing Solutions 121800", "Trimble Mobile Computing Solutions 121900", "Trimble Mobile Computing Solutions Geo 7X", "Trimble Mobile Computing Solutions Kenai", "Trimble Mobile Computing Solutions Nomad 5", "Trimble Mobile Computing Solutions TSC 7", "Trimble Mobile Resource Management SNM941", "Trimble Mobile Resource Management TVG 660 CDMA PVS8", "TRUCONNECT HMD Global N159V", "TRUCONNECT TruConnect Communications Stratus C8", "TRUCONNECT TruConnect Stratus C7", "TVU Networks TM1000", "TVU Networks TM1000 1", "Tyco Integrated Security LT7090", "Tyco Integrated Security LT9080", "U blox LARA R204", "U Blox LISA C200", "U blox LISA C200", "u Blox MPCI L100", "u blox MPCI L100", "u blox MPCI L201", "u Blox SARA R404M", "u blox SARA R410M 02B", "u Blox Toby L100", "u blox Toby L100", "U Blox TOBY L201", "UAB Ruptela Trace5", "Ublox LEXI R10401D", "ublox LEXI R520", "ublox SARA R410M 52B", "Ublox SARA R422M10S", "Ublox SARA R422S", "Ublox SARA R500S", "Ublox SARA R500Sv1", "Ublox SARA R510M8S", "Ublox SARA R510M8Sv1", "Ublox SARA R510S", "Ublox SARA R510Sv1", "ublox UBX R5", "UnaliWear Kanega LTE", "Uni America dba Certified Devices G1401", "UNIMAX Communications BGM2 0", "Unitech Electronics PA700 NAV2SG1", "Unitech Electronics PA730V", "Untangle e6wl", "USA Clean ARMOR", "USA Clean ARMOR Gen 2", "USA Technologies ePort Telemeter LTE", "USGlobalSat TR300V", "Utility Rocket IoT Model X", "Utility RocketIoT XLE", "Vaica SimpleMed Plus", "Vantron Technology VT M2M LV", "Vantron Technology VT MOB CELL MPCIE", "Vaughn Thermal VaughnCell Q", "Vaughn Thermal VaughnCell uBlox", "Veea DB926 V", "Vendors Exchange International VE1018994", "VendScreen ePort Interactive LTE", "Ventus V Series Router 3FF", "Ventus Wireless LC100", "Ventus Wireless VRB842", "Ventus Wireless VXI300W", "Verizon QTAIR7 Ellipsis 10", "Verizon QTAQZ3KID Ellipsis Kids", "Verizon Smart Communities LCO 277C4N", "Verizon Smart Communities LCO 277C4N DALI", "Verizon Smart Communities LCO 480C4N", "Verizon Smart Communities LCO 480C4N DALI", "Verizon Telematics Inc AT 800", "Verizon Telematics Meridian Prime", "Verizon Telematics Meridian Zenith", "Versa Networks CSG350 2LA", "Versa Networks CSG355 WLA", "Versa Networks CSG355 WLA 4GP", "Versa Networks CSG365 WLA", "Versa Networks CSG365 WLA 4GP", "Versa Networks CSG750 2LA", "Versa Networks CSG750 WLA 4GP", "Versa Networks CSG770 WLA", "Versa Networks CSG770 WLA 4GP", "VGW Casio C771SF", "VGW LG VN250CT", "VGW LG VN251CT", "VGW LG VN270CT", "VGW LG VS415SF", "VGW LG VS450SF", "VGW LG VX8300CT", "VGW LG VX8500CT", "VGW LG VX9100CT", "VGW LG VX9700CT", "VGW LG VX9900CT", "VGW Motorola Milestone 3", "VGW Novatel Wireless T2050", "VGW Samsung SCH i500CT", "VGW Samsung SCH U360CT", "VGW Samsung SCH U365CT", "VGW Samsung SCH U450CT", "VGW Samsung SCH U485CT", "VGW Samsung SCH U485SF", "VGW Samsung SCH U640WB", "VGW Samsung SM B311VCT", "VIA Technologies Mobile360 D700", "Victor Stanley VSRELAY1 LTEM1", "Viptela vEdge 100m", "Viptela vEdge 100wm", "Visible Google Pixel 3", "Visible Google Pixel 3 XL", "Visible LG Stylo 5", "Visible Motorola Z4", "VISIBLE OnePlus Technology IN2015", "Visible SM G960U1 VS Galaxy S9", "Visible SM G965U1 VS Galaxy S9 Plus", "Visible ZTE R2 Z5151VS", "Vision Metering Vision CatM1 410 Radio", "Vision Metering Vision Evolution Meter", "VivaQuant RX 2", "Vivint CC03", "Vivint CC05", "VMware Edge 510 LTE", "VMware Edge 610 LTE", "Vodafone SC415C6", "Vodafone US Landis E660", "Vodafone US LINK DARK V", "Vodafone US SC415C6 v2", "Vodafone US VF Samsara VG54 NA", "Vodafone VF Samsara IG41 NA", "Volansys Technologies CENTAURI 200 CAT M1", "Volansys Technologies CENTAURI 200 CAT1", "Vosker V150", "VZW LG VX9400CT", "WAAV AirBox XA", "Wabtec GoLINC EP", "WAFS Casio C771CT", "WAFS LG VS415CT", "WAFS LG VS450CT", "WAFS Samsung SM B311VGG", "WaterSignal Gen 8S", "WaterSignal Gen 8V", "WaterSignal WaterSignal Generation 7", "Waymo AR7592 1", "Wear24 Quanta MARS QTAXU1", "WellAware Holdings WIRC Model E Cat1", "WellAware Holdings WIRC Model E CatM", "WellAware Holdings WIRC Model S Cat1", "WellAware Holdings WIRC Model S CatM", "Welotec GmbH TK842L US", "Westell EL 400", "Westell REMOTE RMC 747", "Westell REMOTE RMM 1447", "Westermo GW1152 QFL", "Westermo Network Technologies Merlin 4609 F2G T4 S2 DI6 DO2", "Whelen Engineering Company CCONM", "WheribleGPS Wheritrack", "WHOLESALE Alcatel 4053S", "WHOLESALE ALcatel 5046S W", "WHOLESALE Alcatel 5049S GC", "WHOLESALE Alcatel 5049S W", "WHOLESALE Alcatel A406DL MyFlip 2", "WHOLESALE Alcatel A501DL", "WHOLESALE Alcatel A502DL", "WHOLESALE Alcatel A503DL", "WHOLESALE Alcatel A507DL", "WHOLESALE Alcatel A508DL TCL A2X", "WHOLESALE Alcatel A577VL", "WHOLESALE Alcatel A600DL TCL A3X", "WHOLESALE BLU Products B100DL View 1", "WHOLESALE BLU Products B131DL BLU View 1", "WHOLESALE BLU Products B135DL BLU View 2", "WHOLESALE BLU Products B140DL View 3", "WHOLESALE BLU Products B160V", "WHOLESALE CT Cellutions S G955CT", "WHOLESALE CT Cellutions SM G935CT", "WHOLESALE CT Cellutions SM G950CT", "WHOLESALE CT Cellutions VS425CT", "WHOLESALE CT Cellutions VS500CT", "WHOLESALE CT Cellutions Z233CT", "WHOLESALE Digi International IX20 WAN4 Wholesale", "WHOLESALE FIH Limited GW23", "WHOLESALE Franklin Wireless MHS900LWS", "WHOLESALE Google G020I Pixel 4", "WHOLESALE Google G020J Pixel 4 XL", "WHOLESALE Google G025E Pixel 4A 5G", "WHOLESALE Google G8V0U W Pixel 6 Pro 5G", "WHOLESALE Google GB7N6 W Pixel 6 5G", "WHOLESALE Google GE2AE W Pixel 7 Pro 5G", "WHOLESALE Google GVU6C W Pixel 7 5G", "WHOLESALE Google GWKK3 W Pixel 7a 5G", "WHOLESALE Google GX7AS W Pixel 6a", "WHOLESALE HMD Global N152DL Nokia C100", "WHOLESALE HMD Global N156DL", "WHOLESALE HMD Global Oy N1374DL", "WHOLESALE HMD Global Oy N150DL TA 1500 Dua Lipa", "WHOLESALE HMD Global Oy N151DL Drake", "WHOLESALE Hot Pepper Ghost W", "WHOLESALE Hot Pepper Jalapeno", "WHOLESALE HTH Communications VS415PPHTH", "WHOLESALE Huawei H710VL", "WHOLESALE KonnectONE K500HPEL Moxee Talk", "WHOLESALE KonnectONE K779HSDL", "WHOLESALE KonnectONE K779HSDL Moxee Hotspot W", "WHOLESALE KonnectONE K873HSVL Generic Wholesale", "WHOLESALE LG GPLGL423DCGB", "WHOLESALE LG GPLGL455DCGB", "WHOLESALE LG GPLGL555DCGB", "WHOLESALE LG GPLMK500QM5", "WHOLESALE LG GPLMK500QM6", "WHOLESALE LG GPLML212VCB", "WHOLESALE LG GPLML414DCGB", "WHOLESALE LG GPLMQ620QM6", "WHOLESALE LG GPLMQ720QM5", "WHOLESALE LG GPLMQ720QM6", "WHOLESALE LG GPLMQ730QM5", "WHOLESALE LG GPLMQ730QM6", "WHOLESALE LG GPLMX410ULML Spectrum", "WHOLESALE LG GPLMX410UM", "WHOLESALE LG VS450CT", "WHOLESALE Motorola Mobility Motorola Mobility XT2052DL Moto e", "WHOLESALE Motorola Mobility XT1775 Moto E Plus 32GB", "WHOLESALE Motorola Mobility XT1806", "WHOLESALE Motorola Mobility XT1920 DL WS", "WHOLESALE Motorola Mobility XT1925DL WS", "WHOLESALE Motorola Mobility XT1955DL", "WHOLESALE Motorola Mobility XT2005DL Moto e6", "WHOLESALE Motorola Mobility XT2041 4 WS G8 Power", "WHOLESALE Motorola Mobility XT2041DL G8 Optimo Maxx", "WHOLESALE Motorola Mobility XT2052 1 WHS Moto E", "WHOLESALE Motorola Mobility XT2052 1 WS Moto E LE Unlocked", "WHOLESALE Motorola Mobility XT2093 4 WS Moto G Play 5G", "WHOLESALE Motorola Mobility XT2093DL Moto G Play", "WHOLESALE Motorola Mobility XT2113 2 WS Moto G 5G", "WHOLESALE Motorola Mobility XT2115DL", "WHOLESALE Motorola Mobility XT2117 4 WS Moto G Power 5G", "WHOLESALE Motorola Mobility XT2131 1 WS Moto G Stylus 5G", "WHOLESALE Motorola Mobility XT2131DL Moto G Stylus", "WHOLESALE Motorola Mobility XT2163 4 WHS Moto G Pure", "WHOLESALE Motorola Mobility XT2163 4 WS Moto G Pure", "WHOLESALE Motorola Mobility XT2163DL Moto G Pure", "WHOLESALE Motorola Mobility XT2165 5 WS Moto G Pure", "WHOLESALE Motorola Mobility XT2165DL Moto G Pure", "WHOLESALE Motorola Mobility XT2211DL Moto g Stylus", "WHOLESALE Motorola Mobility XT2213 3 Moto G 5G", "WHOLESALE Motorola Mobility XT2213 3 WS Moto G 5G", "WHOLESALE Motorola Mobility XT2213DL Moto G 5G", "WHOLESALE Motorola Mobility XT2215 4 WS Motorola G Stylus 5G", "WHOLESALE Motorola Mobility XT2215DL Moto G Stylus 5G 3rd Gen", "WHOLESALE Motorola Mobility XT2271DL Moto E", "WHOLESALE Motorola Mobility XT2311DL Moto G Power 5G", "WHOLESALE Motorola Mobility XT2315 1 WS Moto G Stylus 5G", "WHOLESALE Motorola Mobility XT2317DL", "WHOLESALE Motorola Mobility XT2413 2 WS Moto G Play", "WHOLESALE Motorola Mobility XT2413V Moto G Play", "WHOLESALE Motorola Mobility XT2419 1WS Moto G Stylus 5G 2024", "WHOLESALE Motorola Mobility XT2419V", "WHOLESALE Motorola XT2215 1 WHS Moto G Stylus 5G", "WHOLESALE Noetic NUUA6L G", "WHOLESALE NUU Mobile NUU S5502L A11L", "WHOLESALE NUU Mobile S280L", "WHOLESALE Reliance Communications Orbic Fun 4G LTE Smartphone", "WHOLESALE Reliance Communications Orbic Magic WS 5G", "WHOLESALE Reliance Communications Orbic Smart Wrist", "WHOLESALE Reliance Communications Orbic Speed W", "WHOLESALE Reliance Communications Orbic Wand WS 5G", "WHOLESALE Reliance Communications RC2200L CHTR", "WHOLESALE Reliance Communications RC2200L DL", "WHOLESALE Reliance Communications RC2200L W", "WHOLESALE Reliance Communications RC545L W Orbic", "WHOLESALE Reliance Communications RC555L WS Orbic Wonder", "WHOLESALE Reliance Communications RC609LSM Orbic Fun", "WHOLESALE Samsung Electronics America SM G970U1 OD VS", "WHOLESALE Samsung Electronics America SM T577U DS OD Galaxy Tab Active 3", "WHOLESALE Samsung S156V Galaxy A15 5G A15X", "WHOLESALE Samsung SG973U1 W Galaxy s10 128GB", "WHOLESALE Samsung SM 907VL", "WHOLESALE Samsung SM 950U1 W", "WHOLESALE Samsung SM A015U W Galaxy A01", "WHOLESALE Samsung SM A025U1 W Galaxy A02s Unlocked", "WHOLESALE Samsung SM A025V W Galaxy A02s 5G", "WHOLESALE Samsung SM A037U1 W Galaxy A03s", "WHOLESALE Samsung SM A102U W Galaxy A10e", "WHOLESALE Samsung SM A102U1 W", "WHOLESALE Samsung SM A115U W Galaxy A11", "WHOLESALE Samsung SM A115U1 W Galaxy A11", "WHOLESALE Samsung SM A125U1 W Galaxy A12 5G", "WHOLESALE Samsung SM A135U1 DS W Galaxy A13", "WHOLESALE Samsung SM A136U1 W Galaxy A13 5G", "WHOLESALE Samsung SM A146U1 W Galaxy A14 5G Unlocked", "WHOLESALE Samsung SM A156U1 W Galaxy A15 5G", "WHOLESALE Samsung SM A166U1 W Galaxy A16 5G", "WHOLESALE Samsung SM A205U W", "WHOLESALE Samsung SM A215U1 W Galaxy A21", "WHOLESALE Samsung SM A236U1 DS W Galaxy A23 5G Dual SIM", "WHOLESALE Samsung SM A256U1 W Galaxy A25 5G", "WHOLESALE Samsung SM A326U1 W Galaxy A32 5G", "WHOLESALE Samsung SM A356U1 W Galaxy A53 5G", "WHOLESALE Samsung SM A426U1 W Galaxy A42 5G", "WHOLESALE Samsung SM A505U1 W Galaxy A50", "WHOLESALE Samsung SM A515U1 W Galaxy A51", "WHOLESALE Samsung SM A516U1 W A51", "WHOLESALE Samsung SM A526U1 W Galaxy A52 5G", "WHOLESALE Samsung SM A536U1 DS W Galaxy A53 5G", "WHOLESALE Samsung SM A546U1 W Galaxy A54 5G", "WHOLESALE Samsung SM A705U W A70", "WHOLESALE Samsung SM A716U1 W Galaxy A71 5G", "WHOLESALE Samsung SM F700U1 W Galaxy Flip", "WHOLESALE Samsung SM F707U1 W Galaxy Z Flip 5G", "WHOLESALE Samsung SM F711U1 W Galaxy Z Flip 3", "WHOLESALE Samsung SM F721U1 W Galaxy Z Flip 4 512GB", "WHOLESALE Samsung SM F731U1 Wc Galaxy Z Flip 5 5G", "WHOLESALE Samsung SM F741U1 W Galaxy Z Fold 6 5G", "WHOLESALE Samsung SM F900U1 W", "WHOLESALE Samsung SM F916U1 W Galaxy Fold 2 Unlocked", "WHOLESALE Samsung SM F926U1 W Galaxy Z Fold 3", "WHOLESALE Samsung SM F936U1 W Galaxy Z Fold 4", "WHOLESALE Samsung SM F936U1 WS c Galaxy Z Fold4 5G", "WHOLESALE Samsung SM F946U W Galaxy Z Fold 5 5G", "WHOLESALE Samsung SM F946U1 WC Galaxy Z Fold5 5G 512GB", "WHOLESALE Samsung SM F956U1 W Galaxy Z Fold 6 5G", "WHOLESALE Samsung SM G715U1 W Galaxy Xcover Pro", "WHOLESALE Samsung SM G736U1 W Galaxy XCover6 Pro 5G", "WHOLESALE Samsung SM G770U1 W Galaxy S10 Lite", "WHOLESALE Samsung SM G781U1 W Galaxy S20 FE 5G Unlocked", "WHOLESALE Samsung SM G781V W Galaxy S20 FE 5G", "WHOLESALE Samsung SM G930U W Galaxy S7", "WHOLESALE Samsung SM G930VC", "WHOLESALE Samsung SM G930VL", "WHOLESALE Samsung SM G935U W Galaxy S7 Unlocked", "WHOLESALE Samsung SM G935VC", "WHOLESALE Samsung SM G950U W", "WHOLESALE Samsung SM G950U1 W Galaxy S8 Dream Unlocked", "WHOLESALE Samsung SM G955U W", "WHOLESALE Samsung SM G955U1 W Galaxy S8 Plus Dream 2 Unlocked", "WHOLESALE Samsung SM G960U1 W", "WHOLESALE Samsung SM G965U1 W", "WHOLESALE Samsung SM G970U W", "WHOLESALE Samsung SM G970U1 W c", "WHOLESALE Samsung SM G970U1 W Galaxy 10e", "WHOLESALE Samsung SM G973U W", "WHOLESALE Samsung SM G973U1 W c", "WHOLESALE Samsung SM G973U1 W Galaxy s10 128GB", "WHOLESALE Samsung SM G975U W", "WHOLESALE Samsung SM G975U1 W c", "WHOLESALE Samsung SM G975U1 W Galaxy S10 Plus 128GB", "WHOLESALE Samsung SM G981U W Galaxy S20 5G", "WHOLESALE Samsung SM G981U1 W S20 5G", "WHOLESALE Samsung SM G981V W S20 5G", "WHOLESALE Samsung SM G986U W S20 Plus 5G", "WHOLESALE Samsung SM G986U1 W Galaxy S20 Plus 5G", "WHOLESALE Samsung SM G988U W S20 Ultra 5G", "WHOLESALE Samsung SM G988U1 W S20 Ultra 5G", "WHOLESALE Samsung SM G990U W Galaxy S21 FE 5G", "WHOLESALE Samsung SM G990U1 W Galaxy S21 FE 5G", "WHOLESALE Samsung SM G990U2 W Galaxy S21 FE 5G UW", "WHOLESALE Samsung SM G990U3 W Galaxy S21 FE 5G", "WHOLESALE Samsung SM G991U W Galaxy S21 5G", "WHOLESALE Samsung SM G991U1 WS Galaxy S21 5G", "WHOLESALE Samsung SM G996U W Galaxy S21 Plus 5G", "WHOLESALE Samsung SM G996U1 WS Galaxy S21 Plus 5G", "WHOLESALE Samsung SM G996U1 WSD Galaxy S21 Plus 5G", "WHOLESALE Samsung SM G998U W Galaxy S21 Ultra 5G", "WHOLESALE Samsung SM G998U1 WS Galaxy S20 Ultra 5G", "WHOLESALE Samsung SM N950U W", "WHOLESALE Samsung SM N950U1 W", "WHOLESALE Samsung SM N960U W", "WHOLESALE Samsung SM N960U1 W", "WHOLESALE Samsung SM N970U W", "WHOLESALE Samsung SM N970U1 W", "WHOLESALE Samsung SM N975U W", "WHOLESALE Samsung SM N975U1 W", "WHOLESALE Samsung SM N981U W Note 20 5G", "WHOLESALE Samsung SM N981U1 W Note 20 5G", "WHOLESALE Samsung SM N986U W Note 20 Plus 5G", "WHOLESALE Samsung SM N986U1 W Note 20 Ultra", "WHOLESALE Samsung SM R965U W Galaxy Watch 6 Classic", "WHOLESALE Samsung SM S102DL", "WHOLESALE Samsung SM S111DL Galaxy A01", "WHOLESALE Samsung SM S115DL", "WHOLESALE Samsung SM S124DL Galaxy A02s", "WHOLESALE Samsung SM S127DL Galaxy A12", "WHOLESALE Samsung SM S134DL Galaxy A03s", "WHOLESALE Samsung SM S135DL Galaxy A03s", "WHOLESALE Samsung SM S136DL Galaxy A13 5G", "WHOLESALE Samsung SM S146VL Galaxy A14 5G", "WHOLESALE Samsung SM S205DL", "WHOLESALE Samsung SM S215DL Galaxy A21", "WHOLESALE Samsung SM S236DL Galaxy J2", "WHOLESALE Samsung SM S237VL Galaxy J3 Luna Pro 5G", "WHOLESALE Samsung SM S256VL Galaxy A25 5G", "WHOLESALE Samsung SM S260DL", "WHOLESALE Samsung SM S326DL Galaxy A32 5G", "WHOLESALE Samsung SM S367VL", "WHOLESALE Samsung SM S426DL Galaxy A42 5G", "WHOLESALE Samsung SM S506DL", "WHOLESALE Samsung SM S515DL Galaxy A51", "WHOLESALE Samsung SM S536DL Galaxy A53 5G", "WHOLESALE Samsung SM S546VL Galaxy A54 5G", "WHOLESALE Samsung SM S711U W Galaxy S23 FE", "WHOLESALE Samsung SM S711U1 W Galaxy S23 FE 5G", "WHOLESALE Samsung SM S721U1 W Galaxy S24 5G", "WHOLESALE Samsung SM S727VL", "WHOLESALE Samsung SM S767VL Galaxy J7 Crown", "WHOLESALE Samsung SM S901U W Galaxy S22 5G", "WHOLESALE Samsung SM S901U1 W Galaxy S22 5G", "WHOLESALE Samsung SM S906U W Galaxy S22 Plus 5G", "WHOLESALE Samsung SM S906U1 W Galaxy S22 Plus 5G", "WHOLESALE Samsung SM S908U W Galaxy S22 Ultra 5G", "WHOLESALE Samsung SM S911U1 W Galaxy S23 Ultra 5G", "WHOLESALE Samsung SM S916U1 W Galaxy S23 Plus 5G", "WHOLESALE Samsung SM S918U1 W Galaxy S23 Ultra 5G", "WHOLESALE Samsung SM S921U1 W Galaxy S24 5G", "WHOLESALE Samsung SM S926U1 W Galaxy S24 5G", "WHOLESALE Samsung SM S928U1 W Galaxy S24 Ultra 5G", "WHOLESALE Samsung SM T227U W", "WHOLESALE Samsung SM T547U Galaxy Tab Active Pro 10 1", "WHOLESALE Samsung SM T577U DS Galaxy Tab Active 3", "WHOLESALE Samsung SM T727U", "WHOLESALE Samsung SM X518U W Galaxy Tab S9 FE 5G", "WHOLESALE Schok Schok Volt SV67Q W", "WHOLESALE SM F926U1 W TB Galaxy Z Fold 3 1TB 5G", "WHOLESALE SM S908U1 W Galaxy S22 Ultra 5G", "WHOLESALE TCT Mobile 4053S", "WHOLESALE TCT Mobile 4058P", "WHOLESALE TCT Mobile 5007S 1V Plus", "WHOLESALE TCT Mobile 6060S W", "WHOLESALE TCT Mobile A501DL", "WHOLESALE TCT Mobile A503DL", "WHOLESALE TCT Mobile A507DL", "WHOLESALE TCT Mobile A508DL TCL A2X", "WHOLESALE TCT Mobile A509DL A3 X", "WHOLESALE TCT Mobile A600DL TCL A3X", "WHOLESALE TCT Mobile T408DL TCL Flip 2", "WHOLESALE TCT Mobile T601DL TCL A2 5G", "WHOLESALE TCT Mobile T608DL", "WHOLESALE TCT Mobile T608G", "WHOLESALE TruConnect Communications Stratus C8", "WHOLESALE Vodafone US Landis G480", "WHOLESALE ZTE Z233VWS Cymal", "WHOLESALE ZTE Z5157V Gabb Z2", "WHOLESALE ZTE Z558VL", "WHOLESALE ZTE Z799VL Majesty Pro", "WHRZT WBB 100", "WHRZT WJB 100", "Wi MM BP400", "WiBASE Industrial Solutions LVR5", "Winegard Company WF 200M", "Winegard Company WF 200T", "Winegard Company WF 4000 1", "Winegard Company WF 4035 1", "Winegard Company WF 6000", "Winegard Company WF 6035", "Winegard Company WF2 400", "Winegard Company WF2 435", "Winegard Company WF2 90B", "Winegard Company WF2 95B", "Winegard GW 1000 2", "Winegard WF2 35B 3", "Winegard WF2 435 3", "Winegard WF2 95B 2", "Winegard WF2 PRO", "Winmate Communications E430RM4L", "Winmate Communications FM07", "Winmate Communications FM10", "Winmate Communications M101PH", "Wire Pulse REEL SENSE 2 0", "Wireless Links Piccolo", "Wireless Links Piccolo ATX Hybrid", "Wireless Telematics WT RF M", "Wise Telemetry Elite Series 2 0", "Wiseeye Technology WiseEye Smart Cam 1 0", "Wistron NeWeb Corporation IMQ3 3", "Wistron NeWeb Corporation UMC A12Q7 R", "Wistron NeWeb Corporation UMC A12Q7 R Linux", "Wistron NeWeb D18S3 1", "Wistron NeWeb IMG03", "Wistron NeWeb IMQ3 0", "Wistron NeWeb IMQ7", "Wistron NeWeb M18QF", "Wistron NeWeb M18QF Q", "Wistron NeWeb M18S3", "Wistron NeWeb UMC A18QA V", "Wistron NeWeb UMC A21LG", "Wistron NeWeb UMC A21LG2", "Wistron NeWeb UMC I210C", "Wistron NeWeb UMC l21M2", "Wistron NeWeb UMC SKV2C", "Wistron NeWeb UMC SKVM2", "WNC 5G CPE LVPK Outdoor", "WNC 5G CPE LVSK Indoor", "WNC 5G Router LVSKR1", "WNC CR200A Titan III 5G Internet Gtwy", "WNC Gemini LV55 5G Internet Gtwy", "WNC GEN3 LV55 5G Internet Gtwy", "WNC HPC LVP2 VoLTE Box", "WNC LV65 Eagle", "WNC LV65BIDU", "WNC VZ 5G CHR Router CR1000A", "WNC VZ 5G Router LRV5 100", "Worldwide Telecommunications 4200 Series", "Worldwide Telecommunications 6200 Series", "Worldwide Telecommunications WTI 1200", "Worldwide Telecommunications WTI 6200", "Xirgo Technologies XG3780", "Xirgo Technologies XG4780", "Xirgo Technologies XT2169R", "Xirgo Technologies XT2450CV", "Xirgo Technologies XT2469R", "Xirgo Technologies XT3182D", "Xirgo Technologies XT4569R", "Xirgo Technologies XT4769R", "Xirgo Technologies XT4950CV", "Xirgo Technologies XT4964", "Xirgo Technologies XT4970D", "Xirgo Technologies XT4970D 1", "Xirgo Technologies XT6372R", "Xirgo Technologies XT6383", "Xplore Technologies iX101L1", "Xplore Technologies iX101L2", "Xplore Technologies iX125R1", "Yealink CP860", "Yealink CP920", "Yealink CP960", "Yealink T41P", "Yealink T41S", "Yealink T41SW", "Yealink T42S", "Yealink T42U", "Yealink T46G", "Yealink T46GW", "Yealink T46S", "Yealink T46SW", "Yealink T49G", "Yealink T53W", "Yealink T54W", "Yealink T57W", "Yealink T64LTE", "Yealink T67LTE", "Yealink VZP59", "Yealink W60", "Zebra Technologies EC55AK", "Zebra Technologies EC55AK 2", "Zebra Technologies EM45A2", "Zebra Technologies ET55AE", "Zebra Technologies ET55AT", "Zebra Technologies ET55BE", "Zebra Technologies ET55BE G", "Zebra Technologies ET55BT", "Zebra Technologies ET55BT G", "Zebra Technologies ET56BE", "Zebra Technologies ET56DE", "Zebra Technologies ET56DT", "Zebra Technologies ET65AW", "Zebra Technologies MC27AJ", "Zebra Technologies MC27AK", "Zebra Technologies MC27AK 4", "Zebra Technologies MC67ND", "Zebra Technologies MC945A", "Zebra Technologies RTL10B1", "Zebra Technologies TC26AK 1 DAC code update", "Zebra Technologies TC26AK 2", "Zebra Technologies TC26EK", "Zebra Technologies TC55CH", "Zebra Technologies TC55CH GMS", "Zebra Technologies TC56CJ", "Zebra Technologies TC56CJ NGMS", "Zebra Technologies TC57HO", "Zebra Technologies TC57HO 1X", "Zebra Technologies TC57HO DAC code update", "Zebra Technologies TC58A1", "Zebra Technologies TC58AE", "Zebra Technologies TC75EK", "Zebra Technologies TC75EK NGMS", "Zebra Technologies TC77HL", "Zebra Technologies TC78A1", "Zebra Technologies TC78A1 2", "Zebra Technologies WCMTA", "ZEFCOM TELESPIRE FIH Limited GW23", "ZEFCOM ZTE Z5157V GABB Blade A3 Prime", "ZEFCOM ZTE Z559DL RW", "ZEFCOM ZTE ZW21", "Zhangzhou Lilliput Electronic Technology VT 7", "Zhongshan Transtek Electronics GBS 2104 G", "Zipit Wireless Bushnell Impulse", "Zipit Wireless Bushnell Southstar Cat M1", "Zoom Telephonics ZoomCell LTE USB Modem", "ZPE Systems BSR", "ZTE Blade VantageZ839PP", "ZTE K83V ZPad 8", "ZTE MC2261", "ZTE Z233V Cymbal Prepaid", "ZTE Z233VL", "ZTE Z291DL", "ZTE Z3153V Blade Vantage 2 Prepay", "ZTE Z3153V Prepay", "ZTE Z610DL", "ZTE Z6530M", "ZTE ZW21", "Zubie Car GL 700", "Zyxel LTE7461 M602"];

var parseResponse = function parseResponse(entries) {
  return entries === null || entries === void 0 ? void 0 : entries.map(function (entry) {
    return entry === null || entry === void 0 ? void 0 : entry['Menu Value'];
  });
};
var getValues = function getValues(payload, isParsed) {
  try {
    var isACSS = window.isACSS;
    var axiosConfig = getAxiosConfig$2(isACSS);
    var url = getUrl$2('getMenuValues');
    return Promise.resolve(postHttpClientRequest(url, payload, axiosConfig)).then(function (response) {
      var _response$data, _response$data$body, _response$data$body$d;
      var entries = ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$body = _response$data.body) === null || _response$data$body === void 0 ? void 0 : (_response$data$body$d = _response$data$body.data) === null || _response$data$body$d === void 0 ? void 0 : _response$data$body$d.entries) || []).map(function (entry) {
        return entry === null || entry === void 0 ? void 0 : entry.values;
      }).filter(Boolean);
      if (entries.length === 0) {
        throw new Error('No data returend from CJCM');
      }
      return isParsed ? parseResponse(entries) : entries;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var isPhoneModel = function isPhoneModel(payload) {
  return (payload === null || payload === void 0 ? void 0 : payload.type) === apiTypes.phoneModel;
};
var useGetValues = function useGetValues(_ref) {
  var _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    _ref$isParsed = _ref.isParsed,
    isParsed = _ref$isParsed === void 0 ? true : _ref$isParsed,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    _ref$flags = _ref.flags,
    flags = _ref$flags === void 0 ? {} : _ref$flags;
  var cacheKey = enabled ? Object.values(payload) : null;
  var query = useSWR(cacheKey, function () {
    if (isPhoneModel(payload) && flags !== null && flags !== void 0 && flags.nrbPhoneModelFFlag) return phoneModelData;
    return getValues(payload, isParsed);
  }, swrDefaults$1);
  return _extends({}, query, {
    isFetched: !!(query !== null && query !== void 0 && query.data) || !!(query !== null && query !== void 0 && query.error)
  });
};
var submitNRB = function submitNRB(_ref2) {
  var url = _ref2.url,
    arg = _ref2.arg;
  try {
    var isACSS = window.isACSS;
    var axiosConfig = getAxiosConfig$2(isACSS);
    var payload = arg.payload;
    return Promise.resolve(postHttpClientRequest(url, payload, axiosConfig)).then(function (response) {
      var _response$data2;
      return response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.body;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var triggerCountMap = new Map();
var useSubmitNRBForm = function useSubmitNRBForm(caseId) {
  var _useState = useState(function () {
      return triggerCountMap.get(caseId) || 1;
    }),
    triggerCount = _useState[0],
    setTriggerCount = _useState[1];
  var url = getUrl$2('submitNrbTicket');
  var mutation = useSWRMutation(url, function (url, _ref3) {
    var arg = _ref3.arg;
    var newCount = triggerCount + 1;
    setTriggerCount(newCount);
    triggerCountSession === null || triggerCountSession === void 0 ? void 0 : triggerCountSession.set(caseId, newCount);
    triggerCountMap.set(caseId, newCount);
    return submitNRB({
      url: url,
      arg: arg
    });
  });
  var sessionTriggerCount = triggerCountSession === null || triggerCountSession === void 0 ? void 0 : triggerCountSession.get(caseId);
  var effectiveTriggerCount = sessionTriggerCount;
  return _extends({}, mutation, {
    effectiveTriggerCount: effectiveTriggerCount
  });
};
var _createStore = createStore({
    name: 'nrbStore',
    initialState: {
      mandatoryCallFailed: false,
      mandatoryCalls: [],
      mandatoryCallFetched: false
    }
  }),
  NrbProvider = _createStore.Provider,
  useNRBState = _createStore.useStoreState,
  useNRBDispatch = _createStore.useStoreDispatch;
var useMandatoryCalls = function useMandatoryCalls(callDetails) {
  var _useNRBState = useNRBState(),
    mandatoryCalls = _useNRBState.mandatoryCalls;
  var dispatch = useNRBDispatch();
  useEffect(function () {
    if (!(callDetails !== null && callDetails !== void 0 && callDetails.isFetched)) return;
    var updatedMandatoryCalls = mandatoryCalls.map(function (call) {
      return (callDetails === null || callDetails === void 0 ? void 0 : callDetails.name) === (call === null || call === void 0 ? void 0 : call.name) ? callDetails : call;
    });
    var existingCall = mandatoryCalls.find(function (call) {
      return call.name === (callDetails === null || callDetails === void 0 ? void 0 : callDetails.name);
    });
    if (existingCall !== null && existingCall !== void 0 && existingCall.isFetched) return;
    updatedMandatoryCalls.push(callDetails);
    var isError = updatedMandatoryCalls.some(function (call) {
      return call.isError;
    });
    var isFetched = updatedMandatoryCalls.every(function (call) {
      return call.isFetched;
    });
    dispatch({
      type: 'SET_NRBSTORE',
      payload: {
        mandatoryCalls: updatedMandatoryCalls,
        mandatoryCallFailed: isError,
        mandatoryCallFetched: isFetched
      }
    });
  }, [callDetails, mandatoryCalls, dispatch]);
};

var useObjectChange = function useObjectChange(array, callback) {
  var prevArrayRef = useRef(array);
  useEffect(function () {
    var prevArray = prevArrayRef.current;
    if (JSON.stringify(array) !== JSON.stringify(prevArray)) {
      callback(array, prevArray);
    }
    prevArrayRef.current = array;
  }, [array, callback]);
};

var _excluded$2 = ["data", "isLoading"];
var extractQuestionnaires = function extractQuestionnaires(filteredQuestions) {
  return filteredQuestions.reduce(function (acc, nextQuestion) {
    var question = nextQuestion['QUESTION'];
    var selection = nextQuestion['Selection'];
    var answerType = nextQuestion['Answer Type'];
    var questionId = nextQuestion['Question ID'];
    var existingQuestion = acc.find(function (q) {
      var keys = ['Qualifier 1', 'Qualifier 2', 'Qualifier 3', 'Qualifier 4', 'Question ID'];
      return keys.every(function (key) {
        var _q$original;
        return (q === null || q === void 0 ? void 0 : (_q$original = q.original) === null || _q$original === void 0 ? void 0 : _q$original[key]) === nextQuestion[key];
      });
    });
    var isEntry = answerType === 'Entry';
    try {
      var newItem = {
        answerType: answerType,
        question: question,
        questionId: questionId,
        original: nextQuestion
      };
      if (isEntry) acc.push(newItem);else {
        if (!existingQuestion) {
          acc.push(newItem);
          if (selection) newItem.options = [selection];
        } else {
          if (selection) existingQuestion === null || existingQuestion === void 0 ? void 0 : existingQuestion.options.push(selection);
        }
      }
    } catch (e) {
      return acc;
    }
    return acc;
  }, []);
};
var extractUniqueValues = function extractUniqueValues(questions, qualifierKey, filters) {
  if (filters === void 0) {
    filters = {};
  }
  var filteredQuestions = questions.filter(function (question) {
    return Object.entries(filters).every(function (_ref) {
      var key = _ref[0],
        value = _ref[1];
      return question["Qualifier " + key] === value;
    });
  });
  var qualifiers = getUniqueValues(filteredQuestions.map(function (q) {
    return q[qualifierKey];
  }).filter(Boolean));
  return {
    qualifiers: qualifiers,
    questionnaires: extractQuestionnaires(filteredQuestions)
  };
};
var useQualifierQuestions = function useQualifierQuestions() {
  var _useFormContext = useFormContext(),
    watch = _useFormContext.watch;
  var problemType = watch('problemType');
  return useGetValues({
    payload: {
      type: apiTypes.qualifierQuestions,
      userInput: problemType
    },
    enabled: !!problemType,
    isParsed: false
  });
};
var useQuestionnaires = function useQuestionnaires() {
  return useSWR('questionnaires', null, swrDefaults$1);
};
var useQualifier = function useQualifier(_ref2) {
  var qualifierType = _ref2.qualifierType,
    _ref2$enabled = _ref2.enabled,
    enabled = _ref2$enabled === void 0 ? true : _ref2$enabled;
  var _useFormContext2 = useFormContext(),
    watch = _useFormContext2.watch,
    setValue = _useFormContext2.setValue;
  var qualifierValues = {
    1: watch('qualifier1'),
    2: watch('qualifier2'),
    3: watch('qualifier3'),
    4: watch('qualifier4')
  };
  var problemType = watch('problemType');
  var qualifierCompleted = Object.values(qualifierValues).every(function (value) {
    return !!value && value !== 'NA';
  });
  var _useQualifierQuestion = useQualifierQuestions(),
    qualifierQuestions = _useQualifierQuestion.data,
    isLoading = _useQualifierQuestion.isLoading,
    rest = _objectWithoutPropertiesLoose(_useQualifierQuestion, _excluded$2);
  var _useQuestionnaires = useQuestionnaires(),
    mutate = _useQuestionnaires.mutate;
  var qualifierNumber = parseInt(qualifierType.replace('qualifier', ''));
  useEffect(function () {
    if (!isLoading && !!problemType && qualifierQuestions === undefined) {
      Object.keys(qualifierValues).forEach(function (key) {
        setValue("qualifier" + key, "NA");
      });
    }
  }, [qualifierQuestions, isLoading]);
  var getQualifierData = function getQualifierData() {
    if (!qualifierQuestions || !enabled) return [];
    var filters = {};
    for (var i = 1; i < qualifierNumber; i++) {
      if (qualifierValues !== null && qualifierValues !== void 0 && qualifierValues[i]) {
        filters[i] = qualifierValues[i];
      }
    }
    return extractUniqueValues(qualifierQuestions, "Qualifier " + qualifierNumber, filters);
  };
  var _getQualifierData = getQualifierData(),
    qualifiers = _getQualifierData.qualifiers,
    questionnaires = _getQualifierData.questionnaires;
  var isNA = checkIsNA(qualifiers);
  useEffect(function () {
    if (isNA) mutate(questionnaires);
  }, [questionnaires, isNA]);
  useEffect(function () {
    if (qualifierCompleted) mutate(questionnaires);
  }, [qualifierCompleted]);
  useObjectChange(qualifierValues, function (newObject, oldObject) {
    if (!isNA) return;
    Object.entries(newObject).forEach(function (_ref3) {
      var key = _ref3[0],
        value = _ref3[1];
      if (!!!value) {
        setValue("qualifier" + key, 'NA');
      }
    });
  });
  return _extends({
    data: qualifiers
  }, rest);
};

var _excluded$3 = ["surface", "isDisabled", "readOnly", "error"],
  _excluded2 = ["field", "label", "surface", "isLoading", "children"];
var palette$2 = ColorTokens.palette;
var PAGE_SIZE = 600;
var WINDOW_SIZE = 300;
var customStyles = function customStyles(isDisabled, isReadOnly, surface, error) {
  return {
    control: function control(provided, state) {
      return _extends({}, provided, {
        padding: 2,
        borderRadius: 0,
        backgroundColor: error && surface === 'dark' ? '#561701' : surface === 'dark' ? '#000000' : error ? '#ffece0' : '#ffffff',
        border: "1px solid " + (error ? '#d38c63' : surface === 'dark' ? isReadOnly ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.8)' : isReadOnly ? 'rgba(0, 0, 0, 0.2)' : palette$2.gray44.value),
        opacity: isDisabled ? 0.2 : 1,
        color: isDisabled ? '#d8dada' : surface === 'dark' ? '#ffffff' : '#000000',
        boxShadow: 'none',
        '&:hover': {
          border: isDisabled || isReadOnly ? "1px solid #d8dada" : "1px solid " + (surface === 'dark' ? '#ffffff' : '#000000')
        },
        '&:after': (state === null || state === void 0 ? void 0 : state.isFocused) && !isDisabled && !isReadOnly && {
          background: 'transparent',
          content: "' '",
          position: 'absolute',
          height: 'calc(100% + 0.375rem)',
          width: 'calc(100% + 0.375rem)',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          border: "0.0625rem dashed " + (surface === 'dark' ? '#ffffff' : '#000000'),
          borderRadius: 0,
          padding: 3
        },
        pointerEvents: isDisabled || isReadOnly ? 'none' : 'auto',
        cursor: isDisabled ? 'not-allowed' : isReadOnly ? 'default' : 'pointer'
      });
    },
    dropdownIndicator: function dropdownIndicator(provided, state) {
      return _extends({}, provided, {
        transition: 'all .2s ease',
        transform: !error && state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
        color: isDisabled ? '#d8dada' : surface === 'dark' ? '#ffffff' : '#000000'
      });
    },
    input: function input(provided) {
      return _extends({}, provided, {
        color: surface === 'dark' ? '#ffffff' : '#000000'
      });
    },
    menu: function menu(provided) {
      return _extends({}, provided, {
        padding: 0,
        margin: 0,
        backgroundColor: surface === 'dark' ? '#000000' : '#ffffff',
        border: "1px solid #d8dada",
        borderRadius: 0,
        boxShadow: 'none',
        zIndex: '2',
        width: 'max-content',
        minWidth: '100%'
      });
    },
    menuList: function menuList(provided) {
      return _extends({}, provided, {
        padding: 0,
        whiteSpace: 'nowrap'
      });
    },
    option: function option(provided, state) {
      return _extends({}, provided, {
        padding: '5px 10px',
        backgroundColor: state !== null && state !== void 0 && state.isFocused ? '#1f7dff' : state !== null && state !== void 0 && state.isSelected ? '#1967d2' : surface === 'dark' ? '#000000' : '#ffffff',
        color: state !== null && state !== void 0 && state.isSelected || state !== null && state !== void 0 && state.isFocused ? '#ffffff' : surface === 'dark' ? '#ffffff' : '#000000',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      });
    },
    indicatorSeparator: function indicatorSeparator() {
      return {
        display: 'none'
      };
    },
    singleValue: function singleValue(provided) {
      return _extends({}, provided, {
        color: isDisabled ? '#d8dada' : surface === 'dark' ? '#ffffff' : '#000000'
      });
    }
  };
};
var CustomDropdownIndicator$1 = function CustomDropdownIndicator(_ref) {
  var surface = _ref.surface,
    error = _ref.error,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  return /*#__PURE__*/React__default.createElement(components.DropdownIndicator, props, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: error ? 'error' : 'down-caret',
    surface: surface
  }));
};
var extractDropDownList = function extractDropDownList(children) {
  return React__default.Children.toArray(children).filter(function (child) {
    return (child === null || child === void 0 ? void 0 : child.type) === 'option';
  }).map(function (option) {
    return option.props.value || option.props.children;
  });
};
var buildOption$1 = function buildOption(value) {
  return {
    value: value,
    label: value
  };
};
var getOptionWindowBoundaries = function getOptionWindowBoundaries(selectedIndex) {
  var startIndex = Math.max(0, selectedIndex - WINDOW_SIZE);
  var endIndex = Math.min(selectedIndex + WINDOW_SIZE);
  return {
    startIndex: startIndex,
    endIndex: endIndex
  };
};
var getWindowedOptions = function getWindowedOptions(options, selectedIndex) {
  if (selectedIndex === -1 || selectedIndex < PAGE_SIZE) {
    return options.slice(0, PAGE_SIZE);
  }
  var _getOptionWindowBound = getOptionWindowBoundaries(selectedIndex),
    startIndex = _getOptionWindowBound.startIndex,
    endIndex = _getOptionWindowBound.endIndex;
  return options.slice(startIndex, endIndex);
};
var filterOptionsByValue = function filterOptionsByValue(options, searchValue) {
  var normalizedSearch = (searchValue || '').toLowerCase();
  return options.filter(function (option) {
    return option.label.toLowerCase().includes(normalizedSearch);
  });
};
var scrollToSelectedOption = function scrollToSelectedOption(menuList, selectedIndex, dropDownValueHeight) {
  if (dropDownValueHeight === void 0) {
    dropDownValueHeight = 26;
  }
  if (!menuList) return;
  var scrollTop = selectedIndex < PAGE_SIZE ? selectedIndex * dropDownValueHeight : WINDOW_SIZE * dropDownValueHeight;
  menuList.scrollTo({
    top: scrollTop,
    behavior: 'smooth'
  });
};
var ComboBox = function ComboBox(_ref2) {
  var field = _ref2.field,
    label = _ref2.label,
    surface = _ref2.surface,
    children = _ref2.children,
    selectProps = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  var _selectProps$isDisabl = selectProps.isDisabled,
    isDisabled = _selectProps$isDisabl === void 0 ? false : _selectProps$isDisabl,
    _selectProps$readOnly = selectProps.readOnly,
    readOnly = _selectProps$readOnly === void 0 ? false : _selectProps$readOnly,
    error = selectProps.error,
    errorText = selectProps.errorText;
  var name = field.name,
    value = field.value;
  var selectRef = useRef(null);
  var allOptions = useMemo(function () {
    var values = extractDropDownList(children);
    return values.map(buildOption$1);
  }, [children]);
  var selectedValue = useMemo(function () {
    return value ? buildOption$1(value) : null;
  }, [value]);
  var getSelectedIndex = useCallback(function () {
    return allOptions.findIndex(function (option) {
      return option.value === value;
    });
  }, [allOptions, value]);
  var defaultOptions = useMemo(function () {
    if (!value) return allOptions.slice(0, PAGE_SIZE);
    var selectedIndex = getSelectedIndex();
    return getWindowedOptions(allOptions, selectedIndex);
  }, [allOptions, value, getSelectedIndex]);
  var loadOptions = useCallback(function (inputValue, callback) {
    var filteredOptions = filterOptionsByValue(allOptions, inputValue);
    if (!inputValue && value) {
      var selectedIndex = getSelectedIndex();
      if (selectedIndex >= PAGE_SIZE) {
        callback(getWindowedOptions(filteredOptions, selectedIndex));
        return;
      }
    }
    callback(filteredOptions.slice(0, PAGE_SIZE));
  }, [allOptions, value, getSelectedIndex]);
  var handleChange = function handleChange(selectedOption) {
    var _selectProps$onChange;
    var value = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value;
    var e = {
      target: {
        value: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) || '',
        name: name
      },
      type: 'change'
    };
    selectProps === null || selectProps === void 0 ? void 0 : (_selectProps$onChange = selectProps.onChange) === null || _selectProps$onChange === void 0 ? void 0 : _selectProps$onChange.call(selectProps, e);
    field.onChange(value);
  };
  var handleMenuOpen = useCallback(function () {
    if (!selectRef.current) return;
    var selectedIndex = getSelectedIndex();
    if (selectedIndex === -1) return;
    setTimeout(function () {
      var _document$querySelect;
      var dropDownValueHeight = (_document$querySelect = document.querySelector('div[role="option"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getBoundingClientRect().height;
      var menuList = document.querySelector('[role="listbox"]');
      scrollToSelectedOption(menuList, selectedIndex, dropDownValueHeight);
    }, 0);
  }, [getSelectedIndex]);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      lineHeight: 1
    }
  }, label && /*#__PURE__*/React__default.createElement("label", {
    style: {
      marginBottom: '0.25rem'
    }
  }, /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: surface === 'dark' ? '#ffffff' : '#000000'
  }, label)), /*#__PURE__*/React__default.createElement(AsyncSelect, {
    ref: selectRef,
    inputId: "async-dropdown",
    isSearchable: !readOnly && !isDisabled,
    isDisabled: isDisabled,
    value: selectedValue,
    placeholder: "",
    onChange: handleChange,
    loadOptions: loadOptions,
    defaultOptions: defaultOptions,
    onMenuOpen: handleMenuOpen,
    cacheOptions: true,
    styles: customStyles(isDisabled, readOnly, surface, error),
    components: {
      DropdownIndicator: function DropdownIndicator(props) {
        return /*#__PURE__*/React__default.createElement(CustomDropdownIndicator$1, _extends({}, props, {
          surface: surface,
          isDisabled: isDisabled,
          readOnly: readOnly,
          error: error
        }));
      }
    },
    closeMenuOnSelect: true,
    blurInputOnSelect: true,
    menuPlacement: "auto",
    maxMenuHeight: 300
  }), error && errorText && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: '0.25rem',
      color: '#d38c63'
    }
  }, /*#__PURE__*/React__default.createElement(Body, {
    size: "small"
  }, errorText)));
};

var _excluded$4 = ["name", "rules", "isLoading", "children"];
var _templateObject$I;
var SelectInput = styled(Stack)(_templateObject$I || (_templateObject$I = _taggedTemplateLiteralLoose(["\n  [class*='SelectContainer'] {\n    align-items: unset !important;\n  }\n  p {\n    color: ", ";\n  }\n"])), function (props) {
  return props.surface === "light" ? "#000000" : props.surface === "dark" && props.isDisabled ? '#a7a7a7' : '#ffffff';
});
var Select = function Select(_ref) {
  var name = _ref.name,
    rules = _ref.rules,
    isLoading = _ref.isLoading,
    children = _ref.children,
    selectProps = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  var _useNRBState = useNRBState(),
    surface = _useNRBState.surface;
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    rules: rules,
    render: function render(_ref2) {
      var _errors$name, _selectProps$label;
      var field = _ref2.field,
        errors = _ref2.formState.errors;
      return /*#__PURE__*/React__default.createElement(SelectInput, {
        surface: surface,
        isDisabled: selectProps === null || selectProps === void 0 ? void 0 : selectProps.disabled
      }, /*#__PURE__*/React__default.createElement(ComboBox, _extends({
        field: field,
        error: !!(errors !== null && errors !== void 0 && errors[name]) && !(selectProps !== null && selectProps !== void 0 && selectProps.readOnly) && !(selectProps !== null && selectProps !== void 0 && selectProps.disabled),
        errorText: errors === null || errors === void 0 ? void 0 : (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message
      }, selectProps, {
        surface: surface
      }), isLoading ? /*#__PURE__*/React__default.createElement("option", null, "Loading...") : children), !!(selectProps !== null && selectProps !== void 0 && selectProps.loadingError) && /*#__PURE__*/React__default.createElement(HStack, {
        justifyContent: "space-between",
        alignItems: "center"
      }, /*#__PURE__*/React__default.createElement(Body, {
        color: surface === "dark" ? '#fff' : '#000',
        size: "small"
      }, "Failed to pull ", selectProps === null || selectProps === void 0 ? void 0 : (_selectProps$label = selectProps.label) === null || _selectProps$label === void 0 ? void 0 : _selectProps$label.toLowerCase()), /*#__PURE__*/React__default.createElement(ButtonIcon, {
        onClick: selectProps === null || selectProps === void 0 ? void 0 : selectProps.onRefetch,
        kind: "ghost",
        size: "small",
        renderIcon: function renderIcon(props) {
          return /*#__PURE__*/React__default.createElement(CarryoverData, props);
        },
        disabled: isLoading,
        surface: surface
      })));
    }
  });
};

var ProblemType = function ProblemType(_ref) {
  var disabled = _ref.disabled;
  var _useFormContext = useFormContext(),
    setValue = _useFormContext.setValue,
    watch = _useFormContext.watch;
  var _useQuestionnaires = useQuestionnaires(),
    mutate = _useQuestionnaires.mutate;
  var problemType = watch('problemType') || '';
  var prevProblemTypeRef = useRef(problemType);
  var _useGetValues = useGetValues({
      payload: {
        type: apiTypes.problemType
      }
    }),
    _useGetValues$data = _useGetValues.data,
    problemTypes = _useGetValues$data === void 0 ? [] : _useGetValues$data,
    isLoading = _useGetValues.isLoading,
    isValidating = _useGetValues.isValidating,
    error = _useGetValues.error,
    refetch = _useGetValues.mutate,
    isFetched = _useGetValues.isFetched;
  useMandatoryCalls({
    name: 'problemType',
    isFetched: isFetched,
    isError: !!error
  });
  var resetDependentFields = function resetDependentFields() {
    var dependentFields = ['qualifier1', 'qualifier2', 'qualifier3', 'qualifier4', 'questionnaires'];
    dependentFields.forEach(function (field) {
      var value = field === 'questionnaires' ? {} : '';
      setValue(field, value, {
        shouldValidate: false,
        shouldDirty: false,
        shouldTouch: false
      });
    });
    mutate([]);
  };
  var handleInBuildingSolutionBehaviour = function handleInBuildingSolutionBehaviour(problemTypeValue) {
    var _prevProblemTypeRef$c;
    var isVZWNE = problemTypeValue === null || problemTypeValue === void 0 ? void 0 : problemTypeValue.includes('VZWNE');
    var prevIsVZWNE = (_prevProblemTypeRef$c = prevProblemTypeRef.current) === null || _prevProblemTypeRef$c === void 0 ? void 0 : _prevProblemTypeRef$c.includes('VZWNE');
    if (isVZWNE) {
      setValue('inBuildingSolution', 'VZW Network Extender', {
        shouldValidate: false,
        shouldDirty: false,
        shouldTouch: false
      });
    } else if (!isVZWNE && prevIsVZWNE) {
      setValue('inBuildingSolution', '', {
        shouldValidate: false,
        shouldDirty: false,
        shouldTouch: false
      });
      setValue('model', '', {
        shouldValidate: false,
        shouldDirty: false,
        shouldTouch: false
      });
    }
    prevProblemTypeRef.current = problemTypeValue || '';
  };
  var onChange = function onChange(e) {
    var _e$target;
    var value = e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value;
    resetDependentFields();
    handleInBuildingSolutionBehaviour(value);
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2",
    "data-field": "problemType"
  }, /*#__PURE__*/React__default.createElement(Select, {
    name: "problemType",
    label: "Problem Type",
    readOnly: !!error || isLoading || isValidating || !problemTypes.length || disabled,
    isLoading: isLoading,
    rules: {
      required: 'Select problem type'
    },
    loadingError: !!error,
    onChange: onChange,
    onRefetch: function onRefetch() {
      return refetch();
    }
  }, problemTypes.map(function (problemType) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: problemType,
      value: problemType
    }, problemType);
  })));
};

var ServiceType = function ServiceType(_ref) {
  var disabled = _ref.disabled,
    serviceTypesForNonUSA = _ref.serviceTypesForNonUSA;
  var _useFormContext = useFormContext(),
    setValue = _useFormContext.setValue,
    watch = _useFormContext.watch;
  var serviceType = watch('serviceType') || '';
  var prevServiceTypeRef = useRef(serviceType);
  var _useGetValues = useGetValues({
      payload: {
        type: apiTypes.serviceType
      }
    }),
    _useGetValues$data = _useGetValues.data,
    serviceTypes = _useGetValues$data === void 0 ? [] : _useGetValues$data,
    isLoading = _useGetValues.isLoading,
    isValidating = _useGetValues.isValidating,
    error = _useGetValues.error,
    refetch = _useGetValues.mutate,
    isFetched = _useGetValues.isFetched;
  useMandatoryCalls({
    name: 'serviceType',
    isFetched: isFetched,
    isError: !!error
  });
  var handleCountryBehaviour = function handleCountryBehaviour(serviceTypeValue) {
    var isServiceTypeForNonUSA = serviceTypesForNonUSA === null || serviceTypesForNonUSA === void 0 ? void 0 : serviceTypesForNonUSA.includes(serviceTypeValue);
    var prevIsServiceTypeForNonUSA = serviceTypesForNonUSA === null || serviceTypesForNonUSA === void 0 ? void 0 : serviceTypesForNonUSA.includes(prevServiceTypeRef.current);
    if (isServiceTypeForNonUSA) {
      setValue('country', '', {
        shouldValidate: false,
        shouldDirty: false,
        shouldTouch: false
      });
    } else if (!isServiceTypeForNonUSA && prevIsServiceTypeForNonUSA) {
      setValue('country', 'USA', {
        shouldValidate: false,
        shouldDirty: false,
        shouldTouch: false
      });
    }
    prevServiceTypeRef.current = serviceTypeValue || '';
  };
  var onChange = function onChange(e) {
    var _e$target;
    var value = e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value;
    handleCountryBehaviour(value);
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2",
    "data-field": "serviceType"
  }, /*#__PURE__*/React__default.createElement(Select, {
    name: "serviceType",
    label: "Service Type",
    readOnly: !!error || isLoading || isValidating || !serviceTypes.length || disabled,
    isLoading: isLoading || isValidating,
    rules: {
      required: 'Select service type'
    },
    onChange: onChange,
    loadingError: !!error,
    onRefetch: function onRefetch() {
      return refetch();
    }
  }, serviceTypes === null || serviceTypes === void 0 ? void 0 : serviceTypes.map(function (serviceType) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: serviceType,
      value: serviceType
    }, serviceType);
  })));
};

var Qualifier1 = function Qualifier1(_ref) {
  var disabled = _ref.disabled;
  var _useQuestionnaires = useQuestionnaires(),
    mutate = _useQuestionnaires.mutate;
  var _useFormContext = useFormContext(),
    watch = _useFormContext.watch,
    setValue = _useFormContext.setValue;
  var problemType = watch('problemType');
  var _useQualifier = useQualifier({
      qualifierType: 'qualifier1'
    }),
    _useQualifier$data = _useQualifier.data,
    qualifiers = _useQualifier$data === void 0 ? [] : _useQualifier$data,
    isLoading = _useQualifier.isLoading;
  var resetDependentFields = function resetDependentFields() {
    var dependentFields = ['qualifier2', 'qualifier3', 'qualifier4', 'questionnaires'];
    dependentFields.forEach(function (field) {
      var value = field === 'questionnaires' ? {} : '';
      setValue(field, value, {
        shouldValidate: false,
        shouldDirty: false,
        shouldTouch: false
      });
    });
    mutate([]);
  };
  var onChange = function onChange(e) {
    resetDependentFields();
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    "data-field": "qualifier1"
  }, /*#__PURE__*/React__default.createElement(Select, {
    name: "qualifier1",
    label: "Qualifier 1",
    readOnly: !qualifiers.length || isLoading || disabled,
    isLoading: isLoading,
    rules: {
      required: 'Select qualifier 1'
    },
    onChange: onChange
  }, qualifiers === null || qualifiers === void 0 ? void 0 : qualifiers.map(function (qualifier, index) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: qualifier + index,
      value: qualifier
    }, qualifier);
  })));
};

var Qualifier2 = function Qualifier2(_ref) {
  var disabled = _ref.disabled;
  var _useQuestionnaires = useQuestionnaires(),
    mutate = _useQuestionnaires.mutate;
  var _useFormContext = useFormContext(),
    watch = _useFormContext.watch,
    setValue = _useFormContext.setValue;
  var qualifier1 = watch('qualifier1');
  var _useQualifier = useQualifier({
      qualifierType: 'qualifier2',
      enabled: !!qualifier1
    }),
    _useQualifier$data = _useQualifier.data,
    qualifiers = _useQualifier$data === void 0 ? [] : _useQualifier$data;
  var isNA = checkIsNA(qualifiers);
  var resetDependentFields = function resetDependentFields() {
    var dependentFields = ['qualifier3', 'qualifier4', 'questionnaires'];
    dependentFields.forEach(function (field) {
      var value = field === 'questionnaires' ? {} : '';
      setValue(field, value, {
        shouldValidate: false,
        shouldDirty: false,
        shouldTouch: false
      });
    });
    mutate([]);
  };
  var onChange = function onChange(e) {
    resetDependentFields();
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    "data-field": "qualifier2"
  }, /*#__PURE__*/React__default.createElement(Select, {
    name: "qualifier2",
    label: "Qualifier 2",
    readOnly: !(qualifiers !== null && qualifiers !== void 0 && qualifiers.length) || isNA || disabled,
    onChange: onChange,
    rules: {
      required: 'Select qualifier 2'
    }
  }, isNA && /*#__PURE__*/React__default.createElement("option", {
    value: "NA"
  }, "NA"), qualifiers === null || qualifiers === void 0 ? void 0 : qualifiers.map(function (qualifier, index) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: qualifier + index,
      value: qualifier
    }, qualifier);
  })));
};

var Qualifier3 = function Qualifier3(_ref) {
  var disabled = _ref.disabled;
  var _useQuestionnaires = useQuestionnaires(),
    mutate = _useQuestionnaires.mutate;
  var _useFormContext = useFormContext(),
    watch = _useFormContext.watch,
    setValue = _useFormContext.setValue;
  var qualifier2 = watch('qualifier2');
  var _useQualifier = useQualifier({
      qualifierType: 'qualifier3',
      enabled: !!qualifier2
    }),
    _useQualifier$data = _useQualifier.data,
    qualifiers = _useQualifier$data === void 0 ? [] : _useQualifier$data;
  var isNA = checkIsNA(qualifiers);
  var resetDependentFields = function resetDependentFields() {
    var dependentFields = ['qualifier4', 'questionnaires'];
    dependentFields.forEach(function (field) {
      var value = field === 'questionnaires' ? {} : '';
      setValue(field, value, {
        shouldValidate: false,
        shouldDirty: false,
        shouldTouch: false
      });
    });
    mutate([]);
  };
  var onChange = function onChange(e) {
    resetDependentFields();
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    "data-field": "qualifier3"
  }, /*#__PURE__*/React__default.createElement(Select, {
    name: "qualifier3",
    label: "Qualifier 3",
    readOnly: !(qualifiers !== null && qualifiers !== void 0 && qualifiers.length) || isNA || disabled,
    onChange: onChange,
    rules: {
      required: 'Select qualifier 3'
    }
  }, isNA && /*#__PURE__*/React__default.createElement("option", {
    value: "NA"
  }, "NA"), qualifiers === null || qualifiers === void 0 ? void 0 : qualifiers.map(function (qualifier, index) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: qualifier + index,
      value: qualifier
    }, qualifier);
  })));
};

var Qualifier4 = function Qualifier4(_ref) {
  var disabled = _ref.disabled;
  var _useFormContext = useFormContext(),
    watch = _useFormContext.watch;
  var qualifier3 = watch('qualifier3');
  var _useQualifier = useQualifier({
      qualifierType: 'qualifier4',
      enabled: !!qualifier3
    }),
    _useQualifier$data = _useQualifier.data,
    qualifiers = _useQualifier$data === void 0 ? [] : _useQualifier$data;
  var isNA = checkIsNA(qualifiers);
  return /*#__PURE__*/React__default.createElement(Box, {
    "data-field": "qualifier4"
  }, /*#__PURE__*/React__default.createElement(Select, {
    name: "qualifier4",
    label: "Qualifier 4",
    readOnly: !(qualifiers !== null && qualifiers !== void 0 && qualifiers.length) || isNA || disabled,
    rules: {
      required: 'Select qualifier 4'
    }
  }, isNA && /*#__PURE__*/React__default.createElement("option", {
    value: "NA"
  }, "NA"), qualifiers === null || qualifiers === void 0 ? void 0 : qualifiers.map(function (qualifier, index) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: qualifier + index,
      value: qualifier
    }, qualifier);
  })));
};

var _excluded$5 = ["name", "rules"];
var Input = function Input(_ref) {
  var name = _ref.name,
    rules = _ref.rules,
    inputProps = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  var _useFormContext = useFormContext(),
    control = _useFormContext.control,
    trigger = _useFormContext.trigger,
    clearErrors = _useFormContext.clearErrors;
  var _useNRBState = useNRBState(),
    surface = _useNRBState.surface;
  var _onChange = function onChange(e, field, errors) {
    var _inputProps$onChange;
    var inputError = errors === null || errors === void 0 ? void 0 : errors[name];
    if (!!inputError) clearErrors(name);
    var value = e.target.value;
    var updatedValue = !!(inputProps !== null && inputProps !== void 0 && inputProps.onChange) ? inputProps === null || inputProps === void 0 ? void 0 : (_inputProps$onChange = inputProps.onChange) === null || _inputProps$onChange === void 0 ? void 0 : _inputProps$onChange.call(inputProps, e) : value;
    if (updatedValue === null) return;
    field.onChange(updatedValue);
    e.target.setSelectionRange(updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.length, updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.length);
  };
  var handleOnBlur = function handleOnBlur() {
    trigger(name);
  };
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    rules: rules,
    render: function render(_ref2) {
      var _errors$name;
      var field = _ref2.field,
        errors = _ref2.formState.errors;
      return /*#__PURE__*/React__default.createElement(Input$1, _extends({}, field, {
        error: !!(errors !== null && errors !== void 0 && errors[name]) && !(inputProps !== null && inputProps !== void 0 && inputProps.readOnly) && !(inputProps !== null && inputProps !== void 0 && inputProps.disabled),
        errorText: errors === null || errors === void 0 ? void 0 : (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message
      }, inputProps, {
        onChange: function onChange(e) {
          return _onChange(e, field, errors);
        },
        surface: surface,
        onBlur: handleOnBlur
      }));
    }
  });
};

var _templateObject$J, _templateObject2$B, _templateObject3$u, _templateObject4$t;
var TableHeader = styled(TableHeader$1)(_templateObject$J || (_templateObject$J = _taggedTemplateLiteralLoose(["\n  font-size: 16px;\n  padding-top: 12px !important;\n  padding-bottom: 8px !important;\n"])));
var Cell = styled(Cell$1)(_templateObject2$B || (_templateObject2$B = _taggedTemplateLiteralLoose(["\n  padding: 8px !important;\n  vertical-align: middle;\n  /* div,\n  span[type='text'] {\n    height: 2.5rem;\n  } */\n  span[class^='IconContainer'] {\n    /* height: 1rem; */\n  }\n"])));
var ScrollStack = styled(Stack)(_templateObject3$u || (_templateObject3$u = _taggedTemplateLiteralLoose(["\n  &::-webkit-scrollbar {\n    width: 4px;\n    background-color: transparent;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: #d8dada;\n    border-radius: 6px;\n  }\n"])));
var InputWrapper = styled.div(_templateObject4$t || (_templateObject4$t = _taggedTemplateLiteralLoose(["\n  width: 250px;\n"])));
var QuestionnairSelect = function QuestionnairSelect(_ref) {
  var _errors$questionnaire, _errors$questionnaire2, _errors$questionnaire3, _q$options;
  var q = _ref.q;
  var name = "questionnaires." + (q === null || q === void 0 ? void 0 : q.questionId);
  var _useFormContext = useFormContext(),
    errors = _useFormContext.formState.errors;
  var hasError = !!(errors !== null && errors !== void 0 && (_errors$questionnaire = errors.questionnaires) !== null && _errors$questionnaire !== void 0 && _errors$questionnaire[q.questionId]);
  return /*#__PURE__*/React__default.createElement(Box, {
    "data-has-error": hasError ? 'true' : 'false'
  }, /*#__PURE__*/React__default.createElement(Select, {
    name: name,
    rules: {
      required: 'This field is required'
    },
    error: hasError,
    errorText: errors === null || errors === void 0 ? void 0 : (_errors$questionnaire2 = errors.questionnaires) === null || _errors$questionnaire2 === void 0 ? void 0 : (_errors$questionnaire3 = _errors$questionnaire2[q.questionId]) === null || _errors$questionnaire3 === void 0 ? void 0 : _errors$questionnaire3.message,
    "data-question-id": q.questionId
  }, q === null || q === void 0 ? void 0 : (_q$options = q.options) === null || _q$options === void 0 ? void 0 : _q$options.map(function (option) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: option,
      value: option
    }, option);
  })));
};
var QuestionnaireInput = function QuestionnaireInput(_ref2) {
  var _errors$questionnaire4, _errors$questionnaire5, _errors$questionnaire6;
  var q = _ref2.q;
  var name = "questionnaires." + (q === null || q === void 0 ? void 0 : q.questionId);
  var _useFormContext2 = useFormContext(),
    errors = _useFormContext2.formState.errors;
  var hasError = !!(errors !== null && errors !== void 0 && (_errors$questionnaire4 = errors.questionnaires) !== null && _errors$questionnaire4 !== void 0 && _errors$questionnaire4[q.questionId]);
  return /*#__PURE__*/React__default.createElement(Box, {
    "data-has-error": hasError ? 'true' : 'false'
  }, /*#__PURE__*/React__default.createElement(Input, {
    name: name,
    rules: {
      required: 'This field is required',
      maxLength: {
        value: 255,
        message: 'Max length is 255'
      }
    },
    required: false,
    error: hasError,
    errorText: errors === null || errors === void 0 ? void 0 : (_errors$questionnaire5 = errors.questionnaires) === null || _errors$questionnaire5 === void 0 ? void 0 : (_errors$questionnaire6 = _errors$questionnaire5[q.questionId]) === null || _errors$questionnaire6 === void 0 ? void 0 : _errors$questionnaire6.message,
    "data-question-id": q.questionId
  }));
};
var Questionnaires = function Questionnaires() {
  var _useQuestionnaires = useQuestionnaires(),
    questionnaiers = _useQuestionnaires.data;
  var _useFormContext3 = useFormContext(),
    watch = _useFormContext3.watch,
    _useFormContext3$form = _useFormContext3.formState,
    errors = _useFormContext3$form.errors,
    submitCount = _useFormContext3$form.submitCount;
  var _useNRBState = useNRBState(),
    surface = _useNRBState.surface;
  var scrollStackRef = useRef(null);
  var qualifier2 = watch('qualifier2');
  var qualifier3 = watch('qualifier3');
  var qualifier4 = watch('qualifier4');
  var isNA = [qualifier2, qualifier3, qualifier4].some(function (q) {
    return q === 'NA';
  });
  var filteredQuestionnaiers = useMemo(function () {
    if (isNA) return questionnaiers;
    return questionnaiers === null || questionnaiers === void 0 ? void 0 : questionnaiers.filter(function (q) {
      var _q$original;
      return ((_q$original = q.original) === null || _q$original === void 0 ? void 0 : _q$original['Qualifier 4']) === qualifier4;
    });
  }, [isNA, questionnaiers, qualifier4]);
  useEffect(function () {
    if (submitCount > 0 && errors !== null && errors !== void 0 && errors.questionnaires && scrollStackRef.current) {
      var questionIds = Object.keys(errors.questionnaires);
      if (questionIds.length > 0) {
        setTimeout(function () {
          var _scrollStackRef$curre;
          var errorElement = (_scrollStackRef$curre = scrollStackRef.current) === null || _scrollStackRef$curre === void 0 ? void 0 : _scrollStackRef$curre.querySelector("[data-has-error=\"true\"]");
          if (errorElement) {
            var rowElement = errorElement.closest('tr');
            if (rowElement) {
              rowElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            } else {
              errorElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }
          }
        }, 100);
      }
    }
  }, [submitCount, errors === null || errors === void 0 ? void 0 : errors.questionnaires]);
  return /*#__PURE__*/React__default.createElement(Stack, {
    gridColumn: "span 4",
    gap: "4px",
    "data-field": "questionnaires"
  }, /*#__PURE__*/React__default.createElement(Body, {
    color: surface === 'dark' ? '#fff' : '#000',
    size: "small"
  }, "Questionnaire"), /*#__PURE__*/React__default.createElement(ScrollStack, {
    ref: scrollStackRef,
    gap: "24px",
    border: "0.0625rem  solid #6f7171",
    height: "175px",
    overflowX: "hidden",
    overflowY: "auto",
    borderRadius: "4px",
    paddingInline: "16px"
  }, /*#__PURE__*/React__default.createElement(Table, {
    striped: false,
    bottomLine: "secondary",
    padding: "compact",
    surface: surface
  }, /*#__PURE__*/React__default.createElement(TableHead, {
    bottomLine: "primary"
  }, /*#__PURE__*/React__default.createElement(TableHeader, null, "#"), /*#__PURE__*/React__default.createElement(TableHeader, null, "Question"), /*#__PURE__*/React__default.createElement(TableHeader, null, "Answers")), /*#__PURE__*/React__default.createElement(TableBody, null, filteredQuestionnaiers === null || filteredQuestionnaiers === void 0 ? void 0 : filteredQuestionnaiers.map(function (q, index) {
    return /*#__PURE__*/React__default.createElement(TableRow$1, {
      key: q.question,
      "data-question-id": q.questionId
    }, /*#__PURE__*/React__default.createElement(Cell, null, index + 1), /*#__PURE__*/React__default.createElement(Cell, null, q.question), /*#__PURE__*/React__default.createElement(Cell, null, /*#__PURE__*/React__default.createElement(InputWrapper, null, q.answerType === 'Selection' ? /*#__PURE__*/React__default.createElement(QuestionnairSelect, {
      q: q
    }) : /*#__PURE__*/React__default.createElement(QuestionnaireInput, {
      q: q
    }))));
  })))));
};

var ProblemStreetAddress = function ProblemStreetAddress(_ref) {
  var attrNames = _ref.attrNames,
    disabled = _ref.disabled;
  var isAddressLineInSubmitVira = getAttributeValue(attrNames, 'addressLine');
  return /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 2",
    "data-field": "addressLine"
  }, /*#__PURE__*/React__default.createElement(Input, {
    name: "addressLine",
    label: "Problem Street Address",
    rules: {
      required: 'You must enter a problem street address'
    },
    readOnly: !!isAddressLineInSubmitVira || disabled
  }));
};

var ZipCode = function ZipCode(_ref) {
  var attrNames = _ref.attrNames,
    disabled = _ref.disabled;
  var isZipCodeInSubmitVira = getAttributeValue(attrNames, 'zipCode2');
  return /*#__PURE__*/React__default.createElement(Box, {
    "data-field": "zipCode"
  }, /*#__PURE__*/React__default.createElement(Input, {
    name: "zipCode",
    label: "Zip Code",
    rules: {
      required: 'You must enter a zipcode'
    },
    readOnly: !!isZipCodeInSubmitVira || disabled
  }));
};

var State = function State(_ref) {
  var attrNames = _ref.attrNames,
    disabled = _ref.disabled;
  var isAddressLineInSubmitVira = getAttributeValue(attrNames, 'addressLine');
  var _useFormContext = useFormContext(),
    getValues = _useFormContext.getValues;
  var defaultValue = getValues('state');
  var _useGetValues = useGetValues({
      payload: {
        type: 'State'
      },
      enabled: !isAddressLineInSubmitVira
    }),
    _useGetValues$data = _useGetValues.data,
    states = _useGetValues$data === void 0 ? [] : _useGetValues$data,
    isLoading = _useGetValues.isLoading,
    isValidating = _useGetValues.isValidating,
    error = _useGetValues.error,
    refetch = _useGetValues.mutate;
  var updatedStates = isAddressLineInSubmitVira ? [defaultValue] : states;
  return /*#__PURE__*/React__default.createElement(Box, {
    "data-field": "state"
  }, /*#__PURE__*/React__default.createElement(Select, {
    name: "state",
    label: "State",
    rules: {
      required: 'Select state'
    },
    readOnly: !!isAddressLineInSubmitVira || !!error || isLoading || isValidating || !states.length || disabled,
    isLoading: isLoading || isValidating,
    loadingError: !!error,
    onRefetch: function onRefetch() {
      return refetch();
    }
  }, updatedStates === null || updatedStates === void 0 ? void 0 : updatedStates.map(function (state) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: state,
      value: state
    }, state);
  })));
};

var Country = function Country(_ref) {
  var disabled = _ref.disabled,
    serviceTypesForUSA = _ref.serviceTypesForUSA,
    serviceTypesForNonUSA = _ref.serviceTypesForNonUSA;
  var _useFormContext = useFormContext(),
    watch = _useFormContext.watch;
  var serviceType = watch('serviceType');
  var _useGetValues = useGetValues({
      payload: {
        type: apiTypes.country
      }
    }),
    _useGetValues$data = _useGetValues.data,
    contries = _useGetValues$data === void 0 ? [] : _useGetValues$data,
    isLoading = _useGetValues.isLoading,
    isValidating = _useGetValues.isValidating,
    error = _useGetValues.error,
    refetch = _useGetValues.mutate;
  var isServiceTypeForUSA = serviceTypesForUSA === null || serviceTypesForUSA === void 0 ? void 0 : serviceTypesForUSA.includes(serviceType);
  var restrictedCountries = ['USA', 'INTERNATIONAL WATERS'];
  var isServiceTypeForNonUSA = serviceTypesForNonUSA === null || serviceTypesForNonUSA === void 0 ? void 0 : serviceTypesForNonUSA.includes(serviceType);
  var filteredCountries = isServiceTypeForNonUSA ? contries === null || contries === void 0 ? void 0 : contries.filter(function (c) {
    return !restrictedCountries.includes(c);
  }) : contries;
  return /*#__PURE__*/React__default.createElement(Box, {
    "data-field": "country"
  }, /*#__PURE__*/React__default.createElement(Select, {
    name: "country",
    label: "Country",
    rules: {
      required: 'Select country'
    },
    readOnly: !!error || isLoading || isValidating || !contries.length || disabled || isServiceTypeForUSA,
    isLoading: isLoading || isValidating,
    loadingError: !!error,
    onRefetch: function onRefetch() {
      return refetch();
    }
  }, filteredCountries === null || filteredCountries === void 0 ? void 0 : filteredCountries.map(function (country) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: country,
      value: country
    }, country);
  })));
};

var PhoneModel = function PhoneModel(_ref) {
  var disabled = _ref.disabled;
  var _useFeatureFlag = useFeatureFlag(),
    _useFeatureFlag$data = _useFeatureFlag.data,
    _useFeatureFlag$data2 = _useFeatureFlag$data === void 0 ? {} : _useFeatureFlag$data,
    _useFeatureFlag$data3 = _useFeatureFlag$data2.nrbPhoneModelFFlag,
    nrbPhoneModelFFlag = _useFeatureFlag$data3 === void 0 ? false : _useFeatureFlag$data3;
  var _useGetValues = useGetValues({
      payload: {
        type: apiTypes.phoneModel
      },
      flags: {
        nrbPhoneModelFFlag: nrbPhoneModelFFlag
      }
    }),
    _useGetValues$data = _useGetValues.data,
    models = _useGetValues$data === void 0 ? [] : _useGetValues$data,
    isLoading = _useGetValues.isLoading,
    isValidating = _useGetValues.isValidating,
    error = _useGetValues.error,
    refetch = _useGetValues.mutate;
  var _useFormContext = useFormContext(),
    setValue = _useFormContext.setValue;
  var sortedModels = useMemo(function () {
    return getUniqueValues(models.sort(function (a, b) {
      return a.localeCompare(b);
    }));
  }, [models]);
  var resetDependentFields = function resetDependentFields() {
    var dependentFields = ['handsetSoftwareVersion'];
    dependentFields.forEach(function (field) {
      setValue(field, '', {
        shouldValidate: false,
        shouldDirty: false,
        shouldTouch: false
      });
    });
  };
  var onChange = function onChange(e) {
    resetDependentFields();
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    "data-field": "phoneModel"
  }, /*#__PURE__*/React__default.createElement(Select, {
    name: "phoneModel",
    label: "Device Model",
    rules: {
      required: 'Select device model'
    },
    readOnly: !!error || isLoading || isValidating || !sortedModels.length || disabled,
    isLoading: isLoading || isValidating,
    loadingError: !!error,
    onRefetch: function onRefetch() {
      return refetch();
    },
    onChange: onChange
  }, sortedModels === null || sortedModels === void 0 ? void 0 : sortedModels.map(function (phoneModel) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: phoneModel,
      value: phoneModel
    }, phoneModel);
  })));
};

var SoftwareVersion = function SoftwareVersion(_ref) {
  var disabled = _ref.disabled;
  var _useFormContext = useFormContext(),
    watch = _useFormContext.watch;
  var phoneModel = watch('phoneModel');
  var _useGetValues = useGetValues({
      payload: {
        type: apiTypes.handsetVersion,
        userInput: phoneModel
      },
      enabled: !!phoneModel
    }),
    _useGetValues$data = _useGetValues.data,
    versions = _useGetValues$data === void 0 ? [] : _useGetValues$data,
    isLoading = _useGetValues.isLoading,
    error = _useGetValues.error,
    refetch = _useGetValues.mutate;
  return /*#__PURE__*/React__default.createElement(Box, {
    "data-field": "handsetSoftwareVersion"
  }, /*#__PURE__*/React__default.createElement(Select, {
    name: "handsetSoftwareVersion",
    label: "Software Version",
    readOnly: !versions.length || isLoading || disabled,
    isLoading: isLoading,
    rules: {
      required: 'Select software version'
    },
    loadingError: !!error,
    onRefetch: function onRefetch() {
      return refetch();
    }
  }, versions === null || versions === void 0 ? void 0 : versions.map(function (softwareVersion) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: softwareVersion,
      value: softwareVersion
    }, softwareVersion);
  })));
};

var InBuildingSolution = function InBuildingSolution(_ref) {
  var attrNames = _ref.attrNames,
    disabled = _ref.disabled;
  var _useFormContext = useFormContext(),
    watch = _useFormContext.watch,
    setValue = _useFormContext.setValue;
  var isBuilding = getInBuilding(attrNames);
  var problemType = watch('problemType');
  var _useGetValues = useGetValues({
      payload: {
        type: apiTypes.buildingService
      },
      enabled: isBuilding
    }),
    _useGetValues$data = _useGetValues.data,
    buildingSolutions = _useGetValues$data === void 0 ? [] : _useGetValues$data,
    isLoading = _useGetValues.isLoading,
    error = _useGetValues.error,
    refetch = _useGetValues.mutate;
  var isVZWNE = problemType === null || problemType === void 0 ? void 0 : problemType.includes('VZWNE');
  var resetDependentFields = function resetDependentFields() {
    var dependentFields = ['model'];
    dependentFields.forEach(function (field) {
      setValue(field, '', {
        shouldValidate: false,
        shouldDirty: false,
        shouldTouch: false
      });
    });
  };
  var onChange = function onChange(e) {
    resetDependentFields();
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    "data-field": "inBuildingSolution"
  }, /*#__PURE__*/React__default.createElement(Select, {
    name: "inBuildingSolution",
    label: "In building Solution?",
    readOnly: !buildingSolutions.length || isLoading || disabled || isVZWNE,
    isLoading: isLoading,
    disabled: !isBuilding,
    rules: {
      required: isBuilding && 'Select in building solution'
    },
    onChange: onChange,
    loadingError: !!error,
    onRefetch: function onRefetch() {
      return refetch();
    }
  }, buildingSolutions === null || buildingSolutions === void 0 ? void 0 : buildingSolutions.map(function (inBuildingSolution) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: inBuildingSolution,
      value: inBuildingSolution
    }, inBuildingSolution);
  })));
};

var ModelNumber = function ModelNumber(_ref) {
  var attrNames = _ref.attrNames,
    disabled = _ref.disabled;
  var isBuilding = getInBuilding(attrNames);
  var _useFormContext = useFormContext(),
    watch = _useFormContext.watch,
    trigger = _useFormContext.trigger;
  var inBuildingSolution = watch('inBuildingSolution');
  var _useGetValues = useGetValues({
      payload: {
        type: apiTypes.buildingServiceModel,
        userInput: inBuildingSolution
      },
      enabled: !!inBuildingSolution
    }),
    _useGetValues$data = _useGetValues.data,
    modelNumbers = _useGetValues$data === void 0 ? [] : _useGetValues$data,
    isLoading = _useGetValues.isLoading,
    isFetched = _useGetValues.isFetched;
  var validate = function validate(value) {
    if (!isBuilding) return true;
    if (isBuilding && !isFetched) return false;else return isBuilding && isFetched && modelNumbers.length > 0 ? !!value : true;
  };
  useObjectChange(isFetched ? modelNumbers : undefined, function () {
    if (!isFetched || (modelNumbers === null || modelNumbers === void 0 ? void 0 : modelNumbers.length) > 0) return;
    trigger(['model']);
  });
  return /*#__PURE__*/React__default.createElement(Box, {
    "data-field": "model"
  }, /*#__PURE__*/React__default.createElement(Select, {
    name: "model",
    label: "Model #",
    readOnly: !modelNumbers.length || isLoading || disabled,
    isLoading: isLoading,
    disabled: !isBuilding,
    rules: {
      validate: validate
    }
  }, modelNumbers === null || modelNumbers === void 0 ? void 0 : modelNumbers.map(function (modelNumber) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: modelNumber,
      value: modelNumber
    }, modelNumber);
  })));
};

var CalledNumber = function CalledNumber(_ref) {
  var attrNames = _ref.attrNames,
    disabled = _ref.disabled;
  var _useFeatureFlag = useFeatureFlag(),
    _useFeatureFlag$data = _useFeatureFlag.data,
    _useFeatureFlag$data2 = _useFeatureFlag$data === void 0 ? {} : _useFeatureFlag$data,
    _useFeatureFlag$data3 = _useFeatureFlag$data2.enableCalledNoForServiceTypeFFlag,
    enableCalledNoForServiceTypeFFlag = _useFeatureFlag$data3 === void 0 ? false : _useFeatureFlag$data3;
  var _useFormContext = useFormContext(),
    watch = _useFormContext.watch,
    setValue = _useFormContext.setValue;
  var problemType = watch('problemType');
  var _getCalledNumberState = getCalledNumberState(attrNames, problemType, enableCalledNoForServiceTypeFFlag),
    readOnly = _getCalledNumberState.readOnly,
    _getCalledNumberState2 = _getCalledNumberState.resetCalledNumber,
    resetCalledNumber = _getCalledNumberState2 === void 0 ? false : _getCalledNumberState2;
  if (resetCalledNumber) {
    setValue('calledNumber', '', {
      shouldValidate: false,
      shouldDirty: false,
      shouldTouch: false
    });
  }
  var onChange = function onChange(e) {
    var _e$target;
    var value = (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value;
    if ((value === null || value === void 0 ? void 0 : value.length) === 0) return value;
    var numbersOnly = value.replace(/[^\d]/g, '');
    if (value.length > 15) return numbersOnly.slice(0, 15);
    return numbersOnly;
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    "data-field": "calledNumber"
  }, /*#__PURE__*/React__default.createElement(Input, {
    type: "number",
    name: "calledNumber",
    label: "Called/Calling Number",
    readOnly: readOnly || disabled,
    rules: {
      required: !readOnly && 'You must enter a called/calling number.',
      pattern: {
        value: /^[0-9]*$/,
        message: 'Please enter a valid phone number.'
      },
      maxLength: {
        value: 15,
        message: 'Please enter betweeen 3 and 15 digits'
      },
      minLength: {
        value: 3,
        message: 'Please enter at least 3 digits.'
      }
    },
    onChange: onChange
  }));
};

var CallBackNumber = function CallBackNumber(_ref) {
  var disabled = _ref.disabled;
  var onChange = function onChange(e) {
    var _e$target;
    var value = (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value;
    if ((value === null || value === void 0 ? void 0 : value.length) === 0) return value;
    var numbersOnly = value.replace(/[^\d]/g, '');
    if (value.length > 30) return numbersOnly.slice(0, 30);
    return numbersOnly;
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    "data-field": "callBackNumber"
  }, /*#__PURE__*/React__default.createElement(Input, {
    type: "number",
    name: "callBackNumber",
    label: "Call Back Number",
    readOnly: disabled,
    rules: {
      required: 'You must enter a call back number.',
      pattern: {
        value: /^[0-9]*$/,
        message: 'Please enter a valid phone number.'
      },
      maxLength: {
        value: 30,
        message: 'Please enter betweeen 10 and 30 digits'
      },
      minLength: {
        value: 10,
        message: 'Please enter at least 10 digits.'
      }
    },
    onChange: onChange,
    maxLength: 30
  }));
};

var _templateObject$K;
var DateInput = styled.div(_templateObject$K || (_templateObject$K = _taggedTemplateLiteralLoose(["\n  span {\n    ", "\n  }\n"])), function (_ref) {
  var surface = _ref.surface;
  return surface === 'dark' && 'color: white;';
});
var ProblemStartDate = function ProblemStartDate(_ref2) {
  var disabled = _ref2.disabled;
  var _useNRBState = useNRBState(),
    surface = _useNRBState.surface;
  var onChange = function onChange(e) {
    var value = e.target.value;
    if ((value === null || value === void 0 ? void 0 : value.length) === 0) return value;
    if (value !== null && value !== void 0 && value.match(/[a-zA-Z]/)) {
      return value === null || value === void 0 ? void 0 : value.replace(/\D/g, '');
    }
    return formDate(value);
  };
  return /*#__PURE__*/React__default.createElement(DateInput, {
    surface: surface,
    "data-field": "problemStartDateTime"
  }, /*#__PURE__*/React__default.createElement(Input, {
    name: "problemStartDateTime",
    label: "Problem Start Date",
    type: "date",
    readOnly: disabled,
    rules: {
      required: 'You must enter a problem start date',
      pattern: {
        value: /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/,
        message: 'Please enter a valid date.'
      },
      validate: {
        validateDateRange: validateDateRange
      }
    },
    onChange: onChange,
    dateFormat: "ddmmyyyy"
  }));
};

var _excluded$6 = ["name", "rules"];
var _templateObject$L;
var TextAreaWrapper = styled.div(_templateObject$L || (_templateObject$L = _taggedTemplateLiteralLoose(["\n  mark {\n    padding: 0 !important;\n    visibility:hidden;\n  }\n"])));
var TextArea = function TextArea(_ref) {
  var name = _ref.name,
    rules = _ref.rules,
    textAreaProps = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  var _useNRBState = useNRBState(),
    surface = _useNRBState.surface;
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    rules: rules,
    render: function render(_ref2) {
      var _errors$name;
      var field = _ref2.field,
        errors = _ref2.formState.errors;
      return /*#__PURE__*/React__default.createElement(TextAreaWrapper, null, /*#__PURE__*/React__default.createElement(TextArea$1, _extends({}, field, textAreaProps, {
        error: !!(errors !== null && errors !== void 0 && errors[name]) && !(textAreaProps !== null && textAreaProps !== void 0 && textAreaProps.readOnly) && !(textAreaProps !== null && textAreaProps !== void 0 && textAreaProps.disabled),
        errorText: errors === null || errors === void 0 ? void 0 : (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
        surface: surface
      })));
    }
  });
};

var ProblemDescription = function ProblemDescription(_ref) {
  var disabled = _ref.disabled;
  return /*#__PURE__*/React__default.createElement(Box, {
    gridColumn: "span 4",
    "data-field": "problemDescription"
  }, /*#__PURE__*/React__default.createElement(TextArea, {
    name: "problemDescription",
    label: "Problem Description",
    readOnly: disabled,
    rules: {
      required: 'You must enter a problem description',
      maxLength: {
        value: 1500,
        message: 'Max length is 1500'
      }
    },
    maxLength: 1500
  }));
};

var useSaveFormToSession = function useSaveFormToSession(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    watch = _ref.watch;
  useEffect(function () {
    if (!watch) return;
    var subscription = watch(function (formData) {
      formSession.set(formData);
    });
    return function () {
      return subscription === null || subscription === void 0 ? void 0 : subscription.unsubscribe();
    };
  }, [watch]);
};

var _templateObject$M;
var CustomButton = styled(Button$1)(_templateObject$M || (_templateObject$M = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  color: ", ";\n  opacity: ", ";\n"])), function (props) {
  return props.surface === 'dark' ? '#fff !important' : '#000 !important';
}, function (props) {
  return props.surface === 'dark' ? '#000 !important' : '#fff !important';
}, function (props) {
  return props.disabled ? 0.5 : 1;
});
var NRBForm = function NRBForm(_ref) {
  var _steps$, _steps$2, _steps$2$nrbFormValid, _steps$3, _steps$3$nrbFormValid;
  var showNRBNotification = _ref.showNRBNotification,
    handleTroubleShootingAction = _ref.handleTroubleShootingAction,
    launchAutoCreateFollowUp = _ref.launchAutoCreateFollowUp,
    interactionCaseId = _ref.interactionCaseId,
    steps = _ref.steps,
    configDetails = _ref.configDetails,
    setIsNextBtnEnableNRB = _ref.setIsNextBtnEnableNRB,
    isACSS = _ref.isACSS,
    isDark = _ref.isDark,
    isTrainingMode = _ref.isTrainingMode;
  window.isACSS = isACSS;
  var _useNRBState = useNRBState(),
    mandatoryCallFailed = _useNRBState.mandatoryCallFailed,
    surface = _useNRBState.surface,
    mandatoryCallFetched = _useNRBState.mandatoryCallFetched;
  var dispatch = useNRBDispatch();
  var formRef = useRef(null);
  var caseId = (configDetails === null || configDetails === void 0 ? void 0 : configDetails.caseId) || '';
  var _useFeatureFlag = useFeatureFlag(),
    _useFeatureFlag$data = _useFeatureFlag.data,
    _useFeatureFlag$data2 = _useFeatureFlag$data === void 0 ? {} : _useFeatureFlag$data,
    _useFeatureFlag$data3 = _useFeatureFlag$data2.enableNewNRBFormDesignFFlag,
    enableNewNRBFormDesignFFlag = _useFeatureFlag$data3 === void 0 ? false : _useFeatureFlag$data3;
  useEffect(function () {
    var storedCaseId = sessionCaseId.get();
    if (storedCaseId && storedCaseId !== caseId) {
      formSession.reset();
    }
    sessionCaseId.set(caseId);
  }, [caseId]);
  useEffect(function () {
    dispatch({
      type: 'SET_NRBSTORE',
      payload: {
        surface: isDark ? 'dark' : 'light'
      }
    });
  }, [isDark]);
  var attrNames = (steps === null || steps === void 0 ? void 0 : (_steps$ = steps[0]) === null || _steps$ === void 0 ? void 0 : _steps$.attrNames) || [];
  var serviceTypesForUSA = (steps === null || steps === void 0 ? void 0 : (_steps$2 = steps[0]) === null || _steps$2 === void 0 ? void 0 : (_steps$2$nrbFormValid = _steps$2.nrbFormValidations) === null || _steps$2$nrbFormValid === void 0 ? void 0 : _steps$2$nrbFormValid.serviceTypesForUSA) || [];
  var serviceTypesForNonUSA = (steps === null || steps === void 0 ? void 0 : (_steps$3 = steps[0]) === null || _steps$3 === void 0 ? void 0 : (_steps$3$nrbFormValid = _steps$3.nrbFormValidations) === null || _steps$3$nrbFormValid === void 0 ? void 0 : _steps$3$nrbFormValid.serviceTypesForNonUSA) || [];
  var defaultFormValues = getDefaultFormValues(attrNames, caseId);
  var methods = useForm({
    defaultValues: defaultFormValues
  });
  useSaveFormToSession(methods);
  var _useQuestionnaires = useQuestionnaires(),
    questionnaires = _useQuestionnaires.data;
  var _useSubmitNRBForm = useSubmitNRBForm(caseId),
    trigger = _useSubmitNRBForm.trigger,
    triggerCount = _useSubmitNRBForm.effectiveTriggerCount,
    isMutating = _useSubmitNRBForm.isMutating;
  var disableFormFields = triggerCount > 2;
  useEffect(function () {
    if (triggerCount > 2) {
      showNRBNotification(triggerCount);
      setIsNextBtnEnableNRB(true);
    }
    isTrainingMode && setIsNextBtnEnableNRB(true);
    return function () {
      setIsNextBtnEnableNRB(false);
    };
  }, []);
  var onSubmit = function onSubmit(nrbFormData) {
    try {
      nrbFormData.questionnaires = parseQuestionnaires({
        nrbFormData: nrbFormData,
        questionnaires: questionnaires
      });
      var additionalPayload = additionalPayloadData({
        steps: steps,
        interactionCaseId: interactionCaseId,
        configDetails: configDetails,
        nrbFormData: nrbFormData
      });
      var payload = {
        nrbFormData: nrbFormData,
        data: additionalPayload
      };
      showNRBNotification(false);
      return Promise.resolve(trigger({
        payload: payload
      })).then(function (response) {
        var _ref2 = response || {},
          nrbTicketCaseId = _ref2.nrbTicketCaseId,
          serviceCaseId = _ref2.serviceCaseId;
        if (nrbTicketCaseId) {
          openRemedyPopup(launchAutoCreateFollowUp, {
            interactionCaseId: interactionCaseId,
            caseId: serviceCaseId,
            ticketCaseId: nrbTicketCaseId
          });
          formSession.reset();
          sessionCaseId.reset();
          callSubmitVira(nrbTicketCaseId, handleTroubleShootingAction);
          return;
        }
        if (triggerCount === 1) {
          showNRBNotification(triggerCount);
        } else {
          showNRBNotification(triggerCount);
          setIsNextBtnEnableNRB(true);
          formSession.reset();
          sessionCaseId.reset();
          callSubmitVira(nrbTicketCaseId, handleTroubleShootingAction);
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var onError = function onError(errors) {
    scrollToFirstError(formRef, errors);
  };
  useEffect(function () {
    if (!mandatoryCallFailed) return;
    showNRBNotification(triggerCount);
    setIsNextBtnEnableNRB(true);
  }, [mandatoryCallFailed]);
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Loader$2, {
    active: isMutating,
    fullscreen: false
  }), /*#__PURE__*/React__default.createElement(FormProvider, methods, /*#__PURE__*/React__default.createElement(Form, {
    id: "nrbForm",
    gap: "24px",
    onSubmit: methods.handleSubmit(onSubmit, onError),
    noValidate: true,
    ref: formRef
  }, enableNewNRBFormDesignFFlag ? /*#__PURE__*/React__default.createElement(Grid, {
    gap: "24px",
    gridTemplateColumns: "repeat(4, 1fr)"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    gridColumn: "span 4",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "24px"
  }, /*#__PURE__*/React__default.createElement(ServiceType, {
    disabled: disableFormFields,
    serviceTypesForNonUSA: serviceTypesForNonUSA
  }), /*#__PURE__*/React__default.createElement(ProblemStartDate, {
    disabled: disableFormFields
  }), /*#__PURE__*/React__default.createElement(InBuildingSolution, {
    attrNames: attrNames,
    disabled: disableFormFields
  })), /*#__PURE__*/React__default.createElement(Grid, {
    gridColumn: "span 4",
    gridTemplateColumns: "repeat(5, 1fr)",
    gap: "24px"
  }, /*#__PURE__*/React__default.createElement(ProblemStreetAddress, {
    attrNames: attrNames,
    disabled: disableFormFields
  }), /*#__PURE__*/React__default.createElement(State, {
    attrNames: attrNames,
    disabled: disableFormFields
  }), /*#__PURE__*/React__default.createElement(ZipCode, {
    attrNames: attrNames,
    disabled: disableFormFields
  }), /*#__PURE__*/React__default.createElement(Country, {
    attrNames: attrNames,
    disabled: disableFormFields,
    serviceTypesForUSA: serviceTypesForUSA,
    serviceTypesForNonUSA: serviceTypesForNonUSA
  })), /*#__PURE__*/React__default.createElement(ProblemDescription, {
    disabled: disableFormFields
  })) : /*#__PURE__*/React__default.createElement(Grid, {
    gap: "24px",
    gridTemplateColumns: "repeat(4, 1fr)"
  }, /*#__PURE__*/React__default.createElement(ServiceType, {
    disabled: disableFormFields,
    serviceTypesForNonUSA: serviceTypesForNonUSA
  }), /*#__PURE__*/React__default.createElement(ProblemType, {
    disabled: disableFormFields
  }), /*#__PURE__*/React__default.createElement(Qualifier1, {
    disabled: disableFormFields
  }), /*#__PURE__*/React__default.createElement(Qualifier2, {
    disabled: disableFormFields
  }), /*#__PURE__*/React__default.createElement(Qualifier3, {
    disabled: disableFormFields
  }), /*#__PURE__*/React__default.createElement(Qualifier4, {
    disabled: disableFormFields
  }), /*#__PURE__*/React__default.createElement(Questionnaires, null), /*#__PURE__*/React__default.createElement(Grid, {
    gridColumn: "span 4",
    gridTemplateColumns: "repeat(5, 1fr)",
    gap: "24px"
  }, /*#__PURE__*/React__default.createElement(ProblemStreetAddress, {
    attrNames: attrNames,
    disabled: disableFormFields
  }), /*#__PURE__*/React__default.createElement(State, {
    attrNames: attrNames,
    disabled: disableFormFields
  }), /*#__PURE__*/React__default.createElement(ZipCode, {
    attrNames: attrNames,
    disabled: disableFormFields
  }), /*#__PURE__*/React__default.createElement(Country, {
    attrNames: attrNames,
    disabled: disableFormFields,
    serviceTypesForUSA: serviceTypesForUSA,
    serviceTypesForNonUSA: serviceTypesForNonUSA
  })), /*#__PURE__*/React__default.createElement(PhoneModel, {
    disabled: disableFormFields
  }), /*#__PURE__*/React__default.createElement(SoftwareVersion, {
    disabled: disableFormFields
  }), /*#__PURE__*/React__default.createElement(InBuildingSolution, {
    attrNames: attrNames,
    disabled: disableFormFields
  }), /*#__PURE__*/React__default.createElement(ModelNumber, {
    attrNames: attrNames,
    disabled: disableFormFields
  }), /*#__PURE__*/React__default.createElement(Grid, {
    gridColumn: "span 4",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "24px"
  }, /*#__PURE__*/React__default.createElement(CalledNumber, {
    attrNames: attrNames,
    disabled: disableFormFields
  }), /*#__PURE__*/React__default.createElement(CallBackNumber, {
    disabled: disableFormFields
  }), /*#__PURE__*/React__default.createElement(ProblemStartDate, {
    disabled: disableFormFields
  })), /*#__PURE__*/React__default.createElement(ProblemDescription, {
    disabled: disableFormFields
  })), /*#__PURE__*/React__default.createElement(CustomButton, {
    type: "submit",
    width: "fit-content",
    disabled: !mandatoryCallFetched || triggerCount > 2 || isTrainingMode,
    surface: surface
  }, "Submit"))));
};

var _templateObject$N, _templateObject2$C, _templateObject3$v, _templateObject4$u, _templateObject5$p, _templateObject6$m, _templateObject7$i, _templateObject8$g, _templateObject9$e, _templateObject0$c, _templateObject1$c, _templateObject10$7;
var Wrapper = styled.div(_templateObject$N || (_templateObject$N = _taggedTemplateLiteralLoose(["\n  margin-top: 40 px;\n  text-align: left;\n  position: absolute;\n  "])));
var Msgcontainer = styled.div(_templateObject2$C || (_templateObject2$C = _taggedTemplateLiteralLoose(["\n  border: 1px solid #000;\n  padding: 5px; \n  margin-left: 2%; \n  width: 85%;\n  "])));
var Messagediv = styled.b(_templateObject3$v || (_templateObject3$v = _taggedTemplateLiteralLoose(["\n  font-weight : bold;\n  margin-right: 5%;\n  margin-bottom: 5%;\n  "])));
var Mdndiv = styled.div(_templateObject4$u || (_templateObject4$u = _taggedTemplateLiteralLoose(["\n  margin-left: 5%;\n  "])));
var Msgdiv = styled.div(_templateObject5$p || (_templateObject5$p = _taggedTemplateLiteralLoose(["\n  display: flex;\n  "])));
var Languagediv = styled.div(_templateObject6$m || (_templateObject6$m = _taggedTemplateLiteralLoose(["\n  float: left;\n  display: flex;\n  margin-bottom: 5%;\n "])));
var CheckBox = styled.div(_templateObject7$i || (_templateObject7$i = _taggedTemplateLiteralLoose(["\n  margin-left: 32.5%; \n "])));
var SubmitButton = styled.button(_templateObject8$g || (_templateObject8$g = _taggedTemplateLiteralLoose(["\n display: block;\n margin-top: 20%;\n padding: 10px 20px;\n background-color: black;\n color: white;\n border: none;\n border-radius: 30px;\n cursor: pointer;\n "])));
var RadioGroup = styled.div(_templateObject9$e || (_templateObject9$e = _taggedTemplateLiteralLoose(["\n margin-top: 70px;\n "])));
var RadioLabel = styled.label(_templateObject0$c || (_templateObject0$c = _taggedTemplateLiteralLoose(["\n display: block;\n margin-bottom: 1px;\n "])));
var RadioInput = styled.input(_templateObject1$c || (_templateObject1$c = _taggedTemplateLiteralLoose(["\n margin-right: 10px;\n\n "])));
var Text = styled.div(_templateObject10$7 || (_templateObject10$7 = _taggedTemplateLiteralLoose(["\n margin-bottom: 10px;\n margin-left: 1px;\n\n "])));
var TestMessage = function TestMessage(_ref) {
  var _configDetails$params, _configDetails$params2, _window, _window$troubleShooti, _window$troubleShooti2, _window$troubleShooti3, _window2, _window2$troubleShoot, _window2$troubleShoot2, _window2$troubleShoot3, _configDetails$select, _configDetails$select2;
  var selectedMdn = _ref.selectedMdn,
    setSendMessage = _ref.setSendMessage,
    setLanguageIndicator = _ref.setLanguageIndicator,
    processAction = _ref.processAction,
    pageId = _ref.pageId;
  var _useState = useState(false),
    isSpanish = _useState[0],
    setIsSpanish = _useState[1];
  var _useState2 = useState(false),
    showRadioButtons = _useState2[0],
    setShowRadioButtons = _useState2[1];
  var _useState3 = useState(true),
    showSubmitButton = _useState3[0],
    setshowSubmitButton = _useState3[1];
  var _useState4 = useState(""),
    setIsSMSReceived = _useState4[1];
  var textMessage = isSpanish ? 'MSJE GRATIS de VZW-NO RESPONDAS: Este es un mensaje de prueba de Verizon Wireless.' : 'FREE VZW MSG-DO NOT REPLY: Test message from Verizon Wireless.';
  var language = isSpanish ? "S" : "E";
  var configDetails = useContext(ConfigContext);
  var handleLanguageToggle = function handleLanguageToggle() {
    setIsSpanish(function (prev) {
      return !prev;
    });
  };
  var finalChannel = (configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.channel) == 'CARE' ? 'Care' : configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.channel;
  var envData = {
    externalTarget: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : _configDetails$params.externalTarget,
    mvoenv: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params2 = configDetails.paramsDetails) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.mvoenv
  };
  var _ref2 = sessionStorage.getItem('nsaIntentSelected') ? JSON.parse(sessionStorage.getItem('nsaIntentSelected')) : {},
    intetnFromSession = _ref2.intent,
    intentIdFromSession = _ref2.intentId;
  var params = {
    accountNumber: configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.accountNumber,
    deviceSku: window.isMVODigital ? (configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.sku) || filteredDeviceSku : configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.sku,
    equipmentId: configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.equipmentId,
    deviceType: (_window = window) === null || _window === void 0 ? void 0 : (_window$troubleShooti = _window.troubleShootingJson) === null || _window$troubleShooti === void 0 ? void 0 : (_window$troubleShooti2 = _window$troubleShooti.ddata) === null || _window$troubleShooti2 === void 0 ? void 0 : (_window$troubleShooti3 = _window$troubleShooti2.device) === null || _window$troubleShooti3 === void 0 ? void 0 : _window$troubleShooti3.deviceType,
    is5GDevice: (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$troubleShoot = _window2.troubleShootingJson) === null || _window2$troubleShoot === void 0 ? void 0 : (_window2$troubleShoot2 = _window2$troubleShoot.ddata) === null || _window2$troubleShoot2 === void 0 ? void 0 : (_window2$troubleShoot3 = _window2$troubleShoot2.device) === null || _window2$troubleShoot3 === void 0 ? void 0 : _window2$troubleShoot3.is5GDevice,
    intent: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select = configDetails.selectedNSAIntent) === null || _configDetails$select === void 0 ? void 0 : _configDetails$select.intent) || intetnFromSession,
    intentId: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select2 = configDetails.selectedNSAIntent) === null || _configDetails$select2 === void 0 ? void 0 : _configDetails$select2.intentId) || intentIdFromSession,
    mtn: configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.mdn,
    mtnId: configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.mtnId,
    channelId: finalChannel || 'Care',
    caseId: configDetails === null || configDetails === void 0 ? void 0 : configDetails.caseId,
    tierId: configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.tier,
    processAction: processAction || '',
    processStep: "SendSMS",
    pageId: pageId,
    loggedInUser: configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.loggedInUser,
    indicator: "SMS",
    languageIndicator: language,
    testSMSReceived: "",
    testMMSReceived: ""
  };
  var sendMessage = function sendMessage() {
    try {
      var resp;
      return Promise.resolve(submitActionForTroubleShooting(params, envData)).then(function (_submitActionForTroub) {
        resp = _submitActionForTroub;
        if (resp) {
          setShowRadioButtons(true);
          setshowSubmitButton(false);
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var handleMessageSent = function handleMessageSent(smsReceived) {
    setIsSMSReceived(smsReceived);
    setIsSpanish(false);
    setShowRadioButtons(false);
    setshowSubmitButton(false);
    setSendMessage(smsReceived);
    setLanguageIndicator(language);
  };
  return /*#__PURE__*/React__default.createElement(Wrapper, null, /*#__PURE__*/React__default.createElement(Msgdiv, null, /*#__PURE__*/React__default.createElement(Messagediv, null, "Send to: "), /*#__PURE__*/React__default.createElement(Mdndiv, null, selectedMdn)), /*#__PURE__*/React__default.createElement(Msgdiv, null, /*#__PURE__*/React__default.createElement(Messagediv, null, "Message:"), /*#__PURE__*/React__default.createElement(Msgcontainer, null, textMessage)), /*#__PURE__*/React__default.createElement(Languagediv, null, /*#__PURE__*/React__default.createElement(Messagediv, null, "Spanish "), /*#__PURE__*/React__default.createElement(CheckBox, null, /*#__PURE__*/React__default.createElement("input", {
    type: "checkbox",
    id: "trgTestMessageSpanishChk",
    onChange: handleLanguageToggle,
    checked: isSpanish
  }))), showSubmitButton && /*#__PURE__*/React__default.createElement(SubmitButton, {
    onClick: sendMessage
  }, "Send Message"), showRadioButtons && /*#__PURE__*/React__default.createElement(RadioGroup, null, /*#__PURE__*/React__default.createElement(Text, null, "Was the message received?"), /*#__PURE__*/React__default.createElement(RadioLabel, null, /*#__PURE__*/React__default.createElement(RadioInput, {
    type: "radio",
    name: "options",
    value: "Y",
    onClick: function onClick() {
      return handleMessageSent("Y");
    }
  }), "Yes"), /*#__PURE__*/React__default.createElement(RadioLabel, null, /*#__PURE__*/React__default.createElement(RadioInput, {
    type: "radio",
    name: "options",
    value: "N",
    onClick: function onClick() {
      return handleMessageSent("N");
    }
  }), "No")));
};

var useDeepLinkStore = create(function (set) {
  return {
    openSimDetails: false,
    openProvisioningTab: false,
    openDeviceDetails: false,
    openCallRecordsTab: false,
    openSpeedTest: false,
    openConnectedDevices: false,
    updateOpenSimDetails: function updateOpenSimDetails() {
      return set(function (state) {
        return {
          openSimDetails: !state.openSimDetails
        };
      });
    },
    updateOpenProvisioningTab: function updateOpenProvisioningTab() {
      return set(function (state) {
        return {
          openProvisioningTab: !state.openProvisioningTab
        };
      });
    },
    updateOpenDeviceDetails: function updateOpenDeviceDetails() {
      return set(function (state) {
        return {
          openDeviceDetails: !state.openDeviceDetails
        };
      });
    },
    updateOpenCallRecordsTab: function updateOpenCallRecordsTab() {
      return set(function (state) {
        return {
          openCallRecordsTab: !state.openCallRecordsTab
        };
      });
    },
    updateOpenSpeedTest: function updateOpenSpeedTest() {
      return set(function (state) {
        return {
          openDeviceDetails: !state.openDeviceDetails,
          openSpeedTest: !state.openSpeedTest
        };
      });
    },
    setOpenSpeedTest: function setOpenSpeedTest(val) {
      return set(function () {
        return {
          openSpeedTest: val
        };
      });
    },
    updateOpenConnectedDevices: function updateOpenConnectedDevices() {
      return set(function (state) {
        return {
          openConnectedDevices: !state.openConnectedDevices
        };
      });
    }
  };
});

var _templateObject$O, _templateObject2$D;
var ContentWrapper$8 = styled.div(_templateObject$O || (_templateObject$O = _taggedTemplateLiteralLoose([""])));
var TiletWrapper$1 = styled.div(_templateObject2$D || (_templateObject2$D = _taggedTemplateLiteralLoose(["\n  width:360px;\n  cursor:pointer;\n   [class*=OuterTileContainer-VDS]{\n \n     height:unset !important;\n   }\n"])));
var DeepLinkButton = function DeepLinkButton(_ref) {
  var _paramContextDetails$, _paramContextDetails$2;
  var uniquekey = _ref.uniquekey,
    _ref$actionButton = _ref.actionButton,
    actionButton = _ref$actionButton === void 0 ? {} : _ref$actionButton,
    isDark = _ref.isDark;
  var _ref2 = useFeatureFlag() || {},
    _ref2$data = _ref2.data,
    _ref2$data2 = _ref2$data === void 0 ? {} : _ref2$data,
    _ref2$data2$speedTest = _ref2$data2.speedTestMidFlowCTAFFlag,
    speedTestMidFlowCTAFFlag = _ref2$data2$speedTest === void 0 ? false : _ref2$data2$speedTest,
    _ref2$data2$deepLinkB = _ref2$data2.deepLinkButtonsNewFFlag,
    deepLinkButtonsNewFFlag = _ref2$data2$deepLinkB === void 0 ? false : _ref2$data2$deepLinkB,
    _ref2$data2$marsCtaFF = _ref2$data2.marsCtaFFlag,
    marsCtaFFlag = _ref2$data2$marsCtaFF === void 0 ? false : _ref2$data2$marsCtaFF,
    _ref2$data2$subscribe = _ref2$data2.subscriberLinkFFlag,
    subscriberLinkFFlag = _ref2$data2$subscribe === void 0 ? false : _ref2$data2$subscribe,
    _ref2$data2$fwamovers = _ref2$data2.fwamoversFFlag,
    fwamoversFFlag = _ref2$data2$fwamovers === void 0 ? false : _ref2$data2$fwamovers,
    _ref2$data2$enableInt = _ref2$data2.enableInternetFFlag,
    enableInternetFFlag = _ref2$data2$enableInt === void 0 ? false : _ref2$data2$enableInt,
    _ref2$data2$historyCT = _ref2$data2.historyCTAFFlag,
    historyCTAFFlag = _ref2$data2$historyCT === void 0 ? false : _ref2$data2$historyCT,
    _ref2$data2$connected = _ref2$data2.connectedDevicesCTAFFlag,
    connectedDevicesCTAFFlag = _ref2$data2$connected === void 0 ? false : _ref2$data2$connected;
  var paramContextDetails = useContext(ParamsContext);
  var _actionButton$text = actionButton.text,
    text = _actionButton$text === void 0 ? '' : _actionButton$text,
    _actionButton$value = actionButton.value,
    value = _actionButton$value === void 0 ? '' : _actionButton$value,
    _actionButton$descrip = actionButton.description,
    description = _actionButton$descrip === void 0 ? '' : _actionButton$descrip;
  var _useLoadLinks = useLoadLinks({
      params: {
        channelId: (_paramContextDetails$ = paramContextDetails === null || paramContextDetails === void 0 ? void 0 : (_paramContextDetails$2 = paramContextDetails.paramsDetails) === null || _paramContextDetails$2 === void 0 ? void 0 : _paramContextDetails$2.channelId) != null ? _paramContextDetails$ : "VZW-ACSS"
      }
    }),
    loadLinks = _useLoadLinks.data;
  var updateOpenSimDetails = useDeepLinkStore(function (state) {
    return state.updateOpenSimDetails;
  });
  var updateOpenProvisioningTab = useDeepLinkStore(function (state) {
    return state.updateOpenProvisioningTab;
  });
  var updateOpenCallRecordsTab = useDeepLinkStore(function (state) {
    return state.updateOpenCallRecordsTab;
  });
  var updateOpenDeviceDetails = useDeepLinkStore(function (state) {
    return state.updateOpenDeviceDetails;
  });
  var updateOpenSpeedTest = useDeepLinkStore(function (state) {
    return state.updateOpenSpeedTest;
  });
  var updateOpenConnectedDevices = useDeepLinkStore(function (state) {
    return state.updateOpenConnectedDevices;
  });
  var handleTileClick = function handleTileClick() {
    console.log("clicked");
    if (value === "Launch TechSee") {
      var techSeeLink = getBaseUrlLink(loadLinks, "LINKS_TECHSEE");
      if (techSeeLink) {
        var _paramContextDetails$3;
        var url = encodeURI(techSeeLink + "?r=" + (paramContextDetails === null || paramContextDetails === void 0 ? void 0 : (_paramContextDetails$3 = paramContextDetails.paramsDetails) === null || _paramContextDetails$3 === void 0 ? void 0 : _paramContextDetails$3.acssCallId));
        window.open(url);
      }
    } else if (value === "Network & Provisioning - Provisioning Details") {
      updateOpenProvisioningTab();
    } else if (value === "View SIM Details") {
      updateOpenSimDetails();
    } else if (deepLinkButtonsNewFFlag && value === "View Device Details") {
      updateOpenDeviceDetails();
    } else if (deepLinkButtonsNewFFlag && value === "View Call Records") {
      updateOpenCallRecordsTab();
    } else if (value === "Perform Router Speed Test" && speedTestMidFlowCTAFFlag) {
      updateOpenSpeedTest();
    } else if (value === "Launch MARS" && marsCtaFFlag) {
      var _paramContextDetails$4;
      var width, height;
      paramContextDetails === null || paramContextDetails === void 0 ? void 0 : (_paramContextDetails$4 = paramContextDetails.paramsDetails) === null || _paramContextDetails$4 === void 0 ? void 0 : _paramContextDetails$4.openLaunchoutDialog("Mars", "Mars", width, height, "", "Mars", "{\"forwardedData\": {\"linkClicked\": \"1\"}}");
    } else if (value === "Launch Subscriber View" && subscriberLinkFFlag) {
      var _paramContextDetails$5;
      var _width, _height;
      paramContextDetails === null || paramContextDetails === void 0 ? void 0 : (_paramContextDetails$5 = paramContextDetails.paramsDetails) === null || _paramContextDetails$5 === void 0 ? void 0 : _paramContextDetails$5.openLaunchoutDialog("SubscriberNew", "Subscriber", _width, _height, "", "SubscriberNewView", "");
    } else if (value === "FWA Movers Flow" && fwamoversFFlag) {
      var _paramContextDetails$6;
      paramContextDetails === null || paramContextDetails === void 0 ? void 0 : (_paramContextDetails$6 = paramContextDetails.paramsDetails) === null || _paramContextDetails$6 === void 0 ? void 0 : _paramContextDetails$6.openLaunchoutDialog('FwaMoversOrderComponent', 'FWA - Moving', 2, 2, false, 'FwaMoversOrderComponent');
    } else if (value === "Enable FWA Internet" && enableInternetFFlag) {
      var _paramContextDetails$7;
      paramContextDetails === null || paramContextDetails === void 0 ? void 0 : (_paramContextDetails$7 = paramContextDetails.paramsDetails) === null || _paramContextDetails$7 === void 0 ? void 0 : _paramContextDetails$7.openLaunchoutDialog('EnableInternet', 'Enable Internet', 1, 1, false, 'EnableInternet', "", "", "", "", "", "", "", "", "", true);
    } else if (value === "View Feature History" && historyCTAFFlag) {
      var _paramContextDetails$8;
      paramContextDetails === null || paramContextDetails === void 0 ? void 0 : (_paramContextDetails$8 = paramContextDetails.paramsDetails) === null || _paramContextDetails$8 === void 0 ? void 0 : _paramContextDetails$8.openLaunchoutDialog("featureHistoryView", "Features", 0, 0, "", "featureHistoryView", "", "", "", "", "COMPONENTSEARCH");
    } else if (connectedDevicesCTAFFlag && value === "View Connected Devices") {
      updateOpenConnectedDevices();
    }
  };
  return /*#__PURE__*/React__default.createElement(ContentWrapper$8, {
    className: isDark && 'midflowContentWrapper',
    id: "midflowcontainer-" + uniquekey
  }, /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "30px"
  }), /*#__PURE__*/React__default.createElement(TiletWrapper$1, {
    id: "tilecontainer-" + uniquekey,
    role: "button",
    tabIndex: "0",
    "aria-label": text + " " + description,
    onClick: function onClick() {
      return handleTileClick();
    },
    onKeyPress: function onKeyPress() {
      return handleTileClick();
    },
    "data-analyticstrack": text,
    "data-track": "{\"type\": \"link\", \"name\": " + text + "}",
    "data-clickstream": text + "-link",
    isDark: isDark,
    "data-testid": "tilecontainer-" + uniquekey
  }, /*#__PURE__*/React__default.createElement(Tilelet, {
    id: "tile-" + uniquekey,
    viewport: "mobile",
    title: {
      bold: true,
      size: 'titleSmall',
      children: "" + text,
      primitive: 'h3'
    },
    subtitle: {
      size: 'bodySmall',
      children: "" + description
    },
    directionalIcon: {
      name: 'right-arrow',
      size: 'medium'
    },
    surface: isDark ? 'dark' : 'light',
    aspectRatio: "none",
    width: "360px",
    backgroundColor: isDark ? "black" : "gray"
  })));
};

var getUserProfile = function getUserProfile() {
  try {
    var _ccareLoginResponse$d, _ccareLoginResponse$d2;
    var userProfile = JSON.parse(localStorage.getItem('userprofile'));
    var _ref = userProfile || {},
      userId = _ref.userId,
      departmentId = _ref.departmentId,
      departmentName = _ref.departmentName,
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      userType = _ref.userType,
      serviceRegionId = _ref.serviceRegionId,
      ccareLoginResponse = _ref.ccareLoginResponse;
    var _ref2 = (ccareLoginResponse === null || ccareLoginResponse === void 0 ? void 0 : (_ccareLoginResponse$d = ccareLoginResponse.data) === null || _ccareLoginResponse$d === void 0 ? void 0 : (_ccareLoginResponse$d2 = _ccareLoginResponse$d.ACSSLoginResponse) === null || _ccareLoginResponse$d2 === void 0 ? void 0 : _ccareLoginResponse$d2.PermissionData) || {},
      Last_Comma_First_Name = _ref2.Last_Comma_First_Name,
      Job_Title = _ref2.Job_Title;
    var cachedUserProfile = {
      firstName: firstName,
      lastName: lastName,
      userId: userId,
      userType: userType,
      dataCenter: "",
      departmentId: departmentId,
      departmentName: departmentName,
      serviceRegionId: serviceRegionId,
      jobTitle: Job_Title,
      lastCommaFirstName: Last_Comma_First_Name
    };
    return cachedUserProfile;
  } catch (e) {
    console.error('Error parsing userprofile from local storage', e);
    return {};
  }
};
var buildParams = function buildParams(customerProfile, env, isDark) {
  var cachedUserProfile = getUserProfile();
  var params = {
    channel: "ACSS",
    isTicketList: [],
    directionalTicketList: ["Network"],
    closedTicketList: [],
    env: env,
    isDark: isDark,
    url: window && window.location && window.location.origin + "/acss" || "",
    client: "VZW-ACSS",
    customerProfile: customerProfile,
    config: {
      headers: {
        sso_jwt: ""
      }
    },
    userProfile: {
      cachedUserProfile: cachedUserProfile
    },
    view: "customer",
    defaultFilter: "Open",
    isShowCreateTicketBtn: true,
    isManager: false,
    enableNRBView: true,
    isTroubleshootingFlow: true
  };
  return params;
};
var logUTPMetrix = function logUTPMetrix(data, actionId, logUsageMetrics) {
  var UTPCase = [{
    EVENT_ID: "UTP_TICKET",
    ACTION_ID: actionId,
    NOTES: (data === null || data === void 0 ? void 0 : data.ticketNumber) + "||" + (data === null || data === void 0 ? void 0 : data.caseType) + "||" + (data === null || data === void 0 ? void 0 : data.ticketFrom) + "||" + (data === null || data === void 0 ? void 0 : data.caseStatus) + "||" + (data === null || data === void 0 ? void 0 : data.category) + "||" + (data === null || data === void 0 ? void 0 : data.subCategory)
  }];
  logUsageMetrics({
    metrics: UTPCase
  });
};
var openingCaseDetailsHandler = function openingCaseDetailsHandler(data, customerProfile, UserProfile, openLaunchoutDialog, logUsageMetrics) {
  if ((data === null || data === void 0 ? void 0 : data.ticketFrom) === "Network") {
    var forwardedData = {
      customerInfo: customerProfile,
      userProfile: UserProfile,
      formData: data === null || data === void 0 ? void 0 : data.formData,
      ticketResponse: {
        isUpdateMode: true,
        ticketId: data === null || data === void 0 ? void 0 : data.ticketNumber,
        selectedFormLink: data === null || data === void 0 ? void 0 : data.aemTemplateId
      },
      isViewNRB: true,
      tier: UserProfile === null || UserProfile === void 0 ? void 0 : UserProfile.getSRDeptPermission('ACSS_TROUBLESHOOTING_TIER'),
      ACSS_REMEDY_POST_SERVLET_SSO: UserProfile === null || UserProfile === void 0 ? void 0 : UserProfile.getSessionPermission('ACSS_REMEDY_POST_SERVLET_SSO'),
      ACSS_REMEDY_APPSERVER_SSO: UserProfile === null || UserProfile === void 0 ? void 0 : UserProfile.getSessionPermission('ACSS_REMEDY_APPSERVER_SSO')
    };
    openLaunchoutDialog('utpCreateTicketView', 'Ticket details', 3, 2, false, 'utpCreateTicketView', forwardedData);
    logUTPMetrix(data, "NRB_NATIVE_VIEW_ONLY", logUsageMetrics);
  }
};

var UTPList = function UTPList(_ref) {
  var customerProfile = _ref.customerProfile,
    env = _ref.env,
    isDark = _ref.isDark,
    logUsageMetrics = _ref.logUsageMetrics,
    UserProfile = _ref.UserProfile,
    openLaunchoutDialog = _ref.openLaunchoutDialog;
  var params = buildParams(customerProfile, env, isDark);
  var handleCaseDetails = function handleCaseDetails(ticket) {
    openingCaseDetailsHandler(ticket, customerProfile, UserProfile, openLaunchoutDialog, logUsageMetrics);
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(UTPTickets, {
    params: params,
    openingCaseDetailsHandler: handleCaseDetails
  }));
};

var _templateObject$P;
var InputWrapper$1 = styled.div(_templateObject$P || (_templateObject$P = _taggedTemplateLiteralLoose(["\n    width: 300px\n"])));
var MacIDProbingQuestion = function MacIDProbingQuestion(_ref) {
  var _steps$;
  var steps = _ref.steps,
    question = _ref.question,
    isDark = _ref.isDark,
    handleOptionsChange = _ref.handleOptionsChange;
  var macIdDetails = (steps === null || steps === void 0 ? void 0 : (_steps$ = steps[0]) === null || _steps$ === void 0 ? void 0 : _steps$.macIdDetails) || [];
  var _useState = useState(function () {
      var _steps$2;
      return (steps === null || steps === void 0 ? void 0 : (_steps$2 = steps[0]) === null || _steps$2 === void 0 ? void 0 : _steps$2.userSelection) || '';
    }),
    inputValue = _useState[0],
    setInputValue = _useState[1];
  var _useState2 = useState(false),
    macIdError = _useState2[0],
    setMacIdError = _useState2[1];
  var _useState3 = useState(''),
    macIdErrorMessage = _useState3[0],
    setMacIdErrorMessage = _useState3[1];
  var handleMacIdChange = function handleMacIdChange(e) {
    var value = e.target.value;
    var allowedCharRegex = /^[A-F0-9:]*$/;
    if (!allowedCharRegex.test(value)) {
      setMacIdError(true);
      setMacIdErrorMessage('Please enter valid MAC ID');
    } else {
      setMacIdError(false);
      setMacIdErrorMessage('');
      setInputValue(value);
      handleOptionsChange(e);
    }
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TextWithHtml, null, question), /*#__PURE__*/React__default.createElement(InputWrapper$1, null, macIdDetails.length > 0 ? /*#__PURE__*/React__default.createElement(DropdownSelect, {
    surface: isDark ? 'dark' : 'light',
    onChange: function onChange(e) {
      return handleOptionsChange(e);
    }
  }, /*#__PURE__*/React__default.createElement("option", {
    value: "-1"
  }, "Select Mac ID"), macIdDetails.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: index,
      value: item === null || item === void 0 ? void 0 : item.value
    }, item === null || item === void 0 ? void 0 : item.value);
  })) : /*#__PURE__*/React__default.createElement(Input$1, {
    label: "MAC ID",
    name: "macId",
    type: "text",
    required: true,
    surface: isDark ? 'dark' : 'light',
    value: inputValue,
    error: macIdError,
    errorText: macIdErrorMessage,
    onChange: handleMacIdChange
  })));
};

var _templateObject$Q;
var ParentWrapper = styled.div(_templateObject$Q || (_templateObject$Q = _taggedTemplateLiteralLoose(["\nol.ol.steps>div>li.li.step:has(div[nonvdsbtn=\"true\"]){\n    display: flex;\n    justify-content: space-between;\n    border-bottom-style: solid;\n    border-color: rgb(216, 218, 218);\n    border-width: 2px;\n    min-height: 5rem;\n    padding-bottom: 1rem;\n}\n.font-700{\nfont-weight: 700;\n}\nli.font-700 a{\n  font-weight: 700 !important;\n}\nol.ol.steps>div>li.li.step>div>button[nonvdsbtn=\"true\"]{\n    pointer-events: auto;\n    padding: 0;\n    margin: 0;\n    border-width: 0.0625rem;\n    border-radius: 2.75rem;\n    box-sizing: border-box;\n    cursor: pointer;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    font-size: 1rem;\n    line-height: 1.25rem;\n    font-family: Verizon-NHG-eDS;\n    font-weight: 700;\n    height: auto;\n    position: relative;\n    text-align: center;\n    -webkit-text-decoration: none;\n    text-decoration: none;\n    touch-action: manipulation;\n    vertical-align: middle;\n    width: auto;\n    min-width: 4.75rem;\n    outline: none;\n    -webkit-tap-highlight-color: transparent;\n    white-space: nowrap;\n    font-weight: 700;\n    -webkit-letter-spacing: 0.03125rem;\n    -moz-letter-spacing: 0.03125rem;\n    -ms-letter-spacing: 0.03125rem;\n    letter-spacing: 0.03125rem;\n    background-color: #000000;\n    border: 0.0625rem solid #000000;\n    color: #ffffff;\n\n    height: 2.75rem;\n    width: 100%;\n     text-align: center;\n    display: inline-block;\n}\n.d-none{\n    display: none !important;\n}\n@media screen and (max-width: 600px) {\n ol.ol.steps>div>li.li.step>div>button[nonvdsbtn=\"true\"]{\n    width: 62px;\n    height: 32px;\n    border-radius: 24px;\n    font-size: 12px;\n    margin-left: 12px;\n }\n ol.ol.steps>div>li.li.step>div[nonvdsbtn=\"true\"]>svg{\n    width: 62px;\n    height: 32px;\n }\n\n ol.ol.steps:has(div[nonvdsbtn=\"true\"]){\n    padding-left: 40px !important;\n }\n\nol.ol.steps>div>li.li.step:has(div[nonvdsbtn=\"true\"])::before{\n    left: -45px;\n }\n\n ol.ol.steps>div>li.li.step>div[nonvdsbtn=\"true\"]{\n    /* width: 70px; */\n }\n}\n"])));
var LongPageRedesign = function LongPageRedesign(_ref) {
  var upDateHideNextBtn = _ref.upDateHideNextBtn,
    description = _ref.description;
  useEffect(function () {
    var olListButton = document.querySelector('ol.ol.steps>div>li.li.step>div>button[nonvdsbtn="true"]');
    if (olListButton) {
      upDateHideNextBtn(true);
    }
    window.coreData = window.coreData || [];
    window.coreData.push({
      task: "emit",
      event: "notify",
      params: {
        name: "InitialSetup_step_1",
        message: ""
      }
    });
    var _handleNextStep = function handleNextStep(e) {
      var _listFont$classList, _listFont2$classList, _document$querySelect, _document$querySelect2;
      var countBtn = e.target.getAttribute("btncnt");
      var btnIndex = Number(countBtn);
      var parentBtn = document.querySelector("div[btncnt=\"" + countBtn + "\"]>button");
      parentBtn === null || parentBtn === void 0 ? void 0 : parentBtn.remove();
      var parentDiv = document.querySelector("div[btncnt=\"" + countBtn + "\"]");
      parentDiv.innerHTML = "<svg role=\"img\" aria-hidden=\"false\" aria-label=\"checkmark icon\" width=\"50px\" height=\"50px\" viewBox=\"0 0 21.6 21.6\" fill=\"#000000\" class=\"StyledSVG-VDS__sc-1fane64-0 jMZxYd\"><title>checkmark icon</title><path d=\"M19.74,5.29,7.88,17.15,1.74,11l.84-.84,5.3,5.31,11-11Z\" stroke=\"none\" fill=\"#000000\"></path></svg>";
      var listFont = document.querySelector("ol.ol.steps>div>li.li.step:has(div[btncnt=\"" + countBtn + "\"])");
      listFont === null || listFont === void 0 ? void 0 : (_listFont$classList = listFont.classList) === null || _listFont$classList === void 0 ? void 0 : _listFont$classList.remove("font-700");
      btnIndex = btnIndex + 1 + "";
      var childBtn = document.querySelector("div[btncnt=\"" + btnIndex + "\"]");
      var newBtn = document.createElement('button');
      newBtn.innerText = 'Next';
      newBtn.setAttribute("btncnt", btnIndex);
      newBtn.setAttribute("nonvdsbtn", true);
      newBtn.addEventListener('click', _handleNextStep);
      var listFont2 = document.querySelector("ol.ol.steps>div>li.li.step:has(div[btncnt=\"" + btnIndex + "\"])");
      listFont2 === null || listFont2 === void 0 ? void 0 : (_listFont2$classList = listFont2.classList) === null || _listFont2$classList === void 0 ? void 0 : _listFont2$classList.add("font-700");
      childBtn === null || childBtn === void 0 ? void 0 : childBtn.appendChild(newBtn);
      if (!childBtn) {
        upDateHideNextBtn(false);
      }
      var totalNoOfRows = (_document$querySelect = document.querySelector("ol.ol.steps>div")) === null || _document$querySelect === void 0 ? void 0 : (_document$querySelect2 = _document$querySelect.children) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.length;
      var btnIndexNextStep = Number(btnIndex) + 1;
      if (totalNoOfRows && totalNoOfRows >= btnIndexNextStep) {
        window.coreData = window.coreData || [];
        window.coreData.push({
          task: "emit",
          event: "notify",
          params: {
            name: "InitialSetup_step_" + btnIndexNextStep,
            message: ""
          }
        });
      }
    };
    olListButton === null || olListButton === void 0 ? void 0 : olListButton.addEventListener('click', _handleNextStep);
    return function () {
      if (olListButton) {
        olListButton.removeEventListener('click', _handleNextStep);
      }
    };
  }, []);
  var parser = new DOMParser();
  var parsedElements = parser.parseFromString(description, 'text/html');
  var listOfTsSteps = parsedElements.querySelectorAll('ol.ol.steps>div>li');
  if (listOfTsSteps && listOfTsSteps.length > 0) {
    var count = 0;
    for (var _iterator = _createForOfIteratorHelperLoose(listOfTsSteps), _step; !(_step = _iterator()).done;) {
      var stepItem = _step.value;
      var divElement = document.createElement("div");
      divElement.setAttribute("btncnt", count);
      divElement.setAttribute("nonvdsbtn", true);
      if (count == 0) {
        var nxtBtn = document.createElement("button");
        nxtBtn.innerText = "Next";
        nxtBtn.setAttribute("btncnt", count);
        nxtBtn.setAttribute("nonvdsbtn", true);
        nxtBtn.setAttribute("data-testid", "btnTest");
        divElement.appendChild(nxtBtn);
        stepItem.classList.add("font-700");
      }
      stepItem.appendChild(divElement);
      count = count + 1;
    }
  }
  var htmlTextContent = parsedElements.documentElement.innerHTML;
  var redesignHtml = "<html>${Text}</html>";
  redesignHtml = redesignHtml.replace("${Text}", htmlTextContent);
  return /*#__PURE__*/React__default.createElement(ParentWrapper, null, /*#__PURE__*/React__default.createElement(TextWithHtml, null, redesignHtml));
};

var _templateObject$R, _templateObject2$E, _templateObject3$w, _templateObject4$v, _templateObject5$q, _templateObject6$n, _templateObject7$j, _templateObject8$h, _templateObject9$f, _templateObject0$d, _templateObject1$d, _templateObject10$8, _templateObject11$6, _templateObject12$5, _templateObject13$5;
var isMvaFlow = window._dg_channelId === 'VZW-MFA';
var RowFlexSpaceWrapper = styled.div(_templateObject$R || (_templateObject$R = _taggedTemplateLiteralLoose(["\n   display:flex;\n   flex-direction:column;\n   @media(min-width:1280px){\n    flex-direction:row;\n    justify-content:space-between;\n   }\n   \n"])));
var RowFlexWrapper = styled.div(_templateObject2$E || (_templateObject2$E = _taggedTemplateLiteralLoose(["\n    display:flex;\n   flex-direction:row;\n   \n"])));
var StepsAndTitleSection$1 = styled.div(_templateObject3$w || (_templateObject3$w = _taggedTemplateLiteralLoose(["\n  @media screen and (min-width:601px) {\n      margin-bottom: 32px !important;\n    }\n \n"])));
var NewPageTitleDigital$1 = styled.div(_templateObject4$v || (_templateObject4$v = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  @media screen and (min-width:601px) {\n    position: relative;\n    margin-left: 0px;\n    display: flex;\n    align-items: center;\n  }\n  @media screen and (max-width:600px) {\n    width: 100%;\n  }\n"])));
var FeedbackSaveExitContainerWrapper = styled.div(_templateObject5$q || (_templateObject5$q = _taggedTemplateLiteralLoose([""])));
var FlexContainer$1 = styled.div(_templateObject6$n || (_templateObject6$n = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n"])));
var TileContainerWrapper = styled.div(_templateObject7$j || (_templateObject7$j = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background-color: ", ";\n  border-radius: 8px;\n  padding: 10px;\n  padding-top: 0px;\n  cursor: pointer;\n   [class*='OuterTileContainer-VDS'] {\n     height: unset !important;\n   }\n\n  ", "\n"])), function (props) {
  return props.isDark ? 'rgb(27, 29, 31)' : '#F6F6F6';
}, function (props) {
  return props.isDark && 'border: 1px solid #fff;';
});
var TopPadder$1 = styled.div(_templateObject8$h || (_templateObject8$h = _taggedTemplateLiteralLoose(["\n  padding-top: 5px;\n"])));
var ArrowDiv = styled.div(_templateObject9$f || (_templateObject9$f = _taggedTemplateLiteralLoose(["\n  padding-top: 5px;\n  padding-right: 10px;\n"])));
var ShopChargerIssueDescription = styled.span(_templateObject0$d || (_templateObject0$d = _taggedTemplateLiteralLoose(["\n  font-family: 'Verizon-NHG-eTX' !important;\n"])));
var RowFlex = styled.div(_templateObject1$d || (_templateObject1$d = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"])));
var CustomTooltip$3 = styled(Tooltip)(_templateObject10$8 || (_templateObject10$8 = _taggedTemplateLiteralLoose(["\n  [class^='DialogWrapper-VDS__sc-33el4z-0'] {\n    left: -90px;\n  }\n  [class^='DialogWrapper-VDS__sc-33el4z-0']::before {\n    left: 94%;\n  }\n\n  [class^='persistentScrollbar'] {\n    left: -90px;\n  }\n  [class^='persistentScrollbar']::before {\n    left: 94%;\n  }\n"])));
var FeedbackBannerWrapper = styled.div(_templateObject11$6 || (_templateObject11$6 = _taggedTemplateLiteralLoose(["\n  margin-bottom: ", ";\n   margin-right: ", ";\n  @media (max-width: 768px) {\n    margin-bottom: ", ";\n  }\n\n  #bgSuccess * {\n    ", "\n  }\n  #bgError * {\n    ", "\n  }\n"])), function (props) {
  return props !== null && props !== void 0 && props.isDigital ? "32px" : "0px";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.isRetail) && "30px";
}, function (props) {
  return props !== null && props !== void 0 && props.isDigital ? "24px" : "0px";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.isDark) && 'background-color: rgb(0, 53, 20);';
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.isDark) && 'background-color: rgb(86, 23, 1);';
});
var IconBannerWrapper = styled.div(_templateObject12$5 || (_templateObject12$5 = _taggedTemplateLiteralLoose(["\n margin-right:", "\n"])), function (props) {
  return (props === null || props === void 0 ? void 0 : props.isRetail) && "30px";
});
var finalComps$4 = {
  styles: styledComps
};
if (window.isBAUACSS) {
  finalComps$4 = {
    styles: styledBauComps
  };
}
if (window.isMVODigital) {
  finalComps$4 = {
    styles: styledDigital
  };
}
var _finalComps$styles$3 = finalComps$4.styles,
  ProvisioningChecksInfo$3 = _finalComps$styles$3.ProvisioningChecksInfo,
  ProvisioningChecksTable$3 = _finalComps$styles$3.ProvisioningChecksTable,
  ContentWrapper$9 = _finalComps$styles$3.ContentWrapper,
  ButtonWrapper$9 = _finalComps$styles$3.ButtonWrapper,
  ButtonWrapperMobile$4 = _finalComps$styles$3.ButtonWrapperMobile,
  TextWrapper$3 = _finalComps$styles$3.TextWrapper,
  TroubleShootingTitle$3 = _finalComps$styles$3.TroubleShootingTitle,
  TitleTextWrapper$3 = _finalComps$styles$3.TitleTextWrapper,
  HeadingWrapper$3 = _finalComps$styles$3.HeadingWrapper,
  PageTitle$4 = _finalComps$styles$3.PageTitle,
  TabsContainer$4 = _finalComps$styles$3.TabsContainer,
  StepContainer$4 = _finalComps$styles$3.StepContainer,
  StepInfoContainer$5 = _finalComps$styles$3.StepInfoContainer,
  IssuesContainer$3 = _finalComps$styles$3.IssuesContainer,
  MapWrapper$3 = _finalComps$styles$3.MapWrapper,
  FeedbackCloseButton$6 = _finalComps$styles$3.FeedbackCloseButton,
  StyledModal$8 = _finalComps$styles$3.StyledModal,
  StyledModalBody$7 = _finalComps$styles$3.StyledModalBody,
  DescWrapper$3 = _finalComps$styles$3.DescWrapper,
  Probing$5 = _finalComps$styles$3.Probing,
  StyledTableHeader$3 = _finalComps$styles$3.StyledTableHeader,
  StyledCell$3 = _finalComps$styles$3.StyledCell,
  StyledTable$3 = _finalComps$styles$3.StyledTable,
  BoldText$3 = _finalComps$styles$3.BoldText,
  ButtonContainer$3 = _finalComps$styles$3.ButtonContainer,
  StyledModalPopup$3 = _finalComps$styles$3.StyledModalPopup,
  StyledCheckbox$3 = _finalComps$styles$3.StyledCheckbox,
  ContentBody$3 = _finalComps$styles$3.ContentBody,
  FootnoteBlock$3 = _finalComps$styles$3.FootnoteBlock,
  CopyIconDiv$3 = _finalComps$styles$3.CopyIconDiv,
  EmailIconDiv$3 = _finalComps$styles$3.EmailIconDiv,
  SmsIconDiv$3 = _finalComps$styles$3.SmsIconDiv,
  ResumeEmailIconDiv$3 = _finalComps$styles$3.ResumeEmailIconDiv,
  FeedbackSaveExitContainer$4 = _finalComps$styles$3.FeedbackSaveExitContainer,
  SaveExitCloseButton$5 = _finalComps$styles$3.SaveExitCloseButton,
  Footer$4 = _finalComps$styles$3.Footer,
  HeaderTabContainer$4 = _finalComps$styles$3.HeaderTabContainer,
  NavStepsContainer$5 = _finalComps$styles$3.NavStepsContainer,
  NavStepsWrapper$3 = _finalComps$styles$3.NavStepsWrapper,
  TroubleShootingTitleNew$4 = _finalComps$styles$3.TroubleShootingTitleNew,
  NewPageTitle$4 = _finalComps$styles$3.NewPageTitle,
  DescWrapperNew$3 = _finalComps$styles$3.DescWrapperNew,
  DropdownWrapper$3 = _finalComps$styles$3.DropdownWrapper,
  BillingSteps$3 = _finalComps$styles$3.BillingSteps,
  IconDownloadEmail$3 = _finalComps$styles$3.IconDownloadEmail,
  TilesContainer$3 = _finalComps$styles$3.TilesContainer,
  ButtonDiv$2 = _finalComps$styles$3.ButtonDiv,
  HeadingSpan$3 = _finalComps$styles$3.HeadingSpan,
  CustomContentDiv$3 = _finalComps$styles$3.CustomContentDiv,
  DescInnerWrapper$3 = _finalComps$styles$3.DescInnerWrapper,
  DescBodyWrapper$3 = _finalComps$styles$3.DescBodyWrapper,
  NetworkCongestion$3 = _finalComps$styles$3.NetworkCongestion,
  SelectDeviceBannerDiv$1 = _finalComps$styles$3.SelectDeviceBannerDiv,
  SpanTag$1 = _finalComps$styles$3.SpanTag,
  StyledNumberInput$3 = _finalComps$styles$3.StyledNumberInput,
  RightArrowDiv$3 = _finalComps$styles$3.RightArrowDiv,
  TiletContainer$3 = _finalComps$styles$3.TiletContainer,
  TechCoachBody$4 = _finalComps$styles$3.TechCoachBody,
  CloseIconWrapper$4 = _finalComps$styles$3.CloseIconWrapper,
  CloseButtonIconContainer$4 = _finalComps$styles$3.CloseButtonIconContainer,
  PopupCloseButton$3 = _finalComps$styles$3.PopupCloseButton,
  CloseButtonHitArea$4 = _finalComps$styles$3.CloseButtonHitArea,
  IconContainer$4 = _finalComps$styles$3.IconContainer,
  CloseIconSVG$4 = _finalComps$styles$3.CloseIconSVG;
var isEligibleForResumeEmail = function isEligibleForResumeEmail(step, navHistory) {
  if (step === void 0) {
    step = {};
  }
  if (navHistory === void 0) {
    navHistory = [];
  }
  var _step = step,
    _step$templateId = _step.templateId,
    templateId = _step$templateId === void 0 ? '' : _step$templateId,
    _step$title = _step.title,
    title = _step$title === void 0 ? '' : _step$title;
  var templates = ['WAITING_FOR_RESPONSE', 'RESOLUTION_OPTIONS_ALL'];
  var hasArticle = navHistory.findIndex(function (item) {
    return item.articleId;
  });
  return templates.includes(templateId) || title.includes('End of Troubleshooting') || hasArticle == -1;
};
var renderMessageModalBody = function renderMessageModalBody(modalParams) {
  return /*#__PURE__*/React__default.createElement(Fragment, null, modalParams.heading && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Title, {
    size: "medium"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, modalParams.heading)), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "20px"
  })), modalParams.description && /*#__PURE__*/React__default.createElement(Body, {
    size: "large"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, modalParams.description)));
};
var renderMessageModal = function renderMessageModal(modalParams, handleModalAction) {
  return /*#__PURE__*/React__default.createElement(MessageModal, {
    body: renderMessageModalBody(modalParams),
    handleAction: modalParams.handleAction,
    id: "instructions_modal",
    showModal: modalParams.show,
    styles: {
      height: '400px'
    },
    title: modalParams.title
  });
};
var renderDelphiBanner = function renderDelphiBanner(eligibleTemplates, templateId, steps) {
  if (eligibleTemplates === void 0) {
    eligibleTemplates = '';
  }
  if (templateId === void 0) {
    templateId = '';
  }
  if (steps === void 0) {
    steps = [];
  }
  var eligibleIds = eligibleTemplates.split(',');
  var _steps = steps,
    firstStep = _steps[0];
  var _ref = firstStep || {},
    _ref$delphiBannerAttr = _ref.delphiBannerAttrs,
    delphiBannerAttrs = _ref$delphiBannerAttr === void 0 ? [] : _ref$delphiBannerAttr;
  if (delphiBannerAttrs.length) return false;
  return !window.isMVODigital || window.isMVODigital && eligibleIds.includes(templateId);
};
var dropdownSelectedOption;
var selectedUrlOption;
var popupContent;
var feedbackStatusObj$1 = {
  feedbackSent: false
};
var handleMapData = function handleMapData(e, setLongitude, setLatitude, setAddressLine, setBtnValue) {
  if (e.data !== undefined && e.data.selectedLocation !== undefined) {
    console.log('MAp Data', e.data);
    var removeUndefinedPrefix = function removeUndefinedPrefix(str) {
      if (typeof str === 'string' && str.startsWith('undefined')) {
        return str.replace(/^undefined\s*/, '');
      }
      return str;
    };
    var _ref2 = e.data || {},
      _ref2$selectedLocatio = _ref2.selectedLocation,
      _ref2$selectedLocatio2 = _ref2$selectedLocatio === void 0 ? {} : _ref2$selectedLocatio,
      _ref2$selectedLocatio3 = _ref2$selectedLocatio2.longitude,
      longitude = _ref2$selectedLocatio3 === void 0 ? '' : _ref2$selectedLocatio3,
      _ref2$selectedLocatio4 = _ref2$selectedLocatio2.latitude,
      latitude = _ref2$selectedLocatio4 === void 0 ? '' : _ref2$selectedLocatio4,
      _ref2$selectedLocatio5 = _ref2$selectedLocatio2.addressLine,
      rawAddressLine = _ref2$selectedLocatio5 === void 0 ? '' : _ref2$selectedLocatio5;
    var addressLine = removeUndefinedPrefix(rawAddressLine);
    setLongitude(longitude);
    setLatitude(latitude);
    setAddressLine(addressLine);
    setBtnValue(false);
  }
};
var TroubleShootingNewPage = function TroubleShootingNewPage(props) {
  var _configDetails$params3, _configDetails$params4, _troubleShootingInfo$, _troubleShootingInfo$2, _configDetails$config, _troubleShootingInfo$4, _mvoTroubleShootingJs, _mvoTroubleShootingJs2, _mvoTroubleShootingJs3, _resolution, _resolution2, _resolution3, _resolution4, _props$values3, _steps$, _steps$2, _steps$3, _steps$4, _configDetails$config2, _configDetails$config3, _analysis$isHowToCont, _steps$filter$, _steps$filter$2, _questions$, _questions$$question, _steps$5, _resolution8, _configDetails$params12, _configDetails$params13, _configDetails$caseDe4, _configDetails$select6, _selectedIntent2, _configDetails$params38, _networkCongestionSte, _networkCongestionSte2, _window25, _window27, _configDetails$params47, _configDetails$params48, _configDetails$params49, _window$config, _configDetails$config5, _configDetails$params50, _configDetails$params51, _configDetails$params52, _configDetails$params53, _values$feedbackConta, _mvoTroubleShootingJs4, _mvoTroubleShootingJs5, _configDetails$params54, _configDetails$params55, _configDetails$params56, _configDetails$params57, _configDetails$params58, _configDetails$params59, _configDetails$params60, _configDetails$params61, _configDetails$params62, _configDetails$params63, _configDetails$params64, _configDetails$params65, _emailModal$FName, _configDetails$params66, _configDetails$params67, _emailModal$emailId, _configDetails$params68, _configDetails$params69, _emailModal$FName2, _emailModal$emailId2, _configDetails$params70, _configDetails$params71, _step$waitStepDetails, _configDetails$params72, _configDetails$params73, _configDetails$params74, _configDetails$params75, _configDetails$params76, _configDetails$params77, _configDetails$params78, _configDetails$params79, _configDetails$params80, _configDetails$params81, _configDetails$params82, _configDetails$params83, _configDetails$params84, _configDetails$params85, _configDetails$params86, _configDetails$params87, _configDetails$params88, _configDetails$params117, _configDetails$params118, _configDetails$params119, _configDetails$params120, _configDetails$params121, _configDetails$params122, _window28, _configDetails$params123, _configDetails$params124, _linksArray, _configDetails$params139, _configDetails$params140, _configDetails$params141, _configDetails$params142, _configDetails$params143, _configDetails$params144, _configDetails$params145, _configDetails$params146, _configDetails$params147, _configDetails$params148, _configDetails$params149, _configDetails$params150, _configDetails$params151, _configDetails$params152, _configDetails$params153, _configDetails$params154, _configDetails$params155, _resolution9, _resolution0, _configDetails$params156, _configDetails$params157, _configDetails$params158, _configDetails$params159, _resolution1, _resolution10, _configDetails$params190, _configDetails$params191, _configDetails$params192, _resolution11, _configDetails$params193, _configDetails$params194, _resolution12, _configDetails$params195, _configDetails$params196, _configDetails$params197, _configDetails$params198, _configDetails$params199, _configDetails$params200, _configDetails$params201, _configDetails$params202, _configDetails$params203, _configDetails$params204, _configDetails$params205, _configDetails$params206, _configDetails$params207, _configDetails$params208, _configDetails$params209, _configDetails$params210;
  console.log('comren', 'TroubleShootingNewPage', props);
  var debouncedgenerator = useDebounce(handleMapData, 100);
  useEffect(function () {
    if (window && window.vzdl && window.vzdl.error && window.vzdl.error.code) {
      window.vzdl.error.code = '';
      delete window.vzdl.error;
    }
  }, []);
  var handleDynamicCta = function handleDynamicCta(e, element) {
    try {
      var _configDetails$params, _configDetails$params2;
      e.preventDefault();
      var envData = {
        externalTarget: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : _configDetails$params.externalTarget,
        mvoenv: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params2 = configDetails.paramsDetails) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.mvoenv
      };
      var ctaURI = element.href;
      var reqParam = {
        contentUrl: ctaURI
      };
      return Promise.resolve(getDynamicCtaResponse(reqParam, envData)).then(function (dynamicCtaResponse) {
        var _dynamicCtaResponse$c = dynamicCtaResponse.content,
          content = _dynamicCtaResponse$c === void 0 ? '' : _dynamicCtaResponse$c;
        if (content) {
          setCtaResponse(dynamicCtaResponse);
          setTimeout(function () {
            setAttachHandler(true);
          }, 0);
        }
        setShowKBDocModal(true);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var stepInputRef = useRef(null);
  var configDetails = useContext(ConfigContext);
  var paramsContext = useContext(ParamsContext);
  var uiLoggerContext = useContext(UiLoggerContext);
  var _useContext = useContext(ModalContext),
    _useContext$additiona = _useContext.additionalInfoSteps,
    additionalInfoSteps = _useContext$additiona === void 0 ? [] : _useContext$additiona;
  var _useState = useState(true),
    btnValue = _useState[0],
    setBtnValue = _useState[1];
  var _useState2 = useState('ai'),
    aiSummaryLoaded = _useState2[0],
    setAISummaryLoaded = _useState2[1];
  var _useState3 = useState(false),
    showInstructions = _useState3[0],
    setShowInstructions = _useState3[1];
  var _useState4 = useState(false),
    showConfirmationModal = _useState4[0],
    setConfirmationModal = _useState4[1];
  var _useState5 = useState(false),
    popHtmlContent = _useState5[0],
    setPopHtmlContent = _useState5[1];
  var _useState6 = useState(''),
    selectedCtaValue = _useState6[0],
    setSelectedCtaValue = _useState6[1];
  var _useState7 = useState(false),
    showKBDocModal = _useState7[0],
    setShowKBDocModal = _useState7[1];
  var _useState8 = useState({}),
    ctaResponse = _useState8[0],
    setCtaResponse = _useState8[1];
  var _useState9 = useState(false),
    setAttachHandler = _useState9[1];
  var _useState0 = useState(''),
    setSelectedIssueOption = _useState0[1];
  var _useState1 = useState(false),
    isNextBtnEnableNRB = _useState1[0],
    setIsNextBtnEnableNRB = _useState1[1];
  var _ref3 = paramsContext || {},
    _ref3$paramsDetails = _ref3.paramsDetails,
    paramsDetails = _ref3$paramsDetails === void 0 ? {} : _ref3$paramsDetails;
  var isACSS = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params3 = configDetails.paramsDetails) === null || _configDetails$params3 === void 0 ? void 0 : _configDetails$params3.channel) === 'CARE' || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params4 = configDetails.paramsDetails) === null || _configDetails$params4 === void 0 ? void 0 : _configDetails$params4.channel) === 'Prepay';
  var _sessionUtility$getMv = sessionUtility.getMvoConfig(),
    _sessionUtility$getMv2 = _sessionUtility$getMv.delphiSiteSurveySummaryIds,
    delphiSiteSurveySummaryIds = _sessionUtility$getMv2 === void 0 ? '' : _sessionUtility$getMv2,
    _sessionUtility$getMv3 = _sessionUtility$getMv.enableDelphiBannerIds,
    enableDelphiBannerIds = _sessionUtility$getMv3 === void 0 ? '' : _sessionUtility$getMv3;
  var _ref4 = configDetails || {},
    _ref4$paramsDetails = _ref4.paramsDetails,
    _ref4$paramsDetails2 = _ref4$paramsDetails === void 0 ? {} : _ref4$paramsDetails,
    _ref4$paramsDetails2$ = _ref4$paramsDetails2.otherContent,
    _ref4$paramsDetails2$2 = _ref4$paramsDetails2$ === void 0 ? {} : _ref4$paramsDetails2$,
    _ref4$paramsDetails2$3 = _ref4$paramsDetails2$2.configData,
    _ref4$paramsDetails2$4 = _ref4$paramsDetails2$3 === void 0 ? {} : _ref4$paramsDetails2$3,
    _ref4$paramsDetails2$5 = _ref4$paramsDetails2$4.enableUserSelectionValidation,
    enableUserSelectionValidation = _ref4$paramsDetails2$5 === void 0 ? true : _ref4$paramsDetails2$5;
  var _ref5 = configDetails || {},
    _ref5$config = _ref5.config,
    _ref5$config2 = _ref5$config === void 0 ? {} : _ref5$config,
    _ref5$config2$enableU = _ref5$config2.enableUserSelectionValidation,
    validationFlag = _ref5$config2$enableU === void 0 ? true : _ref5$config2$enableU;
  console.log('configContext in TSNEW', configDetails);
  console.log('enableUserSelectionValidation in digital', enableUserSelectionValidation);
  console.log('enableUserSelectionValidation in ACSS', validationFlag);
  var _useState10 = useState({
      showModal: false,
      expandModal: false,
      modalType: ''
    }),
    modalValues = _useState10[0],
    setModalValues = _useState10[1];
  var _useState11 = useState({
      showThumbsUp: false,
      showThumbsDown: false,
      thumbsClicked: false,
      submitClicked: false,
      rating: ''
    }),
    flags = _useState11[0],
    setFlags = _useState11[1];
  var _useState12 = useState({
      bannerContainerDetails: {
        show: false,
        templateId: ''
      },
      success: false
    }),
    bannerValues = _useState12[0],
    setBannerValues = _useState12[1];
  var _useState13 = useState(''),
    bannerNameUpdate = _useState13[0],
    setBannerNameUpdate = _useState13[1];
  var _useState14 = useState([]),
    rightMenuItems = _useState14[0],
    setRightMenuItems = _useState14[1];
  var _useState15 = useState(''),
    resoltionRedirectURI = _useState15[0],
    setResolutionRedirectURI = _useState15[1];
  var showBillingChecksButton = false;
  var _props$values = props.values,
    values = _props$values === void 0 ? {} : _props$values,
    _props$functions = props.functions,
    functions = _props$functions === void 0 ? {} : _props$functions;
  var _useState16 = useState(''),
    longitude = _useState16[0],
    setLongitude = _useState16[1];
  var _useState17 = useState(''),
    latitude = _useState17[0],
    setLatitude = _useState17[1];
  var _useState18 = useState(''),
    addressLine = _useState18[0],
    setAddressLine = _useState18[1];
  var _useFeatureFlag = useFeatureFlag(),
    _useFeatureFlag$data = _useFeatureFlag.data,
    _useFeatureFlag$data2 = _useFeatureFlag$data === void 0 ? {} : _useFeatureFlag$data,
    _useFeatureFlag$data3 = _useFeatureFlag$data2.vzmapCoordinatesFFlag,
    vzmapCoordinatesFFlag = _useFeatureFlag$data3 === void 0 ? false : _useFeatureFlag$data3,
    _useFeatureFlag$data4 = _useFeatureFlag$data2.deepLinkButtonsFFlag,
    deepLinkButtonsFFlag = _useFeatureFlag$data4 === void 0 ? false : _useFeatureFlag$data4,
    _useFeatureFlag$data5 = _useFeatureFlag$data2.enableMacIDPQFFlag,
    enableMacIDPQFFlag = _useFeatureFlag$data5 === void 0 ? false : _useFeatureFlag$data5,
    _useFeatureFlag$data6 = _useFeatureFlag$data2.enableNewDesignForCNSPagesFFlag,
    enableNewDesignForCNSPagesFFlag = _useFeatureFlag$data6 === void 0 ? false : _useFeatureFlag$data6;
  var history = useHistory();
  console.log('******values******');
  console.log(values);
  var _values$landingInfo = values.landingInfo,
    landingInfo = _values$landingInfo === void 0 ? {} : _values$landingInfo,
    _values$symptom = values.symptom,
    symptom = _values$symptom === void 0 ? {} : _values$symptom,
    _values$troubleShooti = values.troubleShootingInfo,
    troubleShootingInfo = _values$troubleShooti === void 0 ? {} : _values$troubleShooti,
    _values$thumbsDownSub = values.thumbsDownSubmittedStep,
    thumbsDownSubmittedStep = _values$thumbsDownSub === void 0 ? false : _values$thumbsDownSub;
  var output = getObjectPropertyByPath('ddata.output', troubleShootingInfo, {});
  var context = getObjectPropertyByPath('context', troubleShootingInfo, {});
  var pageIdentifier = (_troubleShootingInfo$ = troubleShootingInfo === null || troubleShootingInfo === void 0 ? void 0 : (_troubleShootingInfo$2 = troubleShootingInfo.context) === null || _troubleShootingInfo$2 === void 0 ? void 0 : _troubleShootingInfo$2.lineInfo[0].pageIdentifier) != null ? _troubleShootingInfo$ : '';
  var _troubleShootingInfo$3 = troubleShootingInfo.selectedMdn,
    selectedMdn = _troubleShootingInfo$3 === void 0 ? '' : _troubleShootingInfo$3;
  var _output$pageContent = output.pageContent,
    pageContent = _output$pageContent === void 0 ? {} : _output$pageContent,
    _output$navHist = output.navHist,
    navHist = _output$navHist === void 0 ? [] : _output$navHist,
    symptomList = output.symptomList,
    currentPageId = output.currentPageId,
    prevStepEnabled = output.prevStepEnabled,
    nextStepEnabled = output.nextStepEnabled,
    midFlowSigninUrl = output.midFlowSigninUrl;
  var _pageContent$steps = pageContent.steps,
    steps = _pageContent$steps === void 0 ? [] : _pageContent$steps;
  var _landingInfo$device = landingInfo.device,
    device = _landingInfo$device === void 0 ? {} : _landingInfo$device;
  var deviceName = device.deviceName;
  var mvoTroubleShootingJson = sessionUtility.getTroubleShootingJson();
  var smsFFlag = getFeatureFlag(configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config = configDetails.config) === null || _configDetails$config === void 0 ? void 0 : _configDetails$config.featureFlagList, 'smsFFlag');
  var _useFeatureFlag2 = useFeatureFlag(),
    _useFeatureFlag2$data = _useFeatureFlag2.data,
    _useFeatureFlag2$data2 = _useFeatureFlag2$data === void 0 ? {} : _useFeatureFlag2$data,
    _useFeatureFlag2$data3 = _useFeatureFlag2$data2.enableTRGFFlag,
    enableTRGFFlag = _useFeatureFlag2$data3 === void 0 ? false : _useFeatureFlag2$data3;
  var isSmartPhone = sessionStorage.getItem("isSmartPhone");
  var processAction = troubleShootingInfo === null || troubleShootingInfo === void 0 ? void 0 : (_troubleShootingInfo$4 = troubleShootingInfo.context) === null || _troubleShootingInfo$4 === void 0 ? void 0 : _troubleShootingInfo$4.processAction;
  var routesArr = location.hash.split('/');
  var is5GDevice = (_mvoTroubleShootingJs = mvoTroubleShootingJson === null || mvoTroubleShootingJson === void 0 ? void 0 : (_mvoTroubleShootingJs2 = mvoTroubleShootingJson.ddata) === null || _mvoTroubleShootingJs2 === void 0 ? void 0 : (_mvoTroubleShootingJs3 = _mvoTroubleShootingJs2.device) === null || _mvoTroubleShootingJs3 === void 0 ? void 0 : _mvoTroubleShootingJs3.is5GDevice) != null ? _mvoTroubleShootingJs : false;
  console.log('routes array in apiconfig--is5G', is5GDevice);
  console.log(routesArr.includes('eotsecure'));
  if (routesArr.includes('eotsecure')) {
    is5GDevice = false;
  }
  var analysis = steps[0] || {};
  var linksArray = [];
  var dropdownArray = [];
  var deviceReplacementEotFlowTileIndex = -1;
  var deviceReplacementMidFlowTileIndex = -1;
  var deviceReplacementBottomTileIndex = -1;
  console.log('@@@@@@@@@@@@@@analysis');
  console.log(values);
  console.log(output);
  console.log(steps);
  console.log(analysis);
  var resolution = getStepByName('resolution', steps);
  console.log('@@@@@@@@@@@@@@resolution');
  console.log(resolution);
  if (Object.keys(resolution).length == 0) {
    if (steps.length > 1) {
      resolution = steps[1];
    }
  }
  var errFname = false;
  var _useState19 = useState(errFname),
    errFNameFlag = _useState19[0],
    setErrFNameFlag = _useState19[1];
  var errEmail = false;
  var _useState20 = useState(errEmail),
    errEmailIdFlag = _useState20[0],
    setErrEmailIdFlag = _useState20[1];
  useEffect(function () {
    setErrFNameFlag(errFname);
    setErrEmailIdFlag(errEmail);
  }, [analysis === null || analysis === void 0 ? void 0 : analysis.custFirstName, analysis === null || analysis === void 0 ? void 0 : analysis.custEmailId, (_resolution = resolution) === null || _resolution === void 0 ? void 0 : _resolution.custFirstName, (_resolution2 = resolution) === null || _resolution2 === void 0 ? void 0 : _resolution2.customerEmailId]);
  var _useState21 = useState({
      FName: (analysis === null || analysis === void 0 ? void 0 : analysis.custFirstName) || ((_resolution3 = resolution) === null || _resolution3 === void 0 ? void 0 : _resolution3.custFirstName) || '',
      emailId: (analysis === null || analysis === void 0 ? void 0 : analysis.custEmailId) || ((_resolution4 = resolution) === null || _resolution4 === void 0 ? void 0 : _resolution4.customerEmailId) || '',
      errFNameTxt: '',
      errEmailIdTxt: '',
      show: false
    }),
    emailModal = _useState21[0],
    setEmailModal = _useState21[1];
  var _useState22 = useState(false),
    showResumeEmail = _useState22[0],
    setShowResumeEmail = _useState22[1];
  var _useState23 = useState(''),
    subProcessStep = _useState23[0],
    setSubProcessStep = _useState23[1];
  var solutionSource = '';
  if (Object.keys(resolution).includes('solutionSource')) {
    var _resolution5;
    solutionSource = (_resolution5 = resolution) === null || _resolution5 === void 0 ? void 0 : _resolution5.solutionSource;
  }
  if (!solutionSource && Object.keys(analysis).includes('solutionSource')) {
    solutionSource = analysis === null || analysis === void 0 ? void 0 : analysis.solutionSource;
  }
  console.log({
    solutionSource: solutionSource,
    analysis: analysis,
    resolution: resolution
  });
  useEffect(function () {
    var _props$values2;
    setFlags(_extends({}, flags, props === null || props === void 0 ? void 0 : (_props$values2 = props.values) === null || _props$values2 === void 0 ? void 0 : _props$values2.flags));
  }, [props === null || props === void 0 ? void 0 : (_props$values3 = props.values) === null || _props$values3 === void 0 ? void 0 : _props$values3.flags]);
  var isEotScreen = resolution.eotFlag || analysis.eotFlag;
  var arrArticleId = steps.filter(function (step) {
    return step.articleId;
  });
  var arrArticleUrl = steps.filter(function (step) {
    return step.articleUrl;
  });
  var arrArticleName = steps.filter(function (step) {
    return step.articleName;
  });
  var arrCJCMSku = steps.filter(function (step) {
    return step.CJCMSku;
  });
  var arrShowcopyUrl = steps.filter(function (step) {
    return step.showCopyUrlIcon;
  });
  var arrSendEmailUrl = steps.filter(function (step) {
    return step.showSendMailIcon;
  });
  var resumeEmailSteps = steps.filter(function (step) {
    return step.showSendResumeMailIcon;
  });
  var articleId = arrArticleId.length && arrArticleId[0].articleId;
  var articleUrl = arrArticleUrl.length && arrArticleUrl[0].articleUrl;
  var articleName = arrArticleName.length && arrArticleName[0].articleName;
  var emailSent = (steps === null || steps === void 0 ? void 0 : (_steps$ = steps[0]) === null || _steps$ === void 0 ? void 0 : _steps$.emailSent) || (steps === null || steps === void 0 ? void 0 : (_steps$2 = steps[1]) === null || _steps$2 === void 0 ? void 0 : _steps$2.emailSent);
  var smsSent = (steps === null || steps === void 0 ? void 0 : (_steps$3 = steps[0]) === null || _steps$3 === void 0 ? void 0 : _steps$3.smsSent) || (steps === null || steps === void 0 ? void 0 : (_steps$4 = steps[1]) === null || _steps$4 === void 0 ? void 0 : _steps$4.smsSent);
  var CJCMSku = arrCJCMSku.length && arrCJCMSku[0].CJCMSku;
  var arrCustomerEmailId = steps.filter(function (step) {
    return step.custEmailId;
  });
  var customerEmailId = (arrCustomerEmailId === null || arrCustomerEmailId === void 0 ? void 0 : arrCustomerEmailId.length) && arrCustomerEmailId[0].custEmailId;
  console.log('articleId, articleUrl, articleName, emailSent, smsSent', articleId, articleUrl, articleName, emailSent, smsSent);
  useEffect(function () {
    if (emailSent != 'SUCCESS') {
      setBannerValues(_extends({}, bannerValues, {
        bannerContainerDetails: {
          show: false
        }
      }));
    }
  }, [analysis]);
  useEffect(function () {
    var _resolution6, _resolution7;
    setEmailModal(_extends({}, emailModal, {
      FName: (analysis === null || analysis === void 0 ? void 0 : analysis.custFirstName) || ((_resolution6 = resolution) === null || _resolution6 === void 0 ? void 0 : _resolution6.custFirstName) || '',
      emailId: (analysis === null || analysis === void 0 ? void 0 : analysis.custEmailId) || ((_resolution7 = resolution) === null || _resolution7 === void 0 ? void 0 : _resolution7.custEmailId) || ''
    }));
    var bannerTemplateId;
    var smsResponse;
    var emailResponse;
    emailSent == 'SUCCESS' ? emailResponse = 'SEND_EMAIL_SUCCESS' : emailResponse = 'SEND_EMAIL_FAILURE';
    smsSent == 'SUCCESS' ? smsResponse = 'SEND_SMS_SUCCESS' : smsResponse = 'SEND_SMS_FAIL';
    bannerTemplateId = smsSent == 'SUCCESS' || smsSent == '' ? smsResponse : emailResponse;
    (emailSent == 'SUCCESS' || emailSent == '' || smsSent == 'SUCCESS' || smsSent == '') && setBannerValues(_extends({}, bannerValues, {
      bannerContainerDetails: {
        show: true,
        templateId: bannerTemplateId
      }
    }));
  }, [analysis === null || analysis === void 0 ? void 0 : analysis.custFirstName, analysis === null || analysis === void 0 ? void 0 : analysis.custEmailId, smsSent, emailSent]);
  var templateTypeMain = analysis.templateType || '';
  var templateIdMain = analysis.templateId || '';
  console.log('isNewTemplate', configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config2 = configDetails.config) === null || _configDetails$config2 === void 0 ? void 0 : _configDetails$config2.isNewTemplate, !is5GDevice);
  var isNewDesign = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config3 = configDetails.config) === null || _configDetails$config3 === void 0 ? void 0 : _configDetails$config3.isNewTemplate) && !is5GDevice;
  if (window.isMVODigital && routesArr.includes('midflowsecure')) {
    var _configDetails$config4;
    isNewDesign = configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config4 = configDetails.config) === null || _configDetails$config4 === void 0 ? void 0 : _configDetails$config4.isNewTemplate;
  }
  var hideRightNav = templateTypeMain == 'searchsupportcontent' || templateTypeMain == 'deviceforums' || templateTypeMain == 'reviewtechbulletin';
  var isHowToContent = (_analysis$isHowToCont = analysis === null || analysis === void 0 ? void 0 : analysis.isHowToContent) != null ? _analysis$isHowToCont : false;
  var instructions = getStepByName('instructions', steps);
  var buttons = resolution.cta || analysis.cta || [];
  var eotFlag = resolution.eotFlag || analysis.eotFlag;
  sessionStorage.setItem('eotFlag', eotFlag);
  if (eotFlag && window.isMVODigital && (templateIdMain == 'RESOLUTION_OPTIONS_ALL_DIGITAL' || templateIdMain == 'RESOLUTION_OPTIONS_GUEST_DIGITAL' || templateIdMain == 'RESOLUTION_OPTIONS_RECOMMEND_AUTH_DGTAL' || templateIdMain == 'RESOLUTION_OPTIONS_CHANGE_DEVICE_DIGITAL')) {
    eotFlag = false;
  }
  var newFootNote = (_steps$filter$ = steps.filter(function (step) {
    return step === null || step === void 0 ? void 0 : step.footnote;
  })[0]) === null || _steps$filter$ === void 0 ? void 0 : _steps$filter$.footnote;
  var questions = (_steps$filter$2 = steps.filter(function (step) {
    return step === null || step === void 0 ? void 0 : step.questions;
  })[0]) === null || _steps$filter$2 === void 0 ? void 0 : _steps$filter$2.questions;
  var probingStep = steps.filter(function (step) {
    return step === null || step === void 0 ? void 0 : step.questions;
  })[0] || {};
  var recommendationType = '';
  steps === null || steps === void 0 ? void 0 : steps.forEach(function (step) {
    if (!isEmpty(step) && !isEmpty(step === null || step === void 0 ? void 0 : step.recommendation)) {
      recommendationType = step.recommendation.toLowerCase();
    }
  });
  var _probingStep$imageDet = probingStep.imageDetails,
    imageDetails = _probingStep$imageDet === void 0 ? [] : _probingStep$imageDet;
  console.log('questions', questions);
  var showFeedback = questions ? questions !== null && questions !== void 0 && (_questions$ = questions[0]) !== null && _questions$ !== void 0 && (_questions$$question = _questions$.question) !== null && _questions$$question !== void 0 && _questions$$question.length ? false : (analysis === null || analysis === void 0 ? void 0 : analysis.templateId) === "DO_YOU_HAVE_AN_ADDITIONAL_WORKING_CHARGER" ? false : true : true;
  var userSelection = '';
  console.log('values.selectedIssueOptionStep===' + values.selectedIssueOptionStep);
  if (values.selectedIssueOptionStep && values.selectedIssueOptionStep !== '') {
    userSelection = values.selectedIssueOptionStep;
  } else {
    userSelection = resolution.userSelection || analysis.userSelection || '';
  }
  var questionObj = questions && questions[0] || {};
  var choices = questionObj.choices,
    question = questionObj.question;
  var isImageProb = templateTypeMain === 'PROBING_QUESTIONS_IMAGE';
  linksArray = choices;
  if (choices && choices.length > 3 && !isImageProb) {
    linksArray = choices.slice(1, 5);
    dropdownArray = choices.slice(5);
    dropdownArray.unshift({
      text: 'Select Other Resolutions',
      value: '-1'
    });
  }
  if (choices && !isImageProb && resolution.templateType !== 'PROBING_QUESTIONS_IMAGE' && choices.length > 3 && choices.find(function (choice) {
    return choice.value == -1;
  }) == undefined) {
    choices.unshift({
      text: 'Please Select',
      value: '-1'
    });
  }
  var topLinksArray = choices && choices.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.showCTATop) === true;
  }) || [];
  var bottomLinksArray = choices && choices.length ? choices.map(function (item) {
    var _item$text;
    var itemName = !isEmpty(item === null || item === void 0 ? void 0 : item.text) ? item === null || item === void 0 ? void 0 : (_item$text = item.text) === null || _item$text === void 0 ? void 0 : _item$text.toLowerCase() : '';
    if (itemName.includes('network compatibility') && item.recommended) {
      return item;
    } else if (!itemName.includes('network extender') && !itemName.includes('network compatibility')) {
      return item;
    }
  }).filter(function (choice) {
    return !isEmpty(choice) && choice.showCTATop == false;
  }) : [];
  var disabledBtnNext = false;
  var disabledBtnPrev = false;
  if (!prevStepEnabled) {
    disabledBtnPrev = true;
  }
  if (!nextStepEnabled) {
    disabledBtnNext = true;
  }
  if (isACSS && vzmapCoordinatesFFlag && analysis.templateId === "MAP_PROBLEM_LOC_NEXT" && !!!longitude && !!!latitude) {
    disabledBtnNext = true;
  }
  if (isACSS && (steps === null || steps === void 0 ? void 0 : (_steps$5 = steps[1]) === null || _steps$5 === void 0 ? void 0 : _steps$5.templateId) === "MID_FLOW_REMEDY") {
    disabledBtnNext = true;
  }
  var recommendationAvailable = false;
  if (topLinksArray !== null && topLinksArray !== void 0 && topLinksArray.length) {
    topLinksArray === null || topLinksArray === void 0 ? void 0 : topLinksArray.filter(function (topLinkTile, index) {
      if (topLinkTile.recommended) {
        recommendationAvailable = true;
        return;
      }
    });
  }
  if (eotFlag) {
    disabledBtnNext = true;
    disabledBtnPrev = true;
    sessionStorage.removeItem('nsaIntentSelected');
  }
  if (templateTypeMain === 'waitscreen') {
    disabledBtnNext = true;
    disabledBtnPrev = true;
  }
  console.log('analysis.templateId===', analysis.templateId);
  if (analysis.templateId === 'RESOLUTION_OPTIONS_ALL_DIGITAL' || ((_resolution8 = resolution) === null || _resolution8 === void 0 ? void 0 : _resolution8.templateId) == 'RESOLUTION_OPTIONS_ALL_DIGITAL') {
    disabledBtnNext = true;
  }
  if (analysis.templateId === 'DEVICE_REPLACEMENT_OPTIONS') {
    disabledBtnNext = false;
  }
  var getRecommendedOffered = function getRecommendedOffered() {
    var getNoteText = '';
    if (!isEmpty(questions) && questions.length > 0 && !isEmpty(questions[0].choices)) {
      var _choices = questions[0].choices;
      for (var choiceCount = 0; _choices.length > choiceCount; choiceCount++) {
        var choice = _choices[choiceCount];
        if (!isEmpty(choice.recommended) && choice.recommended && choice.note !== null && choice.note !== undefined && !isEmpty(choice.note)) {
          getNoteText = choice.note;
        }
      }
    }
    return getNoteText;
  };
  var getRecommendedTile = function getRecommendedTile() {
    var recommendedTile = '';
    if (!isEmpty(questions) && questions.length > 0 && !isEmpty(questions[0].choices)) {
      var _choices2 = questions[0].choices;
      for (var choiceCount = 0; _choices2.length > choiceCount; choiceCount++) {
        var choice = _choices2[choiceCount];
        if (!isEmpty(choice.recommended) && choice.recommended && !isEmpty(choice.text)) {
          recommendedTile = choice.text;
          break;
        }
      }
    }
    var contentEOTFragment = recommendedTile;
    if (sessionStorage.getItem('propositionNBX') !== null && sessionStorage.getItem('propositionNBX') !== undefined) {
      var propositionNBX = JSON.parse(sessionStorage.getItem('propositionNBX'));
      var _propositionNBX$soiEn = propositionNBX.soiEngagementId,
        soiEngagementId = _propositionNBX$soiEn === void 0 ? '' : _propositionNBX$soiEn,
        _propositionNBX$propo = propositionNBX.propositionId,
        propositionId = _propositionNBX$propo === void 0 ? '' : _propositionNBX$propo;
      var soiEngagementIdValue = '';
      var propositionIdValue = '';
      if (soiEngagementId !== '') {
        soiEngagementIdValue = 'soiid_' + soiEngagementId;
      }
      if (propositionId !== '') {
        propositionIdValue = 'propid_' + propositionId;
      }
      contentEOTFragment = "L1|P1|||" + soiEngagementIdValue + "|" + propositionIdValue + "|dispid_82||" + recommendedTile;
    }
    return contentEOTFragment;
  };
  var updateOmniDlObject = function updateOmniDlObject() {
    try {
      console.log('updateOmniDlObject--start--window.vzdl--', window.vzdl);
      return Promise.resolve(sessionUtility.getCaseDetails()).then(function (tsCaseDetails) {
        var _configDetails$select, _configDetails$select2, _window, _window$localStorage, _window2, _window2$troubleShoot, _window2$troubleShoot2, _window3, _window4, _window5, _window5$troubleShoot, _window5$troubleShoot2, _window5$troubleShoot3, _window6, _window8, _configDetails$params5, _configDetails$params8;
        console.log('sessionStorage==', sessionStorage);
        console.log('isBAUACSS: ' + window.isBAUACSS);
        console.log('case details: ' + tsCaseDetails);
        console.log('current page id: ' + currentPageId);
        var isMVA = window._dg_channelId === 'VZW-MFA';
        var issueName = (tsCaseDetails === null || tsCaseDetails === void 0 ? void 0 : tsCaseDetails.intent) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select = configDetails.selectedNSAIntent) === null || _configDetails$select === void 0 ? void 0 : _configDetails$select.intent);
        var symptomId = (tsCaseDetails === null || tsCaseDetails === void 0 ? void 0 : tsCaseDetails.intentId) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select2 = configDetails.selectedNSAIntent) === null || _configDetails$select2 === void 0 ? void 0 : _configDetails$select2.intentId);
        var isFwaIntentPage = false;
        if (window.isMVODigital) {
          var getTroubleshootParams = JSON.parse(sessionStorage.getItem('troubleshootingDetails'));
          issueName = getTroubleshootParams !== null && getTroubleshootParams !== void 0 && getTroubleshootParams.intent ? getTroubleshootParams === null || getTroubleshootParams === void 0 ? void 0 : getTroubleshootParams.intent : '';
          symptomId = getTroubleshootParams !== null && getTroubleshootParams !== void 0 && getTroubleshootParams.intentId ? getTroubleshootParams === null || getTroubleshootParams === void 0 ? void 0 : getTroubleshootParams.intentId : '';
          isFwaIntentPage = getTroubleshootParams !== null && getTroubleshootParams !== void 0 && getTroubleshootParams.isFwaIntentPage ? getTroubleshootParams === null || getTroubleshootParams === void 0 ? void 0 : getTroubleshootParams.isFwaIntentPage : '';
        }
        var stepTitle = analysis.title;
        var selectedFromSearch = (_window = window) === null || _window === void 0 ? void 0 : (_window$localStorage = _window.localStorage) === null || _window$localStorage === void 0 ? void 0 : _window$localStorage.getItem('selectedFromSearch');
        var eventValue = eotFlag ? 'event116' : (currentPageId === null || currentPageId === void 0 ? void 0 : currentPageId.toString()) === '2' ? 'event117' : '';
        var eventId = eventValue;
        if (selectedFromSearch === 'y') {
          if (eventValue !== '') {
            eventId = eventValue + ',event12';
          } else eventId = 'event12';
        }
        if (window.isMVODigital && (resolution.eotFlag || analysis.eotFlag)) {
          eventId = 'event116';
        }
        var _ref6 = ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$troubleShoot = _window2.troubleShootingJson) === null || _window2$troubleShoot === void 0 ? void 0 : (_window2$troubleShoot2 = _window2$troubleShoot.ddata) === null || _window2$troubleShoot2 === void 0 ? void 0 : _window2$troubleShoot2.device) || {},
          deviceSku = _ref6.deviceSku;
        var subFlow = '';
        if (!!((_window3 = window) !== null && _window3 !== void 0 && _window3.oemdevice) && !!deviceSku) {
          subFlow = oemdevice + "_" + deviceSku;
        } else console.log('missing oemdevice or deviceSku');
        var isFwaIntentPageFlag = isFwaIntentPage == 'true' || isFwaIntentPage === true ? true : false;
        var isflow = ((_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.isFwa) || ((_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$troubleShoot = _window5.troubleShootingJson) === null || _window5$troubleShoot === void 0 ? void 0 : (_window5$troubleShoot2 = _window5$troubleShoot.ddata) === null || _window5$troubleShoot2 === void 0 ? void 0 : (_window5$troubleShoot3 = _window5$troubleShoot2.device) === null || _window5$troubleShoot3 === void 0 ? void 0 : _window5$troubleShoot3.isFwa) || isFwaIntentPageFlag;
        var flow = isflow ? 'troubleshooting_asistant_fwa' : 'troubleshooting_asistant_mobile';
        if (analysis.templateId === 'NETWORK_EXTENDER_OFFER' || resolution.templateId === 'NETWORK_EXTENDER_OFFER') {
          flow = 'Network troubleshooting assistant';
          subFlow = 'Mobile troubleshooting assistant';
        }
        var mvoConfig = sessionUtility.getMvoConfig();
        var source = solutionSource !== undefined && solutionSource !== null ? solutionSource.trim() : '';
        source = !isEmpty(solutionSource) ? solutionSource : window.isMVODigital ? 'Vira' : solutionSource;
        var displayChannel = isMVA ? 'mva' : 'vzw';
        var sourceChannel = isMVA ? 'mva' : "vzw_" + source;
        var linkName = isMVA ? 'Troubleshooting' : '';
        var id = currentPageId !== null && currentPageId !== undefined ? currentPageId === null || currentPageId === void 0 ? void 0 : currentPageId.toString() : '';
        var pageTypeLinkname = isMVA ? id + '|' + stepTitle : '';
        if (mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isAcss) {
          displayChannel = 'ACSS';
          sourceChannel = 'ACSS';
        }
        var pageName = 'trouble shooting';
        if (!((_window6 = window) !== null && _window6 !== void 0 && _window6.isBAUACSS) && !!pageName && !!subFlow && !!currentPageId) {
          var _window7, _window7$vzdl, _window7$vzdl$target;
          var engagementObj = ((_window7 = window) === null || _window7 === void 0 ? void 0 : (_window7$vzdl = _window7.vzdl) === null || _window7$vzdl === void 0 ? void 0 : (_window7$vzdl$target = _window7$vzdl.target) === null || _window7$vzdl$target === void 0 ? void 0 : _window7$vzdl$target.engagement) || {};
          if (window.isMVODigital) {
            if (isEotScreen && recommendationAvailable) {
              engagementObj.offered = getRecommendedOffered();
            } else {
              engagementObj.offered = "";
            }
          }
          var targetObj = setVzdlTargetobj(engagementObj);
          tagging.setPageView({
            page: {
              name: pageName,
              subFlow: subFlow,
              url: document.URL,
              sourceChannel: sourceChannel,
              displayChannel: displayChannel,
              flow: flow,
              linkName: linkName,
              id: id,
              pageTypeLinkname: pageTypeLinkname,
              contentFragments: isEotScreen && recommendationAvailable ? getRecommendedTile() : ''
            },
            support: {
              issueNumber: symptomId,
              tsaIssueName: issueName,
              tsaStepName: stepTitle + '_' + currentPageId
            },
            event: {
              value: eventId
            },
            target: _extends({}, targetObj)
          });
        }
        var trgDetails = JSON.parse(sessionStorage.getItem('troubleshootingDetails'));
        var popOutFlow = true;
        console.log('-----trg details----', trgDetails);
        if ((_window8 = window) !== null && _window8 !== void 0 && _window8.isBAUACSS && pageRef.current != currentPageId) {
          var troubleshootingDeviceJson = JSON.parse(sessionStorage.getItem('troubleshootingDevice'));
          var channelSession = troubleshootingDeviceJson === null || troubleshootingDeviceJson === void 0 ? void 0 : troubleshootingDeviceJson.channelSession;
          solutionSource = solutionSource && solutionSource.trim();
          var taggingData = {
            page: {
              channel: (trgDetails === null || trgDetails === void 0 ? void 0 : trgDetails.channel) === 'Retail' ? 'Support' : 'ACSS',
              displayChannel: (trgDetails === null || trgDetails === void 0 ? void 0 : trgDetails.channel) === 'Retail' ? 'Retail' : 'ACSS',
              sourceChannel: (trgDetails === null || trgDetails === void 0 ? void 0 : trgDetails.channel) === 'Retail' ? "POS_" + solutionSource : solutionSource ? "ACSS_" + solutionSource : 'ACSS_Vira|Delphi',
              detail: '',
              flow: (trgDetails === null || trgDetails === void 0 ? void 0 : trgDetails.channel) === 'Retail' ? "troubleshooter| POS_pop out| " + (trgDetails === null || trgDetails === void 0 ? void 0 : trgDetails.category) + "| " + issueName : "troubleshooter| ACSS_pop out| " + (trgDetails === null || trgDetails === void 0 ? void 0 : trgDetails.category) + "| " + issueName,
              subFlow: typeof troubleshootingDeviceJson !== 'undefined' && troubleshootingDeviceJson.deviceName + "_" + troubleshootingDeviceJson.deviceSku,
              throttle: 'NSA',
              name: "ts| " + (trgDetails === null || trgDetails === void 0 ? void 0 : trgDetails.category) + "| " + issueName + "| " + currentPageId + "| " + stepTitle,
              url: document.URL
            },
            support: {
              issueNumber: symptomId,
              tsaIssueName: issueName,
              tsaStepName: stepTitle
            },
            event: {
              value: eventId
            },
            target: {
              engagement: {
                intent: 'support'
              }
            },
            env: {
              businessUnit: 'Wireless'
            },
            txn: {
              agentRole: 'Rep',
              agent: trgDetails === null || trgDetails === void 0 ? void 0 : trgDetails.userId
            }
          };
          if (channelSession) {
            taggingData.page.channelSession = channelSession;
          }
          tagging.setPageView(taggingData, true, popOutFlow);
        } else if ((configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params5 = configDetails.paramsDetails) === null || _configDetails$params5 === void 0 ? void 0 : _configDetails$params5.channel) == 'CARE' && pageRef.current != currentPageId) {
          var _configDetails$params6, _configDetails$params7;
          var _deviceName, _deviceSku;
          popOutFlow = false;
          _deviceSku = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params6 = configDetails.paramsDetails) === null || _configDetails$params6 === void 0 ? void 0 : _configDetails$params6.sku) || '';
          _deviceName = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params7 = configDetails.paramsDetails) === null || _configDetails$params7 === void 0 ? void 0 : _configDetails$params7.deviceName) || '';
          var categoryTitle = sessionStorage.getItem('categoryTitle') || '';
          solutionSource = solutionSource && solutionSource.trim();
          tagging.setPageView({
            page: {
              channel: 'ACSS',
              displayChannel: 'ACSS',
              sourceChannel: solutionSource ? "ACSS_" + solutionSource : 'ACSS_Vira|Delphi',
              detail: '',
              flow: "troubleshooter| ACSS_embedded| " + categoryTitle + "| " + issueName,
              subFlow: _deviceName + "_" + _deviceSku,
              throttle: 'NSA',
              name: "ts| " + categoryTitle + "| " + issueName + "| " + currentPageId + "| " + stepTitle,
              url: document.URL
            },
            support: {
              issueNumber: symptomId || '',
              tsaIssueName: issueName || '',
              tsaStepName: stepTitle || ''
            },
            event: {
              value: eventId || ''
            },
            target: {
              engagement: {
                intent: 'support'
              }
            },
            env: {
              businessUnit: 'Wireless'
            },
            txn: {
              agentRole: 'Rep'
            }
          }, true, popOutFlow);
        } else if ((configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params8 = configDetails.paramsDetails) === null || _configDetails$params8 === void 0 ? void 0 : _configDetails$params8.channel) == 'Retail' && pageRef.current != currentPageId) {
          var _configDetails$params9, _configDetails$params0, _window$config$soeGui, _window9, _window9$config, _window0, _window0$config;
          var _deviceName2, _deviceSku2;
          popOutFlow = false;
          _deviceSku2 = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params9 = configDetails.paramsDetails) === null || _configDetails$params9 === void 0 ? void 0 : _configDetails$params9.sku) || '';
          _deviceName2 = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params0 = configDetails.paramsDetails) === null || _configDetails$params0 === void 0 ? void 0 : _configDetails$params0.deviceName) || '';
          var _categoryTitle = sessionStorage.getItem('categoryTitle') || '';
          tagging.setPageView({
            page: {
              channel: 'Support',
              channelSession: (_window$config$soeGui = (_window9 = window) === null || _window9 === void 0 ? void 0 : (_window9$config = _window9.config) === null || _window9$config === void 0 ? void 0 : _window9$config.soeGuiSubKey) != null ? _window$config$soeGui : '',
              displayChannel: ((_window0 = window) === null || _window0 === void 0 ? void 0 : (_window0$config = _window0.config) === null || _window0$config === void 0 ? void 0 : _window0$config.indirect) === "Y" ? "indirect" : "retail",
              sourceChannel: "POS_" + solutionSource,
              detail: '',
              flow: "troubleshooter| POS_embedded| " + _categoryTitle + "| " + issueName,
              subFlow: _deviceName2 + "_" + _deviceSku2,
              throttle: 'NSA',
              name: "ts| " + _categoryTitle + "| " + issueName + "| " + currentPageId + "| " + stepTitle,
              url: document.referrer + 'sales/global-nav/home.html'
            },
            support: {
              issueNumber: symptomId || '',
              tsaIssueName: issueName || '',
              tsaStepName: stepTitle || ''
            },
            event: {
              value: eventId || ''
            },
            target: {
              engagement: {
                intent: 'support'
              },
              assetsRequested: document.referrer + 'sales/global-nav/home.html'
            },
            env: {
              businessUnit: 'Wireless'
            },
            txn: {
              agentRole: 'Rep',
              agent: paramsDetails.loggedInUser
            }
          }, true, popOutFlow);
        }
        console.log('updateOmniDlObject--end--window.vzdl--', window.vzdl);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  useEffect(function () {
    console.log(currentPageId, 'pageRef.current+++', pageRef.current);
    if (pageRef.current !== currentPageId) {
      pageRef.current = currentPageId;
    } else {
      pageRef.current = '';
    }
  }, [currentPageId]);
  useEffect(function () {
    updateOmniDlObject();
    return function () {
      var _window1, _window1$vzdl, _window1$vzdl$target;
      if ((_window1 = window) !== null && _window1 !== void 0 && (_window1$vzdl = _window1.vzdl) !== null && _window1$vzdl !== void 0 && (_window1$vzdl$target = _window1$vzdl.target) !== null && _window1$vzdl$target !== void 0 && _window1$vzdl$target.message) {
        window.vzdl.target.message = '';
      }
    };
  }, [analysis.title, symptom.issueName, currentPageId, eotFlag, solutionSource]);
  useEffect(function () {
    try {
      var troubleshootingDetails = JSON.parse(sessionStorage.getItem('troubleshootingDetails'));
      if (window.isBAUACSS && typeof troubleshootingDetails !== 'undefined' && (troubleshootingDetails === null || troubleshootingDetails === void 0 ? void 0 : troubleshootingDetails.channel) === 'Retail') {
        if (window && window.vzdl) {
          window.vzdl.page.sourceChannel = 'POS';
          window.vzdl.page.displayChannel = 'Retail';
          window.vzdl.page.flow = 'Support';
          window.vzdl.page.channel = 'Account';
          window.vzdl.page.throttle = 'NSA';
          window.vzdl.target = window.vzdl.target || {};
          window.vzdl.target.engagement = window.vzdl.target.engagement || {};
          window.vzdl.target.engagement.intent = 'Account Management';
          window.vzdl.txn = window.vzdl.txn || {};
          window.vzdl.txn.agent = typeof window.spData !== 'undefined' && typeof window.spData.UserId !== 'undefined' && window.spData.UserId !== null && window.spData.UserId !== '' ? window.spData.UserId : '';
          window.vzdl.txn.product = window.vzdl.txn.product || {};
          window.vzdl.txn.product.current = [];
          window.vzdl.txn.product.current.push({});
          var troubleshootingDevice = JSON.parse(sessionStorage.getItem('troubleshootingDevice'));
          window.vzdl.txn.product.current[0].name = typeof troubleshootingDevice !== 'undefined' && typeof troubleshootingDevice.deviceName !== 'undefined' && troubleshootingDevice.deviceName !== null ? troubleshootingDevice.deviceName : '';
          window.vzdl.txn.product.current[0].id = typeof troubleshootingDevice !== 'undefined' && typeof troubleshootingDevice.deviceId !== 'undefined' && troubleshootingDevice.deviceId !== null ? troubleshootingDevice.deviceId : '';
          window.vzdl.txn.product.current[0].sku = typeof troubleshootingDevice !== 'undefined' && typeof troubleshootingDevice.deviceSku !== 'undefined' && troubleshootingDevice.deviceSku !== null ? troubleshootingDevice.deviceSku : '';
          window.vzdl.env = window.vzdl.env || {};
          window.vzdl.env.businessUnit = 'Wireless';
        }
      }
    } catch (error) {
      console.log('Troubleshooting window.vzdl Retail channel tagging failed.');
    }
  });
  var redirectToBAU = function redirectToBAU(purpose) {
    if (purpose === void 0) {
      purpose = 'issue-selection';
    }
    try {
      return Promise.resolve(sessionUtility.getCaseDetails()).then(function (caseDetails) {
        var mvoConfig = sessionUtility.getMvoConfig();
        if (mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isAcss) {
          var _caseDetails$equipmen;
          var equipmentId = (_caseDetails$equipmen = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.equipmentId) != null ? _caseDetails$equipmen : '';
          redirectFormPostToUrl(caseDetails.changeIssueUrl, equipmentId, purpose);
        } else if (props.combinedIssueSelector) {
          history.goBack();
        } else {
          window.location.href = caseDetails.changeIssueUrl;
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var buildSymptom = function buildSymptom(text, groupName, radioValue, htmlContent) {
    var symptom;
    if (analysis.templateId === 'LV_TEMPADDRESS_PILOT' || resolution.templateId === 'LV_TEMPADDRESS_PILOT') {
      symptom = {
        ariaLabel: text,
        htmlContent: htmlContent,
        children: /*#__PURE__*/React__default.createElement(TextWithHtml, null, htmlContent),
        name: groupName,
        value: radioValue,
        label: text,
        'data-analyticstrack': 'trbl-issue-text',
        'data-track': "{\"type\": \"link\", \"name\": \"" + text + "\"}",
        'data-clickstream': "{" + text + "-trbl-issue-input}"
      };
    } else {
      symptom = {
        ariaLabel: text,
        htmlContent: htmlContent,
        children: /*#__PURE__*/React__default.createElement(TextWithHtml, null, htmlContent),
        name: groupName,
        value: radioValue,
        label: text,
        'data-analyticstrack': 'trbl-issue-radio',
        'data-track': "{\"type\": \"link\", \"name\": \"" + text + "\"}",
        'data-clickstream': "{" + text + "-trbl-issue-radio}"
      };
    }
    return symptom;
  };
  var buildSymptoms = function buildSymptoms() {
    var symptomOptions = [];
    if (choices) {
      choices.forEach(function (issue) {
        var _issue$htmlContent;
        var text = issue.text;
        var symptom = buildSymptom(text, 'issues', issue.value, (_issue$htmlContent = issue === null || issue === void 0 ? void 0 : issue.htmlContent) != null ? _issue$htmlContent : '');
        symptomOptions.push(symptom);
      });
      return symptomOptions;
    }
    console.log(symptomOptions, 'symptomOptions');
    return [];
  };
  var _useState24 = useState([]),
    issuesAll = _useState24[0],
    setIssuesAll = _useState24[1];
  var _useState25 = useState(userSelection),
    selectedOption = _useState25[0],
    setSelectedOption = _useState25[1];
  var _useState26 = useState(true),
    customLocationDisabled = _useState26[0],
    setCustomLocationDisabled = _useState26[1];
  useEffect(function () {
    setSelectedOption(userSelection);
  }, [userSelection]);
  useEffect(function () {
    console.log('selectedOption changed', selectedOption);
    var disablers = ['Other', '', '-1'];
    if (selectedOption && (analysis === null || analysis === void 0 ? void 0 : analysis.templateId) !== "RESOLUTION_OPTIONS_ALL") {
      setBtnValue(false);
    }
    if (disablers.includes(selectedOption)) {
      setBtnValue(true);
    }
  }, [selectedOption]);
  useEffect(function () {
    setIssuesAll(buildSymptoms());
  }, [choices]);
  useEffect(function () {
    var linksArray = document.getElementsByTagName('a');
    Array.from(linksArray).forEach(function (element) {
      if (element.className === 'INVOKE_OVERLAY' && element.getAttribute('listener') !== 'true') {
        console.log('found Element', element);
        element.setAttribute('listener', 'true');
        if (window.isMVODigital) {
          element.addEventListener('contextmenu', function (event) {
            event.preventDefault();
          });
        }
        element.addEventListener('click', function (e) {
          return handleDynamicCta(e, element);
        });
      }
    });
    return function () {
      var linksArray = document.getElementsByTagName('a');
      Array.from(linksArray).forEach(function (element) {
        if (element.className === 'INVOKE_OVERLAY' && element.getAttribute('listener') == 'true') {
          console.log('found cleanup Element', element);
          element.removeEventListener('click', function (e) {
            return handleDynamicCta(e, element);
          });
        }
      });
    };
  });
  function accordionHandler(e) {
    e.stopImmediatePropagation();
    if ($(this).parents().hasClass('accordion')) {
      $(this).parent().children('div').toggle();
      if ($(this).hasClass('arrow-up')) {
        $(this).addClass('arrow-down').removeClass('arrow-up');
        $(this).attr('aria-expanded', false);
      } else {
        $(this).addClass('arrow-up').removeClass('arrow-down');
        $(this).attr('aria-expanded', true);
      }
    }
  }
  function noteAccordionHandler(e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    $(this).parent().children('div').toggle();
    if ($(this).hasClass('arrow-up')) {
      $(this).addClass('arrow-down').removeClass('arrow-up');
      $(this).attr('aria-expanded', false);
    } else {
      $(this).addClass('arrow-up').removeClass('arrow-down');
      $(this).attr('aria-expanded', true);
    }
  }
  useEffect(function () {
    setTimeout(function () {
      var rightMenuId = 0;
      $('#dynamic-cta-content div').each(function (i, elem) {
        console.log('DYNAMIC CTA', elem);
        if (elem.classList.contains('accordion')) {
          rightMenuId = rightMenuId + 1;
          $(elem).attr('id', 'task_step_' + rightMenuId);
          $(elem).addClass('task_step_' + rightMenuId);
          $(elem).find('h2.title').prepend('<span></span>');
          $(elem).find('h2.title').addClass('arrow arrow-down');
          $(elem).find('h2.title').attr('role', 'button');
          $(elem).find('h2.title').attr('tabindex', 0);
          $(elem).children('div').hide();
        }
        if (elem.classList.contains('note')) {
          rightMenuId = rightMenuId + 1;
          $(elem).attr('id', 'task_step_' + rightMenuId);
          $(elem).addClass('task_step_' + rightMenuId);
          var title = $(elem).attr('data-label');
          if ($(elem).find('h2.title').length == 0) {
            if (elem.classList.contains('caution')) {
              $(elem).prepend("<h2 role='button' tabindex='0' class='title arrow arrow-up'><div>" + title + '</div><span></span></h2>');
              $(elem).children('div').show();
            } else {
              $(elem).prepend("<h2 role='button' tabindex='0' class='title arrow arrow-down'><div>" + title + '</div><span></span></h2>');
              $(elem).children('div').hide();
            }
          }
        }
      });
    }, 0);
  });
  useEffect(function () {
    console.log('overlay useEffect-->');
    setTimeout(function () {
      if (document.getElementById('dynamic-cta-content')) {
        console.log('overlay useEffect inside-->');
        var id = '#dynamic-cta-content';
        $(id).on('click', '.accordion h2.title', accordionHandler);
        $(id).on('keypress', '.accordion h2.title', accordionHandler);
        $(id).on('click', '.note h2.title', noteAccordionHandler);
        $(id).on('keypress', '.note h2.title', noteAccordionHandler);
      }
    }, 100);
    return function () {
      if (document.getElementById('dynamic-cta-content')) {
        var id = '#dynamic-cta-content';
        $(id).off('click', '.accordion h2.title', accordionHandler);
        $(id).off('keypress', '.accordion h2.title', accordionHandler);
        $(id).off('click', '.note h2.title', noteAccordionHandler);
        $(id).off('keypress', '.note h2.title', noteAccordionHandler);
      }
    };
  });
  var setEqualHeight = function setEqualHeight(steps, wrapperClassName) {
    var height = 0;
    for (var i = 0; i <= steps.length - 1; i++) {
      var _window10, _steps$i;
      var innerHeight = (_window10 = window) === null || _window10 === void 0 ? void 0 : _window10.getComputedStyle((_steps$i = steps[i]) === null || _steps$i === void 0 ? void 0 : _steps$i.querySelector(wrapperClassName)).height;
      innerHeight = parseInt(innerHeight.substring(0, innerHeight.indexOf('px')));
      height = innerHeight > height ? innerHeight : height;
      if ((i + 1) % 2 === 0 && height !== 0) {
        var _window11, _window12;
        steps[i - 1].querySelector(wrapperClassName).style.height = height + 'px';
        steps[i].querySelector(wrapperClassName).style.height = height + 'px';
        var buttonMaxHeight = (_window11 = window) === null || _window11 === void 0 ? void 0 : _window11.getComputedStyle(steps[i]).minHeight;
        buttonMaxHeight = parseInt(buttonMaxHeight.substring(0, buttonMaxHeight.indexOf('px')));
        var buttonHeight = (_window12 = window) === null || _window12 === void 0 ? void 0 : _window12.getComputedStyle(steps[i]).height;
        buttonHeight = parseInt(buttonHeight.substring(0, buttonHeight.indexOf('px')));
        if (buttonHeight > buttonMaxHeight) {
          steps[i - 1].style.minHeight = '86px';
          steps[i].style.minHeight = '86px';
        }
        height = 0;
      }
    }
  };
  useEffect(function () {
    if (window.isMVODigital && !isMobile()) {
      setEqualHeight(document.querySelectorAll('.autoHeight .toplink_steps'), '.toplink_steps_wrapper');
      setEqualHeight(document.querySelectorAll('.autoHeight .bottomlink_steps'), '.bottomlink_steps_wrapper');
    }
  });
  function filterDescription(step, id) {
    if (step['segments']) {
      var arrSegments = step['segments'].split(',');
      console.log('segment arrSegments', arrSegments);
      $("#content-description-data" + id + " article > div > div").each(function (i, elem) {
        console.log('segment div 1', elem);
        console.log('segment div 2', elem.hasAttribute('segment'));
        console.log('segment div 3', $(elem).attr('segment'), step['segments']);
        if (elem.hasAttribute('segment') && !arrSegments.includes($(elem).attr('segment'))) {
          $(elem).parent().remove();
        }
      });
    }
  }
  useEffect(function () {
    if (isNewDesign) {
      steps.forEach(function (step, ind) {
        filterDescription(step, ind);
      });
    }
  }, [currentPageId]);
  var pageRef = useRef(currentPageId);
  function prepareAccordions(id, rightMenuElements) {
    if (rightMenuElements === void 0) {
      rightMenuElements = [];
    }
    $("#" + id + " div").each(function (i, elem) {
      if (elem.classList.contains('accordion')) {
        rightMenuId = rightMenuId + 1;
        $(elem).attr('id', 'task_step_' + rightMenuId);
        $(elem).addClass('task_step_' + rightMenuId);
        rightMenuElements.push({
          id: rightMenuId,
          title: $(elem).find('h2.title').text()
        });
        $(elem).find('h2.title').prepend('<span></span>');
        $(elem).find('h2.title').addClass('arrow arrow-down');
        $(elem).find('h2.title').attr('role', 'button');
        $(elem).find('h2.title').attr('tabindex', 0);
        $(elem).children('div').hide();
      }
      if (elem.classList.contains('note')) {
        var _$, _$$children, _$$children$first, _$$children$first$con, _$$children$first$con2, _$$children$first$con3;
        rightMenuId = rightMenuId + 1;
        $(elem).attr('id', 'task_step_' + rightMenuId);
        $(elem).addClass('task_step_' + rightMenuId);
        var title = $(elem).attr('data-label');
        var fetchedTitle = title + " " + ((_$ = $(elem)) === null || _$ === void 0 ? void 0 : (_$$children = _$.children('div')) === null || _$$children === void 0 ? void 0 : (_$$children$first = _$$children.first()) === null || _$$children$first === void 0 ? void 0 : (_$$children$first$con = _$$children$first.contents()) === null || _$$children$first$con === void 0 ? void 0 : (_$$children$first$con2 = _$$children$first$con.filter(function () {
          return this.nodeType === 3;
        })) === null || _$$children$first$con2 === void 0 ? void 0 : (_$$children$first$con3 = _$$children$first$con2.text()) === null || _$$children$first$con3 === void 0 ? void 0 : _$$children$first$con3.trim()) || title;
        if ($(elem).find('h2.title').length == 0) {
          if (elem.classList.contains('caution')) {
            $(elem).prepend("<h2 role='button' tabindex='0' class='clickable title arrow arrow-up'><div>" + title + "</div><span></span></h2>");
            $(elem).children('div').show();
          } else {
            $(elem).prepend("<h2 role='button' tabindex='0' class='clickable title arrow arrow-down' aria-label='" + fetchedTitle + "' aria-expanded='false'><div>" + title + "</div><span></span></h2>");
            $(elem).children('div').hide();
          }
        }
      }
    });
  }
  var rightMenuId = 0;
  useEffect(function () {
    if (isNewDesign) {
      $(document).on('scroll', function () {
        if (window.scrollY > 140) {
          $(this).find('div.right-menu-container nav').addClass('fixedRightNav');
        } else {
          $(this).find('div.right-menu-container nav').removeClass('fixedRightNav');
        }
      });
    }
  }, [currentPageId]);
  function issueSelectorRedirectFunc(e) {
    e.preventDefault();
    if (window.isBAUACSS) {
      redirectToBAU();
    } else {
      if (configDetails.redirectToIssueSelecorTab) {
        configDetails.redirectToIssueSelecorTab(0);
      } else {
        redirectToBAU();
      }
    }
  }
  useEffect(function () {
    steps.forEach(function (el, ind) {
      $("#content-description-data" + ind + " a").each(function (i) {
        $(this).attr('data-track', "{\"type\": \"link\", \"name\": \"" + $(this).text() + "\"}");
      });
    });
    $('.other').each(function (i) {
      $(this).removeClass('other');
    });
    $('.xref').each(function (i) {
      if ($(this).attr('href') != '#') {
        $(this).attr('target', '_blank');
        var arrID = $(this).attr('href').match(/\d+/);
        var arrJS = $(this).attr('href').match('javascript:openDocumentLink');
        var id;
        if (arrID && arrJS) {
          id = arrID[0];
        }
        if (id) {
          $(this).attr('href', "https://www.verizon.com/support/knowledge-base-" + id);
        }
      }
    });
    $('.link').each(function (i) {
      if ($(this).attr('href') != '#') {
        $(this).attr('target', '_blank');
        var arrID = $(this).attr('href').match(/\d+/);
        var arrJS = $(this).attr('href').match('javascript:openDocumentLink');
        var id;
        if (arrID && arrJS) {
          id = arrID[0];
        }
        if (id) {
          $(this).attr('href', "https://www.verizon.com/support/knowledge-base-" + id);
        }
      }
    });
    steps.forEach(function (e, index) {
      $("#content-description-data" + index + " a#new-issue").on('click', issueSelectorRedirectFunc);
    });
    steps.forEach(function (ele, index) {
      var id = "#content-description-data" + index;
      $(id).on('click', '.accordion h2.title', accordionHandler);
      $(id).on('keypress', '.accordion h2.title', accordionHandler);
      $(id).on('click', '.note h2.title', noteAccordionHandler);
      $(id).on('keypress', '.note h2.title', noteAccordionHandler);
    });
    return function () {
      steps.forEach(function (ele, index) {
        var id = "#content-description-data" + index;
        $(id).off('click', '.accordion h2.title', accordionHandler);
        $(id).off('keypress', '.accordion h2.title', accordionHandler);
        $(id).off('click', '.note h2.title', noteAccordionHandler);
        $(id).off('keypress', '.note h2.title', noteAccordionHandler);
        $(id + " a#new-issue").off('click', issueSelectorRedirectFunc);
      });
    };
  });
  var invokeCLNRBridgeFunction = function invokeCLNRBridgeFunction() {
    var _ref7 = configDetails || {},
      _ref7$paramsDetails = _ref7.paramsDetails,
      paramsDetails = _ref7$paramsDetails === void 0 ? {} : _ref7$paramsDetails;
    var isUserPartOfClnrPilot = paramsDetails.isUserPartOfClnrPilot,
      viewClnrPopup = paramsDetails.viewClnrPopup,
      viewLegacyClnrPopup = paramsDetails.viewLegacyClnrPopup;
    if (isUserPartOfClnrPilot === 'Y' && viewClnrPopup) {
      console.log('viewClnrPopup called');
      viewClnrPopup();
    } else if (isUserPartOfClnrPilot === 'N' && viewLegacyClnrPopup) {
      console.log('viewLegacyClnrPopup called');
      viewLegacyClnrPopup();
    } else {
      console.log('Either CLNR Flag or CLNR methods not passed.');
    }
  };
  var invokeAcssBridgeFunction = function invokeAcssBridgeFunction() {
    var _props$values4 = props.values,
      values = _props$values4 === void 0 ? {} : _props$values4;
    var _values$troubleShooti2 = values.troubleShootingInfo,
      troubleShootingInfo = _values$troubleShooti2 === void 0 ? {} : _values$troubleShooti2;
    var context = getObjectPropertyByPath('context', troubleShootingInfo, {});
    var _context$lineInfo = context.lineInfo,
      lineInfo = _context$lineInfo === void 0 ? [] : _context$lineInfo;
    var _ref8 = lineInfo[0] || {},
      _ref8$longitude = _ref8.longitude,
      longitude = _ref8$longitude === void 0 ? '' : _ref8$longitude,
      _ref8$latitude = _ref8.latitude,
      latitude = _ref8$latitude === void 0 ? '' : _ref8$latitude;
    var _ref9 = configDetails || {},
      _ref9$paramsDetails = _ref9.paramsDetails,
      paramsDetails = _ref9$paramsDetails === void 0 ? {} : _ref9$paramsDetails,
      _ref9$caseId = _ref9.caseId,
      caseId = _ref9$caseId === void 0 ? '' : _ref9$caseId;
    var _paramsDetails$accoun = paramsDetails.accountNumber,
      accountNumber = _paramsDetails$accoun === void 0 ? '' : _paramsDetails$accoun,
      _paramsDetails$mdn = paramsDetails.mdn,
      mdn = _paramsDetails$mdn === void 0 ? '' : _paramsDetails$mdn;
    var customerId = accountNumber.split('-')[1] || '';
    var requestObj = {
      mvoData: {
        accountNumber: accountNumber,
        mdn: mdn,
        customerId: customerId,
        tsrId: caseId,
        launchFrom: 'KMS',
        noheader: 'true',
        city: '',
        state: '',
        zip: '',
        longitude: longitude,
        latitude: latitude,
        CTI_ENABLE: 'O'
      }
    };
    console.log('viewRemedyTicketCreationPopup', requestObj);
    if (paramsDetails.viewRemedyTicketCreationPopup) {
      console.log('viewRemedyTicketCreationPopup invoked');
      paramsDetails.viewRemedyTicketCreationPopup(requestObj);
    }
  };
  var showCustomLocation = function showCustomLocation(options, step) {
    if (options === void 0) {
      options = [];
    }
    if (step === void 0) {
      step = {};
    }
    console.log('showCustomLocation', step);
    var template = step.templateId;
    console.log('yesss', options, template);
    return template === 'PQ_WIFI_MULTILOCATION_SELECTOR' && options.findIndex(function (op) {
      return op.value && op.value.toLowerCase() === 'other';
    }) > -1;
  };
  var handleSiteSurveyChange = function handleSiteSurveyChange(e) {
    var value = e.target.value;
    console.log('site survey', value);
    setSelectedOption(value);
    setSelectedCtaValue(value);
  };
  var handleNrbChkEligibilityLoader = function handleNrbChkEligibilityLoader(actionButtonObj) {
    var _actionButtonObj$valu = actionButtonObj.value,
      value = _actionButtonObj$valu === void 0 ? '' : _actionButtonObj$valu,
      _actionButtonObj$nrbO = actionButtonObj.nrbOeNeChkEligibilityLoader,
      nrbOeNeChkEligibilityLoader = _actionButtonObj$nrbO === void 0 ? 'no' : _actionButtonObj$nrbO;
    if (functions.handleTroubleShootingAction) {
      var buttonObj = {
        label: 'next',
        action: 'Yes',
        type: 'primary',
        url: '',
        nrbOeNeChkEligibilityLoader: nrbOeNeChkEligibilityLoader
      };
      functions.handleTroubleShootingAction(buttonObj, {
        optionSelected: value
      });
    }
  };
  var handleOkClick = function handleOkClick(buttonObject, calledFromSiteSurvey) {
    if (calledFromSiteSurvey === void 0) {
      calledFromSiteSurvey = false;
    }
    var _buttonObject$value = buttonObject.value,
      value = _buttonObject$value === void 0 ? '' : _buttonObject$value,
      _buttonObject$nrbOeNe = buttonObject.nrbOeNethrowError,
      nrbOeNethrowError = _buttonObject$nrbOeNe === void 0 ? false : _buttonObject$nrbOeNe,
      _buttonObject$nrbNeNo = buttonObject.nrbNeNotEligibleforOffer,
      nrbNeNotEligibleforOffer = _buttonObject$nrbNeNo === void 0 ? false : _buttonObject$nrbNeNo;
    if (value === 'nrb') {
      invokeAcssBridgeFunction();
    }
    setSelectedOption(value);
    setSelectedCtaValue(value);
    if (functions.handleTroubleShootingAction) {
      var buttonObj = {
        label: 'next',
        action: calledFromSiteSurvey ? 'Next' : 'Yes',
        type: 'primary',
        url: '',
        callFunction: '',
        nrbOeNethrowError: nrbOeNethrowError,
        nrbNeNotEligibleforOffer: nrbNeNotEligibleforOffer
      };
      if (value === 'lvmoversflow' || value === 'lvmoversflowmvo' || value === 'lvvacationsuspend' || value === 'lvvacationsuspendmvo' || value === 'lvfollowup' || value === 'View Recommendation') {
        buttonObj.action = 'No';
      }
      functions.handleTroubleShootingAction(buttonObj, {
        optionSelected: value
      });
      setSelectedOption('');
      userSelection = '';
    }
  };
  var handleContinueButton = function handleContinueButton() {
    setConfirmationModal(false);
    var buttonObj = {
      label: 'Next',
      action: 'Next',
      type: 'primary',
      url: '',
      callFunction: ''
    };
    var eligibleOptions = ['nrb', 'clnr', 'deviceRepair'];
    if (selectedCtaValue) {
      handleButtonAction(selectedCtaValue, buttonObj);
    } else {
      if (selectedOption === 'nrb') {
        invokeAcssBridgeFunction();
      }
      if (selectedOption === 'clnr' || selectedOption === 'deviceRepair') {
        invokeCLNRBridgeFunction();
      }
      var button = step.cta[0];
      console.log('BUTTON', button);
      handleAction(button, true);
      if (resoltionRedirectURI) {
        if (eligibleOptions.includes(selectedOption) && !window.isBAUACSS && !window.isMVODigital) {
          return;
        }
        window.open(resoltionRedirectURI, '_blank');
      }
    }
  };
  var handleCancelButton = function handleCancelButton() {
    userSelection = '';
    setSelectedOption('-1');
    setSelectedCtaValue('');
    setConfirmationModal(false);
  };
  var handleSendEmail = function handleSendEmail(e, subProcessStep) {
    if (subProcessStep === void 0) {
      subProcessStep = '';
    }
    e.stopPropagation();
    setSubProcessStep(subProcessStep);
    setShowResumeEmail(true);
  };
  var handleButtonClick = function handleButtonClick(e, item) {
    if (item === void 0) {
      item = {};
    }
    try {
      if (functions.handleAction) {
        functions.handleAction();
      }
      if (e && e.currentTarget) {
        var _item;
        selectedUrlOption = e.currentTarget.getAttribute('data-url') || ((_item = item) === null || _item === void 0 ? void 0 : _item.url);
      }
      var selectedButtonOption = item.value;
      if (selectedButtonOption && (analysis === null || analysis === void 0 ? void 0 : analysis.templateId) !== "RESOLUTION_OPTIONS_ALL") {
        setBtnValue(false);
      }
      if (e.target.value == -1) {
        setBtnValue(true);
      }
      var value = item.value || '';
      setSelectedOption(value);
      popupContent = item.popUpHtmlContent || '';
      setSelectedCtaValue(selectedButtonOption);
      setConfirmationModal(true);
    } catch (err) {
      console.log('Caught Err', err);
    }
  };
  var handleOptionsChange = function handleOptionsChange(e) {
    dropdownSelectedOption = e.target.selectedOptions || [];
    var _e$target = e.target,
      value = _e$target.value;
    setSelectedOption(value);
    setCustomLocationDisabled(value !== 'Other');
    console.log(e.target.value, dropdownSelectedOption);
    if (functions.handleAction) {
      functions.handleAction();
    }
    if (value) {
      setBtnValue(false);
    }
    var _ref0 = typeof dropdownSelectedOption === 'object' && dropdownSelectedOption || [],
      htmlEl = _ref0[0];
    var popup;
    if (htmlEl) {
      popup = htmlEl.getAttribute('data-content');
    }
    if (popup) {
      popupContent = popup;
      setPopHtmlContent(true);
    } else {
      setPopHtmlContent(false);
    }
    var redirectUrl;
    if (htmlEl) {
      redirectUrl = htmlEl.getAttribute('data-url');
    }
    if (redirectUrl) {
      setResolutionRedirectURI(redirectUrl);
    }
    if (e.target.value == '-1') {
      setBtnValue(true);
    }
    if (e.target.name === 'issues') {
      console.log('e.target.value==', e.target.value);
      setSelectedIssueOption(e.target.value);
    }
  };
  var handleNetworkExtFlow = function handleNetworkExtFlow(item) {
    if (item === void 0) {
      item = {};
    }
    try {
      var offerData = {
        actionButton: item,
        handleNrbChkEligibilityLoader: handleNrbChkEligibilityLoader,
        configDetails: configDetails
      };
      return Promise.resolve(chkNeAddOffer(offerData)).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var handleButtonClickDigital = function handleButtonClickDigital(e, item, templateId, resolutionTemplateId) {
    var _item3;
    if (item === void 0) {
      item = {};
    }
    if (templateId === void 0) {
      templateId = '';
    }
    if (resolutionTemplateId === void 0) {
      resolutionTemplateId = '';
    }
    if (resolutionTemplateId === 'RESOLUTION_OPTIONS_MVO_TIER2') {
      templateId = 'RESOLUTION_OPTIONS_MVO_TIER2';
    }
    console.log('-----------resolution templateId---------', resolutionTemplateId);
    console.log('----------- templateId---------', templateId);
    if (item.value.includes('network extender')) {
      if (window.isMVODigital) {
        redirectToNrbFlow(configDetails);
      } else {
        handleNetworkExtFlow(item);
      }
      return;
    }
    if (recommendationAvailable && window.isMVODigital && !window.isLoggedOut && sessionStorage.getItem('propositionNBX')) {
      var _item2;
      triggerRecommendFeedBack((_item2 = item) === null || _item2 === void 0 ? void 0 : _item2.recommended);
    }
    if (isMVA && ((_item3 = item) === null || _item3 === void 0 ? void 0 : _item3.value) === 'Call us') {
      var _item4;
      var domainUrl = window.location.origin;
      navigateToNativePage({
        pageType: 'callUsLanding',
        title: (_item4 = item) === null || _item4 === void 0 ? void 0 : _item4.text,
        requestURLFlag: window.isLoggedOut ? false : true,
        requestURL: domainUrl + "/digital/nsa/secure/gw/contactus/getcallUsLanding"
      });
      return;
    }
    var button = {
      callFunction: '',
      heading: item.text,
      subHeading: item.value,
      popUpHtmlContent: item.popUpHtmlContent,
      label: templateId === 'RESOLUTION_OPTIONS_ALL_DIGITAL' ? 'Done' : 'Next',
      action: templateId === 'RESOLUTION_OPTIONS_ALL_DIGITAL' ? 'Done' : 'Next',
      type: 'primary',
      url: '',
      stopSubmitApiCall: templateId === 'RESOLUTION_OPTIONS_MVO_TIER2',
      target: item.target || ''
    };
    if (e && e.currentTarget) {
      var _item5;
      selectedUrlOption = e.currentTarget.getAttribute('data-url') || ((_item5 = item) === null || _item5 === void 0 ? void 0 : _item5.url);
    }
    var selectedButtonOption = item.value;
    if (selectedButtonOption) {
      setBtnValue(false);
    }
    handleButtonActionDigital(selectedButtonOption, button);
  };
  var triggerRecommendFeedBack = function triggerRecommendFeedBack(recommended) {
    try {
      var _configDetails$params1, _configDetails$params10;
      var recommendFeedBackData = {};
      var envData = {
        externalTarget: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params1 = configDetails.paramsDetails) === null || _configDetails$params1 === void 0 ? void 0 : _configDetails$params1.externalTarget,
        mvoenv: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params10 = configDetails.paramsDetails) === null || _configDetails$params10 === void 0 ? void 0 : _configDetails$params10.mvoenv
      };
      var propositionNBX = JSON.parse(sessionStorage.getItem('propositionNBX'));
      var _propositionNBX$soiEn2 = propositionNBX.soiEngagementId,
        soiEngagementId = _propositionNBX$soiEn2 === void 0 ? '' : _propositionNBX$soiEn2,
        _propositionNBX$cardI = propositionNBX.cardId,
        cardId = _propositionNBX$cardI === void 0 ? '' : _propositionNBX$cardI,
        _propositionNBX$propo2 = propositionNBX.propositionId,
        propositionId = _propositionNBX$propo2 === void 0 ? '' : _propositionNBX$propo2,
        _propositionNBX$rank = propositionNBX.rank,
        rank = _propositionNBX$rank === void 0 ? '' : _propositionNBX$rank,
        _propositionNBX$pegaS = propositionNBX.pegaSessionId,
        pegaSessionId = _propositionNBX$pegaS === void 0 ? '' : _propositionNBX$pegaS;
      var params = {
        promoId: cardId,
        soiEngagementId: soiEngagementId,
        propositionId: propositionId,
        dispositionOptionId: recommended ? '81' : '82',
        rank: rank,
        pegaSessionId: pegaSessionId
      };
      return Promise.resolve(recommendFeedBackAPI(params, envData)).then(function (_recommendFeedBackAPI) {
        recommendFeedBackData = _recommendFeedBackAPI;
        console.log('recommendFeedBackData' + recommendFeedBackData);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var handleButtonActionDigital = function handleButtonActionDigital(selectedButtonOption, button) {
    if (button === void 0) {
      button = {};
    }
    setBtnValue(true);
    var options = {
      optionSelected: ''
    };
    if (selectedButtonOption) {
      options.optionSelected = selectedButtonOption;
    }
    if (longitude && latitude) {
      options.longitude = longitude;
      options.latitude = latitude;
    }
    if (functions.handleTroubleShootingAction) {
      var _button = button,
        _button$target = _button.target,
        target = _button$target === void 0 ? '' : _button$target,
        _button$stopSubmitApi = _button.stopSubmitApiCall,
        stopSubmitApiCall = _button$stopSubmitApi === void 0 ? false : _button$stopSubmitApi;
      if (selectedUrlOption) {
        var _window$tsFeatureFlag;
        if ((_window$tsFeatureFlag = window.tsFeatureFlags) !== null && _window$tsFeatureFlag !== void 0 && _window$tsFeatureFlag.enableMidflowRedirectionFFlag && target === '_self' && selectedButtonOption === 'Sign In') {
          var _window13, _window13$config, _window13$config$trou, _window13$config$trou2, _window13$config$trou3;
          sessionStorage.setItem('authRedirection', 'true');
          sessionStorage.setItem('authRedirectionUrl', selectedUrlOption);
          var issueSelectorPage = window.location.origin + "/digital/nsa/secure/ui/troubleshooting/" + ((_window13 = window) === null || _window13 === void 0 ? void 0 : (_window13$config = _window13.config) === null || _window13$config === void 0 ? void 0 : (_window13$config$trou = _window13$config.troubleShootingJson) === null || _window13$config$trou === void 0 ? void 0 : (_window13$config$trou2 = _window13$config$trou.ddata) === null || _window13$config$trou2 === void 0 ? void 0 : (_window13$config$trou3 = _window13$config$trou2.device) === null || _window13$config$trou3 === void 0 ? void 0 : _window13$config$trou3.soeUrl);
          window.open(issueSelectorPage, '_self');
        } else {
          target === '_self' || isMvaFlow ? window.open(selectedUrlOption, '_self') : window.open(selectedUrlOption, '_blank');
        }
        if (selectedButtonOption === 'Sign In' || stopSubmitApiCall) return;
      }
      functions.handleTroubleShootingAction(button, options);
      dropdownSelectedOption = '';
      setSelectedOption('');
      userSelection = '';
    }
  };
  var handleOptionsChangeDigital = function handleOptionsChangeDigital(e) {
    try {
      var value = e.target.value;
      console.log('event', JSON.stringify(e.target.value));
      dropdownSelectedOption = e.target.selectedOptions;
      setSelectedOption(value);
      setCustomLocationDisabled(value !== 'Other');
      if (functions.handleAction) {
        functions.handleAction();
      }
      if (selectedOption) {
        setBtnValue(false);
      }
      if (e.target.value == -1) {
        setBtnValue(true);
      }
    } catch (error) {
      console.error('catch src/templates/Troubleshooting/TroubleShootingNewPage.js TroubleShootingNewPage handleOptionsChange', error);
    }
  };
  var handleResolutionOptionClick = function handleResolutionOptionClick(e, issue) {
    var _configDetails$params11;
    var target = isMvaFlow ? '_self' : '_blank';
    if ((configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params11 = configDetails.paramsDetails) === null || _configDetails$params11 === void 0 ? void 0 : _configDetails$params11.channel) == 'CARE') {
      var _ref1 = configDetails || {},
        _ref1$paramsDetails = _ref1.paramsDetails,
        _ref1$paramsDetails2 = _ref1$paramsDetails === void 0 ? {} : _ref1$paramsDetails,
        viewShopAccessrioes = _ref1$paramsDetails2.viewShopAccessrioes;
      if (viewShopAccessrioes) {
        viewShopAccessrioes();
      } else {
        var url = e.currentTarget.getAttribute('data-url') || (issue === null || issue === void 0 ? void 0 : issue.url);
        window.open(url, 'detab', 'toolbar=0');
      }
    } else if (e && e.currentTarget) {
      window.open(e.currentTarget.getAttribute('data-url') || (issue === null || issue === void 0 ? void 0 : issue.url), target);
    }
  };
  var disableIssueResolved = function disableIssueResolved() {
    if (templateTypeMain === 'waitscreen' || (analysis === null || analysis === void 0 ? void 0 : analysis.templateId) === 'VIRA_NRB_FORM') return true;
    return false;
  };
  var hideIssueResolved = function hideIssueResolved() {
    console.log('disableIssueResolved', eotFlag, pageIdentifier.includes('SL012046'), pageIdentifier.includes('SL012048'), pageIdentifier);
    if (eotFlag && (pageIdentifier.includes('SL012046') || pageIdentifier.includes('SL012048'))) {
      return true;
    }
    return false;
  };
  var disableNextButton = function disableNextButton() {
    var _steps$6;
    if (analysis.disableCTA || resolution.disableCTA || (analysis === null || analysis === void 0 ? void 0 : analysis.templateId) === 'VIRA_NRB_FORM') {
      return true;
    }
    if (isACSS && vzmapCoordinatesFFlag && analysis.templateId === "MAP_PROBLEM_LOC_NEXT" && !!!longitude && !!!latitude) {
      return true;
    }
    if (isACSS && (steps === null || steps === void 0 ? void 0 : (_steps$6 = steps[1]) === null || _steps$6 === void 0 ? void 0 : _steps$6.templateId) === "MID_FLOW_REMEDY") {
      return true;
    }
    if (templateTypeMain === 'waitscreen') return true;
    return choices && choices.length > 0 ? btnValue : eotFlag ? true : false;
  };
  var handleButtonAction = function handleButtonAction(selectedButtonOption, button) {
    setBtnValue(true);
    var options = {
      optionSelected: ''
    };
    if (selectedButtonOption) {
      options.optionSelected = selectedButtonOption;
    }
    if (longitude && latitude) {
      options.longitude = longitude;
      options.latitude = latitude;
    }
    var _ref10 = paramsContext || {},
      _ref10$paramsDetails = _ref10.paramsDetails,
      paramsDetails = _ref10$paramsDetails === void 0 ? {} : _ref10$paramsDetails;
    if (functions.handleTroubleShootingAction) {
      console.log('selectedUrlOption', selectedUrlOption);
      functions.handleTroubleShootingAction(button, options);
      dropdownSelectedOption = '';
      setSelectedOption('');
      userSelection = '';
      if (selectedButtonOption === 'custFollowUp' && paramsDetails.openLaunchoutDialog) {
        console.log('customerFollowup invoking-->');
        var forwardedData = {
          caseflag: 'CASE_CREATION',
          categoryList: ['Account Management', 'Billing and Payments', 'Device', 'International Travel', 'Plans and add-ons', 'Service', 'Shop', 'Troubleshooting'],
          selectedCategory: 'Troubleshooting'
        };
        paramsDetails.openLaunchoutDialog('createFollowUpCaseView-ScTile-NotLeftNav', 'FollowUp Cases', 3, 2, false, 'createFollowUpCaseView', JSON.stringify(forwardedData));
        console.log('customerFollowup invoked-->', forwardedData);
        return;
      }
      if (selectedButtonOption === 'upgradeDevice' && paramsDetails.viewFlexPopup) {
        console.log('viewFlexPopup invoked');
        paramsDetails.viewFlexPopup();
        return;
      }
      if (!window.isBAUACSS && !window.isMVODigital && selectedButtonOption === 'clnr') {
        invokeCLNRBridgeFunction();
        return;
      }
      selectedUrlOption && window.open(selectedUrlOption, '_blank');
    }
  };
  var handleMulSelDeviceOptionsChange = function handleMulSelDeviceOptionsChange(macAddress) {
    setSelectedOption(macAddress);
    setBtnValue(true);
  };
  var proceedToValidate = function proceedToValidate() {
    var doValidate;
    doValidate = window.isMVODigital === true ? enableUserSelectionValidation : validationFlag;
    return doValidate === true;
  };
  var handleAction = function handleAction(button, calledFromPopup) {
    if (button === void 0) {
      button = {};
    }
    if (calledFromPopup === void 0) {
      calledFromPopup = false;
    }
    if (analysis.templateId === 'CALL_SPECIFIC_NUMBER_ENTRY' && proceedToValidate()) {
      var errorObj = runValidationRules(selectedOption, selectedMdn);
      if (errorObj.hasError) {
        setSelectedCtaValue('');
        setSelectedOption('');
        return;
      }
    }
    var mvoConfig = sessionUtility.getMvoConfig();
    if (isHowToContent && button.label.toLowerCase() == 'yes' && !mvoConfig.isBAUACSS && !window.isMVODigital) {
      if (configDetails.redirectToIssueSelecorTab) {
        configDetails.redirectToIssueSelecorTab(0);
      }
      return;
    }
    if (analysis.templateId === 'LV_END_OF_TS_MVO') {
      if (isMVA) {
        var mvaParam = {
          actionType: 'openPage',
          pageType: 'myFeed'
        };
        invokeNative(JSON.stringify(mvaParam));
        return;
      } else {
        window.location.href = window.location.origin + "/digital/nsa/secure/ui/support/signinlanding";
        return;
      }
    }
    setBtnValue(true);
    var options = {
      optionSelected: ''
    };
    if (selectedOption) {
      options.optionSelected = selectedOption;
    }
    if (longitude && latitude) {
      options.longitude = longitude;
      options.latitude = latitude;
    }
    if (addressLine) {
      options.addressLine = addressLine;
    }
    if (isHowToContent && button.label.toLowerCase() == 'no') {
      redirectToBAU();
      if (isNewDesign) {
        setFlags(function (prev) {
          return _extends({}, prev, {
            showThumbsDown: true,
            thumbsClicked: true
          });
        });
        return;
      }
    }
    if (functions.handleTroubleShootingAction) {
      console.log('dropdownSelectedOption', dropdownSelectedOption);
      if (popHtmlContent && !calledFromPopup) {
        setConfirmationModal(true);
        return;
      }
      if (!calledFromPopup) {
        var _ref11 = typeof dropdownSelectedOption === 'object' && dropdownSelectedOption || [],
          htmlEl = _ref11[0];
        var dataUrl;
        if (htmlEl) {
          dataUrl = htmlEl.getAttribute('data-url');
        }
        if (dataUrl) {
          window.open(dataUrl, '_blank');
        }
      }
      if (analysis.templateId === 'SELECT_DEVICE' || resolution.templateId === 'SELECT_DEVICE') {
        button = {
          label: 'Troubleshoot',
          action: 'Troubleshoot',
          type: 'primary',
          url: '',
          callFunction: ''
        };
      }
      if (analysis.templateId === 'CALL_SPECIFIC_NUMBER_ENTRY') {
        button.isSpecificNumberEntry = true;
      }
      if (isNextBtnEnableNRB) {
        button["isNextBtnEnableNRB"] = isNextBtnEnableNRB;
      }
      functions.handleTroubleShootingAction(button, options);
      dropdownSelectedOption = '';
      setSelectedOption('');
      userSelection = '';
    }
  };
  var handleLinkClick = function handleLinkClick() {
    if (functions.processTroubleShootingPage) {
      setSelectedOption('');
      userSelection = '';
      functions.processTroubleShootingPage('submit', 'skip');
    }
  };
  var handleModalAction = function handleModalAction(button) {
    var mvoConfig = sessionUtility.getMvoConfig();
    var mvoCaseDetails = sessionUtility.getCaseDetails();
    if (button.action === 'close') {
      setShowInstructions(false);
    } else if (button.action === 'done' && !is5GDevice && mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isAcss && mvoCaseDetails.changeIssueUrl) {
      var _mvoCaseDetails$equip;
      var equipmentId = (_mvoCaseDetails$equip = mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.equipmentId) != null ? _mvoCaseDetails$equip : '';
      redirectFormPostToUrl(mvoCaseDetails.changeIssueUrl, equipmentId);
      return;
    }
  };
  var redirectToOldPortal = function redirectToOldPortal(purpose) {
    if (purpose === void 0) {
      purpose = 'issue-selection';
    }
    try {
      return Promise.resolve(sessionUtility.getCaseDetails()).then(function (caseDetails) {
        var _caseDetails$equipmen2;
        var equipmentId = (_caseDetails$equipmen2 = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.equipmentId) != null ? _caseDetails$equipmen2 : '';
        redirectFormPostToUrl(caseDetails.changeIssueUrl, equipmentId, purpose);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var handleChecklistChange = function handleChecklistChange(value, step) {
    console.log(step, 'NextStepPage:handleCheckListChange: value:', value);
    if (eotFlag) {
      return false;
    }
    if (functions.handleReplayNavigation) {
      setSelectedOption('');
      userSelection = '';
      functions.handleReplayNavigation(value, step);
    }
  };
  var modalParams = {
    title: instructions.title,
    heading: instructions.heading,
    description: instructions.description,
    handleAction: function handleAction() {
      return handleModalAction({
        action: 'close'
      });
    },
    show: showInstructions
  };
  var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
  var eventer = window[eventMethod];
  var messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message';
  eventer(messageEvent, function (e) {
    return debouncedgenerator(e, setLongitude, setLatitude, setAddressLine, setBtnValue);
  });
  window.onhashchange = function () {
    console.log('back button pressed for browser');
  };
  var handleModalState = function handleModalState(flags) {
    setModalValues(_extends({}, modalValues, {
      showModal: true,
      expandModal: true,
      modalType: isHowToContent && isNewDesign && !window.isMVODigital ? 'howToFeedback' : 'feedback'
    }));
    setFlags(_extends({}, flags));
  };
  var modalChanged = function modalChanged(open) {
    if (!open) {
      if (props.handleAction) {
        props.handleAction({
          actionData: 'close'
        });
      }
      setModalValues(_extends({}, modalValues, {
        showModal: false,
        expandModal: false,
        modalType: ''
      }));
      if (!(flags.showThumbsDown || flags.showThumbsUp)) {
        setFlags(_extends({}, flags, {
          thumbsClicked: false
        }));
      }
    }
  };
  var handleModalClick = function handleModalClick() {
    setModalValues(_extends({}, modalValues, {
      expandModal: true,
      modalType: isHowToContent && isNewDesign && !window.isMVODigital ? 'howToFeedback' : 'feedback'
    }));
  };
  var handleCloseButton = function handleCloseButton(e) {
    setModalValues(_extends({}, modalValues, {
      showModal: false,
      expandModal: false,
      modalType: ''
    }));
    setFlags(_extends({}, flags, {
      justAfterThumbsDownClicked: false,
      thumbsClicked: !!(e !== null && e !== void 0 && e.done)
    }));
  };
  var handleSolvedClick = function handleSolvedClick(e) {
    try {
      e.preventDefault();
      if (window.isMVODigital && isHowToContent) {
        history.goBack();
        return;
      } else {
        handleAction({
          label: 'Yes',
          action: 'Yes',
          type: 'primary',
          url: '',
          callFunction: ''
        });
      }
    } catch (error) {
      console.error('catch src/templates/Troubleshooting/TroubleShootingNewPage.js TroubleShootingNewPage handleSolvedClick', error);
    }
  };
  var isAcssChannel = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params12 = configDetails.paramsDetails) === null || _configDetails$params12 === void 0 ? void 0 : _configDetails$params12.channel) === 'CARE';
  var isRetailChannel = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params13 = configDetails.paramsDetails) === null || _configDetails$params13 === void 0 ? void 0 : _configDetails$params13.channel) === 'Retail';
  var renderRadioButtons = function renderRadioButtons() {
    var getRadioData = [];
    var questionRadio = question.replace(/<\/?p>/gi, '').replace(/br\s*\/?>/gi, '').replace(/</g, '').trim();
    issuesAll.forEach(function (issue, index) {
      return getRadioData.push({
        name: issue.name,
        label: issue.label,
        value: issue.value,
        'data-track': issue.label,
        children: /*#__PURE__*/React__default.createElement("div", {
          className: "radio-desc " + (issue.htmlContent ? 'vds-radioDesc' : '')
        }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, issue.htmlContent)),
        ariaLabel: issue.label,
        disabled: false,
        inputId: "box-" + index
      });
    });
    if (issuesAll) {
      if (analysis.templateId !== 'LV_TEMPADDRESS_PILOT' || resolution.templateId !== 'LV_TEMPADDRESS_PILOT') {
        var _configDetails$params14, _configDetails$params15, _configDetails$params16, _configDetails$params17;
        return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Probing$5, {
          isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params14 = configDetails.paramsDetails) === null || _configDetails$params14 === void 0 ? void 0 : (_configDetails$params15 = _configDetails$params14.theme) === null || _configDetails$params15 === void 0 ? void 0 : _configDetails$params15.isDark
        }, /*#__PURE__*/React__default.createElement(RadioButtonGroup, {
          onChange: function onChange(e) {
            return handleOptionsChange(e);
          },
          error: false,
          defaultValue: selectedOption ? selectedOption : "-1",
          data: getRadioData,
          ariaLabel: questionRadio,
          surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params16 = configDetails.paramsDetails) !== null && _configDetails$params16 !== void 0 && (_configDetails$params17 = _configDetails$params16.theme) !== null && _configDetails$params17 !== void 0 && _configDetails$params17.isDark ? 'dark' : 'light'
        })), enableTRGFFlag == true && selectedOption == "Text Message (SMS)" && /*#__PURE__*/React__default.createElement(TestMessage, {
          selectedMdn: selectedMdn,
          setSendMessage: props.setSendMessage,
          setLanguageIndicator: props.setLanguageIndicator,
          processAction: processAction,
          pageId: currentPageId
        }));
      }
    }
    if (issuesAll) {
      return issuesAll.map(function (issue, index) {
        if (analysis.templateId === 'LV_TEMPADDRESS_PILOT' || resolution.templateId === 'LV_TEMPADDRESS_PILOT') {
          return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("label", null, "Number of days"), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(StyledNumberInput$3, {
            onChange: function onChange(e) {
              var value = e.target.value;
              if (/^(?:0|[0-9][0-9]?)$/.test(value)) {
                handleOptionsChange(e);
              }
            },
            onKeyDown: function onKeyDown(e) {
              if (e.key === '-' || e.key === '.' || e.key === '+') {
                e.preventDefault();
              }
            },
            type: "number",
            value: selectedOption
          }));
        }
      });
    }
  };
  var renderSettingsTableStatic = function renderSettingsTableStatic(mvd) {
    return /*#__PURE__*/React__default.createElement(StyledTable$3, {
      topLine: "primary",
      indentedCells: false
    }, /*#__PURE__*/React__default.createElement(TableHead, null, /*#__PURE__*/React__default.createElement(StyledTableHeader$3, null, "Setting"), /*#__PURE__*/React__default.createElement(StyledTableHeader$3, null, "Value"), /*#__PURE__*/React__default.createElement(StyledTableHeader$3, null, "Meaning")), /*#__PURE__*/React__default.createElement(TableBody, {
      bottomLine: true,
      hasHover: false,
      striped: false
    }, mvd.map(function (row) {
      return /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(StyledCell$3, null, row.setting), /*#__PURE__*/React__default.createElement(StyledCell$3, null, row.value), /*#__PURE__*/React__default.createElement(StyledCell$3, null, row.meaning));
    })));
  };
  var _useState27 = useState(1),
    activeTab = _useState27[0];
  var onTabChange = function onTabChange(e, i) {
    console.log('onTabChange', e, i);
    if (i == 0) {
      redirectToOldPortal();
    }
    if (i == 2) {
      redirectToOldPortal('issue-history');
    }
  };
  var renderTabs = function renderTabs() {
    return /*#__PURE__*/React__default.createElement(HeaderTabContainer$4, null, /*#__PURE__*/React__default.createElement(TabsContainer$4, null, /*#__PURE__*/React__default.createElement(Tabs$1, {
      orientation: "horizontal",
      indicatorPosition: "top",
      linePosition: "top",
      selectedIndex: activeTab,
      onTabChange: onTabChange
    }, /*#__PURE__*/React__default.createElement(Tab, {
      label: "Issue selector"
    }), /*#__PURE__*/React__default.createElement(Tab, {
      label: "Troubleshooting"
    }), /*#__PURE__*/React__default.createElement(Tab, {
      label: "Issue history"
    }))));
  };
  var closeTechCoachPopup = function closeTechCoachPopup(e) {
    functions.updateValues(values, {
      techCoachEligiblity: _extends({}, values.techCoachEligiblity, {
        openPopup: false,
        openChatbotFlowPopup: false
      })
    });
    taggingSetCloseView('Help from tech coach expert', '#tech_coach_popup_chatbot_flow');
  };
  var getContentFrament = function getContentFrament(tileName) {
    if (sessionStorage.getItem('propositionNBX') !== null && sessionStorage.getItem('propositionNBX') !== undefined) {
      var propositionNBX = JSON.parse(sessionStorage.getItem('propositionNBX'));
      var _propositionNBX$soiEn3 = propositionNBX.soiEngagementId,
        soiEngagementId = _propositionNBX$soiEn3 === void 0 ? '' : _propositionNBX$soiEn3,
        _propositionNBX$propo3 = propositionNBX.propositionId,
        propositionId = _propositionNBX$propo3 === void 0 ? '' : _propositionNBX$propo3;
      var soiEngagementIdValue = '';
      var propositionIdValue = '';
      if (soiEngagementId !== '') {
        soiEngagementIdValue = 'soiid_' + soiEngagementId;
      }
      if (propositionId !== '') {
        propositionIdValue = 'propid_' + propositionId;
      }
      var contentEOTFragment = "L1|P1|||" + soiEngagementIdValue + "|" + propositionIdValue + "|dispid_82||" + tileName;
      var contentFragmentText = "{\"type\": \"impression\", \"name\": \"" + contentEOTFragment + "\"}";
      return contentFragmentText;
    }
  };
  var getRecommendedText = function getRecommendedText() {
    var RecommendedTextWrapper = styled.div(_templateObject13$5 || (_templateObject13$5 = _taggedTemplateLiteralLoose(["\n      margin: 1rem 0;\n    "])));
    var recommendedTitle = [];
    if (!isEmpty(questions) && questions.length > 0 && !isEmpty(questions[0].choices)) {
      recommendedTitle = questions[0].choices.filter(function (choice) {
        return !isEmpty(choice.recommended) && choice.recommended && !isEmpty(choice.recommendedText);
      });
    }
    if (recommendedTitle.length > 0) {
      return /*#__PURE__*/React__default.createElement(RecommendedTextWrapper, null, /*#__PURE__*/React__default.createElement(Body, {
        size: "large",
        bold: true
      }, recommendedTitle[0].recommendedText));
    } else return /*#__PURE__*/React__default.createElement(Fragment, null);
  };
  var getIssueDescription = function getIssueDescription(description) {
    var checkHTML = /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/.test(description);
    if (checkHTML !== undefined && checkHTML !== null && !checkHTML) {
      return description;
    } else {
      return '';
    }
  };
  var getFooterNote = function getFooterNote(footNote, recommendationTileType) {
    if (footNote === void 0) {
      footNote = '';
    }
    if (recommendationTileType === void 0) {
      recommendationTileType = '';
    }
    if (!isEmpty(footNote) && footNote.indexOf('-') > -1) {
      var footNotes = footNote.split('-');
      if (recommendationTileType === 'support' && footNotes.length > 1) {
        return footNotes[1];
      } else if (footNotes.length > 0) {
        return footNotes[0];
      }
    } else return footNote;
  };
  var renderDescription = function renderDescription(tmpStep, index) {
    var _window15, _window15$config, _tmpStep$description, _configDetails$params20, _configDetails$params21, _configDetails$params22, _configDetails$params23, _configDetails$params24, _configDetails$params25;
    var _tmpStep$imageDetails = tmpStep.imageDetails,
      imageDetails = _tmpStep$imageDetails === void 0 ? [] : _tmpStep$imageDetails;
    if (!isNewDesign) {
      var _configDetails$params18, _configDetails$params19;
      return /*#__PURE__*/React__default.createElement(DescWrapper$3, null, /*#__PURE__*/React__default.createElement(Body, {
        size: "large",
        id: "content-description-data" + index,
        color: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params18 = configDetails.paramsDetails) === null || _configDetails$params18 === void 0 ? void 0 : (_configDetails$params19 = _configDetails$params18.theme) === null || _configDetails$params19 === void 0 ? void 0 : _configDetails$params19.isDark) && '#FFFFFF'
      }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, tmpStep.description)));
    }
    var triggerClickToCall = function triggerClickToCall() {
      var _window14, _window14$parent;
      console.log('triggerClickToCall');
      (_window14 = window) === null || _window14 === void 0 ? void 0 : (_window14$parent = _window14.parent) === null || _window14$parent === void 0 ? void 0 : _window14$parent.postMessage({
        isTroubleshooting: true
      }, document.referrer);
    };
    var agentLink = (tmpStep === null || tmpStep === void 0 ? void 0 : tmpStep.templateId) == 'END_OF_TROUBLESHOOTING_CARE1' && (_window15 = window) !== null && _window15 !== void 0 && (_window15$config = _window15.config) !== null && _window15$config !== void 0 && _window15$config.retailIframe ? true : false;
    var c2cUrl = tmpStep === null || tmpStep === void 0 ? void 0 : (_tmpStep$description = tmpStep.description) === null || _tmpStep$description === void 0 ? void 0 : _tmpStep$description.replace('tier 2.', "a &nbsp;");
    var cnsTemplateIds = ['DISRPT_IN_PROG_DATE_TIME', 'DISRPT_5G_IN_PROG_RCMD_WIFI', 'DISRPT_IN_PROG_RCMD_WFC', 'DISRPT_IN_PROG_RCMD_RESTART', 'DISRPT_RSLVD_RCMD_RESTART', 'PLAN_DISRPT_IN_PROG_RCMD_WFC', 'NO_DISRPT_FOUND', 'DISRPT_RSLVD_NO_RCMD', 'DISRPT_5G_RSLVD_NO_RCMD', 'CNS Outage'];
    var newDesignLongPageFlag = window.isMVODigital && !window.fwaDevice && (tmpStep === null || tmpStep === void 0 ? void 0 : tmpStep.templateId) == "InitialSetup" && window.tsFeatureFlags.enabletsLongPageReDesignFFlag;
    return /*#__PURE__*/React__default.createElement(DescWrapperNew$3, {
      isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params20 = configDetails.paramsDetails) === null || _configDetails$params20 === void 0 ? void 0 : (_configDetails$params21 = _configDetails$params20.theme) === null || _configDetails$params21 === void 0 ? void 0 : _configDetails$params21.isDark,
      segments: tmpStep === null || tmpStep === void 0 ? void 0 : tmpStep.segments
    }, /*#__PURE__*/React__default.createElement(DescInnerWrapper$3, null, /*#__PURE__*/React__default.createElement(DescBodyWrapper$3, {
      isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params22 = configDetails.paramsDetails) === null || _configDetails$params22 === void 0 ? void 0 : (_configDetails$params23 = _configDetails$params22.theme) === null || _configDetails$params23 === void 0 ? void 0 : _configDetails$params23.isDark
    }, /*#__PURE__*/React__default.createElement(Body, {
      size: "large",
      id: "content-description-data" + index,
      color: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params24 = configDetails.paramsDetails) === null || _configDetails$params24 === void 0 ? void 0 : (_configDetails$params25 = _configDetails$params24.theme) === null || _configDetails$params25 === void 0 ? void 0 : _configDetails$params25.isDark) && '#FFFFFF'
    }, /*#__PURE__*/React__default.createElement("div", {
      style: isACSS && enableNewDesignForCNSPagesFFlag && cnsTemplateIds.includes(tmpStep === null || tmpStep === void 0 ? void 0 : tmpStep.templateId) ? {
        backgroundColor: "#e3f2fd",
        padding: '20px',
        fontSize: '1.25rem',
        lineHeight: 1.5
      } : {}
    }, !agentLink && newDesignLongPageFlag && /*#__PURE__*/React__default.createElement(LongPageRedesign, {
      upDateHideNextBtn: upDateHideNextBtn,
      templateId: tmpStep === null || tmpStep === void 0 ? void 0 : tmpStep.templateId,
      description: tmpStep === null || tmpStep === void 0 ? void 0 : tmpStep.description
    }), !agentLink && !newDesignLongPageFlag && /*#__PURE__*/React__default.createElement(TextWithHtml, null, tmpStep.description), agentLink && /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: 'flex'
      }
    }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, c2cUrl), /*#__PURE__*/React__default.createElement("a", {
      style: {
        cursor: 'pointer',
        color: '#000'
      },
      onClick: triggerClickToCall
    }, "\xA0 Tech Champion 2 Agent"))))), imageDetails.length > 0 && /*#__PURE__*/React__default.createElement(ImageCarousel, {
      imageDetails: imageDetails
    })));
  };
  var handleFeedbackFlags = function handleFeedbackFlags(flags) {
    setFlags(_extends({}, flags));
  };
  var closeBannerBar = function closeBannerBar() {
    setBannerValues(_extends({}, bannerValues, {
      bannerContainerDetails: {
        show: false
      }
    }));
  };
  var handleDownloadClick = function handleDownloadClick(event) {
    event.stopPropagation();
    window.vzdl.target.message = '';
    var copyUrl = arrArticleUrl.length && arrArticleUrl[0].articleUrl != undefined && arrArticleUrl[0].articleUrl.length ? arrArticleUrl[0].articleUrl : '';
    navigator.clipboard.writeText(copyUrl);
    setBannerValues(_extends({}, bannerValues, {
      bannerContainerDetails: {
        show: true,
        templateId: 'COPY_CLIPBOARD_MODAL'
      }
    }));
    try {
      var _configDetails$caseDe, _configDetails$select3, _window16, _window16$vzdl, _window17, _window17$vzdl, _window18, _window18$vztag, _window18$vztag$api;
      var page = "troubleshooter | " + (symptom.issueName || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$caseDe = configDetails.caseDetails) === null || _configDetails$caseDe === void 0 ? void 0 : _configDetails$caseDe.intent) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select3 = configDetails.selectedNSAIntent) === null || _configDetails$select3 === void 0 ? void 0 : _configDetails$select3.intent)) + " | Copy external URL";
      if ((_window16 = window) !== null && _window16 !== void 0 && (_window16$vzdl = _window16.vzdl) !== null && _window16$vzdl !== void 0 && _window16$vzdl.target) {
        window.vzdl.target.message = 'Copy external URL';
      }
      if ((_window17 = window) !== null && _window17 !== void 0 && (_window17$vzdl = _window17.vzdl) !== null && _window17$vzdl !== void 0 && _window17$vzdl.page && typeof window.vzdl.page === "object") {
        window.vzdl.page.name = page;
        window.vzdl.page.detail = page;
      } else {
        window.vzdl.page = {
          name: page,
          detail: page
        };
      }
      (_window18 = window) === null || _window18 === void 0 ? void 0 : (_window18$vztag = _window18.vztag) === null || _window18$vztag === void 0 ? void 0 : (_window18$vztag$api = _window18$vztag.api) === null || _window18$vztag$api === void 0 ? void 0 : _window18$vztag$api.dispatch('notification');
      sendCustomEvent$1('notification', window.vzdl);
      setTimeout(function () {
        window.vzdl.target.message = '';
        console.log('window.vzdl.target.message2=======', window.vzdl);
      }, 1000);
    } catch (error) {
      console.error('sendCustomEvent handleDownloadClick error', error);
    }
  };
  var handleSmsClick = function handleSmsClick() {
    var button = {
      label: 'SendSMS',
      action: 'SendSMS',
      type: 'primary',
      url: '',
      callFunction: ''
    };
    setBtnValue(true);
    var options = {
      optionSelected: '',
      custEmailId: '',
      custFirstName: '',
      articleId: articleId,
      articleUrl: articleUrl,
      articleName: articleName,
      subProcessStep: 'Article'
    };
    if (selectedOption) {
      options.optionSelected = selectedOption;
    }
    if (functions.handleTroubleShootingAction) {
      functions.handleTroubleShootingAction(button, options);
      setSelectedOption('');
    }
  };
  var handleEmailClick = function handleEmailClick() {
    try {
      var _configDetails$caseDe2, _configDetails$select4, _window19, _window19$vzdl, _configDetails$params26;
      var page = "troubleshooter | " + (symptom.issueName || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$caseDe2 = configDetails.caseDetails) === null || _configDetails$caseDe2 === void 0 ? void 0 : _configDetails$caseDe2.intent) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select4 = configDetails.selectedNSAIntent) === null || _configDetails$select4 === void 0 ? void 0 : _configDetails$select4.intent)) + " | Send Email";
      if ((_window19 = window) !== null && _window19 !== void 0 && (_window19$vzdl = _window19.vzdl) !== null && _window19$vzdl !== void 0 && _window19$vzdl.page && typeof window.vzdl.page === "object") {
        window.vzdl.page.name = page;
        window.vzdl.page.detail = page;
      } else {
        window.vzdl.page = {
          name: page,
          detail: page
        };
      }
      if ((configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params26 = configDetails.paramsDetails) === null || _configDetails$params26 === void 0 ? void 0 : _configDetails$params26.channel) === 'CARE') {
        var _window20, _window20$vztag, _window20$vztag$api;
        window.vzdl.target.message = '';
        console.log('handleEmailClick sendCustomEvent openView', window.vzdl);
        (_window20 = window) === null || _window20 === void 0 ? void 0 : (_window20$vztag = _window20.vztag) === null || _window20$vztag === void 0 ? void 0 : (_window20$vztag$api = _window20$vztag.api) === null || _window20$vztag$api === void 0 ? void 0 : _window20$vztag$api.dispatch('openView', {
          name: page,
          detail: page
        });
        sendCustomEvent$1('openView', window.vzdl);
      } else {
        var _window21, _window21$vztag, _window21$vztag$api;
        console.log('handleEmailClick sendCustomEvent troubleshooting', window.vzdl);
        (_window21 = window) === null || _window21 === void 0 ? void 0 : (_window21$vztag = _window21.vztag) === null || _window21$vztag === void 0 ? void 0 : (_window21$vztag$api = _window21$vztag.api) === null || _window21$vztag$api === void 0 ? void 0 : _window21$vztag$api.dispatch('troubleshooting', {
          name: page,
          detail: page
        });
        sendCustomEvent$1('troubleshooting', window.vzdl);
      }
      setBannerNameUpdate('');
    } catch (error) {
      console.error('sendCustomEvent handleEmailClick error', error);
    }
    setEmailModal(_extends({}, emailModal, {
      show: true
    }));
  };
  var handleResumeIconClick = function handleResumeIconClick() {
    setSubProcessStep('Resume');
    try {
      var _configDetails$caseDe3, _configDetails$select5, _window22, _window22$vzdl, _configDetails$params27;
      var page = "troubleshooter | " + (symptom.issueName || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$caseDe3 = configDetails.caseDetails) === null || _configDetails$caseDe3 === void 0 ? void 0 : _configDetails$caseDe3.intent) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select5 = configDetails.selectedNSAIntent) === null || _configDetails$select5 === void 0 ? void 0 : _configDetails$select5.intent)) + " | Send Resume Email";
      if ((_window22 = window) !== null && _window22 !== void 0 && (_window22$vzdl = _window22.vzdl) !== null && _window22$vzdl !== void 0 && _window22$vzdl.page && typeof window.vzdl.page === "object") {
        window.vzdl.page.name = page;
        window.vzdl.page.detail = page;
      } else {
        window.vzdl.page = {
          name: page,
          detail: page
        };
      }
      if ((configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params27 = configDetails.paramsDetails) === null || _configDetails$params27 === void 0 ? void 0 : _configDetails$params27.channel) === 'CARE') {
        var _window23, _window23$vztag, _window23$vztag$api;
        console.log('handleResumeIconClick sendCustomEvent openView', window.vzdl);
        (_window23 = window) === null || _window23 === void 0 ? void 0 : (_window23$vztag = _window23.vztag) === null || _window23$vztag === void 0 ? void 0 : (_window23$vztag$api = _window23$vztag.api) === null || _window23$vztag$api === void 0 ? void 0 : _window23$vztag$api.dispatch('openView', {
          name: page,
          detail: page
        });
        sendCustomEvent$1('openView', window.vzdl);
      } else {
        var _window24, _window24$vztag, _window24$vztag$api;
        console.log('handleResumeIconClick sendCustomEvent troubleshooting', window.vzdl);
        (_window24 = window) === null || _window24 === void 0 ? void 0 : (_window24$vztag = _window24.vztag) === null || _window24$vztag === void 0 ? void 0 : (_window24$vztag$api = _window24$vztag.api) === null || _window24$vztag$api === void 0 ? void 0 : _window24$vztag$api.dispatch('troubleshooting', {
          name: page,
          detail: page
        });
        sendCustomEvent$1('troubleshooting', window.vzdl);
      }
      setBannerNameUpdate('');
    } catch (error) {
      console.error('sendCustomEvent handleResumeIconClick error', error);
    }
    setShowResumeEmail(true);
  };
  var handleCancelEmailButton = function handleCancelEmailButton() {
    setEmailModal(_extends({}, emailModal, {
      show: false
    }));
  };
  var emailModalChange = function emailModalChange(open) {
    if (!open) {
      setEmailModal(_extends({}, emailModal, {
        show: false
      }));
    }
  };
  var handleSendEmailButton = function handleSendEmailButton() {
    if (errFNameFlag || errEmailIdFlag) {
      return false;
    }
    if (!errFNameFlag && !errEmailIdFlag) {
      setBannerValues(_extends({}, bannerValues, {
        bannerContainerDetails: {
          show: true,
          templateId: 'SEND_EMAIL_MODAL'
        }
      }));
      setEmailModal(_extends({}, emailModal, {
        show: false
      }));
    }
    setBannerNameUpdate('SEND_EMAIL_MODAL');
    var button = {
      label: 'SendEmail',
      action: 'SendEmail',
      type: 'primary',
      url: '',
      callFunction: ''
    };
    setBtnValue(true);
    var options = {
      optionSelected: '',
      custEmailId: emailModal.emailId,
      custFirstName: emailModal.FName,
      articleId: articleId,
      articleUrl: articleUrl,
      articleName: articleName,
      subProcessStep: 'Article'
    };
    if (selectedOption) {
      options.optionSelected = selectedOption;
    }
    if (functions.handleTroubleShootingAction) {
      functions.handleTroubleShootingAction(button, options);
      setSelectedOption('');
    }
  };
  var handleInputChange = function handleInputChange(event) {
    event.preventDefault();
    var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;
    switch (name) {
      case 'FName':
        if (value.trim() == '') {
          setErrFNameFlag(true);
          setEmailModal(_extends({}, emailModal, {
            FName: value,
            errFNameTxt: 'Please enter name'
          }));
        } else {
          setErrFNameFlag(false);
          setEmailModal(_extends({}, emailModal, {
            FName: value,
            errFNameTxt: ''
          }));
        }
        break;
      case 'emailId':
        var checkValidEmail = isValidEmail(value);
        if (!checkValidEmail) {
          setErrEmailIdFlag(true);
          setEmailModal(_extends({}, emailModal, {
            show: true,
            emailId: value,
            errEmailIdTxt: 'Please enter valid email'
          }));
        } else {
          setErrEmailIdFlag(false);
          setEmailModal(_extends({}, emailModal, {
            show: true,
            emailId: value,
            errEmailIdTxt: ''
          }));
        }
        break;
    }
  };
  var _handleFeedbackClick = function handleFeedbackClick(templateType) {
    if (templateType === 'waitscreen') {
      return;
    }
    if (isNewDesign) {
      setModalValues(_extends({}, modalValues, {
        showModal: true
      }));
      setFlags(_extends({}, flags, {
        showThumbsUp: false,
        showThumbsDown: false
      }));
    } else {
      !flags.thumbsClicked && setModalValues(_extends({}, modalValues, {
        showModal: true
      }));
    }
  };
  var renderSubSection = function renderSubSection(subSection) {
    var values = subSection.values || subSection.value || [];
    if (values.length) {
      showBillingChecksButton = true;
      return /*#__PURE__*/React__default.createElement(BillingSteps$3, null, /*#__PURE__*/React__default.createElement("ul", {
        style: {
          paddingLeft: '25px'
        }
      }, values.map(function (value) {
        return /*#__PURE__*/React__default.createElement("li", null, value);
      })));
    }
    if (subSection.tableValues && subSection.tableValues.length) {
      var _configDetails$params28, _configDetails$params29;
      var buttonFix;
      if (subSection.button) {
        var ctaClicked = subSection.button.replaceAll(/\s/g, '');
        buttonFix = {
          label: subSection.button,
          action: 'ReloadStep',
          type: 'primary',
          url: '',
          callFunction: '',
          ctaClicked: ctaClicked,
          uid: 'RBC'
        };
      }
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ProvisioningChecksInfo$3, null, /*#__PURE__*/React__default.createElement("div", null, subSection.id), /*#__PURE__*/React__default.createElement("div", null, subSection.button && /*#__PURE__*/React__default.createElement(Button$1, {
        size: "small",
        "data-analyticstrack": buttonFix.label + "-Btn",
        "data-track": "{\"type\": \"link\", \"name\": \"" + buttonFix.label + "-Btn\"}",
        "data-clickstream": buttonFix.label + "-btn-cta-1",
        onClick: function onClick() {
          return handleAction(buttonFix);
        }
      }, buttonFix.label), subSection.url && /*#__PURE__*/React__default.createElement("a", {
        href: subSection.url,
        target: "blank"
      }, subSection.linkText))), /*#__PURE__*/React__default.createElement(SpacerDiv, {
        height: "5px"
      }), /*#__PURE__*/React__default.createElement(ProvisioningChecksTable$3, {
        color: subSection.color
      }, /*#__PURE__*/React__default.createElement(Table, {
        surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params28 = configDetails.paramsDetails) !== null && _configDetails$params28 !== void 0 && (_configDetails$params29 = _configDetails$params28.theme) !== null && _configDetails$params29 !== void 0 && _configDetails$params29.isDark ? 'dark' : 'light'
      }, /*#__PURE__*/React__default.createElement(TableHead, null, /*#__PURE__*/React__default.createElement(Cell$1, null, "Network Element"), /*#__PURE__*/React__default.createElement(Cell$1, null, "Problem To Correct")), subSection.tableValues.map(function (value) {
        return /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(Cell$1, null, value.networkElement), /*#__PURE__*/React__default.createElement(Cell$1, null, value.problemToCorrect.map(function (problem) {
          return /*#__PURE__*/React__default.createElement("div", null, problem);
        })));
      }))));
    }
  };
  var renderSection = function renderSection(section, isBillingChecks) {
    if (section.length > 0) {
      return section.map(function (subSection) {
        var _subSection$footnote = subSection.footnote,
          footnote = _subSection$footnote === void 0 ? '' : _subSection$footnote;
        return /*#__PURE__*/React__default.createElement(Fragment, null, isBillingChecks && /*#__PURE__*/React__default.createElement(SpacerDiv, {
          height: "10px"
        }), isBillingChecks && /*#__PURE__*/React__default.createElement(BoldText$3, null, subSection.id), isBillingChecks && /*#__PURE__*/React__default.createElement(SpacerDiv, {
          height: "10px"
        }), /*#__PURE__*/React__default.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: subSection.description
          }
        }), renderSubSection(subSection), footnote && /*#__PURE__*/React__default.createElement(FootnoteBlock$3, {
          dangerouslySetInnerHTML: {
            __html: footnote
          }
        }), /*#__PURE__*/React__default.createElement(SpacerDiv, {
          height: "10px"
        }));
      });
    }
  };
  var renderChecksButton = function renderChecksButton(buttonToShow, buttonNote) {
    if (buttonToShow === void 0) {
      buttonToShow = 'Rerun Billing Check';
    }
    if (buttonNote === void 0) {
      buttonNote = '';
    }
    var ctaClicked = buttonToShow.replaceAll(/\s/g, '');
    var buttonCheck = {
      label: buttonToShow,
      action: 'ReloadStep',
      type: 'primary',
      url: '',
      callFunction: '',
      ctaClicked: ctaClicked,
      uid: 'RBC'
    };
    if (!is5GDevice) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(SpacerDiv, {
        height: "10px"
      }), /*#__PURE__*/React__default.createElement(SpacerDiv, {
        height: "10px"
      }), buttonNote, buttonNote && /*#__PURE__*/React__default.createElement(SpacerDiv, {
        height: "5px"
      }), /*#__PURE__*/React__default.createElement(Button$1, {
        test: "test",
        "data-analyticstrack": buttonCheck.label + "-Btn",
        "data-track": "{\"type\": \"link\", \"name\": \"" + buttonCheck.label + "-Btn\"}",
        "data-clickstream": buttonCheck.label + "-btn-cta-1",
        onClick: function onClick() {
          return handleAction(buttonCheck);
        },
        width: "270px",
        className: "rerun-billing-check"
      }, buttonCheck.label), /*#__PURE__*/React__default.createElement(SpacerDiv, {
        height: "10px"
      }), /*#__PURE__*/React__default.createElement(SpacerDiv, {
        height: "10px"
      }));
    }
  };
  var renderChecks = function renderChecks(tmpStep) {
    var _tmpStep$sections, _sections$;
    var sections = (_tmpStep$sections = tmpStep === null || tmpStep === void 0 ? void 0 : tmpStep.sections) != null ? _tmpStep$sections : [];
    var isBillingChecks = ((_sections$ = sections[0]) === null || _sections$ === void 0 ? void 0 : _sections$.sectionId) === 'Billing Checks';
    if (!is5GDevice) {
      var _sections$2, _sections$3, _sections$4, _sections$5, _sections$6;
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("b", null, (!((_sections$2 = sections[0]) !== null && _sections$2 !== void 0 && _sections$2.sectionId) || isBillingChecks) && 'Billing checks'), isBillingChecks && /*#__PURE__*/React__default.createElement(SpacerDiv, {
        height: "10px"
      }), isBillingChecks && /*#__PURE__*/React__default.createElement(SpacerDiv, {
        height: "10px"
      }), isBillingChecks && /*#__PURE__*/React__default.createElement(Line$1, {
        surface: "dark"
      }), renderSection(((_sections$3 = sections[0]) === null || _sections$3 === void 0 ? void 0 : _sections$3.section) || [], isBillingChecks), (((_sections$4 = sections[0]) === null || _sections$4 === void 0 ? void 0 : _sections$4.buttonToShow) || showBillingChecksButton) && renderChecksButton((_sections$5 = sections[0]) === null || _sections$5 === void 0 ? void 0 : _sections$5.buttonToShow, (_sections$6 = sections[0]) === null || _sections$6 === void 0 ? void 0 : _sections$6.buttonNote));
    }
  };
  var renderDuplicateIcon = function renderDuplicateIcon() {
    var _configDetails$params30, _configDetails$params31;
    var color = configDetails !== null && configDetails !== void 0 && (_configDetails$params30 = configDetails.paramsDetails) !== null && _configDetails$params30 !== void 0 && (_configDetails$params31 = _configDetails$params30.theme) !== null && _configDetails$params31 !== void 0 && _configDetails$params31.isDark ? '#ffffff' : '#000000';
    return /*#__PURE__*/React__default.createElement(CopyIconDiv$3, {
      tabIndex: "0",
      role: "link",
      "aria-label": "Copy external URL",
      onClick: handleDownloadClick
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      name: "duplicate",
      size: "medium",
      color: color,
      ariaHidden: "true",
      tabIndex: "-1"
    }));
  };
  var renderSmsIcon = function renderSmsIcon() {
    var _configDetails$params32, _configDetails$params33;
    var color = configDetails !== null && configDetails !== void 0 && (_configDetails$params32 = configDetails.paramsDetails) !== null && _configDetails$params32 !== void 0 && (_configDetails$params33 = _configDetails$params32.theme) !== null && _configDetails$params33 !== void 0 && _configDetails$params33.isDark ? '#ffffff' : '#000000';
    return /*#__PURE__*/React__default.createElement(SmsIconDiv$3, {
      tabIndex: "0",
      role: "link",
      "aria-label": "Send SMS of applicable content",
      onClick: handleSmsClick
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      name: "send-message",
      size: "medium",
      color: color,
      ariaHidden: "true",
      tabIndex: "-1"
    }));
  };
  var renderEmailIcon = function renderEmailIcon() {
    var _configDetails$params34, _configDetails$params35;
    var color = configDetails !== null && configDetails !== void 0 && (_configDetails$params34 = configDetails.paramsDetails) !== null && _configDetails$params34 !== void 0 && (_configDetails$params35 = _configDetails$params34.theme) !== null && _configDetails$params35 !== void 0 && _configDetails$params35.isDark ? '#ffffff' : '#000000';
    return /*#__PURE__*/React__default.createElement(EmailIconDiv$3, {
      tabIndex: "0",
      role: "link",
      "aria-label": "Send email of applicable content",
      onClick: handleEmailClick
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      name: "email",
      size: "medium",
      color: color,
      ariaHidden: "true",
      tabIndex: "-1"
    }));
  };
  var renderResumeIcon = function renderResumeIcon() {
    var _configDetails$params36, _configDetails$params37;
    var color = configDetails !== null && configDetails !== void 0 && (_configDetails$params36 = configDetails.paramsDetails) !== null && _configDetails$params36 !== void 0 && (_configDetails$params37 = _configDetails$params36.theme) !== null && _configDetails$params37 !== void 0 && _configDetails$params37.isDark ? '#ffffff' : '#000000';
    return /*#__PURE__*/React__default.createElement(ResumeEmailIconDiv$3, {
      style: {
        paddingLeft: '5px'
      },
      tabIndex: "0",
      role: "link",
      "aria-label": "Send Resume TS Email",
      onClick: handleResumeIconClick
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      name: "play-with",
      size: "medium",
      color: color,
      ariaHidden: "true",
      tabIndex: "-1"
    }));
  };
  var selectedIntent = {};
  try {
    var _selectedIntent = sessionStorage.getItem('nsaIntentSelected') || '{}';
    selectedIntent = JSON.parse(_selectedIntent);
  } catch (e) {
    console.error('Failed to get nsaIntentSelected from session storage', e);
  }
  var intenttitle = symptom.issueName || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$caseDe4 = configDetails.caseDetails) === null || _configDetails$caseDe4 === void 0 ? void 0 : _configDetails$caseDe4.intent) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select6 = configDetails.selectedNSAIntent) === null || _configDetails$select6 === void 0 ? void 0 : _configDetails$select6.intent) || ((_selectedIntent2 = selectedIntent) === null || _selectedIntent2 === void 0 ? void 0 : _selectedIntent2.intent) || 'Title';
  var personalizedTitle = context === null || context === void 0 ? void 0 : context.personalizedTitle;
  var intent = {};
  if (personalizedTitle) {
    intent = personalizedTitle;
  } else {
    intent = intenttitle;
  }
  var getTitle = function getTitle() {
    var _troubleshootingDetai;
    var troubleshootingDetails;
    if (sessionStorage.getItem('troubleshootingDetails')) {
      troubleshootingDetails = JSON.parse(sessionStorage.getItem('troubleshootingDetails'));
    }
    var title = props.combinedIssueSelector ? (_troubleshootingDetai = troubleshootingDetails) === null || _troubleshootingDetai === void 0 ? void 0 : _troubleshootingDetai.intent : '';
    if (context.personalizedTitle) {
      var _window$tsFeatureFlag2;
      title = window.isMVODigital && (_window$tsFeatureFlag2 = window.tsFeatureFlags) !== null && _window$tsFeatureFlag2 !== void 0 && _window$tsFeatureFlag2.enableRemovePrepaidStringFFlag ? removeTextFromString(intent, 'Prepaid') : intent;
    }
    focusScreenTitle();
    return title || intent || 'Title';
  };
  var getTitleOld = function getTitleOld() {
    var _configDetails$caseDe5, _configDetails$select7;
    var Title = (symptom === null || symptom === void 0 ? void 0 : symptom.issueName) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$caseDe5 = configDetails.caseDetails) === null || _configDetails$caseDe5 === void 0 ? void 0 : _configDetails$caseDe5.intent) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select7 = configDetails.selectedNSAIntent) === null || _configDetails$select7 === void 0 ? void 0 : _configDetails$select7.intent) || 'Title';
    return Title + " " + (currentPageId && currentPageId !== '1' ? typeof deviceName !== 'undefined' && deviceName !== null && deviceName != '' ? ' - ' + deviceName : '' : '');
  };
  var step = steps[0] || {};
  var aiSummryEnabled = step.aiSummryEnabled,
    genAICompositeKey = step.genAICompositeKey;
  var template = step.templateType;
  var disableContinueButton = function disableContinueButton() {
    console.log('disableContinueButton', templateTypeMain, choices, btnValue, analysis.templateId);
    if (analysis.disableCTA || resolution.disableCTA) {
      return true;
    }
    if (templateTypeMain == 'waitscreen') {
      return true;
    }
    if (analysis.templateId == 'DEVICE_REPLACEMENT_OPTIONS' || resolution.templateId == 'DEVICE_REPLACEMENT_OPTIONS') {
      return false;
    }
    if (choices && btnValue) {
      return true;
    }
    if ((analysis.templateId === 'SELECT_DEVICE' || resolution.templateId === 'SELECT_DEVICE') && selectedOption !== '') {
      return false;
    } else if ((analysis.templateId === 'SELECT_DEVICE' || resolution.templateId === 'SELECT_DEVICE') && selectedOption === '') {
      return true;
    }
  };
  var handleOpenedChange = function handleOpenedChange(value) {
    setShowKBDocModal(value);
    if (!value) {
      setCtaResponse({});
      setAttachHandler(false);
    }
  };
  var handleResumeEmailSend = function handleResumeEmailSend(payload) {
    var _analysis$custFirstNa;
    if (subProcessStep === 'Article') {
      setSelectedOption('custEd');
      setSelectedCtaValue('custEd');
    }
    var button = {
      label: 'SendEmail',
      action: 'SendEmail',
      type: 'primary',
      url: '',
      callFunction: ''
    };
    var options = _extends({
      optionSelected: '',
      custFirstName: (_analysis$custFirstNa = analysis === null || analysis === void 0 ? void 0 : analysis.custFirstName) != null ? _analysis$custFirstNa : '',
      subProcessStep: subProcessStep
    }, payload);
    if (selectedOption) {
      options.optionSelected = selectedOption;
    }
    if (subProcessStep === 'Article') {
      options.optionSelected = 'custEd';
    }
    setBannerNameUpdate('SEND_RESUME_EMAIL_MODAL');
    if (functions.handleTroubleShootingAction) {
      functions.handleTroubleShootingAction(button, options);
      setSelectedOption('');
    }
  };
  var eleRef = useRef();
  useEffect(function () {
    if (!thumbsDownSubmittedStep) {
      eleRef.current.focus();
    }
    if (uiLoggerContext.setPageDetails) {
      var pageDetails = {
        pageTitle: getTitle(),
        pageName: "4G Troubleshooting | " + (analysis.title || resolution.title),
        flowName: '4G Troubleshooting'
      };
      uiLoggerContext.setPageDetails(pageDetails);
    }
  }, [currentPageId]);
  var sendEmailRef = useRef(null);
  useEffect(function () {
    if (sendEmailRef.current !== null) {
      sendEmailRef.current.focus();
    }
    if (isACSS && !isHowToContent) {
      var _stepInputRef$current;
      stepInputRef === null || stepInputRef === void 0 ? void 0 : (_stepInputRef$current = stepInputRef.current) === null || _stepInputRef$current === void 0 ? void 0 : _stepInputRef$current.focus();
    } else if (isACSS && isHowToContent) {
      var _eleRef$current;
      eleRef === null || eleRef === void 0 ? void 0 : (_eleRef$current = eleRef.current) === null || _eleRef$current === void 0 ? void 0 : _eleRef$current.focus();
    }
  }, []);
  var isRetail = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params38 = configDetails.paramsDetails) === null || _configDetails$params38 === void 0 ? void 0 : _configDetails$params38.channel) == 'Retail';
  var renderColumn = function renderColumn(row, i) {
    if (row.length == 24) {
      row.unshift(moment().tz('America/New_York').subtract(7 - i + 1, 'days').format('ddd'));
      row.unshift(moment().tz('America/New_York').subtract(7 - i + 1, 'days').format('MM/DD'));
    }
    return row.map(function (column) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "column " + (column == 1 ? 'redbg' : column == 0 ? 'white' : column == 'blank' ? 'column0' : '')
      }, column);
    });
  };
  var renderRow = function renderRow(networkCongestionData) {
    return networkCongestionData.map(function (row, i) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "row"
      }, renderColumn(row, i));
    });
  };
  var renderNetworkCongestion = function renderNetworkCongestion(networkCongestionData) {
    if (networkCongestionData.length == 7) {
      networkCongestionData.unshift(['blank', 'blank', '12 AM', '1 AM', '2 AM', '3 AM', '4 AM', '5 AM', '6 AM', '7 AM', '8 AM', '9 AM', '10 AM', '11 AM', '12 PM', '1 PM', '2 PM', '3 PM', '4 PM', '5 PM', '6 PM', '7 PM', '8 PM', '9 PM', '10 PM', '11 PM']);
    }
    if (networkCongestionData.length) {
      return renderRow(networkCongestionData);
    }
  };
  var networkCongestionStep = steps === null || steps === void 0 ? void 0 : steps.filter(function (step) {
    return (step === null || step === void 0 ? void 0 : step.templateId) == "NETWORK_CONGESTION";
  });
  var networkCongestionDataOriginal = (networkCongestionStep === null || networkCongestionStep === void 0 ? void 0 : (_networkCongestionSte = networkCongestionStep[0]) === null || _networkCongestionSte === void 0 ? void 0 : _networkCongestionSte.networkCongestionData) && JSON.parse(networkCongestionStep === null || networkCongestionStep === void 0 ? void 0 : (_networkCongestionSte2 = networkCongestionStep[0]) === null || _networkCongestionSte2 === void 0 ? void 0 : _networkCongestionSte2.networkCongestionData);
  var selectDeviceBannerEligibility = function selectDeviceBannerEligibility(step) {
    if (step === void 0) {
      step = {};
    }
    var _step2 = step,
      _step2$templateId = _step2.templateId,
      templateId = _step2$templateId === void 0 ? '' : _step2$templateId;
    var urlString = window.location.hash;
    var params = configDetails || {};
    var _params$paramsDetails = params.paramsDetails,
      _params$paramsDetails2 = _params$paramsDetails === void 0 ? {} : _params$paramsDetails,
      _params$paramsDetails3 = _params$paramsDetails2.changeDeviceFlow,
      changeDeviceFlow = _params$paramsDetails3 === void 0 ? false : _params$paramsDetails3;
    console.log('paramsInSelectDevice-->', params);
    return urlString.includes('/eotsecure') && templateId === 'RESOLUTION_OPTIONS_ALL_DIGITAL' && changeDeviceFlow;
  };
  var popOutFlow = (_window25 = window) !== null && _window25 !== void 0 && _window25.isBAUACSS ? true : false;
  var _values$techCoachElig = _extends({}, values.techCoachEligiblity),
    _values$techCoachElig2 = _values$techCoachElig.accountElgible,
    accountElgible = _values$techCoachElig2 === void 0 ? false : _values$techCoachElig2,
    _values$techCoachElig3 = _values$techCoachElig.intentEligible,
    intentEligible = _values$techCoachElig3 === void 0 ? false : _values$techCoachElig3,
    _values$techCoachElig5 = _values$techCoachElig.openChatbotFlowPopup,
    openChatbotFlowPopup = _values$techCoachElig5 === void 0 ? false : _values$techCoachElig5;
  console.log('every render useeffect-->');
  var getIntentId = function getIntentId() {
    var _window26, _configDetails$select8;
    if ((_window26 = window) !== null && _window26 !== void 0 && _window26.isMVODigital) {
      var getTroubleshootParams = JSON.parse(sessionStorage.getItem('troubleshootingDetails'));
      return getTroubleshootParams === null || getTroubleshootParams === void 0 ? void 0 : getTroubleshootParams.intentId;
    }
    var tsCaseDetails = sessionUtility.getCaseDetails();
    return (tsCaseDetails === null || tsCaseDetails === void 0 ? void 0 : tsCaseDetails.intentId) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select8 = configDetails.selectedNSAIntent) === null || _configDetails$select8 === void 0 ? void 0 : _configDetails$select8.intentId);
  };
  var isMVODigital = (_window27 = window) === null || _window27 === void 0 ? void 0 : _window27.isMVODigital;
  var intentId = getIntentId();
  var udbIntentId = false;
  if (intentId === 'IN11995') {
    udbIntentId = true;
  }
  var isGenAIEnabed = (isACSS || isMVODigital) && aiSummryEnabled;
  var _useState28 = useState(false),
    showContent = _useState28[0],
    setShowContent = _useState28[1];
  useEffect(function () {
    if (!isGenAIEnabed) session('aiSummary').reset();
  }, [intentId, isGenAIEnabed]);
  var toggleContent = function toggleContent(event, value) {
    if (!!value) setShowContent(value);else setShowContent(function (prev) {
      return !prev;
    });
  };
  var shouldShowContent = useMemo(function () {
    if (!isGenAIEnabed) return true;else if (isGenAIEnabed && showContent) return true;else return false;
  }, [isGenAIEnabed, showContent]);
  useEffect(function () {
    var rightMenuElements = [];
    if (isNewDesign) {
      steps.forEach(function (e, ind) {
        prepareAccordions("content-description-data" + ind, rightMenuElements);
      });
    }
    setRightMenuItems([].concat(rightMenuElements));
  }, [currentPageId, analysis === null || analysis === void 0 ? void 0 : analysis.templateId, shouldShowContent]);
  var _useState29 = useState(false),
    HideNextBtn = _useState29[0],
    upDateHideNextBtn = _useState29[1];
  var _useState30 = useState(false),
    showNotification = _useState30[0],
    setShowNotification = _useState30[1];
  var _useState31 = useState(''),
    notificationMessage = _useState31[0],
    setNotificationMessage = _useState31[1];
  var nrbEOTErrorMessage = (additionalInfoSteps === null || additionalInfoSteps === void 0 ? void 0 : additionalInfoSteps.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.templateId) === "ERROR_MSG_NRB_RETRY_FAILURE";
  })) || {
    title: 'We were unable to submit NRB ticket.',
    description: 'Please submit the ticket via the Remedy Ticket creation link in the Devices Tab in ACSS.'
  };
  var handleNRBNotification = function handleNRBNotification() {
    var fallbackMessage = {
      title: 'We were unable to submit NRB ticket.',
      description: 'Please try again later.'
    };
    var errorMessage = (additionalInfoSteps === null || additionalInfoSteps === void 0 ? void 0 : additionalInfoSteps.find(function (item) {
      return (item === null || item === void 0 ? void 0 : item.templateId) === "ERROR_MSG_NRB_SUBMISSION_FAILURE";
    })) || fallbackMessage;
    setNotificationMessage(errorMessage);
    setShowNotification(true);
  };
  var showNRBNotification = function showNRBNotification(props) {
    if (!props) {
      setShowNotification(false);
      return;
    }
    handleNRBNotification();
  };
  var showTitle = window.isMVODigital ? true : isHowToContent ? true : false;
  var RenderIconSection = function RenderIconSection() {
    var _configDetails$params39, _configDetails$params40, _configDetails$params41, _configDetails$params42, _configDetails$params43, _configDetails$params44, _configDetails$params45, _configDetails$params46, _arrArticleId$, _arrArticleId$$articl;
    return /*#__PURE__*/React__default.createElement(Fragment, null, (arrShowcopyUrl.length > 0 || arrSendEmailUrl.length > 0 || resumeEmailSteps.length) > 0 ? /*#__PURE__*/React__default.createElement(IconDownloadEmail$3, null, arrShowcopyUrl.length > 0 && arrShowcopyUrl[0].showCopyUrlIcon.toLowerCase() === 'yes' ? /*#__PURE__*/React__default.createElement(CustomTooltip$3, {
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params39 = configDetails.paramsDetails) !== null && _configDetails$params39 !== void 0 && (_configDetails$params40 = _configDetails$params39.theme) !== null && _configDetails$params40 !== void 0 && _configDetails$params40.isDark ? 'dark' : 'light',
      title: "Copy external URL",
      alt: "Copy external URL",
      ariaLabel: "Copy external URL",
      size: "small",
      renderAnchorElement: renderDuplicateIcon,
      containerId: "ContentWrapper"
    }) : '', smsFFlag !== null && smsFFlag !== void 0 && smsFFlag.status && isSmartPhone && arrSendEmailUrl.length > 0 && arrSendEmailUrl[0].showSendMailIcon.toLowerCase() === 'yes' ? /*#__PURE__*/React__default.createElement(CustomTooltip$3, {
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params41 = configDetails.paramsDetails) !== null && _configDetails$params41 !== void 0 && (_configDetails$params42 = _configDetails$params41.theme) !== null && _configDetails$params42 !== void 0 && _configDetails$params42.isDark ? 'dark' : 'light',
      title: "Send SMS of applicable content",
      size: "small",
      renderAnchorElement: renderSmsIcon,
      containerId: "ContentWrapper"
    }) : '', arrSendEmailUrl.length > 0 && arrSendEmailUrl[0].showSendMailIcon.toLowerCase() === 'yes' ? /*#__PURE__*/React__default.createElement(CustomTooltip$3, {
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params43 = configDetails.paramsDetails) !== null && _configDetails$params43 !== void 0 && (_configDetails$params44 = _configDetails$params43.theme) !== null && _configDetails$params44 !== void 0 && _configDetails$params44.isDark ? 'dark' : 'light',
      title: "Send email of applicable content",
      size: "small",
      renderAnchorElement: renderEmailIcon,
      containerId: "ContentWrapper"
    }) : '', !window.isMVODigital && resumeEmailSteps.length > 0 && resumeEmailSteps[0].showSendResumeMailIcon.toLowerCase() == 'yes' && !isEligibleForResumeEmail(resumeEmailSteps[0], navHist) && /*#__PURE__*/React__default.createElement(CustomTooltip$3, {
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params45 = configDetails.paramsDetails) !== null && _configDetails$params45 !== void 0 && (_configDetails$params46 = _configDetails$params45.theme) !== null && _configDetails$params46 !== void 0 && _configDetails$params46.isDark ? 'dark' : 'light',
      title: "Send Resume TS Email",
      size: "small",
      renderAnchorElement: renderResumeIcon,
      containerId: "ContentWrapper"
    })) : '', arrArticleId.length && (_arrArticleId$ = arrArticleId[0]) !== null && _arrArticleId$ !== void 0 && (_arrArticleId$$articl = _arrArticleId$.articleId) !== null && _arrArticleId$$articl !== void 0 && _arrArticleId$$articl.length && arrArticleId[0].articleId != undefined ? /*#__PURE__*/React__default.createElement("div", {
      className: "articalId"
    }, "ID: ", arrArticleId[0].articleId, " ") : '');
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ContentWrapper$9, {
    isNewDesign: isNewDesign,
    hideRightNav: rightMenuItems.length == 0 || hideRightNav
  }, /*#__PURE__*/React__default.createElement(ContentBody$3, {
    id: "contentBody",
    theme: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params47 = configDetails.paramsDetails) === null || _configDetails$params47 === void 0 ? void 0 : _configDetails$params47.theme,
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params48 = configDetails.paramsDetails) === null || _configDetails$params48 === void 0 ? void 0 : (_configDetails$params49 = _configDetails$params48.theme) === null || _configDetails$params49 === void 0 ? void 0 : _configDetails$params49.isDark,
    className: !((_window$config = window.config) !== null && _window$config !== void 0 && _window$config.retailIframe) ? 'popupContentBody' : ''
  }, /*#__PURE__*/React__default.createElement(HeadingSpan$3, {
    type: "hidden",
    tabIndex: window.isMVODigital ? "" : "-1",
    "aria-hidden": "true",
    ref: eleRef
  }), (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config5 = configDetails.config) === null || _configDetails$config5 === void 0 ? void 0 : _configDetails$config5.isBAUACSS) && !window.isMVODigital && renderTabs(), selectDeviceBannerEligibility(step) && /*#__PURE__*/React__default.createElement(SelectDeviceBannerDiv$1, null, /*#__PURE__*/React__default.createElement(SelectDeviceBanner, {
    type: "error"
  })), (analysis === null || analysis === void 0 ? void 0 : analysis.templateId) === 'VIRA_NRB_FORM' && showNotification && /*#__PURE__*/React__default.createElement(Notification, {
    type: "error",
    title: notificationMessage === null || notificationMessage === void 0 ? void 0 : notificationMessage.title,
    subtitle: convertStringToElements(notificationMessage === null || notificationMessage === void 0 ? void 0 : notificationMessage.description),
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params50 = configDetails.paramsDetails) !== null && _configDetails$params50 !== void 0 && (_configDetails$params51 = _configDetails$params50.theme) !== null && _configDetails$params51 !== void 0 && _configDetails$params51.isDark ? 'dark' : 'light'
  }), (analysis === null || analysis === void 0 ? void 0 : analysis.templateId) === 'VIRA_NRBFORM_FAIL' && /*#__PURE__*/React__default.createElement(Notification, {
    type: "error",
    title: nrbEOTErrorMessage === null || nrbEOTErrorMessage === void 0 ? void 0 : nrbEOTErrorMessage.title,
    subtitle: /*#__PURE__*/React__default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: nrbEOTErrorMessage === null || nrbEOTErrorMessage === void 0 ? void 0 : nrbEOTErrorMessage.description
      }
    }),
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params52 = configDetails.paramsDetails) !== null && _configDetails$params52 !== void 0 && (_configDetails$params53 = _configDetails$params52.theme) !== null && _configDetails$params53 !== void 0 && _configDetails$params53.isDark ? 'dark' : 'light'
  }), bannerValues.bannerContainerDetails.show && /*#__PURE__*/React__default.createElement(IconBannerWrapper, {
    isRetail: isRetail
  }, /*#__PURE__*/React__default.createElement(BannerEmailDownload, {
    custEmailId: customerEmailId != null ? customerEmailId : '',
    closeBannerBar: closeBannerBar,
    templateId: bannerValues.bannerContainerDetails.templateId,
    bannerName: bannerNameUpdate,
    selectedMdn: selectedMdn
  })), ((_values$feedbackConta = values.feedbackContainerDetails) === null || _values$feedbackConta === void 0 ? void 0 : _values$feedbackConta.show) && !(mvoTroubleShootingJson !== null && mvoTroubleShootingJson !== void 0 && (_mvoTroubleShootingJs4 = mvoTroubleShootingJson.ddata) !== null && _mvoTroubleShootingJs4 !== void 0 && (_mvoTroubleShootingJs5 = _mvoTroubleShootingJs4.device) !== null && _mvoTroubleShootingJs5 !== void 0 && _mvoTroubleShootingJs5.is5GDevice) && (values.feedbackContainerDetails.success && values.feedbackContainerDetails.show ? /*#__PURE__*/React__default.createElement(FeedbackBannerWrapper, {
    isDigital: window.isMVODigital,
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params54 = configDetails.paramsDetails) === null || _configDetails$params54 === void 0 ? void 0 : (_configDetails$params55 = _configDetails$params54.theme) === null || _configDetails$params55 === void 0 ? void 0 : _configDetails$params55.isDark,
    isACSS: isACSS,
    isRetail: isRetail
  }, /*#__PURE__*/React__default.createElement(FeedbackMessage, {
    values: values,
    closeFeedbackBar: props.functions.closeFeedbackBar
  })) : /*#__PURE__*/React__default.createElement(Box, {
    marginBottom: window.isMVODigital ? ['24px', '32px'] : "0px",
    marginRight: isRetail ? "30px" : "0px"
  }, /*#__PURE__*/React__default.createElement(FeedbackBarError, {
    values: values,
    closeFeedbackBar: props.functions.closeFeedbackBar
  }))), /*#__PURE__*/React__default.createElement(Modal$1, {
    opened: showKBDocModal,
    ariaLabel: "instructional overlay",
    fullScreenDialog: false,
    disableOutsideClick: true,
    disableAnimation: true,
    width: "700",
    hideCloseButton: false,
    onOpenedChange: handleOpenedChange
  }, /*#__PURE__*/React__default.createElement(ModalBody$1, null, /*#__PURE__*/React__default.createElement(DescWrapperNew$3, {
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params56 = configDetails.paramsDetails) === null || _configDetails$params56 === void 0 ? void 0 : (_configDetails$params57 = _configDetails$params56.theme) === null || _configDetails$params57 === void 0 ? void 0 : _configDetails$params57.isDark
  }, /*#__PURE__*/React__default.createElement(Title, {
    size: "small",
    bold: true,
    color: "#000000"
  }, ctaResponse.title), /*#__PURE__*/React__default.createElement("div", {
    size: "large",
    id: "dynamic-cta-content"
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: ctaResponse.content || ''
    }
  }))))), /*#__PURE__*/React__default.createElement(TitleTextWrapper$3, {
    isACSS: isACSS,
    isPopOut: popOutFlow
  }, /*#__PURE__*/React__default.createElement(UserConsumer, null, function (value) {
    return /*#__PURE__*/React__default.createElement(ModalListing$1, {
      symptomId: props.values.symptom.symptomId,
      isOpen: value.isOpen,
      modalClose: value.modalClose,
      deviceResponse: value.deviceResponse,
      modalError: value.modalError,
      spinner: value.spinner,
      setSpinner: value.setSpinner
    });
  }), !isNewDesign && /*#__PURE__*/React__default.createElement(TroubleShootingTitle$3, {
    firstPage: currentPageId && currentPageId === '1'
  }, /*#__PURE__*/React__default.createElement(Title, {
    size: "2XLarge",
    primitive: "h1",
    bold: true
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, {
    style: {
      fontSize: '1.1rem',
      textAlign: 'left',
      lineHeight: '1.25rem'
    }
  }, getTitleOld()))), isNewDesign && /*#__PURE__*/React__default.createElement(Fragment, null, showTitle && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TroubleShootingTitleNew$4, null, /*#__PURE__*/React__default.createElement(Title, {
    id: "screenTitle",
    size: isACSS || popOutFlow ? 'large' : 'XLarge',
    primitive: "h1",
    color: configDetails !== null && configDetails !== void 0 && (_configDetails$params58 = configDetails.paramsDetails) !== null && _configDetails$params58 !== void 0 && (_configDetails$params59 = _configDetails$params58.theme) !== null && _configDetails$params59 !== void 0 && _configDetails$params59.isDark ? "#FFFFFF" : "#000000"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, {
    style: {
      textAlign: 'left',
      padding: !isMobile() && '0px'
    },
    ariaLabel: getTitle()
  }, getTitle()))), /*#__PURE__*/React__default.createElement(Stack, {
    marginRight: isACSS || isRetail ? '20px' : "0px",
    alignItems: "flex-end"
  }, /*#__PURE__*/React__default.createElement(RenderIconSection, null))), showResumeEmail && /*#__PURE__*/React__default.createElement(SendResumeEmail, {
    navHistory: navHist,
    custEmail: emailModal.emailId,
    onSend: handleResumeEmailSend,
    handleModalState: function handleModalState() {
      return setShowResumeEmail(false);
    }
  }), emailModal.show && /*#__PURE__*/React__default.createElement(Modal$1, {
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params60 = configDetails.paramsDetails) !== null && _configDetails$params60 !== void 0 && (_configDetails$params61 = _configDetails$params60.theme) !== null && _configDetails$params61 !== void 0 && _configDetails$params61.isDark ? 'dark' : 'light',
    opened: emailModal.show,
    ariaLabel: "email-modal",
    fullScreenDialog: false,
    expandModal: false,
    onOpenedChange: emailModalChange,
    closeButton: /*#__PURE__*/React__default.createElement(FeedbackCloseButton$6, {
      "data-analyticstrack": "overlay-generic-cta",
      onClick: handleCancelEmailButton
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params62 = configDetails.paramsDetails) !== null && _configDetails$params62 !== void 0 && (_configDetails$params63 = _configDetails$params62.theme) !== null && _configDetails$params63 !== void 0 && _configDetails$params63.isDark ? 'dark' : 'light',
      tabIndex: "-1",
      id: "closeModal",
      name: "close",
      size: "large",
      color: "#000000",
      backgroundColor: "transparent"
    }), ' ')
  }, /*#__PURE__*/React__default.createElement(ModalBody$1, null, /*#__PURE__*/React__default.createElement("div", {
    ref: sendEmailRef,
    style: {
      outline: 'none'
    },
    tabIndex: "0",
    dangerouslySetInnerHTML: {
      __html: "<h2 style='margin:0px'>Send Email</h2>Send this article to a customer<br/><br/>"
    }
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Input$1, {
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params64 = configDetails.paramsDetails) !== null && _configDetails$params64 !== void 0 && (_configDetails$params65 = _configDetails$params64.theme) !== null && _configDetails$params65 !== void 0 && _configDetails$params65.isDark ? 'dark' : 'light',
    type: "text",
    label: "First name",
    readOnly: false,
    required: true,
    disabled: false,
    error: errFNameFlag,
    errorText: emailModal !== null && emailModal !== void 0 && (_emailModal$FName = emailModal.FName) !== null && _emailModal$FName !== void 0 && _emailModal$FName.length ? emailModal === null || emailModal === void 0 ? void 0 : emailModal.errFNameTxt : 'Please enter name',
    name: "FName",
    value: emailModal === null || emailModal === void 0 ? void 0 : emailModal.FName,
    onChange: function onChange(event) {
      return handleInputChange(event);
    },
    "data-track": '{"type": "link", "name": "First name"}'
  })), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Input$1, {
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params66 = configDetails.paramsDetails) !== null && _configDetails$params66 !== void 0 && (_configDetails$params67 = _configDetails$params66.theme) !== null && _configDetails$params67 !== void 0 && _configDetails$params67.isDark ? 'dark' : 'light',
    type: "text",
    label: "Email address",
    readOnly: false,
    required: true,
    disabled: false,
    error: errEmailIdFlag,
    errorText: emailModal !== null && emailModal !== void 0 && (_emailModal$emailId = emailModal.emailId) !== null && _emailModal$emailId !== void 0 && _emailModal$emailId.length ? emailModal === null || emailModal === void 0 ? void 0 : emailModal.errEmailIdTxt : 'Please enter email',
    name: "emailId",
    value: emailModal === null || emailModal === void 0 ? void 0 : emailModal.emailId,
    defaultValue: emailModal === null || emailModal === void 0 ? void 0 : emailModal.emailId,
    onChange: function onChange(event) {
      return handleInputChange(event);
    },
    "data-track": '{"type": "link", "name": "Email address"}'
  }))), /*#__PURE__*/React__default.createElement(ModalFooter$1, null, /*#__PURE__*/React__default.createElement(ButtonGroup$1, {
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params68 = configDetails.paramsDetails) !== null && _configDetails$params68 !== void 0 && (_configDetails$params69 = _configDetails$params68.theme) !== null && _configDetails$params69 !== void 0 && _configDetails$params69.isDark ? 'dark' : 'light',
    childWidth: "100%",
    viewport: "desktop",
    rowQuantity: {
      desktop: 2
    },
    data: [{
      children: 'Cancel',
      size: 'large',
      use: 'secondary',
      'data-clickstream': 'cancel - send email',
      'data-track': 'cancel - send email',
      onClick: function onClick() {
        handleCancelEmailButton();
      }
    }, {
      children: 'Send',
      size: 'large',
      use: 'primary',
      'data-clickstream': 'send email',
      'data-track': 'send email',
      disabled: ((_emailModal$FName2 = emailModal.FName) === null || _emailModal$FName2 === void 0 ? void 0 : _emailModal$FName2.length) == 0 || ((_emailModal$emailId2 = emailModal.emailId) === null || _emailModal$emailId2 === void 0 ? void 0 : _emailModal$emailId2.length) == 0 || errFNameFlag || errEmailIdFlag,
      onClick: function onClick() {
        handleSendEmailButton();
      }
    }]
  }))))), /*#__PURE__*/React__default.createElement(Stack, {
    flexDirection: ['column', 'row'],
    gap: isACSS || popOutFlow ? '25px' : '32px',
    marginLeft: ['0', isACSS || isRetail ? (symptomList === null || symptomList === void 0 ? void 0 : symptomList.length) === 0 ? '0px' : '20px' : '0'],
    marginRight: isACSS || isRetail ? '20px' : "0px"
  }, /*#__PURE__*/React__default.createElement(LeftNav, {
    symptomList: symptomList,
    isDark: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params70 = configDetails.paramsDetails) === null || _configDetails$params70 === void 0 ? void 0 : (_configDetails$params71 = _configDetails$params70.theme) === null || _configDetails$params71 === void 0 ? void 0 : _configDetails$params71.isDark) == true
  }), template === 'waitscreen' && /*#__PURE__*/React__default.createElement(StepContainer$4, null, /*#__PURE__*/React__default.createElement(StepInfoContainer$5, {
    id: "wait-step-info-container",
    isNewDesign: isNewDesign,
    hideRightNav: true,
    isWaitScreen: true
  }, isACSS || isRetail ? step !== null && step !== void 0 && step.waitStepDetails && (step === null || step === void 0 ? void 0 : (_step$waitStepDetails = step.waitStepDetails) === null || _step$waitStepDetails === void 0 ? void 0 : _step$waitStepDetails.length) !== 0 ? /*#__PURE__*/React__default.createElement(Stepper, {
    steps: step.waitStepDetails,
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params72 = configDetails.paramsDetails) === null || _configDetails$params72 === void 0 ? void 0 : (_configDetails$params73 = _configDetails$params72.theme) === null || _configDetails$params73 === void 0 ? void 0 : _configDetails$params73.isDark
  }) : /*#__PURE__*/React__default.createElement(WaitScreen, {
    loadingMsg: step.description
  }) : window.isMVODigital && /*#__PURE__*/React__default.createElement(WaitScreen, {
    loadingMsg: step.description
  }))), template !== 'waitscreen' && /*#__PURE__*/React__default.createElement(StepContainer$4, {
    isNewDesign: isNewDesign,
    hideRightNav: rightMenuItems.length == 0 || hideRightNav,
    isPopOutFlow: popOutFlow
  }, /*#__PURE__*/React__default.createElement(StepInfoContainer$5, {
    id: "step-info-container",
    isNewDesign: isNewDesign,
    hideRightNav: rightMenuItems.length == 0 || hideRightNav,
    hideRightPadding: analysis.templateId === 'SELECT_DEVICE' || resolution.templateId === 'SELECT_DEVICE',
    isDark: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params74 = configDetails.paramsDetails) === null || _configDetails$params74 === void 0 ? void 0 : (_configDetails$params75 = _configDetails$params74.theme) === null || _configDetails$params75 === void 0 ? void 0 : _configDetails$params75.isDark) === true
  }, !isNewDesign && /*#__PURE__*/React__default.createElement(HeadingWrapper$3, null, /*#__PURE__*/React__default.createElement("div", {
    className: "checklist-wrapper"
  }, /*#__PURE__*/React__default.createElement(CheckList, {
    steps: navHist,
    onChange: function onChange(value) {
      return handleChecklistChange(value);
    },
    size: "100%",
    value: currentPageId,
    caretSize: "small",
    is5GDevice: is5GDevice,
    eotFlag: eotFlag,
    marginBottom: "20px",
    "data-track": "{\"type\": \"link\", \"name\": \"" + currentPageId + "\"}"
  })), /*#__PURE__*/React__default.createElement(PageTitle$4, null, /*#__PURE__*/React__default.createElement(Title, {
    size: "medium"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, {
    style: {
      fontSize: !isMobile() ? '1rem' : ''
    }
  }, analysis.title || resolution.title)))), /*#__PURE__*/React__default.createElement(InStepBanner, {
    isLeftNav: symptomList,
    isACSS: true,
    steps: steps,
    isDark: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params76 = configDetails.paramsDetails) === null || _configDetails$params76 === void 0 ? void 0 : (_configDetails$params77 = _configDetails$params76.theme) === null || _configDetails$params77 === void 0 ? void 0 : _configDetails$params77.isDark) == true
  }), /*#__PURE__*/React__default.createElement(DelphiBanner, {
    steps: steps,
    isDark: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params78 = configDetails.paramsDetails) === null || _configDetails$params78 === void 0 ? void 0 : (_configDetails$params79 = _configDetails$params78.theme) === null || _configDetails$params79 === void 0 ? void 0 : _configDetails$params79.isDark) == true
  }), isNewDesign && !isHowToContent && /*#__PURE__*/React__default.createElement(NavStepsContainer$5, {
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params80 = configDetails.paramsDetails) === null || _configDetails$params80 === void 0 ? void 0 : (_configDetails$params81 = _configDetails$params80.theme) === null || _configDetails$params81 === void 0 ? void 0 : _configDetails$params81.isDark
  }, window.isMVODigital ? /*#__PURE__*/React__default.createElement(StepsAndTitleSection$1, null, /*#__PURE__*/React__default.createElement(NavStepsContainer$5, null, /*#__PURE__*/React__default.createElement(NavSteps, {
    steps: navHist,
    value: currentPageId,
    eotFlag: eotFlag,
    onChange: function onChange(value, step) {
      return handleChecklistChange(value, step);
    },
    "data-track": "{\"type\": \"link\", \"name\": \"" + currentPageId + "\"}",
    stepInputRef: stepInputRef
  })), /*#__PURE__*/React__default.createElement(NewPageTitleDigital$1, null, /*#__PURE__*/React__default.createElement(Title, {
    size: isMobile() ? "large" : "medium",
    primitive: "h2",
    color: "#000000",
    bold: true
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, analysis.title || resolution.title)))) : /*#__PURE__*/React__default.createElement(NavStepsWrapper$3, {
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params82 = configDetails.paramsDetails) === null || _configDetails$params82 === void 0 ? void 0 : (_configDetails$params83 = _configDetails$params82.theme) === null || _configDetails$params83 === void 0 ? void 0 : _configDetails$params83.isDark
  }, /*#__PURE__*/React__default.createElement(NavSteps, {
    steps: navHist,
    value: currentPageId,
    eotFlag: eotFlag,
    onChange: function onChange(value, step) {
      return handleChecklistChange(value, step);
    },
    "data-track": "{\"type\": \"link\", \"name\": \"" + currentPageId + "\"}",
    stepInputRef: stepInputRef
  }), /*#__PURE__*/React__default.createElement(NewPageTitle$4, null, /*#__PURE__*/React__default.createElement(Title, {
    size: isMobile() ? 'large' : 'medium',
    primitive: "h2",
    color: configDetails !== null && configDetails !== void 0 && (_configDetails$params84 = configDetails.paramsDetails) !== null && _configDetails$params84 !== void 0 && (_configDetails$params85 = _configDetails$params84.theme) !== null && _configDetails$params85 !== void 0 && _configDetails$params85.isDark ? "#ffffff" : "#000000",
    bold: true
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, {
    style: {
      marginLeft: isMobile() ? '' : '5px'
    }
  }, analysis.title || resolution.title)))), /*#__PURE__*/React__default.createElement(Stack, {
    alignItems: "flex-end"
  }, /*#__PURE__*/React__default.createElement(RenderIconSection, null))), isGenAIEnabed && /*#__PURE__*/React__default.createElement(AISummary, {
    intentId: intentId,
    description: step === null || step === void 0 ? void 0 : step.description,
    isACSS: isACSS,
    toggleContent: toggleContent,
    showContent: showContent,
    acssCallId: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params86 = configDetails.paramsDetails) === null || _configDetails$params86 === void 0 ? void 0 : _configDetails$params86.acssCallId,
    setAISummaryLoaded: setAISummaryLoaded,
    genAICompositeKey: genAICompositeKey,
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params87 = configDetails.paramsDetails) !== null && _configDetails$params87 !== void 0 && (_configDetails$params88 = _configDetails$params87.theme) !== null && _configDetails$params88 !== void 0 && _configDetails$params88.isDark ? 'dark' : 'light'
  }), /*#__PURE__*/React__default.createElement(AnimatePresence, {
    initial: false
  }, shouldShowContent && /*#__PURE__*/React__default.createElement(Stack, {
    as: motion.div,
    key: "content",
    initial: {
      height: 0,
      opacity: 0
    },
    animate: {
      height: 'auto',
      opacity: 1
    },
    exit: {
      height: 0,
      opacity: 0
    },
    transition: {
      duration: 0.3,
      ease: 'easeInOut'
    },
    style: {
      overflow: aiSummryEnabled ? 'hidden' : 'unset'
    }
  }, steps.map(function (tmpStep, index) {
    var _tmpStep$templateId, _actionButtons$, _configDetails$params89, _configDetails$params90, _configDetails$params91, _configDetails$params92, _actionButtons$2, _configDetails$params93, _configDetails$params94, _configDetails$params95, _configDetails$params96, _configDetails$params97, _configDetails$params98, _configDetails$params99, _configDetails$params100, _tmpStep$contentUrl, _configDetails$params101, _configDetails$params102, _configDetails$params103, _configDetails$params104, _configDetails$params105, _configDetails$params106;
    var templateId = (_tmpStep$templateId = tmpStep === null || tmpStep === void 0 ? void 0 : tmpStep.templateId) != null ? _tmpStep$templateId : '';
    console.log('templateId---------', templateId);
    var _tmpStep$sections2 = tmpStep.sections,
      sections = _tmpStep$sections2 === void 0 ? [] : _tmpStep$sections2,
      _tmpStep$actionButton = tmpStep.actionButtons,
      actionButtons = _tmpStep$actionButton === void 0 ? [] : _tmpStep$actionButton;
    return /*#__PURE__*/React__default.createElement(Fragment, {
      key: "tsr-step-" + index
    }, /*#__PURE__*/React__default.createElement("input", {
      type: "hidden",
      value: templateId,
      id: "templateId",
      "data-track": "{\"type\": \"link\", \"name\": \"" + templateId + "\"}"
    }), deepLinkButtonsFFlag && (actionButtons === null || actionButtons === void 0 ? void 0 : (_actionButtons$ = actionButtons[0]) === null || _actionButtons$ === void 0 ? void 0 : _actionButtons$.showNewMidFlowCTA) && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(DeepLinkButton, {
      uniquekey: "tsr-step-" + index,
      actionButton: actionButtons[0],
      isDark: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params89 = configDetails.paramsDetails) === null || _configDetails$params89 === void 0 ? void 0 : (_configDetails$params90 = _configDetails$params89.theme) === null || _configDetails$params90 === void 0 ? void 0 : _configDetails$params90.isDark) === true
    }), /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "20px"
    })), tmpStep.heading && tmpStep.heading !== '' && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Title, {
      size: "small"
    }, /*#__PURE__*/React__default.createElement(TextWithHtml, {
      style: {
        fontSize: !isMobile() ? '1rem' : ''
      }
    }, tmpStep.heading)), !choices && /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "10px"
    })), templateId.includes('SYSTEM_CHECKS_') && sections.length > 0 && renderChecks(tmpStep), tmpStep.delphiMsg && renderDelphiBanner(enableDelphiBannerIds, tmpStep === null || tmpStep === void 0 ? void 0 : tmpStep.templateId, steps) && /*#__PURE__*/React__default.createElement(notification, {
      messaage: /*#__PURE__*/React__default.createElement(TextWithHtml, null, tmpStep.delphiMsg),
      dynamicTemplates: delphiSiteSurveySummaryIds,
      step: tmpStep,
      isDark: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params91 = configDetails.paramsDetails) === null || _configDetails$params91 === void 0 ? void 0 : (_configDetails$params92 = _configDetails$params91.theme) === null || _configDetails$params92 === void 0 ? void 0 : _configDetails$params92.isDark) == true
    }), tmpStep.templateId !== 'searchsupportcontent' && tmpStep.templateType !== 'searchsupportcontent' && tmpStep.templateId !== 'BATTERYCHARGINGISSUES' && tmpStep.templateType !== 'reviewtechbulletin' && tmpStep.templateType !== 'reviewopenalerts' && tmpStep.templateType !== 'deviceforums' && tmpStep.templateId !== 'DEVICE_FORUMS' && tmpStep.description && tmpStep.description.trim() !== '' && /*#__PURE__*/React__default.createElement(Fragment, null, renderDescription(tmpStep, index), !choices && /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "10px"
    })), tmpStep.templateId === 'SELECT_DEVICE' && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(MultiDevices, {
      functions: functions,
      values: values,
      handleMulSelDeviceOptionsChange: handleMulSelDeviceOptionsChange,
      selectedOption: selectedOption,
      handleModalState: handleModalState,
      flags: flags
    })), deepLinkButtonsFFlag && (actionButtons === null || actionButtons === void 0 ? void 0 : (_actionButtons$2 = actionButtons[0]) === null || _actionButtons$2 === void 0 ? void 0 : _actionButtons$2.showNewMidFlowCTA) == false && /*#__PURE__*/React__default.createElement(MidFlowButton, {
      uniquekey: "tsr-step-" + index,
      actionButton: actionButtons[0],
      handleOkClick: handleOkClick,
      isDark: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params93 = configDetails.paramsDetails) === null || _configDetails$params93 === void 0 ? void 0 : (_configDetails$params94 = _configDetails$params93.theme) === null || _configDetails$params94 === void 0 ? void 0 : _configDetails$params94.isDark) === true,
      handleNrbChkEligibilityLoader: handleNrbChkEligibilityLoader
    }), !deepLinkButtonsFFlag && (actionButtons === null || actionButtons === void 0 ? void 0 : actionButtons[0]) && /*#__PURE__*/React__default.createElement(MidFlowButton, {
      uniquekey: "tsr-step-" + index,
      actionButton: actionButtons[0],
      handleOkClick: handleOkClick,
      isDark: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params95 = configDetails.paramsDetails) === null || _configDetails$params95 === void 0 ? void 0 : (_configDetails$params96 = _configDetails$params95.theme) === null || _configDetails$params96 === void 0 ? void 0 : _configDetails$params96.isDark) === true,
      handleNrbChkEligibilityLoader: handleNrbChkEligibilityLoader
    }), tmpStep.templateType == 'kbcontent' && tmpStep.description.trim() == '' && /*#__PURE__*/React__default.createElement(Fragment, null, " ", window.isMVODigital ? /*#__PURE__*/React__default.createElement(Body, {
      size: "large"
    }, "No results found for: ", /*#__PURE__*/React__default.createElement("br", null), "Device: ", (_configDetails$params97 = configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params98 = configDetails.paramsDetails) === null || _configDetails$params98 === void 0 ? void 0 : _configDetails$params98.deviceName) != null ? _configDetails$params97 : '', ", ", CJCMSku != null ? CJCMSku : '', /*#__PURE__*/React__default.createElement("br", null), "Keyword / DOC ID: ", tmpStep === null || tmpStep === void 0 ? void 0 : tmpStep.templateId, /*#__PURE__*/React__default.createElement("br", null), "Content not Found") : /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", null, "No results found for: "), /*#__PURE__*/React__default.createElement("div", null, "Device: ", (_configDetails$params99 = configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params100 = configDetails.paramsDetails) === null || _configDetails$params100 === void 0 ? void 0 : _configDetails$params100.deviceName) != null ? _configDetails$params99 : '', ", ", CJCMSku != null ? CJCMSku : ''), /*#__PURE__*/React__default.createElement("div", null, "Keyword / DOC ID: ", tmpStep === null || tmpStep === void 0 ? void 0 : tmpStep.templateId), /*#__PURE__*/React__default.createElement("div", null, "Content not Found"))), tmpStep.templateType == 'networkcongestion' && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(NetworkCongestion$3, null, (networkCongestionDataOriginal === null || networkCongestionDataOriginal === void 0 ? void 0 : networkCongestionDataOriginal.length) && renderNetworkCongestion(networkCongestionDataOriginal || []))), tmpStep.templateId === 'searchsupportcontent' || tmpStep.templateType === 'searchsupportcontent' ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(SearchBarComponent, {
      step: tmpStep
    })) : /*#__PURE__*/React__default.createElement(Fragment, null), tmpStep.templateId === 'BATTERYCHARGINGISSUES' || tmpStep.templateType === 'reviewopenalerts' || tmpStep.templateType === 'reviewtechbulletin' || tmpStep.templateType === 'deviceforums' || tmpStep.templateId === 'DEVICE_FORUMS' || tmpStep.templateType === 'ost' || tmpStep.templateId === 'OST' ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(IframePage, {
      url: (_tmpStep$contentUrl = tmpStep === null || tmpStep === void 0 ? void 0 : tmpStep.contentUrl) != null ? _tmpStep$contentUrl : '',
      styles: tmpStep.templateType === 'deviceforums' || tmpStep.templateId === 'DEVICE_FORUMS' ? {
        height: '400px',
        width: '100%',
        backgroundColor: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params101 = configDetails.paramsDetails) === null || _configDetails$params101 === void 0 ? void 0 : (_configDetails$params102 = _configDetails$params101.theme) === null || _configDetails$params102 === void 0 ? void 0 : _configDetails$params102.isDark) === true && '#fff'
      } : tmpStep.templateType === 'reviewopenalerts' || tmpStep.templateId === 'REVIEWOPENALERTS' || tmpStep.templateType === 'ost' || tmpStep.templateId === 'OST' ? {
        height: '500px',
        width: '100%',
        backgroundColor: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params103 = configDetails.paramsDetails) === null || _configDetails$params103 === void 0 ? void 0 : (_configDetails$params104 = _configDetails$params103.theme) === null || _configDetails$params104 === void 0 ? void 0 : _configDetails$params104.isDark) === true && '#fff'
      } : {
        height: '300px',
        width: '100%',
        backgroundColor: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params105 = configDetails.paramsDetails) === null || _configDetails$params105 === void 0 ? void 0 : (_configDetails$params106 = _configDetails$params105.theme) === null || _configDetails$params106 === void 0 ? void 0 : _configDetails$params106.isDark) === true && '#fff'
      }
    })) : /*#__PURE__*/React__default.createElement(Fragment, null), tmpStep.mvd && tmpStep.mvd.length > 0 && /*#__PURE__*/React__default.createElement(Fragment, null, renderSettingsTableStatic(tmpStep.mvd)), analysis && analysis.iframe && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(IframePage, {
      url: analysis.iframe,
      styles: {
        overflow: 'hidden',
        height: '100%',
        width: '100%'
      }
    }), /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "10px"
    })), COVERAGE_INTERACTIVE_MAP_ARR.includes(tmpStep.templateType) && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(SpacerDiv, {
      height: "10px"
    }), /*#__PURE__*/React__default.createElement(MapWrapper$3, null, /*#__PURE__*/React__default.createElement(IframePage, {
      url: tmpStep.contentUrl ? tmpStep.contentUrl : 'https://vzwmaptest-aws.ebiz.verizon.com/map4/?token=A2fSGrShtSEyjbe433asdgsve4aygh87aNyBeZw4b4yaHrgs46',
      allow: "geolocation " + (tmpStep.geoLocation ? tmpStep.geoLocation : 'https://vzwmaptest-aws.ebiz.verizon.com;'),
      frameBorder: "1",
      height: "600"
    }))));
  }), !window.isMVODigital && choices && choices.length <= 3 && analysis.templateId != 'SELECT_DEVICE' && resolution.templateId != 'SELECT_DEVICE' && (analysis === null || analysis === void 0 ? void 0 : analysis.templateId) !== 'NE_FWA_MACID' && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(CustomContentDiv$3, {
    isSetFlexColumn: typeof analysis.devices === 'undefined' && resolution.templateId === 'CONFIRM_DEVICE_SHOW_ACTIVE' && typeof resolution.devices !== 'undefined'
  }, /*#__PURE__*/React__default.createElement(IssuesContainer$3, {
    isSetFlexColumn: typeof analysis.devices === 'undefined' && resolution.templateId === 'CONFIRM_DEVICE_SHOW_ACTIVE' && typeof resolution.devices !== 'undefined',
    isMvoDigi: window.isMVODigital
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "question"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, question)), typeof analysis.devices === 'undefined' && resolution.templateId === 'CONFIRM_DEVICE_SHOW_ACTIVE' && typeof resolution.devices !== 'undefined' && /*#__PURE__*/React__default.createElement(DeviceConnected, {
    values: values
  }), analysis.templateId !== 'CALL_SPECIFIC_NUMBER_ENTRY' && analysis.templateId !== 'DEVICE_REPLACEMENT_OPTIONS' && renderRadioButtons(), analysis.templateId === 'DEVICE_REPLACEMENT_OPTIONS' && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TilesContainer$3, {
    className: "autoHeight"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "question"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, question)), /*#__PURE__*/React__default.createElement(TiletContainer$3, null, linksArray.map(function (issue) {
    var _configDetails$params107, _configDetails$params108, _configDetails$params109, _configDetails$params110, _configDetails$params111, _configDetails$params112, _configDetails$params113, _configDetails$params114, _configDetails$params115, _configDetails$params116;
    return /*#__PURE__*/React__default.createElement(TileContainerWrapper, {
      isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params107 = configDetails.paramsDetails) === null || _configDetails$params107 === void 0 ? void 0 : (_configDetails$params108 = _configDetails$params107.theme) === null || _configDetails$params108 === void 0 ? void 0 : _configDetails$params108.isDark,
      key: issue === null || issue === void 0 ? void 0 : issue.text,
      onClick: function onClick(e) {
        return handleResolutionOptionClick(e, issue);
      },
      onKeyPress: function onKeyPress(e) {
        return handleResolutionOptionClick(e, issue);
      },
      "data-analyticstrack": issue === null || issue === void 0 ? void 0 : issue.text,
      "data-track": "{\"type\": \"link\", \"name\": " + (issue === null || issue === void 0 ? void 0 : issue.text) + "}",
      "data-clickstream": (issue === null || issue === void 0 ? void 0 : issue.text) + "-link",
      "data-url": issue === null || issue === void 0 ? void 0 : issue.url,
      role: "link",
      tabIndex: "0",
      "aria-label": (issue !== null && issue !== void 0 && issue.recommended ? 'Recommended' : '') + " " + (issue === null || issue === void 0 ? void 0 : issue.text) + " " + (issue === null || issue === void 0 ? void 0 : issue.description)
    }, /*#__PURE__*/React__default.createElement(TileContainer$1, {
      padding: "16px",
      aspectRatio: "none",
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params109 = configDetails.paramsDetails) !== null && _configDetails$params109 !== void 0 && (_configDetails$params110 = _configDetails$params109.theme) !== null && _configDetails$params110 !== void 0 && _configDetails$params110.isDark ? 'dark' : 'light'
    }, /*#__PURE__*/React__default.createElement(FlexContainer$1, null, (issue === null || issue === void 0 ? void 0 : issue.recommended) && /*#__PURE__*/React__default.createElement(TopPadder$1, null, /*#__PURE__*/React__default.createElement(Badge, {
      maxWidth: "120px"
    }, "Recommended")), /*#__PURE__*/React__default.createElement(TopPadder$1, null, /*#__PURE__*/React__default.createElement(Title, {
      size: "small",
      bold: true,
      primitive: "h3",
      color: configDetails !== null && configDetails !== void 0 && (_configDetails$params111 = configDetails.paramsDetails) !== null && _configDetails$params111 !== void 0 && (_configDetails$params112 = _configDetails$params111.theme) !== null && _configDetails$params112 !== void 0 && _configDetails$params112.isDark ? "#FFFFFF" : "#000000"
    }, issue === null || issue === void 0 ? void 0 : issue.text)), /*#__PURE__*/React__default.createElement(TopPadder$1, null, /*#__PURE__*/React__default.createElement(Body, {
      color: configDetails !== null && configDetails !== void 0 && (_configDetails$params113 = configDetails.paramsDetails) !== null && _configDetails$params113 !== void 0 && (_configDetails$params114 = _configDetails$params113.theme) !== null && _configDetails$params114 !== void 0 && _configDetails$params114.isDark ? "#FFFFFF" : "#000000"
    }, /*#__PURE__*/React__default.createElement(ShopChargerIssueDescription, null, issue === null || issue === void 0 ? void 0 : issue.description))))), /*#__PURE__*/React__default.createElement(RightArrowDiv$3, null, /*#__PURE__*/React__default.createElement(Icon$1, {
      name: "right-arrow",
      size: "medium",
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params115 = configDetails.paramsDetails) !== null && _configDetails$params115 !== void 0 && (_configDetails$params116 = _configDetails$params115.theme) !== null && _configDetails$params116 !== void 0 && _configDetails$params116.isDark ? 'dark' : 'light'
    })));
  }))), deviceReplacementMidFlowTileIndex !== -1 && isMvaFlow && /*#__PURE__*/React__default.createElement(SpanTag$1, null, /*#__PURE__*/React__default.createElement(TextLink, {
    type: "inline",
    size: "small",
    href: linksArray[deviceReplacementMidFlowTileIndex].url
  }, linksArray[deviceReplacementMidFlowTileIndex].text)), deviceReplacementMidFlowTileIndex !== -1 && !isMvaFlow && /*#__PURE__*/React__default.createElement(SpanTag$1, null, /*#__PURE__*/React__default.createElement(TextLink, {
    type: "inline",
    size: "small",
    onClick: function onClick(e) {
      return window.open(linksArray[deviceReplacementMidFlowTileIndex].url, '_blank');
    }
  }, linksArray[deviceReplacementMidFlowTileIndex].text)), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "25px"
  })), analysis.templateId === 'CALL_SPECIFIC_NUMBER_ENTRY' && /*#__PURE__*/React__default.createElement(CapturePhoneNo, {
    forwardValue: handleSiteSurveyChange,
    selectedMdn: selectedMdn,
    step: analysis,
    validate: validationFlag
  })), imageDetails.length > 0 && /*#__PURE__*/React__default.createElement(ImageCarousel, {
    imageDetails: imageDetails
  })), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "25px"
  })), (analysis === null || analysis === void 0 ? void 0 : analysis.templateId) === "ACSS_REMEDY_COMPONENT" && /*#__PURE__*/React__default.createElement(UTPList, {
    customerProfile: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.customerInfo,
    env: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.mvoenv,
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params117 = configDetails.paramsDetails) === null || _configDetails$params117 === void 0 ? void 0 : (_configDetails$params118 = _configDetails$params117.theme) === null || _configDetails$params118 === void 0 ? void 0 : _configDetails$params118.isDark,
    logUsageMetrics: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.logUsageMetrics,
    UserProfile: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.UserProfile,
    openLaunchoutDialog: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.openLaunchoutDialog
  }), enableMacIDPQFFlag && isACSS && (analysis === null || analysis === void 0 ? void 0 : analysis.templateId) === 'NE_FWA_MACID' && /*#__PURE__*/React__default.createElement(MacIDProbingQuestion, {
    steps: steps,
    question: question,
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params119 = configDetails.paramsDetails) === null || _configDetails$params119 === void 0 ? void 0 : (_configDetails$params120 = _configDetails$params119.theme) === null || _configDetails$params120 === void 0 ? void 0 : _configDetails$params120.isDark,
    handleOptionsChange: handleOptionsChange
  }), (analysis === null || analysis === void 0 ? void 0 : analysis.templateId) === 'VIRA_NRB_FORM' && /*#__PURE__*/React__default.createElement(NrbProvider, null, /*#__PURE__*/React__default.createElement(NRBForm, {
    showNRBNotification: showNRBNotification,
    handleTroubleShootingAction: functions.handleTroubleShootingAction,
    launchAutoCreateFollowUp: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.launchAutoCreateFollowUp,
    interactionCaseId: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.interactionCaseId,
    steps: steps,
    configDetails: configDetails,
    setIsNextBtnEnableNRB: setIsNextBtnEnableNRB,
    isACSS: isACSS,
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params121 = configDetails.paramsDetails) === null || _configDetails$params121 === void 0 ? void 0 : (_configDetails$params122 = _configDetails$params121.theme) === null || _configDetails$params122 === void 0 ? void 0 : _configDetails$params122.isDark,
    isTrainingMode: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.isTrainingMode
  })), !((_window28 = window) !== null && _window28 !== void 0 && _window28.isMVODigital) && analysis && analysis.templateId == 'RESOLUTION_OPTIONS_ALL' && choices && choices.length > 3 && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ButtonContainer$3, {
    isDark: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params123 = configDetails.paramsDetails) === null || _configDetails$params123 === void 0 ? void 0 : (_configDetails$params124 = _configDetails$params123.theme) === null || _configDetails$params124 === void 0 ? void 0 : _configDetails$params124.isDark) === true
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "question"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, question)), /*#__PURE__*/React__default.createElement(TiletContainer$3, {
    id: 'wrapperTitleContainer'
  }, (_linksArray = linksArray) === null || _linksArray === void 0 ? void 0 : _linksArray.map(function (issue, index) {
    var _configDetails$params125, _configDetails$params126, _configDetails$params127, _configDetails$params128, _configDetails$params129, _configDetails$params130, _configDetails$params131, _configDetails$params132, _configDetails$params133, _configDetails$params134, _configDetails$params135, _configDetails$params136, _configDetails$params137, _configDetails$params138;
    return /*#__PURE__*/React__default.createElement(TileContainerWrapper, {
      isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params125 = configDetails.paramsDetails) === null || _configDetails$params125 === void 0 ? void 0 : (_configDetails$params126 = _configDetails$params125.theme) === null || _configDetails$params126 === void 0 ? void 0 : _configDetails$params126.isDark,
      key: "tile-" + (issue === null || issue === void 0 ? void 0 : issue.text),
      id: "parent-" + index,
      style: {
        cursor: 'pointer'
      },
      onClick: function onClick(e) {
        return handleButtonClick(e, issue);
      },
      "data-analyticstrack": issue === null || issue === void 0 ? void 0 : issue.text,
      "data-track": "{\"type\": \"link\", \"name\": " + (issue === null || issue === void 0 ? void 0 : issue.text) + "}",
      "data-clickstream": (issue === null || issue === void 0 ? void 0 : issue.text) + "-link",
      "data-url": issue === null || issue === void 0 ? void 0 : issue.url,
      "data-content": issue === null || issue === void 0 ? void 0 : issue.popUpHtmlContent
    }, /*#__PURE__*/React__default.createElement(TileContainer$1, {
      padding: "16px",
      aspectRatio: "none",
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params127 = configDetails.paramsDetails) !== null && _configDetails$params127 !== void 0 && (_configDetails$params128 = _configDetails$params127.theme) !== null && _configDetails$params128 !== void 0 && _configDetails$params128.isDark ? 'dark' : 'light'
    }, /*#__PURE__*/React__default.createElement(FlexContainer$1, {
      key: "flexcontainer-" + (issue === null || issue === void 0 ? void 0 : issue.text)
    }, /*#__PURE__*/React__default.createElement("div", null, (issue === null || issue === void 0 ? void 0 : issue.recommended) && /*#__PURE__*/React__default.createElement(TopPadder$1, null, /*#__PURE__*/React__default.createElement(Badge, {
      maxWidth: "120px",
      key: "Badge-" + (issue === null || issue === void 0 ? void 0 : issue.text)
    }, "Recommended")), /*#__PURE__*/React__default.createElement(TopPadder$1, null, /*#__PURE__*/React__default.createElement(Title, {
      size: "small",
      bold: true,
      primitive: "h3",
      key: "title-" + (issue === null || issue === void 0 ? void 0 : issue.text),
      color: configDetails !== null && configDetails !== void 0 && (_configDetails$params129 = configDetails.paramsDetails) !== null && _configDetails$params129 !== void 0 && (_configDetails$params130 = _configDetails$params129.theme) !== null && _configDetails$params130 !== void 0 && _configDetails$params130.isDark ? "#FFFFFF" : "#000000"
    }, issue === null || issue === void 0 ? void 0 : issue.text)), /*#__PURE__*/React__default.createElement(TopPadder$1, null, /*#__PURE__*/React__default.createElement(Body, {
      key: "Body-" + (issue === null || issue === void 0 ? void 0 : issue.text),
      color: configDetails !== null && configDetails !== void 0 && (_configDetails$params131 = configDetails.paramsDetails) !== null && _configDetails$params131 !== void 0 && (_configDetails$params132 = _configDetails$params131.theme) !== null && _configDetails$params132 !== void 0 && _configDetails$params132.isDark ? "#FFFFFF" : "#000000"
    }, issue === null || issue === void 0 ? void 0 : issue.description))))), !window.isMVODigital && (issue === null || issue === void 0 ? void 0 : issue.value) === 'custEd' ? /*#__PURE__*/React__default.createElement(RowFlex, null, /*#__PURE__*/React__default.createElement(ButtonDiv$2, null, /*#__PURE__*/React__default.createElement(Button$1, {
      id: "button-" + index,
      key: "button-" + (issue === null || issue === void 0 ? void 0 : issue.text),
      className: "sendEmailBtnDesc",
      size: "small",
      onClick: function onClick(e) {
        handleSendEmail(e, 'Article');
      },
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params133 = configDetails.paramsDetails) !== null && _configDetails$params133 !== void 0 && (_configDetails$params134 = _configDetails$params133.theme) !== null && _configDetails$params134 !== void 0 && _configDetails$params134.isDark ? 'dark' : 'light'
    }, "Send Email Summary")), /*#__PURE__*/React__default.createElement(ArrowDiv, null, /*#__PURE__*/React__default.createElement(Icon$1, {
      key: "icon-" + (issue === null || issue === void 0 ? void 0 : issue.text),
      name: "right-arrow",
      size: "medium",
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params135 = configDetails.paramsDetails) !== null && _configDetails$params135 !== void 0 && (_configDetails$params136 = _configDetails$params135.theme) !== null && _configDetails$params136 !== void 0 && _configDetails$params136.isDark ? 'dark' : 'light'
    }))) : /*#__PURE__*/React__default.createElement(RightArrowDiv$3, null, /*#__PURE__*/React__default.createElement(Icon$1, {
      key: "icon-" + (issue === null || issue === void 0 ? void 0 : issue.text),
      name: "right-arrow",
      size: "medium",
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params137 = configDetails.paramsDetails) !== null && _configDetails$params137 !== void 0 && (_configDetails$params138 = _configDetails$params137.theme) !== null && _configDetails$params138 !== void 0 && _configDetails$params138.isDark ? 'dark' : 'light'
    })));
  })), dropdownArray.length > 1 ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '350px',
      paddingTop: '20px',
      clear: 'both'
    }
  }, /*#__PURE__*/React__default.createElement(DropdownSelect, {
    className: "dropdownSelectEot",
    selectId: "activationDropdown",
    onChange: function onChange(e) {
      return handleOptionsChange(e);
    },
    value: selectedOption,
    "data-track": "{\"type\": \"link\", \"name\": \"" + selectedOption + "\"}",
    color: configDetails !== null && configDetails !== void 0 && (_configDetails$params139 = configDetails.paramsDetails) !== null && _configDetails$params139 !== void 0 && (_configDetails$params140 = _configDetails$params139.theme) !== null && _configDetails$params140 !== void 0 && _configDetails$params140.isDark ? '#ffffff' : '#000000',
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params141 = configDetails.paramsDetails) !== null && _configDetails$params141 !== void 0 && (_configDetails$params142 = _configDetails$params141.theme) !== null && _configDetails$params142 !== void 0 && _configDetails$params142.isDark ? 'dark' : 'light'
  }, dropdownArray.map(function (issue) {
    return /*#__PURE__*/React__default.createElement("option", {
      "data-url": issue.url,
      "data-content": issue.popUpHtmlContent,
      value: issue.value
    }, issue.text);
  }))) : /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "10px"
  }), step.footnote && /*#__PURE__*/React__default.createElement(FootnoteBlock$3, {
    dangerouslySetInnerHTML: {
      __html: step.footnote
    }
  })), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "25px"
  }), /*#__PURE__*/React__default.createElement(StyledModalPopup$3, {
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params143 = configDetails.paramsDetails) !== null && _configDetails$params143 !== void 0 && (_configDetails$params144 = _configDetails$params143.theme) !== null && _configDetails$params144 !== void 0 && _configDetails$params144.isDark ? 'dark' : 'light',
    theme: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params145 = configDetails.paramsDetails) === null || _configDetails$params145 === void 0 ? void 0 : _configDetails$params145.theme,
    opened: showConfirmationModal,
    ariaLabel: "confirmation-modal",
    fullScreenDialog: false,
    hideCloseButton: false,
    onOpenedChange: function onOpenedChange(value) {
      return setConfirmationModal(value);
    }
  }, /*#__PURE__*/React__default.createElement(ModalBody$1, {
    id: "dark-theme-color"
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: popupContent
    }
  })), /*#__PURE__*/React__default.createElement(ModalFooter$1, null, /*#__PURE__*/React__default.createElement(ButtonGroup$1, {
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params146 = configDetails.paramsDetails) !== null && _configDetails$params146 !== void 0 && (_configDetails$params147 = _configDetails$params146.theme) !== null && _configDetails$params147 !== void 0 && _configDetails$params147.isDark ? 'dark' : 'light',
    childWidth: "100%",
    viewport: "desktop",
    rowQuantity: {
      desktop: 2
    },
    data: [{
      children: 'Cancel',
      size: 'large',
      use: 'secondary',
      width: '200px',
      onClick: function onClick() {
        return handleCancelButton();
      }
    }, {
      children: 'Ok',
      size: 'large',
      use: 'primary',
      width: '200px',
      onClick: function onClick() {
        return handleContinueButton();
      }
    }]
  })))), !window.isMVODigital && analysis && analysis.templateId != 'RESOLUTION_OPTIONS_ALL' && analysis.templateType !== 'PROBING_QUESTIONS_IMAGE' && resolution.templateType !== 'PROBING_QUESTIONS_IMAGE' && analysis.templateId != 'SELECT_DEVICE' && resolution.templateId != 'SELECT_DEVICE' && choices && choices.length > 3 && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(IssuesContainer$3, null, /*#__PURE__*/React__default.createElement("div", {
    className: "question"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, question)), /*#__PURE__*/React__default.createElement(DropdownWrapper$3, {
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params148 = configDetails.paramsDetails) === null || _configDetails$params148 === void 0 ? void 0 : (_configDetails$params149 = _configDetails$params148.theme) === null || _configDetails$params149 === void 0 ? void 0 : _configDetails$params149.isDark
  }, /*#__PURE__*/React__default.createElement(DropdownSelect, {
    onChange: function onChange(e) {
      return handleOptionsChange(e);
    },
    color: configDetails !== null && configDetails !== void 0 && (_configDetails$params150 = configDetails.paramsDetails) !== null && _configDetails$params150 !== void 0 && (_configDetails$params151 = _configDetails$params150.theme) !== null && _configDetails$params151 !== void 0 && _configDetails$params151.isDark ? '#ffffff' : '#000000',
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params152 = configDetails.paramsDetails) !== null && _configDetails$params152 !== void 0 && (_configDetails$params153 = _configDetails$params152.theme) !== null && _configDetails$params153 !== void 0 && _configDetails$params153.isDark ? 'dark' : 'light'
  }, choices.map(function (issue) {
    return /*#__PURE__*/React__default.createElement("option", {
      "data-url": issue.url,
      value: issue.value
    }, issue.text);
  }))), showCustomLocation(choices, probingStep) && /*#__PURE__*/React__default.createElement(UserInput, {
    isDisabled: customLocationDisabled,
    forwardValue: handleSiteSurveyChange
  })), /*#__PURE__*/React__default.createElement(Line$1, {
    type: "secondary"
  }), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "25px"
  })), analysis && analysis.templateType === 'PROBING_QUESTIONS_IMAGE' && /*#__PURE__*/React__default.createElement(ImageProbingQuestions, {
    stepObj: analysis,
    handler: handleSiteSurveyChange,
    channelDetail: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params154 = configDetails.paramsDetails) === null || _configDetails$params154 === void 0 ? void 0 : _configDetails$params154.channel,
    isMVO: window.isMVODigital
  }), resolution && resolution.templateType === 'PROBING_QUESTIONS_IMAGE' && /*#__PURE__*/React__default.createElement(ImageProbingQuestions, {
    stepObj: resolution,
    handler: handleSiteSurveyChange,
    channelDetail: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params155 = configDetails.paramsDetails) === null || _configDetails$params155 === void 0 ? void 0 : _configDetails$params155.channel,
    isMVO: window.isMVODigital
  }), window.isMVODigital && analysis && analysis.templateType !== 'PROBING_QUESTIONS_IMAGE' && resolution.templateType !== 'PROBING_QUESTIONS_IMAGE' && analysis.templateId != 'DEVICE_REPLACEMENT_OPTIONS' && resolution.templateId != 'DEVICE_REPLACEMENT_OPTIONS' && analysis.templateId != 'RESOLUTION_OPTIONS_ALL_DIGITAL' && ((_resolution9 = resolution) === null || _resolution9 === void 0 ? void 0 : _resolution9.templateId) != 'RESOLUTION_OPTIONS_ALL_DIGITAL' && analysis.templateId != 'RESOLUTION_OPTIONS_MVO_TIER2' && resolution.templateId != 'RESOLUTION_OPTIONS_MVO_TIER2' && analysis.templateId != 'SELECT_DEVICE' && resolution.templateId != 'SELECT_DEVICE' && choices && choices.length <= 3 && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(CustomContentDiv$3, {
    isSetFlexColumn: typeof analysis.devices === 'undefined' && resolution.templateId === 'CONFIRM_DEVICE_SHOW_ACTIVE' && typeof resolution.devices !== 'undefined'
  }, /*#__PURE__*/React__default.createElement(IssuesContainer$3, {
    isSetFlexColumn: typeof analysis.devices === 'undefined' && resolution.templateId === 'CONFIRM_DEVICE_SHOW_ACTIVE' && typeof resolution.devices !== 'undefined',
    isMvoDigi: window.isMVODigital
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "question"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, {
    className: "radio-question",
    tag: "h3",
    style: {
      fontSize: '1rem'
    }
  }, question)), typeof analysis.devices === 'undefined' && resolution.templateId === 'CONFIRM_DEVICE_SHOW_ACTIVE' && typeof resolution.devices !== 'undefined' && /*#__PURE__*/React__default.createElement(DeviceConnected, {
    values: values
  }), analysis.templateId !== 'CALL_SPECIFIC_NUMBER_ENTRY' && renderRadioButtons(), analysis.templateId === 'CALL_SPECIFIC_NUMBER_ENTRY' && /*#__PURE__*/React__default.createElement(CapturePhoneNo, {
    forwardValue: handleSiteSurveyChange,
    selectedMdn: selectedMdn,
    step: analysis,
    validate: enableUserSelectionValidation
  })), imageDetails.length > 0 && /*#__PURE__*/React__default.createElement(ImageCarousel, {
    imageDetails: imageDetails
  })), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "25px"
  })), window.isMVODigital && analysis && analysis.templateType !== 'PROBING_QUESTIONS_IMAGE' && resolution.templateType !== 'PROBING_QUESTIONS_IMAGE' && analysis.templateId != 'DEVICE_REPLACEMENT_OPTIONS' && resolution.templateId != 'DEVICE_REPLACEMENT_OPTIONS' && analysis.templateId != 'RESOLUTION_OPTIONS_ALL_DIGITAL' && analysis.templateId != 'RESOLUTION_OPTIONS_MVO_TIER2' && ((_resolution0 = resolution) === null || _resolution0 === void 0 ? void 0 : _resolution0.templateId) != 'RESOLUTION_OPTIONS_ALL_DIGITAL' && choices && choices.length > 3 && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(IssuesContainer$3, null, /*#__PURE__*/React__default.createElement(DropdownSelect, {
    onChange: function onChange(e) {
      return handleOptionsChangeDigital(e);
    },
    style: {
      width: '185px !important'
    },
    color: configDetails !== null && configDetails !== void 0 && (_configDetails$params156 = configDetails.paramsDetails) !== null && _configDetails$params156 !== void 0 && (_configDetails$params157 = _configDetails$params156.theme) !== null && _configDetails$params157 !== void 0 && _configDetails$params157.isDark ? '#ffffff' : '#000000',
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params158 = configDetails.paramsDetails) !== null && _configDetails$params158 !== void 0 && (_configDetails$params159 = _configDetails$params158.theme) !== null && _configDetails$params159 !== void 0 && _configDetails$params159.isDark ? 'dark' : 'light'
  }, choices.map(function (issue) {
    return /*#__PURE__*/React__default.createElement("option", {
      value: issue.value
    }, issue.text);
  })), showCustomLocation(choices, probingStep) && /*#__PURE__*/React__default.createElement(UserInput, {
    isDisabled: customLocationDisabled,
    onSubmit: function onSubmit(metadata) {
      return handleOkClick(metadata, true);
    },
    forwardValue: handleSiteSurveyChange
  })), /*#__PURE__*/React__default.createElement(Line$1, {
    type: "secondary"
  }), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "25px"
  })), window.isMVODigital && analysis && (analysis.templateId == 'DEVICE_REPLACEMENT_OPTIONS' || resolution.templateId == 'DEVICE_REPLACEMENT_OPTIONS') && analysis.templateId != 'RESOLUTION_OPTIONS_ALL_DIGITAL' && ((_resolution1 = resolution) === null || _resolution1 === void 0 ? void 0 : _resolution1.templateId) != 'RESOLUTION_OPTIONS_ALL_DIGITAL' && choices && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TilesContainer$3, {
    className: "autoHeight"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "question"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, question)), /*#__PURE__*/React__default.createElement(TiletContainer$3, null, linksArray.filter(function (topLinkTile, index) {
    if (topLinkTile.text.toLowerCase() === 'learn about repair and replacement') {
      deviceReplacementMidFlowTileIndex = index;
    }
    return topLinkTile.text.toLowerCase() !== 'learn about repair and replacement';
  }).map(function (issue) {
    var _configDetails$params160, _configDetails$params161, _configDetails$params162, _configDetails$params163, _configDetails$params164, _configDetails$params165, _configDetails$params166, _configDetails$params167, _configDetails$params168, _configDetails$params169;
    return /*#__PURE__*/React__default.createElement(TileContainerWrapper, {
      isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params160 = configDetails.paramsDetails) === null || _configDetails$params160 === void 0 ? void 0 : (_configDetails$params161 = _configDetails$params160.theme) === null || _configDetails$params161 === void 0 ? void 0 : _configDetails$params161.isDark,
      key: issue === null || issue === void 0 ? void 0 : issue.text,
      onClick: function onClick(e) {
        return handleResolutionOptionClick(e, issue);
      },
      onKeyPress: function onKeyPress(e) {
        return handleResolutionOptionClick(e, issue);
      },
      "data-analyticstrack": issue === null || issue === void 0 ? void 0 : issue.text,
      "data-track": "{\"type\": \"link\", \"name\": " + (issue === null || issue === void 0 ? void 0 : issue.text) + "}",
      "data-clickstream": (issue === null || issue === void 0 ? void 0 : issue.text) + "-link",
      "data-url": issue === null || issue === void 0 ? void 0 : issue.url,
      role: "link",
      tabIndex: "0",
      "aria-label": (issue !== null && issue !== void 0 && issue.recommended ? 'Recommended' : '') + " " + (issue === null || issue === void 0 ? void 0 : issue.text) + " " + (issue !== null && issue !== void 0 && issue.note ? getIssueDescription(issue === null || issue === void 0 ? void 0 : issue.description) : issue === null || issue === void 0 ? void 0 : issue.description)
    }, /*#__PURE__*/React__default.createElement(TileContainer$1, {
      padding: "16px",
      aspectRatio: "none",
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params162 = configDetails.paramsDetails) !== null && _configDetails$params162 !== void 0 && (_configDetails$params163 = _configDetails$params162.theme) !== null && _configDetails$params163 !== void 0 && _configDetails$params163.isDark ? 'dark' : 'light'
    }, /*#__PURE__*/React__default.createElement(FlexContainer$1, null, (issue === null || issue === void 0 ? void 0 : issue.recommended) && /*#__PURE__*/React__default.createElement(TopPadder$1, null, /*#__PURE__*/React__default.createElement(Badge, {
      maxWidth: "120px",
      fillColor: "black"
    }, "Recommended")), /*#__PURE__*/React__default.createElement(TopPadder$1, null, /*#__PURE__*/React__default.createElement(Title, {
      size: "small",
      bold: true,
      primitive: "h3",
      color: configDetails !== null && configDetails !== void 0 && (_configDetails$params164 = configDetails.paramsDetails) !== null && _configDetails$params164 !== void 0 && (_configDetails$params165 = _configDetails$params164.theme) !== null && _configDetails$params165 !== void 0 && _configDetails$params165.isDark ? "#FFFFFF" : "#000000"
    }, issue === null || issue === void 0 ? void 0 : issue.text)), /*#__PURE__*/React__default.createElement(TopPadder$1, null, /*#__PURE__*/React__default.createElement(Body, {
      color: configDetails !== null && configDetails !== void 0 && (_configDetails$params166 = configDetails.paramsDetails) !== null && _configDetails$params166 !== void 0 && (_configDetails$params167 = _configDetails$params166.theme) !== null && _configDetails$params167 !== void 0 && _configDetails$params167.isDark ? "#FFFFFF" : "#000000"
    }, issue !== null && issue !== void 0 && issue.note ? getIssueDescription(issue === null || issue === void 0 ? void 0 : issue.description) : issue === null || issue === void 0 ? void 0 : issue.description, " ")))), /*#__PURE__*/React__default.createElement(HStack, {
      justifyContent: "space-between",
      paddingLeft: "16px"
    }, /*#__PURE__*/React__default.createElement(Body, {
      color: ColorTokens.palette.gray44.value
    }, issue === null || issue === void 0 ? void 0 : issue.note), /*#__PURE__*/React__default.createElement(RightArrowDiv$3, null, /*#__PURE__*/React__default.createElement(Icon$1, {
      name: "right-arrow",
      size: "medium",
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params168 = configDetails.paramsDetails) !== null && _configDetails$params168 !== void 0 && (_configDetails$params169 = _configDetails$params168.theme) !== null && _configDetails$params169 !== void 0 && _configDetails$params169.isDark ? 'dark' : 'light'
    }))));
  }))), deviceReplacementMidFlowTileIndex !== -1 && isMvaFlow && /*#__PURE__*/React__default.createElement(SpanTag$1, null, /*#__PURE__*/React__default.createElement(TextLink, {
    type: "inline",
    size: "small",
    href: linksArray[deviceReplacementMidFlowTileIndex].url
  }, linksArray[deviceReplacementMidFlowTileIndex].text)), deviceReplacementMidFlowTileIndex !== -1 && !isMvaFlow && /*#__PURE__*/React__default.createElement(SpanTag$1, null, /*#__PURE__*/React__default.createElement(TextLink, {
    type: "inline",
    size: "small",
    onClick: function onClick(e) {
      return window.open(linksArray[deviceReplacementMidFlowTileIndex].url, '_blank');
    }
  }, linksArray[deviceReplacementMidFlowTileIndex].text)), step.footnote && /*#__PURE__*/React__default.createElement(FootnoteBlock$3, {
    dangerouslySetInnerHTML: {
      __html: step.footnote
    }
  }), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "25px"
  })), window.isMVODigital && analysis && (analysis.templateId == 'RESOLUTION_OPTIONS_ALL_DIGITAL' || analysis.templateId == 'RESOLUTION_OPTIONS_MVO_TIER2' || resolution.templateId == 'RESOLUTION_OPTIONS_MVO_TIER2' || ((_resolution10 = resolution) === null || _resolution10 === void 0 ? void 0 : _resolution10.templateId) == 'RESOLUTION_OPTIONS_ALL_DIGITAL') && analysis.templateId != 'DEVICE_REPLACEMENT_OPTIONS' && resolution.templateId != 'DEVICE_REPLACEMENT_OPTIONS' && choices && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TilesContainer$3, {
    className: "autoHeight"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "question"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, question), getRecommendedText(), !recommendationAvailable && window.config.troubleShootingJson.ddata.device.selected5GDevice && /*#__PURE__*/React__default.createElement(TextWithHtml, null, getFooterNote(newFootNote, ''))), /*#__PURE__*/React__default.createElement(TiletContainer$3, null, topLinksArray.filter(function (topLinkTile, index) {
    if (topLinkTile.text.toLowerCase() === 'learn about repair and replacement') {
      deviceReplacementEotFlowTileIndex = index;
    }
    return topLinkTile.text.toLowerCase() !== 'learn about repair and replacement';
  }).map(function (issue) {
    var _configDetails$params170, _configDetails$params171, _configDetails$params172, _configDetails$params173, _configDetails$params174, _configDetails$params175, _configDetails$params176, _configDetails$params177, _configDetails$params178, _configDetails$params179;
    return /*#__PURE__*/React__default.createElement(TileContainerWrapper, {
      isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params170 = configDetails.paramsDetails) === null || _configDetails$params170 === void 0 ? void 0 : (_configDetails$params171 = _configDetails$params170.theme) === null || _configDetails$params171 === void 0 ? void 0 : _configDetails$params171.isDark,
      key: issue === null || issue === void 0 ? void 0 : issue.text,
      onClick: function onClick(e) {
        return handleButtonClickDigital(e, issue, analysis.templateId, resolution.templateId);
      },
      onKeyPress: function onKeyPress(e) {
        return handleButtonClickDigital(e, issue, analysis.templateId, resolution.templateId);
      },
      "data-analyticstrack": issue === null || issue === void 0 ? void 0 : issue.text,
      "data-track": "" + (issue !== null && issue !== void 0 && issue.recommended ? getContentFrament(issue === null || issue === void 0 ? void 0 : issue.text) : "{\"type\": \"link\", \"name\": " + (issue === null || issue === void 0 ? void 0 : issue.text) + "}"),
      "data-clickstream": (issue === null || issue === void 0 ? void 0 : issue.text) + "-link",
      "data-url": issue === null || issue === void 0 ? void 0 : issue.url,
      role: "link",
      tabIndex: "0",
      "aria-label": (issue !== null && issue !== void 0 && issue.recommended ? 'Recommended' : '') + " " + (issue === null || issue === void 0 ? void 0 : issue.text) + " " + (issue !== null && issue !== void 0 && issue.note ? getIssueDescription(issue === null || issue === void 0 ? void 0 : issue.description) : issue === null || issue === void 0 ? void 0 : issue.description)
    }, /*#__PURE__*/React__default.createElement(TileContainer$1, {
      padding: "16px",
      aspectRatio: "none",
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params172 = configDetails.paramsDetails) !== null && _configDetails$params172 !== void 0 && (_configDetails$params173 = _configDetails$params172.theme) !== null && _configDetails$params173 !== void 0 && _configDetails$params173.isDark ? 'dark' : 'light'
    }, /*#__PURE__*/React__default.createElement(FlexContainer$1, null, (issue === null || issue === void 0 ? void 0 : issue.recommended) && /*#__PURE__*/React__default.createElement(TopPadder$1, null, /*#__PURE__*/React__default.createElement(Badge, {
      maxWidth: "120px",
      fillColor: "black"
    }, "Recommended")), /*#__PURE__*/React__default.createElement(TopPadder$1, null, /*#__PURE__*/React__default.createElement(Title, {
      size: "small",
      bold: true,
      primitive: "h3",
      color: configDetails !== null && configDetails !== void 0 && (_configDetails$params174 = configDetails.paramsDetails) !== null && _configDetails$params174 !== void 0 && (_configDetails$params175 = _configDetails$params174.theme) !== null && _configDetails$params175 !== void 0 && _configDetails$params175.isDark ? "#FFFFFF" : "#000000"
    }, issue === null || issue === void 0 ? void 0 : issue.text)), /*#__PURE__*/React__default.createElement(TopPadder$1, null, /*#__PURE__*/React__default.createElement(Body, {
      color: configDetails !== null && configDetails !== void 0 && (_configDetails$params176 = configDetails.paramsDetails) !== null && _configDetails$params176 !== void 0 && (_configDetails$params177 = _configDetails$params176.theme) !== null && _configDetails$params177 !== void 0 && _configDetails$params177.isDark ? "#FFFFFF" : "#000000"
    }, "  ", issue !== null && issue !== void 0 && issue.note ? getIssueDescription(issue === null || issue === void 0 ? void 0 : issue.description) : issue === null || issue === void 0 ? void 0 : issue.description, " ")))), /*#__PURE__*/React__default.createElement(HStack, {
      justifyContent: "space-between",
      paddingLeft: "16px"
    }, /*#__PURE__*/React__default.createElement(Body, {
      color: ColorTokens.palette.gray44.value
    }, issue === null || issue === void 0 ? void 0 : issue.note), /*#__PURE__*/React__default.createElement(RightArrowDiv$3, null, /*#__PURE__*/React__default.createElement(Icon$1, {
      name: "right-arrow",
      size: "medium",
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params178 = configDetails.paramsDetails) !== null && _configDetails$params178 !== void 0 && (_configDetails$params179 = _configDetails$params178.theme) !== null && _configDetails$params179 !== void 0 && _configDetails$params179.isDark ? 'dark' : 'light'
    }))));
  }))), deviceReplacementEotFlowTileIndex !== -1 && isMvaFlow && /*#__PURE__*/React__default.createElement(SpanTag$1, null, /*#__PURE__*/React__default.createElement(TextLink, {
    type: "inline",
    size: "small",
    href: topLinksArray[deviceReplacementEotFlowTileIndex].url
  }, topLinksArray[deviceReplacementEotFlowTileIndex].text)), deviceReplacementEotFlowTileIndex !== -1 && !isMvaFlow && /*#__PURE__*/React__default.createElement(SpanTag$1, null, /*#__PURE__*/React__default.createElement(TextLink, {
    type: "inline",
    size: "small",
    onClick: function onClick(e) {
      return window.open(topLinksArray[deviceReplacementEotFlowTileIndex].url, '_blank');
    }
  }, topLinksArray[deviceReplacementEotFlowTileIndex].text)), newFootNote && (window.config.troubleShootingJson.ddata.device.selected5GDevice === undefined ? true : !window.config.troubleShootingJson.ddata.device.selected5GDevice) && /*#__PURE__*/React__default.createElement(FootnoteBlock$3, {
    dangerouslySetInnerHTML: {
      __html: getFooterNote(newFootNote, recommendationType)
    }
  }), /*#__PURE__*/React__default.createElement(TilesContainer$3, {
    className: "autoHeight"
  }, /*#__PURE__*/React__default.createElement(TiletContainer$3, null, bottomLinksArray.filter(function (bottomLinkTile, index) {
    if (recommendationType === 'support' && bottomLinkTile.text.toLowerCase() === 'learn about repair and replacement') {
      deviceReplacementBottomTileIndex = index;
    }
    return bottomLinkTile.text.toLowerCase() !== 'learn about repair and replacement';
  }).map(function (issue) {
    var _configDetails$params180, _configDetails$params181, _configDetails$params182, _configDetails$params183, _configDetails$params184, _configDetails$params185, _configDetails$params186, _configDetails$params187, _configDetails$params188, _configDetails$params189;
    return /*#__PURE__*/React__default.createElement(TileContainerWrapper, {
      isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params180 = configDetails.paramsDetails) === null || _configDetails$params180 === void 0 ? void 0 : (_configDetails$params181 = _configDetails$params180.theme) === null || _configDetails$params181 === void 0 ? void 0 : _configDetails$params181.isDark,
      key: issue === null || issue === void 0 ? void 0 : issue.text,
      onClick: function onClick(e) {
        return handleButtonClickDigital(e, issue, analysis.templateId, resolution.templateId);
      },
      onKeyPress: function onKeyPress(e) {
        return handleButtonClickDigital(e, issue, analysis.templateId, resolution.templateId);
      },
      "data-analyticstrack": issue === null || issue === void 0 ? void 0 : issue.text,
      "data-track": "{\"type\": \"link\", \"name\": " + (issue === null || issue === void 0 ? void 0 : issue.text) + "}",
      "data-clickstream": (issue === null || issue === void 0 ? void 0 : issue.text) + "-link",
      "data-url": issue === null || issue === void 0 ? void 0 : issue.url,
      role: "link",
      tabIndex: "0",
      "aria-label": (issue !== null && issue !== void 0 && issue.recommended ? 'Recommended' : '') + " " + (issue === null || issue === void 0 ? void 0 : issue.text) + " " + (issue === null || issue === void 0 ? void 0 : issue.description)
    }, /*#__PURE__*/React__default.createElement(TileContainer$1, {
      padding: "16px",
      aspectRatio: "none",
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params182 = configDetails.paramsDetails) !== null && _configDetails$params182 !== void 0 && (_configDetails$params183 = _configDetails$params182.theme) !== null && _configDetails$params183 !== void 0 && _configDetails$params183.isDark ? 'dark' : 'light'
    }, /*#__PURE__*/React__default.createElement(FlexContainer$1, null, (issue === null || issue === void 0 ? void 0 : issue.recommended) && /*#__PURE__*/React__default.createElement(TopPadder$1, null, /*#__PURE__*/React__default.createElement(Badge, {
      maxWidth: "120px"
    }, "Recommended")), /*#__PURE__*/React__default.createElement(TopPadder$1, null, /*#__PURE__*/React__default.createElement(Title, {
      size: "small",
      bold: true,
      primitive: "h3",
      color: configDetails !== null && configDetails !== void 0 && (_configDetails$params184 = configDetails.paramsDetails) !== null && _configDetails$params184 !== void 0 && (_configDetails$params185 = _configDetails$params184.theme) !== null && _configDetails$params185 !== void 0 && _configDetails$params185.isDark ? "#FFFFFF" : "#000000"
    }, issue === null || issue === void 0 ? void 0 : issue.text)), /*#__PURE__*/React__default.createElement(TopPadder$1, null, /*#__PURE__*/React__default.createElement(Body, {
      color: configDetails !== null && configDetails !== void 0 && (_configDetails$params186 = configDetails.paramsDetails) !== null && _configDetails$params186 !== void 0 && (_configDetails$params187 = _configDetails$params186.theme) !== null && _configDetails$params187 !== void 0 && _configDetails$params187.isDark ? "#FFFFFF" : "#000000"
    }, issue === null || issue === void 0 ? void 0 : issue.description)))), /*#__PURE__*/React__default.createElement(RightArrowDiv$3, null, /*#__PURE__*/React__default.createElement(Icon$1, {
      name: "right-arrow",
      size: "medium",
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params188 = configDetails.paramsDetails) !== null && _configDetails$params188 !== void 0 && (_configDetails$params189 = _configDetails$params188.theme) !== null && _configDetails$params189 !== void 0 && _configDetails$params189.isDark ? 'dark' : 'light'
    })));
  }))), deviceReplacementBottomTileIndex !== -1 && isMvaFlow && /*#__PURE__*/React__default.createElement(SpanTag$1, null, /*#__PURE__*/React__default.createElement(TextLink, {
    type: "inline",
    size: "small",
    href: bottomLinksArray[deviceReplacementBottomTileIndex].url
  }, bottomLinksArray[deviceReplacementBottomTileIndex].text)), deviceReplacementBottomTileIndex !== -1 && !isMvaFlow && /*#__PURE__*/React__default.createElement(SpanTag$1, null, /*#__PURE__*/React__default.createElement(TextLink, {
    type: "inline",
    size: "small",
    onClick: function onClick(e) {
      return window.open(bottomLinksArray[deviceReplacementBottomTileIndex].url, '_blank');
    }
  }, bottomLinksArray[deviceReplacementBottomTileIndex].text)), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "25px"
  })), !window.isMVODigital && buttons && buttons.length > 1 && (!isNewDesign || isNewDesign && isHowToContent) && /*#__PURE__*/React__default.createElement(TextWrapper$3, {
    size: "large",
    isNewDesign: isNewDesign,
    style: {
      marginTop: '15px',
      marginBottom: '28px'
    }
  }, "Did this solve the problem?")))))), showFeedback && /*#__PURE__*/React__default.createElement(Fragment, null, window.isMVODigital && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "10px"
  }), /*#__PURE__*/React__default.createElement(FeedbackSaveExitContainerWrapper, null, /*#__PURE__*/React__default.createElement(FeedbackSaveExitContainer$4, {
    isNewDesign: isNewDesign,
    hideRightNav: rightMenuItems.length == 0 || hideRightNav,
    isMvoDigi: window.isMVODigital
  }, /*#__PURE__*/React__default.createElement(FeedbackContainer, {
    key: aiSummaryLoaded,
    functions: functions,
    values: values,
    eotFlag: eotFlag,
    handleModalState: handleModalState,
    flags: flags,
    intentId: intentId,
    acssCallId: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params190 = configDetails.paramsDetails) === null || _configDetails$params190 === void 0 ? void 0 : _configDetails$params190.acssCallId,
    isACSS: isACSS
  }))))), !isMobile() ? /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "20px"
  }) : /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "4px"
  }), (!isNewDesign || window.isMVODigital) && /*#__PURE__*/React__default.createElement(ButtonWrapper$9, {
    hideRightNav: rightMenuItems.length == 0 || hideRightNav,
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params191 = configDetails.paramsDetails) === null || _configDetails$params191 === void 0 ? void 0 : (_configDetails$params192 = _configDetails$params191.theme) === null || _configDetails$params192 === void 0 ? void 0 : _configDetails$params192.isDark
  }, isNewDesign && /*#__PURE__*/React__default.createElement(Line$1, {
    type: "secondary"
  }), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "20px"
  }), /*#__PURE__*/React__default.createElement(RowFlexSpaceWrapper, null, /*#__PURE__*/React__default.createElement(RowFlexWrapper, null, !udbIntentId && /*#__PURE__*/React__default.createElement(NavigationButtonDigital, {
    buttons: buttons,
    handleAction: handleAction,
    stackButtons: isMobile(),
    showPrevious:  navHist.length > 0,
    showNext:  navHist.length > 0,
    disableNext: disabledBtnNext,
    disablePrevious: disabledBtnPrev,
    pageId: currentPageId,
    handlePrevious: function handlePrevious(value) {
      return handleChecklistChange(value);
    },
    handleNext: function handleNext(value) {
      return handleChecklistChange(value);
    },
    size: "165px",
    disabled: HideNextBtn || disableContinueButton(),
    caretSize: "medium",
    isNewDesign: isNewDesign,
    isHowToContent: isHowToContent,
    functions: functions,
    values: values,
    eotFlag: eotFlag,
    handleModalState: handleModalState,
    templateId: analysis.templateId
  }), window.isMVODigital && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "solvedProblemLinkNew"
  }, isNewDesign && analysis.templateId !== 'RESOLUTION_OPTIONS_ALL_DIGITAL' && ((_resolution11 = resolution) === null || _resolution11 === void 0 ? void 0 : _resolution11.templateId) !== 'RESOLUTION_OPTIONS_ALL_DIGITAL' && !udbIntentId && analysis.templateId !== 'RESOLUTION_OPTIONS_MVO_TIER2' && buttons.length > 0 && buttons[0].label.toLowerCase() == 'yes' && /*#__PURE__*/React__default.createElement(TextLink, {
    type: "standAlone",
    surface: "light",
    disabled: false,
    onClick: handleSolvedClick
  }, "This solved my problem")))), !isHowToContent && /*#__PURE__*/React__default.createElement(SaveAndRetrieveTooltip, {
    configDetails: configDetails,
    isProbing: !showFeedback,
    midFlowSigninUrl: midFlowSigninUrl
  })), analysis && analysis.skipSolution && !window.isMVODigital && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "10px"
  }), /*#__PURE__*/React__default.createElement(TextWrapper$3, null, /*#__PURE__*/React__default.createElement(TextLink, {
    type: "standAlone",
    size: "medium",
    onClick: handleLinkClick,
    color: "gray",
    id: "textLink",
    "data-track": '{"type": "link", "name": "Cannot complete this step"}',
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params193 = configDetails.paramsDetails) !== null && _configDetails$params193 !== void 0 && (_configDetails$params194 = _configDetails$params193.theme) !== null && _configDetails$params194 !== void 0 && _configDetails$params194.isDark ? "dark" : "light"
  }, "Cannot complete this step")))), (!isNewDesign || window.isMVODigital) && /*#__PURE__*/React__default.createElement(ButtonWrapperMobile$4, null, isNewDesign && /*#__PURE__*/React__default.createElement(Line$1, {
    type: "secondary"
  }), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "20px"
  }), !udbIntentId && /*#__PURE__*/React__default.createElement(NavigationButtonDigital, {
    buttons: buttons,
    handleAction: handleAction,
    stackButtons: isMobile(),
    showPrevious:  navHist.length > 0,
    showNext:  navHist.length > 0,
    disableNext: disabledBtnNext,
    disablePrevious: disabledBtnPrev,
    pageId: currentPageId,
    handlePrevious: function handlePrevious(value) {
      return handleChecklistChange(value);
    },
    handleNext: function handleNext(value) {
      return handleChecklistChange(value);
    },
    size: "165px",
    disabled: HideNextBtn || disableContinueButton(),
    caretSize: "medium",
    isNewDesign: isNewDesign,
    isHowToContent: isHowToContent,
    functions: functions,
    values: values,
    eotFlag: eotFlag,
    handleModalState: handleModalState,
    templateId: analysis.templateId
  }), window.isMVODigital && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "solvedProblemLink"
  }, isNewDesign && analysis.templateId !== 'RESOLUTION_OPTIONS_ALL_DIGITAL' && ((_resolution12 = resolution) === null || _resolution12 === void 0 ? void 0 : _resolution12.templateId) !== 'RESOLUTION_OPTIONS_ALL_DIGITAL' && !udbIntentId && analysis.templateId !== 'RESOLUTION_OPTIONS_MVO_TIER2' && buttons.length > 0 && buttons[0].label.toLowerCase() == 'yes' && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "20px"
  }), /*#__PURE__*/React__default.createElement(TextLink, {
    type: "standAlone",
    surface: "light",
    disabled: false,
    onClick: handleSolvedClick
  }, "This solved my problem")))), !isHowToContent && /*#__PURE__*/React__default.createElement(SaveAndRetrieveTooltip, {
    configDetails: configDetails,
    isProbing: !showFeedback,
    midFlowSigninUrl: midFlowSigninUrl
  }), analysis && analysis.skipSolution && !window.isMVODigital && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TextWrapper$3, null, /*#__PURE__*/React__default.createElement(TextLink, {
    type: "standAlone",
    size: "medium",
    onClick: handleLinkClick,
    color: "gray",
    id: "textLink",
    "data-track": '{"type": "link", "name": "Cannot complete this step"}'
  }, /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "10px"
  }), "Cannot complete this step"), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "25px"
  }))), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "10px"
  })), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "20px"
  }), modalParams.show && renderMessageModal(modalParams), isNewDesign && !window.isMVODigital && !isHowToContent && analysis && analysis.skipSolution && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '83%',
      margin: 'auto'
    },
    id: "textLink"
  }, /*#__PURE__*/React__default.createElement(StyledCheckbox$3, {
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params195 = configDetails.paramsDetails) === null || _configDetails$params195 === void 0 ? void 0 : (_configDetails$params196 = _configDetails$params195.theme) === null || _configDetails$params196 === void 0 ? void 0 : _configDetails$params196.isDark,
    name: "default",
    width: "auto",
    disabled: false,
    error: false,
    selected: false,
    onChange: handleLinkClick,
    "data-track": isAcssChannel || isRetailChannel ? 'Unable to complete this step' : "{'type': 'link', 'name': 'Unable to complete this step'}",
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params197 = configDetails.paramsDetails) !== null && _configDetails$params197 !== void 0 && (_configDetails$params198 = _configDetails$params197.theme) !== null && _configDetails$params198 !== void 0 && _configDetails$params198.isDark ? "dark" : "light"
  }, "Unable to complete this step"), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "10px"
  }))), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "25px"
  }))), isNewDesign && !window.isMVODigital && /*#__PURE__*/React__default.createElement(Footer$4, {
    className: "footer1",
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params199 = configDetails.paramsDetails) === null || _configDetails$params199 === void 0 ? void 0 : (_configDetails$params200 = _configDetails$params199.theme) === null || _configDetails$params200 === void 0 ? void 0 : _configDetails$params200.isDark
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "footer-line"
  }), /*#__PURE__*/React__default.createElement(ActionButtons, {
    key: aiSummaryLoaded,
    handleAction: handleAction,
    buttons: buttons,
    showPrevious: true,
    showNext: true,
    disableNext: disabledBtnNext,
    disablePrevious: disabledBtnPrev,
    pageId: currentPageId,
    handlePrevious: function handlePrevious(value) {
      return handleChecklistChange(value);
    },
    handleNext: handleAction,
    disabledButtons: disableNextButton(),
    newBtnType: true,
    nextStepEnabled: disableIssueResolved(),
    hideIssueResolved: hideIssueResolved(),
    handleFeedbackClick: function handleFeedbackClick() {
      return _handleFeedbackClick(templateTypeMain);
    },
    isNewDesign: isNewDesign,
    isHowToContent: isHowToContent,
    functions: functions,
    values: values,
    eotFlag: eotFlag,
    handleModalState: handleModalState,
    feedbackPostSubmit: feedbackStatusObj$1,
    thumbsDownSubmittedStep: thumbsDownSubmittedStep,
    templateId: analysis.templateId,
    isNextBtnEnableNRB: isNextBtnEnableNRB,
    intentId: intentId,
    acssCallId: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params201 = configDetails.paramsDetails) === null || _configDetails$params201 === void 0 ? void 0 : _configDetails$params201.acssCallId,
    isACSS: isACSS
  }))), /*#__PURE__*/React__default.createElement(StyledModal$8, {
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params202 = configDetails.paramsDetails) !== null && _configDetails$params202 !== void 0 && (_configDetails$params203 = _configDetails$params202.theme) !== null && _configDetails$params203 !== void 0 && _configDetails$params203.isDark ? 'dark' : 'light',
    theme: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params204 = configDetails.paramsDetails) === null || _configDetails$params204 === void 0 ? void 0 : _configDetails$params204.theme,
    closeButton: modalValues.modalType === 'saveAndExit' ? /*#__PURE__*/React__default.createElement(SaveExitCloseButton$5, {
      "data-analyticstrack": "overlay-generic-cta"
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params205 = configDetails.paramsDetails) !== null && _configDetails$params205 !== void 0 && (_configDetails$params206 = _configDetails$params205.theme) !== null && _configDetails$params206 !== void 0 && _configDetails$params206.isDark ? 'dark' : 'light',
      id: "closeModal",
      name: "close",
      size: "large",
      color: "#000000",
      backgroundColor: "transparent"
    }), ' ') : /*#__PURE__*/React__default.createElement(FeedbackCloseButton$6, {
      "data-analyticstrack": "overlay-generic-cta"
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params207 = configDetails.paramsDetails) !== null && _configDetails$params207 !== void 0 && (_configDetails$params208 = _configDetails$params207.theme) !== null && _configDetails$params208 !== void 0 && _configDetails$params208.isDark ? 'dark' : 'light',
      id: "closeModal",
      name: "close",
      size: "large",
      color: "#000000",
      backgroundColor: "transparent"
    }), ' '),
    onOpenedChange: modalChanged,
    opened: modalValues.showModal,
    zIndex: "15000",
    expandModal: modalValues.expandModal,
    disableAnimation: window.isMVODigital && isMvaFlow && modalValues.modalType === 'feedback' ? true : false,
    disableOutsideClick: true,
    modalType: modalValues.modalType === 'saveAndExit',
    howToModalType: modalValues.modalType === 'howToFeedback',
    modalName: modalValues.modalType,
    maxHeight: "95vh"
  }, /*#__PURE__*/React__default.createElement(StyledModalBody$7, null, modalValues.modalType === 'feedback' && /*#__PURE__*/React__default.createElement(FeedbackContainerModal, {
    functions: functions,
    values: values,
    flags: flags,
    handleModalClick: handleModalClick,
    symptom: symptom,
    handleCloseButton: handleCloseButton,
    handleFeedbackFlags: handleFeedbackFlags,
    intentId: intentId,
    acssCallId: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params209 = configDetails.paramsDetails) === null || _configDetails$params209 === void 0 ? void 0 : _configDetails$params209.acssCallId,
    isACSS: isACSS
  }), modalValues.modalType === 'howToFeedback' && /*#__PURE__*/React__default.createElement(HowToFeedbackContainerModal, {
    functions: functions,
    values: values,
    handleModalClick: handleModalClick,
    flags: flags,
    symptom: symptom,
    handleCloseButton: handleCloseButton,
    handleFeedbackFlags: handleFeedbackFlags,
    intentId: intentId,
    acssCallId: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params210 = configDetails.paramsDetails) === null || _configDetails$params210 === void 0 ? void 0 : _configDetails$params210.acssCallId,
    isACSS: isACSS
  }), modalValues.modalType === 'saveAndExit' && /*#__PURE__*/React__default.createElement(SaveAndExitContainerModal, {
    functions: functions,
    values: values,
    handleModalClick: handleModalClick,
    symptom: symptom,
    handleCloseButton: handleCloseButton
  }))), window.isMVODigital && /*#__PURE__*/React__default.createElement(Modal$1, {
    surface: "light",
    fullScreenDialog: false,
    disableAnimation: window._dg_channelId === 'VZW-MFA' ? true : false,
    disableOutsideClick: false,
    ariaLabel: "Tech coach help",
    onOpenedChange: function onOpenedChange(status) {
      if (status) {
        taggingSetOpenView('Help from tech coach expert', '#tech_coach_popup_chatbot_flow');
      }
    },
    opened: accountElgible && intentEligible && openChatbotFlowPopup,
    id: "tech_coach_popup_chatbot_flow",
    closeButton: /*#__PURE__*/React__default.createElement(CloseIconWrapper$4, null, /*#__PURE__*/React__default.createElement(CloseButtonIconContainer$4, null, /*#__PURE__*/React__default.createElement(PopupCloseButton$3, {
      onClick: closeTechCoachPopup
    }, /*#__PURE__*/React__default.createElement(CloseButtonHitArea$4, null), /*#__PURE__*/React__default.createElement(IconContainer$4, null, /*#__PURE__*/React__default.createElement(CloseIconSVG$4, {
      role: "img",
      "aria-hidden": "false",
      "aria-label": "close icon",
      viewBox: "0 0 21.6 21.6"
    }, /*#__PURE__*/React__default.createElement("title", null, "close icon"), /*#__PURE__*/React__default.createElement("path", {
      d: "M11.59,10.8l7.11,7.1-.8.8-7.1-7.11L3.7,18.7l-.8-.8L10,10.8,2.9,3.7l.8-.8L10.8,10,17.9,2.9l.8.8Z",
      stroke: "none",
      fill: "#000000"
    }))))))
  }, /*#__PURE__*/React__default.createElement(ModalTitle, null, "Do you want help from a Tech Coach expert?"), /*#__PURE__*/React__default.createElement(ModalBody$1, {
    children: /*#__PURE__*/React__default.createElement("div", {
      className: "tech_coach_popup_body"
    }, /*#__PURE__*/React__default.createElement(TechCoachBody$4, null, "You're enrolled in device protection, with 24/7 access to an expert who can help you resolve your issue."), /*#__PURE__*/React__default.createElement(TechCoachBody$4, null, "You can also continue troubleshooting on your own."))
  }), /*#__PURE__*/React__default.createElement(ModalFooter$1, {
    buttonData: {
      primary: {
        children: 'Chat with Tech Coach',
        'data-analyticstrack': 'chat_with_tech_coach_cta',
        'data-track': '{type: button, name: Chat with Tech Coach}',
        onClick: function onClick() {
          var target = isMVA ? '_self' : '_blank';
          window.open('https://my.asurion.com/device-care/chat?utm=vz_troubleshoot&mxclient=verizon&cid=chat', target, "noopener");
        }
      },
      close: {
        children: 'Troubleshoot',
        'data-analyticstrack': 'tech_coach_troubleshoot_cta',
        'data-track': '{type: button, name: Troubleshoot - Tech Coach}',
        onClick: function onClick() {
          closeTechCoachPopup();
        }
      }
    }
  })));
};
TroubleShootingNewPage.propTypes = {
  functions: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
};
TroubleShootingNewPage.defaultProps = {};

var SelectStates = function SelectStates() {
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("option", null, "Select"), /*#__PURE__*/React__default.createElement("option", {
    value: "AL"
  }, "Alabama"), /*#__PURE__*/React__default.createElement("option", {
    value: "AK"
  }, "Alaska"), /*#__PURE__*/React__default.createElement("option", {
    value: "AZ"
  }, "Arizona"), /*#__PURE__*/React__default.createElement("option", {
    value: "AR"
  }, "Arkansas"), /*#__PURE__*/React__default.createElement("option", {
    value: "CA"
  }, "California"), /*#__PURE__*/React__default.createElement("option", {
    value: "CO"
  }, "Colorado"), /*#__PURE__*/React__default.createElement("option", {
    value: "CT"
  }, "Connecticut"), /*#__PURE__*/React__default.createElement("option", {
    value: "DE"
  }, "Delaware"), /*#__PURE__*/React__default.createElement("option", {
    value: "DC"
  }, "District of Columbia"), /*#__PURE__*/React__default.createElement("option", {
    value: "FL"
  }, "Florida"), /*#__PURE__*/React__default.createElement("option", {
    value: "GA"
  }, "Georgia"), /*#__PURE__*/React__default.createElement("option", {
    value: "HI"
  }, "Hawaii"), /*#__PURE__*/React__default.createElement("option", {
    value: "ID"
  }, "Idaho"), /*#__PURE__*/React__default.createElement("option", {
    value: "IL"
  }, "Illinois"), /*#__PURE__*/React__default.createElement("option", {
    value: "IN"
  }, "Indiana"), /*#__PURE__*/React__default.createElement("option", {
    value: "IA"
  }, "Iowa"), /*#__PURE__*/React__default.createElement("option", {
    value: "KS"
  }, "Kansas"), /*#__PURE__*/React__default.createElement("option", {
    value: "KY"
  }, "Kentucky"), /*#__PURE__*/React__default.createElement("option", {
    value: "LA"
  }, "Louisiana"), /*#__PURE__*/React__default.createElement("option", {
    value: "ME"
  }, "Maine"), /*#__PURE__*/React__default.createElement("option", {
    value: "MD"
  }, "Maryland"), /*#__PURE__*/React__default.createElement("option", {
    value: "MA"
  }, "Massachusetts"), /*#__PURE__*/React__default.createElement("option", {
    value: "MI"
  }, "Michigan"), /*#__PURE__*/React__default.createElement("option", {
    value: "MN"
  }, "Minnesota"), /*#__PURE__*/React__default.createElement("option", {
    value: "MS"
  }, "Mississippi"), /*#__PURE__*/React__default.createElement("option", {
    value: "MO"
  }, "Missouri"), /*#__PURE__*/React__default.createElement("option", {
    value: "MT"
  }, "Montana"), /*#__PURE__*/React__default.createElement("option", {
    value: "NE"
  }, "Nebraska"), /*#__PURE__*/React__default.createElement("option", {
    value: "NV"
  }, "Nevada"), /*#__PURE__*/React__default.createElement("option", {
    value: "NH"
  }, "New Hampshire"), /*#__PURE__*/React__default.createElement("option", {
    value: "NJ"
  }, "New Jersey"), /*#__PURE__*/React__default.createElement("option", {
    value: "NM"
  }, "New Mexico"), /*#__PURE__*/React__default.createElement("option", {
    value: "NY"
  }, "New York"), /*#__PURE__*/React__default.createElement("option", {
    value: "NC"
  }, "North Carolina"), /*#__PURE__*/React__default.createElement("option", {
    value: "ND"
  }, "North Dakota"), /*#__PURE__*/React__default.createElement("option", {
    value: "OH"
  }, "Ohio"), /*#__PURE__*/React__default.createElement("option", {
    value: "OK"
  }, "Oklahoma"), /*#__PURE__*/React__default.createElement("option", {
    value: "OR"
  }, "Oregon"), /*#__PURE__*/React__default.createElement("option", {
    value: "PA"
  }, "Pennsylvania"), /*#__PURE__*/React__default.createElement("option", {
    value: "RI"
  }, "Rhode Island"), /*#__PURE__*/React__default.createElement("option", {
    value: "SC"
  }, "South Carolina"), /*#__PURE__*/React__default.createElement("option", {
    value: "SD"
  }, "South Dakota"), /*#__PURE__*/React__default.createElement("option", {
    value: "TN"
  }, "Tennessee"), /*#__PURE__*/React__default.createElement("option", {
    value: "TX"
  }, "Texas"), /*#__PURE__*/React__default.createElement("option", {
    value: "UT"
  }, "Utah"), /*#__PURE__*/React__default.createElement("option", {
    value: "VT"
  }, "Vermont"), /*#__PURE__*/React__default.createElement("option", {
    value: "VA"
  }, "Virginia"), /*#__PURE__*/React__default.createElement("option", {
    value: "WA"
  }, "Washington"), /*#__PURE__*/React__default.createElement("option", {
    value: "WV"
  }, "West Virginia"), /*#__PURE__*/React__default.createElement("option", {
    value: "WI"
  }, "Wisconsin"), /*#__PURE__*/React__default.createElement("option", {
    value: "WY"
  }, "Wyoming"));
};

var _templateObject$S, _templateObject2$F, _templateObject3$x, _templateObject4$w, _templateObject5$r, _templateObject6$o, _templateObject7$k, _templateObject8$i, _templateObject9$g, _templateObject0$e, _templateObject1$e, _templateObject10$9;
var validCityRegex = RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/);
var ContentWrapper$a = styled.div(_templateObject$S || (_templateObject$S = _taggedTemplateLiteralLoose(["\nborder: 1px solid hsl(180deg 3% 85%);\nmargin: 0px -15px -5px -15px\n"])));
var ContentWrapperMobile = styled.div(_templateObject2$F || (_templateObject2$F = _taggedTemplateLiteralLoose(["\n  margin-right: auto;\n  position: relative;\n  margin-bottom: 2rem;\n"])));
var TitleTextWrapper$4 = styled.div(_templateObject3$x || (_templateObject3$x = _taggedTemplateLiteralLoose(["\n  padding-top: 5rem;\n"])));
var TitleTextWrapperMobile = styled.div(_templateObject4$w || (_templateObject4$w = _taggedTemplateLiteralLoose(["\nmargin: 0px auto;\nwidth: 90%;\n"])));
var TitleContainer$4 = styled.div(_templateObject5$r || (_templateObject5$r = _taggedTemplateLiteralLoose(["\n  margin-right: 6rem;\n  @media screen and (max-width: 600px) {\n    margin-right: 1rem;\n  }\n"])));
var ChoicesWrapper = styled.div(_templateObject6$o || (_templateObject6$o = _taggedTemplateLiteralLoose([" \n  padding: 2rem 0rem 2rem 0rem;\n"])));
var ButtonWrapper$a = styled.div(_templateObject7$k || (_templateObject7$k = _taggedTemplateLiteralLoose(["\n  justify-content: left;\n"])));
var ButtonWrapperMobile$5 = styled.div(_templateObject8$i || (_templateObject8$i = _taggedTemplateLiteralLoose(["\n  margin: 0px auto;\n"])));
var SpacerDiv$2 = styled.div(_templateObject9$g || (_templateObject9$g = _taggedTemplateLiteralLoose(["\n  height: ", ";\n  width: ", ";\n"])), function (props) {
  return props.height || "20px";
}, function (props) {
  return props.width || "100%";
});
var AddressDiv = styled.div(_templateObject0$e || (_templateObject0$e = _taggedTemplateLiteralLoose(["\n  padding: 0rem 0rem 0.5rem 0rem;\n  color: ", ";\n"])), verizonTheme.red);
var InputFieldWrapper$1 = styled.div(_templateObject1$e || (_templateObject1$e = _taggedTemplateLiteralLoose(["\n  padding: 1rem 0rem 0.5rem 0rem;\n"])));
var SelectWrapper$1 = styled.div(_templateObject10$9 || (_templateObject10$9 = _taggedTemplateLiteralLoose(["\n  float: left;\n  padding-right: 10px;\n"])));
var inputData = {
  allCalls: true,
  specificNumber: "",
  allLocations: true,
  address: ""
};
var addressData = {
  address: "",
  city: "",
  state: "",
  zipcode: "",
  fullAddress: ""
};
var buildRadioBtns = function buildRadioBtns(value, text, groupName) {
  var radioBtn = {
    ariaLabel: text,
    children: text,
    name: groupName,
    value: value,
    "data-analyticstrack": "trbl-issue-radio",
    "data-track": "{\"type\": \"link\", \"name\": \"" + text + "\"}",
    "data-clickstream": "{" + text + "-trbl-issue-radio}"
  };
  return radioBtn;
};
var QuestionsPage = function QuestionsPage(props) {
  var _props$values = props.values,
    values = _props$values === void 0 ? {} : _props$values,
    _props$functions = props.functions,
    functions = _props$functions === void 0 ? {} : _props$functions;
  var _values$troubleShooti = values.troubleShootingInfo,
    questionsInfo = _values$troubleShooti === void 0 ? {} : _values$troubleShooti;
  var _questionsInfo$contex = questionsInfo.context,
    context = _questionsInfo$contex === void 0 ? {} : _questionsInfo$contex;
  var _context$lineInfo = context.lineInfo,
    lineInfo = _context$lineInfo === void 0 ? {} : _context$lineInfo;
  var _ref = lineInfo[0] || {},
    mtn = _ref.mtn,
    allCalls = _ref.allCalls,
    specificNumber = _ref.specificNumber,
    allLocations = _ref.allLocations,
    address = _ref.address;
  var output = getObjectPropertyByPath("ddata.output", questionsInfo, {});
  var _output$pageContent = output.pageContent,
    pageContent = _output$pageContent === void 0 ? {} : _output$pageContent,
    currentPageId = output.currentPageId,
    prevStepEnabled = output.prevStepEnabled,
    nextStepEnabled = output.nextStepEnabled;
  var _pageContent$steps = pageContent.steps,
    steps = _pageContent$steps === void 0 ? [] : _pageContent$steps;
  var step = steps[0] || {};
  var _step$questions = step.questions,
    questions = _step$questions === void 0 ? [] : _step$questions,
    _step$cta = step.cta,
    buttons = _step$cta === void 0 ? [] : _step$cta;
  var _values$questionRecor = values.questionRecordIds,
    questionRecordIds = _values$questionRecor === void 0 ? [] : _values$questionRecor,
    _values$questionsPara = values.questionsParams,
    questionsParams = _values$questionsPara === void 0 ? {} : _values$questionsPara;
  var disabledFlag = false;
  var _useState = useState({
      numberErrFlag: false,
      numberErrTxt: "",
      hasNumberError: false
    }),
    validateRadiogroup1 = _useState[0],
    setValidateRadiogroup1 = _useState[1];
  var numberErrFlag = validateRadiogroup1.numberErrFlag,
    numberErrTxt = validateRadiogroup1.numberErrTxt,
    hasNumberError = validateRadiogroup1.hasNumberError;
  var _useState2 = useState({
      addressErrFlag: false,
      cityErrFlag: false,
      stateErrFlag: false,
      zipcodeErrFlag: false,
      addressErrTxt: "",
      cityErrTxt: "",
      stateErrTxt: "",
      zipcodeErrTxt: "",
      hasAddressError: false
    }),
    validateRadiogroup2 = _useState2[0],
    setValidateRadiogroup2 = _useState2[1];
  var addressErrFlag = validateRadiogroup2.addressErrFlag,
    cityErrFlag = validateRadiogroup2.cityErrFlag,
    stateErrFlag = validateRadiogroup2.stateErrFlag,
    zipcodeErrFlag = validateRadiogroup2.zipcodeErrFlag,
    addressErrTxt = validateRadiogroup2.addressErrTxt,
    cityErrTxt = validateRadiogroup2.cityErrTxt,
    stateErrTxt = validateRadiogroup2.stateErrTxt,
    zipcodeErrTxt = validateRadiogroup2.zipcodeErrTxt,
    hasAddressError = validateRadiogroup2.hasAddressError;
  var _useState3 = useState(true),
    validateFullAddress = _useState3[0],
    setValidateFullAddress = _useState3[1];
  var splitAddress = function splitAddress() {
    if (address) {
      var str = address;
      var addressSeperated = str.toString().split(",");
      return addressSeperated;
    }
  };
  var addressCheck = {};
  var getAddressValidation = function getAddressValidation(inputLabel) {
    try {
      var params = {
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        zipCode: ""
      };
      var _temp = function () {
        if (addressData.address && addressData.city && addressData.state && addressData.zipcode && addressData.zipcode.length === 5 && inputLabel === "Address") {
          params.addressLine1 = addressData.address;
          params.addressLine2 = "";
          params.city = addressData.city;
          params.state = addressData.state;
          params.zipCode = addressData.zipcode;
          return Promise.resolve(addressValidation(params)).then(function (_addressValidation) {
            addressCheck = _addressValidation;
            var _addressCheck = addressCheck,
              validAddress = _addressCheck.validAddress;
            if (typeof validAddress !== "undefined") {
              setValidateFullAddress(validAddress);
            }
          });
        }
      }();
      return Promise.resolve(_temp && _temp.then ? _temp.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var getAddressDetails = function getAddressDetails() {
    if (addressData.address && addressData.city && addressData.state && addressData.zipcode) {
      inputData.address = addressData.address + ", " + addressData.city + ", " + addressData.state + ", " + addressData.zipcode;
    }
    return inputData.address;
  };
  var validateNumber = function validateNumber(value, questionsParams) {
    var numberFlag = false;
    var numberTxt = "";
    numberTxt = isValidPhoneNumber(value, true, true);
    if (getPhoneDigits(value) === mtn) {
      numberTxt = "Please enter a phone number other than your own";
    }
    numberFlag = numberTxt ? true : false;
    setValidateRadiogroup1(_extends({}, validateRadiogroup1, {
      numberErrFlag: numberFlag,
      numberErrTxt: numberTxt,
      hasNumberError: false
    }));
    inputData.specificNumber = value;
    inputData.allCalls = false;
    questionsParams.allCalls = inputData.allCalls;
    questionsParams.specificNumber = getPhoneDigits(inputData.specificNumber);
  };
  var validateAddress = function validateAddress(value, questionsParams) {
    var addressFlag = false;
    var addressTxt = "";
    addressTxt = isValidAddress(value) ? "" : "Invalid Address";
    if (value.length === 0) {
      addressTxt = "Address is required";
    }
    addressFlag = addressTxt ? true : false;
    setValidateRadiogroup2(_extends({}, validateRadiogroup2, {
      addressErrFlag: addressFlag,
      addressErrTxt: addressTxt
    }));
    addressData.address = value;
    inputData.allLocations = false;
    questionsParams.allLocations = inputData.allLocations;
    questionsParams.Address = addressData.address;
  };
  var validateCity = function validateCity(value, questionsParams) {
    var cityFlag = false;
    var cityTxt = "";
    cityTxt = validCityRegex.test(value) ? "" : "Invalid City";
    if (value.length === 0) {
      cityTxt = "City is required";
    }
    cityFlag = cityTxt ? true : false;
    setValidateRadiogroup2(_extends({}, validateRadiogroup2, {
      cityErrFlag: cityFlag,
      cityErrTxt: cityTxt
    }));
    addressData.city = value;
    questionsParams.City = addressData.city;
  };
  var validateState = function validateState(value, questionsParams) {
    var stateFlag = false;
    var stateTxt = "";
    stateTxt = "";
    if (value.length > 2) {
      stateTxt = "Please Select State";
    }
    stateFlag = stateTxt ? true : false;
    setValidateRadiogroup2(_extends({}, validateRadiogroup2, {
      stateErrFlag: stateFlag,
      stateErrTxt: stateTxt
    }));
    addressData.state = value;
    questionsParams.State = addressData.state;
  };
  var validateZipcode = function validateZipcode(value, questionsParams) {
    var zipcodeFlag = false;
    var zipcodeTxt = "";
    zipcodeTxt = isValidZipCode(value) ? "" : "Invalid Zipcode";
    if (value.length === 0) {
      zipcodeTxt = "Zipcode is required";
    }
    zipcodeFlag = zipcodeTxt ? true : false;
    setValidateRadiogroup2(_extends({}, validateRadiogroup2, {
      zipcodeErrFlag: zipcodeFlag,
      zipcodeErrTxt: zipcodeTxt,
      hasAddressError: false
    }));
    addressData.zipcode = value;
    questionsParams.Zipcode = addressData.zipcode;
  };
  var buildInputData = function buildInputData(input, value) {
    var handleChange = function handleChange(event) {
      event.preventDefault();
      var _event$target = event.target,
        name = _event$target.name,
        value = _event$target.value;
      switch (name) {
        case "Number":
          validateNumber(value, questionsParams);
          break;
        case "Address":
          validateAddress(value, questionsParams);
          break;
        case "City":
          validateCity(value, questionsParams);
          break;
        case "State":
          validateState(value, questionsParams);
          break;
        case "Zipcode":
          validateZipcode(value, questionsParams);
          break;
      }
      questionsParams.allCalls = inputData.allCalls;
      questionsParams.allLocations = inputData.allLocations;
      questionsParams.address = getAddressDetails();
      functions.handleQuestionsPageInputs(questionsParams);
      getAddressValidation(input.label);
    };
    var inputLabel = input.label;
    var inputType = input.type;
    var choiceValue = false;
    var questionRecords = [];
    questionRecords = questionRecordIds;
    if (questionRecords.includes(value)) {
      choiceValue = true;
    }
    var renderInputs = function renderInputs() {
      var replayAddress = splitAddress();
      var addressStreet;
      var addressCity;
      var addressState;
      var addressZipcode;
      var inputNumber;
      if (replayAddress) {
        if (questionsParams.Address == replayAddress[0]) {
          addressStreet = replayAddress[0];
          addressCity = replayAddress[1];
          addressState = replayAddress[2].replace(/\s/g, '');
          addressZipcode = replayAddress[3];
        }
      }
      if (specificNumber && questionsParams.specificNumber === undefined) {
        inputNumber = specificNumber;
      }
      return /*#__PURE__*/React__default.createElement(Fragment, null, choiceValue && inputLabel === "Number" && /*#__PURE__*/React__default.createElement(InputFieldWrapper$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
        error: numberErrFlag,
        errorText: numberErrTxt,
        "data-analyticstrack": "SpecificNumber",
        "data-track": "{\"type\": \"link\", \"name\": \"Specific Number\"}",
        value: inputNumber ? inputNumber : questionsParams.specificNumber,
        label: inputLabel,
        maxLength: 20,
        name: inputLabel,
        onChange: function onChange(event) {
          return handleChange(event);
        },
        required: true,
        type: inputType,
        width: isMobile() ? 300 : 400
      })), choiceValue && inputLabel === "Address" && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(InputFieldWrapper$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
        error: addressErrFlag,
        errorText: addressErrTxt,
        "data-analyticstrack": "Address",
        "data-track": "{\"type\": \"link\", \"name\": \"Address\"}",
        value: addressStreet,
        label: inputLabel,
        maxLength: 25,
        name: inputLabel,
        onChange: function onChange(event) {
          return handleChange(event);
        },
        required: true,
        type: inputType,
        width: isMobile() ? 300 : 400
      })), /*#__PURE__*/React__default.createElement(InputFieldWrapper$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
        error: cityErrFlag,
        errorText: cityErrTxt,
        "data-analyticstrack": "City",
        "data-track": "{\"type\": \"link\", \"name\": \"City\"}",
        value: addressCity,
        label: "City",
        maxLength: 15,
        name: "City",
        onChange: function onChange(event) {
          return handleChange(event);
        },
        required: true,
        type: inputType,
        width: isMobile() ? 300 : 400
      })), /*#__PURE__*/React__default.createElement(SelectWrapper$1, null, /*#__PURE__*/React__default.createElement(InputFieldWrapper$1, null, /*#__PURE__*/React__default.createElement(DropdownSelect, {
        error: stateErrFlag,
        errorText: stateErrTxt,
        "data-analyticstrack": "SelectState-Dropdown",
        "data-track": "{\"type\": \"link\", \"name\": \"Select State\"}",
        value: addressState,
        label: "State",
        name: "State",
        onChange: function onChange(event) {
          return handleChange(event);
        },
        required: true,
        width: isMobile() ? "150px" : "200px"
      }, /*#__PURE__*/React__default.createElement(SelectStates, null)))), /*#__PURE__*/React__default.createElement(InputFieldWrapper$1, null, /*#__PURE__*/React__default.createElement(Input$1, {
        error: zipcodeErrFlag,
        errorText: zipcodeErrTxt,
        "data-analyticstrack": "Zipcode",
        "data-track": "{\"type\": \"link\", \"name\": \"Zipcode\"}",
        value: addressZipcode,
        label: "Zipcode",
        maxLength: 5,
        name: "Zipcode",
        onChange: function onChange(event) {
          return handleChange(event);
        },
        required: true,
        type: inputType,
        width: isMobile() ? 140 : 190
      }))));
    };
    return /*#__PURE__*/React__default.createElement(Fragment, null, renderInputs());
  };
  var renderChoices = function renderChoices(choices) {
    var radioOptions = [];
    var inputData;
    var defaultRadio = "";
    choices.forEach(function (question) {
      var value = question.value;
      var text = question.text;
      if (question.input) {
        var input = question.input;
        inputData = buildInputData(input, value);
      }
      var options = buildRadioBtns(value, text, "options");
      radioOptions.push(options);
      if (question.value === "all" && allCalls) {
        defaultRadio = "all";
      }
      if (question.value === "everywhere" && allLocations) {
        defaultRadio = "everywhere";
      }
      if (question.value === "specific_num" && specificNumber) {
        defaultRadio = "specific_num";
      }
      if (question.value === "specific_loc" && address) {
        defaultRadio = "specific_loc";
      }
    });
    var handleOptionSelect = function handleOptionSelect(element) {
      var optionValue = element.target.value;
      var toggleRadio = optionValue;
      var disableInput = "";
      choices.forEach(function (question) {
        var radioValue = question.value;
        if (toggleRadio !== radioValue) {
          disableInput = radioValue;
        }
      });
      if (functions.handleQuestionsLabel) {
        functions.handleQuestionsLabel(toggleRadio, disableInput);
      }
      if (optionValue === "all") {
        setValidateRadiogroup1(_extends({}, validateRadiogroup1, {
          numberErrFlag: false
        }));
        if (allCalls) {
          questionsParams.allCalls = true;
          questionsParams.specificNumber = "";
        }
        if (functions.handleQuestionsPageInputs) {
          functions.handleQuestionsPageInputs(questionsParams);
        }
      }
      if (optionValue === "everywhere") {
        setValidateRadiogroup2(_extends({}, validateRadiogroup2, {
          addressErrFlag: false,
          cityErrFlag: false,
          stateErrFlag: false,
          zipcodeErrFlag: false
        }));
        setValidateFullAddress(true);
        if (allLocations) {
          questionsParams.allLocations = true;
          questionsParams.address = "";
        }
        if (functions.handleQuestionsPageInputs) {
          functions.handleQuestionsPageInputs(questionsParams);
        }
      }
      if (optionValue === "specific_num" && !numberErrFlag) {
        setValidateRadiogroup1(_extends({}, validateRadiogroup1, {
          hasNumberError: true
        }));
        if (!addressErrFlag && !cityErrFlag && !stateErrFlag && !zipcodeErrFlag) {
          setValidateFullAddress(true);
        }
      }
      if (optionValue === "specific_loc" && !addressErrFlag && !cityErrFlag && !stateErrFlag && !zipcodeErrFlag) {
        setValidateRadiogroup2(_extends({}, validateRadiogroup2, {
          hasAddressError: true
        }));
      }
      if (optionValue === "all" && !numberErrFlag && !addressErrFlag && !cityErrFlag && !stateErrFlag && !zipcodeErrFlag || optionValue === "everywhere" && !numberErrFlag && !addressErrFlag && !cityErrFlag && !stateErrFlag && !zipcodeErrFlag) {
        var emptyCheck_num = questionRecordIds.includes("specific_num");
        var emptyCheck_loc = questionRecordIds.includes("specific_loc");
        if (!emptyCheck_num) {
          setValidateRadiogroup1(_extends({}, validateRadiogroup1, {
            hasNumberError: false
          }));
        }
        if (!emptyCheck_loc) {
          setValidateRadiogroup2(_extends({}, validateRadiogroup2, {
            hasAddressError: false
          }));
        }
      }
    };
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(RadioButtonGroup, {
      defaultValue: defaultRadio,
      onChange: handleOptionSelect,
      data: radioOptions
    }), inputData);
  };
  var renderQuestion = function renderQuestion(question) {
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TitleContainer$4, null, /*#__PURE__*/React__default.createElement(Title, {
      size: "medium"
    }, question.question)), /*#__PURE__*/React__default.createElement(ChoicesWrapper, null, renderChoices(question.choices)));
  };
  var renderQuestions = function renderQuestions() {
    return /*#__PURE__*/React__default.createElement(Fragment, null, questions.map(function (question, i) {
      return /*#__PURE__*/React__default.createElement(Fragment, {
        key: i
      }, renderQuestion(question));
    }));
  };
  var handleAction = function handleAction(button) {
    if (functions.handleTroubleShootingAction) {
      functions.handleTroubleShootingAction(button);
    }
  };
  var handleChecklistChange = function handleChecklistChange(value) {
    console.log("QuestionPage handleChecklistChange::", value);
    if (functions.handleReplayNavigation) {
      functions.handleReplayNavigation(value);
    }
  };
  if (questionRecordIds.length > 1 && !numberErrFlag && !addressErrFlag && !cityErrFlag && !stateErrFlag && !zipcodeErrFlag && !hasNumberError && !hasAddressError && validateFullAddress) {
    disabledFlag = true;
  }
  var renderDesktop = function renderDesktop() {
    var disabledBtnPrev = false;
    var disabledBtnNext = false;
    if (!prevStepEnabled) {
      disabledBtnPrev = true;
    }
    if (!nextStepEnabled) {
      disabledBtnNext = true;
    }
    return /*#__PURE__*/React__default.createElement(ContentWrapper$a, null, /*#__PURE__*/React__default.createElement("form", null, /*#__PURE__*/React__default.createElement(TitleTextWrapper$4, null, renderQuestions(), !validateFullAddress && /*#__PURE__*/React__default.createElement(AddressDiv, null, "Sorry, we were unable to verify this address. Please change it and try again."), /*#__PURE__*/React__default.createElement(SpacerDiv$2, {
      height: "20px"
    })), /*#__PURE__*/React__default.createElement(ButtonWrapper$a, null, /*#__PURE__*/React__default.createElement(ActionButtons, {
      buttons: buttons,
      handleAction: handleAction,
      disabled: !disabledFlag,
      disableNext: disabledBtnNext,
      disablePrevious: disabledBtnPrev,
      showPrevious: true,
      showNext: true,
      disableMargin: true,
      pageId: currentPageId,
      handlePrevious: function handlePrevious(value) {
        return handleChecklistChange(value);
      },
      handleNext: function handleNext(value) {
        return handleChecklistChange(value);
      }
    }))));
  };
  var renderMobile = function renderMobile() {
    var disabledBtnPrev = false;
    var disabledBtnNext = false;
    if (!prevStepEnabled) {
      disabledBtnPrev = true;
    }
    if (!nextStepEnabled) {
      disabledBtnNext = true;
    }
    return /*#__PURE__*/React__default.createElement(ContentWrapperMobile, null, /*#__PURE__*/React__default.createElement("form", null, /*#__PURE__*/React__default.createElement(TitleTextWrapperMobile, null, renderQuestions(), !validateFullAddress && /*#__PURE__*/React__default.createElement(AddressDiv, null, "Sorry, we were unable to verify this address. Please change it and try again."), /*#__PURE__*/React__default.createElement(SpacerDiv$2, {
      height: "20px"
    })), /*#__PURE__*/React__default.createElement(ButtonWrapperMobile$5, null, /*#__PURE__*/React__default.createElement(ActionButtons, {
      buttons: buttons,
      handleAction: handleAction,
      disabled: !disabledFlag,
      size: "280px"
    })), /*#__PURE__*/React__default.createElement(SpacerDiv$2, {
      height: "40px"
    }), /*#__PURE__*/React__default.createElement(ButtonWrapperMobile$5, null, /*#__PURE__*/React__default.createElement(ActionButtons, {
      showPrevious: true,
      showNext: true,
      pageId: currentPageId,
      disableNext: disabledBtnNext,
      disablePrevious: disabledBtnPrev,
      handlePrevious: function handlePrevious(value) {
        return handleChecklistChange(value);
      },
      handleNext: function handleNext(value) {
        return handleChecklistChange(value);
      }
    }))));
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, !isMobile() && renderDesktop(), isMobile() && renderMobile());
};
QuestionsPage.propTypes = {
  functions: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
};
QuestionsPage.defaultProps = {};

var _templateObject$T, _templateObject2$G, _templateObject3$y, _templateObject4$x, _templateObject5$s;
var ContentWrapper$b = styled.div(_templateObject$T || (_templateObject$T = _taggedTemplateLiteralLoose(["\nborder: 1px solid hsl(180deg 3% 85%);\nmargin: 0px -15px -5px -15px\n"])));
var TitleWrapper$6 = styled.div(_templateObject2$G || (_templateObject2$G = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  padding-top: 15px;\n  width: 100%;\n\n  div:last-child {\n    margin-left: auto;\n  }\n"])));
var TitleTextWrapper$5 = styled.div(_templateObject3$y || (_templateObject3$y = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  width: 95%;\n"])));
var MessageWrapper$1 = styled.div(_templateObject4$x || (_templateObject4$x = _taggedTemplateLiteralLoose(["\n  margin-left: auto;\n  margin-right: auto;\n  width: 795px;\n  @media (max-width: 600px) {\n    width: auto;\n  }\n"])));
var Cancel$4 = styled.div(_templateObject5$s || (_templateObject5$s = _taggedTemplateLiteralLoose(["\n  margin-right: 10px;\n"])));
var NetworkOutagePage = function NetworkOutagePage(props) {
  var _props$values = props.values,
    values = _props$values === void 0 ? {} : _props$values,
    _props$functions = props.functions,
    functions = _props$functions === void 0 ? {} : _props$functions;
  var _values$landingInfo = values.landingInfo,
    landingInfo = _values$landingInfo === void 0 ? {} : _values$landingInfo,
    _values$outageInfo = values.outageInfo,
    outageInfo = _values$outageInfo === void 0 ? {} : _values$outageInfo,
    _values$troubleShooti = values.troubleShootingInfo,
    troubleShootingInfo = _values$troubleShooti === void 0 ? {} : _values$troubleShooti,
    _values$symptom = values.symptom,
    symptom = _values$symptom === void 0 ? {} : _values$symptom;
  var outagePageInfo = getObjectPropertyByPath("ddata.output.pageContent", troubleShootingInfo, {});
  var _outageInfo$data = outageInfo.data,
    data = _outageInfo$data === void 0 ? {} : _outageInfo$data;
  var _outagePageInfo$steps = outagePageInfo.steps,
    steps = _outagePageInfo$steps === void 0 ? [] : _outagePageInfo$steps;
  var issue = steps[0] || {};
  var _issue$cta = issue.cta,
    buttons = _issue$cta === void 0 ? [] : _issue$cta;
  var _landingInfo$device = landingInfo.device,
    device = _landingInfo$device === void 0 ? {} : _landingInfo$device;
  var handleCancel = function handleCancel() {
    if (functions.handleCancel) {
      functions.handleCancel();
    }
  };
  var handleAction = function handleAction(button) {
    if (functions.handleTroubleShootingAction) {
      functions.handleTroubleShootingAction(button);
    }
  };
  var statusCode = data.statusCode;
  return /*#__PURE__*/React__default.createElement(ContentWrapper$b, {
    "data-testid": "Network-Outage-Page"
  }, /*#__PURE__*/React__default.createElement(TitleWrapper$6, null, /*#__PURE__*/React__default.createElement(TitleTextWrapper$5, null, /*#__PURE__*/React__default.createElement(Title, {
    size: "small"
  }, symptom.issueName, " - ", device.deviceName)), /*#__PURE__*/React__default.createElement(Cancel$4, {
    "data-analyticstrack": "cancel-Icon",
    "data-track": "{\"type\": \"link\", \"name\": \"cancel-Icon\"}",
    "data-clickstream": "cancel-Icon",
    onClick: handleCancel
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "close",
    size: "large"
  }))), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "2rem"
  }), (statusCode === "10" || statusCode === "20") && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Outage, {
    outageInfo: outageInfo
  }), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "1rem"
  })), /*#__PURE__*/React__default.createElement(MessageWrapper$1, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "large"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, issue.heading)), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: isMobile() ? "2rem" : "5rem"
  })), /*#__PURE__*/React__default.createElement(ActionButtons, {
    buttons: buttons,
    handleAction: handleAction,
    size: isMobile() ? "300px" : undefined
  }));
};
NetworkOutagePage.propTypes = {
  functions: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
};
NetworkOutagePage.defaultProps = {};

var _templateObject$U, _templateObject2$H, _templateObject3$z, _templateObject4$y, _templateObject5$t, _templateObject6$p, _templateObject7$l, _templateObject8$j;
var DisplayList$1 = styled.div(_templateObject$U || (_templateObject$U = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  @media(min-width: 601px) {\n    padding: 20px 5px 15px 0px;\n  }\n  @media(max-width: 600px) {\n    padding: 15px 0px 15px 0px;\n  }\n"])));
var EachBlock$1 = styled.div(_templateObject2$H || (_templateObject2$H = _taggedTemplateLiteralLoose(["\n  // position: relative;\n  height: 250px;\n  padding: 10px;\n  border: 1px solid lightgray;\n  display: flex;\n  flex-direction: column;\n  .device-info {\n    display: flex;\n    height: inherit;\n    flex-direction: column;\n  }\n  @media(min-width: 601px) {\n    width: 32%;\n  }\n  @media(max-width: 600px) {\n    width: 69%;\n    height: auto;\n    padding: 5px;\n    // margin: 0 auto;\n  }\n"])));
var Content$2 = styled.div(_templateObject3$z || (_templateObject3$z = _taggedTemplateLiteralLoose(["\n  padding: 6px 10px 10px 10px;\n"])));
var Content1 = styled.div(_templateObject4$y || (_templateObject4$y = _taggedTemplateLiteralLoose(["\n  order: 1;\n  padding 6px 10px 10px 10px;\n"])));
var Content2 = styled.div(_templateObject5$t || (_templateObject5$t = _taggedTemplateLiteralLoose(["\n  order: 2;\n  padding: 6px 10px 10px 10px;\n"])));
var Content3 = styled.div(_templateObject6$p || (_templateObject6$p = _taggedTemplateLiteralLoose(["\n  order: 3;\n  padding: 6px 10px 10px 10px;\n"])));
var Content4 = styled.div(_templateObject7$l || (_templateObject7$l = _taggedTemplateLiteralLoose(["\n  order: 4;\n  padding: 6px 10px 10px 10px;\n"])));
var ButtonWrapper$b = styled.div(_templateObject8$j || (_templateObject8$j = _taggedTemplateLiteralLoose(["\n  padding: 6px 10px 10px 10px;\n  margin-top: auto;\n  // position: absolute;\n  // bottom: 0;\n"])));
var SvgWifi$1 = function SvgWifi(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    style: {
      "margin-left": ".5rem"
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M5.2 11.6l.8.8c1.6-1.6 4.3-1.6 5.9 0l.8-.8c-1-1-2.3-1.6-3.7-1.6-1.4.1-2.8.6-3.8 1.6zM2.5 9l.8.8C4.9 8.3 6.8 7.4 9 7.4c2.1 0 4.1.8 5.6 2.3l.8-.7c-1.7-1.7-4-2.7-6.4-2.7-2.5 0-4.7.9-6.5 2.7z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M9 2.6c-3.4 0-6.6 1.3-9 3.7l.8.8C3 5 5.9 3.8 9 3.8s6 1.2 8.2 3.4l.8-.9c-2.4-2.4-5.6-3.7-9-3.7zM7.6 14l1.3 1.3 1.3-1.3c-.7-.7-1.9-.7-2.6 0z"
  }));
};
var SvgNo$1 = function SvgNo(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    style: {
      "margin-left": ".5rem"
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.4 18.5",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React__default.createElement("path", {
    d: "M9.2.2c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm-7.9 9c0-4.3 3.5-7.9 7.9-7.9 2 0 3.8.7 5.1 1.9l-11 11.2c-1.2-1.4-2-3.2-2-5.2zm7.9 7.9c-2 0-3.8-.7-5.1-1.9L15.2 4.1c1.2 1.4 1.9 3.2 1.9 5.1 0 4.4-3.5 7.9-7.9 7.9z"
  }));
};
var DeviceList$1 = function DeviceList(_ref) {
  var listOfDevices = _ref.listOfDevices,
    handleAction = _ref.handleAction,
    buttons = _ref.buttons,
    templateId = _ref.templateId,
    resolutionTemplateId = _ref.resolutionTemplateId;
  var renderExtenderInfo = function renderExtenderInfo(singleDevice) {
    var stroke = "grey";
    if (singleDevice.Active === "true") {
      stroke = "#2B9853";
    }
    var IconSignal = /*#__PURE__*/React__default.createElement(SvgWifi$1, {
      stroke: stroke
    });
    return Object.entries(singleDevice).map(function (info, index) {
      if (info[0] === "MAC Address" || info[0] === "Active" || info[0] === "APSSID" || info[0] === "Host Name") {
        return /*#__PURE__*/React__default.createElement(Fragment, null, info[0] === "Host Name" ? /*#__PURE__*/React__default.createElement(Content1, {
          key: index
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "a-bold"
        }), /*#__PURE__*/React__default.createElement("div", null, info[1], " ", " ", " ", IconSignal)) : null, info[0] === "MAC Address" ? /*#__PURE__*/React__default.createElement(Content2, {
          key: index
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "a-bold"
        }, "Model number"), /*#__PURE__*/React__default.createElement("div", null, info[1])) : null, info[0] === "Active" ? /*#__PURE__*/React__default.createElement(Content3, {
          key: index
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "a-bold"
        }, "Status"), /*#__PURE__*/React__default.createElement("div", null, info[1] === "true" ? "Active" : "In Active")) : null, info[0] === "APSSID" && info[1] != "" ? /*#__PURE__*/React__default.createElement(Content4, {
          key: index
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "a-bold"
        }, "Paired to"), /*#__PURE__*/React__default.createElement("div", null, info[1])) : null);
      }
    });
  };
  var renderDeviceInfo = function renderDeviceInfo(singleDevice) {
    var stroke = "#d73629";
    if (singleDevice.DeviceType === "good") {
      stroke = "#2B9853";
    }
    var IconSignal = /*#__PURE__*/React__default.createElement(SvgWifi$1, {
      stroke: stroke
    });
    if (singleDevice.DeviceType === "InActive") {
      IconSignal = /*#__PURE__*/React__default.createElement(SvgNo$1, null);
    }
    return Object.entries(singleDevice).map(function (info, index) {
      if (info[0] === "MAC Address" || info[0] === "APSSID" || info[0] === "Connected To" || info[0] === "Host Name") {
        return /*#__PURE__*/React__default.createElement(Content$2, {
          key: index
        }, info[0] !== "Host Name" ? /*#__PURE__*/React__default.createElement("div", {
          className: "a-bold"
        }, info[0]) : null, /*#__PURE__*/React__default.createElement("div", null, info[1], " ", info[0] === "Host Name" ? IconSignal : null));
      }
    });
  };
  var getMACAddress = function getMACAddress(singleDevice) {
    var _Object$entries$filte;
    return (_Object$entries$filte = Object.entries(singleDevice).filter(function (info) {
      return info[0] === "MAC Address";
    })[0]) === null || _Object$entries$filte === void 0 ? void 0 : _Object$entries$filte[1];
  };
  var renderTroubleshootButton = function renderTroubleshootButton(singleDevice, button) {
    if (button) {
      return /*#__PURE__*/React__default.createElement(Button$1, {
        "data-analyticstrack": button.label + "-Btn",
        "data-track": "{\"type\": \"link\", \"name\": \"" + button.label + "-Btn\"}",
        "data-clickstream": button.label + "-btn-cta",
        size: "small",
        width: isMobile() ? '100%' : undefined,
        use: "secondary",
        onClick: function onClick() {
          return handleAction(button, getMACAddress(singleDevice));
        },
        "data-testid": "deviceForTroubleshooting"
      }, button.label);
    }
  };
  var renderDeviceList = function renderDeviceList() {
    var button = null;
    if (listOfDevices.length > 0) {
      return listOfDevices.map(function (singleDevice, index) {
        if (resolutionTemplateId && resolutionTemplateId === "SELECT_DEVICE") {
          button = buttons[0];
        }
        if (templateId === "NETWORK_GOOD_GOTO_EXTENDER_TYPE") {
          if (singleDevice.Active == "false") {
            button = buttons[0];
          } else {
            button = {
              label: "Call an agent",
              action: "ContactUs",
              type: "primary",
              url: "",
              callFunction: ""
            };
          }
        }
        return /*#__PURE__*/React__default.createElement(EachBlock$1, {
          key: index
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "device-info"
        }, templateId === "NETWORK_GOOD_GOTO_EXTENDER_TYPE" ? renderExtenderInfo(singleDevice) : renderDeviceInfo(singleDevice)), /*#__PURE__*/React__default.createElement(ButtonWrapper$b, null, renderTroubleshootButton(singleDevice, button)));
      });
    }
  };
  return /*#__PURE__*/React__default.createElement(DisplayList$1, {
    "data-testid": "device-list"
  }, renderDeviceList());
};
DeviceList$1.propTypes = {};
DeviceList$1.defaultProps = {};

var _templateObject$V, _templateObject2$I, _templateObject3$A, _templateObject4$z, _templateObject5$u, _templateObject6$q, _templateObject7$m, _templateObject8$k, _templateObject9$h, _templateObject0$f, _templateObject1$f, _templateObject10$a, _templateObject11$7, _templateObject12$6, _templateObject13$6, _templateObject14$5, _templateObject15$5;
var ContentWrapper$c = styled.div(_templateObject$V || (_templateObject$V = _taggedTemplateLiteralLoose(["\nborder: 1px solid hsl(180deg 3% 85%);\nmargin: 0px -15px -5px -15px\n"])));
var CustomTitle = styled.div(_templateObject2$I || (_templateObject2$I = _taggedTemplateLiteralLoose(["\n    font-size: 1.2rem;\n    line-height: 1.5rem;\n    font-family: Verizon-NHG-eDS;\n    color: #000000;\n    margin: 0;\n    text-decoration: none;\n"])));
var TitleWrapper$7 = styled.div(_templateObject3$A || (_templateObject3$A = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  padding-top: 15px;\n  width: 100%;\n\n  div:last-child {\n    margin-left: auto;\n    margin-right: 10px;\n  }\n  @media(max-width:601px){\n    margin:auto;\n    width: 94%;    \n  }\n\n"])));
var TitleTextWrapper$6 = styled.div(_templateObject4$z || (_templateObject4$z = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  width: 95%;\n"])));
var HeadingWrapper$4 = styled.div(_templateObject5$u || (_templateObject5$u = _taggedTemplateLiteralLoose(["\n  a {\n    color: black;\n    cursor: pointer;\n  }\n  @media(max-width: 768px) {\n    font-size:1.0rem;\n  }\n"])));
var Cancel$5 = styled.div(_templateObject6$q || (_templateObject6$q = _taggedTemplateLiteralLoose(["\n  min-height: 1rem;\n  min-width: 1rem;\n  @media(min-width: 601px) {\n    margin-right: 10px;\n  }\n  @media(max-width: 600px){\n    margin-left: 5px;\n  }\n"])));
var StepInfoContainer$6 = styled.div(_templateObject7$m || (_templateObject7$m = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  @media(min-width: 601px) {\n    padding: 10px 50px 15px 50px;\n  }\n  @media(max-width: 600px){\n    padding: 5px 15px 5px 15px;\n  }\n"])));
var SelectionBox$1 = styled.div(_templateObject8$k || (_templateObject8$k = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  padding: 12px 0 0 0;\n  border-bottom: 1px solid gray;\n  float: left;\n  .selectedTab {\n    border-bottom: 4px solid #d52b1e;\n  }\n"])));
var SelectedItem$1 = styled.div(_templateObject9$h || (_templateObject9$h = _taggedTemplateLiteralLoose(["\n  // padding-right: 20px;\n  z-index: 1;\n  padding-bottom: 12px;\n  cursor: pointer;\n  margin-right: 20px;\n  font-weight: bold;\n  color: gray;\n  &:last-of-type{\n    margin-right: 0;\n  }\n  @media(min-width: 601px) {\n    font-size: 15px;\n  }\n  @media(max-width: 600px) {\n    font-size: 13px;\n  }\n"])));
var ButtonWrapper$c = styled.div(_templateObject0$f || (_templateObject0$f = _taggedTemplateLiteralLoose(["\n  padding-bottom: 25px;\n  @media screen and (max-width: 600px) {\n    display:none\n  }\n"])));
var ButtonWrapperMobile$6 = styled.div(_templateObject1$f || (_templateObject1$f = _taggedTemplateLiteralLoose(["\n  width: 50%;\n  margin:0px auto;\n  @media screen and (min-width: 600px) {\n    display:none\n  }\n"])));
var SearchContainer$2 = styled.div(_templateObject10$a || (_templateObject10$a = _taggedTemplateLiteralLoose(["\n  margin-top: 15px;\n  margin-bottom: 10px;\n  width:  100%;\n"])));
var SearchWrapper$3 = styled.div(_templateObject11$7 || (_templateObject11$7 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  @media(min-width:601px) {\n    float: right;\n  }\n"])));
var SearchBox$3 = styled.input(_templateObject12$6 || (_templateObject12$6 = _taggedTemplateLiteralLoose(["\n  z-index: -1;\n  border: none;\n  -webkit-border-radius: 2rem;\n  -moz-border-radius: 2rem;\n  border-radius: 2rem;\n  font-size: 1rem;\n  height: 5px;\n  padding: 1rem;\n  background-color: #E0E3E7;\n  font-weight: bolder;\n  ::placeholder {\n    font-weight: 30px;\n    margin-left: 20px;\n  }\n  :focus {\n    border: none;\n    outline: none;\n  }\n  @media(min-width:601px) {\n    width: 85%;\n  }\n  @media(max-width:601px) {\n    width: 80%;    \n  }\n"])));
var SearchButtonsWrapper$1 = styled.div(_templateObject13$6 || (_templateObject13$6 = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  width: -6em;\n  margin-top: -1em;\n  position: absolute;\n  top: 65%;\n  right: 2rem;\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n  background-repeat: no-repeat;\n  background-size: 10;0%;\n  @media(max-width:601px) {\n    right: 3rem;\n  }\n"])));
var SearchButton$1 = styled.button(_templateObject14$5 || (_templateObject14$5 = _taggedTemplateLiteralLoose(["\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n  @media(max-width:601px) {\n    position: absolute;\n    right: 0px;\n  }\n"])));
var NoDeviceMessage$1 = styled.div(_templateObject15$5 || (_templateObject15$5 = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  ul {\n    margin: 10px 0 0 0;\n    padding-left: 15px;\n  }\n"])));
var tabsData$1 = [{
  selection: "Poor wifi Connection",
  DeviceType: "poor",
  count: 0
}, {
  selection: "Connected",
  DeviceType: "good",
  count: 0
}, {
  selection: "In-active",
  DeviceType: "InActive",
  count: 0
}];
var getTabsData$1 = function getTabsData(devices) {
  var countPoorWifi = 0,
    countConnected = 0,
    countInActive = 0;
  devices.forEach(function (device) {
    if (device.DeviceType === "poor") {
      countPoorWifi++;
    }
    if (device.DeviceType === "good") {
      countConnected++;
    }
    if (device.DeviceType === "InActive") {
      countInActive++;
    }
  });
  var tempTabsData = JSON.parse(JSON.stringify(tabsData$1));
  tempTabsData.forEach(function (tab) {
    if (tab.DeviceType === "poor") {
      tab.count = countPoorWifi;
    }
    if (tab.DeviceType === "good") {
      tab.count = countConnected;
    }
    if (tab.DeviceType === "InActive") {
      tab.count = countInActive;
    }
  });
  return tempTabsData;
};
var Devices = function Devices(props) {
  console.log("comren: Devices");
  var _props$values = props.values,
    values = _props$values === void 0 ? {} : _props$values,
    _props$functions = props.functions,
    functions = _props$functions === void 0 ? {} : _props$functions;
  var _values$landingInfo = values.landingInfo,
    landingInfo = _values$landingInfo === void 0 ? {} : _values$landingInfo,
    _values$symptom = values.symptom,
    symptom = _values$symptom === void 0 ? {} : _values$symptom,
    _values$troubleShooti = values.troubleShootingInfo,
    troubleShootingInfo = _values$troubleShooti === void 0 ? {} : _values$troubleShooti;
  var issueName = symptom.issueName;
  var _useState = useState(false),
    setBtnValue = _useState[1];
  var _useState2 = useState(""),
    searchInput = _useState2[0],
    setSearchInput = _useState2[1];
  var _useState3 = useState(""),
    selectedTab = _useState3[0],
    setSelectedTab = _useState3[1];
  var output = getObjectPropertyByPath("ddata.output", troubleShootingInfo, {});
  var _output$pageContent = output.pageContent,
    pageContent = _output$pageContent === void 0 ? {} : _output$pageContent,
    _output$navHist = output.navHist,
    navHist = _output$navHist === void 0 ? [] : _output$navHist,
    currentPageId = output.currentPageId,
    prevStepEnabled = output.prevStepEnabled,
    nextStepEnabled = output.nextStepEnabled;
  var disabledBtnPrev = false;
  var disabledBtnNext = false;
  if (!prevStepEnabled) {
    disabledBtnPrev = true;
  }
  if (!nextStepEnabled) {
    disabledBtnNext = true;
  }
  var _pageContent$steps = pageContent.steps,
    steps = _pageContent$steps === void 0 ? [] : _pageContent$steps;
  var analysis = getStepByName("analysis", steps);
  var resolution = getStepByName("resolution", steps);
  var closure = getStepByName("closure", steps);
  var resolutionTemplateId = resolution && resolution.templateId || "";
  var buttonsObj = null;
  var buttons = [];
  if (resolutionTemplateId === "SELECT_DEVICE") {
    buttonsObj = resolution.cta[1] || null;
    buttons = buttonsObj ? [buttonsObj] : [];
  }
  if (analysis.templateId === "CONFIRM_DEVICE") {
    buttons = analysis.cta;
  }
  var listOfDevicesData = getListOfDevices(output);
  var _useState4 = useState(listOfDevicesData),
    listOfDevices = _useState4[0],
    setListOfDevices = _useState4[1];
  var _useState5 = useState(getTabsData$1(listOfDevicesData)),
    tabs = _useState5[0],
    setTabs = _useState5[1];
  var pageTitle = resolution && resolution.title || analysis && analysis.title || closure && closure.title;
  var analysisHeading = analysis && analysis.heading;
  var resolutionHeading = Object.keys(resolution).length ? resolution.heading : "";
  var resolutionSubHeading = Object.keys(resolution).length ? resolution.subHeading : "";
  var _landingInfo$device = landingInfo.device,
    device = _landingInfo$device === void 0 ? {} : _landingInfo$device;
  var is5GDevice = device.is5GDevice;
  useEffect(function () {
    if (is5GDevice && pageTitle && issueName && currentPageId) {
      taggingSetStepNameValue(pageTitle + "/" + issueName + "_" + currentPageId);
      console.log("analytics : step", pageTitle + "/" + issueName + "_" + currentPageId);
    }
    if (is5GDevice && issueName && currentPageId) {
      taggingSetPageValue(issueName + "_" + currentPageId);
      console.log("analytics : page", issueName + "_" + currentPageId);
    }
  }, [is5GDevice, pageTitle, issueName, currentPageId]);
  var handleTabSelection = function handleTabSelection(selectedTab) {
    setSelectedTab(selectedTab);
    filterDeviceList(searchInput.trim(), selectedTab);
  };
  useEffect(function () {
    handleTabSelection("poor");
  }, []);
  var handleCancel = function handleCancel() {
    if (functions.handleCancel) {
      functions.handleCancel();
    }
  };
  var handleChecklistChange = function handleChecklistChange(value) {
    console.log('Devices:handleCheckListChange: value:', value);
    if (functions.handleReplayNavigation) {
      functions.handleReplayNavigation(value);
    }
  };
  var handleSearchClick = function handleSearchClick(searchText) {
    filterDeviceList(searchText.trim(), selectedTab);
  };
  var handleTypeAhead = function handleTypeAhead(event) {
    if (event.keyCode === 13) {
      handleSearchClick(event.target.value);
    }
  };
  var handleKeyUp = function handleKeyUp(event) {
    handleSearchClick(event.target.value);
  };
  var handleSearchText = function handleSearchText(event) {
    setSearchInput(event.target.value);
    handleSearchClick(event.target.value);
  };
  var filterDeviceList = function filterDeviceList(searchText, selectedTab) {
    var filteredDeviceList = listOfDevicesData;
    if (searchText) {
      filteredDeviceList = filteredDeviceList.filter(function (device) {
        return device["Host Name"].toLowerCase().includes(searchText.toLowerCase());
      });
      setTabs(getTabsData$1(filteredDeviceList));
    }
    if (selectedTab) {
      filteredDeviceList = filteredDeviceList.filter(function (device) {
        return device.DeviceType === selectedTab;
      });
    }
    if (selectedTab && !searchText) {
      setTabs(getTabsData$1(listOfDevicesData));
    }
    setListOfDevices(filteredDeviceList);
  };
  var handleAction = function handleAction(button, macAddress) {
    if (functions.handleTroubleShootingAction) {
      functions.handleTroubleShootingAction(button, {
        macAddress: macAddress
      });
      setBtnValue(true);
    }
  };
  var renderPageTitle = /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TitleWrapper$7, null, /*#__PURE__*/React__default.createElement(TitleTextWrapper$6, null, /*#__PURE__*/React__default.createElement(Title, {
    size: "small"
  }, isMobile() ? ellipsis(pageTitle + "/" + issueName, 100) : ellipsis(pageTitle + "/" + issueName, 300))), /*#__PURE__*/React__default.createElement(Cancel$5, {
    "data-analyticstrack": "cancel - Icon",
    "data-track": "{ \"type\": \"link\", \"name\": \"cancel-Icon\" } ",
    "data-clickstream": "cancel - Icon",
    onClick: handleCancel,
    "data-testid": "CancelBtn"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "close",
    size: "large"
  }))));
  var renderAnalysisHeading = function renderAnalysisHeading() {
    if (analysisHeading) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Title, {
        size: "medium"
      }, /*#__PURE__*/React__default.createElement(HeadingWrapper$4, null, /*#__PURE__*/React__default.createElement(TextWithHtml, null, analysisHeading))), /*#__PURE__*/React__default.createElement(SpacerDiv, {
        height: "15px"
      }));
    }
  };
  var renderResolutionHeading = function renderResolutionHeading() {
    if (resolutionHeading) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(CustomTitle, null, /*#__PURE__*/React__default.createElement(HeadingWrapper$4, null, /*#__PURE__*/React__default.createElement(TextWithHtml, null, resolutionHeading))));
    }
  };
  var renderResolutionSubHeading = function renderResolutionSubHeading() {
    if (resolutionSubHeading) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Body, {
        size: "small"
      }, /*#__PURE__*/React__default.createElement(TextWithHtml, {
        id: "extra"
      }, resolution.subHeading)));
    }
  };
  var renderChecklist = /*#__PURE__*/React__default.createElement(CheckList, {
    steps: navHist,
    onChange: function onChange(value) {
      return handleChecklistChange(value);
    },
    size: "100%",
    value: currentPageId
  });
  var renderTabs = function renderTabs() {
    var cssClass;
    return tabs.map(function (tab) {
      cssClass = "";
      if (selectedTab === tab.DeviceType) {
        cssClass = "selectedTab";
      }
      return /*#__PURE__*/React__default.createElement(SelectedItem$1, {
        key: tab.DeviceType,
        className: "" + cssClass,
        onClick: function onClick() {
          return handleTabSelection(tab.DeviceType);
        }
      }, /*#__PURE__*/React__default.createElement("span", null, tab.selection), /*#__PURE__*/React__default.createElement("span", null, " (", tab.count, ") "));
    });
  };
  var renderButtons = /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ButtonWrapper$c, null, /*#__PURE__*/React__default.createElement(ActionButtons, {
    buttons: buttons,
    showPrevious: true,
    showNext: true,
    stackButtons: isMobile(),
    disableNext: disabledBtnNext,
    disablePrevious: disabledBtnPrev,
    pageId: currentPageId,
    handleAction: handleAction,
    handlePrevious: handleChecklistChange,
    handleNext: handleChecklistChange
  })), /*#__PURE__*/React__default.createElement(ButtonWrapperMobile$6, null, /*#__PURE__*/React__default.createElement(ActionButtons, {
    buttons: buttons,
    stackButtons: isMobile(),
    handleAction: handleAction
  }), /*#__PURE__*/React__default.createElement(ActionButtons, {
    showPrevious: true,
    showNext: true,
    disableNext: disabledBtnNext,
    disablePrevious: disabledBtnPrev,
    pageId: currentPageId,
    handlePrevious: handleChecklistChange,
    handleNext: handleChecklistChange
  })));
  var renderNoDeviceMessage = function renderNoDeviceMessage() {
    if (listOfDevices.length == 0) {
      return /*#__PURE__*/React__default.createElement(NoDeviceMessage$1, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", null, "Sorry, no results matched your search.")), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", null, "Suggestions"), /*#__PURE__*/React__default.createElement("ul", null, /*#__PURE__*/React__default.createElement("li", null, "Please connect your device to the Wifi network (Joe's-wifi)"), /*#__PURE__*/React__default.createElement("li", null, "If you are having trouble with connecting your device, please click \"Can't find my device\".")));
    }
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ContentWrapper$c, {
    "data-testid": "Devices"
  }, renderPageTitle, /*#__PURE__*/React__default.createElement(StepInfoContainer$6, null, renderChecklist, renderAnalysisHeading(), renderResolutionHeading(), renderResolutionSubHeading(), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "15px"
  }), /*#__PURE__*/React__default.createElement(SearchContainer$2, null, /*#__PURE__*/React__default.createElement(SearchWrapper$3, null, /*#__PURE__*/React__default.createElement(SearchBox$3, {
    maxLength: "37",
    type: "text",
    placeholder: "Search devices",
    onKeyDown: handleTypeAhead,
    onKeyUp: handleKeyUp,
    onChange: handleSearchText,
    value: searchInput
  }), /*#__PURE__*/React__default.createElement(SearchButtonsWrapper$1, null, /*#__PURE__*/React__default.createElement(SearchButton$1, {
    onClick: function onClick(event) {
      return handleSearchClick(searchInput);
    },
    "data-analyticstrack": "Search-Button",
    "data-track": "{\"type\": \"button\", \"name\": \"Search-Button\"}",
    "data-clickstream": "Search-Button",
    "data-testid": "SearchBtn"
  }, /*#__PURE__*/React__default.createElement("svg", {
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M17.896 17.101l-5.995-5.994A6.721 6.721 0 0 0 13.5 6.75a6.75 6.75 0 1 0-6.75 6.75c1.661 0 3.18-.603 4.356-1.598l5.995 5.995.795-.796zM6.75 12.375A5.63 5.63 0 0 1 1.125 6.75 5.63 5.63 0 0 1 6.75 1.125a5.63 5.63 0 0 1 5.625 5.625 5.63 5.63 0 0 1-5.625 5.625z"
  }))))), /*#__PURE__*/React__default.createElement(SelectionBox$1, null, renderTabs())), /*#__PURE__*/React__default.createElement(DeviceList$1, {
    buttons: resolution.cta,
    handleAction: handleAction,
    listOfDevices: listOfDevices,
    templateId: analysis.templateId,
    resolutionTemplateId: resolutionTemplateId
  }), renderNoDeviceMessage()), renderButtons), /*#__PURE__*/React__default.createElement(FeedbackContainer, {
    functions: functions,
    values: values
  }));
};
Devices.propTypes = {
  functions: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
};
Devices.defaultProps = {};

var _templateObject$W, _templateObject2$J, _templateObject3$B, _templateObject4$A, _templateObject5$v, _templateObject6$r, _templateObject7$n, _templateObject8$l, _templateObject9$i, _templateObject0$g, _templateObject1$g, _templateObject10$b, _templateObject11$8, _templateObject12$7, _templateObject13$7, _templateObject14$6, _templateObject15$6, _templateObject16$5, _templateObject17$5, _templateObject18$5;
var ContentWrapper$d = styled.div(_templateObject$W || (_templateObject$W = _taggedTemplateLiteralLoose(["\nborder: 1px solid hsl(180deg 3% 85%);\nmargin: 0px -15px -5px -15px;\npadding: 1em;\n"])));
var StepContainer$5 = styled.div(_templateObject2$J || (_templateObject2$J = _taggedTemplateLiteralLoose(["\n  display: flex;\n  @media(min-width: 601px) {\n    min-height: 325px;\n    justify-content: space-between;\n    padding: 20px 50px 15px 50px;\n  }\n  @media(max-width: 600px) {\n    flex-direction: column;\n    padding: 10px 15px 15px 15px;\n  }\n"])));
var StepInfoContainer$7 = styled.div(_templateObject3$B || (_templateObject3$B = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  @media(min-width: 601px) {\n    width: 60%;\n  }\n"])));
var DeviceImageContainer$3 = styled.div(_templateObject4$A || (_templateObject4$A = _taggedTemplateLiteralLoose(["\n  @media(min-width: 601px) {\n    margin-top:40px;\n  }\n  @media(max-width: 600px) {\n    text-align: center;\n    margin-top: 30px;\n  }\n"])));
var DeviceImage$5 = styled.img(_templateObject5$v || (_templateObject5$v = _taggedTemplateLiteralLoose(["\n  width: auto;\n"])));
var CustomTitle$1 = styled.div(_templateObject6$r || (_templateObject6$r = _taggedTemplateLiteralLoose(["\n    font-size: 1.2rem;\n    line-height: 1.5rem;\n    font-family: Verizon-NHG-eDS;\n    color: #000000;\n    margin: 0;\n    text-decoration: none;\n"])));
var TitleWrapper$8 = styled.div(_templateObject7$n || (_templateObject7$n = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  padding-top: 15px;\n  width: 100%;\n\n  div:last-child {\n    margin-left: auto;\n    margin-right: 10px;\n  }\n"])));
var TitleTextWrapper$7 = styled.div(_templateObject8$l || (_templateObject8$l = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  width: 95%;\n"])));
var HeadingWrapper$5 = styled.div(_templateObject9$i || (_templateObject9$i = _taggedTemplateLiteralLoose(["\n  width: 600px;\n  a {\n    color: black;\n    cursor: pointer;\n    // text-decoration: underline;\n    border-bottom: 1px solid black;\n  }\n  @media(max-width: 768px) {\n    width: auto;\n    font-size:1.0rem;\n  }\n"])));
var SubHeading = styled.span(_templateObject0$g || (_templateObject0$g = _taggedTemplateLiteralLoose(["\n  font-size: 1rem;\n"])));
var BodyWrapper = styled.div(_templateObject1$g || (_templateObject1$g = _taggedTemplateLiteralLoose(["\n  width: 700px;\n\n  @media(max-width: 768px) {\n    width: auto;\n  }\n"])));
var Cancel$6 = styled.div(_templateObject10$b || (_templateObject10$b = _taggedTemplateLiteralLoose(["\n  min-height: 1rem;\n  min-width: 1rem;\n  @media(min-width: 601px) {\n    margin-right: 10px;\n  }\n  @media(max-width: 600px){\n    margin-left: 5px;\n  }\n"])));
var ConnectivityWrap = styled.div(_templateObject11$8 || (_templateObject11$8 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin: 20px 0;\n"])));
var Symbol$1 = styled.div(_templateObject12$7 || (_templateObject12$7 = _taggedTemplateLiteralLoose(["\n  border-radius: 100%;\n  height: 45px;\n  width: 45px;\n  margin-right: 20px;\n  background: #DCDDDA;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var SubTitleContent = styled.div(_templateObject13$7 || (_templateObject13$7 = _taggedTemplateLiteralLoose(["\n  font-weight: 800;\n  color: #747676;\n  font-size: 1rem;\n"])));
var ConnectivityContent = styled.div(_templateObject14$6 || (_templateObject14$6 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  .value {\n    text-transform : uppercase;\n  }\n"])));
var ButtonWrapper$d = styled.div(_templateObject15$6 || (_templateObject15$6 = _taggedTemplateLiteralLoose(["\n  padding-bottom: 25px;\n  @media screen and (max-width: 600px) {\n    display:none\n  }\n"])));
var ButtonWrapperMobile$7 = styled.div(_templateObject16$5 || (_templateObject16$5 = _taggedTemplateLiteralLoose(["\n  width: 50%;\n  margin:0px auto;\n  @media screen and (min-width: 600px) {\n    display:none\n  }\n"])));
var InputFieldWrapper$2 = styled.div(_templateObject17$5 || (_templateObject17$5 = _taggedTemplateLiteralLoose(["\n  padding: 20px 0;\n"])));
var SelectWrapper$2 = styled.div(_templateObject18$5 || (_templateObject18$5 = _taggedTemplateLiteralLoose(["\n  float: left;\n  padding-right: 10px;\n"])));
var Wifi = function Wifi(props) {
  console.log("comren: Wifi");
  var _props$values = props.values,
    values = _props$values === void 0 ? {} : _props$values,
    _props$functions = props.functions,
    functions = _props$functions === void 0 ? {} : _props$functions;
  var _values$landingInfo = values.landingInfo,
    landingInfo = _values$landingInfo === void 0 ? {} : _values$landingInfo,
    _values$symptom = values.symptom,
    symptom = _values$symptom === void 0 ? {} : _values$symptom,
    _values$troubleShooti = values.troubleShootingInfo,
    troubleShootingInfo = _values$troubleShooti === void 0 ? {} : _values$troubleShooti;
  var issueName = symptom.issueName;
  var _useState = useState(false),
    setBtnValue = _useState[1];
  var output = getObjectPropertyByPath("ddata.output", troubleShootingInfo, {});
  var context = getObjectPropertyByPath('context', troubleShootingInfo, {});
  var _output$pageContent = output.pageContent,
    pageContent = _output$pageContent === void 0 ? {} : _output$pageContent,
    _output$navHist = output.navHist,
    navHist = _output$navHist === void 0 ? [] : _output$navHist,
    currentPageId = output.currentPageId,
    prevStepEnabled = output.prevStepEnabled,
    nextStepEnabled = output.nextStepEnabled;
  var disabledBtnPrev = false;
  var disabledBtnNext = false;
  if (!prevStepEnabled) {
    disabledBtnPrev = true;
  }
  if (!nextStepEnabled) {
    disabledBtnNext = true;
  }
  var _pageContent$steps = pageContent.steps,
    steps = _pageContent$steps === void 0 ? [] : _pageContent$steps;
  var analysis = getStepByName("analysis", steps);
  var resolution = getStepByName("resolution", steps);
  var closure = getStepByName("closure", steps);
  var buttons = resolution.cta || analysis.cta;
  var pageTitle = resolution && resolution.title || analysis && analysis.title || closure && closure.title;
  var analysisHeading = analysis && analysis.heading;
  var analysisSubHeading = analysis && analysis.subHeading || "";
  var resolutionHeading = resolution && resolution.heading || "";
  var resolutionSubHeading = resolution && resolution.subHeading || "";
  var image = analysis.image || resolution && resolution.image;
  var deviceTitle = analysis.userDeviceData && analysis.userDeviceData.title;
  var deviceHeading = analysis.userDeviceData && analysis.userDeviceData.heading;
  var deviceSubHeading = analysis.userDeviceData && analysis.userDeviceData.subHeading;
  var questions = analysis.questions || [];
  var questionObj = questions[0] || {};
  var questionChoices = questionObj.choices,
    question = questionObj.question;
  var selectedQuestion = questionChoices && questionChoices[0].value ? questionChoices[0].value : "";
  var _useState2 = useState(selectedQuestion),
    selectedDevice = _useState2[0],
    setSelectedDevice = _useState2[1];
  var answers = resolution && resolution.answers || analysis && analysis.answers || [];
  var answerObj = answers[0] || {};
  var _answerObj$choices = answerObj.choices,
    answerChoices = _answerObj$choices === void 0 ? [] : _answerObj$choices;
  var selectedDeviceArr = answerChoices.filter(function (choice) {
    return choice.value === selectedDevice;
  });
  var selectedDeviceDesc = selectedDeviceArr.length ? selectedDeviceArr[0].text : resolutionHeading;
  var _useState3 = useState(selectedDeviceDesc),
    selectedDeviceDescription = _useState3[0],
    setSelectedDeviceDescription = _useState3[1];
  var _landingInfo$device = landingInfo.device,
    device = _landingInfo$device === void 0 ? {} : _landingInfo$device;
  var is5GDevice = device.is5GDevice;
  useEffect(function () {
    if (is5GDevice && pageTitle && issueName && currentPageId) {
      taggingSetStepNameValue(pageTitle + "/" + issueName + "_" + currentPageId);
      console.log("analytics : step", pageTitle + "/" + issueName + "_" + currentPageId);
    }
    if (is5GDevice && issueName && currentPageId) {
      taggingSetPageValue(issueName + "_" + currentPageId);
      console.log("analytics : page", issueName + "_" + currentPageId);
    }
  }, [is5GDevice, pageTitle, issueName, currentPageId]);
  var handleCancel = function handleCancel() {
    console.log("SlowSpeedPage: handleCancel: called...");
    if (functions.handleCancel) {
      functions.handleCancel();
    }
  };
  var handleChecklistChange = function handleChecklistChange(value) {
    if (functions.handleReplayNavigation) {
      functions.handleReplayNavigation(value);
    }
  };
  var handleChange = function handleChange(event) {
    event.preventDefault();
    setSelectedDevice(event.target.value);
    var selectedDeviceArr = answerChoices.filter(function (choice) {
      return choice.value === event.target.value;
    });
    var selectedDeviceDesc = selectedDeviceArr.length ? selectedDeviceArr[0].text : resolutionHeading;
    setSelectedDeviceDescription(selectedDeviceDesc);
  };
  var handleAction = function handleAction(button) {
    console.log("Wifi:handleAction: called with action: " + button.action);
    if (functions.handleTroubleShootingAction) {
      functions.handleTroubleShootingAction(button);
      setBtnValue(true);
    }
  };
  var renderPageTitle = /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TitleWrapper$8, null, /*#__PURE__*/React__default.createElement(TitleTextWrapper$7, null, /*#__PURE__*/React__default.createElement(Title, {
    size: "small"
  }, isMobile() ? ellipsis(pageTitle + "/" + issueName, 100) : ellipsis(pageTitle + "/" + issueName, 300))), /*#__PURE__*/React__default.createElement(Cancel$6, {
    "data-analyticstrack": "cancel - Icon",
    "data-track": "{ \"type\": \"link\", \"name\": \"cancel-Icon\" } ",
    "data-clickstream": "cancel - Icon",
    "data-testid": "cancel",
    onClick: handleCancel
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "close",
    size: "large"
  }))));
  var renderChecklist = /*#__PURE__*/React__default.createElement(CheckList, {
    steps: navHist,
    onChange: function onChange(value) {
      return handleChecklistChange(value);
    },
    size: "100%",
    value: currentPageId
  });
  var renderDeviceTitle = /*#__PURE__*/React__default.createElement(Title, {
    size: "small"
  }, " ", /*#__PURE__*/React__default.createElement(SubTitleContent, null, " ", deviceTitle, " "), " ");
  function DeviceIcon(props) {
    return /*#__PURE__*/React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 18.4 18",
      width: "30px",
      height: "30px"
    }, props), /*#__PURE__*/React__default.createElement("path", {
      d: "M15.6 2.6l-.8.8c3.1 3.1 3.1 8.1 0 11.1l.8.8c3.5-3.5 3.5-9.2 0-12.7zM3.7 3.4l-.8-.8c-3.5 3.5-3.5 9.2 0 12.7l.8-.8c-3-3-3-8 0-11.1z"
    }), /*#__PURE__*/React__default.createElement("path", {
      d: "M13.7 4.7l-.8.8c2 1.9 2 5.1 0 7.1l.8.8c2.3-2.5 2.3-6.3 0-8.7zM5 4.7C2.6 7.1 2.6 11 5 13.4l.8-.8c-2-1.9-2-5.1 0-7.1L5 4.7zM9.3 6.2C7.7 6.2 6.5 7.4 6.5 9s1.3 2.8 2.8 2.8 2.8-1.3 2.8-2.8c0-.8-.3-1.5-.8-2s-1.2-.8-2-.8zm1.2 4c-.7.7-1.7.7-2.4 0s-.7-1.7 0-2.4 1.7-.7 2.4 0c.7.6.7 1.7 0 2.4z"
    }));
  }
  var renderDeviceInfo = function renderDeviceInfo() {
    if (!deviceHeading && !deviceSubHeading) {
      return /*#__PURE__*/React__default.createElement(SpacerDiv, {
        height: "15px"
      });
    }
    var color = "#cd040b";
    if (deviceSubHeading.toUpperCase() === "GOOD") {
      color = "#000000";
    }
    return /*#__PURE__*/React__default.createElement(ConnectivityWrap, null, deviceHeading || deviceSubHeading ? /*#__PURE__*/React__default.createElement(Symbol$1, null, " ", /*#__PURE__*/React__default.createElement(DeviceIcon, null), " ") : null, /*#__PURE__*/React__default.createElement(ConnectivityContent, null, deviceHeading ? /*#__PURE__*/React__default.createElement(Body, {
      size: "large"
    }, " ", deviceHeading, " ") : null, deviceSubHeading ? /*#__PURE__*/React__default.createElement(Body, {
      className: "value",
      color: color,
      bold: true,
      size: "large"
    }, " ", deviceSubHeading.toUpperCase(), " ") : null));
  };
  var renderAnalysisHeading = function renderAnalysisHeading() {
    if (analysisHeading) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Title, {
        size: "medium"
      }, /*#__PURE__*/React__default.createElement(HeadingWrapper$5, null, /*#__PURE__*/React__default.createElement(TextWithHtml, null, analysisHeading))), /*#__PURE__*/React__default.createElement(SpacerDiv, {
        height: "15px"
      }));
    }
  };
  var renderResolutionHeading = function renderResolutionHeading() {
    if (resolutionHeading) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(CustomTitle$1, null, /*#__PURE__*/React__default.createElement(HeadingWrapper$5, null, /*#__PURE__*/React__default.createElement(TextWithHtml, null, resolutionHeading))));
    }
  };
  var renderAnalysisSubHeading = function renderAnalysisSubHeading() {
    if (analysisSubHeading) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Body, {
        size: "small"
      }, /*#__PURE__*/React__default.createElement(SubHeading, null, /*#__PURE__*/React__default.createElement(TextWithHtml, {
        id: "extra"
      }, analysisSubHeading))));
    }
  };
  var renderResolutionSubHeading = function renderResolutionSubHeading() {
    if (resolutionSubHeading) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Body, {
        size: "small"
      }, /*#__PURE__*/React__default.createElement(SubHeading, null, /*#__PURE__*/React__default.createElement(TextWithHtml, {
        id: "extra"
      }, resolutionSubHeading))));
    }
  };
  var renderDropdownOptions = function renderDropdownOptions() {
    if (questionChoices) {
      return questionChoices.map(function (choice) {
        return /*#__PURE__*/React__default.createElement("option", {
          key: choice.key,
          value: choice.value
        }, " ", choice.text, " ");
      });
    }
  };
  var renderQuestionsDropdown = /*#__PURE__*/React__default.createElement(SelectWrapper$2, null, /*#__PURE__*/React__default.createElement(InputFieldWrapper$2, null, /*#__PURE__*/React__default.createElement(DropdownSelect, {
    "data-analyticstrack": "SelectState-Dropdown",
    "data-track": "{\"type\": \"link\", \"name\": \"Select Device\"}",
    value: selectedDevice,
    label: question || "",
    name: "device",
    onChange: function onChange(event) {
      return handleChange(event);
    },
    "data-testid": "dropdown",
    required: true,
    width: isMobile() ? "100%" : "350px"
  }, renderDropdownOptions())));
  var renderAnswers = /*#__PURE__*/React__default.createElement(Body, {
    size: "large"
  }, /*#__PURE__*/React__default.createElement(BodyWrapper, null, /*#__PURE__*/React__default.createElement(TextWithHtml, null, selectedDeviceDescription)));
  var renderButtons = /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ButtonWrapper$d, null, /*#__PURE__*/React__default.createElement(ActionButtons, {
    buttons: buttons,
    showPrevious: true,
    showNext: true,
    stackButtons: isMobile(),
    disableNext: disabledBtnNext,
    disablePrevious: disabledBtnPrev,
    pageId: currentPageId,
    handleAction: handleAction,
    handlePrevious: function handlePrevious(value) {
      return handleChecklistChange(value);
    },
    handleNext: function handleNext(value) {
      return handleChecklistChange(value);
    }
  })), /*#__PURE__*/React__default.createElement(ButtonWrapperMobile$7, null, /*#__PURE__*/React__default.createElement(ActionButtons, {
    buttons: buttons,
    stackButtons: isMobile(),
    handleAction: handleAction
  }), /*#__PURE__*/React__default.createElement(ActionButtons, {
    showPrevious: true,
    showNext: true,
    disableNext: disabledBtnNext,
    disablePrevious: disabledBtnPrev,
    pageId: currentPageId,
    handlePrevious: function handlePrevious(value) {
      return handleChecklistChange(value);
    },
    handleNext: function handleNext(value) {
      return handleChecklistChange(value);
    }
  })));
  var renderDeviceImageContainer = function renderDeviceImageContainer() {
    if (image) {
      return /*#__PURE__*/React__default.createElement(DeviceImageContainer$3, null, /*#__PURE__*/React__default.createElement(DeviceImage$5, {
        alt: "Device",
        src: image,
        style: window.innerWidth < 601 ? {
          objectFit: 'cover',
          width: "74%",
          height: "82%"
        } : {
          width: "100%"
        }
      }));
    }
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ContentWrapper$d, null, renderPageTitle, /*#__PURE__*/React__default.createElement(StepContainer$5, {
    id: "stepContainer"
  }, /*#__PURE__*/React__default.createElement(StepInfoContainer$7, null, renderChecklist, renderDeviceTitle, renderDeviceInfo(), renderAnalysisHeading(), renderAnalysisSubHeading(), questions.length > 0 ? renderQuestionsDropdown : renderResolutionHeading(), questions.length > 0 ? answers.length > 0 ? renderAnswers : renderResolutionHeading() : null, renderResolutionSubHeading(), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "15px"
  })), renderDeviceImageContainer()), renderButtons), /*#__PURE__*/React__default.createElement(FeedbackContainer, {
    functions: functions,
    values: values
  }));
};
Wifi.propTypes = {
  functions: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
};
Wifi.defaultProps = {};

var TrackingIcon = "real-time-tracking_auxiliary~UdxTZmSc.png";

var MulticastIcon = "multicast_auxiliary~DvbeXwpH.png";

var _templateObject$X, _templateObject2$K, _templateObject3$C, _templateObject4$B, _templateObject5$w, _templateObject6$s, _templateObject7$o, _templateObject8$m, _templateObject9$j, _templateObject0$h, _templateObject1$h, _templateObject10$c, _templateObject11$9, _templateObject12$8, _templateObject13$8, _templateObject14$7, _templateObject15$7, _templateObject16$6, _templateObject17$6, _templateObject18$6, _templateObject19$5;
var ContentWrapper$e = styled.div(_templateObject$X || (_templateObject$X = _taggedTemplateLiteralLoose(["\nborder: 1px solid hsl(180deg 3% 85%);\nmargin: 0px -15px -5px -15px\n\n"])));
var StepContainer$6 = !window.isMVODigital ? styled.div(_templateObject2$K || (_templateObject2$K = _taggedTemplateLiteralLoose(["\nborder-bottom: 1px solid hsl(180deg 3% 85%);\n"]))) : styled.div(_templateObject3$C || (_templateObject3$C = _taggedTemplateLiteralLoose(["\ndisplay: flex; \n@media(min-width: 601px) {\n  min-height: 325px;\n  justify-content: space-between;\n  padding: 20px 50px 15px 50px;\n}\n@media(max-width: 600px) {\n  flex-direction: column;\n  padding: 10px 15px 15px 15px;\n}\n"])));
var StepInfoContainer$8 = styled.div(_templateObject4$B || (_templateObject4$B = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  @media(min-width: 601px) {\n    width: 60%;\n  }\n"])));
var DeviceImageContainer$4 = styled.div(_templateObject5$w || (_templateObject5$w = _taggedTemplateLiteralLoose(["  \n  margin-top: 30px;\n  @media(min-width: 601px) {\n    margin-top:40px;\n  }\n  @media(max-width: 600px) {\n    text-align: center;\n    margin-top: 30px;\n  }\n"])));
var DeviceImage$6 = styled.img(_templateObject6$s || (_templateObject6$s = _taggedTemplateLiteralLoose(["  \n  width: auto;\n"])));
var CustomTitle$2 = styled.div(_templateObject7$o || (_templateObject7$o = _taggedTemplateLiteralLoose(["\n    font-size: 1.2rem;\n    line-height: 1.5rem;\n    font-family: Verizon-NHG-eDS;\n    color: #000000;\n    margin: 0;\n    text-decoration: none;\n"])));
var TitleWrapper$9 = styled.div(_templateObject8$m || (_templateObject8$m = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  padding-top: 15px;\n  width: 100%;\n\n  div:last-child {\n    margin-left: auto;\n    margin-right: 10px;\n  }\n"])));
var TitleTextWrapper$8 = styled.div(_templateObject9$j || (_templateObject9$j = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  width: 95%;\n"])));
var HeadingWrapper$6 = styled.div(_templateObject0$h || (_templateObject0$h = _taggedTemplateLiteralLoose(["\n  width: 600px;\n  a {\n    color: black;\n    cursor: pointer;\n    // text-decoration: underline;\n    border-bottom: 1px solid black;\n  }\n  @media(max-width: 768px) {\n    width: auto;\n    font-size:1.0rem;\n  }\n"])));
var BodyWrapper$1 = styled.div(_templateObject1$h || (_templateObject1$h = _taggedTemplateLiteralLoose(["\n  width: 800px;\n\n  @media(max-width: 768px) {\n    width: auto;\n  }\n"])));
var Cancel$7 = styled.div(_templateObject10$c || (_templateObject10$c = _taggedTemplateLiteralLoose(["\n  min-height: 1rem;\n  min-width: 1rem;\n  @media(min-width: 601px) {\n    margin-right: 10px;\n  }\n  @media(max-width: 600px){\n    margin-left: 5px;\n  }\n"])));
var ConnectivityWrap$1 = styled.div(_templateObject11$9 || (_templateObject11$9 = _taggedTemplateLiteralLoose(["\n  display: flex;\n"])));
var Symbol$2 = styled.div(_templateObject12$8 || (_templateObject12$8 = _taggedTemplateLiteralLoose(["\n  border-radius: 100%;\n  height: 45px;\n  width: 45px;\n  margin-right: 20px;\n  background: #DCDDDA;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  @media(max-width: 320px) {\n    width: 55px;\n  }\n"])));
var SubTitleContent$1 = styled.div(_templateObject13$8 || (_templateObject13$8 = _taggedTemplateLiteralLoose(["\n  font-weight: 800;\n  color: #747676;\n  font-size: 1rem;\n"])));
var ConnectivityContent$1 = styled.div(_templateObject14$7 || (_templateObject14$7 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  .value {\n    text-transform : uppercase;\n  }\n"])));
var ButtonWrapper$e = styled.div(_templateObject15$7 || (_templateObject15$7 = _taggedTemplateLiteralLoose(["\n  padding-bottom: 25px;\n  @media screen and (max-width: 600px) {\n    display:none\n  }\n"])));
var ButtonWrapperMobile$8 = styled.div(_templateObject16$6 || (_templateObject16$6 = _taggedTemplateLiteralLoose(["\n  width: 50%;\n  margin:0px auto;\n  @media screen and (min-width: 600px) {\n    display:none\n  }\n"])));
var SelectWrapper$3 = styled.div(_templateObject17$6 || (_templateObject17$6 = _taggedTemplateLiteralLoose(["\n  float: left;\n  padding: 3px 0;\n  // padding-right: 10px;\n"])));
var LocationsContainer = styled.div(_templateObject18$6 || (_templateObject18$6 = _taggedTemplateLiteralLoose(["\n  display: table;\n  .location-container-row{;\n    display: table-row\n    div {\n      display: table-cell\n    }\n    div.location {\n      width : 130px;    \n    }\n    .dash {\n      padding: 0 10px;\n      width: 0;\n    }\n  }  \n  @media screen and (max-width: 600px) {\n    div.location {\n      width : 130px !important;    \n    }\n  }\n"])));
var IconImage$3 = styled.img(_templateObject19$5 || (_templateObject19$5 = _taggedTemplateLiteralLoose(["\n  width: 45px;\n  height: auto;\n"])));
var BlackSpot = function BlackSpot(props) {
  console.log("comren: BlackSpot");
  var _props$values = props.values,
    values = _props$values === void 0 ? {} : _props$values,
    _props$functions = props.functions,
    functions = _props$functions === void 0 ? {} : _props$functions;
  var _values$landingInfo = values.landingInfo,
    landingInfo = _values$landingInfo === void 0 ? {} : _values$landingInfo,
    _values$symptom = values.symptom,
    symptom = _values$symptom === void 0 ? {} : _values$symptom,
    _values$troubleShooti = values.troubleShootingInfo,
    troubleShootingInfo = _values$troubleShooti === void 0 ? {} : _values$troubleShooti;
  var issueName = symptom.issueName;
  var _useState = useState(false);
  var output = getObjectPropertyByPath("ddata.output", troubleShootingInfo, {});
  var context = getObjectPropertyByPath('context', troubleShootingInfo, {});
  var _output$pageContent = output.pageContent,
    pageContent = _output$pageContent === void 0 ? {} : _output$pageContent,
    _output$navHist = output.navHist,
    navHist = _output$navHist === void 0 ? [] : _output$navHist,
    currentPageId = output.currentPageId,
    prevStepEnabled = output.prevStepEnabled,
    nextStepEnabled = output.nextStepEnabled;
  var disabledBtnPrev = false;
  var disabledBtnNext = false;
  if (!prevStepEnabled) {
    disabledBtnPrev = true;
  }
  if (!nextStepEnabled) {
    disabledBtnNext = true;
  }
  var _pageContent$steps = pageContent.steps,
    steps = _pageContent$steps === void 0 ? [] : _pageContent$steps;
  var blackspot = getStepByName("blackspot", steps);
  var resolution = getStepByName("resolution", steps);
  var closure = getStepByName("closure", steps);
  var buttons = blackspot.cta && blackspot.cta.length > 0 && blackspot.cta || resolution && resolution.cta && resolution.cta.length > 0 && resolution.cta || [];
  var pageTitle = resolution && resolution.title || blackspot && blackspot.title || closure && closure.title;
  var blackspotHeading = blackspot && blackspot.heading || "";
  var resolutionHeading = resolution && resolution.heading || "";
  var blackspotDeviceTitle = blackspot.userDeviceData && blackspot.userDeviceData.title || "";
  var blackspotDeviceHeading = blackspot.userDeviceData && blackspot.userDeviceData.heading || "";
  var blackspotDeviceSubHeading = blackspot.userDeviceData && blackspot.userDeviceData.subHeading || "";
  var userLocation = blackspot.userLocation || resolution && resolution.userLocation || [];
  var image = blackspot.image || resolution && resolution.image;
  var questions = blackspot.questions || [];
  var questionObj = questions[0] || {};
  var questionChoices = questionObj.choices,
    question = questionObj.question;
  var _landingInfo$device = landingInfo.device,
    device = _landingInfo$device === void 0 ? {} : _landingInfo$device;
  var is5GDevice = device.is5GDevice;
  if (questionChoices) {
    var option = questionChoices.find(function (question) {
      return question.value == "-1";
    });
    !option && questionChoices.unshift({
      text: "Select Location",
      value: "-1"
    });
  }
  var selectedQuestion = questionChoices && questionChoices[0].value ? questionChoices[0].value : "";
  var _useState2 = useState(selectedQuestion),
    selectedDevice = _useState2[0],
    setSelectedDevice = _useState2[1];
  useEffect(function () {
    if (is5GDevice && pageTitle && issueName && currentPageId) {
      taggingSetStepNameValue(pageTitle + "/" + issueName + "_" + currentPageId);
      console.log("analytics : step", pageTitle + "/" + issueName + "_" + currentPageId);
    }
    if (is5GDevice && issueName && currentPageId) {
      taggingSetPageValue(issueName + "_" + currentPageId);
      console.log("analytics : page", issueName + "_" + currentPageId);
    }
  }, [is5GDevice, pageTitle, issueName, currentPageId]);
  var handleCancel = function handleCancel() {
    console.log("SlowSpeedPage: handleCancel: called...");
    if (functions.handleCancel) {
      functions.handleCancel();
    }
  };
  var handleChecklistChange = function handleChecklistChange(value) {
    if (functions.handleReplayNavigation) {
      functions.handleReplayNavigation(value);
    }
  };
  var handleChange = function handleChange(event) {
    console.log("handleChange: ", event.target.value);
    event.preventDefault();
    setSelectedDevice(event.target.value);
    if (functions.handleTroubleShootingAction && event.target.value !== "-1") {
      functions.handleTroubleShootingAction({
        action: event.target.value,
        callFunction: "",
        label: "",
        url: ""
      }, {
        selectedLocation: event.target.value
      });
    }
  };
  var handleAction = function handleAction(button) {
    console.log("BlackSpot:handleAction: called with action: " + button.action);
    if (functions.handleTroubleShootingAction) {
      functions.handleTroubleShootingAction(button);
    }
  };
  var renderPageTitle = /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TitleWrapper$9, null, /*#__PURE__*/React__default.createElement(TitleTextWrapper$8, null, /*#__PURE__*/React__default.createElement(Title, {
    size: "small"
  }, isMobile() ? ellipsis(pageTitle + "/" + issueName, 100) : ellipsis(pageTitle + "/" + issueName, 300))), /*#__PURE__*/React__default.createElement(Cancel$7, {
    "data-testid": "cancelIcon",
    "data-analyticstrack": "cancel - Icon",
    "data-track": "{ \"type\": \"link\", \"name\": \"cancel-Icon\" } ",
    "data-clickstream": "cancel - Icon",
    onClick: handleCancel
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "close",
    size: "large"
  }))));
  var renderChecklist = /*#__PURE__*/React__default.createElement(CheckList, {
    marginBottom: "20px",
    steps: navHist,
    onChange: function onChange(value) {
      return handleChecklistChange(value);
    },
    size: "100%",
    value: currentPageId
  });
  var renderBlackSpotDeviceTitle = blackspotDeviceTitle && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Title, {
    size: "small"
  }, " ", /*#__PURE__*/React__default.createElement(SubTitleContent$1, null, " ", blackspotDeviceTitle, " "), " "), /*#__PURE__*/React__default.createElement(HeightDiv, {
    margin: "8px"
  }));
  var renderBlackSpotDeviceInfo = function renderBlackSpotDeviceInfo() {
    var color = "#cd040b";
    if (!blackspotDeviceHeading && !blackspotDeviceSubHeading) {
      return null;
    }
    if (blackspotDeviceSubHeading.toUpperCase() === "GOOD") {
      color = "#000000";
    }
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(HeightDiv, {
      margin: "10px"
    }), /*#__PURE__*/React__default.createElement(ConnectivityWrap$1, null, blackspotDeviceHeading || blackspotDeviceSubHeading ? /*#__PURE__*/React__default.createElement(Symbol$2, null, " ", /*#__PURE__*/React__default.createElement(IconImage$3, {
      src: MulticastIcon
    }), " ") : null, /*#__PURE__*/React__default.createElement(ConnectivityContent$1, null, blackspotDeviceHeading ? /*#__PURE__*/React__default.createElement(Body, {
      size: "large"
    }, " ", blackspotDeviceHeading, " ") : null, blackspotDeviceSubHeading ? /*#__PURE__*/React__default.createElement(Body, {
      className: "value",
      color: color,
      bold: true,
      size: "large"
    }, " ", blackspotDeviceSubHeading.toUpperCase(), " ") : null)), /*#__PURE__*/React__default.createElement(HeightDiv, {
      margin: "15px"
    }));
  };
  var renderLocationInfo = function renderLocationInfo() {
    if (userLocation.length > 0) {
      return userLocation.map(function (location) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "location-container-row"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "location"
        }, /*#__PURE__*/React__default.createElement(Body, {
          size: "large"
        }, location.location)), /*#__PURE__*/React__default.createElement("div", {
          className: "dash"
        }, /*#__PURE__*/React__default.createElement(Body, {
          size: "large"
        }, "-")), /*#__PURE__*/React__default.createElement("div", {
          className: "signal"
        }, /*#__PURE__*/React__default.createElement(Body, {
          className: "",
          bold: true,
          size: "large"
        }, location.signal)));
      });
    }
  };
  var renderBlackSpotDeviceInfo2 = function renderBlackSpotDeviceInfo2() {
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ConnectivityWrap$1, null, /*#__PURE__*/React__default.createElement(Symbol$2, null, " ", /*#__PURE__*/React__default.createElement(IconImage$3, {
      src: TrackingIcon
    }), " "), /*#__PURE__*/React__default.createElement(ConnectivityContent$1, null, blackspotHeading ? /*#__PURE__*/React__default.createElement(Body, {
      className: "value",
      bold: true,
      size: "large"
    }, /*#__PURE__*/React__default.createElement(TextWithHtml, {
      id: "extra"
    }, blackspotHeading)) : null)), /*#__PURE__*/React__default.createElement(HeightDiv, {
      margin: "10px"
    }));
  };
  var renderBlackSpotTitle = function renderBlackSpotTitle() {
    if (pageTitle) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Title, {
        size: "large"
      }, /*#__PURE__*/React__default.createElement(HeadingWrapper$6, null, /*#__PURE__*/React__default.createElement(TextWithHtml, null, pageTitle))), /*#__PURE__*/React__default.createElement(HeightDiv, {
        margin: "10px"
      }));
    }
  };
  var renderBlackspotHeading = function renderBlackspotHeading() {
    if (blackspotHeading) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(CustomTitle$2, null, /*#__PURE__*/React__default.createElement(Body, {
        size: "large"
      }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, blackspotHeading))), /*#__PURE__*/React__default.createElement(HeightDiv, {
        margin: "10px"
      }));
    }
  };
  var renderResolutionHeading = function renderResolutionHeading() {
    if (resolutionHeading) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(CustomTitle$2, null, /*#__PURE__*/React__default.createElement(Body, {
        size: "large"
      }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, resolutionHeading))), /*#__PURE__*/React__default.createElement(HeightDiv, {
        margin: "10px"
      }));
    }
  };
  var renderDropdownOptions = function renderDropdownOptions() {
    if (questionChoices) {
      return questionChoices.map(function (choice) {
        return /*#__PURE__*/React__default.createElement("option", {
          key: choice.key,
          value: choice.value
        }, " ", choice.text, " ");
      });
    }
  };
  var renderLocationsDropdown = /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "large",
    bold: true
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, {
    id: "extra"
  }, blackspotHeading)), /*#__PURE__*/React__default.createElement(SelectWrapper$3, null, /*#__PURE__*/React__default.createElement(DropdownSelect, {
    "data-analyticstrack": "SelectState-Dropdown",
    "data-track": "{\"type\": \"link\", \"name\": \"Select Device\"}",
    value: selectedDevice,
    label: question || "",
    name: "device",
    onChange: function onChange(event) {
      return handleChange(event);
    },
    required: true,
    width: isMobile() ? "100%" : "360px"
  }, renderDropdownOptions())));
  var renderButtons = /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ButtonWrapper$e, null, /*#__PURE__*/React__default.createElement(ActionButtons, {
    buttons: buttons,
    showPrevious: true,
    showNext: true,
    stackButtons: isMobile(),
    disableNext: disabledBtnNext,
    disablePrevious: disabledBtnPrev,
    pageId: currentPageId,
    handleAction: handleAction,
    handlePrevious: function handlePrevious(value) {
      return handleChecklistChange(value);
    },
    handleNext: function handleNext(value) {
      return handleChecklistChange(value);
    }
  })), /*#__PURE__*/React__default.createElement(ButtonWrapperMobile$8, null, /*#__PURE__*/React__default.createElement(ActionButtons, {
    buttons: buttons,
    stackButtons: isMobile(),
    handleAction: handleAction
  }), /*#__PURE__*/React__default.createElement(ActionButtons, {
    showPrevious: true,
    showNext: true,
    disableNext: disabledBtnNext,
    disablePrevious: disabledBtnPrev,
    pageId: currentPageId,
    handlePrevious: function handlePrevious(value) {
      return handleChecklistChange(value);
    },
    handleNext: function handleNext(value) {
      return handleChecklistChange(value);
    }
  })));
  var renderDeviceImageContainer = function renderDeviceImageContainer() {
    if (image) {
      return /*#__PURE__*/React__default.createElement(DeviceImageContainer$4, null, /*#__PURE__*/React__default.createElement(DeviceImage$6, {
        alt: "Device",
        src: image,
        style: window.innerWidth < 601 ? {
          objectFit: 'cover',
          width: "74%",
          height: "82%"
        } : {
          width: "100%"
        }
      }));
    }
  };
  var renderSurveyResults = function renderSurveyResults() {
    if (blackspot.templateId === "WIFI_BLACK_SPOT_CHECK_RESULT_POOR" || blackspot.templateId === "WIFI_BLACK_SPOT_CHECK_RESULT_GOOD") {
      return /*#__PURE__*/React__default.createElement(Fragment, null, renderBlackspotHeading(), /*#__PURE__*/React__default.createElement(LocationsContainer, null, renderLocationInfo()), /*#__PURE__*/React__default.createElement(HeightDiv, {
        margin: "10px"
      }), renderResolutionHeading());
    }
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ContentWrapper$e, {
    "data-testid": "Blackspot"
  }, renderPageTitle, /*#__PURE__*/React__default.createElement(StepContainer$6, {
    id: "stepContainer"
  }, /*#__PURE__*/React__default.createElement(StepInfoContainer$8, null, renderChecklist, renderBlackSpotDeviceTitle, renderBlackSpotTitle(), blackspot.templateId === "WIFI_BLACK_SPOT_CHECK_START" && questions.length > 0 && renderLocationsDropdown, renderBlackSpotDeviceInfo(), blackspot.templateId === "WIFI_BLACK_SPOT_CHECK_CONTINUE" && renderBlackSpotDeviceInfo2(), renderSurveyResults(), /*#__PURE__*/React__default.createElement(HeightDiv, {
    margin: "10px"
  })), renderDeviceImageContainer()), renderButtons), /*#__PURE__*/React__default.createElement(FeedbackContainer, {
    functions: functions,
    values: values
  }));
};
BlackSpot.propTypes = {
  functions: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
};
BlackSpot.defaultProps = {};

var _templateObject$Y, _templateObject2$L, _templateObject3$D, _templateObject4$C, _templateObject5$x, _templateObject6$t, _templateObject7$p, _templateObject8$n, _templateObject9$k, _templateObject0$i, _templateObject1$i, _templateObject10$d, _templateObject11$a, _templateObject12$9, _templateObject13$9, _templateObject14$8, _templateObject15$8, _templateObject16$7, _templateObject17$7, _templateObject18$7, _templateObject19$6;
var MiniExtender = "data:image/png;base64,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";
var RegularExtender = "data:image/png;base64,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";
var ThirdPartyExtender = "data:image/png;base64,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";
var ContentWrapper$f = !window.isMVODigital ? styled.div(_templateObject$Y || (_templateObject$Y = _taggedTemplateLiteralLoose(["\nborder-bottom: 1px solid hsl(180deg 3% 85%);\n"]))) : styled.div(_templateObject2$L || (_templateObject2$L = _taggedTemplateLiteralLoose(["\n  @media (min-width: 601px) {\n    box-shadow: 0px 0px 10px #aaa;\n    margin-left: auto;\n    margin-right: auto;\n    width: 1024px;\n  }\n  @media (max-width: 600px) {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    margin-bottom: 2rem;\n    width: 100%;\n  }\n"])));
var StepContainer$7 = styled.div(_templateObject3$D || (_templateObject3$D = _taggedTemplateLiteralLoose(["\n  display: flex;\n  @media (min-width: 601px) {\n    min-height: 325px;\n    justify-content: space-between;\n    padding: 20px 50px 15px 50px;\n  }\n  @media (max-width: 600px) {\n    flex-direction: column;\n    padding: 10px;\n  }\n"])));
var StepInfoContainer$9 = styled.div(_templateObject4$C || (_templateObject4$C = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  @media (min-width: 601px) {\n    position: relative;\n    padding: 10px 50px 15px 50px;\n  }\n  @media (max-width: 600px) {\n    padding: 5px;\n  }\n"])));
var DeviceImageContainer$5 = styled.div(_templateObject5$x || (_templateObject5$x = _taggedTemplateLiteralLoose(["\n  margin-top: 30px;\n  @media (min-width: 601px) {\n    margin-top: 40px;\n  }\n  @media (max-width: 600px) {\n    text-align: center;\n    margin-top: 30px;\n  }\n"])));
var DeviceImage$7 = styled.img(_templateObject6$t || (_templateObject6$t = _taggedTemplateLiteralLoose(["\n  width: auto;\n"])));
var HeadingTitle = styled.div(_templateObject7$p || (_templateObject7$p = _taggedTemplateLiteralLoose(["\n  font-size: 1.2rem;\n  line-height: 1.5rem;\n  font-family: Verizon-NHG-eDS;\n  color: #000000;\n  margin: 0;\n  text-decoration: none;\n  ol {\n    list-style-type: disc;\n    li {\n      margin: 10px 0;\n      line-height: 22px;\n    }\n  }\n"])));
var TitleWrapper$a = styled.div(_templateObject8$n || (_templateObject8$n = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  padding-top: 15px;\n  width: 100%;\n\n  div:last-child {\n    margin-left: auto;\n    margin-right: 10px;\n  }\n"])));
var TitleTextWrapper$9 = styled.div(_templateObject9$k || (_templateObject9$k = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  width: 95%;\n"])));
var HeadingWrapper$7 = styled.div(_templateObject0$i || (_templateObject0$i = _taggedTemplateLiteralLoose(["\n  width: 600px;\n  a {\n    color: black;\n    cursor: pointer;\n    // text-decoration: underline;\n    border-bottom: 1px solid black;\n  }\n  @media (max-width: 768px) {\n    width: auto;\n    font-size: 1rem;\n  }\n"])));
var Cancel$8 = styled.div(_templateObject1$i || (_templateObject1$i = _taggedTemplateLiteralLoose(["\n  min-height: 1rem;\n  min-width: 1rem;\n  @media (min-width: 601px) {\n    margin-right: 10px;\n  }\n  @media (max-width: 600px) {\n    margin-left: 5px;\n  }\n"])));
var ButtonWrapper$f = styled.div(_templateObject10$d || (_templateObject10$d = _taggedTemplateLiteralLoose(["\n  padding-bottom: 25px;\n  @media screen and (max-width: 600px) {\n    display: none;\n  }\n"])));
var ButtonWrapperMobile$9 = styled.div(_templateObject11$a || (_templateObject11$a = _taggedTemplateLiteralLoose(["\n  width: 50%;\n  margin: 0px auto;\n  @media screen and (min-width: 600px) {\n    display: none;\n  }\n"])));
var DisplayList$2 = styled.div(_templateObject12$9 || (_templateObject12$9 = _taggedTemplateLiteralLoose(["\n  @media (min-width: 601px) {\n    padding: 20px 5px 15px 0px;\n  }\n  @media (max-width: 600px) {\n    padding: 15px 0px 15px 0px;\n  }\n"])));
var ExtenderBlock = styled.div(_templateObject13$9 || (_templateObject13$9 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;  \n  align-items: center;\n  width: 100%;  \n  @media (max-width: 600px) {\n    justify-content: center;\n  }\n"])));
var EachExtender = styled.div(_templateObject14$8 || (_templateObject14$8 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  height: 265px;\n  width: 230px;\n  padding: 20px;\n  border: 1px solid lightgray;\n  justify-content: space-evenly;\n  align-items: center;\n  font-size: 24px;\n  cursor: pointer;\n"])));
var SubTitleContent$2 = styled.div(_templateObject15$8 || (_templateObject15$8 = _taggedTemplateLiteralLoose(["\n  font-weight: 800;\n  color: #747676;\n  font-size: 1rem;\n"])));
var ToolTipWrapper = styled.div(_templateObject16$7 || (_templateObject16$7 = _taggedTemplateLiteralLoose(["    \n  @media (min-width: 601px) {\n    position: absolute;\n    bottom: 0;\n    span {\n      span {\n\n      }\n    }\n  }\n  @media (max-width: 600px) {\n    margin-top: 15px;\n  }\n"])));
var ConnectivityWrap$2 = styled.div(_templateObject17$7 || (_templateObject17$7 = _taggedTemplateLiteralLoose(["\n  display: flex;\n"])));
var Symbol$3 = styled.div(_templateObject18$7 || (_templateObject18$7 = _taggedTemplateLiteralLoose(["\n \n  margin-right: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var ConnectivityContent$2 = styled.div(_templateObject19$6 || (_templateObject19$6 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  .value {\n    text-transform: uppercase;\n  }\n"])));
var getExtenderImage = function getExtenderImage(hostName) {
  switch (hostName.toLowerCase()) {
    case "regular extender":
      return RegularExtender;
    case "mini extender":
      return MiniExtender;
    case "third party extender":
      return ThirdPartyExtender;
  }
};
var Extender = function Extender(props) {
  console.log("comren: Extender");
  var _props$values = props.values,
    values = _props$values === void 0 ? {} : _props$values,
    _props$functions = props.functions,
    functions = _props$functions === void 0 ? {} : _props$functions;
  var _values$landingInfo = values.landingInfo,
    landingInfo = _values$landingInfo === void 0 ? {} : _values$landingInfo,
    _values$symptom = values.symptom,
    symptom = _values$symptom === void 0 ? {} : _values$symptom,
    _values$troubleShooti = values.troubleShootingInfo,
    troubleShootingInfo = _values$troubleShooti === void 0 ? {} : _values$troubleShooti;
  var issueName = symptom.issueName;
  var _useState = useState(false);
  var output = getObjectPropertyByPath("ddata.output", troubleShootingInfo, {});
  var listOfDevices = getListOfDevices(output);
  var context = getObjectPropertyByPath("context", troubleShootingInfo, {});
  var _output$pageContent = output.pageContent,
    pageContent = _output$pageContent === void 0 ? {} : _output$pageContent,
    _output$navHist = output.navHist,
    navHist = _output$navHist === void 0 ? [] : _output$navHist,
    currentPageId = output.currentPageId,
    prevStepEnabled = output.prevStepEnabled,
    nextStepEnabled = output.nextStepEnabled;
  var disabledBtnPrev = false;
  var disabledBtnNext = false;
  if (!prevStepEnabled) {
    disabledBtnPrev = true;
  }
  if (!nextStepEnabled) {
    disabledBtnNext = true;
  }
  var _pageContent$steps = pageContent.steps,
    steps = _pageContent$steps === void 0 ? [] : _pageContent$steps;
  var analysis = getStepByName("analysis", steps);
  var resolution = getStepByName("resolution", steps);
  var closure = getStepByName("closure", steps);
  var buttons = analysis.cta || closure.cta || [];
  if (analysis.templateId == "NETWORK_GOOD_GOTO_EXTENDER_TYPE" || analysis.templateId == "NETWORK_GOOD_CANT_FIND_EXTENDER_TYPE") {
    var buttonsObj = analysis && analysis.cta[1] || null;
    buttons = buttonsObj ? [buttonsObj] : [];
  }
  var pageTitle = analysis && analysis.title || closure && closure.title;
  var analysisHeading = analysis && analysis.heading || closure && closure.heading || "";
  var analysisSubHeading = analysis && analysis.subHeading || closure && closure.subHeading || "";
  var analysisDescription = analysis && analysis.description || closure && closure.description || "";
  var analysisSideNote = analysis && analysis.sidenote || closure && closure.sidenote || "";
  var deviceTitle = analysis && analysis.userDeviceData && analysis.userDeviceData.title || closure && closure.userDeviceData && closure.userDeviceData.title;
  var image = analysis && analysis.image || closure && closure.image;
  var _landingInfo$device = landingInfo.device,
    device = _landingInfo$device === void 0 ? {} : _landingInfo$device;
  var is5GDevice = device.is5GDevice;
  useEffect(function () {
    if (is5GDevice && pageTitle && issueName && currentPageId) {
      taggingSetStepNameValue(pageTitle + "/" + issueName + "_" + currentPageId);
      console.log("analytics : step", pageTitle + "/" + issueName + "_" + currentPageId);
    }
    if (is5GDevice && issueName && currentPageId) {
      taggingSetPageValue(issueName + "_" + currentPageId);
      console.log("analytics : page", issueName + "_" + currentPageId);
    }
  }, [is5GDevice, pageTitle, issueName, currentPageId]);
  var handleCancel = function handleCancel() {
    console.log("SlowSpeedPage: handleCancel: called...");
    if (functions.handleCancel) {
      functions.handleCancel();
    }
  };
  var handleChecklistChange = function handleChecklistChange(value) {
    if (functions.handleReplayNavigation) {
      functions.handleReplayNavigation(value);
    }
  };
  var handleAction = function handleAction(button, macAddress) {
    console.log("Extender:handleAction: called with action: " + button.action);
    if (functions.handleTroubleShootingAction) {
      functions.handleTroubleShootingAction(button, {
        macAddress: macAddress
      });
    }
  };
  var renderPageTitle = /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TitleWrapper$a, null, /*#__PURE__*/React__default.createElement(TitleTextWrapper$9, null, /*#__PURE__*/React__default.createElement(Title, {
    size: "small"
  }, isMobile() ? ellipsis(pageTitle + "/" + issueName, 100) : ellipsis(pageTitle + "/" + issueName, 300))), /*#__PURE__*/React__default.createElement(Cancel$8, {
    "data-analyticstrack": "cancel - Icon",
    "data-testid": "Cancel",
    "data-track": "{ \"type\": \"link\", \"name\": \"cancel-Icon\" } ",
    "data-clickstream": "cancel - Icon",
    onClick: handleCancel
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "close",
    size: "large"
  }))));
  var renderChecklist = /*#__PURE__*/React__default.createElement(CheckList, {
    marginBottom: "0px",
    steps: navHist,
    onChange: function onChange(value) {
      return handleChecklistChange(value);
    },
    size: "100%",
    value: currentPageId
  });
  var renderTitle = function renderTitle() {
    if (pageTitle) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Title, {
        size: "large"
      }, /*#__PURE__*/React__default.createElement(HeadingWrapper$7, null, /*#__PURE__*/React__default.createElement(TextWithHtml, null, pageTitle))), /*#__PURE__*/React__default.createElement(HeightDiv, {
        margin: "3px"
      }));
    }
  };
  var renderHeading = function renderHeading(heading) {
    if (heading) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(HeadingTitle, null, /*#__PURE__*/React__default.createElement(Body, {
        size: "large"
      }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, heading))));
    }
  };
  var renderSubHeading = function renderSubHeading(subHeading) {
    if (subHeading) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Body, {
        size: "small"
      }, /*#__PURE__*/React__default.createElement(TextWithHtml, {
        id: "extra"
      }, subHeading)), /*#__PURE__*/React__default.createElement(HeightDiv, {
        margin: "5px"
      }));
    }
  };
  var renderDescription = function renderDescription(description) {
    if (description) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Body, {
        size: "small"
      }, /*#__PURE__*/React__default.createElement(TextWithHtml, {
        id: "extra"
      }, description)));
    }
  };
  var renderBottomTip = function renderBottomTip(description) {
    if (description) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ToolTipWrapper, null, /*#__PURE__*/React__default.createElement(ConnectivityWrap$2, null, /*#__PURE__*/React__default.createElement(Symbol$3, null, /*#__PURE__*/React__default.createElement(Tooltip, {
        title: /*#__PURE__*/React__default.createElement(TextWithHtml, {
          id: "extra"
        }, description),
        size: "medium"
      })), /*#__PURE__*/React__default.createElement(ConnectivityContent$2, null, /*#__PURE__*/React__default.createElement(Body, {
        className: "value",
        size: "small"
      }, /*#__PURE__*/React__default.createElement(TextWithHtml, {
        id: "extra"
      }, description))))));
    }
  };
  var renderButtons = /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ButtonWrapper$f, null, /*#__PURE__*/React__default.createElement(ActionButtons, {
    buttons: buttons,
    showPrevious: true,
    showNext: true,
    stackButtons: isMobile(),
    disableNext: disabledBtnNext,
    disablePrevious: disabledBtnPrev,
    pageId: currentPageId,
    handleAction: handleAction,
    handlePrevious: function handlePrevious(value) {
      return handleChecklistChange(value);
    },
    handleNext: function handleNext(value) {
      return handleChecklistChange(value);
    }
  })), /*#__PURE__*/React__default.createElement(ButtonWrapperMobile$9, null, /*#__PURE__*/React__default.createElement(ActionButtons, {
    buttons: buttons,
    stackButtons: isMobile(),
    handleAction: handleAction
  }), /*#__PURE__*/React__default.createElement(ActionButtons, {
    showPrevious: true,
    showNext: true,
    disableNext: disabledBtnNext,
    disablePrevious: disabledBtnPrev,
    pageId: currentPageId,
    handlePrevious: function handlePrevious(value) {
      return handleChecklistChange(value);
    },
    handleNext: function handleNext(value) {
      return handleChecklistChange(value);
    }
  })));
  var renderDeviceImageContainer = function renderDeviceImageContainer() {
    if (image) {
      return /*#__PURE__*/React__default.createElement(DeviceImageContainer$5, null, /*#__PURE__*/React__default.createElement(DeviceImage$7, {
        alt: "Device",
        src: image,
        style: window.innerWidth < 601 ? {
          objectFit: "cover",
          width: "74%",
          height: "82%"
        } : {
          width: "100%"
        }
      }));
    }
  };
  var getName = function getName(singleExtender) {
    var _Object$entries$filte;
    return (_Object$entries$filte = Object.entries(singleExtender).filter(function (info) {
      return info[0] === "Host Name";
    })[0]) === null || _Object$entries$filte === void 0 ? void 0 : _Object$entries$filte[1];
  };
  var renderSingleExtender = function renderSingleExtender(singleExtender) {
    var hostName;
    return Object.entries(singleExtender).map(function (info, index) {
      if (info[0] === "Host Name") {
        if (info[0] === "Host Name") {
          hostName = info[1];
        }
        return /*#__PURE__*/React__default.createElement(Fragment, {
          key: index
        }, info[0] === "Host Name" ? /*#__PURE__*/React__default.createElement("div", null, info[1]) : null, /*#__PURE__*/React__default.createElement(DeviceImage$7, {
          alt: "Device",
          src: getExtenderImage(hostName),
          style: {
            objectFit: "cover",
            width: "auto",
            height: "auto"
          }
        }));
      }
    });
  };
  var renderExtenderDeviceList = function renderExtenderDeviceList() {
    if (listOfDevices.length > 0) {
      return listOfDevices.filter(function (singleExtender, index) {
        return singleExtender['Host Name'] !== "Table Top Extender";
      }).map(function (singleExtender, index) {
        var button = {
          label: getName(singleExtender),
          action: "Pair",
          type: "",
          url: "",
          callFunction: ""
        };
        return /*#__PURE__*/React__default.createElement(EachExtender, {
          key: index,
          "data-testid": "eachExtender",
          onClick: function onClick() {
            return handleAction(button, getName(singleExtender));
          },
          className: "eachBlock"
        }, renderSingleExtender(singleExtender));
      });
    }
  };
  var renderDeviceTitle = /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Title, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(SubTitleContent$2, null, " ", deviceTitle, " ")), /*#__PURE__*/React__default.createElement(HeightDiv, {
    margin: "15px"
  }));
  var renderMainTamplate = function renderMainTamplate() {
    if (analysis.templateId !== "NETWORK_GOOD_GOTO_EXTENDER_TYPE" && analysis.templateId !== "NETWORK_GOOD_CANT_FIND_EXTENDER_TYPE") {
      return /*#__PURE__*/React__default.createElement(Fragment, null, renderHeading(analysisHeading), renderSubHeading(analysisSubHeading), renderDescription(analysisDescription), renderBottomTip(analysisSideNote), /*#__PURE__*/React__default.createElement(HeightDiv, {
        margin: "10px"
      }));
    }
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ContentWrapper$f, null, renderPageTitle, /*#__PURE__*/React__default.createElement(StepContainer$7, {
    id: "stepContainer"
  }, /*#__PURE__*/React__default.createElement(StepInfoContainer$9, null, renderChecklist, analysis.templateId !== "NETWORK_GOOD_GOTO_EXTENDER_TYPE" && analysis.templateId !== "NETWORK_GOOD_CANT_FIND_EXTENDER_TYPE" && renderDeviceTitle, renderTitle(), renderMainTamplate(), analysis.templateId === "NETWORK_GOOD_CANT_FIND_EXTENDER_TYPE" && /*#__PURE__*/React__default.createElement(DisplayList$2, null, /*#__PURE__*/React__default.createElement(ExtenderBlock, null, renderExtenderDeviceList())), analysis.templateId === "NETWORK_GOOD_GOTO_EXTENDER_TYPE" && /*#__PURE__*/React__default.createElement(DeviceList$1, {
    buttons: analysis.cta,
    handleAction: handleAction,
    listOfDevices: listOfDevices,
    templateId: analysis.templateId
  })), (analysis.templateId === "NETWORK_GOOD_GOTO_MINI_EXTENDER_WPS_PAIRING_PLUGIN" || analysis.templateId === "NETWORK_GOOD_GOTO_MINI_EXTENDER_WPS_PAIRING_BUTTON" || analysis.templateId === "NETWORK_GOOD_GOTO_MINI_EXTENDER_WPS_PAIRING_CONFIRM" || analysis.templateId === "NETWORK_GOOD_GOTO_REG_EXTENDER_WPS_PAIRING_PLUGIN" || analysis.templateId === "NETWORK_GOOD_GOTO_REG_EXTENDER_WPS_PAIRING_BUTTON" || analysis.templateId === "NETWORK_GOOD_GOTO_REG_EXTENDER_WPS_PAIRING_CONFIRM" || analysis.templateId === "NETWORK_GOOD_GOTO_REG_EXTENDER_ETHERNET_PAIRING_CABLE" || analysis.templateId === "NETWORK_GOOD_GOTO_REG_EXTENDER_ETHERNET_PAIRING_PAIR" || closure.templateId === "NETWORK_GOOD_MINI_EXTENDER_PAIRING_OK") && renderDeviceImageContainer()), renderButtons), /*#__PURE__*/React__default.createElement(FeedbackContainer, {
    functions: functions,
    values: values
  }));
};
Extender.propTypes = {
  functions: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
};
Extender.defaultProps = {};

var finalComps$5 = {
  styles: styledComps
};
finalComps$5 = {
  styles: styledDigital
};
var _finalComps$styles$4 = finalComps$5.styles,
  FeedbackCloseButton$7 = _finalComps$styles$4.FeedbackCloseButton,
  StyledModal$9 = _finalComps$styles$4.StyledModal,
  StyledModalBody$8 = _finalComps$styles$4.StyledModalBody;
var CompletionPageView = function CompletionPageView(props) {
  var _props$values3, _window2, _window2$_dg_channelI, _values$feedbackConta, _mvoTroubleShootingJs, _mvoTroubleShootingJs2, _props$functions2, _props$functions3, _window$tsFeatureFlag, _getIssueName, _configDetails$params, _configDetails$params2, _configDetails$params3, _configDetails$params4, _configDetails$params5;
  console.log('comren CompletionPageView', props);
  var _props$values = props.values,
    values = _props$values === void 0 ? {} : _props$values,
    _props$functions = props.functions,
    functions = _props$functions === void 0 ? {} : _props$functions;
  var configDetails = useContext(ConfigContext);
  var _useState = useState(''),
    deviceHealthData = _useState[0],
    setDeviceHealthData = _useState[1];
  var _useState2 = useState({
      showThumbsUp: false,
      showThumbsDown: false,
      thumbsClicked: false,
      submitClicked: false,
      rating: ''
    }),
    flags = _useState2[0],
    setFlags = _useState2[1];
  useEffect(function () {
    var _props$values2;
    setFlags(_extends({}, flags, props === null || props === void 0 ? void 0 : (_props$values2 = props.values) === null || _props$values2 === void 0 ? void 0 : _props$values2.flags));
  }, [props === null || props === void 0 ? void 0 : (_props$values3 = props.values) === null || _props$values3 === void 0 ? void 0 : _props$values3.flags]);
  var _values$landingInfo = values.landingInfo,
    landingInfo = _values$landingInfo === void 0 ? {} : _values$landingInfo,
    _values$troubleShooti = values.troubleShootingInfo,
    completionInfo = _values$troubleShooti === void 0 ? {} : _values$troubleShooti,
    _values$troubleShooti2 = values.troubleShootingInfo,
    troubleShootingInfo = _values$troubleShooti2 === void 0 ? {} : _values$troubleShooti2;
  var output = getObjectPropertyByPath('ddata.output', completionInfo, {});
  var currentPageId = output.currentPageId;
  var _landingInfo$device = landingInfo.device,
    device = _landingInfo$device === void 0 ? {} : _landingInfo$device;
  var imageUrl = device.imageUrl;
  var context = getObjectPropertyByPath("context", troubleShootingInfo, {});
  window.landingInfo = landingInfo;
  var _useMediaQuery = useMediaQuery(),
    isMobile = _useMediaQuery.isMobile,
    isDesktop = _useMediaQuery.isDesktop,
    isTablet = _useMediaQuery.isTablet;
  var _useState3 = useState({
      showModal: false,
      expandModal: false,
      modalType: 'feedback',
      isHowDoWeDo: true
    }),
    modalValues = _useState3[0],
    setModalValues = _useState3[1];
  var history = useHistory();
  var updateOmniDlObject = function updateOmniDlObject() {
    try {
      var _temp2 = function _temp2(_sessionUtility$getCa) {
        function _temp(_sessionUtility$getCa2) {
          var symptomId = intentId || (_sessionUtility$getCa2 === null || _sessionUtility$getCa2 === void 0 ? void 0 : _sessionUtility$getCa2.intentId);
          var stepTitle = 'End of TroubleShooting - Positive Completion';
          updateVzdl(issueName, symptomId, 'event116', stepTitle, currentPageId);
          sessionStorage.setItem('completionPage', 'true');
          triggerPageViewUpdateEvent('pageViewUpdate', 'event116');
        }
        var issueName = intent || (_sessionUtility$getCa === null || _sessionUtility$getCa === void 0 ? void 0 : _sessionUtility$getCa.intent);
        return intentId ? _temp(intentId) : Promise.resolve(sessionUtility.getCaseDetails()).then(_temp);
      };
      ['completionPage', 'processAction', 'processStep', 'troubleshootingDetails', 'mvoIntentSelected', 'mvoCaseId', 'mvoParentCategoryId'].forEach(function (key) {
        return sessionStorage.setItem(key, '');
      });
      document.body.addEventListener('keydown', handleCloseButtonEsc);
      if (!props.actionHappened) {
        window.scrollTo(0, 0);
      }
      var _configDetails$select = configDetails === null || configDetails === void 0 ? void 0 : configDetails.selectedNSAIntent,
        intent = _configDetails$select.intent,
        intentId = _configDetails$select.intentId;
      return Promise.resolve(intent ? _temp2(intent) : Promise.resolve(sessionUtility.getCaseDetails()).then(_temp2));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var handleDeviceHealthSessionData = function handleDeviceHealthSessionData() {
    var data = JSON.parse(sessionStorage.getItem('deviceHealthData') || '{}');
    setDeviceHealthData(data);
    sessionStorage.setItem('deviceHealthData', '');
  };
  useEffect(function () {
    try {
      var _props$values4, _props$values4$sympto, _configDetails$caseDe, _configDetails$select2;
      handleDeviceHealthSessionData();
      updateOmniDlObject();
      var page = "troubleshooter | " + ((props === null || props === void 0 ? void 0 : (_props$values4 = props.values) === null || _props$values4 === void 0 ? void 0 : (_props$values4$sympto = _props$values4.symptom) === null || _props$values4$sympto === void 0 ? void 0 : _props$values4$sympto.issueName) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$caseDe = configDetails.caseDetails) === null || _configDetails$caseDe === void 0 ? void 0 : _configDetails$caseDe.intent) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select2 = configDetails.selectedNSAIntent) === null || _configDetails$select2 === void 0 ? void 0 : _configDetails$select2.intent)) + " | Completion";
      window.vzdl.page = page;
      window.sendCustomEvent && window.sendCustomEvent('troubleshooting', window.vzdl);
    } catch (error) {
      console.error(error);
    }
  }, []);
  var modalChanged = function modalChanged(open) {
    if (!open) {
      if (props.handleAction) {
        props.handleAction({
          actionData: 'close'
        });
      }
      setModalValues(_extends({}, modalValues, {
        showModal: false
      }));
      if (!(flags.showThumbsDown || flags.showThumbsUp)) {
        setFlags(_extends({}, flags, {
          thumbsClicked: false,
          justAfterThumbsDownClicked: false
        }));
      }
    }
  };
  var handleCloseButtonEsc = function handleCloseButtonEsc(e) {
    console.log(e.key);
    if (e.key === 'Escape') {
      setModalValues(_extends({}, modalValues, {
        showModal: false,
        expandModal: false,
        isHowDoWeDo: false
      }));
    }
  };
  var handleActionDone = function handleActionDone() {
    try {
      var options = {
        label: 'doneRedirect'
      };
      if (functions.handleTroubleShootingAction) {
        var button = {
          action: "Done",
          callFunction: "",
          label: "Done",
          type: "secondary",
          url: ""
        };
        functions.handleTroubleShootingAction(button, options);
      }
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var redirectToBAU = function redirectToBAU() {
    try {
      if (props.combinedIssueSelector) {
        if (functions.redirectToCombinedIssueSelector) {
          functions.redirectToCombinedIssueSelector();
        } else {
          history === null || history === void 0 ? void 0 : history.goBack();
        }
      } else if (window.isMVODigital && window.isLoggedOut) {
        window.location.href = window.document.referrer;
      }
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var handleModalState = function handleModalState(flags) {
    setModalValues(_extends({}, modalValues, {
      showModal: true,
      expandModal: true,
      modalType: 'feedback',
      isHowDoWeDo: false
    }));
    setFlags(_extends({}, flags));
  };
  var handleFeedbackFlags = function handleFeedbackFlags(flags) {
    console.log('handleFeedbackFlags flags', flags);
    setFlags(_extends({}, flags));
  };
  var handleModalClick = function handleModalClick() {
    setModalValues(_extends({}, modalValues, {
      expandModal: true,
      modalType: 'feedback',
      isHowDoWeDo: false
    }));
  };
  var handleCloseButton = function handleCloseButton(e) {
    setModalValues(_extends({}, modalValues, {
      showModal: false
    }));
    setFlags(_extends({}, flags, {
      justAfterThumbsDownClicked: false,
      thumbsClicked: !!(e !== null && e !== void 0 && e.done)
    }));
  };
  if (sessionStorage.getItem('troubleshootingDetails') === '') {
    sessionStorage.setItem('troubleshootingDetails', JSON.stringify(window.caseDetails));
  }
  var troubleshootingDetails = JSON.parse(sessionStorage.getItem('troubleshootingDetails'));
  var troubleshootingDevice = JSON.parse(sessionStorage.getItem('troubleshootingDevice'));
  console.log('completionpage : ', troubleshootingDetails, troubleshootingDevice, props, configDetails);
  var getIssueName = function getIssueName() {
    var _configDetails$config, _configDetails$config2, _window;
    var issueName = (troubleshootingDetails === null || troubleshootingDetails === void 0 ? void 0 : troubleshootingDetails.intent) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config = configDetails.config) === null || _configDetails$config === void 0 ? void 0 : (_configDetails$config2 = _configDetails$config.caseDetails) === null || _configDetails$config2 === void 0 ? void 0 : _configDetails$config2.intent) || 'Title';
    issueName = (_window = window) !== null && _window !== void 0 && _window.hlthFlow && issueName === "undefined" ? deviceHealthData === null || deviceHealthData === void 0 ? void 0 : deviceHealthData.intent : issueName;
    return issueName;
  };
  var getTitle = function getTitle() {
    return context !== null && context !== void 0 && context.personalizedTitle ? context === null || context === void 0 ? void 0 : context.personalizedTitle : "";
  };
  var mvoTroubleShootingJson = sessionUtility.getTroubleShootingJson();
  console.log(modalValues.showModal);
  var isMVA = ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$_dg_channelI = _window2._dg_channelId) === null || _window2$_dg_channelI === void 0 ? void 0 : _window2$_dg_channelI.toLowerCase()) === "vzw-mfa" ? true : false;
  return /*#__PURE__*/React__default.createElement(Fragment, null, (_values$feedbackConta = values.feedbackContainerDetails) !== null && _values$feedbackConta !== void 0 && _values$feedbackConta.show && !(mvoTroubleShootingJson !== null && mvoTroubleShootingJson !== void 0 && (_mvoTroubleShootingJs = mvoTroubleShootingJson.ddata) !== null && _mvoTroubleShootingJs !== void 0 && (_mvoTroubleShootingJs2 = _mvoTroubleShootingJs.device) !== null && _mvoTroubleShootingJs2 !== void 0 && _mvoTroubleShootingJs2.is5GDevice) ? values.feedbackContainerDetails.success && values.feedbackContainerDetails.show ? /*#__PURE__*/React__default.createElement(Stack, {
    marginBottom: ['24px', '32px']
  }, /*#__PURE__*/React__default.createElement(FeedbackMessage, {
    values: values,
    closeFeedbackBar: (_props$functions2 = props.functions) === null || _props$functions2 === void 0 ? void 0 : _props$functions2.closeFeedbackBar
  })) : /*#__PURE__*/React__default.createElement(Stack, {
    marginBottom: ['24px', '32px']
  }, /*#__PURE__*/React__default.createElement(FeedbackBarError, {
    values: values,
    closeFeedbackBar: (_props$functions3 = props.functions) === null || _props$functions3 === void 0 ? void 0 : _props$functions3.closeFeedbackBar
  })) : null, /*#__PURE__*/React__default.createElement(Stack, {
    marginTop: isDesktop || isTablet ? "0px" : '16px'
  }, /*#__PURE__*/React__default.createElement(Stack, {
    gap: "32px"
  }, /*#__PURE__*/React__default.createElement(Title, {
    size: "XLarge",
    primitive: "h1",
    bold: false
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, (_window$tsFeatureFlag = window.tsFeatureFlags) !== null && _window$tsFeatureFlag !== void 0 && _window$tsFeatureFlag.enableRemovePrepaidStringFFlag ? removeTextFromString(getTitle(), 'Prepaid') : getTitle())), /*#__PURE__*/React__default.createElement(Stack, {
    flexDirection: isDesktop || isTablet ? "row" : 'column',
    justifyContent: "flex-start",
    marginBottom: "32px",
    gap: isDesktop || isTablet ? "12px" : '8px'
  }, /*#__PURE__*/React__default.createElement(Stack, {
    width: isMobile ? 'auto' : '641px'
  }, /*#__PURE__*/React__default.createElement(Box, {
    marginBottom: "32px"
  }, /*#__PURE__*/React__default.createElement(Title, {
    size: "medium",
    bold: true,
    primitive: "h2"
  }, "That's great to hear! Glad we could help with ", getIssueName() !== undefined || getIssueName() !== null ? (_getIssueName = getIssueName()) === null || _getIssueName === void 0 ? void 0 : _getIssueName.toLowerCase() : "", "."))), /*#__PURE__*/React__default.createElement(Stack, {
    gap: "10px",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : _configDetails$params.deviceName,
    src: imageUrl !== "" && imageUrl !== undefined && imageUrl !== null && imageUrl.indexOf("null") < 0 ? imageUrl : "https://www.verizon.com/content/dam/support/images_support/troubleshooting_guide/odi/ODI.png",
    id: "deviceImage",
    width: "131.34",
    height: "200"
  }), /*#__PURE__*/React__default.createElement(TextLink, {
    "data-track": '{"type": "link", "name": "Change Device"}',
    href: isMVA ? "/support/devices/?type=app" : "/support/devices"
  }, "Change device"))), /*#__PURE__*/React__default.createElement(Stack, {
    marginBottom: "32px"
  }, window.isMVODigital && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(FeedbackContainer, {
    functions: functions,
    values: values,
    handleModalState: handleModalState,
    flags: flags,
    page: "completePage"
  })))), /*#__PURE__*/React__default.createElement(Stack, null, /*#__PURE__*/React__default.createElement(Line$1, {
    type: "secondary"
  })), /*#__PURE__*/React__default.createElement(Stack, {
    marginTop: "32px",
    className: "marginResetFooter",
    textAlign: isDesktop || isTablet ? "left" : "center"
  }, /*#__PURE__*/React__default.createElement(ButtonGroup$1, {
    childWidth: '100%',
    viewport: 'desktop',
    rowQuantity: [{
      desktop: 2,
      tablet: 2,
      mobile: 1
    }],
    data: [{
      children: 'Done',
      size: 'large',
      use: 'primary',
      width: isDesktop || isTablet ? "auto" : "100%",
      "data-analyticstrack": "Done-btn",
      "data-track": 'done-btn',
      "data-clickstream": "done-troubleshooting-cta",
      onClick: function onClick() {
        handleActionDone();
      }
    }, {
      children: 'Troubleshoot another issue',
      size: 'large',
      use: 'textLink',
      width: "auto",
      onClick: function onClick() {
        redirectToBAU();
      }
    }]
  }))), modalValues.showModal && /*#__PURE__*/React__default.createElement(StyledModal$9, {
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params2 = configDetails.paramsDetails) !== null && _configDetails$params2 !== void 0 && (_configDetails$params3 = _configDetails$params2.theme) !== null && _configDetails$params3 !== void 0 && _configDetails$params3.isDark ? 'dark' : 'light',
    closeButton: /*#__PURE__*/React__default.createElement(FeedbackCloseButton$7, {
      tabIndex: "0",
      "data-analyticstrack": "overlay-generic-cta",
      "aria-label": "close",
      role: "button"
    }, /*#__PURE__*/React__default.createElement(Icon$1, {
      surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params4 = configDetails.paramsDetails) !== null && _configDetails$params4 !== void 0 && (_configDetails$params5 = _configDetails$params4.theme) !== null && _configDetails$params5 !== void 0 && _configDetails$params5.isDark ? 'dark' : 'light',
      id: "closeModal",
      name: "close",
      size: "large",
      tabIndex: "0",
      color: "#000000",
      backgroundColor: "transparent"
    }), ' '),
    onOpenedChange: modalChanged,
    opened: modalValues.showModal,
    zIndex: "15000",
    expandModal: modalValues.expandModal,
    disableOutsideClick: true,
    modalName: modalValues.modalType,
    maxHeight: "95vh"
  }, /*#__PURE__*/React__default.createElement(StyledModalBody$8, null, modalValues.modalType === 'feedback' && /*#__PURE__*/React__default.createElement(FeedbackContainerModal, {
    functions: functions,
    values: values,
    flags: flags,
    handleModalClick: handleModalClick,
    handleCloseButton: handleCloseButton,
    handleFeedbackFlags: handleFeedbackFlags,
    modalValues: modalValues
  }))));
};
CompletionPageView.propTypes = {
  functions: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
};
CompletionPageView.defaultProps = {};

var SmartSolutionIq = function SmartSolutionIq(props) {
  var _smartSolutionIq, _smartSolutionIq2, _smartSolutionIq2$dat;
  var smartAISolution = window.enableSmartIqSolutionFFlag;
  var smartSolutionIq = {};
  if (smartAISolution) {
    var responseData = props === null || props === void 0 ? void 0 : props.smartData;
    if (typeof responseData === 'string') {
      smartSolutionIq = JSON.parse(responseData);
    }
  }
  console.log('comren SmartSolution', props);
  var _useMediaQuery = useMediaQuery(),
    isDesktop = _useMediaQuery.isDesktop,
    isTablet = _useMediaQuery.isTablet;
  var SmartAccordion = function SmartAccordion(_ref) {
    var smartData = _ref.smartData;
    var title = smartData.title,
      _smartData$steps = smartData.steps,
      steps = _smartData$steps === void 0 ? [] : _smartData$steps;
    return /*#__PURE__*/React__default.createElement(Accordion$1, {
      topLine: false,
      bottomLine: true
    }, /*#__PURE__*/React__default.createElement(AccordionItem, null, /*#__PURE__*/React__default.createElement(AccordionHeader, {
      bold: true,
      "data-testid": "accordion-header"
    }, /*#__PURE__*/React__default.createElement(AccordionTitle, null, title)), /*#__PURE__*/React__default.createElement(AccordionDetail, null, /*#__PURE__*/React__default.createElement("ul", null, steps === null || steps === void 0 ? void 0 : steps.map(function (item) {
      return /*#__PURE__*/React__default.createElement("li", null, item);
    })))));
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Stack, {
    marginTop: isDesktop || isTablet ? "0px" : '16px'
  }, /*#__PURE__*/React__default.createElement(Stack, {
    gap: "32px"
  }, /*#__PURE__*/React__default.createElement(Title, {
    size: "medium",
    primitive: "h1",
    bold: false
  }, (_smartSolutionIq = smartSolutionIq) === null || _smartSolutionIq === void 0 ? void 0 : _smartSolutionIq.empatheticMessage), /*#__PURE__*/React__default.createElement(Stack, {
    flexDirection: 'column',
    justifyContent: "flex-start",
    marginBottom: "32px",
    gap: isDesktop || isTablet ? "12px" : '8px'
  }, (_smartSolutionIq2 = smartSolutionIq) === null || _smartSolutionIq2 === void 0 ? void 0 : (_smartSolutionIq2$dat = _smartSolutionIq2.data) === null || _smartSolutionIq2$dat === void 0 ? void 0 : _smartSolutionIq2$dat.map(function (smartData) {
    return /*#__PURE__*/React__default.createElement(SmartAccordion, {
      smartData: smartData
    });
  })))));
};
SmartSolutionIq.propTypes = {
  functions: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
};
SmartSolutionIq.defaultProps = {};

var _templateObject$Z, _templateObject2$M;
var LoaderSmart = styled.div(_templateObject$Z || (_templateObject$Z = _taggedTemplateLiteralLoose(["\n  border: 8px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 8px solid #000000;\n  width: 40px;\n  height: 40px;\n  -webkit-animation: spin 2s linear infinite; /* Safari */\n  animation: spin 2s linear infinite;\n  @-webkit-keyframes spin {\n    0% { -webkit-transform: rotate(0deg); }\n    100% { -webkit-transform: rotate(360deg); }\n }\n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n"])));
var LoaderSmartSmall = styled.div(_templateObject2$M || (_templateObject2$M = _taggedTemplateLiteralLoose(["\n  border: 6px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 8px solid #000000;\n  width: 25px;\n  height: 25px;\n  -webkit-animation: spin 2s linear infinite; /* Safari */\n  animation: spin 2s linear infinite;\n  @-webkit-keyframes spin {\n    0% { -webkit-transform: rotate(0deg); }\n    100% { -webkit-transform: rotate(360deg); }\n }\n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n"])));
var SmartSolution = function SmartSolution(props) {
  var _props$smartData, _props$smartData$data;
  var smartData = [];
  smartData = props === null || props === void 0 ? void 0 : (_props$smartData = props.smartData) === null || _props$smartData === void 0 ? void 0 : (_props$smartData$data = _props$smartData.data) === null || _props$smartData$data === void 0 ? void 0 : _props$smartData$data.Standard;
  var diagnosticArr = smartData !== null && smartData !== undefined ? Object.values(smartData) : [];
  var _useState = useState([]),
    progressArr = _useState[0],
    setProgressArr = _useState[1];
  var _useState2 = useState(0),
    progressKey = _useState2[0],
    setProgressKey = _useState2[1];
  console.log('comren SmartSolution', props);
  useEffect(function () {
    var timer = "";
    if (progressKey < diagnosticArr.length) {
      timer = setTimeout(updateRenderedThings, 4000);
    } else {
      clearInterval(timer);
    }
  }, [progressKey]);
  var updateRenderedThings = function updateRenderedThings() {
    var renderedThings = progressArr === null || progressArr === void 0 ? void 0 : progressArr.concat(diagnosticArr[progressKey]);
    setProgressKey(function (prev) {
      return prev + 1;
    });
    setProgressArr(renderedThings);
  };
  var runTheDiagnostic = function runTheDiagnostic(diagnosticData, index) {
    var _Object$keys, _Object$keys2;
    window.scrollTo({
      left: 0,
      top: progressKey == diagnosticArr.length ? 300 : 30 + index * 5,
      behavior: 'smooth'
    });
    return /*#__PURE__*/React__default.createElement(HStack, {
      alignItems: "start",
      marginBottom: "10px"
    }, /*#__PURE__*/React__default.createElement(Box, {
      width: ["70%", "25%"]
    }, /*#__PURE__*/React__default.createElement(Body, {
      size: "small"
    }, (_Object$keys = Object.keys(smartData)) === null || _Object$keys === void 0 ? void 0 : _Object$keys[index])), /*#__PURE__*/React__default.createElement(Box, {
      width: ["30%", "10%"],
      marginLeft: "5%",
      textAlign: ["right", "left"],
      justifyContent: "right",
      display: "flex"
    }, /*#__PURE__*/React__default.createElement(Body, {
      size: "small"
    }, progressKey - 1 === index && diagnosticArr.length !== progressKey ? /*#__PURE__*/React__default.createElement(LoaderSmartSmall, null) : renderIcon((_Object$keys2 = Object.keys(smartData)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2[index], diagnosticData))));
  };
  var renderIcon = function renderIcon(checks, diagnosticData) {
    var _diagnosticData$4GSi, _diagnosticData$4GSi2, _diagnosticData$Healt, _diagnosticData$Healt2, _diagnosticData$Enabl, _diagnosticData$Enabl2, _diagnosticData$Enabl3, _diagnosticData$Enabl4;
    switch (checks) {
      case "Network":
        var networkSignal = !isNaN(diagnosticData === null || diagnosticData === void 0 ? void 0 : (_diagnosticData$4GSi = diagnosticData["4G Signal"]) === null || _diagnosticData$4GSi === void 0 ? void 0 : _diagnosticData$4GSi.split(" ")[0]) ? diagnosticData === null || diagnosticData === void 0 ? void 0 : (_diagnosticData$4GSi2 = diagnosticData["4G Signal"]) === null || _diagnosticData$4GSi2 === void 0 ? void 0 : _diagnosticData$4GSi2.split(" ")[0] : false;
        return /*#__PURE__*/React__default.createElement(Icon$2, {
          name: networkSignal ? networkSignal > -105 && networkSignal < -85 ? "checkmark-alt" : "close-alt" : "close-alt",
          color: networkSignal ? networkSignal > -105 && networkSignal < -85 ? ColorTokens.feedback.success.onlight.value : ColorTokens.feedback.error.onlight.value : ColorTokens.feedback.error.onlight.value,
          size: "medium",
          ariaHidden: true
        });
      case "Battery":
        return /*#__PURE__*/React__default.createElement(Icon$2, {
          name: (diagnosticData === null || diagnosticData === void 0 ? void 0 : (_diagnosticData$Healt = diagnosticData.Health) === null || _diagnosticData$Healt === void 0 ? void 0 : _diagnosticData$Healt.toLowerCase()) === "good" ? "checkmark-alt" : "close-alt",
          color: (diagnosticData === null || diagnosticData === void 0 ? void 0 : (_diagnosticData$Healt2 = diagnosticData.Health) === null || _diagnosticData$Healt2 === void 0 ? void 0 : _diagnosticData$Healt2.toLowerCase()) === "good" ? ColorTokens.feedback.success.onlight.value : ColorTokens.feedback.error.onlight.value,
          size: "medium",
          ariaHidden: true
        });
      case "Wifi":
        return /*#__PURE__*/React__default.createElement(Icon$2, {
          name: (diagnosticData === null || diagnosticData === void 0 ? void 0 : (_diagnosticData$Enabl = diagnosticData.Enabled) === null || _diagnosticData$Enabl === void 0 ? void 0 : _diagnosticData$Enabl.toLowerCase()) === "yes" ? "checkmark-alt" : "close-alt",
          color: (diagnosticData === null || diagnosticData === void 0 ? void 0 : (_diagnosticData$Enabl2 = diagnosticData.Enabled) === null || _diagnosticData$Enabl2 === void 0 ? void 0 : _diagnosticData$Enabl2.toLowerCase()) === "yes" ? ColorTokens.feedback.success.onlight.value : ColorTokens.feedback.error.onlight.value,
          size: "medium",
          ariaHidden: true
        });
      case "Bluetooth":
        return /*#__PURE__*/React__default.createElement(Icon$2, {
          name: (diagnosticData === null || diagnosticData === void 0 ? void 0 : (_diagnosticData$Enabl3 = diagnosticData.Enabled) === null || _diagnosticData$Enabl3 === void 0 ? void 0 : _diagnosticData$Enabl3.toLowerCase()) === "yes" ? "checkmark-alt" : "close-alt",
          color: (diagnosticData === null || diagnosticData === void 0 ? void 0 : (_diagnosticData$Enabl4 = diagnosticData.Enabled) === null || _diagnosticData$Enabl4 === void 0 ? void 0 : _diagnosticData$Enabl4.toLowerCase()) === "yes" ? ColorTokens.feedback.success.onlight.value : ColorTokens.feedback.error.onlight.value,
          size: "medium",
          ariaHidden: true
        });
      default:
        return /*#__PURE__*/React__default.createElement(Icon$2, {
          name: "checkmark-alt",
          color: ColorTokens.feedback.success.onlight.value,
          size: "medium",
          ariaHidden: true
        });
    }
  };
  var loadDiagnosticData = function loadDiagnosticData() {
    return /*#__PURE__*/React__default.createElement(Fragment, null, progressArr === null || progressArr === void 0 ? void 0 : progressArr.map(function (diagnosticData, index) {
      return runTheDiagnostic(diagnosticData, index);
    }), !progressArr.length && /*#__PURE__*/React__default.createElement(Box, {
      width: ["100%", "60%"],
      "data-testid": "loader",
      justifyContent: "center",
      textAlign: "center",
      display: "flex"
    }, /*#__PURE__*/React__default.createElement(LoaderSmart, null)), progressKey >= diagnosticArr.length ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: "column",
        paddingBottom: "16px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        paddingBottom: "16px",
        paddingTop: "16px"
      }
    }, /*#__PURE__*/React__default.createElement(Body, {
      size: "large",
      bold: true
    }, "Start Here : Smart Solutions")), /*#__PURE__*/React__default.createElement(UnorderedList, null, /*#__PURE__*/React__default.createElement(ListItem$2, {
      size: "bodyMedium",
      spacing: "compact"
    }, "Make sure device is power cycled within the last 21 days"), /*#__PURE__*/React__default.createElement(ListItem$2, {
      size: "bodyMedium",
      spacing: "compact"
    }, "Power cycle the device."), /*#__PURE__*/React__default.createElement(ListItem$2, {
      size: "bodyMedium",
      spacing: "compact"
    }, "Please reset network settings (Settings  >  General  >  Reset  >  Reset Network Settings)."), /*#__PURE__*/React__default.createElement(ListItem$2, {
      size: "bodyMedium",
      spacing: "compact"
    }, "Enable mobile data in the device settings."), /*#__PURE__*/React__default.createElement(ListItem$2, {
      size: "bodyMedium",
      spacing: "compact"
    }, "Verify the device is connected to Wi-Fi."), /*#__PURE__*/React__default.createElement(ListItem$2, {
      size: "bodyMedium",
      spacing: "compact"
    }, "Please factory reset and attempt programming again."))), /*#__PURE__*/React__default.createElement(Stack, {
      alignItems: "center"
    }, /*#__PURE__*/React__default.createElement(Body, {
      size: "medium",
      bold: true
    }, "Still face the issue then start troubleshooting :"), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Button$1, {
      size: "large",
      surface: "light",
      disabled: false,
      use: "primary",
      width: "250px"
    }, "Start TroubleShooting"))) : null);
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, loadDiagnosticData());
};
SmartSolution.propTypes = {
  functions: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired
};
SmartSolution.defaultProps = {};

var qa1 = "https://mobile-exp-qa1-west-2.vzw.com";
var qa2 = "https://mobile-exp-qa2.vzw.com";
var qa3 = "https://mobile-exp-qa3.vzw.com";
var qa4 = "https://mobile-exp-qa4.vzw.com";
var qa5 = "https://mobile-exp-qa5.vzw.com";
var prod = "https://mobile-exp.vzw.com";
var getMVAHost = function getMVAHost() {
  var url = window.location.host;
  if (url.includes('qa1')) {
    return qa1;
  } else if (url.includes('qa2')) {
    return qa2;
  } else if (url.includes('qa3')) {
    return qa3;
  } else if (url.includes('qa4')) {
    return qa4;
  } else if (url.includes('qa5')) {
    return qa5;
  } else {
    return prod;
  }
};
function callFunc(title, pageType, isNative, webViewUrl, mtn) {
  var redir = sessionStorage.getItem('launchPageType');
  console.log("title: " + title + " pagetype: " + pageType + " isNative: " + isNative + " webviewurl: " + webViewUrl, 'before if condition');
  if (webViewUrl.toLowerCase().indexOf("/mva") > -1) {
    console.log("title: " + title + " pagetype: " + pageType + " isNative: " + isNative + " webviewurl: " + webViewUrl, ' inside if condition');
    if (isNative && redir) {
      console.log('Inside native && redir if', redir, isNative);
      var requestParamm = {};
      if (redir && redir == "managefiveGNetworks") {
        requestParamm.requestUrl = getMVAHost() + tsaEnvConfig$1().apiUrls.managefiveGNetworks;
        requestParamm.selectedMdn = mtn;
        console.log(requestParamm, 'Request Param in managefiveGNetworks cond');
        var json = {
          "actionType": "openPage",
          "title": title,
          "presentationStyle": "push",
          "tryToReplaceFirst": false,
          "disableAction": false,
          "pageType": redir,
          "appContext": "mobile/nsa/psecure/gw/5groutermgmt",
          "requestURL": requestParamm.requestUrl,
          "RequestParams": {
            "selectedMdn": requestParamm.selectedMdn
          }
        };
        console.log(json, "json in managefiveGNetworks cond");
      } else if (redir && redir == "moreTab5gHomeSupport") {
        requestParamm.requestUrl = getMVAHost() + tsaEnvConfig$1().apiUrls.moreTab5gHomeSupport;
        requestParamm.mdn = mtn;
        console.log(requestParamm, 'Request Param in moreTab5gHomeSupport cond');
        var json = {
          "actionType": "openPage",
          "title": title,
          "presentationStyle": "push",
          "tryToReplaceFirst": false,
          "disableAction": false,
          "pageType": redir,
          "appContext": "mobile/nsa/psecure/gw/5groutermgmt",
          "requestURL": requestParamm.requestUrl,
          "RequestParams": {
            "mdn": requestParamm.mdn
          }
        };
        console.log(json, "json in moreTab5gHomeSupport cond");
      } else if (redir && redir == "fiveGHomeLanding") {
        requestParamm.requestUrl = getMVAHost() + tsaEnvConfig$1().apiUrls.fiveGHomeLanding;
        console.log(requestParamm, 'Request Param in fiveGHomeLanding cond');
        var json = {
          "actionType": "openPage",
          "title": title,
          "presentationStyle": "push",
          "tryToReplaceFirst": false,
          "disableAction": false,
          "pageType": redir,
          "appContext": "mobile/nsa/psecure/gw/5groutermgmt",
          "requestURL": requestParamm.requestUrl
        };
        console.log(json, "json in fiveGHomeLanding cond");
      }
    } else if (isNative && !redir) {
      console.log('Inside isNative && !redir else if', redir, isNative);
      var json = {
        "actionType": "openPage",
        "title": title,
        "presentationStyle": "push",
        "tryToReplaceFirst": false,
        "disableAction": false,
        "pageType": pageType,
        "appContext": "mobile/nsa/psecure/gw/5groutermgmt"
      };
    } else {
      console.log('Inside else', redir, isNative);
      var json = {
        "actionType": "openUrl",
        "pageType": "openBrowser",
        "browserUrl": webViewUrl,
        "openInWebview": true
      };
    }
    if (window.webkit != undefined) {
      console.log('Inside window.webkit != undefined if');
      if (window.webkit.messageHandlers.mfAppInterface != undefined) {
        console.log('window.webkit.messageHandlers.mfAppInterface != undefined', json);
        window.webkit.messageHandlers.mfAppInterface.postMessage(json);
      }
      console.log('Line 61 Native');
    }
    if (window.mfAppInterface != undefined) {
      console.log('Inside window.mfAppInterface != undefined if', json);
      window.mfAppInterface.postMessage(json);
    }
  }
  console.log('Line 68 Native');
}

var notificationType = {
  yellow: 'warning',
  warning: 'warning',
  green: 'success',
  success: 'success',
  blue: 'info',
  info: 'info',
  brown: 'error',
  error: 'error'
};
var getNotificationButtons = function getNotificationButtons(item) {
  var buttons = [];
  if (item !== null && item !== void 0 && item.ctaLabel1 && item.ctaLabel1 !== '') {
    var btn1 = {
      children: item.ctaLabel1,
      href: item.ctaLink1
    };
    buttons.push(btn1);
  }
  if (item !== null && item !== void 0 && item.ctaLabel2 && item.ctaLabel2 !== '') {
    var btn2 = {
      children: item.ctaLabel2,
      href: item.ctaLink2
    };
    buttons.push(btn2);
  }
  return buttons;
};
var getNotificationType = function getNotificationType(color) {
  var _color;
  if (color === void 0) {
    color = 'info';
  }
  var type = (_color = color) === null || _color === void 0 ? void 0 : _color.toLowerCase();
  try {
    return notificationType[type];
  } catch (e) {
    return type;
  }
};
var AlertBanner = function AlertBanner(_ref) {
  var _ref$alertBannerConte = _ref.alertBannerContent,
    alertBannerContent = _ref$alertBannerConte === void 0 ? [] : _ref$alertBannerConte;
  var _useState = useState((alertBannerContent === null || alertBannerContent === void 0 ? void 0 : alertBannerContent.length) || 0),
    notifictionCount = _useState[0],
    setNotificaitonCount = _useState[1];
  var onClose = function onClose() {
    setNotificaitonCount(function (prev) {
      return prev - 1;
    });
  };
  if ((alertBannerContent === null || alertBannerContent === void 0 ? void 0 : alertBannerContent.length) === 0 || notifictionCount === 0) return null;
  return /*#__PURE__*/React__default.createElement(Stack, {
    maxWidth: "1232px",
    marginInline: "auto",
    gap: "12px",
    paddingBottom: "16px"
  }, alertBannerContent.map(function (item) {
    var buttons = getNotificationButtons(item);
    return /*#__PURE__*/React__default.createElement(Notification, {
      key: item.title,
      type: getNotificationType(item.colorType),
      title: item.title,
      subtitle: item.subTitle,
      buttonData: buttons,
      disableFocus: true,
      onCloseButtonClick: onClose
    });
  }));
};

var DescWrapperNew$4 = styledDigital.DescWrapperNew,
  DescInnerWrapper$4 = styledDigital.DescInnerWrapper,
  DescBodyWrapper$4 = styledDigital.DescBodyWrapper,
  StepOption$5 = styledDigital.StepOption,
  IssueBoxWrapper$4 = styledDigital.IssueBoxWrapper,
  IssueContentbox$4 = styledDigital.IssueContentbox,
  IssueContentArrow$4 = styledDigital.IssueContentArrow;
var IssueResolved = function IssueResolved(_ref) {
  var content = _ref.content,
    functions = _ref.functions;
  console.log("issueResolved data-->", content);
  var _content$ddata = content.ddata,
    _content$ddata2 = _content$ddata === void 0 ? {} : _content$ddata,
    _content$ddata2$outpu = _content$ddata2.output,
    _content$ddata2$outpu2 = _content$ddata2$outpu === void 0 ? {} : _content$ddata2$outpu,
    _content$ddata2$outpu3 = _content$ddata2$outpu2.pageContent,
    _content$ddata2$outpu4 = _content$ddata2$outpu3 === void 0 ? {} : _content$ddata2$outpu3,
    _content$ddata2$outpu5 = _content$ddata2$outpu4.steps,
    steps = _content$ddata2$outpu5 === void 0 ? [] : _content$ddata2$outpu5;
  console.log("issueResolved data-->", steps);
  var handleAction = function handleAction(event, choice) {
    var button = _extends({}, choice, {
      stopSubmitApiCall: true,
      target: "new_tab"
    });
    if (functions.handleTroubleShootingAction) {
      functions.handleTroubleShootingAction(button);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "issue-wrapper"
  }, steps.map(function (content) {
    var _content$questions = content.questions,
      questions = _content$questions === void 0 ? [] : _content$questions;
    var _ref2 = questions[0] || {},
      _ref2$question = _ref2.question,
      question = _ref2$question === void 0 ? "" : _ref2$question,
      _ref2$choices = _ref2.choices,
      choices = _ref2$choices === void 0 ? [] : _ref2$choices;
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(DescWrapperNew$4, null, /*#__PURE__*/React__default.createElement(DescInnerWrapper$4, null, /*#__PURE__*/React__default.createElement(DescBodyWrapper$4, null, /*#__PURE__*/React__default.createElement(Body, {
      size: "large",
      id: "content-description-data0",
      "data-testid": "content-description-data0"
    }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, content.description || ''))))), question && /*#__PURE__*/React__default.createElement("div", {
      className: "question",
      "data-testid": "question-container"
    }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, question)), choices.length > 0 && choices.map(function (choice) {
      return /*#__PURE__*/React__default.createElement(StepOption$5, {
        key: choice.text,
        onClick: function onClick(e) {
          return handleAction(e, choice);
        },
        "data-analyticstrack": choice.text,
        "data-track": "{\"type\": \"link\", \"name\": " + choice.text + "}",
        "data-clickstream": choice.text + "-link",
        "data-url": choice.url,
        role: "link",
        className: "toplink_steps"
      }, /*#__PURE__*/React__default.createElement(IssueBoxWrapper$4, {
        className: "toplink_steps_wrapper"
      }, /*#__PURE__*/React__default.createElement(IssueContentbox$4, null, choice.text && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Title, {
        size: "XSmall"
      }, choice.text)), /*#__PURE__*/React__default.createElement("div", {
        style: {
          paddingTop: '6px'
        }
      }, choice.description && /*#__PURE__*/React__default.createElement(Body, {
        size: "small"
      }, choice.description))), /*#__PURE__*/React__default.createElement(IssueContentArrow$4, null, ' ', /*#__PURE__*/React__default.createElement(Icon$1, {
        name: "right-arrow",
        size: "small",
        ariaHidden: true,
        tabIndex: "-100",
        color: "#000000",
        inverted: false
      }))));
    }));
  }));
};

var _templateObject$_;
var EotLoginBannerWrapper = styled.div(_templateObject$_ || (_templateObject$_ = _taggedTemplateLiteralLoose(["\n  @media (min-width:601px) {\n    padding: 0px 70px 0px 66px;\n  }\n  \n  @media (max-width: 600px) {\n    padding: 0 15px 0 15px;\n  }\n\n  margin-top: 15px;\n  margin-bottom: 15px;\n"])));
var EotSigninBanner = function EotSigninBanner() {
  var _useState = useState(false),
    showEotLoginSuccessBanner = _useState[0],
    setShowEotLoginSuccessBanner = _useState[1];
  var routes = location.hash.split('/');
  var isEotSecureFlow = routes.includes('eotsecure');
  var isMvoDigital = window.isMVODigital;
  useEffect(function () {
    if (isEotSecureFlow && isEmpty(window.eotBannerShown)) {
      window.eotBannerShown = true;
      setShowEotLoginSuccessBanner(true);
      setTimeout(function () {
        setShowEotLoginSuccessBanner(false);
      }, 3000);
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(Fragment, null, isMvoDigital && isEotSecureFlow && showEotLoginSuccessBanner && /*#__PURE__*/React__default.createElement(EotLoginBannerWrapper, null, /*#__PURE__*/React__default.createElement(Notification, {
    type: "success",
    title: "Now that you're signed in, you can explore personalized troubleshooting solutions.",
    fullBleed: false,
    inline: false,
    disableFocus: true
  })));
};

var breadCrumbHandler = function breadCrumbHandler(title, template, configDetails, values) {
  try {
    return Promise.resolve(sessionUtility.getTroubleShootingJson()).then(function (mvoTroubleShootingJson) {
      return Promise.resolve(sessionUtility.getMvoConfig()).then(function (mvoConfig) {
        return Promise.resolve(sessionUtility.getCaseDetails()).then(function (mvoCaseDetails) {
          var _lineInfo$;
          var breadCrumb;
          var _values$troubleShooti = values.troubleShootingInfo,
            troubleShootingInfo = _values$troubleShooti === void 0 ? {} : _values$troubleShooti,
            symptomId = values.symptomId;
          var output = getObjectPropertyByPath('ddata.output', troubleShootingInfo, {});
          var _output$pageContent = output.pageContent,
            pageContent = _output$pageContent === void 0 ? {} : _output$pageContent;
          var _pageContent$steps = pageContent.steps,
            steps = _pageContent$steps === void 0 ? [] : _pageContent$steps;
          var KBDocId = steps.map(function (e) {
            return e.templateId;
          }).join(',') || "";
          var lineInfo = getObjectPropertyByPath('context.lineInfo', troubleShootingInfo, {}) || [];
          var pageIdentifier = ((_lineInfo$ = lineInfo[0]) === null || _lineInfo$ === void 0 ? void 0 : _lineInfo$.pageIdentifier) || sessionStorage.getItem("solutionId");
          if (mvoTroubleShootingJson) {
            if (window.isBAUACSS) {
              var _ref = mvoTroubleShootingJson || {},
                _ref$ddata = _ref.ddata,
                _ref$ddata2 = _ref$ddata === void 0 ? {} : _ref$ddata,
                _ref$ddata2$device = _ref$ddata2.device,
                _ref$ddata2$device2 = _ref$ddata2$device === void 0 ? {} : _ref$ddata2$device,
                _ref$ddata2$device2$e = _ref$ddata2$device2.equipmentId,
                equipmentId = _ref$ddata2$device2$e === void 0 ? "" : _ref$ddata2$device2$e,
                _ref$ddata2$device2$d = _ref$ddata2$device2.deviceId,
                deviceId = _ref$ddata2$device2$d === void 0 ? "" : _ref$ddata2$device2$d;
              var _ref2 = mvoCaseDetails || {},
                _ref2$mtn = _ref2.mtn,
                mtn = _ref2$mtn === void 0 ? "" : _ref2$mtn,
                _ref2$accountNumber = _ref2.accountNumber,
                accountNumber = _ref2$accountNumber === void 0 ? "" : _ref2$accountNumber,
                _ref2$intent = _ref2.intent,
                intent = _ref2$intent === void 0 ? "" : _ref2$intent,
                _ref2$caseId = _ref2.caseId,
                caseId = _ref2$caseId === void 0 ? "" : _ref2$caseId;
              if (!(mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isLoggedOut) && mvoCaseDetails && mvoCaseDetails !== null && mvoCaseDetails !== void 0 && mvoCaseDetails.mtn) {
                breadCrumb = "MDN: " + mtn + "> Acct Num: " + accountNumber + "> Equipment ID: " + equipmentId + " > Location: TroubleshootingSteps, Symptom: " + intent + ",Solution Title: " + title + ", Solution ID: " + pageIdentifier + ", KB Doc ID: " + KBDocId + ", TSR ID: " + caseId + ", Device ID: " + deviceId;
              } else {
                breadCrumb = "MDN: > Acct Num: > Equipment ID: " + equipmentId + " > Location: TroubleshootingSteps, Symptom: " + intent + ",Solution Title: " + title + ", Solution ID: " + pageIdentifier + ", KB Doc ID: " + KBDocId + ", TSR ID: " + caseId + ", Device ID: " + deviceId;
              }
            } else {
              var _ref3 = configDetails || {},
                _ref3$paramsDetails = _ref3.paramsDetails,
                _ref3$paramsDetails2 = _ref3$paramsDetails === void 0 ? {} : _ref3$paramsDetails,
                _ref3$paramsDetails2$ = _ref3$paramsDetails2.accountNumber,
                _accountNumber = _ref3$paramsDetails2$ === void 0 ? "" : _ref3$paramsDetails2$,
                _ref3$paramsDetails2$2 = _ref3$paramsDetails2.mdn,
                mdn = _ref3$paramsDetails2$2 === void 0 ? "" : _ref3$paramsDetails2$2,
                _ref3$paramsDetails2$3 = _ref3$paramsDetails2.equipmentId,
                _equipmentId = _ref3$paramsDetails2$3 === void 0 ? "" : _ref3$paramsDetails2$3,
                _ref3$paramsDetails2$4 = _ref3$paramsDetails2.deviceId,
                _deviceId = _ref3$paramsDetails2$4 === void 0 ? "" : _ref3$paramsDetails2$4,
                _ref3$selectedNSAInte = _ref3.selectedNSAIntent,
                _ref3$selectedNSAInte2 = _ref3$selectedNSAInte === void 0 ? {} : _ref3$selectedNSAInte,
                _ref3$selectedNSAInte3 = _ref3$selectedNSAInte2.intent,
                _intent = _ref3$selectedNSAInte3 === void 0 ? "" : _ref3$selectedNSAInte3,
                _ref3$caseId = _ref3.caseId,
                _caseId = _ref3$caseId === void 0 ? "" : _ref3$caseId;
              var selectedMdnValue = troubleShootingInfo !== null && troubleShootingInfo !== void 0 && troubleShootingInfo.selectedMdn ? troubleShootingInfo.selectedMdn : mdn;
              if (!(mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isLoggedOut) && selectedMdnValue) {
                breadCrumb = "MDN: " + selectedMdnValue + "> Acct Num: " + _accountNumber + "> Equipment ID: " + _equipmentId + " > Location: TroubleshootingSteps, Symptom: " + _intent + ",Solution Title: " + title + ", Solution ID: " + pageIdentifier + ", KB Doc ID: " + KBDocId + ", TSR ID: " + _caseId + ", Device ID: " + _deviceId;
              } else {
                breadCrumb = "MDN: > Acct Num: > Equipment ID: " + _equipmentId + " > Location: TroubleshootingSteps, Symptom: " + _intent + ",Solution Title: " + title + ", Solution ID: " + pageIdentifier + ", KB Doc ID: " + KBDocId + ", TSR ID: " + _caseId + ", Device ID: " + _deviceId;
              }
            }
          }
          return breadCrumb;
        });
      });
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var feedbackDataHandler = function feedbackDataHandler(feedbackData, values, configDetails, page, trgDetails) {
  if (trgDetails === void 0) {
    trgDetails = {};
  }
  try {
    var _configDetails$params, _configDetails$params2;
    var _ref4 = values || {},
      _ref4$symptom = _ref4.symptom,
      symptom = _ref4$symptom === void 0 ? {} : _ref4$symptom;
    var internalFlag = false;
    var methodName = 'Feedback';
    var contactFlag = 'N';
    var user = (_configDetails$params = configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params2 = configDetails.paramsDetails) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.loggedInUser) != null ? _configDetails$params : 'customer';
    var feedbackSubject = (symptom === null || symptom === void 0 ? void 0 : symptom.issueName) || 'Troubleshooting Assistant External';
    var feedbackMessage = page == "error" ? "" + feedbackData : feedbackData.feedbackSubject + " | " + feedbackData.feedbackMessage;
    if (feedbackData !== null && feedbackData !== void 0 && feedbackData.aiSummary) {
      feedbackMessage = feedbackMessage + " | Gen AI Summary";
    }
    var location = 'Solutions Portal';
    var type = 'Suggestion';
    var anonymousFlowFlag = true;
    var title = localStorage.getItem('title') || 'feedback';
    var template = localStorage.getItem('template') || 'feedback';
    return Promise.resolve(breadCrumbHandler(title, template, configDetails, values)).then(function (breadCrumb) {
      var data = _extends({
        internalFlag: internalFlag,
        methodName: methodName,
        contactFlag: contactFlag,
        user: user,
        feedbackSubject: feedbackSubject,
        feedbackMessage: feedbackMessage,
        location: location,
        type: type,
        anonymousFlowFlag: anonymousFlowFlag,
        breadCrumb: breadCrumb
      }, window.isBAUACSS && trgDetails.email !== null && trgDetails.email !== undefined && {
        email: trgDetails.email
      });
      localStorage.removeItem('title');
      localStorage.removeItem('template');
      return data;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var feedbackDataHandlerDigital = function feedbackDataHandlerDigital(feedbackData, values, configDetails) {
  try {
    var feedbackMessage = feedbackData.feedbackSubject + " | " + feedbackData.feedbackMessage;
    var title = localStorage.getItem('title') || 'feedback';
    var template = localStorage.getItem('template') || 'feedback';
    return Promise.resolve(breadCrumbHandler(title, template, configDetails, values)).then(function (breadCrumb) {
      if (feedbackData !== null && feedbackData !== void 0 && feedbackData.aiSummary) {
        feedbackMessage = feedbackMessage + " | Gen AI Summary";
      }
      var data = {
        'internalFlag': false,
        'methodName': 'Feedback',
        'contactFlag': 'N',
        'user': 'customer',
        'feedbackSubject': 'Troubleshooting Assistant External',
        'feedbackMessage': feedbackMessage,
        'location': 'Solutions Portal',
        'type': 'Suggestion',
        'anonymousFlowFlag': true,
        'breadCrumb': breadCrumb
      };
      localStorage.removeItem('title');
      localStorage.removeItem('template');
      return data;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var _templateObject$$, _templateObject2$N, _templateObject3$E, _templateObject4$D, _templateObject5$y;
var OptionContainer = styled.div(_templateObject$$ || (_templateObject$$ = _taggedTemplateLiteralLoose(["\n    @media (min-width: 601px) {\n        width:50%; \n    } \n    div.question {\n        font-size: 1rem;\n        font-family: 'Verizon-NHG-eDS';\n        font-weight: 400;\n        line-height: 1.25rem;\n        letter-spacing: 0.03125rem;\n        text-decoration: none;\n        margin-bottom: 15px;\n        a { color: #428bca;  text-decoration : underline;}\n    }\n    @media(min-width:601px) {\n        column-fill: auto;\n        column-count: 1;\n        margin-bottom: 30px;\n        max-width: '100%';\n    }    \n    \n    [class^=\"LabelWrapper-VDS\"] {\n        font-weight: 400;\n    }\n\n    div.question {\n        font-size: 2rem;\n        font-family: 'Verizon-NHG-eDS';\n        font-weight: bold;\n        line-height: 2.5rem;\n        letter-spacing: 0.03125rem;\n        text-decoration: none;\n        padding-bottom:15px;\n    }\n\n    [class^=\"RadioButtonGroupWrapper-VDS\"] {\n        width:328px;\n    }\n"])));
var NrbWrapper = styled.div(_templateObject2$N || (_templateObject2$N = _taggedTemplateLiteralLoose(["\n    margin-top:40px;\n    @media (max-width: 600px) {\n        margin: 0 15px 0 15px;\n        min-height:75vh;\n        position:relative;\n        .continueBtn {\n            width: 100%;\n            vertical-align:bottom;\n            right:0;\n            left:0;\n            bottom:0;    \n        }    \n    }        \n    div.nrbTitleWrapper {\n    h1{\n          font-weight:400;\n          font-size:48px;\n          line-height:48px\n        }   \n        width:596px;\n        \n        padding: 20px 0 20px 0;\n        @media (max-width: 600px) {\n            padding: 25px 0 10px 0;\n            width:328px;\n            h1 { \n                 font-weight:700;\n                 font-size: 32px;\n                 line-height:36px;\n                 width:328px\n            }\n        }\n    }\n    .nrbTitlePb {\n        padding-bottom: 40px !important;\n        @media (max-width: 600px) {\n            padding-bottom: 20px !important;\n        }\n    }\n"])));
var NotificationWrapper = styled.div(_templateObject3$E || (_templateObject3$E = _taggedTemplateLiteralLoose(["\n        @media (max-width: 600px) {\n            margin-top:40px;\n        } "])));
var NrbContainer = styled.div(_templateObject4$D || (_templateObject4$D = _taggedTemplateLiteralLoose(["\n    @media (min-width: 601px) {\n        width:50%; \n    } \n    div.title {\n        font-size: 2rem;\n        font-family: 'Verizon-NHG-eDS';\n        font-weight: bold;\n        line-height: 2.5rem;\n        letter-spacing: 0.03125rem;\n        text-decoration: none;\n        padding-bottom:15px;\n    }\n    div.description {\n        font-size: 1rem;\n        font-family: 'Verizon-NHG-eDS';\n        font-weight: 400;\n        line-height: 1.25rem;\n        letter-spacing: 0.03125rem;\n        text-decoration: none;\n        margin-bottom: 10px;\n        a.ne-step-link{ color: #000000;  text-decoration : underline;font-size:16px;font-weight:400;line-height:20px;letter-spacing: 0.5px;height:20px; display:inline-block}\n        p.ne-content{color:#6F7171; font-size:24px; font-weight:400;line-height:28px;font-family: 'Verizon-NHG-eDS'; width:624px}\n        p.ne-content-qualify{color:#6F7171; font-size:24px; font-weight:400;line-height:28px;font-family: 'Verizon-NHG-eDS'; width:596px;height:100px;margin-top:10px}\n        p.ne-content-step{color:#000000;font-size:16px; font-weight:400; line-height:20px;letter-spacing: 0.5px; \n               width:432px;margin-bottom: 0px !important}\n\n        p.ne-blank-para{\n          margin-bottom:0rem;\n        }\n        @media (max-width: 600px) {\n            margin-bottom: 25px;\n            p.ne-content{\n               font-size:20px;\n               line-height:24px;\n               width:345px;\n\n            }\n\n            p.ne-content-qualify{\n               font-size:20px;\n               line-height:24px;\n               width:344px;\n               margin-top:0px;\n            }\n\n            p.ne-content-step{\n                 width:328px\n                  }\n\n        }  \n         \n       \n    }\n"])));
var LoaderWrapper$1 = styled.div(_templateObject5$y || (_templateObject5$y = _taggedTemplateLiteralLoose(["\n    top:50px;\n    left: 45%;\n    padding-top: 25px;\n    width: 50px;\n    position: relative;\n    z-index: 1;\n    @media (max-width: 600px) {\n        width: 40px;\n    }\n    & div {\n        & div {\n            width: 40px;\n            height: 40px;\n            border: 0.18rem solid #000000;\n            border-top-color: transparent;\n            @media (max-width: 600px) {\n                width: 35px;\n                height: 35px;\n            }\n        }\n    }\n"])));
var NetworkExtenderNrb = function NetworkExtenderNrb(props) {
  console.log("network nrb------", props);
  var current_location = useLocation();
  var current_url_pageId = current_location.pathname.split("/")[1];
  if (!current_url_pageId) current_url_pageId = 1;
  console.log("current_location++++++", current_location, current_url_pageId);
  var history = useHistory();
  var configDetails = useContext(ConfigContext);
  console.log("configDetails**********", configDetails);
  var _useState = useState([]),
    choicesAll = _useState[0],
    setChoicesAll = _useState[1];
  var _useState2 = useState(''),
    questionAll = _useState2[0],
    setQuestionAll = _useState2[1];
  var _useState3 = useState(''),
    nrbOptionVal = _useState3[0],
    setNrbOptionVal = _useState3[1];
  var _useState4 = useState(''),
    loaderImg = _useState4[0],
    setLoaderImg = _useState4[1];
  var _useState5 = useState(false),
    setContinueBtnDisabled = _useState5[1];
  var _useState6 = useState(false),
    showNotification = _useState6[0],
    setShowNotification = _useState6[1];
  var _useState7 = useState(''),
    nrbSolutionStepZero = _useState7[0],
    setNrbSolutionStepZero = _useState7[1];
  var _useState8 = useState(false),
    isContinueClicked = _useState8[0],
    setIsContinueClicked = _useState8[1];
  var _useState9 = useState(false),
    isEligibilityCheckDone = _useState9[0],
    setIsEligibilityCheckDone = _useState9[1];
  var _configDetails$config = configDetails === null || configDetails === void 0 ? void 0 : configDetails.config,
    _configDetails$config2 = _configDetails$config.networkExtenderOptions,
    networkExtenderOptions = _configDetails$config2 === void 0 ? {} : _configDetails$config2;
  var _useState0 = useState(''),
    updateContinueTrack = _useState0[0],
    setUpdateContinueTrack = _useState0[1];
  var _useState1 = useState({}),
    checkNbxResponse = _useState1[0],
    setCheckNbxRespnse = _useState1[1];
  console.log("getAddOfferData3====", nrbSolutionStepZero);
  var handleOptionsChange = function handleOptionsChange(e) {
    if (e.target.value === 'yes') {
      setUpdateContinueTrack('Go to network qualification');
    } else {
      setUpdateContinueTrack('Go to Repeater education');
    }
    setNrbOptionVal(e.target.value);
    setContinueBtnDisabled(false);
    setShowNotification(false);
  };
  var updateVZDL = function updateVZDL(errorPage) {
    var _window, _window$location;
    var routesArr = location.hash.split('/');
    var paramPageNum = routesArr[1];
    if (!paramPageNum) paramPageNum = "1";
    if (paramPageNum === "noteligibleforoffer") paramPageNum = "5";
    var pageNameTagging = '';
    var errorNotificationIdTagging = '';
    if (paramPageNum === "1") {
      pageNameTagging = 'Home Internet connection';
    } else if (paramPageNum === "2") {
      pageNameTagging = 'Network Extender Questionnaire';
      if (nrbOptionVal === '') {
        errorNotificationIdTagging = 'Please select one of this options to continue';
      }
    } else if (paramPageNum === "3") {
      pageNameTagging = 'Network Extender Qualification';
    } else if (paramPageNum === "4") {
      pageNameTagging = 'Repeater Education';
    } else if (paramPageNum === "5") {
      pageNameTagging = 'Error Page';
    }
    if (errorPage) {
      pageNameTagging = errorPage;
    }
    var taggingData = {
      page: {
        channel: 'Troubleshooting',
        displayChannel: 'VZW',
        sourceChannel: 'VZW',
        detail: '',
        flow: "Network troubleshooting assistant - " + window.flowType,
        subFlow: 'Mobile troubleshooting assistant',
        name: pageNameTagging,
        throttle: 'NSA',
        contentFragments: window.flowType,
        inApp: window._dg_channelId === "VZW-MFA" ? 'mva /mfa' : ''
      },
      target: {
        engagement: {
          intent: 'support'
        },
        message: errorNotificationIdTagging
      },
      env: {
        businessUnit: 'Wireless'
      },
      cmp: {
        smartLinkUrl: (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.href,
        smartLinkName: 'NetworkExtender 0$ Offer'
      }
    };
    return taggingData;
  };
  var updateContinuDataTrackVal = function updateContinuDataTrackVal(paramPageNum) {
    if (paramPageNum === "1") {
      setUpdateContinueTrack('Go to network questionnaire');
    } else if (paramPageNum === "3") {
      setUpdateContinueTrack('Go to Cart page/ error page');
    } else {
      setUpdateContinueTrack('Continue');
    }
  };
  useEffect(function () {
    var _current_location$sta;
    console.log("isContinueClicked++++", isContinueClicked);
    var routesArr = location.hash.split('/');
    console.log("routesArr*********", routesArr);
    var paramPageNum = routesArr[1];
    if (!paramPageNum) paramPageNum = "1";
    if (paramPageNum == "3" && current_location !== null && current_location !== void 0 && (_current_location$sta = current_location.state) !== null && _current_location$sta !== void 0 && _current_location$sta.data) {
      var _Object$keys, _current_location$sta2;
      if (((_Object$keys = Object.keys(current_location === null || current_location === void 0 ? void 0 : (_current_location$sta2 = current_location.state) === null || _current_location$sta2 === void 0 ? void 0 : _current_location$sta2.data)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0) {
        var _configDetails$params, _current_location$sta3;
        var getEnvData = {
          externalTarget: window.externalTarget,
          mvoenv: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : _configDetails$params.mvoenv
        };
        var getApiUrl = tsaEnvConfig$1(getEnvData).apiUrls.recommendFeedBackURL;
        var envData = {
          externalTarget: getApiUrl,
          mvoenv: process.env.NODE_ENV
        };
        recommendFeedBackAPI(current_location === null || current_location === void 0 ? void 0 : (_current_location$sta3 = current_location.state) === null || _current_location$sta3 === void 0 ? void 0 : _current_location$sta3.data, envData);
      }
    }
    if (!isContinueClicked) {
      setContinueBtnDisabled(false);
      if (paramPageNum === "noteligibleforoffer") paramPageNum = "5";
      var _networkExtenderOptio = networkExtenderOptions.cartUrl,
        cartUrl = _networkExtenderOptio === void 0 ? '' : _networkExtenderOptio;
      console.log("*******paramPageNum********", paramPageNum, cartUrl);
      setIsEligibilityCheckDone(false);
      if (parseInt(paramPageNum) === 3 && !cartUrl) {
        getErrorResponse();
      } else {
        console.log("-----if-----8");
        getNrbIntialLoad(paramPageNum);
      }
    }
    updateContinuDataTrackVal(paramPageNum);
    tagging.setPageView(updateVZDL());
    setIsContinueClicked(false);
  }, [current_url_pageId]);
  var displayErrorMesage = function displayErrorMesage(title, description) {
    var errorResponse = {
      "responseInfo": {
        "timeStamp": "21-02-2024 10:49:11",
        "correlationId": "123",
        "responseCode": "00",
        "responseMessage": "SUCCESS",
        "sectionErrors": []
      },
      "body": {
        "steps": [{
          "eotFlag": false,
          "templateId": "NBX_MVO_ERROR",
          "templateType": "customcontent",
          "title": "" + title,
          "description": "" + description,
          "skipSolution": false,
          "isHowToContent": false,
          "disableCTA": false,
          "pageId": "1"
        }]
      }
    };
    var nrbSolutionSteps = errorResponse.body.steps;
    var step_0 = nrbSolutionSteps[0] || {};
    setNrbSolutionStepZero(step_0);
    setChoicesAll([]);
    tagging.setPageView(updateVZDL('Error page'));
  };
  var getNbxErrorResponse = function getNbxErrorResponse() {
    var title = "Oops, looks like something went wrong.";
    var description = "<p>Unfortunately, we are unable to complete your order at this time. Please try again later.</p>";
    displayErrorMesage(title, description);
  };
  var getNEInResponse = function getNEInResponse() {
    var title = "You already have a Verizon LTE Network Extender offer in your shopping cart.";
    var description = "<p>Please checkout and complete your order first.</p>";
    displayErrorMesage(title, description);
  };
  var getErrorResponse = function getErrorResponse() {
    var errorResponse = {
      "responseInfo": {
        "timeStamp": "21-02-2024 10:49:11",
        "correlationId": "123",
        "responseCode": "00",
        "responseMessage": "SUCCESS",
        "sectionErrors": []
      },
      "body": {
        "steps": [{
          "eotFlag": false,
          "templateId": "LV_MVO_ERROR",
          "templateType": "customcontent",
          "title": "LV_MVO_ERROR",
          "description": "<p>Your request could not be processed at this time. Please try again later.</p>",
          "skipSolution": false,
          "isHowToContent": false,
          "disableCTA": false,
          "pageId": "1"
        }]
      }
    };
    var nrbSolutionSteps = errorResponse.body.steps;
    var step_0 = nrbSolutionSteps[0] || {};
    setNrbSolutionStepZero(step_0);
    setChoicesAll([]);
    tagging.setPageView(updateVZDL('Error page'));
  };
  var getNrbApiLoad = function getNrbApiLoad(paramPageId, isContinue, mtn, routesArr, proposition) {
    if (isContinue === void 0) {
      isContinue = false;
    }
    if (proposition === void 0) {
      proposition = {};
    }
    try {
      var _window$accountNumber, _window$_dg_channelId, _configDetails$params2;
      var nrbInitialPayload = {
        pageId: paramPageId.toString(),
        mtn: mtn,
        accountNumber: (_window$accountNumber = window.accountNumber) != null ? _window$accountNumber : '',
        src: window.flowType,
        channelId: (_window$_dg_channelId = window._dg_channelId) != null ? _window$_dg_channelId : ''
      };
      if (nrbOptionVal) {
        nrbInitialPayload.userSelection = nrbOptionVal;
      }
      var getEnvData = {
        externalTarget: window.externalTarget,
        mvoenv: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params2 = configDetails.paramsDetails) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.mvoenv
      };
      console.log(nrbInitialPayload, "getEnvData--3------", getEnvData);
      console.log("paramPageId-----", paramPageId);
      console.log("paramPageId-----", typeof paramPageId);
      var getApiUrl = tsaEnvConfig$1(getEnvData).apiUrls.getNrbURL;
      var envData = {
        externalTarget: getApiUrl,
        mvoenv: process.env.NODE_ENV
      };
      setLoaderImg(true);
      console.log("nrbInitialPayload++++++++++", nrbInitialPayload);
      return Promise.resolve(getNrbReq(nrbInitialPayload, envData)).then(function (nrbData) {
        console.log(nrbData === null || nrbData === void 0 ? void 0 : nrbData.success, "nrbData==", nrbData);
        if (nrbData !== null && nrbData !== void 0 && nrbData.success) {
          var _nrbSolutionSteps$fil;
          var _nrbData$response = nrbData.response,
            _nrbData$response2 = _nrbData$response === void 0 ? {} : _nrbData$response,
            _nrbData$response2$da = _nrbData$response2.data,
            _nrbData$response2$da2 = _nrbData$response2$da === void 0 ? {} : _nrbData$response2$da,
            _nrbData$response2$da3 = _nrbData$response2$da2.body,
            body = _nrbData$response2$da3 === void 0 ? {} : _nrbData$response2$da3;
          var nrbSolutionSteps = body.steps;
          var step_0 = nrbSolutionSteps[0] || {};
          setNrbSolutionStepZero(step_0);
          var questions = (_nrbSolutionSteps$fil = nrbSolutionSteps.filter(function (step) {
            return step === null || step === void 0 ? void 0 : step.questions;
          })[0]) === null || _nrbSolutionSteps$fil === void 0 ? void 0 : _nrbSolutionSteps$fil.questions;
          if (questions && questions.length > 0) {
            var questionObj = questions && questions[0] || {};
            var _questionObj$choices = questionObj.choices,
              choices = _questionObj$choices === void 0 ? [] : _questionObj$choices,
              _questionObj$question = questionObj.question,
              question = _questionObj$question === void 0 ? '' : _questionObj$question;
            setChoicesAll([].concat(choices));
            setQuestionAll(question);
          } else {
            setChoicesAll([]);
          }
          setLoaderImg(false);
          console.log(isContinue, "routesArr1======", routesArr, paramPageId);
          if (isContinue) {
            var _routesArr = location.hash.split('/');
            console.log("routesArr======", _routesArr);
            if (parseInt(paramPageId) === 3) {
              history.push({
                pathname: "/" + parseInt(paramPageId),
                state: {
                  data: proposition
                }
              });
            } else {
              history.push("/" + parseInt(paramPageId));
            }
          }
        } else {
          getErrorResponse();
        }
        setLoaderImg(false);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var chkMdnFound = function chkMdnFound(routesArr) {
    var foundMtn = {};
    if (window.mtnHash) {
      var _additionalMtns$find;
      var additionalMtns = (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns) || [];
      console.log(routesArr, "--routerArr--additionalMtns:", additionalMtns);
      console.log(routesArr, "--routerArr--additionalMtns:", additionalMtns, foundMtn);
      foundMtn = (_additionalMtns$find = additionalMtns.find(function (mtn) {
        return mtn.mtnHash == window.mtnHash;
      })) != null ? _additionalMtns$find : {};
    }
    return foundMtn;
  };
  var getNrbIntialLoad = function getNrbIntialLoad(paramPageId, isContinue, proposition) {
    if (isContinue === void 0) {
      isContinue = false;
    }
    if (proposition === void 0) {
      proposition = {};
    }
    try {
      var _temp5 = function _temp5() {
        function _temp3() {
          setLoaderImg(false);
        }
        console.log("offerEligibility^^^^^^^^^^^^^^", offerEligibility);
        var _temp2 = function () {
          if (routesArr[1] === "noteligibleforoffer") {
            return Promise.resolve(getNrbApiLoad(5, isContinue, mtn, routesArr)).then(function () {});
          } else {
            var _temp6 = function () {
              if (offerEligibility === "yes" || isEligibilityCheckDone) {
                console.log("@####");
                setIsEligibilityCheckDone(true);
                return Promise.resolve(getNrbApiLoad(paramPageId, isContinue, mtn, routesArr, proposition)).then(function () {});
              } else if (offerEligibility === "no") {
                var _routesArr2 = location.hash.split('/');
                console.log("routesArr======", _routesArr2);
                history.push("/noteligibleforoffer");
              } else if (offerEligibility === "error") {
                getErrorResponse();
              }
            }();
            if (_temp6 && _temp6.then) return _temp6.then(function () {});
          }
        }();
        return _temp2 && _temp2.then ? _temp2.then(_temp3) : _temp3(_temp2);
      };
      var routesArr = location.hash.split('/');
      var _ref = chkMdnFound(routesArr) || {},
        _ref$mtn = _ref.mtn,
        mtn = _ref$mtn === void 0 ? '' : _ref$mtn;
      console.log("paramPageId^^^^^^^^^^", paramPageId, mtn, configDetails);
      var offerEligibility;
      console.log("isEligibilityCheckDone++++++++", isEligibilityCheckDone);
      setLoaderImg(true);
      var _temp4 = function () {
        if (routesArr[1] !== "noteligibleforoffer" && !isEligibilityCheckDone) {
          var _configDetails$params3, _window$accountNumber2;
          var getEnvData = {
            externalTarget: window.externalTarget,
            mvoenv: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params3 = configDetails.paramsDetails) === null || _configDetails$params3 === void 0 ? void 0 : _configDetails$params3.mvoenv
          };
          console.log("getEnvData--4------", getEnvData);
          return Promise.resolve(chkOfferEligibility(mtn, (_window$accountNumber2 = window.accountNumber) != null ? _window$accountNumber2 : '', networkExtenderOptions === null || networkExtenderOptions === void 0 ? void 0 : networkExtenderOptions.accessoryId, getEnvData)).then(function (_chkOfferEligibility) {
            offerEligibility = _chkOfferEligibility;
          });
        }
      }();
      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp5) : _temp5(_temp4));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var handleNotificationClose = function handleNotificationClose() {
    setShowNotification(false);
  };
  var handleContinue = function handleContinue() {
    try {
      setNrbOptionVal("");
      if (parseInt(nrbSolutionStepZero.pageId) === 2 && nrbOptionVal === '') {
        setShowNotification(true);
        return Promise.resolve();
      }
      setLoaderImg(true);
      var getCurrentPageId = parseInt(nrbSolutionStepZero.pageId) + 1;
      console.log(parseInt(nrbSolutionStepZero.pageId), "------***********-----", nrbOptionVal);
      var _temp0 = function () {
        if (parseInt(nrbSolutionStepZero.pageId) === 2 && nrbOptionVal === 'no') {
          console.log(typeof getCurrentPageId, "-----if-----2", getCurrentPageId);
          setIsContinueClicked(true);
          return Promise.resolve(getNrbIntialLoad(4, true)).then(function () {});
        } else {
          var _temp1 = function () {
            if (parseInt(nrbSolutionStepZero.pageId) === 2 && nrbOptionVal === "yes") {
              var _configDetails$params4;
              setIsContinueClicked(true);
              var getEnvData = {
                externalTarget: window.externalTarget,
                mvoenv: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params4 = configDetails.paramsDetails) === null || _configDetails$params4 === void 0 ? void 0 : _configDetails$params4.mvoenv
              };
              return Promise.resolve(chkNBXEligibility(getEnvData)).then(function (nbxResponse) {
                var _nbxResponse$service, _nbxResponse$service$, _nbxResponse$service$2, _nbxResponse$service$3, _nbxResponse$service$4, _nbxResponse$service$5, _nbxResponse$service$6, _nbxResponse$service$7;
                var cardId = nbxResponse === null || nbxResponse === void 0 ? void 0 : (_nbxResponse$service = nbxResponse.service) === null || _nbxResponse$service === void 0 ? void 0 : (_nbxResponse$service$ = _nbxResponse$service.serviceBody) === null || _nbxResponse$service$ === void 0 ? void 0 : (_nbxResponse$service$2 = _nbxResponse$service$.serviceResponse) === null || _nbxResponse$service$2 === void 0 ? void 0 : (_nbxResponse$service$3 = _nbxResponse$service$2.containerList) === null || _nbxResponse$service$3 === void 0 ? void 0 : (_nbxResponse$service$4 = _nbxResponse$service$3[0]) === null || _nbxResponse$service$4 === void 0 ? void 0 : (_nbxResponse$service$5 = _nbxResponse$service$4.propositionList) === null || _nbxResponse$service$5 === void 0 ? void 0 : (_nbxResponse$service$6 = _nbxResponse$service$5.proposition) === null || _nbxResponse$service$6 === void 0 ? void 0 : (_nbxResponse$service$7 = _nbxResponse$service$6[0]) === null || _nbxResponse$service$7 === void 0 ? void 0 : _nbxResponse$service$7.cardId;
                if (cardId === undefined || cardId === null || cardId === "") {
                  getNbxErrorResponse();
                  setLoaderImg(false);
                } else {
                  var _nbxResponse$service2, _nbxResponse$service3, _nbxResponse$service4, _nbxResponse$service5, _nbxResponse$service6, _nbxResponse$service7;
                  var propostion = nbxResponse === null || nbxResponse === void 0 ? void 0 : (_nbxResponse$service2 = nbxResponse.service) === null || _nbxResponse$service2 === void 0 ? void 0 : (_nbxResponse$service3 = _nbxResponse$service2.serviceBody) === null || _nbxResponse$service3 === void 0 ? void 0 : (_nbxResponse$service4 = _nbxResponse$service3.serviceResponse) === null || _nbxResponse$service4 === void 0 ? void 0 : (_nbxResponse$service5 = _nbxResponse$service4.containerList) === null || _nbxResponse$service5 === void 0 ? void 0 : (_nbxResponse$service6 = _nbxResponse$service5[0]) === null || _nbxResponse$service6 === void 0 ? void 0 : (_nbxResponse$service7 = _nbxResponse$service6.propositionList) === null || _nbxResponse$service7 === void 0 ? void 0 : _nbxResponse$service7.proposition[0];
                  propostion.dispositionOptionId = "82";
                  setCheckNbxRespnse(propostion);
                  getNrbIntialLoad(getCurrentPageId, true, propostion);
                }
              });
            } else {
              var _temp10 = function () {
                if (parseInt(nrbSolutionStepZero.pageId) === 3) {
                  var _configDetails$params5, _window$accountNumber3;
                  console.log(typeof getCurrentPageId, "-----if-----3", getCurrentPageId);
                  var routesArr = location.hash.split('/');
                  var _ref2 = chkMdnFound(routesArr) || {},
                    _ref2$mtn = _ref2.mtn,
                    mtn = _ref2$mtn === void 0 ? '' : _ref2$mtn;
                  console.log("paramPageId^^^^^^^^^^foundMtn", mtn);
                  var _getEnvData = {
                    externalTarget: window.externalTarget,
                    mvoenv: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params5 = configDetails.paramsDetails) === null || _configDetails$params5 === void 0 ? void 0 : _configDetails$params5.mvoenv
                  };
                  console.log("getEnvData--1------", _getEnvData);
                  setLoaderImg(true);
                  if (Object.keys(checkNbxResponse).length) {
                    var _configDetails$params6;
                    var propostion = checkNbxResponse;
                    propostion.dispositionOptionId = "81";
                    var getEnvDataAPI = {
                      externalTarget: window.externalTarget,
                      mvoenv: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params6 = configDetails.paramsDetails) === null || _configDetails$params6 === void 0 ? void 0 : _configDetails$params6.mvoenv
                    };
                    var getApiUrl = tsaEnvConfig$1(getEnvDataAPI).apiUrls.recommendFeedBackURL;
                    var envData = {
                      externalTarget: getApiUrl,
                      mvoenv: process.env.NODE_ENV
                    };
                    recommendFeedBackAPI(propostion, envData);
                  }
                  return Promise.resolve(chkOfferEligibility(mtn, (_window$accountNumber3 = window.accountNumber) != null ? _window$accountNumber3 : '', networkExtenderOptions === null || networkExtenderOptions === void 0 ? void 0 : networkExtenderOptions.accessoryId, _getEnvData)).then(function (offerEligibility) {
                    var _temp7 = function () {
                      if (offerEligibility === "yes") {
                        var _window$accountNumber4;
                        console.log("getEnvData--2------", _getEnvData);
                        return Promise.resolve(chkAddOfferEligibility(mtn, (_window$accountNumber4 = window.accountNumber) != null ? _window$accountNumber4 : '', networkExtenderOptions, _getEnvData)).then(function (getAddOfferData) {
                          console.log("getAddOfferData===", getAddOfferData);
                          if (getAddOfferData === "yes") {
                            var CART_PARAM = "?pageName=cart";
                            window.open((networkExtenderOptions === null || networkExtenderOptions === void 0 ? void 0 : networkExtenderOptions.cartUrl) + CART_PARAM, "_self");
                            setTimeout(function () {
                              setLoaderImg(false);
                            }, 2500);
                          } else if (getAddOfferData === "isNEinCart") {
                            getNEInResponse();
                            setLoaderImg(false);
                          } else {
                            getNbxErrorResponse();
                            setLoaderImg(false);
                          }
                        });
                      } else if (offerEligibility === "no") {
                        var _routesArr3 = location.hash.split('/');
                        console.log("routesArr======", _routesArr3);
                        history.push("/noteligibleforoffer");
                        setLoaderImg(false);
                      } else if (getAddOfferData === "error") {
                        getNbxErrorResponse();
                        setLoaderImg(false);
                      }
                    }();
                    if (_temp7 && _temp7.then) return _temp7.then(function () {});
                  });
                } else {
                  setIsContinueClicked(true);
                  console.log(typeof getCurrentPageId, "-----if-----", getCurrentPageId);
                  return Promise.resolve(getNrbIntialLoad(getCurrentPageId, true)).then(function () {});
                }
              }();
              if (_temp10 && _temp10.then) return _temp10.then(function () {});
            }
          }();
          if (_temp1 && _temp1.then) return _temp1.then(function () {});
        }
      }();
      return Promise.resolve(_temp0 && _temp0.then ? _temp0.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var callVdsRadioBtn = function callVdsRadioBtn() {
    console.log("choicesAll===", choicesAll);
    if (choicesAll && choicesAll.length > 0) {
      var getRadioData = [];
      choicesAll.forEach(function (listItem, index) {
        return getRadioData.push({
          name: "nrbOptions",
          label: listItem.text,
          value: listItem.value,
          ariaLabel: listItem.text,
          disabled: false
        });
      });
      return /*#__PURE__*/React__default.createElement(RadioButtonGroup, {
        onChange: function onChange(e) {
          handleOptionsChange(e);
        },
        error: false,
        data: getRadioData,
        defaultValue: "-1",
        checked: false
      });
    }
  };
  var _ref3 = nrbSolutionStepZero != null ? nrbSolutionStepZero : {},
    _ref3$title = _ref3.title,
    title = _ref3$title === void 0 ? '' : _ref3$title,
    _ref3$templateId = _ref3.templateId,
    templateId = _ref3$templateId === void 0 ? '' : _ref3$templateId,
    _ref3$description = _ref3.description,
    description = _ref3$description === void 0 ? '' : _ref3$description;
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(NrbWrapper, null, loaderImg ? /*#__PURE__*/React__default.createElement(LoaderWrapper$1, null, /*#__PURE__*/React__default.createElement(Loader$2, {
    fullscreen: false,
    active: loaderImg,
    surface: "light"
  })) : /*#__PURE__*/React__default.createElement(Fragment, null, templateId === 'NE_QUAL_SPEED_MVO' && showNotification && /*#__PURE__*/React__default.createElement(NotificationWrapper, null, /*#__PURE__*/React__default.createElement(Notification, {
    title: "Please select an option to continue.",
    type: "error",
    fullBleed: false,
    inline: false,
    disableFocus: true,
    onCloseButtonClick: handleNotificationClose
  })), choicesAll.length === 0 && /*#__PURE__*/React__default.createElement(NrbContainer, null, /*#__PURE__*/React__default.createElement("div", {
    className: "nrbTitleWrapper"
  }, templateId !== 'LV_MVO_ERROR' && /*#__PURE__*/React__default.createElement(Title, {
    size: "XLarge",
    primitive: "h1"
  }, title)), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, description))), choicesAll.length > 0 && /*#__PURE__*/React__default.createElement(OptionContainer, null, /*#__PURE__*/React__default.createElement("div", {
    className: "nrbTitleWrapper nrbTitlePb"
  }, /*#__PURE__*/React__default.createElement(Title, {
    size: "XLarge",
    primitive: "h1"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, questionAll))), callVdsRadioBtn()), templateId !== 'NEOFFER_WELCOME_BACK' && templateId !== 'NE_NOQUAL_SPEED_MVO' && templateId !== 'NE_OFFER_NOT_ELIGIBLE' && templateId !== 'LV_MVO_ERROR' && templateId !== 'NBX_MVO_ERROR' && /*#__PURE__*/React__default.createElement(Button$1, {
    className: "continueBtn",
    size: "large",
    inverted: false,
    secondary: false,
    onClick: function onClick() {
      return handleContinue();
    },
    "data-track": updateContinueTrack
  }, "Continue"))));
};

var _templateObject$10, _templateObject2$O;
var NrbWrapper$1 = styled.div(_templateObject$10 || (_templateObject$10 = _taggedTemplateLiteralLoose(["  \n    margin-top:40px; \n    @media (max-width: 600px) {\n        margin: 0 15px 0 15px;        \n        .continueBtn {\n            width: 100%;\n            vertical-align:bottom;\n            margin-top: 40px;\n        } \n    }    \n    div.nrbTitleWrapper {\n        padding: 0px 0 20px 0;\n        @media (max-width: 600px) {\n            padding: 25px 0 10px 0;\n            h1 { font-weight:bold;}\n        }\n    }\n    .nrbTitlePb {\n        padding-bottom: 40px !important;\n        @media (max-width: 600px) {\n            padding-bottom: 20px !important;\n        }\n    }\n"])));
var NrbContainer$1 = styled.div(_templateObject2$O || (_templateObject2$O = _taggedTemplateLiteralLoose(["\n    @media (min-width: 601px) {\n        width:50%; \n    }\n    div.title {\n        font-size: 2rem;\n        font-family: 'Verizon-NHG-eDS';\n        font-weight: bold;\n        line-height: 2.5rem;\n        letter-spacing: 0.03125rem;\n        text-decoration: none;\n        padding-bottom:15px;\n    }\n    div.description {\n        font-size: 1rem;\n        font-family: 'Verizon-NHG-eDS';\n        font-weight: 400;\n        line-height: 1.75rem;\n        letter-spacing: 0.03125rem;\n        text-decoration: none;\n        margin-bottom: 15px;\n        a { color: #428bca;  text-decoration : underline;}\n        @media (max-width: 600px) {\n            p { padding: 5px 0 5px 0;  }\n        }        \n    }\n"])));
var NrbCheckOfferEligibility = function NrbCheckOfferEligibility(_ref) {
  var mtn = _ref.mtn,
    mvoenv = _ref.mvoenv,
    handleNrbLoader = _ref.handleNrbLoader;
  console.log("handleNrbLoader+++++++++++++", handleNrbLoader);
  var _useState = useState({}),
    nrbSolutionStepZero = _useState[0],
    setNrbSolutionStepZero = _useState[1];
  var renderCheckEligibility = function renderCheckEligibility() {
    try {
      var _temp2 = function _temp2() {
        var _troubleshootingDetai, _window$accountNumber, _window$_dg_channelId;
        var nrbInitialPayload = {
          pageId: "5",
          mtn: ((_troubleshootingDetai = troubleshootingDetails) === null || _troubleshootingDetai === void 0 ? void 0 : _troubleshootingDetai.mtn) || mtn,
          accountNumber: (_window$accountNumber = window.accountNumber) != null ? _window$accountNumber : '',
          src: 'vira',
          channelId: (_window$_dg_channelId = window._dg_channelId) != null ? _window$_dg_channelId : ''
        };
        var getEnvData = {
          externalTarget: window.externalTarget,
          mvoenv: mvoenv
        };
        console.log("getEnvData--3------", getEnvData);
        var getApiUrl = tsaEnvConfig$1(getEnvData).apiUrls.getNrbURL;
        var envData = {
          externalTarget: getApiUrl,
          mvoenv: process.env.NODE_ENV
        };
        console.log("nrbInitialPayload++++++++++", nrbInitialPayload);
        return Promise.resolve(getNrbReq(nrbInitialPayload, envData)).then(function (nrbData) {
          console.log(nrbData === null || nrbData === void 0 ? void 0 : nrbData.success, "nrbData==", nrbData);
          if (nrbData !== null && nrbData !== void 0 && nrbData.success) {
            var _nrbData$response = nrbData.response,
              _nrbData$response2 = _nrbData$response === void 0 ? {} : _nrbData$response,
              _nrbData$response2$da = _nrbData$response2.data,
              _nrbData$response2$da2 = _nrbData$response2$da === void 0 ? {} : _nrbData$response2$da,
              _nrbData$response2$da3 = _nrbData$response2$da2.body,
              body = _nrbData$response2$da3 === void 0 ? {} : _nrbData$response2$da3;
            var nrbSolutionSteps = body.steps;
            setNrbSolutionStepZero(nrbSolutionSteps[0] || {});
          } else {
            var errorResponse = {
              "responseInfo": {
                "timeStamp": "21-02-2024 10:49:11",
                "correlationId": "123",
                "responseCode": "00",
                "responseMessage": "SUCCESS",
                "sectionErrors": []
              },
              "body": {
                "steps": [{
                  "eotFlag": false,
                  "templateId": "LV_MVO_ERROR",
                  "templateType": "customcontent",
                  "title": "LV_MVO_ERROR",
                  "description": "<p>Your request could not be processed at this time. Please try again later.</p>",
                  "skipSolution": false,
                  "isHowToContent": false,
                  "disableCTA": false,
                  "pageId": "1"
                }]
              }
            };
            var _nrbSolutionSteps = errorResponse.body.steps;
            setNrbSolutionStepZero(_nrbSolutionSteps[0] || {});
          }
          handleNrbLoader(false);
          window.scrollTo({
            left: 0,
            top: 0,
            behavior: 'smooth'
          });
        });
      };
      var troubleshootingDetails;
      var _temp = function () {
        if (sessionStorage.getItem('troubleshootingDetails')) {
          return Promise.resolve(JSON.parse(sessionStorage.getItem('troubleshootingDetails'))).then(function (_JSON$parse) {
            troubleshootingDetails = _JSON$parse;
          });
        }
      }();
      return Promise.resolve(_temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  useEffect(function () {
    renderCheckEligibility();
  }, []);
  console.log("nrbSolutionStepZero***************", nrbSolutionStepZero);
  return /*#__PURE__*/React__default.createElement(NrbWrapper$1, null, /*#__PURE__*/React__default.createElement(NrbContainer$1, null, /*#__PURE__*/React__default.createElement("div", {
    className: "nrbTitleWrapper"
  }, /*#__PURE__*/React__default.createElement(Title, {
    size: "XLarge",
    primitive: "h1"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, nrbSolutionStepZero === null || nrbSolutionStepZero === void 0 ? void 0 : nrbSolutionStepZero.title))), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, /*#__PURE__*/React__default.createElement(Body, {
    size: "large"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, nrbSolutionStepZero === null || nrbSolutionStepZero === void 0 ? void 0 : nrbSolutionStepZero.description)))));
};

var redirectToIssueSelectorPage = function redirectToIssueSelectorPage(configDetails) {
  var _window, _window$config, _window$config$troubl, _window$config$troubl2, _window$config$troubl3;
  var _configDetails$additi = configDetails.additionalMtns,
    additionalMtns = _configDetails$additi === void 0 ? [] : _configDetails$additi;
  var seoUrl = (_window = window) === null || _window === void 0 ? void 0 : (_window$config = _window.config) === null || _window$config === void 0 ? void 0 : (_window$config$troubl = _window$config.troubleShootingJson) === null || _window$config$troubl === void 0 ? void 0 : (_window$config$troubl2 = _window$config$troubl.ddata) === null || _window$config$troubl2 === void 0 ? void 0 : (_window$config$troubl3 = _window$config$troubl2.device) === null || _window$config$troubl3 === void 0 ? void 0 : _window$config$troubl3.soeUrl;
  var mtnDetails = additionalMtns.find(function (mtn) {
    return mtn.seoUrl == seoUrl;
  });
  var combinedIssueSelectorUrl = !isEmpty(mtnDetails) ? mtnDetails.combinedIssueSelectorUrl : '';
  if (combinedIssueSelectorUrl) {
    window.location.href = combinedIssueSelectorUrl;
  } else {
    var currentPageUrl = window.location.href;
    var navigateToPage = currentPageUrl === null || currentPageUrl === void 0 ? void 0 : currentPageUrl.replace(/\/start\/.*/, '');
    window.location.href = navigateToPage;
  }
};
var redirectToBAU = function redirectToBAU(purpose) {
  if (purpose === void 0) {
    purpose = 'issue-selection';
  }
  try {
    return Promise.resolve(sessionUtility.getCaseDetails()).then(function (_ref) {
      var _ref$changeIssueUrl = _ref.changeIssueUrl,
        changeIssueUrl = _ref$changeIssueUrl === void 0 ? '' : _ref$changeIssueUrl,
        _ref$equipmentId = _ref.equipmentId,
        equipmentId = _ref$equipmentId === void 0 ? '' : _ref$equipmentId;
      var _ref2 = sessionUtility.getMvoConfig() || {},
        _ref2$isAcss = _ref2.isAcss,
        isAcss = _ref2$isAcss === void 0 ? false : _ref2$isAcss;
      if (isAcss) {
        redirectFormPostToUrl(changeIssueUrl, equipmentId, purpose);
      } else {
        window.location.href = changeIssueUrl;
      }
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var redirectToHealthCheckMFE = function redirectToHealthCheckMFE() {
  var _window2;
  var isRecommendedIssue = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.recIssue) || false;
  sessionStorage.setItem('deviceHealthData', JSON.stringify(_extends({}, JSON.parse(sessionStorage.getItem('deviceHealthData')), {
    isNavHistFlow: true,
    isRecommendedIssue: isRecommendedIssue
  })));
  var troubleshootingDevice = sessionStorage.getItem('troubleshootingDevice');
  if (!isEmpty(troubleshootingDevice)) {
    var _troubleshootingDevic, _troubleshootingDevic2;
    troubleshootingDevice = JSON.parse(troubleshootingDevice);
    var enCodedSkuId = encodeURIComponent(encodeURIComponent((_troubleshootingDevic = troubleshootingDevice) === null || _troubleshootingDevic === void 0 ? void 0 : _troubleshootingDevic.deviceSku));
    var healthCheckMFEUrl = "/digital/nsa/secure/ui/troubleshooting/devicehlth/" + ((_troubleshootingDevic2 = troubleshootingDevice) === null || _troubleshootingDevic2 === void 0 ? void 0 : _troubleshootingDevic2.soeUrl) + "/" + enCodedSkuId + "/mtn";
    window.location.href = healthCheckMFEUrl;
  }
};
var isChangeDeviceFlow = function isChangeDeviceFlow(configDetails) {
  var _configDetails$params = configDetails.paramsDetails,
    _configDetails$params2 = _configDetails$params === void 0 ? {} : _configDetails$params,
    _configDetails$params3 = _configDetails$params2.isLoggedOut,
    configIsLoggedOut = _configDetails$params3 === void 0 ? false : _configDetails$params3;
  var _ref3 = window || {},
    _ref3$hlthFlow = _ref3.hlthFlow,
    hlthFlow = _ref3$hlthFlow === void 0 ? false : _ref3$hlthFlow,
    _ref3$isLoggedOut = _ref3.isLoggedOut,
    isLoggedOut = _ref3$isLoggedOut === void 0 ? false : _ref3$isLoggedOut;
  if (hlthFlow || configIsLoggedOut || isLoggedOut) {
    return false;
  } else {
    var _window3, _window3$config, _window3$config$troub, _window3$config$troub2, _window3$config$troub3;
    var additionalMtns = (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns) || [];
    var seoUrl = (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$config = _window3.config) === null || _window3$config === void 0 ? void 0 : (_window3$config$troub = _window3$config.troubleShootingJson) === null || _window3$config$troub === void 0 ? void 0 : (_window3$config$troub2 = _window3$config$troub.ddata) === null || _window3$config$troub2 === void 0 ? void 0 : (_window3$config$troub3 = _window3$config$troub2.device) === null || _window3$config$troub3 === void 0 ? void 0 : _window3$config$troub3.soeUrl;
    var mtnDetails = additionalMtns.find(function (mtn) {
      return mtn.seoUrl == seoUrl;
    });
    return isEmpty(mtnDetails) ? true : false;
  }
};
var callAndSetNBXTroubleShooting = function callAndSetNBXTroubleShooting(techCoachEligible, envData, symptomId) {
  try {
    var troubleShootingNBXData = {};
    var paramsNBX = {
      "isTechCoachEligible": techCoachEligible ? "true" : "false",
      "isIntentId": symptomId
    };
    return Promise.resolve(troubleShootingNBXCall(paramsNBX, envData)).then(function (_troubleShootingNBXCa) {
      var _troubleShootingNBXDa, _troubleShootingNBXDa2, _troubleShootingNBXDa3, _troubleShootingNBXDa4, _troubleShootingNBXDa5, _troubleShootingNBXDa6, _troubleShootingNBXDa7, _troubleShootingNBXDa8, _troubleShootingNBXDa9, _containerList$;
      troubleShootingNBXData = _troubleShootingNBXCa;
      console.log("troubleShootingNBXData", JSON.stringify(troubleShootingNBXData));
      var containerList = (_troubleShootingNBXDa = troubleShootingNBXData) === null || _troubleShootingNBXDa === void 0 ? void 0 : (_troubleShootingNBXDa2 = _troubleShootingNBXDa.service) === null || _troubleShootingNBXDa2 === void 0 ? void 0 : (_troubleShootingNBXDa3 = _troubleShootingNBXDa2.serviceBody) === null || _troubleShootingNBXDa3 === void 0 ? void 0 : (_troubleShootingNBXDa4 = _troubleShootingNBXDa3.serviceResponse) === null || _troubleShootingNBXDa4 === void 0 ? void 0 : _troubleShootingNBXDa4.containerList;
      var pegaSessionId = (_troubleShootingNBXDa5 = troubleShootingNBXData) === null || _troubleShootingNBXDa5 === void 0 ? void 0 : (_troubleShootingNBXDa6 = _troubleShootingNBXDa5.service) === null || _troubleShootingNBXDa6 === void 0 ? void 0 : (_troubleShootingNBXDa7 = _troubleShootingNBXDa6.serviceBody) === null || _troubleShootingNBXDa7 === void 0 ? void 0 : (_troubleShootingNBXDa8 = _troubleShootingNBXDa7.serviceResponse) === null || _troubleShootingNBXDa8 === void 0 ? void 0 : (_troubleShootingNBXDa9 = _troubleShootingNBXDa8.contextInfo) === null || _troubleShootingNBXDa9 === void 0 ? void 0 : _troubleShootingNBXDa9.sessionId;
      var arrProposition = containerList ? (_containerList$ = containerList[0]) === null || _containerList$ === void 0 ? void 0 : _containerList$.propositionList : "";
      var _ref4 = arrProposition ? arrProposition : [],
        _ref4$proposition = _ref4.proposition,
        proposition = _ref4$proposition === void 0 ? [] : _ref4$proposition;
      sessionStorage.removeItem("propositionNBX");
      if (proposition.length) {
        console.log(proposition[0].propositionName);
        if (pegaSessionId) {
          proposition[0].pegaSessionId = pegaSessionId;
        }
        sessionStorage.setItem("propositionNBX", JSON.stringify(proposition[0]));
        return true;
      } else return false;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var showTopLine = function showTopLine(values) {
  var _ref5 = sessionUtility.getMvoConfig() || {},
    _ref5$isAcss = _ref5.isAcss,
    isAcss = _ref5$isAcss === void 0 ? false : _ref5$isAcss;
  var _ref6 = values || {},
    _ref6$activePage = _ref6.activePage,
    activePage = _ref6$activePage === void 0 ? "" : _ref6$activePage;
  return !isAcss && !window.isMVODigital && activePage !== 'main_symptom' && activePage !== 'account_issue' && !isMobile();
};
var getPageForTemplate = function getPageForTemplate(templateType, step, stepsArrayOfOne) {
  if (templateType === void 0) {
    templateType = '';
  }
  if (step === void 0) {
    step = {};
  }
  if (stepsArrayOfOne === void 0) {
    stepsArrayOfOne = {};
  }
  var page = 'unknown';
  switch (templateType) {
    case 'alert':
      page = 'account_issue';
      break;
    case 'analysis':
    case 'closure':
    case 'resolution':
    case 'customcontent':
    case 'Custom':
    case 'PROBING_QUESTIONS_IMAGE':
    case 'kbcontent':
    case 'reviewtechbulletin':
    case 'reviewopenalerts':
    case 'deviceforums':
    case 'ost':
    case 'searchsupportcontent':
    case 'instructionlink':
    case 'confirmcoverageinteractivemapinternal':
    case 'confirmcoverageinteractivemapretail':
    case 'systemchecksexternal':
    case 'systemchecksinternal':
    case 'networkcongestion':
      if (checkForEligibleTemplates(step, stepsArrayOfOne)) {
        page = 'extender';
      } else if (step.userDeviceData || step.templateId === 'TURN_ON_WIFI') {
        page = 'wifi';
      } else if (typeof step.devices === 'undefined' && stepsArrayOfOne.templateId === 'CONFIRM_DEVICE_SHOW_ACTIVE' && typeof stepsArrayOfOne.devices !== 'undefined') {
        page = 'trouble_shooting';
      } else if (step.templateId === 'WIFI_CPEA_ROUTER_GOOD_DYNAMIC_WIFI_DATA' && typeof step.devices === 'undefined' && stepsArrayOfOne.templateId === 'SELECT_DEVICE' && typeof stepsArrayOfOne.devices !== 'undefined') {
        page = 'trouble_shooting';
      } else if (step.templateId === 'WIFI_CPEA_ROUTER_GOOD_DYNAMIC_WIFI_DATA' || step.templateId === 'CONFIRM_DEVICE') {
        page = 'devices';
      } else {
        page = 'trouble_shooting';
      }
      break;
    case 'blackspot':
      page = 'blackspot';
      break;
    case 'diagnostics':
      page = 'diagnostics';
      break;
    case 'networkoutage':
      page = 'network_outage';
      break;
    case 'contactoptions-error':
    case 'contactoptions':
      page = 'contacts';
      break;
    case 'questionnaire':
      page = 'questions';
      break;
    case 'waitscreen':
      page = 'waitscreen';
      break;
    case 'congratulations_screen':
      page = 'completion';
      break;
    default:
      page = 'unknown';
      break;
  }
  return page;
};
var checkForEligibleTemplates = function checkForEligibleTemplates(step, stepsArrayOfOne) {
  if (step === void 0) {
    step = {};
  }
  if (stepsArrayOfOne === void 0) {
    stepsArrayOfOne = {};
  }
  if (step.hasOwnProperty('solutionSource') || stepsArrayOfOne.hasOwnProperty('solutionSource')) return false;
  var _step = step,
    _step$templateId = _step.templateId,
    templateId = _step$templateId === void 0 ? '' : _step$templateId;
  var eligibleTemplates = ['NETWORK_GOOD_GOTO_EXTENDER_TYPE', 'NETWORK_GOOD_CANT_FIND_EXTENDER_TYPE', 'NETWORK_GOOD_GOTO_MINI_EXTENDER_WPS_PAIRING_PLUGIN', 'NETWORK_GOOD_GOTO_MINI_EXTENDER_WPS_PAIRING_BUTTON', 'NETWORK_GOOD_GOTO_MINI_EXTENDER_WPS_PAIRING_CONFIRM', 'NETWORK_GOOD_GOTO_REG_EXTENDER_WPS_PAIRING_PLUGIN', 'NETWORK_GOOD_GOTO_REG_EXTENDER_WPS_PAIRING_BUTTON', 'NETWORK_GOOD_GOTO_REG_EXTENDER_WPS_PAIRING_CONFIRM', 'NETWORK_GOOD_GOTO_REG_EXTENDER_ETHERNET_PAIRING_CABLE', 'NETWORK_GOOD_GOTO_REG_EXTENDER_ETHERNET_PAIRING_PAIR', 'NETWORK_GOOD_GOTO_REG_EXTENDER_ETHERNET_PAIRING_CONFIRM', 'NETWORK_GOOD_MINI_EXTENDER_PAIRING_OK'];
  return eligibleTemplates.includes(templateId);
};
var getPageFromSteps = function getPageFromSteps(pageContent, callback) {
  var _pageContent$steps = pageContent.steps,
    steps = _pageContent$steps === void 0 ? [] : _pageContent$steps;
  var step = steps[0] || {};
  var stepsArrayOfOne = steps[1] || {};
  var templateType = step.templateType || '';
  if (step.templateId === 'BATTERYCHARGINGISSUES') {
    templateType = 'reviewtechbulletin';
  }
  if (step.templateId === 'DEVICE_FORUMS') {
    templateType = 'deviceforums';
  }
  if (step.templateId === 'searchsupportcontent') {
    templateType = 'searchsupportcontent';
  }
  var page = getPageForTemplate(templateType, step, stepsArrayOfOne);
  console.log('getPageFromSteps !!!!!!!!steps!!!!', steps, templateType, page);
  callback(templateType);
  return page;
};
var getpages = function getpages() {
  return [{
    id: 'main_symptom',
    previousPage: '',
    nextPage: 'questions'
  }, {
    id: 'questions',
    previousPage: 'main_symptom',
    nextPage: 'trouble_shooting'
  }, {
    id: 'trouble_shooting',
    previousPage: 'questions',
    nextPage: 'contacts'
  }, {
    id: 'contacts',
    previousPage: 'trouble_shooting',
    nextPage: ''
  }];
};
var getPageById = function getPageById(id) {
  var pages = getpages();
  var page = getpages()[0];
  pages.forEach(function (tmpPage) {
    if (tmpPage.id === id) {
      page = tmpPage;
    }
  });
  return page;
};
var setPageTitle = function setPageTitle(values, configDetails) {
  var _values$context, _configDetails$params4, _configDetails$params5;
  var newTitle = ((_values$context = values.context) === null || _values$context === void 0 ? void 0 : _values$context.personalizedTitle) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params4 = configDetails.paramsDetails) === null || _configDetails$params4 === void 0 ? void 0 : _configDetails$params4.deviceName) && "What is wrong with your " + (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params5 = configDetails.paramsDetails) === null || _configDetails$params5 === void 0 ? void 0 : _configDetails$params5.deviceName) + "?" || document.title;
  if (newTitle !== document.title && window.isMVODigital) {
    var element;
    element = document.querySelector('#pageTitle');
    if (!element) {
      element = document.createElement('div');
      element.style.position = 'fixed';
      element.style.top = '-100%';
      element.id = 'pageTitle';
      element.setAttribute('aria-live', 'polite');
      element.setAttribute('role', 'navigation');
      document.body.appendChild(element, document.body.firstChild);
    }
    element.textContent = newTitle;
    document.title = newTitle;
  }
};
var update4GVzdlPageAttributes = function update4GVzdlPageAttributes(pageAttributes) {
  try {
    pageAttributes.forEach(function (attr) {
      var _JSON$parse, _JSON$parse2;
      var attrArr = attr.itemMatch.split('.');
      if (!window.vzdl[attrArr[0]]) {
        window.vzdl[attrArr[0]] = {};
      }
      var mvoConfig = sessionUtility.getMvoConfig();
      if ((mvoConfig === null || mvoConfig === void 0 ? void 0 : mvoConfig._dg_channelId) == 'Care' && attr.itemKey == 'channelSession') {
        return;
      }
      if ((_JSON$parse = JSON.parse(sessionStorage.getItem('troubleshootingDevice'))) !== null && _JSON$parse !== void 0 && _JSON$parse.channelSession && ((_JSON$parse2 = JSON.parse(sessionStorage.getItem('troubleshootingDevice'))) === null || _JSON$parse2 === void 0 ? void 0 : _JSON$parse2.channelSession) !== '' && attrArr[0] === 'page' && attrArr[1] === 'channelSession') {
        var _JSON$parse3;
        window.vzdl['page']['channelSession'] = (_JSON$parse3 = JSON.parse(sessionStorage.getItem('troubleshootingDevice'))) === null || _JSON$parse3 === void 0 ? void 0 : _JSON$parse3.channelSession;
      } else {
        window.vzdl[attrArr[0]][attrArr[1]] = attr.itemValue;
      }
    });
  } catch (error) {
    console.error('update4GVzdlPageAttributes', error);
  }
};
var handleEotSecureCaseConversion = function handleEotSecureCaseConversion() {
  if (!sessionStorage.getItem('eotSecureCaseConverted')) {
    sessionStorage.setItem('eotSecureCaseConverted', true);
  }
};
var handleMidflowSecureCaseConversion = function handleMidflowSecureCaseConversion() {
  if (!sessionStorage.getItem('midflowSecureCaseConverted')) {
    sessionStorage.setItem('midflowSecureCaseConverted', true);
  }
};
var logClickStreamSwitch = function logClickStreamSwitch(activePage, templateId, currentPageId, stepTitle) {
  switch (activePage) {
    case 'questions':
      taggingSetPageView('issue_information');
      logClickStream('PAGE-LOADED', 'PAGE-LOADED', 'PAGE-LOADED', 'issue_information', templateId, currentPageId);
      break;
    case 'trouble_shooting':
      logClickStream('PAGE-LOADED', 'PAGE-LOADED', 'PAGE-LOADED', 'issue_steps', templateId, currentPageId);
      break;
    case 'contacts':
    case 'completion':
      window.vzdl.event.value = 'event116';
      taggingSetPageView('tsa_completion');
      logClickStream('PAGE-LOADED', 'PAGE-LOADED', 'PAGE-LOADED', 'tsa_completion', templateId, currentPageId);
      break;
  }
};
var setDataPostSubmit = function setDataPostSubmit(troubleShootingInfo, routesArr, refPageId, setTemplateType) {
  try {
    var _mvoTroubleShootingJs, _mvoTroubleShootingJs2, _mvoTroubleShootingJs3, _troubleShootingInfo$2, _troubleShootingInfo$3, _troubleShootingInfo$4, _troubleShootingInfo$5, _troubleShootingInfo$6, _troubleShootingInfo$7, _troubleShootingInfo$8, _troubleShootingInfo$9, _troubleShootingInfo$0, _troubleShootingInfo$1, _troubleShootingInfo$10;
    console.log('setDataPostSubmit', troubleShootingInfo, routesArr);
    var _troubleShootingInfo$ = troubleShootingInfo.pageAttributes,
      pageAttributes = _troubleShootingInfo$ === void 0 ? [] : _troubleShootingInfo$;
    var mvoTroubleShootingJson = sessionUtility.getTroubleShootingJson();
    var is5GFlow = (_mvoTroubleShootingJs = mvoTroubleShootingJson === null || mvoTroubleShootingJson === void 0 ? void 0 : (_mvoTroubleShootingJs2 = mvoTroubleShootingJson.ddata) === null || _mvoTroubleShootingJs2 === void 0 ? void 0 : (_mvoTroubleShootingJs3 = _mvoTroubleShootingJs2.device) === null || _mvoTroubleShootingJs3 === void 0 ? void 0 : _mvoTroubleShootingJs3.is5GDevice) != null ? _mvoTroubleShootingJs : false;
    if (window.vzdl === '') {
      window.vzdl = {};
    }
    if (!is5GFlow && window.vzdl && pageAttributes && pageAttributes.length > 0) {
      update4GVzdlPageAttributes(pageAttributes);
    }
    var pageContent = getObjectPropertyByPath('ddata.output.pageContent', troubleShootingInfo, {});
    var activePage = getPageFromSteps(pageContent, setTemplateType);
    var _pageContent$steps2 = pageContent.steps,
      steps = _pageContent$steps2 === void 0 ? [] : _pageContent$steps2;
    var step = steps[0] || {};
    var title = step.title;
    if (!title) {
      var _steps$1$title, _steps$;
      title = (_steps$1$title = (_steps$ = steps[1]) === null || _steps$ === void 0 ? void 0 : _steps$.title) != null ? _steps$1$title : 'Title';
    }
    localStorage.setItem('title', title);
    var templateId = (_troubleShootingInfo$2 = troubleShootingInfo === null || troubleShootingInfo === void 0 ? void 0 : (_troubleShootingInfo$3 = troubleShootingInfo.ddata) === null || _troubleShootingInfo$3 === void 0 ? void 0 : (_troubleShootingInfo$4 = _troubleShootingInfo$3.output) === null || _troubleShootingInfo$4 === void 0 ? void 0 : (_troubleShootingInfo$5 = _troubleShootingInfo$4.pageContent) === null || _troubleShootingInfo$5 === void 0 ? void 0 : (_troubleShootingInfo$6 = _troubleShootingInfo$5.steps[0]) === null || _troubleShootingInfo$6 === void 0 ? void 0 : _troubleShootingInfo$6.templateId) != null ? _troubleShootingInfo$2 : '';
    var currentPageId = (_troubleShootingInfo$7 = troubleShootingInfo === null || troubleShootingInfo === void 0 ? void 0 : (_troubleShootingInfo$8 = troubleShootingInfo.ddata) === null || _troubleShootingInfo$8 === void 0 ? void 0 : (_troubleShootingInfo$9 = _troubleShootingInfo$8.output) === null || _troubleShootingInfo$9 === void 0 ? void 0 : _troubleShootingInfo$9.currentPageId) != null ? _troubleShootingInfo$7 : '';
    refPageId.current = (_troubleShootingInfo$0 = troubleShootingInfo === null || troubleShootingInfo === void 0 ? void 0 : (_troubleShootingInfo$1 = troubleShootingInfo.ddata) === null || _troubleShootingInfo$1 === void 0 ? void 0 : (_troubleShootingInfo$10 = _troubleShootingInfo$1.output) === null || _troubleShootingInfo$10 === void 0 ? void 0 : _troubleShootingInfo$10.currentPageId) != null ? _troubleShootingInfo$0 : '';
    if (templateId && sessionStorage.getItem('isTroubleshootCaseOpen') === 'Y') {
      sessionStorage.setItem('isTroubleshootCaseOpen', 'N');
    }
    if (currentPageId) {
      sessionStorage.setItem('trgCurrentPageId', currentPageId);
    }
    if (templateId && routesArr.includes('eotsecure')) {
      handleEotSecureCaseConversion();
    }
    if (templateId && routesArr.includes('midflowsecure')) {
      handleMidflowSecureCaseConversion();
    }
    var _temp8 = function () {
      if (templateId && currentPageId) {
        return Promise.resolve(logClickStreamSwitch(activePage, templateId, currentPageId, title)).then(function () {});
      }
    }();
    return Promise.resolve(_temp8 && _temp8.then ? _temp8.then(function () {}) : void 0);
  } catch (e) {
    return Promise.reject(e);
  }
};

var _templateObject$11, _templateObject2$P, _templateObject3$F, _templateObject4$E, _templateObject5$z;
var enablePageCache = false;
var singlePageMode = false;
var PageWrapper = styled.div(_templateObject$11 || (_templateObject$11 = _taggedTemplateLiteralLoose(["\n  @media (max-width: 600px) {\n    display: flow-root;\n  }\n"])));
var MainWrapper$1 = styled.div(_templateObject2$P || (_templateObject2$P = _taggedTemplateLiteralLoose(["\n  @media (min-width: 601px) {\n  }\n"])));
var getContentWrapper = function getContentWrapper() {
  if (window.isMVODigital) {
    return styled.div(_templateObject3$F || (_templateObject3$F = _taggedTemplateLiteralLoose(["\n      @media (min-width: 821px) {\n        max-width: 1232px;\n        width: 100%;\n        margin-inline: auto;\n      }\n    "])));
  }
  return styled.div(_templateObject4$E || (_templateObject4$E = _taggedTemplateLiteralLoose(["\n    margin: 0px;\n  "])));
};
var ContentWrapper$g = getContentWrapper();
var LoaderContainer$2 = styled.div(_templateObject5$z || (_templateObject5$z = _taggedTemplateLiteralLoose(["\n  div:nth-child(2) {\n    z-index: 2 !important;\n  }\n"])));
var isMVA$1 = window._dg_channelId === "VZW-MFA";
var getTroubleShootingData = function getTroubleShootingData(state, values, ctaClicked, currentPage, content, pageId, selectedDevice, selectedLocation, optionSelected, longitude, latitude, button, configDetails, options, blockSubmitViracall, combinedIssueSelector, changeDeviceFlag, setSmartAIData, sendMessage, languageIndicator) {
  if (ctaClicked === void 0) {
    ctaClicked = '';
  }
  if (blockSubmitViracall === void 0) {
    blockSubmitViracall = false;
  }
  try {
    var _configDetails$params4, _configDetails$params5;
    var _temp8 = function _temp8() {
      var _window, _window2, _troubleshootingDetai, _troubleshootingDetai2, _troubleshootingDetai3, _troubleshootingDetai4, _troubleshootingDetai5, _troubleshootingDetai6, _troubleshootingDetai7, _troubleshootingDetai8, _troubleshootingDetai9, _troubleshootingDetai0, _troubleshootingDetai1, _troubleshootingDetai10, _window3, _window3$troubleShoot, _window3$troubleShoot2, _window3$troubleShoot3, _window4, _window4$troubleShoot, _window4$troubleShoot2, _window4$troubleShoot3, _window5, _window5$caseDetails, _steps, _steps$, _troubleshootingDetai11, _troubleshootingDetai12, _troubleshootingDetai13, _troubleshootingDetai14, _configDetails$config1, _configDetails$config10, _configDetails$config11;
      function _temp6() {
        try {
          var _troubleShootingData, _troubleShootingData$, _troubleShootingData2, _troubleShootingData3;
          sessionStorage.setItem('processAction', (_troubleShootingData = troubleShootingData) === null || _troubleShootingData === void 0 ? void 0 : (_troubleShootingData$ = _troubleShootingData.context) === null || _troubleShootingData$ === void 0 ? void 0 : _troubleShootingData$.processAction);
          sessionStorage.setItem('processStep', ((_troubleShootingData2 = troubleShootingData) === null || _troubleShootingData2 === void 0 ? void 0 : (_troubleShootingData3 = _troubleShootingData2.context) === null || _troubleShootingData3 === void 0 ? void 0 : _troubleShootingData3.processStep) || 'Next');
          sessionStorage.setItem('currentPageUrl', window.location.href);
        } catch (error) {
          console.log(error);
        }
        console.log('info getTroubleShootingData', troubleShootingData);
        return troubleShootingData;
      }
      var deviceHealthData;
      if (sessionStorage.getItem('deviceHealthData')) {
        deviceHealthData = JSON.parse(sessionStorage.getItem('deviceHealthData'));
      }
      var isHealthCheck = ((_window = window) === null || _window === void 0 ? void 0 : _window.hlthFlow) || false;
      var isRecommendedIssue = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.recIssue) || false;
      console.log('info api params 1: ', combinedIssueSelector, troubleshootingDetails);
      var additionalMtn = (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns) || [];
      var selectedIntent = !isEmpty((_troubleshootingDetai = troubleshootingDetails) === null || _troubleshootingDetai === void 0 ? void 0 : _troubleshootingDetai.intent) ? (_troubleshootingDetai2 = troubleshootingDetails) === null || _troubleshootingDetai2 === void 0 ? void 0 : _troubleshootingDetai2.intent : configDetails.selectedNSAIntent.intent;
      var selectedIntentId = !isEmpty((_troubleshootingDetai3 = troubleshootingDetails) === null || _troubleshootingDetai3 === void 0 ? void 0 : _troubleshootingDetai3.intentId) ? (_troubleshootingDetai4 = troubleshootingDetails) === null || _troubleshootingDetai4 === void 0 ? void 0 : _troubleshootingDetai4.intentId : configDetails.selectedNSAIntent.intentId;
      var selectedMtn = !isEmpty((_troubleshootingDetai5 = troubleshootingDetails) === null || _troubleshootingDetai5 === void 0 ? void 0 : _troubleshootingDetai5.mtn) ? (_troubleshootingDetai6 = troubleshootingDetails) === null || _troubleshootingDetai6 === void 0 ? void 0 : _troubleshootingDetai6.mtn : configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.mdn;
      var selectedMtnId = !isEmpty((_troubleshootingDetai7 = troubleshootingDetails) === null || _troubleshootingDetai7 === void 0 ? void 0 : _troubleshootingDetai7.mtnId) ? (_troubleshootingDetai8 = troubleshootingDetails) === null || _troubleshootingDetai8 === void 0 ? void 0 : _troubleshootingDetai8.mtnId : configDetails === null || configDetails === void 0 ? void 0 : configDetails.mtnId;
      var currentCaseId = !isEmpty((_troubleshootingDetai9 = troubleshootingDetails) === null || _troubleshootingDetai9 === void 0 ? void 0 : _troubleshootingDetai9.caseId) ? (_troubleshootingDetai0 = troubleshootingDetails) === null || _troubleshootingDetai0 === void 0 ? void 0 : _troubleshootingDetai0.caseId : configDetails === null || configDetails === void 0 ? void 0 : configDetails.caseId;
      var accNum = !isEmpty((_troubleshootingDetai1 = troubleshootingDetails) === null || _troubleshootingDetai1 === void 0 ? void 0 : _troubleshootingDetai1.accountNumber) ? (_troubleshootingDetai10 = troubleshootingDetails) === null || _troubleshootingDetai10 === void 0 ? void 0 : _troubleshootingDetai10.accountNumber : configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.accountNumber;
      var filteredDeviceSku;
      additionalMtn.forEach(function (mtnObj, index) {
        if (mtnObj.mtn == selectedMtn) {
          filteredDeviceSku = mtnObj.deviceSku;
        }
      });
      var params = {
        deviceSku: window.isMVODigital ? (configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.sku) || filteredDeviceSku : configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.sku,
        equipmentId: configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.equipmentId,
        deviceType: (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$troubleShoot = _window3.troubleShootingJson) === null || _window3$troubleShoot === void 0 ? void 0 : (_window3$troubleShoot2 = _window3$troubleShoot.ddata) === null || _window3$troubleShoot2 === void 0 ? void 0 : (_window3$troubleShoot3 = _window3$troubleShoot2.device) === null || _window3$troubleShoot3 === void 0 ? void 0 : _window3$troubleShoot3.deviceType,
        is5GDevice: (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$troubleShoot = _window4.troubleShootingJson) === null || _window4$troubleShoot === void 0 ? void 0 : (_window4$troubleShoot2 = _window4$troubleShoot.ddata) === null || _window4$troubleShoot2 === void 0 ? void 0 : (_window4$troubleShoot3 = _window4$troubleShoot2.device) === null || _window4$troubleShoot3 === void 0 ? void 0 : _window4$troubleShoot3.is5GDevice,
        intent: combinedIssueSelector ? selectedIntent : configDetails.selectedNSAIntent.intent || mvoCaseDetails.intent || ((_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$caseDetails = _window5.caseDetails) === null || _window5$caseDetails === void 0 ? void 0 : _window5$caseDetails.intentId),
        intentId: combinedIssueSelector ? selectedIntentId : configDetails.selectedNSAIntent.intentId || mvoCaseDetails.intentId,
        channelId: finalChannel || 'Care',
        caseId: combinedIssueSelector ? currentCaseId : configDetails.caseId,
        mtn: combinedIssueSelector ? selectedMtn : configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.mdn,
        tierId: combinedIssueSelector ? 1 : configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.tier,
        processAction: processAction != null ? processAction : '',
        processStep: processStep != null ? processStep : 'Next',
        pageId: currentPageId
      };
      if ((_steps = steps) !== null && _steps !== void 0 && (_steps$ = _steps[0]) !== null && _steps$ !== void 0 && _steps$.address) {
        var _steps2, _steps2$;
        params.address = (_steps2 = steps) === null || _steps2 === void 0 ? void 0 : (_steps2$ = _steps2[0]) === null || _steps2$ === void 0 ? void 0 : _steps2$.address;
      }
      if (params.processStep === "SubmitNrbForm" && !!(options !== null && options !== void 0 && options.ticketCaseId)) {
        params.nrbTicketCaseId = options === null || options === void 0 ? void 0 : options.ticketCaseId;
        params.processStep = "submittedNRB";
      }
      if (params.processStep === "SubmitNrbForm" && !(options !== null && options !== void 0 && options.ticketCaseId)) {
        params.processStep = "submittedNRBFailed";
        params.ctaClicked = "No";
      }
      getNBXParams(params);
      var _configDetails$params = configDetails.paramsDetails,
        _configDetails$params2 = _configDetails$params === void 0 ? {} : _configDetails$params,
        _configDetails$params3 = _configDetails$params2.changeDeviceFlow,
        changeDeviceFlow = _configDetails$params3 === void 0 ? false : _configDetails$params3;
      console.log('info api params 2: ', params, combinedIssueSelector, troubleshootingDetails);
      var _ref = mvoConfig || {},
        _ref$troubleShootingJ = _ref.troubleShootingJson,
        _ref$troubleShootingJ2 = _ref$troubleShootingJ === void 0 ? {} : _ref$troubleShootingJ,
        _ref$troubleShootingJ3 = _ref$troubleShootingJ2.ddata,
        _ref$troubleShootingJ4 = _ref$troubleShootingJ3 === void 0 ? {} : _ref$troubleShootingJ3,
        _ref$troubleShootingJ5 = _ref$troubleShootingJ4.device,
        _ref$troubleShootingJ6 = _ref$troubleShootingJ5 === void 0 ? {} : _ref$troubleShootingJ5,
        _ref$troubleShootingJ7 = _ref$troubleShootingJ6.soeUrl,
        soeUrl = _ref$troubleShootingJ7 === void 0 ? '' : _ref$troubleShootingJ7;
      if (soeUrl) {
        params.seoUrl = soeUrl;
      }
      if (currentPage == 'diagnostics') {
        var _options$newValues$tr, _options$newValues, _options$newValues$tr2, _options$newValues$tr3, _options$newValues$tr4, _options$newValues$tr5, _options$newValues2, _options$newValues2$t, _options$newValues2$t2, _options$newValues2$t3;
        params.testSuccessPollCount = parseInt((_options$newValues$tr = options === null || options === void 0 ? void 0 : (_options$newValues = options.newValues) === null || _options$newValues === void 0 ? void 0 : (_options$newValues$tr2 = _options$newValues.troubleShootingInfo) === null || _options$newValues$tr2 === void 0 ? void 0 : (_options$newValues$tr3 = _options$newValues$tr2.ddata) === null || _options$newValues$tr3 === void 0 ? void 0 : (_options$newValues$tr4 = _options$newValues$tr3.output) === null || _options$newValues$tr4 === void 0 ? void 0 : _options$newValues$tr4.testSuccessPollCount) != null ? _options$newValues$tr : 0, 10);
        params.testFailPollCount = parseInt((_options$newValues$tr5 = options === null || options === void 0 ? void 0 : (_options$newValues2 = options.newValues) === null || _options$newValues2 === void 0 ? void 0 : (_options$newValues2$t = _options$newValues2.troubleShootingInfo) === null || _options$newValues2$t === void 0 ? void 0 : (_options$newValues2$t2 = _options$newValues2$t.ddata) === null || _options$newValues2$t2 === void 0 ? void 0 : (_options$newValues2$t3 = _options$newValues2$t2.output) === null || _options$newValues2$t3 === void 0 ? void 0 : _options$newValues2$t3.testFailPollCount) != null ? _options$newValues$tr5 : 0, 10);
      }
      if (configDetails !== null && configDetails !== void 0 && configDetails.paramsDetails) {
        params.accountNumber = combinedIssueSelector ? accNum : configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.accountNumber;
      }
      if (activityID) {
        params.activityID = activityID;
      }
      if (optionSelected) {
        params.userSelection = optionSelected;
      }
      if (selectedDevice) {
        params.selectedDevice = selectedDevice;
      }
      if (selectedLocation) {
        params.selectedLocation = selectedLocation;
      }
      if (optionSelected == "Text Message (SMS)") {
        params.testSMSReceived = sendMessage;
        params.languageIndicator = languageIndicator;
        params.indicator = 'SMS';
        params.testMMSReceived = "";
        params.processStep = 'Next';
      }
      if (longitude && latitude) {
        console.log(longitude, 'longo');
        params.longitude = longitude;
        params.latitude = latitude;
        console.log(params);
      }
      if (options && options.addressLine) {
        params.address = options.addressLine;
      }
      if (state !== 'start') {
        params.caseId = caseId;
        params.ctaClicked = currentPage === 'waitscreen' ? '' : ctaClicked;
      }
      if (params.processStep == 'SendEmail' || params.processStep == 'SendSMS') {
        params.ctaClicked = 'No';
        params.custEmailId = options.custEmailId;
        params.custFirstName = options.custFirstName;
        params.articleId = options.articleId;
        params.articleUrl = options.articleUrl;
        params.articleName = options.articleName;
        params.subProcessStep = options.subProcessStep;
      }
      if (button && button.uid == 'RBC') {
        var _button$ctaClicked = button.ctaClicked,
          _ctaClicked = _button$ctaClicked === void 0 ? '' : _button$ctaClicked;
        params.ctaClicked = _ctaClicked;
      }
      if (button && button.isSpecificNumberEntry) {
        params.userSelectionValidation = true;
      }
      if (state === 'submit' && activePage === 'questions') {
        params.allCalls = allCalls;
        params.allLocations = allLocations;
        params.specificNumber = "" + (allCalls ? '' : specificNumber);
        params.address = "" + (allLocations ? '' : address);
      }
      if (state === 'replay') {
        params.pageId = pageId;
      }
      var mdn = ((_troubleshootingDetai11 = troubleshootingDetails) === null || _troubleshootingDetai11 === void 0 ? void 0 : _troubleshootingDetai11.mtn) === "" || ((_troubleshootingDetai12 = troubleshootingDetails) === null || _troubleshootingDetai12 === void 0 ? void 0 : _troubleshootingDetai12.mtn) === null || ((_troubleshootingDetai13 = troubleshootingDetails) === null || _troubleshootingDetai13 === void 0 ? void 0 : _troubleshootingDetai13.mtn) === undefined ? configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.mdn : (_troubleshootingDetai14 = troubleshootingDetails) === null || _troubleshootingDetai14 === void 0 ? void 0 : _troubleshootingDetai14.mtn;
      if (!is5GDevice) {
        var _troubleshootingDetai15, _window6, _window6$caseDetails;
        params.equipmentId = configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.equipmentId;
        params.mtn = combinedIssueSelector ? mdn : configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.mdn;
        params.mtnId = selectedMtnId;
        params.channelId = finalChannel || 'Care';
        params.intentId = combinedIssueSelector ? (_troubleshootingDetai15 = troubleshootingDetails) === null || _troubleshootingDetai15 === void 0 ? void 0 : _troubleshootingDetai15.intentId : configDetails.selectedNSAIntent.intentId || mvoCaseDetails.intentId;
        params.intent = combinedIssueSelector ? selectedIntent : configDetails.selectedNSAIntent.intent || mvoCaseDetails.intent || ((_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$caseDetails = _window6.caseDetails) === null || _window6$caseDetails === void 0 ? void 0 : _window6$caseDetails.intentId);
        params.caseId = currentCaseId;
        params.tierId = combinedIssueSelector ? 1 : configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.tier;
        params.loggedInUser = configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.loggedInUser;
      }
      console.log('***********mvo************');
      console.log(state);
      console.log(mvoConfig === null || mvoConfig === void 0 ? void 0 : mvoConfig.isAcss);
      console.log(configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails);
      if (mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isAcss && typeof (configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.acssCallId) !== 'undefined' && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.acssCallId) !== '' && (state === 'submit' || state === 'Poll')) {
        params.callerId = configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.acssCallId;
      }
      if (combinedIssueSelector) {
        var _troubleshootingDetai16, _troubleshootingDetai17, _troubleshootingDetai18, _troubleshootingDetai19;
        params.caseId = ((_troubleshootingDetai16 = troubleshootingDetails) === null || _troubleshootingDetai16 === void 0 ? void 0 : _troubleshootingDetai16.caseId) !== null && ((_troubleshootingDetai17 = troubleshootingDetails) === null || _troubleshootingDetai17 === void 0 ? void 0 : _troubleshootingDetai17.caseId) !== undefined && ((_troubleshootingDetai18 = troubleshootingDetails) === null || _troubleshootingDetai18 === void 0 ? void 0 : _troubleshootingDetai18.caseId) !== "" ? (_troubleshootingDetai19 = troubleshootingDetails) === null || _troubleshootingDetai19 === void 0 ? void 0 : _troubleshootingDetai19.caseId : configDetails === null || configDetails === void 0 ? void 0 : configDetails.caseId;
        if (is5GDevice) {
          params.caseId = caseId;
        }
      }
      params.changeDevice = false;
      if (changeDeviceFlow) {
        params.changeDevice = true;
      }
      if (finalChannel == 'Verizon Website') {
        var _window7, _window7$config;
        if ((_window7 = window) !== null && _window7 !== void 0 && (_window7$config = _window7.config) !== null && _window7$config !== void 0 && _window7$config.portalStandalone) {
          params.changeDevice = true;
        }
      }
      if (finalChannel == 'My Verizon') {
        var _configDetails$config, _configDetails$config2, _configDetails$config3, _configDetails$config4, _configDetails$config5, _configDetails$config6, _window8, _window8$config, _configDetails$config7, _configDetails$config8, _configDetails$config9, _configDetails$config0;
        if (!(configDetails !== null && configDetails !== void 0 && (_configDetails$config = configDetails.config) !== null && _configDetails$config !== void 0 && (_configDetails$config2 = _configDetails$config.caseDetails) !== null && _configDetails$config2 !== void 0 && _configDetails$config2.mtn) && !(configDetails !== null && configDetails !== void 0 && (_configDetails$config3 = configDetails.config) !== null && _configDetails$config3 !== void 0 && (_configDetails$config4 = _configDetails$config3.caseDetails) !== null && _configDetails$config4 !== void 0 && _configDetails$config4.mtnId)) {
          params.changeDevice = true;
          if (window.isMVODigital) {
            params.channelId = 'Verizon Website';
          }
        }
        if ((configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config5 = configDetails.config) === null || _configDetails$config5 === void 0 ? void 0 : (_configDetails$config6 = _configDetails$config5.caseDetails) === null || _configDetails$config6 === void 0 ? void 0 : _configDetails$config6.mtnId) == 0 || (_window8 = window) !== null && _window8 !== void 0 && (_window8$config = _window8.config) !== null && _window8$config !== void 0 && _window8$config.portalStandalone) {
          params.changeDevice = false;
          params.channelId = 'My Verizon';
        }
        if (isMVA$1 && isMVODigital && !changeDeviceFlag) {
          params.changeDevice = false;
        }
        console.log('changeDevice', !(configDetails !== null && configDetails !== void 0 && (_configDetails$config7 = configDetails.config) !== null && _configDetails$config7 !== void 0 && (_configDetails$config8 = _configDetails$config7.caseDetails) !== null && _configDetails$config8 !== void 0 && _configDetails$config8.mtn), !(configDetails !== null && configDetails !== void 0 && (_configDetails$config9 = configDetails.config) !== null && _configDetails$config9 !== void 0 && (_configDetails$config0 = _configDetails$config9.caseDetails) !== null && _configDetails$config0 !== void 0 && _configDetails$config0.mtnId));
      }
      var _ref2 = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config1 = configDetails.config) === null || _configDetails$config1 === void 0 ? void 0 : (_configDetails$config10 = _configDetails$config1.troubleShootingJson) === null || _configDetails$config10 === void 0 ? void 0 : (_configDetails$config11 = _configDetails$config10.ddata) === null || _configDetails$config11 === void 0 ? void 0 : _configDetails$config11.device) || {},
        productDisplayNameClean = _ref2.productDisplayNameClean;
      if (productDisplayNameClean) {
        params.productDisplayNameClean = productDisplayNameClean;
      }
      console.log('info api params 3: ', params);
      if (state === 'replay' && sessionStorage.getItem('nsaIntentSelected')) {
        params.caseId = JSON.parse(sessionStorage.getItem('nsaIntentSelected')).caseId;
      }
      var isLvFlow = window.location.hash.includes('getcase');
      if (isLvFlow) {
        var _window9, _window9$config, _window9$config$caseD;
        params.caseId = (_window9 = window) === null || _window9 === void 0 ? void 0 : (_window9$config = _window9.config) === null || _window9$config === void 0 ? void 0 : (_window9$config$caseD = _window9$config.caseDetails) === null || _window9$config$caseD === void 0 ? void 0 : _window9$config$caseD.caseId;
      }
      if (optionSelected && optionSelected === "nrb_servicecase") {
        params.ctaClicked = "No";
        params.processStep = "No";
      }
      if (isHealthCheck) {
        var _deviceHealthData, _deviceHealthData2, _deviceHealthData1;
        params.isHealthCheck = isHealthCheck;
        params.caseId = (_deviceHealthData = deviceHealthData) === null || _deviceHealthData === void 0 ? void 0 : _deviceHealthData.caseId;
        params.isRecommendedIssue = isRecommendedIssue;
        params.changeDevice = false;
        params.channelId = 'My Verizon';
        if (isRecommendedIssue || (_deviceHealthData2 = deviceHealthData) !== null && _deviceHealthData2 !== void 0 && _deviceHealthData2.isNavHistFlow) {
          var _deviceHealthData3, _deviceHealthData4, _deviceHealthData5, _deviceHealthData6, _deviceHealthData7, _deviceHealthData8, _deviceHealthData9, _deviceHealthData0;
          params.intent = (_deviceHealthData3 = deviceHealthData) === null || _deviceHealthData3 === void 0 ? void 0 : _deviceHealthData3.intent;
          params.intentId = (_deviceHealthData4 = deviceHealthData) === null || _deviceHealthData4 === void 0 ? void 0 : _deviceHealthData4.intentId;
          params.mtn = (_deviceHealthData5 = deviceHealthData) === null || _deviceHealthData5 === void 0 ? void 0 : _deviceHealthData5.mdn;
          params.mtnId = (_deviceHealthData6 = deviceHealthData) === null || _deviceHealthData6 === void 0 ? void 0 : _deviceHealthData6.mtnId;
          params.pageId = currentPageId != null ? currentPageId : (_deviceHealthData7 = deviceHealthData) === null || _deviceHealthData7 === void 0 ? void 0 : _deviceHealthData7.pageId;
          sessionStorage.setItem('troubleshootingDetails', JSON.stringify(_extends({}, JSON.parse(sessionStorage.getItem('troubleshootingDetails')), {
            intent: (_deviceHealthData8 = deviceHealthData) === null || _deviceHealthData8 === void 0 ? void 0 : _deviceHealthData8.intent,
            intentId: (_deviceHealthData9 = deviceHealthData) === null || _deviceHealthData9 === void 0 ? void 0 : _deviceHealthData9.intentId,
            mtn: (_deviceHealthData0 = deviceHealthData) === null || _deviceHealthData0 === void 0 ? void 0 : _deviceHealthData0.mdn
          })));
        }
        if ((_deviceHealthData1 = deviceHealthData) !== null && _deviceHealthData1 !== void 0 && _deviceHealthData1.isNavHistFlow) {
          var _deviceHealthData10, _deviceHealthData11;
          params.processStep = (_deviceHealthData10 = deviceHealthData) === null || _deviceHealthData10 === void 0 ? void 0 : _deviceHealthData10.processStep;
          (_deviceHealthData11 = deviceHealthData) === null || _deviceHealthData11 === void 0 ? true : delete _deviceHealthData11.isNavHistFlow;
          sessionStorage.setItem('deviceHealthData', JSON.stringify(deviceHealthData));
        }
      }
      if (window.isMVODigital && window.isLoggedOut) {
        params.changeDevice = true;
        params.mtn = "";
      }
      var troubleShootingData = {};
      if (button !== null && button !== void 0 && button.isNextBtnEnableNRB || false) {
        params["processStep"] = "submittedNRBFailed";
      }
      var _temp5 = _catch(function () {
        var _temp4 = _switch(state, [[function () {
          return 'close';
        }, function () {
          return Promise.resolve(closeTroubleShooting(params, envData)).then(function (_closeTroubleShooting) {
            troubleShootingData = _closeTroubleShooting;
          });
        }], [function () {
          return 'submit';
        }, function () {
          console.log('params:: submit', params);
          var _temp3 = function () {
            if (!blockSubmitViracall) {
              var _temp2 = function () {
                if (window.isMVODigital && !window.isLoggedOut && window.enableSmartDiagnosticFFlag) {
                  var smartApiUrl = tsaEnvConfig$1().apiUrls.smartSolutionDiagnosticURL;
                  var deviceId = "";
                  additionalMtn === null || additionalMtn === void 0 ? void 0 : additionalMtn.forEach(function (mtnObj, index) {
                    if (mtnObj.mtn == selectedMtn) {
                      deviceId = mtnObj === null || mtnObj === void 0 ? void 0 : mtnObj.imei;
                    }
                  });
                  var param = {
                    "mdn": params.mtn,
                    "refresh": "hard",
                    "cmd": "standardDiag",
                    "deviceid": deviceId,
                    "meid": "",
                    "iccid": "",
                    "accnum": "",
                    "callid": "",
                    "uswin": "",
                    "frontendsessionid": ""
                  };
                  return Promise.resolve(smartSolutionDiagnosticAPI(smartApiUrl, param, envData)).then(function (smartAIData) {
                    setSmartAIData(smartAIData);
                  });
                } else {
                  var _temp9 = function () {
                    if (window.isMVODigital && !window.isLoggedOut && window.enableSmartIqSolutionFFlag) {
                      var _smartApiUrl = tsaEnvConfig$1().apiUrls.smartSolutionURL;
                      var smartParam = {
                        "useCase": "simplifyingtroubleshooting",
                        "contextId": "Zero_Shot_Testing",
                        "preSeed_injection_map": {
                          "{Context}": "Assume you are an awesome Telecom call centre representative.",
                          "{Issue}": params.intent,
                          "{Question}": "Yourtaskistoperformthefollowingactions:\\n\"+\"Outputajsonobjectthatcontainsthefollowingkeys:empatheticMessage,datainthebelowformat\\n\"+\"{\\n\"+\"data:[\\n\"+\"{\\n\"+\"\\\"title\\\":\\\"PossibleCauses\\\",\\n\"+\"\\\"steps\\\":[\\n\"+\"\\\"Cause1\\\",\\n\"+\"\\\"Cause2\\\",\\n\"+\"\\\"Cause3\\\"\\n\"+\"]},\\n\"+\"{\\n\"+\"\\\"title\\\":\\\"RecommendedFixes\\\",\\n\"+\"\\\"steps\\\":[\\n\"+\"\\\"Fix1\\\",\\n\"+\"\\\"Fix2\\\"\\n\"+\"]\\n\"+\"},\\n\"+\"{\\n\"+\"\\\"title\\\":\\\"BestPractices\\\",\\n\"+\"\\\"steps\\\":[\\n\"+\"\\\"Practice1\\\"\\n\"+\"\\\"Practice2\\\"\\n\"+\"]\\n\"+\"}\\n\"+\"]\\n\"+\"}\\n\"+\"\\n\"+\"whilelimitingthepossibleCausesto5steps,recommendedFixesto3steps,bestPracticesto6steps.Pleasetakeoutthe\\\"*\\\"fromtheresponse"
                        }
                      };
                      return Promise.resolve(smartSolutionAPI(_smartApiUrl, smartParam, envData)).then(function (smartAIData) {
                        setSmartAIData(smartAIData);
                      });
                    } else {
                      return Promise.resolve(submitActionForTroubleShooting(params, envData)).then(function (_submitActionForTroub) {
                        troubleShootingData = _submitActionForTroub;
                        console.log('troubleShootingData---2---', troubleShootingData);
                      });
                    }
                  }();
                  if (_temp9 && _temp9.then) return _temp9.then(function () {});
                }
              }();
              if (_temp2 && _temp2.then) return _temp2.then(function () {});
            } else {
              redirectToBAU();
            }
          }();
          if (_temp3 && _temp3.then) return _temp3.then(function () {});
        }], [function () {
          return 'replay';
        }, function () {
          var _params$nextProcessId;
          var navHistoryList = getObjectPropertyByPath('ddata.output.navHist', troubleShootingInfo, {});
          if (navHistoryList !== 'undefined') {
            navHistoryList === null || navHistoryList === void 0 ? void 0 : navHistoryList.forEach(function (obj) {
              if (params.pageId > 1 && obj.pageId == parseInt(params.pageId) - 1) {
                params.nextProcessIdentifier = obj.pageIdentifier;
              }
            });
          }
          params.nextProcessIdentifier = (_params$nextProcessId = params.nextProcessIdentifier) != null ? _params$nextProcessId : '';
          return Promise.resolve(replayActionForTroubleShooting(params, envData)).then(function (_replayActionForTroub) {
            troubleShootingData = _replayActionForTroub;
          });
        }], [function () {
          return 'Poll';
        }, function () {
          console.log('params:: Poll', params);
          return Promise.resolve(pollActionForTroubleShooting(params, envData)).then(function (_pollActionForTrouble) {
            troubleShootingData = _pollActionForTrouble;
          });
        }], [function () {
          return 'ts_new';
        }], [function () {
          return 'ts_complete';
        }, function () {
          return Promise.resolve(startActionForTroubleShootingNew(params, envData)).then(function (_startActionForTroubl) {
            troubleShootingData = _startActionForTroubl;
          });
        }], [], [function () {
          return 'start';
        }, function () {
          if (combinedIssueSelector) {
            if (is5GDevice) {
              var _troubleshootingDetai20;
              params.intent = (_troubleshootingDetai20 = troubleshootingDetails) === null || _troubleshootingDetai20 === void 0 ? void 0 : _troubleshootingDetai20.intentId;
              params.intentId = null;
              params.caseId = null;
              params.tierId = null;
              params.mtn = null;
            }
          }
          return Promise.resolve(startTroubleShooting(params, envData)).then(function (_startTroubleShooting) {
            troubleShootingData = _startTroubleShooting;
          });
        }]]);
        if (_temp4 && _temp4.then) return _temp4.then(function () {});
      }, function () {});
      return _temp5 && _temp5.then ? _temp5.then(_temp6) : _temp6(_temp5);
    };
    var mvoCaseDetails = sessionUtility.getCaseDetails();
    var mvoConfig = sessionUtility.getMvoConfig();
    var _values$context = values.context,
      context = _values$context === void 0 ? {} : _values$context,
      _values$landingInfo = values.landingInfo,
      landingInfo = _values$landingInfo === void 0 ? {} : _values$landingInfo,
      _values$symptomId = values.symptomId,
      symptomId = _values$symptomId === void 0 ? '' : _values$symptomId,
      _values$activePage = values.activePage,
      activePage = _values$activePage === void 0 ? '' : _values$activePage,
      _values$questionsPara = values.questionsParams,
      questionsParams = _values$questionsPara === void 0 ? {} : _values$questionsPara,
      _values$troubleShooti = values.troubleShootingInfo,
      troubleShootingInfo = _values$troubleShooti === void 0 ? {} : _values$troubleShooti;
    console.log('info getTroubleShootingData: ', currentPage, options);
    var steps = [];
    if (troubleShootingInfo.ddata) {
      steps = troubleShootingInfo.ddata.output.pageContent.steps || [];
    }
    var _ref3 = troubleShootingInfo.ddata || {},
      _ref3$output = _ref3.output,
      output = _ref3$output === void 0 ? {} : _ref3$output;
    var currentPageId = pageId || output.currentPageId || '';
    if (state == 'Poll' && activePage !== 'diagnostics') {
      currentPageId = parseInt(currentPageId, 10) + 1;
    }
    var _ref4 = steps[0] || {},
      _ref4$activityID = _ref4.activityID,
      activityID = _ref4$activityID === void 0 ? '' : _ref4$activityID;
    var _ref5 = currentPage === 'waitscreen' ? content : context,
      _ref5$caseId = _ref5.caseId,
      caseId = _ref5$caseId === void 0 ? '' : _ref5$caseId;
    var _questionsParams$allC = questionsParams.allCalls,
      allCalls = _questionsParams$allC === void 0 ? true : _questionsParams$allC,
      _questionsParams$spec = questionsParams.specificNumber,
      specificNumber = _questionsParams$spec === void 0 ? '' : _questionsParams$spec,
      _questionsParams$allL = questionsParams.allLocations,
      allLocations = _questionsParams$allL === void 0 ? true : _questionsParams$allL,
      _questionsParams$addr = questionsParams.address,
      address = _questionsParams$addr === void 0 ? '' : _questionsParams$addr;
    var _landingInfo$device = landingInfo.device,
      device = _landingInfo$device === void 0 ? {} : _landingInfo$device;
    var _device$deviceSku = device.deviceSku,
      deviceSku = _device$deviceSku === void 0 ? '' : _device$deviceSku,
      _device$equipmentId = device.equipmentId,
      equipmentId = _device$equipmentId === void 0 ? '' : _device$equipmentId,
      _device$deviceType = device.deviceType,
      deviceType = _device$deviceType === void 0 ? '' : _device$deviceType,
      is5GDevice = device.is5GDevice;
    var envData = {
      externalTarget: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params4 = configDetails.paramsDetails) === null || _configDetails$params4 === void 0 ? void 0 : _configDetails$params4.externalTarget,
      mvoenv: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params5 = configDetails.paramsDetails) === null || _configDetails$params5 === void 0 ? void 0 : _configDetails$params5.mvoenv
    };
    var processAction = currentPage === 'waitscreen' ? content.processAction : context.processAction;
    var processStep = currentPage === 'waitscreen' ? content.processStep : ctaClicked || 'Next';
    var finalChannel = (configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.channel) == 'CARE' ? 'Care' : configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.channel;
    if (window.isMVODigital) {
      var _window0, _window1, _window10, _window10$config;
      finalChannel = (_window0 = window) === null || _window0 === void 0 ? void 0 : _window0._dg_channelId;
      if ((_window1 = window) !== null && _window1 !== void 0 && _window1.isLoggedOut || (_window10 = window) !== null && _window10 !== void 0 && (_window10$config = _window10.config) !== null && _window10$config !== void 0 && _window10$config.isLoggedOut) {
        finalChannel = 'Verizon Website';
      } else {
        finalChannel = 'My Verizon';
      }
    }
    var troubleshootingDetails;
    var _temp7 = function () {
      if (sessionStorage.getItem('troubleshootingDetails')) {
        return Promise.resolve(JSON.parse(sessionStorage.getItem('troubleshootingDetails'))).then(function (_JSON$parse) {
          troubleshootingDetails = _JSON$parse;
        });
      }
    }();
    return Promise.resolve(_temp7 && _temp7.then ? _temp7.then(_temp8) : _temp8(_temp7));
  } catch (e) {
    return Promise.reject(e);
  }
};
var renderMessageModal$1 = function renderMessageModal(modalParams, handleModalAction) {
  return /*#__PURE__*/React__default.createElement(MessageModal, {
    body: modalParams.body,
    buttons: modalParams.buttons,
    handleAction: handleModalAction,
    isError: modalParams.isError,
    showModal: modalParams.show,
    stackButtons: isMobile(),
    styles: modalParams.styles,
    title: modalParams.title,
    options: modalParams.options,
    link: modalParams.link
  });
};
var selectedLocation;
var loadingMessage = '';
var renderCheckingPhoneLoader = function renderCheckingPhoneLoader(show, is5gloadingmsg, previousPageLoaderMessage, values, theme) {
  console.log('loader renderCheckingPhoneLoader', show, is5gloadingmsg, previousPageLoaderMessage, values, theme);
  if (!show) {
    return;
  }
  var _values$landingInfo2 = values.landingInfo,
    landingInfo = _values$landingInfo2 === void 0 ? {} : _values$landingInfo2;
  var _landingInfo$device2 = landingInfo.device,
    device = _landingInfo$device2 === void 0 ? {} : _landingInfo$device2;
  var is5GDevice = device.is5GDevice;
  var _values$troubleShooti2 = values.troubleShootingInfo,
    troubleShootingInfo = _values$troubleShooti2 === void 0 ? {} : _values$troubleShooti2,
    symptomId = values.symptomId;
  var output = getObjectPropertyByPath('ddata.output', troubleShootingInfo, {});
  var _output$pageContent = output.pageContent,
    pageContent = _output$pageContent === void 0 ? {} : _output$pageContent;
  var _pageContent$steps = pageContent.steps,
    steps = _pageContent$steps === void 0 ? [] : _pageContent$steps;
  var analysis = getStepByName('analysis', steps);
  if (is5GDevice) {
    if (analysis.dynamicWaitingScreen && symptomId != '23504') {
      loadingMessage = analysis.dynamicWaitingScreen;
    } else if (symptomId == '23504' && !previousPageLoaderMessage) {
      loadingMessage = 'Please hold on while we check for your connectivity with the extender.';
      if (analysis.templateId == 'NETWORK_GOOD_GOTO_REG_EXTENDER_WPS_PAIRING_BUTTON' || analysis.templateId == 'NETWORK_GOOD_GOTO_MINI_EXTENDER_WPS_PAIRING_BUTTON' || analysis.templateId == 'NETWORK_GOOD_GOTO_REG_EXTENDER_ETHERNET_PAIRING_CABLE') {
        loadingMessage = 'Please wait for 2 minutes while the router pairs with the Wifi extender.';
      }
    } else if (selectedLocation) {
      loadingMessage = "Checking the Wifi connectivity in " + selectedLocation;
    } else if (is5gloadingmsg || previousPageLoaderMessage && symptomId == '23504') {
      loadingMessage = 'Please hold on while we check your connection. This may take a moment.';
    } else {
      loadingMessage = 'Please wait while we check your device This should take about a minute.';
    }
  } else {
    loadingMessage = '';
  }
  console.log('loadingMessage ', loadingMessage);
  return /*#__PURE__*/React__default.createElement(LoaderContainer$2, {
    className: "trg-ts-styled-loader"
  }, /*#__PURE__*/React__default.createElement(Loader, {
    active: show,
    fullscreen: true
  }, /*#__PURE__*/React__default.createElement(Title, {
    size: "medium"
  }, loadingMessage)), /*#__PURE__*/React__default.createElement(Loader$2, {
    active: true,
    fullscreen: false,
    surface: (theme === null || theme === void 0 ? void 0 : theme.themeId) === 'theme_dark' ? "dark" : "light"
  }));
};
var renderCheckingPhoneLoader2 = function renderCheckingPhoneLoader2(show, heading, previousPageLoaderMessage, values, theme) {
  console.log('loader renderCheckingPhoneLoader2', show, heading, previousPageLoaderMessage, values, theme);
  if (!show) {
    return;
  }
  var _values$troubleShooti3 = values.troubleShootingInfo,
    troubleShootingInfo = _values$troubleShooti3 === void 0 ? {} : _values$troubleShooti3,
    symptomId = values.symptomId;
  var output = getObjectPropertyByPath('ddata.output', troubleShootingInfo, {});
  var _output$pageContent2 = output.pageContent,
    pageContent = _output$pageContent2 === void 0 ? {} : _output$pageContent2;
  var _pageContent$steps2 = pageContent.steps,
    steps = _pageContent$steps2 === void 0 ? [] : _pageContent$steps2;
  var analysis = getStepByName('analysis', steps);
  if (analysis.dynamicWaitingScreen) {
    loadingMessage = analysis.dynamicWaitingScreen;
  } else if (symptomId == '23504' && !previousPageLoaderMessage) {
    loadingMessage = 'Please hold on while we check for your connectivity with the extender.';
    if (analysis.templateId == 'NETWORK_GOOD_GOTO_EXTENDER_TYPE') {
      loadingMessage = 'Please wait for 2 minutes while the router pairs with the Wifi extender.';
    }
  } else if (previousPageLoaderMessage && symptomId == '23504') {
    loadingMessage = 'Please hold on while we check your connection, This may take a moment.';
  } else if (selectedLocation) {
    loadingMessage = "Checking the Wifi connectivity in " + selectedLocation;
  } else {
    loadingMessage = heading;
  }
  console.log('loadingMessage ', loadingMessage);
  return /*#__PURE__*/React__default.createElement(LoaderContainer$2, null, /*#__PURE__*/React__default.createElement(Loader, {
    active: show,
    fullscreen: true
  }, /*#__PURE__*/React__default.createElement(Title, {
    size: "medium"
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: loadingMessage
    }
  }))), /*#__PURE__*/React__default.createElement(Loader$2, {
    active: true,
    fullscreen: false,
    surface: (theme === null || theme === void 0 ? void 0 : theme.themeId) === 'theme_dark' ? "dark" : "light"
  }));
};
var renderPage = function renderPage(values, functions, showModal, actionHappened, allIntentsData, pendingCases, combinedIssueSelector, alertBanners, setShowCheckingPhoneLoader, showIssueResolved, issueResolvedContent, smartAIData, sendMessage, setSendMessage, languageIndicator, setLanguageIndicator) {
  var _window$tsFeatureFlag, _mvoTroubleShootingJs, _mvoTroubleShootingJs2, _mvoTroubleShootingJs3;
  if (showModal === void 0) {
    showModal = false;
  }
  if (showIssueResolved === void 0) {
    showIssueResolved = false;
  }
  if (issueResolvedContent === void 0) {
    issueResolvedContent = {};
  }
  if (sendMessage === void 0) {
    sendMessage = '';
  }
  if (languageIndicator === void 0) {
    languageIndicator = '';
  }
  var routesArr = location.hash.split('/');
  if (window.isMVODigital && (_window$tsFeatureFlag = window.tsFeatureFlags) !== null && _window$tsFeatureFlag !== void 0 && _window$tsFeatureFlag.enableEOTRemoveHashFFlag && (window.location.href.includes("midflowsecure") || window.location.href.includes("eotsecure")) && !(window.location.href.includes("/#/midflowsecure") || window.location.href.includes("/#/eotsecure"))) {
    routesArr = window.location.search.split("/");
  }
  console.log("Routes Array", routesArr);
  var activePage = values.activePage,
    _values$landingInfo3 = values.landingInfo,
    landingInfo = _values$landingInfo3 === void 0 ? {} : _values$landingInfo3;
  console.log("Main:renderPage: activePage: " + activePage);
  console.log(values);
  var mvoTroubleShootingJson = sessionUtility.getTroubleShootingJson();
  var is5GDevice = (_mvoTroubleShootingJs = mvoTroubleShootingJson === null || mvoTroubleShootingJson === void 0 ? void 0 : (_mvoTroubleShootingJs2 = mvoTroubleShootingJson.ddata) === null || _mvoTroubleShootingJs2 === void 0 ? void 0 : (_mvoTroubleShootingJs3 = _mvoTroubleShootingJs2.device) === null || _mvoTroubleShootingJs3 === void 0 ? void 0 : _mvoTroubleShootingJs3.is5GDevice) != null ? _mvoTroubleShootingJs : false;
  var ErrorPage = function ErrorPage() {
    console.log('comren ErrorPage');
    var mvoConfig = sessionUtility.getMvoConfig();
    if (mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.errorDetails) {
      var errorMessage = mvoConfig === null || mvoConfig === void 0 ? void 0 : mvoConfig.errorDetails.message;
      throw new Error(errorMessage);
    }
    return null;
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(ContentWrapper$g, {
    id: "ContentWrapper",
    className: ""
  }, /*#__PURE__*/React__default.createElement(ErrorPage, null), activePage === 'nrb' && /*#__PURE__*/React__default.createElement(NetworkExtenderNrb, null), activePage === 'diagnostics' && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(EotSigninBanner, null), /*#__PURE__*/React__default.createElement(WaitResultDiagnostics, {
    functions: functions,
    values: values,
    combinedIssueSelector: combinedIssueSelector
  })), activePage === 'main_symptom' && Object.keys(landingInfo).length > 0 && combinedIssueSelector && /*#__PURE__*/React__default.createElement(CombinedSymptoms, {
    functions: functions,
    values: values,
    allIntentsData: allIntentsData,
    pendingCases: pendingCases,
    alertBanners: alertBanners,
    setShowCheckingPhoneLoader: setShowCheckingPhoneLoader
  }), (activePage === 'trouble_shooting' || activePage === 'waitscreen') && (!is5GDevice || routesArr.includes('eotsecure') || routesArr.includes('midflowsecure')) && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(EotSigninBanner, null), /*#__PURE__*/React__default.createElement(TroubleShootingNewPage, {
    actionHappened: actionHappened,
    functions: functions,
    values: values,
    combinedIssueSelector: combinedIssueSelector,
    sendMessage: sendMessage,
    setSendMessage: setSendMessage,
    languageIndicator: languageIndicator,
    setLanguageIndicator: setLanguageIndicator
  })), activePage === 'questions' && /*#__PURE__*/React__default.createElement(QuestionsPage, {
    functions: functions,
    values: values
  }), activePage === 'account_issue' && /*#__PURE__*/React__default.createElement(AccountIssuePage, {
    functions: functions,
    values: values
  }), activePage === 'contacts' && /*#__PURE__*/React__default.createElement(ContactsPage, {
    functions: functions,
    values: values,
    showTextMeModal: showModal
  }), activePage === 'network_outage' && /*#__PURE__*/React__default.createElement(NetworkOutagePage, {
    functions: functions,
    values: values
  }), activePage === 'devices' && /*#__PURE__*/React__default.createElement(Devices, {
    functions: functions,
    values: values
  }), activePage === 'wifi' && /*#__PURE__*/React__default.createElement(Wifi, {
    functions: functions,
    values: values
  }), activePage === 'blackspot' && /*#__PURE__*/React__default.createElement(BlackSpot, {
    functions: functions,
    values: values
  }), activePage === 'extender' && /*#__PURE__*/React__default.createElement(Extender, {
    functions: functions,
    values: values
  }), activePage === 'smartSolutionDiagnostic' && /*#__PURE__*/React__default.createElement(SmartSolution, {
    smartData: smartAIData,
    values: values
  }), activePage === 'smartSoutionIq' && /*#__PURE__*/React__default.createElement(SmartSolutionIq, {
    smartData: smartAIData,
    values: values
  }), activePage === 'completion' && /*#__PURE__*/React__default.createElement(CompletionPageView, {
    actionHappened: actionHappened,
    functions: functions,
    values: values,
    combinedIssueSelector: combinedIssueSelector
  }), showIssueResolved === true && /*#__PURE__*/React__default.createElement(IssueResolved, {
    functions: functions,
    content: issueResolvedContent
  })));
};
var Main = function Main(props) {
  var _configDetails$params6, _window11, _window11$troubleShoo, _window11$troubleShoo2, _window11$troubleShoo3, _window12, _window12$troubleShoo, _window12$troubleShoo2, _window12$troubleShoo3, _values$context2, _troubleshootingDetai21, _troubleshootingDetai22, _window13, _window14, _values$landingInfo$d, _values$landingInfo10, _values$landingInfo11, _values$outageInfo$da, _values$outageInfo3, _values$outageInfo3$d, _configDetails$config170, _mvoTroubleShootingJs20, _mvoTroubleShootingJs21, _configDetails$config171, _configDetails$config172, _configDetails$params31, _configDetails$params32, _configDetails$params33, _configDetails$params34;
  var configDetails = useContext(ConfigContext);
  var combinedIssueSelector = configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params6 = configDetails.paramsDetails) === null || _configDetails$params6 === void 0 ? void 0 : _configDetails$params6.combinedIssueSelector;
  console.log('info configDetails Main', configDetails, (_window11 = window) === null || _window11 === void 0 ? void 0 : (_window11$troubleShoo = _window11.troubleShootingJson) === null || _window11$troubleShoo === void 0 ? void 0 : (_window11$troubleShoo2 = _window11$troubleShoo.ddata) === null || _window11$troubleShoo2 === void 0 ? void 0 : (_window11$troubleShoo3 = _window11$troubleShoo2.device) === null || _window11$troubleShoo3 === void 0 ? void 0 : _window11$troubleShoo3.is5GDevice);
  var uiLoggerContext = useContext(UiLoggerContext);
  var _useState = useState({
      activePage: (_window12 = window) !== null && _window12 !== void 0 && (_window12$troubleShoo = _window12.troubleShootingJson) !== null && _window12$troubleShoo !== void 0 && (_window12$troubleShoo2 = _window12$troubleShoo.ddata) !== null && _window12$troubleShoo2 !== void 0 && (_window12$troubleShoo3 = _window12$troubleShoo2.device) !== null && _window12$troubleShoo3 !== void 0 && _window12$troubleShoo3.is5GDevice || combinedIssueSelector ? 'main_symptom' : '',
      addressCheck: true,
      validInput: '',
      symptomId: '',
      accountIssueInfo: {},
      context: {},
      landingInfo: {},
      outageInfo: {},
      questionRecordIds: [],
      questionsParams: {},
      symptom: {},
      troubleShootingInfo: {},
      searchResults: {},
      showModal: false,
      showSearchResults: false,
      showTypeAhead: false,
      replayMain: false,
      feedbackContainerDetails: {
        show: false,
        success: false
      },
      thumbsUpClick: false,
      thumbsDownClick: false,
      techCoachEligiblity: {
        accountElgible: false,
        intentEligible: false,
        openPopup: false,
        openChatbotFlowPopup: false
      },
      flags: {
        justAfterThumbsDownClicked: false,
        showThumbsUp: false,
        showThumbsDown: false,
        thumbsClicked: false,
        submitClicked: false,
        rating: ''
      }
    }),
    values = _useState[0],
    setValues = _useState[1];
  useEffect(function () {
    setPageTitle(values, configDetails);
  }, [(_values$context2 = values.context) === null || _values$context2 === void 0 ? void 0 : _values$context2.personalizedTitle]);
  var FLAGS_DEFAULT = {
    justAfterThumbsDownClicked: false,
    showThumbsUp: false,
    showThumbsDown: false,
    thumbsClicked: false,
    submitClicked: false,
    rating: ''
  };
  console.log('activePage', values.activePage);
  var _useState2 = useState({}),
    allIntentsData = _useState2[0],
    setAllIntentsData = _useState2[1];
  var _useState3 = useState({}),
    pendingCases = _useState3[0],
    setPendingCases = _useState3[1];
  var _useState4 = useState([]),
    alertBanners = _useState4[0],
    setAlertBanners = _useState4[1];
  var _useState5 = useState(false),
    actionHappened = _useState5[0],
    setActionHappened = _useState5[1];
  var _useState6 = useState({}),
    smartAIData = _useState6[0],
    setSmartAIData = _useState6[1];
  var _useState7 = useState(''),
    templateType = _useState7[0],
    setTemplateType = _useState7[1];
  var _useState8 = useState({
      show: false,
      heading: ''
    }),
    showCheckingPhoneLoader5g = _useState8[0],
    setshowCheckingPhoneLoader5g = _useState8[1];
  var _useState9 = useState(''),
    sendMessage = _useState9[0],
    setSendMessage = _useState9[1];
  var _useState0 = useState(''),
    languageIndicator = _useState0[0],
    setLanguageIndicator = _useState0[1];
  var _useState1 = useState(false),
    showCheckingPhoneLoader = _useState1[0],
    setShowCheckingPhoneLoader = _useState1[1];
  var _useState10 = useState(false),
    show5gloadingmsg = _useState10[0],
    set5gloadingmsg = _useState10[1];
  var _useState11 = useState(''),
    showCallScheduleModal = _useState11[0],
    setShowCallScheduleModal = _useState11[1];
  var _useState12 = useState(''),
    supportRequestNumber = _useState12[0],
    setSupportRequestNumber = _useState12[1];
  var _useState13 = useState(false),
    previousPageLoaderMessage = _useState13[0],
    setPreviousPageLoaderMessage = _useState13[1];
  var _useState14 = useState({
      body: '',
      buttons: [],
      isError: false,
      show: false,
      title: '',
      options: [],
      link: ''
    }),
    messageModalInfo = _useState14[0],
    setMessageModalInfo = _useState14[1];
  var _useState15 = useState(false),
    showErrorPage = _useState15[0],
    setShowErrorPage = _useState15[1];
  var _useState16 = useState(false),
    showIssueResolved = _useState16[0],
    setShowIssueResolved = _useState16[1];
  var _useState17 = useState({}),
    issueResolvedContent = _useState17[0],
    setIssueResolvedContent = _useState17[1];
  var _useState18 = useState(false),
    nrbEligibility = _useState18[0],
    setNrbEligibility = _useState18[1];
  var troubleshootingDetails;
  if (sessionStorage.getItem('troubleshootingDetails')) {
    troubleshootingDetails = JSON.parse(sessionStorage.getItem('troubleshootingDetails'));
  }
  var selectedMtn = !isEmpty((_troubleshootingDetai21 = troubleshootingDetails) === null || _troubleshootingDetai21 === void 0 ? void 0 : _troubleshootingDetai21.mtn) ? (_troubleshootingDetai22 = troubleshootingDetails) === null || _troubleshootingDetai22 === void 0 ? void 0 : _troubleshootingDetai22.mtn : configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.mdn;
  var additionalMtn = (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns) || [];
  var filteredDeviceSku;
  additionalMtn.forEach(function (mtnObj, index) {
    if (mtnObj.mtn == selectedMtn) {
      filteredDeviceSku = mtnObj.deviceSku;
    }
  });
  var _useState19 = useState(null),
    error = _useState19[0],
    setError = _useState19[1];
  if (error) {
    throw error;
  }
  var updateValues = function updateValues(currentValues, newValues) {
    var _ref6 = newValues.context || {},
      personalizedTitle = _ref6.personalizedTitle;
    var tsData = _extends({}, currentValues, newValues);
    if (!!personalizedTitle) {
      tsData.symptom.issueName = personalizedTitle;
    }
    if (!newValues.flags) {
      tsData.flags = FLAGS_DEFAULT;
    }
    setValues(_extends({}, tsData));
  };
  var launchPageType = getParameterByName('launchPage') !== 'null' ? getParameterByName('launchPage') : '';
  console.log(launchPageType);
  sessionStorage.setItem('launchPageType', launchPageType);
  var refPageId = useRef(0);
  var articleType;
  var param1;
  var param2;
  var routerParams = useParams();
  var selectedDevice;
  var location = useLocation();
  var history = useHistory();
  var deviceHealthData;
  if (sessionStorage.getItem('deviceHealthData')) {
    deviceHealthData = JSON.parse(sessionStorage.getItem('deviceHealthData'));
  }
  var isHealthCheck = ((_window13 = window) === null || _window13 === void 0 ? void 0 : _window13.hlthFlow) || false;
  var isRecommendedIssue = ((_window14 = window) === null || _window14 === void 0 ? void 0 : _window14.recIssue) || false;
  var isNavHistFlow = false;
  var callSubmitVira = function callSubmitVira(troubleShootingInfo, landingInfo, outageInfo, symptom, allIntentsData, nsaIntentId, envData, activePage, tsData, routesArr, isLVFlow, techCoachFlags) {
    if (isLVFlow === void 0) {
      isLVFlow = false;
    }
    if (techCoachFlags === void 0) {
      techCoachFlags = {};
    }
    try {
      var _window15, _window15$config, _window15$config$trou, _window15$config$trou2, _window15$config$trou3, _window16, _window16$config, _window16$config$trou, _window16$config$trou2, _window16$config$trou3, _window17, _window17$config, _window17$config$trou, _window17$config$trou2, _window17$config$trou3, _window18, _window18$config, _window18$config$case, _window19, _window19$config, _window19$config$case, _window20, _window20$config, _window20$config$case, _window21, _window22, _window22$config, _window23, _window24, _window24$config, _window25, _window25$config, _window25$config$trou, _window25$config$trou2, _window25$config$trou3, _window26, _window26$config, _window26$config$case;
      var tsParams = {
        deviceSku: window.isMVODigital ? ((_window15 = window) === null || _window15 === void 0 ? void 0 : (_window15$config = _window15.config) === null || _window15$config === void 0 ? void 0 : (_window15$config$trou = _window15$config.troubleShootingJson) === null || _window15$config$trou === void 0 ? void 0 : (_window15$config$trou2 = _window15$config$trou.ddata) === null || _window15$config$trou2 === void 0 ? void 0 : (_window15$config$trou3 = _window15$config$trou2.device) === null || _window15$config$trou3 === void 0 ? void 0 : _window15$config$trou3.deviceSku) || filteredDeviceSku : (_window16 = window) === null || _window16 === void 0 ? void 0 : (_window16$config = _window16.config) === null || _window16$config === void 0 ? void 0 : (_window16$config$trou = _window16$config.troubleShootingJson) === null || _window16$config$trou === void 0 ? void 0 : (_window16$config$trou2 = _window16$config$trou.ddata) === null || _window16$config$trou2 === void 0 ? void 0 : (_window16$config$trou3 = _window16$config$trou2.device) === null || _window16$config$trou3 === void 0 ? void 0 : _window16$config$trou3.deviceSku,
        equipmentId: (_window17 = window) === null || _window17 === void 0 ? void 0 : (_window17$config = _window17.config) === null || _window17$config === void 0 ? void 0 : (_window17$config$trou = _window17$config.troubleShootingJson) === null || _window17$config$trou === void 0 ? void 0 : (_window17$config$trou2 = _window17$config$trou.ddata) === null || _window17$config$trou2 === void 0 ? void 0 : (_window17$config$trou3 = _window17$config$trou2.device) === null || _window17$config$trou3 === void 0 ? void 0 : _window17$config$trou3.equipmentId,
        deviceType: '',
        is5GDevice: false,
        intent: (_window18 = window) === null || _window18 === void 0 ? void 0 : (_window18$config = _window18.config) === null || _window18$config === void 0 ? void 0 : (_window18$config$case = _window18$config.caseDetails) === null || _window18$config$case === void 0 ? void 0 : _window18$config$case.intent,
        intentId: nsaIntentId,
        mtn: (_window19 = window) === null || _window19 === void 0 ? void 0 : (_window19$config = _window19.config) === null || _window19$config === void 0 ? void 0 : (_window19$config$case = _window19$config.caseDetails) === null || _window19$config$case === void 0 ? void 0 : _window19$config$case.mtn,
        mtnId: (_window20 = window) === null || _window20 === void 0 ? void 0 : (_window20$config = _window20.config) === null || _window20$config === void 0 ? void 0 : (_window20$config$case = _window20$config.caseDetails) === null || _window20$config$case === void 0 ? void 0 : _window20$config$case.mtnId,
        channelId: window.isMVODigital && ((_window21 = window) !== null && _window21 !== void 0 && _window21.isLoggedOut || (_window22 = window) !== null && _window22 !== void 0 && (_window22$config = _window22.config) !== null && _window22$config !== void 0 && _window22$config.isLoggedOut) ? 'Verizon Website' : 'My Verizon',
        processAction: '',
        processStep: isLVFlow ? 'resume' : 'Next',
        loggedInUser: null,
        tierId: 1,
        changeDevice: window.isMVODigital ? (_window23 = window) !== null && _window23 !== void 0 && _window23.isLoggedOut || (_window24 = window) !== null && _window24 !== void 0 && (_window24$config = _window24.config) !== null && _window24$config !== void 0 && _window24$config.isLoggedOut ? true : isChangeDeviceFlow(configDetails) : false,
        caseId: allIntentsData === null || allIntentsData === void 0 ? void 0 : allIntentsData.caseId,
        seoUrl: (_window25 = window) === null || _window25 === void 0 ? void 0 : (_window25$config = _window25.config) === null || _window25$config === void 0 ? void 0 : (_window25$config$trou = _window25$config.troubleShootingJson) === null || _window25$config$trou === void 0 ? void 0 : (_window25$config$trou2 = _window25$config$trou.ddata) === null || _window25$config$trou2 === void 0 ? void 0 : (_window25$config$trou3 = _window25$config$trou2.device) === null || _window25$config$trou3 === void 0 ? void 0 : _window25$config$trou3.soeUrl,
        accountNumber: (_window26 = window) === null || _window26 === void 0 ? void 0 : (_window26$config = _window26.config) === null || _window26$config === void 0 ? void 0 : (_window26$config$case = _window26$config.caseDetails) === null || _window26$config$case === void 0 ? void 0 : _window26$config$case.accountNumber
      };
      if (window.isMVODigital && tsParams !== null && tsParams !== void 0 && tsParams.intentId.startsWith('IN') && !window.isLoggedOut && !sessionStorage.getItem('propositionNBX')) {
        var _configDetails$config12, _configDetails$config13;
        console.log("tech coach" + (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config12 = configDetails.config) === null || _configDetails$config12 === void 0 ? void 0 : _configDetails$config12.isTechCoachEligible));
        var techCoachEligible = configDetails !== null && configDetails !== void 0 && (_configDetails$config13 = configDetails.config) !== null && _configDetails$config13 !== void 0 && _configDetails$config13.isTechCoachEligible ? true : false;
        callAndSetNBXTroubleShooting(techCoachEligible, envData, tsParams.intentId);
      }
      getNBXParams(tsParams);
      if (isHealthCheck) {
        var _deviceHealthData12, _deviceHealthData13, _deviceHealthData22;
        tsParams.isHealthCheck = isHealthCheck;
        tsParams.caseId = (_deviceHealthData12 = deviceHealthData) === null || _deviceHealthData12 === void 0 ? void 0 : _deviceHealthData12.caseId;
        tsParams.isRecommendedIssue = isRecommendedIssue;
        tsParams.changeDevice = false;
        if (isRecommendedIssue || (_deviceHealthData13 = deviceHealthData) !== null && _deviceHealthData13 !== void 0 && _deviceHealthData13.isNavHistFlow) {
          var _deviceHealthData14, _deviceHealthData15, _deviceHealthData16, _deviceHealthData17, _deviceHealthData18, _deviceHealthData19, _deviceHealthData20, _deviceHealthData21;
          tsParams.intent = (_deviceHealthData14 = deviceHealthData) === null || _deviceHealthData14 === void 0 ? void 0 : _deviceHealthData14.intent;
          tsParams.intentId = (_deviceHealthData15 = deviceHealthData) === null || _deviceHealthData15 === void 0 ? void 0 : _deviceHealthData15.intentId;
          tsParams.mtn = (_deviceHealthData16 = deviceHealthData) === null || _deviceHealthData16 === void 0 ? void 0 : _deviceHealthData16.mdn;
          tsParams.mtnId = (_deviceHealthData17 = deviceHealthData) === null || _deviceHealthData17 === void 0 ? void 0 : _deviceHealthData17.mtnId;
          tsParams.pageId = (_deviceHealthData18 = deviceHealthData) === null || _deviceHealthData18 === void 0 ? void 0 : _deviceHealthData18.pageId;
          sessionStorage.setItem('troubleshootingDetails', JSON.stringify(_extends({}, JSON.parse(sessionStorage.getItem('troubleshootingDetails')), {
            intent: (_deviceHealthData19 = deviceHealthData) === null || _deviceHealthData19 === void 0 ? void 0 : _deviceHealthData19.intent,
            intentId: (_deviceHealthData20 = deviceHealthData) === null || _deviceHealthData20 === void 0 ? void 0 : _deviceHealthData20.intentId,
            mtn: (_deviceHealthData21 = deviceHealthData) === null || _deviceHealthData21 === void 0 ? void 0 : _deviceHealthData21.mdn
          })));
        }
        if ((_deviceHealthData22 = deviceHealthData) !== null && _deviceHealthData22 !== void 0 && _deviceHealthData22.isNavHistFlow) {
          var _deviceHealthData23, _deviceHealthData24;
          tsParams.processStep = (_deviceHealthData23 = deviceHealthData) === null || _deviceHealthData23 === void 0 ? void 0 : _deviceHealthData23.processStep;
          (_deviceHealthData24 = deviceHealthData) === null || _deviceHealthData24 === void 0 ? true : delete _deviceHealthData24.isNavHistFlow;
          sessionStorage.setItem('deviceHealthData', JSON.stringify(deviceHealthData));
        }
      }
      console.log('troubleShootingInfo', troubleShootingInfo);
      return Promise.resolve(submitActionForTroubleShooting(tsParams, envData)).then(function (_submitActionForTroub2) {
        troubleShootingInfo = _submitActionForTroub2;
        var _troubleShootingInfo = troubleShootingInfo,
          _troubleShootingInfo$ = _troubleShootingInfo.context,
          context = _troubleShootingInfo$ === void 0 ? {} : _troubleShootingInfo$;
        var pageContent = getObjectPropertyByPath('ddata.output.pageContent', troubleShootingInfo, {});
        console.log('activePage', activePage);
        activePage = getPageFromSteps(pageContent, setTemplateType);
        console.log('tsData', tsData);
        tsData = {
          landingInfo: landingInfo,
          outageInfo: outageInfo,
          troubleShootingInfo: troubleShootingInfo,
          context: context,
          activePage: activePage,
          symptom: symptom
        };
        if (!isEmpty(techCoachFlags)) {
          tsData['techCoachEligiblity'] = techCoachFlags['techCoachEligiblity'];
        }
        console.log('tsData', tsData);
        setDataPostSubmit(troubleShootingInfo, routesArr, refPageId, setTemplateType);
        updateValues(values, tsData);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var getChannelTagging = function getChannelTagging(channel_id, getChannel) {
    if (channel_id === void 0) {
      channel_id = '';
    }
    if (getChannel === void 0) {
      getChannel = '';
    }
    var result = 'vzw';
    if (channel_id == 'CARE') {
      result = 'ACSS';
    } else if (channel_id == 'Retail' && getChannel == 'source') {
      result = 'POS';
    } else if (channel_id == 'Retail' && getChannel === 'display') {
      result = 'retail';
    }
    return result;
  };
  useEffect(function () {
    var current = true;
    var initialize = function initialize() {
      try {
        var _configDetails$params7, _configDetails$params8;
        var tsData = false;
        var envData = {
          externalTarget: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params7 = configDetails.paramsDetails) === null || _configDetails$params7 === void 0 ? void 0 : _configDetails$params7.externalTarget,
          mvoenv: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params8 = configDetails.paramsDetails) === null || _configDetails$params8 === void 0 ? void 0 : _configDetails$params8.mvoenv
        };
        if (enablePageCache) {
          var tsJson = sessionStorage.getItem('tsData') || '';
          tsData = tsJson ? JSON.parse(tsJson) : false;
        }
        if (window.vzwDL && window.vzwDL.authentication && window.vzwDL.authentication.eHash2) {
          window.vzdl.user.encEmailid = window.vzwDL.authentication.eHash2;
        }
        if (window.vzwDL && window.vzwDL.authentication && window.vzwDL.authentication.mHash2) {
          window.vzdl.user.emcMdn = window.vzwDL.authentication.mHash2;
        }
        return Promise.resolve(getLandingInfo()).then(function (landingInfo) {
          var _landingInfo$device6;
          function _temp33() {
            var _configDetails$config107, _configDetails$config108, _window$tsFeatureFlag7;
            var _exit = false;
            function _temp31(_result) {
              var _exit2 = false;
              if (_exit) return _result;
              function _temp29(_result4) {
                var _exit3 = false;
                if (_exit2) return _result4;
                function _temp27(_result6) {
                  if (_exit3) return _result6;
                  function _temp25() {
                    function _temp23() {
                      if (!templateId && !currentPageId) {
                        var _window27, _window27$tsFeatureFl, _configDetails$params9, _configDetails$params0, _window28, _window28$vzdl, _window28$vzdl$user, _window29, _window29$vzdl, _window29$vzdl$user, _window$tsFeatureFlag2, _configDetails$config14, _window$tsFeatureFlag3, _configDetails$config15;
                        console.log("configDetails++++++++", configDetails);
                        var subFlow = window.isMVODigital && (_window27 = window) !== null && _window27 !== void 0 && (_window27$tsFeatureFl = _window27.tsFeatureFlags) !== null && _window27$tsFeatureFl !== void 0 && _window27$tsFeatureFl.enableDeviceNameForTaggingFFlag ? deviceName : deviceOem + "_" + deviceSku;
                        var flow = isFwa || is5GDevice ? 'troubleshooting_asistant_fwa' : 'troubleshooting_asistant_mobile';
                        var sourceChannel = getChannelTagging(configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params9 = configDetails.paramsDetails) === null || _configDetails$params9 === void 0 ? void 0 : _configDetails$params9.channel, 'source');
                        var displayChannel = getChannelTagging(configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params0 = configDetails.paramsDetails) === null || _configDetails$params0 === void 0 ? void 0 : _configDetails$params0.channel, 'display');
                        var pageTypeLinkname = "1|What is wrong with your " + deviceName;
                        var throttle = "NSA";
                        var messaageId = "click on the checkbox to proceed";
                        var inApp = isMVA$1 ? 'mva' : 'vzw';
                        var detail = '';
                        var accountHash = ((_window28 = window) === null || _window28 === void 0 ? void 0 : (_window28$vzdl = _window28.vzdl) === null || _window28$vzdl === void 0 ? void 0 : (_window28$vzdl$user = _window28$vzdl.user) === null || _window28$vzdl$user === void 0 ? void 0 : _window28$vzdl$user.account) || '';
                        var mtnHash = ((_window29 = window) === null || _window29 === void 0 ? void 0 : (_window29$vzdl = _window29.vzdl) === null || _window29$vzdl === void 0 ? void 0 : (_window29$vzdl$user = _window29$vzdl.user) === null || _window29$vzdl$user === void 0 ? void 0 : _window29$vzdl$user.id) || '';
                        var eventValue = (currentPageId === null || currentPageId === void 0 ? void 0 : currentPageId.toString()) === '1';
                        var eventId = eventValue;
                        var page = {
                          name: 'Issue Selector',
                          id: "1",
                          linkName: "Troubleshooting",
                          subFlow: subFlow,
                          flow: flow,
                          pageTypeLinkname: pageTypeLinkname,
                          sourceChannel: sourceChannel,
                          displayChannel: displayChannel,
                          throttle: throttle,
                          messaageId: messaageId,
                          inApp: inApp,
                          detail: detail
                        };
                        tagging.setPageView({
                          page: _extends({}, page),
                          target: {
                            engagement: {
                              intent: 'support'
                            },
                            sandBox: "200",
                            messaage: "click on the checkbox to proceed"
                          },
                          env: {
                            businessUnit: 'Wireless'
                          },
                          user: {
                            authStatus: window.isMVODigital && !window.isLoggedOut ? 'logged in' : 'anonymous',
                            session: 1,
                            account: window.isMVODigital && (_window$tsFeatureFlag2 = window.tsFeatureFlags) !== null && _window$tsFeatureFlag2 !== void 0 && _window$tsFeatureFlag2.mtnAccountHashMismatchFFlag ? configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config14 = configDetails.config) === null || _configDetails$config14 === void 0 ? void 0 : _configDetails$config14.accountHash : accountHash,
                            id: window.isMVODigital && (_window$tsFeatureFlag3 = window.tsFeatureFlags) !== null && _window$tsFeatureFlag3 !== void 0 && _window$tsFeatureFlag3.mtnAccountHashMismatchFFlag ? configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config15 = configDetails.config) === null || _configDetails$config15 === void 0 ? void 0 : _configDetails$config15.selectedMtnHash : mtnHash
                          },
                          event: {
                            value: eventId
                          },
                          error: {
                            code: window.isMVODigital ? '' : '404|Page not found'
                          },
                          search: {
                            term: 'searchResults'
                          }
                        });
                        logClickStream('PAGE-LOADED', 'PAGE-LOADED', 'PAGE-LOADED', '');
                      }
                      if (!locationArr.includes('chatbot') && !locationArr.includes('nrbflow')) {
                        var _troubleShootingInfo2 = troubleShootingInfo,
                          _troubleShootingInfo3 = _troubleShootingInfo2.context,
                          context = _troubleShootingInfo3 === void 0 ? {} : _troubleShootingInfo3;
                        var pageContent = getObjectPropertyByPath('ddata.output.pageContent', troubleShootingInfo);
                        if (pageContent) {
                          activePage = getPageFromSteps(pageContent, setTemplateType) || values.activePage;
                        }
                        if (!tsData) {
                          tsData = {
                            landingInfo: landingInfo,
                            outageInfo: outageInfo,
                            troubleShootingInfo: troubleShootingInfo,
                            context: context,
                            activePage: activePage,
                            symptom: symptom
                          };
                          if (configDetails !== null && configDetails !== void 0 && configDetails.selectedNSAIntent) {
                            var _configDetails$select, _configDetails$select2;
                            tsData.symptom.issueName = (_configDetails$select = configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select2 = configDetails.selectedNSAIntent) === null || _configDetails$select2 === void 0 ? void 0 : _configDetails$select2.intent) != null ? _configDetails$select : '';
                          }
                        }
                        console.log('tsData', tsData, 'activePage', activePage);
                        updateValues(values, tsData);
                      }
                      if (activePage === 'waitscreen') {
                        var _configDetails$config16;
                        var _troubleShootingInfo4 = troubleShootingInfo,
                          _troubleShootingInfo5 = _troubleShootingInfo4.context,
                          _context = _troubleShootingInfo5 === void 0 ? {} : _troubleShootingInfo5;
                        window.setTimeout(function () {
                          _processTroubleShootingPage('Poll', 'Next', parseInt(currentPageId, 10), activePage, _context, '', '', '', '', '', '', '', '', {
                            newValues: tsData
                          });
                        }, (_configDetails$config16 = configDetails.config) === null || _configDetails$config16 === void 0 ? void 0 : _configDetails$config16.pollDelay);
                      }
                    }
                    var runMode = sessionUtility.getRunMode();
                    var _temp22 = function () {
                      if (runMode === 'development' && singlePageMode) {
                        tsData = false;
                        var _temp21 = _switch(values.activePage, [[function () {
                          return 'account_issue';
                        }, function () {
                          return Promise.resolve(getAccountIssueInfo(envData)).then(function (_getAccountIssueInfo) {
                            troubleShootingInfo = _getAccountIssueInfo;
                          });
                        }], [function () {
                          return 'contacts';
                        }, function () {
                          return Promise.resolve(getContactsInfo(envData)).then(function (_getContactsInfo) {
                            troubleShootingInfo = _getContactsInfo;
                          });
                        }], [function () {
                          return 'network_outage';
                        }, function () {
                          return Promise.resolve(getOutagePageInfo(envData)).then(function (_getOutagePageInfo) {
                            troubleShootingInfo = _getOutagePageInfo;
                          });
                        }], [function () {
                          return 'questions';
                        }, function () {
                          return Promise.resolve(getQuestionsInfo(envData)).then(function (_getQuestionsInfo) {
                            troubleShootingInfo = _getQuestionsInfo;
                          });
                        }], [], [function () {
                          return 'trouble_shooting';
                        }, function () {
                          return Promise.resolve(getTroubleShootingInfo(envData)).then(function (_getTroubleShootingIn) {
                            troubleShootingInfo = _getTroubleShootingIn;
                          });
                        }]]);
                        if (_temp21 && _temp21.then) return _temp21.then(function () {});
                      }
                    }();
                    return _temp22 && _temp22.then ? _temp22.then(_temp23) : _temp23(_temp22);
                  }
                  var _temp24 = function () {
                    if (curentRoute == 'test') {
                      var _mvoTroubleShootingJs4, _mvoTroubleShootingJs5, _mvoTroubleShootingJs6;
                      console.log('info test-vira param1', param1);
                      console.log('info test-vira param2', param2);
                      var fp1 = param2 === null || param2 === void 0 ? void 0 : param2.param1;
                      var fp2 = param2 === null || param2 === void 0 ? void 0 : param2.param2;
                      var newKbid;
                      var newCcid = '';
                      if (fp1) {
                        var isKbParam1 = fp1.includes('kb:');
                        var isCcParam1 = fp1.includes('cc:');
                        if (isKbParam1) {
                          newKbid = fp1 ? fp1.replace('kb:', '') : '';
                        }
                        if (isCcParam1) {
                          newCcid = fp1 ? fp1.replace('cc:', '') : '';
                        }
                      }
                      if (fp2) {
                        var isKbParam2 = fp2.includes('kb:');
                        var isCcParam2 = fp2.includes('cc:');
                        if (isKbParam2) {
                          newKbid = fp2 ? fp2.replace('kb:', '') : '';
                        }
                        if (isCcParam2) {
                          newCcid = fp2 ? fp2.replace('cc:', '') : '';
                        }
                      }
                      console.log('info test-vira newKbid, newCcid', newKbid, newCcid);
                      var _landingInfo$device4 = landingInfo.device,
                        device = _landingInfo$device4 === void 0 ? {} : _landingInfo$device4,
                        _landingInfo$symptomS = landingInfo.symptomSelector,
                        symptomSelector = _landingInfo$symptomS === void 0 ? {} : _landingInfo$symptomS;
                      var _device$deviceSku2 = device.deviceSku,
                        _deviceSku = _device$deviceSku2 === void 0 ? '' : _device$deviceSku2,
                        _device$equipmentId2 = device.equipmentId,
                        equipmentId = _device$equipmentId2 === void 0 ? '' : _device$equipmentId2,
                        _device$deviceType2 = device.deviceType,
                        deviceType = _device$deviceType2 === void 0 ? '' : _device$deviceType2,
                        _is5GDevice = device.is5GDevice;
                      var _ref7 = mvoCaseDetails || [],
                        _ref7$mtn = _ref7.mtn,
                        mtn = _ref7$mtn === void 0 ? '' : _ref7$mtn,
                        _ref7$channel = _ref7.channel,
                        channel = _ref7$channel === void 0 ? '' : _ref7$channel,
                        _ref7$intentId = _ref7.intentId,
                        intentId = _ref7$intentId === void 0 ? '' : _ref7$intentId,
                        _ref7$caseId = _ref7.caseId,
                        caseId = _ref7$caseId === void 0 ? '' : _ref7$caseId,
                        _ref7$intent = _ref7.intent,
                        intent = _ref7$intent === void 0 ? '' : _ref7$intent,
                        _ref7$processAction = _ref7.processAction,
                        processAction = _ref7$processAction === void 0 ? '' : _ref7$processAction,
                        _ref7$processStep = _ref7.processStep,
                        processStep = _ref7$processStep === void 0 ? '' : _ref7$processStep,
                        _ref7$tier = _ref7.tier,
                        tier = _ref7$tier === void 0 ? '' : _ref7$tier,
                        _ref7$tierId = _ref7.tierId,
                        tierId = _ref7$tierId === void 0 ? '' : _ref7$tierId;
                      var finalChannel = (configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.channel) == 'CARE' ? 'Care' : configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.channel;
                      if (window.isMVODigital) {
                        var _window30, _window31, _window31$config;
                        if ((_window30 = window) !== null && _window30 !== void 0 && _window30.isLoggedOut || (_window31 = window) !== null && _window31 !== void 0 && (_window31$config = _window31.config) !== null && _window31$config !== void 0 && _window31$config.isLoggedOut) {
                          finalChannel = 'Verizon Website';
                        } else {
                          finalChannel = 'My Verizon';
                        }
                      }
                      var params = {
                        kbid: newKbid ? newKbid : '',
                        ccid: newCcid ? newCcid : '',
                        contentType: articleType,
                        deviceSku: _deviceSku,
                        equipmentId: equipmentId || ((_mvoTroubleShootingJs4 = mvoTroubleShootingJson === null || mvoTroubleShootingJson === void 0 ? void 0 : (_mvoTroubleShootingJs5 = mvoTroubleShootingJson.ddata) === null || _mvoTroubleShootingJs5 === void 0 ? void 0 : (_mvoTroubleShootingJs6 = _mvoTroubleShootingJs5.device) === null || _mvoTroubleShootingJs6 === void 0 ? void 0 : _mvoTroubleShootingJs6.equipmentId) != null ? _mvoTroubleShootingJs4 : ''),
                        deviceType: deviceType,
                        is5GDevice: _is5GDevice,
                        intent: intent,
                        intentId: intentId,
                        mtn: mtn,
                        channelId: finalChannel || 'Care',
                        caseId: caseId,
                        tierId: (configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.tier) || tier || tierId,
                        processAction: '',
                        processStep: processStep && processStep !== '' ? processStep : 'Next'
                      };
                      return Promise.resolve(testActionForTroubleShooting(params, envData)).then(function (_testActionForTrouble) {
                        troubleShootingInfo = _testActionForTrouble;
                        var pageContent = getObjectPropertyByPath('ddata.output.pageContent', troubleShootingInfo, {});
                        activePage = getPageFromSteps(pageContent, setTemplateType);
                      });
                    }
                  }();
                  return _temp24 && _temp24.then ? _temp24.then(_temp25) : _temp25(_temp24);
                }
                console.log('configDetails combinedIssueSelector', combinedIssueSelector);
                var _temp26 = function () {
                  if (combinedIssueSelector && curentRoute != "resume") {
                    var _temp20 = function _temp20(_result5) {
                      var _window32, _window32$config;
                      if (_exit3) return _result5;
                      if (!window.isLoggedOut && !((_window32 = window) !== null && _window32 !== void 0 && (_window32$config = _window32.config) !== null && _window32$config !== void 0 && _window32$config.tangleWoodFlag)) {
                        try {
                          var _configDetails$config17, _configDetails$config18, _configDetails$config19, _configDetails$config20, _configDetails$config21, _configDetails$config22, _configDetails$config23, _configDetails$config24, _window33;
                          var mdnIndex = Number(routerParams.routeMtnId) || ((_configDetails$config17 = configDetails.config) === null || _configDetails$config17 === void 0 ? void 0 : (_configDetails$config18 = _configDetails$config17.caseDetails) === null || _configDetails$config18 === void 0 ? void 0 : _configDetails$config18.mtnId);
                          var mtn = mdnIndex !== null && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns) !== null && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns) !== undefined && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns.length) > 0 && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns[Number(mdnIndex)]) !== null && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns[Number(mdnIndex)]) !== undefined ? configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns[Number(mdnIndex)].mtn : (_configDetails$config19 = configDetails.config) === null || _configDetails$config19 === void 0 ? void 0 : (_configDetails$config20 = _configDetails$config19.caseDetails) === null || _configDetails$config20 === void 0 ? void 0 : _configDetails$config20.mtn;
                          if (isHealthCheck) {
                            var _deviceHealthData25;
                            mtn = (_deviceHealthData25 = deviceHealthData) === null || _deviceHealthData25 === void 0 ? void 0 : _deviceHealthData25.mdn;
                          }
                          var _deviceSku2 = (_configDetails$config21 = configDetails.config) === null || _configDetails$config21 === void 0 ? void 0 : (_configDetails$config22 = _configDetails$config21.troubleShootingJson) === null || _configDetails$config22 === void 0 ? void 0 : (_configDetails$config23 = _configDetails$config22.ddata) === null || _configDetails$config23 === void 0 ? void 0 : (_configDetails$config24 = _configDetails$config23.device) === null || _configDetails$config24 === void 0 ? void 0 : _configDetails$config24.deviceSku;
                          var recentPendingCaseParams = {
                            mdn: mtn,
                            mtnIndex: mdnIndex.toString(),
                            skuId: _deviceSku2
                          };
                          console.time('getRecentPendingCase');
                          if (!isNavHistFlow && !((_window33 = window) !== null && _window33 !== void 0 && _window33.recIssue)) {
                            getRecentPendingCase(recentPendingCaseParams, envData).then(function (pendingCasesResponse) {
                              var _pendingCasesResponse3;
                              console.timeEnd('getRecentPendingCase');
                              var _pendingCasesResponse = pendingCasesResponse === null || pendingCasesResponse === void 0 ? void 0 : (_pendingCasesResponse3 = pendingCasesResponse.response) === null || _pendingCasesResponse3 === void 0 ? void 0 : _pendingCasesResponse3.data,
                                _pendingCasesResponse2 = _pendingCasesResponse.errors,
                                errors = _pendingCasesResponse2 === void 0 ? [] : _pendingCasesResponse2,
                                body = _pendingCasesResponse.body;
                              var pendingCases = errors.length > 0 ? {
                                caseStatus: 'N',
                                intentName: '',
                                troubleshootingUrl: ''
                              } : body;
                              setPendingCases(pendingCases);
                            });
                          }
                        } catch (error) {
                          console.log('Get Recent Pending Case API failed catch block ' + error);
                        }
                      }
                      checkAlertBanner(envData).then(function (alertBannerResp) {
                        var _alertBannerResp$resp = alertBannerResp.response.data.sitealerts,
                          sitealerts = _alertBannerResp$resp === void 0 ? [] : _alertBannerResp$resp;
                        if (sitealerts.length > 0) {
                          setAlertBanners(sitealerts);
                        }
                      })["catch"](function (e) {
                        console.log("Alert banner call failed");
                      });
                    };
                    if (routerParams.routeMtnId) {
                      var _window34, _window35, _window35$config;
                      ((_window34 = window) === null || _window34 === void 0 ? void 0 : _window34.caseDetails) && (window.caseDetails.mtnId = Number(routerParams.routeMtnId));
                      ((_window35 = window) === null || _window35 === void 0 ? void 0 : (_window35$config = _window35.config) === null || _window35$config === void 0 ? void 0 : _window35$config.caseDetails) && (window.config.caseDetails.mtnId = Number(routerParams.routeMtnId));
                    }
                    if (routerParams.routeMtnHash) {
                      var additionalMtns = (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns) || [];
                      var foundMtn = additionalMtns.find(function (mtn) {
                        return mtn.mtnHash == routerParams.routeMtnHash;
                      });
                      if (foundMtn) {
                        var _window36, _window36$config, _window37, _window38, _window38$config, _window39;
                        var mtnHashId = additionalMtns.indexOf(foundMtn);
                        if ((_window36 = window) !== null && _window36 !== void 0 && (_window36$config = _window36.config) !== null && _window36$config !== void 0 && _window36$config.caseDetails) {
                          window.config.caseDetails.mtnId = mtnHashId;
                          window.config.caseDetails.mtn = foundMtn === null || foundMtn === void 0 ? void 0 : foundMtn.mtn;
                        }
                        if ((_window37 = window) !== null && _window37 !== void 0 && _window37.caseDetails) {
                          window.caseDetails.mtnId = mtnHashId;
                          window.caseDetails.mtn = foundMtn === null || foundMtn === void 0 ? void 0 : foundMtn.mtn;
                        }
                        if ((_window38 = window) !== null && _window38 !== void 0 && (_window38$config = _window38.config) !== null && _window38$config !== void 0 && _window38$config.troubleShootingJson) {
                          window.config.troubleShootingJson.ddata.device.deviceName = foundMtn === null || foundMtn === void 0 ? void 0 : foundMtn.deviceName;
                          window.config.troubleShootingJson.ddata.device.deviceSku = foundMtn === null || foundMtn === void 0 ? void 0 : foundMtn.deviceSku;
                          window.config.troubleShootingJson.ddata.device.equipmentId = foundMtn === null || foundMtn === void 0 ? void 0 : foundMtn.equipmentId;
                        }
                        if ((_window39 = window) !== null && _window39 !== void 0 && _window39.troubleShootingJson) {
                          window.troubleShootingJson.ddata.device.deviceName = foundMtn === null || foundMtn === void 0 ? void 0 : foundMtn.deviceName;
                          window.troubleShootingJson.ddata.device.deviceSku = foundMtn === null || foundMtn === void 0 ? void 0 : foundMtn.deviceSku;
                          window.troubleShootingJson.ddata.device.equipmentId = foundMtn === null || foundMtn === void 0 ? void 0 : foundMtn.equipmentId;
                        }
                      }
                    }
                    var _allIntentsData;
                    var _temp19 = _catch(function () {
                      var _deviceHealthData26, _window46, _window46$caseDetails, _deviceHealthData27, _deviceHealthData28, _configDetails$config45, _configDetails$config46, _configDetails$config47, _configDetails$config48, _configDetails$config49, _configDetails$config50, _configDetails$config51, _configDetails$config52, _configDetails$config53, _configDetails$config54, _configDetails$config55, _configDetails$config56, _configDetails$config57, _configDetails$config58, _configDetails$config59, _configDetails$config60, _configDetails$config61, _configDetails$config62, _configDetails$config63, _configDetails$config64, _configDetails$config65, _configDetails$config66, _configDetails$config67, _configDetails$config68, _configDetails$config69, _configDetails$config70, _configDetails$config71, _configDetails$config72, _configDetails$config73, _configDetails$config74, _configDetails$config75, _configDetails$config76, _window47, _window47$config, _configDetails$config87, _deviceHealthData29, _deviceHealthData30, _deviceHealthData31, _deviceHealthData33, _deviceHealthData34;
                      function _temp18() {
                        var _allIntentsData2, _allIntentsData3, _configDetails$config25, _configDetails$config26;
                        console.log('getAllIntents allIntentsData', _allIntentsData);
                        var pegaClassList = ((_allIntentsData2 = _allIntentsData) === null || _allIntentsData2 === void 0 ? void 0 : _allIntentsData2.pegaClassList) || [];
                        var classList = ((_allIntentsData3 = _allIntentsData) === null || _allIntentsData3 === void 0 ? void 0 : _allIntentsData3.classList) || [];
                        var nsaPrimaryIntentIds = getCookie('nsaPrimaryIntentIds');
                        var additionalMtns = (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns) || [];
                        var mdnIndex = Number(routerParams === null || routerParams === void 0 ? void 0 : routerParams.routeMtnId) || ((_configDetails$config25 = configDetails.config) === null || _configDetails$config25 === void 0 ? void 0 : (_configDetails$config26 = _configDetails$config25.caseDetails) === null || _configDetails$config26 === void 0 ? void 0 : _configDetails$config26.mtnId);
                        if (mdnIndex !== "" && mdnIndex !== undefined && mdnIndex !== null && window.isMVODigital && !window.isLoggedOut) {
                          var _configDetails$config27, _configDetails$config28;
                          var mtn = mdnIndex !== null && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns) !== null && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns) !== undefined && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns.length) > 0 && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns[Number(mdnIndex)]) !== null && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns[Number(mdnIndex)]) !== undefined ? configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns[Number(mdnIndex)].mtn : (_configDetails$config27 = configDetails.config) === null || _configDetails$config27 === void 0 ? void 0 : (_configDetails$config28 = _configDetails$config27.caseDetails) === null || _configDetails$config28 === void 0 ? void 0 : _configDetails$config28.mtn;
                          _allIntentsData.selectedMdn = mtn;
                        }
                        console.log('selectedMdn', _allIntentsData.selectedMdn, additionalMtns);
                        additionalMtns.forEach(function (mtnObj, index) {
                          if (mtnObj.mtn == _allIntentsData.selectedMdn) {
                            sessionStorage.setItem('selectedMdnIndex', index);
                          }
                        });
                        if (locationArr.includes('nrbflow')) {
                          setValues({
                            activePage: 'nrb',
                            flags: FLAGS_DEFAULT
                          });
                          _exit3 = true;
                          return;
                        }
                        if (locationArr.includes('chatbot')) {
                          var _allIntentsData4, _allIntentsData5;
                          window.caseId = (_allIntentsData4 = _allIntentsData) === null || _allIntentsData4 === void 0 ? void 0 : _allIntentsData4.caseId;
                          var bauIntentIds = ((_allIntentsData5 = _allIntentsData) === null || _allIntentsData5 === void 0 ? void 0 : _allIntentsData5.bauIntentIds) || '';
                          var bauIntentIdsArr = bauIntentIds.split(',');
                          var nsaIntentId;
                          var bauIntentId;
                          if (bauIntentIdsArr.length) {
                            var foundBAUIntentId = false;
                            for (var i = 0; i < bauIntentIdsArr.length; i++) {
                              var _window40, _window40$config, _window40$config$case, _window41, _window41$config, _window41$config$case;
                              var bauIntentIdArr = bauIntentIdsArr[i].split('#');
                              nsaIntentId = bauIntentIdArr[0];
                              bauIntentId = bauIntentIdArr[1];
                              if (nsaIntentId == ((_window40 = window) === null || _window40 === void 0 ? void 0 : (_window40$config = _window40.config) === null || _window40$config === void 0 ? void 0 : (_window40$config$case = _window40$config.caseDetails) === null || _window40$config$case === void 0 ? void 0 : _window40$config$case.intentId) || bauIntentId == ((_window41 = window) === null || _window41 === void 0 ? void 0 : (_window41$config = _window41.config) === null || _window41$config === void 0 ? void 0 : (_window41$config$case = _window41$config.caseDetails) === null || _window41$config$case === void 0 ? void 0 : _window41$config$case.intentId)) {
                                foundBAUIntentId = true;
                                break;
                              }
                            }
                            var isSymptomElgibleForTechCoach = false;
                            if (foundBAUIntentId) {
                              var _window42, _window42$config, _window42$config$case;
                              console.log('make getDeviceSymptoms call then redirect to bau');
                              if ((_window42 = window) !== null && _window42 !== void 0 && (_window42$config = _window42.config) !== null && _window42$config !== void 0 && (_window42$config$case = _window42$config.caseDetails) !== null && _window42$config$case !== void 0 && _window42$config$case.intent.startsWith('How To')) {
                                var _window43, _window43$config, _window43$config$case, _allIntentsData6;
                                handleHowToIntent(bauIntentId, (_window43 = window) === null || _window43 === void 0 ? void 0 : (_window43$config = _window43.config) === null || _window43$config === void 0 ? void 0 : (_window43$config$case = _window43$config.caseDetails) === null || _window43$config$case === void 0 ? void 0 : _window43$config$case.intent, (_allIntentsData6 = _allIntentsData) === null || _allIntentsData6 === void 0 ? void 0 : _allIntentsData6.selectedMdn);
                              } else {
                                try {
                                  var _configDetails$config29, _configDetails$config30, _configDetails$config31, _configDetails$config32, _configDetails$config33, _configDetails$config34, _configDetails$config35, _configDetails$config36, _configDetails$config37, _configDetails$config38, _configDetails$config39, _configDetails$config40;
                                  var selectedMdnIndex = sessionStorage.getItem('selectedMdnIndex');
                                  if (selectedMdnIndex == undefined || selectedMdnIndex == null) {
                                    selectedMdnIndex = '';
                                  }
                                  var deviceSku1 = encodeURIComponent(encodeURIComponent(configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config29 = configDetails.config) === null || _configDetails$config29 === void 0 ? void 0 : (_configDetails$config30 = _configDetails$config29.troubleShootingJson) === null || _configDetails$config30 === void 0 ? void 0 : (_configDetails$config31 = _configDetails$config30.ddata) === null || _configDetails$config31 === void 0 ? void 0 : (_configDetails$config32 = _configDetails$config31.device) === null || _configDetails$config32 === void 0 ? void 0 : _configDetails$config32.deviceSku));
                                  var redirectUrl = "/support/" + (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config33 = configDetails.config) === null || _configDetails$config33 === void 0 ? void 0 : (_configDetails$config34 = _configDetails$config33.troubleShootingJson) === null || _configDetails$config34 === void 0 ? void 0 : (_configDetails$config35 = _configDetails$config34.ddata) === null || _configDetails$config35 === void 0 ? void 0 : (_configDetails$config36 = _configDetails$config35.device) === null || _configDetails$config36 === void 0 ? void 0 : _configDetails$config36.soeUrl) + "-troubleshooting/#!/main/device/" + selectedMdnIndex + "&" + deviceSku1 + "&" + (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config37 = configDetails.config) === null || _configDetails$config37 === void 0 ? void 0 : (_configDetails$config38 = _configDetails$config37.troubleShootingJson) === null || _configDetails$config38 === void 0 ? void 0 : (_configDetails$config39 = _configDetails$config38.ddata) === null || _configDetails$config39 === void 0 ? void 0 : (_configDetails$config40 = _configDetails$config39.device) === null || _configDetails$config40 === void 0 ? void 0 : _configDetails$config40.equipmentId) + "/symptom/" + bauIntentId;
                                  window.location.href = redirectUrl;
                                } catch (error) {
                                  console.error('handleSymptomSelect redirection error', error);
                                }
                              }
                            } else {
                              var _nsaIntentId;
                              classList === null || classList === void 0 ? void 0 : classList.forEach(function (cls) {
                                var _cls$intentList;
                                cls === null || cls === void 0 ? void 0 : (_cls$intentList = cls.intentList) === null || _cls$intentList === void 0 ? void 0 : _cls$intentList.forEach(function (intent) {
                                  var _window44, _window44$config, _window44$config$case, _window44$config$case2, _window44$config$case3, _intent$name, _intent$name$toLowerC;
                                  if (((_window44 = window) === null || _window44 === void 0 ? void 0 : (_window44$config = _window44.config) === null || _window44$config === void 0 ? void 0 : (_window44$config$case = _window44$config.caseDetails) === null || _window44$config$case === void 0 ? void 0 : (_window44$config$case2 = _window44$config$case.intent) === null || _window44$config$case2 === void 0 ? void 0 : (_window44$config$case3 = _window44$config$case2.toLowerCase()) === null || _window44$config$case3 === void 0 ? void 0 : _window44$config$case3.trim()) == (intent === null || intent === void 0 ? void 0 : (_intent$name = intent.name) === null || _intent$name === void 0 ? void 0 : (_intent$name$toLowerC = _intent$name.toLowerCase()) === null || _intent$name$toLowerC === void 0 ? void 0 : _intent$name$toLowerC.trim())) {
                                    _nsaIntentId = intent.id;
                                    isSymptomElgibleForTechCoach = intent !== null && intent !== void 0 && intent.isTechCoachEligible ? true : false;
                                  }
                                });
                              });
                              if (_nsaIntentId) {
                                var _allIntentsData7;
                                var isAccountEligibleForTechCoach = (_allIntentsData7 = _allIntentsData) !== null && _allIntentsData7 !== void 0 && _allIntentsData7.techCoachEligible ? true : false;
                                var openPopup = isAccountEligibleForTechCoach && isSymptomElgibleForTechCoach ? true : false;
                                var techCoachFlags = {
                                  techCoachEligiblity: {
                                    accountElgible: isAccountEligibleForTechCoach,
                                    intentEligible: isSymptomElgibleForTechCoach,
                                    openPopup: false,
                                    openChatbotFlowPopup: openPopup
                                  }
                                };
                                callSubmitVira(troubleShootingInfo, landingInfo, outageInfo, symptom, _allIntentsData, _nsaIntentId, envData, activePage, tsData, routesArr, false, techCoachFlags);
                              } else {
                                if (window.isLoggedOut) {
                                  var _configDetails$config41;
                                  if (configDetails !== null && configDetails !== void 0 && (_configDetails$config41 = configDetails.config) !== null && _configDetails$config41 !== void 0 && _configDetails$config41.loggedOutCombinedIssueSelectorUrl) {
                                    var _configDetails$config42;
                                    window.location.href = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config42 = configDetails.config) === null || _configDetails$config42 === void 0 ? void 0 : _configDetails$config42.loggedOutCombinedIssueSelectorUrl) + "?flow=matchnotfound";
                                  }
                                } else {
                                  if ((additionalMtns === null || additionalMtns === void 0 ? void 0 : additionalMtns.length) > 0) {
                                    var selectedArray = additionalMtns === null || additionalMtns === void 0 ? void 0 : additionalMtns.filter(function (o) {
                                      var _window45, _window45$config, _window45$config$case;
                                      return o.mtn == ((_window45 = window) === null || _window45 === void 0 ? void 0 : (_window45$config = _window45.config) === null || _window45$config === void 0 ? void 0 : (_window45$config$case = _window45$config.caseDetails) === null || _window45$config$case === void 0 ? void 0 : _window45$config$case.mtn);
                                    });
                                    if ((selectedArray === null || selectedArray === void 0 ? void 0 : selectedArray.length) > 0) {
                                      var _selectedArray$;
                                      window.location.href = ((_selectedArray$ = selectedArray[0]) === null || _selectedArray$ === void 0 ? void 0 : _selectedArray$.combinedIssueSelectorUrl) + "?flow=matchnotfound";
                                    } else {
                                      var _configDetails$config43;
                                      if (configDetails !== null && configDetails !== void 0 && (_configDetails$config43 = configDetails.config) !== null && _configDetails$config43 !== void 0 && _configDetails$config43.loggedOutCombinedIssueSelectorUrl) {
                                        var _configDetails$config44;
                                        window.location.href = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config44 = configDetails.config) === null || _configDetails$config44 === void 0 ? void 0 : _configDetails$config44.loggedOutCombinedIssueSelectorUrl) + "?flow=matchnotfound";
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                        console.log('allIntentsData', _allIntentsData);
                        if (pegaClassList.length > 0 && nsaPrimaryIntentIds) {
                          var _allIntentsData8, _allIntentsData9, _allIntentsData9$clas, _allIntentsData0, _allIntentsData0$topI, _allIntentsData1, _allIntentsData10;
                          var pegaIntentsList = [];
                          pegaClassList === null || pegaClassList === void 0 ? void 0 : pegaClassList.forEach(function (cls) {
                            var _cls$intentList2;
                            cls === null || cls === void 0 ? void 0 : (_cls$intentList2 = cls.intentList) === null || _cls$intentList2 === void 0 ? void 0 : _cls$intentList2.forEach(function (intent) {
                              intent.title = intent.name;
                              pegaIntentsList.push(intent);
                            });
                          });
                          console.log('getAllIntents allIntentsData', nsaPrimaryIntentIds);
                          var nsaPrimaryIntentIdsArr = [];
                          var nsaPrimaryPegaIntentIdsArr = [];
                          nsaPrimaryIntentIdsArr = nsaPrimaryIntentIds.split(',');
                          if (nsaPrimaryIntentIdsArr.length > 0) {
                            nsaPrimaryIntentIdsArr.forEach(function (npiid) {
                              pegaIntentsList.forEach(function (pi) {
                                if (pi.id == npiid.trim()) {
                                  nsaPrimaryPegaIntentIdsArr.push(pi);
                                }
                              });
                            });
                          }
                          console.log('getAllIntents allIntentsData', nsaPrimaryIntentIdsArr, pegaIntentsList, nsaPrimaryPegaIntentIdsArr);
                          console.log('getAllIntents allIntentsData 1', (_allIntentsData8 = _allIntentsData) === null || _allIntentsData8 === void 0 ? void 0 : _allIntentsData8.classList);
                          (_allIntentsData9 = _allIntentsData) === null || _allIntentsData9 === void 0 ? void 0 : (_allIntentsData9$clas = _allIntentsData9.classList) === null || _allIntentsData9$clas === void 0 ? void 0 : _allIntentsData9$clas.forEach(function (cls) {
                            var _cls$intentList3;
                            cls === null || cls === void 0 ? void 0 : (_cls$intentList3 = cls.intentList) === null || _cls$intentList3 === void 0 ? void 0 : _cls$intentList3.forEach(function (intent) {
                              nsaPrimaryPegaIntentIdsArr.forEach(function (nppi) {
                                if (nppi.name == intent.name) {
                                  intent.id = nppi.id;
                                  intent.isFwa = false;
                                }
                              });
                            });
                          });
                          (_allIntentsData0 = _allIntentsData) === null || _allIntentsData0 === void 0 ? void 0 : (_allIntentsData0$topI = _allIntentsData0.topIntents) === null || _allIntentsData0$topI === void 0 ? void 0 : _allIntentsData0$topI.forEach(function (intent) {
                            nsaPrimaryPegaIntentIdsArr.forEach(function (nppi) {
                              if (nppi.name == intent.name) {
                                intent.id = nppi.id;
                                intent.isFwa = false;
                              }
                            });
                          });
                          console.log('getAllIntents allIntentsData 2', (_allIntentsData1 = _allIntentsData) === null || _allIntentsData1 === void 0 ? void 0 : _allIntentsData1.classList);
                          console.log('getAllIntents allIntentsData 2', (_allIntentsData10 = _allIntentsData) === null || _allIntentsData10 === void 0 ? void 0 : _allIntentsData10.topIntents);
                        }
                        setAllIntentsData(_allIntentsData);
                      }
                      var selectedMdnValue = "";
                      var selectedMdnHash = "";
                      if (window.isMVODigital && !window.isLoggedOut) {
                        var selectedMdnIndex = Number(routerParams === null || routerParams === void 0 ? void 0 : routerParams.routeMtnId);
                        if (!Number.isNaN(selectedMdnIndex) && selectedMdnIndex !== undefined && selectedMdnIndex !== null) {
                          var mtnObj = selectedMdnIndex !== null && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns) !== null && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns) !== undefined && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns.length) > 0 && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns[Number(selectedMdnIndex)]) !== null && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns[Number(selectedMdnIndex)]) !== undefined ? configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns[Number(selectedMdnIndex)] : "";
                          selectedMdnValue = mtnObj.mtn;
                          selectedMdnHash = mtnObj.mtnHash;
                          window.selectedProductType = mtnObj === null || mtnObj === void 0 ? void 0 : mtnObj.productType;
                          var mtn = selectedMdnIndex !== null && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns) !== null && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns) !== undefined && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns.length) > 0 && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns[Number(selectedMdnIndex)]) !== null && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns[Number(selectedMdnIndex)]) !== undefined ? configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns[Number(selectedMdnIndex)].mtn : "";
                          selectedMdnValue = mtn;
                        }
                      }
                      var channel;
                      if (window.isMVODigital) {
                        var _window$config;
                        if (window.isLoggedOut || (_window$config = window.config) !== null && _window$config !== void 0 && _window$config.isLoggedOut) {
                          channel = 'Verizon Website';
                        } else {
                          channel = 'My Verizon';
                        }
                      }
                      var params = {
                        appId: 'DO',
                        channel: channel,
                        categorizeIntent: true,
                        tier: '1',
                        accountNumber: isHealthCheck && !((_deviceHealthData26 = deviceHealthData) !== null && _deviceHealthData26 !== void 0 && _deviceHealthData26.backButtonTrigger) ? (_window46 = window) === null || _window46 === void 0 ? void 0 : (_window46$caseDetails = _window46.caseDetails) === null || _window46$caseDetails === void 0 ? void 0 : _window46$caseDetails.accountNumber : '',
                        mdn: isHealthCheck && !((_deviceHealthData27 = deviceHealthData) !== null && _deviceHealthData27 !== void 0 && _deviceHealthData27.backButtonTrigger) ? (_deviceHealthData28 = deviceHealthData) === null || _deviceHealthData28 === void 0 ? void 0 : _deviceHealthData28.mdn : (_configDetails$config45 = configDetails.config) === null || _configDetails$config45 === void 0 ? void 0 : (_configDetails$config46 = _configDetails$config45.caseDetails) === null || _configDetails$config46 === void 0 ? void 0 : _configDetails$config46.mtn,
                        mtnId: Number(routerParams.routeMtnId) || ((_configDetails$config47 = configDetails.config) === null || _configDetails$config47 === void 0 ? void 0 : (_configDetails$config48 = _configDetails$config47.caseDetails) === null || _configDetails$config48 === void 0 ? void 0 : _configDetails$config48.mtnId),
                        equipmentId: (_configDetails$config49 = configDetails.config) === null || _configDetails$config49 === void 0 ? void 0 : (_configDetails$config50 = _configDetails$config49.troubleShootingJson) === null || _configDetails$config50 === void 0 ? void 0 : (_configDetails$config51 = _configDetails$config50.ddata) === null || _configDetails$config51 === void 0 ? void 0 : (_configDetails$config52 = _configDetails$config51.device) === null || _configDetails$config52 === void 0 ? void 0 : _configDetails$config52.equipmentId,
                        sku: (_configDetails$config53 = configDetails.config) === null || _configDetails$config53 === void 0 ? void 0 : (_configDetails$config54 = _configDetails$config53.troubleShootingJson) === null || _configDetails$config54 === void 0 ? void 0 : (_configDetails$config55 = _configDetails$config54.ddata) === null || _configDetails$config55 === void 0 ? void 0 : (_configDetails$config56 = _configDetails$config55.device) === null || _configDetails$config56 === void 0 ? void 0 : _configDetails$config56.deviceSku,
                        displayMode: 'view',
                        userType: 'External',
                        loginId: 'Customer',
                        deviceId: (_configDetails$config57 = configDetails.config) === null || _configDetails$config57 === void 0 ? void 0 : (_configDetails$config58 = _configDetails$config57.troubleShootingJson) === null || _configDetails$config58 === void 0 ? void 0 : (_configDetails$config59 = _configDetails$config58.ddata) === null || _configDetails$config59 === void 0 ? void 0 : (_configDetails$config60 = _configDetails$config59.device) === null || _configDetails$config60 === void 0 ? void 0 : _configDetails$config60.deviceSku,
                        deviceName: (_configDetails$config61 = configDetails.config) === null || _configDetails$config61 === void 0 ? void 0 : (_configDetails$config62 = _configDetails$config61.troubleShootingJson) === null || _configDetails$config62 === void 0 ? void 0 : (_configDetails$config63 = _configDetails$config62.ddata) === null || _configDetails$config63 === void 0 ? void 0 : (_configDetails$config64 = _configDetails$config63.device) === null || _configDetails$config64 === void 0 ? void 0 : _configDetails$config64.deviceName,
                        deviceType: (_configDetails$config65 = configDetails.config) === null || _configDetails$config65 === void 0 ? void 0 : (_configDetails$config66 = _configDetails$config65.troubleShootingJson) === null || _configDetails$config66 === void 0 ? void 0 : (_configDetails$config67 = _configDetails$config66.ddata) === null || _configDetails$config67 === void 0 ? void 0 : (_configDetails$config68 = _configDetails$config67.device) === null || _configDetails$config68 === void 0 ? void 0 : _configDetails$config68.deviceType,
                        oem: (_configDetails$config69 = configDetails.config) === null || _configDetails$config69 === void 0 ? void 0 : (_configDetails$config70 = _configDetails$config69.troubleShootingJson) === null || _configDetails$config70 === void 0 ? void 0 : (_configDetails$config71 = _configDetails$config70.ddata) === null || _configDetails$config71 === void 0 ? void 0 : (_configDetails$config72 = _configDetails$config71.device) === null || _configDetails$config72 === void 0 ? void 0 : _configDetails$config72.oem,
                        operatingSystem: (_configDetails$config73 = configDetails.config) === null || _configDetails$config73 === void 0 ? void 0 : (_configDetails$config74 = _configDetails$config73.troubleShootingJson) === null || _configDetails$config74 === void 0 ? void 0 : (_configDetails$config75 = _configDetails$config74.ddata) === null || _configDetails$config75 === void 0 ? void 0 : (_configDetails$config76 = _configDetails$config75.device) === null || _configDetails$config76 === void 0 ? void 0 : _configDetails$config76.operatingSystem,
                        billingSystem: 'VISION_WEST',
                        mvmdCompatible: 'N',
                        tsrID: '',
                        customerVerified: 'Y',
                        customerOnSameDevice: 'Y',
                        loggedInUser: '',
                        topIntents: (_window47 = window) === null || _window47 === void 0 ? void 0 : (_window47$config = _window47.config) === null || _window47$config === void 0 ? void 0 : _window47$config.topIntents
                      };
                      if (window.isMVODigital && !window.isLoggedOut) {
                        var _window48, _window48$config, _window48$config$trou, _window48$config$trou2, _window48$config$trou3;
                        params.seoUrl = (_window48 = window) === null || _window48 === void 0 ? void 0 : (_window48$config = _window48.config) === null || _window48$config === void 0 ? void 0 : (_window48$config$trou = _window48$config.troubleShootingJson) === null || _window48$config$trou === void 0 ? void 0 : (_window48$config$trou2 = _window48$config$trou.ddata) === null || _window48$config$trou2 === void 0 ? void 0 : (_window48$config$trou3 = _window48$config$trou2.device) === null || _window48$config$trou3 === void 0 ? void 0 : _window48$config$trou3.soeUrl;
                        params.mtnHash = selectedMdnHash;
                      }
                      if (channel == 'My Verizon') {
                        var _configDetails$config77, _configDetails$config78, _configDetails$config79, _configDetails$config80, _configDetails$config81, _configDetails$config82, _configDetails$config83, _configDetails$config84, _configDetails$config85, _configDetails$config86;
                        params.changeDevice = false;
                        if (!(configDetails !== null && configDetails !== void 0 && (_configDetails$config77 = configDetails.config) !== null && _configDetails$config77 !== void 0 && (_configDetails$config78 = _configDetails$config77.caseDetails) !== null && _configDetails$config78 !== void 0 && _configDetails$config78.mtn) && !(configDetails !== null && configDetails !== void 0 && (_configDetails$config79 = configDetails.config) !== null && _configDetails$config79 !== void 0 && (_configDetails$config80 = _configDetails$config79.caseDetails) !== null && _configDetails$config80 !== void 0 && _configDetails$config80.mtnId)) {
                          params.changeDevice = true;
                          if (window.isMVODigital) {
                            params.channel = 'Verizon Website';
                          }
                        }
                        if ((configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config81 = configDetails.config) === null || _configDetails$config81 === void 0 ? void 0 : (_configDetails$config82 = _configDetails$config81.caseDetails) === null || _configDetails$config82 === void 0 ? void 0 : _configDetails$config82.mtnId) == 0) {
                          params.changeDevice = false;
                          params.channel = 'My Verizon';
                        }
                        console.log('changeDevice', !(configDetails !== null && configDetails !== void 0 && (_configDetails$config83 = configDetails.config) !== null && _configDetails$config83 !== void 0 && (_configDetails$config84 = _configDetails$config83.caseDetails) !== null && _configDetails$config84 !== void 0 && _configDetails$config84.mtn), !(configDetails !== null && configDetails !== void 0 && (_configDetails$config85 = configDetails.config) !== null && _configDetails$config85 !== void 0 && (_configDetails$config86 = _configDetails$config85.caseDetails) !== null && _configDetails$config86 !== void 0 && _configDetails$config86.mtnId));
                      } else if (window.isMVODigital && channel == 'Verizon Website') {
                        params.changeDevice = true;
                      }
                      if (configDetails !== null && configDetails !== void 0 && (_configDetails$config87 = configDetails.config) !== null && _configDetails$config87 !== void 0 && _configDetails$config87.isOptimisedFlow) {
                        var _configDetails$config88;
                        params.isOptimisedFlow = configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config88 = configDetails.config) === null || _configDetails$config88 === void 0 ? void 0 : _configDetails$config88.isOptimisedFlow;
                      }
                      if (isHealthCheck && !((_deviceHealthData29 = deviceHealthData) !== null && _deviceHealthData29 !== void 0 && _deviceHealthData29.backButtonTrigger)) {
                        params.isHealthCheck = isHealthCheck;
                      }
                      if (isHealthCheck && (_deviceHealthData30 = deviceHealthData) !== null && _deviceHealthData30 !== void 0 && _deviceHealthData30.caseId && !((_deviceHealthData31 = deviceHealthData) !== null && _deviceHealthData31 !== void 0 && _deviceHealthData31.backButtonTrigger)) {
                        var _deviceHealthData32;
                        params.caseId = (_deviceHealthData32 = deviceHealthData) === null || _deviceHealthData32 === void 0 ? void 0 : _deviceHealthData32.caseId;
                      }
                      if (isHealthCheck && (_deviceHealthData33 = deviceHealthData) !== null && _deviceHealthData33 !== void 0 && _deviceHealthData33.processStep && !((_deviceHealthData34 = deviceHealthData) !== null && _deviceHealthData34 !== void 0 && _deviceHealthData34.backButtonTrigger)) {
                        var _deviceHealthData35, _deviceHealthData36;
                        params.processStep = (_deviceHealthData35 = deviceHealthData) === null || _deviceHealthData35 === void 0 ? void 0 : _deviceHealthData35.processStep;
                        params.ctaClicked = (_deviceHealthData36 = deviceHealthData) === null || _deviceHealthData36 === void 0 ? void 0 : _deviceHealthData36.processStep;
                      }
                      if (window.isMVODigital && (params.mdn === null || params.mdn === undefined || params.mdn === "") && selectedMdnValue !== "") {
                        params.mdn = selectedMdnValue;
                      } else if (window.isMVODigital && (params.mdn === null || params.mdn === undefined || params.mdn === "") && selectedMdnValue === "") {
                        params.mdn = "";
                      }
                      if (window.isMVODigital) {
                        var sEcidValue = getCookie('s_ecid');
                        if (sEcidValue !== null && sEcidValue !== undefined && sEcidValue !== "" && sEcidValue.length > 0) {
                          params.ecid = sEcidValue.split('|')[1];
                        }
                        params.userAgent = navigator.userAgent;
                      }
                      if (window.isMVODigital) {
                        var _window$tsFeatureFlag4, _window$tsFeatureFlag5;
                        params.flags = {
                          popularCategoriesFFlag: ((_window$tsFeatureFlag4 = window.tsFeatureFlags) === null || _window$tsFeatureFlag4 === void 0 ? void 0 : _window$tsFeatureFlag4.popularCategoriesFFlag) || "",
                          popularCategoriesUnauthFFlag: ((_window$tsFeatureFlag5 = window.tsFeatureFlags) === null || _window$tsFeatureFlag5 === void 0 ? void 0 : _window$tsFeatureFlag5.popularCategoriesUnauthFFlag) || ""
                        };
                      }
                      console.log('getAllIntents allIntentsData params', params);
                      var _temp17 = function (_window49, _window49$config, _window50) {
                        if (!((_window49 = window) !== null && _window49 !== void 0 && (_window49$config = _window49.config) !== null && _window49$config !== void 0 && _window49$config.tangleWoodFlag) && !((_window50 = window) !== null && _window50 !== void 0 && _window50.recIssue) && !isNavHistFlow) {
                          return Promise.resolve(getAllIntents(params, envData)).then(function (_getAllIntents) {
                            _allIntentsData = _getAllIntents;
                          });
                        }
                      }();
                      return _temp17 && _temp17.then ? _temp17.then(_temp18) : _temp18(_temp17);
                    }, function (error) {
                      console.error('combinedIssueSelector getAllIntents', error);
                    });
                    return _temp19 && _temp19.then ? _temp19.then(_temp20) : _temp20(_temp19);
                  }
                }();
                return _temp26 && _temp26.then ? _temp26.then(_temp27) : _temp27(_temp26);
              }
              var _temp28 = function () {
                if ((curentRoute == 'start' || curentRoute == 'resume' || curentRoute == 'preview' || routesArr.includes('start') || mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isAcss || routesArr.includes('eotsecure') || routesArr.includes('midflowsecure')) && caseDetailsFlag) {
                  var _mvoCaseDetails$proce, _mvoCaseDetails$proce2, _configDetails$config89, _configDetails$config90, _configDetails$config91, _configDetails$select3, _configDetails$config102, _configDetails$config103, _configDetails$config104;
                  var _landingInfo$device5 = landingInfo.device,
                    device = _landingInfo$device5 === void 0 ? {} : _landingInfo$device5,
                    _landingInfo$symptomS2 = landingInfo.symptomSelector,
                    symptomSelector = _landingInfo$symptomS2 === void 0 ? {} : _landingInfo$symptomS2;
                  var _device$deviceSku3 = device.deviceSku,
                    _deviceSku3 = _device$deviceSku3 === void 0 ? '' : _device$deviceSku3,
                    _device$equipmentId3 = device.equipmentId,
                    equipmentId = _device$equipmentId3 === void 0 ? '' : _device$equipmentId3,
                    _device$deviceType3 = device.deviceType,
                    deviceType = _device$deviceType3 === void 0 ? '' : _device$deviceType3,
                    _is5GDevice2 = device.is5GDevice;
                  var _ref8 = mvoCaseDetails || [],
                    _ref8$mtn = _ref8.mtn,
                    mtn = _ref8$mtn === void 0 ? '' : _ref8$mtn,
                    _ref8$channel = _ref8.channel,
                    channel = _ref8$channel === void 0 ? '' : _ref8$channel,
                    _ref8$intentId = _ref8.intentId,
                    intentId = _ref8$intentId === void 0 ? '' : _ref8$intentId,
                    _ref8$caseId = _ref8.caseId,
                    caseId = _ref8$caseId === void 0 ? '' : _ref8$caseId,
                    _ref8$intent = _ref8.intent,
                    intent = _ref8$intent === void 0 ? '' : _ref8$intent,
                    _ref8$tier = _ref8.tier,
                    tier = _ref8$tier === void 0 ? '' : _ref8$tier,
                    _ref8$tierId = _ref8.tierId,
                    tierId = _ref8$tierId === void 0 ? '' : _ref8$tierId;
                  var processAction = (_mvoCaseDetails$proce = mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.processAction) != null ? _mvoCaseDetails$proce : '';
                  var processStep = (_mvoCaseDetails$proce2 = mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.processStep) != null ? _mvoCaseDetails$proce2 : 'Next';
                  if ((configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config89 = configDetails.config) === null || _configDetails$config89 === void 0 ? void 0 : (_configDetails$config90 = _configDetails$config89.caseDetails) === null || _configDetails$config90 === void 0 ? void 0 : (_configDetails$config91 = _configDetails$config90.processStep) === null || _configDetails$config91 === void 0 ? void 0 : _configDetails$config91.toLowerCase()) === 'resume') {
                    processStep = configDetails.config.caseDetails.processStep;
                  }
                  console.log('route processStep, processAction', processStep, processAction);
                  try {
                    if (processStep !== 'resume') {
                      if (sessionStorage.getItem('processAction')) {
                        processAction = sessionStorage.getItem('processAction');
                        console.log('route processStep, processAction', processStep, processAction);
                      }
                      if (sessionStorage.getItem('processStep')) {
                        processStep = sessionStorage.getItem('processStep');
                        console.log('route processStep, processAction', processStep, processAction);
                        if (window.isMVODigital) {
                          processStep = 'REFRESH';
                        }
                        if (mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isAcss) {
                          processStep = 'resume';
                        }
                        console.log('route processStep, processAction', processStep, processAction);
                      }
                      if (window.isMVODigital && routesArr.includes('eotsecure')) {
                        var caseConverted = sessionStorage.getItem('eotSecureCaseConverted');
                        processStep = caseConverted === 'true' ? 'REFRESH' : 'resume';
                        if (!caseConverted) processAction = '';
                      }
                      if (window.isMVODigital && routesArr.include('midflowsecure')) {
                        var _caseConverted = sessionStorage.getItem('midflowSecureCaseConverted');
                        processStep = _caseConverted === 'true' ? 'REFRESH' : 'resume';
                        if (!_caseConverted) processAction = '';
                      }
                      if (window.isMVODigital && (curentRoute == 'resume' || routesArr.includes('eotsecure') || routesArr.includes('midflowsecure')) && !sessionStorage.getItem('processAction') && !sessionStorage.getItem('processStep')) {
                        processAction = '';
                        processStep = 'resume';
                      }
                      console.log('route processStep, processAction', processStep, processAction);
                    }
                  } catch (error) {
                    console.error(error);
                  }
                  if (curentRoute == 'preview') {
                    processAction = '';
                    processStep = 'Preview';
                  }
                  var finalChannel = (configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.channel) == 'CARE' ? 'Care' : configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.channel;
                  if (window.isMVODigital) {
                    var _window51, _window52, _window52$config;
                    if ((_window51 = window) !== null && _window51 !== void 0 && _window51.isLoggedOut || (_window52 = window) !== null && _window52 !== void 0 && (_window52$config = _window52.config) !== null && _window52$config !== void 0 && _window52$config.isLoggedOut) {
                      finalChannel = 'Verizon Website';
                    } else {
                      finalChannel = 'My Verizon';
                    }
                  }
                  var _ref9 = JSON.parse(sessionStorage.getItem('nsaIntentSelected')) || {},
                    intetnFromSession = _ref9.intent,
                    intentIdFromSession = _ref9.intentId;
                  var params = {
                    deviceSku: window.isMVODigital ? (configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.sku) || filteredDeviceSku : configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.sku,
                    equipmentId: configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.equipmentId,
                    deviceType: '',
                    is5GDevice: false,
                    intent: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select3 = configDetails.selectedNSAIntent) === null || _configDetails$select3 === void 0 ? void 0 : _configDetails$select3.intent) || intetnFromSession,
                    intentId: configDetails.selectedNSAIntent.intentId || intentIdFromSession,
                    mtn: configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.mdn,
                    mtnId: configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.mtnId,
                    channelId: finalChannel || 'Care',
                    caseId: configDetails.caseId,
                    tierId: configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.tier,
                    processAction: processAction != null ? processAction : '',
                    processStep: processStep != null ? processStep : 'Next',
                    loggedInUser: configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.loggedInUser
                  };
                  console.log('howto configDetails', configDetails);
                  if (configDetails !== null && configDetails !== void 0 && configDetails.howToData) {
                    var _configDetails$howToD, _configDetails$howToD2, _configDetails$howToD3, _configDetails$howToD4;
                    params.howTo = configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$howToD = configDetails.howToData) === null || _configDetails$howToD === void 0 ? void 0 : _configDetails$howToD.howTo;
                    params.reviewFlag = configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$howToD2 = configDetails.howToData) === null || _configDetails$howToD2 === void 0 ? void 0 : _configDetails$howToD2.reviewFlag;
                    params.contentList = configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$howToD3 = configDetails.howToData) === null || _configDetails$howToD3 === void 0 ? void 0 : _configDetails$howToD3.contentList;
                    params.pageIdentifier = configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$howToD4 = configDetails.howToData) === null || _configDetails$howToD4 === void 0 ? void 0 : _configDetails$howToD4.pageIdentifier;
                  }
                  var _configDetails$params1 = configDetails.paramsDetails,
                    _configDetails$params10 = _configDetails$params1 === void 0 ? {} : _configDetails$params1,
                    _configDetails$params11 = _configDetails$params10.changeDeviceFlow,
                    changeDeviceFlow = _configDetails$params11 === void 0 ? false : _configDetails$params11;
                  params.changeDevice = false;
                  if (changeDeviceFlow) {
                    params.changeDevice = true;
                  }
                  var _ref0 = mvoConfig || {},
                    _ref0$troubleShooting = _ref0.troubleShootingJson,
                    _ref0$troubleShooting2 = _ref0$troubleShooting === void 0 ? {} : _ref0$troubleShooting,
                    _ref0$troubleShooting3 = _ref0$troubleShooting2.ddata,
                    _ref0$troubleShooting4 = _ref0$troubleShooting3 === void 0 ? {} : _ref0$troubleShooting3,
                    _ref0$troubleShooting5 = _ref0$troubleShooting4.device,
                    _ref0$troubleShooting6 = _ref0$troubleShooting5 === void 0 ? {} : _ref0$troubleShooting5,
                    _ref0$troubleShooting7 = _ref0$troubleShooting6.soeUrl,
                    soeUrl = _ref0$troubleShooting7 === void 0 ? '' : _ref0$troubleShooting7;
                  if (soeUrl) {
                    params.seoUrl = soeUrl;
                  }
                  if (finalChannel == 'Verizon Website') {
                    var _window53, _window53$config;
                    if ((_window53 = window) !== null && _window53 !== void 0 && (_window53$config = _window53.config) !== null && _window53$config !== void 0 && _window53$config.portalStandalone) {
                      params.changeDevice = true;
                    }
                  }
                  if (finalChannel == 'My Verizon') {
                    var _configDetails$config92, _configDetails$config93, _configDetails$config94, _configDetails$config95, _configDetails$config96, _configDetails$config97, _window54, _window54$config, _configDetails$config98, _configDetails$config99, _configDetails$config100, _configDetails$config101;
                    if (!(configDetails !== null && configDetails !== void 0 && (_configDetails$config92 = configDetails.config) !== null && _configDetails$config92 !== void 0 && (_configDetails$config93 = _configDetails$config92.caseDetails) !== null && _configDetails$config93 !== void 0 && _configDetails$config93.mtn) && !(configDetails !== null && configDetails !== void 0 && (_configDetails$config94 = configDetails.config) !== null && _configDetails$config94 !== void 0 && (_configDetails$config95 = _configDetails$config94.caseDetails) !== null && _configDetails$config95 !== void 0 && _configDetails$config95.mtnId)) {
                      params.changeDevice = true;
                      if (window.isMVODigital) {
                        params.channelId = 'Verizon Website';
                      }
                      if (window.isMVODigital && routesArr.includes('midflowsecure') && sessionStorage.getItem('eotFlag') === 'true') {
                        params.processAction = null;
                        params.processStep = 'resume';
                      }
                    }
                    if ((configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config96 = configDetails.config) === null || _configDetails$config96 === void 0 ? void 0 : (_configDetails$config97 = _configDetails$config96.caseDetails) === null || _configDetails$config97 === void 0 ? void 0 : _configDetails$config97.mtnId) == 0 || (_window54 = window) !== null && _window54 !== void 0 && (_window54$config = _window54.config) !== null && _window54$config !== void 0 && _window54$config.portalStandalone) {
                      params.changeDevice = false;
                      params.channelId = 'My Verizon';
                    }
                    if (isHealthCheck) {
                      params.channelId = 'My Verizon';
                    }
                    console.log('changeDevice', !(configDetails !== null && configDetails !== void 0 && (_configDetails$config98 = configDetails.config) !== null && _configDetails$config98 !== void 0 && (_configDetails$config99 = _configDetails$config98.caseDetails) !== null && _configDetails$config99 !== void 0 && _configDetails$config99.mtn), !(configDetails !== null && configDetails !== void 0 && (_configDetails$config100 = configDetails.config) !== null && _configDetails$config100 !== void 0 && (_configDetails$config101 = _configDetails$config100.caseDetails) !== null && _configDetails$config101 !== void 0 && _configDetails$config101.mtnId));
                  }
                  if (window && window.isPreview) {
                    params.isPreview = window.isPreview;
                  }
                  if (configDetails !== null && configDetails !== void 0 && configDetails.paramsDetails) {
                    params.accountNumber = configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.accountNumber;
                  }
                  console.log('***********mvo************');
                  console.log(mvoConfig === null || mvoConfig === void 0 ? void 0 : mvoConfig.isAcss);
                  console.log(configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails);
                  if (mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isAcss && typeof (configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.acssCallId) !== 'undefined' && (configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.acssCallId) !== '') {
                    params.callerId = configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.acssCallId;
                  }
                  var _ref1 = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config102 = configDetails.config) === null || _configDetails$config102 === void 0 ? void 0 : (_configDetails$config103 = _configDetails$config102.troubleShootingJson) === null || _configDetails$config103 === void 0 ? void 0 : (_configDetails$config104 = _configDetails$config103.ddata) === null || _configDetails$config104 === void 0 ? void 0 : _configDetails$config104.device) || {},
                    productDisplayNameClean = _ref1.productDisplayNameClean;
                  if (productDisplayNameClean) {
                    params.productDisplayNameClean = productDisplayNameClean;
                  }
                  console.log('submit params', params);
                  return function () {
                    if (!locationArr.includes('chatbot') && !locationArr.includes('nrbflow')) {
                      var _temp16 = function _temp16(_result2) {
                        var _Object$keys, _troubleShootingInfo6, _troubleShootingInfo7, _troubleShootingInfo8, _troubleShootingInfo9, _troubleShootingInfo0;
                        if (_exit2) return _result2;
                        console.log('troubleShootingData---3---', troubleShootingInfo);
                        console.log('info api response: ', troubleShootingInfo);
                        if (((_Object$keys = Object.keys(troubleShootingInfo)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) == 0) {
                          setError("Encountered Error");
                        } else if (((_troubleShootingInfo6 = troubleShootingInfo) === null || _troubleShootingInfo6 === void 0 ? void 0 : (_troubleShootingInfo7 = _troubleShootingInfo6.ddata) === null || _troubleShootingInfo7 === void 0 ? void 0 : (_troubleShootingInfo8 = _troubleShootingInfo7.output) === null || _troubleShootingInfo8 === void 0 ? void 0 : (_troubleShootingInfo9 = _troubleShootingInfo8.pageContent) === null || _troubleShootingInfo9 === void 0 ? void 0 : (_troubleShootingInfo0 = _troubleShootingInfo9.steps) === null || _troubleShootingInfo0 === void 0 ? void 0 : _troubleShootingInfo0.length) == 0) {
                          setError("Encountered Error");
                        }
                        setShowCheckingPhoneLoader(false);
                        setDataPostSubmit(troubleShootingInfo, routesArr, refPageId, setTemplateType);
                      };
                      setShowCheckingPhoneLoader(true);
                      var _temp15 = function () {
                        if (sessionStorage.getItem('isTroubleshootCaseOpen') === 'Y') {
                          var _ref10 = JSON.parse(sessionStorage.getItem('nsaIntentSelected')) || {},
                            _ref10$caseId = _ref10.caseId,
                            _caseId = _ref10$caseId === void 0 ? '' : _ref10$caseId;
                          params.ctaClicked = '';
                          delete params.callerId;
                          params.mtnId = '';
                          params.caseId = _caseId;
                          params.pageId = parseInt(sessionStorage.getItem('trgCurrentPageId'), 10);
                          var _temp12 = function () {
                            if (window.isMVODigital) {
                              params.processStep = 'Next';
                              return Promise.resolve(replayActionForTroubleShooting(params, envData)).then(function (_replayActionForTroub2) {
                                troubleShootingInfo = _replayActionForTroub2;
                              });
                            } else {
                              params.processStep = 'resume';
                              return Promise.resolve(submitActionForTroubleShooting(params, envData)).then(function (_submitActionForTroub3) {
                                troubleShootingInfo = _submitActionForTroub3;
                              });
                            }
                          }();
                          if (_temp12 && _temp12.then) return _temp12.then(function () {});
                        } else {
                          var _temp14 = function _temp14() {
                            getNBXParams(params);
                            if (isHealthCheck) {
                              var _deviceHealthData37, _deviceHealthData38, _deviceHealthData47;
                              params.isHealthCheck = isHealthCheck;
                              params.caseId = (_deviceHealthData37 = deviceHealthData) === null || _deviceHealthData37 === void 0 ? void 0 : _deviceHealthData37.caseId;
                              params.isRecommendedIssue = isRecommendedIssue;
                              params.changeDevice = false;
                              if (isRecommendedIssue || (_deviceHealthData38 = deviceHealthData) !== null && _deviceHealthData38 !== void 0 && _deviceHealthData38.isNavHistFlow) {
                                var _deviceHealthData39, _deviceHealthData40, _deviceHealthData41, _deviceHealthData42, _deviceHealthData43, _deviceHealthData44, _deviceHealthData45, _deviceHealthData46;
                                params.intent = (_deviceHealthData39 = deviceHealthData) === null || _deviceHealthData39 === void 0 ? void 0 : _deviceHealthData39.intent;
                                params.intentId = (_deviceHealthData40 = deviceHealthData) === null || _deviceHealthData40 === void 0 ? void 0 : _deviceHealthData40.intentId;
                                params.mtn = (_deviceHealthData41 = deviceHealthData) === null || _deviceHealthData41 === void 0 ? void 0 : _deviceHealthData41.mdn;
                                params.mtnId = (_deviceHealthData42 = deviceHealthData) === null || _deviceHealthData42 === void 0 ? void 0 : _deviceHealthData42.mtnId;
                                params.pageId = (_deviceHealthData43 = deviceHealthData) === null || _deviceHealthData43 === void 0 ? void 0 : _deviceHealthData43.pageId;
                                sessionStorage.setItem('troubleshootingDetails', JSON.stringify(_extends({}, JSON.parse(sessionStorage.getItem('troubleshootingDetails')), {
                                  intent: (_deviceHealthData44 = deviceHealthData) === null || _deviceHealthData44 === void 0 ? void 0 : _deviceHealthData44.intent,
                                  intentId: (_deviceHealthData45 = deviceHealthData) === null || _deviceHealthData45 === void 0 ? void 0 : _deviceHealthData45.intentId,
                                  mtn: (_deviceHealthData46 = deviceHealthData) === null || _deviceHealthData46 === void 0 ? void 0 : _deviceHealthData46.mdn
                                })));
                              }
                              if ((_deviceHealthData47 = deviceHealthData) !== null && _deviceHealthData47 !== void 0 && _deviceHealthData47.isNavHistFlow) {
                                var _deviceHealthData48, _deviceHealthData49, _deviceHealthData50;
                                params.processStep = (_deviceHealthData48 = deviceHealthData) === null || _deviceHealthData48 === void 0 ? void 0 : _deviceHealthData48.processStep;
                                isNavHistFlow = (_deviceHealthData49 = deviceHealthData) === null || _deviceHealthData49 === void 0 ? void 0 : _deviceHealthData49.isNavHistFlow;
                                (_deviceHealthData50 = deviceHealthData) === null || _deviceHealthData50 === void 0 ? true : delete _deviceHealthData50.isNavHistFlow;
                                sessionStorage.setItem('deviceHealthData', JSON.stringify(deviceHealthData));
                              }
                            }
                            if (window.isMVODigital && window.isLoggedOut) {
                              params.changeDevice = true;
                              params.mtn = "";
                            }
                            params.changeDevice = isChangeDeviceFlow(configDetails);
                            if (window.isMVODigital) {
                              var completionPageChecks = sessionStorage.getItem('completionPage');
                              var troubleshootingDetailsCheck = true;
                              if (sessionStorage.getItem("troubleshootingDetails")) {
                                var _JSON$parse2;
                                var mtnValues = (_JSON$parse2 = JSON.parse(sessionStorage.getItem("troubleshootingDetails"))) === null || _JSON$parse2 === void 0 ? void 0 : _JSON$parse2.mtn;
                                if (mtnValues === undefined || mtnValues === null) {
                                  troubleshootingDetailsCheck = true;
                                } else {
                                  troubleshootingDetailsCheck = false;
                                }
                              }
                              if (completionPageChecks === 'true' && troubleshootingDetailsCheck) {
                                sessionStorage.setItem('completionPage', '');
                                redirectToIssueSelectorPage(configDetails);
                                history.go();
                                _exit2 = true;
                                return;
                              }
                            }
                            return Promise.resolve(submitActionForTroubleShooting(params, envData)).then(function (_submitActionForTroub4) {
                              troubleShootingInfo = _submitActionForTroub4;
                            });
                          };
                          if ((params === null || params === void 0 ? void 0 : params.processStep) === "REFRESH") {
                            if (localStorage.getItem("troubleshootingDetails")) {
                              sessionStorage.setItem("troubleshootingDetails", localStorage.getItem("troubleshootingDetails"));
                            }
                            var prevParams = JSON.parse(localStorage.getItem('troubleshootParams'));
                            params.mtn = prevParams === null || prevParams === void 0 ? void 0 : prevParams.mtn;
                            params.caseId = prevParams === null || prevParams === void 0 ? void 0 : prevParams.caseId;
                            params.intent = prevParams === null || prevParams === void 0 ? void 0 : prevParams.intent;
                            params.intentId = prevParams === null || prevParams === void 0 ? void 0 : prevParams.intentId;
                            params.changeDevice = prevParams === null || prevParams === void 0 ? void 0 : prevParams.changeDevice;
                            localStorage.removeItem('troubleshootParams');
                          }
                          var _temp13 = function () {
                            if (processStep == "resume" && window.isMVODigital && params !== null && params !== void 0 && params.intentId.startsWith('IN') && !window.isLoggedOut && !sessionStorage.getItem('propositionNBX')) {
                              var _configDetails$config105, _configDetails$config106;
                              console.log("tech coach" + (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config105 = configDetails.config) === null || _configDetails$config105 === void 0 ? void 0 : _configDetails$config105.isTechCoachEligible));
                              var techCoachEligible = configDetails !== null && configDetails !== void 0 && (_configDetails$config106 = configDetails.config) !== null && _configDetails$config106 !== void 0 && _configDetails$config106.isTechCoachEligible ? true : false;
                              return Promise.resolve(callAndSetNBXTroubleShooting(techCoachEligible, envData, params.intentId)).then(function () {});
                            }
                          }();
                          return _temp13 && _temp13.then ? _temp13.then(_temp14) : _temp14(_temp13);
                        }
                      }();
                      return _temp15 && _temp15.then ? _temp15.then(_temp16) : _temp16(_temp15);
                    }
                  }();
                }
              }();
              return _temp28 && _temp28.then ? _temp28.then(_temp29) : _temp29(_temp28);
            }
            var _values$outageInfo = values.outageInfo,
              outageInfo = _values$outageInfo === void 0 ? {} : _values$outageInfo;
            var mvoConfig = sessionUtility.getMvoConfig();
            var mvoCaseDetails = sessionUtility.getCaseDetails();
            if (!(mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isLoggedOut) && !(mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isAcss)) {}
            var troubleShootingInfo = {};
            var activePage = values.activePage;
            var symptom = {};
            var caseDetailsFlag = true;
            var curentRoute = (_configDetails$config107 = configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config108 = configDetails.config) === null || _configDetails$config108 === void 0 ? void 0 : _configDetails$config108.curentRoute) != null ? _configDetails$config107 : 'start';
            if (window.isMVODigital) {
              var _window$tsFeatureFlag6;
              curentRoute = location.pathname.split('/')[1];
              if ((_window$tsFeatureFlag6 = window.tsFeatureFlags) !== null && _window$tsFeatureFlag6 !== void 0 && _window$tsFeatureFlag6.enableEOTRemoveHashFFlag && (window.location.href.includes("midflowsecure") || window.location.href.includes("eotsecure")) && !(window.location.href.includes("/#/midflowsecure") || window.location.href.includes("/#/eotsecure"))) {
                curentRoute = window.location.search.split("/")[1];
              }
            }
            console.log('route curentRoute', curentRoute, activePage);
            var routesArr = location.pathname.split('/');
            if ((_window$tsFeatureFlag7 = window.tsFeatureFlags) !== null && _window$tsFeatureFlag7 !== void 0 && _window$tsFeatureFlag7.enableEOTRemoveHashFFlag && (window.location.href.includes("midflowsecure") || window.location.href.includes("eotsecure")) && !(window.location.href.includes("/#/midflowsecure") || window.location.href.includes("/#/eotsecure"))) {
              routesArr = window.location.search.split("/");
            }
            var locationArr = window.location.href.split('/');
            console.log('route location', locationArr, window.location, routesArr);
            var templateId;
            var currentPageId;
            if (curentRoute === 'nrb') {
              setValues({
                activePage: 'nrb',
                flags: FLAGS_DEFAULT
              });
              return;
            }
            var _temp30 = function () {
              if (curentRoute === 'getcase') {
                var _window55, _window55$config, _window56, _window56$troubleShoo, _window56$troubleShoo2;
                var lvCaseId = '';
                var _ref11 = ((_window55 = window) === null || _window55 === void 0 ? void 0 : (_window55$config = _window55.config) === null || _window55$config === void 0 ? void 0 : _window55$config.caseDetails) || {},
                  _ref11$accountNumber = _ref11.accountNumber,
                  accountNumber = _ref11$accountNumber === void 0 ? '' : _ref11$accountNumber,
                  _ref11$mtn = _ref11.mtn,
                  mtn = _ref11$mtn === void 0 ? '' : _ref11$mtn;
                var newreqObj = {
                  deviceSku: (_window56 = window) === null || _window56 === void 0 ? void 0 : (_window56$troubleShoo = _window56.troubleShootingJson) === null || _window56$troubleShoo === void 0 ? void 0 : (_window56$troubleShoo2 = _window56$troubleShoo.ddata) === null || _window56$troubleShoo2 === void 0 ? void 0 : _window56$troubleShoo2.device.deviceSku,
                  intent: "Service Address Mismatch",
                  intentId: "IN11902",
                  channelId: "My Verizon",
                  caseId: "",
                  accountNumber: accountNumber,
                  mtn: mtn,
                  processAction: "",
                  processStep: "Next",
                  changeDevice: false,
                  locationViolationInfo: {
                    lvCaseId: routesArr[3]
                  }
                };
                return Promise.resolve(getViraCaseIdForLv(newreqObj, envData)).then(function (getViraCaseIdForLvResp) {
                  function _temp11() {
                    _exit = true;
                  }
                  var _getViraCaseIdForLvRe = getViraCaseIdForLvResp.response,
                    _getViraCaseIdForLvRe2 = _getViraCaseIdForLvRe === void 0 ? {} : _getViraCaseIdForLvRe,
                    _getViraCaseIdForLvRe3 = _getViraCaseIdForLvRe2.data,
                    _getViraCaseIdForLvRe4 = _getViraCaseIdForLvRe3 === void 0 ? {} : _getViraCaseIdForLvRe3,
                    _getViraCaseIdForLvRe5 = _getViraCaseIdForLvRe4.body,
                    body = _getViraCaseIdForLvRe5 === void 0 ? {} : _getViraCaseIdForLvRe5,
                    _getViraCaseIdForLvRe6 = getViraCaseIdForLvResp.success,
                    success = _getViraCaseIdForLvRe6 === void 0 ? false : _getViraCaseIdForLvRe6;
                  var _temp10 = function () {
                    if (success) {
                      var _body$intent = body.intent,
                        intent = _body$intent === void 0 ? '' : _body$intent,
                        _body$intentId = body.intentId,
                        intentId = _body$intentId === void 0 ? '' : _body$intentId,
                        _body$continueTrouble = body.continueTroubleshooting,
                        continueTroubleshooting = _body$continueTrouble === void 0 ? false : _body$continueTrouble,
                        _body$caseId = body.caseId,
                        caseId = _body$caseId === void 0 ? '' : _body$caseId;
                      lvCaseId = caseId;
                      var _temp1 = function () {
                        if (continueTroubleshooting) {
                          var reqObj = {
                            caseId: lvCaseId,
                            accountNumber: accountNumber,
                            mtn: mtn
                          };
                          return Promise.resolve(getAllCases(reqObj, envData)).then(function (allCaseResp) {
                            var _allCaseResp$response = allCaseResp.response,
                              _allCaseResp$response2 = _allCaseResp$response === void 0 ? {} : _allCaseResp$response,
                              _allCaseResp$response3 = _allCaseResp$response2.data,
                              _allCaseResp$response4 = _allCaseResp$response3 === void 0 ? {} : _allCaseResp$response3,
                              _allCaseResp$response5 = _allCaseResp$response4.body,
                              body = _allCaseResp$response5 === void 0 ? {} : _allCaseResp$response5,
                              _allCaseResp$success = allCaseResp.success,
                              success = _allCaseResp$success === void 0 ? false : _allCaseResp$success;
                            if (success) {
                              var _window57, _window57$config;
                              var _body$intent2 = body.intent,
                                _intent = _body$intent2 === void 0 ? '' : _body$intent2,
                                _body$intentId2 = body.intentId,
                                _intentId = _body$intentId2 === void 0 ? '' : _body$intentId2,
                                _body$continueTrouble2 = body.continueTroubleshooting,
                                _continueTroubleshooting = _body$continueTrouble2 === void 0 ? false : _body$continueTrouble2,
                                _body$caseId2 = body.caseId,
                                _caseId2 = _body$caseId2 === void 0 ? '' : _body$caseId2;
                              if ((_window57 = window) !== null && _window57 !== void 0 && (_window57$config = _window57.config) !== null && _window57$config !== void 0 && _window57$config.caseDetails) {
                                window.config.caseDetails = _extends({}, window.config.caseDetails, {
                                  intent: _intent,
                                  intentId: _intentId,
                                  caseId: _caseId2
                                });
                              }
                              if (_intentId && _continueTroubleshooting) {
                                var caseDetails = _extends({}, mvoCaseDetails, {
                                  intent: _intent,
                                  intentId: _intentId
                                });
                                sessionUtility.setCaseDetails(caseDetails);
                                var _troubleshootingDetails = _extends({}, sessionUtility.getTroubleShootingDetails(), {
                                  intent: _intent,
                                  intentId: _intentId
                                });
                                sessionUtility.setTroubleShootingDetails(_troubleshootingDetails);
                                callSubmitVira(troubleShootingInfo, landingInfo, outageInfo, symptom, {
                                  caseId: _caseId2
                                }, _intentId, envData, activePage, tsData, routesArr, true);
                              }
                            } else {
                              setShowErrorPage(true);
                            }
                          });
                        } else if (continueTroubleshooting === false) {
                          var _body$troubleshootVir = body.troubleshootViraResponse,
                            troubleshootViraResponse = _body$troubleshootVir === void 0 ? {} : _body$troubleshootVir;
                          setIssueResolvedContent(troubleshootViraResponse);
                          setShowIssueResolved(true);
                        }
                      }();
                      if (_temp1 && _temp1.then) return _temp1.then(function () {});
                    } else {
                      setShowErrorPage(true);
                    }
                  }();
                  return _temp10 && _temp10.then ? _temp10.then(_temp11) : _temp11(_temp10);
                });
              }
            }();
            return _temp30 && _temp30.then ? _temp30.then(_temp31) : _temp31(_temp30);
          }
          var is5G = !!(landingInfo !== null && landingInfo !== void 0 && (_landingInfo$device6 = landingInfo.device) !== null && _landingInfo$device6 !== void 0 && _landingInfo$device6.is5GDevice);
          sessionStorage.setItem('currentPageUrl', window.location.href);
          var _ref12 = (landingInfo === null || landingInfo === void 0 ? void 0 : landingInfo.device) || {},
            deviceSku = _ref12.deviceSku,
            deviceOem = _ref12.deviceOem,
            isFwa = _ref12.isFwa,
            is5GDevice = _ref12.is5GDevice,
            deviceName = _ref12.deviceName;
          if (isMVA$1) {
            var mvaPageTitle = !isEmpty(deviceName) ? deviceName + " troubleshooting assistant" : "Troubleshooting assistant";
            nativeSetTitle(mvaPageTitle);
          }
          var _temp32 = function () {
            if (is5G) {
              var dvSku = landingInfo.device && landingInfo.device.deviceSku ? {
                deviceSku: landingInfo.device.deviceSku
              } : {
                deviceSku: null
              };
              var _temp0 = _catch(function () {
                return Promise.resolve(getAnalyticsData(dvSku, envData)).then(function (analyticsData) {
                  var _analyticsData$ddata, _analyticsData$ddata$;
                  console.log(analyticsData);
                  if (analyticsData !== null && analyticsData !== void 0 && (_analyticsData$ddata = analyticsData.ddata) !== null && _analyticsData$ddata !== void 0 && (_analyticsData$ddata$ = _analyticsData$ddata.output) !== null && _analyticsData$ddata$ !== void 0 && _analyticsData$ddata$.fourGLte) {
                    setValues(_extends({}, values, {
                      fourGLte: analyticsData.ddata.output.fourGLte,
                      flags: FLAGS_DEFAULT
                    }));
                    sessionStorage.setItem('fourGLte', "" + analyticsData.ddata.output.fourGLte);
                  }
                  if (window.vzdl && analyticsData.pageAttributes && analyticsData.pageAttributes.length > 0) {
                    analyticsData.pageAttributes.forEach(function (attr) {
                      var attrArr = attr.itemMatch.split('.');
                      if (!window.vzdl[attrArr[0]]) {
                        window.vzdl[attrArr[0]] = {};
                      }
                      window.vzdl[attrArr[0]][attrArr[1]] = attr.itemValue;
                    });
                  }
                });
              }, function (error) {
                console.error('analyticsData error', error);
              });
              if (_temp0 && _temp0.then) return _temp0.then(function () {});
            }
          }();
          return _temp32 && _temp32.then ? _temp32.then(_temp33) : _temp33(_temp32);
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };
    if (current) {
      initialize();
    }
    return function () {
      current = false;
    };
  }, []);
  useEffect(function () {
    var locationListener = history.listen(function (loc, action) {
      var currentRoute = loc.pathname.split('/')[1];
      console.log('location', location, action, currentRoute, loc);
      if (action === 'POP' && currentRoute == 'mtn') {
        window.location.reload();
      }
    });
    return function () {
      locationListener();
    };
  }, [location]);
  useEffect(function () {
  }, [values.landingInfo, values.symptomId]);
  useEffect(function () {
    window.scrollTo({
      left: 0,
      top: 0,
      behavior: 'smooth'
    });
  }, [values.activePage]);
  var showWaitingSpinner = function showWaitingSpinner() {
    var _values$landingInfo4, _values$landingInfo4$;
    var is5gloadingmsg = ((_values$landingInfo4 = values.landingInfo) === null || _values$landingInfo4 === void 0 ? void 0 : (_values$landingInfo4$ = _values$landingInfo4.device) === null || _values$landingInfo4$ === void 0 ? void 0 : _values$landingInfo4$.is5GDevice) || false;
    is5gloadingmsg && set5gloadingmsg(true);
    setShowCheckingPhoneLoader(true);
  };
  var hideWaitingSpinner = function hideWaitingSpinner() {
    setShowCheckingPhoneLoader(false);
    setshowCheckingPhoneLoader5g(_extends({}, showCheckingPhoneLoader5g, {
      show: false
    }));
  };
  var getSymptomById = function getSymptomById(symptomId, issueName) {
    var symptom = {};
    if (combinedIssueSelector) {
      var _allIntentsData$topIn;
      allIntentsData === null || allIntentsData === void 0 ? void 0 : (_allIntentsData$topIn = allIntentsData.topIntents) === null || _allIntentsData$topIn === void 0 ? void 0 : _allIntentsData$topIn.forEach(function (issue) {
        if (issue.id == symptomId && issue.name.toLowerCase() == issueName.toLowerCase()) {
          symptom = _extends({}, issue, {
            symptomId: issue.id,
            issueName: issue.name,
            newUrl: '',
            bauUrl: ''
          });
        }
      });
    } else {
      var _mvoTroubleShootingJs0, _mvoTroubleShootingJs1, _mvoTroubleShootingJs10;
      var symptomSelector = {};
      var _mvoTroubleShootingJson2 = sessionUtility.getTroubleShootingJson();
      var is5GFlow = (_mvoTroubleShootingJs0 = _mvoTroubleShootingJson2 === null || _mvoTroubleShootingJson2 === void 0 ? void 0 : (_mvoTroubleShootingJs1 = _mvoTroubleShootingJson2.ddata) === null || _mvoTroubleShootingJs1 === void 0 ? void 0 : (_mvoTroubleShootingJs10 = _mvoTroubleShootingJs1.device) === null || _mvoTroubleShootingJs10 === void 0 ? void 0 : _mvoTroubleShootingJs10.is5GDevice) != null ? _mvoTroubleShootingJs0 : false;
      if (is5GFlow) {
        var _values$landingInfo$s, _values$landingInfo5;
        symptomSelector = (_values$landingInfo$s = (_values$landingInfo5 = values.landingInfo) === null || _values$landingInfo5 === void 0 ? void 0 : _values$landingInfo5.symptomSelector) != null ? _values$landingInfo$s : {};
      } else {
        var _mvoTroubleShootingJs11, _mvoTroubleShootingJs12;
        symptomSelector = (_mvoTroubleShootingJs11 = _mvoTroubleShootingJson2 === null || _mvoTroubleShootingJson2 === void 0 ? void 0 : (_mvoTroubleShootingJs12 = _mvoTroubleShootingJson2.ddata) === null || _mvoTroubleShootingJs12 === void 0 ? void 0 : _mvoTroubleShootingJs12.symptomSelector) != null ? _mvoTroubleShootingJs11 : {};
      }
      var _symptomSelector = symptomSelector,
        _symptomSelector$issu = _symptomSelector.issues,
        issues = _symptomSelector$issu === void 0 ? [] : _symptomSelector$issu;
      issues.forEach(function (issue) {
        if (issue.symptomId == symptomId && issue.issueName.toLowerCase() == issueName.toLowerCase()) {
          symptom = issue;
        }
      });
    }
    console.log('symptom', symptom);
    return symptom;
  };
  var trgDetails;
  if (sessionStorage.getItem('troubleshootingDetails')) {
    trgDetails = JSON.parse(sessionStorage.getItem('troubleshootingDetails'));
  }
  var callFeedbackAPI = function callFeedbackAPI(url, method, data) {
    try {
      var response = false;
      var axiosConfig = {
        timeout: 300000,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          channelId: window._dg_channelId
        }
      };
      var apiMethod = (method === null || method === void 0 ? void 0 : method.toLowerCase()) === "post" ? postHttpClientRequest(url, data, axiosConfig) : getHttpClientRequest(url, axiosConfig);
      return Promise.resolve(apiMethod.then(function (resp, headers) {
        response = {
          success: true,
          response: resp,
          headers: headers
        };
      })["catch"](function (err, headers) {
        response = {
          success: false,
          error: err,
          headers: headers
        };
        logNewrelicNoticeError(err, 'APIError');
      })).then(function () {
        return response;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var _processTroubleShootingPage = function processTroubleShootingPage(state, action, pageId, currentPage, content, optionSelected, feedbackData, fromPage, label, feedbackThumbsUp, longitude, latitude, button, options, selectedIssueOptionStep, thumbsDownSubmittedStep) {
    if (currentPage === void 0) {
      currentPage = '';
    }
    if (content === void 0) {
      content = {};
    }
    try {
      var _mvoTroubleShootingJs13, _mvoTroubleShootingJs14, _mvoTroubleShootingJs15;
      var _temp44 = function _temp44(_result7) {
        var _exit5 = false;
        if (_exit4) return _result7;
        function _temp42(_result8) {
          var _troubleShootingInfo$2, _troubleShootingInfo17, _troubleShootingInfo18, _troubleShootingInfo19, _troubleShootingInfo20, _troubleShootingInfo21, _troubleShootingInfo$3, _troubleShootingInfo22, _troubleShootingInfo23, _troubleShootingInfo24;
          if (_exit5) return _result8;
          function _temp40() {
            var _troubleShootingInfo1, _troubleShootingInfo10, _troubleShootingInfo11, _troubleShootingInfo12;
            var perContentImpressionValue = getTemplateId(steps);
            taggingSet_perContentImpression(perContentImpressionValue);
            var _values$outageInfo2 = values.outageInfo,
              outageInfo = _values$outageInfo2 === void 0 ? {} : _values$outageInfo2;
            if (activePage === 'network_outage' && !(mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isLoggedOut) && !(mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isAcss)) {}
            hideWaitingSpinner();
            var newValues = {
              activePage: activePage,
              context: context,
              outageInfo: outageInfo,
              troubleShootingInfo: troubleShootingInfo,
              showSearchResults: false
            };
            console.log('info 1', activePage, (_troubleShootingInfo1 = troubleShootingInfo) === null || _troubleShootingInfo1 === void 0 ? void 0 : (_troubleShootingInfo10 = _troubleShootingInfo1.context) === null || _troubleShootingInfo10 === void 0 ? void 0 : _troubleShootingInfo10.processStep);
            updateValues(values, newValues);
            console.log('info 2', activePage, (_troubleShootingInfo11 = troubleShootingInfo) === null || _troubleShootingInfo11 === void 0 ? void 0 : (_troubleShootingInfo12 = _troubleShootingInfo11.context) === null || _troubleShootingInfo12 === void 0 ? void 0 : _troubleShootingInfo12.processStep);
            if (activePage === 'waitscreen') {
              var _configDetails$config109;
              if (is5GFlow) {
                setshowCheckingPhoneLoader5g(_extends({}, showCheckingPhoneLoader5g, {
                  show: true,
                  heading: loaderHeading
                }));
              }
              if (!is5GFlow && (showCheckingPhoneLoader || showCheckingPhoneLoader5g.show)) {
                hideWaitingSpinner();
              }
              window.setTimeout(function () {
                _processTroubleShootingPage('Poll', action, '', activePage, context);
              }, (_configDetails$config109 = configDetails.config) === null || _configDetails$config109 === void 0 ? void 0 : _configDetails$config109.pollDelay);
            }
            return troubleShootingInfo;
          }
          var _troubleShootingInfo13 = troubleShootingInfo,
            _troubleShootingInfo14 = _troubleShootingInfo13.context,
            context = _troubleShootingInfo14 === void 0 ? {} : _troubleShootingInfo14;
          var _troubleShootingInfo15 = troubleShootingInfo,
            _troubleShootingInfo16 = _troubleShootingInfo15.pageAttributes,
            pageAttributes = _troubleShootingInfo16 === void 0 ? [] : _troubleShootingInfo16;
          var _context$lineInfo = context.lineInfo,
            lineInfo = _context$lineInfo === void 0 ? {} : _context$lineInfo;
          var _ref13 = lineInfo[0] || [],
            _ref13$pageIdentifier = _ref13.pageIdentifier,
            pageIdentifier = _ref13$pageIdentifier === void 0 ? '' : _ref13$pageIdentifier;
          var pageContent = getObjectPropertyByPath('ddata.output.pageContent', troubleShootingInfo, {});
          if (window.vzdl === '') {
            window.vzdl = {};
          }
          if (!is5GFlow && window.vzdl && pageAttributes && pageAttributes.length > 0) {
            update4GVzdlPageAttributes(pageAttributes);
          }
          var _pageContent$steps3 = pageContent.steps,
            steps = _pageContent$steps3 === void 0 ? [] : _pageContent$steps3;
          var step = steps[0] || {};
          var title = step.title;
          if (!title) {
            var _steps$1$title, _steps$2;
            title = (_steps$1$title = (_steps$2 = steps[1]) === null || _steps$2 === void 0 ? void 0 : _steps$2.title) != null ? _steps$1$title : 'Title';
          }
          var template = step.templateId;
          localStorage.setItem('title', title);
          var loaderHeading = step.heading || '';
          var activePage = getPageFromSteps(pageContent, setTemplateType);
          if (pageIdentifier === 'CONGRATULATIONS_PAGE') {
            activePage = 'completion';
          }
          if (window.isMVODigital && !window.isLoggedOut && window.enableSmartDiagnosticFFlag) {
            activePage = 'smartSolutionDiagnostic';
          }
          if (window.isMVODigital && !window.isLoggedOut && window.enableSmartIqSolutionFFlag) {
            activePage = 'smartSoutionIq';
          }
          if (state === 'replay' && activePage === 'questions') {
            updateQuestionParamRecords(context);
          }
          var templateId = (_troubleShootingInfo$2 = (_troubleShootingInfo17 = troubleShootingInfo) === null || _troubleShootingInfo17 === void 0 ? void 0 : (_troubleShootingInfo18 = _troubleShootingInfo17.ddata) === null || _troubleShootingInfo18 === void 0 ? void 0 : (_troubleShootingInfo19 = _troubleShootingInfo18.output) === null || _troubleShootingInfo19 === void 0 ? void 0 : (_troubleShootingInfo20 = _troubleShootingInfo19.pageContent) === null || _troubleShootingInfo20 === void 0 ? void 0 : (_troubleShootingInfo21 = _troubleShootingInfo20.steps[0]) === null || _troubleShootingInfo21 === void 0 ? void 0 : _troubleShootingInfo21.templateId) != null ? _troubleShootingInfo$2 : '';
          var currentPageId = (_troubleShootingInfo$3 = (_troubleShootingInfo22 = troubleShootingInfo) === null || _troubleShootingInfo22 === void 0 ? void 0 : (_troubleShootingInfo23 = _troubleShootingInfo22.ddata) === null || _troubleShootingInfo23 === void 0 ? void 0 : (_troubleShootingInfo24 = _troubleShootingInfo23.output) === null || _troubleShootingInfo24 === void 0 ? void 0 : _troubleShootingInfo24.currentPageId) != null ? _troubleShootingInfo$3 : '';
          if (currentPageId) {
            sessionStorage.setItem('trgCurrentPageId', currentPageId);
          }
          var _temp39 = function () {
            if (typeof templateId !== 'undefined' && templateId && typeof currentPageId !== 'undefined' && currentPageId) {
              return Promise.resolve(logClickStreamSwitch(activePage, templateId, currentPageId, title)).then(function () {});
            }
          }();
          return _temp39 && _temp39.then ? _temp39.then(_temp40) : _temp40(_temp39);
        }
        if (feedbackThumbsUp && options.flags) {
          setValues(_extends({}, values, {
            feedbackContainerDetails: {
              show: true,
              success: true
            },
            thumbsUpClick: true,
            flags: values.flags ? _extends({}, values.flags, options.flags) : values.flags
          }));
        } else if (feedbackThumbsUp) {
          setValues(_extends({}, values, {
            feedbackContainerDetails: {
              show: true,
              success: true
            },
            thumbsUpClick: true,
            flags: FLAGS_DEFAULT
          }));
        }
        var _temp41 = function () {
          if (state === 'close' || action.toLowerCase().indexOf('done') !== -1) {
            var _configDetails$params12;
            var _temp38 = function _temp38() {
              if (!isMVA$1) {
                if (fromPage == 'completion' || label && label === 'doneRedirect' || is5GFlow) {
                  if (!is5GFlow && mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isAcss && mvoCaseDetails.changeIssueUrl) {
                    var _mvoCaseDetails$equip;
                    var equipmentId = (_mvoCaseDetails$equip = mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.equipmentId) != null ? _mvoCaseDetails$equip : '';
                    redirectFormPostToUrl(mvoCaseDetails.changeIssueUrl, equipmentId);
                    _exit5 = true;
                    return;
                  }
                  if (mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isLoggedOut) {
                    window.location.href = '/support/';
                  } else {
                    window.location.href = '/digital/nsa/secure/ui/support/signinlanding';
                  }
                }
              }
              if (isMVA$1) {
                if (label && label === 'doneRedirect') {
                  var mvaParam = {
                    "actionType": "openPage",
                    "pageType": "myFeed"
                  };
                  invokeNative(JSON.stringify(mvaParam));
                }
              }
              setShowCheckingPhoneLoader(false);
              _exit5 = true;
            };
            var feedbackApiUrl = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params12 = configDetails.paramsDetails) === null || _configDetails$params12 === void 0 ? void 0 : _configDetails$params12.externalTarget) + "/acss/service/troubleshooting/feedback";
            var _temp37 = function () {
              if (feedbackData) {
                var resp;
                var _temp36 = _catch(function () {
                  function _temp35() {
                    if (uiLoggerContext.setPageDetails && resp.success == false) {
                      var pageDetails = {
                        errorShown: '1',
                        userViewedMessage: 'Looks like something went wrong. Please try again.',
                        messageStyle: 'error_banner'
                      };
                      uiLoggerContext.setPageDetails(pageDetails);
                    }
                    setValues(_extends({}, values, {
                      feedbackContainerDetails: {
                        show: true,
                        success: resp.success
                      },
                      thumbsDownClick: true,
                      selectedIssueOptionStep: selectedIssueOptionStep,
                      thumbsDownSubmittedStep: thumbsDownSubmittedStep,
                      flags: values.flags && options.flags ? _extends({}, values.flags, options.flags) : FLAGS_DEFAULT
                    }));
                  }
                  var data;
                  var _temp34 = function () {
                    if (window.isMVODigital) {
                      var envConfig = tsaEnvConfig$1();
                      return Promise.resolve(feedbackDataHandlerDigital(feedbackData, values, configDetails)).then(function (_feedbackDataHandlerD) {
                        data = _feedbackDataHandlerD;
                        return Promise.resolve(callFeedbackAPI(envConfig.apiUrls.feedbackNsaUrl, 'post', data)).then(function (_callFeedbackAPI) {
                          resp = _callFeedbackAPI;
                        });
                      });
                    } else {
                      return Promise.resolve(feedbackDataHandler(feedbackData, values, configDetails, 'main', trgDetails)).then(function (_feedbackDataHandler) {
                        data = _feedbackDataHandler;
                        return Promise.resolve(callAxios$1(feedbackApiUrl, 'post', data)).then(function (_callAxios) {
                          resp = _callAxios;
                        });
                      });
                    }
                  }();
                  return _temp34 && _temp34.then ? _temp34.then(_temp35) : _temp35(_temp34);
                }, function (e) {
                  console.log(e);
                });
                if (_temp36 && _temp36.then) return _temp36.then(function () {});
              }
            }();
            return _temp37 && _temp37.then ? _temp37.then(_temp38) : _temp38(_temp37);
          }
        }();
        return _temp41 && _temp41.then ? _temp41.then(_temp42) : _temp42(_temp41);
      };
      var _exit4 = false;
      console.log('info processTroubleShootingPage:', currentPage);
      var _mvoTroubleShootingJson3 = sessionUtility.getTroubleShootingJson();
      var mvoConfig = sessionUtility.getMvoConfig();
      var mvoCaseDetails = sessionUtility.getCaseDetails();
      var is5GFlow = (_mvoTroubleShootingJs13 = _mvoTroubleShootingJson3 === null || _mvoTroubleShootingJson3 === void 0 ? void 0 : (_mvoTroubleShootingJs14 = _mvoTroubleShootingJson3.ddata) === null || _mvoTroubleShootingJs14 === void 0 ? void 0 : (_mvoTroubleShootingJs15 = _mvoTroubleShootingJs14.device) === null || _mvoTroubleShootingJs15 === void 0 ? void 0 : _mvoTroubleShootingJs15.is5GDevice) != null ? _mvoTroubleShootingJs13 : false;
      var showNewWaitscreen = !is5GFlow && currentPage === 'waitscreen';
      if (!showNewWaitscreen && currentPage != 'diagnostics') {
        showWaitingSpinner();
      }
      values.thumbsDownClick = false, values.thumbsUpClick = false;
      if (values.feedbackContainerDetails) {
        values.feedbackContainerDetails.show = false;
      }
      var troubleShootingInfo;
      var _temp43 = function () {
        if (!(action.toLowerCase().indexOf('done') !== -1)) {
          var _configDetails$select4, _configDetails$select5;
          var selectedIntent = configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select4 = configDetails.selectedNSAIntent) === null || _configDetails$select4 === void 0 ? void 0 : (_configDetails$select5 = _configDetails$select4.intent) === null || _configDetails$select5 === void 0 ? void 0 : _configDetails$select5.toLowerCase();
          var isHowToIntent = (selectedIntent === null || selectedIntent === void 0 ? void 0 : selectedIntent.indexOf('how to')) > -1 ? true : false;
          var blockSubmitViraAPIcall = action.toLowerCase() === 'yes' && isHowToIntent ? true : false;
          console.log('Is how to Intent: ' + isHowToIntent);
          console.log('Block submit call: ' + blockSubmitViraAPIcall);
          if (isHowToIntent && state === 'submit' && window.isBAUACSS) {
            redirectToBAU();
            _exit4 = true;
            return;
          }
          var changeDeviceFlag = isChangeDeviceFlow(configDetails);
          return Promise.resolve(getTroubleShootingData(state, values, action, currentPage, content, pageId, selectedDevice, selectedLocation, optionSelected, longitude, latitude, button, configDetails, options, blockSubmitViraAPIcall, combinedIssueSelector, changeDeviceFlag, setSmartAIData, sendMessage, languageIndicator)).then(function (_getTroubleShootingDa) {
            troubleShootingInfo = _getTroubleShootingDa;
          });
        }
      }();
      return Promise.resolve(_temp43 && _temp43.then ? _temp43.then(_temp44) : _temp44(_temp43));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var processMainSymptom = function processMainSymptom(symptomId, issueName) {
    try {
      var symptom = getSymptomById(symptomId, issueName);
      processSymptomRedirection(symptom);
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var processSymptomRedirection = function processSymptomRedirection(symptom) {
    var _mvoTroubleShootingJs16, _mvoTroubleShootingJs17;
    if (symptom.redirect) {
      window.location.href = symptom.bauUrl;
      return true;
    }
    taggingSetIssueDetails_vzwDL(symptom);
    taggingSetIssueDetails_vzdl(symptom);
    var mvoTroubleShootingJson = sessionUtility.getTroubleShootingJson();
    var troubleshootingDetails = sessionUtility.getTroubleShootingDetails();
    var routesArr = location.pathname.split('/');
    console.log('route routesArr', routesArr);
    if (combinedIssueSelector && !routesArr.includes('mtn')) {
      history.push("mtn/" + (configDetails === null || configDetails === void 0 ? void 0 : configDetails.route1MtnId));
    }
    if (combinedIssueSelector && !routesArr.includes('start')) {
      history.push("start/" + troubleshootingDetails.intentId);
    }
    mvoTroubleShootingJson !== null && mvoTroubleShootingJson !== void 0 && (_mvoTroubleShootingJs16 = mvoTroubleShootingJson.ddata) !== null && _mvoTroubleShootingJs16 !== void 0 && (_mvoTroubleShootingJs17 = _mvoTroubleShootingJs16.device) !== null && _mvoTroubleShootingJs17 !== void 0 && _mvoTroubleShootingJs17.is5GDevice ? _processTroubleShootingPage('start', '') : _processTroubleShootingPage('submit', '');
    return false;
  };
  var releventFilter = function releventFilter(array, filterOn) {
    console.log('array filter', JSON.stringify(array));
    var charCount = 0;
    var items = array;
    var queryWords = filterOn.toLowerCase().split(/\s+/g).filter(function (word) {
      charCount += word.length;
      return word.length >= 1;
    });
    if (!items || charCount <= 2) {
      return '';
    }
    if (filterOn === false) {
      return items;
    }
    var newItems = items;
    if (filterOn && array) {
      newItems = [];
      var getItemRelevance = function getItemRelevance(item) {
        var relevance = 0;
        for (var wordIdx in queryWords) {
          if (queryWords.hasOwnProperty(wordIdx)) {
            if (item._lowerCaseTitle.indexOf(queryWords[wordIdx]) > -1) {
              relevance += queryWords[wordIdx].length * 1.175;
            } else if (item._lowerCaseSyns.indexOf(queryWords[wordIdx]) > -1) {
              relevance += queryWords[wordIdx].length;
            }
          }
        }
        return relevance;
      };
      array.length > 0 && array.forEach(function (item) {
        if (!item._lowerCaseTitle) {
          item._lowerCaseTitle = item.title.toLowerCase();
          item._lowerCaseSyns = item.synonym ? item.synonym.toLowerCase() : '';
        }
        var isDuplicate = false;
        var wordRel = getItemRelevance(item);
        if (wordRel > 0) {
          item.count = wordRel;
          newItems.push(item);
          isDuplicate = true;
        }
        if (!isDuplicate) {
          item.count = wordRel;
          newItems.push(item);
        }
      });
    }
    var finalItems = newItems.filter(function (element) {
      return element.count >= 3;
    });
    finalItems = finalItems.sort(function (a, b) {
      return b.count - a.count;
    });
    return finalItems;
  };
  var uniqueArray = function uniqueArray(array) {
    return array && array.length > 0 && (array === null || array === void 0 ? void 0 : array.filter(function (v, i, a) {
      return a.findIndex(function (v2) {
        return v2.title === v.title;
      }) === i;
    }));
  };
  var highlightMatchesFilter = function highlightMatchesFilter(array, filterOn) {
    if (!filterOn) {
      return '';
    }
    var filterWords = filterOn.toLowerCase().split(' ').filter(function (x) {
      return x.length > 1;
    });
    filterWords.sort(function (x, y) {
      return y.length - x.length;
    });
    function highlightWords(item) {
      if (!item) {
        return '';
      }
      var highlightedItem = item;
      filterWords.forEach(function (word) {
        var wordIdx = item.toLowerCase().indexOf(word);
        if (wordIdx >= 0) {
          highlightedItem = highlightWords(item.substring(0, wordIdx)) + '<strong>' + item.substring(wordIdx, wordIdx + word.length) + '</strong>' + highlightWords(item.substring(wordIdx + word.length));
          return false;
        }
        return true;
      });
      return highlightedItem;
    }
    array.length > 0 && array.forEach(function (item) {
      item.title = highlightWords(item.name);
    });
    return array;
  };
  var finalAppend = function finalAppend(array) {
    var finalItems = [];
    if (!array) {
      return '';
    }
    if (array.length === 0) {
      array.push({
        title: 'No Matches to Your Search, Try Different Words.',
        displayTitle: 'No Matches to Your Search, Try Different Words.'
      });
      return array;
    }
    if (typeof array.unshift !== 'undefined') {
      finalItems = array.sort(function (a, b) {
        if (b.count === a.count) {
          return b.usage < a.usage ? -1 : b.usage > a.usage ? 1 : 0;
        }
        return b.count - a.count;
      });
    }
    return finalItems;
  };
  var filterSearchSymptoms = function filterSearchSymptoms(params) {
    console.log('searchResults', values);
    var searchText = params.query;
    var classList = (allIntentsData === null || allIntentsData === void 0 ? void 0 : allIntentsData.classList) || [];
    var searchIntentsList = [];
    classList === null || classList === void 0 ? void 0 : classList.forEach(function (cls) {
      var _cls$intentList4;
      cls === null || cls === void 0 ? void 0 : (_cls$intentList4 = cls.intentList) === null || _cls$intentList4 === void 0 ? void 0 : _cls$intentList4.forEach(function (intent) {
        intent.title = intent.name;
        searchIntentsList.push(intent);
      });
    });
    var allSearchIntents = {
      subSymptoms: searchIntentsList
    };
    console.log('searchResults allSearchIntents', allSearchIntents.subSymptoms);
    var relevantData = releventFilter(allSearchIntents.subSymptoms, searchText);
    console.log('searchResults relevantData', relevantData);
    var uniqueData = uniqueArray(relevantData);
    console.log('searchResults uniqueData', uniqueData);
    var limitedData = uniqueData && uniqueData.slice(0, 10);
    console.log('searchResults limitedData', limitedData);
    var highlightedResults = highlightMatchesFilter(limitedData, searchText);
    console.log('searchResults highlightedResults', highlightedResults);
    var finalAppendData = finalAppend(highlightedResults);
    console.log('searchResults finalAppendData', finalAppendData);
    return {
      subSymptoms: finalAppendData
    };
  };
  var handleSearch = function handleSearch(params, showTypeAhead, showSearchResults) {
    try {
      var _temp45 = function () {
        if (combinedIssueSelector) {
          var searchResults = filterSearchSymptoms(params);
          updateValues(values, {
            searchResults: searchResults,
            showModal: true,
            showSearchResults: showSearchResults,
            showTypeAhead: showTypeAhead
          });
        } else {
          return Promise.resolve(getSearchSymptoms(params)).then(function (searchResults) {
            updateValues(values, {
              searchResults: searchResults,
              showModal: true,
              showSearchResults: showSearchResults,
              showTypeAhead: showTypeAhead
            });
          });
        }
      }();
      return Promise.resolve(_temp45 && _temp45.then ? _temp45.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var handleCloseModal = function handleCloseModal() {
    try {
      updateValues(values, {
        showModal: false
      });
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var createSupportRequestNew = function createSupportRequestNew(callType) {
    try {
      var _window58, _configDetails$params13, _configDetails$params14;
      var mvoConfig = sessionUtility.getMvoConfig();
      console.log('API data', values);
      var _values$context3 = values.context,
        context = _values$context3 === void 0 ? {} : _values$context3,
        _values$landingInfo6 = values.landingInfo,
        landingInfo = _values$landingInfo6 === void 0 ? {} : _values$landingInfo6,
        _values$symptom = values.symptom,
        symptom = _values$symptom === void 0 ? {} : _values$symptom;
      var _context$lineInfo2 = context.lineInfo,
        lineInfo = _context$lineInfo2 === void 0 ? [] : _context$lineInfo2;
      var _landingInfo$device7 = landingInfo.device,
        device = _landingInfo$device7 === void 0 ? {} : _landingInfo$device7;
      var contactPreference = callType === 'textMe' ? 'Mobile text messaging' : callType === 'serviceRequest' ? 'Manage within account' : callType === 'LiveChat' ? 'Live Chat' : '';
      var payload = {
        caseId: context.caseId || '',
        channelId: ((_window58 = window) === null || _window58 === void 0 ? void 0 : _window58._dg_channelId) || '',
        callReason: 'Troubleshooting',
        intent: 'Troubleshooting',
        ticketDetails: {
          contactMTN: '',
          reason: 'Troubleshooting',
          relatingTo: symptom.issueName || "Phone Calls & Can't make calls",
          device: device.deviceName || '',
          latitude: '',
          longitude: '',
          zipcode: '',
          isTroubleShootingCompleted: 'Y',
          additionalInfo: '',
          selectedMTNs: lineInfo.map(function (el) {
            return {
              selectedMTN: el.mtn
            };
          }),
          preferredContactOption: contactPreference
        }
      };
      var envData = {
        externalTarget: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params13 = configDetails.paramsDetails) === null || _configDetails$params13 === void 0 ? void 0 : _configDetails$params13.externalTarget,
        mvoenv: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params14 = configDetails.paramsDetails) === null || _configDetails$params14 === void 0 ? void 0 : _configDetails$params14.mvoenv
      };
      return Promise.resolve(createSupportRequest(payload, envData)).then(function (troubleShootingInfo) {
        if (troubleShootingInfo.ticketNumber) {
          var ticketNum = troubleShootingInfo.ticketNumber;
          var ticketDesc = "Troubleshooting - Phone Calls & Can't make calls";
          if (callType === 'textMe') {
            openModal('textMe', troubleShootingInfo.ticketNumber);
          } else {
            if (callType === 'serviceRequest') {
              openModal('serviceRequest', troubleShootingInfo.ticketNumber);
            } else if (callType === 'LiveChat') {
              initChatBot();
            }
          }
        } else {
          openModal('error');
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var initChatBot = function initChatBot() {
    var _window59, _window60, _window60$config;
    var _values$landingInfo7 = values.landingInfo,
      landingInfo = _values$landingInfo7 === void 0 ? {} : _values$landingInfo7,
      _values$troubleShooti4 = values.troubleShootingInfo,
      troubleShootingInfo = _values$troubleShooti4 === void 0 ? {} : _values$troubleShooti4;
    var output = getObjectPropertyByPath('ddata.output', troubleShootingInfo, {});
    var _getObjectPropertyByP = getObjectPropertyByPath('context', troubleShootingInfo, {}),
      _getObjectPropertyByP2 = _getObjectPropertyByP.lineInfo,
      _getObjectPropertyByP3 = _getObjectPropertyByP2 === void 0 ? [{}] : _getObjectPropertyByP2,
      techCoachEligible = _getObjectPropertyByP3[0].techCoachEligible;
    var _output$pageContent3 = output.pageContent,
      pageContent = _output$pageContent3 === void 0 ? {} : _output$pageContent3;
    var _pageContent$steps4 = pageContent.steps,
      steps = _pageContent$steps4 === void 0 ? [] : _pageContent$steps4;
    var _ref14 = steps[0] || {},
      _ref14$custFirstName = _ref14.custFirstName,
      custFirstName = _ref14$custFirstName === void 0 ? '' : _ref14$custFirstName;
    var _landingInfo$device8 = landingInfo.device,
      device = _landingInfo$device8 === void 0 ? {} : _landingInfo$device8;
    var _device$deviceName = device.deviceName,
      deviceName = _device$deviceName === void 0 ? '' : _device$deviceName;
    var _ref15 = configDetails || {},
      _ref15$selectedNSAInt = _ref15.selectedNSAIntent,
      selectedNSAIntent = _ref15$selectedNSAInt === void 0 ? {} : _ref15$selectedNSAInt;
    var _selectedNSAIntent$in = selectedNSAIntent.intent,
      intent = _selectedNSAIntent$in === void 0 ? '' : _selectedNSAIntent$in;
    var asyncMsgText = "Hey there, " + custFirstName + " is reaching out for Troubleshooting.\n\n<b>Device</b>: " + deviceName + " \n\n<b>Issue</b>: " + intent + "\n\nTo resume troubleshooting, please open ACSS from VC widget.";
    console.log('user text', asyncMsgText);
    var liveChatRequest = {
      userText: techCoachEligible ? 'chat with tech coach agent' : 'live agent',
      supportIntent: intent,
      tileKey: 'networktroubleshooting'
    };
    console.log('Invoking Live Chat-->', liveChatRequest);
    if ((_window59 = window) !== null && _window59 !== void 0 && _window59.isLoggedOut || (_window60 = window) !== null && _window60 !== void 0 && (_window60$config = _window60.config) !== null && _window60$config !== void 0 && _window60$config.isLoggedOut) {
      if (isMVA$1) {
        openMvaChatbot(liveChatRequest.userText, liveChatRequest.supportIntent);
      } else {
        window.EchannelVera.init(liveChatRequest);
      }
      return;
    }
    if (!window.AskvzGlobals) {
      window.AskvzGlobals = {};
      window.AskvzGlobals.livechatParams = {};
    }
    if (!window.AskvzGlobals.livechatParams) {
      window.AskvzGlobals.livechatParams = {};
    }
    window.AskvzGlobals.livechatParams.messageText = asyncMsgText;
    if (isMVA$1) {
      openMvaChatbot(liveChatRequest.userText, liveChatRequest.supportIntent);
    } else {
      window.EchannelVera.init(liveChatRequest);
    }
  };
  var createSupportTicket = function createSupportTicket(url) {
    var envConfig = tsaEnvConfig$1();
    var mvoCaseDetails = sessionUtility.getCaseDetails();
    var _values$context4 = values.context,
      context = _values$context4 === void 0 ? {} : _values$context4,
      _values$landingInfo8 = values.landingInfo,
      landingInfo = _values$landingInfo8 === void 0 ? {} : _values$landingInfo8,
      _values$symptom2 = values.symptom,
      symptom = _values$symptom2 === void 0 ? {} : _values$symptom2;
    var _context$lineInfo3 = context.lineInfo,
      lineInfo = _context$lineInfo3 === void 0 ? {} : _context$lineInfo3;
    var _ref16 = lineInfo[0] || {},
      _ref16$mtn = _ref16.mtn,
      mtn = _ref16$mtn === void 0 ? '' : _ref16$mtn;
    var _landingInfo$device9 = landingInfo.device,
      device = _landingInfo$device9 === void 0 ? {} : _landingInfo$device9;
    var payload = {
      MTNS: [{
        MTN: mtn
      }],
      device: device.deviceName || '',
      caseId: context.caseId || '',
      relatingTo: symptom.issueName || (mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.intent) || "Phone Calls & Can't make calls",
      isTroubleShootingComplete: false,
      callReason: 'Troubleshooting'
    };
    var targetUrl = url || envConfig.apiUrls.supportTicketUrl;
    redirectWithPostData(targetUrl, payload);
  };
  var formCreateCasePaylod = function formCreateCasePaylod() {
    var _values$context5 = values.context,
      context = _values$context5 === void 0 ? {} : _values$context5,
      _values$landingInfo9 = values.landingInfo,
      landingInfo = _values$landingInfo9 === void 0 ? {} : _values$landingInfo9,
      _values$symptom3 = values.symptom,
      symptom = _values$symptom3 === void 0 ? {} : _values$symptom3;
    var _landingInfo$device0 = landingInfo.device,
      device = _landingInfo$device0 === void 0 ? {} : _landingInfo$device0;
    var mvoConfig = sessionUtility.getMvoConfig();
    var _ref17 = (mvoConfig === null || mvoConfig === void 0 ? void 0 : mvoConfig.tokenDetails) || {},
      name = _ref17.name,
      loggedInMtn = _ref17.loggedInMtn,
      email = _ref17.email;
    var payloadSub = {
      device: device.deviceName || '',
      latitude: '',
      longitude: '',
      isTroubleShootingComplete: 'Y',
      reasonCode: '',
      failureReason: '',
      reasonDescription: ''
    };
    var troubleShootData = _extends({
      fullName: name || '',
      contactMTN: loggedInMtn || '',
      email: email || '',
      reason: 'Troubleshooting',
      relatingTo: symptom.issueName || "Phone Calls & Can't make calls",
      additionalInfo: ''
    }, payloadSub);
    return {
      caseId: context.caseId || '',
      callReason: 'Troubleshooting',
      intent: 'Troubleshooting',
      processStep: '',
      processAction: 'GetIVRTimeslots',
      errorMessages: {
        uiError: '',
        externalSystem: '',
        backendError: '',
        backendErrorCode: '',
        intentProcessStep: ''
      },
      ticketDetails: troubleShootData
    };
  };
  var openScheduleCallbackModal = function openScheduleCallbackModal() {
    try {
      var _configDetails$params15, _configDetails$params16;
      var envData = {
        externalTarget: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params15 = configDetails.paramsDetails) === null || _configDetails$params15 === void 0 ? void 0 : _configDetails$params15.externalTarget,
        mvoenv: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params16 = configDetails.paramsDetails) === null || _configDetails$params16 === void 0 ? void 0 : _configDetails$params16.mvoenv
      };
      return Promise.resolve(initSupportRequest(formCreateCasePaylod(), envData)).then(function (createCaseResp) {
        console.log('initCaseResp--->', createCaseResp);
        if (createCaseResp.ticketNumber) {
          updateValues(_extends({}, values), {
            createCaseResponse: createCaseResp
          });
          setShowCallScheduleModal(!showCallScheduleModal);
        } else {
          openModal('error');
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var deviceRepair = function deviceRepair() {
    try {
      window.location.href = '/support/1d/secure/schedule-device-repair/';
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var closeScheduleCallModal = function closeScheduleCallModal() {
    setShowCallScheduleModal(false);
  };
  var processCallFunction = function processCallFunction(button) {
    var _window61;
    var _button$callFunction = button.callFunction,
      callFunction = _button$callFunction === void 0 ? '' : _button$callFunction,
      _button$popUpHtmlCont = button.popUpHtmlContent,
      popUpHtmlContent = _button$popUpHtmlCont === void 0 ? '' : _button$popUpHtmlCont,
      _button$heading = button.heading,
      heading = _button$heading === void 0 ? '' : _button$heading;
    var callBackFunction = callFunction || popUpHtmlContent;
    var doReturn = true;
    var mvoConfig = sessionUtility.getMvoConfig();
    console.log("Main:processCallFunction: got function: " + callBackFunction);
    switch (callBackFunction) {
      case 'openChat':
        var _values$landingInfo0 = values.landingInfo,
          landingInfo = _values$landingInfo0 === void 0 ? {} : _values$landingInfo0,
          _values$symptom4 = values.symptom,
          symptom = _values$symptom4 === void 0 ? {} : _values$symptom4;
        var _landingInfo$device1 = landingInfo.device,
          device = _landingInfo$device1 === void 0 ? {} : _landingInfo$device1;
        var _device$is5GDevice = device.is5GDevice,
          is5GDevice = _device$is5GDevice === void 0 ? false : _device$is5GDevice;
        if (isMVA$1) {
          var _configDetails$config110, _configDetails$select6;
          var searchTerm = configDetails !== null && configDetails !== void 0 && (_configDetails$config110 = configDetails.config) !== null && _configDetails$config110 !== void 0 && _configDetails$config110.isTechCoachEligible ? "chat with tech coach agent" : "live agent";
          var symtomName = "";
          symtomName = (symptom === null || symptom === void 0 ? void 0 : symptom.name) !== null && (symptom === null || symptom === void 0 ? void 0 : symptom.name) !== undefined && (symptom === null || symptom === void 0 ? void 0 : symptom.name) !== "" ? symptom === null || symptom === void 0 ? void 0 : symptom.name : configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$select6 = configDetails.selectedNSAIntent) === null || _configDetails$select6 === void 0 ? void 0 : _configDetails$select6.intent;
          if (symtomName && symtomName !== "undefined") {
            openMvaChatbot(searchTerm, symtomName);
          } else {
            openMvaChatbot(searchTerm, "");
          }
        } else if (window.EchannelVera && !isMVA$1) {
          is5GDevice ? window.EchannelVera.init({}) : initChatBot();
        } else {
          console.log('Main:processCallFunction: ChatBot not enabled on page.');
        }
        break;
      case 'sdr':
        if (templateType === 'contactoptions-error') {
          triggerSubmitViraAPI(heading);
          createSupportTicket();
        } else {
          (mvoConfig === null || mvoConfig === void 0 ? void 0 : mvoConfig.isNewExp) === 'Y' ? createSupportRequestNew('serviceRequest') : createSupportTicket();
        }
        break;
      case 'textMe':
        if (templateType !== 'contactoptions-error') {
          createSupportRequestNew('textMe');
        }
        break;
      case 'scheduleCallback':
        if (templateType !== 'contactoptions-error') {
          openScheduleCallbackModal();
        }
        break;
      case 'deviceRepair':
        if (templateType !== 'contactoptions-error') {
          triggerSubmitViraAPI(heading);
          deviceRepair();
        }
        break;
      case 'onAcssSelectDifferentIssue':
        var popOutFlow = (_window61 = window) !== null && _window61 !== void 0 && _window61.isBAUACSS ? true : false;
        if (popOutFlow) {
          redirectToBAU();
        } else {
          var customEvent = new CustomEvent('issueSelectTab', {
            detail: {
              issueSelectTab: true
            }
          });
          window.dispatchEvent(customEvent);
        }
        break;
      default:
        console.log("Main:processCallFunction: got unknown function: " + callBackFunction);
        break;
    }
    return doReturn;
  };
  var handleModalAction = function handleModalAction(button) {
    var _ref18 = button || {},
      actionData = _ref18.actionData;
    var mvoTroubleShootingJson = sessionUtility.getTroubleShootingJson();
    var mvoConfig = sessionUtility.getMvoConfig();
    var mvoCaseDetails = sessionUtility.getCaseDetails();
    if (actionData === 'cancel' || actionData === 'close') ; else if (actionData === 'done') {
      var _mvoTroubleShootingJs18, _mvoTroubleShootingJs19, _window62;
      _processTroubleShootingPage('close', 'CloseCase');
      if (!(mvoTroubleShootingJson !== null && mvoTroubleShootingJson !== void 0 && (_mvoTroubleShootingJs18 = mvoTroubleShootingJson.ddata) !== null && _mvoTroubleShootingJs18 !== void 0 && (_mvoTroubleShootingJs19 = _mvoTroubleShootingJs18.device) !== null && _mvoTroubleShootingJs19 !== void 0 && _mvoTroubleShootingJs19.is5GDevice) && mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isAcss && mvoCaseDetails.changeIssueUrl) {
        var _mvoCaseDetails$equip2;
        var equipmentId = (_mvoCaseDetails$equip2 = mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.equipmentId) != null ? _mvoCaseDetails$equip2 : '';
        redirectFormPostToUrl(mvoCaseDetails.changeIssueUrl, equipmentId);
        return;
      }
      if (((_window62 = window) === null || _window62 === void 0 ? void 0 : _window62._dg_channelId) === 'VZW-MFA') {
        var url = '/mva';
        var launchType = sessionStorage.getItem('launchPageType');
        console.log(launchType, 'Launch Type from Session Storage 2465');
        if (launchType) {
          var _window63, _window63$config, _window63$config$case;
          var caseMtn = (_window63 = window) === null || _window63 === void 0 ? void 0 : (_window63$config = _window63.config) === null || _window63$config === void 0 ? void 0 : (_window63$config$case = _window63$config.caseDetails) === null || _window63$config$case === void 0 ? void 0 : _window63$config$case.mtn;
          callFunc('Network settings', 'managefiveGNetworks', true, url, caseMtn);
          console.log(url, caseMtn, 'Inside if 2469');
        } else {
          callFunc('Network settings', 'managefiveGNetworks', true);
          console.log('Inside else 2473');
        }
        return;
      }
      sessionStorage.removeItem('tsData');
      if (mvoConfig !== null && mvoConfig !== void 0 && mvoConfig.isLoggedOut) {
        window.location.href = '/support/1d';
      } else {
        window.location.href = '/support/1d/secure';
      }
      return;
    } else if (actionData === 'viewSupportRequest') {
      window.location.href = "/digital/nsa/secure/ui/sdr/manageticket?cid=" + supportRequestNumber;
      return;
    }
    setMessageModalInfo(_extends({}, messageModalInfo, {
      show: false
    }));
  };
  var openModal = function openModal(identifier, ticketNumber, displayMsg) {
    if (ticketNumber) {
      setSupportRequestNumber(ticketNumber);
    }
    switch (identifier) {
      case 'textMe':
        var modalParams = _extends({}, messageModalInfo, {
          body: 'An agent will reach out to you via SMS text in regards to your troubleshooting issue.',
          buttons: [{
            type: 'primary',
            text: 'View the support request',
            actionData: 'viewSupportRequest'
          }],
          show: true,
          styles: {
            height: '350px'
          },
          title: "We've submitted a support request for you."
        });
        setMessageModalInfo(_extends({}, modalParams));
        break;
      case 'sheduleCallBack':
        var schedulemodalParams = _extends({}, messageModalInfo, {
          body: displayMsg,
          buttons: [{
            type: 'primary',
            text: 'View support request',
            actionData: 'viewSupportRequest'
          }, {
            type: 'secondary',
            text: 'Close window',
            actionData: 'close'
          }],
          show: true,
          styles: {
            height: '350px'
          },
          title: 'Talk to you soon.'
        });
        setMessageModalInfo(_extends({}, schedulemodalParams));
        break;
      case 'serviceRequest':
        var serviceRequestModalParams = _extends({}, messageModalInfo, {
          body: 'An agent will reach out to you soon in regards to your troubleshooting issue.',
          buttons: [{
            type: 'primary',
            text: 'View the support request',
            actionData: 'viewSupportRequest'
          }],
          show: true,
          styles: {
            height: '350px'
          },
          title: "We've submitted a support request for you."
        });
        setMessageModalInfo(_extends({}, serviceRequestModalParams));
        break;
      case 'error':
        var errorModalParams = _extends({}, messageModalInfo, {
          body: "We couldn't schedule your appointment, you can try again, or close the window and continue with the troubleshooter.",
          buttons: [{
            type: 'primary',
            text: 'Try again',
            actionData: 'cancel'
          }, {
            type: 'secondary',
            text: 'Close window',
            actionData: 'close'
          }],
          show: true,
          styles: {
            height: '350px'
          },
          title: 'Something went wrong.'
        });
        setMessageModalInfo(_extends({}, errorModalParams));
        break;
    }
    return;
  };
  var handleCancel = function handleCancel() {
    var modalParams = _extends({}, messageModalInfo, {
      body: "You'll have to start over again for help with this issue.",
      buttons: [{
        type: 'secondary',
        text: 'Done',
        actionData: 'done'
      }, {
        type: 'primary',
        text: 'Cancel',
        actionData: 'cancel'
      }],
      show: true,
      styles: {
        height: '350px',
        marginBottom: '10px'
      },
      title: "Are you sure you're done with troubleshooting?"
    });
    setMessageModalInfo(_extends({}, modalParams));
  };
  var handleNextPage = function handleNextPage(symptomId, issueName, options) {
    try {
      var _temp50 = function _temp50(_result9) {
        if (_exit6) return _result9;
        setNextPage();
      };
      var _exit6 = false;
      console.log('handleNextPage', options === null || options === void 0 ? void 0 : options.selectedSymptomId, options === null || options === void 0 ? void 0 : options.isDirectFlow);
      var _temp49 = function () {
        if (values.activePage === 'main_symptom' || options !== null && options !== void 0 && options.isDirectFlow) {
          var _temp48 = function _temp48() {
            _exit6 = true;
          };
          if (options !== null && options !== void 0 && options.selectedSymptomId.startsWith('IN') && window.isMVODigital && !window.isLoggedOut) {
            var _configDetails$config111, _configDetails$params17, _configDetails$params18;
            var techCoachEligible = configDetails !== null && configDetails !== void 0 && (_configDetails$config111 = configDetails.config) !== null && _configDetails$config111 !== void 0 && _configDetails$config111.isTechCoachEligible ? true : false;
            var getSymptomId = options !== null && options !== void 0 && options.selectedSymptomId ? options === null || options === void 0 ? void 0 : options.selectedSymptomId : "";
            var envData = {
              externalTarget: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params17 = configDetails.paramsDetails) === null || _configDetails$params17 === void 0 ? void 0 : _configDetails$params17.externalTarget,
              mvoenv: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params18 = configDetails.paramsDetails) === null || _configDetails$params18 === void 0 ? void 0 : _configDetails$params18.mvoenv
            };
            callAndSetNBXTroubleShooting(techCoachEligible, envData, getSymptomId);
          }
          var _temp47 = function () {
            if (options !== null && options !== void 0 && options.combinedIssueSelector && issueName.startsWith('How To') && !(options !== null && options !== void 0 && options.selectedSymptomId.startsWith('IN'))) {
              handleHowToIntent(symptomId, issueName);
            } else {
              var _temp51 = function () {
                if (options !== null && options !== void 0 && options.combinedIssueSelector && (options === null || options === void 0 ? void 0 : options.isFwaFlow) == false && !(options !== null && options !== void 0 && options.selectedSymptomId.startsWith('IN'))) {
                  try {
                    var _configDetails$config112, _configDetails$config113, _configDetails$config114, _configDetails$config115, _configDetails$config116, _configDetails$config117, _configDetails$config118, _configDetails$config119, _configDetails$config120, _configDetails$config121, _configDetails$config122, _configDetails$config123;
                    var selectedMdnIndex = sessionStorage.getItem('selectedMdnIndex');
                    if (selectedMdnIndex == undefined || selectedMdnIndex == null) {
                      selectedMdnIndex = '';
                    }
                    var deviceSku1 = encodeURIComponent(encodeURIComponent(configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config112 = configDetails.config) === null || _configDetails$config112 === void 0 ? void 0 : (_configDetails$config113 = _configDetails$config112.troubleShootingJson) === null || _configDetails$config113 === void 0 ? void 0 : (_configDetails$config114 = _configDetails$config113.ddata) === null || _configDetails$config114 === void 0 ? void 0 : (_configDetails$config115 = _configDetails$config114.device) === null || _configDetails$config115 === void 0 ? void 0 : _configDetails$config115.deviceSku));
                    var redirectUrl = "/support/" + (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config116 = configDetails.config) === null || _configDetails$config116 === void 0 ? void 0 : (_configDetails$config117 = _configDetails$config116.troubleShootingJson) === null || _configDetails$config117 === void 0 ? void 0 : (_configDetails$config118 = _configDetails$config117.ddata) === null || _configDetails$config118 === void 0 ? void 0 : (_configDetails$config119 = _configDetails$config118.device) === null || _configDetails$config119 === void 0 ? void 0 : _configDetails$config119.soeUrl) + "-troubleshooting/#!/main/device/" + selectedMdnIndex + "&" + deviceSku1 + "&" + (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config120 = configDetails.config) === null || _configDetails$config120 === void 0 ? void 0 : (_configDetails$config121 = _configDetails$config120.troubleShootingJson) === null || _configDetails$config121 === void 0 ? void 0 : (_configDetails$config122 = _configDetails$config121.ddata) === null || _configDetails$config122 === void 0 ? void 0 : (_configDetails$config123 = _configDetails$config122.device) === null || _configDetails$config123 === void 0 ? void 0 : _configDetails$config123.equipmentId) + "/symptom/" + (options === null || options === void 0 ? void 0 : options.selectedSymptomId);
                    window.location.href = redirectUrl;
                  } catch (error) {
                    console.error('handleSymptomSelect redirection error', error);
                  }
                } else {
                  if (window.isMVODigital) {
                    windowScrollTop();
                  }
                  return Promise.resolve(processMainSymptom(symptomId, issueName)).then(function () {});
                }
              }();
              if (_temp51 && _temp51.then) return _temp51.then(function () {});
            }
          }();
          return _temp47 && _temp47.then ? _temp47.then(_temp48) : _temp48(_temp47);
        }
      }();
      return Promise.resolve(_temp49 && _temp49.then ? _temp49.then(_temp50) : _temp50(_temp49));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var setNextPage = function setNextPage() {
    var page = getPageById(values.activePage);
    var activePage = page.nextPage || page.id;
    updateValues(values, {
      activePage: activePage
    });
    hideWaitingSpinner();
  };
  var handlePreviousPage = function handlePreviousPage() {
    var page = getPageById(values.activePage);
    var activePage = page.previousPage || page.id;
    updateValues(values, {
      activePage: activePage
    });
    setPreviousPageLoaderMessage(true);
  };
  var handleHowToIntent = function handleHowToIntent(symptomId, issueName, mdn) {
    try {
      var _temp52 = _catch(function () {
        var _configDetails$params19, _configDetails$params20, _configDetails$config124, _configDetails$config125, _configDetails$config126, _configDetails$config127, _configDetails$config128, _configDetails$config129, _configDetails$config130, _configDetails$config131, _configDetails$config132, _configDetails$config133, _configDetails$config134, _configDetails$config135, _configDetails$config136, _configDetails$config137, _configDetails$config138, _configDetails$config139, _configDetails$config140, _configDetails$config141, _configDetails$config142, _configDetails$config143, _configDetails$config144, _configDetails$config145, _configDetails$config146, _configDetails$config147, _configDetails$config148, _configDetails$config149, _configDetails$config150, _configDetails$config151, _configDetails$config152, _configDetails$config153, _window64, _window64$config;
        setShowCheckingPhoneLoader(true);
        var channel;
        if (window.isMVODigital) {
          var _window$config2;
          if (window.isLoggedOut || (_window$config2 = window.config) !== null && _window$config2 !== void 0 && _window$config2.isLoggedOut) {
            channel = 'Verizon Website';
          } else {
            channel = 'My Verizon';
          }
        }
        var envData = {
          externalTarget: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params19 = configDetails.paramsDetails) === null || _configDetails$params19 === void 0 ? void 0 : _configDetails$params19.externalTarget,
          mvoenv: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params20 = configDetails.paramsDetails) === null || _configDetails$params20 === void 0 ? void 0 : _configDetails$params20.mvoenv
        };
        var params = {
          appId: 'DO',
          channel: channel,
          tier: '1',
          accountNumber: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config124 = configDetails.config) === null || _configDetails$config124 === void 0 ? void 0 : (_configDetails$config125 = _configDetails$config124.caseDetails) === null || _configDetails$config125 === void 0 ? void 0 : _configDetails$config125.accountNumber,
          mdn: (allIntentsData === null || allIntentsData === void 0 ? void 0 : allIntentsData.selectedMdn) || mdn,
          equipmentId: (_configDetails$config126 = configDetails.config) === null || _configDetails$config126 === void 0 ? void 0 : (_configDetails$config127 = _configDetails$config126.troubleShootingJson) === null || _configDetails$config127 === void 0 ? void 0 : (_configDetails$config128 = _configDetails$config127.ddata) === null || _configDetails$config128 === void 0 ? void 0 : (_configDetails$config129 = _configDetails$config128.device) === null || _configDetails$config129 === void 0 ? void 0 : _configDetails$config129.equipmentId,
          sku: (_configDetails$config130 = configDetails.config) === null || _configDetails$config130 === void 0 ? void 0 : (_configDetails$config131 = _configDetails$config130.troubleShootingJson) === null || _configDetails$config131 === void 0 ? void 0 : (_configDetails$config132 = _configDetails$config131.ddata) === null || _configDetails$config132 === void 0 ? void 0 : (_configDetails$config133 = _configDetails$config132.device) === null || _configDetails$config133 === void 0 ? void 0 : _configDetails$config133.deviceSku,
          displayMode: 'view',
          userType: 'External',
          loginId: 'Customer',
          deviceId: (_configDetails$config134 = configDetails.config) === null || _configDetails$config134 === void 0 ? void 0 : (_configDetails$config135 = _configDetails$config134.troubleShootingJson) === null || _configDetails$config135 === void 0 ? void 0 : (_configDetails$config136 = _configDetails$config135.ddata) === null || _configDetails$config136 === void 0 ? void 0 : (_configDetails$config137 = _configDetails$config136.device) === null || _configDetails$config137 === void 0 ? void 0 : _configDetails$config137.deviceSku,
          deviceName: (_configDetails$config138 = configDetails.config) === null || _configDetails$config138 === void 0 ? void 0 : (_configDetails$config139 = _configDetails$config138.troubleShootingJson) === null || _configDetails$config139 === void 0 ? void 0 : (_configDetails$config140 = _configDetails$config139.ddata) === null || _configDetails$config140 === void 0 ? void 0 : (_configDetails$config141 = _configDetails$config140.device) === null || _configDetails$config141 === void 0 ? void 0 : _configDetails$config141.deviceName,
          deviceType: (_configDetails$config142 = configDetails.config) === null || _configDetails$config142 === void 0 ? void 0 : (_configDetails$config143 = _configDetails$config142.troubleShootingJson) === null || _configDetails$config143 === void 0 ? void 0 : (_configDetails$config144 = _configDetails$config143.ddata) === null || _configDetails$config144 === void 0 ? void 0 : (_configDetails$config145 = _configDetails$config144.device) === null || _configDetails$config145 === void 0 ? void 0 : _configDetails$config145.deviceType,
          oem: (_configDetails$config146 = configDetails.config) === null || _configDetails$config146 === void 0 ? void 0 : (_configDetails$config147 = _configDetails$config146.troubleShootingJson) === null || _configDetails$config147 === void 0 ? void 0 : (_configDetails$config148 = _configDetails$config147.ddata) === null || _configDetails$config148 === void 0 ? void 0 : (_configDetails$config149 = _configDetails$config148.device) === null || _configDetails$config149 === void 0 ? void 0 : _configDetails$config149.oem,
          operatingSystem: (_configDetails$config150 = configDetails.config) === null || _configDetails$config150 === void 0 ? void 0 : (_configDetails$config151 = _configDetails$config150.troubleShootingJson) === null || _configDetails$config151 === void 0 ? void 0 : (_configDetails$config152 = _configDetails$config151.ddata) === null || _configDetails$config152 === void 0 ? void 0 : (_configDetails$config153 = _configDetails$config152.device) === null || _configDetails$config153 === void 0 ? void 0 : _configDetails$config153.operatingSystem,
          billingSystem: 'VISION_WEST',
          mvmdCompatible: 'N',
          tsrID: '',
          customerVerified: 'Y',
          customerOnSameDevice: 'Y',
          loggedInUser: '',
          topIntents: (_window64 = window) === null || _window64 === void 0 ? void 0 : (_window64$config = _window64.config) === null || _window64$config === void 0 ? void 0 : _window64$config.topIntents
        };
        return Promise.resolve(getDeviceSymptoms(params, envData)).then(function (symptomsData) {
          var _foundIntent$symptomI, _foundIntent$stepId, _foundIntent$guideId, _configDetails$config154, _configDetails$config155, _configDetails$config156, _configDetails$config157, _configDetails$config158, _configDetails$config159, _configDetails$config160, _configDetails$config161, _configDetails$config162, _configDetails$config163, _configDetails$config164, _configDetails$config165;
          console.log('getDeviceSymptoms symptomsData', symptomsData, params, envData);
          var allSubSymptoms = [];
          if (symptomsData.length > 0) {
            symptomsData.forEach(function (symptom) {
              allSubSymptoms.push.apply(allSubSymptoms, symptom === null || symptom === void 0 ? void 0 : symptom.subSymptoms);
            });
          }
          console.log('getDeviceSymptoms allSubSymptoms', allSubSymptoms);
          var foundIntent = allSubSymptoms.find(function (subSymptom) {
            return (subSymptom === null || subSymptom === void 0 ? void 0 : subSymptom.title.toLowerCase()) == (issueName === null || issueName === void 0 ? void 0 : issueName.toLowerCase());
          });
          var symptomId = (_foundIntent$symptomI = foundIntent === null || foundIntent === void 0 ? void 0 : foundIntent.symptomId) != null ? _foundIntent$symptomI : '';
          var stepId = (_foundIntent$stepId = foundIntent === null || foundIntent === void 0 ? void 0 : foundIntent.stepId) != null ? _foundIntent$stepId : '';
          var guideId = (_foundIntent$guideId = foundIntent === null || foundIntent === void 0 ? void 0 : foundIntent.guideId) != null ? _foundIntent$guideId : '';
          var selectedMdnIndex = sessionStorage.getItem('selectedMdnIndex');
          var deviceSku1 = encodeURIComponent(encodeURIComponent((_configDetails$config154 = configDetails.config) === null || _configDetails$config154 === void 0 ? void 0 : (_configDetails$config155 = _configDetails$config154.troubleShootingJson) === null || _configDetails$config155 === void 0 ? void 0 : (_configDetails$config156 = _configDetails$config155.ddata) === null || _configDetails$config156 === void 0 ? void 0 : (_configDetails$config157 = _configDetails$config156.device) === null || _configDetails$config157 === void 0 ? void 0 : _configDetails$config157.deviceSku));
          var redirectUrl = "/support/" + (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config158 = configDetails.config) === null || _configDetails$config158 === void 0 ? void 0 : (_configDetails$config159 = _configDetails$config158.troubleShootingJson) === null || _configDetails$config159 === void 0 ? void 0 : (_configDetails$config160 = _configDetails$config159.ddata) === null || _configDetails$config160 === void 0 ? void 0 : (_configDetails$config161 = _configDetails$config160.device) === null || _configDetails$config161 === void 0 ? void 0 : _configDetails$config161.soeUrl) + "-troubleshooting/#!/main/device/" + selectedMdnIndex + "&" + deviceSku1 + "&" + (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config162 = configDetails.config) === null || _configDetails$config162 === void 0 ? void 0 : (_configDetails$config163 = _configDetails$config162.troubleShootingJson) === null || _configDetails$config163 === void 0 ? void 0 : (_configDetails$config164 = _configDetails$config163.ddata) === null || _configDetails$config164 === void 0 ? void 0 : (_configDetails$config165 = _configDetails$config164.device) === null || _configDetails$config165 === void 0 ? void 0 : _configDetails$config165.equipmentId) + "/symptom/" + symptomId + "/" + stepId + "/" + guideId;
          window.location.href = redirectUrl;
        });
      }, function (error) {
        console.error('getDeviceSymptoms error', error);
      });
      return Promise.resolve(_temp52 && _temp52.then ? _temp52.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var getSelectedSymptom = function getSelectedSymptom(symptomId, issueName) {
    var _allIntentsData$class;
    var intentList = allIntentsData === null || allIntentsData === void 0 ? void 0 : (_allIntentsData$class = allIntentsData.classList) === null || _allIntentsData$class === void 0 ? void 0 : _allIntentsData$class.map(function (o) {
      return o.intentList;
    });
    var intentListArray = intentList.flat();
    var selectedSymptom = intentListArray === null || intentListArray === void 0 ? void 0 : intentListArray.filter(function (o) {
      return o.name.toLowerCase() === issueName.toLowerCase() && o.id == symptomId;
    });
    var symptom = (selectedSymptom === null || selectedSymptom === void 0 ? void 0 : selectedSymptom.length) > 0 ? selectedSymptom[0] : {};
    return symptom;
  };
  var handleSymptomSelect = function handleSymptomSelect(symptomId, issueName) {
    try {
      var symptom = getSymptomById(symptomId, issueName);
      console.log('handleSymptomSelect', symptomId, issueName, symptom);
      if (combinedIssueSelector) {
        var troubleshootingDevice = JSON.parse(sessionStorage.getItem('troubleshootingDevice'));
        var is5GDevice = troubleshootingDevice === null || troubleshootingDevice === void 0 ? void 0 : troubleshootingDevice.is5GDevice;
        console.log('handleSymptomSelect is5GDevice', is5GDevice);
        var landingInfo = values.landingInfo;
        landingInfo.device.is5GDevice = is5GDevice;
        landingInfo.device.isFwa = is5GDevice;
        console.log('handleSymptomSelect landingInfo', landingInfo);
        var selectedSymptom = getSelectedSymptom(symptomId, issueName);
        var isAccountEligibleForTechCoach = allIntentsData !== null && allIntentsData !== void 0 && allIntentsData.techCoachEligible ? true : false;
        var isSymptomElgibleForTechCoach = selectedSymptom !== null && selectedSymptom !== void 0 && selectedSymptom.isTechCoachEligible ? true : false;
        var openPopup = isAccountEligibleForTechCoach && isSymptomElgibleForTechCoach ? true : false;
        updateValues(values, {
          symptomId: symptomId,
          symptom: symptom,
          showTypeAhead: false,
          landingInfo: landingInfo,
          techCoachEligiblity: {
            accountElgible: isAccountEligibleForTechCoach,
            intentEligible: isSymptomElgibleForTechCoach,
            openPopup: openPopup,
            openChatbotFlowPopup: false
          }
        });
      }
      if (!combinedIssueSelector) {
        updateValues(values, {
          symptomId: symptomId,
          symptom: symptom,
          showTypeAhead: false
        });
      }
      if (symptomId == '23504') {
        loadingMessage = 'Please hold on while we check for your connectivity with the extender.';
      } else {
        loadingMessage = 'Please wait while we check your device This should take about a minute.';
      }
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var handleTypeAheadSelect = function handleTypeAheadSelect(symptomId, issueName) {
    var symptom = getSymptomById(symptomId, issueName);
    updateValues(values, {
      symptomId: symptomId,
      symptom: symptom,
      showTypeAhead: false
    });
    handleNextPage(symptomId, issueName, {
      isDirectFlow: true
    });
  };
  var handleAddressValidation = function handleAddressValidation(addressCheck) {
    updateValues(values, {
      addressCheck: addressCheck
    });
  };
  var handleQuestionsPageInputs = function handleQuestionsPageInputs(questionsParams) {
    updateValues(values, {
      questionsParams: questionsParams
    });
  };
  var handleQuestionsLabel = function handleQuestionsLabel(radioRecordId, disableInput) {
    var questionRecordIds = [];
    questionRecordIds = values.questionRecordIds;
    questionRecordIds.push(radioRecordId);
    for (var i = 0; i < questionRecordIds.length; i++) {
      if (disableInput === questionRecordIds[i]) {
        questionRecordIds.splice(i, 1);
      }
    }
    questionRecordIds = [].concat(new Set(questionRecordIds));
    updateValues(values, {
      questionRecordIds: questionRecordIds
    });
  };
  var triggerSubmitViraAPI = function triggerSubmitViraAPI(buttonLabel, ticketCaseId) {
    try {
      var _values$context$proce, _values$context6, _mvoCaseDetails$proce3, _values$troubleShooti5, _values$troubleShooti6, _values$troubleShooti7, _values$troubleShooti8;
      var _temp54 = function _temp54() {
        var _troubleshootingDetai23, _troubleshootingDetai24, _troubleshootingDetai25, _troubleshootingDetai26, _troubleshootingDetai27, _troubleshootingDetai28, _troubleshootingDetai29, _troubleshootingDetai30, _troubleshootingDetai31, _troubleshootingDetai32, _window65, _window66, _window66$config, _troubleshootingDetai33, _configDetails$params21, _configDetails$config166, _configDetails$config167, _window67, _window67$troubleShoo, _window67$troubleShoo2, _window67$troubleShoo3, _window68, _window68$caseDetails, _window69, _window69$troubleShoo, _window69$troubleShoo2, _window69$troubleShoo3, _window$troubleShooti, _window70, _window70$troubleShoo, _window70$troubleShoo2, _window70$troubleShoo3, _window$troubleShooti2, _window71, _window71$troubleShoo, _window71$troubleShoo2, _window71$troubleShoo3, _configDetails$params22, _configDetails$params23;
        var selectedIntent = !isEmpty((_troubleshootingDetai23 = _troubleshootingDetails2) === null || _troubleshootingDetai23 === void 0 ? void 0 : _troubleshootingDetai23.intent) ? (_troubleshootingDetai24 = _troubleshootingDetails2) === null || _troubleshootingDetai24 === void 0 ? void 0 : _troubleshootingDetai24.intent : configDetails.selectedNSAIntent.intent;
        var selectedIntentId = !isEmpty((_troubleshootingDetai25 = _troubleshootingDetails2) === null || _troubleshootingDetai25 === void 0 ? void 0 : _troubleshootingDetai25.intentId) ? (_troubleshootingDetai26 = _troubleshootingDetails2) === null || _troubleshootingDetai26 === void 0 ? void 0 : _troubleshootingDetai26.intentId : configDetails.selectedNSAIntent.intentId;
        var selectedMtn = !isEmpty((_troubleshootingDetai27 = _troubleshootingDetails2) === null || _troubleshootingDetai27 === void 0 ? void 0 : _troubleshootingDetai27.mtn) ? (_troubleshootingDetai28 = _troubleshootingDetails2) === null || _troubleshootingDetai28 === void 0 ? void 0 : _troubleshootingDetai28.mtn : configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.mdn;
        var selectedMtnId = !isEmpty((_troubleshootingDetai29 = _troubleshootingDetails2) === null || _troubleshootingDetai29 === void 0 ? void 0 : _troubleshootingDetai29.mtnId) ? (_troubleshootingDetai30 = _troubleshootingDetails2) === null || _troubleshootingDetai30 === void 0 ? void 0 : _troubleshootingDetai30.mtnId : configDetails === null || configDetails === void 0 ? void 0 : configDetails.mtnId;
        var currentCaseId = !isEmpty((_troubleshootingDetai31 = _troubleshootingDetails2) === null || _troubleshootingDetai31 === void 0 ? void 0 : _troubleshootingDetai31.caseId) ? (_troubleshootingDetai32 = _troubleshootingDetails2) === null || _troubleshootingDetai32 === void 0 ? void 0 : _troubleshootingDetai32.caseId : configDetails === null || configDetails === void 0 ? void 0 : configDetails.caseId;
        var channelIdDetails = (_window65 = window) !== null && _window65 !== void 0 && _window65.isLoggedOut || (_window66 = window) !== null && _window66 !== void 0 && (_window66$config = _window66.config) !== null && _window66$config !== void 0 && _window66$config.isLoggedOut ? 'Verizon Website' : 'My Verizon';
        var params = {
          accountNumber: combinedIssueSelector ? (_troubleshootingDetai33 = _troubleshootingDetails2) === null || _troubleshootingDetai33 === void 0 ? void 0 : _troubleshootingDetai33.accountNumber : configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params21 = configDetails.paramsDetails) === null || _configDetails$params21 === void 0 ? void 0 : _configDetails$params21.accountNumber,
          caseId: combinedIssueSelector ? currentCaseId : configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config166 = configDetails.config) === null || _configDetails$config166 === void 0 ? void 0 : (_configDetails$config167 = _configDetails$config166.caseDetails) === null || _configDetails$config167 === void 0 ? void 0 : _configDetails$config167.caseId,
          changeDevice: false,
          channelId: channelIdDetails,
          ctaClicked: 'Next',
          deviceSku: window.isMVODigital ? (configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.sku) || filteredDeviceSku : configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.sku,
          deviceType: (_window67 = window) === null || _window67 === void 0 ? void 0 : (_window67$troubleShoo = _window67.troubleShootingJson) === null || _window67$troubleShoo === void 0 ? void 0 : (_window67$troubleShoo2 = _window67$troubleShoo.ddata) === null || _window67$troubleShoo2 === void 0 ? void 0 : (_window67$troubleShoo3 = _window67$troubleShoo2.device) === null || _window67$troubleShoo3 === void 0 ? void 0 : _window67$troubleShoo3.deviceType,
          equipmentId: configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.equipmentId,
          intent: combinedIssueSelector ? selectedIntent : configDetails.selectedNSAIntent.intent || mvoCaseDetails.intentId || ((_window68 = window) === null || _window68 === void 0 ? void 0 : (_window68$caseDetails = _window68.caseDetails) === null || _window68$caseDetails === void 0 ? void 0 : _window68$caseDetails.intentId),
          intentId: combinedIssueSelector ? selectedIntentId : configDetails.selectedNSAIntent.intentId || mvoCaseDetails.intentId,
          is5GDevice: (_window69 = window) === null || _window69 === void 0 ? void 0 : (_window69$troubleShoo = _window69.troubleShootingJson) === null || _window69$troubleShoo === void 0 ? void 0 : (_window69$troubleShoo2 = _window69$troubleShoo.ddata) === null || _window69$troubleShoo2 === void 0 ? void 0 : (_window69$troubleShoo3 = _window69$troubleShoo2.device) === null || _window69$troubleShoo3 === void 0 ? void 0 : _window69$troubleShoo3.is5GDevice,
          loggedInUser: '',
          mtn: combinedIssueSelector ? selectedMtn : configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.mdn,
          mtnId: combinedIssueSelector ? selectedMtnId : '',
          pageId: currentPageId,
          processAction: processAction != null ? processAction : '',
          processStep: processStep != null ? processStep : 'Next',
          productDisplayNameClean: (_window$troubleShooti = (_window70 = window) === null || _window70 === void 0 ? void 0 : (_window70$troubleShoo = _window70.troubleShootingJson) === null || _window70$troubleShoo === void 0 ? void 0 : (_window70$troubleShoo2 = _window70$troubleShoo.ddata) === null || _window70$troubleShoo2 === void 0 ? void 0 : (_window70$troubleShoo3 = _window70$troubleShoo2.device) === null || _window70$troubleShoo3 === void 0 ? void 0 : _window70$troubleShoo3.productDisplayNameClean) != null ? _window$troubleShooti : '',
          soeUrl: (_window$troubleShooti2 = (_window71 = window) === null || _window71 === void 0 ? void 0 : (_window71$troubleShoo = _window71.troubleShootingJson) === null || _window71$troubleShoo === void 0 ? void 0 : (_window71$troubleShoo2 = _window71$troubleShoo.ddata) === null || _window71$troubleShoo2 === void 0 ? void 0 : (_window71$troubleShoo3 = _window71$troubleShoo2.device) === null || _window71$troubleShoo3 === void 0 ? void 0 : _window71$troubleShoo3.soeUrl) != null ? _window$troubleShooti2 : '',
          tierId: combinedIssueSelector ? 1 : configDetails === null || configDetails === void 0 ? void 0 : configDetails.paramsDetails.tier,
          userSelection: buttonLabel
        };
        var envData = {
          externalTarget: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params22 = configDetails.paramsDetails) === null || _configDetails$params22 === void 0 ? void 0 : _configDetails$params22.externalTarget,
          mvoenv: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params23 = configDetails.paramsDetails) === null || _configDetails$params23 === void 0 ? void 0 : _configDetails$params23.mvoenv
        };
        if (window.isMVODigital && params !== null && params !== void 0 && params.intentId.startsWith('IN') && !window.isLoggedOut && !sessionStorage.getItem('propositionNBX')) {
          var _configDetails$config168, _configDetails$config169;
          console.log("tech coach" + (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config168 = configDetails.config) === null || _configDetails$config168 === void 0 ? void 0 : _configDetails$config168.isTechCoachEligible));
          var techCoachEligible = configDetails !== null && configDetails !== void 0 && (_configDetails$config169 = configDetails.config) !== null && _configDetails$config169 !== void 0 && _configDetails$config169.isTechCoachEligible ? true : false;
          callAndSetNBXTroubleShooting(techCoachEligible, envData, params.intentId);
        }
        getNBXParams(params);
        if (isHealthCheck) {
          var _deviceHealthData51, _deviceHealthData52, _deviceHealthData61;
          params.isHealthCheck = isHealthCheck;
          params.caseId = (_deviceHealthData51 = deviceHealthData) === null || _deviceHealthData51 === void 0 ? void 0 : _deviceHealthData51.caseId;
          params.isRecommendedIssue = isRecommendedIssue;
          params.changeDevice = false;
          if (isRecommendedIssue || (_deviceHealthData52 = deviceHealthData) !== null && _deviceHealthData52 !== void 0 && _deviceHealthData52.isNavHistFlow) {
            var _deviceHealthData53, _deviceHealthData54, _deviceHealthData55, _deviceHealthData56, _deviceHealthData57, _deviceHealthData58, _deviceHealthData59, _deviceHealthData60;
            params.intent = (_deviceHealthData53 = deviceHealthData) === null || _deviceHealthData53 === void 0 ? void 0 : _deviceHealthData53.intent;
            params.intentId = (_deviceHealthData54 = deviceHealthData) === null || _deviceHealthData54 === void 0 ? void 0 : _deviceHealthData54.intentId;
            params.mtn = (_deviceHealthData55 = deviceHealthData) === null || _deviceHealthData55 === void 0 ? void 0 : _deviceHealthData55.mdn;
            params.mtnId = (_deviceHealthData56 = deviceHealthData) === null || _deviceHealthData56 === void 0 ? void 0 : _deviceHealthData56.mtnId;
            params.pageId = currentPageId != null ? currentPageId : (_deviceHealthData57 = deviceHealthData) === null || _deviceHealthData57 === void 0 ? void 0 : _deviceHealthData57.pageId;
            sessionStorage.setItem('troubleshootingDetails', JSON.stringify(_extends({}, JSON.parse(sessionStorage.getItem('troubleshootingDetails')), {
              intent: (_deviceHealthData58 = deviceHealthData) === null || _deviceHealthData58 === void 0 ? void 0 : _deviceHealthData58.intent,
              intentId: (_deviceHealthData59 = deviceHealthData) === null || _deviceHealthData59 === void 0 ? void 0 : _deviceHealthData59.intentId,
              mtn: (_deviceHealthData60 = deviceHealthData) === null || _deviceHealthData60 === void 0 ? void 0 : _deviceHealthData60.mdn
            })));
          }
          if ((_deviceHealthData61 = deviceHealthData) !== null && _deviceHealthData61 !== void 0 && _deviceHealthData61.isNavHistFlow) {
            var _deviceHealthData62, _deviceHealthData63;
            params.processStep = (_deviceHealthData62 = deviceHealthData) === null || _deviceHealthData62 === void 0 ? void 0 : _deviceHealthData62.processStep;
            (_deviceHealthData63 = deviceHealthData) === null || _deviceHealthData63 === void 0 ? true : delete _deviceHealthData63.isNavHistFlow;
            sessionStorage.setItem('deviceHealthData', JSON.stringify(deviceHealthData));
          }
        }
        submitActionForTroubleShooting(params, envData);
      };
      if (!window.isMVODigital) {
        return Promise.resolve();
      }
      var mvoCaseDetails = sessionUtility.getCaseDetails();
      var processAction = (_values$context$proce = values === null || values === void 0 ? void 0 : (_values$context6 = values.context) === null || _values$context6 === void 0 ? void 0 : _values$context6.processAction) != null ? _values$context$proce : '';
      var processStep = (_mvoCaseDetails$proce3 = mvoCaseDetails === null || mvoCaseDetails === void 0 ? void 0 : mvoCaseDetails.processStep) != null ? _mvoCaseDetails$proce3 : 'Next';
      var currentPageId = (_values$troubleShooti5 = values === null || values === void 0 ? void 0 : (_values$troubleShooti6 = values.troubleShootingInfo) === null || _values$troubleShooti6 === void 0 ? void 0 : (_values$troubleShooti7 = _values$troubleShooti6.ddata) === null || _values$troubleShooti7 === void 0 ? void 0 : (_values$troubleShooti8 = _values$troubleShooti7.output) === null || _values$troubleShooti8 === void 0 ? void 0 : _values$troubleShooti8.currentPageId) != null ? _values$troubleShooti5 : '';
      var _troubleshootingDetails2;
      var _temp53 = function () {
        if (sessionStorage.getItem('troubleshootingDetails')) {
          return Promise.resolve(JSON.parse(sessionStorage.getItem('troubleshootingDetails'))).then(function (_JSON$parse3) {
            _troubleshootingDetails2 = _JSON$parse3;
          });
        }
      }();
      return Promise.resolve(_temp53 && _temp53.then ? _temp53.then(_temp54) : _temp54(_temp53));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var handleNrbLoader = function handleNrbLoader(n) {
    console.log("n------------", n);
    setShowCheckingPhoneLoader(n);
  };
  var handleTroubleShootingAction = function handleTroubleShootingAction(button, options, feedback, feedbackThumbsUp) {
    if (options === void 0) {
      options = {};
    }
    console.log("&&&&&&&&&&&&&", button, options, feedback, feedbackThumbsUp);
    console.log("$$$$$$$$$$$$$$$$--------------------");
    console.log("1-----", showCheckingPhoneLoader5g);
    console.log("2-----", showCheckingPhoneLoader);
    console.log("3-----", showErrorPage);
    console.log("$$$$$$$$$$$$$$$$*****************");
    if (options.optionSelected === 'neofferaccepted' && button.nrbOeNeChkEligibilityLoader) {
      if (button.nrbOeNeChkEligibilityLoader === 'yes') {
        setShowCheckingPhoneLoader(true);
        window.scrollTo({
          left: 0,
          top: 0,
          behavior: 'smooth'
        });
      } else {
        setShowCheckingPhoneLoader(false);
      }
      return;
    }
    if (options.optionSelected === 'neofferaccepted' && button.nrbNeNotEligibleforOffer) {
      setNrbEligibility(true);
      setShowCheckingPhoneLoader(true);
      return;
    }
    if (button.nrbOeNethrowError) {
      setError("Catch error");
      return;
    }
    console.log('info handleTroubleShootingAction');
    var buttonLabel = button.heading;
    setActionHappened(false);
    if (values.selectedIssueOptionStep) {
      delete values.selectedIssueOptionStep;
    }
    if (values.thumbsDownSubmittedStep) {
      delete values.thumbsDownSubmittedStep;
    }
    var mvoConfig = sessionUtility.getMvoConfig();
    selectedDevice = options && options.macAddress;
    selectedLocation = options && options.selectedLocation;
    var longitude = options && options.longitude;
    var latitude = options && options.latitude;
    var selectedIssueOptionStep = options && options.selectedIssueOptionStep;
    var thumbsDownSubmittedStep = options && options.thumbsDownSubmittedStep;
    var optionSelected;
    if (options) {
      optionSelected = options.optionSelected;
    }
    var feedbackData;
    if (feedback) {
      feedbackData = feedback;
    }
    var _button$action = button.action,
      action = _button$action === void 0 ? '' : _button$action,
      _button$callFunction2 = button.callFunction,
      callFunction = _button$callFunction2 === void 0 ? '' : _button$callFunction2,
      _button$label = button.label,
      label = _button$label === void 0 ? '' : _button$label,
      _button$url2 = button.url,
      url = _button$url2 === void 0 ? '' : _button$url2,
      _button$popUpHtmlCont2 = button.popUpHtmlContent,
      popUpHtmlContent = _button$popUpHtmlCont2 === void 0 ? '' : _button$popUpHtmlCont2,
      _button$stopSubmitApi = button.stopSubmitApiCall,
      stopSubmitApiCall = _button$stopSubmitApi === void 0 ? false : _button$stopSubmitApi;
    var buttonAction = action || label;
    var callBackFunction = callFunction || popUpHtmlContent;
    console.log("callBackFunction===", callBackFunction);
    if (callBackFunction && callBackFunction === 'scheduleCallback' && (mvoConfig === null || mvoConfig === void 0 ? void 0 : mvoConfig.isNewExp) === 'Y') {
      triggerSubmitViraAPI(buttonLabel);
      var doReturn = processCallFunction(button);
      if (doReturn) {
        return;
      }
    }
    if (url) {
      window.location.href = url;
      return;
    }
    if (callBackFunction) {
      if (!stopSubmitApiCall) {
        triggerSubmitViraAPI(buttonLabel);
      }
      var _doReturn = processCallFunction(button);
      if (_doReturn) {
        return;
      }
    }
    console.log('Action--->', action);
    if (action === 'ts_multi' || action === 'ts_radio' || action === 'ts_dropdown' || action === 'ts_options') {
      _processTroubleShootingPage('ts_new', buttonAction, '', '', '', optionSelected, '', options.fromPage);
      return;
    }
    if (action === 'ts_complete') {
      _processTroubleShootingPage('ts_complete', buttonAction, '', '', '', optionSelected, '', options.fromPage, '', '', longitude, latitude);
      return;
    }
    if (action === '') {
      return;
    }
    if (action.toLowerCase().indexOf('done') !== -1) {
      if (button.label !== 'Done' && feedbackThumbsUp !== "feedbackThumbsUp") {
        triggerSubmitViraAPI(buttonLabel);
      }
      _processTroubleShootingPage('submit', buttonAction, '', '', '', optionSelected, feedbackData, options.fromPage, options.label, feedbackThumbsUp, '', '', '', options, selectedIssueOptionStep, thumbsDownSubmittedStep);
      return;
    }
    if (action.toLowerCase().indexOf('close') !== -1) {
      var _window72;
      if (window._dg_channelId === 'VZW-MFA' && window.isMVODigital) {
        if (window.callFunc) {
          window.callFunc('Network settings', 'managefiveGNetworks', true);
        }
      }
      if (((_window72 = window) === null || _window72 === void 0 ? void 0 : _window72._dg_channelId) === 'VZW-MFA') {
        var _url = '/mva';
        var launchType = sessionStorage.getItem('launchPageType');
        console.log(launchType, 'Launch Type from Session Storage 2860');
        if (launchType) {
          var _window73, _window73$config, _window73$config$case;
          var caseMtn = (_window73 = window) === null || _window73 === void 0 ? void 0 : (_window73$config = _window73.config) === null || _window73$config === void 0 ? void 0 : (_window73$config$case = _window73$config.caseDetails) === null || _window73$config$case === void 0 ? void 0 : _window73$config$case.mtn;
          callFunc('Network settings', 'managefiveGNetworks', true, _url, caseMtn);
          console.log(_url, caseMtn, 'Inside if 2864');
        } else {
          callFunc('Network settings', 'managefiveGNetworks', true);
          console.log('Inside else 2868');
        }
      }
      _processTroubleShootingPage('close', buttonAction, '', '', '', optionSelected, '', options.fromPage);
    } else {
      _processTroubleShootingPage('submit', buttonAction, '', '', '', optionSelected, '', options.fromPage, '', '', longitude, latitude, button, options);
    }
  };
  var redirectToCombinedIssueSelector = function redirectToCombinedIssueSelector() {
    var _window74, _window74$config, _window74$config$trou, _window74$config$trou2, _window74$config$trou3;
    var additionalMtns = (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns) || [];
    var seoUrl = (_window74 = window) === null || _window74 === void 0 ? void 0 : (_window74$config = _window74.config) === null || _window74$config === void 0 ? void 0 : (_window74$config$trou = _window74$config.troubleShootingJson) === null || _window74$config$trou === void 0 ? void 0 : (_window74$config$trou2 = _window74$config$trou.ddata) === null || _window74$config$trou2 === void 0 ? void 0 : (_window74$config$trou3 = _window74$config$trou2.device) === null || _window74$config$trou3 === void 0 ? void 0 : _window74$config$trou3.soeUrl;
    var mtnDetails = additionalMtns.find(function (mtn) {
      return mtn.seoUrl == seoUrl;
    });
    var combinedIssueSelectorUrl = !isEmpty(mtnDetails) ? mtnDetails === null || mtnDetails === void 0 ? void 0 : mtnDetails.combinedIssueSelectorUrl : '';
    combinedIssueSelectorUrl ? window.location.href = combinedIssueSelectorUrl : history.goBack();
  };
  var handleReplayNavigation = function handleReplayNavigation(value, step) {
    var _configDetails$params24, _configDetails$params25, _configDetails$params26, _configDetails$params27, _window75, _window76;
    var _values$landingInfo1 = values.landingInfo,
      landingInfo = _values$landingInfo1 === void 0 ? {} : _values$landingInfo1;
    var _landingInfo$device10 = landingInfo.device,
      device = _landingInfo$device10 === void 0 ? {} : _landingInfo$device10;
    var is5GDevice = device.is5GDevice;
    var isACSS = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params24 = configDetails.paramsDetails) === null || _configDetails$params24 === void 0 ? void 0 : _configDetails$params24.channel) == 'CARE' || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params25 = configDetails.paramsDetails) === null || _configDetails$params25 === void 0 ? void 0 : _configDetails$params25.channel) == 'Prepay' || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params26 = configDetails.paramsDetails) === null || _configDetails$params26 === void 0 ? void 0 : _configDetails$params26.channel) == 'Retail' || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params27 = configDetails.paramsDetails) === null || _configDetails$params27 === void 0 ? void 0 : _configDetails$params27.channel) == 'Verizon Website' ? true : false;
    var popOutFlow = (_window75 = window) !== null && _window75 !== void 0 && _window75.isBAUACSS ? true : false;
    if (popOutFlow && (step === null || step === void 0 ? void 0 : step.templateId) === 'ISSUE_SELECTOR') {
      redirectToBAU();
    } else if ((_window76 = window) !== null && _window76 !== void 0 && _window76.hlthFlow && (step === null || step === void 0 ? void 0 : step.templateId) === 'ISSUE_SELECTOR') {
      var _deviceHealthData64;
      isNavHistFlow = false;
      var troubleshootingDevice = JSON.parse(sessionStorage.getItem('troubleshootingDevice'));
      var mtnId = (_deviceHealthData64 = deviceHealthData) === null || _deviceHealthData64 === void 0 ? void 0 : _deviceHealthData64.mtnId;
      var enCodedSkuId = encodeURIComponent(encodeURIComponent(troubleshootingDevice === null || troubleshootingDevice === void 0 ? void 0 : troubleshootingDevice.deviceSku));
      var issueSelectorUrl = "/digital/nsa/secure/ui/troubleshooting/" + (troubleshootingDevice === null || troubleshootingDevice === void 0 ? void 0 : troubleshootingDevice.soeUrl) + "/" + enCodedSkuId + "/combined#/mtn/" + mtnId;
      window.location.href = issueSelectorUrl;
    } else if (combinedIssueSelector && (step === null || step === void 0 ? void 0 : step.templateId) === 'ISSUE_SELECTOR') {
      var _window77;
      history.goBack();
      redirectToCombinedIssueSelector();
      if (isChangeDeviceFlow(configDetails) || (_window77 = window) !== null && _window77 !== void 0 && _window77.isLoggedOut) {
        setTimeout(function () {
          window.location.reload();
        }, 100);
      }
    } else if ((step === null || step === void 0 ? void 0 : step.templateId) === 'Health_Check') {
      redirectToHealthCheckMFE();
    } else if (isACSS && (step === null || step === void 0 ? void 0 : step.templateId) === 'ISSUE_SELECTOR') {
      var customEvent = new CustomEvent('issueSelectTab', {
        detail: {
          issueSelectTab: true
        }
      });
      window.dispatchEvent(customEvent);
    } else if (!isACSS && (step === null || step === void 0 ? void 0 : step.templateId) === 'ISSUE_SELECTOR') {
      redirectToCombinedIssueSelector();
    } else if ((value === '1' || value === 1) && is5GDevice) {
      var replayValues = {
        activePage: 'main_symptom',
        replayMain: true
      };
      updateValues(values, replayValues);
    } else {
      if (values.thumbsDownSubmittedStep) {
        delete values.thumbsDownSubmittedStep;
      }
      _processTroubleShootingPage('replay', '', value);
    }
  };
  var updateQuestionParamRecords = function updateQuestionParamRecords(context) {
    var _context$lineInfo5 = context.lineInfo,
      lineInfo = _context$lineInfo5 === void 0 ? {} : _context$lineInfo5;
    var _ref19 = lineInfo[0] || {},
      allCalls = _ref19.allCalls,
      specificNumber = _ref19.specificNumber,
      allLocations = _ref19.allLocations,
      address = _ref19.address;
    if (allCalls) {
      handleQuestionsLabel('all', 'specific_num');
    }
    if (specificNumber) {
      handleQuestionsLabel('specific_num', 'all');
    }
    if (allLocations) {
      handleQuestionsLabel('everywhere', 'specific_loc');
    }
    if (address) {
      handleQuestionsLabel('specific_loc', 'everywhere');
    }
  };
  var handleAction = function handleAction() {
    setActionHappened(true);
  };
  var closeFeedbackBar = function closeFeedbackBar(values) {
    setValues(_extends({}, values, {
      feedbackContainerDetails: {
        show: false
      }
    }));
  };
  var functions = {
    handleCancel: handleCancel,
    handleNextPage: handleNextPage,
    setNextPage: setNextPage,
    handlePreviousPage: handlePreviousPage,
    handleSearch: handleSearch,
    handleCloseModal: handleCloseModal,
    handleSymptomSelect: handleSymptomSelect,
    handleTypeAheadSelect: handleTypeAheadSelect,
    processSymptomRedirection: processSymptomRedirection,
    processTroubleShootingPage: _processTroubleShootingPage,
    handleQuestionsLabel: handleQuestionsLabel,
    handleTroubleShootingAction: handleTroubleShootingAction,
    handleQuestionsPageInputs: handleQuestionsPageInputs,
    handleAddressValidation: handleAddressValidation,
    closeScheduleCallModal: closeScheduleCallModal,
    openModal: openModal,
    handleReplayNavigation: handleReplayNavigation,
    updateValues: updateValues,
    handleAction: handleAction,
    closeFeedbackBar: closeFeedbackBar,
    redirectToCombinedIssueSelector: redirectToCombinedIssueSelector
  };
  if (values.activePage === 'unknown') {
    throw new Error('Unknown page for templateType');
  }
  var check5GDevice = (_values$landingInfo$d = (_values$landingInfo10 = values.landingInfo) === null || _values$landingInfo10 === void 0 ? void 0 : (_values$landingInfo11 = _values$landingInfo10.device) === null || _values$landingInfo11 === void 0 ? void 0 : _values$landingInfo11.is5GDevice) != null ? _values$landingInfo$d : false;
  var outageStatus = (_values$outageInfo$da = (_values$outageInfo3 = values.outageInfo) === null || _values$outageInfo3 === void 0 ? void 0 : (_values$outageInfo3$d = _values$outageInfo3.data) === null || _values$outageInfo3$d === void 0 ? void 0 : _values$outageInfo3$d.statusCode) != null ? _values$outageInfo$da : '';
  var mvoTroubleShootingJson = sessionUtility.getTroubleShootingJson();
  var isNewDesign = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config170 = configDetails.config) === null || _configDetails$config170 === void 0 ? void 0 : _configDetails$config170.isNewTemplate) && !(mvoTroubleShootingJson !== null && mvoTroubleShootingJson !== void 0 && (_mvoTroubleShootingJs20 = mvoTroubleShootingJson.ddata) !== null && _mvoTroubleShootingJs20 !== void 0 && (_mvoTroubleShootingJs21 = _mvoTroubleShootingJs20.device) !== null && _mvoTroubleShootingJs21 !== void 0 && _mvoTroubleShootingJs21.is5GDevice);
  return /*#__PURE__*/React__default.createElement(Fragment, null, !check5GDevice && outageStatus === '10' && /*#__PURE__*/React__default.createElement(Outage4g, {
    outageInfo: values.outageInfo
  }), window.isMVODigital && isNewDesign && !combinedIssueSelector && !showIssueResolved && /*#__PURE__*/React__default.createElement(Breadcrumbs, {
    isHealthCheck: isHealthCheck,
    deviceHealthData: deviceHealthData
  }), window.isMVODigital ? combinedIssueSelector && !showIssueResolved && values.activePage !== 'main_symptom' && values.activePage !== 'nrb' && /*#__PURE__*/React__default.createElement(Breadcrumbs, {
    activePage: values.activePage,
    isHealthCheck: isHealthCheck,
    deviceHealthData: deviceHealthData
  }) : combinedIssueSelector && !showIssueResolved && values.activePage !== 'nrb' && /*#__PURE__*/React__default.createElement(Breadcrumbs, {
    activePage: values.activePage,
    isHealthCheck: isHealthCheck,
    deviceHealthData: deviceHealthData
  }), window.isMVODigital && (values === null || values === void 0 ? void 0 : values.activePage) === 'main_symptom' && combinedIssueSelector && alertBanners.length > 0 && /*#__PURE__*/React__default.createElement(AlertBanner, {
    alertBannerContent: alertBanners
  }), /*#__PURE__*/React__default.createElement(PageWrapper, {
    className: "PageWrapper"
  }, /*#__PURE__*/React__default.createElement(MainWrapper$1, {
    className: "MainWrapper"
  }, showTopLine(values) && /*#__PURE__*/React__default.createElement(Line$1, {
    type: "secondary"
  }), showErrorPage && /*#__PURE__*/React__default.createElement(ErrorPage, null), nrbEligibility && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ContentWrapper$g, {
    id: "ContentWrapper",
    className: ""
  }, /*#__PURE__*/React__default.createElement(NrbCheckOfferEligibility, {
    mtn: (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config171 = configDetails.config) === null || _configDetails$config171 === void 0 ? void 0 : (_configDetails$config172 = _configDetails$config171.caseDetails) === null || _configDetails$config172 === void 0 ? void 0 : _configDetails$config172.mtn) || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params31 = configDetails.paramsDetails) === null || _configDetails$params31 === void 0 ? void 0 : _configDetails$params31.mdn),
    mvoenv: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params32 = configDetails.paramsDetails) === null || _configDetails$params32 === void 0 ? void 0 : _configDetails$params32.mvoenv,
    handleNrbLoader: handleNrbLoader
  }))), !nrbEligibility && !showCheckingPhoneLoader5g.show && !showCheckingPhoneLoader && renderPage(values, functions, showCallScheduleModal, actionHappened, allIntentsData, pendingCases, combinedIssueSelector, alertBanners, setShowCheckingPhoneLoader, showIssueResolved, issueResolvedContent, smartAIData, sendMessage, setSendMessage, languageIndicator, setLanguageIndicator), !showCheckingPhoneLoader5g.show && renderCheckingPhoneLoader(showCheckingPhoneLoader, show5gloadingmsg, previousPageLoaderMessage, values, configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params33 = configDetails.paramsDetails) === null || _configDetails$params33 === void 0 ? void 0 : _configDetails$params33.theme), showCheckingPhoneLoader5g.show && renderCheckingPhoneLoader2(showCheckingPhoneLoader, showCheckingPhoneLoader5g.heading, previousPageLoaderMessage, values, configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params34 = configDetails.paramsDetails) === null || _configDetails$params34 === void 0 ? void 0 : _configDetails$params34.theme), renderMessageModal$1(messageModalInfo, handleModalAction))));
};

var _templateObject$12, _templateObject2$Q, _templateObject3$G, _templateObject4$F, _templateObject5$A, _templateObject6$u, _templateObject7$q, _templateObject8$o, _templateObject9$l, _templateObject0$j, _templateObject1$j, _templateObject10$e;
var ContentWrapper$h = styled.div(_templateObject$12 || (_templateObject$12 = _taggedTemplateLiteralLoose(["\n  @media (min-width: 601px) {\n    box-shadow: 0px 0px 10px #aaa;\n    height: 450px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 48px;\n    width: 1024px;\n  }\n\n  @media (max-width: 600px) {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin-top: 48px;\n    width: 100%;\n  }\n\n  position: relative;\n"])));
var TitleWrapper$b = styled.div(_templateObject2$Q || (_templateObject2$Q = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  padding-top: 12px;\n  width: 100%;\n\n  div:last-child {\n    margin-left: auto;\n  }\n"])));
var TitleTextWrapper$a = styled.div(_templateObject3$G || (_templateObject3$G = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  width: 95%;\n"])));
var StyledTextWithHtml$4 = styled(TextWithHtml)(_templateObject4$F || (_templateObject4$F = _taggedTemplateLiteralLoose(["\n  @media (max-width: 600px) {\n    width: 330px;\n  }\n"])));
var Cancel$9 = styled.div(_templateObject5$A || (_templateObject5$A = _taggedTemplateLiteralLoose(["\n  margin-right: 10px;\n"])));
var StepContainer$8 = styled.div(_templateObject6$u || (_templateObject6$u = _taggedTemplateLiteralLoose(["\n  display: flex;\n\n  @media (min-width: 601px) {\n    height: 290px;\n    justify-content: space-between;\n    padding: 0px 70px 20px 70px;\n  }\n\n  @media (max-width: 600px) {\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n  }\n"])));
var StepInfoContainer$a = styled.div(_templateObject7$q || (_templateObject7$q = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n\n  @media (min-width: 601px) {\n    align-items: flex-start;\n    height: 275px;\n    width: 51%;\n    justify-content: flex-start;\n  }\n\n  @media (max-width: 600px) {\n    width: 100%;\n  }\n"])));
var ContactsContainer$4 = styled.div(_templateObject8$o || (_templateObject8$o = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  @media (min-width: 601px) {\n      margin-top: 50px;\n    width: 40%;\n  }\n\n  @media (max-width: 600px) {\n    width: 100%;\n  }\n"])));
var StepOption$6 = styled.div(_templateObject9$l || (_templateObject9$l = _taggedTemplateLiteralLoose(["\n  border: 1px solid ", ";\n  border-radius: 7px;\n  display: flex;\n  cursor: pointer;\n  flex-direction: column;\n  height: 64px;\n  justify-content: center;\n  padding-left: 14px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  padding-right: 14px;\n  width: 315px;\n\n  :not(:first-child) {\n    margin-top: 15px;\n  }\n"])), verizonTheme.coolGray3);
var IssueBoxWrapper$5 = styled.div(_templateObject0$j || (_templateObject0$j = _taggedTemplateLiteralLoose(["\n  display: flex;\n"])));
var IssueContentbox$5 = styled.div(_templateObject1$j || (_templateObject1$j = _taggedTemplateLiteralLoose(["\n  @media (min-width: 601px) {\n    width: 320px;\n  }\n\n  @media (max-width: 600px) {\n    width: 280px;\n  }\n  cursor: pointer;  \n  justify-content: left;\n"])));
var IssueContentArrow$5 = styled.div(_templateObject10$e || (_templateObject10$e = _taggedTemplateLiteralLoose(["\n  @media (min-width: 601px) {\n    width: 40px;\n  }\n\n  @media (max-width: 600px) {\n    width: 30px;\n  }\n  cursor: pointer;\n  justify-content: right;\n  display: inline-flex;\n  align-items:flex-end;\n  /*padding-top: 32px;*/\n"])));
var renderNextOptions$1 = function renderNextOptions(contactOptions, handleSelect) {
  var optionCount = 0;
  return contactOptions.map(function (option) {
    return /*#__PURE__*/React__default.createElement(StepOption$6, {
      key: "option_" + optionCount++,
      onClick: function onClick() {
        return handleSelect(option);
      },
      "data-analyticstrack": option.heading,
      "data-track": "{\"type\": \"link\", \"name\": " + option.heading + "}",
      "data-clickstream": option.heading + "-link",
      "data-testid": "stepOptions"
    }, /*#__PURE__*/React__default.createElement(IssueBoxWrapper$5, null, /*#__PURE__*/React__default.createElement(IssueContentbox$5, null, option.heading && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Body, {
      size: "medium",
      primitive: "h5",
      bold: true
    }, option.heading)), /*#__PURE__*/React__default.createElement("div", {
      style: {
        paddingTop: "6px"
      }
    }, option.subHeading && /*#__PURE__*/React__default.createElement(Body, {
      size: "small"
    }, option.subHeading))), /*#__PURE__*/React__default.createElement(IssueContentArrow$5, null, " ", /*#__PURE__*/React__default.createElement(Icon$1, {
      name: "right-arrow",
      size: "small"
    }))));
  });
};
var errorResponse = {
  "responseInfo": {
    "timeStamp": "08-12-2021 10:07:43",
    "correlationId": "7d82dd46-e5b3-4294-9256-4d182856bb68-38811681",
    "responseCode": "00",
    "responseMessage": "SUCCESS",
    "sectionErrors": []
  },
  "body": {
    "ddata": {
      "output": {
        "pageContent": {
          "steps": [{
            "answers": [],
            "userLocation": [],
            "templateId": "4G_ERROR_PEGA_NO_RESPONSE",
            "templateType": "contactoptions-error",
            "title": "Contact us",
            "heading": "<p>An error occurred during troubleshooting.</p>",
            "subHeading": "",
            "description": "<p>Please try again after sometime or try these contact options</p>",
            "image": "",
            "cta": [],
            "questions": [],
            "contactOptions": [{
              "heading": "Schedule call back",
              "subHeading": "skip the hold time and receive a call in 10-15 mins",
              "url": "/support/1d/secure/contact-us/schedule/",
              "callFunction": "scheduleCallback"
            }, {
              "heading": "Chat with us",
              "subHeading": "Estimated wait time 12 mins",
              "url": "",
              "callFunction": "openChat"
            }, {
              "heading": "Send us a support request",
              "subHeading": "We'll get back to you with the best way to help you",
              "url": "/digital/nsa/secure/ui/sdr/createsupportrequest#/",
              "callFunction": "sdr"
            }, {
              "heading": "No, let's try another solution",
              "subHeading": "start with another solution",
              "url": "/support/devices/",
              "callFunction": ""
            }],
            "sidenote": ""
          }]
        },
        "navHist": [],
        "prevStepEnabled": true,
        "nextStepEnabled": false
      }
    },
    "context": {
      "lineInfo": [],
      "availablePaths": []
    },
    "pageAttributes": [{
      "itemKey": "hashedAccountNumber",
      "itemValue": "f0040b157e3b45b57ebaba3c7cbdce28fb47eefa4443f3c5c475756bd3daa84d",
      "itemType": "text",
      "itemMatch": "user.account"
    }, {
      "itemKey": "hashedMdn",
      "itemValue": "775f6c102bc0903dd9d81145f4001d3816b090935a25b2d06cc647c8e4dd4134",
      "itemType": "text",
      "itemMatch": "user.id"
    }, {
      "itemKey": "zip",
      "itemValue": "07920",
      "itemType": "text",
      "itemMatch": "user.zip"
    }, {
      "itemKey": "customerRole",
      "itemValue": "accountManager",
      "itemType": "text",
      "itemMatch": "user.customerRole"
    }, {
      "itemKey": "customerType",
      "itemValue": "PE",
      "itemType": "text",
      "itemMatch": "user.customerType"
    }, {
      "itemKey": "accountType",
      "itemValue": "mixMatch",
      "itemType": "text",
      "itemMatch": "user.accountType"
    }, {
      "itemKey": "pegaCaseId",
      "itemValue": "",
      "itemType": "text",
      "itemMatch": "utils.pegaCaseId"
    }]
  }
};
var ErrorBoundaryUiDigital = function ErrorBoundaryUiDigital(props) {
  console.log("comren ErrorBoundaryUiDigital");
  var uiLoggerContext = React__default.useContext(UiLoggerContext);
  var configDetails = React__default.useContext(ConfigContext);
  var contactOptions = errorResponse.body.ddata.output.pageContent.steps[0].contactOptions;
  var finalContactOptions = contactOptions;
  if (window.isLoggedOut) {
    finalContactOptions = contactOptions.filter(function (option) {
      return option.callFunction != "sdr";
    });
  }
  var _useState = useState("");
  var _useState2 = useState({
      showModal: false,
      expandModal: false
    }),
    modalValues = _useState2[0],
    setModalValues = _useState2[1];
  var _useState3 = useState({
      showThumbsUp: false,
      showThumbsDown: false,
      thumbsClicked: false,
      submitClicked: false,
      rating: ''
    });
  var _useState4 = useState({
      body: "",
      buttons: [],
      isError: false,
      show: false,
      title: "",
      options: [],
      link: ""
    }),
    messageModalInfo = _useState4[0],
    setMessageModalInfo = _useState4[1];
  useEffect(function () {
    var _window$tsFeatureFlag;
    if (uiLoggerContext !== null && uiLoggerContext !== void 0 && uiLoggerContext.setPageDetails) {
      var _sessionUtility$getTr = sessionUtility.getTroubleShootingDetails(),
        _sessionUtility$getTr2 = _sessionUtility$getTr.intent,
        intent = _sessionUtility$getTr2 === void 0 ? '' : _sessionUtility$getTr2;
      var innrHTML = document.getElementById("error_description");
      var pageDetails = {
        pageTitle: intent,
        pageName: "Troubleshooting | " + intent,
        errorShown: "1",
        userViewedMessage: innrHTML && innrHTML.children && innrHTML.children[0].innerHTML || ''
      };
      uiLoggerContext.setPageDetails(pageDetails);
    }
    if ((_window$tsFeatureFlag = window.tsFeatureFlags) !== null && _window$tsFeatureFlag !== void 0 && _window$tsFeatureFlag.enableErrorScreenPageViewFFlag) {
      var _window, _window$vzdl, _window2, _window2$vzdl, _window3, _window3$vzdl, _window4, _window4$vzdl;
      var page = ((_window = window) === null || _window === void 0 ? void 0 : (_window$vzdl = _window.vzdl) === null || _window$vzdl === void 0 ? void 0 : _window$vzdl.page) || {};
      var target = ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$vzdl = _window2.vzdl) === null || _window2$vzdl === void 0 ? void 0 : _window2$vzdl.target) || {};
      var env = ((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$vzdl = _window3.vzdl) === null || _window3$vzdl === void 0 ? void 0 : _window3$vzdl.env) || {};
      var user = ((_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$vzdl = _window4.vzdl) === null || _window4$vzdl === void 0 ? void 0 : _window4$vzdl.user) || {};
      tagging.setPageView({
        page: _extends({}, page),
        target: _extends({}, target),
        env: _extends({}, env),
        user: _extends({}, user),
        event: {
          value: 'event11'
        },
        error: {
          code: 'Data issue'
        }
      });
      logClickStream('PAGE-LOADED', 'PAGE-LOADED', 'PAGE-LOADED', '');
    }
  }, []);
  var handleCancel = function handleCancel() {
    var modalParams = _extends({}, messageModalInfo, {
      body: "You'll have to start over again for help with this issue.",
      buttons: [{
        type: "secondary",
        text: "Done",
        actionData: "done"
      }, {
        type: "primary",
        text: "Cancel",
        actionData: "cancel"
      }],
      show: true,
      styles: {
        height: "350px",
        marginBottom: "10px"
      },
      title: "Are you sure you're done with troubleshooting?"
    });
    setMessageModalInfo(_extends({}, modalParams));
    setModalValues({
      showModal: true,
      expandModal: true
    });
  };
  var processCallFunction = function processCallFunction(button) {
    var _button$callFunction = button.callFunction,
      callFunction = _button$callFunction === void 0 ? "" : _button$callFunction;
    var doReturn = true;
    switch (callFunction) {
      case "openChat":
        if (window._dg_channelId === "VZW-MFA") {
          openMvaChatbot();
          return;
        }
        if (window.EchannelVera) {
          window.EchannelVera.init({});
        } else {
          console.log("Main:processCallFunction: ChatBot not enabled on page.");
        }
        break;
      default:
        console.log("Main:processCallFunction: got unknown function: " + callFunction);
        break;
    }
    return doReturn;
  };
  var handleSelect = function handleSelect(button) {
    var _button$action = button.action,
      action = _button$action === void 0 ? "" : _button$action,
      _button$callFunction2 = button.callFunction,
      callFunction = _button$callFunction2 === void 0 ? "" : _button$callFunction2,
      _button$url2 = button.url,
      url = _button$url2 === void 0 ? "" : _button$url2;
    if (callFunction && callFunction === "scheduleCallback" && window.isNewExp === "Y") {
      var doReturn = processCallFunction(button);
      if (doReturn) {
        return;
      }
    }
    if (url) {
      window.location.href = url;
      return;
    }
    if (callFunction) {
      var _doReturn = processCallFunction(button);
      if (_doReturn) {
        return;
      }
    }
    if (action === "") {
      return;
    }
  };
  var navigateToBackPage = function navigateToBackPage() {
    var currentPageUrl = window.location.href;
    var currentPageUrlIndex = currentPageUrl.indexOf('start/');
    if (currentPageUrl && !isEmpty(currentPageUrl) && !isEmpty(currentPageUrl.substring(0, currentPageUrlIndex))) {
      var navigateToPage = currentPageUrl.substring(0, currentPageUrlIndex);
      window.location.href = navigateToPage;
      history.go();
    } else {
      var defaultRedirectURL = "";
      if (window.isLoggedOut) {
        defaultRedirectURL = "/digital/nsa/nos/ui/support/nonsigninlanding";
      } else {
        defaultRedirectURL = "/digital/nsa/secure/ui/support/signinlanding";
      }
      window.location.href = defaultRedirectURL;
    }
  };
  var handleModalActionDigital = function handleModalActionDigital(button) {
    var _ref = button || {},
      actionData = _ref.actionData;
    if (actionData === "cancel" || actionData === "close") ; else if (actionData === "done") {
      var _window6, _window6$config, _window6$config$troub, _window6$config$troub2, _window6$config$troub3;
      var additionalMtns = (configDetails === null || configDetails === void 0 ? void 0 : configDetails.additionalMtns) || [];
      console.log(additionalMtns);
      var seoUrl = (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$config = _window6.config) === null || _window6$config === void 0 ? void 0 : (_window6$config$troub = _window6$config.troubleShootingJson) === null || _window6$config$troub === void 0 ? void 0 : (_window6$config$troub2 = _window6$config$troub.ddata) === null || _window6$config$troub2 === void 0 ? void 0 : (_window6$config$troub3 = _window6$config$troub2.device) === null || _window6$config$troub3 === void 0 ? void 0 : _window6$config$troub3.soeUrl;
      var mtnDetails = additionalMtns.find(function (mtn) {
        return mtn.seoUrl == seoUrl;
      });
      var combinedIssueSelectorUrl = !isEmpty(mtnDetails) ? mtnDetails === null || mtnDetails === void 0 ? void 0 : mtnDetails.combinedIssueSelectorUrl : '';
      if (combinedIssueSelectorUrl) {
        window.location.href = combinedIssueSelectorUrl;
        history.go();
      } else {
        navigateToBackPage();
      }
      sessionStorage.removeItem("tsData");
      return;
    }
    setMessageModalInfo(_extends({}, messageModalInfo, {
      show: false
    }));
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ContentWrapper$h, {
    "data-testid": "ErrorBoundaryUiDigital"
  }, /*#__PURE__*/React__default.createElement(TitleWrapper$b, null, /*#__PURE__*/React__default.createElement(TitleTextWrapper$a, null, /*#__PURE__*/React__default.createElement(Title, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TextWithHtml, null))), /*#__PURE__*/React__default.createElement(Cancel$9, {
    "data-analyticstrack": "cancel-Icon",
    "data-track": "{\"type\": \"link\", \"name\": \"cancel-Icon\"}",
    "data-clickstream": "cancel-Icon",
    onClick: handleCancel,
    "data-testid": "cancelIcon"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "close",
    size: "large"
  }))), /*#__PURE__*/React__default.createElement(StepContainer$8, null, /*#__PURE__*/React__default.createElement(StepInfoContainer$a, null, /*#__PURE__*/React__default.createElement(Title, {
    bold: true,
    size: "medium"
  }, /*#__PURE__*/React__default.createElement(StyledTextWithHtml$4, null, errorResponse.body.ddata.output.pageContent.steps[0].heading), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "20px"
  })), errorResponse.body.ddata.output.pageContent.steps[0].description && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "large",
    id: "error_description"
  }, /*#__PURE__*/React__default.createElement(StyledTextWithHtml$4, null, errorResponse.body.ddata.output.pageContent.steps[0].description)), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "20px"
  }))), /*#__PURE__*/React__default.createElement(ContactsContainer$4, null, renderNextOptions$1(finalContactOptions, handleSelect)))), modalValues.showModal && /*#__PURE__*/React__default.createElement(MessageModal, {
    body: messageModalInfo.body,
    buttons: messageModalInfo.buttons,
    handleAction: handleModalActionDigital,
    isError: messageModalInfo.isError,
    showModal: messageModalInfo.show,
    styles: messageModalInfo.styles,
    title: messageModalInfo.title,
    options: messageModalInfo.options,
    link: messageModalInfo.link
  }));
};

var _templateObject$13, _templateObject2$R, _templateObject3$H, _templateObject4$G;
var ButtonsWrapper$8 = styled.div(_templateObject$13 || (_templateObject$13 = _taggedTemplateLiteralLoose(["\n  button {\n    span:last-child {\n      background-color: ", " !important;\n      color: ", " !important;\n      padding: ", " !important;\n      border-radius: ", " !important;\n    }\n  }\n\n"])), function (props) {
  return props !== null && props !== void 0 && props.isACSS ? props.isDarkTheme && '#fff' : '#000';
}, function (props) {
  return props.isDarkTheme && '#000';
}, function (props) {
  return props.isDarkTheme && '0.8rem';
}, function (props) {
  return !props.isACCS && '6.25rem';
});
var IssueHistoryWrapper = styled.div(_templateObject2$R || (_templateObject2$R = _taggedTemplateLiteralLoose(["\n  display:flex;\n  flex-direction:row;\n  margin-top:20px;\n  margin-bottom:30px;\n  cursor:pointer;\n"])));
var ContentWrapper$i = styled.div(_templateObject3$H || (_templateObject3$H = _taggedTemplateLiteralLoose(["\n\nmargin: 10px 15px 40px 15px;\nwidth: 80%;\n.errorHead{\n    font-size:24px;\n    font-weight:bold;\n}\n.errorDesc{\n  font-size:12px;\n}\n\n\n.issueHistoryLink{\n    font-weight:bold;\n    font-size:14px;\n    font-family: 'Verizon-NHG-eDS' !important;\n}\n.linkHeading{\n    font-size:18px;\n    font-weight:400;\n    font-family: 'Verizon-NHG-eDS' !important;\n}\n.linkStyle{\n    font-size:12px;\n    margin-bottom:10px;\n    color:", " !important;\n    border-bottom:", " !important;\n}\n.linkStyle:hover{\n  text-decoration:", " !important;\n}\n.feedbackHead{\n    font-weight:bold;\n    font-size:14px;\n    margin-bottom:10px;\n\n}\n.feedbackDesc{\n    font-size:14px;\n}\n\n\n"])), function (props) {
  return !props.isDarkTheme && 'unset';
}, function (props) {
  return props.isACSS && !props.isDarkTheme && '1px solid black';
}, function (props) {
  return !props.isDarkTheme && 'unset';
});
var TextAreaConatiner = styled.div(_templateObject4$G || (_templateObject4$G = _taggedTemplateLiteralLoose(["\n[class^=\"StyledTextarea-VDS\"] {\n  :focus-visible {\n    border: unset !important;\n  }\n\n}\n[class^=\"HighlightMark-VDS\"]{\n  padding:unset;\n}\n"])));
var ErrorScreenAcss = function ErrorScreenAcss(_ref) {
  var _useContext, _configDetails$params, _configDetails$params2;
  var handleIssueSelector = _ref.handleIssueSelector;
  var _useState = useState(false),
    btnShow = _useState[0],
    setBtnShow = _useState[1];
  var _useState2 = useState(""),
    feedbackMsg = _useState2[0],
    setFeedbackMsg = _useState2[1];
  var _useState3 = useState(false),
    showSuccess = _useState3[0],
    setShowSuccess = _useState3[1];
  var _useState4 = useState(false),
    showFailure = _useState4[0],
    setShowFailure = _useState4[1];
  var _useState5 = useState(false),
    alreadySent = _useState5[0],
    setAlreadySent = _useState5[1];
  var configDetails = useContext(ConfigContext);
  var additionInfoSteps = (_useContext = useContext(ParamsContext)) === null || _useContext === void 0 ? void 0 : _useContext.additionalInfoSteps;
  var isACSS = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : _configDetails$params.channel) == "CARE" || (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params2 = configDetails.paramsDetails) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.channel) == "Prepay";
  var errorContent1 = additionInfoSteps === null || additionInfoSteps === void 0 ? void 0 : additionInfoSteps.filter(function (o) {
    return o.templateId == "ERROR_PAGE_1";
  })[0];
  var errorContent2 = additionInfoSteps === null || additionInfoSteps === void 0 ? void 0 : additionInfoSteps.filter(function (o) {
    return o.templateId == "ERROR_PAGE_2";
  })[0];
  var errorContent3 = additionInfoSteps === null || additionInfoSteps === void 0 ? void 0 : additionInfoSteps.filter(function (o) {
    return o.templateId == "ERROR_PAGE_3";
  })[0];
  var errorContent4 = additionInfoSteps === null || additionInfoSteps === void 0 ? void 0 : additionInfoSteps.filter(function (o) {
    return o.templateId == "ERROR_PAGE_4";
  })[0];
  var handleChange = function handleChange(event) {
    var _event$target$value;
    setFeedbackMsg(event.target.value);
    if (((_event$target$value = event.target.value) === null || _event$target$value === void 0 ? void 0 : _event$target$value.length) > 0) {
      if (!alreadySent) setBtnShow(true);else setBtnShow(false);
    } else {
      setBtnShow(false);
    }
  };
  var submitFeedback = function submitFeedback() {
    try {
      var _configDetails$params3;
      var feedbackApiUrl = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params3 = configDetails.paramsDetails) === null || _configDetails$params3 === void 0 ? void 0 : _configDetails$params3.externalTarget) + "/acss/service/troubleshooting/feedback";
      var _temp = function () {
        if (feedbackMsg) {
          var resp, data;
          return Promise.resolve(feedbackDataHandler(feedbackMsg, {}, configDetails, "error")).then(function (_feedbackDataHandler) {
            data = _feedbackDataHandler;
            return Promise.resolve(callAxios$1(feedbackApiUrl, 'post', data)).then(function (_callAxios) {
              var _resp, _resp2;
              resp = _callAxios;
              if (((_resp = resp) === null || _resp === void 0 ? void 0 : _resp.success) == true) {
                setAlreadySent(true);
                setShowSuccess(true);
                setFeedbackMsg("");
                setBtnShow(false);
              }
              if (((_resp2 = resp) === null || _resp2 === void 0 ? void 0 : _resp2.success) == false) {
                setShowFailure(true);
              }
            });
          });
        }
      }();
      return Promise.resolve(_temp && _temp.then ? _temp.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var closeSuccess = function closeSuccess(val) {
    setShowSuccess(!val);
  };
  var closeFailure = function closeFailure(val) {
    setShowFailure(!val);
  };
  var handleClick = function handleClick(e) {
    e.preventDefault();
    handleIssueSelector(2);
  };
  var _ref2 = configDetails || {},
    _ref2$paramsDetails = _ref2.paramsDetails,
    _ref2$paramsDetails2 = _ref2$paramsDetails === void 0 ? {} : _ref2$paramsDetails,
    _ref2$paramsDetails2$ = _ref2$paramsDetails2.theme,
    _ref2$paramsDetails2$2 = _ref2$paramsDetails2$ === void 0 ? {} : _ref2$paramsDetails2$,
    _ref2$paramsDetails2$3 = _ref2$paramsDetails2$2.isDark,
    isDark = _ref2$paramsDetails2$3 === void 0 ? false : _ref2$paramsDetails2$3;
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ContentWrapper$i, {
    isDarkTheme: isDark == true,
    isACSS: isACSS
  }, showSuccess && /*#__PURE__*/React__default.createElement(FeedbackMessage, {
    "data-testid": "success-feedback-bar",
    values: showSuccess,
    closeFeedbackBar: closeSuccess
  }), showFailure && /*#__PURE__*/React__default.createElement(FeedbackBarError, {
    "data-testid": "error-feedback-bar",
    values: showFailure,
    closeFeedbackBar: closeFailure
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: errorContent1 === null || errorContent1 === void 0 ? void 0 : errorContent1.description
    }
  })), /*#__PURE__*/React__default.createElement(IssueHistoryWrapper, null, /*#__PURE__*/React__default.createElement(TextLinkCaret, {
    id: "resume_cta",
    surface: isDark == true ? "dark" : "light",
    disabled: false,
    iconPosition: "right",
    onClick: function onClick(e) {
      handleClick(e);
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: errorContent2 === null || errorContent2 === void 0 ? void 0 : errorContent2.description
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginBottom: 30
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: errorContent3 === null || errorContent3 === void 0 ? void 0 : errorContent3.description
    }
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: errorContent4 === null || errorContent4 === void 0 ? void 0 : errorContent4.description
    }
  }), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "10px"
  }), /*#__PURE__*/React__default.createElement(TextAreaConatiner, null, /*#__PURE__*/React__default.createElement(TextArea$1, {
    surface: isDark == true ? "dark" : "light",
    disabled: alreadySent,
    required: false,
    value: feedbackMsg,
    onChange: function onChange(event) {
      return handleChange(event);
    },
    helperText: "This information will only be used by Verizon and will not be shared with third parties.",
    helperTextPlacement: "bottom",
    placeholder: "Type here...",
    maxLength: 500,
    "data-testid": "textAraInfo"
  })), /*#__PURE__*/React__default.createElement(SpacerDiv, {
    height: "20px"
  }), /*#__PURE__*/React__default.createElement(ButtonsWrapper$8, {
    isDarkTheme: isDark == true,
    isACSS: isACSS
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    "data-testid": "submitBtn",
    onClick: submitFeedback,
    disabled: !btnShow,
    size: "small",
    use: "primary",
    surface: isDark == true ? 'dark' : 'light',
    "data-track": "{\"type\": \"link\", \"name\": \"Submit\"}",
    role: "button",
    tabIndex: "0"
  }, "Submit")))));
};

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  function ErrorBoundary(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      hasError: false,
      response: []
    };
    return _this;
  }
  _inheritsLoose(ErrorBoundary, _React$Component);
  var _proto = ErrorBoundary.prototype;
  _proto.componentDidMount = function componentDidMount() {};
  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.props.errorcode !== "0" && this.props.errorcode !== "00") {
      this.setState({
        response: response
      });
    }
  };
  _proto.componentDidCatch = function componentDidCatch(error, info) {
    try {
      if (!this.props.hideError) {
        this.setState({
          hasError: true
        });
        window.vzdl.error = window.vzdl.error || {};
        window.vzdl.error.code = window.vzdl.error.code || {};
        window.vzdl.error.code = "Sorry, due to a technical issue your troubleshooting request could not be completed. Please close this window and resume troubleshooting from the issue history tab.";
      }
      console.error(error, info);
    } catch (error) {
      console.error(error);
    }
  };
  _proto.render = function render() {
    if (this.state.hasError) {
      var _JSON$parse;
      try {
        var spinnerEle = document.getElementById("spinner");
        if (spinnerEle) {
          document.getElementById("spinner").style.display = "none";
        }
      } catch (error) {
        console.error(error);
      }
      if (this.props.jsx) {
        return this.props.jsx;
      }
      var newErrorScreen = (_JSON$parse = JSON.parse(sessionStorage.getItem('mvoConfig'))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.isNewErrorScreenEnable;
      return /*#__PURE__*/React__default.createElement("div", null, window.isMVODigital ? /*#__PURE__*/React__default.createElement(ErrorBoundaryUiDigital, null) : newErrorScreen ? /*#__PURE__*/React__default.createElement(ErrorScreenAcss, {
        handleIssueSelector: this.props.handleIssueSelector
      }) : null);
    }
    return this.props.children;
  };
  return ErrorBoundary;
}(React__default.Component);

var NewUILoggerMain = function NewUILoggerMain(_ref) {
  var pageDetails = _ref.pageDetails;
  return /*#__PURE__*/React__default.createElement("input", {
    type: "hidden",
    id: "pageDetails",
    value: JSON.stringify(pageDetails)
  });
};

var _this = undefined;
var newrelic$1 = window.newrelic || '';
window.onerror = function (message, source, lineno, colno, error) {
  console.log("message: source: lineno: colno: error " + message + ":" + source + ":" + lineno + ":" + colno + ":" + error);
  logJSError(error === null || error === void 0 ? void 0 : error.stack, message, 'GENERIC', source);
  logNewrelicNoticeError(error, 'GlobalError');
  return true;
};
var UiLoggerContext = createContext(null);
var App = function App(props) {
  var _useState = useState({
      brand: [],
      deviceType: [],
      Device: []
    }),
    deviceResponse = _useState[0];
  var _useState2 = useState(),
    additionalInfoSteps = _useState2[0],
    setAdditionalInfoSteps = _useState2[1];
  var _useState3 = useState(props.modalError),
    modalError = _useState3[0],
    setModalError = _useState3[1];
  var _useState4 = useState(false),
    spinner = _useState4[0],
    setSpinner = _useState4[1];
  var _useState5 = useState({}),
    forParamDetails = _useState5[0],
    setForParamDetails = _useState5[1];
  var _useState6 = useState({}),
    nsaIntentForMain = _useState6[0],
    setNsaIntentForMain = _useState6[1];
  var _useState7 = useState({
      App_id: 'AEM_ID_287238',
      version: 1,
      errorID: 'AEM_ID_126354',
      flowName: 'Troubleshooting',
      pageName: '',
      pageTitle: '',
      errorShown: '0',
      userViewedMessage: '',
      messageStyle: 'Page'
    }),
    pageDetails = _useState7[0],
    _setPageDetails = _useState7[1];
  var configDetails = {};
  configDetails.config = sessionUtility.getMvoConfig();
  console.log('info configDetails app', configDetails);
  useEffect(function () {
    if (window && window.isMVODigital) {
      var _window, _window$vzwDL, _window$vzwDL$page;
      var loginStatus = window.isLoggedOut ? 'unauthenticated' : 'authenticated';
      var channel = sessionUtility.getMvoConfig();
      var _ref = window.caseDetails || {},
        caseId = _ref.caseId;
      if (!caseId) {
        caseId = sessionUtility.getCaseDetails().caseId || '';
      }
      sessionStorage.setItem('sessionDetails', JSON.stringify({
        loginStatus: loginStatus,
        GLOBALID: '',
        caseId: caseId,
        soesessionId: ((_window = window) === null || _window === void 0 ? void 0 : (_window$vzwDL = _window.vzwDL) === null || _window$vzwDL === void 0 ? void 0 : (_window$vzwDL$page = _window$vzwDL.page) === null || _window$vzwDL$page === void 0 ? void 0 : _window$vzwDL$page.sessionId) || '',
        e2eRequestId: window.e2eRequestId || '',
        channelId: window._dg_channelId || ''
      }));
    }
  }, []);
  useEffect(function () {
    if (props !== null && props !== void 0 && props.additionalInfoSteps) {
      setAdditionalInfoSteps(props.additionalInfoSteps);
    }
    if (props !== null && props !== void 0 && props.paramsDetails) {
      setForParamDetails(props.paramsDetails);
    }
    if (props !== null && props !== void 0 && props.nsaIntent) {
      setNsaIntentForMain(props.nsaIntent);
    }
  }, [props]);
  var handleClick = function handleClick(e) {
    try {
      var interfaceName = e.target.tagName + '.' + e.target.className;
      var eventId = "MouseEvent." + e.type;
      var clickstream = '';
      if (e.target.dataset && e.target.dataset.clickstream) {
        clickstream = e.target.dataset.clickstream;
      } else if (e.target.parentNode && e.target.parentNode.dataset && e.target.parentNode.dataset.clickstream) {
        clickstream = e.target.parentNode.dataset.clickstream;
      } else if (e.target.offsetParent && e.target.offsetParent.dataset && e.target.offsetParent.dataset.clickstream) {
        clickstream = e.target.offsetParent.dataset.clickstream;
      } else if (e.target.nextSibling && e.target.nextSibling.dataset && e.target.nextSibling.dataset.clickstream) {
        clickstream = e.target.nextSibling.dataset.clickstream;
      } else if (e.target.nextSibling && e.target.nextSibling.nextSibling && e.target.nextSibling.nextSibling.dataset && e.target.nextSibling.nextSibling.dataset.clickstream) {
        clickstream = e.target.nextSibling.nextSibling.dataset.clickstream;
      }
      console.log('handling global click events', clickstream);
      if (e.target.textContent && e.target.textContent.toLowerCase() === 'sign out') {
        console.log('SIGN OUT: CLEAR SESSION---');
        sessionStorage.clear();
      }
      if (clickstream && clickstream !== '') {
        console.log('button click clickstream::');
        logClickStream(interfaceName, eventId, clickstream);
      }
    } catch (error) {
      console.error(error);
    }
  };
  var _useState8 = useState(false),
    isOpen = _useState8[0],
    modalToggle = _useState8[1];
  var modalOpen = function modalOpen() {
    console.log('modalOpen');
    modalToggle(true);
    setSpinner(true);
  };
  var modalClose = function modalClose() {
    modalToggle(false);
  };
  var handleError = function handleError(e) {
    try {
      var message = e.message,
        filename = e.filename,
        error = e.error;
      var errorStack = error && error.stack ? error.stack : '';
      _this.setState({
        error: true
      });
      logJSError(errorStack, message, 'GENERIC', filename);
    } catch (ex) {
      console.log('ex:' + ex);
    }
  };
  useEffect(function () {
    var current = true;
    var initialize = function initialize() {
      var _configDetails$config, _configDetails$config2, _configDetails$config3;
      var isNrb = window.location.hash.includes('nrb');
      var isLVFlow = window.location.hash.includes('getcase');
      if (configDetails.config && (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$config = configDetails.config) === null || _configDetails$config === void 0 ? void 0 : _configDetails$config.redirectToNSA) != '') {
        externalNavRedirect().then(function (res) {
          var navigateUrl = res.navigateUrl;
          if (navigateUrl && navigateUrl !== '') {
            redirectWithPostData(navigateUrl, configDetails.config.caseDetails);
          }
        })["catch"](function (err) {
          console.log(err + 'error in redirection');
        });
      }
      console.log('configDetails.config?.isNewTemplate', (_configDetails$config2 = configDetails.config) === null || _configDetails$config2 === void 0 ? void 0 : _configDetails$config2.isNewTemplate);
      if ((_configDetails$config3 = configDetails.config) !== null && _configDetails$config3 !== void 0 && _configDetails$config3.troubleShootingJson && !configDetails.config.troubleShootingJson.ddata.device.is5GDevice) {
        setAdditionalInfoSteps(props.additionalInfoSteps);
        setModalError(props.modalError);
      }
      if (window && window.vzwDL && window.vzwDL.page) {
        var page = window.vzwDL.page;
        page['flowType'] = configDetails.config.troubleShootingJson && configDetails.config.troubleShootingJson.ddata && configDetails.config.troubleShootingJson.ddata.device && configDetails.config.troubleShootingJson.ddata.device.is5GDevice ? '5g troubleshooting assistant' : 'troubleshooting assistant';
        page['selfServiceType'] = configDetails.config.troubleShootingJson && configDetails.config.troubleShootingJson.ddata && configDetails.config.troubleShootingJson.ddata.device && configDetails.config.troubleShootingJson.ddata.device.is5GDevice ? '5g troubleshooting assistant' : 'troubleshooting assistant';
      }
      if (typeof newrelic$1 != 'undefined' && typeof newrelic$1.setCustomAttribute != 'undefined') {
        newrelic$1.setCustomAttribute('channelId', common.getChannelId());
        newrelic$1.setCustomAttribute('nsaSessionId', getAMId());
      }
      document.addEventListener('error', handleError);
      document.addEventListener('click', handleClick);
    };
    if (current) {
      initialize();
    }
    return function () {
      current = false;
    };
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "App"
  }, /*#__PURE__*/React__default.createElement(UiLoggerContext.Provider, {
    value: {
      setPageDetails: function setPageDetails(newData) {
        return _setPageDetails(_extends({}, pageDetails, newData));
      }
    }
  }, /*#__PURE__*/React__default.createElement(NewUILoggerMain, {
    pageDetails: pageDetails
  }), /*#__PURE__*/React__default.createElement(UserProvider, {
    value: {
      nsaIntentForMain: nsaIntentForMain,
      paramDetails: forParamDetails,
      isOpen: isOpen,
      modalClose: modalClose,
      modalOpen: modalOpen,
      deviceResponse: deviceResponse,
      additionalInfoSteps: additionalInfoSteps,
      modalError: modalError,
      spinner: spinner,
      setSpinner: setSpinner
    }
  }, /*#__PURE__*/React__default.createElement(ErrorBoundary, {
    errorcode: "00",
    handleIssueSelector: props.handleIssueSelector
  }, /*#__PURE__*/React__default.createElement(HashRouter, null, /*#__PURE__*/React__default.createElement(Switch, null, /*#__PURE__*/React__default.createElement(Route, {
    exact: true,
    path: "/nrb",
    component: Main
  }), /*#__PURE__*/React__default.createElement(Route, {
    exact: true,
    path: "/resume",
    component: Main
  }), /*#__PURE__*/React__default.createElement(Route, {
    exact: true,
    path: "/start",
    component: Main
  }), /*#__PURE__*/React__default.createElement(Route, {
    exact: true,
    path: "/eotsecure",
    component: Main
  }), /*#__PURE__*/React__default.createElement(Route, {
    exact: true,
    path: "/getcase",
    component: Main
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: "/start5g/:subsymptomid",
    component: Main
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: "/mtn/:routeMtnId",
    component: Main
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: "/mtnhash/:routeMtnHash",
    component: Main
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: "/nrb/:routeMtnHash/:param1?/:param2?",
    component: Main
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: "/test/:symptomId/:param1/:param2?",
    component: Main
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: "/preview",
    component: Main
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: "/",
    component: Main
  })))))));
};

window.$ = window.jQuery = $$1;
var NSATRG = function NSATRG(_ref) {
  var _useContext, _useContext2, _useContext3, _useContext4;
  var caseId = _ref.caseId,
    selectedNSAIntent = _ref.selectedNSAIntent,
    redirectToIssueSelecorTab = _ref.redirectToIssueSelecorTab,
    howToData = _ref.howToData,
    handleIssueSelector = _ref.handleIssueSelector;
  var paramsDetails = (_useContext = useContext(ParamsContext)) === null || _useContext === void 0 ? void 0 : _useContext.paramsDetails;
  var config = (_useContext2 = useContext(ParamsContext)) === null || _useContext2 === void 0 ? void 0 : _useContext2.configDetails;
  var additionalInfoSteps = (_useContext3 = useContext(ParamsContext)) === null || _useContext3 === void 0 ? void 0 : _useContext3.additionalInfoSteps;
  var modalError = (_useContext4 = useContext(ParamsContext)) === null || _useContext4 === void 0 ? void 0 : _useContext4.modalError;
  var _useState = useState({}),
    nsaIntent = _useState[0],
    setNsaIntent = _useState[1];
  console.log("info params", paramsDetails);
  sessionUtility.setExternalTarget(paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.externalTarget);
  sessionUtility.setRunMode(paramsDetails.mvoenv);
  sessionUtility.setUserId(paramsDetails.loggedInUser);
  useEffect(function () {
    if (selectedNSAIntent) {
      setNsaIntent(selectedNSAIntent);
    }
  }, [selectedNSAIntent]);
  var Provider = ConfigContext.Provider;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Provider, {
    value: {
      paramsDetails: paramsDetails,
      config: config,
      selectedNSAIntent: selectedNSAIntent,
      caseId: caseId,
      redirectToIssueSelecorTab: redirectToIssueSelecorTab,
      howToData: howToData
    }
  }, /*#__PURE__*/React__default.createElement(App, {
    additionalInfoSteps: additionalInfoSteps,
    modalError: modalError,
    paramsDetails: paramsDetails,
    nsaIntent: nsaIntent,
    handleIssueSelector: handleIssueSelector
  })));
};

var _templateObject$14, _templateObject2$S, _templateObject3$I, _templateObject4$H, _templateObject5$B, _templateObject6$v, _templateObject7$r, _templateObject8$p;
var SearchBarContainer = styled.div(_templateObject$14 || (_templateObject$14 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    max-width: 427px;\n    background-color: ", ";\n    color:", ";\n    position: relative;\n\n"])), function (props) {
  return props.isDark ? props === null || props === void 0 ? void 0 : props.darkBC : '#FFFFFF';
}, function (props) {
  return props.isDark ? '#FFFFFF' : '#000000';
});
var SearchInputContainer = styled.div(_templateObject2$S || (_templateObject2$S = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    display: flex;\n    align-items: center;\n    position: relative;\n    padding: 2px 15px;\n    border-radius: 4px;\n    border: 1px solid #8f8d8d;\n"])));
var SearchInput = styled.input(_templateObject3$I || (_templateObject3$I = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 40px;\n  outline: none;\n  border: none;\n  font-size: 16px;\n  color: ", ";\n  font-weight: 500;\n  border-radius: 6px;\n  background-color: transparent;\n  font-family: 'Verizon-NHG-eDS';\n  &:focus {\n    outline: none;\n    &::placeholder {\n      opacity: 0;\n    }\n  }\n  &&&:focus-visible{\n    border: none !important;\n  }\n  &::placeholder {\n    color: ", ";\n    transition: all 250ms ease-in-out;\n  }\n"])), function (props) {
  return props.isDark ? '#fff' : '#3D3D3D';
}, function (props) {
  return props.isDark ? '#fff' : '#3D3D3D';
});
var SearchIcon = styled.div(_templateObject4$H || (_templateObject4$H = _taggedTemplateLiteralLoose(["\n  vertical-align: middle;\n  transition: all 200ms ease-in-out;\n  cursor: pointer;\n  &:hover {\n    color: #dfdfdf;\n  }"])));
var ClearIcon = styled.div(_templateObject5$B || (_templateObject5$B = _taggedTemplateLiteralLoose(["\n  vertical-align: middle;\n  transition: all 200ms ease-in-out;\n  cursor: pointer;\n  &:hover {\n    color: #dfdfdf;\n  }"])));
var SearchContent = styled.div(_templateObject6$v || (_templateObject6$v = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    border: 1px solid #6F7171;\n    border-radius: 2px 2px 0 0;\n    margin-top: 1px;\n    box-sizing: border-box;\n    line-height: 20px;\n    overflow: auto;\n    position: absolute;\n    z-index: 9;\n    background: ", ";\n    top: 46px;\n    max-height: 266px;\n"])), function (props) {
  return props.isDark ? props.darkBC : '#ffffff';
});
var ListItem = styled.div(_templateObject7$r || (_templateObject7$r = _taggedTemplateLiteralLoose(["\npadding: 12px 16px;\ncursor: pointer;\n&:hover{\n    border-left: 2px solid #d52b1e;\n}\n"])));
var NoResultContainer = styled.div(_templateObject8$p || (_templateObject8$p = _taggedTemplateLiteralLoose(["\n    padding: 0.5em 0;\n"])));
function htmlDecode(input) {
  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}
var initialState$1 = {
  queryString: '',
  matchedResults: [],
  selectedValue: '',
  selectedDeviceObj: null,
  optionSelected: false,
  noResultsFound: false
};
var reducer$1 = function reducer(state, action) {
  var newState;
  switch (action.type) {
    case 'UPDATE_QUERY_STRING':
      newState = _extends({}, state, {
        queryString: htmlDecode(action.payload)
      });
      break;
    case 'UI_SEARCH':
      var matchedResults = action.payload.deviceJson.filter(function (ele) {
        return ele.deviceName.toLowerCase().includes(action.payload.queryString.toLowerCase());
      });
      newState = _extends({}, state, {
        matchedResults: matchedResults
      });
      break;
    case "CLEAR_RESULTS":
      newState = _extends({}, state, {
        matchedResults: []
      });
      break;
    case "CLEAR_QUERYSTRING":
      newState = _extends({}, state, {
        queryString: '',
        matchedResults: []
      });
      break;
    case "SET_SELECTED_VALUE":
      newState = _extends({}, state, {
        selectedValue: action.payload.deviceName,
        selectedDeviceObj: action.payload
      });
      break;
    case "CLEAR_SELECTED_DEVICE":
      newState = _extends({}, state, {
        selectedDeviceObj: {},
        selectedValue: ''
      });
      break;
    case "UPDATE_NO_RESULTS_FOUND":
      newState = _extends({}, state, {
        noResultsFound: action.payload
      });
      break;
    default:
      return state;
  }
  return newState;
};
var Searchbar = function Searchbar(props) {
  var _state$matchedResults3, _state$matchedResults4, _state$matchedResults5;
  var _props$deviceSelector = props.deviceSelectorJson,
    deviceSelectorJson = _props$deviceSelector === void 0 ? {} : _props$deviceSelector,
    setSelectedDevice = props.setSelectedDevice,
    clearSelection = props.clearSelection,
    noResultsFound = props.noResultsFound;
  var allDeviceList = deviceSelectorJson || [];
  var _useReducer = useReducer(reducer$1, initialState$1),
    state = _useReducer[0],
    dispatch = _useReducer[1];
  var _useState = useState(null),
    currentActiveSearchID = _useState[0],
    setCurrentActiveSearchId = _useState[1];
  var _ref = useFeatureFlag() || {},
    _ref$data = _ref.data,
    _ref$data2 = _ref$data === void 0 ? {} : _ref$data,
    _ref$data2$deviceSele = _ref$data2.deviceSelectorAccessibilityFFlag,
    deviceSelectorAccessibilityFFlag = _ref$data2$deviceSele === void 0 ? false : _ref$data2$deviceSele;
  var handleChange = function handleChange(e) {
    var value = e.target.value;
    dispatch({
      type: "UPDATE_QUERY_STRING",
      payload: value
    });
    if (!value) {
      dispatch({
        type: 'CLEAR_QUERYSTRING'
      });
      return;
    }
    dispatch({
      type: "UI_SEARCH",
      payload: {
        deviceJson: allDeviceList,
        queryString: value
      }
    });
  };
  var clearQueryString = function clearQueryString() {
    dispatch({
      type: 'CLEAR_QUERYSTRING'
    });
    dispatch({
      type: 'CLEAR_SELECTED_DEVICE'
    });
    setSelectedDevice({});
  };
  var handleSelect = function handleSelect(device) {
    dispatch({
      type: 'SET_SELECTED_VALUE',
      payload: device
    });
    dispatch({
      type: 'UPDATE_QUERY_STRING',
      payload: device.deviceName
    });
    dispatch({
      type: "CLEAR_RESULTS"
    });
    setSelectedDevice(device);
  };
  useEffect(function () {
    clearQueryString();
  }, [clearSelection]);
  useEffect(function () {
    if (state.matchedResults.length == 0 && state.queryString && !state.selectedValue) {
      dispatch({
        type: 'UPDATE_NO_RESULTS_FOUND',
        payload: true
      });
    } else if (state.noResultsFound === true) {
      dispatch({
        type: 'UPDATE_NO_RESULTS_FOUND',
        payload: false
      });
    }
  }, [state.queryString]);
  useEffect(function () {
    noResultsFound(state.noResultsFound);
  }, [state.noResultsFound]);
  console.log("Reducer State-->", state);
  var handleSearchKeyUp = function handleSearchKeyUp() {
    var _state$matchedResults;
    var totaltSearchResult = ((_state$matchedResults = state.matchedResults) === null || _state$matchedResults === void 0 ? void 0 : _state$matchedResults.length) - 1;
    var currentSearchId = currentActiveSearchID;
    if (currentSearchId === null || currentSearchId === 0) {
      currentSearchId = totaltSearchResult;
    } else {
      currentSearchId = currentSearchId - 1;
    }
    setCurrentActiveSearchId(currentSearchId);
  };
  var handleSearchKeyDown = function handleSearchKeyDown() {
    var _state$matchedResults2;
    var totaltSearchResult = ((_state$matchedResults2 = state.matchedResults) === null || _state$matchedResults2 === void 0 ? void 0 : _state$matchedResults2.length) - 1;
    var currentSearchId = currentActiveSearchID;
    if (currentSearchId === null || totaltSearchResult === currentSearchId) {
      currentSearchId = 0;
    } else {
      currentSearchId = currentSearchId + 1;
    }
    setCurrentActiveSearchId(currentSearchId);
  };
  var focusSearchInputBox = function focusSearchInputBox(e) {
    var _document$getElementB;
    var key = e.key;
    switch (key) {
      case 'Esc':
      case 'Escape':
        clearQueryString();
        break;
      case 'Up':
      case 'ArrowUp':
        handleSearchKeyUp();
        break;
      case 'ArrowDown':
      case 'Down':
        handleSearchKeyDown();
        break;
      case 'Enter':
        (_document$getElementB = document.getElementById('searchBoxCurrentID' + currentActiveSearchID)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.click();
        break;
    }
  };
  return /*#__PURE__*/React__default.createElement(SearchBarContainer, {
    isDark: props === null || props === void 0 ? void 0 : props.isDark,
    darkBC: props === null || props === void 0 ? void 0 : props.darkBC
  }, /*#__PURE__*/React__default.createElement(SearchInputContainer, null, deviceSelectorAccessibilityFFlag ? /*#__PURE__*/React__default.createElement(SearchInput, {
    placeholder: "Search Devices",
    value: state.queryString,
    onChange: handleChange,
    isDark: props.isDark,
    "aria-expanded": ((_state$matchedResults3 = state.matchedResults) === null || _state$matchedResults3 === void 0 ? void 0 : _state$matchedResults3.length) > 0 ? "true" : "false",
    role: "combobox",
    autoComplete: "off",
    "aria-activedescendant": currentActiveSearchID !== null ? "searchBoxCurrentID" + currentActiveSearchID : "",
    "aria-owns": "searchDropDownList",
    "aria-controls": "searchDropDownList",
    "aria-haspopup": "listbox",
    "data-track": "{\"type\": \"link\", \"name\": \"Search devices\"}",
    tabIndex: "0",
    "aria-label": "Search Devices",
    onKeyDown: focusSearchInputBox
  }) : /*#__PURE__*/React__default.createElement(SearchInput, {
    placeholder: "Search Devices",
    value: state.queryString,
    onChange: handleChange,
    isDark: props.isDark
  }), !state.queryString ? /*#__PURE__*/React__default.createElement(SearchIcon, null, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "search",
    size: "small",
    color: props.isDark ? "#ffffff" : "#000000",
    ariaHidden: true
  })) : /*#__PURE__*/React__default.createElement(ClearIcon, {
    onClick: clearQueryString
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "close-alt",
    size: "small",
    color: props.isDark ? "#ffffff" : "#000000",
    ariaHidden: true
  }))), ((_state$matchedResults4 = state.matchedResults) === null || _state$matchedResults4 === void 0 ? void 0 : _state$matchedResults4.length) > 0 && /*#__PURE__*/React__default.createElement(SearchContent, {
    tabindex: "-1",
    id: "searchDropDownList",
    isDark: props === null || props === void 0 ? void 0 : props.isDark,
    darkBC: props === null || props === void 0 ? void 0 : props.darkBC,
    role: "listbox"
  }, (_state$matchedResults5 = state.matchedResults) === null || _state$matchedResults5 === void 0 ? void 0 : _state$matchedResults5.map(function (res, ind) {
    return /*#__PURE__*/React__default.createElement(ListItem, {
      tabindex: "-1",
      role: "option",
      id: "searchBoxCurrentID" + ind,
      key: res.deviceName + '_' + ind,
      onClick: function onClick() {
        return handleSelect(res);
      },
      value: res.deviceName
    }, htmlDecode(res.deviceName));
  })), state.noResultsFound && /*#__PURE__*/React__default.createElement(NoResultContainer, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "large",
    color: props.isDark ? "#ffffff" : "#000000",
    bold: false
  }, "No results found.")));
};

var _templateObject$15, _templateObject2$T, _templateObject3$J, _templateObject4$I, _templateObject5$C;
var CardContainer = styled.div(_templateObject$15 || (_templateObject$15 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    background: ", ";\n    box-shadow: 0 0 0 0.5px #d8dada;\n    border: 0.5px solid #d8dada;\n    border-radius: 8px;\n    width: 200px;\n    padding: 1em;\n    flex-basis: 32%;\n    cursor: pointer;\n    position: relative;\n"])), function (props) {
  return props.isDark ? props.darkBC : '#FFFFFF';
});
var ImageContainer$5 = styled.div(_templateObject2$T || (_templateObject2$T = _taggedTemplateLiteralLoose(["\n    height: 100px;\n    text-align: center;\n    margin-bottom: 0.5em\n"])));
var Image$1 = styled.img(_templateObject3$J || (_templateObject3$J = _taggedTemplateLiteralLoose(["\n    padding: 0.5em;\n    object-fit: cover;\n    height: 100px;\n"])));
var TextContainer = styled.div(_templateObject4$I || (_templateObject4$I = _taggedTemplateLiteralLoose(["\n    padding-bottom: 34px;\n"])));
var CaretContainer = styled.div(_templateObject5$C || (_templateObject5$C = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    display: flex;\n    flex-direction: row-reverse;\n    bottom: 16px;\n    right: 16px;\n"])));
function htmlDecode$1(input) {
  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}
var Card = function Card(props) {
  var _paramsDetails$theme;
  var _props$deviceObject = props.deviceObject,
    _props$deviceObject$d = _props$deviceObject.deviceMainImg,
    deviceMainImg = _props$deviceObject$d === void 0 ? '' : _props$deviceObject$d,
    _props$deviceObject$d2 = _props$deviceObject.deviceName,
    deviceName = _props$deviceObject$d2 === void 0 ? '' : _props$deviceObject$d2;
  var _props$isDark = props.isDark,
    isDark = _props$isDark === void 0 ? false : _props$isDark;
  var _ref = useContext(ParamsContext) || {},
    _ref$paramsDetails = _ref.paramsDetails,
    paramsDetails = _ref$paramsDetails === void 0 ? {} : _ref$paramsDetails;
  var darkBC = paramsDetails === null || paramsDetails === void 0 ? void 0 : (_paramsDetails$theme = paramsDetails.theme) === null || _paramsDetails$theme === void 0 ? void 0 : _paramsDetails$theme.themeObject.background;
  var handleUpdateDevice = function handleUpdateDevice() {
    var _props$deviceObject2 = props.deviceObject,
      _props$deviceObject2$ = _props$deviceObject2.deviceId,
      deviceId = _props$deviceObject2$ === void 0 ? '' : _props$deviceObject2$,
      _props$deviceObject2$2 = _props$deviceObject2.deviceName,
      deviceName = _props$deviceObject2$2 === void 0 ? '' : _props$deviceObject2$2,
      _props$deviceObject2$3 = _props$deviceObject2.deviceType,
      deviceType = _props$deviceObject2$3 === void 0 ? '' : _props$deviceObject2$3,
      _props$deviceObject2$4 = _props$deviceObject2.deviceBrand,
      deviceBrand = _props$deviceObject2$4 === void 0 ? '' : _props$deviceObject2$4,
      _props$deviceObject2$5 = _props$deviceObject2.deviceSku,
      deviceSku = _props$deviceObject2$5 === void 0 ? '' : _props$deviceObject2$5,
      _props$deviceObject2$6 = _props$deviceObject2.deviceOs,
      deviceOs = _props$deviceObject2$6 === void 0 ? '' : _props$deviceObject2$6,
      _props$deviceObject2$7 = _props$deviceObject2.deviceMainImg,
      deviceMainImg = _props$deviceObject2$7 === void 0 ? '' : _props$deviceObject2$7,
      _props$deviceObject2$8 = _props$deviceObject2.deviceThumbImg,
      deviceThumbImg = _props$deviceObject2$8 === void 0 ? '' : _props$deviceObject2$8;
    var acssPaylod = {
      deviceBrand: deviceBrand,
      deviceId: deviceId,
      deviceName: deviceName,
      deviceOs: deviceOs,
      deviceSku: deviceSku,
      deviceType: deviceType,
      deviceMainImg: deviceMainImg,
      deviceThumbImg: deviceThumbImg,
      isDeviceDetailsFromDeviceSelector: true
    };
    console.log("Device tile update info", acssPaylod);
    var updateDeviceTileDetails = paramsDetails.updateDeviceTileDetails;
    if (updateDeviceTileDetails && typeof updateDeviceTileDetails === 'function') {
      updateDeviceTileDetails(acssPaylod);
      console.log("updateDeviceTileDetails Invoked");
      return;
    }
    console.log("updateDeviceTileDetails not present in props");
  };
  return /*#__PURE__*/React__default.createElement(CardContainer, {
    onClick: handleUpdateDevice,
    onKeyDown: function onKeyDown(e) {
      return e.key === 'Enter' || e.key === 'Space' ? handleUpdateDevice() : '';
    },
    tabIndex: "0",
    role: "button",
    isDark: isDark,
    darkBC: darkBC
  }, /*#__PURE__*/React__default.createElement(ImageContainer$5, null, /*#__PURE__*/React__default.createElement(Image$1, {
    variant: "top",
    src: deviceMainImg
  })), /*#__PURE__*/React__default.createElement(TextContainer, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "large",
    color: isDark ? "#ffffff" : "#000000",
    bold: true
  }, htmlDecode$1(deviceName))), /*#__PURE__*/React__default.createElement(CaretContainer, null, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "right-arrow",
    size: "medium",
    color: isDark ? "#ffffff" : "#000000",
    inverted: isDark === true,
    role: "button",
    ariaHidden: "true"
  })));
};

var _templateObject$16, _templateObject2$U, _templateObject3$K, _templateObject4$J, _templateObject5$D, _templateObject6$w, _templateObject7$s, _templateObject8$q;
var MobileTabMain = styled.div(_templateObject$16 || (_templateObject$16 = _taggedTemplateLiteralLoose(["\n  \n"])));
var FilterContainer = styled.div(_templateObject2$U || (_templateObject2$U = _taggedTemplateLiteralLoose(["\n    display: flex;\n    padding-top: 16px;\n    margin-right: 20px;\n    justify-content: space-between;\n"])));
var FilterContainerHome = styled(FilterContainer)(_templateObject3$K || (_templateObject3$K = _taggedTemplateLiteralLoose(["\n    justify-content: unset;\n    column-gap: 15px\n"])));
var SelectContainerDefault = styled.div(_templateObject4$J || (_templateObject4$J = _taggedTemplateLiteralLoose(["\n    flex-basis: 31.5%;\n"])));
var SelectContainerDark = styled.div(_templateObject5$D || (_templateObject5$D = _taggedTemplateLiteralLoose(["\nflex-basis: 31.5%;\n    select {\n        border-color: #ffffff;\n        border-width: 0.625px 0;\n        border-style: solid;\n    }\n    select :hover{\n        border-width: 0.625px;\n    }\n"])));
var MobileTabBody = styled.div(_templateObject6$w || (_templateObject6$w = _taggedTemplateLiteralLoose(["\n    margin-top: 12px;\n    max-height: ", ";\n    overflow-y: scroll;\n"])), function (props) {
  return props.height ? props.height + "px" : "40vh";
});
var CardsContainer = styled.div(_templateObject7$s || (_templateObject7$s = _taggedTemplateLiteralLoose(["\n    display: flex;\n    row-gap: 12px;\n    justify-content: space-between;\n    padding: 0.5em 0 1em;\n    flex-wrap: wrap;\n    overflow-y: scroll;   \n"])));
var ButtonWrapper$g = styled.div(_templateObject8$q || (_templateObject8$q = _taggedTemplateLiteralLoose(["\n margin-bottom: 2rem;\n button * {\n    background-color: transparent;\n}\n"])));
var filterHelper = function filterHelper(filterString, filterCriteria, arr) {
  if (!filterString) return arr;
  return arr.filter(function (device) {
    if (filterCriteria === 'brand' && device.deviceBrand === filterString) {
      return true;
    }
    if (filterCriteria === 'deviceType' && device.deviceType === filterString) {
      return true;
    }
    if (filterCriteria === 'deviceOs' && device.deviceOs === filterString) {
      return true;
    }
    return false;
  });
};
var getOffset = function getOffset(el) {
  var rect = el.getBoundingClientRect();
  return {
    bottom: rect.bottom + window.scrollY
  };
};
var filterEmpty = function filterEmpty(arr) {
  if (!arr) return [];
  arr = arr.filter(function (e) {
    return e && e.trim();
  });
  arr.unshift("Select");
  return arr;
};
function htmlDecode$2(input) {
  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}
var MobileTabComponent = function MobileTabComponent(_ref) {
  var deviceJson = _ref.deviceJson,
    forwardDevices = _ref.forwardDevices,
    selectedDevice = _ref.selectedDevice,
    tabName = _ref.tabName,
    isLoading = _ref.isLoading,
    isDark = _ref.isDark;
  var deviceList = deviceJson.device || [];
  var deviceTypeList = filterEmpty(deviceJson.deviceType);
  var deviceBrandList = filterEmpty(deviceJson.brand);
  var deviceOsList = filterEmpty(deviceJson.deviceOs);
  var _useState = useState(''),
    deviceType = _useState[0],
    setDeviceType = _useState[1];
  var _useState2 = useState(''),
    deviceBrand = _useState2[0],
    setDeviceBrand = _useState2[1];
  var _useState3 = useState(''),
    deviceOs = _useState3[0],
    setDeviceOs = _useState3[1];
  var _useState4 = useState(deviceList),
    filteredDevice = _useState4[0],
    setFilteredDevice = _useState4[1];
  var _useState5 = useState(deviceList.slice(0, 6)),
    devicesToRender = _useState5[0],
    setDevicesToRender = _useState5[1];
  var _useState6 = useState(deviceList.length > 6),
    showMoreCta = _useState6[0],
    setShowMoreCta = _useState6[1];
  var showMoreRef = useRef(null);
  var _ref2 = useFeatureFlag() || {},
    _ref2$data = _ref2.data,
    _ref2$data2 = _ref2$data === void 0 ? {} : _ref2$data,
    _ref2$data2$deviceSel = _ref2$data2.deviceSelectorAccessibilityFFlag,
    deviceSelectorAccessibilityFFlag = _ref2$data2$deviceSel === void 0 ? false : _ref2$data2$deviceSel;
  useEffect(function () {
    console.log("devicejson changed", deviceJson);
    var _deviceJson$device = deviceJson.device,
      device = _deviceJson$device === void 0 ? [] : _deviceJson$device;
    setFilteredDevice(device);
    setDevicesToRender(device.slice(0, 6));
    setShowMoreCta(device.length > 6);
  }, [deviceJson]);
  useEffect(function () {
    if (tabName) {
      setDeviceType('');
      setDeviceBrand('');
      setDeviceOs('');
    }
  }, [tabName]);
  var deviceFilter = function deviceFilter(deviceType, brand, deviceOs, deviceList) {
    var filteredDeviceType = filterHelper(deviceType, "deviceType", deviceList);
    var filteredBrand = filterHelper(brand, "brand", filteredDeviceType);
    return filterHelper(deviceOs, "deviceOs", filteredBrand);
  };
  var changeHandlerSelect = function changeHandlerSelect(e) {
    var _e$target = e.target,
      name = _e$target.name,
      value = _e$target.value;
    if (name === 'deviceType') setDeviceType(value);
    if (name === 'deviceBrand') setDeviceBrand(value);
    if (name === 'deviceOs') setDeviceOs(value);
  };
  useEffect(function () {
    console.log("filter query", deviceType, deviceBrand, deviceOs);
    var filteredArr = deviceFilter(deviceType, deviceBrand, deviceOs, deviceList);
    setFilteredDevice(filteredArr);
    setDevicesToRender(filteredArr.slice(0, 6));
  }, [deviceType, deviceBrand, deviceOs]);
  useEffect(function () {
    setShowMoreCta(filteredDevice.length > 6);
  }, [filteredDevice.length]);
  useEffect(function () {
    forwardDevices(filteredDevice);
  }, [filteredDevice]);
  useEffect(function () {
    if (selectedDevice.deviceId) {
      setDevicesToRender([selectedDevice]);
      setShowMoreCta(false);
    } else {
      setDevicesToRender(filteredDevice.slice(0, 6));
      setShowMoreCta(filteredDevice.length > 6);
    }
  }, [selectedDevice]);
  var handleShowMore = function handleShowMore() {
    setDevicesToRender(filteredDevice);
    setShowMoreCta(false);
    console.log("showMoreRef.current", showMoreRef.current);
    setTimeout(function () {
      if (deviceSelectorAccessibilityFFlag && showMoreRef.current) {
        showMoreRef.current.focus();
      }
    }, 0);
  };
  var getRelativeHeight = function getRelativeHeight() {
    var el = document.getElementById("filter_section");
    var height = null;
    if (el) {
      height = document.documentElement.scrollHeight - getOffset(el).bottom - 94;
      console.log("documentH: BoundingH: netH", document.documentElement.scrollHeight, getOffset(el).bottom, height);
    }
    return height;
  };
  var SelectContainer = isDark ? SelectContainerDark : SelectContainerDefault;
  var FilterWrapper = tabName === "mobile" ? FilterContainer : FilterContainerHome;
  return /*#__PURE__*/React__default.createElement(MobileTabMain, {
    "data-testid": "mobile-tab-main"
  }, isLoading && /*#__PURE__*/React__default.createElement(Loader$2, {
    active: true,
    fullscreen: false
  }), /*#__PURE__*/React__default.createElement(FilterWrapper, {
    id: "filter_section"
  }, /*#__PURE__*/React__default.createElement(SelectContainer, null, /*#__PURE__*/React__default.createElement(DropdownSelect, {
    label: "Device type",
    name: "deviceType",
    ariaLabel: "Device type",
    onChange: changeHandlerSelect,
    surface: isDark ? "dark" : "light"
  }, deviceTypeList.map(function (device, index) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: device + "_" + index,
      value: device === "Select" ? '' : device
    }, device);
  }))), /*#__PURE__*/React__default.createElement(SelectContainer, null, /*#__PURE__*/React__default.createElement(DropdownSelect, {
    label: "Brand",
    name: "deviceBrand",
    ariaLabel: "Brand",
    onChange: changeHandlerSelect,
    surface: isDark ? "dark" : "light"
  }, deviceBrandList.map(function (device, index) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: device + "_" + index,
      value: device === "Select" ? '' : device
    }, htmlDecode$2(device));
  }))), tabName === "mobile" && /*#__PURE__*/React__default.createElement(SelectContainer, null, /*#__PURE__*/React__default.createElement(DropdownSelect, {
    label: "OS",
    name: "deviceOs",
    ariaLabel: "OS",
    onChange: changeHandlerSelect,
    surface: isDark ? "dark" : "light"
  }, deviceOsList.map(function (device, index) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: device + "_" + index,
      value: device === "Select" ? '' : device
    }, device);
  })))), deviceSelectorAccessibilityFFlag && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    style: {
      position: 'absolute',
      width: '1px',
      height: '1px',
      padding: 0,
      margin: '-1px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      border: 0
    },
    "aria-hidden": "false",
    "aria-live": "assertive",
    "aria-atomic": "true"
  }, devicesToRender === null || devicesToRender === void 0 ? void 0 : devicesToRender.length, " devices"), /*#__PURE__*/React__default.createElement("span", {
    ref: showMoreRef,
    tabIndex: "-1",
    style: {
      position: 'absolute',
      width: '1px',
      height: '1px',
      padding: 0,
      margin: '-1px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      border: 0
    },
    "aria-hidden": "false"
  })), /*#__PURE__*/React__default.createElement(MobileTabBody, {
    height: getRelativeHeight()
  }, /*#__PURE__*/React__default.createElement(CardsContainer, {
    "data-testid": "cards_parent"
  }, devicesToRender.map(function (card, ind) {
    return /*#__PURE__*/React__default.createElement(Card, {
      deviceObject: card,
      key: card.deviceId + ind,
      isDark: isDark
    });
  })), showMoreCta && /*#__PURE__*/React__default.createElement(ButtonWrapper$g, null, /*#__PURE__*/React__default.createElement(Button$1, {
    size: "small",
    surface: isDark ? "dark" : "light",
    disabled: false,
    use: "secondary",
    onClick: handleShowMore
  }, "Show more"))));
};

var _templateObject$17, _templateObject2$V, _templateObject3$L, _templateObject4$K, _templateObject5$E, _templateObject6$x, _templateObject7$t;
var MobileTabMain$1 = styled.div(_templateObject$17 || (_templateObject$17 = _taggedTemplateLiteralLoose(["\n  \n"])));
var FilterContainer$1 = styled.div(_templateObject2$V || (_templateObject2$V = _taggedTemplateLiteralLoose(["\n    display: flex;\n    gap: 12px;\n    padding-top: 16px;\n"])));
var SelectContainerDefault$1 = styled.div(_templateObject3$L || (_templateObject3$L = _taggedTemplateLiteralLoose(["\n    flex-basis: 30.9%;\n"])));
var SelectContainerDark$1 = styled.div(_templateObject4$K || (_templateObject4$K = _taggedTemplateLiteralLoose(["\nflex-basis: 31.5%;\n    select {\n        border-color: #ffffff;\n        border-width: 0.625px 0;\n        border-style: solid;\n    }\n    select :hover{\n        border-width: 0.625px;\n    }\n"])));
var MobileTabBody$1 = styled.div(_templateObject5$E || (_templateObject5$E = _taggedTemplateLiteralLoose(["\n    margin-top: 12px;\n    min-height: 377px;\n    max-height: 60vh;\n    overflow-y: auto;\n"])));
var CardsContainer$1 = styled.div(_templateObject6$x || (_templateObject6$x = _taggedTemplateLiteralLoose(["\n    display: flex;\n    gap: 12px;\n    padding: 0.5em 0 1em;\n    flex-wrap: wrap;\n    overflow-y: auto;\n"])));
var ButtonWrapper$h = styled.div(_templateObject7$t || (_templateObject7$t = _taggedTemplateLiteralLoose(["\n margin-bottom: 2rem;\n padding-left: 2px;\n button {\n    color: unset !important;\n    background-color: unset !important;\n    box-shadow: rgb(0, 0, 0) 0px 0px 0px 0.0625rem !important;\n }\n"])));
var filterHelper$1 = function filterHelper(filterString, filterCriteria, arr) {
  if (filterString === void 0) {
    filterString = '';
  }
  if (filterCriteria === void 0) {
    filterCriteria = '';
  }
  if (arr === void 0) {
    arr = [];
  }
  if (!filterString) return arr;
  return arr.filter(function (device) {
    if (filterCriteria === 'brand' && device.deviceBrand === filterString) {
      return true;
    }
    if (filterCriteria === 'deviceType' && device.deviceType === filterString) {
      return true;
    }
    if (filterCriteria === 'deviceOs' && device.deviceOs === filterString) {
      return true;
    }
    return false;
  });
};
var filterEmpty$1 = function filterEmpty(arr) {
  if (!arr) return [];
  return arr.filter(function (e) {
    return e && e.trim();
  });
};
function htmlDecode$3(input) {
  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}
var MobileTabRetail = function MobileTabRetail(_ref) {
  var deviceJson = _ref.deviceJson,
    forwardDevices = _ref.forwardDevices,
    selectedDevice = _ref.selectedDevice,
    tabName = _ref.tabName,
    isLoading = _ref.isLoading,
    isDark = _ref.isDark;
  var deviceList = deviceJson.device || [];
  var deviceTypeList = filterEmpty$1(deviceJson.deviceType);
  var deviceBrandList = filterEmpty$1(deviceJson.brand);
  var deviceOsList = filterEmpty$1(deviceJson.deviceOs);
  var _useState = useState(''),
    deviceType = _useState[0],
    setDeviceType = _useState[1];
  var _useState2 = useState(''),
    deviceBrand = _useState2[0],
    setDeviceBrand = _useState2[1];
  var _useState3 = useState(''),
    deviceOs = _useState3[0],
    setDeviceOs = _useState3[1];
  var _useState4 = useState(deviceList),
    filteredDevice = _useState4[0],
    setFilteredDevice = _useState4[1];
  var _useState5 = useState(deviceList.slice(0, 6)),
    devicesToRender = _useState5[0],
    setDevicesToRender = _useState5[1];
  var _useState6 = useState(deviceList.length > 6),
    showMoreCta = _useState6[0],
    setShowMoreCta = _useState6[1];
  useEffect(function () {
    console.log("devicejson changed", deviceJson);
    var _deviceJson$device = deviceJson.device,
      device = _deviceJson$device === void 0 ? [] : _deviceJson$device;
    setFilteredDevice(device);
    setDevicesToRender(device.slice(0, 6));
    setShowMoreCta(device.length > 6);
  }, [deviceJson]);
  useEffect(function () {
    if (tabName) {
      setDeviceType('');
      setDeviceBrand('');
      setDeviceOs('');
    }
  }, [tabName]);
  var deviceFilter = function deviceFilter(deviceType, brand, deviceOs, deviceList) {
    if (deviceType === void 0) {
      deviceType = '';
    }
    if (brand === void 0) {
      brand = '';
    }
    if (deviceOs === void 0) {
      deviceOs = '';
    }
    if (deviceList === void 0) {
      deviceList = [];
    }
    var filteredDeviceType = filterHelper$1(deviceType, "deviceType", deviceList);
    var filteredBrand = filterHelper$1(brand, "brand", filteredDeviceType);
    return filterHelper$1(deviceOs, "deviceOs", filteredBrand);
  };
  var changeHandlerSelect = function changeHandlerSelect(e) {
    var _e$target = e.target,
      name = _e$target.name,
      value = _e$target.value;
    if (name === 'deviceType') setDeviceType(value);
    if (name === 'deviceBrand') setDeviceBrand(value);
    if (name === 'deviceOs') setDeviceOs(value);
  };
  useEffect(function () {
    console.log("filter query", deviceType, deviceBrand, deviceOs);
    var filteredArr = deviceFilter(deviceType, deviceBrand, deviceOs, deviceList);
    setFilteredDevice(filteredArr);
    setDevicesToRender(filteredArr.slice(0, 6));
  }, [deviceType, deviceBrand, deviceOs]);
  useEffect(function () {
    setShowMoreCta(filteredDevice.length > 6);
  }, [filteredDevice.length]);
  useEffect(function () {
    forwardDevices(filteredDevice);
  }, [filteredDevice]);
  useEffect(function () {
    if (selectedDevice.deviceId) {
      setDevicesToRender([selectedDevice]);
      setShowMoreCta(false);
    } else {
      setDevicesToRender(filteredDevice.slice(0, 6));
      setShowMoreCta(filteredDevice.length > 6);
    }
  }, [selectedDevice]);
  var handleShowMore = function handleShowMore() {
    setDevicesToRender(filteredDevice);
    setShowMoreCta(false);
  };
  var SelectContainer = isDark ? SelectContainerDark$1 : SelectContainerDefault$1;
  return /*#__PURE__*/React__default.createElement(MobileTabMain$1, {
    "data-testid": "mobile-tab-main"
  }, isLoading && /*#__PURE__*/React__default.createElement(Loader$2, {
    active: true,
    fullscreen: false
  }), /*#__PURE__*/React__default.createElement(FilterContainer$1, {
    id: "filter_section"
  }, /*#__PURE__*/React__default.createElement(SelectContainer, null, /*#__PURE__*/React__default.createElement(DropdownSelect, {
    label: "Device type",
    name: "deviceType",
    onChange: changeHandlerSelect,
    surface: isDark ? "dark" : "light"
  }, /*#__PURE__*/React__default.createElement("option", {
    value: ""
  }, "Select"), deviceTypeList.map(function (device, index) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: device + "_" + index,
      value: device
    }, device);
  }))), /*#__PURE__*/React__default.createElement(SelectContainer, null, /*#__PURE__*/React__default.createElement(DropdownSelect, {
    label: "Brand",
    name: "deviceBrand",
    onChange: changeHandlerSelect,
    surface: isDark ? "dark" : "light"
  }, /*#__PURE__*/React__default.createElement("option", {
    value: ""
  }, "Select"), deviceBrandList.map(function (device, index) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: device + "_" + index,
      value: device
    }, htmlDecode$3(device));
  }))), tabName === "mobile" && /*#__PURE__*/React__default.createElement(SelectContainer, null, /*#__PURE__*/React__default.createElement(DropdownSelect, {
    label: "OS",
    name: "deviceOs",
    onChange: changeHandlerSelect,
    surface: isDark ? "dark" : "light"
  }, /*#__PURE__*/React__default.createElement("option", {
    value: ""
  }, "Select"), deviceOsList.map(function (device, index) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: device + "_" + index,
      value: device
    }, device);
  })))), /*#__PURE__*/React__default.createElement(MobileTabBody$1, null, /*#__PURE__*/React__default.createElement(CardsContainer$1, {
    "data-testid": "cards_parent"
  }, devicesToRender.map(function (card, ind) {
    return /*#__PURE__*/React__default.createElement(Card, {
      deviceObject: card,
      key: card.deviceId + ind,
      isDark: isDark
    });
  })), showMoreCta && /*#__PURE__*/React__default.createElement(ButtonWrapper$h, null, /*#__PURE__*/React__default.createElement(Button$1, {
    size: "small",
    surface: isDark ? "dark" : "light",
    disabled: false,
    use: "secondary",
    onClick: handleShowMore
  }, "Show more"))));
};

var _templateObject$18, _templateObject2$W, _templateObject3$M, _templateObject4$L, _templateObject5$F, _templateObject6$y;
var DeviceSelectorHomeMain = styled.div(_templateObject$18 || (_templateObject$18 = _taggedTemplateLiteralLoose(["\n"])));
var HeadingDiv = styled.div(_templateObject2$W || (_templateObject2$W = _taggedTemplateLiteralLoose(["\nmargin-top:20px"])));
var SubTitleDiv = styled.div(_templateObject3$M || (_templateObject3$M = _taggedTemplateLiteralLoose(["\nmargin-top:20px;\nmax-width: 529px;\n"])));
var SearchContainer$3 = styled.div(_templateObject4$L || (_templateObject4$L = _taggedTemplateLiteralLoose(["\nmargin-top: 30px\n"])));
var TabContainer = styled.div(_templateObject5$F || (_templateObject5$F = _taggedTemplateLiteralLoose(["\n\n"])));
var ErrorBanner = styled.div(_templateObject6$y || (_templateObject6$y = _taggedTemplateLiteralLoose([""])));
var isDark = function isDark(paramsDetails) {
  var _paramsDetails$theme;
  return paramsDetails !== null && paramsDetails !== void 0 && (_paramsDetails$theme = paramsDetails.theme) !== null && _paramsDetails$theme !== void 0 && _paramsDetails$theme.isDark ? true : false;
};
var DeviceSelectorHome = function DeviceSelectorHome() {
  var _paramsDetails$theme2, _paramsDetails$theme3, _window, _window$caseDetails;
  var _useState = useState([{}, {}]),
    devices = _useState[0],
    setDevices = _useState[1];
  var _useState2 = useState({}),
    filteredDeviceFromTab = _useState2[0],
    setFilteredDeviceFromTab = _useState2[1];
  var _useState3 = useState({}),
    selectedDeviceFromSearch = _useState3[0],
    setSelectedDeviceFromSearch = _useState3[1];
  var _ref = useContext(ParamsContext) || {},
    _ref$paramsDetails = _ref.paramsDetails,
    paramsDetails = _ref$paramsDetails === void 0 ? {} : _ref$paramsDetails,
    _ref$configDetails = _ref.configDetails,
    configDetails = _ref$configDetails === void 0 ? {} : _ref$configDetails;
  var _useState4 = useState(0),
    selectedTabIndex = _useState4[0],
    setSelectedTabIndex = _useState4[1];
  var _useState5 = useState(false),
    isLoading = _useState5[0],
    setIsLoading = _useState5[1];
  var _useState6 = useState(false),
    noResultsFound = _useState6[0],
    setNoResultsFound = _useState6[1];
  var _useState7 = useState({}),
    deviceDetailsRes = _useState7[0],
    setDeviceDetailsRes = _useState7[1];
  var darkBC = paramsDetails === null || paramsDetails === void 0 ? void 0 : (_paramsDetails$theme2 = paramsDetails.theme) === null || _paramsDetails$theme2 === void 0 ? void 0 : (_paramsDetails$theme3 = _paramsDetails$theme2.themeObject) === null || _paramsDetails$theme3 === void 0 ? void 0 : _paramsDetails$theme3.background;
  var handleForwardDevices = useCallback(function (deviceList) {
    setFilteredDeviceFromTab(deviceList);
  });
  var getDeviceData = function getDeviceData() {
    try {
      setIsLoading(true);
      return Promise.resolve(getDeviceSelectorJson(paramsDetails)).then(function (deviceResp) {
        var _ref2 = deviceResp || {},
          _ref2$body = _ref2.body,
          body = _ref2$body === void 0 ? {} : _ref2$body;
        var _body$deviceCategorie = body.deviceCategories,
          deviceCategories = _body$deviceCategorie === void 0 ? [] : _body$deviceCategorie;
        if (deviceCategories.length) {
          setDevices(deviceCategories);
        }
        setIsLoading(false);
        console.log("device Selector Resp", deviceResp);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  useEffect(function () {
    getDeviceData();
  }, []);
  var fwaFeatureFlagObj = getFeatureFlag(configDetails === null || configDetails === void 0 ? void 0 : configDetails.featureFlagList, 'restrictDeviceSelectorHomeTabFFlag');
  var getUseDeviceDataProps = {
    params: paramsDetails,
    customerInfo: paramsDetails.customerInfo
  };
  var _useDeviceData = useDeviceData(getUseDeviceDataProps),
    deviceDetailsResponse = _useDeviceData.data;
  useEffect(function () {
    var _deviceDetailsRespons, _deviceDetailsRespons2, _deviceDetailsRespons3;
    if (deviceDetailsResponse !== null && deviceDetailsResponse !== void 0 && (_deviceDetailsRespons = deviceDetailsResponse.response) !== null && _deviceDetailsRespons !== void 0 && (_deviceDetailsRespons2 = _deviceDetailsRespons.data) !== null && _deviceDetailsRespons2 !== void 0 && (_deviceDetailsRespons3 = _deviceDetailsRespons2.body) !== null && _deviceDetailsRespons3 !== void 0 && _deviceDetailsRespons3.data) {
      var _deviceDetailsRespons4, _deviceDetailsRespons5, _deviceDetailsRespons6;
      setDeviceDetailsRes(deviceDetailsResponse === null || deviceDetailsResponse === void 0 ? void 0 : (_deviceDetailsRespons4 = deviceDetailsResponse.response) === null || _deviceDetailsRespons4 === void 0 ? void 0 : (_deviceDetailsRespons5 = _deviceDetailsRespons4.data) === null || _deviceDetailsRespons5 === void 0 ? void 0 : (_deviceDetailsRespons6 = _deviceDetailsRespons5.body) === null || _deviceDetailsRespons6 === void 0 ? void 0 : _deviceDetailsRespons6.data);
    }
  }, [deviceDetailsResponse]);
  var selectedMTN = ((_window = window) === null || _window === void 0 ? void 0 : (_window$caseDetails = _window.caseDetails) === null || _window$caseDetails === void 0 ? void 0 : _window$caseDetails.mtn) || (paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.mdn);
  var selectedMTNData;
  if (deviceDetailsRes) {
    var _deviceDetailsRes$cus, _deviceDetailsRes$cus2, _deviceDetailsRes$cus3;
    var mtns = deviceDetailsRes === null || deviceDetailsRes === void 0 ? void 0 : (_deviceDetailsRes$cus = deviceDetailsRes.customerInsight) === null || _deviceDetailsRes$cus === void 0 ? void 0 : (_deviceDetailsRes$cus2 = _deviceDetailsRes$cus.billAccounts) === null || _deviceDetailsRes$cus2 === void 0 ? void 0 : (_deviceDetailsRes$cus3 = _deviceDetailsRes$cus2[0]) === null || _deviceDetailsRes$cus3 === void 0 ? void 0 : _deviceDetailsRes$cus3.mtns;
    selectedMTNData = mtns ? mtns.find(function (e) {
      return e.mtn === selectedMTN;
    }) : {};
  }
  var isFWADevice_ = isFWADevice(selectedMTNData);
  console.log("fwaFeatureFlagObj+++++++++", fwaFeatureFlagObj);
  console.log("isFWADevice_+++++++++", isFWADevice_);
  useEffect(function () {
    var setChangeDeviceClicked = paramsDetails.setChangeDeviceClicked,
      changeDeviceClicked = paramsDetails.changeDeviceClicked;
    if (setChangeDeviceClicked && typeof setChangeDeviceClicked === 'function' && changeDeviceClicked) {
      setChangeDeviceClicked(false);
    }
  }, []);
  var handleTabChange = function handleTabChange(e, index) {
    console.log("selectedTab-->", index);
    setSelectedTabIndex(index);
  };
  var isDarkTheme = isDark(paramsDetails);
  var _paramsDetails$channe = paramsDetails.channel,
    channel = _paramsDetails$channe === void 0 ? 'CARE' : _paramsDetails$channe;
  var compoenentToRender = null;
  if (channel === "CARE" || channel === "Care" || channel === "Prepay" || channel === "My Verizon" || channel === "Verizon Website") {
    compoenentToRender = selectedTabIndex === 1 ? /*#__PURE__*/React__default.createElement(MobileTabComponent, {
      tabName: "home",
      deviceJson: devices[0],
      forwardDevices: handleForwardDevices,
      selectedDevice: selectedDeviceFromSearch,
      isLoading: isLoading,
      noResultsFound: noResultsFound,
      isDark: isDarkTheme
    }) : /*#__PURE__*/React__default.createElement(MobileTabComponent, {
      tabName: "mobile",
      deviceJson: devices[1],
      forwardDevices: handleForwardDevices,
      selectedDevice: selectedDeviceFromSearch,
      isLoading: isLoading,
      noResultsFound: noResultsFound,
      isDark: isDarkTheme
    });
  } else if (channel === "Retail") {
    compoenentToRender = selectedTabIndex === 1 ? /*#__PURE__*/React__default.createElement(MobileTabRetail, {
      tabName: "home",
      deviceJson: devices[0],
      forwardDevices: handleForwardDevices,
      selectedDevice: selectedDeviceFromSearch,
      isLoading: isLoading,
      noResultsFound: noResultsFound,
      isDark: isDarkTheme
    }) : /*#__PURE__*/React__default.createElement(MobileTabRetail, {
      tabName: "mobile",
      deviceJson: devices[1],
      forwardDevices: handleForwardDevices,
      selectedDevice: selectedDeviceFromSearch,
      isLoading: isLoading,
      noResultsFound: noResultsFound,
      isDark: isDarkTheme
    });
  }
  return /*#__PURE__*/React__default.createElement(DeviceSelectorHomeMain, {
    id: "panel-3",
    role: "tabpanel",
    tabIndex: "0",
    "aria-labelledby": "tab-3",
    "data-role": "tabpanel"
  }, !paramsDetails.equipmentId && /*#__PURE__*/React__default.createElement(ErrorBanner, null, /*#__PURE__*/React__default.createElement(Notification, {
    type: "error",
    title: "We were unable to identify this device.",
    subtitle: "To continue, select a device to troubleshoot.",
    fullBleed: false,
    inline: false,
    disableFocus: true,
    hideCloseButton: true,
    surface: isDarkTheme ? 'dark' : 'light'
  })), /*#__PURE__*/React__default.createElement(HeadingDiv, null, /*#__PURE__*/React__default.createElement(Title, {
    size: "small",
    bold: true,
    color: isDarkTheme ? "#ffffff" : "#000000"
  }, "Select a device to troubleshoot.")), /*#__PURE__*/React__default.createElement(SubTitleDiv, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "large",
    color: isDarkTheme ? "#ffffff" : "#000000",
    bold: false
  }, "The available issues vary based on device and may change when a different device is selected.")), /*#__PURE__*/React__default.createElement(SearchContainer$3, null, /*#__PURE__*/React__default.createElement(Searchbar, {
    noResultsFound: function noResultsFound(value) {
      return setNoResultsFound(value);
    },
    deviceSelectorJson: filteredDeviceFromTab,
    clearSelection: selectedTabIndex,
    setSelectedDevice: function setSelectedDevice(obj) {
      return setSelectedDeviceFromSearch(obj);
    },
    isDark: isDarkTheme,
    darkBC: darkBC
  })), /*#__PURE__*/React__default.createElement(TabContainer, {
    className: "deviceSelectorTab"
  }, /*#__PURE__*/React__default.createElement(Tabs$1, {
    orientation: "horizontal",
    indicatorPosition: "bottom",
    linePosition: "bottom",
    selectedIndex: selectedTabIndex,
    onTabChange: handleTabChange,
    id: "deviceTabsSection",
    surface: isDarkTheme ? 'dark' : 'light'
  }, /*#__PURE__*/React__default.createElement(Tab, {
    label: "Mobile"
  }), fwaFeatureFlagObj !== null && fwaFeatureFlagObj !== void 0 && fwaFeatureFlagObj.status ? /*#__PURE__*/React__default.createElement(Tab, {
    label: "Home",
    hide: true
  }) : /*#__PURE__*/React__default.createElement(Tab, {
    label: "Home"
  })), compoenentToRender));
};

var _templateObject$19, _templateObject2$X, _templateObject3$N, _templateObject4$M;
var PaginationWrapper = styled.ul(_templateObject$19 || (_templateObject$19 = _taggedTemplateLiteralLoose(["\nfloat: right;\n    font-size: 13px;\n    display: flex;\n    list-style-type: none;\n    padding: 0px;\n    justify-content: end !important;\n    width: 100%;\n    .PaginationItem {\n        margin: 0.15em 0 0.15em 0.5em;\n    }\n"])));
var PaginationItem = styled.li.attrs({
  className: 'PaginationItem'
})(_templateObject2$X || (_templateObject2$X = _taggedTemplateLiteralLoose(["\n  .input {\n  /* Custom Styles */\n  }\n  .button {\n  /* Custom Styles */\n }\n"])));
var PageBtn = styled.span(_templateObject3$N || (_templateObject3$N = _taggedTemplateLiteralLoose(["\n    border:0px;\n    background-color: ", ";\n    cursor: pointer;\n\n    font-weight: ", ";\n    font-size: ", ";\n"])), function (props) {
  return props.isDark ? props === null || props === void 0 ? void 0 : props.darkBC : "white";
}, function (props) {
  return props.active && "bolder";
}, function (props) {
  return props.active && "14px";
});
var NextPageBtn = styled.span(_templateObject4$M || (_templateObject4$M = _taggedTemplateLiteralLoose(["\n    border:0px;\n    background-color:  ", ";;\n    cursor: pointer;\n"])), function (props) {
  return props.isDark ? props === null || props === void 0 ? void 0 : props.darkBC : "white";
});
var Pagination = function Pagination(_ref) {
  var _useContext, _paramsDetails$theme, _paramsDetails$theme2, _paramsDetails$theme3;
  var _ref$howManyPages = _ref.howManyPages,
    howManyPages = _ref$howManyPages === void 0 ? 10 : _ref$howManyPages,
    setCurrentPage = _ref.setCurrentPage,
    currentPage = _ref.currentPage;
  var paramsDetails = (_useContext = useContext(ParamsContext)) === null || _useContext === void 0 ? void 0 : _useContext.paramsDetails;
  var isDarkTheme = paramsDetails !== null && paramsDetails !== void 0 && (_paramsDetails$theme = paramsDetails.theme) !== null && _paramsDetails$theme !== void 0 && _paramsDetails$theme.isDark ? true : false;
  var darkBC = paramsDetails === null || paramsDetails === void 0 ? void 0 : (_paramsDetails$theme2 = paramsDetails.theme) === null || _paramsDetails$theme2 === void 0 ? void 0 : (_paramsDetails$theme3 = _paramsDetails$theme2.themeObject) === null || _paramsDetails$theme3 === void 0 ? void 0 : _paramsDetails$theme3.background;
  var WhiteLeftArrow = "iVBORw0KGgoAAAANSUhEUgAAAD4AAAA+CAYAAABzwahEAAAABGdBTUEAALGPC/xhBQAAAnZJREFUaAXl2UFSwjAUANCkshA9AyupeAwdXIobdQa9gCvv4hXc6DjiOINb9QjqUqSsOIPiAhr/r0OnAi0F0jT/9y+YQLHJS1LMT4TIITq9Xv2j2233+/1yDtUHVTqmK0a08P1HoVTjezB4zAtvFD5GK6WCkVZC1L9+fm5Ndz7WZww+iQ6wUn4LKS/zgEsTlSagGzvV6ouJNkzWkTncRjR2QqZwW9GZwm1GZwafhZZSDpSUB3k904iNhvapTgGNHaAVTgWtFU4JrQ1ODa0FThG9MpwqeiU4ZfTScOropeBxaOE4jdrW1jPelEIs9H+cCxoHJjWcEzo1nBsa4XN3YD57vX3cIxtvFwW9BQkHtWca2x2NxKmOaOX7bW5o7IBYOGd0LJw7eia8COgpeFHQ/+BFQofwWWi8CNGBX7+3vyKP123XPYP9PyUT0DykE4qa664B3C/5vn8BB3i5nVpOtMvYW2dzfb0J0/nJWI2WVBQsYPCoFo5s23B6uR9tF1x8F6XSuTMaDaOfUy67rvuK7Q/gWIjDw2nmfa1abcJzwQaP3jBJqVQqg41y+XBq2it11PG8G1ivl/APuEQ44mNQwsi3YORPuYz8FBw7oAj4mfAi4GPh3PGJcM74uXCu+FRwjvjUcG74heCc8AvDueCXgnPALw2njg+TFIQsGgmJzTEkNtc2JzYrjfi4oxLW9neQ2OAel3UprRY4dgA1vDY4NbxWOCW8djgVfCZwCvjM4LbjM4XbjM8cbit+pZUbotJEwgrvBFZ4V2nuofs7RuDY6Bj8cE2IB92oNPczMtWjDYms8Hbh2PIUjnRa0eusy4j3PG+PNdJW3C9F4335Op7UkwAAAABJRU5ErkJggg";
  var BlackLeftArrow = "iVBORw0KGgoAAAANSUhEUgAAAD4AAAA+CAYAAABzwahEAAAABGdBTUEAALGPC/xhBQAAAWpJREFUaAXtmTFuAjEURDcRTY5F4AipuEAqjpUmSUULZyC0OUjSECmZQWvk/bJbVpk/lj6sLUvm/Zlv77LDME9bYdkd4mGe5edZldDfiF/EAZECvoYmOIPKS7cW9BeIH5WpDQ11aW8rrWhz23u0N4+wdBuZobPUtJW20iIZaB1ZtreIuBMMK4108N6b9mYyZFtPaUOrSZ5S6TVUZA2Xv4pS1LShR8Xld28rbaWRAdWWyt53o4qEbr3L+sT4h5jSG/DwSB5aStdnttr1PaH5sUWkeHFH4LoReo9QU7bHc1G81DjhWeO0fd1O6DwjfurBf359jL+/p/w7Ji7iZLV+D/7N8GpSBx4rj4TE3dG2Dy6R69r2tv207l3zckUegFzzrnnX/PVmJ/WG94pSSPtUZ/hwMsh1e0edlZeTOgBZeSQkPs/b9sElcl3b3raf1v2LnMcbQNH2Z8x5asyTHCrwqaCLkoRflo6/b5iBP5eGnPiaAZUwAAAAAElFTkSuQmCC";
  var WhiteRightArrow = "iVBORw0KGgoAAAANSUhEUgAAADwAAAA+CAYAAAB3NHh5AAAABGdBTUEAALGPC/xhBQAAAnFJREFUaAXl2z1O60AQAODdJEXCHdJFoX7iAoBEBxRIwDE4y+teSQOICvFXIUDcIqwXpcgdAD3FLDMJi5xIhODszuyYKVjHgMafZ2xnN4pSxNHv95u9LDs3xmwQpx6lq1EmRez/4fBCObfttL7gQJOCAXvinBtVFsYmB5oUDMn+Kq2ffVdxoLVPTjVmWbaaK3UNbb3kc2qtXzW0ebfbvfH7Yo3kYIRwolnAnGg2MBeaFcyBZgdTo5MAU6KTASPaWrs2dO4q5iMrKTAFOjlwbHSS4JjoZMGx0EmDY6CTB4dGiwCHRIsBh0KLAodAiwMvihYJXgQtFlwWLRpcBi0e/FM06TItHlyM6HQ697D8uzXPEnAlKuxPYs/adZhLX86aT+tHY078P1RhdEr9Acdy0VJc99Y9Y+Bvqh8e3ag+dSzEj3Vg6+DXgKHCd0vN5m6jrvVKVar8Vq83VJ7/g2ridfwZH9jNdrv9Upm7NCAbj9Yewx1691MKG0Us7q8EeF4sgsW/8UCssfbou8oiFkN0hT0Wxr0xZ/xzuo0nfld8IWm7DBZ9IitcFisSvAhWHHhRrChwCKwYcCisCHBIbPJgwNbhTcUxjHM/ZxE1K5J9LMXA4olIEhwLmyQ4JhbBSU0ePrBHMAa7ZhFZjGRauoDdnzjA8UrFaPJe3F92OwkwFRZPEjuYEssOpsaygjmwCGa5S3+JVeoWllKD3aAQOB3k1/BMbKu1hUup0wcZ8jUpmBuLJ460pWEicAjoyecstjFBZX2XkIJ1rXYGiYc+ObQXKRbzkrY0JjRPTztveX4KiR8oK4u52QK/xjMYDFpsB/CbEr8D6nKqQlTkDbIAAAAASUVORK5CYII";
  var BlackRightArrow = "iVBORw0KGgoAAAANSUhEUgAAADwAAAA+CAYAAAB3NHh5AAAABGdBTUEAALGPC/xhBQAAAVFJREFUaAXtmDtOw1AUREFJQVZCTVZgkOgQBaujp8hHQlQ0/JbCDlIikCjg3CiWrNfQWXhmrjSJX2WfO3Od9zI7Gr9OuOU92qH38W8/7h0L9gn9oE90iaTrAbqC7SUP3QH7MQC2cDrQB8cTbxohVx1EmWmakHjLZRugDtnF+zzQJtvQOE3ULbahcTpO0wHVSrxxNi+yxFuoA5npzLRQnFsUy3hf0AW78/Sf0Md0ZdXmY+LrM57/tGH4Yn2Nngu4disOtYd2Ai5TH+ujHHbQK5yLcniJVGoOyC2qOR7WG4srVP93y1TBblGb1r2zMpQHEDvYjZOzgcXtheLMxtk4O/Fc109PYpwYTzzGM6cYBxa3JQ8Cds6ucdLiiFfOBpYmyB0E4qzy29h+Zl+cZjawuD35uoOg3VRIOts7dcPF9wBaGraFtoDtoTsu5HZQPdy/+v4F7xhk8sMUhkYAAAAASUVORK5CYII";
  var numberOfPages = [];
  for (var i = 1; i <= howManyPages; i++) {
    numberOfPages.push(i);
  }
  var _useState = useState([]),
    arrOfCurrButtons = _useState[0],
    setArrOfCurrButtons = _useState[1];
  useEffect(function () {
    var tempNumberOfPages = [].concat(arrOfCurrButtons);
    if (currentPage >= 1 && currentPage < 3) {
      tempNumberOfPages = numberOfPages.slice(0, 4);
    } else if (currentPage >= 3 && currentPage < numberOfPages.length - 1) {
      var sliced1 = numberOfPages.slice(currentPage - 2, currentPage);
      var sliced2 = numberOfPages.slice(currentPage, currentPage + 2);
      tempNumberOfPages = [].concat(sliced1, sliced2);
    }
    setArrOfCurrButtons(tempNumberOfPages);
    setCurrentPage(currentPage);
  }, [currentPage, howManyPages]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(PaginationWrapper, null, howManyPages && currentPage != 1 ? /*#__PURE__*/React__default.createElement(PaginationItem, {
    className: "pagination-item"
  }, /*#__PURE__*/React__default.createElement(PageBtn, {
    onClick: currentPage > 1 ? function () {
      return setCurrentPage(currentPage - 1);
    } : null,
    "aria-label": "To go to previous page",
    isDark: isDarkTheme,
    darkBC: darkBC
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "leftArrowImg",
    src: "data:image/png;base64," + (isDarkTheme ? WhiteLeftArrow : BlackLeftArrow),
    height: "12px",
    width: "15px"
  }), "  Previous")) : null, arrOfCurrButtons.map(function (pages, index) {
    return /*#__PURE__*/React__default.createElement(PaginationItem, {
      key: pages
    }, /*#__PURE__*/React__default.createElement(PageBtn, {
      onClick: function onClick() {
        return setCurrentPage(pages);
      },
      active: currentPage == pages,
      "aria-label": "To go to " + pages + " page",
      isDark: isDarkTheme,
      darkBC: darkBC
    }, pages));
  }), howManyPages && currentPage != howManyPages ? /*#__PURE__*/React__default.createElement(PaginationItem, null, /*#__PURE__*/React__default.createElement(NextPageBtn, {
    isDark: isDarkTheme,
    darkBC: darkBC,
    onClick: currentPage < numberOfPages.length ? function () {
      return setCurrentPage(currentPage + 1);
    } : null,
    "aria-label": "To go to next page"
  }, "Next ", /*#__PURE__*/React__default.createElement("img", {
    className: "rightArrowImg",
    src: "data:image/png;base64," + (isDarkTheme ? WhiteRightArrow : BlackRightArrow),
    height: "12px",
    width: "15px"
  }))) : null));
};

var _templateObject$1a, _templateObject2$Y, _templateObject3$O, _templateObject4$N, _templateObject5$G, _templateObject6$z, _templateObject7$u, _templateObject8$r, _templateObject9$m, _templateObject0$k, _templateObject1$k, _templateObject10$f, _templateObject11$b, _templateObject12$a, _templateObject13$a, _templateObject14$9, _templateObject15$9, _templateObject16$8, _templateObject17$8, _templateObject18$8;
var Wrapper$1 = styled.div(_templateObject$1a || (_templateObject$1a = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  font-size: 1rem;\n  color: ", ";\n"])), function (props) {
  return props.isDarkTheme && "#FFF";
});
var IssueTitle = styled.table(_templateObject2$Y || (_templateObject2$Y = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  font-weight: normal;\n"])));
var IssueTitleDate = styled.td(_templateObject3$O || (_templateObject3$O = _taggedTemplateLiteralLoose(["\n  width: 24%;\n  margin: 0.5rem 0 1.4rem;\n"])));
var IssueTitleButton = styled.td.attrs({
  className: 'ResumeButton'
})(_templateObject4$N || (_templateObject4$N = _taggedTemplateLiteralLoose(["\n  width: 75%;\n  padding:0;\n  vertical-align: baseline;\n  padding-top: 0.25rem;\n  padding-left:2px;\n"])));
var Text$1 = styled.p(_templateObject5$G || (_templateObject5$G = _taggedTemplateLiteralLoose(["\n  font-size:12px\n"])));
var PaginationWrapper$1 = styled.div(_templateObject6$z || (_templateObject6$z = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  padding: 5px;\n"])));
var IssueDetailTable = styled.table(_templateObject7$u || (_templateObject7$u = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  font-size: 1rem;\n"])));
var TableRow = styled.tr(_templateObject8$r || (_templateObject8$r = _taggedTemplateLiteralLoose([""])));
var TableCell = styled.td(_templateObject9$m || (_templateObject9$m = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  font-weight: ", " !important;\n  padding-top: ", ";\n  padding-left: ", ";\n  font-size: 12px;\n  padding-right: 10px;\n  vertical-align: top;\n  a.review {\n    // text-decoration: underline;\n    font-weight: bold !important;\n    position: relative;\n  }\n"])), function (props) {
  return props.width ? props.width : '25%';
}, function (props) {
  return props.isBold ? 700 : 400;
}, function (props) {
  return props.isBold ? '23px' : 0;
}, function (props) {
  return props.rightAlign ? '4rem' : '0';
});
var TableData = styled.td(_templateObject0$k || (_templateObject0$k = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  border-bottom: ", ";\n  padding: 10px 12px 3px 0px;\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.borderBottom && '1px solid rgb(216, 218, 218)';
});
var TableHeading = styled.th(_templateObject1$k || (_templateObject1$k = _taggedTemplateLiteralLoose(["\n  padding: 10px 12px 0px 0;\n"])));
var AccordionContentUL = styled.ul(_templateObject10$f || (_templateObject10$f = _taggedTemplateLiteralLoose(["\n  padding: 12px 0 0 0;\n  position: relative;\n\n  .AccordionContentWrapper {\n    padding-bottom: 20px;\n    position: relative;\n    top: -1px;\n    line-height: 1.25rem !important;\n    letter-spacing: 0.03125rem;\n  }\n\n  .AccordionContentTimeline {\n    border-left: 2px solid ", " !important;\n  }\n\n  .AccordionContentSingle {\n    list-style-type: none;\n    margin: 0 0 0 7px;\n    padding-left: 20px;\n  }\n\n  .AccordionContent {\n    list-style-type: none;\n    margin: 0 0 0 7px;\n    padding-left: 20px;\n  }\n\n  .AccordionContent:before {\n    border-radius: 50%;\n    height: 14px;\n    width: 14px;\n    position: absolute;\n    left: 1px;\n    font-size: 14px;\n    content: '';\n    text-align: center;\n    color: #000;\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.isDarkTheme ? '#FFF' : '#000';
}, function (props) {
  return props.isDarkTheme ? '#FFF' : '#000';
});
var NoIssuesFoundDiv = styled.div(_templateObject11$b || (_templateObject11$b = _taggedTemplateLiteralLoose(["\n  padding: 20px 0 0 5px;\n"])));
var AccordionWrapperIssueHistory = styled.div(_templateObject12$a || (_templateObject12$a = _taggedTemplateLiteralLoose(["\n  button.accordionButton {\n    background: unset;\n    -webkit-appearance: none;\n    border-radius: 0;\n    span:first-child {\n      padding-right: 0px;\n    }\n  }\n\n  [class^=\"InnerElementWrapper-VDS\"] {      \n      padding-top: 13px;\n      padding-bottom: 45px;\n      padding-right:0px;     \n  }\n    \n  .toggleIconWrapper{\n      top:7px !important;\n  }\n\n  [class^=\"AccordionList-VDS\"] {\n      [class^=\"ComponentWrapper-VDS\"] {\n          [class^=\"StyledLine-VDS\"] {\n                  height: 0.0625rem !important;\n                  background-color: ", ";\n          }\n      }\n      [class^=\"ComponentWrapper-VDS\"]:first-child {\n          [class^=\"StyledLine-VDS\"] {\n                  height: 0.25rem !important;\n                  background-color: ", ";\n          }\n      }\n      [class^=\"HitArea-VDS\"] {\n        background: ", ";\n      }\n\n      [class^=\"StyledAnchor-VDS\"] {\n        border-bottom: ", ";\n      }\n  }\n    \n  .historyDate {\n      margin-bottom: 1rem;\n  }\n"])), function (props) {
  return props.isDarkTheme ? '#ffffff !important' : '#000000 !important';
}, function (props) {
  return props.isDarkTheme ? '#ffffff !important' : '#000000 !important';
}, function (props) {
  return props.isDarkTheme && 'unset';
}, function (props) {
  return props.isDarkTheme && 'unset';
});
var RadioBoxContainer = styled.section(_templateObject13$a || (_templateObject13$a = _taggedTemplateLiteralLoose(["\n  padding: 20px 0 30px 0;\n  [class^=\"RadioBoxLabelWrapper-VDS__\"] {\n    margin-right: 8px !important;\n  }\n"])));
var FilterHeading = styled.p(_templateObject14$9 || (_templateObject14$9 = _taggedTemplateLiteralLoose(["\n  font-size:16px;\n  margin-bottom:13px;\n"])));
var ClnrViewDisplay = styled.div(_templateObject15$9 || (_templateObject15$9 = _taggedTemplateLiteralLoose(["\n  display: block;\n  margin-bottom: 30px;\n  margin-top:2px;\n  width: 100%;\n  ::after {\n    display:block;\n    content:\"\";\n    clear:both;\n  }\n"])));
var ViewOrderDetail = styled.div(_templateObject16$8 || (_templateObject16$8 = _taggedTemplateLiteralLoose(["\n    float:left;\n    padding-top: 5px;\n    #view_order_cta {\n      color: unset !important;\n    }\n    #view_order_cta:hover {\n      color: unset !important;\n      text-decoration: none !important;\n    }\n"])));
var TroubleshootIssue = styled.div(_templateObject17$8 || (_templateObject17$8 = _taggedTemplateLiteralLoose(["\n    float: right;\n    button {\n    overflow:hidden;\n  }\n"])));
var TroubleshootIssueText = styled.span(_templateObject18$8 || (_templateObject18$8 = _taggedTemplateLiteralLoose(["\n    font-family: 'Verizon-NHG-eTX' !important;\n"])));
var handleViewOrderDetails = function handleViewOrderDetails(e, item, configDetails) {
  try {
    e.preventDefault();
    var _ref = configDetails || {},
      paramsDetails = _ref.paramsDetails,
      _ref$paramsDetails = _ref.paramsDetails,
      _ref$paramsDetails2 = _ref$paramsDetails === void 0 ? {} : _ref$paramsDetails,
      viewClnrDetailsPopup = _ref$paramsDetails2.viewClnrDetailsPopup;
    return Promise.resolve(GetOrderCaseId(item, paramsDetails)).then(function (getOrderCaseIdData) {
      var _getOrderCaseIdData$r, _getOrderCaseIdData$r2, _getOrderCaseIdData$r3, _getOrderCaseIdData$r4, _getOrderCaseIdData$r5, _getOrderCaseIdData$r6;
      var getOrderCaseId = getOrderCaseIdData === null || getOrderCaseIdData === void 0 ? void 0 : (_getOrderCaseIdData$r = getOrderCaseIdData.response) === null || _getOrderCaseIdData$r === void 0 ? void 0 : (_getOrderCaseIdData$r2 = _getOrderCaseIdData$r.data) === null || _getOrderCaseIdData$r2 === void 0 ? void 0 : (_getOrderCaseIdData$r3 = _getOrderCaseIdData$r2.body) === null || _getOrderCaseIdData$r3 === void 0 ? void 0 : (_getOrderCaseIdData$r4 = _getOrderCaseIdData$r3.serviceBody) === null || _getOrderCaseIdData$r4 === void 0 ? void 0 : (_getOrderCaseIdData$r5 = _getOrderCaseIdData$r4.serviceResponse) === null || _getOrderCaseIdData$r5 === void 0 ? void 0 : (_getOrderCaseIdData$r6 = _getOrderCaseIdData$r5.caseDetails) === null || _getOrderCaseIdData$r6 === void 0 ? void 0 : _getOrderCaseIdData$r6.caseID;
      if (getOrderCaseId && viewClnrDetailsPopup) {
        viewClnrDetailsPopup(getOrderCaseId);
      }
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var handleNavigateIssueSelector = function handleNavigateIssueSelector(e, props) {
  e.preventDefault();
  props.selectedIssueSelectorObject();
};
var IssueDetail = function IssueDetail(_ref2) {
  var _headerData$issueStat;
  var props = _ref2.props,
    headerData = _ref2.headerData,
    isAcssChannel = _ref2.isAcssChannel;
  var handleResume = function handleResume(e, item) {
    e.preventDefault();
    props.selectedResumeObject(item);
  };
  var renderReview = function renderReview() {
    var _headerData$details$, _headerData$details$$;
    if (headerData !== null && headerData !== void 0 && (_headerData$details$ = headerData.details[0]) !== null && _headerData$details$ !== void 0 && (_headerData$details$$ = _headerData$details$.steps[0]) !== null && _headerData$details$$ !== void 0 && _headerData$details$$.howTo) {
      return /*#__PURE__*/React__default.createElement("a", {
        title: "Review",
        className: "review",
        onClick: function onClick(e) {
          return handleResume(e, headerData);
        },
        tabIndex: "0",
        role: "button"
      }, "Review");
    }
    return '';
  };
  return /*#__PURE__*/React__default.createElement(Wrapper$1, {
    isDarkTheme: props.isDarkTheme
  }, /*#__PURE__*/React__default.createElement(IssueTitle, null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement(IssueTitleDate, null, /*#__PURE__*/React__default.createElement(Text$1, null, headerData.issueDateTime)), /*#__PURE__*/React__default.createElement(IssueTitleButton, {
    isDarkTheme: props.isDarkTheme
  }, ((_headerData$issueStat = headerData.issueStatus) === null || _headerData$issueStat === void 0 ? void 0 : _headerData$issueStat.toLowerCase()) === 'open' ? /*#__PURE__*/React__default.createElement(TextLinkCaret, {
    id: "resume_cta",
    surface: props.isDarkTheme ? 'dark' : 'light',
    disabled: false,
    iconPosition: "right",
    onClick: function onClick(e) {
      return handleResume(e, headerData);
    }
  }, "Resume") : ''))), /*#__PURE__*/React__default.createElement(IssueDetailTable, null, /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    isBold: true,
    width: "25%"
  }, "Case number"), /*#__PURE__*/React__default.createElement(TableCell, {
    isBold: true,
    width: "35%"
  }, "Issue description"), /*#__PURE__*/React__default.createElement(TableCell, {
    isBold: true,
    width: "20%"
  }, "Resolution"), /*#__PURE__*/React__default.createElement(TableCell, {
    isBold: true,
    width: "20%"
  }, "Status")), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    isBold: false,
    width: "25%"
  }, headerData.caseNumber), /*#__PURE__*/React__default.createElement(TableCell, {
    isBold: false,
    width: "35%"
  }, headerData.issueDescription), isAcssChannel && headerData !== null && headerData !== void 0 && headerData.orderNumber && headerData !== null && headerData !== void 0 && headerData.locationCode ? /*#__PURE__*/React__default.createElement(TableCell, {
    isBold: false,
    width: "20%"
  }, "Replacement Issued") : /*#__PURE__*/React__default.createElement(TableCell, {
    isBold: false,
    width: "20%"
  }, headerData.resolution === '' ? '-' : headerData.resolution), isAcssChannel && headerData !== null && headerData !== void 0 && headerData.orderNumber && headerData !== null && headerData !== void 0 && headerData.locationCode && (headerData === null || headerData === void 0 ? void 0 : headerData.clnrCaseStatus) !== null && (headerData === null || headerData === void 0 ? void 0 : headerData.clnrCaseStatus) !== undefined ? /*#__PURE__*/React__default.createElement(TableCell, {
    isBold: false,
    width: "20%"
  }, headerData.clnrCaseStatus) : /*#__PURE__*/React__default.createElement(TableCell, {
    isBold: false,
    width: "20%"
  }, headerData.issueStatus.charAt(0).toUpperCase() + headerData.issueStatus.substring(1)), /*#__PURE__*/React__default.createElement(TableCell, {
    width: "20%"
  }, renderReview()))));
};
var AccordionContent = function AccordionContent(props) {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AccordionContentUL, {
    isDarkTheme: props.isDarkTheme
  }, props.history.details.map(function (item, index, arrLen) {
    return /*#__PURE__*/React__default.createElement("li", {
      className: (arrLen.length === 1 ? 'AccordionContentSingle ' : 'AccordionContent ') + (index !== arrLen.length - 1 ? 'AccordionContentTimeline' : ''),
      key: item.dateTime + '_' + index
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "AccordionContentWrapper"
    }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", {
      className: "historyDate"
    }, item.dateTime)), /*#__PURE__*/React__default.createElement(IssueDetailTable, null, index === 0 && /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableHeading, {
      width: "16%"
    }, "Creator"), /*#__PURE__*/React__default.createElement(TableHeading, {
      width: "58%"
    }, "Troubleshooting steps completed"), /*#__PURE__*/React__default.createElement(TableHeading, {
      width: "26%"
    }, "Response"))), /*#__PURE__*/React__default.createElement("tbody", null, item.steps.map(function (step, stepIndex) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableRow, null, stepIndex === 0 ? /*#__PURE__*/React__default.createElement(TableData, {
        width: "16%"
      }, item.createdBy) : /*#__PURE__*/React__default.createElement(TableData, {
        width: "16%"
      }), /*#__PURE__*/React__default.createElement(TableData, {
        width: "58%",
        borderBottom: true
      }, step.stepName), /*#__PURE__*/React__default.createElement(TableData, {
        width: "26%",
        borderBottom: true
      }, step.response)));
    })))));
  })));
};
var casesFactory = function casesFactory(allCases) {
  if (allCases === void 0) {
    allCases = [];
  }
  function filterRepeat(allcases) {
    var map = new Map();
    allcases.forEach(function (caseObj) {
      return map.set(caseObj.intentId, (map.get(caseObj.intentId) || 0) + 1);
    });
    return allcases.filter(function (caseObj) {
      return map.get(caseObj.intentId) > 1;
    });
  }
  var res = {
    openCases: [],
    closedCases: [],
    repeatCases: [],
    allCases: allCases
  };
  allCases.forEach(function (caseObj) {
    var status = caseObj.issueStatus ? caseObj.issueStatus.toLowerCase() : '';
    if (status.includes("open")) {
      res.openCases.push(caseObj);
    }
    if (status.includes('closed')) {
      res.closedCases.push(caseObj);
    }
  });
  res.repeatCases = filterRepeat(allCases);
  console.log("casesObject", res);
  return res;
};
var IssueHistoryNew = function IssueHistoryNew(props) {
  var _configDetails$params;
  var _props$history = props.history,
    history = _props$history === void 0 ? [] : _props$history;
  if (window && window.vzdl && window.vzdl.error && window.vzdl.error.code) {
    window.vzdl.error.code = '';
    delete window.vzdl.error;
  }
  var _useState = useState(1),
    currentPage = _useState[0],
    setCurrentPage = _useState[1];
  var _useState2 = useState(3),
    listCountPerPage = _useState2[0];
  var _useState3 = useState([]),
    casesToRender = _useState3[0],
    setCasesToRender = _useState3[1];
  var _useState4 = useState('all'),
    activeFilter = _useState4[0],
    setActiveFilter = _useState4[1];
  var casesRef = useRef(null);
  useEffect(function () {
    if (history && history.length > 0) {
      var casesData = casesFactory(history);
      casesRef.current = casesData;
      setCasesToRender(casesData.allCases);
    }
  }, [history]);
  console.log("caseRef", casesRef.current);
  var configDetails = useContext(ConfigContext);
  var isAcssChannel = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : _configDetails$params.channel) === 'CARE';
  var handleCaseChange = function handleCaseChange(event) {
    var value = event.target.value;
    console.log("radio changed-->", value);
    var _casesRef$current = casesRef.current,
      _casesRef$current$ope = _casesRef$current.openCases,
      openCases = _casesRef$current$ope === void 0 ? [] : _casesRef$current$ope,
      _casesRef$current$clo = _casesRef$current.closedCases,
      closedCases = _casesRef$current$clo === void 0 ? [] : _casesRef$current$clo,
      _casesRef$current$rep = _casesRef$current.repeatCases,
      repeatCases = _casesRef$current$rep === void 0 ? [] : _casesRef$current$rep,
      _casesRef$current$all = _casesRef$current.allCases,
      allCases = _casesRef$current$all === void 0 ? [] : _casesRef$current$all;
    setCurrentPage(1);
    switch (value) {
      case 'open':
        setCasesToRender(openCases);
        setActiveFilter('open');
        break;
      case 'closed':
        setCasesToRender(closedCases);
        setActiveFilter('closed');
        break;
      case 'repeat':
        setCasesToRender(repeatCases);
        setActiveFilter('repeat');
        break;
      default:
        setCasesToRender(allCases);
        setActiveFilter('all');
    }
  };
  if (!isEmpty(props)) {
    var isDarkTheme = props.isDarkTheme ? true : false;
    var indexOfLastPage = currentPage * listCountPerPage;
    var indexOfFirstPage = indexOfLastPage - listCountPerPage;
    var currentListOnPage = casesToRender.slice(indexOfFirstPage, indexOfLastPage);
    var howManyPages = casesToRender.length > listCountPerPage ? Math.ceil(casesToRender.length / listCountPerPage) : 1;
    if (!isEmpty(currentListOnPage)) {
      var _casesRef$current2 = casesRef.current,
        _casesRef$current2$op = _casesRef$current2.openCases,
        openCases = _casesRef$current2$op === void 0 ? [] : _casesRef$current2$op,
        _casesRef$current2$cl = _casesRef$current2.closedCases,
        closedCases = _casesRef$current2$cl === void 0 ? [] : _casesRef$current2$cl,
        _casesRef$current2$re = _casesRef$current2.repeatCases,
        repeatCases = _casesRef$current2$re === void 0 ? [] : _casesRef$current2$re,
        _casesRef$current2$al = _casesRef$current2.allCases,
        allCases = _casesRef$current2$al === void 0 ? [] : _casesRef$current2$al;
      var openCount = "(" + openCases.length + ")";
      var closedCount = "(" + closedCases.length + ")";
      var repeatCount = "(" + repeatCases.length + ")";
      var allCount = "(" + allCases.length + ")";
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(RadioBoxContainer, null, /*#__PURE__*/React__default.createElement(FilterHeading, null, "Filter by case type."), /*#__PURE__*/React__default.createElement(RadioBoxGroup, {
        childWidth: '200px',
        defaultValue: "all",
        orientation: "horizontal",
        onChange: handleCaseChange,
        surface: isDarkTheme ? 'dark' : 'light',
        data: [{
          id: 'all',
          text: 'All cases',
          subtext: allCount,
          disabled: allCount === '(0)',
          value: 'all',
          name: 'RadioBoxGroup'
        }, {
          id: 'open',
          text: 'Open cases',
          subtext: openCount,
          disabled: openCount === '(0)',
          value: 'open',
          name: 'RadioBoxGroup'
        }, {
          id: 'closed',
          text: 'Closed cases',
          subtext: closedCount,
          disabled: closedCount === '(0)',
          value: 'closed',
          name: 'RadioBoxGroup'
        }, {
          id: 'repeat',
          text: 'Repeat cases',
          subtext: repeatCount,
          disabled: repeatCount === '(0)',
          value: 'repeat',
          name: 'RadioBoxGroup'
        }]
      })), /*#__PURE__*/React__default.createElement(AccordionWrapperIssueHistory, {
        key: activeFilter,
        id: "panel-2",
        role: "tabpanel",
        tabIndex: "0",
        "aria-labelledby": "tab-2",
        "data-role": "tabpanel",
        isDarkTheme: isDarkTheme
      }, /*#__PURE__*/React__default.createElement(Accordion$1, {
        id: "active_filter" + activeFilter,
        type: "single",
        inverted: isDarkTheme,
        topLine: true,
        bottomLine: true,
        surface: isDarkTheme ? 'dark' : 'light'
      }, currentListOnPage.map(function (item, index) {
        return /*#__PURE__*/React__default.createElement(AccordionItem, {
          inverted: isDarkTheme,
          key: item.caseNumber + '_' + index
        }, /*#__PURE__*/React__default.createElement(AccordionHeader, {
          triggerType: "icon",
          inverted: isDarkTheme,
          primitive: "div"
        }, /*#__PURE__*/React__default.createElement(IssueDetail, {
          props: props,
          headerData: item,
          isAcssChannel: isAcssChannel
        })), /*#__PURE__*/React__default.createElement(AccordionDetail, {
          inverted: isDarkTheme,
          children: /*#__PURE__*/React__default.createElement(AccordionContent, {
            isDarkTheme: isDarkTheme,
            history: item
          })
        }), /*#__PURE__*/React__default.createElement(Fragment, null, isAcssChannel && item !== null && item !== void 0 && item.orderNumber && item !== null && item !== void 0 && item.locationCode ? /*#__PURE__*/React__default.createElement(ClnrViewDisplay, null, /*#__PURE__*/React__default.createElement(ViewOrderDetail, null, /*#__PURE__*/React__default.createElement(TextLinkCaret, {
          id: "view_order_cta",
          surface: props.isDarkTheme ? 'dark' : 'light',
          disabled: false,
          iconPosition: "right",
          onClick: function onClick(e) {
            return handleViewOrderDetails(e, item, configDetails);
          }
        }, "View order details"), " "), /*#__PURE__*/React__default.createElement(TroubleshootIssue, null, /*#__PURE__*/React__default.createElement(Button$1, {
          size: "small",
          use: "secondary",
          surface: props.isDarkTheme ? "dark" : "light",
          onClick: function onClick(e) {
            return handleNavigateIssueSelector(e, props);
          },
          "data-track": "{\"type\": \"link\", \"name\": \"Troubleshoot new issue\"}",
          role: "button",
          tabIndex: "0"
        }, /*#__PURE__*/React__default.createElement(TroubleshootIssueText, null, "Troubleshoot new issue")))) : /*#__PURE__*/React__default.createElement(Fragment, null)));
      }))), howManyPages > 1 && /*#__PURE__*/React__default.createElement(PaginationWrapper$1, null, /*#__PURE__*/React__default.createElement(Pagination, {
        howManyPages: howManyPages,
        setCurrentPage: setCurrentPage,
        currentPage: currentPage
      })));
    }
    return /*#__PURE__*/React__default.createElement(NoIssuesFoundDiv, null, props === null || props === void 0 ? void 0 : props.noHistoryFound);
  }
};

var IssueSelectorLoader = function IssueSelectorLoader() {
  var _useContext, _paramsDetails$theme;
  var paramsDetails = (_useContext = useContext(ParamsContext)) === null || _useContext === void 0 ? void 0 : _useContext.paramsDetails;
  var _useFeatureFlag = useFeatureFlag(),
    _useFeatureFlag$data = _useFeatureFlag.data,
    _useFeatureFlag$data2 = _useFeatureFlag$data === void 0 ? {} : _useFeatureFlag$data,
    _useFeatureFlag$data3 = _useFeatureFlag$data2.healthCheckDiagnosticsFFlag,
    healthCheckDiagnosticsFFlag = _useFeatureFlag$data3 === void 0 ? false : _useFeatureFlag$data3;
  var helthCheckAvaliable = {};
  var helthCheckNotEnabled = {
    position: "relative",
    top: "150px"
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "trg-ts-loader",
    style: !healthCheckDiagnosticsFFlag ? helthCheckNotEnabled : helthCheckAvaliable
  }, /*#__PURE__*/React__default.createElement(Loader$2, {
    active: true,
    fullscreen: false,
    surface: (paramsDetails === null || paramsDetails === void 0 ? void 0 : (_paramsDetails$theme = paramsDetails.theme) === null || _paramsDetails$theme === void 0 ? void 0 : _paramsDetails$theme.themeId) === "theme_dark" ? "dark" : "light"
  }));
};

var ErrorComponent = function ErrorComponent(_ref) {
  var _useContext, _useContext2;
  var handleTabChangeEvent = _ref.handleTabChangeEvent;
  var paramsDetails = (_useContext = useContext(ParamsContext)) === null || _useContext === void 0 ? void 0 : _useContext.paramsDetails;
  var additionalInfoSteps = (_useContext2 = useContext(ParamsContext)) === null || _useContext2 === void 0 ? void 0 : _useContext2.additionalInfoSteps;
  var Provider = ConfigContext.Provider;
  return /*#__PURE__*/React__default.createElement(UserProvider, {
    value: {
      paramsDetails: paramsDetails,
      additionalInfoSteps: additionalInfoSteps
    }
  }, /*#__PURE__*/React__default.createElement(Provider, {
    value: {
      paramsDetails: paramsDetails
    }
  }, /*#__PURE__*/React__default.createElement(ErrorScreenAcss, {
    handleIssueSelector: handleTabChangeEvent
  })));
};

var _templateObject$1b, _templateObject2$Z, _templateObject3$P, _templateObject4$O;
var SearchResultsContainer$4 = styled.div(_templateObject$1b || (_templateObject$1b = _taggedTemplateLiteralLoose(["\n  padding-top: 15px;\n  padding-bottom: 15px;\n  position: absolute;\n  top: 52px;\n  width: 100%;\n  ", "\n  box-shadow: 0px 1px 5px #939292;\n"])), function (props) {
  return props.theme.themeId === "theme_dark" ? "\n  background-color: " + props.theme.themeObject.background + " !important;\n  " : "\n  background-color: #fff\n  ";
});
var SearchResultsList = styled.div(_templateObject2$Z || (_templateObject2$Z = _taggedTemplateLiteralLoose(["\n  width: calc(100% - 35px);\n  min-height: 50px;\n  max-height: 300px;\n  overflow-y: auto;\n  padding: 0px 10px 6px 15px;\n  ", "\n"])), function (props) {
  return props.theme.themeId === "theme_dark" ? "\n    &::-webkit-scrollbar {\n      display: block !important;\n      width: 10px !important;\n      background: " + props.theme.themeObject.background + " !important;\n    }\n    &::-webkit-scrollbar-thumb {\n      background-color: #acacac;\n    }\n    " : "\n    background-color: #fff;\n    &::-webkit-scrollbar {\n      display: block !important;\n      width: 10px !important;\n      background: #dedcdc !important;\n    }\n    &::-webkit-scrollbar-thumb {\n      background-color: #acacac;\n    }\n  ";
});
var SearchIssueText = styled.div(_templateObject3$P || (_templateObject3$P = _taggedTemplateLiteralLoose(["\n  height: 45px;\n  display: flex;\n  align-items: center;\n  span {\n    color: ", ";\n    cursor: ", ";\n    margin: 0;\n  }\n  span.intentLink {\n    cursor: pointer;\n  }\n"])), function (props) {
  return !props.isDarkTheme && "#0065ff";
}, function (props) {
  return props.options && "pointer";
});
var Overlay = styled.div(_templateObject4$O || (_templateObject4$O = _taggedTemplateLiteralLoose(["\n  background-color: rgb(152 148 148 / 40%) !important;\n  inset: 0px;\n  position: fixed;\n  padding: 1rem;\n  z-index: -1;\n"])));
var SearchResultsStyled = {
  SearchIssueText: SearchIssueText,
  SearchResultsContainer: SearchResultsContainer$4,
  SearchResultsList: SearchResultsList,
  Overlay: Overlay
};

var releventFilter = function releventFilter(array, filterOn) {
  console.log("array filter", JSON.stringify(array));
  var charCount = 0;
  var items = array;
  if (filterOn === false) {
    return items;
  }
  var queryWords = filterOn.toLowerCase().split(/\s+/g).filter(function (word) {
    charCount += word.length;
    return word.length >= 1;
  });
  if (!items || charCount <= 2) {
    return "";
  }
  var newItems = items;
  if (filterOn && array) {
    newItems = [];
    var getItemRelevance = function getItemRelevance(item) {
      var relevance = 0;
      for (var wordIdx in queryWords) {
        if (queryWords.hasOwnProperty(wordIdx)) {
          if (item._lowerCaseTitle.indexOf(queryWords[wordIdx]) > -1) {
            relevance += queryWords[wordIdx].length * 1.175;
          } else if (item._lowerCaseSyns.indexOf(queryWords[wordIdx]) > -1) {
            relevance += queryWords[wordIdx].length;
          }
        }
      }
      return relevance;
    };
    array.length > 0 && array.forEach(function (item) {
      if (!item._lowerCaseTitle) {
        item._lowerCaseTitle = item.title.toLowerCase();
        item._lowerCaseSyns = item.synonyms ? item.synonyms.toLowerCase() : "";
      }
      var isDuplicate = false;
      var wordRel = getItemRelevance(item);
      if (wordRel > 0) {
        item.count = wordRel;
        newItems.push(item);
        isDuplicate = true;
      }
      if (!isDuplicate) {
        item.count = wordRel;
        newItems.push(item);
      }
    });
  }
  var finalItems = newItems.filter(function (element) {
    return element.count >= 3;
  });
  finalItems = finalItems.sort(function (a, b) {
    return b.count - a.count;
  });
  return finalItems;
};
var finalAppend = function finalAppend(array) {
  var finalItems = [];
  if (!array) {
    return "";
  }
  if (array.length === 0) {
    array.push({
      title: "No Matches to Your Search, Try Different Words.",
      displayTitle: "No Matches to Your Search, Try Different Words."
    });
    return array;
  } else {
    if ("undefined" !== typeof array.unshift) {
      finalItems = array.sort(function (a, b) {
        if (b.count === a.count) {
          return b.usage < a.usage ? -1 : b.usage > a.usage ? 1 : 0;
        }
        return b.count - a.count;
      });
    }
  }
  return finalItems;
};
var highlightMatchesFilter = function highlightMatchesFilter(array, filterOn) {
  if (!filterOn) {
    return "";
  }
  var items = array;
  var filterWords = filterOn.toLowerCase().split(" ").filter(function (x) {
    return x.length > 1;
  });
  filterWords.sort(function (x, y) {
    return y.length - x.length;
  });
  function highlightWords(item) {
    if (!item) {
      return "";
    }
    var highlightedItem = item;
    filterWords.forEach(function (word) {
      var wordIdx = item.toLowerCase().indexOf(word);
      if (wordIdx >= 0) {
        highlightedItem = highlightWords(item.substring(0, wordIdx)) + "<strong>" + item.substring(wordIdx, wordIdx + word.length) + "</strong>" + highlightWords(item.substring(wordIdx + word.length));
        return false;
      }
      return true;
    });
    return highlightedItem;
  }
  array.length > 0 && array.forEach(function (item) {
    item.displayTitle = highlightWords(item.title);
  });
  console.log("FINAL INTEMS OF HIGHLIGHT ", items);
  return items;
};
var uniqueArray = function uniqueArray(array, filterOn) {
  return array && array.length > 0 && (array === null || array === void 0 ? void 0 : array.filter(function (v, i, a) {
    return a.findIndex(function (v2) {
      return v2.title === v.title;
    }) === i;
  }));
};
var isDark$1 = function isDark(paramsDetails) {
  var _paramsDetails$theme;
  return paramsDetails !== null && paramsDetails !== void 0 && (_paramsDetails$theme = paramsDetails.theme) !== null && _paramsDetails$theme !== void 0 && _paramsDetails$theme.isDark ? true : false;
};
var getPaginationDetails = function getPaginationDetails(currentPage, symptomsPerPage, intentList) {
  var _intentList;
  if (currentPage === void 0) {
    currentPage = 1;
  }
  if (symptomsPerPage === void 0) {
    symptomsPerPage = 10;
  }
  if (intentList === void 0) {
    intentList = [];
  }
  if (!((_intentList = intentList) !== null && _intentList !== void 0 && _intentList.length)) return {};
  var indexOfLastSymptom = currentPage * symptomsPerPage;
  var indexOfFirstSymptom = indexOfLastSymptom - symptomsPerPage;
  var symptomsOnCurrentPage = intentList.slice(indexOfFirstSymptom, indexOfLastSymptom) || [];
  var pageCount = Math.ceil(intentList.length / symptomsPerPage);
  return {
    symptoms: symptomsOnCurrentPage,
    pageCount: pageCount
  };
};
var focusIntentListFirstChild = function focusIntentListFirstChild() {
  var firstItem = document.getElementById("intentListWrapId");
  if (firstItem) {
    var interactiveEl = firstItem.querySelector("a");
    if (interactiveEl) {
      interactiveEl.focus();
    }
  }
};
var getVZDLObject = function getVZDLObject(vzdlKeyArray) {
  var vzdlObject = {};
  for (var _iterator = _createForOfIteratorHelperLoose(vzdlKeyArray), _step; !(_step = _iterator()).done;) {
    var key = _step.value;
    vzdlObject[key] = "";
  }
  return vzdlObject;
};

var SearchResultsContainer$5 = SearchResultsStyled.SearchResultsContainer,
  SearchResultsList$1 = SearchResultsStyled.SearchResultsList,
  SearchIssueText$1 = SearchResultsStyled.SearchIssueText;
var NoResultsComponent = function NoResultsComponent() {
  var _useContext;
  var paramsDetails = (_useContext = useContext(ParamsContext)) === null || _useContext === void 0 ? void 0 : _useContext.paramsDetails;
  var isDarkTheme = isDark$1(paramsDetails);
  return /*#__PURE__*/React__default.createElement(SearchResultsContainer$5, {
    theme: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.theme
  }, /*#__PURE__*/React__default.createElement(SearchResultsList$1, {
    theme: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.theme
  }, /*#__PURE__*/React__default.createElement(SearchIssueText$1, {
    isDarkTheme: isDarkTheme,
    "aria-label": "No Matches to Your Search, Try Different Words.",
    tabIndex: "0",
    "data-track": "{\"type\": \"link\", \"name\": \"No Matches to Your Search, Try Different Words.\"}"
  }, /*#__PURE__*/React__default.createElement("span", null, "No Matches to Your Search, Try Different Words."))));
};

var SearchResultsContainer$6 = SearchResultsStyled.SearchResultsContainer,
  SearchResultsList$2 = SearchResultsStyled.SearchResultsList,
  SearchIssueText$2 = SearchResultsStyled.SearchIssueText;
var SearchResultComponent = function SearchResultComponent(_ref) {
  var _useContext;
  var currentActiveSearchID = _ref.currentActiveSearchID,
    _ref$searchFilteredRe = _ref.searchFilteredResult,
    searchFilteredResult = _ref$searchFilteredRe === void 0 ? [] : _ref$searchFilteredRe,
    handleSubSymptoms = _ref.handleSubSymptoms;
  var paramsDetails = (_useContext = useContext(ParamsContext)) === null || _useContext === void 0 ? void 0 : _useContext.paramsDetails;
  var isDarkTheme = isDark$1(paramsDetails);
  return /*#__PURE__*/React__default.createElement(SearchResultsContainer$6, {
    theme: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.theme
  }, /*#__PURE__*/React__default.createElement(SearchResultsList$2, {
    theme: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.theme,
    role: "listbox",
    tabIndex: -1,
    id: "searchDropDownList",
    "data-testid": "searchDropDownListId",
    "aria-relevant": "additions text"
  }, searchFilteredResult === null || searchFilteredResult === void 0 ? void 0 : searchFilteredResult.map(function (items, index) {
    if (items !== null && items !== void 0 && items.title && index < 10) {
      return /*#__PURE__*/React__default.createElement(SearchIssueText$2, {
        role: "option",
        tabindex: "-1",
        isDarkTheme: isDarkTheme,
        options: items === null || items === void 0 ? void 0 : items.symptomId,
        key: index,
        id: "searchBoxCurrentID" + index,
        "aria-label": items.title,
        "data-track": "{\"type\": \"link\", \"name\": \"" + items.displayTitle + "\"}",
        "aria-selected": currentActiveSearchID == index,
        "aria-live": "" + (index == 0 ? "assertive" : "off")
      }, /*#__PURE__*/React__default.createElement("span", {
        "class": "intentLink",
        id: "searchBoxCurrentIDClick" + index,
        onClick: function onClick() {
          return handleSubSymptoms(items);
        },
        "data-track": "{\"type\": \"link\", \"name\": \"" + items.displayTitle + "\"}"
      }, /*#__PURE__*/React__default.createElement(TextWithHtml, null, items.displayTitle)));
    }
  })));
};
var SearchResultComponent$1 = memo(SearchResultComponent);

var _templateObject$1c;
var InputElement = styled.input(_templateObject$1c || (_templateObject$1c = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 46px;\n  box-shadow: 0 1px 1px rgb(0 0 0 / 8%);\n  border: 1px solid #ccc;\n  line-height: 1;\n  padding: 6px 15px;\n  font-size: 14px;\n  box-sizing: border-box;\n  :focus {\n    border: 1px solid #ccc;\n    outline: none;\n  }\n  ", "\n"])), function (props) {
  return props.isDarkTheme ? "\n      background-color:" + props.darkBC + ";\n      color:#fff;\n      ::placeholder {\n      color: #fff\n      }\n      " : "\n      ::placeholder {\n        color: #000\n        }\n";
});
var InputBox = function InputBox(_ref) {
  var _useContext, _paramsDetails$theme;
  var value = _ref.value,
    ariaActivedescendant = _ref.ariaActivedescendant,
    onChange = _ref.onChange,
    onKeyDown = _ref.onKeyDown,
    searchFilteredResult = _ref.searchFilteredResult;
  var paramsDetails = (_useContext = useContext(ParamsContext)) === null || _useContext === void 0 ? void 0 : _useContext.paramsDetails;
  var isDarkTheme = isDark$1(paramsDetails);
  var darkBC = paramsDetails === null || paramsDetails === void 0 ? void 0 : (_paramsDetails$theme = paramsDetails.theme) === null || _paramsDetails$theme === void 0 ? void 0 : _paramsDetails$theme.themeObject.background;
  return /*#__PURE__*/React__default.createElement(InputElement, {
    id: "searchInput",
    role: "combobox",
    autoComplete: "off",
    onKeyDown: onKeyDown,
    "aria-activedescendant": ariaActivedescendant !== null ? "searchBoxCurrentID" + ariaActivedescendant : "",
    isDarkTheme: isDarkTheme,
    placeholder: "Search issues",
    value: value,
    onChange: onChange,
    "aria-label": "Search issues",
    tabIndex: "0",
    "data-track": "{\"type\": \"link\", \"name\": \"Search issues\"}",
    "aria-expanded": "" + (searchFilteredResult !== null && searchFilteredResult !== void 0 && searchFilteredResult.length ? "true" : "false"),
    "aria-owns": "searchDropDownList",
    "aria-controls": "searchDropDownList",
    "aria-haspopup": "listbox",
    darkBC: darkBC
  });
};

var _templateObject$1d;
var IconContainer$5 = styled.div(_templateObject$1d || (_templateObject$1d = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    position: absolute;\n    right: 11px;\n    top: 11px;\n"])));
var SearchIconComponent = function SearchIconComponent(_ref) {
  var _useContext;
  var searchFilterText = _ref.searchFilterText,
    onClick = _ref.onClick;
  var paramsDetails = (_useContext = useContext(ParamsContext)) === null || _useContext === void 0 ? void 0 : _useContext.paramsDetails;
  var isDarkTheme = isDark$1(paramsDetails);
  return /*#__PURE__*/React__default.createElement(IconContainer$5, {
    role: searchFilterText.length > 0 && "button",
    "aria-hidden": true,
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: searchFilterText.length > 0 ? 'close' : 'search',
    size: "medium",
    surface: isDarkTheme ? 'dark' : 'light',
    ariaHidden: true
  }));
};

var _templateObject$1e, _templateObject2$_, _templateObject3$Q;
var Overlay$1 = styled.div(_templateObject$1e || (_templateObject$1e = _taggedTemplateLiteralLoose(["\n  background-color: rgb(152 148 148 / 40%) !important;\n  inset: 0px;\n  position: fixed;\n  padding: 1rem;\n  z-index: -1;\n"])));
var InputWrapper$2 = styled.div(_templateObject2$_ || (_templateObject2$_ = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 75%;\n  margin: 15px 0;\n  @media (max-width: 970px) {\n    width: 100%;\n  }\n"])));
var InputElementContainer = styled.div(_templateObject3$Q || (_templateObject3$Q = _taggedTemplateLiteralLoose(["\n  position: relative;\n  z-index: 999;\n"])));
var SearchBox$4 = function SearchBox(_ref) {
  var _useContext;
  var _ref$subSymptomsList = _ref.subSymptomsList,
    subSymptomsList = _ref$subSymptomsList === void 0 ? [] : _ref$subSymptomsList,
    handleSubSymptoms = _ref.handleSubSymptoms;
  var paramsDetails = (_useContext = useContext(ParamsContext)) === null || _useContext === void 0 ? void 0 : _useContext.paramsDetails;
  var isDarkTheme = isDark$1(paramsDetails);
  var _useState = useState(''),
    searchFilterText = _useState[0],
    setSearchFilterText = _useState[1];
  var _useState2 = useState([]),
    searchFilteredResult = _useState2[0],
    setSearchFilteredResult = _useState2[1];
  var _useState3 = useState(null),
    currentActiveSearchID = _useState3[0],
    setCurrentActiveSearchId = _useState3[1];
  var _useState4 = useState(false),
    enableSearch = _useState4[0],
    setEnableSearch = _useState4[1];
  var handleHelpSearchText = function handleHelpSearchText(event) {
    setEnableSearch(true);
    setCurrentActiveSearchId(null);
    if (event.target.value) {
      var searchText = event.target.value;
      setSearchFilterText(searchText);
      var relevantData = releventFilter(subSymptomsList, searchText);
      console.log("relevantData", relevantData);
      var uniqueData = uniqueArray(relevantData);
      console.log("uniqueData", uniqueData);
      var limitedData = uniqueData && uniqueData.slice(0, 8);
      console.log("limitedData", limitedData);
      var highlightedResult = highlightMatchesFilter(limitedData, searchText);
      console.log("highlightedResult", highlightedResult);
      var finalAppendData = finalAppend(highlightedResult);
      console.log("finalAppendData", finalAppendData);
      setSearchFilteredResult(finalAppendData);
    } else {
      setSearchFilteredResult(null);
      setSearchFilterText("");
    }
  };
  var handleCancelSearch = function handleCancelSearch() {
    if (searchFilterText.length > 0) {
      setSearchFilterText("");
      setSearchFilteredResult(null);
      setCurrentActiveSearchId(null);
    }
  };
  var handleSearchKeyUp = function handleSearchKeyUp() {
    var totaltSearchResult = (searchFilteredResult === null || searchFilteredResult === void 0 ? void 0 : searchFilteredResult.length) - 1;
    var currentSearchId = currentActiveSearchID;
    if (currentSearchId === null || currentSearchId === 0) {
      currentSearchId = totaltSearchResult;
    } else {
      currentSearchId = currentSearchId - 1;
    }
    setCurrentActiveSearchId(currentSearchId);
  };
  var handleSearchKeyDown = function handleSearchKeyDown() {
    var totaltSearchResult = (searchFilteredResult === null || searchFilteredResult === void 0 ? void 0 : searchFilteredResult.length) - 1;
    var currentSearchId = currentActiveSearchID;
    if (currentSearchId === null || totaltSearchResult === currentSearchId) {
      currentSearchId = 0;
    } else {
      currentSearchId = currentSearchId + 1;
    }
    setCurrentActiveSearchId(currentSearchId);
  };
  var focusSearchInputBox = function focusSearchInputBox(e) {
    var key = e.key;
    if (!enableSearch) return;
    switch (key) {
      case 'Esc':
      case 'Escape':
        handleCancelSearch();
        break;
      case 'Up':
      case 'ArrowUp':
        handleSearchKeyUp();
        break;
      case 'ArrowDown':
      case 'Down':
        handleSearchKeyDown();
        break;
      case 'Enter':
        document.getElementById('searchBoxCurrentIDClick' + currentActiveSearchID).click();
        break;
    }
  };
  return /*#__PURE__*/React__default.createElement(InputElementContainer, {
    className: "ts-search-issues-wrapper"
  }, (searchFilterText === null || searchFilterText === void 0 ? void 0 : searchFilterText.length) > 0 && isDarkTheme && /*#__PURE__*/React__default.createElement(Overlay$1, null), /*#__PURE__*/React__default.createElement(InputWrapper$2, null, /*#__PURE__*/React__default.createElement(InputBox, {
    ariaActivedescendant: currentActiveSearchID,
    value: searchFilterText,
    onChange: handleHelpSearchText,
    onKeyDown: focusSearchInputBox,
    searchFilteredResult: searchFilteredResult
  }), /*#__PURE__*/React__default.createElement(SearchIconComponent, {
    searchFilterText: searchFilterText,
    onClick: handleCancelSearch
  }), searchFilterText.length > 0 && enableSearch ? (searchFilteredResult === null || searchFilteredResult === void 0 ? void 0 : searchFilteredResult.length) > 0 ? /*#__PURE__*/React__default.createElement(SearchResultComponent$1, {
    currentActiveSearchID: currentActiveSearchID,
    searchFilteredResult: searchFilteredResult,
    handleSubSymptoms: handleSubSymptoms
  }) : /*#__PURE__*/React__default.createElement(NoResultsComponent, null) : /*#__PURE__*/React__default.createElement(Fragment, null)));
};

var categoryImages = [{
  name: "screen",
  image: {
    dark: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAYAAAA4TnrqAAAACXBIWXMAAC4jAAAuIwF4pT92AAAB0UlEQVR4Ae2c4U3DMBBGr6h7tBu0G5BOQldgg3SDjgCTEDZgBNgAJgiK1B+R4zT3FeLY8J7kP5YVO08+u1Z9WbVt2xrEOJlZ3a+/Q5MfZAkgS2AdafplZm8jj9ia2Sao+zCz98Xe4HeIvdeQdkjTrfkjpY60r6+0L6W43oswFECWALIEYgt8DhwvJRXbSD9d/1W/IldZ3eDvFx7DJtwhCUMBZAkgSyDXNSvG45WTxRyczWzXf25JsjpRTcL+PsMKwlAAWQLIEkCWALIEStoNX5YeADNLYGpmhb9rYqfzf8OUrKVP/llBGAqUJOtgZquE5TUcADNLAFkCyBJAlgCyBJAlMCUr3KpPWY0+McwsAWQJIEsAWQLIEkCWALIEkCWALAFkCSBLAFkCyBJAlgCyBJAlgCyB2N/32zDdtUc1UjfW/lZi/SxOSTnSh8QXcJvwrgdhKIAsAWQJrC9rQW506WsPOcpKuWh6yXI3LOkC7iBZcmYGV0JLkrV4WLLACyBLAFkCJa1Zz47PuFTO6+ie20DHMKG8JFlPjp85tVOW5+BfkX3/A5AlgCyBvyardmZg3AQzS6Ck3fAc+3zAjOzDR5cka+doMyuEoQCyBJDlxcy+ARIjFhJFvlzoAAAAAElFTkSuQmCC",
    light: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAYAAAA4TnrqAAAACXBIWXMAAC4jAAAuIwF4pT92AAAB6klEQVR4Ae2c0U3DMBRF70Pdo9mgbEA6CVmBDcoGXYFJKBt0BNgAJjCKBFJwXlLfijg23CP5x3Id+8h+iVXbABCU3HQIIWCYbiCSkSwCySLYOEU/AJwnqmgAbKO8NwCvq/Xgd/D65RIHt1Mc2L5TH/Sc8qNAWFtK7ZemIYFkEUgWgRfgV8fMOgBdxnY0Tl5nZu0wo0hZX42/W7kN2/gNqWlIIFkEkkVQaszyeJhZWSzBEcBuWG9Nss4hhFOuh5nZe5ynaUggWQSSRSBZBJJFUNPb8NnMVm2ARhbB7Mgys/i7xlud/xsuTcO1V/5FoWlIUJOsfQjBciUAL3EDNLIIJItAsggki0CyCCSLYFZW/JoG8FhaB3KikUUgWQSSRSBZBJJFIFkEkkUgWQSSRSBZBJJFIFkEkkUgWQSSRSBZBJJF4P1935jZYaKK1subKX8t3nOKoJYz0m3Oo3n9UcK4DZqGBJJFIFkEfYDfF9iu/vjcfQHt+MEm56mFVOJzfqVQ0wbc0WHJhRltCa1J1urTUgGeQLIIJIugppj1lHCNS5u4HT1lN1A3unKlxKtQJq47ubg2nPjdKGltmAHJIpAsgj8lK4RwSDmBcW39GlkENX06HL3rAxbkNq66Jlm7hDKLomlIIFkEkpUKgE84Z9vweFtbSwAAAABJRU5ErkJg"
  }
}, {
  name: "phone",
  image: {
    dark: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEcAAABLCAYAAAAicppkAAAACXBIWXMAAC4jAAAuIwF4pT92AAAFJklEQVR42uVc7ZWVMBCdfQ08Oli2gsUKFiuQDsxWsNgBViBWIFYgHZjtACsQO2AriD8MHsSQmSQTCGfnHH68B4TkZj5uJgM3Sik4mWQA0AGABIAeAMZYD7o5ITgCAL4sfj9rsDruB13gfFKtfj9osCYAaLRmvVrNmQDgajn/okFqU9AcAQDFzmb1VYNgkisAfAKAAQDKoCcppXyPUikl1R8ZlVJZQFu+h1j0YUta3/Z9bsqVUp2hE90B4JgmyiSDz+S5XJwppRpklqoDAZpBGjb6Nimlihjg1LpxTKaDzGt9NBwAUWZiVG4iEwBn7vsUAtDWiYLg6GxSJwJQtmFmJICoztZVnO2bEARiAJRRwJmd7eQIwIhECC5wBv0swQzQgIEjPPxKox9YEK7j0JqljJ5RcQugxgbO4ABKZ1DxGrmnDASntjj+3AOgidpHIDpeiQzS1kYoe+4R0648ohjJvCgDE0TVn2JQ+MUyYWQ034YSYW3guPKVagf2bCOjrsuXEYteNjYpI5gAB3vOLBPaBZpXQwVn9Oy4Tf17xvDeMhBQaZjAf8ApLYPxpe17sWcRGCFNfRVLcPIIYbhFzCuPDJCLCcutyDVfEGOWh53Y89Zk9AGBJFdK/U2TPm8kCn3TnxkA5EgeGEuiS6SNpdSGMbwjpkl7Q8q1WuaQB2ZwOksS/MWwg2AC5wEAfuqBU3PL60E2xHv71e9ymUMWFhPIFA/dd+E7k2eIbjz9psm0YGtx50veCgamXAZymNHD92SG5xW2Rn2IFeaEM2JH24BlgthysI59F8uTXSAZbBFzKpg4TKHcV96UqLsef7Pc1JMbzuqW4JhLAHiynP9gcfo2p/5o+L8l7Ij2yBayScb/ghFid1Rf0UVMuDcefrDyYPvreyTVZ2CmlSNpj1CSNzoCnnlErXUgkBeDKvuY1qj3r7fuFYH7442hsgIjmWvOkzs+s7ggZGhNslwG4EPGqCQNCOx3cARnBICP2j++BYDKVIIyAMD9BrPNCE70/ca5x8ACo1Zrr1wEEBm1nsMhhCpCyjQ/wVYx+bgQVZhqWjbfc3VYJ6UhHqG5fC3ac7HYd4j2fLZoT3sWxbHVBEodMk1yh5S4Zvr8VtrijQdj3l0uSOTxDc0ToiHdmX0OtlKn5knGiBt90Q/flTF1zbTHRt9h4GCzTxmc3LGOh/WgFGlXAPDNkg/OkYR5rp2vLadcEh10tlg29Ef7HMrstwzmZeM/uU5W9YHJs2h1yFiREsU5Y5nCZRq10NcPEUtbWOuQWwbm2xE0yKX0rk0FHKxIQCr/0rMQKVMAh1Ik0B4AUDTz4i4SoKQ1YgDUpwIOZWAxAMKurVIAh7KzSQ21GEC9BjpnDArRwaFyFypA3cJ/dBYt2LNyDEIbqAnmIBy0kSMoiFTAoXAX1g7vWTnG1VkKQJyEDfNVMiVwqAD1jE4TW9LUKYFDBWhgXDQ2MdMhMWg3BaCJ0Q9FK8yMtWijRDEuM8M4V5MaOHOKlbLCHlW8146Ccj8xv2XR6azdL+S6WwD4rncrfL9DMRH6susXCThe5DD5oiqCCUsV+aX7mJHFNJicyfl3KfocjvfUG8uMRwXmCHBmM+sdAJoMhC46MEeBs1zVu+SL51cqKTkgFg519MeFMr3v/sTY5iPXXnwqX14qdSi/TwWYFD9LJTRIV8f7XHZNTwvObGq1Pq5HAZMqOMs99sZSnRoVGKx46WgZtZndbRRh/tClt9EqxM70KbxcgyX0WqokrKmC5DftUjMW5EOYegAAAABJRU5ErkJggg",
    light: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABLCAYAAADTecHpAAAACXBIWXMAAC4jAAAuIwF4pT92AAAFRklEQVR42u1c7ZGVMBQ92Qb2dSAdiBVICXQgHYgdYAd0IHbAVmDsADtgO8AK4o8NDoP5uElueHkzMpNxfGxIOLnfOUEopfBolxCiAdADmAFIpdSabawHBWgC8Onw0wuAWSk1/QfoDaANwLPh1iuAgROopwcEp7WAAwDvAHwTQqxCiI5lQKVUUgNwAzAAuKU+K2C8DsAEYAOgHE0CqJLGS5xsf5ikvAIgC1iLA6QNQH8pQABaAKthMv3VIB3m1GiJsQE1xUh56CRqzyQ2APW9QNJz7Byqt4SCRB200iugCG25J0AH1ZscIFUsAB0M8EYEZ2/DvUHySNNGlaRYUaW0uhCQast7kNTNZuyWBGD2tnK6/hTAtSYsMebgbGdkIAjSI2UjEzjVYdU7ZpBGTz+nQXNJR3tQRdfftgwA9Qb1aBjVrXUBVAUAYwy6dFbt6nNLBMgm2WOw234DiTzHvRMFHOtktBS6VG1OBGjzSHOdKJEKwBQL0EyJG7Rxdz2nZ3DZq0NKOwapbEIB6gMHHT2qVjElxrYxukDDf5ZMaQNIcgR8Dk/BGmVrO7IwgDT4pMgH0BQ5+exRtl4Mm3NoAp6xuqTIhWR0CcOjBqxRtiVEIauzJUypzgBZY5kMrjkqq44ASQZI0WYLHikeqE6IfrNH2Z4F6SOdy2pKNZI9g6GoFu32tVSQi1wWSSAFqRa7WZ8BWrhWmhA4yoDgcKOmK5ZFGYh9V9MC+vQ4yjUTqo63iBXtiGPPkVI0mhbRZ833dksM44OSV4cX7AIy/yBbZJC+zVTuSLJDhBhovCLGMWjDShzzH3fv00NywEiJoiMy7zFSRZsYb2x4/4YST/wVt4Q8LCVcmGIk0fCyQ4Tt7M9bz7NlA/ZZb/m6Ltf9L0qpJXLntwPw8/TzZyFE5el6fpeGMNyZJXJ7Ok1mjgRgN6y2q07cIe+Ivx0vefr/xwiAjOSFlxiANKPi1XL7E2HFXc9eAXwPBGg1EB+qmMEpyRvJRXv6TompROtKKi19zk6iJhj3Vv/bAKj/4QcJIfYSgIli8qKUaj30lFXTUEzXh1hbpJ89ai+2X1NOdpmV/uLZ5agSpEiWsJkY0mwEqinQYFJt0UfNL3ycKyCOCAnUupLJDRwStAd+xpiIKEU/Lbffs9HjrqD82UicHmP9qpSqCFTdH5bbv7Ut20oH6MkhBZvDFr0TQvQeKZIOKXr2BJbl2yBChk+xRb5t7faRbZAtgj1KQU/o/9XxJ5MQon5YCSJKQRWx95SNR8ROwGLY55IM+/bkWpFOfPsY+ktOgHxF+J6hXrQ42COt7r9y0mpYacCeWjNpJ5PAYFv0YuwE8TknrSYHT3pJVDVfWVZFEEfbkgBKLsoTdlxDWzKthvUoAoGY0BGB5gRJFgMQQdVIxxEygNSXBJBPTXKAtBEWpioCICI5gQOkVbv3hstRXH1ebGAC6ejdpA4pqnsy2FgAIpRnQ0G6Me3/18UARBD7LOfIfAy20gCiBIDRZKxIRzEUA1AgSCPjmD5Va4oBKBAkyZVoelQtuZSS6zikJMY1DdN42ciiOU/6UY9YDQxjtblULfdxyIEI0pLq5TxHsqJV7Yozo21AOjEkqJlPYuciASIcPlEppwlzhxilnGWP+lLCFfFXaV9GMHm6IbE62RXpxQhRcMgJ6/X4osQyCUt6c+9D/31g0Wwl9mHL/Ur4MkLlcdExNeqysnnGcGBNBGfh3isr6htmmnLT6/Yc2P2XDg+2S/fm76h20z0lpzgVSwBqyrkF/RA8QQdQU+6xH+o7ipop32uDLvU5jqzXH3fkTHeR9ZbKAAAAAElFTkSuQmA"
  }
}, {
  name: "application",
  image: {
    dark: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAABLCAYAAADgQt7gAAAACXBIWXMAAC4jAAAuIwF4pT92AAACVElEQVRoge2a7XHCMAyGRa//ywbNBmUDwgSlExQ2YIPSDToCnaBs0LABI4QN2gnSC2fucoqdvMqXAtVzlx8Ey37jsy0pyiTLsoyulLtrFU4mXpH7wNCHEWqdEdFD8UZow06G0wSTENG82Ng2rBb/RvySiI5ElFVce7exfETu/yr71I2DkfkhdsWBdj5Sj31+HQV9xB77hDdCZx6fDaJHIorZvfz3k6CPFdIIFR9aCn0RdSmes3C+4HJJndqB2S+aiLCjUoubDMzq+G457tyd661AZz5pO5CQFGneh/hf54m5/UnQxw5pJBH/Agg4OIf04/lvCRypef9rdLIsntfCxGshPeeXNUHa3nPSFJnVRKgpetKcAeP5qSAe3wbi+Q1of3Tj1cbzqHh04AsRs4+E9psukxGeXNTB43EoPi8AJT/omp+y35/Mha9cBoVyYms7f7hXgb1IPGfHvGAsFJ8/+JbZi8XbOa9F02WzYptYuiEjtmyk9mdQ8TxKFK9PRr4/3lr20Vsywh8WSi7E44FOSuJhdwEP+wHawx5WEs9PnfOoWp9JzazFNQ4vdfGRL5kpxfOWjGhh4rXoo7jQyOE0AXVSeQb0BbR7dm0HeQB05qGX/Q5fcaEXxlpcgNAqLnSCHZVaWHFBC3Tmq96CjV78XtCnr7jQC5JMau2EVVFVXOgci+e1MPFahM75rb60EqUw2z7H1cLEaxHasO8N9KDVDV5VQSlXX8B3lciFfgHo+3IPuRoX1EaJideiaSblIxk6Gr3JmR/6mzKE0osvi220MPEqENEfbSTMwOjUTAsAAAAASUVORK5CYII",
    light: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAABLCAYAAADgQt7gAAAACXBIWXMAAC4jAAAuIwF4pT92AAACc0lEQVRoge1a7VHDMAyVOP7TDegGZAPCBt2AsgEbUDZghLJBN6DdoCOEDcoE5swZzqfYqeR8qC16d/6RYskvwZGerCAAODhTXJ0rcTDyirjOLL07Qa4VANzEPyRfWOccTkqLAUTcAsB9PNNeWC38D/KIuEDEPSK6jrFBxCpjPw9/77Jv/DqSG3B0OOcgHgBQp+ZlRkPtg4+9wEedsN/SedwnL3kat4hYxz+E6zuBjyVnEpd8ciuMiPmQ5CkefC74HQVJbUfsH0pIWKjUwkUKs2P4QOwlf+59XO/jAARPftt3ISEa7vShk9QBAGYJH83QSYpFPhgvGAT8AlXGvsoQiIf3v8zYt2xNz2vByGtBFOeD1u4SaRvn3L7DvjqiUL2cXks4cULlTKDHV5lo8cy032dCbVmoFCz8O+bEfi60fx6yGKkZc2JQPc7S5xFYxQ93z8/I9TtJ4b7yuRWQ+wSAeG/7m3sU2P+gVJitnXN/eieUeRLy/sVcEXsxeYvzWijdNktyQiB9If0Zziq+LiHBJX8g1+L9SeDfj5eePkYrRujNsosL6XpDZ9h1JsO+DZ1h2XoeEWcheXTtz20cQhM+6iMJrwn6iP7nknreihEtGHktjNFcKEo4peCEykqgxZPNhb6jj55nHfYHtJoLY+FUmwssaDUXBoGFSi1Yc0EL3CefPQU7B/Ibgc+vqW6WRT5o9KdArAu70NVo6fExYHpeC0ZeC8k4Tw6ETgWtOsE+x9WCkddCTpi9FvDhdjdoV4WLZPflaAHOGYKPK1ofRTD9FxfgJwkjr4XSSqqFIJsnVaMXqW2m/qaMg9bBl2kbLRh5FQDANzJR/eIq8gn3AAAAAElFTkSuQmA"
  }
}, {
  name: "contacts",
  image: {
    dark: "data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAYAAAA4TnrqAAAACXBIWXMAAC4jAAAuIwF4pT92AAAE40lEQVR4nO2c4XWbMBDHL375bjpB2MB0grgTlA0ST1C6gUdwJ2gyQe0J6myAJ6i7AZ5AfTSnPhXfCUlIQvjxf0/vJYAF/JBOdyfBnRACElIGACUArAGgAIAVc2knAKgB4AgAewBoYtxCKrByANgiqKXD718B4AXhBdPYsDKE9MVTfQcAqADg7Km+/zQmrAK70IPnei8I7MVzvaPBegaAnWGXe+v8Xxj+7hXP408trMjlWeh1FkLshBCF5rpyIUQlhKh76nrxeW+xQbUAGubGGgRgW+e6B9puirAybDWUatw/pP6tBlg5NVi7CF2F6+KNh4cxyMCv0T/KiX1ndBpr/L895hdx3BvW41OtUf8exOA7PLm9prlTT7Q9/hjqaVu24jxGN2whcfbGVV7sCFM4+zjI2PcdkDOtYqiOAUGpD5hqzc51LjQ9tESb82jYoy8Wvd+7d82c43dn23KIjeRgtYbwh8ZTbi/iGwB8AoAPbSSAcd4dlnb7V4zVqN/GgAUYTnXlPqAYNl+pM+63tR+VYkNcHE/XsibuwdkEdDfoPOydh9GrCDgCcg+qq9q1PtXPyjAfRCXcNhG7jm9RjuSdyznulb+rGwTFSdqtRnGc+6U0V6r7bSN2mVDFxPXZm9hiORpWxMh3wixmSGVMuBRbnzFEOmtDIqRGtap1BONb47l1uauhxcWpPlID0YKZJDgFTv6rg8kS/y7GaFKMHvGaMnX3PeOkhTTo1Kgrga2tDK6ZuFmfHM/HzQGslGt6n2pjmumg6Nyg63EK3SWpUvZc017+Boidg4LNAaDU88cGBpiE5FRysEJkBExBpQqsDdW0WQdf0kUGnMYy+s/E1BugXStDw3IBJTUmMEpBYQ0BJTUGsDOTWiooWKbJPp36QG2IbScsXY0BjMqDrRZENhEGXpgJKMqPa9CnSQEYubBkwTiBrtlEV1BSKQG70oLxbiuHuoaCkkoW2ILpnw8OE5K6DIJtTkwCoyZBlhEyFXT96IxRIc/ZIQVMpaW5PJGJM2xTn89CTSTX8gTcJIXLOgT1BnU3ZgLLpj5fJedYqCfgwhGXbGlhMONsCsu0Pl+Fy3+V6gmoaSMpb2ucHGHFKsax4REnTim1C2SPiaSAQ6kdgJ6Yut/T68QT68s3bT3N/aXSsvryWf+ui1qfZRrTHfA4uQ7LduF+98Sma7VyTwtr+zKlgK5LIT16bjGbjyDYVqaw2mN+RrieSzfNzWUdGiTK2bBb1xUoHSypClfEUMH2reqAXfQqZjbJZ8lRcHPj0A7YMErO/t5TGxm9YCmUN7d85L58iUoH90kOTkZvltnAkqo7TTTzlAUY+hqc71XPV3KB1VUT+tW1VBRjdudmNMOy0AzLQjMsC82wLDTDstAMy0IzLAvNsCyUIqwMY9DM4Nio9aUGSyYdnzzl/Lv1DQKWEqxudnaFAbtrkE7VNwhYSrD2RBrbdW0DlxZfMcsVjJQSrEqztsEGmG7+4OK46OWvUoJV9ywGMQHWB2rYOvsEZoGpqXrunUehmTXWrYj2svo5tY+NSRXYQmy+pXUK1qJQqcICR2BdeQMFiXvwOhtmIq+gYALhjisw76Ag8W6oyrZLfgzwdtlkAmmbFrYJAQomlnUwARb05feppWh0wIJ/JWCK+SwKWJTPKUw1+acCi/PdCQD4Aymw74XoCvsQAAAAAElFTkSuQmCC",
    light: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAYAAAA4TnrqAAAACXBIWXMAAC4jAAAuIwF4pT92AAAE+0lEQVR4nO1c7XHbMAwFe/kfd4J4g6gT1NnAIzgbuBtkhHSCuhPU2cDZQJ2g7gbJBOixB/kUCSDBL30kene8XGyKJp8AEHykZBARpgJjzAoAtgCwAYAKAG6Frv0GgBoATgBwRMSXQYZgyRq7AMAaAA4AYAeNEcVeuyk9jlGJAgBrSY+RBHHlaIl/d2SRm50zEtUUa527En0eJWYZY3ZkUdeK6s+d/yvldT8RcRfZRR4jWNTOYxlnIrJytGFj3J6CvKutw2zdkKxCCuL2831EmxsPaY+zI4uCuRSj7GBXie0/OAjbzo0sadbL5ioOF39JvRmYEuCNMRuKHWvma2tBNSLWVNfW+cPUe0bETXTA5ftlCfvBfJUe8CPu3DFwGj9Spl3kbgdacVIOFkJS7pwoSxwR+ivFx6Rg7/vRtWAVqeVUiqjODe5ZcxGyaEEbslYLqVskw2bGwFlX9BrykyNI/nJkyn8B4DsA3AHAZ0S0E8WK/hr6/BsAPHHXIuIhKdDqcWRqxk8oSvNtyjnUKih+7Ft3OTjxTLCsDTOG6BDQbdyVYT9mSByrUjOg40Z1x1HHtnfJs0h4OwmC2/2ArpMVxpheIkmhIhhXrQv2740oCZRQA82OtfrClrly7vcwlMsUdEVN6nPUxOKmQW4RGu3bgTGlmLIZQJZqAmsa5KyqqKZNRNX026J2NTBZlxmTm4iAks9BrapFVDuhLUJYwgqkJxtdCUlasYAuzLo2+T3ZwBsUcHU40O91saax3wit3Lb6dNlq45gvEkcYi+KWTMVcUujT1tOnY9sNex0eiajRCKP+HRx92kpkZVcEAoiaKmHnQciKIGpswqQJYcuqDrngWUL50AT9qmQfGUjSczmyEolqMDhhiHgWpKX/feiZ3ACux8lAteOaQV3SIVOxamJ0xzREUb1erPRcOxhhgg6Gn6hzXUSpiQrXcyoYlPxt6PxVF2PFsDfYS1NlCYtq1Rdn4bEtzGVZnE59Qzp8CFbChiuEamItC3tlvr52/E4u8O07cotzqAQsyNKs5KHJ70Lay2xZ3EZy7Yv+wecQOgOUtSFlMqxtLyNRa4mLdiUpRgSrpTRA546zlixtexnJEjP4diU2qFHJdsYphqyhindt2BmA6zDsKad0MzWyPKrDrkcWut2xmbYfcuz9TYUshZ516VfvfFbAmu6J6tUkQwcd3Gf281RnteisV46DtT6lFCh1qWi9yB8MSZBVUorKsjyxNWfpJb+s6mCtBBErOvzxEfFKu1tvloJOiQYR93Qixp6a+Sh4oomst2b26lmIaN3D+vf9OyfNknSHiFsp/l5xH3Kgtd2BVv3Nk1tfS/Y+EN0nMTRoNDTVk2VqshqQeV5MlGbPHLJJ0mNwuU89cwgmqwu6I9wm5rtD0Q2LhawPjIWsACxkBWAhKwALWQFYyArAQlYAFrICMDmy7PLJGHOgZdS02htT9/aIjjWn+Uvin7K9tMdpJkpUW/OvOvVUZAntJRE2JbKk/bo3hGnI8sjieZ4KG5ks3zsfKg1ZJQ+VTIYsLWEuskqfvpkUWQrC0LEZWvyY0uTIUhLGleLnuSb1ZrY2SOs/Kd9oJIHd0orFZDN4GqB0oE2DrETB1Jc7CYRlJ8pism7YRoRLfinwdNk8FtKBFnZfgiiYk+qgJKzow++zkmg8hBV/S8Ds9CyBsEFepzBL8a9D2DDvnQCAfxLmlBnTcLwWAAAAAElFTkSuQmA"
  }
}, {
  name: "battery",
  image: {
    dark: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAABLCAYAAADpqX6aAAAACXBIWXMAAC4jAAAuIwF4pT92AAABEUlEQVRoBe2a3Q2CMBRGi3EP2UQ3kU3UTXQT3cRNME18MFj6A/c0iN9JeKGUnpDv3ocbmr7v3QQmbRrQlG7YGBxaDclSbA1f/Iis7S0OsCywWMGUPh/kb2NwMHxXEB+DzjnXFe6zyGAs4yGu/su2VgVQSOmZd/VZilV0g5sPdGWXT3zBH4c3x2SfPtDV1L4JtkFllkKyFJKlkCyFZCkkSyFZCslSSJZCshS5sy6LsXyK5FRRMaCQLEVugRWP1AkUAwrJUkiWIrd1nSu4JM/IlT3Nd0mSlFVmKVZZYBfYI4sldYMkyiyFZCkkS6EhB4VkKTTkoFAMKCRLMVZgXY1fTCO0oaUx2d37WhTKLMXvyDrnXg4sG4dp2KG1AAAAAElFTkSuQmCC",
    light: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAABLCAYAAADpqX6aAAAACXBIWXMAAC4jAAAuIwF4pT92AAABHElEQVRoBe2a2w2CQBBFd419SCfaiXSidqKdYCd2MoaED0PYl+zZ+Lgn4YfXnJA7GzLgzcyV4r0vv2iGmfnSazZri7ZEshTbije+R47taxSo1mCxhik9P8R/xsB7f6h1r2AN51w/bSXUyGAs40tcxyfb1WqAQkprDlpnKX5iNbiNgW7s8srY8Mf5zpDsw8yGZmozQsugMkshWQrJUkiWQrIUkqWQLIVkKSRLIVmKrFlXjbF8ipypomJAIVmKrAZ7Z6ROoBhQSJZCshS57wZnWsTMkjVyP9qd1uskScoqsxQ/+aH5Antkkfsig68GOSizFJKlkCyFhhwUkqXQkINCMaCQLEWowfoWv5hG6JYOhWR30/ZRKLMU3yPrnHsCbrU2h/kGniUAAAAASUVORK5CYA"
  }
}, {
  name: "audio",
  image: {
    dark: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABDCAYAAAA2weP+AAAACXBIWXMAAC4jAAAuIwF4pT92AAADdElEQVR42u1c0ZGbMBB9ZvwPHcQdmA5MByYVHB2EVBBcQZwKgiuIrwO7A9MB7gBXoHxEnnE4rZA5kFbgneFHB2h58/ZptavzQggBTy0CkAIobU4aeApWCqAGkNmeeOkhq0oAW1cOBB6yauvSieWLVdNiGAtW+cAwVqzizjB2rOLKMLas4sgwE1ZdR5w/8wWwCMARwB8AIXHPDcD3EZPUEsBv4x2DEMLVlQohGqG3kxBiJe9PiL9/xoey9b591zMugIqEEMcOoBohRN56bmjASmLuTPdcwFCrzgBiAPuRfTkR43sAK9ca9oxWJRLUsa0E8EsxHmr1jKFWUdcYGgaNPOS2NayvVtkGLBJC1IRvkS0N46RVXdYQKUsIoBhbwzhqlekCcFCMf2svAEuJ7lBJYawB6s6qzCJQeyngF4N7cxkZoWIXUDyKfiHGt2e0aigNKx/mjg3nKAjfreZhLrSqBPBmlCZ8ZKRKyzKbeVhhWauKB7DutlYJOLEAHIhFzIuKa1/duinGf+gy+BY727btAmwHYNHjOjMArJErMMU+kxXzSrFsigyDXBV3ivE3Q5adiAxgsoDpQjPtCVgydcAaYtXLXgx7TsDXckeis5pIL6KpA1YDqCi2GOSPH56bOmBaPepjcwCsGRBozJVhfS2ZA2CD2hwAiwd8Vz0HwKIBgZ4FYAmxdeoF9BwA2/QEbDVHhqm2QVd01+ciAF9egJmnGSr9qqYekikRjuVndG+qgEVQVyoqQ4alFDOXGoSLHo6uGFUpVBpUGH7D+lnANgSdfbA91B33M/41mfvoXnVfKAJL4WGbXe1K6w3mzepMp3uBpQ/ILQJ2kZLyCFoOs1ZfRoTy0SZgIYCfUgNWDkDbwbyRq9K490ewlxi2/BGDPrGzkR9SwE4X/CL9qQ3vzwl2/e8r4wN0ts6H3c+INSbvHyMkjzL03jv2dxfL2tblc2gSomNpWCOTv69Q9wZdaRsViqoU6qCUK8bHzG2EZKLxJ3J17Jwr22JNIpuBaJ4ElnWCk7ZRunXQ7Qhsb745sS1V+FB17QhcVSs4sK29I6hg0OB1Wd7hwLY7aFfpS2fTd8Hkhz76/nPpGZ9o+/cxLgVEE7axMG4VVxNtewHmE9s41/RZso17E4Qd23zpGrFhm09tNhZs87Ev6ZRtC49/oQ4SuNrmhH8BSMSYze0cY2IAAAAASUVORK5CYII",
    light: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABDCAYAAAA2weP+AAAACXBIWXMAAC4jAAAuIwF4pT92AAADr0lEQVR42u2c7XGbQBCG39X4v+nA6kB0IDoQqcCUoFQQ3AEdhFQQpQO5A9SB3AGuYPMj64nM3HEHgvsA3wyjGT5Pr57d29tbRMyMGBsRJQByZq5dPncTqVg5gCuAwvWzHyKkqgZw8NWHTYRUHXz24+GLqgURFgpVwRMWGlVBExYiVUESFjJVwRFmSdXbjM8vohCMiBIiOgH4DeBRc9o7gO9zBalEVAP4KZ/mxsxeNgA5gBYA92xnAFs5P1Mdv7MPded+lfEaD0IlAE4GoVoAx851kwqmEOtjK/qu2wToq14BpMxczdyds2Z/RURbryY5lqo5CZN7VjpX4M0kh/oql4LJfXU/5NGpYFNQ5UiwRNyEqm+JE8GmosqFYD33Vo6aQVPlSjDDqPnpR32QKHeqoDDtCUA/RsCCma+ORuUKQM3MjcXpR7GMbv8LAOXtjtJAxBTbKKruIeyGmFbCFJtnqLRoO+fMLtggXzWFYArzaga4lN5g1kXgWroyQTHDEsBzZ/dO9pumiS2AX4pDedSrRoZWyYS92370RvD/m2oSfjAJ9sLMNHQTp+61CSWZjnaL68+qVJJM6xZJGGRUfFEcerak7KyJAJYpmME085GCZYsWTExTlfEovggb5sB3sn7QJ7ZqVH8komTRgskXv+hoMTTVAJYunbBefxTtqtHMrZ0yI7tWwsa2bA2CTdrWIFg64b2uaxAsmVDoVQimGhGbsUKvQbD9SMG2qyNMU2TyZsrPyUzgSRUIL52wYmSYofJfl0WbpOSv9pbzS2u/t1moWIkmU3GRBKGp5ToydRWImU0O3NJR+spSPCn2lxZibwHshgq21+AcA10V1NVBr8x8Gun3Lh8DhQuTTDzQ1c20vsN+sbro83suBKuJ6OhKLcnnZx3RjjZLfRKGqEz51LVrdrCdcceCLoavfKf4l9opBzzjqnjG6VNtxcTpjxT66sI9gIaISgfVhWDmhohS20VksQIVXVX3xsGXOjkod0o0fT7PXuMqI9EWwB/D/K5x6dsM7QR11VGp+oLBl2vOXIF41PSr9lXjOkmRHeYpCs56+pN4rdO/lzZMX6ef9vQnD+LFhntom0Gw6xBT9PYmyFjaHBHWBPfqzFjaZvJht6I1Or8VhGAjaCtmGiVTMU+ruJBC+KOPO14ufWXmzGVfg0ggMnPLzDmAb1DXdAXTgsq4Ws4SvgSLibZgc/qh0hb0IkiItEWxahQSbdEss4VCW3Trkr5po1j/oU4C3q3L95gA4C84CQdnkHbNQgAAAABJRU5ErkJg"
  }
}, {
  name: "setup",
  image: {
    dark: "data:image/png;base64, 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",
    light: "data:image/png;base64,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"
  }
}, {
  name: "internet",
  image: {
    dark: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABFCAYAAAACRBuaAAAACXBIWXMAAC4jAAAuIwF4pT92AAACYUlEQVR4nO2c/1HCMBiGXz3+hw10A7uBuIEbgBvgBOIGbEDdwBFwAukGjIATxIuX3pXSJn1raJPwPXe5HldowsP3hfyg3CilECAZgE8AzwD2oTTvNoA21NGidgDuzDELpWGhySpFTc3jaUjCQkrDuqgqP+b8YbzmhRNZNlEwko4Dt+mMEGS5RBUA5iIrIlEYWVZUojCirOhEYSRZUYoCKWvpob5oRYGQlQPYmmNfohb1hx6UOkquTsk7vKZeMqXUUbWzV0rNelx30MKKKmGEJSFKF9t0R6fNtyUoPzr0YyGn3r0p3XHYXFoiQjkiLPSIWjve2xmuDl536C+W84uWTj/+zryBLt+GrLAkRWkmHZ9Xyti2nF+Y4yZVUSBkaboIW7ScQySiikr7svqHzk53XClpa0QMEbUy7Zw3rf33mRuywqJOvSp9J9JdhSUjCv9cdXAJS0oUPCzRtAlLThQ8rWfVhSUpCuTQwUY5rFilKgqeV0pzMzZJUhQC3b4PFpFFILIIfHXwl6acgjDkvn8bEZOsN/I1O9+yJA0JRBaByCKIWZbeXXoypRiiwlg6+CYOphPHULMGSUMCkUUgsghEFoHIIhBZBCKLQGQRiCwCkUVwCVl67UmRZX2xd+gRiSwCkUUgsghEFsFQsr70XbOmvA9Up3cksghEFsGkxxhnV1nOvSomPTYvca2yJA0JRBaByCJoklVUNi9fg235CDRtsh6vtQN3IWlI0BRZWSWyZp7qqV6Tu3u0nWXlB26+/gVpU7vR6YQmWfpOqEdPlV/ymnem+OTBdi1JQwKRRSCyugLgF8pSWSYhM+emAAAAAElFTkSuQmCC",
    light: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABFCAYAAAACRBuaAAAACXBIWXMAAC4jAAAuIwF4pT92AAACgUlEQVR4nO2b61EbMRRGv5vxf+gAOsAd4HSQEpwOQgWQDigBOkgJmwqCO6AEqOBmbkbMLLH28a21u5J8z4zGYHsl7bHe0oqqIjdEZAvgF4BvqvqSS/a+ZJCHTwRRDYArew3/Z0FWslqiLsJbFzkJy6YaRkS1eQewVdXX9XKYSckaEGWYpLeFs3XE6rJGiDoA2KnqecsqSRTWlFWaKKwlq0RRWENWqaLAyBKR/amJlSzqHzbOGgoAnuyr9jrm+7Fg46TQ/WtHsGnN5dT4lwiMKJ0qrAZRg7IiomhhtYiy0DndCe3Ln54a/Kyqve1Yzm2UiFwDuKYuGigV+54S0VvCci9RAB4G7u04jIiUFlZC1ZtFFiuslDZqNlljhZXUmM8qa6SwvpBVr9ch6yV0SE30R5+QyBRh2Q0POmTtWp83/39Ozw1V1arbd+KSvKcwBJMm0oSwakThlFWHEcKqEoVTl2h6hFUnCinWsyLCqhRlbFJEYsJExP78UasopFwpNWGquq1VFHLcvs8Zl0XgsgiSNPBzIyI76zjIZJ5Sn40oQlYQdU9e04QzEsnwakjgsghcFkHJsp4BfA3hsESCpTTwMV5V1Rpx6y0XmTV4NSRwWQQui8BlEbgsApdF4LIIXBaByyJwWQTJZdlCnYgoGR7mvMlUeMkicFkELovAZREsJeu3qtoxctvj/7lQmsnxkkXgsgg2E8Y4zcdy7rmxmbB5ibCBeXZ4NSRwWQQuiyAm69DavLzLNucrENtkfWttXtZ+/xReDQliJWsrIh9Dg8tE6bTj5J4e7WYfDrkhPI2WgsfWUYCjOGOy7BHd20SJzxnnVQgpuemLy6shgcsicFljAfAXa729LjbRHKEAAAAASUVORK5CYA"
  }
}, {
  name: "text",
  image: {
    dark: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAYAAAA4TnrqAAAACXBIWXMAAC4jAAAuIwF4pT92AAAFgElEQVR4nO1c7XHiMBBVbvI/6iB0EHcQdxA6CFfBUQIlcBWcqeAowVRwpgPSgalAN2ZWGce8lVZGMtjkzWgu4wNLeqxW+yU9GGPUFZF12kwp9ewZzl4pVSulSqVURf/WQ0zhGmTNqeUCYqTYE2kFEZgEQ5HVSMxSKbVQSj0l7qshbq2U2saWuNRkNSStlFLvKTthcCTS1rFIS0WWpkFeQtKu876Xnu+xpK0uGMsJKcha0sCky21H+qZpB2ou5CSxGf0tJXFPaqC/TmvIitS0MaY0MhTGmHmkfmfGmKUxphL2verbVyyiMmNM7RlkTQPVEX8gNI5CQFjZZxwxBri4AZKQtPlIOxC5g5HlI2o7MEndlnuWZx1CWCqi6og6KUZbxyAsBVEVLYNbIcq2uUOvigjr2ymHay87X3NtRAff2EM7mzk6K26YpHbLHHqsjEkW18lYiLLNJWGsHRbSwYp5eXXjS68PYVB/Sd2dxrX4B54fyfUYJJ6UAE2o6C947Z7m/AU/hP03jijCfMREKQrj/AbPX6DjLRBXbvdbj3DpcQ3p4rqrXiQvOoAXebfZkbVcouz7StUtWeexGvIlv0iXT2ctwbMdrfWpAQUHn0gvn+Aiq9nlXsFzTtmPHU3QceMSGBdZC/DsY6JSZYEE4cWaEaFkTVWqLCqysbo4ccGRxSU7pyxVFgV41sT6WbJy8GwvSCZMAUggmqWoQ8i6B6lSJBBoKeYcWWd+EaWq7gVorhlHFsrF3RNZKLeYP4KHSKoakyEEORlzWSuBGkL2jHagrFUxE1q7sGglZG3RiFTnos9p5CogP8kZQWw1TaFlBGmAcMHEmaSpK+0IUi4CXKMzSP1B6URdWRQjyAZzDm2bMJ8D78tMS/3aMyCdhZahRHwbcf/l+QzyNUP+/7ntqwHMBbUP0gKRM9UjDf5JMBN86IkxSyzeBO9wfR/90F1IC0nOBCQmWUNBX6vjmGRJdypXyQ8yBrtw7aoSdRG6s38CkYW3TT84J7SNjYdUn6N+9HgSW/qMC8j3QzgPT0U2HVzpJWnKzFX9Itn6XRnzKrbpgMgK6UTThC1phx4lR4uOCbClcUm/n9F36tb4Q4rYMsDBgcsboocPQvGdAlA+cccpeKQEJdvyVIDmWnFkQUfyjshCc/0mC0AziRqWLLQ9v13TIBwQSCg+fJKF7BWXXzYVoDmeDGGXBY+kC2V8pgTNnArZ+shClu6r0GEeK1DU4yghq2RMiIvPwNwoNEPWp9D4HGnkq71PVLqWzHmjTw58lX+aHOvuS3YTMyW4eW7aetonWTUjXa8TI6tgpOqLypHEs7j40ZjLI9uYMxHaTTdcJSELmQv7lGeRB8SM2fWPSNn7yNKMkTaFahpNJgG3/M5XjiCu1MVZYepIG5ffZAOdfcoko59qvwIKRk8dnS5dYLTQhB5ovLGmPWFr59xQrYMFkqoxK3ZNOzuXN/zpnZsjjo4SDyG1ArfUcs8ZbtG8Uir2LDDJkKJpQf2FWAC4/0DFFZLiEA2uDSivdLJ1wZwO6b1SOIlAcCm/XHDavRiItLngfom6j9Sjh2jSKG9opcj363VR0i8a01abBYyl9xluRIBPsUukSIotTTLUHNE0jlXATSHmkttCDDic2fiBfzob5pHyaHMyJ2LdeYVgLxKrgOE7a7XQMexo7BeZPV2yKmCH2MSF9CIeG4YtKIzDBdWGwAf1H6csXaDYpagYXdRXt12CMsUxP59i96Gm70l1Tt4pGokJW/yRbMe1y5ALq3KIcVWcvf8qp79D9dC+dUFiOcRRGUsWUuxdWF20Tugf2lC1BsUZNmJbX8s/tWQhxW6R7MLBseGRfkG0A6aWolGS1Q7FfEuRA80yPJA++JYiF5RS/wEaBLfPsgArPAAAAABJRU5ErkJggg",
    light: "data:image/png;base64,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"
  }
}, {
  name: "device",
  image: {
    dark: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAABDCAYAAAAiVH0fAAAACXBIWXMAAC4jAAAuIwF4pT92AAACVUlEQVRo3u2b33GCQBDGvzi8Swl0IB2EEuwA0oEl0EHswEsH6SCkA+xAO8AKNi/HDEE47i8K7s7cgyDL/di9j70D3ojoCCDF89sBQO3iIJKg7wuAjV0dbPBC9lKw0cC2KwDx4H4lAPI5YC8AygfDZiFgecwy7PIslvdm5ZhdC2gFYCd/H9ca2T7oJ4BijZHtg7Z2Wltkx0BXJ1BToB8AxOZVQNcQWRXorQu6JIG6yTLWBDTrz383CwHNerDGoKFgkwCgtStoCNhUnkgEAk1sQQEARFTRf6uICBYtJaKm40dY+gERJdKfyn/XmoH/37XIoyoKANvOtnY+Wlj4uwxkTNXzrx9Rj2msGkO5h5T2AuoL9ltVojkCewP1ASugtwyb9+eWc4O6CpQgcyssxc5YjIaabWQPigWxDwBfI/tOGoLlP6IOkS00IycsIhwkom0zhVWBloapXswJagqr6oywHNvFXKAmsLagOsDlHKC6sImiMzURxZonqwyV28S3FzWOZdEwpIxnqYyNphbu5TE6ZurbuahQlYFXi8408pizJWjQ57NCMZXaW171KeAxUAEPbweoYEsJ5u+mrgZWgeah07ge6NTeEXQMODiobgUVS2UsfCpjx7cYUd3+7SpzPV+kGYVQb9M0I7VyBn4YzbAMy7AMy7AMy7AMy7AMy7A+bGjW067IP9LiuWC3WMY3A5zGDKtI4xvM15mm0v6K+1cHpsbsbg7YdqHNxGhiv4DZdwcZgB9OY4a1T2Mb+53Yf1kTbLbUyMZP0Pl0LthdCCVkgWJYhvVif01tr5qU1vlPAAAAAElFTkSuQmCC",
    light: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAABDCAYAAAAiVH0fAAAACXBIWXMAAC4jAAAuIwF4pT92AAACfElEQVRo3u3b0XWbMBQG4N8+qSo9ORvUG9QbhBHYwOkETTdwJ6g3sD1B0g3IBmGDZgP3CQ4vzUOvz1FdhCQkILLvfQSM74cscUHW7MNH+QcJRFNXs9BzzHFFwdhLjZuWbc8AionzygDcjYEtmrraTCkVUm2GwHKfZWxiIaRaCanubX32IqA0yC6EVGjqan+RLatDadPu1MI3Fw6FBj7OrwAKACWAYn4l0Kypq/RbVkiVu0CTH6Bo4Hl0gaaELQ3QXcfx/0BTwZb0YBAEHQR7XrXEgOqJ94VGx54SEVLt3xs0KvYskXUguIgNjVZBCamylkTWVJd6/6ybuipi9NHoLUs39CfD7tAWjgYNxloqFx38MDU0CCukuqUWXTgc/sN3lI4N7Y0laAHgU8vu34aP7VzBQ0B7YTXoZwN0CeDQF2yBHpq6WvWB9m3ZbQc0a+rqSCOwN9gBGlSwzD1bdQ9g3QF90W4fXuChoV5YIdXWAAWABx3qCx4D6oylZL4adn85vdAyFAj3+DvLYAIXY0CdsJar/q0LqkXe9phGcTcG1Io1lIF6MlvH8u9Ij2mlY17RoZ1YSxnonYwH+L9zC6mWQ7esqTp67nvVHcBt0BWAl6GxeUs1VNL23tEBNkFttXc4lm4lGYDX0DLNATw41DpAEXgF4CeAPAa0Bfx9DKjTwzsllWOAoHNvDF1oEfv7eH6WsYxlLGMZy1jGMpaxjL1C7KxljcArgF8T57XE2dRKjDUCM14QwX02/YixRmAJ87TIKQ6e40CG97hGgF6k27D78/9JWM65Aa8RYGzQz9g3jjDP0unHpI/VXqYn2bIZDRBTxiAXjysoHo0Zm1a8ATv+arjhbukcAAAAAElFTkSuQmA"
  }
}, {
  name: "email",
  image: {
    dark: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAA5CAYAAAB+pNYgAAAACXBIWXMAAC4jAAAuIwF4pT92AAACL0lEQVR4nO2b7XGCQBCG32TyP5RAKojpwBLSQbQDS0kJ2kE60HSgHaQEU8FlbmZ/MLjALd7HHtln5n55wPGO+4iwPDjnTjCC8GE5iyqMxxoWqQULS4CFJeBpZOovgB2AH3WrTkcL4BPAM3eEKcH7wN4B/IdfzDWAr6GgEFCGfsMjfcOWzI7OczAoCC8dDrTT64JCa6jsPkImS6+zLlSWS/BYS2X3GroBV4YXGhx+x2eq75pZ03kMBcVmwIXly2xFZcdRu8em/HSg87/Vjbvl5CuTxob5vMveOdd05mseDa13jE1n/af+vKmw/Fg5564jBzg751rlQbW0ziGudJ7dbW7CCrmCP5MMa/VYiJ9amjNK6N+dWj02308cAWXYHzV4TOonbsxyFjc0e2yOn4LCmnvXQavHovmJ455bNNo8FtdPHDPLUJPHYvgpqbO0eCyWn5I6iyO3x5L6iSP2beVcHkvvJ46IZZjDY6n8lN1ZqT2W0k/ZncURy2PZ/cSR41HYvR4r4yeOxGV4j8dy+kmFs+Z6bJ3ZTyqcxRHisWNpP3GUenw/5bEh8vmJoXSvwwbANnDuluYXQ0NjyB7AG7UKcPzS5/uyy9TTRTPksWJ+4tDUctT3WFE/cWjsz/JeeintJw6tzWwqeyms80+AhSXAwhJgYQmwsARYWAIsLAEWlgALS4CFJcDCEmBhCbCwBHBvhTULeCkgBk1/H/barwArQwEWlgALS4AX/Hc1qy0JgD9GRzqDb/OjVwAAAABJRU5ErkJggg",
    light: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAA5CAYAAAB+pNYgAAAACXBIWXMAAC4jAAAuIwF4pT92AAACPklEQVR4Ae2b7W3CMBCGz1X/lxHSCQobMEJHgA0YpSPABt0AugFs0BHoBG9l6SpF1HF8IbbP6F4pf8CfD/YTBI4johNZkuJhwVCl5amFQWqJwRLEYAnyHCn6Q0Q7IvpWN+p86Yjog4heQj2MCd4Dewfw8HdM59yaiD6HQFHCNvQVj845v8IeNjy/YwzUX5B47YloAYAe5fLz4XklMZB+z7rwtmzeY865jrfdW2qd0Da88BWKb/jM+7vZ8PjPEVCDDG6X24mX6Njy3LW4HfkOH5vXnsudAu+FYXGFzVjDrXgs0U+bXnkZLK60JKJrpAO/nDvloDoe59Ac/PyWN3XksHqfylhna6Wg1gkf9r/dMRlWr4GmPJbqp4G698FCIx6T+ikbLCj32BQ/ZYUFpR6b6qfssHqNqvDYPX4qBguVPTaHn4rCQiWPzeWn4rBQ2GNz+qkKrF5HWT02t5+qwkImj+XyU3VYmNljOf2kAhZm8lhuP6mB1et8ksdK+EkdLAg9VtJPKmEh3WPrkn5KhVX8H2kAZ5Z17Hf+48jv4x23UzRV/r4HcAXgV9hBWPXg6/n6mYYWTdWzDgC8w7aJxbdcvlqqHwwB4CW+4qMCofjXV1yualScool4rJqfQlFz5Cjgsap+CkXd+Sz20mttP4Wi8jCb1rMUdvJPEIMliMESxGAJYrAEMViCGCxBDJYgBksQgyWIwRLEYAlisAQJPRW2aP2hgJmyuG3GHvsVxLahIAZLEIMliBf8VzOjrRki+gWpLBvJ4+xaqwAAAABJRU5ErkJg"
  }
}, {
  name: "international",
  image: {
    dark: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAABl0lEQVRIie3UzYtPcRTH8XNnJmpKTZhGbC0NeapJw0yxkJ0tys/OX8DKgiyU8QeMPDRDmkRZWUhZoGiiRNkQWWnGUx6Kn4fXLOaom+7Fb/rJZs7m1umcz/t8z/fzvRHz8b+jqEqiIyLWR8SOiGhGxImiKJpto2IQn/AZU3iMobYBEjKED7iAU/iOM1hSU9+FVehpBTKI9xjFFjzCNBoo0Ie9mMAbs/EVjTrBRbn/cm4A73Aa3bicQi/yVNM4j11YhgN4WSV+Dk3cRn8pvxgjKfoRPzCJIwnvLNUuxxieVAH2pMiDBJ3FLXzDW1zEPvSVejqxCUdxP+HPsLkKUKTgJezETRzLy+4q1XXndxivck13cAgbUGn9n83rcuKtv0w5gMO4i4nMX8MV9NYK1kBG0y2NdMfrnHIybXsQa3Ida1sST8DStNxUumM3erEQX7AN47jesngJsqLCrhtz6tVpgu1zBtRA9+MpjuPhby9zjoCTuJGPrtFW8QTcy3fyHAv+tq/jzyWzbyQirkbEcESsbOuvez7+ecwAUOIhOfisfWoAAAAASUVORK5CYII",
    light: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAABjUlEQVRIie3UTUtVURTG8d/1SoIQVBqGTRuFFZqBhL1ADaJB0DSFbt8hauSgcNCgPsANM8qIiIJGDkJwUEEhCkHQJCgchZZGFvRqDdYWDrdz4io3mvifbNh78zxrrf2cwzr/m1LBfhP24ji+4UpaG0Y/PuML5vAShxppIAku4TZG8BOjaCu434wubFqNST8+ooqDeIF5VMR4O3Aad7CAX/ieznPZKOafpQ8fcA2tuJ+EZlNX87iFU9iGc3ibJz4mHvIJdmX2t+ByEv2EZUzhYjIvZ+524gZe5RkMJpHnyeg6HuMHFnEXZ8RYVihjP4Yxk8xf40CeQSkJ3sNJPMIl8djNmXutaT2Md2JMTzGEXsXRBz2p4iM1VfbhAp6JB4WHeICtfxPMoyrSUkli71OVUyK257FHjKN7teLQLiI3J9IxkKpswVccxU1MrEV8he3+jOs+UfVuEYJj9QiVC/aXRKKynMBObMBmnK2z2Lq5iknx0VUaLQ7Toqs3oou6qJ1zESWMi+zv0OBf9zr/lt98flg0TNT23QAAAABJRU5ErkJggg"
  }
}];
var getDataUrl = function getDataUrl(category, isDark) {
  if (!category) return "";
  category = category.toLowerCase();
  for (var _i = 0, _categoryImages = categoryImages; _i < _categoryImages.length; _i++) {
    var _categoryImages$_i = _categoryImages[_i],
      name = _categoryImages$_i.name,
      image = _categoryImages$_i.image;
    if (category.includes(name)) {
      return isDark ? image.dark : image.light;
    }
  }
  return "";
};
var NO_POPULAR_INTENTS = "No popular flows returned for this device, please use search or select the Alphabetical tab.";
var userKeys = ["agentDeviceId", "account", "id", "existingServices", "accountType", "amid", "customerRole", "customerType", "numberOfLines", "planType", "authStatus", "authType", "tenure", "prospect", "session", "chatId", "childId", "creditAppNum", "crmHashEmail", "deviceDollars", "zip", "productsQualified", "accountLast2", "acctId_unhashed", "custId_unhashed", "visionAcctID_unhashed", "visionCustID_unhashed", "cdUserId", "deviceDetail", "departmentId", "regionId", "ivrCallId"];
var txnKeys = ["agentRole", "agent", "autoPay", "id", "offer", "discountId", "orderType", "status", "cartId", "outletId", "quoteId", "paymentType", "shippingZip", "shippingTotal", "tradeInQty", "tradeInAmt", "total", "taxAmt", "recurringPrice", "nonRecurringPrice", "futurePayment", "installOptions", "discount", "paymentAmt", "reasonCode", "reviewOption", "txnDetail", "shippingState"];
var utilsKeys = ["StrategyApiKey", "appApiKey", "pegaCaseId", "athenaSession", "outcome", "pegaOffer"];

var _templateObject$1f, _templateObject2$$;
var IconContainer$6 = styled.span(_templateObject$1f || (_templateObject$1f = _taggedTemplateLiteralLoose(["\n  margin-left: 13px;\n"])));
var ItemsIcons = styled.img(_templateObject2$$ || (_templateObject2$$ = _taggedTemplateLiteralLoose(["\n  width: 20px;\n  margin-right: 12px;\n"])));
var CategoryIcon = function CategoryIcon(_ref) {
  var _useContext;
  var categoryTitle = _ref.categoryTitle;
  var paramsDetails = (_useContext = useContext(ParamsContext)) === null || _useContext === void 0 ? void 0 : _useContext.paramsDetails;
  var isDarkTheme = isDark$1(paramsDetails);
  var dataUrl = useMemo(function () {
    return getDataUrl(categoryTitle, isDarkTheme);
  }, [categoryTitle, isDarkTheme]);
  return /*#__PURE__*/React__default.createElement(IconContainer$6, null, dataUrl && /*#__PURE__*/React__default.createElement(ItemsIcons, {
    src: dataUrl,
    alt: "Phone Calls Icon"
  }));
};

var _templateObject$1g, _templateObject2$10, _templateObject3$R, _templateObject4$P;
var IssueSelectorTileContainer = styled.div(_templateObject$1g || (_templateObject$1g = _taggedTemplateLiteralLoose(["\n  margin-bottom: 10px;\n  border: 1px solid #d8d8d8;\n  cursor: pointer;\n  width: 48%;\n  height: 58px;\n  display: flex;\n  align-items: center;\n  box-shadow: 0 1px 1px rgb(0 0 0 / 8%);\n  background-color: ", ";\n  &:nth-child(even) {\n    margin-right: 0;\n  }\n  @media (max-width: 1140px) {\n    width: 45.5%;\n  }\n  @media (max-width: 970px) {\n    margin-right: 0;\n    width: 100%;\n  }\n"])), function (props) {
  return props.isDark ? props.darkBC : '#fff';
});
var SymptomsWrapper = styled.div(_templateObject2$10 || (_templateObject2$10 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n\n  .intentListLink:focus-visible {\n    border: none !important;\n  }\n\n  .firstintent: first-child {\n    padding-top: 10px;\n  }\n\n  .intentListLink {\n    text-decoration: none;\n  }\n"])));
var CategoryTitle = styled.div(_templateObject3$R || (_templateObject3$R = _taggedTemplateLiteralLoose(["\n  margin-bottom: 16px;\n"])));
var IssueSelectorTitle = styled.span(_templateObject4$P || (_templateObject4$P = _taggedTemplateLiteralLoose([""])));
var CategoryTiles = function CategoryTiles(_ref) {
  var _useContext, _paramsDetails$theme;
  var _ref$symptomsList = _ref.symptomsList,
    symptomsList = _ref$symptomsList === void 0 ? [] : _ref$symptomsList,
    handleSymptomsSelect = _ref.handleSymptomsSelect,
    hide = _ref.hide,
    showTitle = _ref.showTitle;
  var paramsDetails = (_useContext = useContext(ParamsContext)) === null || _useContext === void 0 ? void 0 : _useContext.paramsDetails;
  var isDarkTheme = isDark$1(paramsDetails);
  var darkBC = paramsDetails === null || paramsDetails === void 0 ? void 0 : (_paramsDetails$theme = paramsDetails.theme) === null || _paramsDetails$theme === void 0 ? void 0 : _paramsDetails$theme.themeObject.background;
  if (hide) return null;
  return /*#__PURE__*/React__default.createElement(Fragment, null, showTitle && /*#__PURE__*/React__default.createElement(CategoryTitle, null, /*#__PURE__*/React__default.createElement(Title, {
    primitive: "h3",
    color: isDarkTheme ? '#ffffff' : '#000000'
  }, "Issue categories", ' ')), /*#__PURE__*/React__default.createElement(SymptomsWrapper, null, symptomsList === null || symptomsList === void 0 ? void 0 : symptomsList.map(function (items, index) {
    return /*#__PURE__*/React__default.createElement(IssueSelectorTileContainer, {
      key: index,
      tabIndex: "0",
      onClick: function onClick() {
        return handleSymptomsSelect(items);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter' || e.key === 'Space') {
          handleSymptomsSelect(items);
        }
      },
      "data-track": "{\"type\": \"link\", \"name\": \"" + (items === null || items === void 0 ? void 0 : items.title) + "\"}",
      role: "button",
      "aria-label": items.title,
      "data-testid": "handleSymptomSet",
      isDark: isDarkTheme,
      darkBC: darkBC
    }, /*#__PURE__*/React__default.createElement(CategoryIcon, {
      categoryTitle: items.title
    }), /*#__PURE__*/React__default.createElement(IssueSelectorTitle, null, items.title));
  })));
};

var _templateObject$1h;
var PaginationWrapper$2 = styled.div(_templateObject$1h || (_templateObject$1h = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  nav {\n    float:right\n  }\n"])));
var PaginationComponent = function PaginationComponent(_ref) {
  var _useContext;
  var total = _ref.total,
    selectedPage = _ref.selectedPage,
    selectPage = _ref.selectPage;
  var paramsDetails = (_useContext = useContext(ParamsContext)) === null || _useContext === void 0 ? void 0 : _useContext.paramsDetails;
  var isDarkTheme = isDark$1(paramsDetails);
  return /*#__PURE__*/React__default.createElement(PaginationWrapper$2, null, /*#__PURE__*/React__default.createElement(Pagination$2, {
    selectPage: selectPage,
    total: total,
    showArrow: true,
    selectedPage: selectedPage,
    "data-testid": "paginationPopular",
    id: "paginationPopular",
    surface: isDarkTheme ? 'dark' : 'light'
  }));
};

var _templateObject$1i, _templateObject2$11, _templateObject3$S;
var NoIntentMessage = styled.div(_templateObject$1i || (_templateObject$1i = _taggedTemplateLiteralLoose(["\n  padding-top: 20px;\n  text-wrap: wrap;\n  width: 50%;\n"])));
var IntentListWrapper = styled.div(_templateObject2$11 || (_templateObject2$11 = _taggedTemplateLiteralLoose(["\n  width:100%;\n  line-height:32px;\n  padding-top:10px;\n"])));
var Link = styled(TextLink)(_templateObject3$S || (_templateObject3$S = _taggedTemplateLiteralLoose(["\n  color: #0066cf;\n  text-decoration: none;\n  border-bottom: none !important;\n \n  &:hover {\n    text-decoration: none !important;\n    color: #0066cf !important;\n  }\n  &:focus{\n  outline: none !important;\n  }\n"])));
var SubSymptomsList = function SubSymptomsList(_ref) {
  var _useContext;
  var _ref$subSymptomsList = _ref.subSymptomsList,
    subSymptomsList = _ref$subSymptomsList === void 0 ? [] : _ref$subSymptomsList,
    selectedCategory = _ref.selectedCategory,
    handleSubSymptoms = _ref.handleSubSymptoms;
  var paramsDetails = (_useContext = useContext(ParamsContext)) === null || _useContext === void 0 ? void 0 : _useContext.paramsDetails;
  var isDarkTheme = isDark$1(paramsDetails);
  var handleIntentToTroubleshoot = function handleIntentToTroubleshoot(items, symptomId) {
    handleSubSymptoms(items, symptomId);
  };
  if (subSymptomsList.length === 0) {
    return /*#__PURE__*/React__default.createElement(NoIntentMessage, null, /*#__PURE__*/React__default.createElement("p", null, " ", NO_POPULAR_INTENTS, " "));
  }
  return /*#__PURE__*/React__default.createElement(IntentListWrapper, {
    id: "intentListWrapId"
  }, subSymptomsList === null || subSymptomsList === void 0 ? void 0 : subSymptomsList.map(function (items, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: items.name + "_" + index
    }, /*#__PURE__*/React__default.createElement(Link, {
      type: "standAlone",
      size: "large",
      onClick: function onClick() {
        return handleIntentToTroubleshoot(items, selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.symptomId);
      },
      ariaLabel: items.name,
      surface: isDarkTheme ? 'dark' : 'light',
      "data-track": "{\"type\": \"link\", \"name\": \"" + items.name + "\"}"
    }, items === null || items === void 0 ? void 0 : items.name));
  }));
};

var _templateObject$1j;
var TabsContainer$5 = styled.div(_templateObject$1j || (_templateObject$1j = _taggedTemplateLiteralLoose([""])));
var SubCategoryComponent = function SubCategoryComponent(_ref) {
  var _useContext, _useContext2;
  var _ref$currentPopularSy = _ref.currentPopularSymptoms,
    currentPopularSymptoms = _ref$currentPopularSy === void 0 ? [] : _ref$currentPopularSy,
    _ref$currentSymptoms = _ref.currentSymptoms,
    currentSymptoms = _ref$currentSymptoms === void 0 ? [] : _ref$currentSymptoms,
    selectedCategory = _ref.selectedCategory,
    _ref$paginationProps = _ref.paginationProps,
    paginationProps = _ref$paginationProps === void 0 ? {} : _ref$paginationProps,
    handleSubSymptoms = _ref.handleSubSymptoms,
    hide = _ref.hide;
  var popularSize = currentPopularSymptoms.length;
  var _useState = useState(popularSize ? 0 : 1),
    activeTab = _useState[0],
    setActiveTab = _useState[1];
  var configDetails = (_useContext = useContext(ParamsContext)) === null || _useContext === void 0 ? void 0 : _useContext.configDetails;
  var paramsDetails = (_useContext2 = useContext(ParamsContext)) === null || _useContext2 === void 0 ? void 0 : _useContext2.paramsDetails;
  var isDarkTheme = isDark$1(paramsDetails);
  var totalPagesForPopular = paginationProps.totalPagesForPopular,
    totalPagesForAlpha = paginationProps.totalPagesForAlpha,
    handlePageNext = paginationProps.handlePageNext,
    popularCurrentPage = paginationProps.popularCurrentPage,
    alphaCurrentPage = paginationProps.alphaCurrentPage;
  useEffect(function () {
    setActiveTab(popularSize ? 0 : 1);
  }, [selectedCategory]);
  useEffect(function () {
    focusIntentListFirstChild();
  }, [alphaCurrentPage, popularCurrentPage]);
  var onTabChange = function onTabChange(e, index) {
    setActiveTab(index);
  };
  if (hide) return null;
  return /*#__PURE__*/React__default.createElement(TabsContainer$5, {
    className: "retailTabContainer"
  }, /*#__PURE__*/React__default.createElement(Tabs$1, {
    width: "auto",
    orientation: "horizontal",
    indicatorPosition: "bottom",
    linePosition: "bottom",
    borderLine: false,
    selectedIndex: activeTab,
    onTabChange: onTabChange,
    surface: isDarkTheme ? 'dark' : 'light'
  }, /*#__PURE__*/React__default.createElement(Tab, {
    label: "Popular",
    hide: !(configDetails !== null && configDetails !== void 0 && configDetails.enablePopularTab)
  }, /*#__PURE__*/React__default.createElement(SubSymptomsList, {
    selectedCategory: selectedCategory,
    subSymptomsList: currentPopularSymptoms,
    handleSubSymptoms: handleSubSymptoms
  }), totalPagesForPopular > 1 && /*#__PURE__*/React__default.createElement(PaginationComponent, {
    total: totalPagesForPopular,
    selectPage: handlePageNext,
    selectedPage: popularCurrentPage
  })), /*#__PURE__*/React__default.createElement(Tab, {
    label: "Alphabetical"
  }, /*#__PURE__*/React__default.createElement(SubSymptomsList, {
    selectedCategory: selectedCategory,
    subSymptomsList: currentSymptoms,
    handleSubSymptoms: handleSubSymptoms
  }), totalPagesForAlpha > 1 && /*#__PURE__*/React__default.createElement(PaginationComponent, {
    total: totalPagesForAlpha,
    selectPage: handlePageNext,
    selectedPage: alphaCurrentPage
  }))));
};

var _excluded$7 = ["attributeID", "value", "systemSource", "showAdditionalInfo"];
var _templateObject$1k, _templateObject2$12, _templateObject3$T, _templateObject4$Q, _templateObject5$H, _templateObject6$A, _templateObject7$v;
var FlexRowItem = styled.div(_templateObject$1k || (_templateObject$1k = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
var LoaderWrapper$2 = styled.div(_templateObject2$12 || (_templateObject2$12 = _taggedTemplateLiteralLoose(["\n  padding-top: 25px;\n  min-width: 20px;\n  position: relative;\n  z-index: 1;\n  & div {\n    background-color:unset;\n    & div {\n      width: 18px;\n      height: 18px;\n    }\n  }\n"])));
var Tag$1 = styled.div(_templateObject3$T || (_templateObject3$T = _taggedTemplateLiteralLoose(["\n  margin-left: 2px;\n  border : 1px solid #d6d6d6;\n  border-radius: 4px;\n  padding: 2px 4px;\n  p{\n    font-family: Verizon-NHG-eTX, Helvetica, Arial, Sans-serif !important;\n  }\n  \n"])));
var AttributeBodyWrapper$1 = styled.div(_templateObject4$Q || (_templateObject4$Q = _taggedTemplateLiteralLoose(["\n   width: max-content;\n   p{\n    font-family: Verizon-NHG-eTX, Helvetica, Arial, Sans-serif !important;\n  }\n"])));
var LeftAttribute = styled.div(_templateObject5$H || (_templateObject5$H = _taggedTemplateLiteralLoose(["\ndisplay: flex;\nalign-items: center;\ncolumn-gap: 6px;\n"])));
var IconWrapper$3 = styled.div(_templateObject6$A || (_templateObject6$A = _taggedTemplateLiteralLoose(["\n  display: flex;\n  *{\n    font-family: unset !important;\n  }\n"])));
var RightAttribute = styled.div(_templateObject7$v || (_templateObject7$v = _taggedTemplateLiteralLoose([""])));
var HealthCheckItem = function HealthCheckItem(_ref) {
  var _tooltip$tooltip;
  var _ref$attribute = _ref.attribute,
    attribute = _ref$attribute === void 0 ? {} : _ref$attribute,
    isDark = _ref.isDark;
  var value = attribute.value,
    systemSource = attribute.systemSource,
    showAdditionalInfo = attribute.showAdditionalInfo,
    tooltip = _objectWithoutPropertiesLoose(attribute, _excluded$7);
  var hideTooltip = !(tooltip !== null && tooltip !== void 0 && (_tooltip$tooltip = tooltip.tooltip) !== null && _tooltip$tooltip !== void 0 && _tooltip$tooltip.length) > 0 && !(tooltip !== null && tooltip !== void 0 && tooltip.tooltipHeaderLabel) && !(tooltip !== null && tooltip !== void 0 && tooltip.tooltipHeaderValue);
  var notAvailableTooltip = {
    tooltipHeaderLabel: "Check inconclusive"
  };
  return /*#__PURE__*/React__default.createElement(FlexRowItem, null, /*#__PURE__*/React__default.createElement(LeftAttribute, null, attribute.value == "Yes" && /*#__PURE__*/React__default.createElement(TooltipComponent, {
    tooltip: tooltip,
    show: showAdditionalInfo && !hideTooltip,
    isLoading: value === 'InProgress'
  }, /*#__PURE__*/React__default.createElement(IconWrapper$3, {
    "aria-label": (attribute === null || attribute === void 0 ? void 0 : attribute.attributeID) + " completed",
    role: "img"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "checkmark-alt",
    color: "#008331",
    size: "medium",
    style: {
      paddingTop: 3,
      outline: "transparent 0px"
    },
    ariaHidden: true,
    tabIndex: "-1",
    "aria-label": (attribute === null || attribute === void 0 ? void 0 : attribute.attributeID) + " completed"
  }))), attribute.value == "No" && /*#__PURE__*/React__default.createElement(TooltipComponent, {
    tooltip: tooltip,
    show: showAdditionalInfo && !hideTooltip,
    isLoading: value === 'InProgress'
  }, /*#__PURE__*/React__default.createElement(IconWrapper$3, {
    "aria-label": (attribute === null || attribute === void 0 ? void 0 : attribute.attributeID) + " Failed",
    role: "img"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "close-alt",
    color: "#EE0000",
    size: "medium",
    style: {
      paddingTop: 3,
      outline: "transparent 0px"
    },
    ariaHidden: true,
    tabIndex: "-1",
    "aria-label": (attribute === null || attribute === void 0 ? void 0 : attribute.attributeID) + " Failed"
  }))), attribute.value == "NotAvailable" && /*#__PURE__*/React__default.createElement(TooltipComponent, {
    tooltip: notAvailableTooltip,
    show: false,
    isLoading: value === 'InProgress'
  }, /*#__PURE__*/React__default.createElement(IconWrapper$3, {
    "aria-label": (attribute === null || attribute === void 0 ? void 0 : attribute.attributeID) + " Inconclusive",
    role: "img"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "zoom-out",
    color: "#bc9f0a",
    size: "medium",
    style: {
      paddingTop: 3,
      outline: "transparent 0px"
    },
    ariaHidden: true,
    tabIndex: "-1",
    "aria-label": (attribute === null || attribute === void 0 ? void 0 : attribute.attributeID) + " Inconclusive"
  }))), attribute.value == "InProgress" && /*#__PURE__*/React__default.createElement(TooltipComponent, {
    tooltip: tooltip,
    show: showAdditionalInfo,
    isLoading: value === 'InProgress'
  }, /*#__PURE__*/React__default.createElement(LoaderWrapper$2, null, /*#__PURE__*/React__default.createElement(Loader$2, {
    active: true,
    fullscreen: false,
    surface: isDark ? 'dark' : 'light'
  }))), /*#__PURE__*/React__default.createElement(AttributeBodyWrapper$1, null, /*#__PURE__*/React__default.createElement(Micro, {
    color: isDark ? "#ffffff" : "#000000"
  }, attribute.attributeID))), /*#__PURE__*/React__default.createElement(RightAttribute, null, !!systemSource && /*#__PURE__*/React__default.createElement(Tag$1, null, /*#__PURE__*/React__default.createElement(Micro, {
    viewport: "mobile",
    color: isDark ? "#ffffff" : "#000000"
  }, systemSource, " "))));
};

var _templateObject$1l, _templateObject2$13;
var FooterContainer = styled.div(_templateObject$1l || (_templateObject$1l = _taggedTemplateLiteralLoose(["\ndisplay: flex;\nborder-radius: 6px;\npadding:2px 16px;\nbackground:", ";\ncolumn-gap: 10px;\nalign-items: center;\nmargin-top: 1rem;\nmargin-bottom: 35px;\n"])), function (props) {
  return props.isDark ? "#000" : "#F6F6F6";
});
var IconWrapper$4 = styled.div(_templateObject2$13 || (_templateObject2$13 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  *{\n    font-family: unset !important;\n  }\n"])));
var HealthCheckFooter = function HealthCheckFooter() {
  var _useContext, _paramsDetails$theme, _paramsDetails$theme2, _paramsDetails$theme3;
  var paramsDetails = (_useContext = useContext(ParamsContext)) === null || _useContext === void 0 ? void 0 : _useContext.paramsDetails;
  var isDark = paramsDetails !== null && paramsDetails !== void 0 && (_paramsDetails$theme = paramsDetails.theme) !== null && _paramsDetails$theme !== void 0 && _paramsDetails$theme.isDark ? true : false;
  var darkBC = paramsDetails === null || paramsDetails === void 0 ? void 0 : (_paramsDetails$theme2 = paramsDetails.theme) === null || _paramsDetails$theme2 === void 0 ? void 0 : (_paramsDetails$theme3 = _paramsDetails$theme2.themeObject) === null || _paramsDetails$theme3 === void 0 ? void 0 : _paramsDetails$theme3.background;
  return /*#__PURE__*/React__default.createElement(FooterContainer, {
    isDark: isDark,
    darkBC: darkBC
  }, /*#__PURE__*/React__default.createElement(Micro, {
    color: isDark ? "#ffffff" : "#000000",
    bold: true
  }, "Legend:"), /*#__PURE__*/React__default.createElement(IconWrapper$4, {
    "aria-label": "No Issue completed",
    role: "img"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "checkmark-alt",
    color: "#008331",
    size: "medium",
    style: {
      paddingTop: 3,
      outline: "transparent 0px"
    },
    ariaHidden: true,
    tabIndex: "-1",
    ariaLabel: "No Issue completed"
  })), /*#__PURE__*/React__default.createElement(Micro, {
    color: isDark ? "#ffffff" : "#000000"
  }, "No Issue"), /*#__PURE__*/React__default.createElement(IconWrapper$4, {
    "aria-label": "Issue Found Failed",
    role: "img"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "close-alt",
    color: "#EE0000",
    size: "medium",
    style: {
      paddingTop: 3,
      outline: "transparent 0px"
    },
    ariaHidden: true,
    tabIndex: "-1",
    ariaLabel: "Issue Found Failed"
  })), /*#__PURE__*/React__default.createElement(Micro, {
    color: isDark ? "#ffffff" : "#000000"
  }, "Issue Found"), /*#__PURE__*/React__default.createElement(IconWrapper$4, {
    "aria-label": "Inconclusive Unavailable",
    role: "img"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "zoom-out",
    color: "#bc9f0a",
    size: "medium",
    style: {
      paddingTop: 3,
      outline: "transparent 0px"
    },
    ariaHidden: true,
    tabIndex: "-1",
    ariaLabel: "Inconclusive Unavailable"
  })), /*#__PURE__*/React__default.createElement(Micro, {
    color: isDark ? "#ffffff" : "#000000"
  }, "Inconclusive"));
};

var _templateObject$1m, _templateObject2$14, _templateObject3$U, _templateObject4$R, _templateObject5$I, _templateObject6$B, _templateObject7$w, _templateObject8$s, _templateObject9$n;
var DeviceHealthCheckMain = styled.section(_templateObject$1m || (_templateObject$1m = _taggedTemplateLiteralLoose(["\n   \n    "])));
var FlexItem = styled.div(_templateObject2$14 || (_templateObject2$14 = _taggedTemplateLiteralLoose(["\n    flex:1;\n    max-width: 165px;\n    p{\n    font-family: Verizon-NHG-eTX, Helvetica, Arial, Sans-serif !important;\n    }\n"])));
var HealthCheckHeading = styled.span(_templateObject3$U || (_templateObject3$U = _taggedTemplateLiteralLoose(["\n"])));
var HealthCheckInnerHeading = styled.span(_templateObject4$R || (_templateObject4$R = _taggedTemplateLiteralLoose(["\n"])));
var HealthCheckInner = styled.div(_templateObject5$I || (_templateObject5$I = _taggedTemplateLiteralLoose(["\n    display: flex;\n    padding-top: 1rem;\n    column-gap: 100px;\n    max-width:700px;\n"])));
var HealthCheckSummary = styled.div(_templateObject6$B || (_templateObject6$B = _taggedTemplateLiteralLoose(["\n    padding: 1rem 0;\n"])));
var LoaderContainer$3 = styled.div(_templateObject7$w || (_templateObject7$w = _taggedTemplateLiteralLoose(["\n  padding-top: 75px;\n  position: relative;\n  z-index: 1;\n  & div {\n    & div {\n      width: 25px;\n      height: 25px;\n      border: 2px solid #000000;\n      border-top-color: transparent;\n    }\n  }\n"])));
var NoHealthCheckWrapper = styled.div(_templateObject8$s || (_templateObject8$s = _taggedTemplateLiteralLoose(["\n    padding-top: 24px;\n    display: flex;\n    column-gap: 10px;\n    align-items: center;\n"])));
var HealthItemWrapper = styled.div(_templateObject9$n || (_templateObject9$n = _taggedTemplateLiteralLoose(["\n    margin-top: 10px;\n    display: flex;\n    flex-direction: column;\n    row-gap: 10px;\n"])));
var DeviceHealthCheck = function DeviceHealthCheck(_ref) {
  var _useContext, _paramsDetails$theme, _paramsDetails$channe, _window, _window$troubleShooti, _window$troubleShooti2, _window$troubleShooti3, _window2, _healthCheckList$slic;
  var _ref$deviceHealthChec = _ref.deviceHealthCheckData,
    deviceHealthCheckData = _ref$deviceHealthChec === void 0 ? {} : _ref$deviceHealthChec;
  var healthCheckData = deviceHealthCheckData.healthCheckData,
    isLoading = deviceHealthCheckData.isLoading;
  var _healthCheckData$heal = healthCheckData.healthCheckList,
    healthCheckList = _healthCheckData$heal === void 0 ? [] : _healthCheckData$heal,
    _healthCheckData$proc = healthCheckData.processStep,
    processStep = _healthCheckData$proc === void 0 ? '' : _healthCheckData$proc;
  var paramsDetails = (_useContext = useContext(ParamsContext)) === null || _useContext === void 0 ? void 0 : _useContext.paramsDetails;
  var isDark = paramsDetails !== null && paramsDetails !== void 0 && (_paramsDetails$theme = paramsDetails.theme) !== null && _paramsDetails$theme !== void 0 && _paramsDetails$theme.isDark ? true : false;
  var isACSS = (paramsDetails === null || paramsDetails === void 0 ? void 0 : (_paramsDetails$channe = paramsDetails.channel) === null || _paramsDetails$channe === void 0 ? void 0 : _paramsDetails$channe.toLowerCase()) === "care";
  var deviceSku = (paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.sku) || ((_window = window) === null || _window === void 0 ? void 0 : (_window$troubleShooti = _window.troubleShootingJson) === null || _window$troubleShooti === void 0 ? void 0 : (_window$troubleShooti2 = _window$troubleShooti.ddata) === null || _window$troubleShooti2 === void 0 ? void 0 : (_window$troubleShooti3 = _window$troubleShooti2.device) === null || _window$troubleShooti3 === void 0 ? void 0 : _window$troubleShooti3.deviceSku) || '';
  var popOutFlow = (_window2 = window) !== null && _window2 !== void 0 && _window2.isBAUACSS ? true : false;
  var _useFeatureFlag = useFeatureFlag(),
    _useFeatureFlag$data = _useFeatureFlag.data,
    _useFeatureFlag$data2 = _useFeatureFlag$data === void 0 ? {} : _useFeatureFlag$data,
    _useFeatureFlag$data3 = _useFeatureFlag$data2.deviceSelectorAccessibilityFFlag,
    deviceSelectorAccessibilityFFlag = _useFeatureFlag$data3 === void 0 ? false : _useFeatureFlag$data3;
  useEffect(function () {
    if (processStep === 'Next') {
      var _paramsDetails$accoun;
      var success = [];
      var fail = [];
      var norun = [];
      var partialSuccess = [];
      healthCheckList.map(function (_ref2) {
        var attrNames = _ref2.attrNames;
        return attrNames;
      }).flat().forEach(function (item) {
        var _item$attributeID, _item$attributeID2, _item$attributeID3, _item$attributeID4;
        if ((item === null || item === void 0 ? void 0 : item.value) === 'Yes') success.push(item === null || item === void 0 ? void 0 : (_item$attributeID = item.attributeID) === null || _item$attributeID === void 0 ? void 0 : _item$attributeID.toLowerCase());else if ((item === null || item === void 0 ? void 0 : item.value) === 'No') fail.push(item === null || item === void 0 ? void 0 : (_item$attributeID2 = item.attributeID) === null || _item$attributeID2 === void 0 ? void 0 : _item$attributeID2.toLowerCase());else if ((item === null || item === void 0 ? void 0 : item.value) === 'PartialDataAvailable') partialSuccess.push(item === null || item === void 0 ? void 0 : (_item$attributeID3 = item.attributeID) === null || _item$attributeID3 === void 0 ? void 0 : _item$attributeID3.toLowerCase());else if ((item === null || item === void 0 ? void 0 : item.value) === 'NotAvailable') norun.push(item === null || item === void 0 ? void 0 : (_item$attributeID4 = item.attributeID) === null || _item$attributeID4 === void 0 ? void 0 : _item$attributeID4.toLowerCase());
      });
      var tsaIntentResults = [{
        name: 'success',
        data: success
      }, {
        name: 'fail',
        data: fail
      }, {
        name: 'norun',
        data: norun
      }, {
        name: 'partialSuccess',
        data: partialSuccess
      }].filter(function (item) {
        var _item$data;
        return (item === null || item === void 0 ? void 0 : (_item$data = item.data) === null || _item$data === void 0 ? void 0 : _item$data.length) > 0;
      }).map(function (item) {
        var _item$data2;
        return "^" + (item === null || item === void 0 ? void 0 : item.name) + ":" + (item === null || item === void 0 ? void 0 : (_item$data2 = item.data) === null || _item$data2 === void 0 ? void 0 : _item$data2.join('|'));
      }).join('');
      tagging.setPageView({
        page: {
          subFlow: deviceSku,
          detail: ""
        },
        event: {
          value: "event351"
        },
        user: {
          authType: "logged in",
          accountLast2: paramsDetails === null || paramsDetails === void 0 ? void 0 : (_paramsDetails$accoun = paramsDetails.accountNumber) === null || _paramsDetails$accoun === void 0 ? void 0 : _paramsDetails$accoun.slice(-2)
        },
        support: {
          tsaIntentResults: tsaIntentResults
        }
      }, true, popOutFlow);
    }
  }, [healthCheckData]);
  return /*#__PURE__*/React__default.createElement(DeviceHealthCheckMain, null, /*#__PURE__*/React__default.createElement(HealthCheckSummary, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "large",
    bold: true,
    color: isDark ? "#fff" : "#000000"
  }, deviceSelectorAccessibilityFFlag ? /*#__PURE__*/React__default.createElement(HealthCheckHeading, {
    role: "heading",
    "aria-level": "2"
  }, "Initial Diagnostic Summary") : /*#__PURE__*/React__default.createElement(HealthCheckHeading, null, "Initial Diagnostic Summary"))), /*#__PURE__*/React__default.createElement(Line$1, {
    type: "primary",
    surface: isDark ? "dark" : "light"
  }), isLoading && !healthCheckList.length && /*#__PURE__*/React__default.createElement(LoaderContainer$3, null, /*#__PURE__*/React__default.createElement(Loader$2, {
    fullscreen: false,
    active: true,
    surface: isDark ? "dark" : "light"
  })), !isLoading && !healthCheckList.length && /*#__PURE__*/React__default.createElement(NoHealthCheckWrapper, null, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "error",
    size: "large",
    color: "#000000",
    surface: isDark ? 'dark' : 'light'
  }), /*#__PURE__*/React__default.createElement(Body, {
    size: "large",
    bold: false,
    color: isDark ? "#fff" : "#000000"
  }, deviceSelectorAccessibilityFFlag ? /*#__PURE__*/React__default.createElement(HealthCheckHeading, {
    role: "heading",
    "aria-level": "2"
  }, "No diagnostic summary available for this device.") : /*#__PURE__*/React__default.createElement(HealthCheckHeading, null, "No diagnostic summary available for this device."))), healthCheckList.length > 0 && /*#__PURE__*/React__default.createElement(HealthCheckInner, {
    "aria-live": "polite",
    "aria-atomic": "true"
  }, healthCheckList === null || healthCheckList === void 0 ? void 0 : (_healthCheckList$slic = healthCheckList.slice(0, 3)) === null || _healthCheckList$slic === void 0 ? void 0 : _healthCheckList$slic.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(FlexItem, {
      key: (item === null || item === void 0 ? void 0 : item.group) + index
    }, /*#__PURE__*/React__default.createElement(Body, {
      size: "medium",
      bold: true,
      color: isDark ? "#ffffff" : "#000000"
    }, deviceSelectorAccessibilityFFlag ? /*#__PURE__*/React__default.createElement(HealthCheckInnerHeading, {
      role: "heading",
      "aria-level": "3"
    }, item.group) : /*#__PURE__*/React__default.createElement(HealthCheckInnerHeading, null, item.group)), /*#__PURE__*/React__default.createElement(HealthItemWrapper, null, item.attrNames.map(function (attribute) {
      return /*#__PURE__*/React__default.createElement(HealthCheckItem, {
        key: attribute === null || attribute === void 0 ? void 0 : attribute.attributeID,
        attribute: attribute,
        isDark: isDark
      });
    })));
  })), /*#__PURE__*/React__default.createElement(HealthCheckFooter, null));
};

var _templateObject$1n, _templateObject2$15, _templateObject3$V, _templateObject4$S, _templateObject5$J, _templateObject6$C;
var MileStoneWrapper = styled.div(_templateObject$1n || (_templateObject$1n = _taggedTemplateLiteralLoose(["\nmargin-bottom:", "\n"])), function (_ref) {
  var hasMargin = _ref.hasMargin;
  return hasMargin ? '1rem' : 0;
});
var LeftSection$1 = styled.div(_templateObject2$15 || (_templateObject2$15 = _taggedTemplateLiteralLoose(["\nposition: relative;\n"])));
var RightSection$1 = styled.div(_templateObject3$V || (_templateObject3$V = _taggedTemplateLiteralLoose([""])));
var RadioContainer$1 = styled.div(_templateObject4$S || (_templateObject4$S = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    left: 1rem;\n    label{\n    font-size: 12px;\n    }\n  ", "\n\n"])), function (props) {
  return props.isDark && "\n        div[class^=\"StyledInnerCircle-VDS\"] {\n            background-color: #fff !important;\n        }\n    ";
});
var LineContainer = styled.div(_templateObject5$J || (_templateObject5$J = _taggedTemplateLiteralLoose(["\n    padding-top: 1.2rem;\n    padding-left: 0.4rem;\n"])));
var Line = styled.div(_templateObject6$C || (_templateObject6$C = _taggedTemplateLiteralLoose(["\n    height: 70px;\n    width: 0.0625rem;\n    background-color: ", ";\n"])), function (props) {
  return props.isDark ? '#fff !important' : '#000000';
});
var MileStone = function MileStone(props) {
  var _props$title = props.title,
    title = _props$title === void 0 ? '' : _props$title,
    _props$dateTime = props.dateTime,
    dateTime = _props$dateTime === void 0 ? '' : _props$dateTime,
    _props$showLine = props.showLine,
    showLine = _props$showLine === void 0 ? true : _props$showLine,
    _props$type = props.type,
    type = _props$type === void 0 ? "COMPLETED" : _props$type,
    isLastChild = props.isLastChild,
    _props$isDark = props.isDark,
    isDark = _props$isDark === void 0 ? false : _props$isDark;
  var checked = type === 'COMPLETED';
  return /*#__PURE__*/React__default.createElement(MileStoneWrapper, {
    hasMargin: isLastChild && dateTime
  }, /*#__PURE__*/React__default.createElement(LeftSection$1, null, /*#__PURE__*/React__default.createElement(RadioContainer$1, {
    isDark: isDark
  }, /*#__PURE__*/React__default.createElement(RadioButton, {
    name: "block",
    label: title,
    children: dateTime,
    ariaLabel: title + '' + dateTime,
    selected: checked,
    surface: isDark ? 'dark' : 'light'
  })), showLine && /*#__PURE__*/React__default.createElement(LineContainer, null, /*#__PURE__*/React__default.createElement(Line, {
    isDark: isDark,
    "data-testid": "progress-line"
  }))), /*#__PURE__*/React__default.createElement(RightSection$1, null));
};

var _templateObject$1o, _templateObject2$16, _templateObject3$W, _templateObject4$T, _templateObject5$K, _templateObject6$D;
var TileContainer = styled.article(_templateObject$1o || (_templateObject$1o = _taggedTemplateLiteralLoose(["\n    display: flex;\n    column-gap: 10px;\n    padding-bottom: 16px;\n    padding-top:12px;\n    min-height:390px;\n    background-color: ", ";\n"])), function (props) {
  return props.isDark ? '#1B1D1F !important' : '#F6F6F6';
});
var LeftSection$2 = styled.section(_templateObject2$16 || (_templateObject2$16 = _taggedTemplateLiteralLoose(["\n    display:flex;\n    flex-direction:column;\n    flex: 0.6;\n    border-radius: 4px;\n    background-color: ", ";\n    padding-bottom: 10px;\n"])), function (props) {
  return props.isDark ? '#333333 !important' : '#ffffff';
});
var RightSection$2 = styled.section(_templateObject3$W || (_templateObject3$W = _taggedTemplateLiteralLoose(["\n    flex: 1;\n    background-color: ", ";\n"])), function (props) {
  return props.isDark ? '#003E6C !important' : '#E3F2FD';
});
var Card$1 = styled.div(_templateObject4$T || (_templateObject4$T = _taggedTemplateLiteralLoose(["\n    padding:10px;\n"])));
var OutageContentContainer = styled.div(_templateObject5$K || (_templateObject5$K = _taggedTemplateLiteralLoose(["\n    border-radius: 4px;\n    padding: 10px;\n    p{\n    font-size: 12px\n    }\n    .outage-info-link{\n    font-size: 12px;\n    font-weight: bold;\n    color:#006FC1;\n    }\n"])));
var ViewDetailsWrapper = styled.div(_templateObject6$D || (_templateObject6$D = _taggedTemplateLiteralLoose(["\n    display:flex;\n    flex-direction:row-reverse;\n    padding-top: 2rem;\n    padding-right: 1rem;\n    padding-bottom: 0.5rem;\n    float: right;\n\n    ", "\n"])), function (props) {
  return props.isDark && "\n        button {\n            background-color: #000 !important;\n        }\n    ";
});
var NetworkOutageTile = function NetworkOutageTile(_ref) {
  var _ref$outageObj = _ref.outageObj,
    outageObj = _ref$outageObj === void 0 ? {} : _ref$outageObj,
    viewCallback = _ref.viewCallback,
    _ref$isDark = _ref.isDark,
    isDark = _ref$isDark === void 0 ? false : _ref$isDark,
    _ref$isRetail = _ref.isRetail,
    isRetail = _ref$isRetail === void 0 ? false : _ref$isRetail,
    _ref$volteViewDetails = _ref.volteViewDetailsFFlag,
    volteViewDetailsFFlag = _ref$volteViewDetails === void 0 ? false : _ref$volteViewDetails;
  console.log("NetworkOutageTile props-->", outageObj, viewCallback);
  var _outageObj$outageCont = outageObj.outageContent,
    outageContent = _outageObj$outageCont === void 0 ? '' : _outageObj$outageCont,
    _outageObj$outageMile = outageObj.outageMileStone,
    outageMileStone = _outageObj$outageMile === void 0 ? [] : _outageObj$outageMile,
    _outageObj$caseId = outageObj.caseId,
    caseId = _outageObj$caseId === void 0 ? '' : _outageObj$caseId,
    _outageObj$eventSubTy = outageObj.eventSubType,
    eventSubType = _outageObj$eventSubTy === void 0 ? '' : _outageObj$eventSubTy;
  var enableVolteViewDetails = volteViewDetailsFFlag ? true : eventSubType !== 'VOLTE';
  var disableViewCta = isRetail || !enableVolteViewDetails;
  var handleViewDetails = function handleViewDetails() {
    var _window, _window$vzdl;
    if (!(viewCallback && typeof viewCallback === "function")) {
      console.log("viewNetworkOutagePopup not defined");
      return;
    }
    if ((_window = window) !== null && _window !== void 0 && (_window$vzdl = _window.vzdl) !== null && _window$vzdl !== void 0 && _window$vzdl.page && typeof window.vzdl.page === "object") {
      window.vzdl.page.detail = "Network Alerts";
    } else {
      window.vzdl.page = {
        detail: "Network Alerts"
      };
    }
    tagging.setPageView(window.vzdl, true);
    setTimeout(function () {
      viewCallback(caseId, eventSubType);
      console.log("viewNetworkOutagePopup inovoked with caseId : ", caseId);
    }, 500);
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TileContainer, {
    isDark: isDark
  }, /*#__PURE__*/React__default.createElement(LeftSection$2, {
    isDark: isDark
  }, /*#__PURE__*/React__default.createElement(Card$1, null, outageMileStone.map(function (mileStone, index) {
    var dateTime = mileStone.dateTime,
      eventName = mileStone.eventName;
    var eventType = dateTime ? "COMPLETED" : "PENDING";
    var showLine = !(index === outageMileStone.length - 1);
    var isLastChild = outageMileStone.length - 1 === index;
    var props = {
      title: eventName,
      dateTime: dateTime,
      type: eventType,
      showLine: showLine
    };
    return /*#__PURE__*/React__default.createElement(MileStone, _extends({
      key: dateTime + '_' + index,
      isDark: isDark
    }, props, {
      isLastChild: isLastChild
    }));
  })), !disableViewCta && /*#__PURE__*/React__default.createElement(ViewDetailsWrapper, {
    isDark: isDark
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    size: "small",
    disabled: false,
    use: "secondary",
    surface: isDark ? 'dark' : 'light',
    onClick: handleViewDetails,
    "data-track": (eventSubType === null || eventSubType === void 0 ? void 0 : eventSubType.toLowerCase()) + " outage details"
  }, "View Details"))), /*#__PURE__*/React__default.createElement(RightSection$2, {
    isDark: isDark
  }, /*#__PURE__*/React__default.createElement(OutageContentContainer, {
    dangerouslySetInnerHTML: {
      __html: outageContent
    }
  }))));
};

var _templateObject$1p;
var Wrapper$2 = styled.article(_templateObject$1p || (_templateObject$1p = _taggedTemplateLiteralLoose(["\n    scale:0.99;\n    height: 435px;\n    [class^=\"OuterTileContainer-VDS__\"] {\n    padding:0;\n}\n\n    [class^=\"CarouselContainer-VDS__\"]{\n    padding-bottom: 22px;\n    padding-top:0;\n}\n"])));
var OutageCarousel = function OutageCarousel(props) {
  var _configDetails$params;
  var _props$isDark = props.isDark,
    isDark = _props$isDark === void 0 ? false : _props$isDark,
    _props$outageData = props.outageData,
    outageData = _props$outageData === void 0 ? [] : _props$outageData;
  console.log("OutageCarousel props-->", props);
  var configDetails = useContext(ConfigContext);
  var isRetail = (configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : _configDetails$params.channel) == 'Retail';
  var _useFeatureFlag = useFeatureFlag(),
    _useFeatureFlag$data = _useFeatureFlag.data,
    _useFeatureFlag$data2 = _useFeatureFlag$data === void 0 ? {} : _useFeatureFlag$data,
    _useFeatureFlag$data3 = _useFeatureFlag$data2.volteOutageTaggingFFlag,
    volteOutageTaggingFFlag = _useFeatureFlag$data3 === void 0 ? false : _useFeatureFlag$data3,
    _useFeatureFlag$data4 = _useFeatureFlag$data2.volteViewDetailsFFlag,
    volteViewDetailsFFlag = _useFeatureFlag$data4 === void 0 ? false : _useFeatureFlag$data4;
  var vzdlObj = window.vzdl;
  var handleCarouselMove = function handleCarouselMove(e, selectedGroupIdx) {
    if (volteOutageTaggingFFlag) {
      var _vzdlObj;
      props === null || props === void 0 ? void 0 : props.setSelectedCauroselIndex(selectedGroupIdx);
      if ((_vzdlObj = vzdlObj) !== null && _vzdlObj !== void 0 && _vzdlObj.target) {
        var _outageData$selectedG, _outageData$selectedG2;
        vzdlObj.target.message = (outageData === null || outageData === void 0 ? void 0 : (_outageData$selectedG = outageData[selectedGroupIdx]) === null || _outageData$selectedG === void 0 ? void 0 : (_outageData$selectedG2 = _outageData$selectedG.eventSubType) === null || _outageData$selectedG2 === void 0 ? void 0 : _outageData$selectedG2.toLowerCase()) + "Outagesummary";
      } else {
        var _outageData$selectedG3, _outageData$selectedG4;
        vzdlObj = {
          target: {
            message: (outageData === null || outageData === void 0 ? void 0 : (_outageData$selectedG3 = outageData[selectedGroupIdx]) === null || _outageData$selectedG3 === void 0 ? void 0 : (_outageData$selectedG4 = _outageData$selectedG3.eventSubType) === null || _outageData$selectedG4 === void 0 ? void 0 : _outageData$selectedG4.toLowerCase()) + "Outagesummary"
          }
        };
      }
      tagging.setPageView(vzdlObj, true);
    }
  };
  var carouselData = outageData === null || outageData === void 0 ? void 0 : outageData.map(function (outage, index) {
    var _outage$outageSummary = outage.outageSummary,
      outageSummary = _outage$outageSummary === void 0 ? '' : _outage$outageSummary;
    var id = "tile_" + ++index;
    return {
      id: id,
      title: {
        size: 'bodyLarge',
        primitive: 'div',
        children: outageSummary
      },
      subtitle: {
        size: 'bodyLarge',
        primitive: 'div',
        children: /*#__PURE__*/React__default.createElement(NetworkOutageTile, _extends({
          isDark: isDark,
          outageObj: outage
        }, props, {
          isRetail: isRetail,
          volteViewDetailsFFlag: volteViewDetailsFFlag
        }))
      },
      showBorder: false
    };
  });
  return /*#__PURE__*/React__default.createElement(Wrapper$2, null, /*#__PURE__*/React__default.createElement(Carousel, {
    viewport: "desktop",
    peek: "none",
    layout: "1UP",
    gutter: "24px",
    surface: isDark ? 'dark' : 'light',
    paginationInset: "-10px",
    paginationDisplay: "onHover",
    onChange: handleCarouselMove,
    renderItem: function renderItem(tileProps) {
      return /*#__PURE__*/React__default.createElement(Tilelet, _extends({
        backgroundColor: "gray",
        surface: isDark ? 'dark' : 'light'
      }, tileProps, {
        width: "100%",
        height: "390px"
      }));
    },
    data: carouselData
  }));
};

var _templateObject$1q, _templateObject2$17;
var NetworkOutageContainer = styled.article(_templateObject$1q || (_templateObject$1q = _taggedTemplateLiteralLoose(["\n   [id*=\"accordionDetail\"]{\n        background: unset !important;\n        padding-bottom:0\n    }\n    [class^=\"InnerElementWrapper-VDS__\"]{\n     padding-top:1rem;\n     padding-bottom:1rem;\n     padding-left: 0.5rem;\n    }\n    span[class*=\"toggleIconWrapper\"]{\n    margin-top: 1rem;\n    margin-right: 0.5rem;\n    }\n    ", "\n    margin: 16px 0 0 5px;\n"])), function (_ref) {
  var _ref$theme = _ref.theme,
    isDark = _ref$theme.isDark,
    background = _ref$theme.themeObject.background;
  return isDark && "\n        background-color: " + background + " !important;\n    ";
});
var NetworkOutagetitle = styled.span(_templateObject2$17 || (_templateObject2$17 = _taggedTemplateLiteralLoose(["\n    margin-left: 10px;\n    font-size: 16px;\n    font-weight: 700;\n"])));
var NetworkOutageMain = function NetworkOutageMain(props) {
  var _configDetails$params, _configDetails$params2, _configDetails$params3, _configDetails$params4, _configDetails$params5, _configDetails$params6, _configDetails$params7, _configDetails$params8, _configDetails$params9;
  var configDetails = useContext(ConfigContext);
  var _useFeatureFlag = useFeatureFlag(),
    _useFeatureFlag$data = _useFeatureFlag.data,
    _useFeatureFlag$data2 = _useFeatureFlag$data === void 0 ? {} : _useFeatureFlag$data,
    _useFeatureFlag$data3 = _useFeatureFlag$data2.volteOutageTaggingFFlag,
    volteOutageTaggingFFlag = _useFeatureFlag$data3 === void 0 ? false : _useFeatureFlag$data3;
  var _useState = useState(0),
    selectedCauroselIndex = _useState[0],
    setSelectedCauroselIndex = _useState[1];
  useEffect(function () {
    var accordionButton = document.querySelector(".accordionButton");
    accordionButton === null || accordionButton === void 0 ? void 0 : accordionButton.setAttribute("data-track", "networkOutageexpanded");
    var vzdlObj = window.vzdl;
    if (volteOutageTaggingFFlag) {
      var _vzdlObj;
      if ((_vzdlObj = vzdlObj) !== null && _vzdlObj !== void 0 && _vzdlObj.target) {
        vzdlObj.target.message = "networkOutagesummary";
      } else {
        vzdlObj = {
          target: {
            message: "networkOutagesummary"
          }
        };
      }
      tagging.setPageView(vzdlObj, true);
    } else {
      var _vzdlObj2;
      if ((_vzdlObj2 = vzdlObj) !== null && _vzdlObj2 !== void 0 && _vzdlObj2.target) {
        vzdlObj.target.message = "network outage summary";
      } else {
        vzdlObj = {
          target: {
            message: "network outage summary"
          }
        };
      }
    }
    return function () {
      var _window$vzdl;
      if ((_window$vzdl = window.vzdl) !== null && _window$vzdl !== void 0 && _window$vzdl.target) {
        window.vzdl.target.message = '';
      }
    };
  }, []);
  var vzdlObj = window.vzdl;
  var getAccordionState = function getAccordionState(e, open) {
    if (open === true) {
      var _e$target;
      (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.setAttribute("data-track", "networkOutagecollided");
      if (volteOutageTaggingFFlag) {
        var _vzdlObj3;
        if ((_vzdlObj3 = vzdlObj) !== null && _vzdlObj3 !== void 0 && _vzdlObj3.target) {
          var _props$outageData, _props$outageData$sel, _props$outageData$sel2;
          vzdlObj.target.message = (props === null || props === void 0 ? void 0 : (_props$outageData = props.outageData) === null || _props$outageData === void 0 ? void 0 : (_props$outageData$sel = _props$outageData[selectedCauroselIndex]) === null || _props$outageData$sel === void 0 ? void 0 : (_props$outageData$sel2 = _props$outageData$sel.eventSubType) === null || _props$outageData$sel2 === void 0 ? void 0 : _props$outageData$sel2.toLowerCase()) + "Outagesummary";
        } else {
          var _props$outageData2, _props$outageData2$se, _props$outageData2$se2;
          vzdlObj = {
            target: {
              message: ((_props$outageData2 = props.outageData) === null || _props$outageData2 === void 0 ? void 0 : (_props$outageData2$se = _props$outageData2[selectedCauroselIndex]) === null || _props$outageData2$se === void 0 ? void 0 : (_props$outageData2$se2 = _props$outageData2$se.eventSubType) === null || _props$outageData2$se2 === void 0 ? void 0 : _props$outageData2$se2.toLowerCase()) + "Outagesummary"
            }
          };
        }
        tagging.setPageView(vzdlObj, true);
      }
    } else {
      var _e$target2;
      (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.setAttribute("data-track", "networkOutageexpanded");
    }
  };
  return /*#__PURE__*/React__default.createElement(NetworkOutageContainer, {
    theme: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : _configDetails$params.theme
  }, /*#__PURE__*/React__default.createElement(TileContainer$1, {
    padding: "0px 8px",
    aspectRatio: "none",
    backgroundColor: configDetails !== null && configDetails !== void 0 && (_configDetails$params2 = configDetails.paramsDetails) !== null && _configDetails$params2 !== void 0 && (_configDetails$params3 = _configDetails$params2.theme) !== null && _configDetails$params3 !== void 0 && _configDetails$params3.isDark ? '#1B1D1F' : '#F6F6F6'
  }, /*#__PURE__*/React__default.createElement(Accordion$1, {
    topLine: false,
    bottomLine: false,
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params4 = configDetails.paramsDetails) !== null && _configDetails$params4 !== void 0 && (_configDetails$params5 = _configDetails$params4.theme) !== null && _configDetails$params5 !== void 0 && _configDetails$params5.isDark ? 'dark' : 'light'
  }, /*#__PURE__*/React__default.createElement(AccordionItem, null, /*#__PURE__*/React__default.createElement(AccordionHeader, {
    onClick: function onClick(e, opened) {
      getAccordionState(e, opened);
    }
  }, /*#__PURE__*/React__default.createElement(AccordionTitle, null, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "signal-broadcast",
    size: "large",
    color: "#000000",
    surface: configDetails !== null && configDetails !== void 0 && (_configDetails$params6 = configDetails.paramsDetails) !== null && _configDetails$params6 !== void 0 && (_configDetails$params7 = _configDetails$params6.theme) !== null && _configDetails$params7 !== void 0 && _configDetails$params7.isDark ? 'dark' : 'light'
  }), /*#__PURE__*/React__default.createElement(NetworkOutagetitle, null, "Network Outage Summary"))), /*#__PURE__*/React__default.createElement(AccordionDetail, null, /*#__PURE__*/React__default.createElement(OutageCarousel, _extends({
    isDark: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params8 = configDetails.paramsDetails) === null || _configDetails$params8 === void 0 ? void 0 : (_configDetails$params9 = _configDetails$params8.theme) === null || _configDetails$params9 === void 0 ? void 0 : _configDetails$params9.isDark,
    setSelectedCauroselIndex: setSelectedCauroselIndex
  }, props)))))));
};

var _templateObject$1r, _templateObject2$18;
var MAX_INTENTS = 5;
var Stack$1 = styled.div(_templateObject$1r || (_templateObject$1r = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding-bottom: 16px;\n"])));
var Link$1 = styled(TextLink)(_templateObject2$18 || (_templateObject2$18 = _taggedTemplateLiteralLoose(["\n  color: #0066cf;\n  text-decoration: none;\n  border-bottom: none !important;\n \n  &:hover {\n    color: #0066cf !important;\n  }\n \n"])));
var TopIntents = function TopIntents(_ref) {
  var _configDetails$params, _configDetails$params2;
  var _ref$topIntents = _ref.topIntents,
    topIntents = _ref$topIntents === void 0 ? [] : _ref$topIntents,
    _onClick = _ref.onClick,
    _ref$hide = _ref.hide,
    hide = _ref$hide === void 0 ? false : _ref$hide,
    deviceName = _ref.deviceName;
  var configDetails = useContext(ConfigContext);
  var isDark = configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$params = configDetails.paramsDetails) === null || _configDetails$params === void 0 ? void 0 : (_configDetails$params2 = _configDetails$params.theme) === null || _configDetails$params2 === void 0 ? void 0 : _configDetails$params2.isDark;
  var intents = useMemo(function () {
    return topIntents.sort(function (a, b) {
      return Number(a === null || a === void 0 ? void 0 : a.weightage) > Number(b === null || b === void 0 ? void 0 : b.weightage) ? 1 : -1;
    }).slice(0, MAX_INTENTS);
  }, [topIntents]);
  if (topIntents.length === 0 || hide) return null;
  return /*#__PURE__*/React__default.createElement(Stack$1, {
    "data-testid": "top_intents_container"
  }, /*#__PURE__*/React__default.createElement(Title, {
    primitive: "h3",
    color: isDark ? "#ffffff" : "#000000"
  }, "Top issues for ", deviceName, " "), intents.map(function (intent) {
    return /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(Link$1, {
      type: "standAlone",
      size: "large",
      onClick: function onClick() {
        return _onClick === null || _onClick === void 0 ? void 0 : _onClick(intent);
      },
      ariaLabel: intent.name,
      "data-track": "{\"type\": \"link\", \"name\": \"" + intent.name + "\"}",
      surface: isDark ? "dark" : "light"
    }, intent === null || intent === void 0 ? void 0 : intent.name));
  }));
};

var _templateObject$1s;
var CategoryContainer = styled.div(_templateObject$1s || (_templateObject$1s = _taggedTemplateLiteralLoose(["\n  width:75%;\n  position: relative;\n"])));
var CategoryDropdown = function CategoryDropdown(_ref) {
  var _useContext;
  var _ref$symptomsList = _ref.symptomsList,
    symptomsList = _ref$symptomsList === void 0 ? [] : _ref$symptomsList,
    selectedCategory = _ref.selectedCategory,
    onCategoryChange = _ref.onCategoryChange;
  var SelectCategoryElementRef = useRef(null);
  var paramsDetails = (_useContext = useContext(ParamsContext)) === null || _useContext === void 0 ? void 0 : _useContext.paramsDetails;
  var isDarkTheme = isDark$1(paramsDetails);
  useEffect(function () {
    if (SelectCategoryElementRef.current !== null && (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.title) !== "") {
      SelectCategoryElementRef.current.focus();
    }
  }, [selectedCategory]);
  return /*#__PURE__*/React__default.createElement(CategoryContainer, null, /*#__PURE__*/React__default.createElement(DropdownSelect, {
    ref: SelectCategoryElementRef,
    label: "Category",
    tabIndex: "0",
    selectId: "selectDropdownCategory",
    onChange: onCategoryChange,
    "data-track": "{\"type\": \"link\", \"name\": \"" + (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.title) + "\"}",
    surface: isDarkTheme ? 'dark' : 'light'
  }, symptomsList.map(function (items, index) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: items.symptomId + "_" + index,
      value: items.symptomId,
      noBorder: true,
      "aria-label": items.title,
      "data-track": "{\"type\": \"link\", \"name\": \"" + items.title + "\"}",
      selected: (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.title) === items.title ? true : false
    }, items.title);
  })));
};

var _templateObject$1t, _templateObject2$19;
var IssueSelectorWrapper = styled.div(_templateObject$1t || (_templateObject$1t = _taggedTemplateLiteralLoose(["\n  .categorySubHead, #selectDropdownCategory-text {\n    font-weight:400;\n    font-size:1rem;\n    margin-bottom:5px;\n  }\n"])));
var IssueSelectorMain = styled.div(_templateObject2$19 || (_templateObject2$19 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  "])));
var IssueSelectorHome = function IssueSelectorHome(_ref) {
  var _useContext, _useContext2, _outageData$outages;
  var _ref$symptomsList = _ref.symptomsList,
    symptomsList = _ref$symptomsList === void 0 ? [] : _ref$symptomsList,
    _ref$subSymptomsList = _ref.subSymptomsList,
    subSymptomsList = _ref$subSymptomsList === void 0 ? [] : _ref$subSymptomsList,
    _ref$popularSymptomLi = _ref.popularSymptomList,
    popularSymptomList = _ref$popularSymptomLi === void 0 ? [] : _ref$popularSymptomLi,
    _ref$topIntents = _ref.topIntents,
    topIntents = _ref$topIntents === void 0 ? [] : _ref$topIntents,
    handleSubSymptoms = _ref.handleSubSymptoms,
    nsaError = _ref.nsaError,
    loading = _ref.loading,
    handleTabChangeEvent = _ref.handleTabChangeEvent;
  var _ref2 = useContext(ParamsContext) || {},
    paramsDetails = _ref2.paramsDetails;
  var outageData = (_useContext = useContext(ParamsContext)) === null || _useContext === void 0 ? void 0 : _useContext.outageData;
  var healthCheckData = (_useContext2 = useContext(ParamsContext)) === null || _useContext2 === void 0 ? void 0 : _useContext2.healthCheckData;
  var _ref3 = useFeatureFlag() || {},
    _ref3$data = _ref3.data,
    _ref3$data2 = _ref3$data === void 0 ? {} : _ref3$data,
    _ref3$data2$healthChe = _ref3$data2.healthCheckDiagnosticsFFlag,
    healthCheckDiagnosticsFFlag = _ref3$data2$healthChe === void 0 ? false : _ref3$data2$healthChe;
  var _useState = useState([]),
    popularIntentList = _useState[0],
    setPopularIntentList = _useState[1];
  var _useState2 = useState(null),
    selectedCategory = _useState2[0],
    setSelectedCategory = _useState2[1];
  var _useState3 = useState(1),
    popularCurrentPage = _useState3[0],
    setPopularCurrentPage = _useState3[1];
  var _useState4 = useState(1),
    currentPage = _useState4[0],
    setCurrentPage = _useState4[1];
  var symptomsPerPage = 10;
  var _getPaginationDetails = getPaginationDetails(popularCurrentPage, symptomsPerPage, popularIntentList),
    currentPopularSymptoms = _getPaginationDetails.symptoms,
    howManyPagesForPopular = _getPaginationDetails.pageCount;
  var _getPaginationDetails2 = getPaginationDetails(currentPage, symptomsPerPage, selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.subSymptoms),
    currentSymptoms = _getPaginationDetails2.symptoms,
    howManyPages = _getPaginationDetails2.pageCount;
  useEffect(function () {
    if (paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.mdn && selectedCategory) {
      setSelectedCategory(null);
    }
  }, [paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.mdn]);
  var handleSymptomsSelect = function handleSymptomsSelect(selectedItem) {
    setSelectedCategory(selectedItem);
    sessionStorage.setItem("categoryTitle", selectedItem.title);
    setCurrentPage(1);
    var popularList = [];
    (popularSymptomList === null || popularSymptomList === void 0 ? void 0 : popularSymptomList.length) > 0 && popularSymptomList.forEach(function (item) {
      if (item.category === selectedItem.title) {
        popularList.push(item);
      }
    });
    setPopularIntentList(popularList);
  };
  var handleCategoryDropdown = function handleCategoryDropdown(e) {
    if (e.target.value !== "") {
      handleSymptomsSelect(symptomsList.find(function (symptomsItems) {
        return symptomsItems.symptomId.toString() === e.target.value.toString();
      }));
    }
  };
  var handlePaginationNext = function handlePaginationNext(pageNo) {
    setPopularCurrentPage(pageNo);
    setCurrentPage(pageNo);
  };
  var paginationProps = {
    totalPagesForPopular: howManyPagesForPopular,
    totalPagesForAlpha: howManyPages,
    handlePageNext: handlePaginationNext,
    popularCurrentPage: popularCurrentPage,
    alphaCurrentPage: currentPage
  };
  if (window && window.vzdl && window.vzdl.error && window.vzdl.error.code) {
    window.vzdl.error.code = "";
    delete window.vzdl.error;
  }
  var isDarkTheme = isDark$1(paramsDetails);
  if (!(paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.equipmentId)) {
    return /*#__PURE__*/React__default.createElement(IssueSelectorLoader, null);
  }
  if (nsaError) {
    return /*#__PURE__*/React__default.createElement(ErrorComponent, {
      handleTabChangeEvent: handleTabChangeEvent
    });
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(IssueSelectorWrapper, {
    id: "panel-0",
    role: "tabpanel",
    tabIndex: "0",
    "aria-labelledby": "tab-0",
    "data-role": "tabpanel",
    isDarkTheme: isDarkTheme
  }, (outageData === null || outageData === void 0 ? void 0 : (_outageData$outages = outageData.outages) === null || _outageData$outages === void 0 ? void 0 : _outageData$outages.length) > 0 && /*#__PURE__*/React__default.createElement(NetworkOutageMain, {
    outageData: outageData.outages,
    viewCallback: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.viewNetworkOutagePopup
  }), healthCheckDiagnosticsFFlag && /*#__PURE__*/React__default.createElement(DeviceHealthCheck, {
    deviceHealthCheckData: healthCheckData
  }), loading && /*#__PURE__*/React__default.createElement(IssueSelectorMain, null, /*#__PURE__*/React__default.createElement(IssueSelectorLoader, null)), !loading && /*#__PURE__*/React__default.createElement(IssueSelectorMain, null, /*#__PURE__*/React__default.createElement(SearchBox$4, {
    subSymptomsList: subSymptomsList,
    handleSubSymptoms: handleSubSymptoms
  }), (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.title) && /*#__PURE__*/React__default.createElement(CategoryDropdown, {
    onCategoryChange: handleCategoryDropdown,
    selectedCategory: selectedCategory,
    symptomsList: symptomsList
  }), /*#__PURE__*/React__default.createElement(TopIntents, {
    hide: !!selectedCategory,
    topIntents: topIntents,
    onClick: handleSubSymptoms,
    deviceName: paramsDetails.deviceName
  }), /*#__PURE__*/React__default.createElement(CategoryTiles, {
    hide: !!selectedCategory,
    showTitle: topIntents.length > 0,
    symptomsList: symptomsList,
    handleSymptomsSelect: handleSymptomsSelect
  }), /*#__PURE__*/React__default.createElement(SubCategoryComponent, {
    hide: !selectedCategory,
    currentPopularSymptoms: currentPopularSymptoms,
    currentSymptoms: currentSymptoms,
    paginationProps: paginationProps,
    selectedCategory: selectedCategory,
    handleSubSymptoms: handleSubSymptoms
  }))));
};

var useTroubleShootIntentStore = create(function (set, get) {
  return {
    items: [],
    addItem: function addItem(newItem) {
      return set(function (state) {
        return {
          items: [].concat(state.items, [newItem])
        };
      });
    },
    removeItem: function removeItem(index) {
      return set(function (state) {
        return {
          items: state.items.filter(function (_, i) {
            return i !== index;
          })
        };
      });
    }
  };
});
var useSpeedTestStore = create(function (set) {
  return {
    speedTestResultFlag: false,
    speedTestCode: '',
    notificationText: '',
    setSpeedTestCode: function setSpeedTestCode(code) {
      return set(function (state) {
        return {
          speedTestCode: code
        };
      });
    },
    revaidateSpeedTestState: function revaidateSpeedTestState(val) {
      return set(function (state) {
        return {
          speedTestResultFlag: !state.speedTestResultFlag
        };
      });
    },
    setNotificationText: function setNotificationText(text) {
      return set(function (state) {
        return {
          notificationText: text
        };
      });
    }
  };
});

var _templateObject$1u, _templateObject2$1a, _templateObject3$X, _templateObject4$U;
var PageWrapper$1 = styled.div(_templateObject$1u || (_templateObject$1u = _taggedTemplateLiteralLoose(["\n  margin: 0px 17px 5px 12px;\n"])));
var TroubleshootingWrapper = styled.div(_templateObject2$1a || (_templateObject2$1a = _taggedTemplateLiteralLoose([""])));
var TabWrapper = styled.div(_templateObject3$X || (_templateObject3$X = _taggedTemplateLiteralLoose(["\n  margin-bottom: 5px;\n  padding-top: ", ";\n"])), function (props) {
  return props.isDarkTheme && "5px";
});
var Tabs = styled.span(_templateObject4$U || (_templateObject4$U = _taggedTemplateLiteralLoose(["\n  margin: 0px 6px 0px 6px;\n  padding: 0px 0px 0px 0px;\n  cursor: pointer;\n  font-weight: bold;\n  font-size: 0.87rem;\n  display: ", ";\n  border: none;\n  background: none;\n\n  &:focus-visible {\n    margin-top: 3px;\n  }\n\n  ", "\n\n  ", "\n    \n    ", "\n"])), function (props) {
  return props.hide && "none";
}, function (props) {
  return !props.selectedTab && "\n    opacity: 0.5 !important;\n    ";
}, function (props) {
  return props.disabled ? "cursor: not-allowed;" : "cursor: pointer;";
}, function (props) {
  return props.selectedTab && "\n    border-top: 4px solid #d52b1e;\n    margin-top:0;\n    ";
});
var IssueSelectorNew = React__default.forwardRef(function (props, ref) {
  var _useContext, _useContext2, _configDetails$topInt, _JSON$parse, _paramsDetails$theme2, _paramsDetails$theme3;
  React__default.useImperativeHandle(ref, function () {
    return {
      issueChildhildFunction: function issueChildhildFunction() {
        resetComponent();
      }
    };
  });
  var _useFeatureFlag = useFeatureFlag(),
    _useFeatureFlag$data = _useFeatureFlag.data,
    _useFeatureFlag$data2 = _useFeatureFlag$data === void 0 ? {} : _useFeatureFlag$data,
    _useFeatureFlag$data3 = _useFeatureFlag$data2.shaAlertRedirectionFFlag,
    shaAlertRedirectionFFlag = _useFeatureFlag$data3 === void 0 ? false : _useFeatureFlag$data3;
  var paramsDetails = (_useContext = useContext(ParamsContext)) === null || _useContext === void 0 ? void 0 : _useContext.paramsDetails;
  var _useState = useState([]),
    symptomsList = _useState[0],
    setSymptomsList = _useState[1];
  var _useState2 = useState(0),
    tabIndex = _useState2[0],
    setTabIndex = _useState2[1];
  var _useState3 = useState([]),
    subSymptomsList = _useState3[0],
    setSubSymptomsList = _useState3[1];
  var _useState4 = useState([]),
    priSymBauList = _useState4[0];
  var _useState5 = useState([]),
    topIntents = _useState5[0],
    setTopIntents = _useState5[1];
  var configDetails = (_useContext2 = useContext(ParamsContext)) === null || _useContext2 === void 0 ? void 0 : _useContext2.configDetails;
  var _useState6 = useState(false),
    defaultCategory = _useState6[0],
    setDefaultCategory = _useState6[1];
  var _useState7 = useState(null),
    popularSymptomList = _useState7[0],
    setPopularSymptomList = _useState7[1];
  var _useState8 = useState(false),
    loading = _useState8[0],
    setLoading = _useState8[1];
  var _useState9 = useState({}),
    selectedNSAIntent = _useState9[0],
    setSelectedNSAIntent = _useState9[1];
  var _useState0 = useState(null),
    issueHistoryData = _useState0[0],
    setIssueHistoryData = _useState0[1];
  var _useState1 = useState(false),
    showLoader = _useState1[0],
    setShowLoader = _useState1[1];
  var _useState10 = useState(""),
    noHistoryFound = _useState10[0],
    setnoHistoryFound = _useState10[1];
  var _useState11 = useState(true),
    checkNsaCallCompleted = _useState11[0];
  var droppedCallNsaIntent = React__default.useRef(null);
  var _useState12 = useState(false),
    recomputeCaseId = _useState12[0],
    setRecomputeCaseId = _useState12[1];
  var _useState13 = useState(false),
    showIssueResolved = _useState13[0],
    setShowIssueResolved = _useState13[1];
  var _useState14 = useState(false),
    showApiFailErrMsg = _useState14[0],
    setShowApiFailErrMsg = _useState14[1];
  var _useState15 = useState(null),
    currentNsaSymptomsData = _useState15[0],
    setCurrentNsaSymptomsData = _useState15[1];
  var _useState16 = useState(false),
    nsaError = _useState16[0],
    setNsaError = _useState16[1];
  var _useState17 = useState((paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.flowName) === "nbxAlert" ? true : false),
    isShaAlert = _useState17[0],
    setIsShaAlert = _useState17[1];
  var _useTroubleShootInten = useTroubleShootIntentStore(),
    items = _useTroubleShootInten.items,
    removeItem = _useTroubleShootInten.removeItem;
  console.log("%%%%%%%%%%%%%%%%%%%%");
  console.log(paramsDetails);
  console.log(configDetails);
  console.log("--------------------");
  var tabArray = [{
    title: "Issue selector",
    tabNO: 0,
    tabRef: React__default.useRef(null)
  }, {
    title: "Device selector",
    tabNO: 3,
    tabRef: React__default.useRef(null)
  }, {
    title: "Troubleshooting",
    tabNO: 1,
    tabRef: React__default.useRef(null)
  }, {
    title: "Issue history",
    tabNO: 2,
    tabRef: React__default.useRef(null)
  }].filter(function (el) {
    return el.tabNO === 3 && !configDetails.isDeviceSelectorEnable ? false : true;
  });
  var mvoIsNsaCallLoad = React__default.useRef(false);
  var nsaSymptomsData = React__default.useRef(null);
  var sessionCacheId = React__default.useRef(null);
  var firstLetterCapitalize = function firstLetterCapitalize(word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  };
  var newNsaPayload = {
    channel: (paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.channel.toLowerCase()) === "care" ? firstLetterCapitalize(paramsDetails.channel) : paramsDetails.channel,
    tier: paramsDetails.tier,
    accountNumber: paramsDetails.accountNumber,
    mdn: paramsDetails.mdn,
    equipmentId: paramsDetails.equipmentId,
    sku: paramsDetails.sku,
    loggedInUser: paramsDetails.loggedInUser,
    categorizeIntent: configDetails.categorizeIntent,
    topIntents: (_configDetails$topInt = configDetails === null || configDetails === void 0 ? void 0 : configDetails.topIntents) != null ? _configDetails$topInt : true,
    userDeptName: ((_JSON$parse = JSON.parse(localStorage.getItem("userprofile"))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.departmentName) || "",
    changeDevice: paramsDetails.changeDeviceFlow === true,
    callerId: (paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.acssCallId) || "",
    externalTarget: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.externalTarget,
    mvoenv: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.mvoenv
  };
  useEffect(function () {
    if (items.length !== 0) {
      var currentTab = tabArray.find(function (obj) {
        return obj.tabNO === tabIndex;
      });
      if (currentTab.title == "Issue selector" && currentNsaSymptomsData !== null) {
        checkTroubleshootingIntent();
      } else {
        setShowLoader(true);
        setTabIndex(0);
        triggerIssueSelector();
      }
    }
  }, [items, currentNsaSymptomsData]);
  useEffect(function () {
    if (shaAlertRedirectionFFlag && isShaAlert) {
      sessionStorage.removeItem("isTroubleshootCaseOpen");
      var currentTab = tabArray.find(function (obj) {
        return obj.tabNO === tabIndex;
      });
      if (currentTab.title == "Issue selector" && currentNsaSymptomsData !== null) {
        redirectionFromShaAlert();
        setIsShaAlert(false);
      } else {
        setShowLoader(true);
        setTabIndex(0);
        triggerIssueSelector();
      }
    }
  }, [isShaAlert, currentNsaSymptomsData]);
  var redirectionFromShaAlert = function redirectionFromShaAlert() {
    var _currentNsaSymptomsDa;
    var intentName = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.intentName;
    var intentList = currentNsaSymptomsData === null || currentNsaSymptomsData === void 0 ? void 0 : (_currentNsaSymptomsDa = currentNsaSymptomsData.classList) === null || _currentNsaSymptomsDa === void 0 ? void 0 : _currentNsaSymptomsDa.map(function (o) {
      return o.intentList;
    });
    var intentListArray = intentList === null || intentList === void 0 ? void 0 : intentList.flat();
    var resumeIntent = intentListArray === null || intentListArray === void 0 ? void 0 : intentListArray.filter(function (o) {
      return (o === null || o === void 0 ? void 0 : o.name.toLowerCase()) === (intentName === null || intentName === void 0 ? void 0 : intentName.toLowerCase());
    });
    setShowLoader(false);
    if (resumeIntent.length) {
      handleSubSymptoms(resumeIntent[0]);
    } else {
      return;
    }
  };
  var checkTroubleshootingIntent = function checkTroubleshootingIntent() {
    var _currentNsaSymptomsDa2;
    var TroubleshootingIntent = items[0]['selctedIntent'];
    var intentName = TroubleshootingIntent["troubleshootIntent"];
    var intentList = currentNsaSymptomsData === null || currentNsaSymptomsData === void 0 ? void 0 : (_currentNsaSymptomsDa2 = currentNsaSymptomsData.classList) === null || _currentNsaSymptomsDa2 === void 0 ? void 0 : _currentNsaSymptomsDa2.map(function (o) {
      return o.intentList;
    });
    var intentListArray = intentList === null || intentList === void 0 ? void 0 : intentList.flat();
    var resumeIntent = intentListArray === null || intentListArray === void 0 ? void 0 : intentListArray.filter(function (o) {
      return (o === null || o === void 0 ? void 0 : o.name.toLowerCase()) === (intentName === null || intentName === void 0 ? void 0 : intentName.toLowerCase());
    });
    setShowLoader(false);
    removeItem(0);
    if (resumeIntent.length) {
      handleSubSymptoms(resumeIntent[0]);
    } else {
      return;
    }
  };
  useEffect(function () {
    return function cleanup() {
      var _ref = JSON.parse(sessionStorage.getItem("nsaIntentSelected")) || {},
        _ref$caseId = _ref.caseId,
        caseId = _ref$caseId === void 0 ? "" : _ref$caseId;
      var selectedTab = sessionStorage.getItem("selectedTabIndex");
      if (selectedTab !== null) {
        selectedTab = +selectedTab;
      }
      if (caseId && selectedTab == 1) {
        sessionStorage.setItem("isTroubleshootCaseOpen", "Y");
      }
    };
  }, []);
  useEffect(function () {
    var receiveMessage = function receiveMessage(event) {
      var _event$detail, _event$detail2;
      console.log("event.data-->", event === null || event === void 0 ? void 0 : event.detail);
      if (event !== null && event !== void 0 && (_event$detail = event.detail) !== null && _event$detail !== void 0 && _event$detail.issueSelectTab) {
        reInitMvoCaseId();
        resetComponent();
        reInitIssueSelector();
      }
      if (event !== null && event !== void 0 && (_event$detail2 = event.detail) !== null && _event$detail2 !== void 0 && _event$detail2.isDeviceSelectTab) {
        deviceChange();
      }
    };
    window.addEventListener("issueSelectTab", receiveMessage, false);
    window.addEventListener("isDeviceSelectTab", receiveMessage, false);
    return function () {
      window.removeEventListener("issueSelectTab", receiveMessage, false);
      window.removeEventListener("isDeviceSelectTab", receiveMessage, false);
    };
  }, []);
  var clearSessionStorage = function clearSessionStorage() {
    sessionStorage.removeItem("isTroubleshootCaseOpen");
    sessionStorage.removeItem("nsaIntentSelected");
    sessionStorage.removeItem("selectedTabIndex");
    sessionStorage.removeItem("nsaResponse");
    sessionStorage.setItem("issueSelectorInitailLoad", false);
  };
  useEffect(function () {
    if (paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.mdn && sessionStorage.getItem("currentMdn")) {
      if (sessionStorage.getItem("currentMdn") !== paramsDetails.mdn) {
        clearSessionStorage();
        if (paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.handleTabs) {
          paramsDetails.handleTabs(0);
        }
        setIssueHistoryData([]);
      }
    }
    if (paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.mdn) {
      sessionStorage.setItem("currentMdn", paramsDetails.mdn);
    }
  }, [paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.mdn]);
  useEffect(function () {
    var equipmentIdFromSession = sessionStorage.getItem("equipmentId");
    var _ref2 = paramsDetails || {},
      _ref2$equipmentId = _ref2.equipmentId,
      equipmentId = _ref2$equipmentId === void 0 ? "" : _ref2$equipmentId,
      _ref2$changeDeviceFlo = _ref2.changeDeviceFlow,
      changeDeviceFlow = _ref2$changeDeviceFlo === void 0 ? false : _ref2$changeDeviceFlo;
    if (!equipmentIdFromSession && changeDeviceFlow) {
      sessionStorage.removeItem("selectedTabIndex");
    }
    if (equipmentId && equipmentIdFromSession) {
      if (equipmentIdFromSession !== equipmentId) {
        clearSessionStorage();
      }
    }
    if (equipmentId) {
      sessionStorage.setItem("equipmentId", equipmentId);
    }
  }, [paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.equipmentId]);
  useEffect(function () {
    console.log("paramsDetails changed", paramsDetails);
  }, [paramsDetails]);
  var handleTabSwitch = function handleTabSwitch(paramsDetails, configDetails) {
    if (!(paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.equipmentId) && configDetails !== null && configDetails !== void 0 && configDetails.isDeviceSelectorEnable) {
      console.log("handleTabSwitch if ----");
      setTabIndex(3);
    } else if (paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.equipmentId) {
      console.log("handleTabSwitch else if ----");
      setTabIndex(0);
      callIssueSelector("useEffect");
    }
  };
  useEffect(function () {
    var selectedTabIndex = sessionStorage.getItem("selectedTabIndex");
    if (selectedTabIndex !== null && !isShaAlert) {
      setTabIndex(Number(selectedTabIndex));
    }
  }, []);
  useEffect(function () {
    console.log("paramsDetails-->", paramsDetails);
    if (!isShaAlert) {
      var selectedTab = sessionStorage.getItem("selectedTabIndex");
      if (selectedTab !== null && paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.equipmentId) {
        selectedTab = +selectedTab;
        if (paramsDetails.caseId || paramsDetails.lvViraCaseId) {
          violationCheckFunc();
        } else if (selectedTab == 0) {
          var mvoCaseId = sessionStorage.getItem("mvoCaseId");
          if (mvoCaseId && mvoCaseId !== "null" && mvoCaseId !== "undefined") {
            sessionStorage.setItem("issueSelectorInitailLoad", "true");
          }
          setTabIndex(0);
          triggerIssueSelector();
          setTroubleShootAreaStyles();
        } else if (selectedTab == 1) {
          callIssueSelector("useEffect");
        } else if (selectedTab == 2) {
          handleIssueSelector("useEffect");
        } else if (selectedTab == 3) {
          setTabIndex(3);
        } else {
          console.log("slecttab --- !null");
          handleTabSwitch(paramsDetails, configDetails);
        }
      } else {
        if (paramsDetails.caseId || paramsDetails.lvViraCaseId) {
          violationCheckFunc();
        } else {
          console.log("slecttab --- null");
          handleTabSwitch(paramsDetails, configDetails);
        }
      }
    }
  }, [paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.equipmentId]);
  useEffect(function () {
    if (paramsDetails.changeDeviceClicked === true && tabIndex !== 3 && configDetails !== null && configDetails !== void 0 && configDetails.isDeviceSelectorEnable) {
      setTabIndex(3);
    }
  }, [paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.changeDeviceClicked]);
  useEffect(function () {
    console.log("params changed in issueSelector", paramsDetails);
  }, [paramsDetails]);
  var violationCheckFunc = function violationCheckFunc() {
    try {
      var _temp7 = function _temp7() {
        function _temp5() {
          var _violationCheckData = violationCheckData,
            _violationCheckData$r = _violationCheckData.response,
            _violationCheckData$r2 = _violationCheckData$r === void 0 ? {} : _violationCheckData$r,
            _violationCheckData$r3 = _violationCheckData$r2.data,
            _violationCheckData$r4 = _violationCheckData$r3 === void 0 ? {} : _violationCheckData$r3,
            _violationCheckData$r5 = _violationCheckData$r4.body,
            body = _violationCheckData$r5 === void 0 ? {} : _violationCheckData$r5,
            _violationCheckData$s = _violationCheckData.success,
            success = _violationCheckData$s === void 0 ? false : _violationCheckData$s;
          var _temp3 = function () {
            if (success) {
              var _window, _window$caseDetails, _window3, _window3$caseDetails;
              var _temp2 = function _temp2() {
                if (paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.handleTabs) {
                  paramsDetails.handleTabs(1);
                }
              };
              setShowApiFailErrMsg(false);
              var _body$intent = body.intent,
                intent = _body$intent === void 0 ? "" : _body$intent,
                _body$intentId = body.intentId,
                intentId = _body$intentId === void 0 ? "" : _body$intentId,
                _body$continueTrouble = body.continueTroubleshooting,
                continueTroubleshooting = _body$continueTrouble === void 0 ? false : _body$continueTrouble,
                _body$caseId = body.caseId,
                caseId = _body$caseId === void 0 ? "" : _body$caseId;
              if ((_window = window) !== null && _window !== void 0 && (_window$caseDetails = _window.caseDetails) !== null && _window$caseDetails !== void 0 && _window$caseDetails.intent) {
                var _window2, _window2$caseDetails;
                intent = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$caseDetails = _window2.caseDetails) === null || _window2$caseDetails === void 0 ? void 0 : _window2$caseDetails.intent;
              }
              if ((_window3 = window) !== null && _window3 !== void 0 && (_window3$caseDetails = _window3.caseDetails) !== null && _window3$caseDetails !== void 0 && _window3$caseDetails.intentId) {
                var _window4, _window4$caseDetails;
                intentId = (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$caseDetails = _window4.caseDetails) === null || _window4$caseDetails === void 0 ? void 0 : _window4$caseDetails.intentId;
              }
              var _temp = function (_window5, _window5$config) {
                if (intentId && continueTroubleshooting || (_window5 = window) !== null && _window5 !== void 0 && (_window5$config = _window5.config) !== null && _window5$config !== void 0 && _window5$config.portalStandalone) {
                  setShowIssueResolved(false);
                  return Promise.resolve(setSelectedNSAIntent({
                    intent: intent,
                    intentId: intentId
                  })).then(function () {
                    return Promise.resolve(sessionStorage.setItem("nsaIntentSelected", JSON.stringify({
                      intent: intent,
                      intentId: intentId,
                      mdn: paramsDetails.mdn,
                      caseId: caseId
                    }))).then(function () {
                      return Promise.resolve(sessionStorage.setItem("mvoCaseId", JSON.stringify(caseId))).then(function () {
                        return Promise.resolve(sessionStorage.setItem("processAction", "")).then(function () {
                          return Promise.resolve(sessionStorage.setItem("processStep", "resume")).then(function () {
                            setTabIndex(1);
                          });
                        });
                      });
                    });
                  });
                } else {
                  handleIssueSelector("useEffect");
                }
              }();
              return _temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp);
            } else {
              setTabIndex(1);
              setShowApiFailErrMsg(true);
            }
          }();
          if (_temp3 && _temp3.then) return _temp3.then(function () {});
        }
        var _temp4 = function (_violationCheckData2, _violationCheckData2$, _violationCheckData2$2, _violationCheckData2$3) {
          if ((_violationCheckData2 = violationCheckData) !== null && _violationCheckData2 !== void 0 && (_violationCheckData2$ = _violationCheckData2.response) !== null && _violationCheckData2$ !== void 0 && (_violationCheckData2$2 = _violationCheckData2$.data) !== null && _violationCheckData2$2 !== void 0 && (_violationCheckData2$3 = _violationCheckData2$2.body) !== null && _violationCheckData2$3 !== void 0 && _violationCheckData2$3.continueTroubleshooting || !paramsDetails.lvViraCaseId) {
            var _violationCheckData3, _violationCheckData3$, _violationCheckData3$2;
            var violationCheckPayload = {
              caseId: paramsDetails.lvViraCaseId ? (_violationCheckData3 = violationCheckData) === null || _violationCheckData3 === void 0 ? void 0 : (_violationCheckData3$ = _violationCheckData3.response) === null || _violationCheckData3$ === void 0 ? void 0 : (_violationCheckData3$2 = _violationCheckData3$.data) === null || _violationCheckData3$2 === void 0 ? void 0 : _violationCheckData3$2.body.caseId : paramsDetails.caseId,
              accountNumber: paramsDetails.accountNumber,
              mtn: paramsDetails.mdn
            };
            return Promise.resolve(getAllCases(violationCheckPayload, envData)).then(function (_getAllCases) {
              violationCheckData = _getAllCases;
            });
          }
        }();
        return _temp4 && _temp4.then ? _temp4.then(_temp5) : _temp5(_temp4);
      };
      var violationCheckData;
      var envData = {
        externalTarget: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.externalTarget,
        mvoenv: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.mvoenv
      };
      var _temp6 = function () {
        if (paramsDetails.lvViraCaseId) {
          var getViraCaseIdForLVayload = {
            deviceSku: paramsDetails.sku,
            intent: "Service Address Mismatch",
            intentId: "IN11902",
            channelId: "My Verizon",
            caseId: "",
            accountNumber: paramsDetails.accountNumber,
            mtn: paramsDetails.mdn,
            processAction: "",
            processStep: "Next",
            changeDevice: false,
            locationViolationInfo: {
              lvCaseId: paramsDetails.lvViraCaseId
            }
          };
          return Promise.resolve(getViraCaseIdForLv(getViraCaseIdForLVayload, envData)).then(function (_getViraCaseIdForLv) {
            violationCheckData = _getViraCaseIdForLv;
          });
        }
      }();
      return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(_temp7) : _temp7(_temp6));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var _callTrggerIssueSel = function callTrggerIssueSel(tabChange) {
    try {
      var getChkNsaTimeout = setTimeout(function () {
        if (checkNsaCallCompleted) {
          console.log("^^^^checkNsaCallCompleted^^^^^^", checkNsaCallCompleted);
          triggerIssueSelector(tabChange);
          clearTimeout(getChkNsaTimeout);
          setLoading(false);
        } else {
          _callTrggerIssueSel(tabChange);
        }
      }, 1000);
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var triggerIssueSelector = function triggerIssueSelector(tabChange) {
    try {
      var _temp12 = function () {
        if (!(configDetails !== null && configDetails !== void 0 && configDetails.categorizeIntent) && !(configDetails !== null && configDetails !== void 0 && configDetails.oneApi)) {
          sessionStorage.setItem("firstPageLoad", true);
          setLoading(true);
          return Promise.resolve(getDeviceSymptoms()).then(function () {
            setLoading(false);
            return Promise.resolve(JSON.parse(sessionStorage.getItem("nsaIntentSelected"))).then(function (nsaIntentSelected) {
              function _temp0() {
                return Promise.resolve(callNsaIssueData()).then(function () {});
              }
              var _temp9 = function () {
                if (!tabChange) {
                  var _temp8 = function () {
                    if (nsaIntentSelected && (nsaIntentSelected === null || nsaIntentSelected === void 0 ? void 0 : nsaIntentSelected.mdn) === paramsDetails.mdn) {
                      return Promise.resolve(sessionStorage.setItem("processStep", "resume")).then(function () {
                        return Promise.resolve(sessionStorage.setItem("mvoCaseId", JSON.stringify(nsaIntentSelected === null || nsaIntentSelected === void 0 ? void 0 : nsaIntentSelected.caseId))).then(function () {
                          setSelectedNSAIntent(nsaIntentSelected);
                          setTabIndex(1);
                          if (paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.handleTabs) {
                            paramsDetails.handleTabs(1);
                          }
                        });
                      });
                    } else {
                      return Promise.resolve(sessionStorage.removeItem("nsaIntentSelected")).then(function () {});
                    }
                  }();
                  if (_temp8 && _temp8.then) return _temp8.then(function () {});
                }
              }();
              return _temp9 && _temp9.then ? _temp9.then(_temp0) : _temp0(_temp9);
            });
          });
        } else {
          var _temp13 = function () {
            if (configDetails.nsaPrimary) {
              console.log("configDetails.nsaPrimary - checkNsaCallCompleted===", checkNsaCallCompleted);
              var _temp1 = function () {
                if (checkNsaCallCompleted) {
                  return Promise.resolve(getPrimaryNsaCall(tabChange, false, false)).then(function () {});
                } else {
                  setLoading(true);
                  _callTrggerIssueSel(tabChange);
                }
              }();
              if (_temp1 && _temp1.then) return _temp1.then(function () {});
            } else {
              var _temp14 = function () {
                if (configDetails !== null && configDetails !== void 0 && configDetails.categorizeIntent && configDetails !== null && configDetails !== void 0 && configDetails.oneApi) {
                  return Promise.resolve(getNsaCall(tabChange, false)).then(function () {});
                }
              }();
              if (_temp14 && _temp14.then) return _temp14.then(function () {});
            }
          }();
          if (_temp13 && _temp13.then) return _temp13.then(function () {});
        }
      }();
      return Promise.resolve(_temp12 && _temp12.then ? _temp12.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var getNsaCall = function getNsaCall(tabChange, isNewCaseId) {
    try {
      var _configDetails$topInt2;
      var nsaUrl = (paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.externalTarget) + tsaEnvConfig("development").apiUrls.getnsasymptoms;
      if (paramsDetails.mvoenv !== "development") {
        nsaUrl = (paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.externalTarget) + tsaEnvConfig().apiUrls.getnsasymptoms;
      }
      setNsaError(false);
      setLoading(true);
      mvoIsNsaCallLoad.current = true;
      var paramsChannel = paramsDetails.channel.toLowerCase() === "care" ? firstLetterCapitalize(paramsDetails.channel) : paramsDetails.channel;
      var nsaPayload = {
        channel: paramsChannel,
        tier: paramsDetails.tier,
        accountNumber: paramsDetails.accountNumber,
        mdn: paramsDetails.mdn,
        equipmentId: paramsDetails.equipmentId,
        sku: paramsDetails.sku,
        loggedInUser: paramsDetails.loggedInUser,
        categorizeIntent: configDetails.categorizeIntent,
        topIntents: (_configDetails$topInt2 = configDetails === null || configDetails === void 0 ? void 0 : configDetails.topIntents) != null ? _configDetails$topInt2 : true
      };
      if (paramsDetails.changeDeviceFlow === true) {
        nsaPayload.changeDevice = true;
      }
      console.log("paramsDetails===", paramsDetails);
      if (typeof paramsDetails.acssCallId !== "undefined" && paramsDetails.acssCallId !== "") {
        nsaPayload.callerId = paramsDetails.acssCallId;
      }
      return Promise.resolve(getNsaSymptomsPageLoad(paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.externalTarget, paramsDetails.mvoenv, paramsDetails.channelId, nsaPayload).then(function (nsaResponse) {
        try {
          mvoIsNsaCallLoad.current = false;
          setLoading(false);
          var _temp18 = function () {
            if (nsaResponse.response.data.body) {
              var _data, _data$classList;
              setCurrentNsaSymptomsData(nsaResponse.response.data.body);
              var primarySymtomsList = [];
              if (((_data = data) === null || _data === void 0 ? void 0 : (_data$classList = _data.classList) === null || _data$classList === void 0 ? void 0 : _data$classList.length) == 0) {
                setNsaError(true);
              } else {
                setNsaError(false);
              }
              return Promise.resolve(JSON.parse(sessionStorage.getItem("nsaIntentSelected"))).then(function (nsaIntentSelected) {
                function _temp17() {
                  var subSymptoms = [];
                  if (isNewCaseId) {
                    var _data2;
                    sessionStorage.setItem("futureCaseId", JSON.stringify((_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.caseId));
                  } else {
                    var _primarySymtomsList, _primarySymtomsList2, _data3, _data3$getSymptomsRes;
                    var nsaSymptomsArray = [];
                    data["classList"] = data.classList.filter(function (classListEle) {
                      if (classListEle.intentList && classListEle.intentList.length > 0) {
                        classListEle["intentList"] = classListEle.intentList.filter(function (intentEle) {
                          if (intentEle.name !== "") {
                            return intentEle;
                          }
                        });
                      }
                      if (classListEle.name !== "") {
                        return classListEle;
                      }
                    });
                    nsaSymptomsArray.length = 0;
                    data.classList.forEach(function (getNsaItem, getNsaIndex) {
                      if (typeof getNsaItem.intentList !== "undefined" && getNsaItem.intentList.length > 0) {
                        var nsaItem = getNsaItem.intentList.map(function (obj) {
                          obj["title"] = obj.name;
                          obj["symptomId"] = obj.id.split("IN")[1];
                          return obj;
                        });
                        getNsaItem.intentList = nsaItem;
                      }
                      nsaSymptomsArray.push({
                        title: getNsaItem.name,
                        subSymptoms: typeof getNsaItem.intentList !== "undefined" ? getNsaItem.intentList : "",
                        symptomId: getNsaItem.id
                      });
                    });
                    (_primarySymtomsList = primarySymtomsList).push.apply(_primarySymtomsList, nsaSymptomsArray);
                    primarySymtomsList = primarySymtomsList.sort(function (a, b) {
                      return a.title > b.title ? 1 : -1;
                    });
                    (_primarySymtomsList2 = primarySymtomsList) === null || _primarySymtomsList2 === void 0 ? void 0 : _primarySymtomsList2.forEach(function (item) {
                      if (item.subSymptoms.length > 0) {
                        subSymptoms.push.apply(subSymptoms, item.subSymptoms);
                      }
                    });
                    console.log("subSymptoms==", subSymptoms);
                    setSubSymptomsList(subSymptoms);
                    sessionCacheId.current = (_data3 = data) === null || _data3 === void 0 ? void 0 : (_data3$getSymptomsRes = _data3.getSymptomsResult) === null || _data3$getSymptomsRes === void 0 ? void 0 : _data3$getSymptomsRes.sessionCacheId;
                    setSymptomsList(primarySymtomsList);
                  }
                  setLoading(false);
                  return Promise.resolve(JSON.parse(sessionStorage.getItem("useCaseId"))).then(function (useCaseId) {
                    return Promise.resolve(JSON.parse(sessionStorage.getItem("mvoIntentSelected"))).then(function (item) {
                      if (useCaseId && item) {
                        moveToHandleIntents();
                      }
                    });
                  });
                }
                var _temp16 = function () {
                  if (!tabChange) {
                    var _temp15 = function () {
                      if (nsaIntentSelected && (nsaIntentSelected === null || nsaIntentSelected === void 0 ? void 0 : nsaIntentSelected.mdn) === paramsDetails.mdn) {
                        return Promise.resolve(sessionStorage.setItem("processStep", "resume")).then(function () {
                          return Promise.resolve(sessionStorage.setItem("mvoCaseId", JSON.stringify(nsaIntentSelected === null || nsaIntentSelected === void 0 ? void 0 : nsaIntentSelected.caseId))).then(function () {
                            setSelectedNSAIntent(nsaIntentSelected);
                            setTabIndex(1);
                            if (paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.handleTabs) {
                              paramsDetails.handleTabs(1);
                            }
                          });
                        });
                      } else {
                        return Promise.resolve(sessionStorage.removeItem("nsaIntentSelected")).then(function () {});
                      }
                    }();
                    if (_temp15 && _temp15.then) return _temp15.then(function () {});
                  }
                }();
                return _temp16 && _temp16.then ? _temp16.then(_temp17) : _temp17(_temp16);
              });
            } else {
              setNsaError(true);
            }
          }();
          return Promise.resolve(_temp18 && _temp18.then ? _temp18.then(function () {}) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      })["catch"](function (error) {
        setNsaError(true);
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var getPrimaryNsaCall = function getPrimaryNsaCall(tabChange, isNewCaseId, intentSelectionCall, intentType) {
    try {
      setNsaError(false);
      var _temp19 = _catch(function () {
        if (items.length == 0) {
          setLoading(true);
        }
        return Promise.resolve(getNsaSymptomsData(newNsaPayload)).then(function (newNsaResponse) {
          var _newNsaResponse$data6, _newNsaResponse$data7, _newNsaResponse$data8, _newNsaResponse$class, _primarySymtomsList3, _primarySymtomsList4, _primarySymtomsList5, _newNsaResponse$data9, _newNsaResponse$data0;
          console.log("newNsaResponse--", newNsaResponse);
          var _newNsaResponse$data = newNsaResponse.data,
            _newNsaResponse$data2 = _newNsaResponse$data === void 0 ? {} : _newNsaResponse$data,
            _newNsaResponse$data3 = _newNsaResponse$data2.body,
            _newNsaResponse$data4 = _newNsaResponse$data3 === void 0 ? {} : _newNsaResponse$data3,
            _newNsaResponse$data5 = _newNsaResponse$data4.caseId,
            caseId = _newNsaResponse$data5 === void 0 ? "" : _newNsaResponse$data5;
          console.log("caseId--", caseId);
          var newResponseList = newNsaResponse === null || newNsaResponse === void 0 ? void 0 : (_newNsaResponse$data6 = newNsaResponse.data) === null || _newNsaResponse$data6 === void 0 ? void 0 : _newNsaResponse$data6.body;
          setCurrentNsaSymptomsData(newResponseList);
          var topIntentsFromResponse = (newNsaResponse === null || newNsaResponse === void 0 ? void 0 : (_newNsaResponse$data7 = newNsaResponse.data) === null || _newNsaResponse$data7 === void 0 ? void 0 : (_newNsaResponse$data8 = _newNsaResponse$data7.body) === null || _newNsaResponse$data8 === void 0 ? void 0 : _newNsaResponse$data8.topIntents) || [];
          var combinedTopIntents = topIntentsFromResponse.map(function (intent) {
            return _extends({}, intent, {
              nsaIntentId: intent === null || intent === void 0 ? void 0 : intent.id
            });
          });
          setTopIntents(combinedTopIntents);
          var subSymptoms = [];
          var popularSymptoms = [];
          var nsaSymptomsArray = [];
          var primarySymtomsList = [];
          if ((newNsaResponse === null || newNsaResponse === void 0 ? void 0 : (_newNsaResponse$class = newNsaResponse.classList) === null || _newNsaResponse$class === void 0 ? void 0 : _newNsaResponse$class.length) == 0) {
            setNsaError(true);
          }
          newResponseList["classList"] = newResponseList.classList.filter(function (classListEle) {
            if (classListEle.intentList && classListEle.intentList.length > 0) {
              classListEle["intentList"] = classListEle.intentList.filter(function (intentEle) {
                if (intentEle.name !== "") {
                  return intentEle;
                }
              });
            }
            if (classListEle.name !== "") {
              return classListEle;
            }
          });
          newResponseList.classList.forEach(function (getNsaItem, getNsaIndex) {
            if (typeof getNsaItem.intentList !== "undefined" && getNsaItem.intentList.length > 0) {
              var nsaItem = getNsaItem.intentList.map(function (obj) {
                obj["title"] = obj.name;
                obj["synonyms"] = obj.synonym;
                obj["usage"] = obj.weightage;
                return obj;
              });
              getNsaItem.intentList = nsaItem;
            }
            if (typeof getNsaItem.popularIntentList !== "undefined" && getNsaItem.popularIntentList.length > 0) {
              var _nsaItem = getNsaItem.popularIntentList.map(function (obj) {
                obj["category"] = getNsaItem.name;
                return obj;
              });
              getNsaItem.popularIntentList = _nsaItem;
            }
            nsaSymptomsArray.push({
              title: getNsaItem.name,
              subSymptoms: typeof getNsaItem.intentList !== "undefined" ? getNsaItem.intentList : "",
              popularIntentList: typeof getNsaItem.popularIntentList !== "undefined" ? getNsaItem.popularIntentList : "",
              symptomId: getNsaItem.id
            });
          });
          (_primarySymtomsList3 = primarySymtomsList).push.apply(_primarySymtomsList3, nsaSymptomsArray);
          primarySymtomsList = primarySymtomsList.sort(function (a, b) {
            return a.title > b.title ? 1 : -1;
          });
          (_primarySymtomsList4 = primarySymtomsList) === null || _primarySymtomsList4 === void 0 ? void 0 : _primarySymtomsList4.forEach(function (item) {
            if (item.subSymptoms.length > 0) {
              subSymptoms.push.apply(subSymptoms, item.subSymptoms);
            }
          });
          (_primarySymtomsList5 = primarySymtomsList) === null || _primarySymtomsList5 === void 0 ? void 0 : _primarySymtomsList5.forEach(function (item) {
            var _item$popularIntentLi;
            if ((item === null || item === void 0 ? void 0 : (_item$popularIntentLi = item.popularIntentList) === null || _item$popularIntentLi === void 0 ? void 0 : _item$popularIntentLi.length) > 0) {
              popularSymptoms.push.apply(popularSymptoms, item.popularIntentList);
            }
          });
          console.log("subSymptoms==", subSymptoms);
          console.log("popularSymptoms==", popularSymptoms);
          console.log("primarySymtomsList---", primarySymtomsList);
          if (caseId && primarySymtomsList.length > 0) {
            sessionStorage.setItem("issueSelectorInitailLoad", JSON.stringify(true));
          } else {
            setNsaError(true);
            sessionStorage.setItem("issueSelectorInitailLoad", JSON.stringify(false));
          }
          setSubSymptomsList(subSymptoms);
          setPopularSymptomList(popularSymptoms);
          setSymptomsList(primarySymtomsList);
          var nsaSessionArray = [newNsaResponse, {}];
          sessionStorage.setItem("nsaResponse", JSON.stringify(nsaSessionArray));
          sessionStorage.setItem("mvoCaseId", JSON.stringify(newNsaResponse === null || newNsaResponse === void 0 ? void 0 : (_newNsaResponse$data9 = newNsaResponse.data) === null || _newNsaResponse$data9 === void 0 ? void 0 : (_newNsaResponse$data0 = _newNsaResponse$data9.body) === null || _newNsaResponse$data0 === void 0 ? void 0 : _newNsaResponse$data0.caseId));
          setLoading(false);
          setNsaError(false);
          return Promise.resolve(JSON.parse(sessionStorage.getItem("useCaseId"))).then(function (useCaseId) {
            return Promise.resolve(JSON.parse(sessionStorage.getItem("mvoIntentSelected"))).then(function (item) {
              if (useCaseId && item) {
                moveToHandleIntents();
              }
            });
          });
        });
      }, function (error) {
        console.log("Error from getNsaSymptomsData", error);
        setNsaError(true);
        setLoading(false);
      });
      return Promise.resolve(_temp19 && _temp19.then ? _temp19.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var setTroubleShootAreaStyles = function setTroubleShootAreaStyles(height, overflow) {
    var troubleshootingTab = document.querySelector(".troubleshoottabarea");
    if (troubleshootingTab !== null) {
      troubleshootingTab.style.height = "700px";
      troubleshootingTab.style.overflow = "auto";
      troubleshootingTab.style.width = "99.5%";
    }
  };
  useEffect(function () {
    if ((topIntents === null || topIntents === void 0 ? void 0 : topIntents.length) > 0) {
      setTroubleShootAreaStyles();
    }
  }, [topIntents]);
  useEffect(function () {
    try {
      var _window6;
      var isRetail = paramsDetails.channel.toLowerCase() === "retail";
      var isPopOutFlow = (_window6 = window) !== null && _window6 !== void 0 && _window6.isBAUACSS ? true : false;
      if (isRetail) {
        var _window$config$soeGui, _window7, _window7$config, _window8, _window8$config, _window$config$outlet, _window9, _window9$config, _configDetails$mtns, _configDetails$mtns$, _configDetails$mtns2, _configDetails$mtns2$, _configDetails$mtns3, _configDetails$mtns3$, _paramsDetails$accoun, _paramsDetails$accoun2;
        tagging.setPageView({
          page: {
            channel: "Support",
            channelSession: (_window$config$soeGui = (_window7 = window) === null || _window7 === void 0 ? void 0 : (_window7$config = _window7.config) === null || _window7$config === void 0 ? void 0 : _window7$config.soeGuiSubKey) != null ? _window$config$soeGui : "",
            displayChannel: ((_window8 = window) === null || _window8 === void 0 ? void 0 : (_window8$config = _window8.config) === null || _window8$config === void 0 ? void 0 : _window8$config.indirect) === "Y" ? "indirect" : "retail",
            sourceChannel: "POS",
            detail: "",
            flow: window.isBAUACSS ? "troubleshooter| POS_pop out" : "troubleshooter| POS_embedded",
            subFlow: "",
            throttle: "NSA",
            name: "ts| Issue Selector",
            url: document.referrer + 'sales/global-nav/home.html'
          },
          support: {
            issueNumber: "",
            tsaIssueName: "",
            tsaStepName: ""
          },
          target: {
            engagement: {
              intent: "support"
            }
          },
          env: {
            businessUnit: "Wireless"
          },
          txn: _extends({}, getVZDLObject(txnKeys), {
            agentRole: "Rep",
            agent: paramsDetails.loggedInUser,
            outletId: (_window$config$outlet = (_window9 = window) === null || _window9 === void 0 ? void 0 : (_window9$config = _window9.config) === null || _window9$config === void 0 ? void 0 : _window9$config.outletId) != null ? _window$config$outlet : ""
          }),
          user: _extends({}, getVZDLObject(userKeys), {
            account: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$mtns = configDetails.mtns) === null || _configDetails$mtns === void 0 ? void 0 : (_configDetails$mtns$ = _configDetails$mtns[0]) === null || _configDetails$mtns$ === void 0 ? void 0 : _configDetails$mtns$.hashedAccountNumber,
            id: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$mtns2 = configDetails.mtns) === null || _configDetails$mtns2 === void 0 ? void 0 : (_configDetails$mtns2$ = _configDetails$mtns2[0]) === null || _configDetails$mtns2$ === void 0 ? void 0 : _configDetails$mtns2$.mtnhashCode,
            accountType: "LLP",
            customerType: "PE",
            numberOfLines: "",
            authStatus: "logged in",
            zip: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$mtns3 = configDetails.mtns) === null || _configDetails$mtns3 === void 0 ? void 0 : (_configDetails$mtns3$ = _configDetails$mtns3[0]) === null || _configDetails$mtns3$ === void 0 ? void 0 : _configDetails$mtns3$.zipCode,
            accountLast2: paramsDetails === null || paramsDetails === void 0 ? void 0 : (_paramsDetails$accoun = paramsDetails.accountNumber) === null || _paramsDetails$accoun === void 0 ? void 0 : _paramsDetails$accoun.substr((paramsDetails === null || paramsDetails === void 0 ? void 0 : (_paramsDetails$accoun2 = paramsDetails.accountNumber) === null || _paramsDetails$accoun2 === void 0 ? void 0 : _paramsDetails$accoun2.length) - 2)
          }),
          utils: _extends({}, getVZDLObject(utilsKeys)),
          cmp: {
            all: ""
          },
          error: {
            code: ""
          },
          park: {
            csFlag: ""
          },
          platform: {
            call: ""
          },
          search: {
            term: "",
            type: "",
            results: ""
          },
          event: {
            value: ""
          }
        }, true, isPopOutFlow);
      }
    } catch (error) {
      console.log("setPageView error", error);
    }
  }, []);
  var handleIssueSelector = function handleIssueSelector(from) {
    try {
      var _paramsDetails$change = paramsDetails.changeDeviceFlow,
        changeDeviceFlow = _paramsDetails$change === void 0 ? false : _paramsDetails$change;
      var _temp20 = function () {
        if (from == "useEffect" && configDetails !== null && configDetails !== void 0 && configDetails.isIssueHistoryEnable && !changeDeviceFlow) {
          setShowLoader(true);
          return Promise.resolve(ChangeTabIssueHistory(paramsDetails)).then(function (issueHistoryData) {
            var _issueHistoryData$res, _issueHistoryData$res2, _issueHistoryData$res3, _issueHistoryData$res4;
            if ((issueHistoryData === null || issueHistoryData === void 0 ? void 0 : (_issueHistoryData$res = issueHistoryData.response) === null || _issueHistoryData$res === void 0 ? void 0 : (_issueHistoryData$res2 = _issueHistoryData$res.data) === null || _issueHistoryData$res2 === void 0 ? void 0 : (_issueHistoryData$res3 = _issueHistoryData$res2.body) === null || _issueHistoryData$res3 === void 0 ? void 0 : (_issueHistoryData$res4 = _issueHistoryData$res3.issueHistory) === null || _issueHistoryData$res4 === void 0 ? void 0 : _issueHistoryData$res4.length) > 0) {
              setTabIndex(2);
              setIssueHistoryData(issueHistoryData.response.data.body.issueHistory);
              setTroubleShootAreaStyles("660px", "scroll");
            } else if (tabIndex === 0 && configDetails !== null && configDetails !== void 0 && configDetails.isIssueSelectorEnable) {
              triggerIssueSelector(true);
              setTroubleShootAreaStyles("660px", "scroll");
            } else {
              triggerIssueSelector();
              setTroubleShootAreaStyles("735px", "auto");
            }
            setShowLoader(false);
          });
        } else if (tabIndex === 0 && configDetails !== null && configDetails !== void 0 && configDetails.isIssueSelectorEnable) {
          triggerIssueSelector(true);
          setTroubleShootAreaStyles("660px", "scroll");
        } else {
          setTroubleShootAreaStyles("735px", "auto");
          triggerIssueSelector(true);
        }
      }();
      return Promise.resolve(_temp20 && _temp20.then ? _temp20.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var callIssueSelector = function callIssueSelector(from) {
    try {
      if (from === "tabChange") sessionStorage.removeItem("isTroubleshootCaseOpen");
      var _temp22 = function () {
        if (sessionStorage.getItem("isTroubleshootCaseOpen") === "Y" && from != "tabChange") {
          var _ref3 = JSON.parse(sessionStorage.getItem("nsaIntentSelected")) || {},
            _ref3$caseId = _ref3.caseId,
            caseId = _ref3$caseId === void 0 ? "" : _ref3$caseId;
          var _temp21 = function () {
            if (caseId) {
              return Promise.resolve(sessionStorage.setItem("processStep", "resume")).then(function () {
                return Promise.resolve(sessionStorage.setItem("mvoCaseId", JSON.stringify(caseId))).then(function () {
                  setSelectedNSAIntent(JSON.parse(sessionStorage.getItem("nsaIntentSelected")));
                  sessionStorage.setItem("issueSelectorInitailLoad", JSON.stringify(true));
                  setTabIndex(1);
                  if (paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.handleTabs) {
                    paramsDetails.handleTabs(1);
                  }
                });
              });
            } else {
              handleIssueSelector(from);
            }
          }();
          if (_temp21 && _temp21.then) return _temp21.then(function () {});
        } else {
          handleIssueSelector(from);
        }
      }();
      return Promise.resolve(_temp22 && _temp22.then ? _temp22.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var _useState18 = useState(null),
    howToData = _useState18[0],
    setHowToData = _useState18[1];
  var handleSubSymptoms = function handleSubSymptoms(item, parentSymptomId) {
    try {
      setHowToData(null);
      var categoryTitle;
      if (configDetails !== null && configDetails !== void 0 && configDetails.categorizeIntent) {
        sessionStorage.setItem("useCaseId", JSON.stringify(true));
        sessionStorage.setItem("nsaIntentSelected", JSON.stringify(null));
        sessionStorage.setItem("mvoIntentSelected", JSON.stringify(item));
        sessionStorage.setItem("mvoParentCategoryId", parentSymptomId);
        setTroubleShootAreaStyles("735px", "auto");
        moveToHandleIntents(true);
        for (var i = 0; i < symptomsList.length; i++) {
          if (typeof symptomsList[i].intentList !== "undefined") {
            for (var j = 0; j < symptomsList[i].intentList.length; j++) {
              if (symptomsList[i].intentList[j].symptomId == item.symptomId) {
                categoryTitle = symptomsList[i].name;
                console.log("rana------- categoty----title-----", categoryTitle);
                sessionStorage.setItem("categoryTitle", categoryTitle);
              }
            }
          }
        }
        for (var _i = 0; _i < symptomsList.length; _i++) {
          if (typeof symptomsList[_i].subSymptoms !== "undefined") {
            for (var _j = 0; _j < symptomsList[_i].subSymptoms.length; _j++) {
              if (symptomsList[_i].subSymptoms[_j].id == item.id) {
                categoryTitle = symptomsList[_i].title;
                sessionStorage.setItem("categoryTitle", categoryTitle);
              }
            }
          }
        }
      } else {
        console.log("testing function rana======symptom list===", symptomsList);
        console.log("testing function rana======symptom id for filter===", item.symptomId);
        for (var _i2 = 0; _i2 < symptomsList.length; _i2++) {
          for (var _j2 = 0; _j2 < symptomsList[_i2].subSymptoms.length; _j2++) {
            if (symptomsList[_i2].subSymptoms[_j2].symptomId == item.symptomId) {
              categoryTitle = symptomsList[_i2].title;
              sessionStorage.setItem("categoryTitle", categoryTitle);
            }
          }
        }
        if (!parentSymptomId) {
          console.log("^^^^^^^symptomsList^^^^^^^^");
          console.log(parentSymptomId);
          console.log(symptomsList);
          for (var _i3 = 0; _i3 < symptomsList.length; _i3++) {
            for (var _j3 = 0; _j3 < symptomsList[_i3].subSymptoms.length; _j3++) {
              console.log("===parentSymptomId===");
              console.log(symptomsList[_i3].subSymptoms[_j3].title);
              console.log(item.title);
              console.log(symptomsList[_i3].subSymptoms[_j3].symptomId);
              console.log(item.symptomId);
              if (symptomsList[_i3].subSymptoms[_j3].title === item.title && symptomsList[_i3].subSymptoms[_j3].symptomId === item.symptomId) {
                var _symptomsList$_i;
                parentSymptomId = (_symptomsList$_i = symptomsList[_i3]) === null || _symptomsList$_i === void 0 ? void 0 : _symptomsList$_i.symptomId;
                console.log("---parentSymptomId---", parentSymptomId);
              }
            }
          }
        }
        sessionStorage.setItem("useCaseId", JSON.stringify(true));
        sessionStorage.setItem("nsaIntentSelected", JSON.stringify(null));
        sessionStorage.setItem("mvoIntentSelected", JSON.stringify(item));
        sessionStorage.setItem("mvoParentCategoryId", parentSymptomId);
        if (mvoIsNsaCallLoad.current) {
          setLoading(true);
          return Promise.resolve();
        } else {
          console.log("---parent movetohandleintents");
          moveToHandleIntents();
        }
      }
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var callNsaIssueData = function callNsaIssueData(isNewCaseId) {
    try {
      var paramsChannel = paramsDetails.channel.toLowerCase() === "care" ? firstLetterCapitalize(paramsDetails.channel) : paramsDetails.channel;
      mvoIsNsaCallLoad.current = true;
      var nsaPayload = {
        channel: paramsChannel,
        tier: paramsDetails.tier,
        accountNumber: paramsDetails.accountNumber,
        mdn: paramsDetails.mdn,
        equipmentId: paramsDetails.equipmentId,
        sku: paramsDetails.sku,
        loggedInUser: paramsDetails.loggedInUser,
        topIntents: true
      };
      if (paramsDetails.changeDeviceFlow === true) {
        nsaPayload.changeDevice = true;
      }
      console.log("paramsDetails===", paramsDetails);
      if (typeof paramsDetails.acssCallId !== "undefined" && paramsDetails.acssCallId !== "") {
        nsaPayload.callerId = paramsDetails.acssCallId;
      }
      setNsaError(false);
      return Promise.resolve(getNsaSymptomsPageLoad(paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.externalTarget, paramsDetails.mvoenv, paramsDetails.channelId, nsaPayload).then(function (nsaResponse) {
        try {
          mvoIsNsaCallLoad.current = false;
          var _temp23 = function () {
            if (nsaResponse.response.data.body) {
              var _data4 = nsaResponse.response.data.body;
              setCurrentNsaSymptomsData(_data4);
              if (isNewCaseId) {
                sessionStorage.setItem("futureCaseId", JSON.stringify(_data4 === null || _data4 === void 0 ? void 0 : _data4.caseId));
              } else {
                var _data4$intentIds;
                nsaSymptomsData.current = {
                  intentList: _data4.intentList,
                  intentIds: _data4 === null || _data4 === void 0 ? void 0 : (_data4$intentIds = _data4.intentIds) === null || _data4$intentIds === void 0 ? void 0 : _data4$intentIds.split(",")
                };
              }
              console.log(symptomsList);
              if (nsaSymptomsData.current && nsaSymptomsData.current.intentList) {
                console.log("droppedCallNsaIntent===", droppedCallNsaIntent);
                nsaSymptomsData.current.intentList = nsaSymptomsData.current.intentList.map(function (itemlist) {
                  if (itemlist.intent.toLowerCase() == "dropped calls" && droppedCallNsaIntent.current !== null) {
                    itemlist.intentId = droppedCallNsaIntent.current.split("#")[0];
                  }
                  return itemlist;
                });
              }
              console.log("###########nsaSymptomsData - Dropped call check##############");
              console.log(nsaSymptomsData);
              setLoading(false);
              return Promise.resolve(JSON.parse(sessionStorage.getItem("useCaseId"))).then(function (useCaseId) {
                return Promise.resolve(JSON.parse(sessionStorage.getItem("mvoIntentSelected"))).then(function (item) {
                  if (useCaseId && item) {
                    moveToHandleIntents();
                  }
                });
              });
            } else {
              setNsaError(true);
            }
          }();
          return Promise.resolve(_temp23 && _temp23.then ? _temp23.then(function () {}) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      })["catch"](function (error) {
        setNsaError(true);
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var moveToHandleIntents = function moveToHandleIntents(subSym) {
    try {
      var presentCaseId = sessionStorage.getItem('mvoCaseId');
      sessionStorage.setItem("previousCaseId", presentCaseId);
      var item = JSON.parse(sessionStorage.getItem("mvoIntentSelected"));
      var bauIntents = topIntents.filter(function (intent) {
        var _intent$id;
        return !(intent !== null && intent !== void 0 && (_intent$id = intent.id) !== null && _intent$id !== void 0 && _intent$id.startsWith("IN"));
      });
      var _temp38 = function () {
        if (subSym && (configDetails !== null && configDetails !== void 0 && configDetails.categorizeIntent || configDetails !== null && configDetails !== void 0 && configDetails.nsaPrimary)) {
          var _temp28 = function () {
            if (configDetails !== null && configDetails !== void 0 && configDetails.nsaPrimary && [].concat(priSymBauList, bauIntents).some(function (obj) {
              return obj.nsaIntentId === item.id;
            })) {
              var _priSymBauList$filter = priSymBauList.filter(function (obj) {
                  return obj.nsaIntentId === item.id;
                }),
                getParentSymtom = _priSymBauList$filter[0];
              item.guideId = (getParentSymtom === null || getParentSymtom === void 0 ? void 0 : getParentSymtom.guideId) || (item === null || item === void 0 ? void 0 : item.guideId);
              item.stepId = (getParentSymtom === null || getParentSymtom === void 0 ? void 0 : getParentSymtom.stepId) || (item === null || item === void 0 ? void 0 : item.stepId);
              item.symptomId = (getParentSymtom === null || getParentSymtom === void 0 ? void 0 : getParentSymtom.symptomId) || (item === null || item === void 0 ? void 0 : item.symptomId);
              return Promise.resolve(sessionStorage.removeItem("mvoIntentSelected")).then(function () {
                return Promise.resolve(redirectFormPostToTRGUrl(item, (getParentSymtom === null || getParentSymtom === void 0 ? void 0 : getParentSymtom.parentSymptomId) || (item === null || item === void 0 ? void 0 : item.parentSymptomId), paramsDetails, sessionCacheId.current, "showBauStep")).then(function () {
                  return Promise.resolve(getPrimaryNsaCall(false, false, true, "bau")).then(function () {});
                });
              });
            } else {
              var _temp27 = function _temp27() {
                var _sessionStorage = sessionStorage,
                  _setItem = _sessionStorage.setItem,
                  _paramsDetails$mdn = paramsDetails.mdn;
                return Promise.resolve(JSON.parse(sessionStorage.getItem("mvoCaseId"))).then(function (_JSON$parse2) {
                  var _getNsaResponseObj$, _getNsaResponseObj$$d, _getNsaResponseObj$$d2, _getNsaResponseObj$2, _getNsaResponseObj$2$, _getNsaResponseObj$2$2;
                  function _temp25() {
                    var useCaseId = JSON.parse(sessionStorage.getItem("useCaseId"));
                    if (!mvoIsNsaCallLoad.current && useCaseId) {
                      sessionStorage.setItem("useCaseId", JSON.stringify(false));
                      if (configDetails !== null && configDetails !== void 0 && configDetails.categorizeIntent || configDetails !== null && configDetails !== void 0 && configDetails.oneApi || configDetails !== null && configDetails !== void 0 && configDetails.nsaPrimary) {}
                    }
                  }
                  _setItem.call(_sessionStorage, "nsaIntentSelected", JSON.stringify(_extends({}, item, {
                    mdn: _paramsDetails$mdn,
                    caseId: _JSON$parse2,
                    intent: item.name,
                    intentId: item.id
                  })));
                  sessionStorage.setItem("firstPageLoad", false);
                  console.log("-------------paramsDetails------------");
                  console.log(paramsDetails);
                  console.log(item);
                  var getNsaResponseObj = JSON.parse(sessionStorage.getItem("nsaResponse"));
                  console.log(getNsaResponseObj);
                  if (typeof getNsaResponseObj !== "undefined" && (getNsaResponseObj === null || getNsaResponseObj === void 0 ? void 0 : getNsaResponseObj.length) > 0 && typeof ((_getNsaResponseObj$ = getNsaResponseObj[0]) === null || _getNsaResponseObj$ === void 0 ? void 0 : (_getNsaResponseObj$$d = _getNsaResponseObj$.data) === null || _getNsaResponseObj$$d === void 0 ? void 0 : (_getNsaResponseObj$$d2 = _getNsaResponseObj$$d.body) === null || _getNsaResponseObj$$d2 === void 0 ? void 0 : _getNsaResponseObj$$d2.nbxIntentIds) !== "undefined" && ((_getNsaResponseObj$2 = getNsaResponseObj[0]) === null || _getNsaResponseObj$2 === void 0 ? void 0 : (_getNsaResponseObj$2$ = _getNsaResponseObj$2.data) === null || _getNsaResponseObj$2$ === void 0 ? void 0 : (_getNsaResponseObj$2$2 = _getNsaResponseObj$2$.body) === null || _getNsaResponseObj$2$2 === void 0 ? void 0 : _getNsaResponseObj$2$2.nbxIntentIds) !== "") {
                    var nbxIntentIdsFromNsaFlow = getNsaResponseObj[0].data.body.nbxIntentIds.split(",");
                    console.log(nbxIntentIdsFromNsaFlow);
                    var nBSFlow = nbxIntentIdsFromNsaFlow.includes(item.id);
                    console.log(nBSFlow);
                    sessionStorage.setItem("nBSFlow", Boolean(nBSFlow));
                  }
                  var _temp24 = function () {
                    if (configDetails !== null && configDetails !== void 0 && configDetails.isTroubleshootEnable || paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.displayTabs) {
                      return Promise.resolve(sessionStorage.setItem("processAction", "")).then(function () {
                        return Promise.resolve(sessionStorage.setItem("processStep", "")).then(function () {
                          setTabIndex(1);
                          if (paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.handleTabs) {
                            paramsDetails.handleTabs(1);
                          }
                        });
                      });
                    } else {
                      return Promise.resolve(sessionStorage.removeItem("nsaIntentSelected")).then(function () {
                        return Promise.resolve(JSON.parse(sessionStorage.getItem("mvoCaseId"))).then(function (caseId) {
                          return Promise.resolve(redirectFormPostToNSAUrl(item, item.id, paramsDetails, caseId)).then(function () {});
                        });
                      });
                    }
                  }();
                  return _temp24 && _temp24.then ? _temp24.then(_temp25) : _temp25(_temp24);
                });
              };
              setSelectedNSAIntent({
                intentId: item.id,
                intent: (item === null || item === void 0 ? void 0 : item.title) || (item === null || item === void 0 ? void 0 : item.name)
              });
              var _temp26 = function () {
                if (sessionStorage.getItem("firstPageLoad") == "false") {
                  return Promise.resolve(JSON.parse(sessionStorage.getItem("futureCaseId"))).then(function () {});
                }
              }();
              return _temp26 && _temp26.then ? _temp26.then(_temp27) : _temp27(_temp26);
            }
          }();
          if (_temp28 && _temp28.then) return _temp28.then(function () {});
        } else {
          var _temp39 = function () {
            if (typeof (configDetails === null || configDetails === void 0 ? void 0 : configDetails.categorizeIntent) === "undefined" || !(configDetails !== null && configDetails !== void 0 && configDetails.categorizeIntent)) {
              return Promise.resolve(JSON.parse(sessionStorage.getItem("mvoParentCategoryId"))).then(function (parentSymptomId) {
                var _temp36 = function () {
                  if (nsaSymptomsData.current && nsaSymptomsData.current.intentList) {
                    var _nsaSymptomsData$curr;
                    var isIntentAvailable = (_nsaSymptomsData$curr = nsaSymptomsData.current.intentList) === null || _nsaSymptomsData$curr === void 0 ? void 0 : _nsaSymptomsData$curr.find(function (intent) {
                      var _intent$intent, _item$title;
                      return (intent === null || intent === void 0 ? void 0 : (_intent$intent = intent.intent) === null || _intent$intent === void 0 ? void 0 : _intent$intent.toLowerCase()) === (item === null || item === void 0 ? void 0 : (_item$title = item.title) === null || _item$title === void 0 ? void 0 : _item$title.toLowerCase());
                    });
                    var _temp35 = function () {
                      if (isIntentAvailable) {
                        setSelectedNSAIntent(isIntentAvailable);
                        var _temp34 = function (_nsaSymptomsData$curr2) {
                          if ((_nsaSymptomsData$curr2 = nsaSymptomsData.current.intentIds) !== null && _nsaSymptomsData$curr2 !== void 0 && _nsaSymptomsData$curr2.includes(isIntentAvailable.intentId)) {
                            var _temp33 = function _temp33() {
                              var _sessionStorage2 = sessionStorage,
                                _setItem2 = _sessionStorage2.setItem,
                                _paramsDetails$mdn2 = paramsDetails.mdn;
                              return Promise.resolve(JSON.parse(sessionStorage.getItem("mvoCaseId"))).then(function (_JSON$parse3) {
                                function _temp31() {
                                  var useCaseId = JSON.parse(sessionStorage.getItem("useCaseId"));
                                  var _temp29 = function () {
                                    if (!mvoIsNsaCallLoad.current && useCaseId) {
                                      sessionStorage.setItem("useCaseId", JSON.stringify(false));
                                      return Promise.resolve(callNsaIssueData(true)).then(function () {});
                                    }
                                  }();
                                  if (_temp29 && _temp29.then) return _temp29.then(function () {});
                                }
                                _setItem2.call(_sessionStorage2, "nsaIntentSelected", JSON.stringify(_extends({}, isIntentAvailable, {
                                  mdn: _paramsDetails$mdn2,
                                  caseId: _JSON$parse3
                                })));
                                sessionStorage.setItem("firstPageLoad", false);
                                var _temp30 = function () {
                                  if (configDetails !== null && configDetails !== void 0 && configDetails.isTroubleshootEnable || paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.displayTabs) {
                                    return Promise.resolve(sessionStorage.setItem("processAction", "")).then(function () {
                                      return Promise.resolve(sessionStorage.setItem("processStep", "")).then(function () {
                                        setTabIndex(1);
                                        if (paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.handleTabs) {
                                          paramsDetails.handleTabs(1);
                                        }
                                      });
                                    });
                                  } else {
                                    return Promise.resolve(sessionStorage.removeItem("nsaIntentSelected")).then(function () {
                                      return Promise.resolve(JSON.parse(sessionStorage.getItem("mvoCaseId"))).then(function (caseId) {
                                        return Promise.resolve(redirectFormPostToNSAUrl(item, isIntentAvailable.intentId, paramsDetails, caseId)).then(function () {});
                                      });
                                    });
                                  }
                                }();
                                return _temp30 && _temp30.then ? _temp30.then(_temp31) : _temp31(_temp30);
                              });
                            };
                            var _temp32 = function () {
                              if (sessionStorage.getItem("firstPageLoad") == "false") {
                                return Promise.resolve(JSON.parse(sessionStorage.getItem("futureCaseId"))).then(function () {});
                              }
                            }();
                            return _temp32 && _temp32.then ? _temp32.then(_temp33) : _temp33(_temp32);
                          } else {
                            return Promise.resolve(sessionStorage.removeItem("mvoIntentSelected")).then(function () {
                              return Promise.resolve(redirectFormPostToTRGUrl(item, parentSymptomId, paramsDetails, sessionCacheId.current, "showBauStep")).then(function () {
                                return Promise.resolve(getDeviceSymptoms()).then(function () {});
                              });
                            });
                          }
                        }();
                        if (_temp34 && _temp34.then) return _temp34.then(function () {});
                      } else {
                        return Promise.resolve(sessionStorage.removeItem("mvoIntentSelected")).then(function () {
                          return Promise.resolve(redirectFormPostToTRGUrl(item, parentSymptomId, paramsDetails, sessionCacheId.current, "showBauStep")).then(function () {
                            return Promise.resolve(getDeviceSymptoms()).then(function () {});
                          });
                        });
                      }
                    }();
                    if (_temp35 && _temp35.then) return _temp35.then(function () {});
                  } else {
                    return Promise.resolve(sessionStorage.removeItem("mvoIntentSelected")).then(function () {
                      return Promise.resolve(redirectFormPostToTRGUrl(item, parentSymptomId, paramsDetails, sessionCacheId.current, "showBauStep")).then(function () {
                        return Promise.resolve(getDeviceSymptoms()).then(function () {});
                      });
                    });
                  }
                }();
                if (_temp36 && _temp36.then) return _temp36.then(function () {});
              });
            }
          }();
          if (_temp39 && _temp39.then) return _temp39.then(function () {});
        }
      }();
      return Promise.resolve(_temp38 && _temp38.then ? _temp38.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var getDeviceSymptoms = function getDeviceSymptoms() {
    try {
      return Promise.resolve(issueSelectorPageLoad(paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.externalTarget, paramsDetails.mvoenv, paramsDetails.channelId, {
        appId: paramsDetails.appId,
        channel: paramsDetails.channel,
        tier: paramsDetails.tier,
        accountNumber: paramsDetails.accountNumber,
        mdn: paramsDetails.mdn,
        equipmentId: paramsDetails.equipmentId,
        sku: paramsDetails.sku,
        displayMode: paramsDetails.displayMode,
        userType: paramsDetails.userType,
        loginId: paramsDetails.loginId,
        deviceId: paramsDetails.deviceId,
        deviceName: paramsDetails.deviceName,
        deviceType: paramsDetails.deviceType,
        oem: paramsDetails.oem,
        operatingSystem: paramsDetails.operatingSystem,
        billingSystem: paramsDetails.billingSystem,
        mvmdCompatible: paramsDetails.mvmdCompatible,
        tsrID: "",
        customerVerified: paramsDetails.customerVerified,
        customerOnSameDevice: paramsDetails.customerOnSameDevice,
        loggedInUser: paramsDetails.loggedInUser,
        sessionId: paramsDetails.acssCallId,
        FrontEndSessionID: paramsDetails.acssCallId
      }).then(function (res) {
        var _res$response, _res$response$data, _res$response2, _res$response2$data, _res$response2$data$b;
        if (res !== null && res !== void 0 && res.success && res !== null && res !== void 0 && (_res$response = res.response) !== null && _res$response !== void 0 && (_res$response$data = _res$response.data) !== null && _res$response$data !== void 0 && _res$response$data.body && res !== null && res !== void 0 && (_res$response2 = res.response) !== null && _res$response2 !== void 0 && (_res$response2$data = _res$response2.data) !== null && _res$response2$data !== void 0 && (_res$response2$data$b = _res$response2$data.body) !== null && _res$response2$data$b !== void 0 && _res$response2$data$b.getSymptomsResult) {
          var _response$getSymptoms, _primarySymtomsList6, _response$getSymptoms2;
          var response = res.response.data.body;
          var subSymptoms = [];
          var primarySymtomsList = response === null || response === void 0 ? void 0 : (_response$getSymptoms = response.getSymptomsResult) === null || _response$getSymptoms === void 0 ? void 0 : _response$getSymptoms.primarySymptoms;
          var droppedCallsObj = {
            53142: "IN11331#Dropped Calls TS",
            53127: "IN11492#NumberShare Dropped Calls",
            53132: "IN11493#Dropped Calls wearable device platform",
            53137: "IN11494#ODI Dropped Calls",
            54828: "IN11331#Dropped Calls TS",
            54823: "IN11492#NumberShare Dropped Calls",
            54833: "IN11493#Dropped Calls wearable device platform",
            54818: "IN11494#ODI Dropped Calls"
          };
          droppedCallNsaIntent.current = null;
          primarySymtomsList = primarySymtomsList.map(function (item) {
            if (item.title == "Phone Calls") {
              item.subSymptoms = item.subSymptoms.map(function (subItemList) {
                if (droppedCallsObj[subItemList.symptomId]) {
                  droppedCallNsaIntent.current = droppedCallsObj[subItemList.symptomId];
                  subItemList.title = "Dropped Calls";
                }
                return subItemList;
              });
            }
            return item;
          });
          console.log("!!!!!!!!!!drop calls - primarySymtomsList");
          console.log(primarySymtomsList);
          primarySymtomsList = primarySymtomsList.sort(function (a, b) {
            return a.title > b.title ? 1 : -1;
          });
          (_primarySymtomsList6 = primarySymtomsList) === null || _primarySymtomsList6 === void 0 ? void 0 : _primarySymtomsList6.forEach(function (item) {
            if (item.subSymptoms.length > 0) {
              item.subSymptoms = item.subSymptoms.sort(function (a, b) {
                return a.title > b.title ? 1 : -1;
              });
              subSymptoms.push.apply(subSymptoms, item.subSymptoms);
            }
          });
          var newArray = [];
          subSymptoms === null || subSymptoms === void 0 ? void 0 : subSymptoms.forEach(function (item) {
            item["subSymptom"] = _extends({}, item);
            newArray.push(item);
          });
          setSubSymptomsList(subSymptoms);
          sessionCacheId.current = response === null || response === void 0 ? void 0 : (_response$getSymptoms2 = response.getSymptomsResult) === null || _response$getSymptoms2 === void 0 ? void 0 : _response$getSymptoms2.sessionCacheId;
          setSymptomsList(primarySymtomsList);
        }
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var reInitIssueSelector = function reInitIssueSelector() {
    try {
      var chkSessionVal = ["undefined", "null", "", null];
      var getNsaResponseObj = sessionStorage.getItem("nsaResponse");
      var getIssueSelectorInitailLoad = sessionStorage.getItem("issueSelectorInitailLoad");
      console.log(getNsaResponseObj);
      console.log("nsaResponse----", chkSessionVal.includes(getNsaResponseObj));
      console.log("issueSelectorInitailLoad----", getIssueSelectorInitailLoad);
      var _temp40 = function () {
        if (chkSessionVal.includes(getNsaResponseObj) || !getIssueSelectorInitailLoad || getIssueSelectorInitailLoad === "false") {
          setShowLoader(true);
          console.log("@@@@@^^^^checkNsaCallCompleted^^^^^^");
          return Promise.resolve(triggerIssueSelector(true)).then(function () {
            setTroubleShootAreaStyles("660px", "scroll");
            setShowLoader(false);
          });
        }
      }();
      return Promise.resolve(_temp40 && _temp40.then ? _temp40.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var resetComponent = function resetComponent() {
    setTabIndex(0);
    if (paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.handleTabs) {
      paramsDetails.handleTabs(0);
    }
  };
  var reInitMvoCaseId = function reInitMvoCaseId() {
    var futureCaseId = sessionStorage.getItem("futureCaseId");
  };
  var deviceChange = function deviceChange() {
    setTabIndex(3);
  };
  var handleTabChangeEvent = function handleTabChangeEvent(tabId, isDisabled) {
    if (isDisabled === void 0) {
      isDisabled = false;
    }
    try {
      var _window11, _paramsDetails$channe;
      var _temp46 = function _temp46() {
        return Promise.resolve(JSON.parse(sessionStorage.getItem("nsaIntentSelected"))).then(function (nsaIntentSelected) {
          var _exit = false;
          function _temp44(_result) {
            if (_exit) return _result;
            setTabIndex(tabId);
            if (paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.handleTabs) {
              paramsDetails.handleTabs(tabId);
            }
            var _temp42 = function () {
              if (tabIndex !== tabId && tabId === 2 && configDetails !== null && configDetails !== void 0 && configDetails.isIssueHistoryEnable) {
                try {
                  if (paramsChannel === "retail") {
                    var _window$config$soeGui2, _window0, _window0$config, _window1, _window1$config, _window$config$outlet2, _window10, _window10$config, _configDetails$mtns4, _configDetails$mtns4$, _configDetails$mtns5, _configDetails$mtns5$, _configDetails$mtns6, _configDetails$mtns6$, _paramsDetails$accoun3, _paramsDetails$accoun4;
                    tagging.setPageView({
                      page: {
                        channel: "Support",
                        channelSession: (_window$config$soeGui2 = (_window0 = window) === null || _window0 === void 0 ? void 0 : (_window0$config = _window0.config) === null || _window0$config === void 0 ? void 0 : _window0$config.soeGuiSubKey) != null ? _window$config$soeGui2 : "",
                        displayChannel: ((_window1 = window) === null || _window1 === void 0 ? void 0 : (_window1$config = _window1.config) === null || _window1$config === void 0 ? void 0 : _window1$config.indirect) === "Y" ? "indirect" : "retail",
                        sourceChannel: "POS",
                        detail: "",
                        flow: window.isBAUACSS ? "troubleshooter| POS_pop out" : "troubleshooter| POS_embedded",
                        subFlow: "",
                        throttle: "NSA",
                        name: "ts| Issue History",
                        url: document.referrer + 'sales/global-nav/home.html'
                      },
                      support: {
                        issueNumber: "",
                        tsaIssueName: "",
                        tsaStepName: ""
                      },
                      target: {
                        engagement: {
                          intent: "support"
                        }
                      },
                      env: {
                        businessUnit: "Wireless"
                      },
                      txn: _extends({}, getVZDLObject(txnKeys), {
                        agentRole: "Rep",
                        agent: paramsDetails.loggedInUser,
                        outletId: (_window$config$outlet2 = (_window10 = window) === null || _window10 === void 0 ? void 0 : (_window10$config = _window10.config) === null || _window10$config === void 0 ? void 0 : _window10$config.outletId) != null ? _window$config$outlet2 : ""
                      }),
                      user: _extends({}, getVZDLObject(userKeys), {
                        account: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$mtns4 = configDetails.mtns) === null || _configDetails$mtns4 === void 0 ? void 0 : (_configDetails$mtns4$ = _configDetails$mtns4[0]) === null || _configDetails$mtns4$ === void 0 ? void 0 : _configDetails$mtns4$.hashedAccountNumber,
                        id: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$mtns5 = configDetails.mtns) === null || _configDetails$mtns5 === void 0 ? void 0 : (_configDetails$mtns5$ = _configDetails$mtns5[0]) === null || _configDetails$mtns5$ === void 0 ? void 0 : _configDetails$mtns5$.mtnhashCode,
                        accountType: "LLP",
                        customerType: "PE",
                        numberOfLines: "",
                        authStatus: "logged in",
                        zip: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$mtns6 = configDetails.mtns) === null || _configDetails$mtns6 === void 0 ? void 0 : (_configDetails$mtns6$ = _configDetails$mtns6[0]) === null || _configDetails$mtns6$ === void 0 ? void 0 : _configDetails$mtns6$.zipCode,
                        accountLast2: paramsDetails === null || paramsDetails === void 0 ? void 0 : (_paramsDetails$accoun3 = paramsDetails.accountNumber) === null || _paramsDetails$accoun3 === void 0 ? void 0 : _paramsDetails$accoun3.substr((paramsDetails === null || paramsDetails === void 0 ? void 0 : (_paramsDetails$accoun4 = paramsDetails.accountNumber) === null || _paramsDetails$accoun4 === void 0 ? void 0 : _paramsDetails$accoun4.length) - 2)
                      }),
                      utils: _extends({}, getVZDLObject(utilsKeys)),
                      cmp: {
                        all: ""
                      },
                      error: {
                        code: ""
                      },
                      park: {
                        csFlag: ""
                      },
                      platform: {
                        call: ""
                      },
                      search: {
                        term: "",
                        type: "",
                        results: ""
                      },
                      event: {
                        value: ""
                      }
                    }, true, popOutFlow);
                  }
                } catch (error) {
                  console.log("setPageView error", error);
                }
                setShowLoader(true);
                setIssueHistoryData([]);
                return Promise.resolve(ChangeTabIssueHistory(paramsDetails)).then(function (issueHistoryData) {
                  var _issueHistoryData$res5, _issueHistoryData$res6, _issueHistoryData$res7, _issueHistoryData$res8;
                  if (!(issueHistoryData !== null && issueHistoryData !== void 0 && issueHistoryData.success)) {
                    setnoHistoryFound("No history in the last 30 days");
                  }
                  if ((issueHistoryData === null || issueHistoryData === void 0 ? void 0 : (_issueHistoryData$res5 = issueHistoryData.response) === null || _issueHistoryData$res5 === void 0 ? void 0 : (_issueHistoryData$res6 = _issueHistoryData$res5.data) === null || _issueHistoryData$res6 === void 0 ? void 0 : (_issueHistoryData$res7 = _issueHistoryData$res6.body) === null || _issueHistoryData$res7 === void 0 ? void 0 : (_issueHistoryData$res8 = _issueHistoryData$res7.issueHistory) === null || _issueHistoryData$res8 === void 0 ? void 0 : _issueHistoryData$res8.length) > 0) {
                    setnoHistoryFound("");
                    setIssueHistoryData(issueHistoryData.response.data.body.issueHistory);
                    setTroubleShootAreaStyles("660px", "scroll");
                  } else {
                    setnoHistoryFound("No history in the last 30 days");
                    setIssueHistoryData([]);
                    setTroubleShootAreaStyles("", "");
                  }
                  setShowLoader(false);
                });
              } else if (tabIndex !== tabId && tabId === 0 && configDetails !== null && configDetails !== void 0 && configDetails.isIssueSelectorEnable) {
                setTroubleShootAreaStyles("660px", "scroll");
              } else {
                setTroubleShootAreaStyles("735px", "auto");
              }
            }();
            if (_temp42 && _temp42.then) return _temp42.then(function () {});
          }
          var _ref4 = nsaIntentSelected || {},
            _ref4$caseId = _ref4.caseId,
            caseId = _ref4$caseId === void 0 ? "" : _ref4$caseId;
          if (tabId === 1) {
            var previousCaseId = sessionStorage.getItem("previousCaseId");
            if (previousCaseId) {
              sessionStorage.setItem("mvoCaseId", previousCaseId);
            }
          }
          var _temp43 = function () {
            if (tabId === 1 && !caseId || tabId == 1 && !paramsDetails.equipmentId) {
              _exit = true;
            } else {
              var _temp47 = function () {
                if (tabId === 1 && caseId) {
                  return Promise.resolve(sessionStorage.setItem("processStep", "resume")).then(function () {
                    setSelectedNSAIntent(nsaIntentSelected);
                  });
                }
              }();
              if (_temp47 && _temp47.then) return _temp47.then(function () {});
            }
          }();
          return _temp43 && _temp43.then ? _temp43.then(_temp44) : _temp44(_temp43);
        });
      };
      var popOutFlow = (_window11 = window) !== null && _window11 !== void 0 && _window11.isBAUACSS ? true : false;
      var paramsChannel = paramsDetails === null || paramsDetails === void 0 ? void 0 : (_paramsDetails$channe = paramsDetails.channel) === null || _paramsDetails$channe === void 0 ? void 0 : _paramsDetails$channe.toLowerCase();
      if (isDisabled) return Promise.resolve();
      if (tabId === 0) {
        setRecomputeCaseId(function (val) {
          return !val;
        });
      }
      var _temp45 = function () {
        if (tabId === 0) {
          try {
            if (paramsChannel === "retail") {
              var _window$config$soeGui3, _window12, _window12$config, _window13, _window13$config, _window$config$outlet3, _window14, _window14$config, _configDetails$mtns7, _configDetails$mtns7$, _configDetails$mtns8, _configDetails$mtns8$, _configDetails$mtns9, _configDetails$mtns9$, _paramsDetails$accoun5, _paramsDetails$accoun6;
              tagging.setPageView({
                page: {
                  channel: "Support",
                  channelSession: (_window$config$soeGui3 = (_window12 = window) === null || _window12 === void 0 ? void 0 : (_window12$config = _window12.config) === null || _window12$config === void 0 ? void 0 : _window12$config.soeGuiSubKey) != null ? _window$config$soeGui3 : "",
                  displayChannel: ((_window13 = window) === null || _window13 === void 0 ? void 0 : (_window13$config = _window13.config) === null || _window13$config === void 0 ? void 0 : _window13$config.indirect) === "Y" ? "indirect" : "retail",
                  sourceChannel: "POS",
                  detail: "",
                  flow: window.isBAUACSS ? "troubleshooter| POS_pop out" : "troubleshooter| POS_embedded",
                  subFlow: "",
                  throttle: "NSA",
                  name: "ts| Issue Selector",
                  url: document.referrer + 'sales/global-nav/home.html'
                },
                support: {
                  issueNumber: "",
                  tsaIssueName: "",
                  tsaStepName: ""
                },
                target: {
                  engagement: {
                    intent: "support"
                  }
                },
                env: {
                  businessUnit: "Wireless"
                },
                txn: _extends({}, getVZDLObject(txnKeys), {
                  agentRole: "Rep",
                  agent: paramsDetails.loggedInUser,
                  outletId: (_window$config$outlet3 = (_window14 = window) === null || _window14 === void 0 ? void 0 : (_window14$config = _window14.config) === null || _window14$config === void 0 ? void 0 : _window14$config.outletId) != null ? _window$config$outlet3 : ""
                }),
                user: _extends({}, getVZDLObject(userKeys), {
                  account: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$mtns7 = configDetails.mtns) === null || _configDetails$mtns7 === void 0 ? void 0 : (_configDetails$mtns7$ = _configDetails$mtns7[0]) === null || _configDetails$mtns7$ === void 0 ? void 0 : _configDetails$mtns7$.hashedAccountNumber,
                  id: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$mtns8 = configDetails.mtns) === null || _configDetails$mtns8 === void 0 ? void 0 : (_configDetails$mtns8$ = _configDetails$mtns8[0]) === null || _configDetails$mtns8$ === void 0 ? void 0 : _configDetails$mtns8$.mtnhashCode,
                  accountType: "LLP",
                  customerType: "PE",
                  numberOfLines: "",
                  authStatus: "logged in",
                  zip: configDetails === null || configDetails === void 0 ? void 0 : (_configDetails$mtns9 = configDetails.mtns) === null || _configDetails$mtns9 === void 0 ? void 0 : (_configDetails$mtns9$ = _configDetails$mtns9[0]) === null || _configDetails$mtns9$ === void 0 ? void 0 : _configDetails$mtns9$.zipCode,
                  accountLast2: paramsDetails === null || paramsDetails === void 0 ? void 0 : (_paramsDetails$accoun5 = paramsDetails.accountNumber) === null || _paramsDetails$accoun5 === void 0 ? void 0 : _paramsDetails$accoun5.substr((paramsDetails === null || paramsDetails === void 0 ? void 0 : (_paramsDetails$accoun6 = paramsDetails.accountNumber) === null || _paramsDetails$accoun6 === void 0 ? void 0 : _paramsDetails$accoun6.length) - 2)
                }),
                utils: _extends({}, getVZDLObject(utilsKeys)),
                cmp: {
                  all: ""
                },
                error: {
                  code: ""
                },
                park: {
                  csFlag: ""
                },
                platform: {
                  call: ""
                },
                search: {
                  term: "",
                  type: "",
                  results: ""
                },
                event: {
                  value: ""
                }
              }, true, popOutFlow);
            }
          } catch (error) {
            console.log("setPageView error", error);
          }
          return Promise.resolve(callIssueSelector("tabChange")).then(function () {});
        }
      }();
      return Promise.resolve(_temp45 && _temp45.then ? _temp45.then(_temp46) : _temp46(_temp45));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  useEffect(function () {
    var _currentTab$tabRef;
    if (typeof tabIndex === "number") sessionStorage.setItem("selectedTabIndex", tabIndex);
    console.log("!!!!!!!!!!!!!tabRef.current");
    var currentTab = tabArray.find(function (obj) {
      return obj.tabNO === tabIndex;
    });
    console.log(currentTab);
    if (currentTab !== null && currentTab !== void 0 && (_currentTab$tabRef = currentTab.tabRef) !== null && _currentTab$tabRef !== void 0 && _currentTab$tabRef.current) {
      console.log(currentTab.tabRef.current);
      currentTab.tabRef.current.focus();
    }
  }, [tabIndex]);
  var isDark = function isDark(paramsDetails) {
    var _paramsDetails$theme;
    return paramsDetails !== null && paramsDetails !== void 0 && (_paramsDetails$theme = paramsDetails.theme) !== null && _paramsDetails$theme !== void 0 && _paramsDetails$theme.isDark ? true : false;
  };
  var handleChangeTab = function handleChangeTab() {
    return Promise.resolve(handleTabChangeEvent(0, false)).then(function () {
      setDefaultCategory(true);
    });
  };
  var handleResume = function handleResume(item) {
    try {
      sessionStorage.setItem("howToData", null);
      var _temp50 = function () {
        if (item.bau) {
          var _paramsDetails$appId, _paramsDetails$channe2, _paramsDetails$tier, _paramsDetails$tier2, _paramsDetails$mdn3, _paramsDetails$custom;
          var date = item.issueDateTime.split(" ")[0];
          var params = {
            appId: (_paramsDetails$appId = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.appId) != null ? _paramsDetails$appId : "ACSS",
            channel: (_paramsDetails$channe2 = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.channel) != null ? _paramsDetails$channe2 : "Care",
            tierId: (_paramsDetails$tier = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.tier) != null ? _paramsDetails$tier : "",
            tier: (_paramsDetails$tier2 = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.tier) != null ? _paramsDetails$tier2 : "",
            mdn: (_paramsDetails$mdn3 = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.mdn) != null ? _paramsDetails$mdn3 : "",
            equipId: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.equipmentId,
            custVerified: (_paramsDetails$custom = paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.customerVerified) != null ? _paramsDetails$custom : "Y",
            userId: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.loggedInUser,
            token: paramsDetails === null || paramsDetails === void 0 ? void 0 : paramsDetails.token,
            tsrID: item.caseNumber + "~" + date,
            tsrAction: "resumeBauStep"
          };
          return Promise.resolve(redirectResumeFormPostToTRGUrl(paramsDetails.mvoSolPortal, params)).then(function () {});
        } else {
          var _temp49 = function _temp49() {
            return Promise.resolve(setSelectedNSAIntent({
              intent: item.issueDescription,
              intentId: item.intentId
            })).then(function () {
              return Promise.resolve(sessionStorage.setItem("nsaIntentSelected", JSON.stringify({
                intent: item.issueDescription,
                intentId: item.intentId,
                mdn: paramsDetails.mdn,
                caseId: item.caseNumber
              }))).then(function () {
                return Promise.resolve(sessionStorage.setItem("mvoCaseId", JSON.stringify(item.caseNumber))).then(function () {
                  return Promise.resolve(sessionStorage.setItem("previousCaseId", JSON.stringify(item.caseNumber))).then(function () {
                    return Promise.resolve(sessionStorage.setItem("processAction", "")).then(function () {
                      return Promise.resolve(sessionStorage.setItem("processStep", "resume")).then(function () {
                        setRecomputeCaseId(function (val) {
                          return !val;
                        });
                        setTabIndex(1);
                        if (paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.handleTabs) {
                          paramsDetails.handleTabs(1);
                        }
                      });
                    });
                  });
                });
              });
            });
          };
          setTroubleShootAreaStyles("", "");
          console.log("howto item", item);
          var _temp48 = function (_item$details$, _item$details$$steps$) {
            if (item !== null && item !== void 0 && (_item$details$ = item.details[0]) !== null && _item$details$ !== void 0 && (_item$details$$steps$ = _item$details$.steps[0]) !== null && _item$details$$steps$ !== void 0 && _item$details$$steps$.howTo) {
              var _item$details$2, _item$details$2$steps, _item$details$3, _item$details$3$steps;
              return Promise.resolve(setHowToData({
                howTo: item === null || item === void 0 ? void 0 : (_item$details$2 = item.details[0]) === null || _item$details$2 === void 0 ? void 0 : (_item$details$2$steps = _item$details$2.steps[0]) === null || _item$details$2$steps === void 0 ? void 0 : _item$details$2$steps.howTo,
                reviewFlag: true,
                contentList: item === null || item === void 0 ? void 0 : (_item$details$3 = item.details[0]) === null || _item$details$3 === void 0 ? void 0 : (_item$details$3$steps = _item$details$3.steps[0]) === null || _item$details$3$steps === void 0 ? void 0 : _item$details$3$steps.contentList,
                pageIdentifier: item === null || item === void 0 ? void 0 : item.pageIdentifier
              })).then(function () {});
            }
          }();
          return _temp48 && _temp48.then ? _temp48.then(_temp49) : _temp49(_temp48);
        }
      }();
      return Promise.resolve(_temp50 && _temp50.then ? _temp50.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };
  useEffect(function () {
    if (paramsDetails.channel === "CARE" && paramsDetails.channelId === "VZW-ACSS") {
      var roleTabKeydown = function roleTabKeydown(e) {
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
          roleTabs[tabFocus].setAttribute("tabindex", -1);
          if (e.key === "ArrowRight") {
            tabFocus++;
            if (tabFocus >= roleTabs.length) {
              tabFocus = 0;
            }
          } else if (e.key === "ArrowLeft") {
            tabFocus--;
            if (tabFocus < 0) {
              tabFocus = roleTabs.length - 1;
            }
          }
          roleTabs[tabFocus].setAttribute("tabindex", 0);
          roleTabs[tabFocus].focus();
        }
      };
      var roleTabs = document.querySelectorAll('[data-role="tab"]');
      var roleTabList = document.querySelector('[data-role="tablist"]');
      var tabFocus = 0;
      roleTabList.addEventListener("keydown", function (e) {
        return roleTabKeydown(e);
      });
      return function () {
        roleTabList.removeEventListener("keydown", function (e) {
          return roleTabKeydown(e);
        });
      };
    }
  }, []);
  var _ref5 = configDetails || {},
    _ref5$isNewIssueHisto = _ref5.isNewIssueHistoryEnable,
    isNewIssueHistoryEnable = _ref5$isNewIssueHisto === void 0 ? false : _ref5$isNewIssueHisto;
  var updateMvoCaseId_onNavTabSwitch = useMemo(function () {
    var _ref6 = JSON.parse(sessionStorage.getItem("nsaIntentSelected")) || {},
      _ref6$caseId = _ref6.caseId,
      caseId = _ref6$caseId === void 0 ? "" : _ref6$caseId;
    var mvoCaseId = sessionStorage.getItem("mvoCaseId");
    console.log("mvoCaseId!!!!!!!==", mvoCaseId, "===caseId=", caseId, "===recomputeCaseId===", recomputeCaseId);
    var falsyValues = ["undefined", "null", ""];
    if (!falsyValues.includes(mvoCaseId)) {
      mvoCaseId = JSON.parse(mvoCaseId);
    } else {
      mvoCaseId = null;
    }
    return sessionStorage.getItem("isTroubleshootCaseOpen") === "Y" && caseId ? caseId : mvoCaseId;
  }, [recomputeCaseId, tabIndex]);
  console.log("memoized case", updateMvoCaseId_onNavTabSwitch);
  return configDetails !== null && configDetails !== void 0 && configDetails.isTroubleshootEnable || paramsDetails !== null && paramsDetails !== void 0 && paramsDetails.displayTabs ? /*#__PURE__*/React__default.createElement(PageWrapper$1, null, showLoader && /*#__PURE__*/React__default.createElement("div", {
    className: "trg-ts-loader"
  }, /*#__PURE__*/React__default.createElement(Loader$2, {
    active: true,
    fullscreen: false,
    surface: (paramsDetails === null || paramsDetails === void 0 ? void 0 : (_paramsDetails$theme2 = paramsDetails.theme) === null || _paramsDetails$theme2 === void 0 ? void 0 : _paramsDetails$theme2.themeId) === "theme_dark" ? "dark" : "light"
  })), /*#__PURE__*/React__default.createElement(TabWrapper, {
    className: "TabWrapper",
    role: "tablist",
    "data-role": "tablist",
    isDarkTheme: (paramsDetails === null || paramsDetails === void 0 ? void 0 : (_paramsDetails$theme3 = paramsDetails.theme) === null || _paramsDetails$theme3 === void 0 ? void 0 : _paramsDetails$theme3.themeId) === "theme_dark"
  }, tabArray.map(function (tab) {
    var enableTab = true;
    var hideTab = false;
    if (tab.tabNO == 2 && !configDetails.isIssueHistoryEnable) {
      hideTab = true;
    }
    var _ref7 = JSON.parse(sessionStorage.getItem("nsaIntentSelected")) || {},
      _ref7$caseId = _ref7.caseId,
      caseId = _ref7$caseId === void 0 ? "" : _ref7$caseId;
    if (tab.tabNO === 1 && (!caseId || !paramsDetails.equipmentId)) {
      enableTab = false;
    }
    if (tab.tabNO === 0 && !paramsDetails.equipmentId) {
      enableTab = false;
    }
    return /*#__PURE__*/React__default.createElement(Tabs, {
      ref: tab.tabRef,
      tabIndex: "0",
      hide: hideTab,
      disabled: !enableTab,
      selectedTab: tabIndex === tab.tabNO,
      onClick: function onClick() {
        return handleTabChangeEvent(tab.tabNO, !enableTab);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === "Enter" || e.key === "Space") {
          handleTabChangeEvent(tab.tabNO, !enableTab);
        }
      },
      "aria-label": tab.title,
      "data-class": tab.tabNO == 1 ? "tabTS" : "",
      className: tabIndex === tab.tabNO ? "tabSelected" : "",
      "data-track": "{\"type\": \"link\", \"name\": \"" + tab.title + "\"}",
      "aria-selected": tabIndex === tab.tabNO ? "true" : "false",
      role: "tab",
      "aria-controls": "panel-" + tab.tabNO,
      id: "tab-" + tab.tabNO,
      "data-role": "tab",
      "data-testid": "tab"
    }, tab.title);
  })), tabIndex === 0 ? /*#__PURE__*/React__default.createElement(IssueSelectorHome, {
    symptomsList: symptomsList,
    subSymptomsList: subSymptomsList,
    popularSymptomList: popularSymptomList,
    topIntents: topIntents,
    handleSubSymptoms: handleSubSymptoms,
    nsaError: nsaError,
    loading: loading,
    trobleshootNew: defaultCategory,
    handleTabChangeEvent: handleTabChangeEvent
  }) : tabIndex === 1 ? /*#__PURE__*/React__default.createElement(TroubleshootingWrapper, {
    id: "panel-1",
    role: "tabpanel",
    tabIndex: "0",
    "data-role": "tabpanel",
    "aria-labelledby": "tab-1"
  }, showApiFailErrMsg ? /*#__PURE__*/React__default.createElement(ErrorScreenAcss, {
    handleIssueSelector: handleTabChangeEvent
  }) : showIssueResolved ? /*#__PURE__*/React__default.createElement(IssueResolved, null) : /*#__PURE__*/React__default.createElement(NSATRG, {
    caseId: updateMvoCaseId_onNavTabSwitch,
    selectedNSAIntent: selectedNSAIntent,
    redirectToIssueSelecorTab: handleTabChangeEvent,
    howToData: howToData,
    handleIssueSelector: handleTabChangeEvent
  })) : tabIndex === 2 && isNewIssueHistoryEnable ? /*#__PURE__*/React__default.createElement(IssueHistoryNew, {
    history: issueHistoryData,
    isDarkTheme: isDark(paramsDetails),
    selectedResumeObject: handleResume,
    noHistoryFound: noHistoryFound,
    selectedIssueSelectorObject: handleChangeTab
  }) : tabIndex === 2 && !isNewIssueHistoryEnable ? null : tabIndex === 3 && configDetails.isDeviceSelectorEnable && /*#__PURE__*/React__default.createElement(DeviceSelectorHome, null)) : /*#__PURE__*/React__default.createElement(PageWrapper$1, null, /*#__PURE__*/React__default.createElement(IssueSelectorHome, {
    symptomsList: symptomsList,
    popularSymptomList: popularSymptomList,
    subSymptomsList: subSymptomsList,
    handleSubSymptoms: handleSubSymptoms,
    nsaError: nsaError,
    loading: loading,
    trobleshootNew: defaultCategory,
    handleTabChangeEvent: handleTabChangeEvent
  }));
});

var name = "acss-mvo-ts-components";
var version = "3.31.75";
var description = "react component for acss from mvo";
var author = "VZ";
var license = "MIT";
var repository = "VZ/acss-mvo-ts-components";
var main = "dist/index.js";
var module = "dist/index.modern.js";
var source = "src/index.js";
var engines = {
	node: ">=10"
};
var scripts = {
	clean: "rimraf ./dist",
	build: "microbundle-crl --no-compress --format modern,cjs --css-modules false",
	prepare: "rimraf .husky && mkdir .husky && cd .. && husky install acss-mvo-ts-components/.husky && cd ./acss-mvo-ts-components && node ./config/husky.js",
	start: "microbundle-crl watch --no-compress --format modern,cjs",
	"build:webpack": "npm run clean && webpack --config webpack.prod.js",
	coverage: "npm test -- --coverage --testResultsProcessor ./node_modules/jest-sonar-reporter/index.js",
	test: "cross-env NODE_OPTIONS=--experimental-vm-modules jest --env=jsdom --watchAll=false",
	"test:build": "run-s build",
	"test-coverage": "npm test -- --coverage --silent --verbose --testResultsProcessor ./node_modules/jest-sonar-reporter/index.js",
	"testcase-coverage": "npm run coverage",
	"test:lint": "eslint .",
	"test:unit": "cross-env CI=1 react-scripts test --env=jsdom",
	"test:watch": "react-scripts test --env=jsdom",
	lint: "npm run lint:js",
	"lint:eslint": "eslint --ignore-path .eslintignore",
	"lint:js": "npm run lint:eslint -- . --fix",
	eslint: "eslint js --fix",
	predeploy: "cd example && npm install && npm run build",
	deploy: "gh-pages -d example/build",
	buildAndPublish: "node scripts/buildAndPublish",
	"test:clear": "jest --clearCache",
	"test:folder": "node scripts/test-folder.js",
	"test:file": "node scripts/test-file.js"
};
var peerDependencies = {
	react: "^18.2.0"
};
var devDependencies = {
	"@progress/kendo-licensing": "^1.1.0",
	"@testing-library/dom": "^10.4.0",
	"@testing-library/jest-dom": "^6.5.0",
	"@testing-library/react": "^16.0.1",
	"@testing-library/react-hooks": "^8.0.1",
	"@testing-library/user-event": "^14.5.2",
	"@types/enzyme-adapter-react-16": "^1.0.9",
	"babel-eslint": "10.0.3",
	"babel-jest": "^29.7.0",
	"cross-env": "^7.0.2",
	enzyme: "^3.11.0",
	"enzyme-adapter-react-16": "^1.15.3",
	"enzyme-adapter-utils": "^1.13.1",
	eslint: "^6.8.0",
	"eslint-config-prettier": "^6.7.0",
	"eslint-config-standard": "^14.1.0",
	"eslint-config-standard-react": "^9.2.0",
	"eslint-plugin-import": "^2.18.2",
	"eslint-plugin-node": "^11.0.0",
	"eslint-plugin-prettier": "^3.1.1",
	"eslint-plugin-promise": "^4.2.1",
	"eslint-plugin-react": "^7.17.0",
	"eslint-plugin-standard": "^4.0.1",
	"gh-pages": "^2.2.0",
	husky: "^6.0.0",
	jest: "29.7.0",
	"jest-axe": "8.0.0",
	"jest-circus": "26.6.0",
	"jest-cli": "^22.4.2",
	"jest-environment-jsdom": "29.7.0",
	"jest-html-reporters": "3.1.7",
	"jest-resolve": "26.6.0",
	"jest-sonar": "^0.2.12",
	"jest-sonar-reporter": "^2.0.0",
	"jest-watch-typeahead": "0.6.1",
	"js-cookie": "^2.2.1",
	"lint-staged": "^9.4.2",
	"microbundle-crl": "^0.13.11",
	"npm-run-all": "^4.1.5",
	prettier: "^2.0.4",
	react: "^18.2.0",
	"react-redux": "7.2.0",
	"react-scripts": "^5.0.1",
	"react-test-renderer": "^18.3.1",
	redux: "4.0.1",
	webpack: "^5.90.3",
	"webpack-cli": "^5.1.4",
	xml2js: "^0.5.0"
};
var files = [
	"dist"
];
var dependencies = {
	"@types/enzyme": "^3.10.18",
	"@vds/accordions": "4.1.7",
	"@vds/badges": "4.1.1",
	"@vds/breadcrumbs": "3.1.0",
	"@vds/button-icons": "^4.0.10",
	"@vds/buttons": "3.5.0",
	"@vds/buttons-1.6.0": "npm:@vds/buttons@1.6.1",
	"@vds/buttons-3.3.11": "npm:@vds/buttons@^3.3.11",
	"@vds/carousels": "4.0.25",
	"@vds/checkboxes": "3.3.27",
	"@vds/date-pickers": "^4.0.3",
	"@vds/grids": "3.2.4",
	"@vds/html-parsers": "4.0.27",
	"@vds/icons": "4.6.0",
	"@vds/inputs": "4.0.1",
	"@vds/layout": "^1.0.2",
	"@vds/lines": "4.0.2",
	"@vds/lists": "3.7.13",
	"@vds/loaders": "3.2.14",
	"@vds/modals": "4.1.10",
	"@vds/notifications": "4.0.14",
	"@vds/pagination": "4.0.6",
	"@vds/radio-boxes": "3.3.8",
	"@vds/radio-buttons": "4.0.1",
	"@vds/selects": "4.0.28",
	"@vds/selects-old": "npm:@vds/selects@1.9.25",
	"@vds/tables": "3.4.4",
	"@vds/tabs": "3.3.35",
	"@vds/tiles": "4.1.22",
	"@vds/tooltips": "3.6.15",
	"@vds/type-lockups": "4.1.15",
	"@vds/typography": "3.3.19",
	"@vz/react-util": "1.3.2",
	"@vzrf/dropdown": "^2.0.13",
	"@vzrf/react-dropdown": "^1.4.9",
	axios: "^0.27.2",
	"copy-webpack-plugin": "^9.0.1",
	"create-file-webpack": "^1.0.2",
	"crypto-js": "^4.2.0",
	"framer-motion": "^11.3.19",
	"html-webpack-plugin": "^5.3.2",
	jquery: "^3.5.1",
	lodash: "^4.17.21",
	"mini-css-extract-plugin": "^1.6.2",
	moment: "^2.29.4",
	"moment-timezone": "^0.5.43",
	"prop-types": "15.7.2",
	"react-bootstrap": "^1.4.0",
	"react-device-detect": "^2.2.2",
	"react-dom": "^18.2.0",
	"react-draggable": "^4.4.6",
	"react-hook-form": "7.53.2",
	"react-idle-timer": "^4.5.0",
	"react-modal": "^3.11.2",
	"react-responsive-modal": "^3.2.0",
	"react-router-dom": "5.2.0",
	"react-select": "^5.8.0",
	recharts: "^2.2.0",
	rechartsUpdated: "npm:recharts@^2.2.0",
	rimraf: "^3.0.2",
	semver: "^7.5.4",
	shelljs: "^0.8.5",
	"simple-jsonp-promise": "^1.1.0",
	"styled-components": "^4.4.1",
	swr: "^2.2.5",
	"universal-cookie": "^4.0.4",
	"utp-ticket-list": "25.3.137",
	zustand: "5.0.3"
};
var eslintConfig = {
	parser: "babel-eslint",
	"extends": "airbnb",
	env: {
		browser: true,
		node: true,
		es6: true
	},
	plugins: [
		"react",
		"jsx-a11y"
	],
	rules: {
		"no-underscore-dangle": [
			2,
			{
				allow: [
					"__REDUX_DEVTOOLS_EXTENSION__",
					"window.__REDUX_DEVTOOLS_EXTENSION__()"
				]
			}
		]
	}
};
var packageInfo = {
	name: name,
	version: version,
	description: description,
	author: author,
	license: license,
	repository: repository,
	main: main,
	module: module,
	source: source,
	engines: engines,
	scripts: scripts,
	peerDependencies: peerDependencies,
	devDependencies: devDependencies,
	files: files,
	dependencies: dependencies,
	"lint-staged": {
	"*.js": [
	]
},
	eslintConfig: eslintConfig
};

var _templateObject$1v;
window.trgIssueSelector = {
  name: packageInfo.name,
  version: packageInfo.version
};
var PageWrapper$2 = styled.div(_templateObject$1v || (_templateObject$1v = _taggedTemplateLiteralLoose(["\n[class^='ModalDialogWrapper-VDS'] > [class^='ModalDialogWrapper-VDS'] {\n  > span {\n    height: unset !important;\n    > div {\n      height: unset !important;\n    }\n  }\n}\n\n[class^='ModalDialogWrapper'] {\n  padding: 48px 0px 45px 44px !important;\n}\n", "\n\n"])), function (props) {
  return props.theme.themeId === "theme_dark" && "\n\na {\n  color: #fff;\n}\n";
});
var ParamsContext = React__default.createContext();
var ConfigContext = React__default.createContext();
var IssueSelector = React__default.forwardRef(function (props, ref) {
  var _additionalInfoData$b2;
  console.log(props, "props!!!!!!!!!!!!!!!!");
  var childIssueRef = React__default.useRef(null);
  React__default.useImperativeHandle(ref, function () {
    return {
      resetComponent: function resetComponent() {
        childIssueRef.current.issueChildhildFunction();
      }
    };
  });
  var _ref = props.params || {},
    _ref$mdn = _ref.mdn,
    mdn = _ref$mdn === void 0 ? '' : _ref$mdn,
    _ref$accountNumber = _ref.accountNumber,
    accountNumber = _ref$accountNumber === void 0 ? '' : _ref$accountNumber;
  var _useState = useState(false),
    showComp = _useState[0],
    setShowComp = _useState[1];
  var _useAdditionalInfo = useAdditionalInfo(props.params),
    additionalInfoData = _useAdditionalInfo.data;
  var _useState2 = useState([]),
    additionalInfoSteps = _useState2[0],
    setAdditionalInfoSteps = _useState2[1];
  var _useState3 = useState(false),
    modalError = _useState3[0],
    setModalError = _useState3[1];
  var _useState4 = useState({}),
    config = _useState4[0],
    setConfig = _useState4[1];
  var _useState5 = useState(false),
    loading = _useState5[0],
    setLoading = _useState5[1];
  var _useState6 = useState({}),
    careLandingParams = _useState6[0],
    setCareLandingParams = _useState6[1];
  var _useFeatureFlag = useFeatureFlag(),
    _useFeatureFlag$data = _useFeatureFlag.data,
    _useFeatureFlag$data2 = _useFeatureFlag$data === void 0 ? {} : _useFeatureFlag$data,
    volteOutageFFlag = _useFeatureFlag$data2.volteOutageFFlag,
    _useFeatureFlag$data5 = _useFeatureFlag$data2.cBandOutageFFlag,
    cBandOutageFFlag = _useFeatureFlag$data5 === void 0 ? false : _useFeatureFlag$data5;
  var networkOutageFeatureFlag = getFeatureFlag(config === null || config === void 0 ? void 0 : config.featureFlagList, "enableNetworkOutageTileFFlag");
  var outageString = "RAN";
  if (volteOutageFFlag) outageString += ",VOLTE";
  if (cBandOutageFFlag) outageString += ",CB ONLY";
  var _useNetworkOutage = useNetworkOutage({
      mdn: mdn,
      accountNo: accountNumber,
      outageType: outageString,
      networkOutageFeatureFlag: networkOutageFeatureFlag
    }),
    outageData = _useNetworkOutage.outageData;
  var _useHealthCheck = useHealthCheck(careLandingParams),
    data = _useHealthCheck.data,
    isLoading = _useHealthCheck.isLoading,
    error = _useHealthCheck.error;
  var healthCheckData = {
    healthCheckData: data,
    isLoading: isLoading,
    error: error
  };
  var skuRef = useRef();
  var equipmentRef = useRef("");
  useEffect(function () {
    var _additionalInfoData$b;
    if (additionalInfoData !== null && additionalInfoData !== void 0 && (_additionalInfoData$b = additionalInfoData.body) !== null && _additionalInfoData$b !== void 0 && _additionalInfoData$b.configData) {
      getAdditionalInfo(additionalInfoData);
    }
  }, [additionalInfoData === null || additionalInfoData === void 0 ? void 0 : (_additionalInfoData$b2 = additionalInfoData.body) === null || _additionalInfoData$b2 === void 0 ? void 0 : _additionalInfoData$b2.configData]);
  useEffect(function () {
    var setRunMode = function setRunMode() {
      try {
        var _props$params;
        sessionUtility.setRunMode(props === null || props === void 0 ? void 0 : (_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.mvoenv);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    };
    setRunMode();
    sessionStorage.setItem('issueSelectorInitailLoad', JSON.stringify(false));
    var issueSelectorLoadDelay = getCookie$1("issueSelectorDelay");
    setTimeout(function () {
      if (showComp === false) {
        setShowComp(true);
      }
    }, issueSelectorLoadDelay || 3000);
  }, []);
  useEffect(function () {
    var _ref2 = (props === null || props === void 0 ? void 0 : props.params) || {},
      _ref2$sku = _ref2.sku,
      sku = _ref2$sku === void 0 ? '' : _ref2$sku,
      _ref2$equipmentId = _ref2.equipmentId,
      equipmentId = _ref2$equipmentId === void 0 ? '' : _ref2$equipmentId,
      changeDeviceFlow = _ref2.changeDeviceFlow;
    var paramsCopy = _extends({}, props.params);
    if (sku) {
      var getSku = sku.slice(-2).split('');
      if (getSku[0] === '-') {
        paramsCopy.sku = sku.slice(0, -2);
      }
    }
    if (changeDeviceFlow === true) {
      console.log("props.params.changeDeviceFlow======", equipmentId);
      equipmentRef.current = equipmentId;
      paramsCopy.equipmentId = equipmentRef.current;
    }
    if (!equipmentId || !sku) {
      var _ref3 = additionalInfoData || {},
        _ref3$body = _ref3.body,
        _ref3$body2 = _ref3$body === void 0 ? {} : _ref3$body,
        _ref3$body2$configDat = _ref3$body2.configData,
        _ref3$body2$configDat2 = _ref3$body2$configDat === void 0 ? {} : _ref3$body2$configDat,
        _ref3$body2$configDat3 = _ref3$body2$configDat2.mtns,
        mtns = _ref3$body2$configDat3 === void 0 ? [] : _ref3$body2$configDat3;
      var _ref4 = mtns[0] || {},
        _ref4$deviceSku = _ref4.deviceSku,
        deviceSku = _ref4$deviceSku === void 0 ? '' : _ref4$deviceSku,
        eqid = _ref4.equipmentId;
      if (eqid) {
        equipmentRef.current = eqid;
        paramsCopy.equipmentId = equipmentRef.current;
      }
      if (deviceSku) {
        skuRef.current = deviceSku;
        paramsCopy.sku = skuRef.current;
      }
    }
    console.log("skuRenderCount++++++++++++++++paramsCopy", paramsCopy);
    setCareLandingParams(paramsCopy);
  }, [props === null || props === void 0 ? void 0 : props.params]);
  var renderComponent;
  renderComponent = /*#__PURE__*/React__default.createElement(IssueSelectorNew, {
    ref: childIssueRef
  });
  useEffect(function () {
    var _careLandingParams$eq = careLandingParams.equipmentId,
      equipmentId = _careLandingParams$eq === void 0 ? '' : _careLandingParams$eq;
    console.log("careLandingParams----", careLandingParams);
    if (equipmentId && showComp === false) {
      setShowComp(true);
    }
  }, [careLandingParams]);
  var getAdditionalInfo = function getAdditionalInfo(additionalData) {
    try {
      var _additionalData$body$, _additionalData$body, _additionalData$respo, _additionalData$body$2, _additionalData$body2, _additionalData$body3, _additionalData$body4, _additionalData$body5;
      setLoading(true);
      var configData = (_additionalData$body$ = additionalData === null || additionalData === void 0 ? void 0 : (_additionalData$body = additionalData.body) === null || _additionalData$body === void 0 ? void 0 : _additionalData$body.configData) != null ? _additionalData$body$ : null;
      if ((configData === null || configData === void 0 ? void 0 : configData.isIssueHistoryEnable) === null || (configData === null || configData === void 0 ? void 0 : configData.isIssueHistoryEnable) === undefined) {
        var enableIssueHistory = getCookie$1("isIssueHistoryEnable");
        configData.isIssueHistoryEnable = enableIssueHistory === "true" ? true : false;
      }
      if ((configData === null || configData === void 0 ? void 0 : configData.isTroubleshootEnable) === null || (configData === null || configData === void 0 ? void 0 : configData.isTroubleshootEnable) === undefined || !(configData !== null && configData !== void 0 && configData.isTroubleshootEnable)) {
        var isTroubleshootEnable = getCookie$1("isTroubleshootEnable");
        configData.isTroubleshootEnable = isTroubleshootEnable === "true" ? true : false;
      }
      if (!(configData !== null && configData !== void 0 && configData.isDeviceSelectorEnable)) {
        var isDeviceSelectorEnable = getCookie$1("isDeviceSelectorEnable");
        configData.isDeviceSelectorEnable = isDeviceSelectorEnable === "true" ? true : false;
      }
      if (window.isBAUACSS != undefined || window.isBAUACSS) {
        configData.isIssueHistoryEnable = false;
      }
      var errorMSG = (additionalData === null || additionalData === void 0 ? void 0 : (_additionalData$respo = additionalData.responseInfo) === null || _additionalData$respo === void 0 ? void 0 : _additionalData$respo.responseMessage) == "SUCCESS" ? false : true;
      setAdditionalInfoSteps((_additionalData$body$2 = additionalData === null || additionalData === void 0 ? void 0 : (_additionalData$body2 = additionalData.body) === null || _additionalData$body2 === void 0 ? void 0 : (_additionalData$body3 = _additionalData$body2.ddata) === null || _additionalData$body3 === void 0 ? void 0 : (_additionalData$body4 = _additionalData$body3.output) === null || _additionalData$body4 === void 0 ? void 0 : (_additionalData$body5 = _additionalData$body4.pageContent) === null || _additionalData$body5 === void 0 ? void 0 : _additionalData$body5.steps) != null ? _additionalData$body$2 : []);
      var _ref5 = additionalData || {},
        _ref5$body = _ref5.body,
        _ref5$body2 = _ref5$body === void 0 ? {} : _ref5$body,
        _ref5$body2$configDat = _ref5$body2.configData,
        _ref5$body2$configDat2 = _ref5$body2$configDat === void 0 ? {} : _ref5$body2$configDat,
        _ref5$body2$configDat3 = _ref5$body2$configDat2.mtns,
        mtns = _ref5$body2$configDat3 === void 0 ? [] : _ref5$body2$configDat3;
      var _ref6 = mtns[0] || {},
        _ref6$deviceSku = _ref6.deviceSku,
        deviceSku = _ref6$deviceSku === void 0 ? '' : _ref6$deviceSku,
        _ref6$equipmentId = _ref6.equipmentId,
        equipmentId = _ref6$equipmentId === void 0 ? '' : _ref6$equipmentId;
      console.log("Mtns from other content", mtns, deviceSku, equipmentId);
      var sku = careLandingParams.sku,
        equipId = careLandingParams.equipmentId;
      if (!sku || !equipId) {
        skuRef.current = deviceSku;
        equipmentRef.current = equipmentId;
        console.log("sku useRef-->", skuRef.current);
        setCareLandingParams(function (prevParams) {
          return _extends({}, prevParams, {
            equipmentId: equipmentId,
            sku: deviceSku
          });
        });
      }
      setModalError(errorMSG);
      setConfig(configData);
      setLoading(false);
      sessionUtility.setMvoConfig(configData);
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };
  console.log("info child", props.params);
  console.log("config", config);
  console.log("info stringify", JSON.stringify(props.params));
  console.log("Package Version - 1.0.80");
  if (loading === false && showComp === true) {
    var _props$params2;
    if (config !== null && config !== void 0 && config.isIssueSelectorEnable && config !== null && config !== void 0 && config.isTroubleshootEnable || config !== null && config !== void 0 && config.isIssueSelectorEnable && props !== null && props !== void 0 && (_props$params2 = props.params) !== null && _props$params2 !== void 0 && _props$params2.equipmentId) {
      var _props$params3, _props$params4, _props$params4$theme;
      console.log("tabtabtab2");
      return /*#__PURE__*/React__default.createElement(PageWrapper$2, {
        theme: props === null || props === void 0 ? void 0 : (_props$params3 = props.params) === null || _props$params3 === void 0 ? void 0 : _props$params3.theme,
        className: props !== null && props !== void 0 && (_props$params4 = props.params) !== null && _props$params4 !== void 0 && (_props$params4$theme = _props$params4.theme) !== null && _props$params4$theme !== void 0 && _props$params4$theme.isDark ? "dark" : "light"
      }, /*#__PURE__*/React__default.createElement(UserProvider, {
        value: {
          paramsDetails: careLandingParams,
          additionalInfoSteps: additionalInfoSteps
        }
      }, /*#__PURE__*/React__default.createElement(ParamsContext.Provider, {
        value: {
          paramsDetails: careLandingParams,
          configDetails: config,
          additionalInfoSteps: additionalInfoSteps,
          modalError: modalError,
          outageData: outageData,
          healthCheckData: healthCheckData
        }
      }, /*#__PURE__*/React__default.createElement(ConfigContext.Provider, {
        value: {
          paramsDetails: careLandingParams
        }
      }, /*#__PURE__*/React__default.createElement(ErrorBoundary, {
        errorcode: "00"
      }, renderComponent)))));
    } else {
      return /*#__PURE__*/React__default.createElement("div", null, "Loading...");
    }
  } else {
    return /*#__PURE__*/React__default.createElement("div", null, "Loading...");
  }
});

function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1.apply(null, arguments);
}

function _objectWithoutPropertiesLoose$1(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

function _setPrototypeOf$1(t, e) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf$1(t, e);
}

function _inheritsLoose$1(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf$1(t, o);
}

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config$1 = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

var TransitionGroupContext = React__default.createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$1(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config$1.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config$1.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose$1(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};

var removeClass$1 = function removeClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$1(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass$1(node, baseClassName);
    }

    if (activeClassName) {
      removeClass$1(node, activeClassName);
    }

    if (doneClassName) {
      removeClass$1(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        props = _objectWithoutPropertiesLoose$1(_this$props, ["classNames"]);

    return /*#__PURE__*/React__default.createElement(Transition, _extends$1({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(React__default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$1({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};

function createWrapperAndAppendToBody(wrapperId) {
  var wrapperElement = document.createElement("div");
  wrapperElement.setAttribute("id", wrapperId);
  document.body.appendChild(wrapperElement);
  return wrapperElement;
}
function ReactPortal(_ref) {
  var children = _ref.children,
    _ref$wrapperId = _ref.wrapperId,
    wrapperId = _ref$wrapperId === void 0 ? "react-portal-wrapper" : _ref$wrapperId;
  var _useState = useState(null),
    wrapperElement = _useState[0],
    setWrapperElement = _useState[1];
  useLayoutEffect(function () {
    var element = document.getElementById(wrapperId);
    var systemCreated = false;
    if (!element) {
      systemCreated = true;
      element = createWrapperAndAppendToBody(wrapperId);
    }
    setWrapperElement(element);
    return function () {
      if (systemCreated && element.parentNode) {
        element.parentNode.removeChild(element);
      }
    };
  }, [wrapperId]);
  if (wrapperElement === null) return null;
  return createPortal(children, wrapperElement);
}

function Launchout(_ref) {
  var children = _ref.children,
    handleClose = _ref.handleClose,
    modalTitle = _ref.modalTitle,
    width = _ref.width,
    height = _ref.height,
    isDark = _ref.isDark;
  var nodeRef = useRef(null);
  useEffect(function () {
    var _window$minimizeCompo;
    var closeOnEscapeKey = function closeOnEscapeKey(e) {
      return e.key === "Escape" ? handleClose() : null;
    };
    document.body.addEventListener("keydown", closeOnEscapeKey);
    var data = {
      desc: modalTitle,
      height: 2,
      hide: false,
      hideViewInOpenComponents: false,
      id: modalTitle === "Device" ? "deviceDetailsTRGPopup" : "networkDetailsTRGPopup",
      isLegacyLaunch: true,
      lastFocusElement: "",
      linkParams: "fromTroubleshootingTab",
      modal: false,
      preload: false,
      reactJSObjectName: "",
      status: "hide",
      isTroubleshootingData: true,
      isMinimize: false,
      isOpen: true,
      zIndex: 5,
      width: 3
    };
    var listData = ((_window$minimizeCompo = window.minimizeComponentList) === null || _window$minimizeCompo === void 0 ? void 0 : _window$minimizeCompo.filter(function (item) {
      return item.id !== data.id;
    })) || [];
    var customEvent = new CustomEvent("isComponentMinimize", {
      detail: {
        minimizeComponentList: [].concat(listData, [data])
      }
    });
    window.minimizeComponentList = [].concat(listData, [data]);
    window.dispatchEvent(customEvent);
    window.addEventListener("closeMinimizeComponent", handleCloseMinimizedComponent);
    return function () {
      document.body.removeEventListener("keydown", closeOnEscapeKey);
    };
  }, []);
  var handleCloseMinimizedComponent = function handleCloseMinimizedComponent(e) {
    handleClose();
  };
  var closeHandle = function closeHandle() {
    var _window$minimizeCompo2;
    var minimizedData = (_window$minimizeCompo2 = window.minimizeComponentList) === null || _window$minimizeCompo2 === void 0 ? void 0 : _window$minimizeCompo2.filter(function (item) {
      return item.id !== (modalTitle === "Device" ? "deviceDetailsTRGPopup" : "networkDetailsTRGPopup");
    });
    var customEvent = new CustomEvent("isComponentMinimize", {
      detail: {
        minimizeComponentList: [].concat(minimizedData)
      }
    });
    window.minimizeComponentList = [].concat(minimizedData);
    window.dispatchEvent(customEvent);
    handleClose();
  };
  return /*#__PURE__*/React__default.createElement(ReactPortal, {
    wrapperId: "react-portal-modal-container"
  }, /*#__PURE__*/React__default.createElement(CSSTransition, {
    "in": true,
    timeout: {
      entry: 0,
      exit: 0
    },
    unmountOnExit: true,
    classNames: "trg-modal",
    nodeRef: nodeRef
  }, /*#__PURE__*/React__default.createElement(Draggable, {
    positionOffset: {
      x: "-50%",
      y: "-50%"
    },
    handle: "strong"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: isDark ? 'trg-modal trg-modal-dark' : "trg-modal",
    ref: nodeRef,
    style: {
      width: width,
      height: height
    }
  }, /*#__PURE__*/React__default.createElement("strong", {
    className: "trg-modal-cursor"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "trg-modal-header"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "title"
  }, modalTitle), /*#__PURE__*/React__default.createElement("div", {
    onClick: closeHandle,
    onTouchEnd: closeHandle,
    "data-testid": "closeHandle",
    className: "close-btn"
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    surface: isDark ? 'dark' : 'light',
    name: "close",
    size: "medium",
    color: "#000000"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: isDark ? 'trg-modal-content trg-modal-dark' : "trg-modal-content"
  }, children)))));
}

var _templateObject$1w, _templateObject2$1b, _templateObject3$Y, _templateObject4$V;
var RowWrapper = styled.div(_templateObject$1w || (_templateObject$1w = _taggedTemplateLiteralLoose(["\n   display: flex;\n  width: 100%;\n  font-size: 14px;\n  &:hover{\n   background-color:", ";\n  }\n \n"])), function (props) {
  return !props.isDark && '#dcdcdb';
});
var DescriptionDiv = styled.div(_templateObject2$1b || (_templateObject2$1b = _taggedTemplateLiteralLoose(["\n      width: 160px;\n      overflow-y: auto;\n     white-space: nowrap; \n     scrollbar-width:none;\n     border-bottom:1px solid #ccc;\n     margin-left:10px;\n"])));
var ValueDiv = styled.div(_templateObject3$Y || (_templateObject3$Y = _taggedTemplateLiteralLoose(["\nwidth: 240px;\noverflow-y: auto;\nwhite-space: nowrap; \nscrollbar-width:none;\nborder-bottom:1px solid #ccc;\npadding-left:40px;\n"])));
var HeadingDiv$1 = styled.div(_templateObject4$V || (_templateObject4$V = _taggedTemplateLiteralLoose(["\n  color:", "\n"])), function (props) {
  return props.isDark && '#000';
});
function EsimDetails(props) {
  var _useQuerySimService = useQuerySimService(props),
    simData = _useQuerySimService.data;
  var isDark = props === null || props === void 0 ? void 0 : props.isDark;
  var iccIdProfileState = "";
  var activationCode = "";
  if (simData) {
    activationCode = simData.activationCode;
    if (simData.iccIdProfileState === "I0") {
      iccIdProfileState = "I0 - Profile Installed Successfully (Next step: SIM OTA)";
    } else if (simData.iccIdProfileState === "I1") {
      iccIdProfileState = "I1 - Profile Install Failed";
    } else if (simData.iccIdProfileState === "I2") {
      iccIdProfileState = "I2 - Profile Install Failed";
    } else if (simData.iccIdProfileState === "L0") {
      iccIdProfileState = "L0 - Profile Downloaded Succesfully (Next step: Profile installed)";
    } else if (simData.iccIdProfileState === "L1") {
      iccIdProfileState = "L1 - Profile Download Failed";
    } else if (simData.iccIdProfileState === "L2") {
      iccIdProfileState = "L2 - Profile Download Failed";
    } else if (simData.iccIdProfileState === "C0") {
      iccIdProfileState = "C0 - Profile ready for download (Next step: Device downloads profile)";
    } else if (simData.iccIdProfileState === "C1") {
      iccIdProfileState = "C1 - Profile Reservation Confirmation Failed";
    } else if (simData.iccIdProfileState === "C2") {
      iccIdProfileState = "C2 - Profile Reservation Confirmation Failed";
    } else if (simData.iccIdProfileState === "D0") {
      iccIdProfileState = "D0 - Profile Reserved (Next step: MDN is activated in billing)";
    } else if (simData.iccIdProfileState === "D1") {
      iccIdProfileState = "D1 - Profile Reservation Failed";
    } else if (simData.iccIdProfileState === "D2") {
      iccIdProfileState = "D2 - Profile Reservation Failed";
    }
  }
  var getProfileData = function getProfileData() {
    return /*#__PURE__*/React__default.createElement(Row$2, {
      className: "esim-row"
    }, /*#__PURE__*/React__default.createElement(RowWrapper, {
      isDark: isDark
    }, /*#__PURE__*/React__default.createElement(DescriptionDiv, null, "Profile State"), /*#__PURE__*/React__default.createElement(ValueDiv, null, iccIdProfileState)));
  };
  var getActivationCode = function getActivationCode() {
    return /*#__PURE__*/React__default.createElement(Row$2, {
      className: "esim-row"
    }, /*#__PURE__*/React__default.createElement(RowWrapper, {
      isDark: isDark
    }, /*#__PURE__*/React__default.createElement(DescriptionDiv, null, "Activation Code"), /*#__PURE__*/React__default.createElement(ValueDiv, null, activationCode)));
  };
  return /*#__PURE__*/React__default.createElement("div", {
    id: "deviceeSimDetails"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "reactivate-table-esim",
    "data-testid": "AcssGridApi"
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    bleed: "1272",
    rowGutter: "10px",
    colSizes: {
      mobile: 1,
      tablet: 1,
      desktop: 1
    }
  }, /*#__PURE__*/React__default.createElement(Row$2, {
    className: "esim-row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "esim-row-header"
  }, /*#__PURE__*/React__default.createElement(HeadingDiv$1, {
    isDark: isDark
  }, "Description"), /*#__PURE__*/React__default.createElement(HeadingDiv$1, {
    isDark: isDark
  }, "Value"))), iccIdProfileState !== "" || activationCode !== "" ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Tooltip, {
    renderAnchorElement: getProfileData
  }, iccIdProfileState), /*#__PURE__*/React__default.createElement(Tooltip, {
    renderAnchorElement: getActivationCode
  }, activationCode)) : /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Row$2, {
    className: "esim-no-row"
  }, "No Rows To Show"), /*#__PURE__*/React__default.createElement(Row$2, null)))));
}

var _templateObject$1x, _templateObject2$1c;
var RegenrateWrapper = styled.div(_templateObject$1x || (_templateObject$1x = _taggedTemplateLiteralLoose(["\n [class^=\"SelectContainer-VDS\"]{\n  height:1.75rem !important;\n  }\n"])));
var StyledDropdownSelect = styled(DropdownSelect)(_templateObject2$1c || (_templateObject2$1c = _taggedTemplateLiteralLoose(["\n\nfont-size: 0.75rem;\n    padding-top: 0px;\n    padding-bottom: 0px;\n    padding-left:5px;  \n"])));
var RegenerateQRPopup = /*#__PURE__*/function (_Component) {
  function RegenerateQRPopup(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.EMAIL_VALIDATION_FLAG = false;
    _this.prevLogMetrics = {
      EVENT_ID: "",
      ACTION_ID: "",
      NOTES: ""
    };
    _this.emailValv2 = {
      emailValidationStatus: "",
      isEmailValid: false,
      isLoading: false,
      invalidErrorMsg: false,
      manualValidation: false,
      sameEmailErrorMsg: false,
      showSendEmailMsg: false,
      showBlueBannerMsg: false
    };
    _this.prevLogMetrics = {
      EVENT_ID: "",
      ACTION_ID: "",
      NOTES: ""
    };
    _this.REGENQROCODE_BPID_FIX = false;
    _this.emailValidation = function () {
      var _this$state$UserProfi, _this$state$UserProfi2, _this$state$UserProfi3;
      var ACSS_EMAIL_VALIDATION = false;
      var sessionParamData = [];
      sessionParamData = (_this$state$UserProfi = _this.state.UserProfile) === null || _this$state$UserProfi === void 0 ? void 0 : (_this$state$UserProfi2 = _this$state$UserProfi.permission) === null || _this$state$UserProfi2 === void 0 ? void 0 : (_this$state$UserProfi3 = _this$state$UserProfi2.sessionPermission) === null || _this$state$UserProfi3 === void 0 ? void 0 : _this$state$UserProfi3.ACSS_EMAIL_VALIDATION;
      if (!IsNullOrUndefinedObj(sessionParamData) && sessionParamData[0] == "Y") {
        ACSS_EMAIL_VALIDATION = true;
      }
      return ACSS_EMAIL_VALIDATION;
    };
    _this.onChangeEmail = function (e) {
      var _window$caseDetails$a, _window, _window$caseDetails, _this$props, _this$props$params;
      if (e.target.value == "") {
        _this.setState({
          inputClass: "invalid"
        });
        _this.setState({
          submit: "submit-button-disabled"
        });
        _this.setState({
          onSubmit: true
        });
      }
      var customerId;
      function getSecondPart(str) {
        customerId = str.split("-")[0];
        return str.split("-")[1];
      }
      var billaccountno = getSecondPart((_window$caseDetails$a = (_window = window) === null || _window === void 0 ? void 0 : (_window$caseDetails = _window.caseDetails) === null || _window$caseDetails === void 0 ? void 0 : _window$caseDetails.accountNumber) != null ? _window$caseDetails$a : (_this$props = _this.props) === null || _this$props === void 0 ? void 0 : (_this$props$params = _this$props.params) === null || _this$props$params === void 0 ? void 0 : _this$props$params.accountNumber);
      if (e.target.value.replaceAll(/\s+/g, "").match(/^(")?(?:[^\."])(?:(?:[\.])?(?:[\w\-!#$%&'*+/=?^_`{|}~]))*\1@(\w[\-\w]*\.){1,5}([A-Za-z]){3,}$/) !== null && _this.emailValidation) {
        try {
          var _window$caseDetails$u, _window2, _window2$caseDetails, _this$props2, _this$props2$params, _window$caseDetails$u2, _window3, _window3$caseDetails, _this$props3, _this$props3$params, _window$caseDetails$a2, _window4, _window4$caseDetails, _this$props4, _this$props4$params, _window$caseDetails$m, _window5, _window5$caseDetails, _this$props5, _this$props5$params;
          var requestObj = {
            meta: {
              client: "CXP",
              user: (_window$caseDetails$u = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$caseDetails = _window2.caseDetails) === null || _window2$caseDetails === void 0 ? void 0 : _window2$caseDetails.userId) != null ? _window$caseDetails$u : (_this$props2 = _this.props) === null || _this$props2 === void 0 ? void 0 : (_this$props2$params = _this$props2.params) === null || _this$props2$params === void 0 ? void 0 : _this$props2$params.loggedInUser,
              clientCorrelationId: ""
            },
            data: {
              clientId: "ACSS",
              userId: (_window$caseDetails$u2 = (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$caseDetails = _window3.caseDetails) === null || _window3$caseDetails === void 0 ? void 0 : _window3$caseDetails.userId) != null ? _window$caseDetails$u2 : (_this$props3 = _this.props) === null || _this$props3 === void 0 ? void 0 : (_this$props3$params = _this$props3.params) === null || _this$props3$params === void 0 ? void 0 : _this$props3$params.loggedInUser,
              customerId: (_window$caseDetails$a2 = (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$caseDetails = _window4.caseDetails) === null || _window4$caseDetails === void 0 ? void 0 : _window4$caseDetails.accountNumber) != null ? _window$caseDetails$a2 : (_this$props4 = _this.props) === null || _this$props4 === void 0 ? void 0 : (_this$props4$params = _this$props4.params) === null || _this$props4$params === void 0 ? void 0 : _this$props4$params.accountNumber
            },
            validateData: {
              sourceSystem: "VZW-ACSS",
              accountNumber: formatBillAccountNo(billaccountno),
              mtn: (_window$caseDetails$m = (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$caseDetails = _window5.caseDetails) === null || _window5$caseDetails === void 0 ? void 0 : _window5$caseDetails.mtn) != null ? _window$caseDetails$m : (_this$props5 = _this.props) === null || _this$props5 === void 0 ? void 0 : (_this$props5$params = _this$props5.params) === null || _this$props5$params === void 0 ? void 0 : _this$props5$params.mdn,
              emailAddress: e.target.value.trim(),
              ipAddress: ""
            },
            loggerComponentName: "CustomerContactInformation"
          };
          _this.setState({
            email: e.target.value
          });
          getValidateEmail(requestObj).then(function (data) {
            var _data$response;
            console.log("data=====", data);
            var getValidateEmailResponse = data === null || data === void 0 ? void 0 : (_data$response = data.response) === null || _data$response === void 0 ? void 0 : _data$response.data;
            console.log("getValidateEmailResponse=====", getValidateEmailResponse);
            _this.setState({
              emailValidationInfo: getValidateEmailResponse
            });
          });
        } catch (err) {
          console.log(err);
        }
      } else if (e.target.value.match(/^(")?(?:[^\."])(?:(?:[\.])?(?:[\w\-!#$%&'*+/=?^_`{|}~]))*\1@(\w[\-\w]*\.){1,5}([A-Za-z]){3,}$/) !== null) {
        _this.setState({
          inputClass: "valid"
        });
        _this.setState({
          submit: "submit-button-enabled"
        });
        _this.setState({
          onSubmit: false
        });
      } else {
        _this.setState({
          inputClass: "invalid"
        });
        _this.setState({
          submit: "submit-button-disabled"
        });
        _this.setState({
          onSubmit: true
        });
      }
      _this.setState({
        email: e.target.value.replaceAll(/\s+/g, "")
      });
      _this.setState({
        info: false
      });
    };
    _this.handleEmailChange = function (e) {
      _this.setState({
        email: e.target.value,
        info: false,
        onSubmit: true
      }, function () {
        if (!_this.validateRegex(e.target.value)) {
          _this.resetEmailErrors();
          _this.emailValv2.invalidErrorMsg = true;
          _this.setState({
            submit: "submit-button-disabled"
          });
          return;
        } else {
          _this.resetEmailErrors();
          _this.setState({
            submit: "submit-button-disabled",
            inputClass: "valid"
          });
        }
      });
    };
    _this.verifyEmail = function () {
      var selectedCallKey = _this.props.selectedCallKey;
      var _getCallKeyMetaData = getCallKeyMetaData(selectedCallKey),
        customerId = _getCallKeyMetaData.customerId,
        billAccountNo = _getCallKeyMetaData.billAccountNo,
        mtn = _getCallKeyMetaData.mtn;
      _this.logMetrics("MANUAL_VALIDATION_CLICK_HERE", "Sending Verification Email");
      _this.emailValv2.showSendEmailMsg = false;
      _this.emailValv2.showBlueBannerMsg = true;
      _this.emailValv2.confirmHandler = _this.confirmBtnHandler;
      _this.setState({
        onSubmit: true
      });
      if (_this.state.email && _this.validateRegex(_this.state.email)) {
        var request = {
          action: "manual",
          mtn: mtn,
          customerId: customerId + "-" + billAccountNo,
          accountNumber: billAccountNo,
          email: _this.state.email.trim(),
          emailType: "M"
        };
        HttpService.post("" + Constants.ACSS_CUST_EMAIL_VERIFICATION, request, {
          headers: {
            channelId: "OMNI-CARE"
          }
        })["catch"](function (err) {
        });
      }
    };
    _this.confirmBtnHandler = function () {
      _this.emailValv2.invalidErrorMsg = false;
      _this.emailValv2.isEmailValid = false;
      _this.emailValv2.manualValidation = false;
      _this.emailValv2.showBlueBannerMsg = false;
      _this.logMetrics("MANUAL_VALIDATION_CONFIRM_BUTTON_CLICKED", "Confirm button clicked in blue banner");
      _this.validateEmail();
      _this.setState({
        onSubmit: true
      });
    };
    _this.logMetrics = function (actionId, notes) {
      if (actionId !== _this.prevLogMetrics.ACTION_ID && notes !== _this.prevLogMetrics.NOTES) {
        _this.prevLogMetrics.ACTION_ID = actionId;
        _this.prevLogMetrics.NOTES = notes;
      }
    };
    _this.validateRegex = function (emailid) {
      return /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/.test(emailid);
    };
    _this.resetEmailErrors = function () {
      _this.emailValv2.invalidErrorMsg = false, _this.emailValv2.isEmailValid = false;
      _this.emailValv2.sameEmailErrorMsg = false;
      _this.emailValv2.manualValidation = false;
    };
    _this.getEmailStyle = function (emailObj) {
      if (!emailObj.invalidErrorMsg && emailObj.manualValidation) {
        return {
          border: "1px solid orange",
          borderBottom: "2px solid orange"
        };
      } else if (emailObj.invalidErrorMsg) {
        return {
          border: "1px solid red",
          borderBottom: "2px solid red"
        };
      } else if (emailObj.isEmailValid) {
        return {
          border: "1px solid green",
          borderBottom: "2px solid green"
        };
      } else {
        return {
          border: "1px solid black",
          borderBottom: "2px solid black"
        };
      }
    };
    _this.onDeviceChange = function (e) {
      _this.setState({
        device: e.target.value
      });
      _this.setState({
        info: false
      });
      _this.setState({
        oneMSGEmailData: ''
      });
    };
    _this.onSubmit = function () {
      var _window$caseDetails$a3, _window6, _window6$caseDetails, _this$props6, _this$props6$params;
      var customerId;
      function getSecondPart(str) {
        customerId = str.split("-")[0];
        return str.split("-")[1];
      }
      var billaccountno = getSecondPart((_window$caseDetails$a3 = (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$caseDetails = _window6.caseDetails) === null || _window6$caseDetails === void 0 ? void 0 : _window6$caseDetails.accountNumber) != null ? _window$caseDetails$a3 : (_this$props6 = _this.props) === null || _this$props6 === void 0 ? void 0 : (_this$props6$params = _this$props6.params) === null || _this$props6$params === void 0 ? void 0 : _this$props6$params.accountNumber);
      _this.setState({
        info: true
      });
      var QRData = {};
      QRData.data = {};
      QRData.data.item = [{
        key: "EmailAddress",
        value: _this.state.email
      }, {
        key: "LangInd",
        value: "E"
      }, {
        key: "AccountNumber",
        value: billaccountno
      }, {
        key: "CustId",
        value: customerId
      }];
      if (_this.REGENQROCODE_BPID_FIX) {
        var QRdDevices = [{
          itemCode: "iPhone",
          itemValue: "DeviceSetUp_QRCode"
        }, {
          itemCode: "Samsung Galaxy Watch",
          itemValue: "QRCode-SamsungWatch"
        }, {
          itemCode: "Motorola",
          itemValue: "QRCodeAndroidDev"
        }, {
          itemCode: "Pixel",
          itemValue: "QRCode_Pixel"
        }];
        var selectedDevice = QRdDevices.find(function (obj) {
          return obj.itemValue === _this.state.device;
        });
        if (selectedDevice) {
          QRData.businessProcessId = selectedDevice.itemValue;
        }
      } else {
        QRData.businessProcessId = "DeviceSetUp_QRCode";
      }
      getOneMessageEmailService(QRData).then(function (data) {
        var _data$response2;
        console.log("data=====", data);
        var getOneMessageEmailServiceResponse = data === null || data === void 0 ? void 0 : (_data$response2 = data.response) === null || _data$response2 === void 0 ? void 0 : _data$response2.data;
        console.log("getOneMessageEmailServiceResponse=====", getOneMessageEmailServiceResponse);
        _this.setState({
          oneMSGEmailData: getOneMessageEmailServiceResponse
        });
        _this.forceUpdate();
      });
    };
    _this.getDisplayMessage = function () {
      var displayMessage = null;
      if (_this.state && _this.state.oneMSGEmailData && _this.state.oneMSGEmailData.status && _this.state.oneMSGEmailData.status === 200) {
        if (_this.state.oneMSGEmailData.data && _this.state.oneMSGEmailData.data.Status === "Success" && _this.state.oneMSGEmailData.data.StatusCode === "200") displayMessage = "QR Email initiated successfully for " + _this.state.device;
      } else if (_this.state.oneMSGEmailData && _this.state.oneMSGEmailData.error) {
        displayMessage = "QR Email Failed. Please re-try";
      }
      return displayMessage;
    };
    _this.state = {
      email: "",
      info: false,
      device: "DeviceSetUp_QRCode",
      inputClass: "valid",
      submit: "submit-button-disabled",
      error: "",
      onSubmit: true,
      UserProfile: {},
      refData: []
    };
    return _this;
  }
  _inheritsLoose(RegenerateQRPopup, _Component);
  var _proto = RegenerateQRPopup.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    var dataPayload = {
      isVisionLoginEnabled: "Y",
      callIdRefresh: "Y"
    };
    getProfileData(dataPayload).then(function (data) {
      var _data$response3, _data$response3$data, _this2$state$UserProf, _this2$state$UserProf2, _this2$state$UserProf3, _this2$state$UserProf4, _this2$state$UserProf5, _this2$state$UserProf6, _this2$state$UserProf7, _this2$state$UserProf8, _this2$state$UserProf9, _this2$state$UserProf0, _this2$state$UserProf1, _this2$state$UserProf10;
      var UserProfile = data === null || data === void 0 ? void 0 : (_data$response3 = data.response) === null || _data$response3 === void 0 ? void 0 : (_data$response3$data = _data$response3.data) === null || _data$response3$data === void 0 ? void 0 : _data$response3$data.data;
      _this2.setState({
        UserProfile: _this2.state.UserProfile = UserProfile
      });
      _this2.REGENQROCODE_BPID_FIX = (_this2$state$UserProf = _this2.state.UserProfile) !== null && _this2$state$UserProf !== void 0 && (_this2$state$UserProf2 = _this2$state$UserProf.permission) !== null && _this2$state$UserProf2 !== void 0 && (_this2$state$UserProf3 = _this2$state$UserProf2.sessionPermission) !== null && _this2$state$UserProf3 !== void 0 && _this2$state$UserProf3.ACSS_REGENQROCODE_BPID_FIX && ((_this2$state$UserProf4 = _this2.state.UserProfile) === null || _this2$state$UserProf4 === void 0 ? void 0 : (_this2$state$UserProf5 = _this2$state$UserProf4.permission) === null || _this2$state$UserProf5 === void 0 ? void 0 : (_this2$state$UserProf6 = _this2$state$UserProf5.sessionPermission) === null || _this2$state$UserProf6 === void 0 ? void 0 : _this2$state$UserProf6.ACSS_REGENQROCODE_BPID_FIX) === "Y" ? true : false;
      var reGenRefData = "";
      if (reGenRefData instanceof Promise) {
        reGenRefData.then(function (response) {
          _this2.setState({
            refData: response
          });
        });
      }
      _this2.EMAIL_VALIDATION_FLAG = _this2.state.UserProfile && (_this2$state$UserProf7 = _this2.state.UserProfile) !== null && _this2$state$UserProf7 !== void 0 && (_this2$state$UserProf8 = _this2$state$UserProf7.permission) !== null && _this2$state$UserProf8 !== void 0 && (_this2$state$UserProf9 = _this2$state$UserProf8.sessionPermission) !== null && _this2$state$UserProf9 !== void 0 && _this2$state$UserProf9.ACSS_EMAIL_VALIDATION_REGENQRCODE && ((_this2$state$UserProf0 = _this2.state.UserProfile) === null || _this2$state$UserProf0 === void 0 ? void 0 : (_this2$state$UserProf1 = _this2$state$UserProf0.permission) === null || _this2$state$UserProf1 === void 0 ? void 0 : (_this2$state$UserProf10 = _this2$state$UserProf1.sessionPermission) === null || _this2$state$UserProf10 === void 0 ? void 0 : _this2$state$UserProf10.ACSS_EMAIL_VALIDATION_REGENQRCODE) === "Y" ? true : false;
    });
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _prevState$emailValid, _prevState$emailValid2, _this$state$emailVali, _this$state$emailVali2, _prevState$emailValid3, _prevState$emailValid4, _this$state$emailVali3, _this$state$emailVali4;
    if ((prevState === null || prevState === void 0 ? void 0 : (_prevState$emailValid = prevState.emailValidationInfo) === null || _prevState$emailValid === void 0 ? void 0 : (_prevState$emailValid2 = _prevState$emailValid.nbsMailValidation) === null || _prevState$emailValid2 === void 0 ? void 0 : _prevState$emailValid2.validationStatus) !== ((_this$state$emailVali = this.state.emailValidationInfo) === null || _this$state$emailVali === void 0 ? void 0 : (_this$state$emailVali2 = _this$state$emailVali.nbsMailValidation) === null || _this$state$emailVali2 === void 0 ? void 0 : _this$state$emailVali2.validationStatus) && this.state.emailValidationInfo && this.state.emailValidationInfo.nbsMailValidation && this.state.emailValidationInfo.nbsMailValidation.validationStatus === "Invalid") {
      var EmailFieldValidationInvalid = [{
        ACTION_ID: "EMAIL_FIELD_VALIDATION",
        EVENT_ID: "REGENERATE_QR_POP_SCREEN",
        NOTES: "Entered Invalid Email Address"
      }];
      this.logMetrics(EmailFieldValidationInvalid.ACTION_ID, EmailFieldValidationInvalid.NOTES);
      this.setState({
        inputClass: "invalid"
      });
      this.setState({
        submit: "submit-button-disabled"
      });
      this.setState({
        onSubmit: true
      });
    } else if ((prevState === null || prevState === void 0 ? void 0 : (_prevState$emailValid3 = prevState.emailValidationInfo) === null || _prevState$emailValid3 === void 0 ? void 0 : (_prevState$emailValid4 = _prevState$emailValid3.nbsMailValidation) === null || _prevState$emailValid4 === void 0 ? void 0 : _prevState$emailValid4.validationStatus) !== ((_this$state$emailVali3 = this.state.emailValidationInfo) === null || _this$state$emailVali3 === void 0 ? void 0 : (_this$state$emailVali4 = _this$state$emailVali3.nbsMailValidation) === null || _this$state$emailVali4 === void 0 ? void 0 : _this$state$emailVali4.validationStatus) && this.state.emailValidationInfo && this.state.emailValidationInfo.nbsMailValidation && this.state.emailValidationInfo.nbsMailValidation.validationStatus === "Valid") {
      var _EmailFieldValidationInvalid = [{
        ACTION_ID: "EMAIL_FIELD_VALIDATION",
        EVENT_ID: "REGENERATE_QR_POP_SCREEN",
        NOTES: "Entered valid Email Address"
      }];
      this.logMetrics(_EmailFieldValidationInvalid.ACTION_ID, _EmailFieldValidationInvalid.NOTES);
      this.setState({
        inputClass: "valid"
      });
      this.setState({
        submit: "submit-button-enabled"
      });
      this.setState({
        onSubmit: false
      });
    }
  };
  _proto.handleEmailValidationResponse = function handleEmailValidationResponse(emailValidationInfo) {
    if (emailValidationInfo && emailValidationInfo.nbsMailValidation) {
      this.emailValv2.isLoading = false;
      if (emailValidationInfo.nbsMailValidation.validationStatus === "Valid" || emailValidationInfo.nbsMailValidation.validationStatus === "White_listed") {
        emailValidationInfo.nbsMailValidation.validationStatus === "Valid" ? this.logMetrics("EMAIL_VALIDATION_VALID", "Entered Email is Valid") : this.logMetrics("EMAIL_VALIDATION_WHITELISTED", "Entered Email is Whitelisted");
        this.emailValv2.invalidErrorMsg = false;
        this.emailValv2.isEmailValid = true;
        this.emailValv2.emailValidationStatus = emailValidationInfo.nbsMailValidation.validationStatus;
        this.setState({
          onSubmit: false,
          submit: "submit-button-enabled",
          inputClass: "valid"
        });
      }
      if (emailValidationInfo.nbsMailValidation.validationStatus === "Fake" || emailValidationInfo.nbsMailValidation.validationStatus === "Invalid") {
        emailValidationInfo.nbsMailValidation.validationStatus === "Fake" ? this.logMetrics("EMAIL_VALIDATION_FAKE", "Entered Email is Fake") : this.logMetrics("EMAIL_VALIDATION_INVALID", "Entered Email is Invalid");
        this.emailValv2.invalidErrorMsg = true;
        this.emailValv2.emailValidationStatus = emailValidationInfo.nbsMailValidation.validationStatus;
        this.setState({
          onSubmit: true,
          submit: "submit-button-disabled"
        });
      }
      if (emailValidationInfo.nbsMailValidation.validationStatus === "Manual_validation") {
        if (!this.emailValv2.showSendEmailMsg && !this.emailValv2.showBlueBannerMsg) {
          this.logMetrics("EMAIL_VALIDATION_MANUALVALIDATION", "Entered Email is for Manual Validation");
          this.emailValv2.manualValidation = true;
          this.emailValv2.showSendEmailMsg = true;
          this.emailValv2.showBlueBannerMsg = false;
          this.emailValv2.sendVerificationMail = this.verifyEmail;
          this.emailValv2.emailValidationStatus = emailValidationInfo.nbsMailValidation.validationStatus;
          this.setState({
            onSubmit: true,
            submit: "submit-button-disabled"
          });
        }
      }
    }
    if (emailValidationInfo.errors) {
      this.emailValv2.isLoading = false;
      this.setState({
        onSubmit: true,
        submit: "submit-button-disabled"
      });
    }
  };
  _proto.handleEmailBlur = function handleEmailBlur() {
    if (this.state.email && !this.emailValv2.invalidErrorMsg) {
      this.emailValv2.showSendEmailMsg = false;
      this.emailValv2.showBlueBannerMsg = false;
      this.resetEmailErrors();
      this.validateEmail();
    }
  };
  _proto.validateEmail = function validateEmail() {
    var _window$caseDetails$a4,
      _window7,
      _window7$caseDetails,
      _this$props7,
      _this$props7$params,
      _this3 = this;
    var customerId;
    function getSecondPart(str) {
      customerId = str.split("-")[0];
      return str.split("-")[1];
    }
    var billaccountno = getSecondPart((_window$caseDetails$a4 = (_window7 = window) === null || _window7 === void 0 ? void 0 : (_window7$caseDetails = _window7.caseDetails) === null || _window7$caseDetails === void 0 ? void 0 : _window7$caseDetails.accountNumber) != null ? _window$caseDetails$a4 : (_this$props7 = this.props) === null || _this$props7 === void 0 ? void 0 : (_this$props7$params = _this$props7.params) === null || _this$props7$params === void 0 ? void 0 : _this$props7$params.accountNumber);
    if (!this.emailValv2.invalidErrorMsg) {
      var _window$caseDetails$u3, _window8, _window8$caseDetails, _this$props8, _this$props8$params, _window$caseDetails$u4, _window9, _window9$caseDetails, _this$props9, _this$props9$params, _window$caseDetails$a5, _window0, _window0$caseDetails, _this$props0, _this$props0$params, _window$caseDetails$m2, _window1, _window1$caseDetails, _this$props1, _this$props1$params;
      var request = {
        meta: {
          user: (_window$caseDetails$u3 = (_window8 = window) === null || _window8 === void 0 ? void 0 : (_window8$caseDetails = _window8.caseDetails) === null || _window8$caseDetails === void 0 ? void 0 : _window8$caseDetails.userId) != null ? _window$caseDetails$u3 : (_this$props8 = this.props) === null || _this$props8 === void 0 ? void 0 : (_this$props8$params = _this$props8.params) === null || _this$props8$params === void 0 ? void 0 : _this$props8$params.loggedInUser,
          clientCorrelationId: "",
          client: "CXP"
        },
        data: {
          userId: (_window$caseDetails$u4 = (_window9 = window) === null || _window9 === void 0 ? void 0 : (_window9$caseDetails = _window9.caseDetails) === null || _window9$caseDetails === void 0 ? void 0 : _window9$caseDetails.userId) != null ? _window$caseDetails$u4 : (_this$props9 = this.props) === null || _this$props9 === void 0 ? void 0 : (_this$props9$params = _this$props9.params) === null || _this$props9$params === void 0 ? void 0 : _this$props9$params.loggedInUser,
          clientId: "ACSS",
          billingSystem: this.props && this.props.customerInfo && this.props.customerInfo.billingSystem,
          customerId: (_window$caseDetails$a5 = (_window0 = window) === null || _window0 === void 0 ? void 0 : (_window0$caseDetails = _window0.caseDetails) === null || _window0$caseDetails === void 0 ? void 0 : _window0$caseDetails.accountNumber) != null ? _window$caseDetails$a5 : (_this$props0 = this.props) === null || _this$props0 === void 0 ? void 0 : (_this$props0$params = _this$props0.params) === null || _this$props0$params === void 0 ? void 0 : _this$props0$params.accountNumber
        },
        validateData: {
          sourceSystem: "VZW-ACSS",
          accountNumber: billaccountno,
          mtn: (_window$caseDetails$m2 = (_window1 = window) === null || _window1 === void 0 ? void 0 : (_window1$caseDetails = _window1.caseDetails) === null || _window1$caseDetails === void 0 ? void 0 : _window1$caseDetails.mtn) != null ? _window$caseDetails$m2 : (_this$props1 = this.props) === null || _this$props1 === void 0 ? void 0 : (_this$props1$params = _this$props1.params) === null || _this$props1$params === void 0 ? void 0 : _this$props1$params.mdn,
          ipAddress: "",
          emailAddress: this.state.email.trim(),
          pageName: "ACSS QR Code",
          version: "v2"
        },
        loggerComponentName: "CustomerContactInformation"
      };
      this.emailValv2.isLoading = true;
      this.setState({
        onSubmit: false
      });
      getValidateEmail(request);
      HttpService.post("" + Constants.ACSS_CUST_EMAIL_ONLY_VALIDATION, request, {
        headers: {
          channelId: "OMNI-CARE"
        }
      }).then(function (response) {
        var apiResponse = response.data || {
          errors: [{
            msg: "Service Failure"
          }]
        };
        _this3.handleEmailValidationResponse(apiResponse);
      })["catch"](function (err) {
      });
    }
  };
  _proto.render = function render() {
    var _this4 = this;
    var isDark = this.props.isDark;
    return /*#__PURE__*/React__default.createElement(RegenrateWrapper, {
      id: "regeneratePopup"
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "subtitle"
    }, isDark, " Please enter E-mail Address for generating QR Code: "), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      valign: "top",
      width: "110px"
    }, /*#__PURE__*/React__default.createElement("label", {
      className: "description"
    }, "Device Type")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(StyledDropdownSelect, {
      surface: isDark ? "dark" : "light",
      value: this.state.device,
      "data-testid": "option",
      onChange: this.onDeviceChange
    }, /*#__PURE__*/React__default.createElement("option", {
      value: "DeviceSetUp_QRCode"
    }, "iPhone"), /*#__PURE__*/React__default.createElement("option", {
      value: "QRCodeAndroidDev"
    }, "Motorola"), /*#__PURE__*/React__default.createElement("option", {
      value: "QRCode_Pixel"
    }, "Pixel"), /*#__PURE__*/React__default.createElement("option", {
      value: "QRCode-SamsungWatch"
    }, "Samsung Galaxy Watch"))))))), /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      valign: "top",
      width: "110px"
    }, /*#__PURE__*/React__default.createElement("label", {
      className: "description"
    }, "Email Address")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("form", null, !this.EMAIL_VALIDATION_FLAG && /*#__PURE__*/React__default.createElement("input", {
      className: isDark ? this.state.inputClass + "-dark-theme" : this.state.inputClass,
      type: "text",
      value: this.state.email,
      "data-testid": "regenEmail",
      onChange: this.onChangeEmail,
      onBlur: this.onChangeEmail,
      required: true,
      title: this.state.error
    }), this.EMAIL_VALIDATION_FLAG && /*#__PURE__*/React__default.createElement("input", {
      className: isDark ? this.state.inputClass + "-dark-theme" : this.state.inputClass,
      style: this.getEmailStyle(this.emailValv2),
      type: "text",
      value: this.state.email,
      "data-testid": "regenEmailValidation",
      onChange: this.handleEmailChange,
      onBlur: function onBlur(e) {
        return _this4.handleEmailBlur();
      },
      required: true
    }), this.EMAIL_VALIDATION_FLAG && this.emailValv2.isLoading, (this.EMAIL_VALIDATION_FLAG && this.emailValv2.invalidErrorMsg || this.state.email !== "" && this.state.inputClass === "invalid") && /*#__PURE__*/React__default.createElement("label", {
      className: "regenqr-error-label"
    }, "Please enter a valid email address"), this.EMAIL_VALIDATION_FLAG && this.emailValv2.manualValidation && this.emailValv2.showSendEmailMsg && /*#__PURE__*/React__default.createElement("div", {
      className: "regenqr-manual-validation-pre mt-1"
    }, "Please", /*#__PURE__*/React__default.createElement("span", {
      className: "pr-1 pl-1",
      role: "button",
      onClick: this.emailValv2.sendVerificationMail
    }, /*#__PURE__*/React__default.createElement("u", null, "click here")), "to send an email to the customer to validate the email address", /*#__PURE__*/React__default.createElement("div", {
      className: "regenqr-info-icon regenqr-info-icon-dark " + (this.props.isDark ? "regenqr-dark-themed-icon" : "") + " d-inline-block",
      "data-toggle": "tooltip",
      title: "For security, we need to confirm this email address is valid"
    })), this.EMAIL_VALIDATION_FLAG && this.emailValv2.manualValidation && this.emailValv2.showBlueBannerMsg && /*#__PURE__*/React__default.createElement("div", {
      className: "regenqr-manual-validation-pre regenqr-blue-bg-box"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "regenqr-info-icon d-inline-block"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "d-inline-block",
      style: {
        width: "91%"
      }
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "font-weight-bold text-white"
    }, "Please have customer check their email"), /*#__PURE__*/React__default.createElement("br", null), "An email has been sent to ", this.state.email, /*#__PURE__*/React__default.createElement("br", null), "After customer validates the email address, click confirm below."), /*#__PURE__*/React__default.createElement("button", {
      className: "regenqr-confirm-button",
      onClick: this.emailValv2.confirmHandler
    }, "Confirm")))))))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("table", null, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      width: "350px"
    }, /*#__PURE__*/React__default.createElement("label", {
      className: "response-label",
      hidden: !this.state.info,
      "data-testid": "responseLabel"
    }, this.getDisplayMessage())), /*#__PURE__*/React__default.createElement("td", {
      width: this.state.email !== "" && this.state.onSubmit === true ? this.EMAIL_VALIDATION_FLAG ? "120px" : "700px" : "160px"
    }, /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(StyledButton$4, {
      disabled: this.state.onSubmit,
      size: "tiny",
      "data-testid": "regenSubmitButton",
      use: "primary",
      surface: isDark ? "dark" : "light",
      type: "submit",
      onClick: this.onSubmit,
      className: "regenSubmitButton"
    }, "Submit"))))))));
  };
  return RegenerateQRPopup;
}(Component);

var RemoveEidComponent = function RemoveEidComponent() {
  var _useState = useState(""),
    eid = _useState[0],
    setEid = _useState[1];
  var _useState2 = useState(false),
    eidError = _useState2[0],
    setEidError = _useState2[1];
  var _useState3 = useState(false),
    setEidSuccess = _useState3[1];
  var _useState4 = useState(""),
    eidErrorMessage = _useState4[0],
    setEidErrorMessage = _useState4[1];
  var removeEidHandler = function removeEidHandler() {
    clearErrors();
    if (eid.length < 32) {
      setEidErrorMessage("Entered EID is invalid");
      setEidError(true);
    } else {
      getMvaFreeTrial(eid);
    }
  };
  var clearErrors = function clearErrors() {
    setEidErrorMessage("");
    setEidError(false);
    setEidSuccess(false);
  };
  var clearEidHandler = function clearEidHandler() {
    setEidErrorMessage("");
    setEidSuccess("");
    setEidError(false);
    setEid("");
  };
  var eidOnChangeHandler = function eidOnChangeHandler(e) {
    setEid(e.target.value);
  };
  var keyPressHandler = function keyPressHandler(e) {
    var reg = /[^0-9]/;
    if (reg.test(e.key)) {
      e.preventDefault();
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "remove-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: ""
  }, eidError && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Notification, {
    disableAnimation: true,
    type: "error",
    title: eidErrorMessage,
    fullBleed: true,
    onCloseButtonClick: clearErrors
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: ""
  }, /*#__PURE__*/React__default.createElement(Input$1, {
    name: "Eid",
    type: "text",
    label: "Remove Eid",
    id: "removeEid",
    error: false,
    required: true,
    "data-testid": "removeEid",
    onKeyPress: keyPressHandler,
    onChange: eidOnChangeHandler,
    maxLength: 32,
    value: eid,
    disabled: false,
    "aria-label": "RemoveEID"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remove-btn-grp"
  }, /*#__PURE__*/React__default.createElement(ButtonGroup$1, {
    rowQuantity: {
      desktop: 2
    },
    data: [{
      children: "Delete EID",
      size: "small",
      use: "secondary",
      width: "100px",
      disabled: false,
      onClick: removeEidHandler
    }, {
      children: "Reset",
      size: "small",
      use: "secondary",
      width: "80px",
      disabled: false,
      onClick: clearEidHandler
    }],
    alignment: "left"
  })));
};

var _templateObject$1y, _templateObject2$1d, _templateObject3$Z, _templateObject4$W, _templateObject5$L;
var SimLinkWrapper = styled.div(_templateObject$1y || (_templateObject$1y = _taggedTemplateLiteralLoose(["\n    height: 58px;\n  display: flex;\n  width: 100%;\n  padding-left: 25px;\n  margin-bottom: 5px;\n  flex-direction:row;\n  gap:50px;\n"])));
var PinContainer = styled.div(_templateObject2$1d || (_templateObject2$1d = _taggedTemplateLiteralLoose(["\n   display: flex;\n  width: 48%;\n  flex-direction: column;\n  padding-left:15px;\n"])));
var StyledLink = styled(TextLink)(_templateObject3$Z || (_templateObject3$Z = _taggedTemplateLiteralLoose(["\n   border-bottom: none !important;\n  padding: 5px 0px 0px 0px;\n  font-size: 85% !important;\n  color: ", ";\n  place-self: unset !important;\n  :hover{\n  color: ", ";\n  }\n"])), function (props) {
  return props.isDark ? "#85beff" : "#00f";
}, function (props) {
  return props.isDark ? "#85beff" : "#00f";
});
var SimLinkRowWrapper = styled.div(_templateObject4$W || (_templateObject4$W = _taggedTemplateLiteralLoose(["\n  display:flex;\n   flex-direction:column;\n   gap:10px;\n"])));
var SearchButtonWrapper = styled.div(_templateObject5$L || (_templateObject5$L = _taggedTemplateLiteralLoose(["\n  margin-left:70px;\n"])));
function SimDetails(props) {
  var _deviceRef, _deviceSimRef, _deviceSimRef2, _simResponse$queryIcc, _simResponse$queryIcc2, _simResponse$queryIcc3, _simResponse$queryIcc4, _simResponse$queryIcc5, _simResponse$queryIcc6, _simResponse$queryIcc7, _simResponse$queryIcc8, _simResponse$queryIcc9, _simResponse$queryIcc0, _simResponse$queryIcc1, _simResponse$queryIcc10, _simResponse$queryIcc11, _simResponse$queryIcc12, _simResponse$queryIcc13, _UserProfile$permissi5, _UserProfile$permissi6, _props$params;
  var _useDeviceData = useDeviceData(props),
    deviceData = _useDeviceData.data;
  var _useProfileData = useProfileData(props),
    UserProfile = _useProfileData.data;
  var _useState = useState(false),
    regenGRPopup = _useState[0],
    setRegenGRPopup = _useState[1];
  var _useState2 = useState(false),
    eidRemoval = _useState2[0],
    setEidRemoval = _useState2[1];
  var _useState3 = useState(false),
    eSimPopup = _useState3[0],
    setESimPopup = _useState3[1];
  var _useState4 = useState(""),
    IccID = _useState4[0],
    setIccID = _useState4[1];
  var _useState5 = useState(false),
    deviceSimValidation = _useState5[0],
    setDeviceSimValidation = _useState5[1];
  var _useState6 = useState("4G SIM must be 20 positions numeric."),
    deviceValMsg = _useState6[0];
  var _useState7 = useState(""),
    devcSimId = _useState7[0],
    setDevcSimId = _useState7[1];
  var _useState8 = useState(""),
    devcIccId = _useState8[0],
    setDevcIccId = _useState8[1];
  var _useState9 = useState(false),
    isVerifySelfActivation = _useState9[0],
    setIsVerifySelfActivation = _useState9[1];
  var _useState0 = useState(""),
    rowMdn = _useState0[0];
  var _useState1 = useState(""),
    QuardedResponse = _useState1[0],
    setQuardedResponse = _useState1[1];
  var _useState10 = useState(""),
    simResponse = _useState10[0],
    setSimResponse = _useState10[1];
  var deviceSimRef = React__default.createRef();
  var deviceIdRef = React__default.createRef();
  var deviceRef = React__default.createRef();
  var retrievePin = function retrievePin() {
    var _window, _window$caseDetails;
    var _ref = props || {},
      _ref$params = _ref.params,
      _ref$params2 = _ref$params === void 0 ? {} : _ref$params,
      _ref$params2$mdn = _ref$params2.mdn,
      mdn = _ref$params2$mdn === void 0 ? '' : _ref$params2$mdn;
    var mtn = ((_window = window) === null || _window === void 0 ? void 0 : (_window$caseDetails = _window.caseDetails) === null || _window$caseDetails === void 0 ? void 0 : _window$caseDetails.mtn) || mdn;
    var payload = {
      accountNo: IccID,
      msisdn: rowMdn && rowMdn.length > 0 ? "1" + rowMdn : "1" + mtn,
      requestName: IccID
    };
    getGuardedLinkPinPukService(payload).then(function (data) {
      var _data$response, _data$response$data, _data$response$data$d;
      console.log(data);
      setQuardedResponse(data === null || data === void 0 ? void 0 : (_data$response = data.response) === null || _data$response === void 0 ? void 0 : (_data$response$data = _data$response.data) === null || _data$response$data === void 0 ? void 0 : (_data$response$data$d = _data$response$data.data) === null || _data$response$data$d === void 0 ? void 0 : _data$response$data$d.Response);
    });
  };
  var handleIccicLink = function handleIccicLink() {
    var _UserProfile$permissi, _UserProfile$permissi2;
    var deviceUrl = (UserProfile === null || UserProfile === void 0 ? void 0 : (_UserProfile$permissi = UserProfile.permission) === null || _UserProfile$permissi === void 0 ? void 0 : (_UserProfile$permissi2 = _UserProfile$permissi.sessionPermission) === null || _UserProfile$permissi2 === void 0 ? void 0 : _UserProfile$permissi2.ACSS_DEVICEMGTURL) || "";
    if (!IsNullOrEmpty(deviceUrl)) {
      var address = deviceUrl + "deviceId=" + devcIccId + "&app_type=ACSS&uswin";
      window.open(address, "", "height=800,width=510,resizable=yes,scrollbars=yes");
    }
  };
  var getSimLink = function getSimLink() {
    var _UserProfile$permissi3, _UserProfile$permissi4;
    var deviceSimUpdateEnable = (UserProfile === null || UserProfile === void 0 ? void 0 : (_UserProfile$permissi3 = UserProfile.permission) === null || _UserProfile$permissi3 === void 0 ? void 0 : (_UserProfile$permissi4 = _UserProfile$permissi3.SRDeptPermission) === null || _UserProfile$permissi4 === void 0 ? void 0 : _UserProfile$permissi4.DEVICE_DETAIL_SIM_UPDATE_ENABLED) === "Y" ? "Y" : "";
    if (deviceSimUpdateEnable === "Y") {
      return true;
    } else {
      return false;
    }
  };
  useEffect(function () {
    var _window2, _window2$caseDetails, _deviceData, _deviceData$response, _deviceData$response$, _deviceData$response$2, _deviceData2, _selectedMTNData, _selectedMTNData$devi, _selectedMTNData$devi2, _getSimStatus;
    setIsVerifySelfActivation(false);
    deviceSimRef.focus();
    deviceIdRef.focus();
    deviceRef.focus();
    var selectedMTNData;
    var _ref2 = props || {},
      _ref2$params = _ref2.params,
      _ref2$params2 = _ref2$params === void 0 ? {} : _ref2$params,
      _ref2$params2$mdn = _ref2$params2.mdn,
      mdn = _ref2$params2$mdn === void 0 ? '' : _ref2$params2$mdn;
    var selectedMTN = ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$caseDetails = _window2.caseDetails) === null || _window2$caseDetails === void 0 ? void 0 : _window2$caseDetails.mtn) || mdn;
    deviceData = (_deviceData = deviceData) === null || _deviceData === void 0 ? void 0 : (_deviceData$response = _deviceData.response) === null || _deviceData$response === void 0 ? void 0 : (_deviceData$response$ = _deviceData$response.data) === null || _deviceData$response$ === void 0 ? void 0 : (_deviceData$response$2 = _deviceData$response$.body) === null || _deviceData$response$2 === void 0 ? void 0 : _deviceData$response$2.data;
    if ((_deviceData2 = deviceData) !== null && _deviceData2 !== void 0 && _deviceData2.customerInsight) {
      var _deviceData3, _deviceData3$customer, _deviceData3$customer2, _deviceData3$customer3;
      var mtns = (_deviceData3 = deviceData) === null || _deviceData3 === void 0 ? void 0 : (_deviceData3$customer = _deviceData3.customerInsight) === null || _deviceData3$customer === void 0 ? void 0 : (_deviceData3$customer2 = _deviceData3$customer.billAccounts) === null || _deviceData3$customer2 === void 0 ? void 0 : (_deviceData3$customer3 = _deviceData3$customer2[0]) === null || _deviceData3$customer3 === void 0 ? void 0 : _deviceData3$customer3.mtns;
      selectedMTNData = mtns ? mtns.find(function (e) {
        return e.mtn === selectedMTN;
      }) : {};
    }
    var mdnEqLaunch = (_selectedMTNData = selectedMTNData) === null || _selectedMTNData === void 0 ? void 0 : (_selectedMTNData$devi = _selectedMTNData.deviceInfo) === null || _selectedMTNData$devi === void 0 ? void 0 : (_selectedMTNData$devi2 = _selectedMTNData$devi[0]) === null || _selectedMTNData$devi2 === void 0 ? void 0 : _selectedMTNData$devi2.simId;
    if (mdnEqLaunch !== null && mdnEqLaunch !== "" && mdnEqLaunch !== undefined) {
      setDevcIccId(mdnEqLaunch);
      setDevcSimId(mdnEqLaunch);
      setIccID(mdnEqLaunch);
    }
    var request = {
      iccId: mdnEqLaunch != null ? mdnEqLaunch : "",
      applicationId: "VZW-ACSS",
      deviceId: "",
      appId: "ACSS",
      simId: mdnEqLaunch != null ? mdnEqLaunch : ""
    };
    (_getSimStatus = getSimStatus(request)) === null || _getSimStatus === void 0 ? void 0 : _getSimStatus.then(function (data) {
      var _data$response2, _data$response2$data, _data$response2$data$;
      setSimResponse(data === null || data === void 0 ? void 0 : (_data$response2 = data.response) === null || _data$response2 === void 0 ? void 0 : (_data$response2$data = _data$response2.data) === null || _data$response2$data === void 0 ? void 0 : (_data$response2$data$ = _data$response2$data.data) === null || _data$response2$data$ === void 0 ? void 0 : _data$response2$data$.Response);
    });
  }, []);
  var deviceSimSearch = function deviceSimSearch() {
    if (devcSimId.length < 20) {
      setDeviceSimValidation(true);
    } else {
      var caseReq = {
        iccId: devcSimId,
        applicationId: "VZW-ACSS",
        deviceId: "",
        appId: "ACSS",
        simId: devcSimId
      };
      getSimStatus(caseReq).then(function (data) {
        var _data$response3, _data$response3$data, _data$response3$data$;
        setSimResponse(data === null || data === void 0 ? void 0 : (_data$response3 = data.response) === null || _data$response3 === void 0 ? void 0 : (_data$response3$data = _data$response3.data) === null || _data$response3$data === void 0 ? void 0 : (_data$response3$data$ = _data$response3$data.data) === null || _data$response3$data$ === void 0 ? void 0 : _data$response3$data$.Response);
      });
      setDevcIccId(devcSimId);
    }
  };
  var handleSimId = function handleSimId(event) {
    var deviceSimValue = event.target.value;
    var deviceSimVal = deviceSimValue.replace(/-/g, "");
    deviceSimVal = deviceSimVal.replace(/[^0-9]/g, "");
    if (deviceSimVal.length > 20) {
      deviceSimVal = deviceSimVal.substring(0, 20);
    }
    setDevcSimId(deviceSimVal);
  };
  var deviceAlertModalClose = function deviceAlertModalClose() {
    setDeviceSimValidation(false);
  };
  var simCapable;
  var querySimCapable = simResponse !== null && simResponse !== void 0 && simResponse.simCapable ? simResponse === null || simResponse === void 0 ? void 0 : simResponse.simCapable : "";
  if (querySimCapable !== null && querySimCapable !== undefined && querySimCapable.toUpperCase() === "DUAL_IMSI") {
    simCapable = "Vodafone";
  } else if (querySimCapable !== null && querySimCapable !== undefined && querySimCapable.toUpperCase() === "CLOUD") {
    simCapable = "GTI-Cloudsim Applet";
  } else if (querySimCapable !== null && querySimCapable !== undefined && querySimCapable.toUpperCase() === "VZW" || querySimCapable.toUpperCase() === "VZW3G") {
    simCapable = "3G Global Phone";
  } else {
    simCapable = "";
  }
  var isDark = props.isDark;
  return /*#__PURE__*/React__default.createElement("div", {
    id: "deviceSimDetails",
    className: isDark ? "simDark" : "simDefault",
    "aria-label": "VZWSimDetails",
    tabIndex: 0,
    ref: function ref(_ref6) {
      return deviceRef = _ref6;
    },
    "aria-focused": ((_deviceRef = deviceRef) === null || _deviceRef === void 0 ? void 0 : _deviceRef.current) === document.activeElement
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row deviceSimHead"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col-2 d-flex mt-1"
  }, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "vzwsim",
    className: "device-select2",
    "aria-live": "polite",
    "aria-atomic": "true"
  }, "VZW SIM")), /*#__PURE__*/React__default.createElement("div", {
    className: "col-5 d-flex"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "deviceSimInput1"
  }, /*#__PURE__*/React__default.createElement("input", {
    id: "vzwsim",
    type: "text",
    "data-testid": "DevicId",
    tabIndex: 2,
    className: "device-sim-input2",
    ref: function ref(_ref3) {
      return deviceIdRef = _ref3;
    },
    value: devcSimId,
    "aria-label": devcSimId,
    onChange: handleSimId,
    name: "orderlocation"
  })), /*#__PURE__*/React__default.createElement(SearchButtonWrapper, null, /*#__PURE__*/React__default.createElement(StyledButton$4, {
    className: "device-btn",
    "data-testid": "deviceSearchButtonSIM",
    ariaLabel: "Search",
    onClick: function onClick() {
      return deviceSimSearch();
    },
    size: "small",
    surface: props.isDark ? 'dark' : 'light'
  }, "Search")))), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col-3 d-flex"
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "device-select",
    "aria-live": "polite",
    "aria-atomic": "true",
    "aria-label": "SIMTYPE"
  }, "SIMTYPE")), /*#__PURE__*/React__default.createElement("div", {
    className: "col-1 d-flex"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "col-8 d-flex"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "device-order-span"
  }, simResponse !== null && simResponse !== void 0 && simResponse.simType ? simResponse === null || simResponse === void 0 ? void 0 : simResponse.simType : "")), /*#__PURE__*/React__default.createElement("div", {
    className: "col-3 d-flex"
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "device-select",
    htmlFor: "iccid",
    "aria-live": "polite",
    "aria-atomic": "true"
  }, "ICCID")), /*#__PURE__*/React__default.createElement("div", {
    className: "col-1 d-flex"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "col-8 d-flex"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "dot-textlink",
    id: "iccid",
    ref: function ref(_ref5) {
      return deviceSimRef = _ref5;
    },
    "aria-focused": ((_deviceSimRef = deviceSimRef) === null || _deviceSimRef === void 0 ? void 0 : _deviceSimRef.current) === document.activeElement,
    "aria-label": IccID
  }, getSimLink() ? /*#__PURE__*/React__default.createElement(TextLink, {
    type: "standAlone",
    size: "small",
    className: isDark ? "deviceDark" : "deviceOrderLight",
    onClick: handleIccicLink
  }, !IsNullOrEmpty(devcIccId) ? devcIccId && devcIccId.replace(/(\d{5})(\d{5})(\d{5})(\d{5})/, "$1-$2-$3-$4") : "") : /*#__PURE__*/React__default.createElement("span", {
    className: "device-order-span",
    id: "iccid",
    ref: function ref(_ref4) {
      return deviceSimRef = _ref4;
    },
    "aria-focused": ((_deviceSimRef2 = deviceSimRef) === null || _deviceSimRef2 === void 0 ? void 0 : _deviceSimRef2.current) === document.activeElement,
    "aria-label": devcIccId
  }, !IsNullOrEmpty(devcIccId) ? devcIccId && devcIccId.replace(/(\d{5})(\d{5})(\d{5})(\d{5})/, "$1-$2-$3-$4") : "")), " "), /*#__PURE__*/React__default.createElement("div", {
    className: "col-3 d-flex"
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "device-select",
    "aria-live": "polite",
    "aria-atomic": "true",
    "aria-label": "VZW IMSI"
  }, "VZW IMSI")), /*#__PURE__*/React__default.createElement("div", {
    className: "col-1 d-flex"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "col-8 d-flex"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "device-order-span"
  }, simResponse !== null && simResponse !== void 0 && (_simResponse$queryIcc = simResponse.queryIccidResponse) !== null && _simResponse$queryIcc !== void 0 && _simResponse$queryIcc.vzwImsi ? simResponse === null || simResponse === void 0 ? void 0 : (_simResponse$queryIcc2 = simResponse.queryIccidResponse) === null || _simResponse$queryIcc2 === void 0 ? void 0 : _simResponse$queryIcc2.vzwImsi : "")), /*#__PURE__*/React__default.createElement("div", {
    className: "col-3 d-flex"
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "device-select",
    "aria-live": "polite",
    "aria-atomic": "true",
    "aria-label": "IMSI 2"
  }, "IMSI 2")), /*#__PURE__*/React__default.createElement("div", {
    className: "col-1 d-flex"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "col-8 d-flex"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "device-order-span"
  }, simResponse !== null && simResponse !== void 0 && (_simResponse$queryIcc3 = simResponse.queryIccidResponse) !== null && _simResponse$queryIcc3 !== void 0 && _simResponse$queryIcc3.vfImsi ? simResponse === null || simResponse === void 0 ? void 0 : (_simResponse$queryIcc4 = simResponse.queryIccidResponse) === null || _simResponse$queryIcc4 === void 0 ? void 0 : _simResponse$queryIcc4.vfImsi : "")), /*#__PURE__*/React__default.createElement("div", {
    className: "col-3 d-flex"
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "device-select",
    "aria-live": "polite",
    "aria-atomic": "true",
    "aria-label": "SIM Capability"
  }, "SIM Capability")), /*#__PURE__*/React__default.createElement("div", {
    className: "col-1 d-flex"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "col-8 d-flex"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "device-order-span",
    "aria-live": "polite",
    "aria-atomic": "true",
    "aria-label": "GTI-Cloudsim Applet"
  }, simCapable)), /*#__PURE__*/React__default.createElement("div", {
    className: "col-3 d-flex"
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "device-select",
    "aria-live": "polite",
    "aria-atomic": "true",
    "aria-label": "EUIMID"
  }, "EUIMID")), /*#__PURE__*/React__default.createElement("div", {
    className: "col-1 d-flex"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "col-8 d-flex"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "device-order-span"
  }, simResponse !== null && simResponse !== void 0 && (_simResponse$queryIcc5 = simResponse.queryIccidResponse) !== null && _simResponse$queryIcc5 !== void 0 && _simResponse$queryIcc5.euImid ? simResponse === null || simResponse === void 0 ? void 0 : (_simResponse$queryIcc6 = simResponse.queryIccidResponse) === null || _simResponse$queryIcc6 === void 0 ? void 0 : _simResponse$queryIcc6.euImid : "")), /*#__PURE__*/React__default.createElement("div", {
    className: "col-3 d-flex"
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "device-select",
    "aria-live": "polite",
    "aria-atomic": "true",
    "aria-label": "Mobile Number"
  }, "Mobile Number")), /*#__PURE__*/React__default.createElement("div", {
    className: "col-1 d-flex"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "col-8 d-flex"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "device-order-span"
  }, !IsNullOrEmpty(simResponse === null || simResponse === void 0 ? void 0 : (_simResponse$queryIcc7 = simResponse.queryIccidResponse) === null || _simResponse$queryIcc7 === void 0 ? void 0 : _simResponse$queryIcc7.mdn) ? simResponse === null || simResponse === void 0 ? void 0 : (_simResponse$queryIcc8 = simResponse.queryIccidResponse) === null || _simResponse$queryIcc8 === void 0 ? void 0 : (_simResponse$queryIcc9 = _simResponse$queryIcc8.mdn) === null || _simResponse$queryIcc9 === void 0 ? void 0 : _simResponse$queryIcc9.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3") : rowMdn.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3"))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-3 d-flex"
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "device-select",
    "aria-live": "polite",
    "aria-atomic": "true",
    "aria-label": "Sim Status"
  }, "SIM Status")), /*#__PURE__*/React__default.createElement("div", {
    className: "col-1 d-flex"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "col-8 d-flex"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "device-order-span"
  }, simResponse !== null && simResponse !== void 0 && (_simResponse$queryIcc0 = simResponse.queryIccidResponse) !== null && _simResponse$queryIcc0 !== void 0 && _simResponse$queryIcc0.iccIdStat ? simResponse === null || simResponse === void 0 ? void 0 : (_simResponse$queryIcc1 = simResponse.queryIccidResponse) === null || _simResponse$queryIcc1 === void 0 ? void 0 : _simResponse$queryIcc1.iccIdStat : "")), /*#__PURE__*/React__default.createElement("div", {
    className: "col-3 d-flex"
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "device-select",
    "aria-live": "polite",
    "aria-atomic": "true",
    "aria-label": "Grandfathered"
  }, "Grandfathered")), /*#__PURE__*/React__default.createElement("div", {
    className: "col-1 d-flex"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "col-8 d-flex"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "device-order-span"
  }, simResponse !== null && simResponse !== void 0 && (_simResponse$queryIcc10 = simResponse.queryIccidResponse) !== null && _simResponse$queryIcc10 !== void 0 && _simResponse$queryIcc10.grandFatheredIndicator ? simResponse === null || simResponse === void 0 ? void 0 : (_simResponse$queryIcc11 = simResponse.queryIccidResponse) === null || _simResponse$queryIcc11 === void 0 ? void 0 : _simResponse$queryIcc11.grandFatheredIndicator : "")), /*#__PURE__*/React__default.createElement("div", {
    className: "col-3 d-flex"
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "device-select",
    "aria-live": "polite",
    "aria-atomic": "true",
    "aria-label": "Profile Type"
  }, "Profile Type")), /*#__PURE__*/React__default.createElement("div", {
    className: "col-1 d-flex"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "col-8 d-flex"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "device-order-span"
  }, simResponse !== null && simResponse !== void 0 && (_simResponse$queryIcc12 = simResponse.queryIccidResponse) !== null && _simResponse$queryIcc12 !== void 0 && _simResponse$queryIcc12.simProfile ? simResponse === null || simResponse === void 0 ? void 0 : (_simResponse$queryIcc13 = simResponse.queryIccidResponse) === null || _simResponse$queryIcc13 === void 0 ? void 0 : _simResponse$queryIcc13.simProfile : "")), !isVerifySelfActivation && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(SimLinkWrapper, null, /*#__PURE__*/React__default.createElement(SimLinkRowWrapper, null, /*#__PURE__*/React__default.createElement(StyledLink, {
    type: "standAlone",
    size: "small",
    disabled: !simResponse,
    "data-testid": "retrievePin",
    isDark: isDark,
    onClick: function onClick() {
      return retrievePin();
    },
    "aria-label": "RetrievePINPUK"
  }, "RetrievePIN/PUK"), (UserProfile === null || UserProfile === void 0 ? void 0 : (_UserProfile$permissi5 = UserProfile.permission) === null || _UserProfile$permissi5 === void 0 ? void 0 : (_UserProfile$permissi6 = _UserProfile$permissi5.NEXT_GEN) === null || _UserProfile$permissi6 === void 0 ? void 0 : _UserProfile$permissi6.EID_BLOCK_REMOVAL) === "Y" && /*#__PURE__*/React__default.createElement(StyledLink, {
    type: "standAlone",
    size: "small",
    "data-testid": "EidRemoval",
    isDark: isDark,
    onClick: function onClick() {
      return setEidRemoval(true);
    },
    "aria-label": "Regenerate QR Code"
  }, "Remove free trial EID")), /*#__PURE__*/React__default.createElement(SimLinkRowWrapper, null, /*#__PURE__*/React__default.createElement(StyledLink, {
    type: "standAlone",
    size: "small",
    "data-testid": "eSimDetails",
    isDark: isDark,
    onClick: function onClick() {
      return setESimPopup(true);
    },
    "aria-label": "ESim Details"
  }, "ESim Details"), /*#__PURE__*/React__default.createElement(StyledLink, {
    type: "standAlone",
    size: "small",
    "data-testid": "regenerateQRCode",
    isDark: isDark,
    onClick: function onClick() {
      return setRegenGRPopup(true);
    },
    "aria-label": "Regenerate QR Code",
    disabled: props === null || props === void 0 ? void 0 : (_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.isTrainingMode
  }, "Regenerate QrCode"))), /*#__PURE__*/React__default.createElement(PinContainer, null, /*#__PURE__*/React__default.createElement("div", {
    className: "pin-wrapper"
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "device-select",
    "aria-live": "polite",
    "aria-atomic": "true",
    "aria-label": "PIN1"
  }, "PIN1"), /*#__PURE__*/React__default.createElement("span", {
    className: "device-order-span",
    style: {
      "font-weight": "bold"
    }
  }, QuardedResponse && QuardedResponse.pin1)), /*#__PURE__*/React__default.createElement("div", {
    className: "pin-wrapper"
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "device-select",
    "aria-live": "polite",
    "aria-atomic": "true",
    "aria-label": "PUK1"
  }, "PUK1"), /*#__PURE__*/React__default.createElement("span", {
    className: "device-order-span",
    style: {
      "font-weight": "bold"
    }
  }, QuardedResponse && QuardedResponse.puk1)), /*#__PURE__*/React__default.createElement("div", {
    className: "pin-wrapper"
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "device-select",
    "aria-live": "polite",
    "aria-atomic": "true",
    "aria-label": "PIN2"
  }, "PIN2"), /*#__PURE__*/React__default.createElement("span", {
    className: "device-order-span",
    style: {
      "font-weight": "bold"
    }
  }, QuardedResponse && QuardedResponse.pin2)), /*#__PURE__*/React__default.createElement("div", {
    className: "pin-wrapper"
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "device-select",
    "aria-live": "polite",
    "aria-atomic": "true",
    "aria-label": "PUK2"
  }, "PUK2"), /*#__PURE__*/React__default.createElement("span", {
    className: "device-order-span",
    style: {
      "font-weight": "bold"
    }
  }, QuardedResponse && QuardedResponse.puk2))))), regenGRPopup && /*#__PURE__*/React__default.createElement(Launchout, {
    handleClose: function handleClose() {
      return setRegenGRPopup(false);
    },
    modalTitle: "Regenerate QR Code",
    height: "200px",
    width: "430px",
    isDark: isDark
  }, /*#__PURE__*/React__default.createElement(RegenerateQRPopup, props)), eidRemoval && /*#__PURE__*/React__default.createElement(Launchout, {
    handleClose: function handleClose() {
      return setEidRemoval(false);
    },
    modalTitle: "Remove free trial EID",
    height: "350px",
    width: "700px",
    isDark: isDark
  }, /*#__PURE__*/React__default.createElement(RemoveEidComponent, props)), eSimPopup && /*#__PURE__*/React__default.createElement(Launchout, {
    handleClose: function handleClose() {
      return setESimPopup(false);
    },
    modalTitle: "ESIMDetails",
    height: "350px",
    width: "450px",
    isDark: isDark
  }, /*#__PURE__*/React__default.createElement(EsimDetails, _extends({}, props, {
    isDark: isDark
  }))), deviceSimValidation && /*#__PURE__*/React__default.createElement(Notification, {
    disableAnimation: true,
    onCloseButtonClick: deviceAlertModalClose,
    hideCloseButton: false,
    type: "error",
    notificationStyles: {
      height: "auto;"
    },
    children: deviceValMsg,
    "data-testid": "notification"
  }));
}

function DeviceDetails(props) {
  var _myObj$mtns, _myObj$mtns$, _window, _window$config, _window2, _window2$caseDetails, _selectedMTNData4, _selectedMTNData4$dev, _selectedMTNData4$dev2, _selectedMTNData4$dev3, _ref5, _selectedMTNData5, _selectedMTNData5$bas, _selectedMTNData5$bas2, _selectedMTNData5$bas3, _selectedMTNData5$bas4, _selectedMTNData6, _selectedMTNData6$bas, _selectedMTNData6$bas2, _selectedMTNData6$bas3, _selectedMTNData6$bas4, _selectedMTNData7, _selectedMTNData8, _selectedMTNData$devi3, _selectedMTNData9, _selectedMTNData9$dev, _selectedMTNData9$dev2, _selectedMTNData$devi4, _selectedMTNData0, _selectedMTNData0$dev, _selectedMTNData0$dev2, _selectedMTNData$devi5, _selectedMTNData1, _selectedMTNData1$dev, _selectedMTNData1$dev2, _selectedMTNData1$dev3, _selectedMTNData1$dev4, _selectedMTNData1$dev5, _selectedMTNData$devi6, _selectedMTNData10, _selectedMTNData10$de, _selectedMTNData10$de2, _selectedMTNData$devi7, _selectedMTNData11, _selectedMTNData11$de, _selectedMTNData11$de2, _selectedMTNData$devi8, _selectedMTNData12, _selectedMTNData12$de, _selectedMTNData12$de2, _selectedMTNData$devi9, _selectedMTNData13, _selectedMTNData13$de, _selectedMTNData13$de2, _selectedMTNData13$de3, _selectedMTNData13$de4, _getAvailableSoftware, _selectedMTNData14, _selectedMTNData14$de, _selectedMTNData14$de2, _selectedMTNData14$de3, _selectedMTNData14$de4, _networkData$device$a, _networkData$device, _networkData$device$a2, _networkData$device$a3, _networkData$device$a4, _networkData$device$a5, _networkData$device$a6, _networkData$device$a7, _selectedMTNData19, _selectedMTNData19$de, _selectedMTNData19$de2, _selectedMTNData19$de3, _selectedMTNData20, _selectedMTNData20$de, _selectedMTNData20$de2, _selectedMTNData20$de3, _selectedMTNData22, _selectedMTNData22$de, _selectedMTNData22$de2;
  console.log("deviceSku******", props.deviceSku);
  var _useDeviceData = useDeviceData(props),
    deviceResponse = _useDeviceData.data;
  var _useNetworkData = useNetworkData(props),
    networkResponse = _useNetworkData.data;
  var _useProfileData = useProfileData(props),
    userProfile = _useProfileData.data;
  var _useState = useState({}),
    deviceData = _useState[0],
    setdeviceData = _useState[1];
  var _useState2 = useState({}),
    networkData = _useState2[0],
    setNetworkData = _useState2[1];
  var _useState3 = useState(false),
    simOpen = _useState3[0],
    setSimOpen = _useState3[1];
  var _ref = useFeatureFlag() || {},
    _ref$data = _ref.data,
    _ref$data2 = _ref$data === void 0 ? {} : _ref$data,
    _ref$data2$prepayAddF = _ref$data2.prepayAddFixFFlag,
    prepayAddFixFFlag = _ref$data2$prepayAddF === void 0 ? false : _ref$data2$prepayAddF;
  var _props$customerInfo = props.customerInfo,
    customerInfo = _props$customerInfo === void 0 ? {} : _props$customerInfo;
  var simTypeValue = "";
  var mvoConfig = sessionStorage.getItem("mvoConfig");
  var myObj = JSON.parse(mvoConfig);
  var simSkuType = (myObj === null || myObj === void 0 ? void 0 : (_myObj$mtns = myObj.mtns) === null || _myObj$mtns === void 0 ? void 0 : (_myObj$mtns$ = _myObj$mtns[0]) === null || _myObj$mtns$ === void 0 ? void 0 : _myObj$mtns$.simSkuType) || "";
  if (simSkuType) {
    if (simSkuType == "S") {
      simTypeValue = "e";
    } else if (simSkuType == "T") {
      simTypeValue = "p";
    }
  }
  var customerInquirySearchMtn = customerInfo && customerInfo.billAccounts && customerInfo.billAccounts[0] && customerInfo.billAccounts[0].customerInquirySearchMtnDetail;
  if (customerInquirySearchMtn && customerInquirySearchMtn.basicPhoneInfo && customerInquirySearchMtn.basicPhoneInfo.simSkuType) {
    if (customerInquirySearchMtn.basicPhoneInfo.simSkuType == 'S') {
      simTypeValue = 'e';
    } else if (customerInquirySearchMtn.basicPhoneInfo.simSkuType == 'T') {
      simTypeValue = 'p';
    }
  }
  useEffect(function () {
    var _deviceResponse$respo, _deviceResponse$respo2, _deviceResponse$respo3, _networkResponse$resp, _networkResponse$resp2, _networkResponse$resp3;
    setdeviceData(deviceResponse === null || deviceResponse === void 0 ? void 0 : (_deviceResponse$respo = deviceResponse.response) === null || _deviceResponse$respo === void 0 ? void 0 : (_deviceResponse$respo2 = _deviceResponse$respo.data) === null || _deviceResponse$respo2 === void 0 ? void 0 : (_deviceResponse$respo3 = _deviceResponse$respo2.body) === null || _deviceResponse$respo3 === void 0 ? void 0 : _deviceResponse$respo3.data);
    setNetworkData(networkResponse === null || networkResponse === void 0 ? void 0 : (_networkResponse$resp = networkResponse.response) === null || _networkResponse$resp === void 0 ? void 0 : (_networkResponse$resp2 = _networkResponse$resp.data) === null || _networkResponse$resp2 === void 0 ? void 0 : (_networkResponse$resp3 = _networkResponse$resp2.body) === null || _networkResponse$resp3 === void 0 ? void 0 : _networkResponse$resp3.data);
  }, [deviceResponse, networkResponse]);
  var handleSimClick = function handleSimClick() {
    if (windowRetailIframe) return;
    setSimOpen(true);
  };
  var dispatchUsageMetrics = function dispatchUsageMetrics(eventId, actionId, notes) {
    if (eventId === void 0) {
      eventId = "";
    }
    if (actionId === void 0) {
      actionId = "";
    }
    if (notes === void 0) {
      notes = "";
    }
    var metrics = [{
      eventID: eventId,
      actionID: actionId,
      notes: notes
    }];
    var _ref2 = props || {},
      logUsageMetrics = _ref2.logUsageMetrics;
    if (logUsageMetrics) {
      logUsageMetrics({
        metrics: metrics
      });
    }
  };
  var windowRetailIframe = (_window = window) === null || _window === void 0 ? void 0 : (_window$config = _window.config) === null || _window$config === void 0 ? void 0 : _window$config.retailIframe;
  var _ref3 = props || {},
    _ref3$params = _ref3.params,
    _ref3$params2 = _ref3$params === void 0 ? {} : _ref3$params,
    _ref3$params2$mdn = _ref3$params2.mdn,
    mdn = _ref3$params2$mdn === void 0 ? '' : _ref3$params2$mdn;
  var selectedMTN = ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$caseDetails = _window2.caseDetails) === null || _window2$caseDetails === void 0 ? void 0 : _window2$caseDetails.mtn) || mdn;
  var selectedMTNData;
  if (deviceData) {
    var _deviceData$customerI, _deviceData$customerI2, _deviceData$customerI3;
    var mtns = deviceData === null || deviceData === void 0 ? void 0 : (_deviceData$customerI = deviceData.customerInsight) === null || _deviceData$customerI === void 0 ? void 0 : (_deviceData$customerI2 = _deviceData$customerI.billAccounts) === null || _deviceData$customerI2 === void 0 ? void 0 : (_deviceData$customerI3 = _deviceData$customerI2[0]) === null || _deviceData$customerI3 === void 0 ? void 0 : _deviceData$customerI3.mtns;
    selectedMTNData = mtns ? mtns.find(function (e) {
      return e.mtn === selectedMTN;
    }) : {};
  }
  if (!simTypeValue) {
    var _selectedMTNData, _selectedMTNData$devi, _selectedMTNData$devi2, _selectedMTNData2, _selectedMTNData2$dev, _selectedMTNData2$dev2;
    if (((_selectedMTNData = selectedMTNData) === null || _selectedMTNData === void 0 ? void 0 : (_selectedMTNData$devi = _selectedMTNData.deviceInfo) === null || _selectedMTNData$devi === void 0 ? void 0 : (_selectedMTNData$devi2 = _selectedMTNData$devi[0]) === null || _selectedMTNData$devi2 === void 0 ? void 0 : _selectedMTNData$devi2.simSkuType) == 'S') {
      simTypeValue = 'e';
    } else if (((_selectedMTNData2 = selectedMTNData) === null || _selectedMTNData2 === void 0 ? void 0 : (_selectedMTNData2$dev = _selectedMTNData2.deviceInfo) === null || _selectedMTNData2$dev === void 0 ? void 0 : (_selectedMTNData2$dev2 = _selectedMTNData2$dev[0]) === null || _selectedMTNData2$dev2 === void 0 ? void 0 : _selectedMTNData2$dev2.simSkuType) == 'T') {
      simTypeValue = 'p';
    }
  }
  var getAvailableSoftwareVersion = function getAvailableSoftwareVersion(str) {
    if (str === void 0) {
      str = "";
    }
    var returnStr = "";
    try {
      var decodedURIString = decodeURI(str);
      var formatHtmlString = decodedURIString.replaceAll("%2f", "/");
      returnStr = _parseAvailableSoftwareVersion(formatHtmlString);
    } catch (error) {
      console.log("Error while parsing :: getAvailableSoftwareVersion() :: " + error);
    }
    return returnStr != null ? returnStr : "-";
  };
  var _parseAvailableSoftwareVersion = function parseAvailableSoftwareVersion(x) {
    if (x === void 0) {
      x = "";
    }
    if (x.indexOf(">") !== -1 && x.lastIndexOf("</") !== -1 && x.indexOf(">") < x.lastIndexOf("</")) {
      var x1 = x.substring(x.indexOf(">") + 1, x.lastIndexOf("</"));
      return _parseAvailableSoftwareVersion(x1);
    }
    return x;
  };
  var deviceImageClick = function deviceImageClick() {
    var _selectedMTNData3, _selectedMTNData3$dev, _selectedMTNData3$dev2, _selectedMTNData3$dev3, _selectedMTNData3$dev4, _userProfile$permissi, _userProfile$permissi2;
    dispatchUsageMetrics('1D_DEVICE_OVERVIEW_NSA', 'DEVICE_PHOTO_LINK');
    var equipmentInfo = {};
    var eqipid = (_selectedMTNData3 = selectedMTNData) === null || _selectedMTNData3 === void 0 ? void 0 : (_selectedMTNData3$dev = _selectedMTNData3.deviceInfo) === null || _selectedMTNData3$dev === void 0 ? void 0 : (_selectedMTNData3$dev2 = _selectedMTNData3$dev[0]) === null || _selectedMTNData3$dev2 === void 0 ? void 0 : (_selectedMTNData3$dev3 = _selectedMTNData3$dev2.equipGuideData) === null || _selectedMTNData3$dev3 === void 0 ? void 0 : (_selectedMTNData3$dev4 = _selectedMTNData3$dev3.deviceModel) === null || _selectedMTNData3$dev4 === void 0 ? void 0 : _selectedMTNData3$dev4.equipID;
    equipmentInfo.eguideURL = userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$permissi = userProfile.permission) === null || _userProfile$permissi === void 0 ? void 0 : (_userProfile$permissi2 = _userProfile$permissi.sessionPermission) === null || _userProfile$permissi2 === void 0 ? void 0 : _userProfile$permissi2.ACSS_INFOMANAGER_EQUIPMENT_GUIDE;
    equipmentInfo.ID = eqipid;
    if (eqipid !== "") {
      popupWindow(equipmentInfo.eguideURL + equipmentInfo.ID + ".html", equipmentInfo.Name, 800, 510);
    } else {
      equipmentInfo.ID = null;
      popupWindow(equipmentInfo.eguideURL + equipmentInfo.ID + ".html", equipmentInfo.Name, 800, 510);
    }
  };
  var getEmulator = function getEmulator() {
    var _decodeURIComponent;
    var data = {
      deviceSku: (_decodeURIComponent = decodeURIComponent(props.deviceSku)) != null ? _decodeURIComponent : ""
    };
    getModelService(data).then(function (data) {
      var _data$response, _data$response$data, _data$response$data$b, _data$response$data$b2;
      var emulatorUrl = data === null || data === void 0 ? void 0 : (_data$response = data.response) === null || _data$response === void 0 ? void 0 : (_data$response$data = _data$response.data) === null || _data$response$data === void 0 ? void 0 : (_data$response$data$b = _data$response$data.body) === null || _data$response$data$b === void 0 ? void 0 : (_data$response$data$b2 = _data$response$data$b.data) === null || _data$response$data$b2 === void 0 ? void 0 : _data$response$data$b2.emulator;
      console.log(emulatorUrl, "=======isIpad()=======", isIpad());
      if (emulatorUrl) {
        if (isIpad()) {
          ipadShell(emulatorUrl);
        } else {
          popupWindow(emulatorUrl, "", 700, 500);
        }
      } else {
        deviceImageClick();
      }
    });
  };
  var getLaunchDateYears = function getLaunchDateYears(osLaunchDate) {
    if (osLaunchDate === void 0) {
      osLaunchDate = "";
    }
    var _YEARS = "";
    if (prepayAddFixFFlag && osLaunchDate && osLaunchDate.length > 0 && osLaunchDate === 'Not Available') {
      _YEARS = osLaunchDate;
    } else if (osLaunchDate && osLaunchDate.length > 0) {
      try {
        var _launchDate = new Date(osLaunchDate);
        var today = new Date();
        var _ref4 = [today.getMonth() + 1, today.getDate(), today.getFullYear()],
          month = _ref4[0],
          day = _ref4[1],
          year = _ref4[2];
        var activeDate = new Date(month + "/" + day + "/" + year);
        var diffTime = Math.abs(activeDate - _launchDate);
        var yrs = diffTime / (1000 * 60 * 60 * 24 * 365);
        _YEARS = parseFloat(yrs).toFixed(1);
      } catch (error) {
        console.log("Error while finding date difference of _ActivationDate and _LaunchDate :: deviceDetails.js :: " + error);
      }
    }
    return _YEARS;
  };
  var isFWADevice_ = isFWADevice(selectedMTNData);
  var featuresByCategory = ((_selectedMTNData4 = selectedMTNData) === null || _selectedMTNData4 === void 0 ? void 0 : (_selectedMTNData4$dev = _selectedMTNData4.deviceInfo) === null || _selectedMTNData4$dev === void 0 ? void 0 : (_selectedMTNData4$dev2 = _selectedMTNData4$dev[0]) === null || _selectedMTNData4$dev2 === void 0 ? void 0 : (_selectedMTNData4$dev3 = _selectedMTNData4$dev2.equipGuideData) === null || _selectedMTNData4$dev3 === void 0 ? void 0 : _selectedMTNData4$dev3.featuresByCategory) || [];
  var fwaAttributes = networkData === null || networkData === void 0 ? void 0 : networkData.fwaAttributes;
  var fullName = (_ref5 = ((_selectedMTNData5 = selectedMTNData) === null || _selectedMTNData5 === void 0 ? void 0 : (_selectedMTNData5$bas = _selectedMTNData5.basicMtnDetails) === null || _selectedMTNData5$bas === void 0 ? void 0 : (_selectedMTNData5$bas2 = _selectedMTNData5$bas[0]) === null || _selectedMTNData5$bas2 === void 0 ? void 0 : (_selectedMTNData5$bas3 = _selectedMTNData5$bas2.primaryUser) === null || _selectedMTNData5$bas3 === void 0 ? void 0 : (_selectedMTNData5$bas4 = _selectedMTNData5$bas3[0]) === null || _selectedMTNData5$bas4 === void 0 ? void 0 : _selectedMTNData5$bas4.firstName) + " " + ((_selectedMTNData6 = selectedMTNData) === null || _selectedMTNData6 === void 0 ? void 0 : (_selectedMTNData6$bas = _selectedMTNData6.basicMtnDetails) === null || _selectedMTNData6$bas === void 0 ? void 0 : (_selectedMTNData6$bas2 = _selectedMTNData6$bas[0]) === null || _selectedMTNData6$bas2 === void 0 ? void 0 : (_selectedMTNData6$bas3 = _selectedMTNData6$bas2.primaryUser) === null || _selectedMTNData6$bas3 === void 0 ? void 0 : (_selectedMTNData6$bas4 = _selectedMTNData6$bas3[0]) === null || _selectedMTNData6$bas4 === void 0 ? void 0 : _selectedMTNData6$bas4.lastName)) != null ? _ref5 : " ";
  var mtn = (_selectedMTNData7 = selectedMTNData) !== null && _selectedMTNData7 !== void 0 && _selectedMTNData7.mtn ? getFormatMtn((_selectedMTNData8 = selectedMTNData) === null || _selectedMTNData8 === void 0 ? void 0 : _selectedMTNData8.mtn) : "-";
  var modelName = (_selectedMTNData$devi3 = (_selectedMTNData9 = selectedMTNData) === null || _selectedMTNData9 === void 0 ? void 0 : (_selectedMTNData9$dev = _selectedMTNData9.deviceInfo) === null || _selectedMTNData9$dev === void 0 ? void 0 : (_selectedMTNData9$dev2 = _selectedMTNData9$dev[0]) === null || _selectedMTNData9$dev2 === void 0 ? void 0 : _selectedMTNData9$dev2.modelName) != null ? _selectedMTNData$devi3 : "-";
  var manufacturer = (_selectedMTNData$devi4 = (_selectedMTNData0 = selectedMTNData) === null || _selectedMTNData0 === void 0 ? void 0 : (_selectedMTNData0$dev = _selectedMTNData0.deviceInfo) === null || _selectedMTNData0$dev === void 0 ? void 0 : (_selectedMTNData0$dev2 = _selectedMTNData0$dev[0]) === null || _selectedMTNData0$dev2 === void 0 ? void 0 : _selectedMTNData0$dev2.equipmentMfgName) != null ? _selectedMTNData$devi4 : "-";
  var launchDate;
  var dateStr = (_selectedMTNData$devi5 = (_selectedMTNData1 = selectedMTNData) === null || _selectedMTNData1 === void 0 ? void 0 : (_selectedMTNData1$dev = _selectedMTNData1.deviceInfo) === null || _selectedMTNData1$dev === void 0 ? void 0 : (_selectedMTNData1$dev2 = _selectedMTNData1$dev[0]) === null || _selectedMTNData1$dev2 === void 0 ? void 0 : (_selectedMTNData1$dev3 = _selectedMTNData1$dev2.equipGuideData) === null || _selectedMTNData1$dev3 === void 0 ? void 0 : (_selectedMTNData1$dev4 = _selectedMTNData1$dev3.deviceModel) === null || _selectedMTNData1$dev4 === void 0 ? void 0 : (_selectedMTNData1$dev5 = _selectedMTNData1$dev4.osLaunchDate) === null || _selectedMTNData1$dev5 === void 0 ? void 0 : _selectedMTNData1$dev5.split(" ")) != null ? _selectedMTNData$devi5 : "";
  if (dateStr && dateStr !== null && dateStr !== void 0 && dateStr[0] && (dateStr === null || dateStr === void 0 ? void 0 : dateStr[0]) === 'Not' && prepayAddFixFFlag) {
    launchDate = 'Not Available';
  } else if (dateStr && dateStr !== null && dateStr !== void 0 && dateStr[0]) {
    launchDate = dateStr === null || dateStr === void 0 ? void 0 : dateStr[0];
  }
  var activationDate = (_selectedMTNData$devi6 = (_selectedMTNData10 = selectedMTNData) === null || _selectedMTNData10 === void 0 ? void 0 : (_selectedMTNData10$de = _selectedMTNData10.deviceInfo) === null || _selectedMTNData10$de === void 0 ? void 0 : (_selectedMTNData10$de2 = _selectedMTNData10$de[0]) === null || _selectedMTNData10$de2 === void 0 ? void 0 : _selectedMTNData10$de2.deviceActivationDate) != null ? _selectedMTNData$devi6 : "-";
  var imei = (_selectedMTNData$devi7 = (_selectedMTNData11 = selectedMTNData) === null || _selectedMTNData11 === void 0 ? void 0 : (_selectedMTNData11$de = _selectedMTNData11.deviceInfo) === null || _selectedMTNData11$de === void 0 ? void 0 : (_selectedMTNData11$de2 = _selectedMTNData11$de[0]) === null || _selectedMTNData11$de2 === void 0 ? void 0 : _selectedMTNData11$de2.imei) != null ? _selectedMTNData$devi7 : "-";
  var simId = (_selectedMTNData$devi8 = (_selectedMTNData12 = selectedMTNData) === null || _selectedMTNData12 === void 0 ? void 0 : (_selectedMTNData12$de = _selectedMTNData12.deviceInfo) === null || _selectedMTNData12$de === void 0 ? void 0 : (_selectedMTNData12$de2 = _selectedMTNData12$de[0]) === null || _selectedMTNData12$de2 === void 0 ? void 0 : _selectedMTNData12$de2.simId) != null ? _selectedMTNData$devi8 : "-";
  var imgUrl = (_selectedMTNData$devi9 = (_selectedMTNData13 = selectedMTNData) === null || _selectedMTNData13 === void 0 ? void 0 : (_selectedMTNData13$de = _selectedMTNData13.deviceInfo) === null || _selectedMTNData13$de === void 0 ? void 0 : (_selectedMTNData13$de2 = _selectedMTNData13$de[0]) === null || _selectedMTNData13$de2 === void 0 ? void 0 : (_selectedMTNData13$de3 = _selectedMTNData13$de2.equipGuideData) === null || _selectedMTNData13$de3 === void 0 ? void 0 : (_selectedMTNData13$de4 = _selectedMTNData13$de3.deviceModel) === null || _selectedMTNData13$de4 === void 0 ? void 0 : _selectedMTNData13$de4.thumbImage) != null ? _selectedMTNData$devi9 : "";
  var _YEARS = getLaunchDateYears(launchDate);
  var availableSoftware = (_getAvailableSoftware = getAvailableSoftwareVersion((_selectedMTNData14 = selectedMTNData) === null || _selectedMTNData14 === void 0 ? void 0 : (_selectedMTNData14$de = _selectedMTNData14.deviceInfo) === null || _selectedMTNData14$de === void 0 ? void 0 : (_selectedMTNData14$de2 = _selectedMTNData14$de[0]) === null || _selectedMTNData14$de2 === void 0 ? void 0 : (_selectedMTNData14$de3 = _selectedMTNData14$de2.equipGuideData) === null || _selectedMTNData14$de3 === void 0 ? void 0 : (_selectedMTNData14$de4 = _selectedMTNData14$de3.deviceModel) === null || _selectedMTNData14$de4 === void 0 ? void 0 : _selectedMTNData14$de4.currentOsVersion)) != null ? _getAvailableSoftware : "-";
  var deviceOs;
  var osVersion = (_networkData$device$a = networkData === null || networkData === void 0 ? void 0 : (_networkData$device = networkData.device) === null || _networkData$device === void 0 ? void 0 : (_networkData$device$a2 = _networkData$device.analysis) === null || _networkData$device$a2 === void 0 ? void 0 : (_networkData$device$a3 = _networkData$device$a2[0]) === null || _networkData$device$a3 === void 0 ? void 0 : (_networkData$device$a4 = _networkData$device$a3.tables) === null || _networkData$device$a4 === void 0 ? void 0 : (_networkData$device$a5 = _networkData$device$a4[0]) === null || _networkData$device$a5 === void 0 ? void 0 : (_networkData$device$a6 = _networkData$device$a5.rows[2]) === null || _networkData$device$a6 === void 0 ? void 0 : (_networkData$device$a7 = _networkData$device$a6.columns[2]) === null || _networkData$device$a7 === void 0 ? void 0 : _networkData$device$a7.name) != null ? _networkData$device$a : "-";
  if (isFWADevice_) {
    var _networkData$fwaAttri, _networkData$fwaAttri2;
    deviceOs = (_networkData$fwaAttri = networkData === null || networkData === void 0 ? void 0 : (_networkData$fwaAttri2 = networkData.fwaAttributes) === null || _networkData$fwaAttri2 === void 0 ? void 0 : _networkData$fwaAttri2.firmwareVersion) != null ? _networkData$fwaAttri : "-";
  } else {
    var _ref6, _selectedMTNData$devi0, _selectedMTNData15, _selectedMTNData15$de, _selectedMTNData15$de2, _selectedMTNData16, _selectedMTNData16$de, _selectedMTNData16$de2, _selectedMTNData17, _selectedMTNData17$de, _selectedMTNData17$de2;
    deviceOs = (_ref6 = ((_selectedMTNData$devi0 = (_selectedMTNData15 = selectedMTNData) === null || _selectedMTNData15 === void 0 ? void 0 : (_selectedMTNData15$de = _selectedMTNData15.deviceInfo) === null || _selectedMTNData15$de === void 0 ? void 0 : (_selectedMTNData15$de2 = _selectedMTNData15$de[0]) === null || _selectedMTNData15$de2 === void 0 ? void 0 : _selectedMTNData15$de2.deviceOs) != null ? _selectedMTNData$devi0 : "") + " " + osVersion) != null ? _ref6 : "-";
    if (prepayAddFixFFlag && (_selectedMTNData16 = selectedMTNData) !== null && _selectedMTNData16 !== void 0 && (_selectedMTNData16$de = _selectedMTNData16.deviceInfo) !== null && _selectedMTNData16$de !== void 0 && (_selectedMTNData16$de2 = _selectedMTNData16$de[0]) !== null && _selectedMTNData16$de2 !== void 0 && _selectedMTNData16$de2.deviceOs && ((_selectedMTNData17 = selectedMTNData) === null || _selectedMTNData17 === void 0 ? void 0 : (_selectedMTNData17$de = _selectedMTNData17.deviceInfo) === null || _selectedMTNData17$de === void 0 ? void 0 : (_selectedMTNData17$de2 = _selectedMTNData17$de[0]) === null || _selectedMTNData17$de2 === void 0 ? void 0 : _selectedMTNData17$de2.deviceOs) === "Not Available") {
      var _selectedMTNData18, _selectedMTNData18$de, _selectedMTNData18$de2;
      deviceOs = (_selectedMTNData18 = selectedMTNData) === null || _selectedMTNData18 === void 0 ? void 0 : (_selectedMTNData18$de = _selectedMTNData18.deviceInfo) === null || _selectedMTNData18$de === void 0 ? void 0 : (_selectedMTNData18$de2 = _selectedMTNData18$de[0]) === null || _selectedMTNData18$de2 === void 0 ? void 0 : _selectedMTNData18$de2.deviceOs;
    }
  }
  var _WARRANTY = "No";
  if ((_selectedMTNData19 = selectedMTNData) !== null && _selectedMTNData19 !== void 0 && (_selectedMTNData19$de = _selectedMTNData19.deviceInfo) !== null && _selectedMTNData19$de !== void 0 && (_selectedMTNData19$de2 = _selectedMTNData19$de[0]) !== null && _selectedMTNData19$de2 !== void 0 && (_selectedMTNData19$de3 = _selectedMTNData19$de2.equipmentWarranty) !== null && _selectedMTNData19$de3 !== void 0 && _selectedMTNData19$de3.inWarranty) {
    _WARRANTY = "Yes";
  }
  var _INSURANCE = "-";
  if ((_selectedMTNData20 = selectedMTNData) !== null && _selectedMTNData20 !== void 0 && (_selectedMTNData20$de = _selectedMTNData20.deviceInfo) !== null && _selectedMTNData20$de !== void 0 && (_selectedMTNData20$de2 = _selectedMTNData20$de[0]) !== null && _selectedMTNData20$de2 !== void 0 && (_selectedMTNData20$de3 = _selectedMTNData20$de2.equipmentProtection) !== null && _selectedMTNData20$de3 !== void 0 && _selectedMTNData20$de3.protectionStatusDescription) {
    var _selectedMTNData21, _selectedMTNData21$eq;
    _INSURANCE = (_selectedMTNData21 = selectedMTNData) === null || _selectedMTNData21 === void 0 ? void 0 : (_selectedMTNData21$eq = _selectedMTNData21.equipmentProtection) === null || _selectedMTNData21$eq === void 0 ? void 0 : _selectedMTNData21$eq.protectionStatusDescription;
  }
  var _DEVICE_TYPE = "Verizon Provided";
  if ((_selectedMTNData22 = selectedMTNData) !== null && _selectedMTNData22 !== void 0 && (_selectedMTNData22$de = _selectedMTNData22.deviceInfo) !== null && _selectedMTNData22$de !== void 0 && (_selectedMTNData22$de2 = _selectedMTNData22$de[0]) !== null && _selectedMTNData22$de2 !== void 0 && _selectedMTNData22$de2.byodDevice) {
    _DEVICE_TYPE = "BYOD";
  }
  var _WIRELESS_CHARGING = "No";
  var _CHARGING_PORT_TYPE = "Non USB-C";
  var _REMOVABLE_BATTERY = "Yes";
  var _REMOVABLE_MEMORY = "No";
  var _5G_UWB = "No";
  var _5G_NATIONWIDE = "No";
  var _CDMA_LESS_DEVICE = "No";
  var _INSTALL_DATE = "-";
  if (fwaAttributes && fwaAttributes.installDate) {
    _INSTALL_DATE = fwaAttributes.installDate;
  }
  var _INSTALL_TYPE = "-";
  if (fwaAttributes && fwaAttributes.installationType) {
    _INSTALL_TYPE = fwaAttributes.installationType;
  }
  var _ROUTER_MAC_ADDRESS = "-";
  if (fwaAttributes && fwaAttributes.macAddress) {
    _ROUTER_MAC_ADDRESS = fwaAttributes.macAddress;
  }
  var _WIFI_EXTENDER = "No";
  if (fwaAttributes && fwaAttributes.isExtenderInstalled) {
    _WIFI_EXTENDER = fwaAttributes.isExtenderInstalled;
  }
  var _WIFI_BANDS_SUPPORTED = /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("label", {
    className: "viewdetails_popup_customstyle"
  }, "-"));
  if (featuresByCategory && featuresByCategory.length > 0) {
    for (var _iterator = _createForOfIteratorHelperLoose(featuresByCategory), _step; !(_step = _iterator()).done;) {
      var element = _step.value;
      if (element && element.categoryName && element.categoryName === "Battery" && element.featureList && element.featureList.length > 0) {
        for (var _iterator2 = _createForOfIteratorHelperLoose(element.featureList), _step2; !(_step2 = _iterator2()).done;) {
          var elm = _step2.value;
          if (elm && elm.id && elm.id === "1551" && elm.description && elm.description === "Built-in Wireless Charging Support") {
            _WIRELESS_CHARGING = "Yes";
          }
          if (elm && elm.id && elm.id === "1390" && elm.description && elm.description === "Non-removable Battery") {
            _REMOVABLE_BATTERY = "No";
          }
        }
      }
      if (element && element.categoryName && element.categoryName === "Form Factor" && element.featureList && element.featureList.length > 0) {
        for (var _iterator3 = _createForOfIteratorHelperLoose(element.featureList), _step3; !(_step3 = _iterator3()).done;) {
          var _elm = _step3.value;
          if (_elm && _elm.id && _elm.id === "2155" && _elm.description && _elm.description === "Type C Charging port") {
            _CHARGING_PORT_TYPE = "USB-C";
            break;
          }
        }
      }
      if (element && element.categoryName && element.categoryName === "Expandable Memory" && element.featureList && element.featureList.length > 0) {
        for (var _iterator4 = _createForOfIteratorHelperLoose(element.featureList), _step4; !(_step4 = _iterator4()).done;) {
          var _elm2 = _step4.value;
          if (_elm2 && _elm2.id && _elm2.id === "95" && _elm2.description && _elm2.description === "Removable Memory") {
            var _elm2$subFeatures, _elm2$subFeatures2, _elm2$subFeatures3;
            if (_elm2.subFeatures && (_elm2$subFeatures = _elm2.subFeatures) !== null && _elm2$subFeatures !== void 0 && _elm2$subFeatures[0] && (_elm2$subFeatures2 = _elm2.subFeatures) !== null && _elm2$subFeatures2 !== void 0 && _elm2$subFeatures2[0].description && ((_elm2$subFeatures3 = _elm2.subFeatures) === null || _elm2$subFeatures3 === void 0 ? void 0 : _elm2$subFeatures3[0].description.length) > 0) {
              var _elm2$subFeatures4;
              _REMOVABLE_MEMORY = "Yes (" + ((_elm2$subFeatures4 = _elm2.subFeatures) === null || _elm2$subFeatures4 === void 0 ? void 0 : _elm2$subFeatures4[0].description) + ")";
            } else {
              _REMOVABLE_MEMORY = "Yes";
            }
            break;
          }
        }
      }
      if (element && element.categoryName && element.categoryName === "Network" && element.featureList && element.featureList.length > 0) {
        for (var _iterator5 = _createForOfIteratorHelperLoose(element.featureList), _step5; !(_step5 = _iterator5()).done;) {
          var _elm3 = _step5.value;
          if (_elm3 && _elm3.id && _elm3.id === "2739" && _elm3.description && _elm3.description === "5G Nationwide Supported") {
            _5G_NATIONWIDE = "Yes";
          }
          if (_elm3 && _elm3.id && _elm3.id === "1744" && _elm3.description && _elm3.description === "Not CDMA Compatible") {
            _CDMA_LESS_DEVICE = "Yes";
          }
          if (_elm3 && _elm3.id && _elm3.id === "2439" && _elm3.description && _elm3.description === "5G Capable") {
            if (_elm3.subFeatures && _elm3.subFeatures.length > 0) {
              for (var _iterator6 = _createForOfIteratorHelperLoose(_elm3.subFeatures), _step6; !(_step6 = _iterator6()).done;) {
                var elmSf = _step6.value;
                if (elmSf && elmSf.id && elmSf.id === "2696") {
                  _5G_UWB = "Yes";
                  break;
                }
              }
            }
          }
        }
      }
      if (element && element.categoryName && element.categoryName === "Technology" && element.featureList && element.featureList.length > 0) {
        for (var _iterator7 = _createForOfIteratorHelperLoose(element.featureList), _step7; !(_step7 = _iterator7()).done;) {
          var _elm4 = _step7.value;
          if (_elm4 && _elm4.id && _elm4.id === "841" && _elm4.description && _elm4.description === "Wi-Fi") {
            if (_elm4.subFeatures && _elm4.subFeatures.length > 0) {
              _WIFI_BANDS_SUPPORTED = /*#__PURE__*/React__default.createElement("div", null, _elm4.subFeatures.map(function (feature, index) {
                return /*#__PURE__*/React__default.createElement("label", {
                  key: "subFet-" + index,
                  className: "viewdetails_popup_customstyle label_bottom_margin_zero"
                }, feature.description);
              }));
            }
          }
        }
      }
    }
  }
  var deviceInforButtons = /*#__PURE__*/React__default.createElement("div", {
    className: "viewdetails_btn_position"
  }, /*#__PURE__*/React__default.createElement(StyledButton$4, {
    surface: props.isDark ? 'dark' : 'light',
    buttonStyles: {
      margin: "0px 0.625rem 0.625rem 0px;",
      display: "inline-flex;"
    },
    size: "small",
    className: "device_details_custom_btn",
    "data-testid": "Emulator",
    onClick: function onClick(e) {
      getEmulator();
    }
  }, "Emulator"), /*#__PURE__*/React__default.createElement(StyledButton$4, {
    surface: props.isDark ? 'dark' : 'light',
    buttonStyles: {
      margin: "0px 0.625rem 0.625rem 0px;",
      display: "inline-flex;",
      width: "100%"
    },
    size: "small",
    className: "device_details_custom_btn1",
    onClick: function onClick(e) {
      deviceImageClick();
    }
  }, "Equipment Guide"));
  if (deviceData) {
    return /*#__PURE__*/React__default.createElement("div", null, isFWADevice_ ? /*#__PURE__*/React__default.createElement("div", {
      className: (props.isDark ? 'viewdetails-body-dark' : '') + " row viewdetails-body"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "column viewdetails-col "
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "view_details_popup_name",
      role: "heading",
      level: "1"
    }, fullName), /*#__PURE__*/React__default.createElement("div", {
      className: "view_details_popup_name ",
      role: "heading",
      level: "3"
    }, /*#__PURE__*/React__default.createElement("label", {
      className: ""
    }, " ", mtn, " ")), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Manufacturer"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, manufacturer), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Model"), /*#__PURE__*/React__default.createElement("label", {
      className: " viewdetails_popup_customstyle"
    }, modelName)), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "OS Version"), deviceOs !== availableSoftware ? /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        marginBottom: "1rem"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: " articlem-0  fontSize details_device_info ",
      title: deviceOs
    }, deviceOs), /*#__PURE__*/React__default.createElement("div", {
      className: "article iosIconStyle iosIconStyleImgBg"
    })) : /*#__PURE__*/React__default.createElement("div", {
      className: " articlem-0  fontSize details_device_info",
      title: deviceOs
    }, deviceOs), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Current Software Version"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, deviceOs)), /*#__PURE__*/React__default.createElement("div", {
      className: "column viewdetails-col1"
    }, /*#__PURE__*/React__default.createElement("div", null, imgUrl ? /*#__PURE__*/React__default.createElement("img", {
      className: " troubleShooting_deviceOverview_view_details_popup_image pointer",
      name: "tmpImage",
      id: "tmpImage_deviceOverviewUR_DeviceView_tab_0",
      src: imgUrl,
      title: "Equipment Guide",
      alt: "Equipment Guide"
    }) : /*#__PURE__*/React__default.createElement("div", {
      className: "devicedetails_noImage"
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "column viewdetails-col"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: (windowRetailIframe ? 'sim-btn-retail' : 'sim-btn') + " details_fontStyle",
      "data-testid": "handleSimClick",
      onClick: function onClick() {
        return handleSimClick();
      },
      role: "heading",
      level: "1"
    }, simTypeValue, "SIM"), simOpen && /*#__PURE__*/React__default.createElement(Launchout, {
      handleClose: function handleClose() {
        return setSimOpen(false);
      },
      modalTitle: "VZW SIM Details",
      height: windowRetailIframe ? "100vh" : "600px",
      width: "600px",
      isDark: props.isDark
    }, /*#__PURE__*/React__default.createElement(SimDetails, props)), /*#__PURE__*/React__default.createElement("div", {
      className: "notDark",
      tabIndex: "0",
      role: "link"
    }, /*#__PURE__*/React__default.createElement("span", {
      "data-track": simId
    }, simId)), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "IMEI"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, imei), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Install Date"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, _INSTALL_DATE), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Install Type"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, _INSTALL_TYPE), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Router MAC Address"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, _ROUTER_MAC_ADDRESS)), /*#__PURE__*/React__default.createElement("div", {
      className: "column viewdetails-col2"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Wi-Fi Extender"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, _WIFI_EXTENDER), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Wi-Fi Bands Supported"), _WIFI_BANDS_SUPPORTED, !windowRetailIframe && deviceInforButtons)) : /*#__PURE__*/React__default.createElement("div", {
      className: (props.isDark ? 'viewdetails-body-dark' : '') + " row viewdetails-body"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "column viewdetails-col "
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "view_details_popup_name",
      role: "heading",
      level: "1"
    }, fullName), /*#__PURE__*/React__default.createElement("div", {
      className: "view_details_popup_name ",
      role: "heading",
      level: "3"
    }, /*#__PURE__*/React__default.createElement("label", {
      className: ""
    }, " ", mtn, " ")), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Manufacturer"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, manufacturer), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Model"), /*#__PURE__*/React__default.createElement("label", {
      className: " viewdetails_popup_customstyle"
    }, modelName)), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Years"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, _YEARS), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "OS Version"), deviceOs !== availableSoftware ? /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        marginBottom: "1rem"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: " articlem-0  fontSize details_device_info ",
      title: deviceOs
    }, deviceOs), /*#__PURE__*/React__default.createElement("div", {
      className: " iosIconStyle iosIconStyleImgBg"
    })) : /*#__PURE__*/React__default.createElement("div", {
      className: " articlem-0  fontSize details_device_info",
      title: deviceOs
    }, deviceOs), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Release Date"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, launchDate), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Activation Date"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, activationDate)), /*#__PURE__*/React__default.createElement("div", {
      className: "column viewdetails-col1"
    }, /*#__PURE__*/React__default.createElement("div", null, imgUrl ? /*#__PURE__*/React__default.createElement("img", {
      className: " troubleShooting_deviceOverview_view_details_popup_image pointer",
      name: "tmpImage",
      id: "tmpImage_deviceOverviewUR_DeviceView_tab_0",
      src: imgUrl,
      title: "Equipment Guide",
      alt: "Equipment Guide"
    }) : /*#__PURE__*/React__default.createElement("div", {
      className: "devicedetails_noImage"
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "column viewdetails-col"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: (windowRetailIframe ? 'sim-btn-retail' : 'sim-btn') + " details_fontStyle",
      "data-testid": "handleSimClick",
      onClick: function onClick() {
        return handleSimClick();
      },
      role: "heading",
      level: "1"
    }, simTypeValue, "SIM"), simOpen && /*#__PURE__*/React__default.createElement(Launchout, {
      isDark: props.isDark,
      handleClose: function handleClose() {
        return setSimOpen(false);
      },
      modalTitle: "VZW SIM Details",
      height: windowRetailIframe ? "100vh" : "600px",
      width: "600px"
    }, /*#__PURE__*/React__default.createElement(SimDetails, props)), /*#__PURE__*/React__default.createElement("div", {
      className: "viewdetails_popup_customstyle",
      id: "insight-black",
      tabIndex: "0",
      role: "link"
    }, /*#__PURE__*/React__default.createElement("span", {
      "data-track": simId
    }, simId)), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "IMEI"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, imei), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Wireless charging"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, _WIRELESS_CHARGING), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Charging Port Type"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, _CHARGING_PORT_TYPE), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Removable Memory"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, _REMOVABLE_MEMORY), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Removable battery"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, _REMOVABLE_BATTERY), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Device Type"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, _DEVICE_TYPE)), /*#__PURE__*/React__default.createElement("div", {
      className: "column viewdetails-col2"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "5G UWB"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, _5G_UWB), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "5G Nationwide"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, _5G_NATIONWIDE), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "CDMA - LESS device"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, _CDMA_LESS_DEVICE), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Current software Version"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, osVersion), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Warranty Status", " "), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, _WARRANTY), /*#__PURE__*/React__default.createElement("div", {
      className: "view_deatils_heading",
      role: "heading",
      level: "1"
    }, "Insurance"), /*#__PURE__*/React__default.createElement("label", {
      className: "viewdetails_popup_customstyle"
    }, _INSURANCE), !windowRetailIframe && deviceInforButtons)));
  } else return /*#__PURE__*/React__default.createElement("div", {
    className: "loader-container"
  }, /*#__PURE__*/React__default.createElement(Loader$2, {
    fullscreen: false,
    active: true
  }));
}

var rooted = "Rooted~uFAqsTPc.svg";

var serviceState = "Service-State~iWvJjBAD.svg";

var temperture = "temperature~XUxfRNAg.svg";

var storage = "Storage~rLFXhWST.svg";

var hotspot = "mobile-hotspot~sHlNJCLM.svg";

var battery = "battery~lEMSVnGm.svg";

var sim = "SIM-State~poKeqfwp.svg";

var ram = "RAM~boZLZzDw.svg";

var airplaneMode = "Airplane-Mode~vGccUcTo.svg";

var malware = "Malware~HNSVMuTx.svg";

var signalStrength = "Signal-Strength~bpYGeJgK.svg";

function DeviceDiagnostics(props) {
  var _deviceData$customerI, _deviceData$customerI2, _deviceData$customerI3, _deviceData$customerI4, _deviceData$customerI5, _deviceData$customerI6, _deviceData$customerI7, _deviceData$customerI8, _window, _window$caseDetails, _selectedMTNData8, _selectedMTNData8$bas, _selectedMTNData8$bas2, _window4, _window4$caseDetails, _deviceDiagnostics$bo5, _deviceDiagnostics$bo6, _genericAPI$data, _userProfile$permissi, _deviceDiagnostics$an, _deviceDiagnostics$an2, _deviceDiagnostics$an3, _deviceDiagnostics$an4, _deviceDiagnostics$an5, _deviceDiagnosticsInf, _deviceDiagnosticsInf2, _deviceDiagnosticsInf3, _deviceDiagnosticsInf4, _deviceDiagnosticsInf5, _deviceDiagnosticsInf6, _deviceDiagnosticsInf7, _deviceDiagnosticsInf8, _deviceDiagnosticsInf9, _deviceDiagnosticsInf0, _deviceDiagnosticsInf1, _deviceDiagnosticsInf10, _deviceDiagnosticsInf11, _deviceDiagnosticsInf12, _deviceDiagnosticsInf13, _deviceDiagnosticsInf14, _deviceDiagnosticsInf15, _deviceDiagnosticsInf16, _deviceDiagnosticsInf17, _deviceDiagnosticsInf18, _deviceDiagnosticsInf19, _deviceDiagnosticsInf20, _deviceDiagnosticsInf21, _deviceDiagnosticsInf22, _deviceDiagnosticsInf23, _deviceDiagnosticsInf24, _deviceDiagnosticsInf25, _deviceDiagnosticsInf26, _deviceDiagnosticsInf27, _deviceDiagnosticsInf28, _deviceDiagnosticsInf29, _deviceDiagnosticsInf30, _deviceDiagnosticsInf31, _deviceDiagnosticsInf32, _deviceDiagnostics$an6, _deviceDiagnostics$an7, _deviceDiagnostics$an8, _deviceDiagnostics$an9, _deviceDiagnostics$an0, _deviceDiagnosticsInf33, _deviceDiagnosticsInf34, _deviceDiagnosticsInf35, _deviceDiagnosticsInf36;
  var _useDeviceData = useDeviceData(props),
    deviceResponse = _useDeviceData.data;
  var _useProfileData = useProfileData(props),
    userProfile = _useProfileData.data;
  var _useLoadLinks = useLoadLinks(props),
    loadLinks = _useLoadLinks.data;
  var _useDeviceDiagnostics = useDeviceDiagnostics(props),
    deviceDiagnostics = _useDeviceDiagnostics.data,
    refetchDiagnostics = _useDeviceDiagnostics.refetch;
  var _useState = useState(false),
    currentDate = _useState[0],
    setCurrentDate = _useState[1];
  var _useState2 = useState(false),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = useState("soft"),
    setRefresh = _useState3[1];
  var _useState4 = useState({}),
    deviceData = _useState4[0],
    setdeviceData = _useState4[1];
  useEffect(function () {
    var _deviceResponse$respo, _deviceResponse$respo2, _deviceResponse$respo3;
    setdeviceData(deviceResponse === null || deviceResponse === void 0 ? void 0 : (_deviceResponse$respo = deviceResponse.response) === null || _deviceResponse$respo === void 0 ? void 0 : (_deviceResponse$respo2 = _deviceResponse$respo.data) === null || _deviceResponse$respo2 === void 0 ? void 0 : (_deviceResponse$respo3 = _deviceResponse$respo2.body) === null || _deviceResponse$respo3 === void 0 ? void 0 : _deviceResponse$respo3.data);
  }, [deviceResponse]);
  var operatingSystem = (_deviceData$customerI = deviceData === null || deviceData === void 0 ? void 0 : (_deviceData$customerI2 = deviceData.customerInsight) === null || _deviceData$customerI2 === void 0 ? void 0 : (_deviceData$customerI3 = _deviceData$customerI2.billAccounts) === null || _deviceData$customerI3 === void 0 ? void 0 : (_deviceData$customerI4 = _deviceData$customerI3[0]) === null || _deviceData$customerI4 === void 0 ? void 0 : (_deviceData$customerI5 = _deviceData$customerI4.mtns) === null || _deviceData$customerI5 === void 0 ? void 0 : (_deviceData$customerI6 = _deviceData$customerI5[0]) === null || _deviceData$customerI6 === void 0 ? void 0 : (_deviceData$customerI7 = _deviceData$customerI6.deviceInfo) === null || _deviceData$customerI7 === void 0 ? void 0 : (_deviceData$customerI8 = _deviceData$customerI7[0]) === null || _deviceData$customerI8 === void 0 ? void 0 : _deviceData$customerI8.deviceOs) != null ? _deviceData$customerI : "";
  var dispatchUsageMetrics = function dispatchUsageMetrics(metrics) {
    if (metrics === void 0) {
      metrics = [];
    }
    var _ref = props || {},
      logUsageMetrics = _ref.logUsageMetrics;
    if (logUsageMetrics) {
      logUsageMetrics({
        metrics: [].concat(metrics)
      });
    }
  };
  var handleRefetchDiagnostics = function handleRefetchDiagnostics() {
    refetchDiagnostics().then(function (data) {
      if (data) {
        setIsLoading(false);
        setCurrentDate(true);
      }
    })["catch"](function (error) {
      console.error('Error refetching diagnostics:', error);
    });
  };
  var onRefreshClick = function onRefreshClick() {
    setIsLoading(true);
    setRefresh("hard");
    handleRefetchDiagnostics();
  };
  var selectedMTN = (_window = window) === null || _window === void 0 ? void 0 : (_window$caseDetails = _window.caseDetails) === null || _window$caseDetails === void 0 ? void 0 : _window$caseDetails.mtn;
  var selectedMTNData;
  if (deviceData) {
    var _deviceData$customerI9, _deviceData$customerI0, _deviceData$customerI1;
    var mtns = deviceData === null || deviceData === void 0 ? void 0 : (_deviceData$customerI9 = deviceData.customerInsight) === null || _deviceData$customerI9 === void 0 ? void 0 : (_deviceData$customerI0 = _deviceData$customerI9.billAccounts) === null || _deviceData$customerI0 === void 0 ? void 0 : (_deviceData$customerI1 = _deviceData$customerI0[0]) === null || _deviceData$customerI1 === void 0 ? void 0 : _deviceData$customerI1.mtns;
    selectedMTNData = mtns ? mtns.find(function (e) {
      return e.mtn === selectedMTN;
    }) : {};
  }
  var getApiDate = function getApiDate(dateValue) {
    var currentDate = new Date(parseInt(dateValue));
    var month = currentDate.getMonth() + 1;
    var year = currentDate.getFullYear();
    var day = currentDate.getDate();
    day = day < 10 ? "0" + day : day;
    var hour = currentDate.getHours();
    var minutes = currentDate.getMinutes();
    var ampm = hour >= 12 ? "PM" : "AM";
    hour = hour || 12;
    hour = hour > 12 ? hour - 12 : hour;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var disDate = month + "/" + day + "/" + year + ", " + hour + ":" + minutes + " " + ampm;
    return /*#__PURE__*/React__default.createElement("span", {
      style: {
        paddingRight: "1em",
        paddingLeft: "0.625em",
        fontWeight: "500"
      }
    }, " ", disDate, " ");
  };
  var handleVerizonLinkClick = function handleVerizonLinkClick() {
    var metrics = [{
      eventID: "DEVICE_DETAILS",
      actionID: "MVMD_LINK_SELECT",
      notes: "validDeviceTypes"
    }, {
      EVENT_ID: "TROUBLESHOOTING",
      ACTION_ID: "MVD_LINK_CLICK",
      NOTES: "MVD link clicked."
    }];
    dispatchUsageMetrics(metrics);
    var mvmd_url = getMVDBaseUrl(loadLinks);
    var keyvaluepairs = prepareMVDLaunchOutRequestUrlData(selectedMTNData);
    var timestamp = "" + new Date().getTime();
    var data = timestamp + ":" + keyvaluepairs;
    var chksum = Md5(data);
    var requestData = chksum + ":" + data;
    var url = encodeURI(mvmd_url + "?data=" + requestData);
    window.open(url);
  };
  var getIsMyVerizonDiagnosticsShown = function getIsMyVerizonDiagnosticsShown(mtnStatus) {
    var _window3, _window3$caseDetails, _selectedMTNData, _selectedMTNData$devi, _selectedMTNData$devi2, _selectedMTNData2, _selectedMTNData2$dev, _selectedMTNData2$dev2, _selectedMTNData2$dev3, _selectedMTNData2$dev4, _selectedMTNData3, _selectedMTNData3$dev, _selectedMTNData3$dev2, _selectedMTNData3$dev3, _selectedMTNData3$dev4, _selectedMTNData4, _selectedMTNData4$dev, _selectedMTNData4$dev2, _selectedMTNData4$dev3, _selectedMTNData4$dev4, _selectedMTNData5, _selectedMTNData5$dev, _selectedMTNData5$dev2, _selectedMTNData5$dev3, _selectedMTNData5$dev4, _selectedMTNData6, _selectedMTNData6$dev, _selectedMTNData6$dev2, _selectedMTNData6$dev3, _selectedMTNData6$dev4, _selectedMTNData7, _selectedMTNData7$dev, _selectedMTNData7$dev2, _selectedMTNData7$dev3, _selectedMTNData7$dev4;
    var mobileDiagnosticsCapability;
    var selectedMTN = (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$caseDetails = _window3.caseDetails) === null || _window3$caseDetails === void 0 ? void 0 : _window3$caseDetails.mtn;
    var mvmdUrl = getMVDBaseUrl(loadLinks);
    if (!mvmdUrl) {
      return false;
    }
    var validMtnStatus = ["A", "AC", "AR", "AT", "S", "B"];
    if (validMtnStatus.indexOf(mtnStatus) === -1) {
      return false;
    }
    var selectedMTNData;
    if (deviceData) {
      var _deviceData$customerI10, _deviceData$customerI11, _deviceData$customerI12;
      var _mtns = deviceData === null || deviceData === void 0 ? void 0 : (_deviceData$customerI10 = deviceData.customerInsight) === null || _deviceData$customerI10 === void 0 ? void 0 : (_deviceData$customerI11 = _deviceData$customerI10.billAccounts) === null || _deviceData$customerI11 === void 0 ? void 0 : (_deviceData$customerI12 = _deviceData$customerI11[0]) === null || _deviceData$customerI12 === void 0 ? void 0 : _deviceData$customerI12.mtns;
      selectedMTNData = _mtns ? _mtns.find(function (e) {
        return e.mtn === selectedMTN;
      }) : {};
    }
    var equipMfgrName = (_selectedMTNData = selectedMTNData) === null || _selectedMTNData === void 0 ? void 0 : (_selectedMTNData$devi = _selectedMTNData.deviceInfo) === null || _selectedMTNData$devi === void 0 ? void 0 : (_selectedMTNData$devi2 = _selectedMTNData$devi[0]) === null || _selectedMTNData$devi2 === void 0 ? void 0 : _selectedMTNData$devi2.equipmentMfgName;
    if ("APL" === equipMfgrName) {
      return true;
    }
    var validDeviceTypes = ["4GC", "5GF", "5GL", "4GR"];
    var _ref2 = selectedMTNData || {},
      _ref2$basicPhoneInfo = _ref2.basicPhoneInfo,
      _ref2$basicPhoneInfo2 = _ref2$basicPhoneInfo === void 0 ? {} : _ref2$basicPhoneInfo,
      _ref2$basicPhoneInfo3 = _ref2$basicPhoneInfo2.deviceType,
      deviceType = _ref2$basicPhoneInfo3 === void 0 ? '' : _ref2$basicPhoneInfo3,
      _ref2$deviceMtnIndica = _ref2.deviceMtnIndicator,
      deviceMtnIndicator = _ref2$deviceMtnIndica === void 0 ? '' : _ref2$deviceMtnIndica;
    if (validDeviceTypes.indexOf(deviceType) !== -1 || deviceMtnIndicator === 'I' || deviceMtnIndicator === 'W') {
      var metrics = [{
        eventID: "DEVICE_DETAILS",
        actionID: "MVMD_LINK_SELECT",
        notes: "validDeviceTypes"
      }];
      dispatchUsageMetrics(metrics);
      return true;
    }
    if ("NOV" === equipMfgrName) {
      return isNOVModelPresent(selectedMTNData);
    }
    if (selectedMTNData && (((_selectedMTNData2 = selectedMTNData) === null || _selectedMTNData2 === void 0 ? void 0 : (_selectedMTNData2$dev = _selectedMTNData2.deviceInfo) === null || _selectedMTNData2$dev === void 0 ? void 0 : (_selectedMTNData2$dev2 = _selectedMTNData2$dev[0]) === null || _selectedMTNData2$dev2 === void 0 ? void 0 : (_selectedMTNData2$dev3 = _selectedMTNData2$dev2.equipGuideData) === null || _selectedMTNData2$dev3 === void 0 ? void 0 : (_selectedMTNData2$dev4 = _selectedMTNData2$dev3.deviceModel) === null || _selectedMTNData2$dev4 === void 0 ? void 0 : _selectedMTNData2$dev4.sku) === "TR2V1" || ((_selectedMTNData3 = selectedMTNData) === null || _selectedMTNData3 === void 0 ? void 0 : (_selectedMTNData3$dev = _selectedMTNData3.deviceInfo) === null || _selectedMTNData3$dev === void 0 ? void 0 : (_selectedMTNData3$dev2 = _selectedMTNData3$dev[0]) === null || _selectedMTNData3$dev2 === void 0 ? void 0 : (_selectedMTNData3$dev3 = _selectedMTNData3$dev2.equipGuideData) === null || _selectedMTNData3$dev3 === void 0 ? void 0 : (_selectedMTNData3$dev4 = _selectedMTNData3$dev3.deviceModel) === null || _selectedMTNData3$dev4 === void 0 ? void 0 : _selectedMTNData3$dev4.sku) === "ASK-NCQ1338" || ((_selectedMTNData4 = selectedMTNData) === null || _selectedMTNData4 === void 0 ? void 0 : (_selectedMTNData4$dev = _selectedMTNData4.deviceInfo) === null || _selectedMTNData4$dev === void 0 ? void 0 : (_selectedMTNData4$dev2 = _selectedMTNData4$dev[0]) === null || _selectedMTNData4$dev2 === void 0 ? void 0 : (_selectedMTNData4$dev3 = _selectedMTNData4$dev2.equipGuideData) === null || _selectedMTNData4$dev3 === void 0 ? void 0 : (_selectedMTNData4$dev4 = _selectedMTNData4$dev3.deviceModel) === null || _selectedMTNData4$dev4 === void 0 ? void 0 : _selectedMTNData4$dev4.sku) === "ASK-NCQ1338FA" || ((_selectedMTNData5 = selectedMTNData) === null || _selectedMTNData5 === void 0 ? void 0 : (_selectedMTNData5$dev = _selectedMTNData5.deviceInfo) === null || _selectedMTNData5$dev === void 0 ? void 0 : (_selectedMTNData5$dev2 = _selectedMTNData5$dev[0]) === null || _selectedMTNData5$dev2 === void 0 ? void 0 : (_selectedMTNData5$dev3 = _selectedMTNData5$dev2.equipGuideData) === null || _selectedMTNData5$dev3 === void 0 ? void 0 : (_selectedMTNData5$dev4 = _selectedMTNData5$dev3.deviceModel) === null || _selectedMTNData5$dev4 === void 0 ? void 0 : _selectedMTNData5$dev4.sku) === "ARC-XCI55AX" || ((_selectedMTNData6 = selectedMTNData) === null || _selectedMTNData6 === void 0 ? void 0 : (_selectedMTNData6$dev = _selectedMTNData6.deviceInfo) === null || _selectedMTNData6$dev === void 0 ? void 0 : (_selectedMTNData6$dev2 = _selectedMTNData6$dev[0]) === null || _selectedMTNData6$dev2 === void 0 ? void 0 : (_selectedMTNData6$dev3 = _selectedMTNData6$dev2.equipGuideData) === null || _selectedMTNData6$dev3 === void 0 ? void 0 : (_selectedMTNData6$dev4 = _selectedMTNData6$dev3.deviceModel) === null || _selectedMTNData6$dev4 === void 0 ? void 0 : _selectedMTNData6$dev4.sku) === "ARC-XCI55AX" || ((_selectedMTNData7 = selectedMTNData) === null || _selectedMTNData7 === void 0 ? void 0 : (_selectedMTNData7$dev = _selectedMTNData7.deviceInfo) === null || _selectedMTNData7$dev === void 0 ? void 0 : (_selectedMTNData7$dev2 = _selectedMTNData7$dev[0]) === null || _selectedMTNData7$dev2 === void 0 ? void 0 : (_selectedMTNData7$dev3 = _selectedMTNData7$dev2.equipGuideData) === null || _selectedMTNData7$dev3 === void 0 ? void 0 : (_selectedMTNData7$dev4 = _selectedMTNData7$dev3.deviceModel) === null || _selectedMTNData7$dev4 === void 0 ? void 0 : _selectedMTNData7$dev4.sku) === "ASK-NCM1100")) {
      return true;
    }
    return _.get(mobileDiagnosticsCapability, "data.acssService.Response.isDeviceRegistered", false);
  };
  var isNOVModelPresent = function isNOVModelPresent(selectedMtnInquiry) {
    var novDeviceList = state.novatelDeviceListRefData || [];
    var isModelPresent = false;
    novDeviceList.forEach(function (e) {
      var _selectedMtnInquiry$b, _selectedMtnInquiry$b2;
      if (selectedMtnInquiry && selectedMtnInquiry.basicPhoneInfo && e.ItemCode && e.ItemValue && e.ItemValue.toLowerCase() === (selectedMtnInquiry === null || selectedMtnInquiry === void 0 ? void 0 : (_selectedMtnInquiry$b = selectedMtnInquiry.basicPhoneInfo) === null || _selectedMtnInquiry$b === void 0 ? void 0 : (_selectedMtnInquiry$b2 = _selectedMtnInquiry$b.productName) === null || _selectedMtnInquiry$b2 === void 0 ? void 0 : _selectedMtnInquiry$b2.toLowerCase())) {
        isModelPresent = true;
      }
    });
    return isModelPresent;
  };
  var get3gArrowPosition = function get3gArrowPosition(value) {
    var arrowPosition = "150px";
    var value1 = value.substring(0, value.length - 3);
    if (value1 <= -91) {
      arrowPosition = "130px";
    }
    if (value1 >= -90 && value1 <= -66) {
      arrowPosition = "190px";
    }
    if (value1 >= -65) {
      arrowPosition = "250px";
    }
    return arrowPosition;
  };
  var get4gArrowPosition = function get4gArrowPosition(value) {
    var arrowPosition = "150px";
    var value1 = value.substring(0, value.length - 3);
    if (value1 <= -106) {
      arrowPosition = "130px";
    }
    if (value1 >= -105 && value1 <= -86) {
      arrowPosition = "190px";
    }
    if (value1 >= -85) {
      arrowPosition = "250px";
    }
    return arrowPosition;
  };
  var get5gArrowPosition = function get5gArrowPosition(value) {
    var arrowPosition = "150px";
    var value1 = value.substring(0, value.length - 3);
    if (value1 <= -96) {
      arrowPosition = "130px";
    }
    if (value1 >= -90 && value1 <= -81) {
      arrowPosition = "190px";
    }
    if (value1 >= -80) {
      arrowPosition = "250px";
    }
    return arrowPosition;
  };
  var get5g = function get5g(value) {
    var _5gDevice = "";
    value = parseInt(value);
    if (value >= 2070833 && value <= 2279166) {
      _5gDevice = "5G UW High Band";
    }
    if (value >= 422000 && value <= 398000) {
      _5gDevice = "5G Nationwide";
    }
    if (value >= 620000 && value <= 680000) {
      _5gDevice = "5G UW Mid Band";
    }
    return _5gDevice;
  };
  var dynamicProps = {
    secondary: true
  };
  var status = (_selectedMTNData8 = selectedMTNData) === null || _selectedMTNData8 === void 0 ? void 0 : (_selectedMTNData8$bas = _selectedMTNData8.basicMtnDetails) === null || _selectedMTNData8$bas === void 0 ? void 0 : (_selectedMTNData8$bas2 = _selectedMTNData8$bas[0]) === null || _selectedMTNData8$bas2 === void 0 ? void 0 : _selectedMTNData8$bas2.mtnStatusCode;
  var deviceDiagnosticsDeviceNotSupportedMsg = "Utilize MVD to obtain device diagnostics, diagnostics not available in ACSS.";
  var deviceFailedToLoadForMdn = "Unable to load data for this MDN.";
  var deviceDiagnosticsNoMvdButton = "Device diagnostics not available in ACSS.";
  var isMyVerizonDiagnosticShown = false;
  var isHavingAccessToMVD = "If you have access to MVD, utilize it to obtain device diagnostics";
  var isHavingAccessToMVD2 = "If you have access to MVD, please load it for this MDN, feature is temporarily unavailable";
  var acssTier = (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$caseDetails = _window4.caseDetails) === null || _window4$caseDetails === void 0 ? void 0 : _window4$caseDetails.tier;
  if (operatingSystem.indexOf("Apple") >= 0 || operatingSystem.indexOf("iOS") >= 0) {
    isMyVerizonDiagnosticShown = getIsMyVerizonDiagnosticsShown(status);
  }
  if (!isMyVerizonDiagnosticShown) {
    deviceDiagnosticsDeviceNotSupportedMsg = deviceDiagnosticsNoMvdButton;
  }
  var genericAPI = (deviceDiagnostics === null || deviceDiagnostics === void 0 ? void 0 : (_deviceDiagnostics$bo5 = deviceDiagnostics.body) === null || _deviceDiagnostics$bo5 === void 0 ? void 0 : (_deviceDiagnostics$bo6 = _deviceDiagnostics$bo5.data) === null || _deviceDiagnostics$bo6 === void 0 ? void 0 : _deviceDiagnostics$bo6.genericApiResponse) || {};
  var fiveGData = (genericAPI === null || genericAPI === void 0 ? void 0 : (_genericAPI$data = genericAPI.data) === null || _genericAPI$data === void 0 ? void 0 : _genericAPI$data.data) || {};
  if (userProfile && (userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$permissi = userProfile.permission) === null || _userProfile$permissi === void 0 ? void 0 : _userProfile$permissi.sessionPermission.ACSS_TRG_ENABLE_DD_UI) !== "Y") {
    if (acssTier === "2" || acssTier === "3") {
      return /*#__PURE__*/React__default.createElement(Notification, {
        disableAnimation: true,
        type: "info",
        title: "Please load MVD for this MDN, feature is temporarily unavailable.",
        buttonData: [{
          children: "MVD",
          "data-track": "MVD",
          onClick: handleVerizonLinkClick
        }]
      });
    } else {
      return /*#__PURE__*/React__default.createElement(Notification, {
        disableAnimation: true,
        type: "info",
        notificationStyles: {
          height: "auto;"
        },
        title: isHavingAccessToMVD2
      });
    }
  }
  if (operatingSystem.indexOf("Apple") >= 0 || operatingSystem.indexOf("iOS") >= 0) {
    if (acssTier === "2" || acssTier === "3") {
      var mvdButton = [];
      if (isMyVerizonDiagnosticShown) {
        mvdButton = [{
          children: "MVD",
          "data-track": "MVD",
          onClick: handleVerizonLinkClick
        }];
      }
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Notification, {
        id: "vds-notification-icon",
        disableAnimation: true,
        type: "info",
        title: deviceDiagnosticsDeviceNotSupportedMsg,
        buttonData: mvdButton
      }));
    } else {
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Notification, {
        id: "vds-notification-icon",
        disableAnimation: true,
        type: "info",
        title: isHavingAccessToMVD,
        notificationStyles: {
          height: "auto;"
        }
      }));
    }
  }
  if (IsNullOrUndefinedObj(deviceDiagnostics) || IsNullOrEmpty(deviceDiagnostics)) {
    return /*#__PURE__*/React__default.createElement(Fragment, null, deviceDiagnostics === 0 && /*#__PURE__*/React__default.createElement("div", {
      className: "diagnostics_loader"
    }, /*#__PURE__*/React__default.createElement(Loader$2, {
      active: true,
      fullscreen: false
    })), deviceDiagnostics !== 0 && /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      type: "error",
      hideCloseButton: true,
      notificationStyles: {
        height: "auto;"
      },
      children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "60%",
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("span", null, deviceFailedToLoadForMdn)), /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "10%",
          "float": "left",
          paddingLeft: "2%"
        }
      }, (acssTier === "2" || acssTier === "3") && /*#__PURE__*/React__default.createElement(StyledButton$4, _extends({}, dynamicProps, {
        size: "small",
        "data-track": "MVD",
        className: "plan-info-section-button",
        onClick: handleVerizonLinkClick
      }), "MVD")))
    }));
  }
  console.log(deviceDiagnostics, "ooooooooooooooo");
  var deviceDiagnosticsInfo = deviceDiagnostics === null || deviceDiagnostics === void 0 ? void 0 : (_deviceDiagnostics$an = deviceDiagnostics.androidDeviceDiagResponse) === null || _deviceDiagnostics$an === void 0 ? void 0 : (_deviceDiagnostics$an2 = _deviceDiagnostics$an.andriodData) === null || _deviceDiagnostics$an2 === void 0 ? void 0 : (_deviceDiagnostics$an3 = _deviceDiagnostics$an2.diagnosticsData) === null || _deviceDiagnostics$an3 === void 0 ? void 0 : (_deviceDiagnostics$an4 = _deviceDiagnostics$an3.mdnDeviceData) === null || _deviceDiagnostics$an4 === void 0 ? void 0 : (_deviceDiagnostics$an5 = _deviceDiagnostics$an4.versionData) === null || _deviceDiagnostics$an5 === void 0 ? void 0 : _deviceDiagnostics$an5.standard;
  var _ROOTED = (_deviceDiagnosticsInf = deviceDiagnosticsInfo === null || deviceDiagnosticsInfo === void 0 ? void 0 : (_deviceDiagnosticsInf2 = deviceDiagnosticsInfo.device) === null || _deviceDiagnosticsInf2 === void 0 ? void 0 : _deviceDiagnosticsInf2.rooted) != null ? _deviceDiagnosticsInf : " - ";
  var _ServiceState = (_deviceDiagnosticsInf3 = deviceDiagnosticsInfo === null || deviceDiagnosticsInfo === void 0 ? void 0 : (_deviceDiagnosticsInf4 = deviceDiagnosticsInfo.network) === null || _deviceDiagnosticsInf4 === void 0 ? void 0 : _deviceDiagnosticsInf4.serviceState) != null ? _deviceDiagnosticsInf3 : " - ";
  var _TEMPERATURE = (_deviceDiagnosticsInf5 = deviceDiagnosticsInfo === null || deviceDiagnosticsInfo === void 0 ? void 0 : (_deviceDiagnosticsInf6 = deviceDiagnosticsInfo.battery) === null || _deviceDiagnosticsInf6 === void 0 ? void 0 : _deviceDiagnosticsInf6.temperature) != null ? _deviceDiagnosticsInf5 : " - ";
  var _STORAGE = (_deviceDiagnosticsInf7 = deviceDiagnosticsInfo === null || deviceDiagnosticsInfo === void 0 ? void 0 : (_deviceDiagnosticsInf8 = deviceDiagnosticsInfo.storage) === null || _deviceDiagnosticsInf8 === void 0 ? void 0 : _deviceDiagnosticsInf8.free) != null ? _deviceDiagnosticsInf7 : " - ";
  var _HOTSPOT = (_deviceDiagnosticsInf9 = deviceDiagnosticsInfo === null || deviceDiagnosticsInfo === void 0 ? void 0 : (_deviceDiagnosticsInf0 = deviceDiagnosticsInfo.wifi) === null || _deviceDiagnosticsInf0 === void 0 ? void 0 : _deviceDiagnosticsInf0.hotspot) != null ? _deviceDiagnosticsInf9 : " - ";
  var _SIMSTATE = (_deviceDiagnosticsInf1 = deviceDiagnosticsInfo === null || deviceDiagnosticsInfo === void 0 ? void 0 : (_deviceDiagnosticsInf10 = deviceDiagnosticsInfo.network) === null || _deviceDiagnosticsInf10 === void 0 ? void 0 : _deviceDiagnosticsInf10.simState) != null ? _deviceDiagnosticsInf1 : " - ";
  var _RAM = (_deviceDiagnosticsInf11 = deviceDiagnosticsInfo === null || deviceDiagnosticsInfo === void 0 ? void 0 : (_deviceDiagnosticsInf12 = deviceDiagnosticsInfo.ram) === null || _deviceDiagnosticsInf12 === void 0 ? void 0 : _deviceDiagnosticsInf12.free) != null ? _deviceDiagnosticsInf11 : " - ";
  var _AirplaneMode = (_deviceDiagnosticsInf13 = deviceDiagnosticsInfo === null || deviceDiagnosticsInfo === void 0 ? void 0 : (_deviceDiagnosticsInf14 = deviceDiagnosticsInfo.network) === null || _deviceDiagnosticsInf14 === void 0 ? void 0 : _deviceDiagnosticsInf14.airplaneMode) != null ? _deviceDiagnosticsInf13 : " - ";
  var _BATTERY = (_deviceDiagnosticsInf15 = deviceDiagnosticsInfo === null || deviceDiagnosticsInfo === void 0 ? void 0 : (_deviceDiagnosticsInf16 = deviceDiagnosticsInfo.battery) === null || _deviceDiagnosticsInf16 === void 0 ? void 0 : _deviceDiagnosticsInf16.percentage) != null ? _deviceDiagnosticsInf15 : " - ";
  var _MALWARE = (_deviceDiagnosticsInf17 = deviceDiagnosticsInfo === null || deviceDiagnosticsInfo === void 0 ? void 0 : (_deviceDiagnosticsInf18 = deviceDiagnosticsInfo.security) === null || _deviceDiagnosticsInf18 === void 0 ? void 0 : _deviceDiagnosticsInf18.malware) != null ? _deviceDiagnosticsInf17 : " - ";
  var _4g = (_deviceDiagnosticsInf19 = deviceDiagnosticsInfo === null || deviceDiagnosticsInfo === void 0 ? void 0 : (_deviceDiagnosticsInf20 = deviceDiagnosticsInfo.network) === null || _deviceDiagnosticsInf20 === void 0 ? void 0 : _deviceDiagnosticsInf20.fourgSignal) != null ? _deviceDiagnosticsInf19 : " - ";
  var _3g = (_deviceDiagnosticsInf21 = deviceDiagnosticsInfo === null || deviceDiagnosticsInfo === void 0 ? void 0 : (_deviceDiagnosticsInf22 = deviceDiagnosticsInfo.network) === null || _deviceDiagnosticsInf22 === void 0 ? void 0 : _deviceDiagnosticsInf22.threegSignal) != null ? _deviceDiagnosticsInf21 : " - ";
  var _ENABLED = (_deviceDiagnosticsInf23 = deviceDiagnosticsInfo === null || deviceDiagnosticsInfo === void 0 ? void 0 : (_deviceDiagnosticsInf24 = deviceDiagnosticsInfo.wifi) === null || _deviceDiagnosticsInf24 === void 0 ? void 0 : _deviceDiagnosticsInf24.enabled) != null ? _deviceDiagnosticsInf23 : " - ";
  var _SSID = (_deviceDiagnosticsInf25 = deviceDiagnosticsInfo === null || deviceDiagnosticsInfo === void 0 ? void 0 : (_deviceDiagnosticsInf26 = deviceDiagnosticsInfo.wifi) === null || _deviceDiagnosticsInf26 === void 0 ? void 0 : _deviceDiagnosticsInf26.ssid) != null ? _deviceDiagnosticsInf25 : " - ";
  var _SIGNAL = (_deviceDiagnosticsInf27 = deviceDiagnosticsInfo === null || deviceDiagnosticsInfo === void 0 ? void 0 : (_deviceDiagnosticsInf28 = deviceDiagnosticsInfo.wifi) === null || _deviceDiagnosticsInf28 === void 0 ? void 0 : _deviceDiagnosticsInf28.signal) != null ? _deviceDiagnosticsInf27 : " - ";
  var _HDVoice = (_deviceDiagnosticsInf29 = deviceDiagnosticsInfo === null || deviceDiagnosticsInfo === void 0 ? void 0 : (_deviceDiagnosticsInf30 = deviceDiagnosticsInfo.advancedCalling) === null || _deviceDiagnosticsInf30 === void 0 ? void 0 : _deviceDiagnosticsInf30.voLteEnabled) != null ? _deviceDiagnosticsInf29 : " - ";
  var _WifiCalling = (_deviceDiagnosticsInf31 = deviceDiagnosticsInfo === null || deviceDiagnosticsInfo === void 0 ? void 0 : (_deviceDiagnosticsInf32 = deviceDiagnosticsInfo.advancedCalling) === null || _deviceDiagnosticsInf32 === void 0 ? void 0 : _deviceDiagnosticsInf32.voLteVoiceProvisioned) != null ? _deviceDiagnosticsInf31 : " - ";
  var _5g = "";
  if (fiveGData && fiveGData.data) {
    _5g = fiveGData.data.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : fiveGData.data;
  }
  var time = (_deviceDiagnostics$an6 = deviceDiagnostics === null || deviceDiagnostics === void 0 ? void 0 : (_deviceDiagnostics$an7 = deviceDiagnostics.androidDeviceDiagResponse) === null || _deviceDiagnostics$an7 === void 0 ? void 0 : (_deviceDiagnostics$an8 = _deviceDiagnostics$an7.andriodData) === null || _deviceDiagnostics$an8 === void 0 ? void 0 : (_deviceDiagnostics$an9 = _deviceDiagnostics$an8.diagnosticsData) === null || _deviceDiagnostics$an9 === void 0 ? void 0 : (_deviceDiagnostics$an0 = _deviceDiagnostics$an9.mdnDeviceData) === null || _deviceDiagnostics$an0 === void 0 ? void 0 : _deviceDiagnostics$an0.time) != null ? _deviceDiagnostics$an6 : " - ";
  var apiDate = currentDate ? getApiDate(time) : "";
  var _FactoryRest = (_deviceDiagnosticsInf33 = deviceDiagnosticsInfo === null || deviceDiagnosticsInfo === void 0 ? void 0 : (_deviceDiagnosticsInf34 = deviceDiagnosticsInfo.device) === null || _deviceDiagnosticsInf34 === void 0 ? void 0 : _deviceDiagnosticsInf34.lastFactoryReset) != null ? _deviceDiagnosticsInf33 : " - ";
  var _PowerOn = (_deviceDiagnosticsInf35 = deviceDiagnosticsInfo === null || deviceDiagnosticsInfo === void 0 ? void 0 : (_deviceDiagnosticsInf36 = deviceDiagnosticsInfo.device) === null || _deviceDiagnosticsInf36 === void 0 ? void 0 : _deviceDiagnosticsInf36.lastPowerOn) != null ? _deviceDiagnosticsInf35 : " - ";
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    id: "devDiagContent",
    className: "tabContainer",
    role: "tablist",
    style: {
      width: "100%"
    }
  }, isLoading && /*#__PURE__*/React__default.createElement(Loader$2, {
    active: true,
    className: "diagnostics_loader",
    fullscreen: false
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "deviceDiagButtons"
  }, apiDate, /*#__PURE__*/React__default.createElement(StyledButton$4, _extends({
    buttonStyles: {
      margin: "0px 0.625rem 0.625rem 0px;",
      display: "inline-flex;"
    },
    size: "small"
  }, dynamicProps, {
    className: "plan-info-section-button",
    onClick: onRefreshClick
  }), "Refresh"), (acssTier === "2" || acssTier === "3") && /*#__PURE__*/React__default.createElement(StyledButton$4, _extends({
    size: "small"
  }, dynamicProps, {
    buttonStyles: {
      margin: "0px 0.625rem 0.625rem 0px;",
      display: "inline-flex;"
    },
    "data-track": "MVD",
    className: "plan-info-section-button",
    onClick: handleVerizonLinkClick
  }), "MVD")), /*#__PURE__*/React__default.createElement("hr", {
    className: "dispHr"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "diagnostics"
  }, /*#__PURE__*/React__default.createElement("table", {
    summary: "Device diagnostics",
    className: "diagTable"
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("img", {
    className: "deviceImgs",
    src: rooted,
    height: "40px",
    width: "45px",
    alt: "Rooted icon"
  }), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("b", null, "Rooted"), " ", /*#__PURE__*/React__default.createElement("br", null), " ", _ROOTED.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : _ROOTED, " ")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("img", {
    className: "deviceImgs",
    src: serviceState,
    height: "40px",
    width: "45px",
    alt: "Service state icon"
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Service state"), " ", /*#__PURE__*/React__default.createElement("br", null), " ", _ServiceState.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : _ServiceState, " ")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("img", {
    className: "deviceImgs",
    src: temperture,
    height: "45px",
    width: "45px",
    alt: "Temperature icon"
  }), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("b", null, "Temperature"), " ", /*#__PURE__*/React__default.createElement("br", null), " ", _TEMPERATURE.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : _TEMPERATURE, " ")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("img", {
    className: "deviceImgs",
    src: storage,
    height: "40px",
    width: "45px",
    alt: "Storage icon"
  }), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("b", null, "Storage"), " ", /*#__PURE__*/React__default.createElement("br", null), " ", _STORAGE.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : _STORAGE, " ")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("img", {
    className: "deviceImgs",
    src: hotspot,
    height: "40px",
    width: "45px",
    alt: "Hotspot icon"
  }), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("b", null, "Hotspot"), " ", /*#__PURE__*/React__default.createElement("br", null), " ", _HOTSPOT.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : _HOTSPOT, " "))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("img", {
    className: "deviceImgs",
    src: sim,
    height: "40px",
    width: "45px",
    alt: "SIM State icon"
  }), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("b", null, "SIM State"), " ", /*#__PURE__*/React__default.createElement("br", null), " ", _SIMSTATE.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : _SIMSTATE, " ")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("img", {
    className: "deviceImgs",
    src: ram,
    height: "40px",
    width: "45px",
    alt: "RAM icon"
  }), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("b", null, "RAM"), " ", /*#__PURE__*/React__default.createElement("br", null), " ", _RAM.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : _RAM, " ")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("img", {
    className: "deviceImgs",
    src: airplaneMode,
    height: "40px",
    width: "45px",
    alt: "Airplane mode icon"
  }), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("b", null, "Airplane mode"), " ", /*#__PURE__*/React__default.createElement("br", null), " ", _AirplaneMode.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : _AirplaneMode, " ")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("img", {
    className: "deviceImgs",
    src: battery,
    height: "40px",
    width: "45px",
    alt: "Battery icon"
  }), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("b", null, "Battery"), " ", /*#__PURE__*/React__default.createElement("br", null), " ", _BATTERY.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : _BATTERY, " ")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("img", {
    className: "deviceImgs",
    src: malware,
    height: "40px",
    width: "45px",
    alt: "Malware icon"
  }), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("b", null, "Malware"), " ", /*#__PURE__*/React__default.createElement("br", null), " ", _MALWARE.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : _MALWARE, " ")))))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      marginLeft: "17px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "dispHeadings"
  }, /*#__PURE__*/React__default.createElement("b", {
    className: "dispTitle"
  }, "Network Signal"), " ", /*#__PURE__*/React__default.createElement("hr", {
    className: "dispHr",
    style: {
      backgroundColor: "black"
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "signalDiv"
  }, /*#__PURE__*/React__default.createElement("b", {
    className: "signalHeading"
  }, "3G"), /*#__PURE__*/React__default.createElement("div", {
    className: "signalImg"
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "barImg",
    src: signalStrength,
    height: "60px",
    width: "180px",
    alt: "3G signal range -105 (poor) to -65 (good)"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "downArrowImg",
    style: {
      marginLeft: get3gArrowPosition(_3g)
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    "aria-label": _3g + " out of range -105 to -65"
  }, /*#__PURE__*/React__default.createElement(DownArrow, {
    size: "small"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "signalData"
  }, " ", _3g.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : _3g), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "10px",
      fontSize: "10px",
      marginLeft: "9.5em"
    }
  }, /*#__PURE__*/React__default.createElement("pre", {
    style: {
      color: "black"
    }
  }, " \u2264 -105 -104 to -91 -90 to -66 \u2264 -65 "), " "))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "signalDiv"
  }, /*#__PURE__*/React__default.createElement("b", {
    className: "signalHeading"
  }, "4G"), /*#__PURE__*/React__default.createElement("div", {
    className: "signalImg"
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "barImg",
    src: signalStrength,
    height: "60px",
    width: "180px",
    alt: "4G signal range -115 (poor) to -85 (good)"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "downArrowImg",
    style: {
      marginLeft: get4gArrowPosition(_4g)
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    "aria-label": _4g + " out of range -115 to -85"
  }, /*#__PURE__*/React__default.createElement(DownArrow, {
    size: "small"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "signalData"
  }, " ", _4g.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : _4g), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "10px",
      fontSize: "10px",
      marginLeft: "9.5em"
    }
  }, /*#__PURE__*/React__default.createElement("pre", {
    style: {
      color: "black"
    }
  }, " \u2264 -115 -114 to -106 -105 to -86 \u2264 -85 "), " "))), /*#__PURE__*/React__default.createElement("br", null), _5g && /*#__PURE__*/React__default.createElement("div", {
    className: "signalDiv"
  }, /*#__PURE__*/React__default.createElement("b", {
    className: "signalHeading"
  }, get5g(_5g)), /*#__PURE__*/React__default.createElement("div", {
    className: "signalImg"
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "barImg",
    src: signalStrength,
    height: "60px",
    width: "180px",
    alt: "5G signal range -111 (poor) to -80 (good)"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "downArrowImg",
    style: {
      marginLeft: get5gArrowPosition(_5g)
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    "aria-label": _5g + " out of range -111 to -80"
  }, /*#__PURE__*/React__default.createElement(DownArrow, {
    color: ColorTokens.palette.black.value,
    size: "small"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "signalData"
  }, " ", _5g.toUpperCase() == "NOT RETRIEVABLE" ? "N?A" : _5g), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "10px",
      fontSize: "10px",
      marginLeft: "9.5em"
    }
  }, /*#__PURE__*/React__default.createElement("pre", {
    style: {
      color: "black"
    }
  }, " \u2264 -111 -110 to -91 -90 to -81 \u2264 -80 "), " ")))), /*#__PURE__*/React__default.createElement("div", {
    className: "dispHeadings"
  }, /*#__PURE__*/React__default.createElement("b", {
    className: "dispTitle"
  }, "WiFi Settings"), /*#__PURE__*/React__default.createElement("hr", {
    className: "dispHr",
    style: {
      backgroundColor: "black"
    }
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", {
    className: "dubTitle"
  }, "Enabled"), /*#__PURE__*/React__default.createElement("span", {
    className: "subText"
  }, " ", _ENABLED.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : _ENABLED, " ")), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", {
    className: "dubTitle"
  }, "SSID"), " ", /*#__PURE__*/React__default.createElement("span", {
    className: "subText"
  }, " ", _SSID.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : _SSID, " ")), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", {
    className: "dubTitle"
  }, "Signal"), " ", /*#__PURE__*/React__default.createElement("span", {
    className: "subText"
  }, " ", _SIGNAL.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : _SIGNAL, " "))), /*#__PURE__*/React__default.createElement("div", {
    className: "dispHeadings"
  }, /*#__PURE__*/React__default.createElement("b", {
    className: "dispTitle"
  }, "Device Details"), " ", /*#__PURE__*/React__default.createElement("hr", {
    className: "dispHr",
    style: {
      backgroundColor: "black"
    }
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", {
    className: "dubTitle"
  }, "HD Voice"), " ", /*#__PURE__*/React__default.createElement("span", {
    className: "subText2"
  }, " ", _HDVoice.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : _HDVoice, " ")), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", {
    className: "dubTitle"
  }, "WiFi Calling"), " ", /*#__PURE__*/React__default.createElement("span", {
    className: "subText2"
  }, " ", _WifiCalling.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : _WifiCalling, " ")), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", {
    className: "dubTitle"
  }, "Last Factory Reset"), " ", /*#__PURE__*/React__default.createElement("span", {
    className: "subText2"
  }, " ", _FactoryRest.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : _FactoryRest, " ")), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", {
    className: "dubTitle"
  }, "Last Power On"), " ", /*#__PURE__*/React__default.createElement("span", {
    className: "subText2"
  }, " ", _PowerOn.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : _PowerOn, " ")))))));
}

var _templateObject$1z;
function ConnectedDevices(props) {
  var _networkData$connecte3, _networkData$connecte4, _networkData$connecte5, _networkData$connecte6, _networkData$connecte7, _networkData$connecte8, _networkData$connecte9, _networkData$connecte0;
  var _useNetworkData = useNetworkData(props),
    networkResponse = _useNetworkData.data;
  var _useState = useState(false),
    isLoading = _useState[0],
    setIsLoading = _useState[1];
  var _useState2 = useState([]),
    connectedDevices = _useState2[0],
    setConnectedDevices = _useState2[1];
  var _useState3 = useState([]),
    wifiOptions = _useState3[0],
    setWifiOptions = _useState3[1];
  var _useState4 = useState([]),
    statusOptions = _useState4[0],
    setStatusOptions = _useState4[1];
  var _useState5 = useState([]),
    deviceTypeOptions = _useState5[0],
    setDeviceTypeOptions = _useState5[1];
  var _useState6 = useState("ALL"),
    wifiRadioValue = _useState6[0],
    setWifiRadioValue = _useState6[1];
  var _useState7 = useState([]),
    statusValue = _useState7[0],
    setStatusValue = _useState7[1];
  var _useState8 = useState([]),
    deviceTypeValue = _useState8[0],
    setDeviceTypeValue = _useState8[1];
  var _useState9 = useState({}),
    networkData = _useState9[0],
    setNetworkData = _useState9[1];
  var DropDownWrapper = styled.div(_templateObject$1z || (_templateObject$1z = _taggedTemplateLiteralLoose(["\n    [class*=LabelWrapper-VDS__] p{\n      font-weight: bold;\n    }    \n  "])));
  useEffect(function () {
    var _networkResponse$resp, _networkResponse$resp2, _networkResponse$resp3;
    setNetworkData(networkResponse === null || networkResponse === void 0 ? void 0 : (_networkResponse$resp = networkResponse.response) === null || _networkResponse$resp === void 0 ? void 0 : (_networkResponse$resp2 = _networkResponse$resp.data) === null || _networkResponse$resp2 === void 0 ? void 0 : (_networkResponse$resp3 = _networkResponse$resp2.body) === null || _networkResponse$resp3 === void 0 ? void 0 : _networkResponse$resp3.data);
  }, [networkResponse]);
  useEffect(function () {
    if (networkData && typeof networkData === "object" && Object.keys(networkData).length !== 0) {
      getDropdownValues();
    }
    setIsLoading(false);
  }, [networkData]);
  var filterOutDuplicates = function filterOutDuplicates(attrList) {
    if (attrList === void 0) {
      attrList = [];
    }
    return attrList.filter(function (el, index, arr) {
      return el && arr.indexOf(el) === index;
    });
  };
  var getDropdownValues = function getDropdownValues() {
    var _networkData$connecte;
    var connectedDevices = (networkData === null || networkData === void 0 ? void 0 : (_networkData$connecte = networkData.connectedDevices) === null || _networkData$connecte === void 0 ? void 0 : _networkData$connecte.connectedDevicesAttributes) || [];
    var wifiOpt = connectedDevices.map(function (data) {
      return data.wifiRadio;
    });
    var statusOpt = connectedDevices.map(function (data) {
      return data.status;
    });
    var deviceTypeOpt = connectedDevices.map(function (data) {
      return data.deviceType;
    });
    wifiOpt = filterOutDuplicates(wifiOpt);
    wifiOpt.unshift("All");
    statusOpt = filterOutDuplicates(statusOpt);
    statusOpt.unshift("All");
    deviceTypeOpt = filterOutDuplicates(deviceTypeOpt);
    deviceTypeOpt.unshift("All");
    setConnectedDevices(connectedDevices);
    setWifiOptions(wifiOpt);
    setStatusOptions(statusOpt);
    setDeviceTypeOptions(deviceTypeOpt);
    setWifiRadioValue("All");
    setStatusValue("All");
    setDeviceTypeValue("All");
  };
  var generateConnectDevicesRows = function generateConnectDevicesRows(data) {
    return data.map(function (el) {
      return /*#__PURE__*/React__default.createElement("tr", {
        style: {
          borderBottom: "1px solid #DCDCDC"
        }
      }, /*#__PURE__*/React__default.createElement("td", {
        className: "record-device columnHostName"
      }, el.hostName), /*#__PURE__*/React__default.createElement("td", {
        className: "record-device columnMAC"
      }, el.macAddress), /*#__PURE__*/React__default.createElement("td", {
        className: "record-device columnChannel"
      }, el.channel), /*#__PURE__*/React__default.createElement("td", {
        className: "record-device columnAccessPoint"
      }, el.accessPoint), /*#__PURE__*/React__default.createElement("td", {
        className: "record-device columnDropDown"
      }, el.wifiRadio), /*#__PURE__*/React__default.createElement("td", {
        className: "record-device columnDropDown"
      }, el.status), /*#__PURE__*/React__default.createElement("td", {
        className: "record-device columnDropDown"
      }, el.deviceType));
    });
  };
  var onWifiRadioChange = function onWifiRadioChange(eventVal) {
    var selectedVal = eventVal.currentTarget.value;
    setWifiRadioValue(selectedVal);
    filterData(selectedVal, statusValue, deviceTypeValue);
  };
  var onStatusChange = function onStatusChange(eventVal) {
    var selectedVal = eventVal.currentTarget.value;
    setStatusValue(selectedVal);
    filterData(wifiRadioValue, selectedVal, deviceTypeValue);
  };
  var onDeviceTypeChange = function onDeviceTypeChange(eventVal) {
    var selectedVal = eventVal.currentTarget.value;
    setDeviceTypeValue(selectedVal);
    filterData(wifiRadioValue, statusValue, selectedVal);
  };
  var filterData = function filterData(wifiRadioValue, statusValue, deviceTypeValue) {
    var _networkData$connecte2;
    var connectedDevices = (networkData === null || networkData === void 0 ? void 0 : (_networkData$connecte2 = networkData.connectedDevices) === null || _networkData$connecte2 === void 0 ? void 0 : _networkData$connecte2.connectedDevicesAttributes) || [];
    connectedDevices = wifiRadioValue !== "All" ? connectedDevices.filter(function (el) {
      return el.wifiRadio && el.wifiRadio.toLowerCase() === wifiRadioValue.toLowerCase();
    }) : connectedDevices;
    connectedDevices = statusValue !== "All" ? connectedDevices.filter(function (el) {
      return el.status && el.status.toLowerCase() === statusValue.toLowerCase();
    }) : connectedDevices;
    connectedDevices = deviceTypeValue !== "All" ? connectedDevices.filter(function (el) {
      return el.deviceType && el.deviceType.toLowerCase() === deviceTypeValue.toLowerCase();
    }) : connectedDevices;
    setConnectedDevices(connectedDevices);
  };
  var onRefreshClick = function onRefreshClick() {
    try {
      setIsLoading(true);
      var dataPayload = payloadUseNetworkData(props, "connected_devices");
      return Promise.resolve(getNetworkData(dataPayload).then(function (data) {
        console.log("on retry data++++++", data);
        if (data) {
          var _data$response, _data$response$data, _data$response$data$b;
          setIsLoading(false);
          setNetworkData(data === null || data === void 0 ? void 0 : (_data$response = data.response) === null || _data$response === void 0 ? void 0 : (_data$response$data = _data$response.data) === null || _data$response$data === void 0 ? void 0 : (_data$response$data$b = _data$response$data.body) === null || _data$response$data$b === void 0 ? void 0 : _data$response$data$b.data);
        }
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var dynamicProps =  {
    primary: true
  } ;
  var connectedTabState = (networkData === null || networkData === void 0 ? void 0 : (_networkData$connecte3 = networkData.connectedDevices) === null || _networkData$connecte3 === void 0 ? void 0 : (_networkData$connecte4 = _networkData$connecte3.header) === null || _networkData$connecte4 === void 0 ? void 0 : _networkData$connecte4.state) || "";
  if (connectedTabState === "COMPLETED") {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "mainDiv"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "tabContainer",
      role: "tablist",
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      "data-testid": "heading",
      className: "connectDevice_heading"
    }, "Connected Devices"), /*#__PURE__*/React__default.createElement("div", {
      className: "refresh_right"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "refresh_button_div_device"
    }, /*#__PURE__*/React__default.createElement(StyledButton$4, _extends({}, dynamicProps, {
      size: "small",
      className: "refresh_button_device",
      "data-testid": "onRefresh",
      disabled: isLoading,
      onClick: onRefreshClick
    }), "Refresh")), /*#__PURE__*/React__default.createElement("div", {
      className: "refresh_img"
    }, isLoading && /*#__PURE__*/React__default.createElement("div", {
      className: "spinnerLoader"
    })))), /*#__PURE__*/React__default.createElement("hr", {
      className: "head_line",
      style: {
        width: "100%"
      }
    }), /*#__PURE__*/React__default.createElement("table", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "hostName",
      className: "record-device columnHostName"
    }, "Host Name"), /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "macAddress",
      className: "record-device columnMAC"
    }, "MAC Address"), /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "channel",
      className: "record-device columnChannel"
    }, "Channel"), /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "accessPoint",
      className: "record-device columnAccessPoint"
    }, "Access Point"), /*#__PURE__*/React__default.createElement("th", {
      className: "record-device columnDropDown"
    }, /*#__PURE__*/React__default.createElement(DropDownWrapper, {
      className: "Dropdown"
    }, /*#__PURE__*/React__default.createElement(DropdownSelect, {
      "data-testid": "dropDown",
      size: "small",
      label: "WiFi Radio",
      className: "dropdownMenu",
      selectStyles: {
        height: "1.562rem",
        padding: "0 0 0 5px",
        iconRight: "0",
        fontSize: "0.7rem",
        fontWeight: "bold",
        svgIconHeight: "10px"
      },
      selectOptions: wifiOptions,
      onChange: onWifiRadioChange,
      surface: props !== null && props !== void 0 && props.isDark ? 'dark' : 'light'
    }, wifiOptions && wifiOptions.length > 0 && wifiOptions.map(function (item, index) {
      return /*#__PURE__*/React__default.createElement("option", {
        value: item,
        key: item + "_" + index,
        selected: wifiRadioValue === item
      }, item);
    })))), /*#__PURE__*/React__default.createElement("th", {
      className: "record-device columnDropDown"
    }, /*#__PURE__*/React__default.createElement(DropDownWrapper, {
      className: "Dropdown"
    }, /*#__PURE__*/React__default.createElement(DropdownSelect, {
      selectId: "status_options",
      label: "Status",
      onChange: onStatusChange,
      "data-testid": "statusOptions",
      surface: props !== null && props !== void 0 && props.isDark ? 'dark' : 'light'
    }, statusOptions && statusOptions.length > 0 && statusOptions.map(function (item, index) {
      return /*#__PURE__*/React__default.createElement("option", {
        value: item,
        key: item + "_" + index,
        selected: statusValue === item
      }, item);
    })))), /*#__PURE__*/React__default.createElement("th", {
      className: "record-device columnDropDown"
    }, /*#__PURE__*/React__default.createElement(DropDownWrapper, {
      className: "Dropdown"
    }, /*#__PURE__*/React__default.createElement(DropdownSelect, {
      size: "small",
      label: "Device Type",
      className: "dropdownMenu",
      selectOptions: deviceTypeOptions,
      "data-testId": "deviceType",
      onChange: onDeviceTypeChange,
      selectStyles: {
        height: "1.562rem",
        padding: "0 0 0 5px",
        iconRight: "0",
        fontSize: "0.7rem",
        fontWeight: "bold",
        svgIconHeight: "10px"
      },
      surface: props !== null && props !== void 0 && props.isDark ? 'dark' : 'light'
    }, deviceTypeOptions && deviceTypeOptions.length > 0 && deviceTypeOptions.map(function (item, index) {
      return /*#__PURE__*/React__default.createElement("option", {
        value: item,
        key: item + "_" + index,
        selected: deviceTypeValue === item
      }, item);
    }))))), /*#__PURE__*/React__default.createElement(Fragment, null, generateConnectDevicesRows(connectedDevices))));
  } else if (connectedTabState === "FAILED") {
    return /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      hideCloseButton: true,
      type: "error",
      id: "notfication-cont",
      notificationStyles: {
        height: "auto;"
      },
      children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "70%",
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        "data-testid": "dataLoadning"
      }, "The data has failed to load, please retry.")), /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "10%",
          "float": "left"
        }
      }, isLoading && /*#__PURE__*/React__default.createElement("div", {
        className: "spinnerLoader"
      })), /*#__PURE__*/React__default.createElement("div", {
        style: {}
      }, /*#__PURE__*/React__default.createElement(StyledButton$4, {
        size: "small",
        "data-track": "Retry-Button",
        id: "noti-retry-btn",
        disabled: isLoading,
        onClick: onRefreshClick
      }, "Retry")))
    });
  } else if (connectedTabState === "INPROGRESS") {
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      id: "vds-notification-icon",
      hideCloseButton: true,
      type: "info",
      children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "96%",
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "The data is still loading and will refresh when it's complete.")), /*#__PURE__*/React__default.createElement("div", {
        style: {
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "spinnerLoader"
      })))
    }));
  } else if ((networkData === null || networkData === void 0 ? void 0 : networkData.state) == "COMPLETED" && (IsNullOrUndefinedObj(networkData === null || networkData === void 0 ? void 0 : networkData.connectedDevices) || IsNullOrEmpty(networkData === null || networkData === void 0 ? void 0 : networkData.connectedDevices) || IsNullOrUndefinedObj(networkData === null || networkData === void 0 ? void 0 : (_networkData$connecte5 = networkData.connectedDevices) === null || _networkData$connecte5 === void 0 ? void 0 : _networkData$connecte5.header) || IsNullOrEmpty(networkData === null || networkData === void 0 ? void 0 : (_networkData$connecte6 = networkData.connectedDevices) === null || _networkData$connecte6 === void 0 ? void 0 : _networkData$connecte6.header) || IsNullOrUndefinedObj(networkData === null || networkData === void 0 ? void 0 : (_networkData$connecte7 = networkData.connectedDevices) === null || _networkData$connecte7 === void 0 ? void 0 : (_networkData$connecte8 = _networkData$connecte7.header) === null || _networkData$connecte8 === void 0 ? void 0 : _networkData$connecte8.state) || IsNullOrEmpty(networkData === null || networkData === void 0 ? void 0 : (_networkData$connecte9 = networkData.connectedDevices) === null || _networkData$connecte9 === void 0 ? void 0 : (_networkData$connecte0 = _networkData$connecte9.header) === null || _networkData$connecte0 === void 0 ? void 0 : _networkData$connecte0.state))) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "no-data-class vds-notification-icon"
    }, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      type: "info",
      title: "No Connected Device Records available for this MDN.",
      fullBleed: true,
      inlineTreatment: false,
      layout: "horizontal",
      hideCloseButton: true
    }));
  } else return /*#__PURE__*/React__default.createElement(Notification, {
    disableAnimation: true,
    hideCloseButton: true,
    type: "error",
    id: "notfication-cont",
    notificationStyles: {
      height: "auto;"
    },
    children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "70%",
        "float": "left"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      "data-testid": "dataLoadning"
    }, "Data loading is in progress or has failed to load.")), /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "10%",
        "float": "left"
      }
    }, isLoading && /*#__PURE__*/React__default.createElement("div", {
      className: "spinnerLoader"
    })), /*#__PURE__*/React__default.createElement("div", {
      style: {}
    }, /*#__PURE__*/React__default.createElement(StyledButton$4, {
      size: "small",
      "data-track": "Retry-Button",
      id: "noti-retry-btn",
      disabled: isLoading,
      onClick: onRefreshClick
    }, "Retry")))
  });
}

function WifiSettings(props) {
  var _window2, _window2$caseDetails, _networkData$routerIn, _networkData$routerIn2, _networkData$routerIn3, _networkData$routerIn4, _networkData$routerIn5, _networkData$routerIn6, _networkData$routerIn7, _networkData$routerIn8, _networkData$routerIn9, _networkData$routerIn0, _networkData$routerIn1, _networkData$routerIn10, _networkData$routerIn11, _networkData$routerIn12, _routerInterfaces$wif, _routerInterfaces$wif2, _routerInterfaces$wif3, _routerInterfaces$wif4, _routerInterfaces$wif5, _routerInterfaces$wif6, _routerInterfaces$wif7, _routerInterfaces$wif8, _routerInterfaces$wif9, _routerInterfaces$wif0, _routerInterfaces$wif1, _routerInterfaces$wif10, _routerInterfaces$wif11, _routerInterfaces$wif12, _routerInterfaces$wif13, _routerInterfaces$wif14, _routerInterfaces$wif15, _routerInterfaces$wif16, _routerInterfaces$wif17, _routerInterfaces$wif18, _routerInterfaces$wif19, _routerInterfaces$wif20, _routerInterfaces$wif21, _routerInterfaces$wif22, _routerInterfaces$wif23, _routerInterfaces$wif24, _routerInterfaces$wif25, _routerInterfaces$wif26, _routerInterfaces$wif27, _routerInterfaces$wif28, _routerInterfaces$wif29, _routerInterfaces$wif30, _routerInterfaces$wif31, _routerInterfaces$wif32, _routerInterfaces$wif33, _routerInterfaces$wif34, _routerInterfaces$wif35, _routerInterfaces$wif36, _routerInterfaces$wif37, _routerInterfaces$wif38, _routerInterfaces$wif39, _routerInterfaces$wif40, _routerInterfaces$wif41, _routerInterfaces$wif42, _routerInterfaces$wif43, _routerInterfaces$wif44, _routerInterfaces$wif45, _routerInterfaces$wif46, _routerInterfaces$wif47, _routerInterfaces$wif48, _routerInterfaces$wif49, _routerInterfaces$wif50, _routerInterfaces$wif51, _routerInterfaces$wif52, _routerInterfaces$wif53, _routerInterfaces$wif54, _routerInterfaces$wif55, _routerInterfaces$wif56, _routerInterfaces$wif57, _routerInterfaces$wif58, _routerInterfaces$wif59, _routerInterfaces$wif60, _routerInterfaces$wif61, _routerInterfaces$wif62, _routerInterfaces$wif63, _routerInterfaces$wif64, _routerInterfaces$wif65, _routerInterfaces$wif66, _routerInterfaces$wif67, _routerInterfaces$wif68, _routerInterfaces$wif69, _routerInterfaces$wif70, _routerInterfaces$wif71, _routerInterfaces$wif72, _routerInterfaces$wif73, _routerInterfaces$wif74, _routerInterfaces$wif75, _routerInterfaces$wif76, _routerInterfaces$wif77, _routerInterfaces$wif78, _networkData$routerIn13, _networkData$routerIn14, _networkData$routerIn15, _networkData$routerIn16, _networkData$routerIn17, _networkData$routerIn18;
  var _useDeviceData = useDeviceData(props),
    deviceResponse = _useDeviceData.data;
  var _useNetworkData = useNetworkData(props),
    networkResponse = _useNetworkData.data;
  var _useState = useState({}),
    rebootAndReset = _useState[0],
    setRebootAndReset = _useState[1];
  var _useState2 = useState(""),
    notificationText = _useState2[0],
    setNotificationText = _useState2[1];
  var _useState3 = useState(false),
    loading = _useState3[0],
    setLoading = _useState3[1];
  var _useState4 = useState(""),
    _rebootAndResetResponseState = _useState4[0],
    setRebootAndResetResponseState = _useState4[1];
  var _useState5 = useState(false),
    notification = _useState5[0],
    setNotification = _useState5[1];
  var _useState6 = useState({}),
    deviceData = _useState6[0],
    setdeviceData = _useState6[1];
  var _useState7 = useState({}),
    networkData = _useState7[0],
    setNetworkData = _useState7[1];
  useEffect(function () {
    var _deviceResponse$respo, _deviceResponse$respo2, _deviceResponse$respo3, _networkResponse$resp, _networkResponse$resp2, _networkResponse$resp3;
    setdeviceData(deviceResponse === null || deviceResponse === void 0 ? void 0 : (_deviceResponse$respo = deviceResponse.response) === null || _deviceResponse$respo === void 0 ? void 0 : (_deviceResponse$respo2 = _deviceResponse$respo.data) === null || _deviceResponse$respo2 === void 0 ? void 0 : (_deviceResponse$respo3 = _deviceResponse$respo2.body) === null || _deviceResponse$respo3 === void 0 ? void 0 : _deviceResponse$respo3.data);
    setNetworkData(networkResponse === null || networkResponse === void 0 ? void 0 : (_networkResponse$resp = networkResponse.response) === null || _networkResponse$resp === void 0 ? void 0 : (_networkResponse$resp2 = _networkResponse$resp.data) === null || _networkResponse$resp2 === void 0 ? void 0 : (_networkResponse$resp3 = _networkResponse$resp2.body) === null || _networkResponse$resp3 === void 0 ? void 0 : _networkResponse$resp3.data);
  }, [deviceResponse, networkResponse]);
  var onRetryClick = function onRetryClick() {
    try {
      setLoading(true);
      var dataPayload = payloadUseNetworkData(props, "routerInterfaces");
      return Promise.resolve(getNetworkData(dataPayload).then(function (data) {
        console.log("on retry data++++++", data);
        if (data) {
          var _data$response, _data$response$data, _data$response$data$b;
          setLoading(false);
          setNetworkData(data === null || data === void 0 ? void 0 : (_data$response = data.response) === null || _data$response === void 0 ? void 0 : (_data$response$data = _data$response.data) === null || _data$response$data === void 0 ? void 0 : (_data$response$data$b = _data$response$data.body) === null || _data$response$data$b === void 0 ? void 0 : _data$response$data$b.data);
        }
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var wifiReset = function wifiReset() {
    var _window, _window$caseDetails;
    setNotification(false);
    setRebootAndReset({});
    var _ref = props || {},
      _ref$params = _ref.params,
      _ref$params2 = _ref$params === void 0 ? {} : _ref$params,
      _ref$params2$mdn = _ref$params2.mdn,
      mdn = _ref$params2$mdn === void 0 ? '' : _ref$params2$mdn;
    var mtn = ((_window = window) === null || _window === void 0 ? void 0 : (_window$caseDetails = _window.caseDetails) === null || _window$caseDetails === void 0 ? void 0 : _window$caseDetails.mtn) || mdn;
    var req = {
      transactionId: networkData === null || networkData === void 0 ? void 0 : networkData.transactionId,
      command: "resetWifi",
      type: "startCommand",
      mdn: mtn
    };
    getRebootAndReset(req).then(function (resp) {
      var _resp$response$data, _resp$response$data$b;
      setNotification(true);
      if (resp !== null && resp !== void 0 && (_resp$response$data = resp.response.data) !== null && _resp$response$data !== void 0 && (_resp$response$data$b = _resp$response$data.body) !== null && _resp$response$data$b !== void 0 && _resp$response$data$b.data) {
        var _resp$response, _resp$response$data2, _resp$response$data2$;
        var routerResp = resp === null || resp === void 0 ? void 0 : (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : (_resp$response$data2 = _resp$response.data) === null || _resp$response$data2 === void 0 ? void 0 : (_resp$response$data2$ = _resp$response$data2.body) === null || _resp$response$data2$ === void 0 ? void 0 : _resp$response$data2$.data;
        setRebootAndReset(routerResp);
        setNotificationText("");
        setRebootAndResetResponseState("");
      }
    });
  };
  useEffect(function () {
    var _rebootAndReset$resul, _rebootAndReset$resul2, _rebootAndReset$resul3, _rebootAndReset$resul4;
    setNotificationText(rebootAndReset === null || rebootAndReset === void 0 ? void 0 : (_rebootAndReset$resul = rebootAndReset.resultHeader) === null || _rebootAndReset$resul === void 0 ? void 0 : (_rebootAndReset$resul2 = _rebootAndReset$resul[0]) === null || _rebootAndReset$resul2 === void 0 ? void 0 : _rebootAndReset$resul2.explanation);
    setRebootAndResetResponseState(rebootAndReset === null || rebootAndReset === void 0 ? void 0 : (_rebootAndReset$resul3 = rebootAndReset.resultHeader) === null || _rebootAndReset$resul3 === void 0 ? void 0 : (_rebootAndReset$resul4 = _rebootAndReset$resul3[0]) === null || _rebootAndReset$resul4 === void 0 ? void 0 : _rebootAndReset$resul4.state);
    setLoading(false);
  }, [notificationText, _rebootAndResetResponseState, loading]);
  var routerInterfaces = (networkData === null || networkData === void 0 ? void 0 : networkData.routerInterfaces) || "";
  var deviceWifieNotSupportedMsg = "Device Wifi Not Avaliable";
  var _ref2 = props || {},
    _ref2$params = _ref2.params,
    _ref2$params2 = _ref2$params === void 0 ? {} : _ref2$params,
    _ref2$params2$mdn = _ref2$params2.mdn,
    mdn = _ref2$params2$mdn === void 0 ? '' : _ref2$params2$mdn;
  var selectedMTN = ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$caseDetails = _window2.caseDetails) === null || _window2$caseDetails === void 0 ? void 0 : _window2$caseDetails.mtn) || mdn;
  var selectedMTNData;
  if (deviceData) {
    var _deviceData$customerI, _deviceData$customerI2, _deviceData$customerI3;
    var mtns = deviceData === null || deviceData === void 0 ? void 0 : (_deviceData$customerI = deviceData.customerInsight) === null || _deviceData$customerI === void 0 ? void 0 : (_deviceData$customerI2 = _deviceData$customerI.billAccounts) === null || _deviceData$customerI2 === void 0 ? void 0 : (_deviceData$customerI3 = _deviceData$customerI2[0]) === null || _deviceData$customerI3 === void 0 ? void 0 : _deviceData$customerI3.mtns;
    selectedMTNData = mtns ? mtns.find(function (e) {
      return e.mtn === selectedMTN;
    }) : {};
  }
  var isFWADevice_ = isFWADevice(selectedMTNData);
  var dynamicProps =  {
    primary: true
  } ;
  var WifiSettingTabState = (networkData === null || networkData === void 0 ? void 0 : (_networkData$routerIn = networkData.routerInterfaces) === null || _networkData$routerIn === void 0 ? void 0 : (_networkData$routerIn2 = _networkData$routerIn.header) === null || _networkData$routerIn2 === void 0 ? void 0 : _networkData$routerIn2.state) || "";
  var failedMessage = "The data has failed to load, please retry.";
  if (!isFWADevice_) {
    return /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      type: "info",
      notificationStyles: {
        height: "auto;"
      },
      title: deviceWifieNotSupportedMsg
    });
  }
  var _Channel_Type1 = (networkData === null || networkData === void 0 ? void 0 : (_networkData$routerIn3 = networkData.routerInterfaces) === null || _networkData$routerIn3 === void 0 ? void 0 : (_networkData$routerIn4 = _networkData$routerIn3.wifiInterfaceList) === null || _networkData$routerIn4 === void 0 ? void 0 : (_networkData$routerIn5 = _networkData$routerIn4[0]) === null || _networkData$routerIn5 === void 0 ? void 0 : _networkData$routerIn5.channelType) || " - ";
  var _Channel_Type2 = (networkData === null || networkData === void 0 ? void 0 : (_networkData$routerIn6 = networkData.routerInterfaces) === null || _networkData$routerIn6 === void 0 ? void 0 : (_networkData$routerIn7 = _networkData$routerIn6.wifiInterfaceList) === null || _networkData$routerIn7 === void 0 ? void 0 : (_networkData$routerIn8 = _networkData$routerIn7[1]) === null || _networkData$routerIn8 === void 0 ? void 0 : _networkData$routerIn8.channelType) || " - ";
  var _Channel_Type3 = (networkData === null || networkData === void 0 ? void 0 : (_networkData$routerIn9 = networkData.routerInterfaces) === null || _networkData$routerIn9 === void 0 ? void 0 : (_networkData$routerIn0 = _networkData$routerIn9.wifiInterfaceList) === null || _networkData$routerIn0 === void 0 ? void 0 : (_networkData$routerIn1 = _networkData$routerIn0[2]) === null || _networkData$routerIn1 === void 0 ? void 0 : _networkData$routerIn1.channelType) || " - ";
  var _Channel_Type4 = (networkData === null || networkData === void 0 ? void 0 : (_networkData$routerIn10 = networkData.routerInterfaces) === null || _networkData$routerIn10 === void 0 ? void 0 : (_networkData$routerIn11 = _networkData$routerIn10.wifiInterfaceList) === null || _networkData$routerIn11 === void 0 ? void 0 : (_networkData$routerIn12 = _networkData$routerIn11[3]) === null || _networkData$routerIn12 === void 0 ? void 0 : _networkData$routerIn12.channelType) || " - ";
  var _Enable_2_4_Guest = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif === void 0 ? void 0 : (_routerInterfaces$wif2 = _routerInterfaces$wif[0]) === null || _routerInterfaces$wif2 === void 0 ? void 0 : _routerInterfaces$wif2.radioEnable) || " - ";
  var _Enable_2_4_Home = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif3 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif3 === void 0 ? void 0 : (_routerInterfaces$wif4 = _routerInterfaces$wif3[1]) === null || _routerInterfaces$wif4 === void 0 ? void 0 : _routerInterfaces$wif4.radioEnable) || " - ";
  var _Enable_5_Guest = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif5 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif5 === void 0 ? void 0 : (_routerInterfaces$wif6 = _routerInterfaces$wif5[2]) === null || _routerInterfaces$wif6 === void 0 ? void 0 : _routerInterfaces$wif6.radioEnable) || " - ";
  var _Enable_5_Home = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif7 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif7 === void 0 ? void 0 : (_routerInterfaces$wif8 = _routerInterfaces$wif7[3]) === null || _routerInterfaces$wif8 === void 0 ? void 0 : _routerInterfaces$wif8.radioEnable) || " - ";
  var _SSID_2_4_Guest = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif9 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif9 === void 0 ? void 0 : (_routerInterfaces$wif0 = _routerInterfaces$wif9[0]) === null || _routerInterfaces$wif0 === void 0 ? void 0 : _routerInterfaces$wif0.ssid) || " - ";
  var _SSID_2_4_Home = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif1 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif1 === void 0 ? void 0 : (_routerInterfaces$wif10 = _routerInterfaces$wif1[1]) === null || _routerInterfaces$wif10 === void 0 ? void 0 : _routerInterfaces$wif10.ssid) || " - ";
  var _SSID_5_Guest = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif11 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif11 === void 0 ? void 0 : (_routerInterfaces$wif12 = _routerInterfaces$wif11[2]) === null || _routerInterfaces$wif12 === void 0 ? void 0 : _routerInterfaces$wif12.ssid) || " - ";
  var _SSID_5_Home = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif13 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif13 === void 0 ? void 0 : (_routerInterfaces$wif14 = _routerInterfaces$wif13[3]) === null || _routerInterfaces$wif14 === void 0 ? void 0 : _routerInterfaces$wif14.ssid) || " - ";
  var _NetworkStatus_2_4_Guest = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif15 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif15 === void 0 ? void 0 : (_routerInterfaces$wif16 = _routerInterfaces$wif15[0]) === null || _routerInterfaces$wif16 === void 0 ? void 0 : _routerInterfaces$wif16.networkStatus) || " - ";
  var _NetworkStatus_2_4_Home = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif17 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif17 === void 0 ? void 0 : (_routerInterfaces$wif18 = _routerInterfaces$wif17[1]) === null || _routerInterfaces$wif18 === void 0 ? void 0 : _routerInterfaces$wif18.networkStatus) || " - ";
  var _NetworkStatus_5_Guest = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif19 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif19 === void 0 ? void 0 : (_routerInterfaces$wif20 = _routerInterfaces$wif19[2]) === null || _routerInterfaces$wif20 === void 0 ? void 0 : _routerInterfaces$wif20.networkStatus) || " - ";
  var _NetworkStatus_5_Home = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif21 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif21 === void 0 ? void 0 : (_routerInterfaces$wif22 = _routerInterfaces$wif21[3]) === null || _routerInterfaces$wif22 === void 0 ? void 0 : _routerInterfaces$wif22.networkStatus) || " - ";
  var _ChannelOccupancy_2_4_Guest = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif23 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif23 === void 0 ? void 0 : (_routerInterfaces$wif24 = _routerInterfaces$wif23[0]) === null || _routerInterfaces$wif24 === void 0 ? void 0 : _routerInterfaces$wif24.channelOccupancy) || " - ";
  var _ChannelOccupancy_2_4_Home = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif25 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif25 === void 0 ? void 0 : (_routerInterfaces$wif26 = _routerInterfaces$wif25[1]) === null || _routerInterfaces$wif26 === void 0 ? void 0 : _routerInterfaces$wif26.channelOccupancy) || " - ";
  var _ChannelOccupancy_5_Guest = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif27 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif27 === void 0 ? void 0 : (_routerInterfaces$wif28 = _routerInterfaces$wif27[2]) === null || _routerInterfaces$wif28 === void 0 ? void 0 : _routerInterfaces$wif28.channelOccupancy) || " - ";
  var _ChannelOccupancy_5_Home = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif29 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif29 === void 0 ? void 0 : (_routerInterfaces$wif30 = _routerInterfaces$wif29[3]) === null || _routerInterfaces$wif30 === void 0 ? void 0 : _routerInterfaces$wif30.channelOccupancy) || " - ";
  var _Channel_2_4_Guest = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif31 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif31 === void 0 ? void 0 : (_routerInterfaces$wif32 = _routerInterfaces$wif31[0]) === null || _routerInterfaces$wif32 === void 0 ? void 0 : _routerInterfaces$wif32.channel) || " - ";
  var _Channel_2_4_Home = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif33 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif33 === void 0 ? void 0 : (_routerInterfaces$wif34 = _routerInterfaces$wif33[1]) === null || _routerInterfaces$wif34 === void 0 ? void 0 : _routerInterfaces$wif34.channel) || " - ";
  var _Channel_5_Guest = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif35 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif35 === void 0 ? void 0 : (_routerInterfaces$wif36 = _routerInterfaces$wif35[2]) === null || _routerInterfaces$wif36 === void 0 ? void 0 : _routerInterfaces$wif36.channel) || " - ";
  var _Channel_5_Home = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif37 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif37 === void 0 ? void 0 : (_routerInterfaces$wif38 = _routerInterfaces$wif37[3]) === null || _routerInterfaces$wif38 === void 0 ? void 0 : _routerInterfaces$wif38.channel) || " - ";
  var _WPA2KeyPassPhrase_2_4_Guest = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif39 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif39 === void 0 ? void 0 : (_routerInterfaces$wif40 = _routerInterfaces$wif39[0]) === null || _routerInterfaces$wif40 === void 0 ? void 0 : _routerInterfaces$wif40.wpa2KeyPassPhrase) || " - ";
  var _WPA2KeyPassPhrase_2_4_Home = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif41 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif41 === void 0 ? void 0 : (_routerInterfaces$wif42 = _routerInterfaces$wif41[1]) === null || _routerInterfaces$wif42 === void 0 ? void 0 : _routerInterfaces$wif42.wpa2KeyPassPhrase) || " - ";
  var _WPA2KeyPassPhrase_5_Guest = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif43 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif43 === void 0 ? void 0 : (_routerInterfaces$wif44 = _routerInterfaces$wif43[2]) === null || _routerInterfaces$wif44 === void 0 ? void 0 : _routerInterfaces$wif44.wpa2KeyPassPhrase) || " - ";
  var _WPA2KeyPassPhrase_5_Home = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif45 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif45 === void 0 ? void 0 : (_routerInterfaces$wif46 = _routerInterfaces$wif45[3]) === null || _routerInterfaces$wif46 === void 0 ? void 0 : _routerInterfaces$wif46.wpa2KeyPassPhrase) || " - ";
  var _SSID_Broadcast_2_4_Guest = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif47 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif47 === void 0 ? void 0 : (_routerInterfaces$wif48 = _routerInterfaces$wif47[0]) === null || _routerInterfaces$wif48 === void 0 ? void 0 : _routerInterfaces$wif48.ssidBroadcast) || " - ";
  var _SSID_Broadcast_2_4_Home = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif49 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif49 === void 0 ? void 0 : (_routerInterfaces$wif50 = _routerInterfaces$wif49[1]) === null || _routerInterfaces$wif50 === void 0 ? void 0 : _routerInterfaces$wif50.ssidBroadcast) || " - ";
  var _SSID_Broadcast_5_Guest = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif51 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif51 === void 0 ? void 0 : (_routerInterfaces$wif52 = _routerInterfaces$wif51[2]) === null || _routerInterfaces$wif52 === void 0 ? void 0 : _routerInterfaces$wif52.ssidBroadcast) || " - ";
  var _SSID_Broadcast_5_Home = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif53 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif53 === void 0 ? void 0 : (_routerInterfaces$wif54 = _routerInterfaces$wif53[3]) === null || _routerInterfaces$wif54 === void 0 ? void 0 : _routerInterfaces$wif54.ssidBroadcast) || " - ";
  var _WPS_Pairing_2_4_Guest = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif55 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif55 === void 0 ? void 0 : (_routerInterfaces$wif56 = _routerInterfaces$wif55[0]) === null || _routerInterfaces$wif56 === void 0 ? void 0 : _routerInterfaces$wif56.wpsPairing) || " - ";
  var _WPS_Pairing_2_4_Home = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif57 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif57 === void 0 ? void 0 : (_routerInterfaces$wif58 = _routerInterfaces$wif57[1]) === null || _routerInterfaces$wif58 === void 0 ? void 0 : _routerInterfaces$wif58.wpsPairing) || " - ";
  var _WPS_Pairing_5_Guest = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif59 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif59 === void 0 ? void 0 : (_routerInterfaces$wif60 = _routerInterfaces$wif59[2]) === null || _routerInterfaces$wif60 === void 0 ? void 0 : _routerInterfaces$wif60.wpsPairing) || " - ";
  var _WPS_Pairing_5_Home = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif61 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif61 === void 0 ? void 0 : (_routerInterfaces$wif62 = _routerInterfaces$wif61[3]) === null || _routerInterfaces$wif62 === void 0 ? void 0 : _routerInterfaces$wif62.wpsPairing) || " - ";
  var _totalAssociations_2_4_Guest = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif63 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif63 === void 0 ? void 0 : (_routerInterfaces$wif64 = _routerInterfaces$wif63[0]) === null || _routerInterfaces$wif64 === void 0 ? void 0 : _routerInterfaces$wif64.totalAssociations) || " - ";
  var _totalAssociations_2_4_Home = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif65 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif65 === void 0 ? void 0 : (_routerInterfaces$wif66 = _routerInterfaces$wif65[1]) === null || _routerInterfaces$wif66 === void 0 ? void 0 : _routerInterfaces$wif66.totalAssociations) || " - ";
  var _totalAssociations_5_Guest = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif67 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif67 === void 0 ? void 0 : (_routerInterfaces$wif68 = _routerInterfaces$wif67[2]) === null || _routerInterfaces$wif68 === void 0 ? void 0 : _routerInterfaces$wif68.totalAssociations) || " - ";
  var _totalAssociations_5_Home = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif69 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif69 === void 0 ? void 0 : (_routerInterfaces$wif70 = _routerInterfaces$wif69[3]) === null || _routerInterfaces$wif70 === void 0 ? void 0 : _routerInterfaces$wif70.totalAssociations) || " - ";
  var _wirelessMode_2_4_Guest = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif71 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif71 === void 0 ? void 0 : (_routerInterfaces$wif72 = _routerInterfaces$wif71[0]) === null || _routerInterfaces$wif72 === void 0 ? void 0 : _routerInterfaces$wif72.wirelessMode) || " - ";
  var _wirelessMode_2_4_Home = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif73 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif73 === void 0 ? void 0 : (_routerInterfaces$wif74 = _routerInterfaces$wif73[1]) === null || _routerInterfaces$wif74 === void 0 ? void 0 : _routerInterfaces$wif74.wirelessMode) || " - ";
  var _wirelessMode_5_Guest = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif75 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif75 === void 0 ? void 0 : (_routerInterfaces$wif76 = _routerInterfaces$wif75[2]) === null || _routerInterfaces$wif76 === void 0 ? void 0 : _routerInterfaces$wif76.wirelessMode) || " - ";
  var _wirelessMode_5_Home = (routerInterfaces === null || routerInterfaces === void 0 ? void 0 : (_routerInterfaces$wif77 = routerInterfaces.wifiInterfaceList) === null || _routerInterfaces$wif77 === void 0 ? void 0 : (_routerInterfaces$wif78 = _routerInterfaces$wif77[3]) === null || _routerInterfaces$wif78 === void 0 ? void 0 : _routerInterfaces$wif78.wirelessMode) || " - ";
  if (WifiSettingTabState === "COMPLETED") {
    return /*#__PURE__*/React__default.createElement("div", null, _rebootAndResetResponseState === "STARTED" && notification && /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      notificationStyles: {
        height: "auto;"
      },
      type: "success",
      title: "Request has been initiated, please verify with the customer."
    }), notificationText !== "" && _rebootAndResetResponseState !== "STARTED" && notification && /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      notificationStyles: {
        height: "auto;"
      },
      type: "error",
      title: "Unable to verify if command was successful, please manually verify with the customer."
    }), /*#__PURE__*/React__default.createElement("div", {
      id: "devWifiContent",
      className: "tabContainer device_wifi_border",
      role: "tablist",
      style: {
        width: "96%"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      "data-testid": "heading",
      className: "device_wifi_heading",
      style: {
        display: "flex",
        justifyContent: "space-between"
      }
    }, "WiFi Settings", /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        alignItems: "baseline",
        columnGap: "10px"
      }
    }, /*#__PURE__*/React__default.createElement(DisplayDate, null), /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement(StyledButton$4, _extends({}, dynamicProps, {
      size: "small",
      onClick: wifiReset
    }), "Reset Wifi")))), /*#__PURE__*/React__default.createElement("hr", {
      className: "dispHr"
    }), /*#__PURE__*/React__default.createElement("table", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "channelType",
      style: {
        width: "20%"
      }
    }, "Channel type:"), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _Channel_Type1), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _Channel_Type2), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _Channel_Type3), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _Channel_Type4)), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "enabled",
      style: {
        width: "20%"
      }
    }, "Enabled"), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _Enable_2_4_Guest), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _Enable_2_4_Home), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _Enable_5_Guest), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _Enable_5_Home)), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "ssid",
      style: {
        width: "20%"
      }
    }, "SSID"), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _SSID_2_4_Guest), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _SSID_2_4_Home), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _SSID_5_Guest), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _SSID_5_Home)), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "netStatus",
      style: {
        width: "20%"
      }
    }, "Network Status"), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _NetworkStatus_2_4_Guest), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _NetworkStatus_2_4_Home), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _NetworkStatus_5_Guest), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _NetworkStatus_5_Home)), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "channelOccupancy",
      style: {
        width: "20%"
      }
    }, "Channel Occupancy"), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _ChannelOccupancy_2_4_Guest), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _ChannelOccupancy_2_4_Home), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _ChannelOccupancy_5_Guest), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _ChannelOccupancy_5_Home)), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "channel",
      style: {
        width: "20%"
      }
    }, "Channel"), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _Channel_2_4_Guest), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _Channel_2_4_Home), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _Channel_5_Guest), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _Channel_5_Home)), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "wpa2Key",
      style: {
        width: "20%"
      }
    }, "WPA2KeyPassPhrase"), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _WPA2KeyPassPhrase_2_4_Guest), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _WPA2KeyPassPhrase_2_4_Home), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _WPA2KeyPassPhrase_5_Guest), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _WPA2KeyPassPhrase_5_Home)), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "ssidBroadcast",
      style: {
        width: "20%"
      }
    }, "SSID Broadcast"), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _SSID_Broadcast_2_4_Guest), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _SSID_Broadcast_2_4_Home), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _SSID_Broadcast_5_Guest), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _SSID_Broadcast_5_Home)), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "wpsPairing",
      style: {
        width: "20%"
      }
    }, "WPS Pairing"), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _WPS_Pairing_2_4_Guest), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _WPS_Pairing_2_4_Home), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _WPS_Pairing_5_Guest), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _WPS_Pairing_5_Home)), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "totalAssociation",
      style: {
        width: "20%"
      }
    }, "Total Association"), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _totalAssociations_2_4_Guest), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _totalAssociations_2_4_Home), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _totalAssociations_5_Guest), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _totalAssociations_5_Home)), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "wirelessMode",
      style: {
        width: "20%"
      }
    }, "Wireless Mode"), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _wirelessMode_2_4_Guest), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _wirelessMode_2_4_Home), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _wirelessMode_5_Guest), /*#__PURE__*/React__default.createElement("td", {
      className: "device_wifi_data"
    }, _wirelessMode_5_Home)))));
  } else if (WifiSettingTabState === "FAILED") {
    return /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      type: "error",
      title: failedMessage,
      buttonData: [{
        children: "Retry",
        "data-track": "Retry",
        onClick: function onClick() {
          onRetryClick();
        }
      }]
    });
  } else if (WifiSettingTabState === "INPROGRESS") {
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      id: "vds-notification-icon",
      hideCloseButton: true,
      type: "info",
      children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "96%",
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "The data is still loading and will refresh when it's complete.")), /*#__PURE__*/React__default.createElement("div", {
        style: {
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "spinnerLoader"
      })))
    }));
  } else if ((networkData === null || networkData === void 0 ? void 0 : networkData.state) == "COMPLETED" && (IsNullOrUndefinedObj(networkData === null || networkData === void 0 ? void 0 : networkData.routerInterfaces) || IsNullOrEmpty(networkData === null || networkData === void 0 ? void 0 : networkData.routerInterfaces) || IsNullOrUndefinedObj(networkData === null || networkData === void 0 ? void 0 : (_networkData$routerIn13 = networkData.routerInterfaces) === null || _networkData$routerIn13 === void 0 ? void 0 : _networkData$routerIn13.header) || IsNullOrEmpty(networkData === null || networkData === void 0 ? void 0 : (_networkData$routerIn14 = networkData.routerInterfaces) === null || _networkData$routerIn14 === void 0 ? void 0 : _networkData$routerIn14.header) || IsNullOrUndefinedObj(networkData === null || networkData === void 0 ? void 0 : (_networkData$routerIn15 = networkData.routerInterfaces) === null || _networkData$routerIn15 === void 0 ? void 0 : (_networkData$routerIn16 = _networkData$routerIn15.header) === null || _networkData$routerIn16 === void 0 ? void 0 : _networkData$routerIn16.state) || IsNullOrEmpty(networkData === null || networkData === void 0 ? void 0 : (_networkData$routerIn17 = networkData.routerInterfaces) === null || _networkData$routerIn17 === void 0 ? void 0 : (_networkData$routerIn18 = _networkData$routerIn17.header) === null || _networkData$routerIn18 === void 0 ? void 0 : _networkData$routerIn18.state))) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "no-data-class vds-notification-icon"
    }, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      type: "info",
      title: "No Wifi Settings available for this MDN.",
      fullBleed: true,
      inlineTreatment: false,
      layout: "horizontal",
      hideCloseButton: true
    }));
  } else return /*#__PURE__*/React__default.createElement(Notification, {
    disableAnimation: true,
    hideCloseButton: true,
    type: "error",
    id: "notfication-cont",
    notificationStyles: {
      height: "auto;"
    },
    children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "70%",
        "float": "left"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      "data-testid": "dataLoadning"
    }, "Data loading is in progress or has failed to load.")), /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "10%",
        "float": "left"
      }
    }, loading &&
    /*#__PURE__*/
    React__default.createElement("div", {
      className: "spinnerLoader"
    })), /*#__PURE__*/React__default.createElement("div", {
      style: {}
    }, /*#__PURE__*/React__default.createElement(StyledButton$4, {
      size: "small",
      "data-track": "Retry-Button",
      id: "noti-retry-btn",
      disabled: loading,
      onClick: onRetryClick
    }, "Retry")))
  });
}

var Pagination$1 = /*#__PURE__*/function (_Component) {
  function Pagination(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.onClickPage = function (page) {
      _this.props.loadCalls(page);
    };
    _this.popPageNum = function (cnt, pages) {
      var _loop = function _loop(i) {
        var minPageNumber = 1;
        var maxPageNumber = 4;
        if (_this.props.currentPage > 4 && _this.props.currentPage + 3 <= _this.props.totalPages) {
          maxPageNumber = maxPageNumber + 4;
          minPageNumber = maxPageNumber - 3;
        } else if (_this.props.currentPage > 4 && _this.props.currentPage + 3 >= _this.props.totalPages) {
          minPageNumber = _this.props.totalPages - 3;
          maxPageNumber = minPageNumber + 4;
        }
        if (i >= minPageNumber && i <= maxPageNumber) {
          pages.push(/*#__PURE__*/React__default.createElement("li", {
            key: i,
            className: "pagination-item"
          }, /*#__PURE__*/React__default.createElement("button", {
            onClick: function onClick() {
              _this.onClickPage(i);
            },
            className: _this.props.currentPage == i ? 'page-btn current-page' : 'page-btn'
          }, i)));
        }
      };
      for (var i = 1; i <= cnt; i++) {
        _loop(i);
      }
    };
    _this.state = {};
    return _this;
  }
  _inheritsLoose(Pagination, _Component);
  var _proto = Pagination.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var isDark = this.props.isDark;
    var pages = [];
    var cnt = this.props.totalRecordCount % this.props.recordsPerPage > 0 ? Math.trunc(this.props.totalRecordCount / this.props.recordsPerPage) + 1 : this.props.totalRecordCount / this.props.recordsPerPage;
    {
      this.props.totalPages > this.props.pageNumbers && this.props.currentPage != 1 && pages.push(/*#__PURE__*/React__default.createElement("li", {
        className: "pagination-item"
      }, /*#__PURE__*/React__default.createElement("button", {
        className: "page-btn",
        onClick: function onClick() {
          _this2.onClickPage(_this2.props.currentPage - 1 >= 0 ? _this2.props.currentPage - 1 : null);
        }
      }, /*#__PURE__*/React__default.createElement(Icon$1, {
        name: "left-arrow",
        size: "small",
        surface: isDark ? "dark" : "light"
      }), "Previous")));
    }
    this.popPageNum(cnt, pages);
    {
      this.props.totalPages > this.props.pageNumbers && this.props.currentPage != this.props.totalPages && pages.push(/*#__PURE__*/React__default.createElement("li", {
        className: "pagination-item"
      }, /*#__PURE__*/React__default.createElement("button", {
        className: "next-page-btn",
        onClick: function onClick() {
          _this2.onClickPage(_this2.props.currentPage + 1 <= _this2.props.totalPages ? _this2.props.currentPage + 1 : null);
        }
      }, "Next", /*#__PURE__*/React__default.createElement(Icon$1, {
        name: "right-arrow",
        size: "small",
        surface: isDark ? "dark" : "light"
      }))));
    }
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("ul", {
      className: "pagination"
    }, pages));
  };
  return Pagination;
}(Component);

function WifiSignalAnalyzer(props) {
  var _wifiAnalyzerData$bod, _wifiAnalyzerData$bod2, _wifiAnalyzerData$bod3, _wifiAnalyzerData$bod4, _wifiAnalyzerData$bod5, _wifiAnalyzerData$bod6, _wifiAnalyzerData$bod7, _wifiAnalyzerData$bod8, _wifiAnalyzerData$bod9, _wifiAnalyzerData$bod0, _wifiAnalyzerData$bod1, _wifiAnalyzerData$bod10, _wifiAnalyzerData$bod11, _wifiAnalyzerData$bod12, _wifiAnalyzerData$bod13;
  var _useWifiAnalyzerData = useWifiAnalyzerData(props),
    wifiAnalyzerData = _useWifiAnalyzerData.data,
    refetchWifiAnalyzerData = _useWifiAnalyzerData.refetch;
  var _useWifiAnalyzerRawDa = useWifiAnalyzerRawData(props),
    wifiAnalyzerRawData = _useWifiAnalyzerRawDa.data,
    refetchWifiAnalyzerRawData = _useWifiAnalyzerRawDa.refetch;
  var _useProfileData = useProfileData(props),
    userProfile = _useProfileData.data;
  var _useState = useState(false),
    loading = _useState[0],
    setLoading = _useState[1];
  var _useState2 = useState(8),
    wifiAnalyzerRecordsPerPage = _useState2[0];
  var _useState3 = useState(0),
    wifiAnalyzerStartRecord = _useState3[0],
    setWifiAnalyzerStartRecord = _useState3[1];
  var _useState4 = useState(8),
    wifiAnalyzerEndRecord = _useState4[0],
    setWifiAnalyzerEndRecord = _useState4[1];
  var _useState5 = useState(1),
    wifiAnalyzerCurrentPage = _useState5[0],
    setWifiAnalyzerCurrentPage = _useState5[1];
  var _useState6 = useState(1),
    wifiAnalyzerPageNumbersToShow = _useState6[0];
  var _useState7 = useState(-1),
    activeRowIndex = _useState7[0],
    setActiveRowIndex = _useState7[1];
  var loadwifiAnalyzer = function loadwifiAnalyzer(page) {
    setActiveRowIndex(-1);
    setWifiAnalyzerCurrentPage(page);
    setWifiAnalyzerStartRecord((page - 1) * wifiAnalyzerRecordsPerPage);
    setWifiAnalyzerEndRecord(page * wifiAnalyzerRecordsPerPage);
  };
  var onOSTRedirect = function onOSTRedirect() {
    var url = "https://vzwkm.verizon.com/content/dsc/kb/en/verizondevices-ditamap/303358.html";
    window.open(url, "_blank", "noopener");
  };
  var onRetryClick = function onRetryClick() {
    setLoading(true);
    refetchWifiAnalyzerRawData().then(function (data) {
      if (data) {
        setLoading(false);
      }
    });
    refetchWifiAnalyzerData().then(function (data) {
      if (data) {
        setLoading(false);
      }
    });
  };
  var fetchRawWifiAnalyzerTroubleshooting = function fetchRawWifiAnalyzerTroubleshooting(element) {
    var req = {
      serviceHeader: {
        clientId: "vzw_acss_services",
        clientTransactionId: "",
        serviceName: "getInsights"
      },
      serviceRequest: {
        insightName: "wifianlyzer_raw",
        insightId: element.mdn,
        additionalParams: {
          keyId: element.time,
          useCaseId: "soi_def_wifianlyzer",
          targetChannel: "vzw_mva_services_wifianlyzer_raw",
          targetChannelId: ""
        }
      }
    };
    getWifiAnalyzerRawData(req);
  };
  var dynamicProps =  {
    primary: true
  } ;
  var wifiTestHistory = (wifiAnalyzerData === null || wifiAnalyzerData === void 0 ? void 0 : (_wifiAnalyzerData$bod = wifiAnalyzerData.body) === null || _wifiAnalyzerData$bod === void 0 ? void 0 : (_wifiAnalyzerData$bod2 = _wifiAnalyzerData$bod.data) === null || _wifiAnalyzerData$bod2 === void 0 ? void 0 : (_wifiAnalyzerData$bod3 = _wifiAnalyzerData$bod2.aggregates) === null || _wifiAnalyzerData$bod3 === void 0 ? void 0 : (_wifiAnalyzerData$bod4 = _wifiAnalyzerData$bod3[0]) === null || _wifiAnalyzerData$bod4 === void 0 ? void 0 : (_wifiAnalyzerData$bod5 = _wifiAnalyzerData$bod4.value) === null || _wifiAnalyzerData$bod5 === void 0 ? void 0 : _wifiAnalyzerData$bod5.wifiTestHistory) || [];
  var wifiRawData = wifiAnalyzerRawData === null || wifiAnalyzerRawData === void 0 ? void 0 : wifiAnalyzerRawData.body;
  if ((wifiAnalyzerData === null || wifiAnalyzerData === void 0 ? void 0 : (_wifiAnalyzerData$bod6 = wifiAnalyzerData.body) === null || _wifiAnalyzerData$bod6 === void 0 ? void 0 : (_wifiAnalyzerData$bod7 = _wifiAnalyzerData$bod6.status) === null || _wifiAnalyzerData$bod7 === void 0 ? void 0 : _wifiAnalyzerData$bod7.message) === "Success" && (IsNullOrUndefinedObj(wifiAnalyzerData.body.data) || IsNullOrEmpty(wifiAnalyzerData.body.data) || IsNullOrUndefinedObj(wifiAnalyzerData.body.data.aggregates) || (wifiAnalyzerData === null || wifiAnalyzerData === void 0 ? void 0 : (_wifiAnalyzerData$bod8 = wifiAnalyzerData.body) === null || _wifiAnalyzerData$bod8 === void 0 ? void 0 : (_wifiAnalyzerData$bod9 = _wifiAnalyzerData$bod8.data) === null || _wifiAnalyzerData$bod9 === void 0 ? void 0 : (_wifiAnalyzerData$bod0 = _wifiAnalyzerData$bod9.aggregates) === null || _wifiAnalyzerData$bod0 === void 0 ? void 0 : _wifiAnalyzerData$bod0.length) == 0)) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "no-data-class vds-notification-icon"
    }, /*#__PURE__*/React__default.createElement(Notification, {
      type: "info",
      title: "No Wi-Fi Analyzer results found for this customer.",
      surface: "light",
      disableAnimation: true,
      fullBleed: true,
      hideCloseButton: true,
      disableFocus: false,
      inline: false,
      layout: "horizontal",
      buttonData: [{
        children: 'OST',
        onClick: onOSTRedirect
      }]
    }));
  } else if (IsNullOrUndefinedObj(wifiAnalyzerData === null || wifiAnalyzerData === void 0 ? void 0 : wifiAnalyzerData.body) || IsNullOrEmpty(wifiAnalyzerData === null || wifiAnalyzerData === void 0 ? void 0 : wifiAnalyzerData.body) || IsNullOrUndefinedObj(wifiAnalyzerData === null || wifiAnalyzerData === void 0 ? void 0 : (_wifiAnalyzerData$bod1 = wifiAnalyzerData.body) === null || _wifiAnalyzerData$bod1 === void 0 ? void 0 : _wifiAnalyzerData$bod1.status) || IsNullOrUndefinedObj(wifiAnalyzerData === null || wifiAnalyzerData === void 0 ? void 0 : (_wifiAnalyzerData$bod10 = wifiAnalyzerData.body) === null || _wifiAnalyzerData$bod10 === void 0 ? void 0 : (_wifiAnalyzerData$bod11 = _wifiAnalyzerData$bod10.status) === null || _wifiAnalyzerData$bod11 === void 0 ? void 0 : _wifiAnalyzerData$bod11.message) || (wifiAnalyzerData === null || wifiAnalyzerData === void 0 ? void 0 : (_wifiAnalyzerData$bod12 = wifiAnalyzerData.body) === null || _wifiAnalyzerData$bod12 === void 0 ? void 0 : (_wifiAnalyzerData$bod13 = _wifiAnalyzerData$bod12.status) === null || _wifiAnalyzerData$bod13 === void 0 ? void 0 : _wifiAnalyzerData$bod13.message) !== "Success") {
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      id: "vds-notification-icon",
      hideCloseButton: true,
      type: "info",
      children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "96%",
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "The data is still loading and will refresh when it's complete.")), /*#__PURE__*/React__default.createElement("div", {
        style: {
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "spinnerLoader"
      })))
    }));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "mainDiv"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "wifiRecords"
  }, /*#__PURE__*/React__default.createElement("table", {
    width: "100%"
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    className: "wifiRecords_heading",
    width: "80%"
  }, "History"), /*#__PURE__*/React__default.createElement("td", {
    width: "5%"
  }, loading &&
  /*#__PURE__*/
  React__default.createElement("div", {
    className: "spinnerLoader"
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(StyledButton$4, _extends({
    style: {
      marginTop: "5px"
    },
    buttonStyles: {
      marginBottom: "10px;"
    }
  }, dynamicProps, {
    size: "small",
    onClick: onRetryClick,
    className: "wifi_button"
  }), "Refresh"))))), /*#__PURE__*/React__default.createElement("hr", {
    className: "wifiRecordsHr"
  }), /*#__PURE__*/React__default.createElement("table", {
    className: "wifi-table"
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    className: "wifi_data"
  }, "Date/Time"), /*#__PURE__*/React__default.createElement("th", {
    className: "wifi_data"
  }, "Test Name"), /*#__PURE__*/React__default.createElement("th", {
    className: "wifi_data"
  }, "Floor"), /*#__PURE__*/React__default.createElement("th", {
    className: "wifi_data"
  }, "Test Device"), /*#__PURE__*/React__default.createElement("th", {
    className: "wifi_data"
  }, "Results"), /*#__PURE__*/React__default.createElement("th", {
    className: "wifi_data "
  })), /*#__PURE__*/React__default.createElement(Fragment, null, wifiTestHistory && wifiTestHistory.slice(wifiAnalyzerStartRecord, wifiAnalyzerEndRecord).map(function (element, index) {
    var _userProfile$permissi, _userProfile$permissi2;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: element.time
    }, /*#__PURE__*/React__default.createElement("tr", {
      "data-testid": "brand" + index,
      style: {
        borderBottom: "1px solid #DCDCDC",
        cursor: "pointer"
      },
      onClick: function onClick() {
        if (activeRowIndex !== index) {
          fetchRawWifiAnalyzerTroubleshooting(element);
        }
        var activeRowIndex_ = activeRowIndex === index ? -1 : index;
        setActiveRowIndex(activeRowIndex_);
      }
    }, /*#__PURE__*/React__default.createElement("td", {
      className: "wifi_data",
      style: {
        "float": "inline-start"
      }
    }, DisplayDate()), /*#__PURE__*/React__default.createElement("td", {
      className: "wifi_data"
    }, element.testName), /*#__PURE__*/React__default.createElement("td", {
      className: "wifi_data"
    }, element.floor), /*#__PURE__*/React__default.createElement("td", {
      className: "wifi_data"
    }, element.testDevice), /*#__PURE__*/React__default.createElement("td", {
      className: "wifi_data"
    }, element.result), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("span", null, activeRowIndex == index ? /*#__PURE__*/React__default.createElement("span", {
      "aria-label": "collapse"
    }, /*#__PURE__*/React__default.createElement(Minus, {
      name: "minus",
      size: "16"
    })) : /*#__PURE__*/React__default.createElement("span", {
      "aria-label": "expand"
    }, /*#__PURE__*/React__default.createElement(Plus, {
      name: "plus",
      size: "16"
    }))))), activeRowIndex == index && wifiRawData ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colSpan: "5"
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "100%",
        overflow: "hidden"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "50%",
        "float": "left"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "wifi_data"
    }, /*#__PURE__*/React__default.createElement("span", {
      "aria-label": "SSID",
      style: {
        fontWeight: "bold"
      }
    }, "SSID :", " "), wifiRawData.ssid), /*#__PURE__*/React__default.createElement("div", {
      className: "wifi_data"
    }, /*#__PURE__*/React__default.createElement("span", {
      "aria-label": "BandWidthChannels",
      style: {
        fontWeight: "bold"
      }
    }, "Bandwidth Channels :", " "), wifiRawData.bandwidthChannels)), (userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$permissi = userProfile.permission) === null || _userProfile$permissi === void 0 ? void 0 : (_userProfile$permissi2 = _userProfile$permissi.NEXT_GEN) === null || _userProfile$permissi2 === void 0 ? void 0 : _userProfile$permissi2.ACCESSIBILITY_USER) === "Y" ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        marginLeft: "65%"
      }
    }, /*#__PURE__*/React__default.createElement("span", {
      "aria-label": "heatmapSummary"
    }, wifiRawData.heatmapSummary ? wifiRawData.heatmapSummary.replace("xxxx", element.result) : ""))) : /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        marginLeft: "75%"
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      src: wifiRawData.heatmapUrl,
      title: "Heatmap Image",
      alt: "Heatmap Image",
      width: "400",
      height: "400"
    })))))) : "");
  }))), /*#__PURE__*/React__default.createElement(Pagination$1, {
    totalPages: wifiTestHistory.length % wifiAnalyzerRecordsPerPage > 0 ? Math.trunc(wifiTestHistory.length / wifiAnalyzerRecordsPerPage) + 1 : wifiTestHistory.length / wifiAnalyzerRecordsPerPage,
    loadRecords: loadwifiAnalyzer,
    totalRecordCount: wifiTestHistory.length,
    currentPage: wifiAnalyzerCurrentPage,
    recordsPerPage: wifiAnalyzerRecordsPerPage,
    pageNumbers: wifiAnalyzerPageNumbersToShow
  }), /*#__PURE__*/React__default.createElement("br", null));
}

var _templateObject$1A;
var StyledTextLink$3 = styled(TextLink)(_templateObject$1A || (_templateObject$1A = _taggedTemplateLiteralLoose(["\n    \n    border-bottom:", ";\n    text-decoration:none;\n    font-weight:bold;\n    :hover{\n    color:", ";\n    border-bottom:", ";\n    text-decoration:none;\n    }\n  \n"])), function (props) {
  return props.selected ? "4px solid red" : "none";
}, function (props) {
  return props.isDark ? "#fff" : "#000";
}, function (props) {
  return props.selected ? "4px solid red" : "none";
});
function DeviceWifi(props) {
  var _useState = useState(1),
    selectedMenuId = _useState[0],
    setSelectedMenuId = _useState[1];
  var devWifiTabs = [{
    tabId: 1,
    devWifiTabId: "wifi_settings",
    devWifiTabName: "WiFi Settings"
  }, {
    tabId: 2,
    devWifiTabId: "wifi_signalAnalyzer",
    devWifiTabName: "WiFi Signal Analyzer"
  }];
  var dispatchUsageMetrics = function dispatchUsageMetrics(eventId, actionId, notes) {
    if (eventId === void 0) {
      eventId = "";
    }
    if (actionId === void 0) {
      actionId = "";
    }
    if (notes === void 0) {
      notes = "";
    }
    var metrics = [{
      eventID: eventId,
      actionID: actionId,
      notes: notes
    }];
    var _ref = props || {},
      logUsageMetrics = _ref.logUsageMetrics;
    if (logUsageMetrics) {
      logUsageMetrics({
        metrics: metrics
      });
    }
  };
  var logSiteCatalystAndMetricsData = function logSiteCatalystAndMetricsData(id) {
    switch (id) {
      case 1:
        dispatchUsageMetrics("TROUBLESHOOTING", "WIFI_SETTINGS_LAUNCH", "WiFi Settings");
        break;
      case 2:
        dispatchUsageMetrics("TROUBLESHOOTING", "WIFI_SIGNAL_ANALYZER_LAUNCH", "WiFi Analyzer");
        break;
    }
  };
  useEffect(function () {
    logSiteCatalystAndMetricsData(selectedMenuId);
  }, []);
  var menuClicked = function menuClicked(id, e) {
    e.preventDefault();
    logSiteCatalystAndMetricsData(id);
    setSelectedMenuId(id);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    id: "devDiagContent",
    className: "tabContainer",
    role: "tablist",
    style: {
      width: "100%"
    }
  }, devWifiTabs && devWifiTabs.length > 0 && devWifiTabs.map(function (tab) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: tab.tabId,
      style: {
        display: "inline-block",
        margin: "0px 0px 10px 25px"
      }
    }, /*#__PURE__*/React__default.createElement(StyledTextLink$3, {
      href: "#",
      role: "tab",
      "aria-label": tab.devWifiTabName,
      "aria-haspopup": "false",
      "aria-expanded": "false",
      id: tab.devWifiTabName,
      onClick: function onClick(e) {
        menuClicked(tab.tabId, e);
      },
      selected: selectedMenuId === tab.tabId,
      isDark: props.isDark
    }, tab.devWifiTabName));
  }), selectedMenuId === 1 && /*#__PURE__*/React__default.createElement(WifiSettings, props), selectedMenuId === 2 && /*#__PURE__*/React__default.createElement(WifiSignalAnalyzer, props));
}

function Router(props) {
  var _networkData$attribut, _networkData$attribut2, _window2, _window2$caseDetails, _networkData$attribut3, _networkData$attribut4, _networkData$attribut5, _networkData$attribut6, _networkData$attribut7, _networkData$attribut8;
  var _ref = useNetworkData(props) || {},
    networkResponse = _ref.data;
  var _ref2 = useDeviceData(props) || {},
    deviceResponse = _ref2.data;
  var _useState = useState({}),
    rebootAndReset = _useState[0],
    setRebootAndReset = _useState[1];
  var _useState2 = useState(""),
    notificationText = _useState2[0],
    setNotificationText = _useState2[1];
  var _useState3 = useState(false),
    loading = _useState3[0],
    setLoading = _useState3[1];
  var _useState4 = useState(""),
    _rebootAndResetResponseState = _useState4[0],
    setRebootAndResetResponseState = _useState4[1];
  var _useState5 = useState(false),
    notification = _useState5[0],
    setNotification = _useState5[1];
  var _useState6 = useState({}),
    deviceData = _useState6[0],
    setdeviceData = _useState6[1];
  var _useState7 = useState({}),
    networkData = _useState7[0],
    setNetworkData = _useState7[1];
  useEffect(function () {
    var _deviceResponse$respo, _deviceResponse$respo2, _deviceResponse$respo3, _networkResponse$resp, _networkResponse$resp2, _networkResponse$resp3;
    setdeviceData(deviceResponse === null || deviceResponse === void 0 ? void 0 : (_deviceResponse$respo = deviceResponse.response) === null || _deviceResponse$respo === void 0 ? void 0 : (_deviceResponse$respo2 = _deviceResponse$respo.data) === null || _deviceResponse$respo2 === void 0 ? void 0 : (_deviceResponse$respo3 = _deviceResponse$respo2.body) === null || _deviceResponse$respo3 === void 0 ? void 0 : _deviceResponse$respo3.data);
    setNetworkData(networkResponse === null || networkResponse === void 0 ? void 0 : (_networkResponse$resp = networkResponse.response) === null || _networkResponse$resp === void 0 ? void 0 : (_networkResponse$resp2 = _networkResponse$resp.data) === null || _networkResponse$resp2 === void 0 ? void 0 : (_networkResponse$resp3 = _networkResponse$resp2.body) === null || _networkResponse$resp3 === void 0 ? void 0 : _networkResponse$resp3.data);
  }, [deviceResponse, networkResponse]);
  var onRetryClick = function onRetryClick() {
    try {
      setLoading(true);
      var dataPayload = payloadUseNetworkData(props, "routerInterfaces");
      return Promise.resolve(getNetworkData(dataPayload).then(function (data) {
        console.log("on retry data++++++", data);
        if (data) {
          var _data$response, _data$response$data, _data$response$data$b;
          setLoading(false);
          setNetworkData(data === null || data === void 0 ? void 0 : (_data$response = data.response) === null || _data$response === void 0 ? void 0 : (_data$response$data = _data$response.data) === null || _data$response$data === void 0 ? void 0 : (_data$response$data$b = _data$response$data.body) === null || _data$response$data$b === void 0 ? void 0 : _data$response$data$b.data);
        }
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var rebootOrResetRouter = function rebootOrResetRouter(command) {
    var _window, _window$caseDetails;
    setNotification(false);
    setRebootAndReset({});
    var _ref3 = props || {},
      _ref3$params = _ref3.params,
      _ref3$params2 = _ref3$params === void 0 ? {} : _ref3$params,
      _ref3$params2$mdn = _ref3$params2.mdn,
      mdn = _ref3$params2$mdn === void 0 ? '' : _ref3$params2$mdn;
    var mtn = ((_window = window) === null || _window === void 0 ? void 0 : (_window$caseDetails = _window.caseDetails) === null || _window$caseDetails === void 0 ? void 0 : _window$caseDetails.mtn) || mdn;
    var req = {
      transactionId: networkData === null || networkData === void 0 ? void 0 : networkData.transactionId,
      command: command === "reset" ? "resetRouter" : command === "reboot" ? "rebootRouter" : null,
      type: "startCommand",
      mdn: mtn
    };
    getRebootAndReset(req).then(function (resp) {
      var _resp$response$data, _resp$response$data$b;
      setNotification(true);
      if (resp !== null && resp !== void 0 && (_resp$response$data = resp.response.data) !== null && _resp$response$data !== void 0 && (_resp$response$data$b = _resp$response$data.body) !== null && _resp$response$data$b !== void 0 && _resp$response$data$b.data) {
        var _resp$response, _resp$response$data2, _resp$response$data2$;
        var routerResp = resp === null || resp === void 0 ? void 0 : (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : (_resp$response$data2 = _resp$response.data) === null || _resp$response$data2 === void 0 ? void 0 : (_resp$response$data2$ = _resp$response$data2.body) === null || _resp$response$data2$ === void 0 ? void 0 : _resp$response$data2$.data;
        setRebootAndReset(routerResp);
        setNotificationText("");
        setRebootAndResetResponseState("");
      }
    });
  };
  useEffect(function () {
    var _rebootAndReset$resul, _rebootAndReset$resul2, _rebootAndReset$resul3, _rebootAndReset$resul4, _rebootAndReset$resul5;
    setNotificationText((_rebootAndReset$resul = rebootAndReset === null || rebootAndReset === void 0 ? void 0 : (_rebootAndReset$resul2 = rebootAndReset.resultHeader) === null || _rebootAndReset$resul2 === void 0 ? void 0 : (_rebootAndReset$resul3 = _rebootAndReset$resul2[0]) === null || _rebootAndReset$resul3 === void 0 ? void 0 : _rebootAndReset$resul3.explanation) != null ? _rebootAndReset$resul : "TransactionId is not found in cache");
    setRebootAndResetResponseState(rebootAndReset === null || rebootAndReset === void 0 ? void 0 : (_rebootAndReset$resul4 = rebootAndReset.resultHeader) === null || _rebootAndReset$resul4 === void 0 ? void 0 : (_rebootAndReset$resul5 = _rebootAndReset$resul4[0]) === null || _rebootAndReset$resul5 === void 0 ? void 0 : _rebootAndReset$resul5.state);
  }, [notificationText, _rebootAndResetResponseState]);
  var dynamicProps =  {
    primary: true
  } ;
  var fwaAttributes = (networkData === null || networkData === void 0 ? void 0 : networkData.fwaAttributes) || "";
  var routerInterfaces = (networkData === null || networkData === void 0 ? void 0 : networkData.routerInterfaces) || "";
  var antennaTabState = (networkData === null || networkData === void 0 ? void 0 : (_networkData$attribut = networkData.attributes) === null || _networkData$attribut === void 0 ? void 0 : (_networkData$attribut2 = _networkData$attribut.header) === null || _networkData$attribut2 === void 0 ? void 0 : _networkData$attribut2.state) || "";
  var _ref4 = props || {},
    _ref4$params = _ref4.params,
    _ref4$params2 = _ref4$params === void 0 ? {} : _ref4$params,
    _ref4$params2$mdn = _ref4$params2.mdn,
    mdn = _ref4$params2$mdn === void 0 ? '' : _ref4$params2$mdn;
  var selectedMTN = ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$caseDetails = _window2.caseDetails) === null || _window2$caseDetails === void 0 ? void 0 : _window2$caseDetails.mtn) || mdn;
  var selectedMTNData;
  if (deviceData) {
    var _deviceData$customerI, _deviceData$customerI2, _deviceData$customerI3;
    var mtns = deviceData === null || deviceData === void 0 ? void 0 : (_deviceData$customerI = deviceData.customerInsight) === null || _deviceData$customerI === void 0 ? void 0 : (_deviceData$customerI2 = _deviceData$customerI.billAccounts) === null || _deviceData$customerI2 === void 0 ? void 0 : (_deviceData$customerI3 = _deviceData$customerI2[0]) === null || _deviceData$customerI3 === void 0 ? void 0 : _deviceData$customerI3.mtns;
    selectedMTNData = mtns ? mtns.find(function (e) {
      return e.mtn === selectedMTN;
    }) : {};
  }
  var isFWADevice_ = isFWADevice(selectedMTNData);
  var RouterNotSupportedMsg = "Router Details Not Avaliable";
  if (!isFWADevice_) {
    return /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      type: "info",
      notificationStyles: {
        height: "auto;"
      },
      title: RouterNotSupportedMsg
    });
  }
  var _Up_Time = "-";
  if (fwaAttributes && fwaAttributes.upTime) {
    _Up_Time = fwaAttributes.upTime;
  } else if (fwaAttributes && fwaAttributes.deviceUpTime) {
    _Up_Time = fwaAttributes.deviceUpTime;
  }
  var _Firmware_Version = "-";
  if (fwaAttributes && fwaAttributes.firmwareVersion) {
    _Firmware_Version = fwaAttributes.firmwareVersion;
  }
  var _Bytes_Received = "-";
  if (fwaAttributes && fwaAttributes.totalBytesReceived) {
    _Bytes_Received = Number(fwaAttributes.totalBytesReceived / (1024 * 1024)).toFixed(2) + " MB";
  }
  var _Bytes_Sent = "-";
  if (fwaAttributes && fwaAttributes.totalBytesSent) {
    _Bytes_Sent = Number(fwaAttributes.totalBytesSent / (1024 * 1024)).toFixed(2) + " MB";
  }
  var _LAN_Status = "-";
  if (routerInterfaces && routerInterfaces.lanInterface && routerInterfaces.lanInterface.interfaceStatus) {
    _LAN_Status = routerInterfaces.lanInterface.interfaceStatus;
  }
  var _NetworkStatus_2_4_Guest = "-";
  var _NetworkStatus_2_4_Home = "-";
  var _NetworkStatus_5_Guest = "-";
  var _NetworkStatus_5_Home = "-";
  if (routerInterfaces && routerInterfaces.wifiInterfaceList) {
    routerInterfaces.wifiInterfaceList.map(function (element) {
      if (element.interfaceType && element.networkStatus && element.interfaceType === "2.4 Guest Network") {
        _NetworkStatus_2_4_Guest = element.networkStatus;
      } else if (element.interfaceType && element.networkStatus && element.interfaceType === "2.4 Home Network") {
        _NetworkStatus_2_4_Home = element.networkStatus;
      } else if (element.interfaceType && element.networkStatus && element.interfaceType === "5.0 Guest Network") {
        _NetworkStatus_5_Guest = element.networkStatus;
      } else if (element.interfaceType && element.networkStatus && element.interfaceType === "5.0 Home Network") {
        _NetworkStatus_5_Home = element.networkStatus;
      }
    });
  }
  if (antennaTabState === "COMPLETED") {
    return /*#__PURE__*/React__default.createElement("div", null, _rebootAndResetResponseState === "STARTED" && notification && /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      notificationStyles: {
        height: "auto;"
      },
      type: "success",
      title: "Request has been initiated, please verify with the customer."
    }), notificationText !== "" && _rebootAndResetResponseState !== "STARTED" && notification && /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      notificationStyles: {
        height: "auto;"
      },
      type: "error",
      title: "Unable to verify if command was successful, please manually verify with the customer."
    }), /*#__PURE__*/React__default.createElement("div", {
      id: "devWifiContent",
      className: "tabContainer device_wifi_border",
      role: "tablist",
      style: {
        width: "96%"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "device_wifi_heading",
      style: {
        display: "flex",
        justifyContent: "space-between"
      }
    }, "Router", /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        alignItems: "baseline",
        columnGap: "10px"
      }
    }, /*#__PURE__*/React__default.createElement(DisplayDate, null), /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement(StyledButton$4, _extends({
      buttonStyles: {
        display: "inline-flex;"
      }
    }, dynamicProps, {
      size: "small",
      onClick: function onClick() {
        return rebootOrResetRouter("reboot");
      }
    }), "Reboot Router"), /*#__PURE__*/React__default.createElement(StyledButton$4, _extends({}, dynamicProps, {
      size: "small",
      onClick: function onClick() {
        return rebootOrResetRouter("reset");
      }
    }), "Reset Router")))), /*#__PURE__*/React__default.createElement("hr", {
      className: "dispHr"
    }), /*#__PURE__*/React__default.createElement("table", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      width: "25%"
    }, "Firmware Version"), /*#__PURE__*/React__default.createElement("td", null, _Firmware_Version)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      width: "25%"
    }, "Up Time"), /*#__PURE__*/React__default.createElement("td", null, _Up_Time)), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      width: "25%"
    }, "WAN(LTE/5G)")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      width: "25%"
    }, "Bytes Recieved"), /*#__PURE__*/React__default.createElement("td", null, _Bytes_Received)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      width: "25%"
    }, "Bytes Sent"), /*#__PURE__*/React__default.createElement("td", null, _Bytes_Sent)), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      width: "25%"
    }, "LAN Status"), /*#__PURE__*/React__default.createElement("td", null, _LAN_Status)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      width: "25%"
    }, "WiFi-5GHz Primary"), /*#__PURE__*/React__default.createElement("td", null, _NetworkStatus_5_Home)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "WiFi-5GHz Guest"), /*#__PURE__*/React__default.createElement("td", null, _NetworkStatus_5_Guest)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      width: "25%"
    }, "WiFi-2.4GHz Primary"), /*#__PURE__*/React__default.createElement("td", null, _NetworkStatus_2_4_Home)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      width: "25%"
    }, "WiFi-2.4GHz Guest"), /*#__PURE__*/React__default.createElement("td", null, _NetworkStatus_2_4_Guest)))));
  } else if (antennaTabState === "FAILED") {
    return /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      hideCloseButton: true,
      type: "error",
      id: "notfication-cont",
      notificationStyles: {
        height: "auto;"
      },
      children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "70%",
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        "data-testid": "dataLoadning"
      }, "The data has failed to load, please retry.")), /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "10%",
          "float": "left"
        }
      }, loading &&
      /*#__PURE__*/
      React__default.createElement("div", {
        className: "spinnerLoader"
      })), /*#__PURE__*/React__default.createElement("div", {
        style: {}
      }, /*#__PURE__*/React__default.createElement(StyledButton$4, {
        size: "small",
        "data-track": "Retry-Button",
        id: "noti-retry-btn",
        disabled: loading,
        onClick: onRetryClick
      }, "Retry")))
    });
  } else if (antennaTabState === "INPROGRESS") {
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      id: "vds-notification-icon",
      hideCloseButton: true,
      type: "info",
      children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "96%",
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "The data is still loading and will refresh when it's complete.")), /*#__PURE__*/React__default.createElement("div", {
        style: {
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "spinnerLoader"
      })))
    }));
  } else if ((networkData === null || networkData === void 0 ? void 0 : networkData.state) == "COMPLETED" && (IsNullOrUndefinedObj(networkData === null || networkData === void 0 ? void 0 : networkData.attributes) || IsNullOrEmpty(networkData === null || networkData === void 0 ? void 0 : networkData.attributes) || IsNullOrUndefinedObj(networkData === null || networkData === void 0 ? void 0 : (_networkData$attribut3 = networkData.attributes) === null || _networkData$attribut3 === void 0 ? void 0 : _networkData$attribut3.header) || IsNullOrEmpty(networkData === null || networkData === void 0 ? void 0 : (_networkData$attribut4 = networkData.attributes) === null || _networkData$attribut4 === void 0 ? void 0 : _networkData$attribut4.header) || IsNullOrUndefinedObj(networkData === null || networkData === void 0 ? void 0 : (_networkData$attribut5 = networkData.attributes) === null || _networkData$attribut5 === void 0 ? void 0 : (_networkData$attribut6 = _networkData$attribut5.header) === null || _networkData$attribut6 === void 0 ? void 0 : _networkData$attribut6.state) || IsNullOrEmpty(networkData === null || networkData === void 0 ? void 0 : (_networkData$attribut7 = networkData.attributes) === null || _networkData$attribut7 === void 0 ? void 0 : (_networkData$attribut8 = _networkData$attribut7.header) === null || _networkData$attribut8 === void 0 ? void 0 : _networkData$attribut8.state))) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "no-data-class vds-notification-icon"
    }, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      type: "info",
      title: "No Router Records available for this MDN.",
      fullBleed: true,
      inlineTreatment: false,
      layout: "horizontal",
      hideCloseButton: true
    }));
  } else return /*#__PURE__*/React__default.createElement(Notification, {
    disableAnimation: true,
    hideCloseButton: true,
    type: "error",
    id: "notfication-cont",
    notificationStyles: {
      height: "auto;"
    },
    children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "70%",
        "float": "left"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      "data-testid": "dataLoadning"
    }, "Data loading is in progress or has failed to load.")), /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "10%",
        "float": "left"
      }
    }, loading &&
    /*#__PURE__*/
    React__default.createElement("div", {
      className: "spinnerLoader"
    })), /*#__PURE__*/React__default.createElement("div", {
      style: {}
    }, /*#__PURE__*/React__default.createElement(StyledButton$4, {
      size: "small",
      "data-track": "Retry-Button",
      id: "noti-retry-btn",
      disabled: loading,
      onClick: onRetryClick
    }, "Retry")))
  });
}

function Antenna(props) {
  var _networkData$attribut, _networkData$attribut2, _networkData$attribut3, _networkData$attribut4, _networkData$attribut5, _networkData$attribut6, _networkData$attribut7, _networkData$attribut8;
  var _useNetworkData = useNetworkData(props),
    networkResponse = _useNetworkData.data;
  var _useState = useState({}),
    rebootAndReset = _useState[0],
    setRebootAndReset = _useState[1];
  var _useState2 = useState(""),
    notificationText = _useState2[0],
    setNotificationText = _useState2[1];
  var _useState3 = useState(false),
    loading = _useState3[0],
    setLoading = _useState3[1];
  var _useState4 = useState(""),
    _rebootAndResetResponseState = _useState4[0],
    setRebootAndResetResponseState = _useState4[1];
  var _useState5 = useState(false),
    notification = _useState5[0],
    setNotification = _useState5[1];
  var _useState6 = useState({}),
    networkData = _useState6[0],
    setNetworkData = _useState6[1];
  useEffect(function () {
    var _networkResponse$resp, _networkResponse$resp2, _networkResponse$resp3;
    setNetworkData(networkResponse === null || networkResponse === void 0 ? void 0 : (_networkResponse$resp = networkResponse.response) === null || _networkResponse$resp === void 0 ? void 0 : (_networkResponse$resp2 = _networkResponse$resp.data) === null || _networkResponse$resp2 === void 0 ? void 0 : (_networkResponse$resp3 = _networkResponse$resp2.body) === null || _networkResponse$resp3 === void 0 ? void 0 : _networkResponse$resp3.data);
  }, [networkResponse]);
  var onRetryClick = function onRetryClick() {
    try {
      setLoading(true);
      var dataPayload = payloadUseNetworkData(props, "routerInterfaces");
      console.log("on retry dataPayload++++++++++++", dataPayload);
      return Promise.resolve(getNetworkData(dataPayload).then(function (data) {
        console.log("on retry data++++++", data);
        if (data) {
          var _data$response, _data$response$data, _data$response$data$b;
          setLoading(false);
          setNetworkData(data === null || data === void 0 ? void 0 : (_data$response = data.response) === null || _data$response === void 0 ? void 0 : (_data$response$data = _data$response.data) === null || _data$response$data === void 0 ? void 0 : (_data$response$data$b = _data$response$data.body) === null || _data$response$data$b === void 0 ? void 0 : _data$response$data$b.data);
        }
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var rebootOrResetAntenna = function rebootOrResetAntenna(command) {
    var _window, _window$caseDetails;
    setNotification(false);
    setRebootAndReset({});
    var _ref = props || {},
      _ref$params = _ref.params,
      _ref$params2 = _ref$params === void 0 ? {} : _ref$params,
      _ref$params2$mdn = _ref$params2.mdn,
      mdn = _ref$params2$mdn === void 0 ? '' : _ref$params2$mdn;
    var mtn = ((_window = window) === null || _window === void 0 ? void 0 : (_window$caseDetails = _window.caseDetails) === null || _window$caseDetails === void 0 ? void 0 : _window$caseDetails.mtn) || mdn;
    var req = {
      transactionId: networkData === null || networkData === void 0 ? void 0 : networkData.transactionId,
      command: command === "reset" ? "resetAntenna" : command === "reboot" ? "rebootAntenna" : null,
      type: "startCommand",
      mdn: mtn
    };
    getRebootAndReset(req).then(function (resp) {
      var _resp$response$data, _resp$response$data$b;
      setNotification(true);
      if (resp !== null && resp !== void 0 && (_resp$response$data = resp.response.data) !== null && _resp$response$data !== void 0 && (_resp$response$data$b = _resp$response$data.body) !== null && _resp$response$data$b !== void 0 && _resp$response$data$b.data) {
        var _resp$response, _resp$response$data2, _resp$response$data2$;
        var routerResp = resp === null || resp === void 0 ? void 0 : (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : (_resp$response$data2 = _resp$response.data) === null || _resp$response$data2 === void 0 ? void 0 : (_resp$response$data2$ = _resp$response$data2.body) === null || _resp$response$data2$ === void 0 ? void 0 : _resp$response$data2$.data;
        setRebootAndReset(routerResp);
        setNotificationText("");
        setRebootAndResetResponseState("");
      }
    });
  };
  useEffect(function () {
    var _rebootAndReset$resul, _rebootAndReset$resul2, _rebootAndReset$resul3, _rebootAndReset$resul4, _rebootAndReset$resul5;
    setNotificationText((_rebootAndReset$resul = rebootAndReset === null || rebootAndReset === void 0 ? void 0 : (_rebootAndReset$resul2 = rebootAndReset.resultHeader) === null || _rebootAndReset$resul2 === void 0 ? void 0 : (_rebootAndReset$resul3 = _rebootAndReset$resul2[0]) === null || _rebootAndReset$resul3 === void 0 ? void 0 : _rebootAndReset$resul3.explanation) != null ? _rebootAndReset$resul : "TransactionId is not found in cache");
    setRebootAndResetResponseState(rebootAndReset === null || rebootAndReset === void 0 ? void 0 : (_rebootAndReset$resul4 = rebootAndReset.resultHeader) === null || _rebootAndReset$resul4 === void 0 ? void 0 : (_rebootAndReset$resul5 = _rebootAndReset$resul4[0]) === null || _rebootAndReset$resul5 === void 0 ? void 0 : _rebootAndReset$resul5.state);
  }, [notificationText, _rebootAndResetResponseState]);
  var get4gArrowPosition = function get4gArrowPosition(value) {
    var arrowPosition = "0px";
    var value1 = value.substring(0, value.length - 3);
    if (value1 <= -106) {
      arrowPosition = "30px";
    }
    if (value1 >= -105 && value1 <= -86) {
      arrowPosition = "90px";
    }
    if (value1 >= -85) {
      arrowPosition = "150px";
    }
    return arrowPosition;
  };
  var get5gArrowPosition = function get5gArrowPosition(value) {
    var arrowPosition = "0px";
    var value1 = value.substring(0, value.length - 3);
    if (value1 <= -96) {
      arrowPosition = "30px";
    }
    if (value1 >= -90 && value1 <= -81) {
      arrowPosition = "90px";
    }
    if (value1 >= -80) {
      arrowPosition = "150px";
    }
    return arrowPosition;
  };
  var dynamicProps =  {
    primary: true
  } ;
  var fwaAttributes = (networkData === null || networkData === void 0 ? void 0 : networkData.fwaAttributes) || {};
  var antennaTabState = (networkData === null || networkData === void 0 ? void 0 : (_networkData$attribut = networkData.attributes) === null || _networkData$attribut === void 0 ? void 0 : (_networkData$attribut2 = _networkData$attribut.header) === null || _networkData$attribut2 === void 0 ? void 0 : _networkData$attribut2.state) || "";
  var bluetoothStatus = "-";
  if (fwaAttributes && fwaAttributes.bluetoothStatus) {
    bluetoothStatus = fwaAttributes.bluetoothStatus;
  }
  var fdr_timestamp = "-";
  if (fwaAttributes && fwaAttributes.recentFactoryResetTime) {
    fdr_timestamp = fwaAttributes.recentFactoryResetTime;
  }
  var device_Uptime = "-";
  if (fwaAttributes && fwaAttributes.deviceUpTime) {
    device_Uptime = fwaAttributes.deviceUpTime;
  }
  var sim_state = "-";
  if (fwaAttributes && fwaAttributes.simState) {
    sim_state = fwaAttributes.simState;
  }
  var _4G_Network_Signal = "-";
  if (fwaAttributes && fwaAttributes.average4GSignal) {
    _4G_Network_Signal = fwaAttributes.average4GSignal;
  }
  var _5G_Network_Signal = "-";
  if (fwaAttributes && fwaAttributes.average5GSignal) {
    _5G_Network_Signal = fwaAttributes.average5GSignal;
  }
  if (antennaTabState === "COMPLETED") {
    return /*#__PURE__*/React__default.createElement("div", null, _rebootAndResetResponseState === "STARTED" && notification && /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      notificationStyles: {
        height: "auto;"
      },
      type: "success",
      title: "Request has been initiated, please verify with the customer."
    }), notificationText !== "" && _rebootAndResetResponseState !== "STARTED" && notification && /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      notificationStyles: {
        height: "auto;"
      },
      type: "error",
      title: "Unable to verify if command was successful, please manually verify with the customer."
    }), /*#__PURE__*/React__default.createElement("div", {
      id: "devWifiContent",
      className: "tabContainer device_wifi_border",
      role: "tablist",
      style: {
        width: "96%"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      "data-testid": "heading",
      className: "device_wifi_heading",
      style: {
        display: "flex",
        justifyContent: "space-between"
      }
    }, "CPE Antenna", /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        alignItems: "baseline",
        columnGap: "10px"
      }
    }, /*#__PURE__*/React__default.createElement(DisplayDate, null), /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement(StyledButton$4, _extends({
      buttonStyles: {
        margin: "0px 0.625rem 0.625rem 0px",
        display: "inline-flex;"
      }
    }, dynamicProps, {
      size: "small",
      onClick: function onClick() {
        return rebootOrResetAntenna("reboot");
      }
    }), "Reboot Antenna"), /*#__PURE__*/React__default.createElement(StyledButton$4, _extends({
      buttonStyles: {
        margin: "0px 0.625rem 0.625rem 0px",
        display: "inline-flex;"
      }
    }, dynamicProps, {
      size: "small",
      onClick: function onClick() {
        return rebootOrResetAntenna("reset");
      }
    }), "Reset Antenna")))), /*#__PURE__*/React__default.createElement("hr", {
      className: "dispHr"
    }), /*#__PURE__*/React__default.createElement("table", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "bluetoothStatus",
      style: {
        width: "20%"
      }
    }, "Bluetooth Status"), /*#__PURE__*/React__default.createElement("td", {
      className: "device_antenna_data"
    }, bluetoothStatus)), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "fdrTimestamp",
      style: {
        width: "20%"
      }
    }, "FDR Timestamp"), /*#__PURE__*/React__default.createElement("td", {
      className: "device_antenna_data"
    }, fdr_timestamp)), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "deviceUpTime",
      style: {
        width: "20%"
      }
    }, "Device Up Time"), /*#__PURE__*/React__default.createElement("td", {
      className: "device_antenna_data"
    }, device_Uptime)), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "simState",
      style: {
        width: "20%"
      }
    }, "SIM State"), /*#__PURE__*/React__default.createElement("td", {
      className: "device_antenna_data"
    }, sim_state)), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "4gNetSignal",
      style: {
        width: "20%"
      }
    }, "4G Network Signal"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("div", {
      className: "antennaSignalDiv"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "antennaSignalStrength"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "antennaDownArrowImg",
      style: {
        marginLeft: get4gArrowPosition(_4G_Network_Signal)
      }
    }, /*#__PURE__*/React__default.createElement("span", {
      "aria-label": _4G_Network_Signal + " out of range -115 to -85"
    }, /*#__PURE__*/React__default.createElement(DownArrow, {
      name: "down-arrow",
      size: "10"
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "antennaSignalData"
    }, _4G_Network_Signal.toUpperCase() == "NOT RETRIEVABLE" ? "N/A" : _4G_Network_Signal, " ", _4G_Network_Signal !== "--" ? "dBm" : " "), /*#__PURE__*/React__default.createElement("div", {
      className: "antenna_signal_band",
      style: {
        fontSize: "10px",
        marginLeft: "-15px"
      }
    }, /*#__PURE__*/React__default.createElement("pre", {
      style: {
        color: props.isDark ? "#fff" : "#000"
      }
    }, "\u2264-115", "   ", "-114 to -106", "   ", "-105 to -86", "   ", "\u2264-85", " "))))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      "data-testid": "5gNetSignal",
      style: {
        width: "20%"
      }
    }, "5G Network Signal"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("div", {
      className: "antennaSignalDiv"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "antennaSignalStrength"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "antennaDownArrowImg",
      style: {
        marginLeft: get5gArrowPosition(_5G_Network_Signal)
      }
    }, /*#__PURE__*/React__default.createElement("span", {
      "aria-label": _5G_Network_Signal + " out of range -111 to -80"
    }, /*#__PURE__*/React__default.createElement(DownArrow, {
      name: "down-arrow",
      size: "10"
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "antennaSignalData"
    }, _5G_Network_Signal.toUpperCase() == "NOT RETRIEVABLE" ? "N?A" : _5G_Network_Signal, " ", _5G_Network_Signal !== "--" ? "dBm" : " "), /*#__PURE__*/React__default.createElement("div", {
      className: "antenna_signal_band",
      style: {
        fontSize: "10px",
        marginLeft: "-15px"
      }
    }, /*#__PURE__*/React__default.createElement("pre", {
      style: {
        color: props.isDark ? "#fff" : "#000"
      }
    }, "\u2264 -111", "   ", "-110 to -91", "   ", "-90 to -81", "   ", "\u2264-80", " "))))), /*#__PURE__*/React__default.createElement("br", null))));
  } else if (antennaTabState === "FAILED") {
    return /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      hideCloseButton: true,
      type: "error",
      id: "notfication-cont",
      notificationStyles: {
        height: "auto;"
      },
      children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "70%",
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        "data-testid": "dataLoadning"
      }, "The data has failed to load, please retry.")), /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "10%",
          "float": "left"
        }
      }, loading && /*#__PURE__*/React__default.createElement("div", {
        className: "spinnerLoader"
      })), /*#__PURE__*/React__default.createElement("div", {
        style: {}
      }, /*#__PURE__*/React__default.createElement(StyledButton$4, {
        size: "small",
        "data-track": "Retry-Button",
        id: "noti-retry-btn",
        disabled: loading,
        onClick: onRetryClick
      }, "Retry")))
    });
  } else if (antennaTabState === "INPROGRESS") {
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      id: "vds-notification-icon",
      hideCloseButton: true,
      type: "info",
      children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "96%",
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "The data is still loading and will refresh when it's complete.")), /*#__PURE__*/React__default.createElement("div", {
        style: {
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "spinnerLoader"
      })))
    }));
  } else if ((networkData === null || networkData === void 0 ? void 0 : networkData.state) == "COMPLETED" && (IsNullOrUndefinedObj(networkData === null || networkData === void 0 ? void 0 : networkData.attributes) || IsNullOrEmpty(networkData === null || networkData === void 0 ? void 0 : networkData.attributes) || IsNullOrUndefinedObj(networkData === null || networkData === void 0 ? void 0 : (_networkData$attribut3 = networkData.attributes) === null || _networkData$attribut3 === void 0 ? void 0 : _networkData$attribut3.header) || IsNullOrEmpty(networkData === null || networkData === void 0 ? void 0 : (_networkData$attribut4 = networkData.attributes) === null || _networkData$attribut4 === void 0 ? void 0 : _networkData$attribut4.header) || IsNullOrUndefinedObj(networkData === null || networkData === void 0 ? void 0 : (_networkData$attribut5 = networkData.attributes) === null || _networkData$attribut5 === void 0 ? void 0 : (_networkData$attribut6 = _networkData$attribut5.header) === null || _networkData$attribut6 === void 0 ? void 0 : _networkData$attribut6.state) || IsNullOrEmpty(networkData === null || networkData === void 0 ? void 0 : (_networkData$attribut7 = networkData.attributes) === null || _networkData$attribut7 === void 0 ? void 0 : (_networkData$attribut8 = _networkData$attribut7.header) === null || _networkData$attribut8 === void 0 ? void 0 : _networkData$attribut8.state))) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "no-data-class vds-notification-icon"
    }, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      type: "info",
      title: "No Antenna Records available for this MDN.",
      fullBleed: true,
      inlineTreatment: false,
      layout: "horizontal",
      hideCloseButton: true
    }));
  } else return /*#__PURE__*/React__default.createElement(Notification, {
    disableAnimation: true,
    hideCloseButton: true,
    type: "error",
    id: "notfication-cont",
    notificationStyles: {
      height: "auto;"
    },
    children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "70%",
        "float": "left"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      "data-testid": "dataLoadning"
    }, "Data loading is in progress or has failed to load.")), /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "10%",
        "float": "left"
      }
    }, loading && /*#__PURE__*/React__default.createElement("div", {
      className: "spinnerLoader"
    })), /*#__PURE__*/React__default.createElement("div", {
      style: {}
    }, /*#__PURE__*/React__default.createElement(StyledButton$4, {
      size: "small",
      "data-track": "Retry-Button",
      id: "noti-retry-btn",
      disabled: loading,
      onClick: onRetryClick
    }, "Retry")))
  });
}

function SpeedTest(props) {
  var _userProfile$permissi, _userProfile$permissi2, _speedTestHistory$res, _speedTestHistory$res2, _speedTestHistory$res3, _speedTestHistory$res4, _speedTestHistory$res5, _speedTestHistory$res6, _speedTestHistory$res7, _speedTestHistory$res8, _pollResultInfoArray$, _pollResultInfoArray$2, _pollResultInfoArray$3, _Object$keys;
  var _useNetworkData = useNetworkData(props),
    networkResponse = _useNetworkData.data;
  var _useSpeedTestHistory = useSpeedTestHistory(props, "start"),
    speedTestStartLoading = _useSpeedTestHistory.isLoading;
  var _useSpeedTestHistory2 = useSpeedTestHistory(props),
    speedTestHistory = _useSpeedTestHistory2.data,
    refetchSpeedTestHistory = _useSpeedTestHistory2.refetch,
    speedTestLoading = _useSpeedTestHistory2.isLoading;
  var _useFeatureFlag = useFeatureFlag(),
    _useFeatureFlag$data = _useFeatureFlag.data,
    _useFeatureFlag$data2 = _useFeatureFlag$data === void 0 ? {} : _useFeatureFlag$data,
    _useFeatureFlag$data3 = _useFeatureFlag$data2.colorCodeSpeedTestFFlag,
    colorCodeSpeedTestFFlag = _useFeatureFlag$data3 === void 0 ? false : _useFeatureFlag$data3,
    _useFeatureFlag$data4 = _useFeatureFlag$data2.autoSpeedTestFFlag,
    autoSpeedTestFFlag = _useFeatureFlag$data4 === void 0 ? false : _useFeatureFlag$data4,
    _useFeatureFlag$speed = _useFeatureFlag.speedTestRefreshCTAFFlag,
    speedTestRefreshCTAFFlag = _useFeatureFlag$speed === void 0 ? false : _useFeatureFlag$speed;
  var _useState = useState({}),
    speedTest = _useState[0],
    setSpeedTest = _useState[1];
  var _useProfileData = useProfileData(props),
    userProfile = _useProfileData.data;
  var sessionParamData = userProfile && (userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$permissi = userProfile.permission) === null || _userProfile$permissi === void 0 ? void 0 : (_userProfile$permissi2 = _userProfile$permissi.sessionPermission) === null || _userProfile$permissi2 === void 0 ? void 0 : _userProfile$permissi2.ACSS_TRG_SPEEDTEST_AUTOFETCH) || 30;
  var _useState2 = useState(true),
    isRefreshBtnDisabled = _useState2[0],
    setIsRefreshBtnDisabled = _useState2[1];
  var _useState3 = useState(false),
    isLoading = _useState3[0],
    setIsLoading = _useState3[1];
  var _useState4 = useState(false),
    speedTestResponseState = _useState4[0],
    setSpeedTestResponseState = _useState4[1];
  var _useState5 = useState(false),
    notification = _useState5[0],
    setNotification = _useState5[1];
  var autoFetchRefreshSpeedTestData = sessionParamData ? sessionParamData * 1000 : 30 * 1000;
  var _useState6 = useState({}),
    setNetworkData = _useState6[1];
  var notifyRefresh = useSpeedTestStore(function (state) {
    return state.revaidateSpeedTestState;
  });
  var speedTestFlag = useSpeedTestStore(function (state) {
    return state.speedTestResultFlag;
  });
  var setSpeedTestCode = useSpeedTestStore(function (state) {
    return state.setSpeedTestCode;
  });
  var speedTestCode = useSpeedTestStore(function (state) {
    return state.speedTestCode;
  });
  var notificationTitle = useSpeedTestStore(function (state) {
    return state.notificationText;
  });
  var setNotificationTitle = useSpeedTestStore(function (state) {
    return state.setNotificationText;
  });
  var openSpeedTest = useDeepLinkStore(function (state) {
    return state.openSpeedTest;
  });
  var setOpenSpeedTest = useDeepLinkStore(function (state) {
    return state.setOpenSpeedTest;
  });
  var stateFromSession = sessionStorage.getItem('speedTestState');
  var enableRefresh = stateFromSession && stateFromSession !== "STARTED";
  console.log("stateFromSession------>", stateFromSession);
  var revalidateSpeedTestState = function revalidateSpeedTestState() {
    var nState = sessionStorage.getItem('speedTestState');
    if (nState) {
      setSpeedTestResponseState(nState);
      setNotification(true);
    }
    if (nState === "COMPLETED") {
      setIsRefreshBtnDisabled(false);
    }
  };
  useEffect(function () {
    revalidateSpeedTestState();
  }, [speedTestFlag]);
  useEffect(function () {
    if (autoSpeedTestFFlag && openSpeedTest) {
      var timer = setTimeout(function () {
        callSpeedTestNew();
        setOpenSpeedTest(false);
      }, 2500);
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [openSpeedTest]);
  useEffect(function () {
    var _networkResponse$resp, _networkResponse$resp2, _networkResponse$resp3;
    setNetworkData(networkResponse === null || networkResponse === void 0 ? void 0 : (_networkResponse$resp = networkResponse.response) === null || _networkResponse$resp === void 0 ? void 0 : (_networkResponse$resp2 = _networkResponse$resp.data) === null || _networkResponse$resp2 === void 0 ? void 0 : (_networkResponse$resp3 = _networkResponse$resp2.body) === null || _networkResponse$resp3 === void 0 ? void 0 : _networkResponse$resp3.data);
  }, [networkResponse]);
  var callSpeedTestHistory = function callSpeedTestHistory() {
    setIsLoading(true);
    refetchSpeedTestHistory().then(function (data) {
      console.log(data);
      if (data) {
        setIsLoading(false);
      }
    });
  };
  var callSpeedTestNew = function callSpeedTestNew() {
    callSpeedTestStartOrRefresh("start");
    setTimeout(function () {
      callSpeedTestStartOrRefresh("refresh");
    }, autoFetchRefreshSpeedTestData);
  };
  var callSpeedTestStartOrRefresh = function callSpeedTestStartOrRefresh(type) {
    var _networkResponse$resp4, _networkResponse$resp5, _networkResponse$resp6, _networkResponse$resp7, _networkResponse$resp8, _window, _window$caseDetails, _window2, _window2$caseDetails, _props$params, _props$params2;
    if (type === void 0) {
      type = "start";
    }
    setIsLoading(true);
    if (notificationTitle) {
      setSpeedTestResponseState("");
      setNotificationTitle("");
      setSpeedTestCode("");
    }
    var transactionId = (_networkResponse$resp4 = networkResponse === null || networkResponse === void 0 ? void 0 : (_networkResponse$resp5 = networkResponse.response) === null || _networkResponse$resp5 === void 0 ? void 0 : (_networkResponse$resp6 = _networkResponse$resp5.data) === null || _networkResponse$resp6 === void 0 ? void 0 : (_networkResponse$resp7 = _networkResponse$resp6.body) === null || _networkResponse$resp7 === void 0 ? void 0 : (_networkResponse$resp8 = _networkResponse$resp7.data) === null || _networkResponse$resp8 === void 0 ? void 0 : _networkResponse$resp8.transactionId) != null ? _networkResponse$resp4 : "";
    var dataPayload = {
      transactionId: transactionId,
      channel: "VZW-ACSS",
      type: type === "start" ? "startCommand" : type === "refresh" ? "pollCommand" : null,
      mdn: (_window = window) !== null && _window !== void 0 && (_window$caseDetails = _window.caseDetails) !== null && _window$caseDetails !== void 0 && _window$caseDetails.mtn ? (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$caseDetails = _window2.caseDetails) === null || _window2$caseDetails === void 0 ? void 0 : _window2$caseDetails.mtn : props === null || props === void 0 ? void 0 : (_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.mdn,
      channelId: props === null || props === void 0 ? void 0 : (_props$params2 = props.params) === null || _props$params2 === void 0 ? void 0 : _props$params2.channelId
    };
    getSpeedTest(dataPayload).then(function (data) {
      var _data$response, _data$response$data, _data$response$data$b;
      setIsLoading(false);
      if (data !== null && data !== void 0 && (_data$response = data.response) !== null && _data$response !== void 0 && (_data$response$data = _data$response.data) !== null && _data$response$data !== void 0 && (_data$response$data$b = _data$response$data.body) !== null && _data$response$data$b !== void 0 && _data$response$data$b.data) {
        var _data$response2, _data$response2$data, _data$response2$data$, _data$response3, _data$response3$data, _data$response3$data$, _res$resultData, _res$resultData$, _res$resultHeader, _res$resultHeader$, _res$resultHeader2, _res$resultHeader2$, _res$resultHeader3, _res$resultHeader3$, _res$resultHeader4, _res$resultHeader4$;
        setSpeedTest(data === null || data === void 0 ? void 0 : (_data$response2 = data.response) === null || _data$response2 === void 0 ? void 0 : (_data$response2$data = _data$response2.data) === null || _data$response2$data === void 0 ? void 0 : (_data$response2$data$ = _data$response2$data.body) === null || _data$response2$data$ === void 0 ? void 0 : _data$response2$data$.data);
        var res = data === null || data === void 0 ? void 0 : (_data$response3 = data.response) === null || _data$response3 === void 0 ? void 0 : (_data$response3$data = _data$response3.data) === null || _data$response3$data === void 0 ? void 0 : (_data$response3$data$ = _data$response3$data.body) === null || _data$response3$data$ === void 0 ? void 0 : _data$response3$data$.data;
        var spData = (res === null || res === void 0 ? void 0 : (_res$resultData = res.resultData) === null || _res$resultData === void 0 ? void 0 : (_res$resultData$ = _res$resultData[0]) === null || _res$resultData$ === void 0 ? void 0 : _res$resultData$.PollResultInfo) || [];
        sessionStorage.setItem('speedTestState', (res === null || res === void 0 ? void 0 : (_res$resultHeader = res.resultHeader) === null || _res$resultHeader === void 0 ? void 0 : (_res$resultHeader$ = _res$resultHeader[0]) === null || _res$resultHeader$ === void 0 ? void 0 : _res$resultHeader$.state) || '');
        sessionStorage.setItem('speedTestResult', JSON.stringify(spData));
        setSpeedTestResponseState(res === null || res === void 0 ? void 0 : (_res$resultHeader2 = res.resultHeader) === null || _res$resultHeader2 === void 0 ? void 0 : (_res$resultHeader2$ = _res$resultHeader2[0]) === null || _res$resultHeader2$ === void 0 ? void 0 : _res$resultHeader2$.state);
        setNotificationTitle(res === null || res === void 0 ? void 0 : (_res$resultHeader3 = res.resultHeader) === null || _res$resultHeader3 === void 0 ? void 0 : (_res$resultHeader3$ = _res$resultHeader3[0]) === null || _res$resultHeader3$ === void 0 ? void 0 : _res$resultHeader3$.explanation);
        setSpeedTestCode(res === null || res === void 0 ? void 0 : (_res$resultHeader4 = res.resultHeader) === null || _res$resultHeader4 === void 0 ? void 0 : (_res$resultHeader4$ = _res$resultHeader4[0]) === null || _res$resultHeader4$ === void 0 ? void 0 : _res$resultHeader4$.code);
        setNotification(true);
        notifyRefresh();
        if (type === 'refresh') {
          setIsRefreshBtnDisabled(false);
        }
      } else {
        setNotification(true);
      }
    });
  };
  useEffect(function () {
    var nState = sessionStorage.getItem('speedTestState');
    if (nState) {
      setSpeedTestResponseState(nState);
      setNotification(true);
    }
  }, []);
  var getColorCode = function getColorCode(resultType) {
    var res;
    switch (resultType) {
      case 'S':
        res = '#008331';
        break;
      case 'F':
        res = '#EE0000';
        break;
      case 'I':
        res = '#0089EC';
        break;
      default:
        res = '#000000';
        break;
    }
    return res;
  };
  var generateRows = function generateRows(data) {
    return data.map(function (element, index) {
      return /*#__PURE__*/React__default.createElement("tr", {
        style: {
          borderBottom: "1px solid #DCDCDC"
        },
        key: Object.keys(element).toString() + '_' + index
      }, element.columns && element.columns.map(function (el) {
        return /*#__PURE__*/React__default.createElement("td", {
          className: "record columnHostName",
          key: el.name,
          style: colorCodeSpeedTestFFlag && el.resultType ? {
            color: getColorCode(el.resultType)
          } : {}
        }, el.name);
      }));
    });
  };
  var generateHeaderRow = function generateHeaderRow(data) {
    return data.map(function (item) {
      return /*#__PURE__*/React__default.createElement("th", {
        className: "record columnHostName",
        "data-testid": item.name,
        key: item.name
      }, item.name);
    });
  };
  var isSpeedTestHistoryDataPresent = (speedTestHistory === null || speedTestHistory === void 0 ? void 0 : speedTestHistory.length) !== 0 ? true : false;
  var rowHeader = (speedTestHistory === null || speedTestHistory === void 0 ? void 0 : (_speedTestHistory$res = speedTestHistory.resultData) === null || _speedTestHistory$res === void 0 ? void 0 : (_speedTestHistory$res2 = _speedTestHistory$res[0]) === null || _speedTestHistory$res2 === void 0 ? void 0 : (_speedTestHistory$res3 = _speedTestHistory$res2.tables) === null || _speedTestHistory$res3 === void 0 ? void 0 : (_speedTestHistory$res4 = _speedTestHistory$res3[0]) === null || _speedTestHistory$res4 === void 0 ? void 0 : _speedTestHistory$res4.rowHeader) || [];
  var rows = (speedTestHistory === null || speedTestHistory === void 0 ? void 0 : (_speedTestHistory$res5 = speedTestHistory.resultData) === null || _speedTestHistory$res5 === void 0 ? void 0 : (_speedTestHistory$res6 = _speedTestHistory$res5[0]) === null || _speedTestHistory$res6 === void 0 ? void 0 : (_speedTestHistory$res7 = _speedTestHistory$res6.tables) === null || _speedTestHistory$res7 === void 0 ? void 0 : (_speedTestHistory$res8 = _speedTestHistory$res7[0]) === null || _speedTestHistory$res8 === void 0 ? void 0 : _speedTestHistory$res8.rows) || [];
  var testResFromSession = sessionStorage.getItem('speedTestResult');
  var pollResultInfoArray = testResFromSession && JSON.parse(testResFromSession);
  var speedTestResult = (pollResultInfoArray === null || pollResultInfoArray === void 0 ? void 0 : (_pollResultInfoArray$ = pollResultInfoArray.filter(function (el) {
    return el.key === "resultDescription";
  })) === null || _pollResultInfoArray$ === void 0 ? void 0 : (_pollResultInfoArray$2 = _pollResultInfoArray$[0]) === null || _pollResultInfoArray$2 === void 0 ? void 0 : (_pollResultInfoArray$3 = _pollResultInfoArray$2.value) === null || _pollResultInfoArray$3 === void 0 ? void 0 : _pollResultInfoArray$3.value) || "";
  return /*#__PURE__*/React__default.createElement("div", {
    className: "mainDiv"
  }, isLoading && /*#__PURE__*/React__default.createElement(Loader$2, {
    fullscreen: false,
    active: true,
    surface:  "light"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "tabContainer",
    role: "tablist",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "heading",
    className: "device_wifi_heading",
    style: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, "Speed Test", /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      columnGap: '10px'
    }
  }, /*#__PURE__*/React__default.createElement(DisplayDate, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      marginTop: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(StyledButton$4, {
    size: "small",
    disabled: false,
    use: "primary",
    surface: props !== null && props !== void 0 && props.isDark ? "dark" : "light",
    className: "daigButton",
    onClick: callSpeedTestNew
  }, "Speed Test"), (!isRefreshBtnDisabled || ((_Object$keys = Object.keys(speedTest)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) !== 0 && !notification || enableRefresh && speedTestRefreshCTAFFlag) && /*#__PURE__*/React__default.createElement(StyledButton$4, {
    size: "small",
    disabled: false,
    use: "secondary",
    surface: props !== null && props !== void 0 && props.isDark ? "dark" : "light",
    className: "daigButton",
    onClick: function onClick() {
      return callSpeedTestStartOrRefresh("refresh");
    }
  }, "Refresh"))))), /*#__PURE__*/React__default.createElement("hr", {
    className: "head_line"
  }), !isLoading && speedTestResponseState == "STARTED" && notification && /*#__PURE__*/React__default.createElement("div", {
    className: "no-data-class"
  }, /*#__PURE__*/React__default.createElement(Notification, {
    disableAnimation: true,
    type: "success",
    notificationStyles: {
      height: "auto;"
    },
    title: "Speed Test is in progress, results will refresh in " + sessionParamData + " seconds."
  })), !isLoading && speedTestResponseState == "COMPLETED" && speedTestCode != "RVW" && notification && /*#__PURE__*/React__default.createElement("div", {
    className: "no-data-class"
  }, /*#__PURE__*/React__default.createElement(Notification, {
    disableAnimation: true,
    type: "info",
    notificationStyles: {
      height: "auto;"
    },
    title: "Result:",
    subtitle: speedTestResult
  })), !isLoading && speedTestResponseState == "COMPLETED" && speedTestCode == "RVW" && notification && notificationTitle !== "" && /*#__PURE__*/React__default.createElement("div", {
    className: "no-data-class"
  }, /*#__PURE__*/React__default.createElement(Notification, {
    disableAnimation: true,
    type: "error",
    notificationStyles: {
      height: "auto;"
    },
    title: notificationTitle
  })), !isLoading && speedTestResponseState == "INPROGRESS" && notification && /*#__PURE__*/React__default.createElement("div", {
    className: "no-data-class"
  }, /*#__PURE__*/React__default.createElement(Notification, {
    disableAnimation: true,
    type: "info",
    notificationStyles: {
      height: "auto;"
    },
    title: "Speed test is still in progress, please use the 'Refresh' button to retrieve results."
  })), !isLoading && !["STARTED", "COMPLETED", "INPROGRESS"].includes(speedTestResponseState) && notification && notificationTitle !== "" && /*#__PURE__*/React__default.createElement("div", {
    className: "no-data-class"
  }, /*#__PURE__*/React__default.createElement(Notification, {
    disableAnimation: true,
    type: "error",
    notificationStyles: {
      height: "auto;"
    },
    title: "Unable to complete speed test, please try again if needed."
  })), !isLoading && !isSpeedTestHistoryDataPresent && /*#__PURE__*/React__default.createElement("div", {
    className: "no-data-class"
  }, /*#__PURE__*/React__default.createElement(Notification, {
    disableAnimation: true,
    type: "info",
    title: "Speed test data not available for this MDN.",
    fullBleed: true,
    inlineTreatment: false,
    layout: "horizontal",
    hideCloseButton: true,
    buttonData: [{
      children: "Refresh",
      onClick: callSpeedTestHistory
    }]
  })), (speedTestStartLoading || speedTestLoading) && /*#__PURE__*/React__default.createElement(Loader$2, {
    fullscreen: false,
    active: true,
    surface:  "light"
  }), rowHeader && rowHeader.length !== 0 && /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("tr", null, generateHeaderRow(rowHeader)), /*#__PURE__*/React__default.createElement(Fragment, null, generateRows(rows))));
}

var _templateObject$1B;
var StyledTextLink$4 = styled(TextLink)(_templateObject$1B || (_templateObject$1B = _taggedTemplateLiteralLoose(["\n    \n    border-bottom:", ";\n    text-decoration:none;\n    font-weight:bold;\n    :hover{\n    color:", ";\n    border-bottom:", ";\n    text-decoration:none;\n    }\n  \n"])), function (props) {
  return props.selected ? "4px solid red" : "none";
}, function (props) {
  return props.isDark ? "#fff" : "#000";
}, function (props) {
  return props.selected ? "4px solid red" : "none";
});
function DeviceDiagnosticsTabs(props) {
  var _props$defaultTabId = props.defaultTabId,
    defaultTabId = _props$defaultTabId === void 0 ? 1 : _props$defaultTabId;
  var _useState = useState(defaultTabId),
    selectedMenuId = _useState[0],
    setSelectedMenuId = _useState[1];
  var devWifiTabs = [{
    tabId: 1,
    devWifiTabId: "antenna",
    devWifiTabName: "Antenna"
  }, {
    tabId: 2,
    devWifiTabId: "router",
    devWifiTabName: "Router"
  }, {
    tabId: 3,
    devWifiTabId: "speedTest",
    devWifiTabName: "Speed Test"
  }];
  var menuClicked = function menuClicked(id, e) {
    e.preventDefault();
    setSelectedMenuId(id);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    id: "devDiagContent",
    className: "tabContainer",
    role: "tablist",
    style: {
      width: "100%"
    }
  }, devWifiTabs && devWifiTabs.length > 0 && devWifiTabs.map(function (tab) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: tab.tabId,
      style: {
        display: "inline-block",
        margin: "0px 0px 10px 25px"
      }
    }, /*#__PURE__*/React__default.createElement(StyledTextLink$4, {
      href: "#",
      role: "tab",
      "aria-label": tab.devWifiTabName,
      "aria-haspopup": "false",
      "aria-expanded": "false",
      id: tab.devWifiTabName,
      onClick: function onClick(e) {
        menuClicked(tab.tabId, e);
      },
      selected: selectedMenuId === tab.tabId,
      isDark: props.isDark
    }, tab.devWifiTabName));
  }), selectedMenuId === 1 && /*#__PURE__*/React__default.createElement(Antenna, props), selectedMenuId === 2 && /*#__PURE__*/React__default.createElement(Router, props), selectedMenuId === 3 && /*#__PURE__*/React__default.createElement(SpeedTest, props));
}

var _templateObject$1C;
var StyledTextLink$5 = styled(TextLink)(_templateObject$1C || (_templateObject$1C = _taggedTemplateLiteralLoose(["\n    \n    border-bottom:", ";\n    text-decoration:none;\n    font-weight:bold;\n    :hover{\n    color:", ";\n    border-bottom:", ";\n    text-decoration:none;\n    }\n  \n"])), function (props) {
  return props.selected ? "4px solid red" : "none";
}, function (props) {
  return props.isDark ? "#fff" : "#000";
}, function (props) {
  return props.selected ? "4px solid red" : "none";
});
var DeviceDetailsPopup = function DeviceDetailsPopup(props) {
  var _props$params, _window, _window$caseDetails, _Object$keys, _window2, _window2$config, _window3, _window3$config;
  console.log("DeviceDetailsPopup-->", props);
  var _props$selectedTab = props.selectedTab,
    selectedTab = _props$selectedTab === void 0 ? 1 : _props$selectedTab;
  var defaultTabId = selectedTab === 2 ? 3 : 1;
  var _useState = useState(selectedTab),
    selectedMenuId = _useState[0],
    setSelectedMenuId = _useState[1];
  var _useDeviceData = useDeviceData(props),
    deviceResponse = _useDeviceData.data,
    refetchDeviceData = _useDeviceData.refetch;
  var _useLoadLinks = useLoadLinks(props),
    loadLinks = _useLoadLinks.data;
  var _useProfileData = useProfileData(props),
    userProfile = _useProfileData.data;
  var _useState2 = useState({}),
    deviceData = _useState2[0],
    setdeviceData = _useState2[1];
  var _ref = useFeatureFlag() || {},
    _ref$data = _ref.data,
    _ref$data2 = _ref$data === void 0 ? {} : _ref$data,
    _ref$data2$prepayAddF = _ref$data2.prepayAddFixFFlag,
    prepayAddFixFFlag = _ref$data2$prepayAddF === void 0 ? false : _ref$data2$prepayAddF;
  var tabList = {
    1: "Device : Device Details",
    2: "Device : Device Diagnostics",
    3: "Device : Connected Devices",
    4: "Device : WiFi"
  };
  useEffect(function () {
    dispatchUsageMetrics("TROUBLESHOOTING", "DeviceDetailsButton_LAUNCH", "Device Details Button");
    logSiteCatalystAndMetricsData(selectedMenuId);
    taggingForDeviceNetworkTile(tabList[selectedMenuId]);
  }, []);
  useEffect(function () {
    var _deviceResponse$respo, _deviceResponse$respo2, _deviceResponse$respo3;
    setdeviceData(deviceResponse === null || deviceResponse === void 0 ? void 0 : (_deviceResponse$respo = deviceResponse.response) === null || _deviceResponse$respo === void 0 ? void 0 : (_deviceResponse$respo2 = _deviceResponse$respo.data) === null || _deviceResponse$respo2 === void 0 ? void 0 : (_deviceResponse$respo3 = _deviceResponse$respo2.body) === null || _deviceResponse$respo3 === void 0 ? void 0 : _deviceResponse$respo3.data);
  }, [deviceResponse]);
  var callId = (props === null || props === void 0 ? void 0 : (_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.acssCallId) || "";
  var devDetailsTabs = [{
    tabId: 1,
    devDetailsTabId: "device_details",
    devDetailsTabName: "Device Details"
  }, {
    tabId: 2,
    devDetailsTabId: "device_diagnostics",
    devDetailsTabName: "Device Diagnostics"
  }, {
    tabId: 3,
    devDetailsTabId: "connected_devices",
    devDetailsTabName: "Connected Devices"
  }, {
    tabId: 4,
    devDetailsTabId: "device_wifi",
    devDetailsTabName: "WiFi"
  }];
  var dispatchUsageMetrics = function dispatchUsageMetrics(eventId, actionId, notes) {
    if (eventId === void 0) {
      eventId = "";
    }
    if (actionId === void 0) {
      actionId = "";
    }
    if (notes === void 0) {
      notes = "";
    }
    var metrics = [{
      eventID: eventId,
      actionID: actionId,
      notes: notes
    }];
    var _ref2 = props || {},
      logUsageMetrics = _ref2.logUsageMetrics;
    if (logUsageMetrics) {
      logUsageMetrics({
        metrics: metrics
      });
    }
  };
  var logSiteCatalystAndMetricsData = function logSiteCatalystAndMetricsData(id) {
    switch (id) {
      case 1:
        dispatchUsageMetrics("TROUBLESHOOTING", "DEVICE_DETAILS_LAUNCH", "Device Details");
        break;
      case 2:
        dispatchUsageMetrics("TROUBLESHOOTING", "DEVICE_DIAGNOSTICS_LAUNCH", "Device Diagnostics");
        break;
      case 3:
        dispatchUsageMetrics("TROUBLESHOOTING", "CONNECTED_DEVICES_LAUNCH", "Connected Devices");
        break;
      case 4:
        dispatchUsageMetrics("TROUBLESHOOTING", "DEVICE_WIFI_LAUNCH", "Device Wifi");
        break;
      default:
        dispatchUsageMetrics("TROUBLESHOOTING", "DEVICE_DETAILS_LAUNCH", "Device Details");
        break;
    }
  };
  var menuClicked = function menuClicked(id, e) {
    e.preventDefault();
    logSiteCatalystAndMetricsData(id);
    setSelectedMenuId(id);
    taggingForDeviceNetworkTile(tabList[id]);
  };
  var _ref3 = props || {},
    _ref3$params = _ref3.params,
    _ref3$params2 = _ref3$params === void 0 ? {} : _ref3$params,
    _ref3$params2$mdn = _ref3$params2.mdn,
    mdn = _ref3$params2$mdn === void 0 ? '' : _ref3$params2$mdn;
  var selectedMTN = ((_window = window) === null || _window === void 0 ? void 0 : (_window$caseDetails = _window.caseDetails) === null || _window$caseDetails === void 0 ? void 0 : _window$caseDetails.mtn) || mdn;
  var selectedMTNData;
  if (deviceData) {
    var _deviceData$customerI, _deviceData$customerI2, _deviceData$customerI3;
    var mtns = deviceData === null || deviceData === void 0 ? void 0 : (_deviceData$customerI = deviceData.customerInsight) === null || _deviceData$customerI === void 0 ? void 0 : (_deviceData$customerI2 = _deviceData$customerI.billAccounts) === null || _deviceData$customerI2 === void 0 ? void 0 : (_deviceData$customerI3 = _deviceData$customerI2[0]) === null || _deviceData$customerI3 === void 0 ? void 0 : _deviceData$customerI3.mtns;
    selectedMTNData = mtns ? mtns.find(function (e) {
      return e.mtn === selectedMTN;
    }) : {};
  }
  var handleRemoteView = function handleRemoteView() {
    var MVMD_BASE_URL = getMVDBaseUrl(loadLinks);
    var MVMD_REMOTE_VIEW_URL = prepareMVDRemoteViewRequestUrlData(selectedMTNData, callId, MVMD_BASE_URL);
    if (MVMD_REMOTE_VIEW_URL) {
      var url = encodeURI(MVMD_REMOTE_VIEW_URL);
      console.log(url, "----url");
      window.open(url, "", "height=800,width=1200,resizable=yes,scrollbars=yes");
    }
  };
  var readAcssFscFwaFeatureFlagEnablement = function readAcssFscFwaFeatureFlagEnablement() {
    var _userProfile$pilotPro;
    if ((userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$pilotPro = userProfile.pilotProperties) === null || _userProfile$pilotPro === void 0 ? void 0 : _userProfile$pilotPro.ACSS_FSCFWAONLY_FEATUREFLAG_DISABLE) === "Y") {
      return false;
    } else {
      return true;
    }
  };
  var isToggleFeatureFlagEnabled = function isToggleFeatureFlagEnabled(flag) {
    var featureEnablement = localStorage.getItem("featureEnablement") && JSON.parse(localStorage.getItem("featureEnablement"));
    if (featureEnablement) {
      return featureEnablement[flag];
    } else {
      return "N";
    }
  };
  var isFSCFWAOnlyUser = function isFSCFWAOnlyUser() {
    var isFSCFWAOnlyUserFlag = false;
    try {
      var _userProfile$permissi, _userProfile$permissi2, _userProfile$permissi3, _userProfile$permissi4, _userProfile$pilotPro2;
      var featureFlagValue = readAcssFscFwaFeatureFlagEnablement() ? isToggleFeatureFlagEnabled("enableACSSFscFwaOnlyFFlag") : true;
      isFSCFWAOnlyUserFlag = featureFlagValue && ((userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$permissi = userProfile.permission) === null || _userProfile$permissi === void 0 ? void 0 : (_userProfile$permissi2 = _userProfile$permissi.SRDeptPermission) === null || _userProfile$permissi2 === void 0 ? void 0 : _userProfile$permissi2.ACSS_FSC_FWAONLY) && (userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$permissi3 = userProfile.permission) === null || _userProfile$permissi3 === void 0 ? void 0 : (_userProfile$permissi4 = _userProfile$permissi3.SRDeptPermission) === null || _userProfile$permissi4 === void 0 ? void 0 : _userProfile$permissi4.ACSS_FSC_FWAONLY) === "Y" || (userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$pilotPro2 = userProfile.pilotProperties) === null || _userProfile$pilotPro2 === void 0 ? void 0 : _userProfile$pilotPro2.ACSS_FSC_FWAONLY) === "Y");
    } catch (e) {
      isFSCFWAOnlyUserFlag = false;
    }
    return isFSCFWAOnlyUserFlag;
  };
  var handleTechSeeLinkClick = function handleTechSeeLinkClick() {
    var techSeeLink = getBaseUrlLink(loadLinks, "LINKS_TECHSEE");
    if (techSeeLink) {
      var _userProfile$permissi5, _userProfile$permissi6;
      var url = encodeURI(techSeeLink + "?r=" + callId);
      if (isFSCFWAOnlyUser() && userProfile && userProfile !== null && userProfile !== void 0 && (_userProfile$permissi5 = userProfile.permission) !== null && _userProfile$permissi5 !== void 0 && (_userProfile$permissi6 = _userProfile$permissi5.sessionPermission) !== null && _userProfile$permissi6 !== void 0 && _userProfile$permissi6.ACSS_FSC_TECHSEE_URL) {
        var _userProfile$permissi7, _userProfile$permissi8;
        var techSeeLinkFSC = userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$permissi7 = userProfile.permission) === null || _userProfile$permissi7 === void 0 ? void 0 : (_userProfile$permissi8 = _userProfile$permissi7.sessionPermission) === null || _userProfile$permissi8 === void 0 ? void 0 : _userProfile$permissi8.ACSS_FSC_TECHSEE_URL;
        url = encodeURI(techSeeLinkFSC + "?r=" + callId);
        dispatchUsageMetrics("TROUBLESHOOTING", "ACSS_NSA_TECHSEE_FSCAgentFWA", "ACSS NSA Tech See");
      }
      window.open(url);
    }
  };
  var onRefreshClick = function onRefreshClick() {
    refetchDeviceData().then(function (data) {
      console.log(data);
    });
  };
  var isFWADevice_ = isFWADevice(selectedMTNData);
  var isMdnStatusEligbleForDelphi_ = isMdnStatusInEligbleForDelphi(selectedMTNData);
  return /*#__PURE__*/React__default.createElement(Fragment, null, deviceData == undefined || deviceData == null || deviceData != undefined && deviceData != null && ((_Object$keys = Object.keys(deviceData)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) == 0 ? /*#__PURE__*/React__default.createElement(Notification, {
    hideCloseButton: false,
    title: "Data failed to load, Please retry.",
    type: "error",
    id: "notfication-cont",
    buttonData: [{
      children: 'Retry',
      onClick: function onClick(e) {
        return onRefreshClick();
      }
    }]
  }) : /*#__PURE__*/React__default.createElement("div", {
    id: "devDetailsContent",
    className: "tabContainer",
    role: "tablist",
    style: {
      width: "100%"
    }
  }, devDetailsTabs && devDetailsTabs.length > 0 && devDetailsTabs.map(function (tab) {
    var _props$params2;
    if (!isFWADevice_ && (tab.tabId === 3 || tab.tabId === 4)) {
      return;
    } else if ((isMdnStatusEligbleForDelphi_ && isFWADevice_ || prepayAddFixFFlag && (props === null || props === void 0 ? void 0 : (_props$params2 = props.params) === null || _props$params2 === void 0 ? void 0 : _props$params2.channel) === "Prepay") && (tab.tabId === 2 || tab.tabId === 3 || tab.tabId === 4)) {
      return;
    } else {
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: "inline-block",
          margin: "0px 0px 10px 25px"
        },
        key: tab.tabId
      }, /*#__PURE__*/React__default.createElement(StyledTextLink$5, {
        href: "#",
        role: "tab",
        "aria-label": tab.devDetailsTabName,
        "data-track": tab.devDetailsTabName,
        "aria-haspopup": "false",
        "aria-selected": "" + (selectedMenuId === tab.tabId ? "true" : "false"),
        id: tab.devDetailsTabName,
        onClick: function onClick(e) {
          menuClicked(tab.tabId, e);
        },
        surface: props.isDark ? 'dark' : 'light',
        selected: selectedMenuId === tab.tabId,
        isDark: props.isDark
      }, tab.devDetailsTabName));
    }
  }), isFWADevice_ ? !((_window2 = window) !== null && _window2 !== void 0 && (_window2$config = _window2.config) !== null && _window2$config !== void 0 && _window2$config.retailIframe) && /*#__PURE__*/React__default.createElement(StyledButton$4, {
    surface: props.isDark ? 'dark' : 'light',
    size: "small",
    "data-track": "TechSee",
    style: {
      "float": "inline-end",
      display: "inline-flex"
    },
    onClick: function onClick() {
      return handleTechSeeLinkClick();
    }
  }, "TechSee") : !((_window3 = window) !== null && _window3 !== void 0 && (_window3$config = _window3.config) !== null && _window3$config !== void 0 && _window3$config.retailIframe) && /*#__PURE__*/React__default.createElement(StyledButton$4, {
    surface: props.isDark ? 'dark' : 'light',
    size: "small",
    "data-track": "Remote View",
    style: {
      display: "inline-flex",
      "float": "inline-end"
    },
    onClick: function onClick() {
      return handleRemoteView();
    }
  }, "Remote View"), selectedMenuId === 1 && /*#__PURE__*/React__default.createElement(DeviceDetails, props), selectedMenuId === 2 && /*#__PURE__*/React__default.createElement(Fragment, null, isFWADevice_ && /*#__PURE__*/React__default.createElement(DeviceDiagnosticsTabs, _extends({
    defaultTabId: defaultTabId
  }, props)), !isFWADevice_ && /*#__PURE__*/React__default.createElement(DeviceDiagnostics, props)), selectedMenuId === 3 && /*#__PURE__*/React__default.createElement(ConnectedDevices, props), selectedMenuId === 4 && /*#__PURE__*/React__default.createElement(DeviceWifi, props)));
};

var _templateObject$1D, _templateObject2$1e;
var DeviceBanner = styled.div(_templateObject$1D || (_templateObject$1D = _taggedTemplateLiteralLoose(["\n      position: absolute;\n      z-index:1;\n"])));
var OSVersionWrapper = styled.div(_templateObject2$1e || (_templateObject2$1e = _taggedTemplateLiteralLoose(["\n     width: 60px;  \n    overflow: hidden;\n    text-overflow: ellipsis;\n"])));
var DeviceDetails$1 = function DeviceDetails(props) {
  var _window, _window$config, _window2, _window2$caseDetails, _ref7, _selectedMTNData, _selectedMTNData$basi, _selectedMTNData$basi2, _selectedMTNData$basi3, _selectedMTNData$basi4, _selectedMTNData2, _selectedMTNData2$bas, _selectedMTNData2$bas2, _selectedMTNData2$bas3, _selectedMTNData2$bas4, _selectedMTNData3, _selectedMTNData4, _osLaunchDate$split, _myObj$mtns, _myObj$mtns$, _networkData$fwaAttri, _networkData$fwaAttri2, _networkData$fwaAttri3, _networkData$fwaAttri4, _networkData$device, _networkData$device$a, _networkData$device$a2, _networkData$device$a3, _networkData$device$a4, _networkData$device$a5, _networkData$device$a6, _networkData$device2, _networkData$device2$, _networkData$device2$2, _networkData$device2$3, _networkData$device2$4, _networkData$device2$5, _networkData$device2$6, _selectedMTNData$devi, _selectedMTNData5, _selectedMTNData5$dev, _selectedMTNData5$dev2, _selectedMTNData7, _selectedMTNData7$dev, _selectedMTNData7$dev2, _selectedMTNData7$dev3, _selectedMTNData7$dev4, _deviceResponse$respo4, _deviceResponse$respo5, _deviceResponse$respo6, _deviceResponse$respo7;
  var _ref = useDeviceData(props) || {},
    deviceResponse = _ref.data,
    refetchDeviceResponse = _ref.refetch;
  var _ref2 = useNetworkData(props) || {},
    networkResponse = _ref2.data;
  var _ref3 = useProfileData(props) || {},
    userProfile = _ref3.data;
  var _props$customerInfo = props.customerInfo,
    customerInfo = _props$customerInfo === void 0 ? {} : _props$customerInfo;
  var isDarkMode = props.isDark;
  var _ref4 = useFeatureFlag() || {},
    _ref4$data = _ref4.data,
    _ref4$data2 = _ref4$data === void 0 ? {} : _ref4$data,
    _ref4$data2$prepayAdd = _ref4$data2.prepayAddFixFFlag,
    prepayAddFixFFlag = _ref4$data2$prepayAdd === void 0 ? false : _ref4$data2$prepayAdd;
  var _useState = useState(false),
    isOpen = _useState[0],
    setOpen = _useState[1];
  var _useState2 = useState(false),
    simOpen = _useState2[0],
    setSimOpen = _useState2[1];
  var _useState3 = useState(props.deviceName),
    modelName = _useState3[0],
    setModelName = _useState3[1];
  var _useState4 = useState(props.deviceBrand),
    equipName = _useState4[0],
    setEquipName = _useState4[1];
  var _useState5 = useState(props.operatingSystem),
    operatingSystem = _useState5[0],
    setOperatingSystem = _useState5[1];
  var _useState6 = useState(props.deviceSku),
    deviceSku = _useState6[0],
    setDeviceSku = _useState6[1];
  var _useState7 = useState(props.osLaunchDate),
    osLaunchDate = _useState7[0],
    setOsLaunchDate = _useState7[1];
  var _useState8 = useState(props.activationDate),
    activationDate = _useState8[0],
    setActivationDate = _useState8[1];
  var _useState9 = useState(props.imei),
    imei = _useState9[0],
    setImei = _useState9[1];
  var _useState0 = useState(props.deviceThumbImg),
    imgUrl = _useState0[0],
    setImgUrl = _useState0[1];
  var windowRetailIframe = (_window = window) === null || _window === void 0 ? void 0 : (_window$config = _window.config) === null || _window$config === void 0 ? void 0 : _window$config.retailIframe;
  var _useState1 = useState(false),
    loading = _useState1[0],
    setloading = _useState1[1];
  var _useState10 = useState(0),
    counter = _useState10[0],
    setCounter = _useState10[1];
  var _useState11 = useState({}),
    deviceData = _useState11[0],
    setdeviceData = _useState11[1];
  var _useState12 = useState({}),
    networkData = _useState12[0],
    setNetworkData = _useState12[1];
  var _useState13 = useState(false),
    fwaHeaderStatus = _useState13[0],
    setFwaHeaderStatus = _useState13[1];
  var simDetailOpen = useDeepLinkStore(function (state) {
    return state.openSimDetails;
  });
  var updateOpenSimDetails = useDeepLinkStore(function (state) {
    return state.updateOpenSimDetails;
  });
  var viewDetailsOpen = useDeepLinkStore(function (state) {
    return state.openDeviceDetails;
  });
  var updateOpenDeviceDetails = useDeepLinkStore(function (state) {
    return state.updateOpenDeviceDetails;
  });
  useEffect(function () {
    if (viewDetailsOpen) {
      setOpen(true);
    }
  }, [viewDetailsOpen]);
  useEffect(function () {
    if (simDetailOpen) {
      if (windowRetailIframe) return;
      setSimOpen(true);
    }
  }, [simDetailOpen]);
  useEffect(function () {
    setEquipName(props.deviceBrand);
    setModelName(props.deviceName);
    setOperatingSystem(props.operatingSystem);
    setDeviceSku(props.deviceSku);
    setOsLaunchDate(props.osLaunchDate);
    setActivationDate(props.activationDate);
    setImei(props.imei);
    setImgUrl(props.deviceThumbImg);
  }, [props.deviceName, props.deviceBrand, props.operatingSystem, props.deviceSku, props.osLaunchDate, props.osLaunchDate, props.imei, props.deviceThumbImg]);
  useEffect(function () {
    var _deviceResponse$respo, _deviceResponse$respo2, _deviceResponse$respo3, _networkResponse$resp, _networkResponse$resp2, _networkResponse$resp3, _networkResponse$resp4, _networkResponse$resp5, _networkResponse$resp6;
    setdeviceData(deviceResponse === null || deviceResponse === void 0 ? void 0 : (_deviceResponse$respo = deviceResponse.response) === null || _deviceResponse$respo === void 0 ? void 0 : (_deviceResponse$respo2 = _deviceResponse$respo.data) === null || _deviceResponse$respo2 === void 0 ? void 0 : (_deviceResponse$respo3 = _deviceResponse$respo2.body) === null || _deviceResponse$respo3 === void 0 ? void 0 : _deviceResponse$respo3.data);
    setNetworkData(networkResponse === null || networkResponse === void 0 ? void 0 : (_networkResponse$resp = networkResponse.response) === null || _networkResponse$resp === void 0 ? void 0 : (_networkResponse$resp2 = _networkResponse$resp.data) === null || _networkResponse$resp2 === void 0 ? void 0 : (_networkResponse$resp3 = _networkResponse$resp2.body) === null || _networkResponse$resp3 === void 0 ? void 0 : _networkResponse$resp3.data);
    updateFwaHeaderStatus(networkResponse === null || networkResponse === void 0 ? void 0 : (_networkResponse$resp4 = networkResponse.response) === null || _networkResponse$resp4 === void 0 ? void 0 : (_networkResponse$resp5 = _networkResponse$resp4.data) === null || _networkResponse$resp5 === void 0 ? void 0 : (_networkResponse$resp6 = _networkResponse$resp5.body) === null || _networkResponse$resp6 === void 0 ? void 0 : _networkResponse$resp6.data);
  }, [deviceResponse, networkResponse]);
  var updateFwaHeaderStatus = function updateFwaHeaderStatus(networkResponse) {
    var _networkResponse$attr, _networkResponse$attr2, _networkResponse$attr3;
    var connectedDevicesHeaderStatus = networkResponse && (networkResponse === null || networkResponse === void 0 ? void 0 : networkResponse.state) || '';
    var attributesHeaderStatus = (networkResponse === null || networkResponse === void 0 ? void 0 : networkResponse.attributes) && (networkResponse === null || networkResponse === void 0 ? void 0 : (_networkResponse$attr = networkResponse.attributes) === null || _networkResponse$attr === void 0 ? void 0 : _networkResponse$attr.header) && (networkResponse === null || networkResponse === void 0 ? void 0 : (_networkResponse$attr2 = networkResponse.attributes) === null || _networkResponse$attr2 === void 0 ? void 0 : (_networkResponse$attr3 = _networkResponse$attr2.header) === null || _networkResponse$attr3 === void 0 ? void 0 : _networkResponse$attr3.state) || '';
    setFwaHeaderStatus(connectedDevicesHeaderStatus === 'INCONCLUSIVE' || connectedDevicesHeaderStatus === 'FAILED' || attributesHeaderStatus === 'INCONCLUSIVE' || attributesHeaderStatus === 'FAILED' ? true : false);
  };
  var dispatchUsageMetrics = function dispatchUsageMetrics(eventId, actionId, notes) {
    if (eventId === void 0) {
      eventId = "";
    }
    if (actionId === void 0) {
      actionId = "";
    }
    if (notes === void 0) {
      notes = "";
    }
    var metrics = [{
      eventID: eventId,
      actionID: actionId,
      notes: notes
    }];
    var _ref5 = props || {},
      logUsageMetrics = _ref5.logUsageMetrics;
    if (logUsageMetrics) {
      logUsageMetrics({
        metrics: metrics
      });
    }
  };
  var onRetryClick = function onRetryClick() {
    setloading(true);
    setCounter(counter + 1);
    refetchDeviceResponse().then(function (data) {
      console.log(data);
      if (data) {
        setloading(false);
      }
    });
  };
  var getACSSTRGDeviceSelectorTabFlag = function getACSSTRGDeviceSelectorTabFlag() {
    var _userProfile$permissi, _userProfile$permissi2, _userProfile$permissi3, _userProfile$permissi4, _userProfile$permissi5, _userProfile$permissi6, _userProfile$permissi7, _userProfile$permissi8, _userProfile$permissi9, _userProfile$permissi0, _userProfile$pilotPro;
    var acssTrgDeviceSelector = false;
    if (windowRetailIframe || userProfile && ((userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$permissi = userProfile.permission) === null || _userProfile$permissi === void 0 ? void 0 : (_userProfile$permissi2 = _userProfile$permissi.NEXT_GEN) === null || _userProfile$permissi2 === void 0 ? void 0 : _userProfile$permissi2.UI_MODERNIZATION) === "Y" || (userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$permissi3 = userProfile.permission) === null || _userProfile$permissi3 === void 0 ? void 0 : (_userProfile$permissi4 = _userProfile$permissi3.SRDeptPermission) === null || _userProfile$permissi4 === void 0 ? void 0 : _userProfile$permissi4.ACSS_UI_MOD_PH2_ENABLE) === "Y") && ((userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$permissi5 = userProfile.permission) === null || _userProfile$permissi5 === void 0 ? void 0 : (_userProfile$permissi6 = _userProfile$permissi5.NEXT_GEN) === null || _userProfile$permissi6 === void 0 ? void 0 : _userProfile$permissi6.ACSS_TRG_DEVICE_SELECTOR) === "Y" || (userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$permissi7 = userProfile.permission) === null || _userProfile$permissi7 === void 0 ? void 0 : (_userProfile$permissi8 = _userProfile$permissi7.SRDeptPermission) === null || _userProfile$permissi8 === void 0 ? void 0 : _userProfile$permissi8.ACSS_TRG_DEVICE_SELECTOR) === "Y" || (userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$permissi9 = userProfile.permission) === null || _userProfile$permissi9 === void 0 ? void 0 : (_userProfile$permissi0 = _userProfile$permissi9.sessionPermission) === null || _userProfile$permissi0 === void 0 ? void 0 : _userProfile$permissi0.ACSS_TRG_DEVICE_SELECTOR) === "Y" || (userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$pilotPro = userProfile.pilotProperties) === null || _userProfile$pilotPro === void 0 ? void 0 : _userProfile$pilotPro.ACSS_TRG_DEVICE_SELECTORW) === "Y")) {
      acssTrgDeviceSelector = true;
    }
    return acssTrgDeviceSelector;
  };
  var _ref6 = props || {},
    _ref6$params = _ref6.params,
    _ref6$params2 = _ref6$params === void 0 ? {} : _ref6$params,
    _ref6$params2$mdn = _ref6$params2.mdn,
    mdn = _ref6$params2$mdn === void 0 ? '' : _ref6$params2$mdn;
  var selectedMTN = ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$caseDetails = _window2.caseDetails) === null || _window2$caseDetails === void 0 ? void 0 : _window2$caseDetails.mtn) || mdn;
  var selectedMTNData;
  if (deviceData) {
    var _deviceData$customerI, _deviceData$customerI2, _deviceData$customerI3;
    var mtns = deviceData === null || deviceData === void 0 ? void 0 : (_deviceData$customerI = deviceData.customerInsight) === null || _deviceData$customerI === void 0 ? void 0 : (_deviceData$customerI2 = _deviceData$customerI.billAccounts) === null || _deviceData$customerI2 === void 0 ? void 0 : (_deviceData$customerI3 = _deviceData$customerI2[0]) === null || _deviceData$customerI3 === void 0 ? void 0 : _deviceData$customerI3.mtns;
    selectedMTNData = mtns ? mtns.find(function (e) {
      return e.mtn === selectedMTN;
    }) : {};
  }
  var isFWADevice_ = isFWADevice(selectedMTNData);
  var isDark = false;
  var dynamicPropsBase = isDark = {
    primary: true
  };
  var dynamicProps = isDark = {
    primary: true
  };
  var fullName = (_ref7 = ((_selectedMTNData = selectedMTNData) === null || _selectedMTNData === void 0 ? void 0 : (_selectedMTNData$basi = _selectedMTNData.basicMtnDetails) === null || _selectedMTNData$basi === void 0 ? void 0 : (_selectedMTNData$basi2 = _selectedMTNData$basi[0]) === null || _selectedMTNData$basi2 === void 0 ? void 0 : (_selectedMTNData$basi3 = _selectedMTNData$basi2.primaryUser) === null || _selectedMTNData$basi3 === void 0 ? void 0 : (_selectedMTNData$basi4 = _selectedMTNData$basi3[0]) === null || _selectedMTNData$basi4 === void 0 ? void 0 : _selectedMTNData$basi4.firstName) + " " + ((_selectedMTNData2 = selectedMTNData) === null || _selectedMTNData2 === void 0 ? void 0 : (_selectedMTNData2$bas = _selectedMTNData2.basicMtnDetails) === null || _selectedMTNData2$bas === void 0 ? void 0 : (_selectedMTNData2$bas2 = _selectedMTNData2$bas[0]) === null || _selectedMTNData2$bas2 === void 0 ? void 0 : (_selectedMTNData2$bas3 = _selectedMTNData2$bas2.primaryUser) === null || _selectedMTNData2$bas3 === void 0 ? void 0 : (_selectedMTNData2$bas4 = _selectedMTNData2$bas3[0]) === null || _selectedMTNData2$bas4 === void 0 ? void 0 : _selectedMTNData2$bas4.lastName)) != null ? _ref7 : " ";
  var mtn = (_selectedMTNData3 = selectedMTNData) !== null && _selectedMTNData3 !== void 0 && _selectedMTNData3.mtn ? getFormatMtn((_selectedMTNData4 = selectedMTNData) === null || _selectedMTNData4 === void 0 ? void 0 : _selectedMTNData4.mtn) : "";
  var deviceName;
  if (modelName) {
    deviceName = equipName + " | " + modelName;
  } else {
    deviceName = modelName != null ? modelName : "";
  }
  var launchDate;
  var dateStr = (_osLaunchDate$split = osLaunchDate === null || osLaunchDate === void 0 ? void 0 : osLaunchDate.split(" ")) != null ? _osLaunchDate$split : " - ";
  if (prepayAddFixFFlag && osLaunchDate && osLaunchDate === 'Not Available') {
    launchDate = osLaunchDate;
  } else if (dateStr && dateStr[0]) {
    launchDate = dateStr[0];
  }
  var upTime;
  var simState;
  var deviceOsVer;
  var simTypeValue = "";
  var mvoConfig = sessionStorage.getItem("mvoConfig");
  var myObj = JSON.parse(mvoConfig);
  var simSkuType = (myObj === null || myObj === void 0 ? void 0 : (_myObj$mtns = myObj.mtns) === null || _myObj$mtns === void 0 ? void 0 : (_myObj$mtns$ = _myObj$mtns[0]) === null || _myObj$mtns$ === void 0 ? void 0 : _myObj$mtns$.simSkuType) || "";
  if (simSkuType) {
    if (simSkuType == "S") {
      simTypeValue = "e";
    } else if (simSkuType == "T") {
      simTypeValue = "p";
    }
  }
  var customerInquirySearchMtn = customerInfo && customerInfo.billAccounts && customerInfo.billAccounts[0] && customerInfo.billAccounts[0].customerInquirySearchMtnDetail;
  if (customerInquirySearchMtn && customerInquirySearchMtn.basicPhoneInfo && customerInquirySearchMtn.basicPhoneInfo.simSkuType) {
    if (customerInquirySearchMtn.basicPhoneInfo.simSkuType == 'S') {
      simTypeValue = 'e';
    } else if (customerInquirySearchMtn.basicPhoneInfo.simSkuType == 'T') {
      simTypeValue = 'p';
    }
  }
  upTime = networkData !== null && networkData !== void 0 && (_networkData$fwaAttri = networkData.fwaAttributes) !== null && _networkData$fwaAttri !== void 0 && _networkData$fwaAttri.upTime ? networkData === null || networkData === void 0 ? void 0 : (_networkData$fwaAttri2 = networkData.fwaAttributes) === null || _networkData$fwaAttri2 === void 0 ? void 0 : _networkData$fwaAttri2.upTime : "";
  simState = networkData !== null && networkData !== void 0 && (_networkData$fwaAttri3 = networkData.fwaAttributes) !== null && _networkData$fwaAttri3 !== void 0 && _networkData$fwaAttri3.simState ? networkData === null || networkData === void 0 ? void 0 : (_networkData$fwaAttri4 = networkData.fwaAttributes) === null || _networkData$fwaAttri4 === void 0 ? void 0 : _networkData$fwaAttri4.simState : "";
  deviceOsVer = networkData !== null && networkData !== void 0 && (_networkData$device = networkData.device) !== null && _networkData$device !== void 0 && (_networkData$device$a = _networkData$device.analysis) !== null && _networkData$device$a !== void 0 && (_networkData$device$a2 = _networkData$device$a[0]) !== null && _networkData$device$a2 !== void 0 && (_networkData$device$a3 = _networkData$device$a2.tables) !== null && _networkData$device$a3 !== void 0 && (_networkData$device$a4 = _networkData$device$a3[0]) !== null && _networkData$device$a4 !== void 0 && (_networkData$device$a5 = _networkData$device$a4.rows[2]) !== null && _networkData$device$a5 !== void 0 && (_networkData$device$a6 = _networkData$device$a5.columns[2]) !== null && _networkData$device$a6 !== void 0 && _networkData$device$a6.name ? networkData === null || networkData === void 0 ? void 0 : (_networkData$device2 = networkData.device) === null || _networkData$device2 === void 0 ? void 0 : (_networkData$device2$ = _networkData$device2.analysis) === null || _networkData$device2$ === void 0 ? void 0 : (_networkData$device2$2 = _networkData$device2$[0]) === null || _networkData$device2$2 === void 0 ? void 0 : (_networkData$device2$3 = _networkData$device2$2.tables) === null || _networkData$device2$3 === void 0 ? void 0 : (_networkData$device2$4 = _networkData$device2$3[0]) === null || _networkData$device2$4 === void 0 ? void 0 : (_networkData$device2$5 = _networkData$device2$4.rows[2]) === null || _networkData$device2$5 === void 0 ? void 0 : (_networkData$device2$6 = _networkData$device2$5.columns[2]) === null || _networkData$device2$6 === void 0 ? void 0 : _networkData$device2$6.name : "";
  var simId = (_selectedMTNData$devi = (_selectedMTNData5 = selectedMTNData) === null || _selectedMTNData5 === void 0 ? void 0 : (_selectedMTNData5$dev = _selectedMTNData5.deviceInfo) === null || _selectedMTNData5$dev === void 0 ? void 0 : (_selectedMTNData5$dev2 = _selectedMTNData5$dev[0]) === null || _selectedMTNData5$dev2 === void 0 ? void 0 : _selectedMTNData5$dev2.simId) != null ? _selectedMTNData$devi : "";
  var updateDeviceOnClick = function updateDeviceOnClick() {
    var customEvent = new CustomEvent("isDeviceSelectTab", {
      detail: {
        isDeviceSelectTab: true
      }
    });
    window.dispatchEvent(customEvent);
    console.log("updateDeviceOnClicked");
  };
  var getEmulator = function getEmulator() {
    var _decodeURIComponent;
    var data = {
      deviceSku: (_decodeURIComponent = decodeURIComponent(deviceSku)) != null ? _decodeURIComponent : ""
    };
    getModelService(data).then(function (data) {
      var _data$response, _data$response$data, _data$response$data$b, _data$response$data$b2;
      var emulatorUrl = data === null || data === void 0 ? void 0 : (_data$response = data.response) === null || _data$response === void 0 ? void 0 : (_data$response$data = _data$response.data) === null || _data$response$data === void 0 ? void 0 : (_data$response$data$b = _data$response$data.body) === null || _data$response$data$b === void 0 ? void 0 : (_data$response$data$b2 = _data$response$data$b.data) === null || _data$response$data$b2 === void 0 ? void 0 : _data$response$data$b2.emulator;
      console.log(emulatorUrl, "=======isIpad()=======", isIpad());
      if (emulatorUrl) {
        if (isIpad()) {
          ipadShell(emulatorUrl);
        } else {
          popupWindow(emulatorUrl, "", 700, 500);
        }
      } else {
        deviceImageClick();
      }
    });
  };
  var deviceImageClick = function deviceImageClick() {
    dispatchUsageMetrics('1D_DEVICE_OVERVIEW_NSA', 'DEVICE_PHOTO_LINK');
    if (!windowRetailIframe) {
      var _selectedMTNData6, _selectedMTNData6$dev, _selectedMTNData6$dev2, _selectedMTNData6$dev3, _selectedMTNData6$dev4, _userProfile$permissi1, _userProfile$permissi10;
      var equipmentInfo = {};
      var eqipid = (_selectedMTNData6 = selectedMTNData) === null || _selectedMTNData6 === void 0 ? void 0 : (_selectedMTNData6$dev = _selectedMTNData6.deviceInfo) === null || _selectedMTNData6$dev === void 0 ? void 0 : (_selectedMTNData6$dev2 = _selectedMTNData6$dev[0]) === null || _selectedMTNData6$dev2 === void 0 ? void 0 : (_selectedMTNData6$dev3 = _selectedMTNData6$dev2.equipGuideData) === null || _selectedMTNData6$dev3 === void 0 ? void 0 : (_selectedMTNData6$dev4 = _selectedMTNData6$dev3.deviceModel) === null || _selectedMTNData6$dev4 === void 0 ? void 0 : _selectedMTNData6$dev4.equipID;
      equipmentInfo.eguideURL = userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$permissi1 = userProfile.permission) === null || _userProfile$permissi1 === void 0 ? void 0 : (_userProfile$permissi10 = _userProfile$permissi1.sessionPermission) === null || _userProfile$permissi10 === void 0 ? void 0 : _userProfile$permissi10.ACSS_INFOMANAGER_EQUIPMENT_GUIDE;
      equipmentInfo.ID = eqipid;
      if (eqipid !== "") {
        popupWindow(equipmentInfo.eguideURL + equipmentInfo.ID + ".html", equipmentInfo.Name, 800, 510);
      } else {
        equipmentInfo.ID = null;
        popupWindow(equipmentInfo.eguideURL + equipmentInfo.ID + ".html", equipmentInfo.Name, 800, 510);
      }
    }
  };
  var getAvailableSoftwareVersion = function getAvailableSoftwareVersion(str) {
    if (str === void 0) {
      str = "";
    }
    var returnStr = "";
    try {
      var decodedURIString = decodeURI(str);
      var formatHtmlString = decodedURIString.replaceAll("%2f", "/");
      returnStr = _parseAvailableSoftwareVersion(formatHtmlString);
    } catch (error) {
      console.log("Error while parsing :: getAvailableSoftwareVersion() :: " + error);
    }
    return returnStr;
  };
  var _parseAvailableSoftwareVersion = function parseAvailableSoftwareVersion(x) {
    if (x === void 0) {
      x = "";
    }
    if (x.indexOf(">") !== -1 && x.lastIndexOf("</") !== -1 && x.indexOf(">") < x.lastIndexOf("</")) {
      var x1 = x.substring(x.indexOf(">") + 1, x.lastIndexOf("</"));
      return _parseAvailableSoftwareVersion(x1);
    }
    return x;
  };
  var decodeToPlainText = function decodeToPlainText(inputValue) {
    var temp = document.createElement("textarea");
    temp.innerHTML = inputValue;
    return temp.childNodes.length === 0 ? "" : temp.childNodes[0].nodeValue;
  };
  var availableSoftware = getAvailableSoftwareVersion((_selectedMTNData7 = selectedMTNData) === null || _selectedMTNData7 === void 0 ? void 0 : (_selectedMTNData7$dev = _selectedMTNData7.deviceInfo) === null || _selectedMTNData7$dev === void 0 ? void 0 : (_selectedMTNData7$dev2 = _selectedMTNData7$dev[0]) === null || _selectedMTNData7$dev2 === void 0 ? void 0 : (_selectedMTNData7$dev3 = _selectedMTNData7$dev2.equipGuideData) === null || _selectedMTNData7$dev3 === void 0 ? void 0 : (_selectedMTNData7$dev4 = _selectedMTNData7$dev3.deviceModel) === null || _selectedMTNData7$dev4 === void 0 ? void 0 : _selectedMTNData7$dev4.currentOsVersion);
  var deviceOs;
  if (isFWADevice_) {
    var _networkData$fwaAttri5, _networkData$fwaAttri6;
    deviceOs = (_networkData$fwaAttri5 = networkData === null || networkData === void 0 ? void 0 : (_networkData$fwaAttri6 = networkData.fwaAttributes) === null || _networkData$fwaAttri6 === void 0 ? void 0 : _networkData$fwaAttri6.firmwareVersion) != null ? _networkData$fwaAttri5 : "";
  } else {
    var _ref8;
    deviceOs = (_ref8 = (operatingSystem != null ? operatingSystem : "") + " " + deviceOsVer) != null ? _ref8 : "";
    if (prepayAddFixFFlag && operatingSystem === 'Not Available') {
      deviceOs = operatingSystem;
    }
  }
  var closeSimDetails = function closeSimDetails() {
    if (simDetailOpen) {
      updateOpenSimDetails();
    }
    setSimOpen(false);
  };
  var closeDeviceDetails = function closeDeviceDetails() {
    if (viewDetailsOpen) {
      updateOpenDeviceDetails();
    }
    setOpen(false);
  };
  var handleSimClick = function handleSimClick() {
    if (windowRetailIframe) return;
    setSimOpen(true);
  };
  if (deviceData !== null && deviceData !== void 0 && deviceData.customerInsight) {
    return /*#__PURE__*/React__default.createElement(Fragment, null, isFWADevice_, /*#__PURE__*/React__default.createElement("div", {
      className: (isDarkMode ? 'network-container-dark' : 'network-container') + " pl-2"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "prepaid-device-wrapper"
    }, isFWADevice_ && fwaHeaderStatus && /*#__PURE__*/React__default.createElement(DeviceBanner, null, /*#__PURE__*/React__default.createElement(Notification, {
      type: "info",
      title: "Device did not respond and may be offline. Confirm device status with the customer.",
      disableAnimation: true,
      fullBleed: true,
      inline: false
    })), /*#__PURE__*/React__default.createElement("table", {
      width: "100%"
    }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      width: "70% !important"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "dataStyle"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "detailsArea caps",
      "data-track": "pii_cust name",
      role: "heading",
      level: "1"
    }, fullName), /*#__PURE__*/React__default.createElement("div", {
      className: "detailsArea caps",
      role: "heading",
      level: "3"
    }, mtn), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("label", {
      className: "details_model_name nobold",
      id: "deviceOverviewPlan_deviceOverviewUR_DeviceView_tab_0"
    }, decodeToPlainText(deviceName))), /*#__PURE__*/React__default.createElement("div", {
      className: " details_fontStyle ",
      role: "heading",
      level: "1"
    }, isFWADevice_ ? "Device Uptime" : "Release Date"), /*#__PURE__*/React__default.createElement("label", {
      className: "details_device_info"
    }, isFWADevice_ ? upTime : launchDate), /*#__PURE__*/React__default.createElement("div", {
      className: " details_fontStyle  ",
      role: "heading",
      level: "1"
    }, isFWADevice_ ? "SIM Status" : "Activation Date"), /*#__PURE__*/React__default.createElement("label", {
      className: "details_device_info"
    }, isFWADevice_ ? simState : activationDate), /*#__PURE__*/React__default.createElement("div", {
      className: " details_fontStyle",
      role: "heading",
      level: "1"
    }, "OS Version"), /*#__PURE__*/React__default.createElement("div", {
      "class": "article-container"
    }, deviceOs && deviceOs !== availableSoftware ? /*#__PURE__*/React__default.createElement("div", {
      className: "osContainer"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: " articlem-0  fontSize details_device_info ",
      title: deviceOs
    }, /*#__PURE__*/React__default.createElement(OSVersionWrapper, null, deviceOs)), /*#__PURE__*/React__default.createElement("div", {
      className: "article iosIconStyle"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "warning_iconStyle"
    }))) : /*#__PURE__*/React__default.createElement("div", {
      className: " articlem-0  fontSize details_device_info",
      title: deviceOs
    }, /*#__PURE__*/React__default.createElement(OSVersionWrapper, null, deviceOs))), /*#__PURE__*/React__default.createElement("div", {
      className: " details_fontStyle",
      role: "heading",
      level: "1"
    }, "IMEI"), /*#__PURE__*/React__default.createElement("label", {
      className: "details_device_info"
    }, imei), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
      onClick: function onClick() {
        return handleSimClick();
      },
      className: (windowRetailIframe ? 'sim-btn-retail' : 'sim-btn') + " details_fontStyle",
      role: "heading",
      level: "1"
    }, simTypeValue, "SIM"), /*#__PURE__*/React__default.createElement("div", {
      className: (windowRetailIframe ? 'sim-id-retail' : '') + " " + (!isDarkMode && 'notDark'),
      tabIndex: "0",
      role: "link"
    }, simOpen && /*#__PURE__*/React__default.createElement(Launchout, {
      handleClose: function handleClose() {
        return closeSimDetails();
      },
      modalTitle: "VZW SIM Details",
      height: windowRetailIframe ? "100vh" : "600px",
      width: "600px",
      isDark: isDarkMode
    }, /*#__PURE__*/React__default.createElement(SimDetails, props)), /*#__PURE__*/React__default.createElement("span", {
      onClick: function onClick() {
        return handleSimClick();
      },
      "data-track": simId,
      "data-testid": "click"
    }, simId))))), /*#__PURE__*/React__default.createElement("td", {
      id: "networkError1 keepright"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "divStyle"
    }, imgUrl ? /*#__PURE__*/React__default.createElement("div", {
      className: "image_largescreen"
    }, /*#__PURE__*/React__default.createElement("img", {
      className: " troubleShooting_deviceOverview_image pointer",
      id: "tmpImage_deviceOverviewUR_DeviceView_tab_0",
      src: imgUrl,
      "data-testid": "run",
      onClick: function onClick(_e) {
        deviceImageClick();
      },
      title: "Equipment Guide",
      alt: "Equipment Guide"
    }), getACSSTRGDeviceSelectorTabFlag() && /*#__PURE__*/React__default.createElement("div", {
      className: "changeDevice_cta"
    }, /*#__PURE__*/React__default.createElement("a", {
      href: "#",
      "data-testid": "changeDevice",
      onClick: updateDeviceOnClick,
      "data-track": "L1|P1|Delhpi|||||Device Details|Change Device"
    }, "Change Device")), /*#__PURE__*/React__default.createElement("div", {
      className: "device-details_btnstyle1"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "buttonCss",
      id: "keepright"
    }, /*#__PURE__*/React__default.createElement(StyledButton$4, _extends({}, dynamicProps, {
      surface: isDarkMode ? 'dark' : 'light',
      buttonStyles: {
        margin: "0px 0.625rem 0.625rem 0px;"
      },
      size: "small",
      className: "device_details_custom_btn",
      "data-track": "L1|P1|Delhpi|||||Device Details|Emulator",
      onClick: function onClick(_e) {
        getEmulator();
      }
    }), "Emulator")), /*#__PURE__*/React__default.createElement("div", {
      className: "buttonCss",
      id: "keepright"
    }, /*#__PURE__*/React__default.createElement(StyledButton$4, _extends({}, dynamicPropsBase, {
      surface: isDarkMode ? 'dark' : 'light',
      buttonStyles: {
        margin: "0px 0.625rem 0.625rem 0px;"
      },
      baseButton: true,
      size: "small",
      className: "device_details_custom_btn",
      "data-track": "L1|P1|Delhpi|||||Device Details|View Details",
      "data-testid": "viewDetails",
      onClick: function onClick() {
        return setOpen(true);
      },
      id: "trg_device_view_details_btn"
    }), "View Details"), isOpen && /*#__PURE__*/React__default.createElement(Launchout, {
      handleClose: function handleClose() {
        return closeDeviceDetails();
      },
      modalTitle: "Device",
      height: windowRetailIframe ? "100vh" : "600px",
      width: windowRetailIframe ? "100vw" : "1200px",
      isDark: isDarkMode
    }, /*#__PURE__*/React__default.createElement(DeviceDetailsPopup, props))))) : /*#__PURE__*/React__default.createElement("div", {
      className: "image_largescreen"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "noImgAvailIcon"
    }), getACSSTRGDeviceSelectorTabFlag() && /*#__PURE__*/React__default.createElement("div", {
      className: "changeDevice_cta"
    }, /*#__PURE__*/React__default.createElement("a", {
      href: "#",
      onClick: updateDeviceOnClick,
      "data-track": "L1|P1|Delhpi|||||Device Details|Change Device"
    }, "Change Device")), /*#__PURE__*/React__default.createElement("div", {
      className: "device-details_btnstyle"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "buttonCss",
      id: "keepright"
    }, /*#__PURE__*/React__default.createElement(StyledButton$4, _extends({}, dynamicProps, {
      surface: isDarkMode ? 'dark' : 'light',
      buttonStyles: {
        margin: "0px 0.625rem 0.625rem 0px;"
      },
      size: "small",
      className: "device_details_custom_btn",
      "data-track": "L1|P1|Delhpi|||||Device Details|Emulator",
      onClick: function onClick(_e) {
        getEmulator();
      }
    }), "Emulator")), /*#__PURE__*/React__default.createElement("div", {
      className: "buttonCss",
      id: "keepright"
    }, /*#__PURE__*/React__default.createElement(StyledButton$4, _extends({}, dynamicPropsBase, {
      surface: isDarkMode ? 'dark' : 'light',
      buttonStyles: {
        margin: "0px 0.625rem 0.625rem 0px;"
      },
      baseButton: true,
      size: "small",
      className: "device_details_custom_btn",
      "data-track": "L1|P1|Delhpi|||||Device Details|View Details",
      id: "trg_device_view_details_btn",
      "data-testid": "viewDetails1",
      onClick: function onClick() {
        return setOpen(true);
      }
    }), "View Details"), isOpen && /*#__PURE__*/React__default.createElement(Launchout, {
      handleClose: function handleClose() {
        return closeDeviceDetails();
      },
      modalTitle: "Device",
      height: windowRetailIframe ? "100vh" : "600px",
      width: windowRetailIframe ? "100vw" : "1200px",
      isDark: isDarkMode
    }, /*#__PURE__*/React__default.createElement(DeviceDetailsPopup, props)))))))), /*#__PURE__*/React__default.createElement("tr", {
      className: "btn-position"
    }))))));
  } else if (counter === 3) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: (isDarkMode ? 'network-container-dark' : 'network-container') + " loading-tile"
    }, /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative"
      }
    }, "Data Failed to Load")));
  } else if (deviceResponse !== null && deviceResponse !== void 0 && (_deviceResponse$respo4 = deviceResponse.response) !== null && _deviceResponse$respo4 !== void 0 && (_deviceResponse$respo5 = _deviceResponse$respo4.data) !== null && _deviceResponse$respo5 !== void 0 && _deviceResponse$respo5.body && Object.keys(deviceResponse === null || deviceResponse === void 0 ? void 0 : (_deviceResponse$respo6 = deviceResponse.response) === null || _deviceResponse$respo6 === void 0 ? void 0 : (_deviceResponse$respo7 = _deviceResponse$respo6.data) === null || _deviceResponse$respo7 === void 0 ? void 0 : _deviceResponse$respo7.body).length === 0) {
    return /*#__PURE__*/React__default.createElement("div", null, !loading && /*#__PURE__*/React__default.createElement("div", {
      className: (isDarkMode ? 'network-container-dark' : 'network-container') + " loading-tile"
    }, /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative"
      }
    }, "Data Failed to Load"), /*#__PURE__*/React__default.createElement("div", {
      id: "api-retry-btn",
      onClick: onRetryClick,
      "data-testid": "apiretrybtn"
    }, "Retry"))), /*#__PURE__*/React__default.createElement("div", {
      className: isDarkMode ? "network-container-dark" : "network-container",
      style: {
        position: "relative"
      }
    }, loading && /*#__PURE__*/React__default.createElement(Loader$2, {
      fullscreen: false,
      active: true
    })));
  } else if (deviceData && Object.keys(deviceData).length === 0) {
    return /*#__PURE__*/React__default.createElement("div", null, !loading && /*#__PURE__*/React__default.createElement("div", {
      className: (isDarkMode ? 'network-container-dark' : 'network-container') + " loading-tile"
    }, /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        position: "relative"
      }
    }, "Data Failed to Load"), /*#__PURE__*/React__default.createElement("div", {
      id: "api-retry-btn",
      onClick: onRetryClick
    }, "Retry"))), /*#__PURE__*/React__default.createElement("div", {
      className: isDarkMode ? "network-container-dark" : "network-container",
      style: {
        position: "relative"
      }
    }, loading && /*#__PURE__*/React__default.createElement(Loader$2, {
      fullscreen: false,
      active: true
    })));
  } else return /*#__PURE__*/React__default.createElement("div", {
    className: isDarkMode ? "network-container-dark" : "network-container",
    style: {
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement(Loader$2, {
    fullscreen: false,
    active: true
  }));
};

function NetworkExperience(props) {
  var _trgNetworkResponse$s, _trgNetworkResponse$s2, _trgNetworkResponse$s3, _trgNetworkResponse$s4, _trgNetworkResponse$s5, _trgNetworkResponse$s6, _trgNetworkResponse$s7, _trgNetworkResponse$s8, _trgNetworkResponse$s9;
  var _useNetworkData = useNetworkData(props),
    networkResponse = _useNetworkData.data;
  var _useProfileData = useProfileData(props),
    userProfileData = _useProfileData.data;
  var _useState = useState("overall"),
    selectedOption = _useState[0],
    setselectedOption = _useState[1];
  var _useState2 = useState([false, false, false]),
    checkedState = _useState2[0],
    setcheckedState = _useState2[1];
  var _useState3 = useState(0);
  var _useState4 = useState(false),
    loading = _useState4[0],
    setloading = _useState4[1];
  var _useState5 = useState(null),
    type = _useState5[0],
    setType = _useState5[1];
  var _useState6 = useState({}),
    trgNetworkResponse = _useState6[0],
    settrgNetworkResponse = _useState6[1];
  var _useState7 = useState({}),
    userProfile = _useState7[0],
    setuserProfile = _useState7[1];
  var _useState8 = useState({}),
    networkData = _useState8[0],
    setNetworkData = _useState8[1];
  useEffect(function () {
    var _networkResponse$resp, _networkResponse$resp2, _networkResponse$resp3;
    setNetworkData(networkResponse === null || networkResponse === void 0 ? void 0 : (_networkResponse$resp = networkResponse.response) === null || _networkResponse$resp === void 0 ? void 0 : (_networkResponse$resp2 = _networkResponse$resp.data) === null || _networkResponse$resp2 === void 0 ? void 0 : (_networkResponse$resp3 = _networkResponse$resp2.body) === null || _networkResponse$resp3 === void 0 ? void 0 : _networkResponse$resp3.data);
  }, [networkResponse]);
  useEffect(function () {
    setType({
      type: "overall"
    });
    settrgNetworkResponse(networkData);
    setuserProfile(userProfileData);
  }, [networkData]);
  var onValueChange = function onValueChange(e) {
    setselectedOption(e.target.value);
    if (e.target.value == "overall") {
      setType({
        type: "overall"
      });
    } else if (e.target.value == "data") {
      setType({
        type: "data"
      });
    } else if (e.target.value == "hdinvoice") {
      setType({
        type: "hdinvoice"
      });
    }
  };
  var handleOnChange = function handleOnChange(position) {
    var updatedCheckedState = checkedState.map(function (item, index) {
      return index === position ? !item : item;
    });
    setcheckedState(updatedCheckedState);
  };
  var onRetryClick = function onRetryClick() {
    try {
      setloading(true);
      var dataPayload = payloadUseNetworkData(props, "scores");
      return Promise.resolve(getNetworkData(dataPayload).then(function (data) {
        console.log("on retry data++++++", data);
        if (data) {
          var _data$response, _data$response$data, _data$response$data$b;
          setloading(false);
          setNetworkData(data === null || data === void 0 ? void 0 : (_data$response = data.response) === null || _data$response === void 0 ? void 0 : (_data$response$data = _data$response.data) === null || _data$response$data === void 0 ? void 0 : (_data$response$data$b = _data$response$data.body) === null || _data$response$data$b === void 0 ? void 0 : _data$response$data$b.data);
        }
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var _props$isDark = props.isDark,
    isDark = _props$isDark === void 0 ? false : _props$isDark;
  var themeColor = isDark ? "#FFFFFF" : "black";
  var themeColorAreaUnderGraph = isDark ? "#808080" : "#ededeb";
  var themeRadioOptions = isDark ? "#ededeb" : "black";
  var windowWidthClass = window.innerWidth < 1920 ? "label2-class-low" : "label2-class";
  var networkTabState = (trgNetworkResponse === null || trgNetworkResponse === void 0 ? void 0 : (_trgNetworkResponse$s = trgNetworkResponse.scores) === null || _trgNetworkResponse$s === void 0 ? void 0 : (_trgNetworkResponse$s2 = _trgNetworkResponse$s.header) === null || _trgNetworkResponse$s2 === void 0 ? void 0 : _trgNetworkResponse$s2.state) || "";
  var data = (trgNetworkResponse === null || trgNetworkResponse === void 0 ? void 0 : (_trgNetworkResponse$s3 = trgNetworkResponse.scores) === null || _trgNetworkResponse$s3 === void 0 ? void 0 : (_trgNetworkResponse$s4 = _trgNetworkResponse$s3.data) === null || _trgNetworkResponse$s4 === void 0 ? void 0 : (_trgNetworkResponse$s5 = _trgNetworkResponse$s4.scores_30days) === null || _trgNetworkResponse$s5 === void 0 ? void 0 : (_trgNetworkResponse$s6 = _trgNetworkResponse$s5.Response) === null || _trgNetworkResponse$s6 === void 0 ? void 0 : (_trgNetworkResponse$s7 = _trgNetworkResponse$s6.Message) === null || _trgNetworkResponse$s7 === void 0 ? void 0 : _trgNetworkResponse$s7.scorebyunitoftime) || {};
  for (var key in data) {
    if (data[key] && data[key].aggscore === 0) {
      delete data[key].aggscore;
    }
    if (data[key] && data[key].datareliability === 0) {
      delete data[key].datareliability;
    }
    if (data[key] && data[key].hdvoicereliability === 0) {
      delete data[key].hdvoicereliability;
    }
    if (data[key] && data[key].samearea === 0) {
      delete data[key].samearea;
    }
    if (data[key] && data[key].samedevice === 0) {
      delete data[key].samedevice;
    }
  }
  var renderFormattedDateTick = function renderFormattedDateTick(date1) {
    var m = moment$1(new Date(date1));
    return m.format("MM/DD/YYYY");
  };
  var getAccessibilityTable = function getAccessibilityTable(data) {
    return /*#__PURE__*/React__default.createElement("table", {
      className: "scoreTable_customStyle",
      role: "presentation",
      "aria-label": "Network Experience " + Object.keys(data).length + " rows"
    }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header",
      scope: "col"
    }, "Date"), /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header",
      scope: "col"
    }, "Data Score"), /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header",
      scope: "col"
    }, "Voice Score"), /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header",
      scope: "col"
    }, "Experience Score"), /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header_nomax",
      scope: "col"
    }, "Customer with same device"), /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header_nomax",
      scope: "col"
    }, "Customer in same area"))), /*#__PURE__*/React__default.createElement("tbody", null, data.map(function (d) {
      return /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
        "class": "network_table_header",
        scope: "row"
      }, moment$1.utc(d.datetime).format("MM/DD/YYYY")), /*#__PURE__*/React__default.createElement("td", {
        "class": "network_table_cell"
      }, getStatus(d.dataperformance)), /*#__PURE__*/React__default.createElement("td", {
        "class": "network_table_cell"
      }, getStatus(d.hdvoicereliability)), /*#__PURE__*/React__default.createElement("td", {
        "class": "network_table_cell"
      }, getStatus(d.aggscore)), /*#__PURE__*/React__default.createElement("td", {
        "class": "network_table_cell"
      }, getStatus(d.samedevice)), /*#__PURE__*/React__default.createElement("td", {
        "class": "network_table_cell"
      }, getStatus(d.samearea)));
    })));
  };
  var getStatus = function getStatus(value) {
    if (value == "") {
      return "";
    } else if (value <= 50) {
      return "Poor";
    } else if (value <= 75) {
      return "Fair";
    } else if (value <= 85) {
      return "Average";
    } else if (value <= 95) {
      return "Good";
    } else {
      return "Excellent";
    }
  };
  var OverallTooltip = function OverallTooltip(props) {
    if (props && props.active) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "custom-tooltip"
      }, /*#__PURE__*/React__default.createElement("p", {
        className: "label"
      }, props.payload && props.payload[0] && props.payload[0].payload && props.payload[0].payload.aggscore ? getStatus(props.payload[0].payload.aggscore) : ""));
    }
    return null;
  };
  var DataTooltip = function DataTooltip(props) {
    if (props && props.active) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "custom-tooltip"
      }, /*#__PURE__*/React__default.createElement("p", {
        className: "label"
      }, props.payload && props.payload[0] && props.payload[0].payload && props.payload[0].payload.datareliability ? getStatus(props.payload[0].payload.datareliability) : ""));
    }
    return null;
  };
  var HDVoiceTooltip = function HDVoiceTooltip(props) {
    if (props && props.active) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "custom-tooltip"
      }, /*#__PURE__*/React__default.createElement("p", {
        className: "label"
      }, props.payload && props.payload[0] && props.payload[0].payload && props.payload[0].payload.hdvoicereliability ? getStatus(props.payload[0].payload.hdvoicereliability) : ""));
    }
    return null;
  };
  var SameAreaTooltip = function SameAreaTooltip(props) {
    if (props && props.active) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "custom-tooltip"
      }, /*#__PURE__*/React__default.createElement("p", {
        className: "label"
      }, props.payload && props.payload[0] && props.payload[0].payload && props.payload[0].payload.samearea ? getStatus(props.payload[0].payload.samearea) : ""));
    }
    return null;
  };
  var SameDeviceTooltip = function SameDeviceTooltip(props) {
    if (props && props.active) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "custom-tooltip"
      }, /*#__PURE__*/React__default.createElement("p", {
        className: "label"
      }, props.payload && props.payload[0] && props.payload[0].payload && props.payload[0].payload.samedevice ? getStatus(props.payload[0].payload.samedevice) : ""));
    }
    return null;
  };
  if (networkTabState == "COMPLETED") {
    return /*#__PURE__*/React__default.createElement(Fragment, null, Object.keys(data).length === 0 ? /*#__PURE__*/React__default.createElement("div", {
      className: "no-data-class vds-notification-icon"
    }, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      type: "info",
      title: "No data available for this MDN on the Network Experience tab.",
      fullBleed: true,
      inlineTreatment: false,
      layout: "horizontal",
      hideCloseButton: true
    })) : /*#__PURE__*/React__default.createElement(Fragment, null, (userProfile === null || userProfile === void 0 ? void 0 : userProfile.isAccessibilityUser) === "Y" ? /*#__PURE__*/React__default.createElement(Fragment, null, getAccessibilityTable(data)) : /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "radio-buttons-line"
    }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("label", {
      className: "label-class"
    }, /*#__PURE__*/React__default.createElement("input", {
      type: "radio",
      className: "radio-button",
      value: "overall",
      checked: selectedOption === "overall",
      onChange: function onChange(e) {
        return onValueChange(e);
      }
    }), "Overall")), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("label", {
      className: "label-class"
    }, /*#__PURE__*/React__default.createElement("input", {
      type: "radio",
      className: "radio-button",
      value: "data",
      checked: selectedOption === "data",
      onChange: function onChange(e) {
        return onValueChange(e);
      }
    }), "Data")), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("label", {
      className: "label-class"
    }, /*#__PURE__*/React__default.createElement("input", {
      type: "radio",
      className: "radio-button",
      value: "hdinvoice",
      checked: selectedOption === "hdinvoice",
      onChange: function onChange(e) {
        return onValueChange(e);
      }
    }), "HD voice"))), /*#__PURE__*/React__default.createElement("div", {
      className: "checkbox-line"
    },  /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("label", {
      className: windowWidthClass
    }, /*#__PURE__*/React__default.createElement("input", {
      type: "checkbox",
      className: "checkbox-button checkbox-checked-green",
      value: "same-device",
      checked: checkedState[0],
      onChange: function onChange() {
        return handleOnChange(0);
      }
    }), "Customer with same device")),  /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("label", {
      className: windowWidthClass
    }, /*#__PURE__*/React__default.createElement("input", {
      type: "checkbox",
      className: "checkbox-button checkbox-checked-yellow",
      value: "same-area",
      checked: checkedState[1],
      onChange: function onChange() {
        return handleOnChange(1);
      }
    }), "Customer in same area"))), /*#__PURE__*/React__default.createElement("div", {
      className: "displayGraph"
    }, /*#__PURE__*/React__default.createElement(ResponsiveContainer, {
      width: "100%",
      height: 400
    }, /*#__PURE__*/React__default.createElement(ComposedChart, {
      fontSize: "10px",
      data: data,
      cursor: "pointer",
      margin: {
        top: 10,
        right: 30,
        left: 20,
        bottom: 35
      }
    }, /*#__PURE__*/React__default.createElement(XAxis, {
      dataKey: "datetime",
      fill: "white",
      interval: 0,
      height: 90,
      allowDuplicatedCategory: false,
      tickFormatter: renderFormattedDateTick,
      tick: {
        angle: -45
      },
      textAnchor: "end",
      position: "left",
      stroke: themeColor
    }), /*#__PURE__*/React__default.createElement(YAxis, {
      yAxisId: "id1",
      domain: [0, 100],
      tickCount: 6,
      interval: 0,
      ticks: [0, 50, 75, 85, 95, 100],
      height: 100,
      tickFormatter: getStatus,
      stroke: themeColor,
      width: 100,
      tick: true,
      style: {
        fontSize: "0.8rem"
      }
    }), /*#__PURE__*/React__default.createElement(YAxis, {
      axisLine: false,
      tickLine: false,
      yAxisId: "id2",
      domain: [0, 100],
      tickCount: 6,
      interval: 0,
      ticks: [0, 50, 75, 85, 95, 100],
      height: 100,
      tickFormatter: getStatus,
      stroke: themeColor,
      width: 100,
      tick: false,
      style: {
        fontSize: "0.8rem"
      }
    }), /*#__PURE__*/React__default.createElement(YAxis, {
      axisLine: false,
      tickLine: false,
      yAxisId: "id3",
      domain: [0, 100],
      tickCount: 6,
      interval: 0,
      ticks: [0, 50, 75, 85, 95, 100],
      height: 100,
      tickFormatter: getStatus,
      stroke: themeColor,
      width: 100,
      tick: false,
      style: {
        fontSize: "0.8rem"
      }
    }), /*#__PURE__*/React__default.createElement(Tooltip$1, {
      wrapperStyle: function () {
        switch (type) {
          case "overall":
            return {
              backgroundColor: "black",
              color: "white"
            };
          case "data":
            return {
              backgroundColor: "black",
              color: "white"
            };
          case "hdinvoice":
            return {
              backgroundColor: "black",
              color: "white"
            };
          case "samearea":
            if (checkedState[1] === false) {
              return {
                backgroundColor: "black",
                color: "white"
              };
            }
            return {
              backgroundColor: "rgb(255, 102, 0)",
              color: "black"
            };
          case "samedevice":
            if (checkedState[0] === false) {
              return {
                backgroundColor: "black",
                color: "white"
              };
            }
            return {
              backgroundColor: "green",
              color: "white"
            };
          default:
            return null;
        }
      }(),
      labelStyle: {
        color: "green"
      },
      itemStyle: {
        color: "cyan"
      },
      formatter: function formatter(value) {
        return "" + value;
      },
      labelFormatter: function labelFormatter(value) {
        return "label: " + value;
      },
      content: function () {
        switch (type) {
          case "overall":
            return /*#__PURE__*/React__default.createElement(OverallTooltip, {
              payload: data
            });
          case "data":
            return /*#__PURE__*/React__default.createElement(DataTooltip, {
              payload: data
            });
          case "hdinvoice":
            return /*#__PURE__*/React__default.createElement(HDVoiceTooltip, {
              payload: data
            });
          case "samearea":
            return /*#__PURE__*/React__default.createElement(SameAreaTooltip, {
              payload: data
            });
          case "samedevice":
            return /*#__PURE__*/React__default.createElement(SameDeviceTooltip, {
              payload: data
            });
          default:
            return null;
        }
      }()
    }), selectedOption === "overall" && /*#__PURE__*/React__default.createElement(Area, {
      yAxisId: "id1",
      type: "linear",
      dataKey: "aggscore",
      stroke: "black",
      fillOpacity: 1,
      fill: themeColorAreaUnderGraph
    }), selectedOption === "overall" && /*#__PURE__*/React__default.createElement(Line$2, {
      yAxisId: "id1",
      isAnimationActive: false,
      type: "linear",
      name: "",
      dataKey: "aggscore",
      activeDot: {
        onMouseOver: function onMouseOver() {
          return setType({
            type: "overall"
          });
        }
      },
      stackId: "a",
      stroke: themeRadioOptions,
      legendType: "rect",
      fill: themeRadioOptions,
      strokeWidth: 4
    }), selectedOption === "data" && /*#__PURE__*/React__default.createElement(Area, {
      yAxisId: "id1",
      type: "linear",
      dataKey: "datareliability",
      stroke: "black",
      fillOpacity: 1,
      fill: themeColorAreaUnderGraph
    }), selectedOption === "data" && /*#__PURE__*/React__default.createElement(Line$2, {
      yAxisId: "id1",
      isAnimationActive: false,
      type: "linear",
      name: "Data Reliability",
      dataKey: "datareliability",
      activeDot: {
        onMouseOver: function onMouseOver() {
          return setType({
            type: "data"
          });
        }
      },
      stackId: "a",
      stroke: themeRadioOptions,
      legendType: "rect",
      fill: themeRadioOptions,
      strokeWidth: 4
    }), selectedOption === "hdinvoice" && /*#__PURE__*/React__default.createElement(Area, {
      yAxisId: "id1",
      type: "linear",
      dataKey: "hdvoicereliability",
      stroke: "black",
      fillOpacity: 1,
      fill: themeColorAreaUnderGraph
    }), selectedOption === "hdinvoice" && /*#__PURE__*/React__default.createElement(Line$2, {
      yAxisId: "id1",
      isAnimationActive: false,
      type: "linear",
      name: "HD Invoice Reliability",
      dataKey: "hdvoicereliability",
      activeDot: {
        onMouseOver: function onMouseOver() {
          return setType({
            type: "hdinvoice"
          });
        }
      },
      stackId: "a",
      stroke: themeRadioOptions,
      legendType: "rect",
      fill: themeRadioOptions,
      strokeWidth: 4
    }), checkedState[1] === true && /*#__PURE__*/React__default.createElement(Line$2, {
      yAxisId: "id2",
      isAnimationActive: false,
      type: "linear",
      name: "Customer with Same Area",
      dataKey: "samearea",
      activeDot: {
        onMouseOver: function onMouseOver() {
          return setType({
            type: "samearea"
          });
        }
      },
      stackId: "a",
      stroke: "rgb(255, 102, 0)",
      legendType: "rect",
      fill: "rgb(255, 102, 0)",
      strokeWidth: 4
    }), checkedState[0] === true && /*#__PURE__*/React__default.createElement(Line$2, {
      yAxisId: "id3",
      isAnimationActive: false,
      type: "linear",
      name: "Customer with Same Device",
      dataKey: "samedevice",
      activeDot: {
        onMouseOver: function onMouseOver() {
          return setType({
            type: "samedevice"
          });
        }
      },
      stackId: "a",
      stroke: "green",
      legendType: "rect",
      fill: "green",
      strokeWidth: 4
    })))))));
  } else if (networkTabState === "FAILED") {
    return /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      hideCloseButton: true,
      type: "error",
      id: "notfication-cont",
      notificationStyles: {
        height: "auto;"
      },
      children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "70%",
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        "data-testid": "dataLoadning"
      }, "The data has failed to load, please retry.")), /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "10%",
          "float": "left"
        }
      }, loading &&
      /*#__PURE__*/
      React__default.createElement("div", {
        className: "spinnerLoader"
      })), /*#__PURE__*/React__default.createElement("div", {
        style: {}
      }, /*#__PURE__*/React__default.createElement(StyledButton$4, {
        size: "small",
        "data-track": "Retry-Button",
        id: "noti-retry-btn",
        disabled: loading,
        onClick: onRetryClick
      }, "Retry")))
    });
  } else if (networkTabState === "INPROGRESS") {
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      id: "vds-notification-icon",
      hideCloseButton: true,
      type: "info",
      notificationStyles: {
        width: "100%"
      },
      children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "96%",
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "The data is still loading and will refresh when it's complete.")), /*#__PURE__*/React__default.createElement("div", {
        style: {
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "spinnerLoader"
      })))
    }));
  } else if ((networkData === null || networkData === void 0 ? void 0 : networkData.state) == "COMPLETED" && (IsNullOrUndefinedObj(trgNetworkResponse === null || trgNetworkResponse === void 0 ? void 0 : trgNetworkResponse.scores) || IsNullOrEmpty(trgNetworkResponse === null || trgNetworkResponse === void 0 ? void 0 : trgNetworkResponse.scores) || IsNullOrUndefinedObj((_trgNetworkResponse$s8 = trgNetworkResponse.scores) === null || _trgNetworkResponse$s8 === void 0 ? void 0 : _trgNetworkResponse$s8.header) || IsNullOrEmpty((_trgNetworkResponse$s9 = trgNetworkResponse.scores) === null || _trgNetworkResponse$s9 === void 0 ? void 0 : _trgNetworkResponse$s9.header))) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "no-data-class vds-notification-icon"
    }, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      type: "info",
      title: "No data available for this MDN on the Network Experience tab.",
      fullBleed: true,
      inlineTreatment: false,
      layout: "horizontal",
      hideCloseButton: true
    }));
  } else return /*#__PURE__*/React__default.createElement(Notification, {
    disableAnimation: true,
    hideCloseButton: true,
    type: "error",
    id: "notfication-cont",
    notificationStyles: {
      height: "auto;"
    },
    children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "70%",
        "float": "left"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      "data-testid": "dataLoadning"
    }, "Data loading is in progress or has failed to load.")), /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "10%",
        "float": "left"
      }
    }, loading &&
    /*#__PURE__*/
    React__default.createElement("div", {
      className: "spinnerLoader"
    })), /*#__PURE__*/React__default.createElement("div", {
      style: {}
    }, /*#__PURE__*/React__default.createElement(StyledButton$4, {
      size: "small",
      "data-track": "Retry-Button",
      id: "noti-retry-btn",
      disabled: loading,
      onClick: onRetryClick
    }, "Retry")))
  });
}

var _templateObject$1E;
var ProvisionButtonWrapper = styled.div(_templateObject$1E || (_templateObject$1E = _taggedTemplateLiteralLoose(["\n     padding-top: 15px;\n     \n"])));
var DisplayDate$1 = function DisplayDate() {
  var currentDate = new Date();
  var monthName = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
  var month = monthName[currentDate.getMonth()];
  var year = currentDate.getFullYear();
  var day = currentDate.getDate();
  day = day < 10 ? "0" + day : day;
  var hour = currentDate.getHours();
  var minutes = currentDate.getMinutes();
  var ampm = hour >= 12 ? "pm" : "am";
  hour = hour || 12;
  hour = hour > 12 ? hour - 12 : hour;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var disDate = month + " " + day + ", " + year + " " + hour + ":" + minutes + " " + ampm;
  return /*#__PURE__*/React__default.createElement("span", null, " ", disDate);
};
var syncNWBillingFlag = true;
var NPCustomerExperienceIssue = function NPCustomerExperienceIssue(props) {
  var _analysis$tables;
  var _ref = useFeatureFlag() || {},
    _ref$data = _ref.data,
    _ref$data2 = _ref$data === void 0 ? {} : _ref$data,
    _ref$data2$provisioni = _ref$data2.provisioningInsightsTableFFlag,
    provisioningInsightsTableFFlag = _ref$data2$provisioni === void 0 ? false : _ref$data2$provisioni;
  var analysis = props.analysis;
  var status = analysis.status,
    explanation = analysis.explanation,
    action = analysis.action,
    code = analysis.code;
  var Temp = analysis.tables && analysis.tables.map(function (table, idx) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: idx,
      className: "customerexperiencesubissue"
    }, /*#__PURE__*/React__default.createElement("hr", {
      className: "hr4"
    }), /*#__PURE__*/React__default.createElement("div", {
      "class": "contentDiv scroll-bar-settings"
    }, /*#__PURE__*/React__default.createElement("table", {
      className: "prov-table"
    }, /*#__PURE__*/React__default.createElement(RowHeader, {
      rowHeader: table.rowHeader,
      isDark: props.isDark
    }), /*#__PURE__*/React__default.createElement(Rows, {
      rows: table.rows,
      isDark: props.isDark
    }), /*#__PURE__*/React__default.createElement("br", null))));
  });
  if (provisioningInsightsTableFFlag ? (analysis === null || analysis === void 0 ? void 0 : (_analysis$tables = analysis.tables) === null || _analysis$tables === void 0 ? void 0 : _analysis$tables.length) > 0 : (analysis === null || analysis === void 0 ? void 0 : analysis.status) === "fault") {
    if (code === "Billing And Features" && analysis.hasOwnProperty("action") && Object.keys(action).length > 0 && action.type === "command" && action.value === "syncNEwithBilling") {
      syncNWBillingFlag = false;
    }
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Accordion, {
      status: analysis.status,
      explanation: analysis.explanation,
      content: Temp,
      isDark: props.isDark
    }));
  } else {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "customerexperienceissue"
    }, /*#__PURE__*/React__default.createElement("hr", {
      className: "hr"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "x-div"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "imgsize2",
      style: {
        marginTop: "0.625em"
      }
    }, /*#__PURE__*/React__default.createElement(StatusImage, {
      status: status,
      isDark: props.isDark
    })), /*#__PURE__*/React__default.createElement("span", {
      className: "expl1",
      style: {
        width: "70%",
        height: "100%",
        margin: "0.625rem"
      }
    }, explanation)));
  }
};
var NPCustomerExperienceIssues = function NPCustomerExperienceIssues(props) {
  var _props$analysis;
  var temp = (_props$analysis = props.analysis) === null || _props$analysis === void 0 ? void 0 : _props$analysis.map(function (issue, index) {
    return /*#__PURE__*/React__default.createElement(NPCustomerExperienceIssue, {
      key: index,
      analysis: issue,
      header: props.header[index],
      isDark: props.isDark
    });
  });
  return /*#__PURE__*/React__default.createElement("div", null, temp);
};
var Accordion = function Accordion(props) {
  var _useState = useState(false),
    isActive = _useState[0],
    setIsActive = _useState[1];
  return /*#__PURE__*/React__default.createElement("div", {
    className: "customerexperienceissue"
  }, /*#__PURE__*/React__default.createElement("hr", {
    className: "hr"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "x-div cursorPointer",
    onClick: function onClick() {
      return setIsActive(!isActive);
    },
    "data-testid": "accordion"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "imgsize",
    style: {
      marginTop: "0.625em"
    }
  }, /*#__PURE__*/React__default.createElement(StatusImage, {
    status: props.status,
    isDark: props.isDark
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "expl1",
    style: {
      width: "70%",
      height: "100%",
      margin: "0.625rem"
    }
  }, props.explanation), /*#__PURE__*/React__default.createElement("span", {
    "class": "accordionIcon2"
  }, isActive ? /*#__PURE__*/React__default.createElement("span", {
    "aria-label": "collapse"
  }, /*#__PURE__*/React__default.createElement(Minus, {
    name: "minus",
    size: "XLarge",
    surface: props.isDark ? 'dark' : 'light'
  })) : /*#__PURE__*/React__default.createElement("span", {
    "aria-label": "expand"
  }, /*#__PURE__*/React__default.createElement(Plus, {
    name: "plus",
    size: "XLarge",
    surface: props.isDark ? 'dark' : 'light'
  })))), isActive && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
    className: "span-expl"
  }, props.content)));
};
var StatusImage = function StatusImage(props) {
  switch (props.status) {
    case "fault":
      return /*#__PURE__*/React__default.createElement("span", {
        "aria-label": "issue found",
        title: "fault"
      }, /*#__PURE__*/React__default.createElement(CloseAlternate, {
        surface: props.isDark ? 'dark' : 'light',
        size: "XLarge",
        name: "close-alternate"
      }));
    case "tok":
      return /*#__PURE__*/React__default.createElement("span", {
        "aria-label": "no issue found",
        title: "ok"
      }, /*#__PURE__*/React__default.createElement(AlternateCheckmark, {
        surface: props.isDark ? 'dark' : 'light',
        size: "XLarge",
        name: "alternate-checkmark"
      }));
    case "info":
      return /*#__PURE__*/React__default.createElement("span", {
        "aria-label": "info",
        title: "info"
      }, /*#__PURE__*/React__default.createElement(Info, {
        size: "XLarge",
        surface: props.isDark ? 'dark' : 'light',
        name: "info"
      }));
    default:
      return /*#__PURE__*/React__default.createElement("span", {
        "aria-label": "inconclusive",
        title: "inconclusive"
      }, /*#__PURE__*/React__default.createElement(AlternateCheckmark, {
        surface: props.isDark ? 'dark' : 'light',
        size: "XLarge",
        name: "alternate-checkmark"
      }));
  }
};
var RowHeader = function RowHeader(props) {
  var rowHeaderTemp = props.rowHeader.map(function (header, idx) {
    return /*#__PURE__*/React__default.createElement("th", {
      key: idx
    }, header.name);
  });
  return /*#__PURE__*/React__default.createElement("tr", null, rowHeaderTemp);
};
var Row = function Row(props) {
  var row = props.row;
  var RowTemp = row && row.map(function (column, idx) {
    return /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "10px"
      }
    }, column.name, /*#__PURE__*/React__default.createElement("br", null));
  });
  return /*#__PURE__*/React__default.createElement("tr", {
    style: {
      borderBottom: "2px solid #817c7c"
    }
  }, RowTemp, /*#__PURE__*/React__default.createElement("br", null));
};
var Rows = function Rows(props) {
  var RowsTemp = props.rows.map(function (row, idx) {
    return /*#__PURE__*/React__default.createElement(Row, {
      row: row.columns
    });
  });
  return /*#__PURE__*/React__default.createElement("tbody", null, RowsTemp);
};
var Provisioning = function Provisioning(props) {
  var _window, _window$caseDetails, _selectedMTNData, _selectedMTNData$devi, _trgNetworkResponse$p, _trgNetworkResponse$p2, _trgNetworkResponse$p5, _trgNetworkResponse$p6;
  var _useNetworkData = useNetworkData(props),
    networkResponse = _useNetworkData.data;
  var _useProfileData = useProfileData(props),
    userProfileData = _useProfileData.data;
  var _useDeviceData = useDeviceData(props),
    deviceResponse = _useDeviceData.data;
  var _useState2 = useState("");
  var _useState3 = useState("");
  var _useState4 = useState(false),
    syncNwBillingTriggered = _useState4[0],
    setsyncNwBillingTriggered = _useState4[1];
  var _useState5 = useState(""),
    alertType = _useState5[0];
  var _useState6 = useState(false),
    showAlert = _useState6[0],
    setshowAlert = _useState6[1];
  var _useState7 = useState(false),
    loading = _useState7[0],
    setloading = _useState7[1];
  var _useState8 = useState(false),
    syncBillLoading = _useState8[0],
    setsyncBillLoading = _useState8[1];
  var _useState9 = useState("alert-open-service-case"),
    showClassName = _useState9[0];
  var _useState0 = useState({}),
    setuserProfile = _useState0[1];
  var _useState1 = useState({}),
    trgNetworkResponse = _useState1[0],
    settrgNetworkResponse = _useState1[1];
  var _useState10 = useState({}),
    settrgDeviceResp = _useState10[1];
  var prevProps = React__default.useRef(props);
  var _useState11 = useState({}),
    deviceData = _useState11[0],
    setdeviceData = _useState11[1];
  var _useState12 = useState({}),
    networkData = _useState12[0],
    setNetworkData = _useState12[1];
  useEffect(function () {
    var _deviceResponse$respo, _deviceResponse$respo2, _deviceResponse$respo3, _networkResponse$resp, _networkResponse$resp2, _networkResponse$resp3;
    setdeviceData(deviceResponse === null || deviceResponse === void 0 ? void 0 : (_deviceResponse$respo = deviceResponse.response) === null || _deviceResponse$respo === void 0 ? void 0 : (_deviceResponse$respo2 = _deviceResponse$respo.data) === null || _deviceResponse$respo2 === void 0 ? void 0 : (_deviceResponse$respo3 = _deviceResponse$respo2.body) === null || _deviceResponse$respo3 === void 0 ? void 0 : _deviceResponse$respo3.data);
    setNetworkData(networkResponse === null || networkResponse === void 0 ? void 0 : (_networkResponse$resp = networkResponse.response) === null || _networkResponse$resp === void 0 ? void 0 : (_networkResponse$resp2 = _networkResponse$resp.data) === null || _networkResponse$resp2 === void 0 ? void 0 : (_networkResponse$resp3 = _networkResponse$resp2.body) === null || _networkResponse$resp3 === void 0 ? void 0 : _networkResponse$resp3.data);
  }, [deviceResponse, networkResponse]);
  useEffect(function () {
    var syncNwBillingRespData = props.syncNwBillingRespData;
    if (props.trgNwDataE2EID !== prevProps.trgNwDataE2EID) {
      setloading(false);
    }
    if ((IsNullOrUndefinedObj(prevProps.syncNwBillingRespData) || IsNullOrEmpty(prevProps.syncNwBillingRespData)) && syncNwBillingRespData && !IsNullOrEmpty(syncNwBillingRespData) || prevProps.syncNwBillingRespData && syncNwBillingRespData && syncNwBillingRespData.e2eRequestId != prevProps.syncNwBillingRespData.e2eRequestId) {
      setsyncBillLoading(false);
    }
    var modalDialog = document.getElementById("acssdialog-close-icon");
    modalDialog && modalDialog.focus();
  }, [prevProps.syncNwBillingRespData, prevProps.trgNwDataE2EID]);
  useEffect(function () {
    settrgNetworkResponse(networkData);
    setuserProfile(userProfileData);
    settrgDeviceResp(deviceData);
  }, [networkData, deviceData]);
  var syncWithBilling = function syncWithBilling() {
    setsyncBillLoading(true);
    var _props$syncNwBillingR = props.syncNwBillingRespData,
      syncNwBillingRespData = _props$syncNwBillingR === void 0 ? "" : _props$syncNwBillingR;
    delete syncNwBillingRespData.results;
    setsyncNwBillingTriggered(true);
    setshowAlert(true);
  };
  var onRetryClick = function onRetryClick() {
    try {
      setloading(true);
      var dataPayload = payloadUseNetworkData(props, "provisioning");
      return Promise.resolve(getNetworkData(dataPayload).then(function (data) {
        console.log("on retry data++++++", data);
        if (data) {
          var _data$response, _data$response$data, _data$response$data$b;
          setloading(false);
          settrgNetworkResponse(data === null || data === void 0 ? void 0 : (_data$response = data.response) === null || _data$response === void 0 ? void 0 : (_data$response$data = _data$response.data) === null || _data$response$data === void 0 ? void 0 : (_data$response$data$b = _data$response$data.body) === null || _data$response$data$b === void 0 ? void 0 : _data$response$data$b.data);
        }
      })).then(function () {
        if (document.getElementById("Provisioning")) {
          document.getElementById("Provisioning").focus();
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var isDark = props.isDark,
    _props$syncNwBillingR2 = props.syncNwBillingRespData,
    syncNwBillingRespData = _props$syncNwBillingR2 === void 0 ? {} : _props$syncNwBillingR2,
    _props$params = props.params,
    _props$params2 = _props$params === void 0 ? {} : _props$params,
    _props$params2$device = _props$params2.deviceName,
    deviceName = _props$params2$device === void 0 ? '' : _props$params2$device;
  var _syncNwBillingRespDat = syncNwBillingRespData.results,
    results = _syncNwBillingRespDat === void 0 ? {} : _syncNwBillingRespDat;
  var selectedMTN = (_window = window) === null || _window === void 0 ? void 0 : (_window$caseDetails = _window.caseDetails) === null || _window$caseDetails === void 0 ? void 0 : _window$caseDetails.mtn;
  var selectedMTNData;
  if (deviceData) {
    var _deviceData$customerI, _deviceData$customerI2, _deviceData$customerI3;
    var mtns = deviceData === null || deviceData === void 0 ? void 0 : (_deviceData$customerI = deviceData.customerInsight) === null || _deviceData$customerI === void 0 ? void 0 : (_deviceData$customerI2 = _deviceData$customerI.billAccounts) === null || _deviceData$customerI2 === void 0 ? void 0 : (_deviceData$customerI3 = _deviceData$customerI2[0]) === null || _deviceData$customerI3 === void 0 ? void 0 : _deviceData$customerI3.mtns;
    selectedMTNData = mtns ? mtns.find(function (e) {
      return e.mtn === selectedMTN;
    }) : {};
  }
  var deviceInfo = (_selectedMTNData = selectedMTNData) === null || _selectedMTNData === void 0 ? void 0 : (_selectedMTNData$devi = _selectedMTNData.deviceInfo) === null || _selectedMTNData$devi === void 0 ? void 0 : _selectedMTNData$devi[0];
  var provisiongTabState = (trgNetworkResponse === null || trgNetworkResponse === void 0 ? void 0 : (_trgNetworkResponse$p = trgNetworkResponse.provisioning) === null || _trgNetworkResponse$p === void 0 ? void 0 : (_trgNetworkResponse$p2 = _trgNetworkResponse$p.header) === null || _trgNetworkResponse$p2 === void 0 ? void 0 : _trgNetworkResponse$p2.state) || "";
  var _ProductName = "";
  if (deviceInfo && deviceInfo.modelName && deviceInfo.modelName.length > 0) {
    _ProductName = deviceInfo.modelName;
  }
  if (deviceName) {
    _ProductName = deviceName;
  }
  if (provisiongTabState == "COMPLETED") {
    var _trgNetworkResponse$p3, _trgNetworkResponse$p4, _results$resultData, _results$resultData2, _results$resultData3, _results$resultData4;
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "provisioning_heading",
      id: "networkProvisioning_summary_tab_0"
    }, "Provisioning checks insights ( ", _ProductName, " @", /*#__PURE__*/React__default.createElement(DisplayDate$1, null), ")", /*#__PURE__*/React__default.createElement(ProvisionButtonWrapper, null, /*#__PURE__*/React__default.createElement("table", {
      className: "trg_provisioning_buttons_table"
    }, /*#__PURE__*/React__default.createElement("tr", null, (syncBillLoading || loading) && /*#__PURE__*/React__default.createElement("td", {
      width: "50px"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "spinnerLoader"
    })), /*#__PURE__*/React__default.createElement("td", {
      width: "50px"
    }, /*#__PURE__*/React__default.createElement(ProvisioningButton, {
      surface: props.isDark ? 'dark' : 'light',
      baseButton: true,
      size: "small",
      primary: true,
      disabled: syncNwBillingTriggered || syncNWBillingFlag,
      "data-testid": "syncWithBilling",
      onClick: function onClick() {
        return syncWithBilling();
      }
    }, "Sync with Billing")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(ProvisioningButton, {
      surface: props.isDark ? 'dark' : 'light',
      size: "small",
      secondary: true,
      disabled: loading,
      "data-testid": "onRetryClick",
      onClick: onRetryClick
    }, "Refresh")))))), /*#__PURE__*/React__default.createElement(NPCustomerExperienceIssues, {
      header: trgNetworkResponse === null || trgNetworkResponse === void 0 ? void 0 : (_trgNetworkResponse$p3 = trgNetworkResponse.provisioning) === null || _trgNetworkResponse$p3 === void 0 ? void 0 : _trgNetworkResponse$p3.header,
      analysis: trgNetworkResponse === null || trgNetworkResponse === void 0 ? void 0 : (_trgNetworkResponse$p4 = trgNetworkResponse.provisioning) === null || _trgNetworkResponse$p4 === void 0 ? void 0 : _trgNetworkResponse$p4.analysis,
      isDark: isDark
    }), showAlert && syncNwBillingTriggered && results && results.resultData && ((_results$resultData = results.resultData) === null || _results$resultData === void 0 ? void 0 : _results$resultData[0]) && ((_results$resultData2 = results.resultData) === null || _results$resultData2 === void 0 ? void 0 : _results$resultData2[0].status) && ((_results$resultData3 = results.resultData) === null || _results$resultData3 === void 0 ? void 0 : _results$resultData3[0].status.explanation) && /*#__PURE__*/React__default.createElement("div", {
      className: "no-data-class"
    }, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      alertType: alertType != "" ? alertType : "success",
      className: showClassName,
      close: showAlert,
      onClose: function onClose() {
        return setshowAlert(false);
      },
      toastMessage: ((_results$resultData4 = results.resultData) === null || _results$resultData4 === void 0 ? void 0 : _results$resultData4[0].status.explanation) + ".  Please wait for the operation to complete."
    })));
  } else if (provisiongTabState === "FAILED") {
    return /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      hideCloseButton: true,
      type: "error",
      id: "notfication-cont",
      notificationStyles: {
        height: "auto;"
      },
      children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "70%",
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        "data-testid": "dataLoadning"
      }, "The data has failed to load, please retry.")), /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "10%",
          "float": "left"
        }
      }, loading &&
      /*#__PURE__*/
      React__default.createElement("div", {
        className: "spinnerLoader"
      })), /*#__PURE__*/React__default.createElement("div", {
        style: {}
      }, /*#__PURE__*/React__default.createElement(StyledButton$4, {
        size: "small",
        "data-track": "Retry-Button",
        id: "noti-retry-btn",
        disabled: loading,
        onClick: onRetryClick
      }, "Retry")))
    });
  } else if (provisiongTabState === "INPROGRESS") {
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      id: "vds-notification-icon",
      hideCloseButton: true,
      type: "info",
      notificationStyles: {
        width: "100%"
      },
      children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "96%",
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "The data is still loading and will refresh when it's complete.")), /*#__PURE__*/React__default.createElement("div", {
        style: {
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "spinnerLoader"
      })))
    }));
  } else if ((networkData === null || networkData === void 0 ? void 0 : networkData.state) == "COMPLETED" && IsNullOrUndefinedObj(trgNetworkResponse) || IsNullOrEmpty(trgNetworkResponse) || IsNullOrUndefinedObj(trgNetworkResponse === null || trgNetworkResponse === void 0 ? void 0 : trgNetworkResponse.provisioning) || IsNullOrEmpty(trgNetworkResponse === null || trgNetworkResponse === void 0 ? void 0 : trgNetworkResponse.provisioning) || IsNullOrUndefinedObj(trgNetworkResponse === null || trgNetworkResponse === void 0 ? void 0 : (_trgNetworkResponse$p5 = trgNetworkResponse.provisioning) === null || _trgNetworkResponse$p5 === void 0 ? void 0 : _trgNetworkResponse$p5.analysis) || IsNullOrEmpty(trgNetworkResponse === null || trgNetworkResponse === void 0 ? void 0 : (_trgNetworkResponse$p6 = trgNetworkResponse.provisioning) === null || _trgNetworkResponse$p6 === void 0 ? void 0 : _trgNetworkResponse$p6.analysis)) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "no-data-class vds-notification-icon"
    }, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      type: "info",
      title: "No data available for this MDN on the Provisioning tab.",
      fullBleed: true,
      inlineTreatment: false,
      layout: "horizontal",
      hideCloseButton: true
    }));
  } else return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Notification, {
    disableAnimation: true,
    hideCloseButton: true,
    type: "error",
    id: "notfication-cont",
    notificationStyles: {
      height: "auto;"
    },
    children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "70%",
        "float": "left"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      "data-testid": "dataLoadning"
    }, "Data loading is in progress or has failed to load.")), /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "10%",
        "float": "left"
      }
    }, loading &&
    /*#__PURE__*/
    React__default.createElement("div", {
      className: "spinnerLoader"
    })), /*#__PURE__*/React__default.createElement("div", {
      style: {}
    }, /*#__PURE__*/React__default.createElement(StyledButton$4, {
      size: "small",
      "data-track": "Retry-Button",
      id: "noti-retry-btn",
      disabled: loading,
      onClick: onRetryClick
    }, "Retry")))
  }));
};

var _templateObject$1F, _templateObject2$1f, _templateObject3$_;
function getTextBoxColor$1(isDark) {
  return isDark ? "#ffffff" : "#000000";
}
function getPlaceholderColor$1(isDark) {
  return "#757575";
}
var SearchBox$5 = styled(Input$1)(_templateObject$1F || (_templateObject$1F = _taggedTemplateLiteralLoose(["\n  ", "\n\n  width: 250px;\n  height: 25px;\n  \n  padding: 1px 15px 2px 3px;\n  type: text;\n  background-color: transparent;\n  color: ", ";\n\n  ::-webkit-input-placeholder {\n    color: ", ";\n  }\n  ::-moz-placeholder {\n    color: ", ";\n  }\n  :-ms-input-placeholder {\n    color: ", ";\n  }\n  :-moz-placeholder {\n    color: ", ";\n  }\n\n  &:focus {\n    border-left: 1;\n    border-right: 1;\n    border-top: 1;\n  }\n  & svg {\n    color: ", "!important;\n  }\n"])), function (props) {
  return props.vdsDarkSelectBox && css(_templateObject2$1f || (_templateObject2$1f = _taggedTemplateLiteralLoose(["\n        span[class*=\"InputContainer-VDS\"] {\n          background: transparent;\n        }\n      "])));
}, function (props) {
  return getTextBoxColor$1(props.isDark);
}, function (props) {
  return getPlaceholderColor$1();
}, function (props) {
  return getPlaceholderColor$1();
}, function (props) {
  return getPlaceholderColor$1();
}, function (props) {
  return getPlaceholderColor$1();
}, function (props) {
  return props.isDark ? "#d8dada" : "#ffffff";
});
var CallRecordTableNoData = styled.div(_templateObject3$_ || (_templateObject3$_ = _taggedTemplateLiteralLoose(["\n   text-align: center;\n   margin-top: 10px;\n"])));
function InboundCallRecords(props) {
  var _networkData$call_rec5, _networkData$call_rec6, _networkData$call_rec7, _Object$keys, _networkData$call_rec8, _dispTableData$rows, _dispTableData$rowHea, _dispTableData$rows2, _dispTableData$rows2$, _dispTableData$rows3, _dispTableData$rows3$, _dispTableData$rows3$2;
  var _useNetworkData = useNetworkData(props),
    networkResponse = _useNetworkData.data,
    refetchNetworkResponse = _useNetworkData.refetch;
  var _useProfileData = useProfileData(props),
    userProfileData = _useProfileData.data;
  var _useState = useState([]);
  var _useState2 = useState(1);
  var _useState3 = useState(7);
  var _useState4 = useState(0);
  var _useState5 = useState(8),
    inboundRecordsPerPage = _useState5[0];
  var _useState6 = useState(0),
    inboundStartRecord = _useState6[0],
    setinboundStartRecord = _useState6[1];
  var _useState7 = useState(8),
    inboundEndRecord = _useState7[0],
    setinboundEndRecord = _useState7[1];
  var _useState8 = useState(1),
    inboundCurrentPage = _useState8[0],
    setinboundCurrentPage = _useState8[1];
  var _useState9 = useState(1),
    inboundPageNumbersToShow = _useState9[0];
  var _useState0 = useState(""),
    searchText = _useState0[0],
    setsearchText = _useState0[1];
  var _useState1 = useState({
      rowHeader: [],
      rows: []
    }),
    dispTableData = _useState1[0],
    setdispTableData = _useState1[1];
  var _useState10 = useState(""),
    order = _useState10[0],
    setorder = _useState10[1];
  var _useState11 = useState("");
  var _useState12 = useState("");
  var _useState13 = useState(false),
    loading = _useState13[0],
    setloading = _useState13[1];
  var _useState14 = useState({
      rowHeader: [],
      rows: []
    }),
    searchSortTableData = _useState14[0],
    setsearchSortTableData = _useState14[1];
  var _useState15 = useState({}),
    setuserProfile = _useState15[1];
  var _useState16 = useState({}),
    networkData = _useState16[0],
    setNetworkData = _useState16[1];
  var _useState17 = useState(null),
    selectedDate = _useState17[0],
    setSelectedDate = _useState17[1];
  var _useState18 = useState(""),
    selectedDateValue = _useState18[0],
    setSelectedDateValue = _useState18[1];
  var callRecordTableDefaultText = "No call records found in the last 7 days";
  var _useState19 = useState(callRecordTableDefaultText),
    callRecordTableMSG = _useState19[0],
    setCallRecordTableMSG = _useState19[1];
  var _ref = useFeatureFlag() || {},
    _ref$data = _ref.data,
    _ref$data2 = _ref$data === void 0 ? {} : _ref$data,
    _ref$data2$callRecord = _ref$data2.callRecordsMessageFFlag,
    callRecordsMessageFFlag = _ref$data2$callRecord === void 0 ? false : _ref$data2$callRecord;
  useEffect(function () {
    if (props.refresh) {
      setSelectedDate(null);
      setSelectedDateValue("");
    }
  }, [props.refresh]);
  useEffect(function () {
    var _networkResponse$resp, _networkResponse$resp2, _networkResponse$resp3;
    setNetworkData(networkResponse === null || networkResponse === void 0 ? void 0 : (_networkResponse$resp = networkResponse.response) === null || _networkResponse$resp === void 0 ? void 0 : (_networkResponse$resp2 = _networkResponse$resp.data) === null || _networkResponse$resp2 === void 0 ? void 0 : (_networkResponse$resp3 = _networkResponse$resp2.body) === null || _networkResponse$resp3 === void 0 ? void 0 : _networkResponse$resp3.data);
  }, [networkResponse]);
  var prevProps = React__default.useRef(props);
  useEffect(function () {
    if (props.trgNwDataE2EID !== prevProps.trgNwDataE2EID) {
      setloading(false);
    }
  }, [prevProps]);
  useEffect(function () {
    var _networkData$call_rec, _networkData$call_rec2, _networkData$call_rec3, _networkData$call_rec4;
    setuserProfile(userProfileData);
    var filterCallInRecords = networkData === null || networkData === void 0 ? void 0 : (_networkData$call_rec = networkData.call_records) === null || _networkData$call_rec === void 0 ? void 0 : (_networkData$call_rec2 = _networkData$call_rec.analysis) === null || _networkData$call_rec2 === void 0 ? void 0 : (_networkData$call_rec3 = _networkData$call_rec2[0]) === null || _networkData$call_rec3 === void 0 ? void 0 : (_networkData$call_rec4 = _networkData$call_rec3.tables) === null || _networkData$call_rec4 === void 0 ? void 0 : _networkData$call_rec4.filter(function (c) {
      return c.title === "Inbound Calls";
    });
    setdispTableData(filterCallInRecords ? filterCallInRecords === null || filterCallInRecords === void 0 ? void 0 : filterCallInRecords[0] : []);
    setsearchSortTableData(filterCallInRecords ? filterCallInRecords === null || filterCallInRecords === void 0 ? void 0 : filterCallInRecords[0] : []);
  }, [networkData]);
  var onRetryClick = function onRetryClick() {
    setloading(true);
    refetchNetworkResponse().then(function (data) {
      if (data) {
        setloading(false);
      }
    });
  };
  var loadInboundCalls = function loadInboundCalls(page) {
    setinboundCurrentPage(page);
    setinboundStartRecord((page - 1) * inboundRecordsPerPage);
    setinboundEndRecord(page * inboundRecordsPerPage);
  };
  var handleChange = function handleChange(event) {
    var name = event.target.name;
    var value = event.target.value;
    setsearchText(value);
    onChangeEvent(name, value);
  };
  var onChangeEvent = function onChangeEvent(name, value) {
    if (name === "searchText") {
      var originalData = JSON.parse(JSON.stringify(dispTableData));
      var dateRange = {
        startDate: "" + selectedDate,
        endDate: "" + selectedDate + " 23:59:59"
      };
      if (value != null && value != "") {
        var data = originalData === null || originalData === void 0 ? void 0 : originalData.rows;
        data = data.filter(function (srecord) {
          var s = true;
          if (selectedDate != "" && selectedDate != null) {
            var _srecord$columns, _srecord$columns$, _srecord$columns$$nam, _srecord$columns2, _srecord$columns2$;
            s = (srecord === null || srecord === void 0 ? void 0 : (_srecord$columns = srecord.columns) === null || _srecord$columns === void 0 ? void 0 : (_srecord$columns$ = _srecord$columns[0]) === null || _srecord$columns$ === void 0 ? void 0 : (_srecord$columns$$nam = _srecord$columns$.name) === null || _srecord$columns$$nam === void 0 ? void 0 : _srecord$columns$$nam.includes(searchText)) && moment$1(srecord === null || srecord === void 0 ? void 0 : (_srecord$columns2 = srecord.columns) === null || _srecord$columns2 === void 0 ? void 0 : (_srecord$columns2$ = _srecord$columns2[2]) === null || _srecord$columns2$ === void 0 ? void 0 : _srecord$columns2$.name).isBetween(dateRange.startDate, dateRange.endDate);
          } else {
            var _srecord$columns3, _srecord$columns3$, _srecord$columns3$$na;
            s = srecord === null || srecord === void 0 ? void 0 : (_srecord$columns3 = srecord.columns) === null || _srecord$columns3 === void 0 ? void 0 : (_srecord$columns3$ = _srecord$columns3[0]) === null || _srecord$columns3$ === void 0 ? void 0 : (_srecord$columns3$$na = _srecord$columns3$.name) === null || _srecord$columns3$$na === void 0 ? void 0 : _srecord$columns3$$na.includes(searchText);
          }
          return s;
        });
        originalData.rows = data;
      } else {
        if (selectedDate != "" && selectedDate != null) {
          var _data2;
          var _data = originalData.rows;
          _data = (_data2 = _data) === null || _data2 === void 0 ? void 0 : _data2.filter(function (srecord) {
            var _srecord$columns4, _srecord$columns4$;
            return moment$1(srecord === null || srecord === void 0 ? void 0 : (_srecord$columns4 = srecord.columns) === null || _srecord$columns4 === void 0 ? void 0 : (_srecord$columns4$ = _srecord$columns4[2]) === null || _srecord$columns4$ === void 0 ? void 0 : _srecord$columns4$.name).isBetween(dateRange.startDate, dateRange.endDate);
          });
          originalData.rows = _data;
        }
      }
      setsearchSortTableData(originalData);
      setinboundCurrentPage(1);
      setinboundStartRecord(0);
      setinboundEndRecord(8);
    }
  };
  var handleDateChange = function handleDateChange(date) {
    console.log("date-------", date);
    var getSelectedDate = moment$1(date, "MM/DD/YYYY").format("MM/DD/YYYY") || moment$1().format("MM/DD/YYYY");
    var callHistoryRequest = {
      startDate: "" + getSelectedDate,
      endDate: "" + getSelectedDate + " 23:59:59"
    };
    console.log("getSelectedDate-------", getSelectedDate);
    setSelectedDate(getSelectedDate);
    setSelectedDateValue(getSelectedDate);
    if (dispTableData) {
      filterDate(callHistoryRequest);
    }
  };
  var filterDate = function filterDate(range) {
    var originalData = JSON.parse(JSON.stringify(dispTableData));
    if (range != null) {
      var _data3;
      var data = originalData.rows;
      data = (_data3 = data) === null || _data3 === void 0 ? void 0 : _data3.filter(function (srecord) {
        var _srecord$columns5, _srecord$columns5$;
        return moment$1(srecord === null || srecord === void 0 ? void 0 : (_srecord$columns5 = srecord.columns) === null || _srecord$columns5 === void 0 ? void 0 : (_srecord$columns5$ = _srecord$columns5[2]) === null || _srecord$columns5$ === void 0 ? void 0 : _srecord$columns5$.name).isBetween(range.startDate, range.endDate);
      });
      originalData.rows = data;
      setCallRecordTableMSG("No records found for the selected date");
    }
    if (range === null) {
      setSelectedDate(null);
      setSelectedDateValue("");
      setCallRecordTableMSG(callRecordTableDefaultText);
    }
    setsearchSortTableData(originalData);
    setinboundCurrentPage(1);
    setinboundStartRecord(0);
    setinboundEndRecord(8);
  };
  var callInRecordsAllSearch = function callInRecordsAllSearch(callAllRecords, start, end) {
    var data = callAllRecords === null || callAllRecords === void 0 ? void 0 : callAllRecords.rows;
    return data === null || data === void 0 ? void 0 : data.slice(start, end).map(function (element) {
      var _element$columns;
      return /*#__PURE__*/React__default.createElement("tr", {
        style: {
          borderBottom: "1px solid #DCDCDC"
        }
      }, (_element$columns = element.columns) === null || _element$columns === void 0 ? void 0 : _element$columns.map(function (el) {
        return /*#__PURE__*/React__default.createElement("td", {
          className: "record"
        }, el.name);
      }));
    });
  };
  var sorting = function sorting(colIndex) {
    var prvData = searchSortTableData;
    var data = prvData.rows;
    var ordered = order == "" ? "ASC" : order;
    if (ordered === "ASC") {
      if (colIndex === 5) {
        var sorted = [].concat(data).sort(function (a, b) {
          return parseInt(a.columns[colIndex].name) < parseInt(b.columns[colIndex].name) ? 1 : -1;
        });
        prvData.rows = sorted;
      } else {
        var _sorted = [].concat(data).sort(function (a, b) {
          return a.columns[colIndex].name < b.columns[colIndex].name ? 1 : -1;
        });
        prvData.rows = _sorted;
      }
      setsearchSortTableData(prvData);
      setorder("DSC");
    }
    if (ordered === "DSC") {
      if (colIndex === 5) {
        var _sorted2 = [].concat(data).sort(function (a, b) {
          return parseInt(a.columns[colIndex].name) > parseInt(b.columns[colIndex].name) ? 1 : -1;
        });
        prvData.rows = _sorted2;
      } else {
        var _sorted3 = [].concat(data).sort(function (a, b) {
          return a.columns[colIndex].name > b.columns[colIndex].name ? 1 : -1;
        });
        prvData.rows = _sorted3;
      }
      setsearchSortTableData(prvData);
      setorder("ASC");
    }
  };
  var callRecordsTableWithPagination = function callRecordsTableWithPagination() {
    var _searchSortTableData$;
    if ((searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$ = searchSortTableData.rows) === null || _searchSortTableData$ === void 0 ? void 0 : _searchSortTableData$.length) > 0) {
      var _searchSortTableData$2, _searchSortTableData$3, _searchSortTableData$4, _searchSortTableData$5, _searchSortTableData$6;
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("table", {
        className: "call-table"
      }, /*#__PURE__*/React__default.createElement("tr", null, searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$2 = searchSortTableData.rowHeader) === null || _searchSortTableData$2 === void 0 ? void 0 : _searchSortTableData$2.map(function (item, index) {
        return /*#__PURE__*/React__default.createElement("th", {
          className: "record",
          "data-testid": "records",
          onClick: function onClick() {
            return sorting(index);
          }
        }, item.name, " ", order != "" && /*#__PURE__*/React__default.createElement(Icon$1, {
          name: "sort",
          size: "small",
          surface: isDark ? "dark" : "light"
        }), " ");
      })), /*#__PURE__*/React__default.createElement(Fragment, null, callInRecordsAllSearch(searchSortTableData, inboundStartRecord, inboundEndRecord))), /*#__PURE__*/React__default.createElement(Pagination$1, {
        totalPages: (searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$3 = searchSortTableData.rows) === null || _searchSortTableData$3 === void 0 ? void 0 : _searchSortTableData$3.length) % inboundRecordsPerPage > 0 ? Math.trunc((searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$4 = searchSortTableData.rows) === null || _searchSortTableData$4 === void 0 ? void 0 : _searchSortTableData$4.length) / inboundRecordsPerPage) + 1 : (searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$5 = searchSortTableData.rows) === null || _searchSortTableData$5 === void 0 ? void 0 : _searchSortTableData$5.length) / inboundRecordsPerPage,
        loadCalls: loadInboundCalls,
        totalRecordCount: searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$6 = searchSortTableData.rows) === null || _searchSortTableData$6 === void 0 ? void 0 : _searchSortTableData$6.length,
        currentPage: inboundCurrentPage,
        recordsPerPage: inboundRecordsPerPage,
        pageNumbers: inboundPageNumbersToShow
      }));
    } else {
      return /*#__PURE__*/React__default.createElement(CallRecordTableNoData, null, callRecordTableMSG);
    }
  };
  var isDark = props.isDark;
  var searchBoxProps = {
    inlineActionButtonLabel: /*#__PURE__*/React__default.createElement(Search, {
      size: "small",
      name: "search"
    })
  };
  var inBoundTabState = (networkData === null || networkData === void 0 ? void 0 : (_networkData$call_rec5 = networkData.call_records) === null || _networkData$call_rec5 === void 0 ? void 0 : (_networkData$call_rec6 = _networkData$call_rec5.header) === null || _networkData$call_rec6 === void 0 ? void 0 : _networkData$call_rec6.state) || "";
  var dynamicProps = isDark ? {
    vdsDarkSelectBox: true
  } : {
    vdsDarkSelectBox: false
  };
  if (inBoundTabState == "COMPLETED" && networkData !== null && networkData !== void 0 && (_networkData$call_rec7 = networkData.call_records) !== null && _networkData$call_rec7 !== void 0 && _networkData$call_rec7.data && ((_Object$keys = Object.keys(networkData === null || networkData === void 0 ? void 0 : (_networkData$call_rec8 = networkData.call_records) === null || _networkData$call_rec8 === void 0 ? void 0 : _networkData$call_rec8.data)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) !== 0) {
    var _searchSortTableData$7, _searchSortTableData$8, _searchSortTableData$9, _searchSortTableData$0, _searchSortTableData$1;
    console.log(selectedDate, "###############selectedDate");
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
      className: "callRecords"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "callRecords_heading"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "callRecords_heading_text"
    }, "Call summary"), /*#__PURE__*/React__default.createElement("div", {
      "class": "searchInput3"
    }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(SearchBox$5, _extends({
      surface: props.isDark ? 'dark' : 'light',
      autoComplete: "off",
      type: "inlineAction"
    }, searchBoxProps, {
      name: "searchText",
      iconName: "search",
      required: true
    }, dynamicProps, {
      size: 14,
      onChange: handleChange,
      placeholder: "Search recent Inbound Calls",
      "aria-label": "Search recent Inbound Calls",
      value: searchText,
      isDark: isDark,
      label: "Search recent Inbound Calls",
      maxLength: 150,
      disabled: false
    })))), /*#__PURE__*/React__default.createElement("div", {
      "class": "calendar1 vds-new-input"
    }, /*#__PURE__*/React__default.createElement("div", {
      id: "inboundCalendar"
    }, /*#__PURE__*/React__default.createElement(DatePicker, {
      alwaysOpen: false,
      readOnly: false,
      surface: props.isDark ? 'dark' : 'light',
      dateFormat: "MM/DD/YYYY",
      label: "",
      size: "18rem",
      onChange: handleDateChange,
      value: selectedDateValue,
      selectedDate: null,
      disabled: false,
      pastDatesDisabled: false,
      className: "inBoundCallRecordsDatePicker",
      "data-testid": "inBoundCallRecordsDatePicker",
      name: "inBoundCallRecordsDatePicker",
      error: false,
      required: false,
      minDate: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000),
      maxDate: new Date()
    })), /*#__PURE__*/React__default.createElement("button", {
      className: "inputButton vds-close-button " + (isDark ? "dark-btn" : ""),
      onClick: function onClick() {
        filterDate(null);
      }
    }, "x")))), /*#__PURE__*/React__default.createElement("hr", {
      className: "callRecordsHr"
    }), callRecordsMessageFFlag ? /*#__PURE__*/React__default.createElement(Fragment, null, callRecordsTableWithPagination()) : /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("table", {
      className: "call-table"
    }, /*#__PURE__*/React__default.createElement("tr", null, searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$7 = searchSortTableData.rowHeader) === null || _searchSortTableData$7 === void 0 ? void 0 : _searchSortTableData$7.map(function (item, index) {
      return /*#__PURE__*/React__default.createElement("th", {
        className: "record",
        "data-testid": "records",
        onClick: function onClick() {
          return sorting(index);
        }
      }, item.name, " ", order != "" && /*#__PURE__*/React__default.createElement(Icon$1, {
        name: "sort",
        size: "small",
        surface: isDark ? "dark" : "light"
      }), " ");
    })), /*#__PURE__*/React__default.createElement(Fragment, null, callInRecordsAllSearch(searchSortTableData, inboundStartRecord, inboundEndRecord))), /*#__PURE__*/React__default.createElement(Pagination$1, {
      totalPages: (searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$8 = searchSortTableData.rows) === null || _searchSortTableData$8 === void 0 ? void 0 : _searchSortTableData$8.length) % inboundRecordsPerPage > 0 ? Math.trunc((searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$9 = searchSortTableData.rows) === null || _searchSortTableData$9 === void 0 ? void 0 : _searchSortTableData$9.length) / inboundRecordsPerPage) + 1 : (searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$0 = searchSortTableData.rows) === null || _searchSortTableData$0 === void 0 ? void 0 : _searchSortTableData$0.length) / inboundRecordsPerPage,
      loadCalls: loadInboundCalls,
      totalRecordCount: searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$1 = searchSortTableData.rows) === null || _searchSortTableData$1 === void 0 ? void 0 : _searchSortTableData$1.length,
      currentPage: inboundCurrentPage,
      recordsPerPage: inboundRecordsPerPage,
      pageNumbers: inboundPageNumbersToShow
    }))), /*#__PURE__*/React__default.createElement("br", null));
  } else if (inBoundTabState === "FAILED") {
    return /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      hideCloseButton: true,
      type: "error",
      id: "notfication-cont",
      notificationStyles: {
        height: "auto;"
      },
      children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "70%",
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        "data-testid": "dataLoadning"
      }, "The data has failed to load, please retry.")), /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "10%",
          "float": "left"
        }
      }, loading &&
      /*#__PURE__*/
      React__default.createElement("div", {
        className: "spinnerLoader"
      })), /*#__PURE__*/React__default.createElement("div", {
        style: {}
      }, /*#__PURE__*/React__default.createElement(StyledButton$4, {
        surface: props.isDark ? 'dark' : 'light',
        size: "small",
        "data-track": "Retry-Button",
        id: "noti-retry-btn",
        disabled: loading,
        onClick: onRetryClick
      }, "Retry")))
    });
  } else if (inBoundTabState === "INPROGRESS") {
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      id: "vds-notification-icon",
      hideCloseButton: true,
      type: "info",
      notificationStyles: {
        width: "100%"
      },
      children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "96%",
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "The data is still loading and will refresh when it's complete.")), /*#__PURE__*/React__default.createElement("div", {
        style: {
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "spinnerLoader"
      })))
    }));
  } else if ((networkData === null || networkData === void 0 ? void 0 : networkData.state) == "COMPLETED" && (IsNullOrUndefinedObj(dispTableData) || IsNullOrEmpty(dispTableData) || IsNullOrUndefinedObj(dispTableData === null || dispTableData === void 0 ? void 0 : dispTableData.rows) || IsNullOrEmpty(dispTableData === null || dispTableData === void 0 ? void 0 : dispTableData.rows) || (dispTableData === null || dispTableData === void 0 ? void 0 : (_dispTableData$rows = dispTableData.rows) === null || _dispTableData$rows === void 0 ? void 0 : _dispTableData$rows.length) < 1 || IsNullOrUndefinedObj(dispTableData === null || dispTableData === void 0 ? void 0 : dispTableData.rowHeader) || IsNullOrEmpty(dispTableData === null || dispTableData === void 0 ? void 0 : dispTableData.rowHeader) || (dispTableData === null || dispTableData === void 0 ? void 0 : (_dispTableData$rowHea = dispTableData.rowHeader) === null || _dispTableData$rowHea === void 0 ? void 0 : _dispTableData$rowHea.length) < 1 || IsNullOrEmpty(dispTableData === null || dispTableData === void 0 ? void 0 : (_dispTableData$rows2 = dispTableData.rows) === null || _dispTableData$rows2 === void 0 ? void 0 : (_dispTableData$rows2$ = _dispTableData$rows2[0]) === null || _dispTableData$rows2$ === void 0 ? void 0 : _dispTableData$rows2$.columns) || (dispTableData === null || dispTableData === void 0 ? void 0 : (_dispTableData$rows3 = dispTableData.rows) === null || _dispTableData$rows3 === void 0 ? void 0 : (_dispTableData$rows3$ = _dispTableData$rows3[0]) === null || _dispTableData$rows3$ === void 0 ? void 0 : (_dispTableData$rows3$2 = _dispTableData$rows3$.columns) === null || _dispTableData$rows3$2 === void 0 ? void 0 : _dispTableData$rows3$2.length) < 1)) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "no-data-class vds-notification-icon"
    }, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      type: "info",
      title: "No Inbound Call Records available for this MDN.",
      fullBleed: true,
      inlineTreatment: false,
      layout: "horizontal",
      hideCloseButton: true
    }));
  } else return /*#__PURE__*/React__default.createElement(Notification, {
    disableAnimation: true,
    hideCloseButton: true,
    type: "error",
    id: "notfication-cont",
    notificationStyles: {
      height: "auto;"
    },
    children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "70%",
        "float": "left"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      "data-testid": "dataLoadning"
    }, "Data loading is in progress or has failed to load.")), /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "10%",
        "float": "left"
      }
    }, loading &&
    /*#__PURE__*/
    React__default.createElement("div", {
      className: "spinnerLoader"
    })), /*#__PURE__*/React__default.createElement("div", {
      style: {}
    }, /*#__PURE__*/React__default.createElement(StyledButton$4, {
      surface: props.isDark ? 'dark' : 'light',
      size: "small",
      "data-track": "Retry-Button",
      id: "noti-retry-btn",
      disabled: loading,
      onClick: onRetryClick
    }, "Retry")))
  });
}

var _templateObject$1G, _templateObject2$1g, _templateObject3$$;
function getTextBoxColor$2(isDark) {
  return isDark ? "#ffffff" : "#000000";
}
function getPlaceholderColor$2(isDark) {
  return "#757575";
}
var SearchBox$6 = styled(Input$1)(_templateObject$1G || (_templateObject$1G = _taggedTemplateLiteralLoose(["\n  ", "\n\n  width: 250px;\n  height: 25px;\n  \n  padding: 1px 15px 2px 3px;\n  type: text;\n  background-color: transparent;\n  color: ", ";\n\n  ::-webkit-input-placeholder {\n    color: ", ";\n  }\n  ::-moz-placeholder {\n    color: ", ";\n  }\n  :-ms-input-placeholder {\n    color: ", ";\n  }\n  :-moz-placeholder {\n    color: ", ";\n  }\n\n  &:focus {\n    border-left: 1;\n    border-right: 1;\n    border-top: 1;\n  }\n  & svg {\n    color: ", "!important;\n  }\n"])), function (props) {
  return props.vdsDarkSelectBox && css(_templateObject2$1g || (_templateObject2$1g = _taggedTemplateLiteralLoose(["\n        span[class*=\"InputContainer-VDS\"] {\n          background: transparent;\n        }\n      "])));
}, function (props) {
  return getTextBoxColor$2(props.isDark);
}, function (props) {
  return getPlaceholderColor$2();
}, function (props) {
  return getPlaceholderColor$2();
}, function (props) {
  return getPlaceholderColor$2();
}, function (props) {
  return getPlaceholderColor$2();
}, function (props) {
  return props.isDark ? "#d8dada" : "#ffffff";
});
var CallRecordTableNoData$1 = styled.div(_templateObject3$$ || (_templateObject3$$ = _taggedTemplateLiteralLoose(["\n   text-align: center;\n   margin-top: 10px;\n"])));
function OutboundCallRecords(props) {
  var _networkData$call_rec5, _networkData$call_rec6, _networkData$call_rec7, _Object$keys, _networkData$call_rec8, _dispTableData$rows, _dispTableData$rowHea, _dispTableData$rows2, _dispTableData$rows2$, _dispTableData$rows3, _dispTableData$rows3$, _dispTableData$rows3$2;
  var _useNetworkData = useNetworkData(props),
    networkResponse = _useNetworkData.data,
    refetchNetworkResponse = _useNetworkData.refetch;
  var _useProfileData = useProfileData(props),
    userProfileData = _useProfileData.data;
  var _useState = useState([]);
  var _useState2 = useState(1);
  var _useState3 = useState(7);
  var _useState4 = useState(0);
  var _useState5 = useState(8),
    outboundRecordsPerPage = _useState5[0];
  var _useState6 = useState(0),
    outboundStartRecord = _useState6[0],
    setoutboundStartRecord = _useState6[1];
  var _useState7 = useState(8),
    outboundEndRecord = _useState7[0],
    setoutboundEndRecord = _useState7[1];
  var _useState8 = useState(1),
    outboundCurrentPage = _useState8[0],
    setoutboundCurrentPage = _useState8[1];
  var _useState9 = useState(1),
    outboundPageNumbersToShow = _useState9[0];
  var _useState0 = useState(""),
    searchText = _useState0[0],
    setsearchText = _useState0[1];
  var _useState1 = useState({
      call_records: {
        analysis: []
      }
    });
  var _useState10 = useState({
      rowHeader: [],
      rows: []
    }),
    dispTableData = _useState10[0],
    setdispTableData = _useState10[1];
  var _useState11 = useState(""),
    order = _useState11[0],
    setorder = _useState11[1];
  var _useState12 = useState("");
  var _useState13 = useState("");
  var _useState14 = useState(false),
    loading = _useState14[0],
    setloading = _useState14[1];
  var _useState15 = useState({
      rowHeader: [],
      rows: []
    }),
    searchSortTableData = _useState15[0],
    setsearchSortTableData = _useState15[1];
  var _useState16 = useState({}),
    setuserProfile = _useState16[1];
  var _useState17 = useState({}),
    networkData = _useState17[0],
    setNetworkData = _useState17[1];
  var _useState18 = useState(null),
    selectedDate = _useState18[0],
    setSelectedDate = _useState18[1];
  var _useState19 = useState(""),
    selectedDateValue = _useState19[0],
    setSelectedDateValue = _useState19[1];
  var callRecordTableDefaultText = "No call records found in the last 7 days";
  var _useState20 = useState(callRecordTableDefaultText),
    callRecordTableMSG = _useState20[0],
    setCallRecordTableMSG = _useState20[1];
  var _ref = useFeatureFlag() || {},
    _ref$data = _ref.data,
    _ref$data2 = _ref$data === void 0 ? {} : _ref$data,
    _ref$data2$callRecord = _ref$data2.callRecordsMessageFFlag,
    callRecordsMessageFFlag = _ref$data2$callRecord === void 0 ? false : _ref$data2$callRecord;
  useEffect(function () {
    if (props.refresh) {
      setSelectedDate(null);
      setSelectedDateValue("");
    }
  }, [props.refresh]);
  useEffect(function () {
    var _networkResponse$resp, _networkResponse$resp2, _networkResponse$resp3;
    setNetworkData(networkResponse === null || networkResponse === void 0 ? void 0 : (_networkResponse$resp = networkResponse.response) === null || _networkResponse$resp === void 0 ? void 0 : (_networkResponse$resp2 = _networkResponse$resp.data) === null || _networkResponse$resp2 === void 0 ? void 0 : (_networkResponse$resp3 = _networkResponse$resp2.body) === null || _networkResponse$resp3 === void 0 ? void 0 : _networkResponse$resp3.data);
  }, [networkResponse]);
  var prevProps = React__default.useRef(props);
  useEffect(function () {
    if (props.trgNwDataE2EID !== prevProps.trgNwDataE2EID) {
      setloading(false);
    }
  }, [prevProps]);
  useEffect(function () {
    var _networkData$call_rec, _networkData$call_rec2, _networkData$call_rec3, _networkData$call_rec4;
    setuserProfile(userProfileData);
    var filterCallOutRecords = networkData === null || networkData === void 0 ? void 0 : (_networkData$call_rec = networkData.call_records) === null || _networkData$call_rec === void 0 ? void 0 : (_networkData$call_rec2 = _networkData$call_rec.analysis) === null || _networkData$call_rec2 === void 0 ? void 0 : (_networkData$call_rec3 = _networkData$call_rec2[0]) === null || _networkData$call_rec3 === void 0 ? void 0 : (_networkData$call_rec4 = _networkData$call_rec3.tables) === null || _networkData$call_rec4 === void 0 ? void 0 : _networkData$call_rec4.filter(function (c) {
      return c.title === "Outbound Calls";
    });
    setdispTableData(filterCallOutRecords ? filterCallOutRecords === null || filterCallOutRecords === void 0 ? void 0 : filterCallOutRecords[0] : []);
    setsearchSortTableData(filterCallOutRecords ? filterCallOutRecords === null || filterCallOutRecords === void 0 ? void 0 : filterCallOutRecords[0] : []);
  }, [networkData]);
  var onRetryClick = function onRetryClick() {
    var _refetchNetworkRespon;
    setloading(true);
    (_refetchNetworkRespon = refetchNetworkResponse()) === null || _refetchNetworkRespon === void 0 ? void 0 : _refetchNetworkRespon.then(function (data) {
      if (data) {
        setloading(false);
      }
    });
  };
  var loadOutboundCalls = function loadOutboundCalls(page) {
    setoutboundCurrentPage(page);
    setoutboundStartRecord((page - 1) * outboundRecordsPerPage);
    setoutboundEndRecord(page * outboundRecordsPerPage);
  };
  var handleChange = function handleChange(event) {
    var name = event.target.name;
    var value = event.target.value;
    setsearchText(value);
    onChangeEvent(name, value);
  };
  var onChangeEvent = function onChangeEvent(name, value) {
    if (name === "searchText") {
      var originalData = JSON.parse(JSON.stringify(dispTableData));
      var dateRange = {
        startDate: "" + selectedDate,
        endDate: "" + selectedDate + " 23:59:59"
      };
      if (value != null && value != "") {
        var _data;
        var data = originalData.rows;
        data = (_data = data) === null || _data === void 0 ? void 0 : _data.filter(function (srecord) {
          var s = true;
          if (selectedDate != "" && selectedDate != null) {
            var _srecord$columns, _srecord$columns$, _srecord$columns$$nam, _srecord$columns2, _srecord$columns2$;
            s = (srecord === null || srecord === void 0 ? void 0 : (_srecord$columns = srecord.columns) === null || _srecord$columns === void 0 ? void 0 : (_srecord$columns$ = _srecord$columns[0]) === null || _srecord$columns$ === void 0 ? void 0 : (_srecord$columns$$nam = _srecord$columns$.name) === null || _srecord$columns$$nam === void 0 ? void 0 : _srecord$columns$$nam.includes(searchText)) && moment$1(srecord === null || srecord === void 0 ? void 0 : (_srecord$columns2 = srecord.columns) === null || _srecord$columns2 === void 0 ? void 0 : (_srecord$columns2$ = _srecord$columns2[2]) === null || _srecord$columns2$ === void 0 ? void 0 : _srecord$columns2$.name).isBetween(dateRange.startDate, dateRange.endDate);
          } else {
            var _srecord$columns3, _srecord$columns3$, _srecord$columns3$$na;
            s = srecord === null || srecord === void 0 ? void 0 : (_srecord$columns3 = srecord.columns) === null || _srecord$columns3 === void 0 ? void 0 : (_srecord$columns3$ = _srecord$columns3[0]) === null || _srecord$columns3$ === void 0 ? void 0 : (_srecord$columns3$$na = _srecord$columns3$.name) === null || _srecord$columns3$$na === void 0 ? void 0 : _srecord$columns3$$na.includes(searchText);
          }
          return s;
        });
        originalData.rows = data;
      } else {
        if (selectedDate != "" && selectedDate != null) {
          var _data3;
          var _data2 = originalData.rows;
          _data2 = (_data3 = _data2) === null || _data3 === void 0 ? void 0 : _data3.filter(function (srecord) {
            var _srecord$columns4, _srecord$columns4$;
            return moment$1(srecord === null || srecord === void 0 ? void 0 : (_srecord$columns4 = srecord.columns) === null || _srecord$columns4 === void 0 ? void 0 : (_srecord$columns4$ = _srecord$columns4[2]) === null || _srecord$columns4$ === void 0 ? void 0 : _srecord$columns4$.name).isBetween(dateRange.startDate, dateRange.endDate);
          });
          originalData.rows = _data2;
        }
      }
      setsearchSortTableData(originalData);
      setoutboundCurrentPage(1);
      setoutboundStartRecord(0);
      setoutboundEndRecord(8);
    }
  };
  var handleDateChange = function handleDateChange(date) {
    var getSelectedDate = moment$1(date, "MM/DD/YYYY").format("MM/DD/YYYY") || moment$1().format("MM/DD/YYYY");
    var callHistoryRequest = {
      startDate: "" + getSelectedDate,
      endDate: "" + getSelectedDate + " 23:59:59"
    };
    setSelectedDate(getSelectedDate);
    setSelectedDateValue(getSelectedDate);
    if (dispTableData) {
      filterDate(callHistoryRequest);
    }
  };
  var filterDate = function filterDate(range) {
    var originalData = JSON.parse(JSON.stringify(dispTableData));
    if (range != null) {
      var _data4;
      var data = originalData.rows;
      data = (_data4 = data) === null || _data4 === void 0 ? void 0 : _data4.filter(function (srecord) {
        var _srecord$columns5, _srecord$columns5$;
        return moment$1(srecord === null || srecord === void 0 ? void 0 : (_srecord$columns5 = srecord.columns) === null || _srecord$columns5 === void 0 ? void 0 : (_srecord$columns5$ = _srecord$columns5[2]) === null || _srecord$columns5$ === void 0 ? void 0 : _srecord$columns5$.name).isBetween(range.startDate, range.endDate);
      });
      originalData.rows = data;
      setCallRecordTableMSG("No records found for the selected date");
    }
    if (range === null) {
      setSelectedDate(null);
      setSelectedDateValue("");
      setCallRecordTableMSG(callRecordTableDefaultText);
    }
    setsearchSortTableData(originalData);
    setoutboundCurrentPage(1);
    setoutboundStartRecord(0);
    setoutboundEndRecord(8);
  };
  var callOutRecordsAllSearch = function callOutRecordsAllSearch(callAllRecords, start, end) {
    var data = callAllRecords === null || callAllRecords === void 0 ? void 0 : callAllRecords.rows;
    return data === null || data === void 0 ? void 0 : data.slice(start, end).map(function (element) {
      var _element$columns;
      return /*#__PURE__*/React__default.createElement("tr", {
        style: {
          borderBottom: "1px solid #DCDCDC"
        }
      }, (_element$columns = element.columns) === null || _element$columns === void 0 ? void 0 : _element$columns.map(function (el) {
        return /*#__PURE__*/React__default.createElement("td", {
          className: "record"
        }, el.name);
      }));
    });
  };
  var sorting = function sorting(colIndex) {
    var prvData = searchSortTableData;
    var data = prvData.rows;
    var ordered = order == "" ? "ASC" : order;
    if (ordered === "ASC") {
      if (colIndex === 5) {
        var sorted = [].concat(data).sort(function (a, b) {
          return parseInt(a.columns[colIndex].name) < parseInt(b.columns[colIndex].name) ? 1 : -1;
        });
        prvData.rows = sorted;
      } else {
        var _sorted = [].concat(data).sort(function (a, b) {
          return a.columns[colIndex].name < b.columns[colIndex].name ? 1 : -1;
        });
        prvData.rows = _sorted;
      }
      setsearchSortTableData(prvData);
      setorder("DSC");
    }
    if (ordered === "DSC") {
      if (colIndex === 5) {
        var _sorted2 = [].concat(data).sort(function (a, b) {
          return parseInt(a.columns[colIndex].name) > parseInt(b.columns[colIndex].name) ? 1 : -1;
        });
        prvData.rows = _sorted2;
      } else {
        var _sorted3 = [].concat(data).sort(function (a, b) {
          return a.columns[colIndex].name > b.columns[colIndex].name ? 1 : -1;
        });
        prvData.rows = _sorted3;
      }
      setsearchSortTableData(prvData);
      setorder("ASC");
    }
  };
  var callRecordsTableWithPagination = function callRecordsTableWithPagination() {
    var _searchSortTableData$;
    if ((searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$ = searchSortTableData.rows) === null || _searchSortTableData$ === void 0 ? void 0 : _searchSortTableData$.length) > 0) {
      var _searchSortTableData$2, _searchSortTableData$3, _searchSortTableData$4, _searchSortTableData$5, _searchSortTableData$6;
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("table", {
        className: "call-table"
      }, /*#__PURE__*/React__default.createElement("tr", null, searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$2 = searchSortTableData.rowHeader) === null || _searchSortTableData$2 === void 0 ? void 0 : _searchSortTableData$2.map(function (item, index) {
        return /*#__PURE__*/React__default.createElement("th", {
          className: "record",
          "aria-label": item.name,
          onClick: function onClick() {
            return sorting(index);
          }
        }, item.name, " ", order != "" && /*#__PURE__*/React__default.createElement(Icon$1, {
          name: "sort",
          size: "small",
          surface: isDark ? "dark" : "light"
        }), " ");
      })), /*#__PURE__*/React__default.createElement(Fragment, null, callOutRecordsAllSearch(searchSortTableData, outboundStartRecord, outboundEndRecord))), /*#__PURE__*/React__default.createElement(Pagination$1, {
        totalPages: (searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$3 = searchSortTableData.rows) === null || _searchSortTableData$3 === void 0 ? void 0 : _searchSortTableData$3.length) % outboundRecordsPerPage > 0 ? Math.trunc((searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$4 = searchSortTableData.rows) === null || _searchSortTableData$4 === void 0 ? void 0 : _searchSortTableData$4.length) / outboundRecordsPerPage) + 1 : (searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$5 = searchSortTableData.rows) === null || _searchSortTableData$5 === void 0 ? void 0 : _searchSortTableData$5.length) / outboundRecordsPerPage,
        loadCalls: loadOutboundCalls,
        totalRecordCount: searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$6 = searchSortTableData.rows) === null || _searchSortTableData$6 === void 0 ? void 0 : _searchSortTableData$6.length,
        currentPage: outboundCurrentPage,
        recordsPerPage: outboundRecordsPerPage,
        pageNumbers: outboundPageNumbersToShow
      }));
    } else {
      return /*#__PURE__*/React__default.createElement(CallRecordTableNoData$1, null, callRecordTableMSG);
    }
  };
  var isDark = props.isDark;
  var searchBoxProps = {
    inlineActionButtonLabel: /*#__PURE__*/React__default.createElement(Search, {
      size: "small",
      name: "search"
    })
  };
  var outBoundTabState = (networkData === null || networkData === void 0 ? void 0 : (_networkData$call_rec5 = networkData.call_records) === null || _networkData$call_rec5 === void 0 ? void 0 : (_networkData$call_rec6 = _networkData$call_rec5.header) === null || _networkData$call_rec6 === void 0 ? void 0 : _networkData$call_rec6.state) || "";
  var dynamicProps = isDark ? {
    vdsDarkSelectBox: true
  } : {};
  if (outBoundTabState == "COMPLETED" && networkData !== null && networkData !== void 0 && (_networkData$call_rec7 = networkData.call_records) !== null && _networkData$call_rec7 !== void 0 && _networkData$call_rec7.data && ((_Object$keys = Object.keys(networkData === null || networkData === void 0 ? void 0 : (_networkData$call_rec8 = networkData.call_records) === null || _networkData$call_rec8 === void 0 ? void 0 : _networkData$call_rec8.data)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) !== 0) {
    var _searchSortTableData$7, _searchSortTableData$8, _searchSortTableData$9, _searchSortTableData$0, _searchSortTableData$1;
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
      className: "callRecords"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "callRecords_heading"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "callRecords_heading_text"
    }, "Call summary"), /*#__PURE__*/React__default.createElement("div", {
      "class": "searchInput3"
    }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(SearchBox$6, _extends({
      surface: props.isDark ? 'dark' : 'light',
      autoComplete: "off",
      type: "inlineAction"
    }, searchBoxProps, {
      name: "searchText",
      iconName: "search",
      required: true
    }, dynamicProps, {
      size: 14,
      onChange: handleChange,
      placeholder: "Search recent Outbound Calls",
      "aria-label": "Search recent Outbound Calls",
      value: searchText,
      isDark: isDark,
      label: "Search recent Outbound Calls",
      maxLength: 150,
      disabled: false
    })))), /*#__PURE__*/React__default.createElement("div", {
      "class": "calendar1 vds-new-input"
    }, /*#__PURE__*/React__default.createElement("div", {
      id: "outboundCalendar"
    }, /*#__PURE__*/React__default.createElement(DatePicker, {
      type: "calendar",
      surface: props.isDark ? 'dark' : 'light',
      dateFormat: "MM/DD/YYYY",
      label: "",
      size: "18rem",
      style: {
        height: "25px"
      },
      onChange: handleDateChange,
      value: selectedDateValue,
      selectedDate: null,
      disabled: false,
      pastDatesDisabled: false,
      className: "outBoundCallRecordsDatePicker",
      "data-testid": "outBoundCallRecordsDatePicker",
      name: "outBoundCallRecordsDatePicker",
      error: false,
      required: false,
      minDate: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000),
      maxDate: new Date()
    })), /*#__PURE__*/React__default.createElement("button", {
      className: "inputButton vds-close-button " + (isDark ? "dark-btn" : ""),
      onClick: function onClick() {
        filterDate(null);
      }
    }, "x")))), /*#__PURE__*/React__default.createElement("hr", {
      className: "callRecordsHr"
    }), callRecordsMessageFFlag ? /*#__PURE__*/React__default.createElement(Fragment, null, callRecordsTableWithPagination()) : /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("table", {
      className: "call-table"
    }, /*#__PURE__*/React__default.createElement("tr", null, searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$7 = searchSortTableData.rowHeader) === null || _searchSortTableData$7 === void 0 ? void 0 : _searchSortTableData$7.map(function (item, index) {
      return /*#__PURE__*/React__default.createElement("th", {
        className: "record",
        "aria-label": item.name,
        "data-testid": "records",
        onClick: function onClick() {
          return sorting(index);
        }
      }, item.name, " ", order != "" && /*#__PURE__*/React__default.createElement(Icon$1, {
        name: "sort",
        size: "small",
        surface: isDark ? "dark" : "light"
      }), " ");
    })), /*#__PURE__*/React__default.createElement(Fragment, null, callOutRecordsAllSearch(searchSortTableData, outboundStartRecord, outboundEndRecord))), /*#__PURE__*/React__default.createElement(Pagination$1, {
      totalPages: (searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$8 = searchSortTableData.rows) === null || _searchSortTableData$8 === void 0 ? void 0 : _searchSortTableData$8.length) % outboundRecordsPerPage > 0 ? Math.trunc((searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$9 = searchSortTableData.rows) === null || _searchSortTableData$9 === void 0 ? void 0 : _searchSortTableData$9.length) / outboundRecordsPerPage) + 1 : (searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$0 = searchSortTableData.rows) === null || _searchSortTableData$0 === void 0 ? void 0 : _searchSortTableData$0.length) / outboundRecordsPerPage,
      loadCalls: loadOutboundCalls,
      totalRecordCount: searchSortTableData === null || searchSortTableData === void 0 ? void 0 : (_searchSortTableData$1 = searchSortTableData.rows) === null || _searchSortTableData$1 === void 0 ? void 0 : _searchSortTableData$1.length,
      currentPage: outboundCurrentPage,
      recordsPerPage: outboundRecordsPerPage,
      pageNumbers: outboundPageNumbersToShow
    }))), /*#__PURE__*/React__default.createElement("br", null));
  } else if (outBoundTabState === "FAILED") {
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      hideCloseButton: true,
      type: "error",
      id: "notfication-cont",
      notificationStyles: {
        height: "auto;"
      },
      children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "70%",
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        "data-testid": "dataLoadning"
      }, "The data has failed to load, please retry.")), /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "10%",
          "float": "left"
        }
      }, loading &&
      /*#__PURE__*/
      React__default.createElement("div", {
        className: "spinnerLoader"
      })), /*#__PURE__*/React__default.createElement("div", {
        style: {}
      }, /*#__PURE__*/React__default.createElement(StyledButton$4, {
        surface: props.isDark ? 'dark' : 'light',
        size: "small",
        "data-track": "Retry-Button",
        id: "noti-retry-btn",
        disabled: loading,
        onClick: onRetryClick
      }, "Retry")))
    }));
  } else if (outBoundTabState === "INPROGRESS") {
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      id: "vds-notification-icon",
      hideCloseButton: true,
      type: "info",
      notificationStyles: {
        width: "100%"
      },
      children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "96%",
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "The data is still loading and will refresh when it's complete.")), /*#__PURE__*/React__default.createElement("div", {
        style: {
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "spinnerLoader"
      })))
    }));
  } else if ((networkData === null || networkData === void 0 ? void 0 : networkData.state) == "COMPLETED" && (IsNullOrUndefinedObj(dispTableData) || IsNullOrEmpty(dispTableData) || IsNullOrUndefinedObj(dispTableData === null || dispTableData === void 0 ? void 0 : dispTableData.rows) || IsNullOrEmpty(dispTableData === null || dispTableData === void 0 ? void 0 : dispTableData.rows) || (dispTableData === null || dispTableData === void 0 ? void 0 : (_dispTableData$rows = dispTableData.rows) === null || _dispTableData$rows === void 0 ? void 0 : _dispTableData$rows.length) < 1 || IsNullOrUndefinedObj(dispTableData === null || dispTableData === void 0 ? void 0 : dispTableData.rowHeader) || IsNullOrEmpty(dispTableData === null || dispTableData === void 0 ? void 0 : dispTableData.rowHeader) || (dispTableData === null || dispTableData === void 0 ? void 0 : (_dispTableData$rowHea = dispTableData.rowHeader) === null || _dispTableData$rowHea === void 0 ? void 0 : _dispTableData$rowHea.length) < 1 || IsNullOrEmpty(dispTableData === null || dispTableData === void 0 ? void 0 : (_dispTableData$rows2 = dispTableData.rows) === null || _dispTableData$rows2 === void 0 ? void 0 : (_dispTableData$rows2$ = _dispTableData$rows2[0]) === null || _dispTableData$rows2$ === void 0 ? void 0 : _dispTableData$rows2$.columns) || (dispTableData === null || dispTableData === void 0 ? void 0 : (_dispTableData$rows3 = dispTableData.rows) === null || _dispTableData$rows3 === void 0 ? void 0 : (_dispTableData$rows3$ = _dispTableData$rows3[0]) === null || _dispTableData$rows3$ === void 0 ? void 0 : (_dispTableData$rows3$2 = _dispTableData$rows3$.columns) === null || _dispTableData$rows3$2 === void 0 ? void 0 : _dispTableData$rows3$2.length) < 1)) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "no-data-class vds-notification-icon"
    }, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      type: "info",
      title: "No Outbound Call Records available for this MDN.",
      fullBleed: true,
      inlineTreatment: false,
      layout: "horizontal",
      hideCloseButton: true
    }));
  } else return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Notification, {
    disableAnimation: true,
    hideCloseButton: true,
    type: "error",
    id: "notfication-cont",
    notificationStyles: {
      height: "auto;"
    },
    children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "70%",
        "float": "left"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      "data-testid": "dataLoadning"
    }, "Data loading is in progress or has failed to load.")), /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "10%",
        "float": "left"
      }
    }, loading &&
    /*#__PURE__*/
    React__default.createElement("div", {
      className: "spinnerLoader"
    })), /*#__PURE__*/React__default.createElement("div", {
      style: {}
    }, /*#__PURE__*/React__default.createElement(StyledButton$4, {
      surface: props.isDark ? 'dark' : 'light',
      size: "small",
      "data-track": "Retry-Button",
      id: "noti-retry-btn",
      disabled: loading,
      onClick: onRetryClick
    }, "Retry")))
  }));
}

var _templateObject$1H;
var StyledTextLink$6 = styled(TextLink)(_templateObject$1H || (_templateObject$1H = _taggedTemplateLiteralLoose(["\n    \n    border-bottom:", ";\n    text-decoration:none;\n    font-weight:bold;\n    :hover{\n    color:", ";\n    border-bottom:", ";\n    text-decoration:none;\n    }\n  \n"])), function (props) {
  return props.selected ? "4px solid red" : "none";
}, function (props) {
  return props.isDark ? "#fff" : "#000";
}, function (props) {
  return props.selected ? "4px solid red" : "none";
});
var CallRecords = function CallRecords(props) {
  console.log("Call Records-->", props);
  var _useState = useState(1),
    selectedMenuID = _useState[0],
    setselectedMenuID = _useState[1];
  var _useState2 = useState(false),
    loading = _useState2[0],
    setloading = _useState2[1];
  var _useState3 = useState({}),
    settrgNetworkResponse = _useState3[1];
  var _useNetworkData = useNetworkData(props),
    networkResponse = _useNetworkData.data;
  var _useState4 = useState({}),
    setNetworkData = _useState4[1];
  var _useState5 = useState(false),
    refresh = _useState5[0],
    setRefresh = _useState5[1];
  var tabList = {
    1: "Network & Provisioning: Call records Inbound calls",
    2: "Network & Provisioning: Call records Outbound calls"
  };
  useEffect(function () {
    var _networkResponse$resp, _networkResponse$resp2, _networkResponse$resp3;
    setNetworkData(networkResponse === null || networkResponse === void 0 ? void 0 : (_networkResponse$resp = networkResponse.response) === null || _networkResponse$resp === void 0 ? void 0 : (_networkResponse$resp2 = _networkResponse$resp.data) === null || _networkResponse$resp2 === void 0 ? void 0 : (_networkResponse$resp3 = _networkResponse$resp2.body) === null || _networkResponse$resp3 === void 0 ? void 0 : _networkResponse$resp3.data);
    console.log("setNetworkData-->", networkResponse);
  }, [networkResponse]);
  var callRecTabs = [{
    tabId: 1,
    devDiagTabId: "callRec_inboundCallRecords",
    devDiagTabName: "Inbound Calls"
  }, {
    tabId: 2,
    devDiagTabId: "callRec_outboundCallRecords",
    devDiagTabName: "Outbound Calls"
  }];
  useEffect(function () {
    setloading(false);
    logSiteCatalystAndMetricsData(selectedMenuID);
  }, []);
  var handleUsageMetricsNoEvents = function handleUsageMetricsNoEvents(eventID, actionID, notes) {
    if (eventID === void 0) {
      eventID = '';
    }
    if (actionID === void 0) {
      actionID = '';
    }
    if (notes === void 0) {
      notes = '';
    }
    var metrics = [{
      eventID: eventID,
      actionID: actionID,
      notes: notes
    }];
    var _ref = props || {},
      logUsageMetrics = _ref.logUsageMetrics;
    if (logUsageMetrics) {
      logUsageMetrics({
        metrics: metrics
      });
    }
  };
  var logSiteCatalystAndMetricsData = function logSiteCatalystAndMetricsData(id) {
    switch (id) {
      case 1:
        handleUsageMetricsNoEvents("TROUBLESHOOTING", "INBOUND_CALL_RECORDS_LAUNCH", "Inbound Call Records");
        break;
      case 2:
        handleUsageMetricsNoEvents("TROUBLESHOOTING", "OUTBOUND_CALL_RECORDS_LAUNCH", "Outbound Call Records");
        break;
      default:
        handleUsageMetricsNoEvents("TROUBLESHOOTING", "INBOUND_CALL_RECORDS_LAUNCH", "Inbound Call Records");
        break;
    }
  };
  var menuClicked = function menuClicked(id, e) {
    e.preventDefault();
    setselectedMenuID(id);
    logSiteCatalystAndMetricsData(id);
    taggingForDeviceNetworkTile(tabList[id]);
  };
  var onRefreshClick = function onRefreshClick() {
    try {
      setloading(true);
      setRefresh(true);
      var dataPayload = payloadUseNetworkData(props, "call_records");
      return Promise.resolve(getNetworkData(dataPayload).then(function (data) {
        console.log("on retry data++++++", data);
        if (data) {
          var _data$response, _data$response$data, _data$response$data$b;
          setloading(false);
          settrgNetworkResponse(data === null || data === void 0 ? void 0 : (_data$response = data.response) === null || _data$response === void 0 ? void 0 : (_data$response$data = _data$response.data) === null || _data$response$data === void 0 ? void 0 : (_data$response$data$b = _data$response$data.body) === null || _data$response$data$b === void 0 ? void 0 : _data$response$data$b.data);
        }
      })).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var dynamicProps = props.isDark ? {
    primary: true
  } : {
    secondary: true
  };
  return /*#__PURE__*/React__default.createElement("div", {
    id: "devDiagContent",
    className: "tabContainer",
    role: "tablist",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tabContainerHeading"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tabsWrapper"
  }, callRecTabs && callRecTabs.length > 0 && callRecTabs.map(function (tab) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: tab.tabId,
      style: {
        display: "inline-block",
        margin: "0px 0px 10px 25px"
      }
    }, /*#__PURE__*/React__default.createElement(StyledTextLink$6, {
      href: "#",
      role: "tab",
      "aria-label": tab.devDiagTabName,
      "data-track": tab.devDiagTabName,
      "aria-haspopup": "false",
      "aria-selected": "" + (selectedMenuID === tab.tabId ? "true" : "false"),
      id: tab.devDiagTabName,
      onClick: function onClick(e) {
        menuClicked(tab.tabId, e);
      },
      selected: selectedMenuID === tab.tabId,
      isDark: props.isDark
    }, tab.devDiagTabName));
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "refresh_button_wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "refresh_button_div"
  }, /*#__PURE__*/React__default.createElement(StyledButton$4, _extends({
    surface: props.isDark ? 'dark' : 'light'
  }, dynamicProps, {
    size: "small",
    className: "refresh_button",
    disabled: loading,
    onClick: function onClick() {
      return onRefreshClick();
    }
  }), "Refresh")), /*#__PURE__*/React__default.createElement("div", {
    className: "refresh_img"
  }, loading && /*#__PURE__*/React__default.createElement("div", {
    className: "spinnerLoader"
  })))), selectedMenuID === 1 && /*#__PURE__*/React__default.createElement(InboundCallRecords, _extends({}, props, {
    refresh: refresh
  })), selectedMenuID === 2 && /*#__PURE__*/React__default.createElement(OutboundCallRecords, _extends({}, props, {
    refresh: refresh
  })));
};

var _templateObject$1I, _templateObject2$1h, _templateObject3$10, _templateObject4$X, _templateObject5$M, _templateObject6$E, _templateObject7$x, _templateObject8$t, _templateObject9$o, _templateObject0$l, _templateObject1$l, _templateObject10$g, _templateObject11$c, _templateObject12$b, _templateObject13$b, _templateObject14$a, _templateObject15$a;
var OVERVIEW_ASSETS = [{
  id: 1,
  title: "Voice call summary",
  col1: "Outbound Dropped Calls",
  col2: "Outbound Calls with Poor Performance",
  col3: "Inbound Dropped Calls",
  col4: "Inbound Calls with Poor Performance"
}, {
  id: 2,
  title: "Outbound calls by technology",
  col1: "LTE",
  col2: "Wi-fi",
  col3: "LTE Network extender"
}, {
  id: 3,
  title: "Inbound calls by technology",
  col1: "LTE",
  col2: "Wi-fi",
  col3: "LTE Network extender"
}];
var TileList = function TileList(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: props.isDark ? "networkCallSummary tileDarkBg" : "networkCallSummary tileBg"
  }, /*#__PURE__*/React__default.createElement(Accordion$1, {
    topLine: false,
    bottomLine: false,
    surface: props.isDark ? "dark" : "light"
  }, /*#__PURE__*/React__default.createElement(AccordionItem, null, /*#__PURE__*/React__default.createElement(AccordionHeader, {
    trigger: {
      type: "icon"
    }
  }, /*#__PURE__*/React__default.createElement(AccordionTitle, null, "Network and call summary")), /*#__PURE__*/React__default.createElement(AccordionDetail, null, /*#__PURE__*/React__default.createElement(TileletCarousel, {
    peek: "none",
    layout: "1UP",
    gutter: "24px",
    surface: props.isDark ? "dark" : "light",
    paginationFill: props.isDark ? "dark" : "light",
    paginationInset: "0px",
    paginationDisplay: "none",
    tileHeight: "100px",
    data: [{
      subtitle: {
        primitive: 'div',
        children: /*#__PURE__*/React__default.createElement(TileNew, {
          metadata: props.tilesmeta[0],
          data: [{
            col1: props.dataVoiceSummary && props.dataVoiceSummary.droppedOutboundCallSize || '-',
            col2: props.dataVoiceSummary && props.dataVoiceSummary.poorOutboundCallSize || '-',
            col3: props.dataVoiceSummary && props.dataVoiceSummary.droppedInboundCallSize || '-',
            col4: props.dataVoiceSummary && props.dataVoiceSummary.poorInboundCallSize || '-'
          }],
          isDark: props.isDark
        })
      },
      backgroundColor: props.isDark ? "black" : "white",
      showBorder: true
    }, {
      subtitle: {
        primitive: 'div',
        children: /*#__PURE__*/React__default.createElement(TileNew, {
          metadata: props.tilesmeta[1],
          data: [{
            col1: props.data && props.data.outbound_lte || '-',
            col2: props.data && props.data.outbound_wifi || '-',
            col3: props.data && props.data.outbound_femto || '-'
          }],
          isDark: props.isDark
        })
      },
      backgroundColor: props.isDark ? "black" : "white",
      showBorder: true
    }, {
      subtitle: {
        primitive: 'div',
        children: /*#__PURE__*/React__default.createElement(TileNew, {
          metadata: props.tilesmeta[2],
          data: [{
            col1: props.data && props.data.inbound_lte || '-',
            col2: props.data && props.data.inbound_wifi || '-',
            col3: props.data && props.data.inbound_femto || '-'
          }],
          isDark: props.isDark
        })
      },
      backgroundColor: props.isDark ? "black" : "white",
      showBorder: true
    }]
  })))));
};
var TileFlex = styled.div(_templateObject$1I || (_templateObject$1I = _taggedTemplateLiteralLoose(["\n      display: flex;\n      column-gap: 10px;\n      margin-top:", ";\n"])), function (_ref) {
  var index = _ref.index;
  return index === 1 ? '-7px' : '0';
});
var TileCell = styled.div(_templateObject2$1h || (_templateObject2$1h = _taggedTemplateLiteralLoose(["\n      flex:1;\n      background:#F6F6F6;\n      border-radius: 4px;\n      padding:5px;\n      background: ", ";\n      color: ", ";\n"])), function (props) {
  return props.isDark && '#202229 !important';
}, function (props) {
  return props.isDark && '#ffffff !important';
});
var FirstCell = styled.div(_templateObject3$10 || (_templateObject3$10 = _taggedTemplateLiteralLoose(["\n      flex:0.5;\n      border-right: 2px solid #000000;\n      padding:5px;\n"])));
var TileNew = function TileNew(props) {
  var _props$metadata = props.metadata,
    metadata = _props$metadata === void 0 ? {} : _props$metadata,
    _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    _props$isDark = props.isDark,
    isDark = _props$isDark === void 0 ? false : _props$isDark;
  var _Object$values$slice = Object.values(metadata).slice(1),
    firstRow = _Object$values$slice[0],
    rowHeaders = _Object$values$slice.slice(1);
  var columnData = data[0] ? Object.values(data[0]) : [];
  return /*#__PURE__*/React__default.createElement(TileFlex, {
    index: metadata.id,
    isDark: isDark
  }, /*#__PURE__*/React__default.createElement(FirstCell, {
    isDark: isDark
  }, /*#__PURE__*/React__default.createElement(Body, {
    size: "medium",
    color: isDark ? "#FFFFFF" : "#000000",
    bold: true
  }, firstRow)), rowHeaders.map(function (row, ind) {
    return /*#__PURE__*/React__default.createElement(TileCell, {
      isDark: isDark
    }, /*#__PURE__*/React__default.createElement(Body, {
      size: "medium",
      color: isDark ? "#FFFFFF" : "#000000",
      bold: true
    }, row + ':'), /*#__PURE__*/React__default.createElement(Body, {
      size: "large",
      color: isDark ? "#FFFFFF" : "#000000",
      bold: false
    }, columnData[ind]));
  }));
};
var TabsWrapper = styled.div(_templateObject4$X || (_templateObject4$X = _taggedTemplateLiteralLoose(["\n"])));
var IssuesContainer$4 = styled.div(_templateObject5$M || (_templateObject5$M = _taggedTemplateLiteralLoose([""])));
var NonIssuesContainer = styled.div(_templateObject6$E || (_templateObject6$E = _taggedTemplateLiteralLoose([""])));
var Section = styled.section(_templateObject7$x || (_templateObject7$x = _taggedTemplateLiteralLoose(["\n    display: flex;\n"])));
var SideNavigation = styled.aside(_templateObject8$t || (_templateObject8$t = _taggedTemplateLiteralLoose(["\nflex:1;\n"])));
var ConatentArea = styled.article(_templateObject9$o || (_templateObject9$o = _taggedTemplateLiteralLoose(["\nflex:3;\npadding-left:25px;\noverflow-x:scroll;\n"])));
var RadioGroupConatiner = styled.div(_templateObject0$l || (_templateObject0$l = _taggedTemplateLiteralLoose(["\n"])));
var RadioButtonContainer = styled.div(_templateObject1$l || (_templateObject1$l = _taggedTemplateLiteralLoose(["\n    padding: 12px 0 10px 18px;\n"])));
var NoIssuesFound = styled.div(_templateObject10$g || (_templateObject10$g = _taggedTemplateLiteralLoose(["\n    display:flex;\n    width:100%;\n    height:300px;\n    flex-wrap: wrap;\n    align-content:stretch;\n    align-items: center;\n"])));
var NoIssuesItems = styled.div(_templateObject11$c || (_templateObject11$c = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    text-align: center;\n"])));
var Deatails = styled.div(_templateObject12$b || (_templateObject12$b = _taggedTemplateLiteralLoose(["\npadding-top:16px"])));
var RightContentRenderer = function RightContentRenderer(_ref2) {
  var _parentInsightList, _parentInsightList2, _parentInsightList3;
  var currentIntentClick = _ref2.currentIntentClick,
    _ref2$selectedIssue = _ref2.selectedIssue,
    selectedIssue = _ref2$selectedIssue === void 0 ? {} : _ref2$selectedIssue,
    _ref2$isDark = _ref2.isDark,
    isDark = _ref2$isDark === void 0 ? false : _ref2$isDark,
    _ref2$analysis = _ref2.analysis,
    analysis = _ref2$analysis === void 0 ? [] : _ref2$analysis;
  var _useFeatureFlag = useFeatureFlag(),
    _useFeatureFlag$data = _useFeatureFlag.data,
    _useFeatureFlag$data2 = _useFeatureFlag$data === void 0 ? {} : _useFeatureFlag$data,
    _useFeatureFlag$data3 = _useFeatureFlag$data2.networkTroubleshootingCTAFFlag,
    networkTroubleshootingCTAFFlag = _useFeatureFlag$data3 === void 0 ? false : _useFeatureFlag$data3,
    _useFeatureFlag$data4 = _useFeatureFlag$data2.parentChildInsightMappingFFlag,
    parentChildInsightMappingFFlag = _useFeatureFlag$data4 === void 0 ? false : _useFeatureFlag$data4;
  var delphiParentInsight = selectedIssue.delphiParentInsight;
  var parentInsightList = [];
  if (parentChildInsightMappingFFlag && delphiParentInsight) {
    parentInsightList = analysis === null || analysis === void 0 ? void 0 : analysis.filter(function (issue) {
      return (issue === null || issue === void 0 ? void 0 : issue.delphiParentInsight) === delphiParentInsight;
    });
  }
  var renderDetails = function renderDetails(issue, hideTable) {
    if (hideTable === void 0) {
      hideTable = false;
    }
    var _issue$explanation = issue.explanation,
      explanation = _issue$explanation === void 0 ? '' : _issue$explanation,
      _issue$tables = issue.tables,
      tables = _issue$tables === void 0 ? [] : _issue$tables,
      _issue$troubleshootIn = issue.troubleshootIntent,
      troubleshootIntent = _issue$troubleshootIn === void 0 ? '' : _issue$troubleshootIn;
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ListItem$1, null, /*#__PURE__*/React__default.createElement(Body, {
      size: "large",
      color: isDark ? "#FFFFFF" : "#000000",
      bold: true
    }, explanation, networkTroubleshootingCTAFFlag && troubleshootIntent != '' && /*#__PURE__*/React__default.createElement(StyledButton$4, {
      "data-track": "L1|P2|Delhpi|||||Network & Provisioning|Troubleshooting",
      surface: isDark ? 'dark' : 'light',
      className: "trg_network_custom_btn",
      size: "small",
      onClick: function onClick() {
        return currentIntentClick(issue);
      }
    }, "Troubleshoot"))), /*#__PURE__*/React__default.createElement(Line$1, {
      type: "primary",
      surface: isDark ? "dark" : "light"
    }), !hideTable && /*#__PURE__*/React__default.createElement(Fragment, null, tables === null || tables === void 0 ? void 0 : tables.map(function (table, tableIdx) {
      var _table$title = table.title,
        title = _table$title === void 0 ? '' : _table$title,
        _table$rows = table.rows,
        rows = _table$rows === void 0 ? [] : _table$rows,
        _table$rowHeader = table.rowHeader,
        rowHeader = _table$rowHeader === void 0 ? [] : _table$rowHeader,
        _table$details = table.details,
        details = _table$details === void 0 ? '' : _table$details;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
        key: "_table" + explanation + tableIdx
      }, /*#__PURE__*/React__default.createElement(Deatails, null, /*#__PURE__*/React__default.createElement(Body, {
        size: "large",
        color: isDark ? "#FFFFFF" : "#000000",
        bold: false
      }, details)), /*#__PURE__*/React__default.createElement(ListItem$1, null, /*#__PURE__*/React__default.createElement(Body, {
        size: "large",
        color: isDark ? "#FFFFFF" : "#000000",
        bold: true
      }, title)), /*#__PURE__*/React__default.createElement(Line$1, {
        type: "primary",
        surface: isDark ? "dark" : "light"
      }), /*#__PURE__*/React__default.createElement(Table, {
        striped: false,
        surface: isDark ? 'dark' : 'light',
        padding: "compact"
      }, /*#__PURE__*/React__default.createElement(TableHead, null, rowHeader.map(function (head) {
        return /*#__PURE__*/React__default.createElement(TableHeader$1, null, head === null || head === void 0 ? void 0 : head.name);
      })), /*#__PURE__*/React__default.createElement(TableBody, null, rows.map(function (row, rowIdx) {
        var _row$columns = row.columns,
          columns = _row$columns === void 0 ? [] : _row$columns;
        return /*#__PURE__*/React__default.createElement(TableRow$1, {
          key: "_row" + title + rowIdx
        }, columns.map(function (column, colIdx) {
          var _column$name = column.name,
            name = _column$name === void 0 ? '' : _column$name;
          return /*#__PURE__*/React__default.createElement(Cell$1, {
            key: "_column" + title + colIdx
          }, name);
        }));
      }))));
    })));
  };
  return /*#__PURE__*/React__default.createElement(ConatentArea, null, parentChildInsightMappingFFlag ? /*#__PURE__*/React__default.createElement(Fragment, null, ((_parentInsightList = parentInsightList) === null || _parentInsightList === void 0 ? void 0 : _parentInsightList.length) == 0 ? renderDetails(selectedIssue) : /*#__PURE__*/React__default.createElement(Fragment, null, ((_parentInsightList2 = parentInsightList) === null || _parentInsightList2 === void 0 ? void 0 : _parentInsightList2.length) > 0 && ((_parentInsightList3 = parentInsightList) === null || _parentInsightList3 === void 0 ? void 0 : _parentInsightList3.map(function (issue) {
    return renderDetails(issue, true);
  })))) : renderDetails(selectedIssue));
};
var NPCustomerExperienceRendrer = function NPCustomerExperienceRendrer(props) {
  var _issueList$;
  var _props$issueList = props.issueList,
    issueList = _props$issueList === void 0 ? [] : _props$issueList,
    issueFromParent = props.selectedIssue,
    _props$isDark2 = props.isDark,
    isDark = _props$isDark2 === void 0 ? false : _props$isDark2,
    _props$analysis = props.analysis,
    analysis = _props$analysis === void 0 ? [] : _props$analysis;
  var _ref3 = issueFromParent || {},
    code = _ref3.code;
  var _useState = useState(code || ((_issueList$ = issueList[0]) === null || _issueList$ === void 0 ? void 0 : _issueList$.code)),
    radioValue = _useState[0],
    setRadioValue = _useState[1];
  var _useState2 = useState(code ? issueFromParent : issueList[0]),
    selectedIssue = _useState2[0],
    setSelectedIssue = _useState2[1];
  var _useTroubleShootInten = useTroubleShootIntentStore(),
    addItem = _useTroubleShootInten.addItem,
    removeItem = _useTroubleShootInten.removeItem;
  var handleTroubleShoot = function handleTroubleShoot(selctedIntent) {
    removeItem(0);
    addItem({
      selctedIntent: selctedIntent
    });
  };
  var handleRadioChange = function handleRadioChange(e, item) {
    setRadioValue(e.target.value);
    setSelectedIssue(item);
  };
  return /*#__PURE__*/React__default.createElement(Section, null, issueList.length > 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SideNavigation, null, issueList.length > 0 && /*#__PURE__*/React__default.createElement(RadioGroupConatiner, null, issueList.map(function (issue) {
    var _issue$code = issue.code,
      code = _issue$code === void 0 ? '' : _issue$code,
      _issue$explanation2 = issue.explanation,
      explanation = _issue$explanation2 === void 0 ? '' : _issue$explanation2,
      _issue$delphiParentIn = issue.delphiParentInsight,
      delphiParentInsight = _issue$delphiParentIn === void 0 ? '' : _issue$delphiParentIn;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(RadioButtonContainer, null, /*#__PURE__*/React__default.createElement(RadioButton, {
      name: "group",
      children: delphiParentInsight ? delphiParentInsight : explanation,
      value: code,
      ariaLabel: delphiParentInsight ? delphiParentInsight : explanation,
      onChange: function onChange(e) {
        return handleRadioChange(e, issue);
      },
      selected: radioValue === code,
      surface: isDark ? 'dark' : 'light'
    })), /*#__PURE__*/React__default.createElement(Line$1, {
      type: "secondary",
      surface: isDark ? "dark" : "light"
    }));
  }))), /*#__PURE__*/React__default.createElement(Line$1, {
    type: "secondary",
    orientation: "vertical",
    surface: isDark ? "dark" : "light"
  }), /*#__PURE__*/React__default.createElement(RightContentRenderer, {
    currentIntentClick: handleTroubleShoot,
    selectedIssue: selectedIssue,
    isDark: props.isDark,
    analysis: analysis
  })) : /*#__PURE__*/React__default.createElement(NoIssuesFound, null, /*#__PURE__*/React__default.createElement(NoIssuesItems, null, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "error",
    size: "large",
    color: "#000000",
    surface: isDark ? 'dark' : 'light'
  }), " No Issues Found")));
};
var OtherIssuesMain = styled.section(_templateObject13$b || (_templateObject13$b = _taggedTemplateLiteralLoose([""])));
var OtherIssuesContent = styled.article(_templateObject14$a || (_templateObject14$a = _taggedTemplateLiteralLoose([""])));
var ListItem$1 = styled.div(_templateObject15$a || (_templateObject15$a = _taggedTemplateLiteralLoose(["\npadding: 16px 0;\n"])));
var NonIssuesExpRenderer = function NonIssuesExpRenderer(_ref4) {
  var _ref4$issueList = _ref4.issueList,
    issueList = _ref4$issueList === void 0 ? [] : _ref4$issueList,
    _ref4$isDark = _ref4.isDark,
    isDark = _ref4$isDark === void 0 ? false : _ref4$isDark;
  return /*#__PURE__*/React__default.createElement(OtherIssuesMain, null, /*#__PURE__*/React__default.createElement(OtherIssuesContent, null, issueList.map(function (issue, idx) {
    var _issue$explanation3 = issue.explanation,
      explanation = _issue$explanation3 === void 0 ? '' : _issue$explanation3;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: issue + idx
    }, /*#__PURE__*/React__default.createElement(ListItem$1, null, /*#__PURE__*/React__default.createElement(Body, {
      size: "large",
      color: isDark ? "#FFFFFF" : "#000000",
      bold: false
    }, explanation)), idx !== issueList.length - 1 && /*#__PURE__*/React__default.createElement(Line$1, {
      type: "secondary",
      surface: isDark ? "dark" : "light"
    }));
  })));
};
var NPCustomerExperienceIssues$1 = function NPCustomerExperienceIssues(props) {
  var _useFeatureFlag2 = useFeatureFlag(),
    _useFeatureFlag2$data = _useFeatureFlag2.data,
    _useFeatureFlag2$data2 = _useFeatureFlag2$data === void 0 ? {} : _useFeatureFlag2$data,
    _useFeatureFlag2$data3 = _useFeatureFlag2$data2.parentChildInsightMappingFFlag,
    parentChildInsightMappingFFlag = _useFeatureFlag2$data3 === void 0 ? false : _useFeatureFlag2$data3,
    _useFeatureFlag2$data4 = _useFeatureFlag2$data2.badInsightsFFlag,
    badInsightsFFlag = _useFeatureFlag2$data4 === void 0 ? false : _useFeatureFlag2$data4;
  var _props$analysis2 = props.analysis,
    analysis = _props$analysis2 === void 0 ? [] : _props$analysis2,
    _props$isDark3 = props.isDark,
    isDark = _props$isDark3 === void 0 ? false : _props$isDark3;
  var expIssues;
  if (!badInsightsFFlag) {
    expIssues = analysis.filter(function (issue) {
      return issue.status === 'fault' && !issue.delphiParentInsight;
    });
  } else {
    expIssues = analysis.filter(function (issue) {
      return (issue.status === 'fault' || issue.status === 'bad') && !issue.delphiParentInsight;
    });
  }
  if (parentChildInsightMappingFFlag) {
    var _expIssues, _expIssues$push;
    var expParentInsightIssue = analysis === null || analysis === void 0 ? void 0 : analysis.filter(function (issue) {
      return (issue === null || issue === void 0 ? void 0 : issue.delphiParentInsight) != undefined;
    });
    var uniqueList = expParentInsightIssue === null || expParentInsightIssue === void 0 ? void 0 : expParentInsightIssue.filter(function (item, index, self) {
      return index === (self === null || self === void 0 ? void 0 : self.findIndex(function (t) {
        return (t === null || t === void 0 ? void 0 : t.delphiParentInsight) === (item === null || item === void 0 ? void 0 : item.delphiParentInsight);
      }));
    });
    (_expIssues = expIssues) === null || _expIssues === void 0 ? void 0 : (_expIssues$push = _expIssues.push) === null || _expIssues$push === void 0 ? void 0 : _expIssues$push.apply(expIssues, uniqueList);
  }
  var nonExpIssues;
  if (!badInsightsFFlag) {
    nonExpIssues = analysis.filter(function (issue) {
      return issue.status !== 'fault' && !issue.delphiParentInsight;
    });
  } else {
    nonExpIssues = analysis.filter(function (issue) {
      return issue.status !== 'fault' && issue.status !== 'bad' && !issue.delphiParentInsight;
    });
  }
  return /*#__PURE__*/React__default.createElement("section", null, /*#__PURE__*/React__default.createElement(TabsWrapper, null, /*#__PURE__*/React__default.createElement(Tabs$1, {
    surface: isDark ? "dark" : "light",
    orientation: "horizontal",
    indicatorPosition: "bottom"
  }, /*#__PURE__*/React__default.createElement(Tab, {
    label: "Issue Found (" + expIssues.length + ")"
  }, /*#__PURE__*/React__default.createElement(IssuesContainer$4, null, /*#__PURE__*/React__default.createElement(NPCustomerExperienceRendrer, _extends({
    type: "issues",
    issueList: expIssues
  }, props)))), /*#__PURE__*/React__default.createElement(Tab, {
    label: "Other Insights (" + nonExpIssues.length + ")"
  }, /*#__PURE__*/React__default.createElement(NonIssuesContainer, null, /*#__PURE__*/React__default.createElement(NonIssuesExpRenderer, _extends({
    type: "nonissues",
    issueList: nonExpIssues
  }, props)))))));
};
var SummaryNew = function SummaryNew(props) {
  var _trgNetworkResponse$c, _trgNetworkResponse$c2, _trgNetworkResponse$c3, _trgNetworkResponse$c4, _trgNetworkResponse$c5, _trgNetworkResponse$c6, _trgNetworkResponse$c7, _trgNetworkResponse$c8, _trgNetworkResponse$c9, _trgNetworkResponse$c0, _trgNetworkResponse$c1, _trgNetworkResponse$c10, _trgNetworkResponse$c11, _trgNetworkResponse$c12, _trgNetworkResponse$c13, _trgNetworkResponse$c14, _trgNetworkResponse$c15, _trgNetworkResponse$c16, _trgNetworkResponse$c17, _trgNetworkResponse$c18, _trgNetworkResponse$c19, _trgNetworkResponse$c20, _trgNetworkResponse$c21, _trgNetworkResponse$c22, _trgNetworkResponse$c23, _trgNetworkResponse$c24, _trgNetworkResponse$c25, _trgNetworkResponse$c26, _trgNetworkResponse$c27, _trgNetworkResponse$c28, _trgNetworkResponse$c29, _trgNetworkResponse$c30, _window, _window$caseDetails;
  var _useState3 = useState("");
  var _useState4 = useState("");
  var _useState5 = useState(false),
    loading = _useState5[0],
    setloading = _useState5[1];
  var _useState6 = useState(""),
    problemLocation = _useState6[0],
    setproblemLocation = _useState6[1];
  var _useState7 = useState({}),
    trgNetworkResponse = _useState7[0],
    settrgNetworkResponse = _useState7[1];
  var _useState8 = useState({}),
    setuserProfile = _useState8[1];
  var prevProps = React__default.useRef(props);
  var _props$selectedIssue = props.selectedIssue,
    selectedIssue = _props$selectedIssue === void 0 ? {} : _props$selectedIssue;
  var _useFeatureFlag3 = useFeatureFlag(),
    _useFeatureFlag3$data = _useFeatureFlag3.data,
    _useFeatureFlag3$data2 = _useFeatureFlag3$data === void 0 ? {} : _useFeatureFlag3$data,
    _useFeatureFlag3$data3 = _useFeatureFlag3$data2.summaryRefreshFFlag,
    summaryRefreshFFlag = _useFeatureFlag3$data3 === void 0 ? false : _useFeatureFlag3$data3;
  useEffect(function () {
    if (props.trgNwDataE2EID !== prevProps.trgNwDataE2EID) {
      setloading(false);
    }
  }, [prevProps === null || prevProps === void 0 ? void 0 : prevProps.trgNwDataE2EID]);
  var _useNetworkData = useNetworkData(props),
    networkResponse = _useNetworkData.data,
    refetchNetworkResponse = _useNetworkData.refetch;
  var _useProfileData = useProfileData(props),
    userProfileData = _useProfileData.data;
  var _useDeviceData = useDeviceData(props),
    deviceResponse = _useDeviceData.data;
  var _useState9 = useState({}),
    deviceData = _useState9[0],
    setdeviceData = _useState9[1];
  var _useState0 = useState({}),
    networkData = _useState0[0],
    setNetworkData = _useState0[1];
  useEffect(function () {
    var _deviceResponse$respo, _deviceResponse$respo2, _deviceResponse$respo3, _networkResponse$resp, _networkResponse$resp2, _networkResponse$resp3;
    setdeviceData(deviceResponse === null || deviceResponse === void 0 ? void 0 : (_deviceResponse$respo = deviceResponse.response) === null || _deviceResponse$respo === void 0 ? void 0 : (_deviceResponse$respo2 = _deviceResponse$respo.data) === null || _deviceResponse$respo2 === void 0 ? void 0 : (_deviceResponse$respo3 = _deviceResponse$respo2.body) === null || _deviceResponse$respo3 === void 0 ? void 0 : _deviceResponse$respo3.data);
    setNetworkData(networkResponse === null || networkResponse === void 0 ? void 0 : (_networkResponse$resp = networkResponse.response) === null || _networkResponse$resp === void 0 ? void 0 : (_networkResponse$resp2 = _networkResponse$resp.data) === null || _networkResponse$resp2 === void 0 ? void 0 : (_networkResponse$resp3 = _networkResponse$resp2.body) === null || _networkResponse$resp3 === void 0 ? void 0 : _networkResponse$resp3.data);
  }, [deviceResponse, networkResponse]);
  useEffect(function () {
    var _myObj$mtns, _myObj$mtns$;
    var mvoConfig = sessionStorage.getItem("mvoConfig");
    var myObj = JSON.parse(mvoConfig);
    var address = (myObj === null || myObj === void 0 ? void 0 : (_myObj$mtns = myObj.mtns) === null || _myObj$mtns === void 0 ? void 0 : (_myObj$mtns$ = _myObj$mtns[0]) === null || _myObj$mtns$ === void 0 ? void 0 : _myObj$mtns$.address) || "";
    setproblemLocation(address);
    settrgNetworkResponse(networkData);
    setuserProfile(userProfileData);
  }, [networkData]);
  var onRetryClick = function onRetryClick() {
    setloading(true);
    refetchNetworkResponse().then(function (data) {
      if (data) {
        var _data$response, _data$response$data, _data$response$data$b;
        setloading(false);
        settrgNetworkResponse(data === null || data === void 0 ? void 0 : (_data$response = data.response) === null || _data$response === void 0 ? void 0 : (_data$response$data = _data$response.data) === null || _data$response$data === void 0 ? void 0 : (_data$response$data$b = _data$response$data.body) === null || _data$response$data$b === void 0 ? void 0 : _data$response$data$b.data);
      }
    });
  };
  var onRefreshClick = function onRefreshClick() {
    try {
      setloading(true);
      return Promise.resolve(_getNetworkDataFunction(0)).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var _getNetworkDataFunction = function getNetworkDataFunction(pollcount) {
    try {
      var dataPayload = payloadUseNetworkData(props, "overview", pollcount);
      var maxPollCount = 15;
      return Promise.resolve(getNetworkData(dataPayload)).then(function (response) {
        var _response$response, _response$response$da, _responseValue$data;
        var responseValue = response === null || response === void 0 ? void 0 : (_response$response = response.response) === null || _response$response === void 0 ? void 0 : (_response$response$da = _response$response.data) === null || _response$response$da === void 0 ? void 0 : _response$response$da.body;
        var state = responseValue === null || responseValue === void 0 ? void 0 : (_responseValue$data = responseValue.data) === null || _responseValue$data === void 0 ? void 0 : _responseValue$data.state;
        var pollCount = responseValue === null || responseValue === void 0 ? void 0 : responseValue.pollCount;
        if (state === 'INPROGRESS' && pollCount < maxPollCount) {
          _getNetworkDataFunction(pollCount);
        } else if (state === 'COMPLETED') {
          settrgNetworkResponse(responseValue === null || responseValue === void 0 ? void 0 : responseValue.data);
          setloading(false);
          return;
        } else {
          setloading(false);
          return;
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var _props$isDark4 = props.isDark,
    isDark = _props$isDark4 === void 0 ? false : _props$isDark4;
  var poorOutboundCallSize = (_trgNetworkResponse$c = trgNetworkResponse === null || trgNetworkResponse === void 0 ? void 0 : (_trgNetworkResponse$c2 = trgNetworkResponse.call_records) === null || _trgNetworkResponse$c2 === void 0 ? void 0 : (_trgNetworkResponse$c3 = _trgNetworkResponse$c2.analysis) === null || _trgNetworkResponse$c3 === void 0 ? void 0 : (_trgNetworkResponse$c4 = _trgNetworkResponse$c3[0]) === null || _trgNetworkResponse$c4 === void 0 ? void 0 : (_trgNetworkResponse$c5 = _trgNetworkResponse$c4.tables) === null || _trgNetworkResponse$c5 === void 0 ? void 0 : (_trgNetworkResponse$c6 = _trgNetworkResponse$c5.filter(function (obj) {
    return obj.title === "Poor call quality outbound calls identified";
  })) === null || _trgNetworkResponse$c6 === void 0 ? void 0 : (_trgNetworkResponse$c7 = _trgNetworkResponse$c6[0]) === null || _trgNetworkResponse$c7 === void 0 ? void 0 : (_trgNetworkResponse$c8 = _trgNetworkResponse$c7.rows) === null || _trgNetworkResponse$c8 === void 0 ? void 0 : _trgNetworkResponse$c8.length) != null ? _trgNetworkResponse$c : "-";
  var poorInboundCallSize = (_trgNetworkResponse$c9 = trgNetworkResponse === null || trgNetworkResponse === void 0 ? void 0 : (_trgNetworkResponse$c0 = trgNetworkResponse.call_records) === null || _trgNetworkResponse$c0 === void 0 ? void 0 : (_trgNetworkResponse$c1 = _trgNetworkResponse$c0.analysis) === null || _trgNetworkResponse$c1 === void 0 ? void 0 : (_trgNetworkResponse$c10 = _trgNetworkResponse$c1[0]) === null || _trgNetworkResponse$c10 === void 0 ? void 0 : (_trgNetworkResponse$c11 = _trgNetworkResponse$c10.tables) === null || _trgNetworkResponse$c11 === void 0 ? void 0 : (_trgNetworkResponse$c12 = _trgNetworkResponse$c11.filter(function (obj) {
    return obj.title === "Poor call quality inbound calls identified";
  })) === null || _trgNetworkResponse$c12 === void 0 ? void 0 : (_trgNetworkResponse$c13 = _trgNetworkResponse$c12[0]) === null || _trgNetworkResponse$c13 === void 0 ? void 0 : (_trgNetworkResponse$c14 = _trgNetworkResponse$c13.rows) === null || _trgNetworkResponse$c14 === void 0 ? void 0 : _trgNetworkResponse$c14.length) != null ? _trgNetworkResponse$c9 : "-";
  var droppedOutboundCallSize = (_trgNetworkResponse$c15 = trgNetworkResponse === null || trgNetworkResponse === void 0 ? void 0 : (_trgNetworkResponse$c16 = trgNetworkResponse.call_records) === null || _trgNetworkResponse$c16 === void 0 ? void 0 : (_trgNetworkResponse$c17 = _trgNetworkResponse$c16.analysis) === null || _trgNetworkResponse$c17 === void 0 ? void 0 : (_trgNetworkResponse$c18 = _trgNetworkResponse$c17[0]) === null || _trgNetworkResponse$c18 === void 0 ? void 0 : (_trgNetworkResponse$c19 = _trgNetworkResponse$c18.tables) === null || _trgNetworkResponse$c19 === void 0 ? void 0 : (_trgNetworkResponse$c20 = _trgNetworkResponse$c19.filter(function (obj) {
    return obj.title === "Outbound dropped calls identified";
  })) === null || _trgNetworkResponse$c20 === void 0 ? void 0 : (_trgNetworkResponse$c21 = _trgNetworkResponse$c20[0]) === null || _trgNetworkResponse$c21 === void 0 ? void 0 : (_trgNetworkResponse$c22 = _trgNetworkResponse$c21.rows) === null || _trgNetworkResponse$c22 === void 0 ? void 0 : _trgNetworkResponse$c22.length) != null ? _trgNetworkResponse$c15 : "-";
  var droppedInboundCallSize = (_trgNetworkResponse$c23 = trgNetworkResponse === null || trgNetworkResponse === void 0 ? void 0 : (_trgNetworkResponse$c24 = trgNetworkResponse.call_records) === null || _trgNetworkResponse$c24 === void 0 ? void 0 : (_trgNetworkResponse$c25 = _trgNetworkResponse$c24.analysis) === null || _trgNetworkResponse$c25 === void 0 ? void 0 : (_trgNetworkResponse$c26 = _trgNetworkResponse$c25[0]) === null || _trgNetworkResponse$c26 === void 0 ? void 0 : (_trgNetworkResponse$c27 = _trgNetworkResponse$c26.tables) === null || _trgNetworkResponse$c27 === void 0 ? void 0 : (_trgNetworkResponse$c28 = _trgNetworkResponse$c27.filter(function (obj) {
    return obj.title === "Inbound dropped calls identified";
  })) === null || _trgNetworkResponse$c28 === void 0 ? void 0 : (_trgNetworkResponse$c29 = _trgNetworkResponse$c28[0]) === null || _trgNetworkResponse$c29 === void 0 ? void 0 : (_trgNetworkResponse$c30 = _trgNetworkResponse$c29.rows) === null || _trgNetworkResponse$c30 === void 0 ? void 0 : _trgNetworkResponse$c30.length) != null ? _trgNetworkResponse$c23 : "-";
  var dynamicProps = isDark ? {
    primary: true
  } : {
    secondary: true
  };
  var call_records_data = trgNetworkResponse && trgNetworkResponse.call_records && trgNetworkResponse.call_records.data || {};
  var _ref5 = props || {},
    _ref5$params = _ref5.params,
    _ref5$params2 = _ref5$params === void 0 ? {} : _ref5$params,
    _ref5$params2$mdn = _ref5$params2.mdn,
    mdn = _ref5$params2$mdn === void 0 ? '' : _ref5$params2$mdn;
  var selectedMTN = ((_window = window) === null || _window === void 0 ? void 0 : (_window$caseDetails = _window.caseDetails) === null || _window$caseDetails === void 0 ? void 0 : _window$caseDetails.mtn) || mdn;
  var selectedMTNData;
  if (deviceData) {
    var _deviceData$customerI, _deviceData$customerI2, _deviceData$customerI3;
    var mtns = deviceData === null || deviceData === void 0 ? void 0 : (_deviceData$customerI = deviceData.customerInsight) === null || _deviceData$customerI === void 0 ? void 0 : (_deviceData$customerI2 = _deviceData$customerI.billAccounts) === null || _deviceData$customerI2 === void 0 ? void 0 : (_deviceData$customerI3 = _deviceData$customerI2[0]) === null || _deviceData$customerI3 === void 0 ? void 0 : _deviceData$customerI3.mtns;
    selectedMTNData = mtns ? mtns.find(function (e) {
      return e.mtn === selectedMTN;
    }) : {};
  }
  var isFWADevice_ = isFWADevice(selectedMTNData);
  var summaryTabState = trgNetworkResponse && trgNetworkResponse.overview && trgNetworkResponse.overview.header && trgNetworkResponse.overview.header.state && trgNetworkResponse.overview.header.state || "";
  var problemLocationButton = /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "40px"
    }
  });
  if (problemLocation.length > 0) {
    problemLocationButton = /*#__PURE__*/React__default.createElement(StyledButton$4, _extends({}, dynamicProps, {
      size: "small",
      className: "problem_location_button",
      disabled: loading,
      onClick: function onClick() {
        onRetryClick();
      }
    }), /*#__PURE__*/React__default.createElement("span", {
      "aria-label": "submit problem location"
    }, "GO"));
  }
  if (summaryTabState == "COMPLETED") {
    var _trgNetworkResponse$o;
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      "class": "summary_heading",
      id: "networkProvisioning_summary_tab_0"
    }, "Overall customer experience from the past 7 days", summaryRefreshFFlag && /*#__PURE__*/React__default.createElement("div", {
      className: "refresh_button_wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "refresh_button_div"
    }, /*#__PURE__*/React__default.createElement(StyledButton$4, _extends({
      surface: props.isDark ? 'dark' : 'light'
    }, dynamicProps, {
      size: "small",
      className: "refresh_button",
      "data-testid": "onRetryClickID",
      disabled: loading,
      onClick: function onClick() {
        return onRefreshClick();
      }
    }), "Refresh")), /*#__PURE__*/React__default.createElement("div", {
      className: "refresh_img"
    }, loading && /*#__PURE__*/React__default.createElement("div", {
      className: "spinnerLoader"
    })))), !isFWADevice_ && /*#__PURE__*/React__default.createElement(TileList, {
      tilesmeta: OVERVIEW_ASSETS,
      data: call_records_data,
      dataVoiceSummary: {
        poorOutboundCallSize: poorOutboundCallSize,
        poorInboundCallSize: poorInboundCallSize,
        droppedOutboundCallSize: droppedOutboundCallSize,
        droppedInboundCallSize: droppedInboundCallSize
      },
      isDark: isDark
    }), /*#__PURE__*/React__default.createElement(Line$1, {
      type: "secondary",
      style: {
        marginTop: "12px"
      },
      surface: isDark ? "dark" : "light"
    }), (trgNetworkResponse === null || trgNetworkResponse === void 0 ? void 0 : (_trgNetworkResponse$o = trgNetworkResponse.overview) === null || _trgNetworkResponse$o === void 0 ? void 0 : _trgNetworkResponse$o.analysis) && /*#__PURE__*/React__default.createElement(NPCustomerExperienceIssues$1, {
      header: trgNetworkResponse && trgNetworkResponse.overview && trgNetworkResponse.overview.header || {},
      analysis: trgNetworkResponse && trgNetworkResponse.overview && trgNetworkResponse.overview.analysis || [],
      selectedIssue: selectedIssue,
      isDark: isDark
    }));
  } else if (summaryTabState === "FAILED") {
    return /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      hideCloseButton: true,
      type: "error",
      id: "notfication-cont",
      notificationStyles: {
        height: "auto;"
      },
      children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "70%",
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        "data-testid": "dataLoadning"
      }, "The data has failed to load, please retry.")), /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "10%",
          "float": "left"
        }
      }, loading &&
      /*#__PURE__*/
      React__default.createElement("div", {
        className: "spinnerLoader"
      })), /*#__PURE__*/React__default.createElement("div", {
        style: {}
      }, /*#__PURE__*/React__default.createElement(StyledButton$4, {
        size: "small",
        "data-track": "Retry-Button",
        id: "noti-retry-btn",
        disabled: loading,
        onClick: onRetryClick
      }, "Retry")))
    });
  } else if (summaryTabState === "INPROGRESS") {
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      id: "vds-notification-icon",
      hideCloseButton: true,
      type: "info",
      children: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: "96%",
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "The data is still loading and will refresh when it's complete.")), /*#__PURE__*/React__default.createElement("div", {
        style: {
          "float": "left"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "spinnerLoader"
      })))
    }));
  } else if ((networkData === null || networkData === void 0 ? void 0 : networkData.state) == "COMPLETED" && (IsNullOrUndefinedObj(trgNetworkResponse === null || trgNetworkResponse === void 0 ? void 0 : trgNetworkResponse.overview) || IsNullOrEmpty(trgNetworkResponse === null || trgNetworkResponse === void 0 ? void 0 : trgNetworkResponse.overview) || IsNullOrUndefinedObj(trgNetworkResponse.overview.header) || IsNullOrEmpty(trgNetworkResponse.overview.header) || IsNullOrUndefinedObj(trgNetworkResponse.overview.analysis) || IsNullOrEmpty(trgNetworkResponse.overview.analysis))) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "no-data-class vds-notification-icon"
    }, /*#__PURE__*/React__default.createElement(Notification, {
      disableAnimation: true,
      type: "info",
      title: "No Summary Records available for this MDN.",
      fullBleed: true,
      inlineTreatment: false,
      layout: "horizontal",
      hideCloseButton: true
    }));
  } else return /*#__PURE__*/React__default.createElement("div", {
    className: "loader-container"
  }, /*#__PURE__*/React__default.createElement(Loader$2, {
    fullscreen: false,
    active: true
  }));
};

var vzwMapURL = "";
var Coverage = function Coverage(props) {
  var _useProfileData = useProfileData(props),
    userProfileData = _useProfileData.data;
  var _useState = useState(""),
    setmapUrl = _useState[1];
  var _useState2 = useState({}),
    setuserProfile = _useState2[1];
  var dispatchUsageMetrics = function dispatchUsageMetrics() {
    var metrics = [{
      eventID: 'TROUBLESHOOTING',
      actionID: 'COVERAGE_LAUNCH',
      notes: 'VZMap Coverage.'
    }];
    var _ref = props || {},
      logUsageMetrics = _ref.logUsageMetrics;
    if (logUsageMetrics) {
      logUsageMetrics({
        metrics: metrics
      });
    }
  };
  useEffect(function () {
    setmapUrl(vzwMapURL);
    setuserProfile(userProfileData);
    dispatchUsageMetrics();
  }, []);
  var formatUrl = function formatUrl(url) {
    if (url) {
      return url.replace(/ /g, "%20");
    }
    return url;
  };
  var mvoConfig = sessionStorage.getItem("mvoConfig");
  var myObj = JSON.parse(mvoConfig);
  var constructVzMapsUrl = function constructVzMapsUrl() {
    vzwMapURL = myObj === null || myObj === void 0 ? void 0 : myObj.mapsUrl;
    if (vzwMapURL) {
      vzwMapURL = formatUrl(vzwMapURL);
    }
    return vzwMapURL;
  };
  var url = constructVzMapsUrl();
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("iframe", {
    title: "VZMap",
    src: url,
    width: "100%",
    height: "550px"
  }));
};

var _templateObject$1J;
var StyledTextLink$7 = styled(TextLink)(_templateObject$1J || (_templateObject$1J = _taggedTemplateLiteralLoose(["\n    \n    border-bottom:", ";\n    text-decoration:none;\n    font-weight:bold;\n    :hover{\n    color:", ";\n    border-bottom:", ";\n    text-decoration:none;\n    }\n  \n"])), function (props) {
  return props.selected ? "4px solid red" : "none";
}, function (props) {
  return props.isDark ? "#fff" : "#000";
}, function (props) {
  return props.selected ? "4px solid red" : "none";
});
var NetworkDetailsPopup = function NetworkDetailsPopup(props) {
  var _window, _window$caseDetails;
  var _ref = useDeviceData(props) || {},
    deviceResponse = _ref.data;
  var _ref2 = useProfileData(props) || {};
  var _useState = useState(1),
    selectedMenuId = _useState[0],
    setselectedMenuId = _useState[1];
  var _useState2 = useState({}),
    deviceData = _useState2[0],
    setdeviceData = _useState2[1];
  var enableNewExp = props.enableNewExp;
  var tabList = {
    1: "Network & Provisioning: Summary",
    2: "Network & Provisioning: Call records Inbound calls",
    3: "Network & Provisioning: Network Experience",
    4: "Network & Provisioning: Provision",
    5: "Network & Provisioning: Coverage"
  };
  var openProvisioningTab = useDeepLinkStore(function (state) {
    return state.openProvisioningTab;
  });
  var openCallRecordsTab = useDeepLinkStore(function (state) {
    return state.openCallRecordsTab;
  });
  useEffect(function () {
    if (openCallRecordsTab) {
      setselectedMenuId(2);
    }
  }, [openCallRecordsTab]);
  useEffect(function () {
    logSiteCatalystAndMetricsData(selectedMenuId);
    taggingForDeviceNetworkTile(tabList[selectedMenuId]);
  }, []);
  useEffect(function () {
    if (openProvisioningTab) {
      setselectedMenuId(4);
    }
  }, [openProvisioningTab]);
  useEffect(function () {
    var _deviceResponse$respo, _deviceResponse$respo2, _deviceResponse$respo3;
    setdeviceData(deviceResponse === null || deviceResponse === void 0 ? void 0 : (_deviceResponse$respo = deviceResponse.response) === null || _deviceResponse$respo === void 0 ? void 0 : (_deviceResponse$respo2 = _deviceResponse$respo.data) === null || _deviceResponse$respo2 === void 0 ? void 0 : (_deviceResponse$respo3 = _deviceResponse$respo2.body) === null || _deviceResponse$respo3 === void 0 ? void 0 : _deviceResponse$respo3.data);
  }, [deviceResponse]);
  var npProvTabs = [{
    tabId: 1,
    npInfoTabId: "npInfo_summary",
    npInfoTabName: "Summary"
  }, {
    tabId: 2,
    npInfoTabId: "npInfo_callRecords",
    npInfoTabName: "Call Records"
  }, {
    tabId: 3,
    npInfoTabId: "npInfo_netExperience",
    npInfoTabName: "Network Experience"
  }, {
    tabId: 4,
    npInfoTabId: "npInfo_provisioning",
    npInfoTabName: "Provisioning"
  }, {
    tabId: 5,
    npInfoTabId: "npInfo_coverage",
    npInfoTabName: "Coverage"
  }];
  var _props$params = props.params,
    _props$params2 = _props$params === void 0 ? {} : _props$params,
    _props$params2$mdn = _props$params2.mdn,
    mdn = _props$params2$mdn === void 0 ? '' : _props$params2$mdn;
  var selectedMTN = ((_window = window) === null || _window === void 0 ? void 0 : (_window$caseDetails = _window.caseDetails) === null || _window$caseDetails === void 0 ? void 0 : _window$caseDetails.mtn) || mdn;
  var selectedMTNData;
  if (deviceData) {
    var _deviceData$customerI, _deviceData$customerI2, _deviceData$customerI3;
    var mtns = deviceData === null || deviceData === void 0 ? void 0 : (_deviceData$customerI = deviceData.customerInsight) === null || _deviceData$customerI === void 0 ? void 0 : (_deviceData$customerI2 = _deviceData$customerI.billAccounts) === null || _deviceData$customerI2 === void 0 ? void 0 : (_deviceData$customerI3 = _deviceData$customerI2[0]) === null || _deviceData$customerI3 === void 0 ? void 0 : _deviceData$customerI3.mtns;
    selectedMTNData = mtns ? mtns.find(function (e) {
      return e.mtn === selectedMTN;
    }) : {};
  }
  var isFWADevice_ = isFWADevice(selectedMTNData);
  var menuClicked = function menuClicked(id, e) {
    e.preventDefault();
    setselectedMenuId(id);
    logSiteCatalystAndMetricsData(id);
    taggingForDeviceNetworkTile(tabList[id]);
  };
  var escFunction = function escFunction(event) {
    if (event.key === "Escape") {
      document.getElementById("acssdialog-close-icon").click();
    }
  };
  var handleUsageMetricsNoEvents = function handleUsageMetricsNoEvents(eventID, actionID, notes) {
    if (eventID === void 0) {
      eventID = '';
    }
    if (actionID === void 0) {
      actionID = '';
    }
    if (notes === void 0) {
      notes = '';
    }
    var metrics = [{
      eventID: eventID,
      actionID: actionID,
      notes: notes
    }];
    var _ref3 = props || {},
      logUsageMetrics = _ref3.logUsageMetrics;
    if (logUsageMetrics) {
      logUsageMetrics({
        metrics: metrics
      });
    }
  };
  var logSiteCatalystAndMetricsData = function logSiteCatalystAndMetricsData(id) {
    switch (id) {
      case 1:
        handleUsageMetricsNoEvents("TROUBLESHOOTING", "SUMMARY_LAUNCH", "Summary Information");
        break;
      case 2:
        handleUsageMetricsNoEvents("TROUBLESHOOTING", "CALL_RECORDS_LAUNCH", "Call Records");
        break;
      case 3:
        handleUsageMetricsNoEvents("TROUBLESHOOTING", "NETWORK_EXPERIENCE_LAUNCH", "Network Experience");
        break;
      case 4:
        handleUsageMetricsNoEvents("TROUBLESHOOTING", "PROVISIONING_LAUNCH", "Provisioning");
        break;
      case 5:
        handleUsageMetricsNoEvents("TROUBLESHOOTING", "SUMMARY_LAUNCH", "Coverage");
        break;
      default:
        handleUsageMetricsNoEvents("TROUBLESHOOTING", "SUMMARY_LAUNCH", "Summary Information");
        break;
    }
  };
  useEffect(function () {
    document.addEventListener("keydown", escFunction, false);
    var closeIcon = document.getElementById("acssdialog-close-icon");
    if (closeIcon) {
      closeIcon.focus();
    }
  }, []);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    id: "npContent",
    className: "tabContainer",
    role: "tablist",
    style: {
      width: "100%"
    }
  }, npProvTabs && npProvTabs.length > 0 && npProvTabs.map(function (tab) {
    if (isFWADevice_ && tab.tabId === 2 || isFWADevice_ && tab.tabId === 3) {
      return;
    } else {
      return /*#__PURE__*/React__default.createElement("div", {
        key: tab.tabId,
        style: {
          display: "inline-block",
          margin: "0px 0px 10px 25px"
        }
      }, /*#__PURE__*/React__default.createElement(StyledTextLink$7, {
        href: "#",
        role: "tab",
        "aria-label": tab.npInfoTabName,
        "data-track": tab.npInfoTabName,
        "aria-haspopup": "false",
        "aria-selected": "" + (selectedMenuId === tab.tabId ? "true" : "false"),
        id: tab.npInfoTabName,
        onClick: function onClick(e) {
          menuClicked(tab.tabId, e);
        },
        selected: selectedMenuId === tab.tabId,
        isDark: props.isDark
      }, tab.npInfoTabName));
    }
  }), selectedMenuId === 1 && (enableNewExp ? /*#__PURE__*/React__default.createElement(SummaryNew, _extends({}, props, {
    className: "dark-tab"
  })) : null), selectedMenuId === 2 && !isFWADevice_ && /*#__PURE__*/React__default.createElement(CallRecords, props), selectedMenuId === 3 && !isFWADevice_ && /*#__PURE__*/React__default.createElement(NetworkExperience, props), selectedMenuId === 4 && /*#__PURE__*/React__default.createElement(Provisioning, props), selectedMenuId === 5 && /*#__PURE__*/React__default.createElement(Coverage, props))));
};

var _templateObject$1K, _templateObject2$1i, _templateObject3$11, _templateObject4$Y, _templateObject5$N, _templateObject6$F, _templateObject7$y, _templateObject8$u, _templateObject9$p, _templateObject0$m, _templateObject1$m, _templateObject10$h;
var CarouselContainer = styled.div(_templateObject$1K || (_templateObject$1K = _taggedTemplateLiteralLoose(["\n    ", ";\n    border: 1px solid rgb(216, 218, 218);\n [class*=OuterTileContainer-VDS]{\n    padding:0 !important;\n    background: ", ";\n  }\n"])), function (props) {
  return props.channel === "Retail" && 'width:35vw';
}, function (props) {
  return props.isDark ? '#202229 !important' : '#ffffff';
});
var NetworkTileContainer = styled.div(_templateObject2$1i || (_templateObject2$1i = _taggedTemplateLiteralLoose(["\n    display: grid;\n    background: ", ";\n    color: ", ";\n    min-height: 300px;\n"])), function (props) {
  return props.isDark ? '#202229 !important' : '#ffffff';
}, function (props) {
  return props.isDark ? '#ffffff' : '#000000';
});
var NetworkIssuesWrapper = styled.article(_templateObject3$11 || (_templateObject3$11 = _taggedTemplateLiteralLoose(["\n    background: ", ";\n    color: ", ";\n"])), function (props) {
  return props.isDark ? '#202229' : '#ffffff';
}, function (props) {
  return props.isDark ? '#ffffff' : '#000000';
});
var IssueListWrapper = styled.div(_templateObject4$Y || (_templateObject4$Y = _taggedTemplateLiteralLoose(["\n    padding-top: 14px;\n"])));
var NoIssuesFound$1 = styled.div(_templateObject5$N || (_templateObject5$N = _taggedTemplateLiteralLoose(["\n    display:flex;\n    height:250px;\n    flex-wrap: wrap;\n    align-content:stretch;\n    align-items: center;\n"])));
var NoIssuesItems$1 = styled.div(_templateObject6$F || (_templateObject6$F = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    text-align: center;\n"])));
var TextLinkAlign = styled.div(_templateObject7$y || (_templateObject7$y = _taggedTemplateLiteralLoose(["\n    padding-bottom: 7px;\n    a { font-size: 14px; }\n    a:hover { text-decoration:unset !important; color:unset !important }\n"])));
var NetworkAndProv = styled.div(_templateObject8$u || (_templateObject8$u = _taggedTemplateLiteralLoose(["\n    background: ", ";\n    color: ", ";\n"])), function (props) {
  return props.isDark ? '#202229' : '#ffffff';
}, function (props) {
  return props.isDark ? '#ffffff' : '#000000';
});
var NetworkAndProvContainer = styled.div(_templateObject9$p || (_templateObject9$p = _taggedTemplateLiteralLoose(["\n    background: ", ";\n    color: ", ";\n"])), function (props) {
  return props.isDark ? '#202229 !important' : '#ffffff !important';
}, function (props) {
  return props.isDark ? '#ffffff !important' : '#000000 !important';
});
var NetworkAndProvLoaderWrap = styled.div(_templateObject0$m || (_templateObject0$m = _taggedTemplateLiteralLoose([" \n    display: grid;\n    background: ", ";\n    color: ", ";\n    min-height: 300px;\n\n    [class*=StyledOverlay-VDS]{\n        background: ", ";\n      }\n"])), function (props) {
  return props.isDark ? '#202229 !important' : '#ffffff !important';
}, function (props) {
  return props.isDark ? '#ffffff !important' : '#000000 !important';
}, function (props) {
  return props.isDark ? '#202229 !important' : '#ffffff !important';
});
var RefreshOverviewWrapper = styled.div(_templateObject1$m || (_templateObject1$m = _taggedTemplateLiteralLoose(["\n    display: flex;\n    font-size: 1.1rem;\n    font-weight: 500;\n    line-height: 1.5rem;\n    margin: 60px 0px 30px 0px;\n    svg {\n       margin: 10px 10px;\n    } \n"])));
var RefreshOverviewtext = styled.div(_templateObject10$h || (_templateObject10$h = _taggedTemplateLiteralLoose(["\n     line-height: 45px;\n"])));
var IssuesListComponent = function IssuesListComponent(_ref) {
  var _ref$issueList = _ref.issueList,
    issueList = _ref$issueList === void 0 ? [] : _ref$issueList,
    handleLink = _ref.handleLink,
    _ref$isDark = _ref.isDark,
    isDark = _ref$isDark === void 0 ? false : _ref$isDark;
  return /*#__PURE__*/React__default.createElement(IssueListWrapper, null, issueList.length > 0 ? issueList.map(function (issue, idx) {
    var _issue$explanation = issue.explanation,
      explanation = _issue$explanation === void 0 ? '' : _issue$explanation,
      _issue$delphiParentIn = issue.delphiParentInsight,
      delphiParentInsight = _issue$delphiParentIn === void 0 ? '' : _issue$delphiParentIn;
    return /*#__PURE__*/React__default.createElement(TextLinkAlign, null, /*#__PURE__*/React__default.createElement(TextLinkCaret, {
      key: explanation + "_" + idx,
      surface: isDark ? 'dark' : 'light',
      iconPosition: "right",
      onClick: function onClick(e) {
        return handleLink(issue);
      }
    }, delphiParentInsight ? delphiParentInsight : explanation));
  }) : /*#__PURE__*/React__default.createElement(NoIssuesFound$1, {
    isDark: isDark
  }, /*#__PURE__*/React__default.createElement(NoIssuesItems$1, {
    isDark: isDark
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    name: "error",
    size: "large",
    color: "#000000",
    surface: isDark ? 'dark' : 'light'
  }), " No Issues Found")));
};
var NetworkDetailsNew = function NetworkDetailsNew(props) {
  var _window, _window$config, _networkData$call_rec, _networkData$call_rec2, _networkData$call_rec3, _networkData$call_rec4, _networkData$call_rec5, _networkData$call_rec6, _networkData$call_rec7, _networkData$call_rec8, _networkData$call_rec9, _networkData$call_rec0, _networkData$call_rec1, _networkData$call_rec10, _networkData$call_rec11, _networkData$call_rec12, _networkData$call_rec13, _networkData$call_rec14, _networkData$call_rec15, _networkData$call_rec16, _networkData$call_rec17, _networkData$call_rec18, _networkData$call_rec19, _networkData$call_rec20, _networkData$call_rec21, _networkData$call_rec22, _networkData$call_rec23, _networkData$call_rec24, _networkData$call_rec25, _networkData$call_rec26, _networkData$call_rec27, _networkData$call_rec28, _networkData$call_rec29, _networkData$call_rec30, _networkData$call_rec31, _networkData$call_rec32, _networkData$call_rec33, _networkData$call_rec34, _networkData$call_rec35, _networkData$call_rec36, _networkData$call_rec37, _networkData$call_rec38, _networkData$call_rec39, _networkData$call_rec40, _networkData$call_rec41, _networkData$call_rec42, _networkData$call_rec43, _networkData$call_rec44, _networkData$call_rec45, _networkData$call_rec46, _networkData$scores, _networkData$scores$h, _networkData$coverage, _networkData$coverage2, _networkData$overview, _networkData$overview2, _networkData$call_rec47, _networkData$call_rec48, _window2, _window2$caseDetails, _myObj$mtns, _myObj$mtns$;
  var _useState = useState(false),
    isOpen = _useState[0],
    setisOpen = _useState[1];
  var _useState2 = useState(false),
    loading = _useState2[0],
    setloading = _useState2[1];
  var _useDeviceData = useDeviceData(props),
    deviceResponse = _useDeviceData.data;
  var _useNetworkData = useNetworkData(props),
    networkResponse = _useNetworkData.data,
    refetchNetworkResponse = _useNetworkData.refetch;
  var _useProfileData = useProfileData(props),
    userProfile = _useProfileData.data;
  var _useState3 = useState({}),
    deviceData = _useState3[0],
    setdeviceData = _useState3[1];
  var _useState4 = useState({}),
    networkData = _useState4[0],
    setNetworkData = _useState4[1];
  var _useState5 = useState(0),
    counter = _useState5[0];
  var _useState6 = useState(0),
    scoresCounter = _useState6[0],
    setScoresCounter = _useState6[1];
  var _useState7 = useState(0),
    coverageCounter = _useState7[0],
    setCoverageCounter = _useState7[1];
  var _useState8 = useState(0),
    overviewCounter = _useState8[0],
    setOverviewCounter = _useState8[1];
  var _useState9 = useState(0),
    callCounter = _useState9[0],
    setCallCounter = _useState9[1];
  var _useState0 = useState(null),
    selectedIssue = _useState0[0],
    setSelectedIssue = _useState0[1];
  var enableNewExp = props.enableNewExp;
  var _useFeatureFlag = useFeatureFlag(),
    _useFeatureFlag$data = _useFeatureFlag.data,
    _useFeatureFlag$data2 = _useFeatureFlag$data === void 0 ? {} : _useFeatureFlag$data,
    _useFeatureFlag$data3 = _useFeatureFlag$data2.networkTileRefreshExpFFlag,
    networkTileRefreshExpFFlag = _useFeatureFlag$data3 === void 0 ? false : _useFeatureFlag$data3,
    _useFeatureFlag$data4 = _useFeatureFlag$data2.parentChildInsightMappingFFlag,
    parentChildInsightMappingFFlag = _useFeatureFlag$data4 === void 0 ? false : _useFeatureFlag$data4,
    _useFeatureFlag$data5 = _useFeatureFlag$data2.badInsightsFFlag,
    badInsightsFFlag = _useFeatureFlag$data5 === void 0 ? false : _useFeatureFlag$data5;
  var openProvisioningTab = useDeepLinkStore(function (state) {
    return state.openProvisioningTab;
  });
  var updateOpenProvisioningTab = useDeepLinkStore(function (state) {
    return state.updateOpenProvisioningTab;
  });
  var openCallRecordsTab = useDeepLinkStore(function (state) {
    return state.openCallRecordsTab;
  });
  var updateOpenCallRecordsTab = useDeepLinkStore(function (state) {
    return state.updateOpenCallRecordsTab;
  });
  var _useTroubleShootInten = useTroubleShootIntentStore(),
    items = _useTroubleShootInten.items;
  useEffect(function () {
    closeNetworkPopup();
  }, [items]);
  useEffect(function () {
    if (openCallRecordsTab) {
      handleMoreDetails();
    }
  }, [openCallRecordsTab]);
  useEffect(function () {
    if (openProvisioningTab) {
      setisOpen(true);
    }
  }, [openProvisioningTab]);
  useEffect(function () {
    var _deviceResponse$respo, _deviceResponse$respo2, _deviceResponse$respo3, _networkResponse$resp, _networkResponse$resp2, _networkResponse$resp3;
    setdeviceData(_extends({}, deviceResponse === null || deviceResponse === void 0 ? void 0 : (_deviceResponse$respo = deviceResponse.response) === null || _deviceResponse$respo === void 0 ? void 0 : (_deviceResponse$respo2 = _deviceResponse$respo.data) === null || _deviceResponse$respo2 === void 0 ? void 0 : (_deviceResponse$respo3 = _deviceResponse$respo2.body) === null || _deviceResponse$respo3 === void 0 ? void 0 : _deviceResponse$respo3.data));
    setNetworkData(_extends({}, networkResponse === null || networkResponse === void 0 ? void 0 : (_networkResponse$resp = networkResponse.response) === null || _networkResponse$resp === void 0 ? void 0 : (_networkResponse$resp2 = _networkResponse$resp.data) === null || _networkResponse$resp2 === void 0 ? void 0 : (_networkResponse$resp3 = _networkResponse$resp2.body) === null || _networkResponse$resp3 === void 0 ? void 0 : _networkResponse$resp3.data));
    console.log("latest");
  }, [deviceResponse, networkResponse]);
  var windowRetailIframe = (_window = window) === null || _window === void 0 ? void 0 : (_window$config = _window.config) === null || _window$config === void 0 ? void 0 : _window$config.retailIframe;
  var outboundCallSize = (_networkData$call_rec = networkData === null || networkData === void 0 ? void 0 : (_networkData$call_rec2 = networkData.call_records) === null || _networkData$call_rec2 === void 0 ? void 0 : (_networkData$call_rec3 = _networkData$call_rec2.analysis) === null || _networkData$call_rec3 === void 0 ? void 0 : (_networkData$call_rec4 = _networkData$call_rec3[0]) === null || _networkData$call_rec4 === void 0 ? void 0 : (_networkData$call_rec5 = _networkData$call_rec4.tables) === null || _networkData$call_rec5 === void 0 ? void 0 : (_networkData$call_rec6 = _networkData$call_rec5.filter(function (obj) {
    return obj.title === "Outbound Calls";
  })) === null || _networkData$call_rec6 === void 0 ? void 0 : (_networkData$call_rec7 = _networkData$call_rec6[0]) === null || _networkData$call_rec7 === void 0 ? void 0 : (_networkData$call_rec8 = _networkData$call_rec7.rows) === null || _networkData$call_rec8 === void 0 ? void 0 : _networkData$call_rec8.length) != null ? _networkData$call_rec : "";
  var inboundCallSize = (_networkData$call_rec9 = networkData === null || networkData === void 0 ? void 0 : (_networkData$call_rec0 = networkData.call_records) === null || _networkData$call_rec0 === void 0 ? void 0 : (_networkData$call_rec1 = _networkData$call_rec0.analysis) === null || _networkData$call_rec1 === void 0 ? void 0 : (_networkData$call_rec10 = _networkData$call_rec1[0]) === null || _networkData$call_rec10 === void 0 ? void 0 : (_networkData$call_rec11 = _networkData$call_rec10.tables) === null || _networkData$call_rec11 === void 0 ? void 0 : (_networkData$call_rec12 = _networkData$call_rec11.filter(function (obj) {
    return obj.title === "Inbound Calls";
  })) === null || _networkData$call_rec12 === void 0 ? void 0 : (_networkData$call_rec13 = _networkData$call_rec12[0]) === null || _networkData$call_rec13 === void 0 ? void 0 : (_networkData$call_rec14 = _networkData$call_rec13.rows) === null || _networkData$call_rec14 === void 0 ? void 0 : _networkData$call_rec14.length) != null ? _networkData$call_rec9 : "";
  var poorOutboundCallSize = (_networkData$call_rec15 = networkData === null || networkData === void 0 ? void 0 : (_networkData$call_rec16 = networkData.call_records) === null || _networkData$call_rec16 === void 0 ? void 0 : (_networkData$call_rec17 = _networkData$call_rec16.analysis) === null || _networkData$call_rec17 === void 0 ? void 0 : (_networkData$call_rec18 = _networkData$call_rec17[0]) === null || _networkData$call_rec18 === void 0 ? void 0 : (_networkData$call_rec19 = _networkData$call_rec18.tables) === null || _networkData$call_rec19 === void 0 ? void 0 : (_networkData$call_rec20 = _networkData$call_rec19.filter(function (obj) {
    return obj.title === "Poor call quality outbound calls identified";
  })) === null || _networkData$call_rec20 === void 0 ? void 0 : (_networkData$call_rec21 = _networkData$call_rec20[0]) === null || _networkData$call_rec21 === void 0 ? void 0 : (_networkData$call_rec22 = _networkData$call_rec21.rows) === null || _networkData$call_rec22 === void 0 ? void 0 : _networkData$call_rec22.length) != null ? _networkData$call_rec15 : "";
  var poorInboundCallSize = (_networkData$call_rec23 = networkData === null || networkData === void 0 ? void 0 : (_networkData$call_rec24 = networkData.call_records) === null || _networkData$call_rec24 === void 0 ? void 0 : (_networkData$call_rec25 = _networkData$call_rec24.analysis) === null || _networkData$call_rec25 === void 0 ? void 0 : (_networkData$call_rec26 = _networkData$call_rec25[0]) === null || _networkData$call_rec26 === void 0 ? void 0 : (_networkData$call_rec27 = _networkData$call_rec26.tables) === null || _networkData$call_rec27 === void 0 ? void 0 : (_networkData$call_rec28 = _networkData$call_rec27.filter(function (obj) {
    return obj.title === "Poor call quality inbound calls identified";
  })) === null || _networkData$call_rec28 === void 0 ? void 0 : (_networkData$call_rec29 = _networkData$call_rec28[0]) === null || _networkData$call_rec29 === void 0 ? void 0 : (_networkData$call_rec30 = _networkData$call_rec29.rows) === null || _networkData$call_rec30 === void 0 ? void 0 : _networkData$call_rec30.length) != null ? _networkData$call_rec23 : "";
  var droppedOutboundCallSize = (_networkData$call_rec31 = networkData === null || networkData === void 0 ? void 0 : (_networkData$call_rec32 = networkData.call_records) === null || _networkData$call_rec32 === void 0 ? void 0 : (_networkData$call_rec33 = _networkData$call_rec32.analysis) === null || _networkData$call_rec33 === void 0 ? void 0 : (_networkData$call_rec34 = _networkData$call_rec33[0]) === null || _networkData$call_rec34 === void 0 ? void 0 : (_networkData$call_rec35 = _networkData$call_rec34.tables) === null || _networkData$call_rec35 === void 0 ? void 0 : (_networkData$call_rec36 = _networkData$call_rec35.filter(function (obj) {
    return obj.title === "Outbound dropped calls identified";
  })) === null || _networkData$call_rec36 === void 0 ? void 0 : (_networkData$call_rec37 = _networkData$call_rec36[0]) === null || _networkData$call_rec37 === void 0 ? void 0 : (_networkData$call_rec38 = _networkData$call_rec37.rows) === null || _networkData$call_rec38 === void 0 ? void 0 : _networkData$call_rec38.length) != null ? _networkData$call_rec31 : "";
  var droppedInboundCallSize = (_networkData$call_rec39 = networkData === null || networkData === void 0 ? void 0 : (_networkData$call_rec40 = networkData.call_records) === null || _networkData$call_rec40 === void 0 ? void 0 : (_networkData$call_rec41 = _networkData$call_rec40.analysis) === null || _networkData$call_rec41 === void 0 ? void 0 : (_networkData$call_rec42 = _networkData$call_rec41[0]) === null || _networkData$call_rec42 === void 0 ? void 0 : (_networkData$call_rec43 = _networkData$call_rec42.tables) === null || _networkData$call_rec43 === void 0 ? void 0 : (_networkData$call_rec44 = _networkData$call_rec43.filter(function (obj) {
    return obj.title === "Inbound dropped calls identified";
  })) === null || _networkData$call_rec44 === void 0 ? void 0 : (_networkData$call_rec45 = _networkData$call_rec44[0]) === null || _networkData$call_rec45 === void 0 ? void 0 : (_networkData$call_rec46 = _networkData$call_rec45.rows) === null || _networkData$call_rec46 === void 0 ? void 0 : _networkData$call_rec46.length) != null ? _networkData$call_rec39 : "";
  var globalState = (networkData === null || networkData === void 0 ? void 0 : networkData.state) || "FAILED";
  var scoresState = (networkData === null || networkData === void 0 ? void 0 : (_networkData$scores = networkData.scores) === null || _networkData$scores === void 0 ? void 0 : (_networkData$scores$h = _networkData$scores.header) === null || _networkData$scores$h === void 0 ? void 0 : _networkData$scores$h.state) || globalState;
  var coverageState = (networkData === null || networkData === void 0 ? void 0 : (_networkData$coverage = networkData.coverage) === null || _networkData$coverage === void 0 ? void 0 : (_networkData$coverage2 = _networkData$coverage.header) === null || _networkData$coverage2 === void 0 ? void 0 : _networkData$coverage2.state) || globalState;
  var overviewState = (networkData === null || networkData === void 0 ? void 0 : (_networkData$overview = networkData.overview) === null || _networkData$overview === void 0 ? void 0 : (_networkData$overview2 = _networkData$overview.header) === null || _networkData$overview2 === void 0 ? void 0 : _networkData$overview2.state) || globalState;
  var callRecordsState = (networkData === null || networkData === void 0 ? void 0 : (_networkData$call_rec47 = networkData.call_records) === null || _networkData$call_rec47 === void 0 ? void 0 : (_networkData$call_rec48 = _networkData$call_rec47.header) === null || _networkData$call_rec48 === void 0 ? void 0 : _networkData$call_rec48.state) || globalState;
  var pollfromSession = sessionStorage.getItem('pollCount');
  var networkResponseStatus = networkResponse === null || networkResponse === void 0 ? void 0 : networkResponse.success;
  var dispatchUsageMetrics = function dispatchUsageMetrics(metrics) {
    var _ref2 = props || {},
      logUsageMetrics = _ref2.logUsageMetrics;
    if (logUsageMetrics) {
      logUsageMetrics({
        metrics: metrics
      });
    }
  };
  var onRetryClick = function onRetryClick(name, count) {
    setloading(true);
    var metrics = [{
      eventID: 'TROUBLESHOOTING',
      actionID: 'NET_AND_PROV_API',
      notes: 'Network and Prov API invoked for ' + name + " with retry of " + count
    }];
    dispatchUsageMetrics(metrics);
    refetchNetworkResponse().then(function (data) {
      if (data) {
        setloading(false);
      }
    });
  };
  var closeNetworkPopup = function closeNetworkPopup() {
    if (openCallRecordsTab) {
      updateOpenCallRecordsTab();
    }
    if (openProvisioningTab) {
      updateOpenProvisioningTab();
    }
    setisOpen(false);
  };
  var handleMoreDetails = function handleMoreDetails() {
    setisOpen(true);
    setSelectedIssue({});
  };
  var handleRerefesh = function handleRerefesh() {
    try {
      sessionStorage.setItem("pollCount", '');
      setloading(true);
      refetchNetworkResponse().then(function (data) {
        if (data) {
          setloading(false);
        }
      });
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var _ref3 = props || {},
    _ref3$params = _ref3.params,
    _ref3$params2 = _ref3$params === void 0 ? {} : _ref3$params,
    _ref3$params2$mdn = _ref3$params2.mdn,
    mdn = _ref3$params2$mdn === void 0 ? '' : _ref3$params2$mdn;
  var selectedMTN = ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$caseDetails = _window2.caseDetails) === null || _window2$caseDetails === void 0 ? void 0 : _window2$caseDetails.mtn) || mdn;
  var selectedMTNData;
  if (deviceData) {
    var _deviceData$customerI, _deviceData$customerI2, _deviceData$customerI3;
    var mtns = deviceData === null || deviceData === void 0 ? void 0 : (_deviceData$customerI = deviceData.customerInsight) === null || _deviceData$customerI === void 0 ? void 0 : (_deviceData$customerI2 = _deviceData$customerI.billAccounts) === null || _deviceData$customerI2 === void 0 ? void 0 : (_deviceData$customerI3 = _deviceData$customerI2[0]) === null || _deviceData$customerI3 === void 0 ? void 0 : _deviceData$customerI3.mtns;
    selectedMTNData = mtns ? mtns.find(function (e) {
      return e.mtn === selectedMTN;
    }) : {};
  }
  var isFWADevice_ = isFWADevice(selectedMTNData);
  console.log(mdn, isFWADevice_, "isFWADevice_");
  var isMdnStatusEligbleForDelphi = isMdnStatusInEligbleForDelphi(selectedMTNData);
  var mvoConfig = sessionStorage.getItem("mvoConfig");
  var myObj = JSON.parse(mvoConfig);
  var address = (myObj === null || myObj === void 0 ? void 0 : (_myObj$mtns = myObj.mtns) === null || _myObj$mtns === void 0 ? void 0 : (_myObj$mtns$ = _myObj$mtns[0]) === null || _myObj$mtns$ === void 0 ? void 0 : _myObj$mtns$.address) || "";
  var handleShortCutLink = function handleShortCutLink(issue) {
    setSelectedIssue(issue);
    setisOpen(true);
  };
  var renderOverview = function renderOverview() {
    var issuesList;
    if (!badInsightsFFlag) {
      var _networkData$overview3, _networkData$overview4;
      issuesList = networkData === null || networkData === void 0 ? void 0 : (_networkData$overview3 = networkData.overview) === null || _networkData$overview3 === void 0 ? void 0 : (_networkData$overview4 = _networkData$overview3.analysis) === null || _networkData$overview4 === void 0 ? void 0 : _networkData$overview4.filter(function (issue) {
        return (issue === null || issue === void 0 ? void 0 : issue.status) === "fault" && !(issue !== null && issue !== void 0 && issue.delphiParentInsight);
      });
    } else {
      var _networkData$overview5, _networkData$overview6;
      issuesList = networkData === null || networkData === void 0 ? void 0 : (_networkData$overview5 = networkData.overview) === null || _networkData$overview5 === void 0 ? void 0 : (_networkData$overview6 = _networkData$overview5.analysis) === null || _networkData$overview6 === void 0 ? void 0 : _networkData$overview6.filter(function (issue) {
        return ((issue === null || issue === void 0 ? void 0 : issue.status) === "fault" || issue.status === "bad") && !(issue !== null && issue !== void 0 && issue.delphiParentInsight);
      });
    }
    if (parentChildInsightMappingFFlag) {
      var _networkData$overview7, _networkData$overview8, _issuesList, _issuesList$push;
      var newIssueList = networkData === null || networkData === void 0 ? void 0 : (_networkData$overview7 = networkData.overview) === null || _networkData$overview7 === void 0 ? void 0 : (_networkData$overview8 = _networkData$overview7.analysis) === null || _networkData$overview8 === void 0 ? void 0 : _networkData$overview8.filter(function (issue) {
        return (issue === null || issue === void 0 ? void 0 : issue.delphiParentInsight) != undefined;
      });
      var uniqueList = newIssueList === null || newIssueList === void 0 ? void 0 : newIssueList.filter(function (item, index, self) {
        return index === (self === null || self === void 0 ? void 0 : self.findIndex(function (t) {
          return (t === null || t === void 0 ? void 0 : t.delphiParentInsight) === (item === null || item === void 0 ? void 0 : item.delphiParentInsight);
        }));
      });
      (_issuesList = issuesList) === null || _issuesList === void 0 ? void 0 : (_issuesList$push = _issuesList.push) === null || _issuesList$push === void 0 ? void 0 : _issuesList$push.apply(issuesList, uniqueList);
    }
    console.log("newIssueList", issuesList);
    return /*#__PURE__*/React__default.createElement(NetworkIssuesWrapper, {
      isDark: props.isDark
    }, /*#__PURE__*/React__default.createElement(Title, {
      size: "small",
      bold: true,
      color: props.isDark ? '#FFFFFF' : '#000000'
    }, "Network Issues Found"), overviewState === "FAILED" && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("label", {
      className: "scoredata_failed_label"
    }, "Scores data failed to load ", /*#__PURE__*/React__default.createElement("br", null), overviewCounter === 3 ? /*#__PURE__*/React__default.createElement("span", null) : /*#__PURE__*/React__default.createElement("a", {
      href: "#",
      className: "retry_label_color",
      onClick: function onClick(e) {
        e.preventDefault();
        setOverviewCounter(function (count) {
          return count + 1;
        });
        onRetryClick('overview', overviewCounter + 1);
      }
    }, "Retry"))), overviewState === "INPROGRESS" && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("label", {
      className: "scoredata_failed_label"
    }, " Loading network issues... ")), overviewState === "COMPLETED" && /*#__PURE__*/React__default.createElement(IssuesListComponent, {
      isDark: props.isDark,
      issueList: issuesList,
      handleLink: handleShortCutLink
    }));
  };
  var reTryrenderOverview = function reTryrenderOverview() {
    return /*#__PURE__*/React__default.createElement(NetworkIssuesWrapper, {
      isDark: props.isDark
    }, /*#__PURE__*/React__default.createElement(Title, {
      size: "small",
      bold: true,
      color: props.isDark ? '#FFFFFF' : '#000000'
    }, "Network Issues Found"), /*#__PURE__*/React__default.createElement(RefreshOverviewWrapper, null, /*#__PURE__*/React__default.createElement(Icon$1, {
      name: "error",
      size: "large",
      color: "#000000",
      surface: props.isDark ? 'dark' : 'light'
    }), /*#__PURE__*/React__default.createElement(RefreshOverviewtext, null, "Unable to load request data ", /*#__PURE__*/React__default.createElement("br", null), "Please try again after troubleshooting")), /*#__PURE__*/React__default.createElement(StyledButton$4, {
      "data-track": "L1|P2|Delhpi|||||Network & Provisioning|More Details",
      "data-testid": "button",
      surface: props.isDark ? 'dark' : 'light',
      className: "trg_network_custom_btn",
      onClick: function onClick() {
        return handleRerefesh();
      },
      size: "small"
    }, "Refresh"));
  };
  var renderScrores = function renderScrores() {
    var _networkData$scores2, _networkData$coverage3;
    var fwaAttributes = (networkData === null || networkData === void 0 ? void 0 : networkData.fwaAttributes) || {};
    var scoresData = (networkData === null || networkData === void 0 ? void 0 : (_networkData$scores2 = networkData.scores) === null || _networkData$scores2 === void 0 ? void 0 : _networkData$scores2.data) || {};
    var coverageData = (networkData === null || networkData === void 0 ? void 0 : (_networkData$coverage3 = networkData.coverage) === null || _networkData$coverage3 === void 0 ? void 0 : _networkData$coverage3.data) || {};
    var totalPoorCalls;
    if (poorOutboundCallSize && poorInboundCallSize) {
      totalPoorCalls = poorOutboundCallSize + poorInboundCallSize;
    } else if (poorOutboundCallSize) {
      totalPoorCalls = poorOutboundCallSize;
    } else if (poorInboundCallSize) {
      totalPoorCalls = poorInboundCallSize;
    }
    var totalCalls;
    if (outboundCallSize && inboundCallSize) {
      totalCalls = outboundCallSize + inboundCallSize;
    } else if (outboundCallSize) {
      totalCalls = outboundCallSize;
    } else if (inboundCallSize) {
      totalCalls = inboundCallSize;
    }
    var totalDroppedCalls;
    if (droppedOutboundCallSize && droppedInboundCallSize) {
      totalDroppedCalls = droppedOutboundCallSize + droppedInboundCallSize;
    } else if (droppedOutboundCallSize) {
      totalDroppedCalls = droppedOutboundCallSize;
    } else if (droppedInboundCallSize) {
      totalDroppedCalls = droppedInboundCallSize;
    }
    var isScores_Enable = true;
    if (isFWADevice_) {
      var _userProfile$permissi, _userProfile$permissi2;
      if (IsNullOrUndefinedObj(scoresData) || Object.keys(scoresData).length === 0 || userProfile && (userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$permissi = userProfile.permission) === null || _userProfile$permissi === void 0 ? void 0 : (_userProfile$permissi2 = _userProfile$permissi.sessionPermission) === null || _userProfile$permissi2 === void 0 ? void 0 : _userProfile$permissi2.ACSS_ENABLE_5GF_SCORES) === "N") {
        isScores_Enable = false;
      }
    }
    var _CURRENT_NETWORK = "-";
    if (fwaAttributes && fwaAttributes.currentNetwork) {
      _CURRENT_NETWORK = fwaAttributes.currentNetwork;
    }
    var _PRICE_PLAN_DESC = "-";
    if (fwaAttributes && fwaAttributes.pricePlanDesc) {
      _PRICE_PLAN_DESC = fwaAttributes.pricePlanDesc;
    }
    return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(NetworkTileContainer, {
      isDark: props.isDark
    }, /*#__PURE__*/React__default.createElement(Title, {
      size: "small",
      bold: true,
      color: props.isDark ? '#FFFFFF' : '#000000'
    }, "Network & Provisioning"), scoresState === "FAILED" && isScores_Enable && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("label", {
      className: "scoredata_failed_label"
    }, "Scores data failed to load ", /*#__PURE__*/React__default.createElement("br", null), scoresCounter === 3 ? /*#__PURE__*/React__default.createElement("span", null) : /*#__PURE__*/React__default.createElement("a", {
      href: "#",
      className: "retry_label_color",
      "data-testid": "retry_label",
      onClick: function onClick(e) {
        e.preventDefault();
        setScoresCounter(scoresCounter + 1);
        onRetryClick("score", scoresCounter + 1);
      }
    }, "Retry"))), scoresState === "INPROGRESS" && isScores_Enable && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("label", {
      className: "scoredata_failed_label"
    }, " Loading scores data... ")), scoresState === "COMPLETED" && isScores_Enable && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("table", {
      className: "scoreTable_customStyle"
    }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header"
    }), /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header"
    }, "Data"), /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header"
    }, "Voice"), /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header"
    }, "Experience")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell bold"
    }, "Last 7 days"), /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell"
    }, scoresData && scoresData.data_score_current || "-"), /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell"
    }, scoresData && scoresData.voice_score_current || "-"), /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell"
    }, scoresData && scoresData.overall_score_current || "-")), /*#__PURE__*/React__default.createElement("tr", {
      className: "scoreTable_row_customStyle"
    }, /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell bold"
    }, "Last 30 days"), /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell"
    }, scoresData && scoresData.data_score_baseline || "-"), /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell"
    }, scoresData && scoresData.voice_score_baseline || "-"), /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell"
    }, scoresData && scoresData.overall_score_baseline || "-"))))), coverageState === "FAILED" && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("label", {
      className: "scoredata_failed_label"
    }, "Coverage data failed to load ", /*#__PURE__*/React__default.createElement("br", null), coverageCounter === 3 ? /*#__PURE__*/React__default.createElement("span", null) : /*#__PURE__*/React__default.createElement("a", {
      href: "#",
      className: "retry_label_color",
      "data-testid": "coverage-retry",
      onClick: function onClick(e) {
        e.preventDefault();
        setCoverageCounter(coverageCounter + 1);
        onRetryClick("coverage", coverageCounter + 1);
      }
    }, "Retry"))), coverageState === "INPROGRESS" && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("label", {
      className: "scoredata_failed_label"
    }, " Loading coverage data... ")), coverageState === "COMPLETED" && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("table", {
      className: "scoreTable_customStyle"
    }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header network_table_header_center"
    }, /*#__PURE__*/React__default.createElement("span", {
      title: address,
      "aria-label": "Coverage icon"
    }, /*#__PURE__*/React__default.createElement(Location, {
      surface: props.isDark ? 'dark' : 'light',
      size: "large",
      name: "location"
    }))), /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header"
    }, "Overall"), /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header"
    }, "Indoor"), /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header"
    }, "Outdoor")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell  bold"
    }, "LTE Coverage"), /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell"
    }, coverageData && coverageData.lte_overall || "-"), /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell"
    }, coverageData && coverageData.lte_indoor || "-"), /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell"
    }, coverageData && coverageData.lte_outdoor || "-")), coverageData["5g_available"] === true && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell  bold"
    }, "5G Coverage"), /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell"
    }, coverageData["5g_overall"] || "-"), /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell"
    }, coverageData["5g_indoor"] || "-"), /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell"
    }, coverageData["5g_outdoor"] || "-"))))), callRecordsState === "FAILED" && !isFWADevice_ && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("label", {
      className: "scoredata_failed_label"
    }, "Call records data failed to load ", /*#__PURE__*/React__default.createElement("br", null), callCounter === 3 ? /*#__PURE__*/React__default.createElement("span", null) : /*#__PURE__*/React__default.createElement("a", {
      href: "#",
      className: "retry_label_color",
      "data-testid": "retry_label1",
      onClick: function onClick(e) {
        e.preventDefault();
        setCallCounter(callCounter + 1);
        onRetryClick("call records", callCounter + 1);
      }
    }, "Retry"))), callRecordsState === "INPROGRESS" && !isFWADevice_ && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("label", {
      className: "scoredata_failed_label"
    }, " Loading call records data... ")), callRecordsState === "COMPLETED" && !isFWADevice_ && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("table", {
      className: "network_table"
    }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header"
    }), /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header"
    }, "Total Calls"), /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header"
    }, "Dropped"), /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header"
    }, "Poor Performing")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell  bold callSummary"
    }, "Voice Call Summary"), /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell"
    }, totalCalls || "-"), /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell"
    }, totalDroppedCalls || "-"), /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell"
    }, totalPoorCalls || "-"))))), isFWADevice_ && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("table", {
      className: "network_table"
    }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header bold"
    }, "Current"), /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header"
    }, "5G"), /*#__PURE__*/React__default.createElement("th", {
      className: "network_table_header"
    }, "Plan")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell bold"
    }, "Network"), /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell"
    }, _CURRENT_NETWORK), /*#__PURE__*/React__default.createElement("td", {
      className: "network_table_cell"
    }, _PRICE_PLAN_DESC))))), /*#__PURE__*/React__default.createElement("div", {
      className: "network_buttonCss"
    }, /*#__PURE__*/React__default.createElement(StyledButton$4, {
      "data-track": "L1|P2|Delhpi|||||Network & Provisioning|More Details",
      surface: props.isDark ? 'dark' : 'light',
      className: "trg_network_custom_btn",
      onClick: handleMoreDetails,
      size: "small"
    }, "More Details"))));
  };
  var renderContent = function renderContent(pageNo) {
    var _networkResponse$resp4, _networkResponse$resp5, _responseValue$data, _responseValue$data2;
    if (pageNo === void 0) {
      pageNo = 2;
    }
    var responseValue = networkResponse === null || networkResponse === void 0 ? void 0 : (_networkResponse$resp4 = networkResponse.response) === null || _networkResponse$resp4 === void 0 ? void 0 : (_networkResponse$resp5 = _networkResponse$resp4.data) === null || _networkResponse$resp5 === void 0 ? void 0 : _networkResponse$resp5.body;
    if (!loading && (globalState === "COMPLETED" || globalState === "INPROGRESS" && parseInt(pollfromSession) < 10)) {
      if (pageNo === 1) {
        return renderOverview();
      }
      return renderScrores();
    } else if (!loading && networkTileRefreshExpFFlag && (globalState === "INPROGRESS" && parseInt(pollfromSession) >= 10 || networkResponseStatus === false || (networkData === null || networkData === void 0 ? void 0 : networkData.state) === "FAILED")) {
      if (pageNo === 1) {
        return reTryrenderOverview();
      }
      return renderScrores();
    } else if (counter === 3 && !loading) {
      return /*#__PURE__*/React__default.createElement(NetworkAndProvContainer, {
        className: "loading-tile network-container"
      }, /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        style: {
          position: "relative"
        }
      }, "Data Failed to Load")));
    } else if (!loading && networkTileRefreshExpFFlag && (responseValue && Object.keys(responseValue).length === 0 || responseValue !== null && responseValue !== void 0 && (_responseValue$data = responseValue.data) !== null && _responseValue$data !== void 0 && _responseValue$data.network && Object.keys(responseValue === null || responseValue === void 0 ? void 0 : (_responseValue$data2 = responseValue.data) === null || _responseValue$data2 === void 0 ? void 0 : _responseValue$data2.network).length === 0)) {
      return /*#__PURE__*/React__default.createElement(Fragment, null, reTryrenderOverview());
    } else return /*#__PURE__*/React__default.createElement(NetworkAndProvLoaderWrap, {
      isDark: props.isDark,
      style: {
        position: "relative",
        border: "none"
      }
    }, /*#__PURE__*/React__default.createElement(Loader$2, {
      fullscreen: false,
      surface: props.isDark ? 'dark' : 'light',
      active: true
    }));
  };
  var getBgColor = props.isDark ? '#202229' : '#FFFFFF';
  return /*#__PURE__*/React__default.createElement("div", null, isOpen && /*#__PURE__*/React__default.createElement(Launchout, {
    handleClose: function handleClose() {
      return closeNetworkPopup();
    },
    isOpen: isOpen,
    modalTitle: "Network & Provisioning",
    height: windowRetailIframe ? "100vh" : "600px",
    width: windowRetailIframe ? "100vw" : "1200px",
    isDark: props.isDark
  }, /*#__PURE__*/React__default.createElement(NetworkDetailsPopup, _extends({
    enableNewExp: enableNewExp,
    selectedIssue: selectedIssue
  }, props))), isMdnStatusEligbleForDelphi && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(NetworkAndProv, {
    surface: props.isDark
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "network_provisioning_header"
  }, "Network & Provisioning")), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Notification, {
    hideCloseButton: true,
    type: "warning",
    title: "MDN is not Active, network data is not available.",
    surface: props.isDark ? 'dark' : 'light'
  })), (networkData === null || networkData === void 0 ? void 0 : networkData.length) === 0 ? /*#__PURE__*/React__default.createElement(CarouselContainer, {
    isDark: props.isDark,
    channel: props.params.channel
  }, networkTileRefreshExpFFlag && networkResponseStatus === false ? reTryrenderOverview() : /*#__PURE__*/React__default.createElement(NetworkAndProvLoaderWrap, {
    isDark: props.isDark,
    style: {
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement(Loader$2, {
    fullscreen: false,
    surface: props.isDark ? 'dark' : 'light',
    active: true
  }))) : /*#__PURE__*/React__default.createElement(CarouselContainer, {
    isDark: props.isDark,
    channel: props.params.channel
  }, /*#__PURE__*/React__default.createElement(Carousel, {
    viewport: "desktop",
    peek: "none",
    layout: "1UP",
    gutter: "24px",
    surface: props.isDark ? 'dark' : 'light',
    paginationFill: "light",
    paginationInset: "0px",
    paginationDisplay: "onHover",
    renderItem: function renderItem(tileProps) {
      return /*#__PURE__*/React__default.createElement(Tilelet, _extends({
        surface: props.isDark ? 'dark' : 'light'
      }, tileProps, {
        width: "100%",
        height: "300px"
      }));
    },
    data: [{
      subtitle: {
        size: 'bodyLarge',
        primitive: 'div',
        children: renderContent(1)
      },
      background: {
        getBgColor: getBgColor
      },
      backgroundColor: {
        getBgColor: getBgColor
      },
      onClick: function onClick() {},
      showBorder: false
    }, {
      subtitle: {
        size: 'bodyLarge',
        primitive: 'div',
        children: renderContent()
      },
      background: {
        getBgColor: getBgColor
      },
      backgroundColor: {
        getBgColor: getBgColor
      },
      onClick: function onClick() {},
      showBorder: false
    }]
  })));
};

var _templateObject$1L, _templateObject2$1j;
var DeviceInfoMain = styled.div(_templateObject$1L || (_templateObject$1L = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    p{\n        margin-bottom:0 !important\n    }\n"])));
var InfoGroup = styled.div(_templateObject2$1j || (_templateObject2$1j = _taggedTemplateLiteralLoose(["\n    padding-top: 10px;\n"])));
var DeviceInfoPrimary = function DeviceInfoPrimary(props) {
  var deviceName = props.deviceName,
    isLoading = props.isLoading,
    deviceUpTime = props.deviceUpTime,
    planType = props.planType,
    connectedDevices = props.connectedDevices,
    isFetching = props.isFetching,
    isDark = props.isDark;
  return /*#__PURE__*/React__default.createElement(DeviceInfoMain, {
    id: "primary-tile"
  }, /*#__PURE__*/React__default.createElement(InfoGroup, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "large",
    color: isDark ? "#ffffff" : "#000000",
    bold: false
  }, isLoading && !deviceName ? 'Loading...' : deviceName || "Not Available")), /*#__PURE__*/React__default.createElement(InfoGroup, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: isDark ? "#ffffff" : "#000000",
    bold: true
  }, "Device Uptime"), /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: isDark ? "#ffffff" : "#000000",
    bold: false
  }, isFetching && !deviceUpTime ? 'Loading...' : deviceUpTime || "Not Available")), /*#__PURE__*/React__default.createElement(InfoGroup, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: isDark ? "#ffffff" : "#000000",
    bold: true
  }, "Plan"), /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: isDark ? "#ffffff" : "#000000",
    bold: false
  }, isFetching && !planType ? 'Loading...' : planType || "Not Available")), /*#__PURE__*/React__default.createElement(InfoGroup, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: isDark ? "#ffffff" : "#000000",
    bold: true
  }, "Connected Devices"), /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: isDark ? "#ffffff" : "#000000",
    bold: false
  }, isFetching && !connectedDevices ? 'Loading...' : connectedDevices || "Not Available")));
};

var _templateObject$1M, _templateObject2$1k, _templateObject3$12, _templateObject4$Z;
var DeviceInfoMain$1 = styled.div(_templateObject$1M || (_templateObject$1M = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    p{\n        margin-bottom:0 !important\n    }\n"])));
var InfoGroup$1 = styled.div(_templateObject2$1k || (_templateObject2$1k = _taggedTemplateLiteralLoose(["\n    padding-top: 6px;\n"])));
var SIMContainer = styled.div(_templateObject3$12 || (_templateObject3$12 = _taggedTemplateLiteralLoose(["\n    a,a:hover{\n    text-decoration: none;\n    font-size: 12px;\n    font-weight: 700;\n    color: #116fbf;\n    border: none;\n}\n    a:focus{\n    text-decoration:none !important\n    }\n"])));
var SimContainerRetail = styled(SIMContainer)(_templateObject4$Z || (_templateObject4$Z = _taggedTemplateLiteralLoose(["\n    color: #000000;\n"])));
var DeviceInfoSecondary = function DeviceInfoSecondary(props) {
  var _window, _window$config;
  var deviceName = props.deviceName,
    isLoading = props.isLoading,
    deviceUpTime = props.deviceUpTime,
    isFetching = props.isFetching,
    isFwaDevice = props.isFwaDevice,
    osLaunchDate = props.osLaunchDate,
    activationDate = props.activationDate,
    deviceOSString = props.deviceOSString,
    imeiNumber = props.imeiNumber,
    simPrefix = props.simPrefix,
    simStatus = props.simStatus,
    simId = props.simId,
    openSimDetails = props.openSimDetails,
    isDark = props.isDark;
  var windowRetailIframe = (_window = window) === null || _window === void 0 ? void 0 : (_window$config = _window.config) === null || _window$config === void 0 ? void 0 : _window$config.retailIframe;
  var SimLink = windowRetailIframe ? SimContainerRetail : SIMContainer;
  return /*#__PURE__*/React__default.createElement(DeviceInfoMain$1, {
    id: "secondary-tile"
  }, /*#__PURE__*/React__default.createElement(InfoGroup$1, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "large",
    color: isDark ? "#ffffff" : "#000000",
    bold: false
  }, isLoading && !deviceName ? 'Loading...' : deviceName || "Not available")), isFwaDevice && /*#__PURE__*/React__default.createElement(InfoGroup$1, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: isDark ? "#ffffff" : "#000000",
    bold: true
  }, "Device Uptime"), /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: isDark ? "#ffffff" : "#000000",
    bold: false
  }, isFetching && !deviceUpTime ? 'Loading...' : deviceUpTime || "Not available")), !isFwaDevice && /*#__PURE__*/React__default.createElement(InfoGroup$1, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: isDark ? "#ffffff" : "#000000",
    bold: true
  }, "Release Date"), /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: isDark ? "#ffffff" : "#000000",
    bold: false
  }, osLaunchDate || "Not Available")), !isFwaDevice && /*#__PURE__*/React__default.createElement(InfoGroup$1, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: isDark ? "#ffffff" : "#000000",
    bold: true
  }, "Activation Date"), /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: isDark ? "#ffffff" : "#000000",
    bold: false
  }, activationDate || "Not Available")), isFwaDevice && /*#__PURE__*/React__default.createElement(InfoGroup$1, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: isDark ? "#ffffff" : "#000000",
    bold: true
  }, "SIM Status"), /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: isDark ? "#ffffff" : "#000000",
    bold: false
  }, isFetching && !simStatus ? 'Loading...' : simStatus || "Not available")), /*#__PURE__*/React__default.createElement(InfoGroup$1, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: isDark ? "#ffffff" : "#000000",
    bold: true
  }, "OS Version"), /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: isDark ? "#ffffff" : "#000000",
    bold: false
  }, isFetching && !deviceOSString ? 'Loading...' : deviceOSString || "Not available")), /*#__PURE__*/React__default.createElement(InfoGroup$1, null, /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: isDark ? "#ffffff" : "#000000",
    bold: true
  }, "IMEI"), /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: isDark ? "#ffffff" : "#000000",
    bold: false
  }, imeiNumber || "Not Available")), /*#__PURE__*/React__default.createElement(SimLink, null, /*#__PURE__*/React__default.createElement(TextLink, {
    type: "standAlone",
    "data-track": "" + simPrefix + simId,
    disabled: windowRetailIframe,
    onClick: openSimDetails
  }, simPrefix, "SIM"), /*#__PURE__*/React__default.createElement(Body, {
    size: "small",
    color: isDark ? "#ffffff" : "#000000",
    bold: false
  }, simId || "Not Available")));
};

var _templateObject$1N;
var ImageContainer$6 = styled.div(_templateObject$1N || (_templateObject$1N = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: center;\n    img{\n      position: relative;\n      max-height: 100px;\n      max-width: 100px;\n      display: block;\n    }\n    button{\n      border-radius: 0;\n      border: none;\n      }\n\n      button:hover{\n      box-shadow: none !important;\n    }\n"])));
var DeviceImage$8 = function DeviceImage(_ref) {
  var imageUrl = _ref.imageUrl,
    isLoading = _ref.isLoading,
    deviceImageClick = _ref.deviceImageClick,
    isDark = _ref.isDark;
  if (isLoading && !imageUrl) {
    return /*#__PURE__*/React__default.createElement("p", null, "Loading...");
  }
  var handleImageClick = function handleImageClick() {
    deviceImageClick();
  };
  return /*#__PURE__*/React__default.createElement(ImageContainer$6, null, /*#__PURE__*/React__default.createElement(Button$1, {
    use: "secondary",
    surface: isDark ? 'dark' : 'light',
    size: "large",
    "data-track": "L1|P1|Delhpi|||||Device Details| Equipment Guide",
    onClick: handleImageClick
  }, /*#__PURE__*/React__default.createElement("img", {
    src: imageUrl,
    title: "Equipment Guide",
    alt: "Equipment Guide"
  })));
};

var _templateObject$1O, _templateObject2$1l;
var ChangeDeviceMain = styled.div(_templateObject$1O || (_templateObject$1O = _taggedTemplateLiteralLoose(["\n    text-align: center;\n"])));
var ChangeDeviceLink = styled.div(_templateObject2$1l || (_templateObject2$1l = _taggedTemplateLiteralLoose(["\n    padding-top: 7px;\n    a, a:hover{\n    border-bottom:none;\n    }\n"])));
var ChangeDeviceComponent = function ChangeDeviceComponent(_ref) {
  var imageUrl = _ref.imageUrl,
    isLoading = _ref.isLoading,
    isDark = _ref.isDark,
    deviceImageHandler = _ref.deviceImageHandler;
  var updateDeviceOnClick = function updateDeviceOnClick() {
    var customEvent = new CustomEvent("isDeviceSelectTab", {
      detail: {
        isDeviceSelectTab: true
      }
    });
    window.dispatchEvent(customEvent);
  };
  return /*#__PURE__*/React__default.createElement(ChangeDeviceMain, null, /*#__PURE__*/React__default.createElement(DeviceImage$8, {
    imageUrl: imageUrl,
    isLoading: isLoading,
    deviceImageClick: deviceImageHandler,
    isDark: isDark
  }), /*#__PURE__*/React__default.createElement(ChangeDeviceLink, null, /*#__PURE__*/React__default.createElement(TextLink, {
    type: "standAlone",
    "data-track": "L1|P1|Delhpi|||||Device Details|Change Device",
    onClick: updateDeviceOnClick,
    surface: isDark ? "dark" : "light"
  }, "Change Device")));
};

var EmulatorComponent = function EmulatorComponent(props) {
  var isDarkMode = (props === null || props === void 0 ? void 0 : props.isDark) || false;
  var deviceImageClick = props.deviceImageClick,
    deviceSku = props.deviceSku;
  var getEmulator = function getEmulator() {
    var data = {
      deviceSku: decodeURIComponent(deviceSku)
    };
    getModelService(data).then(function (data) {
      var _data$response, _data$response$data, _data$response$data$b, _data$response$data$b2;
      var emulatorUrl = data === null || data === void 0 ? void 0 : (_data$response = data.response) === null || _data$response === void 0 ? void 0 : (_data$response$data = _data$response.data) === null || _data$response$data === void 0 ? void 0 : (_data$response$data$b = _data$response$data.body) === null || _data$response$data$b === void 0 ? void 0 : (_data$response$data$b2 = _data$response$data$b.data) === null || _data$response$data$b2 === void 0 ? void 0 : _data$response$data$b2.emulator;
      console.log(emulatorUrl, "=======isIpad()=======", isIpad());
      if (emulatorUrl) {
        if (isIpad()) {
          ipadShell(emulatorUrl);
        } else {
          popupWindow(emulatorUrl, "", 700, 500);
        }
      } else {
        deviceImageClick();
      }
    });
  };
  return /*#__PURE__*/React__default.createElement(Button$1, {
    use: "secondary",
    surface: isDarkMode ? 'dark' : 'light',
    style: {
      width: '111px'
    },
    size: "small",
    "data-track": "L1|P1|Delhpi|||||Device Details|Emulator",
    onClick: getEmulator
  }, "Emulator");
};

var ViewDetailsCta = function ViewDetailsCta(_ref) {
  var handleModalShow = _ref.handleModalShow,
    isDark = _ref.isDark;
  var isDarkMode = isDark;
  return /*#__PURE__*/React__default.createElement(Button$1, {
    use: "primary",
    surface: isDarkMode ? 'dark' : 'light',
    style: {
      width: '111px',
      fontSize: "10px"
    },
    size: "small",
    "data-track": "L1|P1|Delhpi|||||Device Details|View Details",
    onClick: handleModalShow
  }, "View Details");
};

var _templateObject$1P, _templateObject2$1m, _templateObject3$13, _templateObject4$_, _templateObject5$O;
var TileMain = styled.div(_templateObject$1P || (_templateObject$1P = _taggedTemplateLiteralLoose(["\n    padding-top:  ", ";\n    padding-left:20px;\n    padding-right:20px;\n    display: grid;\n    grid-template-columns: 60fr 40fr;\n    grid-template-rows: auto auto;\n"])), function (_ref) {
  var isPrimary = _ref.isPrimary;
  return isPrimary ? '20px' : '0';
});
var LeftSection$3 = styled.div(_templateObject2$1m || (_templateObject2$1m = _taggedTemplateLiteralLoose(["\n"])));
var RightSection$3 = styled.div(_templateObject3$13 || (_templateObject3$13 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    row-gap: 20px;\n}\n"])));
var ButtonGroup = styled.div(_templateObject4$_ || (_templateObject4$_ = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    row-gap: 10px;\n}\n"])));
var TitleContainer$5 = styled.div(_templateObject5$O || (_templateObject5$O = _taggedTemplateLiteralLoose(["\n  grid-column: 1/-1;\n"])));
var TileCommon = function TileCommon(props) {
  console.log("common props-->", props);
  var userProfile = props.userProfile,
    selectedMTNData = props.selectedMTNData,
    callerName = props.callerName,
    mdn = props.mdn,
    isLoading = props.isLoading,
    deviceSku = props.deviceSku,
    imageUrl = props.imageUrl,
    handleModalShow = props.handleModalShow,
    openSimDetails = props.openSimDetails,
    logUsageMetrics = props.logUsageMetrics,
    isDark = props.isDark;
  var tileId = props.tileId;
  var isPrimary = tileId === "primary";
  var dispatchUsageMetrics = function dispatchUsageMetrics(eventId, actionId, notes) {
    if (eventId === void 0) {
      eventId = "";
    }
    if (actionId === void 0) {
      actionId = "";
    }
    if (notes === void 0) {
      notes = "";
    }
    var metrics = [{
      eventID: eventId,
      actionID: actionId,
      notes: notes
    }];
    if (logUsageMetrics) {
      logUsageMetrics({
        metrics: metrics
      });
    }
  };
  var deviceImageClick = function deviceImageClick() {
    var _window, _window$config;
    var windowRetailIframe = (_window = window) === null || _window === void 0 ? void 0 : (_window$config = _window.config) === null || _window$config === void 0 ? void 0 : _window$config.retailIframe;
    dispatchUsageMetrics('1D_DEVICE_OVERVIEW_NSA', 'DEVICE_PHOTO_LINK');
    if (!windowRetailIframe) {
      var _selectedMTNData$devi, _selectedMTNData$devi2, _selectedMTNData$devi3, _selectedMTNData$devi4, _userProfile$permissi, _userProfile$permissi2;
      var equipmentInfo = {};
      var eqipid = selectedMTNData === null || selectedMTNData === void 0 ? void 0 : (_selectedMTNData$devi = selectedMTNData.deviceInfo) === null || _selectedMTNData$devi === void 0 ? void 0 : (_selectedMTNData$devi2 = _selectedMTNData$devi[0]) === null || _selectedMTNData$devi2 === void 0 ? void 0 : (_selectedMTNData$devi3 = _selectedMTNData$devi2.equipGuideData) === null || _selectedMTNData$devi3 === void 0 ? void 0 : (_selectedMTNData$devi4 = _selectedMTNData$devi3.deviceModel) === null || _selectedMTNData$devi4 === void 0 ? void 0 : _selectedMTNData$devi4.equipID;
      equipmentInfo.eguideURL = userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$permissi = userProfile.permission) === null || _userProfile$permissi === void 0 ? void 0 : (_userProfile$permissi2 = _userProfile$permissi.sessionPermission) === null || _userProfile$permissi2 === void 0 ? void 0 : _userProfile$permissi2.ACSS_INFOMANAGER_EQUIPMENT_GUIDE;
      equipmentInfo.ID = eqipid;
      if (eqipid !== "") {
        popupWindow(equipmentInfo.eguideURL + equipmentInfo.ID + ".html", equipmentInfo.Name, 800, 510);
      } else {
        equipmentInfo.ID = null;
        popupWindow(equipmentInfo.eguideURL + equipmentInfo.ID + ".html", equipmentInfo.Name, 800, 510);
      }
    }
  };
  return /*#__PURE__*/React__default.createElement(TileMain, {
    isPrimary: isPrimary
  }, /*#__PURE__*/React__default.createElement(TitleContainer$5, null, /*#__PURE__*/React__default.createElement(Title, {
    size: "small",
    bold: true,
    color: isDark ? "#ffffff" : "#000000"
  }, isLoading && !callerName ? 'Loading...' : callerName || "Not Available"), /*#__PURE__*/React__default.createElement(Title, {
    size: "small",
    bold: true,
    color: isDark ? "#ffffff" : "#000000"
  }, isLoading && !mdn ? 'Loading...' : mdn || "Not Available")), /*#__PURE__*/React__default.createElement(LeftSection$3, null, isPrimary ? /*#__PURE__*/React__default.createElement(DeviceInfoPrimary, props) : /*#__PURE__*/React__default.createElement(DeviceInfoSecondary, _extends({
    openSimDetails: openSimDetails
  }, props))), /*#__PURE__*/React__default.createElement(RightSection$3, null, /*#__PURE__*/React__default.createElement(ChangeDeviceComponent, {
    deviceImageHandler: deviceImageClick,
    imageUrl: imageUrl,
    isLoading: isLoading,
    isDark: isDark
  }), /*#__PURE__*/React__default.createElement(ButtonGroup, null, /*#__PURE__*/React__default.createElement(EmulatorComponent, {
    deviceSku: deviceSku,
    deviceImageHandler: deviceImageClick,
    isDark: isDark
  }), /*#__PURE__*/React__default.createElement(ViewDetailsCta, {
    handleModalShow: handleModalShow,
    isDark: isDark
  }))));
};

var _templateObject$1Q, _templateObject2$1n, _templateObject3$14;
var DeviceTileMain = styled.article(_templateObject$1Q || (_templateObject$1Q = _taggedTemplateLiteralLoose([""])));
var DeviceCarouselContainer = styled.div(_templateObject2$1n || (_templateObject2$1n = _taggedTemplateLiteralLoose(["\ndisplay: flex;\njustify-content: center;"])));
var CarouselContainer$1 = styled.div(_templateObject3$14 || (_templateObject3$14 = _taggedTemplateLiteralLoose(["\n    ", ";\n    width:100%;\n    border: 1px solid rgb(216, 218, 218);\n [class*=OuterTileContainer-VDS]{\n    padding:0 !important;\n    background: ", ";\n  }\n [class*=CarouselContainer-VDS]{\n    gap: 20px\n }\n"])), function (props) {
  return props.channel === "Retail" && 'width:35vw';
}, function (props) {
  return props.isDark ? '#202229 !important' : '#ffffff';
});
var getCallerName = function getCallerName(nameObj) {
  var _nameObj$basicMtnDeta, _nameObj$basicMtnDeta2, _nameObj$basicMtnDeta3, _nameObj$basicMtnDeta4, _nameObj$basicMtnDeta5, _nameObj$basicMtnDeta6, _nameObj$basicMtnDeta7, _nameObj$basicMtnDeta8;
  var firstName = (nameObj === null || nameObj === void 0 ? void 0 : (_nameObj$basicMtnDeta = nameObj.basicMtnDetails) === null || _nameObj$basicMtnDeta === void 0 ? void 0 : (_nameObj$basicMtnDeta2 = _nameObj$basicMtnDeta[0]) === null || _nameObj$basicMtnDeta2 === void 0 ? void 0 : (_nameObj$basicMtnDeta3 = _nameObj$basicMtnDeta2.primaryUser) === null || _nameObj$basicMtnDeta3 === void 0 ? void 0 : (_nameObj$basicMtnDeta4 = _nameObj$basicMtnDeta3[0]) === null || _nameObj$basicMtnDeta4 === void 0 ? void 0 : _nameObj$basicMtnDeta4.firstName) || '';
  var lastName = (nameObj === null || nameObj === void 0 ? void 0 : (_nameObj$basicMtnDeta5 = nameObj.basicMtnDetails) === null || _nameObj$basicMtnDeta5 === void 0 ? void 0 : (_nameObj$basicMtnDeta6 = _nameObj$basicMtnDeta5[0]) === null || _nameObj$basicMtnDeta6 === void 0 ? void 0 : (_nameObj$basicMtnDeta7 = _nameObj$basicMtnDeta6.primaryUser) === null || _nameObj$basicMtnDeta7 === void 0 ? void 0 : (_nameObj$basicMtnDeta8 = _nameObj$basicMtnDeta7[0]) === null || _nameObj$basicMtnDeta8 === void 0 ? void 0 : _nameObj$basicMtnDeta8.lastName) || '';
  var fullName = firstName + ' ' + lastName;
  return fullName.trim();
};
var getDeviceName = function getDeviceName(brand, device) {
  var deviceNameString;
  if (device) {
    deviceNameString = brand + " | " + device;
  } else {
    deviceNameString = device != null ? device : "";
  }
  return deviceNameString;
};
var getConnectedDevices = function getConnectedDevices(issuesList) {
  var found = issuesList === null || issuesList === void 0 ? void 0 : issuesList.find(function (issue) {
    return issue.code === "WiFi Connected Devices";
  });
  if (found) {
    return found.explanation;
  }
  return "";
};
var getDeviceOs = function getDeviceOs(isFwa, networkResp, operatingSystem) {
  var deviceOs;
  if (isFwa) {
    var _networkResp$fwaAttri, _networkResp$fwaAttri2;
    deviceOs = (_networkResp$fwaAttri = networkResp === null || networkResp === void 0 ? void 0 : (_networkResp$fwaAttri2 = networkResp.fwaAttributes) === null || _networkResp$fwaAttri2 === void 0 ? void 0 : _networkResp$fwaAttri2.firmwareVersion) != null ? _networkResp$fwaAttri : "";
  } else {
    var _networkResp$device, _networkResp$device$a, _networkResp$device$a2, _networkResp$device$a3, _networkResp$device$a4, _networkResp$device$a5, _networkResp$device$a6, _networkResp$device2, _networkResp$device2$, _networkResp$device2$2, _networkResp$device2$3, _networkResp$device2$4, _networkResp$device2$5, _networkResp$device2$6;
    var deviceOsVer = networkResp !== null && networkResp !== void 0 && (_networkResp$device = networkResp.device) !== null && _networkResp$device !== void 0 && (_networkResp$device$a = _networkResp$device.analysis) !== null && _networkResp$device$a !== void 0 && (_networkResp$device$a2 = _networkResp$device$a[0]) !== null && _networkResp$device$a2 !== void 0 && (_networkResp$device$a3 = _networkResp$device$a2.tables) !== null && _networkResp$device$a3 !== void 0 && (_networkResp$device$a4 = _networkResp$device$a3[0]) !== null && _networkResp$device$a4 !== void 0 && (_networkResp$device$a5 = _networkResp$device$a4.rows[2]) !== null && _networkResp$device$a5 !== void 0 && (_networkResp$device$a6 = _networkResp$device$a5.columns[2]) !== null && _networkResp$device$a6 !== void 0 && _networkResp$device$a6.name ? networkResp === null || networkResp === void 0 ? void 0 : (_networkResp$device2 = networkResp.device) === null || _networkResp$device2 === void 0 ? void 0 : (_networkResp$device2$ = _networkResp$device2.analysis) === null || _networkResp$device2$ === void 0 ? void 0 : (_networkResp$device2$2 = _networkResp$device2$[0]) === null || _networkResp$device2$2 === void 0 ? void 0 : (_networkResp$device2$3 = _networkResp$device2$2.tables) === null || _networkResp$device2$3 === void 0 ? void 0 : (_networkResp$device2$4 = _networkResp$device2$3[0]) === null || _networkResp$device2$4 === void 0 ? void 0 : (_networkResp$device2$5 = _networkResp$device2$4.rows[2]) === null || _networkResp$device2$5 === void 0 ? void 0 : (_networkResp$device2$6 = _networkResp$device2$5.columns[2]) === null || _networkResp$device2$6 === void 0 ? void 0 : _networkResp$device2$6.name : "";
    if (operatingSystem != "Not Available" && operatingSystem != "" && operatingSystem != null) {
      var _ref;
      deviceOs = (_ref = (operatingSystem != null ? operatingSystem : "") + " " + deviceOsVer) != null ? _ref : "";
    } else {
      deviceOs = operatingSystem != null ? operatingSystem : "";
    }
  }
  return deviceOs;
};
var getSimPrefix = function getSimPrefix(customerInfo, selectedMTNData) {
  var _myObj$mtns, _myObj$mtns$, _customerInfo$billAcc, _customerInfo$billAcc2, _customerInfo$billAcc3, _customerInfo$billAcc4;
  var simTypeValue = "";
  var mvoConfig = sessionStorage.getItem("mvoConfig");
  var myObj = JSON.parse(mvoConfig);
  var simSkuType = (myObj === null || myObj === void 0 ? void 0 : (_myObj$mtns = myObj.mtns) === null || _myObj$mtns === void 0 ? void 0 : (_myObj$mtns$ = _myObj$mtns[0]) === null || _myObj$mtns$ === void 0 ? void 0 : _myObj$mtns$.simSkuType) || "";
  var simTypeFromACSS = "";
  simTypeFromACSS = customerInfo === null || customerInfo === void 0 ? void 0 : (_customerInfo$billAcc = customerInfo.billAccounts) === null || _customerInfo$billAcc === void 0 ? void 0 : (_customerInfo$billAcc2 = _customerInfo$billAcc[0]) === null || _customerInfo$billAcc2 === void 0 ? void 0 : (_customerInfo$billAcc3 = _customerInfo$billAcc2.customerInquirySearchMtnDetail) === null || _customerInfo$billAcc3 === void 0 ? void 0 : (_customerInfo$billAcc4 = _customerInfo$billAcc3.basicPhoneInfo) === null || _customerInfo$billAcc4 === void 0 ? void 0 : _customerInfo$billAcc4.simSkuType;
  if (!simTypeFromACSS) {
    var _selectedMTNData$devi, _selectedMTNData$devi2;
    simTypeFromACSS = selectedMTNData === null || selectedMTNData === void 0 ? void 0 : (_selectedMTNData$devi = selectedMTNData.deviceInfo) === null || _selectedMTNData$devi === void 0 ? void 0 : (_selectedMTNData$devi2 = _selectedMTNData$devi[0]) === null || _selectedMTNData$devi2 === void 0 ? void 0 : _selectedMTNData$devi2.simSkuType;
  }
  var simTypeMap = {
    "S": "e",
    "T": "p"
  };
  simTypeValue = simTypeMap[simSkuType] || "";
  simTypeValue = simTypeMap[simTypeFromACSS] || "";
  return simTypeValue;
};
var DeviceCarouselHome = function DeviceCarouselHome(props) {
  var _deviceResponse$respo, _deviceResponse$respo2, _deviceResponse$respo3, _networkResponse$resp, _networkResponse$resp2, _networkResponse$resp3, _window, _window$caseDetails, _networkData$fwaAttri, _networkData$fwaAttri2, _networkData$overview, _networkData$overview2, _networkData$overview3, _networkData$overview4, _networkData$overview5, _networkData$fwaAttri3, _selectedMTNData, _selectedMTNData2, _selectedMTNData2$dev, _selectedMTNData2$dev2, _window2, _window2$config, _props$params;
  var _useDeviceData = useDeviceData(props),
    deviceResponse = _useDeviceData.data,
    fetchingDevice = _useDeviceData.isLoading;
  var _useNetworkData = useNetworkData(props),
    networkResponse = _useNetworkData.data;
  var _useProfileData = useProfileData(props),
    userProfile = _useProfileData.data;
  var _useState = useState(false),
    isOpen = _useState[0],
    setOpen = _useState[1];
  var _useState2 = useState(false),
    simOpen = _useState2[0],
    setSimOpen = _useState2[1];
  var _useState3 = useState(1),
    selectedTab = _useState3[0],
    setSelectedTab = _useState3[1];
  console.log("refetchDeviceResponse-->", deviceResponse);
  var deviceData = deviceResponse === null || deviceResponse === void 0 ? void 0 : (_deviceResponse$respo = deviceResponse.response) === null || _deviceResponse$respo === void 0 ? void 0 : (_deviceResponse$respo2 = _deviceResponse$respo.data) === null || _deviceResponse$respo2 === void 0 ? void 0 : (_deviceResponse$respo3 = _deviceResponse$respo2.body) === null || _deviceResponse$respo3 === void 0 ? void 0 : _deviceResponse$respo3.data;
  var networkData = networkResponse === null || networkResponse === void 0 ? void 0 : (_networkResponse$resp = networkResponse.response) === null || _networkResponse$resp === void 0 ? void 0 : (_networkResponse$resp2 = _networkResponse$resp.data) === null || _networkResponse$resp2 === void 0 ? void 0 : (_networkResponse$resp3 = _networkResponse$resp2.body) === null || _networkResponse$resp3 === void 0 ? void 0 : _networkResponse$resp3.data;
  var _props$customerInfo = props.customerInfo,
    customerInfo = _props$customerInfo === void 0 ? {} : _props$customerInfo,
    deviceName = props.deviceName,
    deviceBrand = props.deviceBrand,
    osLaunchDate = props.osLaunchDate,
    activationDate = props.activationDate,
    imei = props.imei,
    operatingSystem = props.operatingSystem,
    deviceSku = props.deviceSku,
    deviceThumbImg = props.deviceThumbImg,
    logUsageMetrics = props.logUsageMetrics,
    isDark = props.isDark;
  var getBgColor = isDark ? '#202229' : '#FFFFFF';
  var deviceNameString = getDeviceName(deviceBrand, deviceName);
  var _ref2 = props || {},
    _ref2$params = _ref2.params,
    _ref2$params2 = _ref2$params === void 0 ? {} : _ref2$params,
    _ref2$params2$mdn = _ref2$params2.mdn,
    mdn = _ref2$params2$mdn === void 0 ? '' : _ref2$params2$mdn;
  var selectedMTN = ((_window = window) === null || _window === void 0 ? void 0 : (_window$caseDetails = _window.caseDetails) === null || _window$caseDetails === void 0 ? void 0 : _window$caseDetails.mtn) || mdn;
  var selectedMTNData;
  if (deviceData) {
    var _deviceData$customerI, _deviceData$customerI2, _deviceData$customerI3;
    var mtns = deviceData === null || deviceData === void 0 ? void 0 : (_deviceData$customerI = deviceData.customerInsight) === null || _deviceData$customerI === void 0 ? void 0 : (_deviceData$customerI2 = _deviceData$customerI.billAccounts) === null || _deviceData$customerI2 === void 0 ? void 0 : (_deviceData$customerI3 = _deviceData$customerI2[0]) === null || _deviceData$customerI3 === void 0 ? void 0 : _deviceData$customerI3.mtns;
    selectedMTNData = mtns ? mtns.find(function (e) {
      return e.mtn === selectedMTN;
    }) : {};
  }
  var isFWADevice_ = isFWADevice(selectedMTNData);
  var callerName = getCallerName(selectedMTNData);
  var upTime = (networkData === null || networkData === void 0 ? void 0 : (_networkData$fwaAttri = networkData.fwaAttributes) === null || _networkData$fwaAttri === void 0 ? void 0 : _networkData$fwaAttri.upTime) || "";
  var planInfo = (networkData === null || networkData === void 0 ? void 0 : (_networkData$fwaAttri2 = networkData.fwaAttributes) === null || _networkData$fwaAttri2 === void 0 ? void 0 : _networkData$fwaAttri2.pricePlanDesc) || "";
  var connecteDevices = getConnectedDevices(networkData === null || networkData === void 0 ? void 0 : (_networkData$overview = networkData.overview) === null || _networkData$overview === void 0 ? void 0 : _networkData$overview.analysis);
  var overviewLoading = (networkData === null || networkData === void 0 ? void 0 : (_networkData$overview2 = networkData.overview) === null || _networkData$overview2 === void 0 ? void 0 : (_networkData$overview3 = _networkData$overview2.header) === null || _networkData$overview3 === void 0 ? void 0 : _networkData$overview3.state) !== "COMPLETED";
  console.log("Overview STATE-->", networkData === null || networkData === void 0 ? void 0 : (_networkData$overview4 = networkData.overview) === null || _networkData$overview4 === void 0 ? void 0 : (_networkData$overview5 = _networkData$overview4.header) === null || _networkData$overview5 === void 0 ? void 0 : _networkData$overview5.state);
  var deviceOS = getDeviceOs(isFWADevice_, networkData, operatingSystem);
  var simPrefix = getSimPrefix(customerInfo, selectedMTNData);
  var simStatus = (networkData === null || networkData === void 0 ? void 0 : (_networkData$fwaAttri3 = networkData.fwaAttributes) === null || _networkData$fwaAttri3 === void 0 ? void 0 : _networkData$fwaAttri3.simState) || "";
  var mtn = getFormatMtn((_selectedMTNData = selectedMTNData) === null || _selectedMTNData === void 0 ? void 0 : _selectedMTNData.mtn);
  var simId = ((_selectedMTNData2 = selectedMTNData) === null || _selectedMTNData2 === void 0 ? void 0 : (_selectedMTNData2$dev = _selectedMTNData2.deviceInfo) === null || _selectedMTNData2$dev === void 0 ? void 0 : (_selectedMTNData2$dev2 = _selectedMTNData2$dev[0]) === null || _selectedMTNData2$dev2 === void 0 ? void 0 : _selectedMTNData2$dev2.simId) || "";
  var windowRetailIframe = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$config = _window2.config) === null || _window2$config === void 0 ? void 0 : _window2$config.retailIframe;
  var simDetailOpen = useDeepLinkStore(function (state) {
    return state.openSimDetails;
  });
  var updateOpenSimDetails = useDeepLinkStore(function (state) {
    return state.updateOpenSimDetails;
  });
  var viewDetailsOpen = useDeepLinkStore(function (state) {
    return state.openDeviceDetails;
  });
  var updateOpenDeviceDetails = useDeepLinkStore(function (state) {
    return state.updateOpenDeviceDetails;
  });
  var openSpeedTest = useDeepLinkStore(function (state) {
    return state.openSpeedTest;
  });
  var openConnectedDevices = useDeepLinkStore(function (state) {
    return state.openConnectedDevices;
  });
  var updateOpenConnectedDevices = useDeepLinkStore(function (state) {
    return state.updateOpenConnectedDevices;
  });
  useEffect(function () {
    if (openConnectedDevices) {
      setSelectedTab(3);
      setOpen(true);
    }
  }, [openConnectedDevices]);
  useEffect(function () {
    if (openSpeedTest) {
      setSelectedTab(2);
    }
    if (viewDetailsOpen) {
      setOpen(true);
    }
  }, [viewDetailsOpen]);
  useEffect(function () {
    if (simDetailOpen) {
      if (windowRetailIframe) return;
      setSimOpen(true);
    }
  }, [simDetailOpen]);
  var openDeviceDetails = function openDeviceDetails() {
    setOpen(true);
  };
  var openSimDetails = function openSimDetails() {
    console.log("openSimDetails click");
    if (windowRetailIframe) return;
    setSimOpen(true);
  };
  var closeSimDetails = function closeSimDetails() {
    if (simDetailOpen) {
      updateOpenSimDetails();
    }
    setSimOpen(false);
  };
  var closeDeviceDetails = function closeDeviceDetails() {
    if (viewDetailsOpen) {
      updateOpenDeviceDetails();
    }
    if (openConnectedDevices) {
      updateOpenConnectedDevices();
    }
    setSelectedTab(1);
    setOpen(false);
  };
  var carouselData = [{
    id: "secondaryTile",
    subtitle: {
      size: 'bodyLarge',
      primitive: 'div',
      children: /*#__PURE__*/React__default.createElement(TileCommon, {
        tileId: "secondary",
        isFwaDevice: isFWADevice_,
        deviceName: deviceNameString,
        callerName: callerName,
        deviceUpTime: upTime,
        deviceOSString: deviceOS,
        imeiNumber: imei,
        simPrefix: simPrefix,
        isFetching: overviewLoading,
        isLoading: fetchingDevice,
        osLaunchDate: osLaunchDate,
        activationDate: activationDate,
        simStatus: simStatus,
        mdn: mtn,
        simId: simId,
        userProfile: userProfile,
        selectedMTNData: selectedMTNData,
        deviceSku: deviceSku,
        imageUrl: deviceThumbImg,
        handleModalShow: openDeviceDetails,
        openSimDetails: openSimDetails,
        logUsageMetrics: logUsageMetrics,
        isDark: isDark
      })
    },
    background: {
      getBgColor: getBgColor
    },
    backgroundColor: {
      getBgColor: getBgColor
    }
  }];
  if (isFWADevice_) {
    carouselData.unshift({
      id: "primaryTile",
      subtitle: {
        size: 'bodyLarge',
        primitive: 'div',
        children: /*#__PURE__*/React__default.createElement(TileCommon, {
          tileId: "primary",
          deviceName: deviceNameString,
          callerName: callerName,
          deviceUpTime: upTime,
          planType: planInfo,
          connectedDevices: connecteDevices,
          isFetching: overviewLoading,
          isLoading: fetchingDevice,
          mdn: mtn,
          userProfile: userProfile,
          selectedMTNData: selectedMTNData,
          deviceSku: deviceSku,
          imageUrl: deviceThumbImg,
          handleModalShow: openDeviceDetails,
          logUsageMetrics: logUsageMetrics,
          isDark: isDark
        })
      },
      background: {
        getBgColor: getBgColor
      },
      backgroundColor: {
        getBgColor: getBgColor
      }
    });
  }
  return /*#__PURE__*/React__default.createElement(DeviceTileMain, null, /*#__PURE__*/React__default.createElement(DeviceCarouselContainer, null, /*#__PURE__*/React__default.createElement(CarouselContainer$1, {
    isDark: isDark,
    channel: (_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.channel
  }, /*#__PURE__*/React__default.createElement(Carousel, {
    viewport: "desktop",
    peek: "none",
    layout: "1UP",
    gutter: "24px",
    surface: isDark ? 'dark' : 'light',
    paginationFill: "light",
    paginationInset: "0px",
    paginationDisplay: "onHover",
    renderItem: function renderItem(tileProps) {
      return /*#__PURE__*/React__default.createElement(Tilelet, _extends({
        surface: isDark ? 'dark' : 'light'
      }, tileProps, {
        width: "97%",
        height: "300px"
      }));
    },
    data: carouselData
  }))), isOpen && /*#__PURE__*/React__default.createElement(Launchout, {
    handleClose: function handleClose() {
      return closeDeviceDetails();
    },
    modalTitle: "Device",
    height: windowRetailIframe ? "100vh" : "600px",
    width: windowRetailIframe ? "100vw" : "1200px",
    isDark: isDark
  }, /*#__PURE__*/React__default.createElement(DeviceDetailsPopup, _extends({
    selectedTab: selectedTab
  }, props))), simOpen && /*#__PURE__*/React__default.createElement(Launchout, {
    handleClose: function handleClose() {
      return closeSimDetails();
    },
    modalTitle: "VZW SIM Details",
    height: windowRetailIframe ? "100vh" : "600px",
    width: "600px",
    isDark: isDark
  }, /*#__PURE__*/React__default.createElement(SimDetails, props)));
};

var DevicesNetworkTiles = function DevicesNetworkTiles(props) {
  var _additionalInfo$body, _additionalInfo$body$, _additionalInfo$body2, _additionalInfo$body3, _window$caseDetails$m, _window, _window$caseDetails, _additionalInfo$body4, _additionalInfo$body5, _getFeatureFlag, _props$params2, _window3, _window3$config;
  var updateDeviceTile = props.updateDeviceTile,
    _props$isDeviceOpen = props.isDeviceOpen,
    isDeviceOpen = _props$isDeviceOpen === void 0 ? false : _props$isDeviceOpen,
    _props$isNetworkOpen = props.isNetworkOpen,
    isNetworkOpen = _props$isNetworkOpen === void 0 ? false : _props$isNetworkOpen,
    closeDeviceDetailsPopup = props.closeDeviceDetailsPopup,
    closeNetworkDetailsPopup = props.closeNetworkDetailsPopup;
  var _ref = useAdditionalInfo(props.params) || {},
    additionalInfo = _ref.data;
  var _ref2 = useFeatureFlag() || {},
    _ref2$data = _ref2.data,
    _ref2$data2 = _ref2$data === void 0 ? {} : _ref2$data,
    deviceTileCarouselExpFFlag = _ref2$data2.deviceTileCarouselExpFFlag;
  var networkPollInfo = {
    delphiPollInterval: additionalInfo === null || additionalInfo === void 0 ? void 0 : (_additionalInfo$body = additionalInfo.body) === null || _additionalInfo$body === void 0 ? void 0 : (_additionalInfo$body$ = _additionalInfo$body.configData) === null || _additionalInfo$body$ === void 0 ? void 0 : _additionalInfo$body$.delphiPollInterval,
    delphiPollLimit: additionalInfo === null || additionalInfo === void 0 ? void 0 : (_additionalInfo$body2 = additionalInfo.body) === null || _additionalInfo$body2 === void 0 ? void 0 : (_additionalInfo$body3 = _additionalInfo$body2.configData) === null || _additionalInfo$body3 === void 0 ? void 0 : _additionalInfo$body3.delphiPollLimit
  };
  var _ref3 = useDeviceData(props) || {},
    deviceResponse = _ref3.data;
  var _ref4 = props || {},
    _ref4$params = _ref4.params,
    _ref4$params2 = _ref4$params === void 0 ? {} : _ref4$params,
    _ref4$params2$mdn = _ref4$params2.mdn,
    mdn = _ref4$params2$mdn === void 0 ? '' : _ref4$params2$mdn;
  var selectedMTN = (_window$caseDetails$m = (_window = window) === null || _window === void 0 ? void 0 : (_window$caseDetails = _window.caseDetails) === null || _window$caseDetails === void 0 ? void 0 : _window$caseDetails.mtn) != null ? _window$caseDetails$m : mdn;
  var selectedMTNData;
  if (deviceResponse) {
    var _deviceResponse$respo, _deviceResponse$respo2, _deviceResponse$respo3, _deviceResponse$respo4, _deviceResponse$respo5, _deviceResponse$respo6, _deviceResponse$respo7;
    var mtns = deviceResponse === null || deviceResponse === void 0 ? void 0 : (_deviceResponse$respo = deviceResponse.response) === null || _deviceResponse$respo === void 0 ? void 0 : (_deviceResponse$respo2 = _deviceResponse$respo.data) === null || _deviceResponse$respo2 === void 0 ? void 0 : (_deviceResponse$respo3 = _deviceResponse$respo2.body) === null || _deviceResponse$respo3 === void 0 ? void 0 : (_deviceResponse$respo4 = _deviceResponse$respo3.data) === null || _deviceResponse$respo4 === void 0 ? void 0 : (_deviceResponse$respo5 = _deviceResponse$respo4.customerInsight) === null || _deviceResponse$respo5 === void 0 ? void 0 : (_deviceResponse$respo6 = _deviceResponse$respo5.billAccounts) === null || _deviceResponse$respo6 === void 0 ? void 0 : (_deviceResponse$respo7 = _deviceResponse$respo6[0]) === null || _deviceResponse$respo7 === void 0 ? void 0 : _deviceResponse$respo7.mtns;
    selectedMTNData = mtns ? mtns.find(function (e) {
      return e.mtn === selectedMTN;
    }) : {};
  }
  var ffList = (additionalInfo === null || additionalInfo === void 0 ? void 0 : (_additionalInfo$body4 = additionalInfo.body) === null || _additionalInfo$body4 === void 0 ? void 0 : (_additionalInfo$body5 = _additionalInfo$body4.configData) === null || _additionalInfo$body5 === void 0 ? void 0 : _additionalInfo$body5.featureFlagList) || [];
  var enableNewExp = (_getFeatureFlag = getFeatureFlag(ffList, "enableNewNetworkTileFFlag")) === null || _getFeatureFlag === void 0 ? void 0 : _getFeatureFlag.status;
  var deviceNameState;
  var deviceTypeState;
  var deviceBrandState;
  var operatingSystemState;
  var deviceSkuState;
  var osLaunchDateState;
  var activationDateState;
  var imeiState;
  var deviceThumbImgState;
  var deviceEquipIdState;
  if (selectedMTNData) {
    var _selectedMTNData, _selectedMTNData$devi, _selectedMTNData$devi2, _selectedMTNData2, _selectedMTNData2$dev, _selectedMTNData2$dev2, _selectedMTNData3, _selectedMTNData3$dev, _selectedMTNData3$dev2, _selectedMTNData4, _selectedMTNData4$dev, _selectedMTNData4$dev2, _selectedMTNData5, _selectedMTNData5$dev, _selectedMTNData5$dev2, _selectedMTNData5$dev3, _selectedMTNData5$dev4, _selectedMTNData6, _selectedMTNData6$dev, _selectedMTNData6$dev2, _selectedMTNData6$dev3, _selectedMTNData6$dev4, _selectedMTNData7, _selectedMTNData7$dev, _selectedMTNData7$dev2, _selectedMTNData8, _selectedMTNData8$dev, _selectedMTNData8$dev2, _selectedMTNData9, _selectedMTNData9$dev, _selectedMTNData9$dev2, _selectedMTNData9$dev3, _selectedMTNData9$dev4, _selectedMTNData0, _selectedMTNData0$dev, _selectedMTNData0$dev2, _selectedMTNData0$dev3, _selectedMTNData0$dev4;
    deviceNameState = ((_selectedMTNData = selectedMTNData) === null || _selectedMTNData === void 0 ? void 0 : (_selectedMTNData$devi = _selectedMTNData.deviceInfo) === null || _selectedMTNData$devi === void 0 ? void 0 : (_selectedMTNData$devi2 = _selectedMTNData$devi[0]) === null || _selectedMTNData$devi2 === void 0 ? void 0 : _selectedMTNData$devi2.modelName) || "";
    deviceTypeState = ((_selectedMTNData2 = selectedMTNData) === null || _selectedMTNData2 === void 0 ? void 0 : (_selectedMTNData2$dev = _selectedMTNData2.deviceInfo) === null || _selectedMTNData2$dev === void 0 ? void 0 : (_selectedMTNData2$dev2 = _selectedMTNData2$dev[0]) === null || _selectedMTNData2$dev2 === void 0 ? void 0 : _selectedMTNData2$dev2.deviceType) || "";
    deviceBrandState = ((_selectedMTNData3 = selectedMTNData) === null || _selectedMTNData3 === void 0 ? void 0 : (_selectedMTNData3$dev = _selectedMTNData3.deviceInfo) === null || _selectedMTNData3$dev === void 0 ? void 0 : (_selectedMTNData3$dev2 = _selectedMTNData3$dev[0]) === null || _selectedMTNData3$dev2 === void 0 ? void 0 : _selectedMTNData3$dev2.equipmentMfgName) || "";
    operatingSystemState = ((_selectedMTNData4 = selectedMTNData) === null || _selectedMTNData4 === void 0 ? void 0 : (_selectedMTNData4$dev = _selectedMTNData4.deviceInfo) === null || _selectedMTNData4$dev === void 0 ? void 0 : (_selectedMTNData4$dev2 = _selectedMTNData4$dev[0]) === null || _selectedMTNData4$dev2 === void 0 ? void 0 : _selectedMTNData4$dev2.deviceOs) || "";
    deviceSkuState = ((_selectedMTNData5 = selectedMTNData) === null || _selectedMTNData5 === void 0 ? void 0 : (_selectedMTNData5$dev = _selectedMTNData5.deviceInfo) === null || _selectedMTNData5$dev === void 0 ? void 0 : (_selectedMTNData5$dev2 = _selectedMTNData5$dev[0]) === null || _selectedMTNData5$dev2 === void 0 ? void 0 : (_selectedMTNData5$dev3 = _selectedMTNData5$dev2.equipGuideData) === null || _selectedMTNData5$dev3 === void 0 ? void 0 : (_selectedMTNData5$dev4 = _selectedMTNData5$dev3.deviceModel) === null || _selectedMTNData5$dev4 === void 0 ? void 0 : _selectedMTNData5$dev4.sku) || "";
    osLaunchDateState = ((_selectedMTNData6 = selectedMTNData) === null || _selectedMTNData6 === void 0 ? void 0 : (_selectedMTNData6$dev = _selectedMTNData6.deviceInfo) === null || _selectedMTNData6$dev === void 0 ? void 0 : (_selectedMTNData6$dev2 = _selectedMTNData6$dev[0]) === null || _selectedMTNData6$dev2 === void 0 ? void 0 : (_selectedMTNData6$dev3 = _selectedMTNData6$dev2.equipGuideData) === null || _selectedMTNData6$dev3 === void 0 ? void 0 : (_selectedMTNData6$dev4 = _selectedMTNData6$dev3.deviceModel) === null || _selectedMTNData6$dev4 === void 0 ? void 0 : _selectedMTNData6$dev4.osLaunchDate) || "";
    activationDateState = ((_selectedMTNData7 = selectedMTNData) === null || _selectedMTNData7 === void 0 ? void 0 : (_selectedMTNData7$dev = _selectedMTNData7.deviceInfo) === null || _selectedMTNData7$dev === void 0 ? void 0 : (_selectedMTNData7$dev2 = _selectedMTNData7$dev[0]) === null || _selectedMTNData7$dev2 === void 0 ? void 0 : _selectedMTNData7$dev2.deviceActivationDate) || "";
    imeiState = ((_selectedMTNData8 = selectedMTNData) === null || _selectedMTNData8 === void 0 ? void 0 : (_selectedMTNData8$dev = _selectedMTNData8.deviceInfo) === null || _selectedMTNData8$dev === void 0 ? void 0 : (_selectedMTNData8$dev2 = _selectedMTNData8$dev[0]) === null || _selectedMTNData8$dev2 === void 0 ? void 0 : _selectedMTNData8$dev2.imei) || "";
    deviceThumbImgState = ((_selectedMTNData9 = selectedMTNData) === null || _selectedMTNData9 === void 0 ? void 0 : (_selectedMTNData9$dev = _selectedMTNData9.deviceInfo) === null || _selectedMTNData9$dev === void 0 ? void 0 : (_selectedMTNData9$dev2 = _selectedMTNData9$dev[0]) === null || _selectedMTNData9$dev2 === void 0 ? void 0 : (_selectedMTNData9$dev3 = _selectedMTNData9$dev2.equipGuideData) === null || _selectedMTNData9$dev3 === void 0 ? void 0 : (_selectedMTNData9$dev4 = _selectedMTNData9$dev3.deviceModel) === null || _selectedMTNData9$dev4 === void 0 ? void 0 : _selectedMTNData9$dev4.thumbImage) || "";
    deviceEquipIdState = ((_selectedMTNData0 = selectedMTNData) === null || _selectedMTNData0 === void 0 ? void 0 : (_selectedMTNData0$dev = _selectedMTNData0.deviceInfo) === null || _selectedMTNData0$dev === void 0 ? void 0 : (_selectedMTNData0$dev2 = _selectedMTNData0$dev[0]) === null || _selectedMTNData0$dev2 === void 0 ? void 0 : (_selectedMTNData0$dev3 = _selectedMTNData0$dev2.equipGuideData) === null || _selectedMTNData0$dev3 === void 0 ? void 0 : (_selectedMTNData0$dev4 = _selectedMTNData0$dev3.deviceModel) === null || _selectedMTNData0$dev4 === void 0 ? void 0 : _selectedMTNData0$dev4.equipID) || "";
  }
  var _useState = useState(deviceEquipIdState),
    setdeviceEquipId = _useState[1];
  var _useState2 = useState(deviceSkuState),
    deviceSku = _useState2[0],
    setdeviceSku = _useState2[1];
  var _useState3 = useState(deviceNameState),
    deviceName = _useState3[0],
    setdeviceName = _useState3[1];
  var _useState4 = useState(deviceTypeState),
    deviceType = _useState4[0],
    setdeviceType = _useState4[1];
  var _useState5 = useState(deviceBrandState),
    deviceBrand = _useState5[0],
    setdeviceBrand = _useState5[1];
  var _useState6 = useState(operatingSystemState),
    operatingSystem = _useState6[0],
    setoperatingSystem = _useState6[1];
  var _useState7 = useState(osLaunchDateState),
    osLaunchDate = _useState7[0],
    setosLaunchDate = _useState7[1];
  var _useState8 = useState(activationDateState),
    activationDate = _useState8[0],
    setactivationDate = _useState8[1];
  var _useState9 = useState(imeiState),
    imei = _useState9[0],
    setimei = _useState9[1];
  var _useState0 = useState(deviceThumbImgState),
    deviceThumbImg = _useState0[0],
    setdeviceThumbImg = _useState0[1];
  var _useState1 = useState(false);
  var _useState10 = useState(false),
    isDevicePopupOpen = _useState10[0],
    setDevicePopupOpen = _useState10[1];
  var _useState11 = useState(false),
    isNetworkPopupOpen = _useState11[0],
    setNetworkPopupOpen = _useState11[1];
  var devicesData = {
    deviceName: deviceName,
    deviceType: deviceType,
    deviceBrand: deviceBrand,
    operatingSystem: operatingSystem,
    deviceSku: deviceSku,
    osLaunchDate: osLaunchDate,
    activationDate: activationDate,
    imei: imei,
    deviceThumbImg: deviceThumbImg
  };
  console.log("isDevicePopupOpen=====", isDevicePopupOpen);
  console.log("isNetworkPopupOpen=====", isNetworkPopupOpen);
  useEffect(function () {
    setTaggingData();
  }, []);
  useEffect(function () {
    setdeviceSku(deviceSkuState);
    setdeviceName(deviceNameState);
    setdeviceType(deviceTypeState);
    setdeviceBrand(deviceBrandState);
    setoperatingSystem(operatingSystemState);
    setosLaunchDate(osLaunchDateState);
    setactivationDate(activationDateState);
    setimei(imeiState);
    setdeviceThumbImg(deviceThumbImgState);
    setdeviceEquipId(deviceEquipIdState);
  }, [deviceNameState, deviceTypeState, deviceBrandState, operatingSystemState, deviceSkuState, osLaunchDateState, activationDateState, imeiState, deviceThumbImgState]);
  useEffect(function () {
    var _props$params;
    if (props !== null && props !== void 0 && (_props$params = props.params) !== null && _props$params !== void 0 && _props$params.mdn) {
      sessionStorage.setItem('transactionID', '');
      sessionStorage.setItem('pollCount', '');
      sessionStorage.removeItem('speedTestResult');
      sessionStorage.removeItem('speedTestState');
    }
  }, [props === null || props === void 0 ? void 0 : (_props$params2 = props.params) === null || _props$params2 === void 0 ? void 0 : _props$params2.mdn]);
  console.log("updateDeviceTile===", updateDeviceTile);
  useEffect(function () {
    updateDeviceTileDetails(updateDeviceTile);
  }, [updateDeviceTile]);
  useEffect(function () {
    if (isDeviceOpen) setDevicePopupOpen(true);
  }, [isDeviceOpen]);
  useEffect(function () {
    if (isNetworkOpen) setNetworkPopupOpen(true);
  }, [isNetworkOpen]);
  var setTaggingData = function setTaggingData() {
    try {
      var _window2, _window2$vzdl;
      var page1 = "L1|P1|Delhpi||||||Device Details";
      var page2 = "L1|P2|Delhpi||||||Network and Provisioning";
      if ((_window2 = window) !== null && _window2 !== void 0 && (_window2$vzdl = _window2.vzdl) !== null && _window2$vzdl !== void 0 && _window2$vzdl.page) {
        window.vzdl.page.contentFragments = page1 + "^" + page2;
      } else {
        window.vzdl = {
          page: {
            contentFragments: page1 + "^" + page2
          }
        };
      }
      var trackEvent = {
        detail: {
          "name": "api:impression",
          "type": "impression",
          "data": {
            "page": {
              "contentFragments": page1 + "^" + page2
            }
          }
        }
      };
      var adobeTrackEvent = document.getElementsByTagName("body");
      var impressionEvent = new CustomEvent('adobeTrackEvent', trackEvent);
      adobeTrackEvent[0].dispatchEvent(impressionEvent);
    } catch (error) {
      console.error('tagging: sendCustomEvent of Network and Device tile error', error);
    }
  };
  var handleDeviceClose = function handleDeviceClose() {
    closeDeviceDetailsPopup();
    setDevicePopupOpen(false);
  };
  var handleNetworkClose = function handleNetworkClose() {
    closeNetworkDetailsPopup();
    setNetworkPopupOpen(false);
  };
  var updateDeviceTileDetails = function updateDeviceTileDetails(deviceDetails) {
    console.log("deviceDetails-----", deviceDetails);
    if (deviceDetails && deviceDetails.isDeviceDetailsFromDeviceSelector) {
      setdeviceEquipId(deviceDetails.deviceId);
      setdeviceSku(deviceDetails.deviceSku);
      setdeviceName(deviceDetails.deviceName);
      setdeviceType(deviceDetails.deviceType);
      setdeviceBrand(deviceDetails.deviceBrand);
      setoperatingSystem(deviceDetails.deviceOs);
      setdeviceThumbImg(deviceDetails.deviceThumbImg);
      setosLaunchDate(" - ");
      setactivationDate(" - ");
      setimei(" - ");
    }
  };
  try {
    if (window.config && window.config.troubleShootingJson) {
      window.troubleShootingJson = window.config.troubleShootingJson;
    }
    if (window.config && window.config.caseDetails) {
      window.caseDetails = window.config.caseDetails;
    }
  } catch (error) {
    console.error("src/index.js error", error);
  }
  var windowRetailIframe = (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$config = _window3.config) === null || _window3$config === void 0 ? void 0 : _window3$config.retailIframe;
  console.log("DeviceNetworkTilesDetails*******props-------", props);
  return /*#__PURE__*/React__default.createElement(Fragment, null, deviceTileCarouselExpFFlag ? /*#__PURE__*/React__default.createElement(DeviceCarouselHome, _extends({}, props, devicesData, networkPollInfo)) : /*#__PURE__*/React__default.createElement(DeviceDetails$1, _extends({}, props, devicesData, networkPollInfo)), isDevicePopupOpen && /*#__PURE__*/React__default.createElement(Launchout, {
    isDark: props.isDark,
    handleClose: function handleClose() {
      return handleDeviceClose();
    },
    modalTitle: "Device",
    height: windowRetailIframe ? "100vh" : "600px",
    width: windowRetailIframe ? "100vw" : "1100px"
  }, /*#__PURE__*/React__default.createElement(DeviceDetailsPopup, _extends({}, props, networkPollInfo))), enableNewExp ? /*#__PURE__*/React__default.createElement(NetworkDetailsNew, _extends({
    enableNewExp: enableNewExp
  }, props, networkPollInfo)) : null, isNetworkPopupOpen && /*#__PURE__*/React__default.createElement(Launchout, {
    isDark: props.isDark,
    handleClose: function handleClose() {
      return handleNetworkClose();
    },
    modalTitle: "Network & Provisioning",
    height: windowRetailIframe ? "100vh" : "600px",
    width: windowRetailIframe ? "100vw" : "1100px"
  }, /*#__PURE__*/React__default.createElement(NetworkDetailsPopup, _extends({
    enableNewExp: enableNewExp
  }, props, networkPollInfo))));
};

export { App, ConfigContext, DevicesNetworkTiles, IssueSelector, ParamsContext, sessionUtility };
//# sourceMappingURL=index.modern.js.map
